(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire37b7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire37b7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6rcps", function(module, exports) {
"use strict";

module.exports = (parcelRequire("g1nA1"));

});
parcelRegister("g1nA1", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $ba9f07d11e8eecf4$export$ffb0004e005737fa; }, function (v) { return $ba9f07d11e8eecf4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $ba9f07d11e8eecf4$export$34b9dba7ce09269b; }, function (v) { return $ba9f07d11e8eecf4$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $ba9f07d11e8eecf4$export$25062201e9e25d76; }, function (v) { return $ba9f07d11e8eecf4$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba9f07d11e8eecf4$export$ffb0004e005737fa;
var $ba9f07d11e8eecf4$export$34b9dba7ce09269b;
var $ba9f07d11e8eecf4$export$25062201e9e25d76;
"use strict";

var $8ZuGG = parcelRequire("8ZuGG");
var $ba9f07d11e8eecf4$var$k = Symbol.for("react.element"), $ba9f07d11e8eecf4$var$l = Symbol.for("react.fragment"), $ba9f07d11e8eecf4$var$m = Object.prototype.hasOwnProperty, $ba9f07d11e8eecf4$var$n = $8ZuGG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $ba9f07d11e8eecf4$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba9f07d11e8eecf4$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$ba9f07d11e8eecf4$var$m.call(a, b) && !$ba9f07d11e8eecf4$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $ba9f07d11e8eecf4$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $ba9f07d11e8eecf4$var$n.current
    };
}
$ba9f07d11e8eecf4$export$ffb0004e005737fa = $ba9f07d11e8eecf4$var$l;
$ba9f07d11e8eecf4$export$34b9dba7ce09269b = $ba9f07d11e8eecf4$var$q;
$ba9f07d11e8eecf4$export$25062201e9e25d76 = $ba9f07d11e8eecf4$var$q;

});
parcelRegister("8ZuGG", function(module, exports) {
"use strict";

module.exports = (parcelRequire("fZqWx"));

});
parcelRegister("fZqWx", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $ba4173e472b74fdb$export$dca3b0875bd9a954; }, function (v) { return $ba4173e472b74fdb$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $ba4173e472b74fdb$export$16fa2f45be04daa8; }, function (v) { return $ba4173e472b74fdb$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ba4173e472b74fdb$export$ffb0004e005737fa; }, function (v) { return $ba4173e472b74fdb$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $ba4173e472b74fdb$export$e2c29f18771995cb; }, function (v) { return $ba4173e472b74fdb$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $ba4173e472b74fdb$export$221d75b3f55bb0bd; }, function (v) { return $ba4173e472b74fdb$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ba4173e472b74fdb$export$5f8d39834fd61797; }, function (v) { return $ba4173e472b74fdb$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ba4173e472b74fdb$export$74bf444e3cd11ea5; }, function (v) { return $ba4173e472b74fdb$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $ba4173e472b74fdb$export$ae55be85d98224ed; }, function (v) { return $ba4173e472b74fdb$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $ba4173e472b74fdb$export$3ba232387fd5d6dd; }, function (v) { return $ba4173e472b74fdb$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $ba4173e472b74fdb$export$e530037191fcd5d7; }, function (v) { return $ba4173e472b74fdb$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $ba4173e472b74fdb$export$fd42f52fd3ae1109; }, function (v) { return $ba4173e472b74fdb$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $ba4173e472b74fdb$export$c8a8987d4410bf2d; }, function (v) { return $ba4173e472b74fdb$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $ba4173e472b74fdb$export$d38cd72104c1f0e9; }, function (v) { return $ba4173e472b74fdb$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $ba4173e472b74fdb$export$7d1e3a5e95ceca43; }, function (v) { return $ba4173e472b74fdb$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $ba4173e472b74fdb$export$257a8862b851cb5b; }, function (v) { return $ba4173e472b74fdb$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $ba4173e472b74fdb$export$a8257692ac88316c; }, function (v) { return $ba4173e472b74fdb$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $ba4173e472b74fdb$export$488013bae63b21da; }, function (v) { return $ba4173e472b74fdb$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $ba4173e472b74fdb$export$7c73462e0d25e514; }, function (v) { return $ba4173e472b74fdb$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $ba4173e472b74fdb$export$7568632d0d33d16d; }, function (v) { return $ba4173e472b74fdb$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $ba4173e472b74fdb$export$88948ce120ea2619; }, function (v) { return $ba4173e472b74fdb$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $ba4173e472b74fdb$export$35808ee640e87ca7; }, function (v) { return $ba4173e472b74fdb$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $ba4173e472b74fdb$export$fae74005e78b1a27; }, function (v) { return $ba4173e472b74fdb$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $ba4173e472b74fdb$export$dc8fbce3eb94dc1e; }, function (v) { return $ba4173e472b74fdb$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $ba4173e472b74fdb$export$6a7bc4e911dc01cf; }, function (v) { return $ba4173e472b74fdb$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $ba4173e472b74fdb$export$6d9c69b0de29b591; }, function (v) { return $ba4173e472b74fdb$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $ba4173e472b74fdb$export$f680877a34711e37; }, function (v) { return $ba4173e472b74fdb$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $ba4173e472b74fdb$export$d5a552a76deda3c2; }, function (v) { return $ba4173e472b74fdb$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $ba4173e472b74fdb$export$aaabe4eda9ed9969; }, function (v) { return $ba4173e472b74fdb$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $ba4173e472b74fdb$export$e5c5a5f917a5871c; }, function (v) { return $ba4173e472b74fdb$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $ba4173e472b74fdb$export$1538c33de8887b59; }, function (v) { return $ba4173e472b74fdb$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $ba4173e472b74fdb$export$13e3392192263954; }, function (v) { return $ba4173e472b74fdb$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $ba4173e472b74fdb$export$b8f5890fc79d6aca; }, function (v) { return $ba4173e472b74fdb$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $ba4173e472b74fdb$export$60241385465d0a34; }, function (v) { return $ba4173e472b74fdb$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $ba4173e472b74fdb$export$306c0aa65ff9ec16; }, function (v) { return $ba4173e472b74fdb$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $ba4173e472b74fdb$export$7b286972b8d8ccbf; }, function (v) { return $ba4173e472b74fdb$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $ba4173e472b74fdb$export$83d89fbfd8236492; }, function (v) { return $ba4173e472b74fdb$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ba4173e472b74fdb$export$dca3b0875bd9a954;
var $ba4173e472b74fdb$export$16fa2f45be04daa8;
var $ba4173e472b74fdb$export$ffb0004e005737fa;
var $ba4173e472b74fdb$export$e2c29f18771995cb;
var $ba4173e472b74fdb$export$221d75b3f55bb0bd;
var $ba4173e472b74fdb$export$5f8d39834fd61797;
var $ba4173e472b74fdb$export$74bf444e3cd11ea5;
var $ba4173e472b74fdb$export$ae55be85d98224ed;
var $ba4173e472b74fdb$export$3ba232387fd5d6dd;
var $ba4173e472b74fdb$export$e530037191fcd5d7;
var $ba4173e472b74fdb$export$fd42f52fd3ae1109;
var $ba4173e472b74fdb$export$c8a8987d4410bf2d;
var $ba4173e472b74fdb$export$d38cd72104c1f0e9;
var $ba4173e472b74fdb$export$7d1e3a5e95ceca43;
var $ba4173e472b74fdb$export$257a8862b851cb5b;
var $ba4173e472b74fdb$export$a8257692ac88316c;
var $ba4173e472b74fdb$export$488013bae63b21da;
var $ba4173e472b74fdb$export$7c73462e0d25e514;
var $ba4173e472b74fdb$export$7568632d0d33d16d;
var $ba4173e472b74fdb$export$88948ce120ea2619;
var $ba4173e472b74fdb$export$35808ee640e87ca7;
var $ba4173e472b74fdb$export$fae74005e78b1a27;
var $ba4173e472b74fdb$export$dc8fbce3eb94dc1e;
var $ba4173e472b74fdb$export$6a7bc4e911dc01cf;
var $ba4173e472b74fdb$export$6d9c69b0de29b591;
var $ba4173e472b74fdb$export$f680877a34711e37;
var $ba4173e472b74fdb$export$d5a552a76deda3c2;
var $ba4173e472b74fdb$export$aaabe4eda9ed9969;
var $ba4173e472b74fdb$export$e5c5a5f917a5871c;
var $ba4173e472b74fdb$export$1538c33de8887b59;
var $ba4173e472b74fdb$export$13e3392192263954;
var $ba4173e472b74fdb$export$b8f5890fc79d6aca;
var $ba4173e472b74fdb$export$60241385465d0a34;
var $ba4173e472b74fdb$export$306c0aa65ff9ec16;
var $ba4173e472b74fdb$export$7b286972b8d8ccbf;
var $ba4173e472b74fdb$export$83d89fbfd8236492;
"use strict";
var $ba4173e472b74fdb$var$l = Symbol.for("react.element"), $ba4173e472b74fdb$var$n = Symbol.for("react.portal"), $ba4173e472b74fdb$var$p = Symbol.for("react.fragment"), $ba4173e472b74fdb$var$q = Symbol.for("react.strict_mode"), $ba4173e472b74fdb$var$r = Symbol.for("react.profiler"), $ba4173e472b74fdb$var$t = Symbol.for("react.provider"), $ba4173e472b74fdb$var$u = Symbol.for("react.context"), $ba4173e472b74fdb$var$v = Symbol.for("react.forward_ref"), $ba4173e472b74fdb$var$w = Symbol.for("react.suspense"), $ba4173e472b74fdb$var$x = Symbol.for("react.memo"), $ba4173e472b74fdb$var$y = Symbol.for("react.lazy"), $ba4173e472b74fdb$var$z = Symbol.iterator;
function $ba4173e472b74fdb$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $ba4173e472b74fdb$var$z && a[$ba4173e472b74fdb$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $ba4173e472b74fdb$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $ba4173e472b74fdb$var$C = Object.assign, $ba4173e472b74fdb$var$D = {};
function $ba4173e472b74fdb$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ba4173e472b74fdb$var$D;
    this.updater = e || $ba4173e472b74fdb$var$B;
}
$ba4173e472b74fdb$var$E.prototype.isReactComponent = {};
$ba4173e472b74fdb$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$ba4173e472b74fdb$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $ba4173e472b74fdb$var$F() {}
$ba4173e472b74fdb$var$F.prototype = $ba4173e472b74fdb$var$E.prototype;
function $ba4173e472b74fdb$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $ba4173e472b74fdb$var$D;
    this.updater = e || $ba4173e472b74fdb$var$B;
}
var $ba4173e472b74fdb$var$H = $ba4173e472b74fdb$var$G.prototype = new $ba4173e472b74fdb$var$F;
$ba4173e472b74fdb$var$H.constructor = $ba4173e472b74fdb$var$G;
$ba4173e472b74fdb$var$C($ba4173e472b74fdb$var$H, $ba4173e472b74fdb$var$E.prototype);
$ba4173e472b74fdb$var$H.isPureReactComponent = !0;
var $ba4173e472b74fdb$var$I = Array.isArray, $ba4173e472b74fdb$var$J = Object.prototype.hasOwnProperty, $ba4173e472b74fdb$var$K = {
    current: null
}, $ba4173e472b74fdb$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $ba4173e472b74fdb$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$ba4173e472b74fdb$var$J.call(b, d) && !$ba4173e472b74fdb$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $ba4173e472b74fdb$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $ba4173e472b74fdb$var$K.current
    };
}
function $ba4173e472b74fdb$var$N(a, b) {
    return {
        $$typeof: $ba4173e472b74fdb$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $ba4173e472b74fdb$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ba4173e472b74fdb$var$l;
}
function $ba4173e472b74fdb$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $ba4173e472b74fdb$var$P = /\/+/g;
function $ba4173e472b74fdb$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $ba4173e472b74fdb$var$escape("" + a.key) : b.toString(36);
}
function $ba4173e472b74fdb$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $ba4173e472b74fdb$var$l:
                case $ba4173e472b74fdb$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $ba4173e472b74fdb$var$Q(h, 0) : d, $ba4173e472b74fdb$var$I(c) ? (e = "", null != a && (e = a.replace($ba4173e472b74fdb$var$P, "$&/") + "/"), $ba4173e472b74fdb$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($ba4173e472b74fdb$var$O(c) && (c = $ba4173e472b74fdb$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($ba4173e472b74fdb$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($ba4173e472b74fdb$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $ba4173e472b74fdb$var$Q(k, g);
        h += $ba4173e472b74fdb$var$R(k, b, e, f, c);
    }
    else if (f = $ba4173e472b74fdb$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $ba4173e472b74fdb$var$Q(k, g++), h += $ba4173e472b74fdb$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $ba4173e472b74fdb$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $ba4173e472b74fdb$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $ba4173e472b74fdb$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $ba4173e472b74fdb$var$U = {
    current: null
}, $ba4173e472b74fdb$var$V = {
    transition: null
}, $ba4173e472b74fdb$var$W = {
    ReactCurrentDispatcher: $ba4173e472b74fdb$var$U,
    ReactCurrentBatchConfig: $ba4173e472b74fdb$var$V,
    ReactCurrentOwner: $ba4173e472b74fdb$var$K
};
function $ba4173e472b74fdb$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$ba4173e472b74fdb$export$dca3b0875bd9a954 = {
    map: $ba4173e472b74fdb$var$S,
    forEach: function(a, b, e) {
        $ba4173e472b74fdb$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $ba4173e472b74fdb$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $ba4173e472b74fdb$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$ba4173e472b74fdb$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$ba4173e472b74fdb$export$16fa2f45be04daa8 = $ba4173e472b74fdb$var$E;
$ba4173e472b74fdb$export$ffb0004e005737fa = $ba4173e472b74fdb$var$p;
$ba4173e472b74fdb$export$e2c29f18771995cb = $ba4173e472b74fdb$var$r;
$ba4173e472b74fdb$export$221d75b3f55bb0bd = $ba4173e472b74fdb$var$G;
$ba4173e472b74fdb$export$5f8d39834fd61797 = $ba4173e472b74fdb$var$q;
$ba4173e472b74fdb$export$74bf444e3cd11ea5 = $ba4173e472b74fdb$var$w;
$ba4173e472b74fdb$export$ae55be85d98224ed = $ba4173e472b74fdb$var$W;
$ba4173e472b74fdb$export$3ba232387fd5d6dd = $ba4173e472b74fdb$var$X;
$ba4173e472b74fdb$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $ba4173e472b74fdb$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $ba4173e472b74fdb$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$ba4173e472b74fdb$var$J.call(b, f) && !$ba4173e472b74fdb$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $ba4173e472b74fdb$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$ba4173e472b74fdb$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $ba4173e472b74fdb$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $ba4173e472b74fdb$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$ba4173e472b74fdb$export$c8a8987d4410bf2d = $ba4173e472b74fdb$var$M;
$ba4173e472b74fdb$export$d38cd72104c1f0e9 = function(a) {
    var b = $ba4173e472b74fdb$var$M.bind(null, a);
    b.type = a;
    return b;
};
$ba4173e472b74fdb$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$ba4173e472b74fdb$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $ba4173e472b74fdb$var$v,
        render: a
    };
};
$ba4173e472b74fdb$export$a8257692ac88316c = $ba4173e472b74fdb$var$O;
$ba4173e472b74fdb$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $ba4173e472b74fdb$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $ba4173e472b74fdb$var$T
    };
};
$ba4173e472b74fdb$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $ba4173e472b74fdb$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$ba4173e472b74fdb$export$7568632d0d33d16d = function(a) {
    var b = $ba4173e472b74fdb$var$V.transition;
    $ba4173e472b74fdb$var$V.transition = {};
    try {
        a();
    } finally{
        $ba4173e472b74fdb$var$V.transition = b;
    }
};
$ba4173e472b74fdb$export$88948ce120ea2619 = $ba4173e472b74fdb$var$X;
$ba4173e472b74fdb$export$35808ee640e87ca7 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useCallback(a, b);
};
$ba4173e472b74fdb$export$fae74005e78b1a27 = function(a) {
    return $ba4173e472b74fdb$var$U.current.useContext(a);
};
$ba4173e472b74fdb$export$dc8fbce3eb94dc1e = function() {};
$ba4173e472b74fdb$export$6a7bc4e911dc01cf = function(a) {
    return $ba4173e472b74fdb$var$U.current.useDeferredValue(a);
};
$ba4173e472b74fdb$export$6d9c69b0de29b591 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useEffect(a, b);
};
$ba4173e472b74fdb$export$f680877a34711e37 = function() {
    return $ba4173e472b74fdb$var$U.current.useId();
};
$ba4173e472b74fdb$export$d5a552a76deda3c2 = function(a, b, e) {
    return $ba4173e472b74fdb$var$U.current.useImperativeHandle(a, b, e);
};
$ba4173e472b74fdb$export$aaabe4eda9ed9969 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useInsertionEffect(a, b);
};
$ba4173e472b74fdb$export$e5c5a5f917a5871c = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useLayoutEffect(a, b);
};
$ba4173e472b74fdb$export$1538c33de8887b59 = function(a, b) {
    return $ba4173e472b74fdb$var$U.current.useMemo(a, b);
};
$ba4173e472b74fdb$export$13e3392192263954 = function(a, b, e) {
    return $ba4173e472b74fdb$var$U.current.useReducer(a, b, e);
};
$ba4173e472b74fdb$export$b8f5890fc79d6aca = function(a) {
    return $ba4173e472b74fdb$var$U.current.useRef(a);
};
$ba4173e472b74fdb$export$60241385465d0a34 = function(a) {
    return $ba4173e472b74fdb$var$U.current.useState(a);
};
$ba4173e472b74fdb$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $ba4173e472b74fdb$var$U.current.useSyncExternalStore(a, b, e);
};
$ba4173e472b74fdb$export$7b286972b8d8ccbf = function() {
    return $ba4173e472b74fdb$var$U.current.useTransition();
};
$ba4173e472b74fdb$export$83d89fbfd8236492 = "18.3.1";

});




parcelRegister("h1d60", function(module, exports) {
"use strict";
function $c63cb039bba59465$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($c63cb039bba59465$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$c63cb039bba59465$var$checkDCE();

module.exports = (parcelRequire("lAuEq"));

});
parcelRegister("lAuEq", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $fb74bc6f62fb4035$export$ae55be85d98224ed; }, function (v) { return $fb74bc6f62fb4035$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $fb74bc6f62fb4035$export$d39a5bbd09211389; }, function (v) { return $fb74bc6f62fb4035$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $fb74bc6f62fb4035$export$882461b6382ed46c; }, function (v) { return $fb74bc6f62fb4035$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $fb74bc6f62fb4035$export$466bfc07425424d5; }, function (v) { return $fb74bc6f62fb4035$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $fb74bc6f62fb4035$export$cd75ccfd720a3cd4; }, function (v) { return $fb74bc6f62fb4035$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $fb74bc6f62fb4035$export$fa8d919ba61d84db; }, function (v) { return $fb74bc6f62fb4035$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $fb74bc6f62fb4035$export$757ceba2d55c277e; }, function (v) { return $fb74bc6f62fb4035$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $fb74bc6f62fb4035$export$b3890eb0ae9dca99; }, function (v) { return $fb74bc6f62fb4035$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $fb74bc6f62fb4035$export$502457920280e6be; }, function (v) { return $fb74bc6f62fb4035$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $fb74bc6f62fb4035$export$c78a37762a8d58e1; }, function (v) { return $fb74bc6f62fb4035$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $fb74bc6f62fb4035$export$dc54d992c10e8a18; }, function (v) { return $fb74bc6f62fb4035$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $fb74bc6f62fb4035$export$83d89fbfd8236492; }, function (v) { return $fb74bc6f62fb4035$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $fb74bc6f62fb4035$export$ae55be85d98224ed;
var $fb74bc6f62fb4035$export$d39a5bbd09211389;
var $fb74bc6f62fb4035$export$882461b6382ed46c;
var $fb74bc6f62fb4035$export$466bfc07425424d5;
var $fb74bc6f62fb4035$export$cd75ccfd720a3cd4;
var $fb74bc6f62fb4035$export$fa8d919ba61d84db;
var $fb74bc6f62fb4035$export$757ceba2d55c277e;
var $fb74bc6f62fb4035$export$b3890eb0ae9dca99;
var $fb74bc6f62fb4035$export$502457920280e6be;
var $fb74bc6f62fb4035$export$c78a37762a8d58e1;
var $fb74bc6f62fb4035$export$dc54d992c10e8a18;
var $fb74bc6f62fb4035$export$83d89fbfd8236492;
"use strict";

var $8ZuGG = parcelRequire("8ZuGG");

var $6S2nq = parcelRequire("6S2nq");
function $fb74bc6f62fb4035$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $fb74bc6f62fb4035$var$da = new Set, $fb74bc6f62fb4035$var$ea = {};
function $fb74bc6f62fb4035$var$fa(a, b) {
    $fb74bc6f62fb4035$var$ha(a, b);
    $fb74bc6f62fb4035$var$ha(a + "Capture", b);
}
function $fb74bc6f62fb4035$var$ha(a, b) {
    $fb74bc6f62fb4035$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$fb74bc6f62fb4035$var$da.add(b[a]);
}
var $fb74bc6f62fb4035$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $fb74bc6f62fb4035$var$ja = Object.prototype.hasOwnProperty, $fb74bc6f62fb4035$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $fb74bc6f62fb4035$var$la = {}, $fb74bc6f62fb4035$var$ma = {};
function $fb74bc6f62fb4035$var$oa(a) {
    if ($fb74bc6f62fb4035$var$ja.call($fb74bc6f62fb4035$var$ma, a)) return !0;
    if ($fb74bc6f62fb4035$var$ja.call($fb74bc6f62fb4035$var$la, a)) return !1;
    if ($fb74bc6f62fb4035$var$ka.test(a)) return $fb74bc6f62fb4035$var$ma[a] = !0;
    $fb74bc6f62fb4035$var$la[a] = !0;
    return !1;
}
function $fb74bc6f62fb4035$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $fb74bc6f62fb4035$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $fb74bc6f62fb4035$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $fb74bc6f62fb4035$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $fb74bc6f62fb4035$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $fb74bc6f62fb4035$var$ra = /[\-:]([a-z])/g;
function $fb74bc6f62fb4035$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($fb74bc6f62fb4035$var$ra, $fb74bc6f62fb4035$var$sa);
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($fb74bc6f62fb4035$var$ra, $fb74bc6f62fb4035$var$sa);
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($fb74bc6f62fb4035$var$ra, $fb74bc6f62fb4035$var$sa);
    $fb74bc6f62fb4035$var$z[b] = new $fb74bc6f62fb4035$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$fb74bc6f62fb4035$var$z.xlinkHref = new $fb74bc6f62fb4035$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $fb74bc6f62fb4035$var$z[a] = new $fb74bc6f62fb4035$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $fb74bc6f62fb4035$var$ta(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$z.hasOwnProperty(b) ? $fb74bc6f62fb4035$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $fb74bc6f62fb4035$var$qa(b, c, e, d) && (c = null), d || null === e ? $fb74bc6f62fb4035$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $fb74bc6f62fb4035$var$ua = $8ZuGG.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $fb74bc6f62fb4035$var$va = Symbol.for("react.element"), $fb74bc6f62fb4035$var$wa = Symbol.for("react.portal"), $fb74bc6f62fb4035$var$ya = Symbol.for("react.fragment"), $fb74bc6f62fb4035$var$za = Symbol.for("react.strict_mode"), $fb74bc6f62fb4035$var$Aa = Symbol.for("react.profiler"), $fb74bc6f62fb4035$var$Ba = Symbol.for("react.provider"), $fb74bc6f62fb4035$var$Ca = Symbol.for("react.context"), $fb74bc6f62fb4035$var$Da = Symbol.for("react.forward_ref"), $fb74bc6f62fb4035$var$Ea = Symbol.for("react.suspense"), $fb74bc6f62fb4035$var$Fa = Symbol.for("react.suspense_list"), $fb74bc6f62fb4035$var$Ga = Symbol.for("react.memo"), $fb74bc6f62fb4035$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $fb74bc6f62fb4035$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $fb74bc6f62fb4035$var$Ja = Symbol.iterator;
function $fb74bc6f62fb4035$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $fb74bc6f62fb4035$var$Ja && a[$fb74bc6f62fb4035$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $fb74bc6f62fb4035$var$A = Object.assign, $fb74bc6f62fb4035$var$La;
function $fb74bc6f62fb4035$var$Ma(a) {
    if (void 0 === $fb74bc6f62fb4035$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $fb74bc6f62fb4035$var$La = b && b[1] || "";
    }
    return "\n" + $fb74bc6f62fb4035$var$La + a;
}
var $fb74bc6f62fb4035$var$Na = !1;
function $fb74bc6f62fb4035$var$Oa(a, b) {
    if (!a || $fb74bc6f62fb4035$var$Na) return "";
    $fb74bc6f62fb4035$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $fb74bc6f62fb4035$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $fb74bc6f62fb4035$var$Ma(a) : "";
}
function $fb74bc6f62fb4035$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $fb74bc6f62fb4035$var$Ma(a.type);
        case 16:
            return $fb74bc6f62fb4035$var$Ma("Lazy");
        case 13:
            return $fb74bc6f62fb4035$var$Ma("Suspense");
        case 19:
            return $fb74bc6f62fb4035$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $fb74bc6f62fb4035$var$Oa(a.type, !1), a;
        case 11:
            return a = $fb74bc6f62fb4035$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $fb74bc6f62fb4035$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $fb74bc6f62fb4035$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $fb74bc6f62fb4035$var$ya:
            return "Fragment";
        case $fb74bc6f62fb4035$var$wa:
            return "Portal";
        case $fb74bc6f62fb4035$var$Aa:
            return "Profiler";
        case $fb74bc6f62fb4035$var$za:
            return "StrictMode";
        case $fb74bc6f62fb4035$var$Ea:
            return "Suspense";
        case $fb74bc6f62fb4035$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $fb74bc6f62fb4035$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $fb74bc6f62fb4035$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $fb74bc6f62fb4035$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $fb74bc6f62fb4035$var$Ga:
            return b = a.displayName || null, null !== b ? b : $fb74bc6f62fb4035$var$Qa(a.type) || "Memo";
        case $fb74bc6f62fb4035$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $fb74bc6f62fb4035$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $fb74bc6f62fb4035$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $fb74bc6f62fb4035$var$Qa(b);
        case 8:
            return b === $fb74bc6f62fb4035$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $fb74bc6f62fb4035$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $fb74bc6f62fb4035$var$Ua(a) {
    var b = $fb74bc6f62fb4035$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $fb74bc6f62fb4035$var$Va(a) {
    a._valueTracker || (a._valueTracker = $fb74bc6f62fb4035$var$Ua(a));
}
function $fb74bc6f62fb4035$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $fb74bc6f62fb4035$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $fb74bc6f62fb4035$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $fb74bc6f62fb4035$var$Ya(a, b) {
    var c = b.checked;
    return $fb74bc6f62fb4035$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $fb74bc6f62fb4035$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $fb74bc6f62fb4035$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $fb74bc6f62fb4035$var$ab(a, b) {
    b = b.checked;
    null != b && $fb74bc6f62fb4035$var$ta(a, "checked", b, !1);
}
function $fb74bc6f62fb4035$var$bb(a, b) {
    $fb74bc6f62fb4035$var$ab(a, b);
    var c = $fb74bc6f62fb4035$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $fb74bc6f62fb4035$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $fb74bc6f62fb4035$var$cb(a, b.type, $fb74bc6f62fb4035$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $fb74bc6f62fb4035$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $fb74bc6f62fb4035$var$cb(a, b, c) {
    if ("number" !== b || $fb74bc6f62fb4035$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $fb74bc6f62fb4035$var$eb = Array.isArray;
function $fb74bc6f62fb4035$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $fb74bc6f62fb4035$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $fb74bc6f62fb4035$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($fb74bc6f62fb4035$var$p(91));
    return $fb74bc6f62fb4035$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $fb74bc6f62fb4035$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($fb74bc6f62fb4035$var$p(92));
            if ($fb74bc6f62fb4035$var$eb(c)) {
                if (1 < c.length) throw Error($fb74bc6f62fb4035$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $fb74bc6f62fb4035$var$Sa(c)
    };
}
function $fb74bc6f62fb4035$var$ib(a, b) {
    var c = $fb74bc6f62fb4035$var$Sa(b.value), d = $fb74bc6f62fb4035$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $fb74bc6f62fb4035$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $fb74bc6f62fb4035$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $fb74bc6f62fb4035$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $fb74bc6f62fb4035$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $fb74bc6f62fb4035$var$mb, $fb74bc6f62fb4035$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $fb74bc6f62fb4035$var$mb = $fb74bc6f62fb4035$var$mb || document.createElement("div");
        $fb74bc6f62fb4035$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $fb74bc6f62fb4035$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $fb74bc6f62fb4035$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $fb74bc6f62fb4035$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $fb74bc6f62fb4035$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($fb74bc6f62fb4035$var$pb).forEach(function(a) {
    $fb74bc6f62fb4035$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $fb74bc6f62fb4035$var$pb[b] = $fb74bc6f62fb4035$var$pb[a];
    });
});
function $fb74bc6f62fb4035$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $fb74bc6f62fb4035$var$pb.hasOwnProperty(a) && $fb74bc6f62fb4035$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $fb74bc6f62fb4035$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $fb74bc6f62fb4035$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $fb74bc6f62fb4035$var$tb = $fb74bc6f62fb4035$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $fb74bc6f62fb4035$var$ub(a, b) {
    if (b) {
        if ($fb74bc6f62fb4035$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($fb74bc6f62fb4035$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($fb74bc6f62fb4035$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($fb74bc6f62fb4035$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($fb74bc6f62fb4035$var$p(62));
    }
}
function $fb74bc6f62fb4035$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $fb74bc6f62fb4035$var$wb = null;
function $fb74bc6f62fb4035$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $fb74bc6f62fb4035$var$yb = null, $fb74bc6f62fb4035$var$zb = null, $fb74bc6f62fb4035$var$Ab = null;
function $fb74bc6f62fb4035$var$Bb(a) {
    if (a = $fb74bc6f62fb4035$var$Cb(a)) {
        if ("function" !== typeof $fb74bc6f62fb4035$var$yb) throw Error($fb74bc6f62fb4035$var$p(280));
        var b = a.stateNode;
        b && (b = $fb74bc6f62fb4035$var$Db(b), $fb74bc6f62fb4035$var$yb(a.stateNode, a.type, b));
    }
}
function $fb74bc6f62fb4035$var$Eb(a) {
    $fb74bc6f62fb4035$var$zb ? $fb74bc6f62fb4035$var$Ab ? $fb74bc6f62fb4035$var$Ab.push(a) : $fb74bc6f62fb4035$var$Ab = [
        a
    ] : $fb74bc6f62fb4035$var$zb = a;
}
function $fb74bc6f62fb4035$var$Fb() {
    if ($fb74bc6f62fb4035$var$zb) {
        var a = $fb74bc6f62fb4035$var$zb, b = $fb74bc6f62fb4035$var$Ab;
        $fb74bc6f62fb4035$var$Ab = $fb74bc6f62fb4035$var$zb = null;
        $fb74bc6f62fb4035$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$fb74bc6f62fb4035$var$Bb(b[a]);
    }
}
function $fb74bc6f62fb4035$var$Gb(a, b) {
    return a(b);
}
function $fb74bc6f62fb4035$var$Hb() {}
var $fb74bc6f62fb4035$var$Ib = !1;
function $fb74bc6f62fb4035$var$Jb(a, b, c) {
    if ($fb74bc6f62fb4035$var$Ib) return a(b, c);
    $fb74bc6f62fb4035$var$Ib = !0;
    try {
        return $fb74bc6f62fb4035$var$Gb(a, b, c);
    } finally{
        if ($fb74bc6f62fb4035$var$Ib = !1, null !== $fb74bc6f62fb4035$var$zb || null !== $fb74bc6f62fb4035$var$Ab) $fb74bc6f62fb4035$var$Hb(), $fb74bc6f62fb4035$var$Fb();
    }
}
function $fb74bc6f62fb4035$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $fb74bc6f62fb4035$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($fb74bc6f62fb4035$var$p(231, b, typeof c));
    return c;
}
var $fb74bc6f62fb4035$var$Lb = !1;
if ($fb74bc6f62fb4035$var$ia) try {
    var $fb74bc6f62fb4035$var$Mb = {};
    Object.defineProperty($fb74bc6f62fb4035$var$Mb, "passive", {
        get: function() {
            $fb74bc6f62fb4035$var$Lb = !0;
        }
    });
    window.addEventListener("test", $fb74bc6f62fb4035$var$Mb, $fb74bc6f62fb4035$var$Mb);
    window.removeEventListener("test", $fb74bc6f62fb4035$var$Mb, $fb74bc6f62fb4035$var$Mb);
} catch (a) {
    $fb74bc6f62fb4035$var$Lb = !1;
}
function $fb74bc6f62fb4035$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $fb74bc6f62fb4035$var$Ob = !1, $fb74bc6f62fb4035$var$Pb = null, $fb74bc6f62fb4035$var$Qb = !1, $fb74bc6f62fb4035$var$Rb = null, $fb74bc6f62fb4035$var$Sb = {
    onError: function(a) {
        $fb74bc6f62fb4035$var$Ob = !0;
        $fb74bc6f62fb4035$var$Pb = a;
    }
};
function $fb74bc6f62fb4035$var$Tb(a, b, c, d, e, f, g, h, k) {
    $fb74bc6f62fb4035$var$Ob = !1;
    $fb74bc6f62fb4035$var$Pb = null;
    $fb74bc6f62fb4035$var$Nb.apply($fb74bc6f62fb4035$var$Sb, arguments);
}
function $fb74bc6f62fb4035$var$Ub(a, b, c, d, e, f, g, h, k) {
    $fb74bc6f62fb4035$var$Tb.apply(this, arguments);
    if ($fb74bc6f62fb4035$var$Ob) {
        if ($fb74bc6f62fb4035$var$Ob) {
            var l = $fb74bc6f62fb4035$var$Pb;
            $fb74bc6f62fb4035$var$Ob = !1;
            $fb74bc6f62fb4035$var$Pb = null;
        } else throw Error($fb74bc6f62fb4035$var$p(198));
        $fb74bc6f62fb4035$var$Qb || ($fb74bc6f62fb4035$var$Qb = !0, $fb74bc6f62fb4035$var$Rb = l);
    }
}
function $fb74bc6f62fb4035$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $fb74bc6f62fb4035$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Xb(a) {
    if ($fb74bc6f62fb4035$var$Vb(a) !== a) throw Error($fb74bc6f62fb4035$var$p(188));
}
function $fb74bc6f62fb4035$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $fb74bc6f62fb4035$var$Vb(a);
        if (null === b) throw Error($fb74bc6f62fb4035$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $fb74bc6f62fb4035$var$Xb(e), a;
                if (f === d) return $fb74bc6f62fb4035$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($fb74bc6f62fb4035$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($fb74bc6f62fb4035$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($fb74bc6f62fb4035$var$p(190));
    }
    if (3 !== c.tag) throw Error($fb74bc6f62fb4035$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $fb74bc6f62fb4035$var$Zb(a) {
    a = $fb74bc6f62fb4035$var$Yb(a);
    return null !== a ? $fb74bc6f62fb4035$var$$b(a) : null;
}
function $fb74bc6f62fb4035$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $fb74bc6f62fb4035$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $fb74bc6f62fb4035$var$ac = $6S2nq.unstable_scheduleCallback, $fb74bc6f62fb4035$var$bc = $6S2nq.unstable_cancelCallback, $fb74bc6f62fb4035$var$cc = $6S2nq.unstable_shouldYield, $fb74bc6f62fb4035$var$dc = $6S2nq.unstable_requestPaint, $fb74bc6f62fb4035$var$B = $6S2nq.unstable_now, $fb74bc6f62fb4035$var$ec = $6S2nq.unstable_getCurrentPriorityLevel, $fb74bc6f62fb4035$var$fc = $6S2nq.unstable_ImmediatePriority, $fb74bc6f62fb4035$var$gc = $6S2nq.unstable_UserBlockingPriority, $fb74bc6f62fb4035$var$hc = $6S2nq.unstable_NormalPriority, $fb74bc6f62fb4035$var$ic = $6S2nq.unstable_LowPriority, $fb74bc6f62fb4035$var$jc = $6S2nq.unstable_IdlePriority, $fb74bc6f62fb4035$var$kc = null, $fb74bc6f62fb4035$var$lc = null;
function $fb74bc6f62fb4035$var$mc(a) {
    if ($fb74bc6f62fb4035$var$lc && "function" === typeof $fb74bc6f62fb4035$var$lc.onCommitFiberRoot) try {
        $fb74bc6f62fb4035$var$lc.onCommitFiberRoot($fb74bc6f62fb4035$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $fb74bc6f62fb4035$var$oc = Math.clz32 ? Math.clz32 : $fb74bc6f62fb4035$var$nc, $fb74bc6f62fb4035$var$pc = Math.log, $fb74bc6f62fb4035$var$qc = Math.LN2;
function $fb74bc6f62fb4035$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($fb74bc6f62fb4035$var$pc(a) / $fb74bc6f62fb4035$var$qc | 0) | 0;
}
var $fb74bc6f62fb4035$var$rc = 64, $fb74bc6f62fb4035$var$sc = 4194304;
function $fb74bc6f62fb4035$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $fb74bc6f62fb4035$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $fb74bc6f62fb4035$var$tc(h) : (f &= g, 0 !== f && (d = $fb74bc6f62fb4035$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $fb74bc6f62fb4035$var$tc(g) : 0 !== f && (d = $fb74bc6f62fb4035$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $fb74bc6f62fb4035$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $fb74bc6f62fb4035$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $fb74bc6f62fb4035$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $fb74bc6f62fb4035$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $fb74bc6f62fb4035$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $fb74bc6f62fb4035$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $fb74bc6f62fb4035$var$yc() {
    var a = $fb74bc6f62fb4035$var$rc;
    $fb74bc6f62fb4035$var$rc <<= 1;
    0 === ($fb74bc6f62fb4035$var$rc & 4194240) && ($fb74bc6f62fb4035$var$rc = 64);
    return a;
}
function $fb74bc6f62fb4035$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $fb74bc6f62fb4035$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $fb74bc6f62fb4035$var$oc(b);
    a[b] = c;
}
function $fb74bc6f62fb4035$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $fb74bc6f62fb4035$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $fb74bc6f62fb4035$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $fb74bc6f62fb4035$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $fb74bc6f62fb4035$var$C = 0;
function $fb74bc6f62fb4035$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $fb74bc6f62fb4035$var$Ec, $fb74bc6f62fb4035$var$Fc, $fb74bc6f62fb4035$var$Gc, $fb74bc6f62fb4035$var$Hc, $fb74bc6f62fb4035$var$Ic, $fb74bc6f62fb4035$var$Jc = !1, $fb74bc6f62fb4035$var$Kc = [], $fb74bc6f62fb4035$var$Lc = null, $fb74bc6f62fb4035$var$Mc = null, $fb74bc6f62fb4035$var$Nc = null, $fb74bc6f62fb4035$var$Oc = new Map, $fb74bc6f62fb4035$var$Pc = new Map, $fb74bc6f62fb4035$var$Qc = [], $fb74bc6f62fb4035$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $fb74bc6f62fb4035$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $fb74bc6f62fb4035$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $fb74bc6f62fb4035$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $fb74bc6f62fb4035$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $fb74bc6f62fb4035$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $fb74bc6f62fb4035$var$Pc.delete(b.pointerId);
    }
}
function $fb74bc6f62fb4035$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $fb74bc6f62fb4035$var$Cb(b), null !== b && $fb74bc6f62fb4035$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $fb74bc6f62fb4035$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $fb74bc6f62fb4035$var$Lc = $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $fb74bc6f62fb4035$var$Mc = $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $fb74bc6f62fb4035$var$Nc = $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $fb74bc6f62fb4035$var$Oc.set(f, $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $fb74bc6f62fb4035$var$Pc.set(f, $fb74bc6f62fb4035$var$Tc($fb74bc6f62fb4035$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $fb74bc6f62fb4035$var$Vc(a) {
    var b = $fb74bc6f62fb4035$var$Wc(a.target);
    if (null !== b) {
        var c = $fb74bc6f62fb4035$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $fb74bc6f62fb4035$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $fb74bc6f62fb4035$var$Ic(a.priority, function() {
                        $fb74bc6f62fb4035$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $fb74bc6f62fb4035$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $fb74bc6f62fb4035$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $fb74bc6f62fb4035$var$wb = d;
            c.target.dispatchEvent(d);
            $fb74bc6f62fb4035$var$wb = null;
        } else return b = $fb74bc6f62fb4035$var$Cb(c), null !== b && $fb74bc6f62fb4035$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $fb74bc6f62fb4035$var$Zc(a, b, c) {
    $fb74bc6f62fb4035$var$Xc(a) && c.delete(b);
}
function $fb74bc6f62fb4035$var$$c() {
    $fb74bc6f62fb4035$var$Jc = !1;
    null !== $fb74bc6f62fb4035$var$Lc && $fb74bc6f62fb4035$var$Xc($fb74bc6f62fb4035$var$Lc) && ($fb74bc6f62fb4035$var$Lc = null);
    null !== $fb74bc6f62fb4035$var$Mc && $fb74bc6f62fb4035$var$Xc($fb74bc6f62fb4035$var$Mc) && ($fb74bc6f62fb4035$var$Mc = null);
    null !== $fb74bc6f62fb4035$var$Nc && $fb74bc6f62fb4035$var$Xc($fb74bc6f62fb4035$var$Nc) && ($fb74bc6f62fb4035$var$Nc = null);
    $fb74bc6f62fb4035$var$Oc.forEach($fb74bc6f62fb4035$var$Zc);
    $fb74bc6f62fb4035$var$Pc.forEach($fb74bc6f62fb4035$var$Zc);
}
function $fb74bc6f62fb4035$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $fb74bc6f62fb4035$var$Jc || ($fb74bc6f62fb4035$var$Jc = !0, $6S2nq.unstable_scheduleCallback($6S2nq.unstable_NormalPriority, $fb74bc6f62fb4035$var$$c)));
}
function $fb74bc6f62fb4035$var$bd(a) {
    function b(b) {
        return $fb74bc6f62fb4035$var$ad(b, a);
    }
    if (0 < $fb74bc6f62fb4035$var$Kc.length) {
        $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Kc[0], a);
        for(var c = 1; c < $fb74bc6f62fb4035$var$Kc.length; c++){
            var d = $fb74bc6f62fb4035$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $fb74bc6f62fb4035$var$Lc && $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Lc, a);
    null !== $fb74bc6f62fb4035$var$Mc && $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Mc, a);
    null !== $fb74bc6f62fb4035$var$Nc && $fb74bc6f62fb4035$var$ad($fb74bc6f62fb4035$var$Nc, a);
    $fb74bc6f62fb4035$var$Oc.forEach(b);
    $fb74bc6f62fb4035$var$Pc.forEach(b);
    for(c = 0; c < $fb74bc6f62fb4035$var$Qc.length; c++)d = $fb74bc6f62fb4035$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $fb74bc6f62fb4035$var$Qc.length && (c = $fb74bc6f62fb4035$var$Qc[0], null === c.blockedOn);)$fb74bc6f62fb4035$var$Vc(c), null === c.blockedOn && $fb74bc6f62fb4035$var$Qc.shift();
}
var $fb74bc6f62fb4035$var$cd = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig, $fb74bc6f62fb4035$var$dd = !0;
function $fb74bc6f62fb4035$var$ed(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$C, f = $fb74bc6f62fb4035$var$cd.transition;
    $fb74bc6f62fb4035$var$cd.transition = null;
    try {
        $fb74bc6f62fb4035$var$C = 1, $fb74bc6f62fb4035$var$fd(a, b, c, d);
    } finally{
        $fb74bc6f62fb4035$var$C = e, $fb74bc6f62fb4035$var$cd.transition = f;
    }
}
function $fb74bc6f62fb4035$var$gd(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$C, f = $fb74bc6f62fb4035$var$cd.transition;
    $fb74bc6f62fb4035$var$cd.transition = null;
    try {
        $fb74bc6f62fb4035$var$C = 4, $fb74bc6f62fb4035$var$fd(a, b, c, d);
    } finally{
        $fb74bc6f62fb4035$var$C = e, $fb74bc6f62fb4035$var$cd.transition = f;
    }
}
function $fb74bc6f62fb4035$var$fd(a, b, c, d) {
    if ($fb74bc6f62fb4035$var$dd) {
        var e = $fb74bc6f62fb4035$var$Yc(a, b, c, d);
        if (null === e) $fb74bc6f62fb4035$var$hd(a, b, d, $fb74bc6f62fb4035$var$id, c), $fb74bc6f62fb4035$var$Sc(a, d);
        else if ($fb74bc6f62fb4035$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($fb74bc6f62fb4035$var$Sc(a, d), b & 4 && -1 < $fb74bc6f62fb4035$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $fb74bc6f62fb4035$var$Cb(e);
                null !== f && $fb74bc6f62fb4035$var$Ec(f);
                f = $fb74bc6f62fb4035$var$Yc(a, b, c, d);
                null === f && $fb74bc6f62fb4035$var$hd(a, b, d, $fb74bc6f62fb4035$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $fb74bc6f62fb4035$var$hd(a, b, d, null, c);
    }
}
var $fb74bc6f62fb4035$var$id = null;
function $fb74bc6f62fb4035$var$Yc(a, b, c, d) {
    $fb74bc6f62fb4035$var$id = null;
    a = $fb74bc6f62fb4035$var$xb(d);
    a = $fb74bc6f62fb4035$var$Wc(a);
    if (null !== a) {
        if (b = $fb74bc6f62fb4035$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $fb74bc6f62fb4035$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $fb74bc6f62fb4035$var$id = a;
    return null;
}
function $fb74bc6f62fb4035$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($fb74bc6f62fb4035$var$ec()){
                case $fb74bc6f62fb4035$var$fc:
                    return 1;
                case $fb74bc6f62fb4035$var$gc:
                    return 4;
                case $fb74bc6f62fb4035$var$hc:
                case $fb74bc6f62fb4035$var$ic:
                    return 16;
                case $fb74bc6f62fb4035$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $fb74bc6f62fb4035$var$kd = null, $fb74bc6f62fb4035$var$ld = null, $fb74bc6f62fb4035$var$md = null;
function $fb74bc6f62fb4035$var$nd() {
    if ($fb74bc6f62fb4035$var$md) return $fb74bc6f62fb4035$var$md;
    var a, b = $fb74bc6f62fb4035$var$ld, c = b.length, d, e = "value" in $fb74bc6f62fb4035$var$kd ? $fb74bc6f62fb4035$var$kd.value : $fb74bc6f62fb4035$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $fb74bc6f62fb4035$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $fb74bc6f62fb4035$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $fb74bc6f62fb4035$var$pd() {
    return !0;
}
function $fb74bc6f62fb4035$var$qd() {
    return !1;
}
function $fb74bc6f62fb4035$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $fb74bc6f62fb4035$var$pd : $fb74bc6f62fb4035$var$qd;
        this.isPropagationStopped = $fb74bc6f62fb4035$var$qd;
        return this;
    }
    $fb74bc6f62fb4035$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $fb74bc6f62fb4035$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $fb74bc6f62fb4035$var$pd);
        },
        persist: function() {},
        isPersistent: $fb74bc6f62fb4035$var$pd
    });
    return b;
}
var $fb74bc6f62fb4035$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $fb74bc6f62fb4035$var$td = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$sd), $fb74bc6f62fb4035$var$ud = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    view: 0,
    detail: 0
}), $fb74bc6f62fb4035$var$vd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$ud), $fb74bc6f62fb4035$var$wd, $fb74bc6f62fb4035$var$xd, $fb74bc6f62fb4035$var$yd, $fb74bc6f62fb4035$var$Ad = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $fb74bc6f62fb4035$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $fb74bc6f62fb4035$var$yd && ($fb74bc6f62fb4035$var$yd && "mousemove" === a.type ? ($fb74bc6f62fb4035$var$wd = a.screenX - $fb74bc6f62fb4035$var$yd.screenX, $fb74bc6f62fb4035$var$xd = a.screenY - $fb74bc6f62fb4035$var$yd.screenY) : $fb74bc6f62fb4035$var$xd = $fb74bc6f62fb4035$var$wd = 0, $fb74bc6f62fb4035$var$yd = a);
        return $fb74bc6f62fb4035$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $fb74bc6f62fb4035$var$xd;
    }
}), $fb74bc6f62fb4035$var$Bd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Ad), $fb74bc6f62fb4035$var$Cd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$Ad, {
    dataTransfer: 0
}), $fb74bc6f62fb4035$var$Dd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Cd), $fb74bc6f62fb4035$var$Ed = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    relatedTarget: 0
}), $fb74bc6f62fb4035$var$Fd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Ed), $fb74bc6f62fb4035$var$Gd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fb74bc6f62fb4035$var$Hd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Gd), $fb74bc6f62fb4035$var$Id = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $fb74bc6f62fb4035$var$Jd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Id), $fb74bc6f62fb4035$var$Kd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    data: 0
}), $fb74bc6f62fb4035$var$Ld = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Kd), $fb74bc6f62fb4035$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $fb74bc6f62fb4035$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $fb74bc6f62fb4035$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $fb74bc6f62fb4035$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $fb74bc6f62fb4035$var$Od[a]) ? !!b[a] : !1;
}
function $fb74bc6f62fb4035$var$zd() {
    return $fb74bc6f62fb4035$var$Pd;
}
var $fb74bc6f62fb4035$var$Qd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $fb74bc6f62fb4035$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $fb74bc6f62fb4035$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $fb74bc6f62fb4035$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $fb74bc6f62fb4035$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $fb74bc6f62fb4035$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $fb74bc6f62fb4035$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $fb74bc6f62fb4035$var$Rd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Qd), $fb74bc6f62fb4035$var$Sd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $fb74bc6f62fb4035$var$Td = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Sd), $fb74bc6f62fb4035$var$Ud = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $fb74bc6f62fb4035$var$zd
}), $fb74bc6f62fb4035$var$Vd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Ud), $fb74bc6f62fb4035$var$Wd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $fb74bc6f62fb4035$var$Xd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Wd), $fb74bc6f62fb4035$var$Yd = $fb74bc6f62fb4035$var$A({}, $fb74bc6f62fb4035$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $fb74bc6f62fb4035$var$Zd = $fb74bc6f62fb4035$var$rd($fb74bc6f62fb4035$var$Yd), $fb74bc6f62fb4035$var$$d = [
    9,
    13,
    27,
    32
], $fb74bc6f62fb4035$var$ae = $fb74bc6f62fb4035$var$ia && "CompositionEvent" in window, $fb74bc6f62fb4035$var$be = null;
$fb74bc6f62fb4035$var$ia && "documentMode" in document && ($fb74bc6f62fb4035$var$be = document.documentMode);
var $fb74bc6f62fb4035$var$ce = $fb74bc6f62fb4035$var$ia && "TextEvent" in window && !$fb74bc6f62fb4035$var$be, $fb74bc6f62fb4035$var$de = $fb74bc6f62fb4035$var$ia && (!$fb74bc6f62fb4035$var$ae || $fb74bc6f62fb4035$var$be && 8 < $fb74bc6f62fb4035$var$be && 11 >= $fb74bc6f62fb4035$var$be), $fb74bc6f62fb4035$var$ee = String.fromCharCode(32), $fb74bc6f62fb4035$var$fe = !1;
function $fb74bc6f62fb4035$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $fb74bc6f62fb4035$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $fb74bc6f62fb4035$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $fb74bc6f62fb4035$var$ie = !1;
function $fb74bc6f62fb4035$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $fb74bc6f62fb4035$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $fb74bc6f62fb4035$var$fe = !0;
            return $fb74bc6f62fb4035$var$ee;
        case "textInput":
            return a = b.data, a === $fb74bc6f62fb4035$var$ee && $fb74bc6f62fb4035$var$fe ? null : a;
        default:
            return null;
    }
}
function $fb74bc6f62fb4035$var$ke(a, b) {
    if ($fb74bc6f62fb4035$var$ie) return "compositionend" === a || !$fb74bc6f62fb4035$var$ae && $fb74bc6f62fb4035$var$ge(a, b) ? (a = $fb74bc6f62fb4035$var$nd(), $fb74bc6f62fb4035$var$md = $fb74bc6f62fb4035$var$ld = $fb74bc6f62fb4035$var$kd = null, $fb74bc6f62fb4035$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $fb74bc6f62fb4035$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $fb74bc6f62fb4035$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $fb74bc6f62fb4035$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$fb74bc6f62fb4035$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $fb74bc6f62fb4035$var$ne(a, b, c, d) {
    $fb74bc6f62fb4035$var$Eb(d);
    b = $fb74bc6f62fb4035$var$oe(b, "onChange");
    0 < b.length && (c = new $fb74bc6f62fb4035$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $fb74bc6f62fb4035$var$pe = null, $fb74bc6f62fb4035$var$qe = null;
function $fb74bc6f62fb4035$var$re(a) {
    $fb74bc6f62fb4035$var$se(a, 0);
}
function $fb74bc6f62fb4035$var$te(a) {
    var b = $fb74bc6f62fb4035$var$ue(a);
    if ($fb74bc6f62fb4035$var$Wa(b)) return a;
}
function $fb74bc6f62fb4035$var$ve(a, b) {
    if ("change" === a) return b;
}
var $fb74bc6f62fb4035$var$we = !1;
if ($fb74bc6f62fb4035$var$ia) {
    var $fb74bc6f62fb4035$var$xe;
    if ($fb74bc6f62fb4035$var$ia) {
        var $fb74bc6f62fb4035$var$ye = "oninput" in document;
        if (!$fb74bc6f62fb4035$var$ye) {
            var $fb74bc6f62fb4035$var$ze = document.createElement("div");
            $fb74bc6f62fb4035$var$ze.setAttribute("oninput", "return;");
            $fb74bc6f62fb4035$var$ye = "function" === typeof $fb74bc6f62fb4035$var$ze.oninput;
        }
        $fb74bc6f62fb4035$var$xe = $fb74bc6f62fb4035$var$ye;
    } else $fb74bc6f62fb4035$var$xe = !1;
    $fb74bc6f62fb4035$var$we = $fb74bc6f62fb4035$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $fb74bc6f62fb4035$var$Ae() {
    $fb74bc6f62fb4035$var$pe && ($fb74bc6f62fb4035$var$pe.detachEvent("onpropertychange", $fb74bc6f62fb4035$var$Be), $fb74bc6f62fb4035$var$qe = $fb74bc6f62fb4035$var$pe = null);
}
function $fb74bc6f62fb4035$var$Be(a) {
    if ("value" === a.propertyName && $fb74bc6f62fb4035$var$te($fb74bc6f62fb4035$var$qe)) {
        var b = [];
        $fb74bc6f62fb4035$var$ne(b, $fb74bc6f62fb4035$var$qe, a, $fb74bc6f62fb4035$var$xb(a));
        $fb74bc6f62fb4035$var$Jb($fb74bc6f62fb4035$var$re, b);
    }
}
function $fb74bc6f62fb4035$var$Ce(a, b, c) {
    "focusin" === a ? ($fb74bc6f62fb4035$var$Ae(), $fb74bc6f62fb4035$var$pe = b, $fb74bc6f62fb4035$var$qe = c, $fb74bc6f62fb4035$var$pe.attachEvent("onpropertychange", $fb74bc6f62fb4035$var$Be)) : "focusout" === a && $fb74bc6f62fb4035$var$Ae();
}
function $fb74bc6f62fb4035$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $fb74bc6f62fb4035$var$te($fb74bc6f62fb4035$var$qe);
}
function $fb74bc6f62fb4035$var$Ee(a, b) {
    if ("click" === a) return $fb74bc6f62fb4035$var$te(b);
}
function $fb74bc6f62fb4035$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $fb74bc6f62fb4035$var$te(b);
}
function $fb74bc6f62fb4035$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $fb74bc6f62fb4035$var$He = "function" === typeof Object.is ? Object.is : $fb74bc6f62fb4035$var$Ge;
function $fb74bc6f62fb4035$var$Ie(a, b) {
    if ($fb74bc6f62fb4035$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$fb74bc6f62fb4035$var$ja.call(b, e) || !$fb74bc6f62fb4035$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $fb74bc6f62fb4035$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $fb74bc6f62fb4035$var$Ke(a, b) {
    var c = $fb74bc6f62fb4035$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $fb74bc6f62fb4035$var$Je(c);
    }
}
function $fb74bc6f62fb4035$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $fb74bc6f62fb4035$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $fb74bc6f62fb4035$var$Me() {
    for(var a = window, b = $fb74bc6f62fb4035$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $fb74bc6f62fb4035$var$Xa(a.document);
    }
    return b;
}
function $fb74bc6f62fb4035$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $fb74bc6f62fb4035$var$Oe(a) {
    var b = $fb74bc6f62fb4035$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $fb74bc6f62fb4035$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $fb74bc6f62fb4035$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $fb74bc6f62fb4035$var$Ke(c, f);
                var g = $fb74bc6f62fb4035$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $fb74bc6f62fb4035$var$Pe = $fb74bc6f62fb4035$var$ia && "documentMode" in document && 11 >= document.documentMode, $fb74bc6f62fb4035$var$Qe = null, $fb74bc6f62fb4035$var$Re = null, $fb74bc6f62fb4035$var$Se = null, $fb74bc6f62fb4035$var$Te = !1;
function $fb74bc6f62fb4035$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $fb74bc6f62fb4035$var$Te || null == $fb74bc6f62fb4035$var$Qe || $fb74bc6f62fb4035$var$Qe !== $fb74bc6f62fb4035$var$Xa(d) || (d = $fb74bc6f62fb4035$var$Qe, "selectionStart" in d && $fb74bc6f62fb4035$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $fb74bc6f62fb4035$var$Se && $fb74bc6f62fb4035$var$Ie($fb74bc6f62fb4035$var$Se, d) || ($fb74bc6f62fb4035$var$Se = d, d = $fb74bc6f62fb4035$var$oe($fb74bc6f62fb4035$var$Re, "onSelect"), 0 < d.length && (b = new $fb74bc6f62fb4035$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $fb74bc6f62fb4035$var$Qe)));
}
function $fb74bc6f62fb4035$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $fb74bc6f62fb4035$var$We = {
    animationend: $fb74bc6f62fb4035$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $fb74bc6f62fb4035$var$Ve("Animation", "AnimationIteration"),
    animationstart: $fb74bc6f62fb4035$var$Ve("Animation", "AnimationStart"),
    transitionend: $fb74bc6f62fb4035$var$Ve("Transition", "TransitionEnd")
}, $fb74bc6f62fb4035$var$Xe = {}, $fb74bc6f62fb4035$var$Ye = {};
$fb74bc6f62fb4035$var$ia && ($fb74bc6f62fb4035$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $fb74bc6f62fb4035$var$We.animationend.animation, delete $fb74bc6f62fb4035$var$We.animationiteration.animation, delete $fb74bc6f62fb4035$var$We.animationstart.animation), "TransitionEvent" in window || delete $fb74bc6f62fb4035$var$We.transitionend.transition);
function $fb74bc6f62fb4035$var$Ze(a) {
    if ($fb74bc6f62fb4035$var$Xe[a]) return $fb74bc6f62fb4035$var$Xe[a];
    if (!$fb74bc6f62fb4035$var$We[a]) return a;
    var b = $fb74bc6f62fb4035$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $fb74bc6f62fb4035$var$Ye) return $fb74bc6f62fb4035$var$Xe[a] = b[c];
    return a;
}
var $fb74bc6f62fb4035$var$$e = $fb74bc6f62fb4035$var$Ze("animationend"), $fb74bc6f62fb4035$var$af = $fb74bc6f62fb4035$var$Ze("animationiteration"), $fb74bc6f62fb4035$var$bf = $fb74bc6f62fb4035$var$Ze("animationstart"), $fb74bc6f62fb4035$var$cf = $fb74bc6f62fb4035$var$Ze("transitionend"), $fb74bc6f62fb4035$var$df = new Map, $fb74bc6f62fb4035$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $fb74bc6f62fb4035$var$ff(a, b) {
    $fb74bc6f62fb4035$var$df.set(a, b);
    $fb74bc6f62fb4035$var$fa(b, [
        a
    ]);
}
for(var $fb74bc6f62fb4035$var$gf = 0; $fb74bc6f62fb4035$var$gf < $fb74bc6f62fb4035$var$ef.length; $fb74bc6f62fb4035$var$gf++){
    var $fb74bc6f62fb4035$var$hf = $fb74bc6f62fb4035$var$ef[$fb74bc6f62fb4035$var$gf], $fb74bc6f62fb4035$var$jf = $fb74bc6f62fb4035$var$hf.toLowerCase(), $fb74bc6f62fb4035$var$kf = $fb74bc6f62fb4035$var$hf[0].toUpperCase() + $fb74bc6f62fb4035$var$hf.slice(1);
    $fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$jf, "on" + $fb74bc6f62fb4035$var$kf);
}
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$$e, "onAnimationEnd");
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$af, "onAnimationIteration");
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$bf, "onAnimationStart");
$fb74bc6f62fb4035$var$ff("dblclick", "onDoubleClick");
$fb74bc6f62fb4035$var$ff("focusin", "onFocus");
$fb74bc6f62fb4035$var$ff("focusout", "onBlur");
$fb74bc6f62fb4035$var$ff($fb74bc6f62fb4035$var$cf, "onTransitionEnd");
$fb74bc6f62fb4035$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$fb74bc6f62fb4035$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$fb74bc6f62fb4035$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$fb74bc6f62fb4035$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$fb74bc6f62fb4035$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$fb74bc6f62fb4035$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$fb74bc6f62fb4035$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$fb74bc6f62fb4035$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$fb74bc6f62fb4035$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$fb74bc6f62fb4035$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $fb74bc6f62fb4035$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $fb74bc6f62fb4035$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($fb74bc6f62fb4035$var$lf));
function $fb74bc6f62fb4035$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $fb74bc6f62fb4035$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $fb74bc6f62fb4035$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fb74bc6f62fb4035$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $fb74bc6f62fb4035$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($fb74bc6f62fb4035$var$Qb) throw a = $fb74bc6f62fb4035$var$Rb, $fb74bc6f62fb4035$var$Qb = !1, $fb74bc6f62fb4035$var$Rb = null, a;
}
function $fb74bc6f62fb4035$var$D(a, b) {
    var c = b[$fb74bc6f62fb4035$var$of];
    void 0 === c && (c = b[$fb74bc6f62fb4035$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($fb74bc6f62fb4035$var$pf(b, a, 2, !1), c.add(d));
}
function $fb74bc6f62fb4035$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $fb74bc6f62fb4035$var$pf(c, a, d, b);
}
var $fb74bc6f62fb4035$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $fb74bc6f62fb4035$var$sf(a) {
    if (!a[$fb74bc6f62fb4035$var$rf]) {
        a[$fb74bc6f62fb4035$var$rf] = !0;
        $fb74bc6f62fb4035$var$da.forEach(function(b) {
            "selectionchange" !== b && ($fb74bc6f62fb4035$var$mf.has(b) || $fb74bc6f62fb4035$var$qf(b, !1, a), $fb74bc6f62fb4035$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$fb74bc6f62fb4035$var$rf] || (b[$fb74bc6f62fb4035$var$rf] = !0, $fb74bc6f62fb4035$var$qf("selectionchange", !1, b));
    }
}
function $fb74bc6f62fb4035$var$pf(a, b, c, d) {
    switch($fb74bc6f62fb4035$var$jd(b)){
        case 1:
            var e = $fb74bc6f62fb4035$var$ed;
            break;
        case 4:
            e = $fb74bc6f62fb4035$var$gd;
            break;
        default:
            e = $fb74bc6f62fb4035$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$fb74bc6f62fb4035$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $fb74bc6f62fb4035$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $fb74bc6f62fb4035$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $fb74bc6f62fb4035$var$Jb(function() {
        var d = f, e = $fb74bc6f62fb4035$var$xb(c), g = [];
        a: {
            var h = $fb74bc6f62fb4035$var$df.get(a);
            if (void 0 !== h) {
                var k = $fb74bc6f62fb4035$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $fb74bc6f62fb4035$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $fb74bc6f62fb4035$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $fb74bc6f62fb4035$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $fb74bc6f62fb4035$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $fb74bc6f62fb4035$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $fb74bc6f62fb4035$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $fb74bc6f62fb4035$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $fb74bc6f62fb4035$var$Vd;
                        break;
                    case $fb74bc6f62fb4035$var$$e:
                    case $fb74bc6f62fb4035$var$af:
                    case $fb74bc6f62fb4035$var$bf:
                        k = $fb74bc6f62fb4035$var$Hd;
                        break;
                    case $fb74bc6f62fb4035$var$cf:
                        k = $fb74bc6f62fb4035$var$Xd;
                        break;
                    case "scroll":
                        k = $fb74bc6f62fb4035$var$vd;
                        break;
                    case "wheel":
                        k = $fb74bc6f62fb4035$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $fb74bc6f62fb4035$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $fb74bc6f62fb4035$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $fb74bc6f62fb4035$var$Kb(w, x), null != F && t.push($fb74bc6f62fb4035$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $fb74bc6f62fb4035$var$wb && (n = c.relatedTarget || c.fromElement) && ($fb74bc6f62fb4035$var$Wc(n) || n[$fb74bc6f62fb4035$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $fb74bc6f62fb4035$var$Wc(n) : null, null !== n && (J = $fb74bc6f62fb4035$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $fb74bc6f62fb4035$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $fb74bc6f62fb4035$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $fb74bc6f62fb4035$var$ue(k);
                        u = null == n ? h : $fb74bc6f62fb4035$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $fb74bc6f62fb4035$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $fb74bc6f62fb4035$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $fb74bc6f62fb4035$var$vf(F))u++;
                            for(; 0 < w - u;)t = $fb74bc6f62fb4035$var$vf(t), w--;
                            for(; 0 < u - w;)x = $fb74bc6f62fb4035$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $fb74bc6f62fb4035$var$vf(t);
                                x = $fb74bc6f62fb4035$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $fb74bc6f62fb4035$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $fb74bc6f62fb4035$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $fb74bc6f62fb4035$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $fb74bc6f62fb4035$var$ve;
                else if ($fb74bc6f62fb4035$var$me(h)) {
                    if ($fb74bc6f62fb4035$var$we) na = $fb74bc6f62fb4035$var$Fe;
                    else {
                        na = $fb74bc6f62fb4035$var$De;
                        var xa = $fb74bc6f62fb4035$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $fb74bc6f62fb4035$var$Ee);
                if (na && (na = na(a, d))) {
                    $fb74bc6f62fb4035$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $fb74bc6f62fb4035$var$cb(h, "number", h.value);
            }
            xa = d ? $fb74bc6f62fb4035$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($fb74bc6f62fb4035$var$me(xa) || "true" === xa.contentEditable) $fb74bc6f62fb4035$var$Qe = xa, $fb74bc6f62fb4035$var$Re = d, $fb74bc6f62fb4035$var$Se = null;
                    break;
                case "focusout":
                    $fb74bc6f62fb4035$var$Se = $fb74bc6f62fb4035$var$Re = $fb74bc6f62fb4035$var$Qe = null;
                    break;
                case "mousedown":
                    $fb74bc6f62fb4035$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $fb74bc6f62fb4035$var$Te = !1;
                    $fb74bc6f62fb4035$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($fb74bc6f62fb4035$var$Pe) break;
                case "keydown":
                case "keyup":
                    $fb74bc6f62fb4035$var$Ue(g, c, e);
            }
            var $a;
            if ($fb74bc6f62fb4035$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $fb74bc6f62fb4035$var$ie ? $fb74bc6f62fb4035$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($fb74bc6f62fb4035$var$de && "ko" !== c.locale && ($fb74bc6f62fb4035$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $fb74bc6f62fb4035$var$ie && ($a = $fb74bc6f62fb4035$var$nd()) : ($fb74bc6f62fb4035$var$kd = e, $fb74bc6f62fb4035$var$ld = "value" in $fb74bc6f62fb4035$var$kd ? $fb74bc6f62fb4035$var$kd.value : $fb74bc6f62fb4035$var$kd.textContent, $fb74bc6f62fb4035$var$ie = !0)), xa = $fb74bc6f62fb4035$var$oe(d, ba), 0 < xa.length && (ba = new $fb74bc6f62fb4035$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $fb74bc6f62fb4035$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $fb74bc6f62fb4035$var$ce ? $fb74bc6f62fb4035$var$je(a, c) : $fb74bc6f62fb4035$var$ke(a, c)) d = $fb74bc6f62fb4035$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $fb74bc6f62fb4035$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $fb74bc6f62fb4035$var$se(g, b);
    });
}
function $fb74bc6f62fb4035$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $fb74bc6f62fb4035$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $fb74bc6f62fb4035$var$Kb(a, c), null != f && d.unshift($fb74bc6f62fb4035$var$tf(a, f, e)), f = $fb74bc6f62fb4035$var$Kb(a, b), null != f && d.push($fb74bc6f62fb4035$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $fb74bc6f62fb4035$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $fb74bc6f62fb4035$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $fb74bc6f62fb4035$var$Kb(c, f), null != k && g.unshift($fb74bc6f62fb4035$var$tf(c, k, h))) : e || (k = $fb74bc6f62fb4035$var$Kb(c, f), null != k && g.push($fb74bc6f62fb4035$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $fb74bc6f62fb4035$var$xf = /\r\n?/g, $fb74bc6f62fb4035$var$yf = /\u0000|\uFFFD/g;
function $fb74bc6f62fb4035$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($fb74bc6f62fb4035$var$xf, "\n").replace($fb74bc6f62fb4035$var$yf, "");
}
function $fb74bc6f62fb4035$var$Af(a, b, c) {
    b = $fb74bc6f62fb4035$var$zf(b);
    if ($fb74bc6f62fb4035$var$zf(a) !== b && c) throw Error($fb74bc6f62fb4035$var$p(425));
}
function $fb74bc6f62fb4035$var$Bf() {}
var $fb74bc6f62fb4035$var$Cf = null, $fb74bc6f62fb4035$var$Df = null;
function $fb74bc6f62fb4035$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $fb74bc6f62fb4035$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $fb74bc6f62fb4035$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $fb74bc6f62fb4035$var$Hf = "function" === typeof Promise ? Promise : void 0, $fb74bc6f62fb4035$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $fb74bc6f62fb4035$var$Hf ? function(a) {
    return $fb74bc6f62fb4035$var$Hf.resolve(null).then(a).catch($fb74bc6f62fb4035$var$If);
} : $fb74bc6f62fb4035$var$Ff;
function $fb74bc6f62fb4035$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $fb74bc6f62fb4035$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $fb74bc6f62fb4035$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $fb74bc6f62fb4035$var$bd(b);
}
function $fb74bc6f62fb4035$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $fb74bc6f62fb4035$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $fb74bc6f62fb4035$var$Nf = Math.random().toString(36).slice(2), $fb74bc6f62fb4035$var$Of = "__reactFiber$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$Pf = "__reactProps$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$uf = "__reactContainer$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$of = "__reactEvents$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$Qf = "__reactListeners$" + $fb74bc6f62fb4035$var$Nf, $fb74bc6f62fb4035$var$Rf = "__reactHandles$" + $fb74bc6f62fb4035$var$Nf;
function $fb74bc6f62fb4035$var$Wc(a) {
    var b = a[$fb74bc6f62fb4035$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$fb74bc6f62fb4035$var$uf] || c[$fb74bc6f62fb4035$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $fb74bc6f62fb4035$var$Mf(a); null !== a;){
                if (c = a[$fb74bc6f62fb4035$var$Of]) return c;
                a = $fb74bc6f62fb4035$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Cb(a) {
    a = a[$fb74bc6f62fb4035$var$Of] || a[$fb74bc6f62fb4035$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $fb74bc6f62fb4035$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($fb74bc6f62fb4035$var$p(33));
}
function $fb74bc6f62fb4035$var$Db(a) {
    return a[$fb74bc6f62fb4035$var$Pf] || null;
}
var $fb74bc6f62fb4035$var$Sf = [], $fb74bc6f62fb4035$var$Tf = -1;
function $fb74bc6f62fb4035$var$Uf(a) {
    return {
        current: a
    };
}
function $fb74bc6f62fb4035$var$E(a) {
    0 > $fb74bc6f62fb4035$var$Tf || (a.current = $fb74bc6f62fb4035$var$Sf[$fb74bc6f62fb4035$var$Tf], $fb74bc6f62fb4035$var$Sf[$fb74bc6f62fb4035$var$Tf] = null, $fb74bc6f62fb4035$var$Tf--);
}
function $fb74bc6f62fb4035$var$G(a, b) {
    $fb74bc6f62fb4035$var$Tf++;
    $fb74bc6f62fb4035$var$Sf[$fb74bc6f62fb4035$var$Tf] = a.current;
    a.current = b;
}
var $fb74bc6f62fb4035$var$Vf = {}, $fb74bc6f62fb4035$var$H = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$Vf), $fb74bc6f62fb4035$var$Wf = $fb74bc6f62fb4035$var$Uf(!1), $fb74bc6f62fb4035$var$Xf = $fb74bc6f62fb4035$var$Vf;
function $fb74bc6f62fb4035$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $fb74bc6f62fb4035$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $fb74bc6f62fb4035$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $fb74bc6f62fb4035$var$$f() {
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H);
}
function $fb74bc6f62fb4035$var$ag(a, b, c) {
    if ($fb74bc6f62fb4035$var$H.current !== $fb74bc6f62fb4035$var$Vf) throw Error($fb74bc6f62fb4035$var$p(168));
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$H, b);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wf, c);
}
function $fb74bc6f62fb4035$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($fb74bc6f62fb4035$var$p(108, $fb74bc6f62fb4035$var$Ra(a) || "Unknown", e));
    return $fb74bc6f62fb4035$var$A({}, c, d);
}
function $fb74bc6f62fb4035$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $fb74bc6f62fb4035$var$Vf;
    $fb74bc6f62fb4035$var$Xf = $fb74bc6f62fb4035$var$H.current;
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$H, a);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wf, $fb74bc6f62fb4035$var$Wf.current);
    return !0;
}
function $fb74bc6f62fb4035$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($fb74bc6f62fb4035$var$p(169));
    c ? (a = $fb74bc6f62fb4035$var$bg(a, b, $fb74bc6f62fb4035$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H), $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$H, a)) : $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wf, c);
}
var $fb74bc6f62fb4035$var$eg = null, $fb74bc6f62fb4035$var$fg = !1, $fb74bc6f62fb4035$var$gg = !1;
function $fb74bc6f62fb4035$var$hg(a) {
    null === $fb74bc6f62fb4035$var$eg ? $fb74bc6f62fb4035$var$eg = [
        a
    ] : $fb74bc6f62fb4035$var$eg.push(a);
}
function $fb74bc6f62fb4035$var$ig(a) {
    $fb74bc6f62fb4035$var$fg = !0;
    $fb74bc6f62fb4035$var$hg(a);
}
function $fb74bc6f62fb4035$var$jg() {
    if (!$fb74bc6f62fb4035$var$gg && null !== $fb74bc6f62fb4035$var$eg) {
        $fb74bc6f62fb4035$var$gg = !0;
        var a = 0, b = $fb74bc6f62fb4035$var$C;
        try {
            var c = $fb74bc6f62fb4035$var$eg;
            for($fb74bc6f62fb4035$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $fb74bc6f62fb4035$var$eg = null;
            $fb74bc6f62fb4035$var$fg = !1;
        } catch (e) {
            throw null !== $fb74bc6f62fb4035$var$eg && ($fb74bc6f62fb4035$var$eg = $fb74bc6f62fb4035$var$eg.slice(a + 1)), $fb74bc6f62fb4035$var$ac($fb74bc6f62fb4035$var$fc, $fb74bc6f62fb4035$var$jg), e;
        } finally{
            $fb74bc6f62fb4035$var$C = b, $fb74bc6f62fb4035$var$gg = !1;
        }
    }
    return null;
}
var $fb74bc6f62fb4035$var$kg = [], $fb74bc6f62fb4035$var$lg = 0, $fb74bc6f62fb4035$var$mg = null, $fb74bc6f62fb4035$var$ng = 0, $fb74bc6f62fb4035$var$og = [], $fb74bc6f62fb4035$var$pg = 0, $fb74bc6f62fb4035$var$qg = null, $fb74bc6f62fb4035$var$rg = 1, $fb74bc6f62fb4035$var$sg = "";
function $fb74bc6f62fb4035$var$tg(a, b) {
    $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg++] = $fb74bc6f62fb4035$var$ng;
    $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg++] = $fb74bc6f62fb4035$var$mg;
    $fb74bc6f62fb4035$var$mg = a;
    $fb74bc6f62fb4035$var$ng = b;
}
function $fb74bc6f62fb4035$var$ug(a, b, c) {
    $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$rg;
    $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$sg;
    $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$qg;
    $fb74bc6f62fb4035$var$qg = a;
    var d = $fb74bc6f62fb4035$var$rg;
    a = $fb74bc6f62fb4035$var$sg;
    var e = 32 - $fb74bc6f62fb4035$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $fb74bc6f62fb4035$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $fb74bc6f62fb4035$var$rg = 1 << 32 - $fb74bc6f62fb4035$var$oc(b) + e | c << e | d;
        $fb74bc6f62fb4035$var$sg = f + a;
    } else $fb74bc6f62fb4035$var$rg = 1 << f | c << e | d, $fb74bc6f62fb4035$var$sg = a;
}
function $fb74bc6f62fb4035$var$vg(a) {
    null !== a.return && ($fb74bc6f62fb4035$var$tg(a, 1), $fb74bc6f62fb4035$var$ug(a, 1, 0));
}
function $fb74bc6f62fb4035$var$wg(a) {
    for(; a === $fb74bc6f62fb4035$var$mg;)$fb74bc6f62fb4035$var$mg = $fb74bc6f62fb4035$var$kg[--$fb74bc6f62fb4035$var$lg], $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg] = null, $fb74bc6f62fb4035$var$ng = $fb74bc6f62fb4035$var$kg[--$fb74bc6f62fb4035$var$lg], $fb74bc6f62fb4035$var$kg[$fb74bc6f62fb4035$var$lg] = null;
    for(; a === $fb74bc6f62fb4035$var$qg;)$fb74bc6f62fb4035$var$qg = $fb74bc6f62fb4035$var$og[--$fb74bc6f62fb4035$var$pg], $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg] = null, $fb74bc6f62fb4035$var$sg = $fb74bc6f62fb4035$var$og[--$fb74bc6f62fb4035$var$pg], $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg] = null, $fb74bc6f62fb4035$var$rg = $fb74bc6f62fb4035$var$og[--$fb74bc6f62fb4035$var$pg], $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg] = null;
}
var $fb74bc6f62fb4035$var$xg = null, $fb74bc6f62fb4035$var$yg = null, $fb74bc6f62fb4035$var$I = !1, $fb74bc6f62fb4035$var$zg = null;
function $fb74bc6f62fb4035$var$Ag(a, b) {
    var c = $fb74bc6f62fb4035$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $fb74bc6f62fb4035$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $fb74bc6f62fb4035$var$xg = a, $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $fb74bc6f62fb4035$var$xg = a, $fb74bc6f62fb4035$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $fb74bc6f62fb4035$var$qg ? {
                id: $fb74bc6f62fb4035$var$rg,
                overflow: $fb74bc6f62fb4035$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $fb74bc6f62fb4035$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $fb74bc6f62fb4035$var$xg = a, $fb74bc6f62fb4035$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $fb74bc6f62fb4035$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $fb74bc6f62fb4035$var$Eg(a) {
    if ($fb74bc6f62fb4035$var$I) {
        var b = $fb74bc6f62fb4035$var$yg;
        if (b) {
            var c = b;
            if (!$fb74bc6f62fb4035$var$Cg(a, b)) {
                if ($fb74bc6f62fb4035$var$Dg(a)) throw Error($fb74bc6f62fb4035$var$p(418));
                b = $fb74bc6f62fb4035$var$Lf(c.nextSibling);
                var d = $fb74bc6f62fb4035$var$xg;
                b && $fb74bc6f62fb4035$var$Cg(a, b) ? $fb74bc6f62fb4035$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $fb74bc6f62fb4035$var$I = !1, $fb74bc6f62fb4035$var$xg = a);
            }
        } else {
            if ($fb74bc6f62fb4035$var$Dg(a)) throw Error($fb74bc6f62fb4035$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $fb74bc6f62fb4035$var$I = !1;
            $fb74bc6f62fb4035$var$xg = a;
        }
    }
}
function $fb74bc6f62fb4035$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $fb74bc6f62fb4035$var$xg = a;
}
function $fb74bc6f62fb4035$var$Gg(a) {
    if (a !== $fb74bc6f62fb4035$var$xg) return !1;
    if (!$fb74bc6f62fb4035$var$I) return $fb74bc6f62fb4035$var$Fg(a), $fb74bc6f62fb4035$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$fb74bc6f62fb4035$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $fb74bc6f62fb4035$var$yg)) {
        if ($fb74bc6f62fb4035$var$Dg(a)) throw $fb74bc6f62fb4035$var$Hg(), Error($fb74bc6f62fb4035$var$p(418));
        for(; b;)$fb74bc6f62fb4035$var$Ag(a, b), b = $fb74bc6f62fb4035$var$Lf(b.nextSibling);
    }
    $fb74bc6f62fb4035$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($fb74bc6f62fb4035$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $fb74bc6f62fb4035$var$yg = null;
        }
    } else $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$xg ? $fb74bc6f62fb4035$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $fb74bc6f62fb4035$var$Hg() {
    for(var a = $fb74bc6f62fb4035$var$yg; a;)a = $fb74bc6f62fb4035$var$Lf(a.nextSibling);
}
function $fb74bc6f62fb4035$var$Ig() {
    $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$xg = null;
    $fb74bc6f62fb4035$var$I = !1;
}
function $fb74bc6f62fb4035$var$Jg(a) {
    null === $fb74bc6f62fb4035$var$zg ? $fb74bc6f62fb4035$var$zg = [
        a
    ] : $fb74bc6f62fb4035$var$zg.push(a);
}
var $fb74bc6f62fb4035$var$Kg = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig;
function $fb74bc6f62fb4035$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($fb74bc6f62fb4035$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($fb74bc6f62fb4035$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($fb74bc6f62fb4035$var$p(284));
        if (!c._owner) throw Error($fb74bc6f62fb4035$var$p(290, a));
    }
    return a;
}
function $fb74bc6f62fb4035$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($fb74bc6f62fb4035$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $fb74bc6f62fb4035$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $fb74bc6f62fb4035$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $fb74bc6f62fb4035$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $fb74bc6f62fb4035$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $fb74bc6f62fb4035$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $fb74bc6f62fb4035$var$Ha && $fb74bc6f62fb4035$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $fb74bc6f62fb4035$var$Lg(a, b, c), d.return = a, d;
        d = $fb74bc6f62fb4035$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $fb74bc6f62fb4035$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $fb74bc6f62fb4035$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $fb74bc6f62fb4035$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $fb74bc6f62fb4035$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    return c = $fb74bc6f62fb4035$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $fb74bc6f62fb4035$var$Lg(a, null, b), c.return = a, c;
                case $fb74bc6f62fb4035$var$wa:
                    return b = $fb74bc6f62fb4035$var$Sg(b, a.mode, c), b.return = a, b;
                case $fb74bc6f62fb4035$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($fb74bc6f62fb4035$var$eb(b) || $fb74bc6f62fb4035$var$Ka(b)) return b = $fb74bc6f62fb4035$var$Tg(b, a.mode, c, null), b.return = a, b;
            $fb74bc6f62fb4035$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $fb74bc6f62fb4035$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $fb74bc6f62fb4035$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($fb74bc6f62fb4035$var$eb(c) || $fb74bc6f62fb4035$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $fb74bc6f62fb4035$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $fb74bc6f62fb4035$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $fb74bc6f62fb4035$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($fb74bc6f62fb4035$var$eb(d) || $fb74bc6f62fb4035$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $fb74bc6f62fb4035$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $fb74bc6f62fb4035$var$Ka(h);
        if ("function" !== typeof l) throw Error($fb74bc6f62fb4035$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($fb74bc6f62fb4035$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $fb74bc6f62fb4035$var$I && $fb74bc6f62fb4035$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $fb74bc6f62fb4035$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $fb74bc6f62fb4035$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $fb74bc6f62fb4035$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $fb74bc6f62fb4035$var$Ha && $fb74bc6f62fb4035$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $fb74bc6f62fb4035$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $fb74bc6f62fb4035$var$ya ? (d = $fb74bc6f62fb4035$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $fb74bc6f62fb4035$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $fb74bc6f62fb4035$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $fb74bc6f62fb4035$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $fb74bc6f62fb4035$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $fb74bc6f62fb4035$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($fb74bc6f62fb4035$var$eb(f)) return n(a, d, f, h);
            if ($fb74bc6f62fb4035$var$Ka(f)) return t(a, d, f, h);
            $fb74bc6f62fb4035$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $fb74bc6f62fb4035$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $fb74bc6f62fb4035$var$Ug = $fb74bc6f62fb4035$var$Og(!0), $fb74bc6f62fb4035$var$Vg = $fb74bc6f62fb4035$var$Og(!1), $fb74bc6f62fb4035$var$Wg = $fb74bc6f62fb4035$var$Uf(null), $fb74bc6f62fb4035$var$Xg = null, $fb74bc6f62fb4035$var$Yg = null, $fb74bc6f62fb4035$var$Zg = null;
function $fb74bc6f62fb4035$var$$g() {
    $fb74bc6f62fb4035$var$Zg = $fb74bc6f62fb4035$var$Yg = $fb74bc6f62fb4035$var$Xg = null;
}
function $fb74bc6f62fb4035$var$ah(a) {
    var b = $fb74bc6f62fb4035$var$Wg.current;
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wg);
    a._currentValue = b;
}
function $fb74bc6f62fb4035$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $fb74bc6f62fb4035$var$ch(a, b) {
    $fb74bc6f62fb4035$var$Xg = a;
    $fb74bc6f62fb4035$var$Zg = $fb74bc6f62fb4035$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($fb74bc6f62fb4035$var$dh = !0), a.firstContext = null);
}
function $fb74bc6f62fb4035$var$eh(a) {
    var b = a._currentValue;
    if ($fb74bc6f62fb4035$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $fb74bc6f62fb4035$var$Yg) {
            if (null === $fb74bc6f62fb4035$var$Xg) throw Error($fb74bc6f62fb4035$var$p(308));
            $fb74bc6f62fb4035$var$Yg = a;
            $fb74bc6f62fb4035$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $fb74bc6f62fb4035$var$Yg = $fb74bc6f62fb4035$var$Yg.next = a;
    }
    return b;
}
var $fb74bc6f62fb4035$var$fh = null;
function $fb74bc6f62fb4035$var$gh(a) {
    null === $fb74bc6f62fb4035$var$fh ? $fb74bc6f62fb4035$var$fh = [
        a
    ] : $fb74bc6f62fb4035$var$fh.push(a);
}
function $fb74bc6f62fb4035$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $fb74bc6f62fb4035$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $fb74bc6f62fb4035$var$ih(a, d);
}
function $fb74bc6f62fb4035$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $fb74bc6f62fb4035$var$jh = !1;
function $fb74bc6f62fb4035$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $fb74bc6f62fb4035$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $fb74bc6f62fb4035$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $fb74bc6f62fb4035$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($fb74bc6f62fb4035$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $fb74bc6f62fb4035$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $fb74bc6f62fb4035$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $fb74bc6f62fb4035$var$ih(a, c);
}
function $fb74bc6f62fb4035$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fb74bc6f62fb4035$var$Cc(a, c);
    }
}
function $fb74bc6f62fb4035$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $fb74bc6f62fb4035$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $fb74bc6f62fb4035$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $fb74bc6f62fb4035$var$A({}, q, r);
                            break a;
                        case 2:
                            $fb74bc6f62fb4035$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $fb74bc6f62fb4035$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $fb74bc6f62fb4035$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($fb74bc6f62fb4035$var$p(191, e));
            e.call(d);
        }
    }
}
var $fb74bc6f62fb4035$var$th = {}, $fb74bc6f62fb4035$var$uh = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$th), $fb74bc6f62fb4035$var$vh = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$th), $fb74bc6f62fb4035$var$wh = $fb74bc6f62fb4035$var$Uf($fb74bc6f62fb4035$var$th);
function $fb74bc6f62fb4035$var$xh(a) {
    if (a === $fb74bc6f62fb4035$var$th) throw Error($fb74bc6f62fb4035$var$p(174));
    return a;
}
function $fb74bc6f62fb4035$var$yh(a, b) {
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$wh, b);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$vh, a);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$uh, $fb74bc6f62fb4035$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $fb74bc6f62fb4035$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $fb74bc6f62fb4035$var$lb(b, a);
    }
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$uh);
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$uh, b);
}
function $fb74bc6f62fb4035$var$zh() {
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$uh);
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$vh);
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$wh);
}
function $fb74bc6f62fb4035$var$Ah(a) {
    $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$wh.current);
    var b = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
    var c = $fb74bc6f62fb4035$var$lb(b, a.type);
    b !== c && ($fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$vh, a), $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$uh, c));
}
function $fb74bc6f62fb4035$var$Bh(a) {
    $fb74bc6f62fb4035$var$vh.current === a && ($fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$uh), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$vh));
}
var $fb74bc6f62fb4035$var$L = $fb74bc6f62fb4035$var$Uf(0);
function $fb74bc6f62fb4035$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $fb74bc6f62fb4035$var$Dh = [];
function $fb74bc6f62fb4035$var$Eh() {
    for(var a = 0; a < $fb74bc6f62fb4035$var$Dh.length; a++)$fb74bc6f62fb4035$var$Dh[a]._workInProgressVersionPrimary = null;
    $fb74bc6f62fb4035$var$Dh.length = 0;
}
var $fb74bc6f62fb4035$var$Fh = $fb74bc6f62fb4035$var$ua.ReactCurrentDispatcher, $fb74bc6f62fb4035$var$Gh = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig, $fb74bc6f62fb4035$var$Hh = 0, $fb74bc6f62fb4035$var$M = null, $fb74bc6f62fb4035$var$N = null, $fb74bc6f62fb4035$var$O = null, $fb74bc6f62fb4035$var$Ih = !1, $fb74bc6f62fb4035$var$Jh = !1, $fb74bc6f62fb4035$var$Kh = 0, $fb74bc6f62fb4035$var$Lh = 0;
function $fb74bc6f62fb4035$var$P() {
    throw Error($fb74bc6f62fb4035$var$p(321));
}
function $fb74bc6f62fb4035$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$fb74bc6f62fb4035$var$He(a[c], b[c])) return !1;
    return !0;
}
function $fb74bc6f62fb4035$var$Nh(a, b, c, d, e, f) {
    $fb74bc6f62fb4035$var$Hh = f;
    $fb74bc6f62fb4035$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $fb74bc6f62fb4035$var$Fh.current = null === a || null === a.memoizedState ? $fb74bc6f62fb4035$var$Oh : $fb74bc6f62fb4035$var$Ph;
    a = c(d, e);
    if ($fb74bc6f62fb4035$var$Jh) {
        f = 0;
        do {
            $fb74bc6f62fb4035$var$Jh = !1;
            $fb74bc6f62fb4035$var$Kh = 0;
            if (25 <= f) throw Error($fb74bc6f62fb4035$var$p(301));
            f += 1;
            $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$N = null;
            b.updateQueue = null;
            $fb74bc6f62fb4035$var$Fh.current = $fb74bc6f62fb4035$var$Qh;
            a = c(d, e);
        }while ($fb74bc6f62fb4035$var$Jh);
    }
    $fb74bc6f62fb4035$var$Fh.current = $fb74bc6f62fb4035$var$Rh;
    b = null !== $fb74bc6f62fb4035$var$N && null !== $fb74bc6f62fb4035$var$N.next;
    $fb74bc6f62fb4035$var$Hh = 0;
    $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$N = $fb74bc6f62fb4035$var$M = null;
    $fb74bc6f62fb4035$var$Ih = !1;
    if (b) throw Error($fb74bc6f62fb4035$var$p(300));
    return a;
}
function $fb74bc6f62fb4035$var$Sh() {
    var a = 0 !== $fb74bc6f62fb4035$var$Kh;
    $fb74bc6f62fb4035$var$Kh = 0;
    return a;
}
function $fb74bc6f62fb4035$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $fb74bc6f62fb4035$var$O ? $fb74bc6f62fb4035$var$M.memoizedState = $fb74bc6f62fb4035$var$O = a : $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$O.next = a;
    return $fb74bc6f62fb4035$var$O;
}
function $fb74bc6f62fb4035$var$Uh() {
    if (null === $fb74bc6f62fb4035$var$N) {
        var a = $fb74bc6f62fb4035$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $fb74bc6f62fb4035$var$N.next;
    var b = null === $fb74bc6f62fb4035$var$O ? $fb74bc6f62fb4035$var$M.memoizedState : $fb74bc6f62fb4035$var$O.next;
    if (null !== b) $fb74bc6f62fb4035$var$O = b, $fb74bc6f62fb4035$var$N = a;
    else {
        if (null === a) throw Error($fb74bc6f62fb4035$var$p(310));
        $fb74bc6f62fb4035$var$N = a;
        a = {
            memoizedState: $fb74bc6f62fb4035$var$N.memoizedState,
            baseState: $fb74bc6f62fb4035$var$N.baseState,
            baseQueue: $fb74bc6f62fb4035$var$N.baseQueue,
            queue: $fb74bc6f62fb4035$var$N.queue,
            next: null
        };
        null === $fb74bc6f62fb4035$var$O ? $fb74bc6f62fb4035$var$M.memoizedState = $fb74bc6f62fb4035$var$O = a : $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$O.next = a;
    }
    return $fb74bc6f62fb4035$var$O;
}
function $fb74bc6f62fb4035$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $fb74bc6f62fb4035$var$Wh(a) {
    var b = $fb74bc6f62fb4035$var$Uh(), c = b.queue;
    if (null === c) throw Error($fb74bc6f62fb4035$var$p(311));
    c.lastRenderedReducer = a;
    var d = $fb74bc6f62fb4035$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($fb74bc6f62fb4035$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $fb74bc6f62fb4035$var$M.lanes |= m;
                $fb74bc6f62fb4035$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $fb74bc6f62fb4035$var$He(d, b.memoizedState) || ($fb74bc6f62fb4035$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $fb74bc6f62fb4035$var$M.lanes |= f, $fb74bc6f62fb4035$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $fb74bc6f62fb4035$var$Xh(a) {
    var b = $fb74bc6f62fb4035$var$Uh(), c = b.queue;
    if (null === c) throw Error($fb74bc6f62fb4035$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $fb74bc6f62fb4035$var$He(f, b.memoizedState) || ($fb74bc6f62fb4035$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $fb74bc6f62fb4035$var$Yh() {}
function $fb74bc6f62fb4035$var$Zh(a, b) {
    var c = $fb74bc6f62fb4035$var$M, d = $fb74bc6f62fb4035$var$Uh(), e = b(), f = !$fb74bc6f62fb4035$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $fb74bc6f62fb4035$var$dh = !0);
    d = d.queue;
    $fb74bc6f62fb4035$var$$h($fb74bc6f62fb4035$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $fb74bc6f62fb4035$var$O && $fb74bc6f62fb4035$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $fb74bc6f62fb4035$var$bi(9, $fb74bc6f62fb4035$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $fb74bc6f62fb4035$var$Q) throw Error($fb74bc6f62fb4035$var$p(349));
        0 !== ($fb74bc6f62fb4035$var$Hh & 30) || $fb74bc6f62fb4035$var$di(c, b, e);
    }
    return e;
}
function $fb74bc6f62fb4035$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $fb74bc6f62fb4035$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fb74bc6f62fb4035$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $fb74bc6f62fb4035$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $fb74bc6f62fb4035$var$ei(b) && $fb74bc6f62fb4035$var$fi(a);
}
function $fb74bc6f62fb4035$var$ai(a, b, c) {
    return c(function() {
        $fb74bc6f62fb4035$var$ei(b) && $fb74bc6f62fb4035$var$fi(a);
    });
}
function $fb74bc6f62fb4035$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$fb74bc6f62fb4035$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $fb74bc6f62fb4035$var$fi(a) {
    var b = $fb74bc6f62fb4035$var$ih(a, 1);
    null !== b && $fb74bc6f62fb4035$var$gi(b, a, 1, -1);
}
function $fb74bc6f62fb4035$var$hi(a) {
    var b = $fb74bc6f62fb4035$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $fb74bc6f62fb4035$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $fb74bc6f62fb4035$var$ii.bind(null, $fb74bc6f62fb4035$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $fb74bc6f62fb4035$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $fb74bc6f62fb4035$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $fb74bc6f62fb4035$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $fb74bc6f62fb4035$var$ji() {
    return $fb74bc6f62fb4035$var$Uh().memoizedState;
}
function $fb74bc6f62fb4035$var$ki(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$Th();
    $fb74bc6f62fb4035$var$M.flags |= a;
    e.memoizedState = $fb74bc6f62fb4035$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $fb74bc6f62fb4035$var$li(a, b, c, d) {
    var e = $fb74bc6f62fb4035$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $fb74bc6f62fb4035$var$N) {
        var g = $fb74bc6f62fb4035$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $fb74bc6f62fb4035$var$Mh(d, g.deps)) {
            e.memoizedState = $fb74bc6f62fb4035$var$bi(b, c, f, d);
            return;
        }
    }
    $fb74bc6f62fb4035$var$M.flags |= a;
    e.memoizedState = $fb74bc6f62fb4035$var$bi(1 | b, c, f, d);
}
function $fb74bc6f62fb4035$var$mi(a, b) {
    return $fb74bc6f62fb4035$var$ki(8390656, 8, a, b);
}
function $fb74bc6f62fb4035$var$$h(a, b) {
    return $fb74bc6f62fb4035$var$li(2048, 8, a, b);
}
function $fb74bc6f62fb4035$var$ni(a, b) {
    return $fb74bc6f62fb4035$var$li(4, 2, a, b);
}
function $fb74bc6f62fb4035$var$oi(a, b) {
    return $fb74bc6f62fb4035$var$li(4, 4, a, b);
}
function $fb74bc6f62fb4035$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $fb74bc6f62fb4035$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $fb74bc6f62fb4035$var$li(4, 4, $fb74bc6f62fb4035$var$pi.bind(null, b, a), c);
}
function $fb74bc6f62fb4035$var$ri() {}
function $fb74bc6f62fb4035$var$si(a, b) {
    var c = $fb74bc6f62fb4035$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fb74bc6f62fb4035$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fb74bc6f62fb4035$var$ti(a, b) {
    var c = $fb74bc6f62fb4035$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $fb74bc6f62fb4035$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $fb74bc6f62fb4035$var$ui(a, b, c) {
    if (0 === ($fb74bc6f62fb4035$var$Hh & 21)) return a.baseState && (a.baseState = !1, $fb74bc6f62fb4035$var$dh = !0), a.memoizedState = c;
    $fb74bc6f62fb4035$var$He(c, b) || (c = $fb74bc6f62fb4035$var$yc(), $fb74bc6f62fb4035$var$M.lanes |= c, $fb74bc6f62fb4035$var$rh |= c, a.baseState = !0);
    return b;
}
function $fb74bc6f62fb4035$var$vi(a, b) {
    var c = $fb74bc6f62fb4035$var$C;
    $fb74bc6f62fb4035$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $fb74bc6f62fb4035$var$Gh.transition;
    $fb74bc6f62fb4035$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $fb74bc6f62fb4035$var$C = c, $fb74bc6f62fb4035$var$Gh.transition = d;
    }
}
function $fb74bc6f62fb4035$var$wi() {
    return $fb74bc6f62fb4035$var$Uh().memoizedState;
}
function $fb74bc6f62fb4035$var$xi(a, b, c) {
    var d = $fb74bc6f62fb4035$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fb74bc6f62fb4035$var$zi(a)) $fb74bc6f62fb4035$var$Ai(b, c);
    else if (c = $fb74bc6f62fb4035$var$hh(a, b, c, d), null !== c) {
        var e = $fb74bc6f62fb4035$var$R();
        $fb74bc6f62fb4035$var$gi(c, a, d, e);
        $fb74bc6f62fb4035$var$Bi(c, b, d);
    }
}
function $fb74bc6f62fb4035$var$ii(a, b, c) {
    var d = $fb74bc6f62fb4035$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($fb74bc6f62fb4035$var$zi(a)) $fb74bc6f62fb4035$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($fb74bc6f62fb4035$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $fb74bc6f62fb4035$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $fb74bc6f62fb4035$var$hh(a, b, e, d);
        null !== c && (e = $fb74bc6f62fb4035$var$R(), $fb74bc6f62fb4035$var$gi(c, a, d, e), $fb74bc6f62fb4035$var$Bi(c, b, d));
    }
}
function $fb74bc6f62fb4035$var$zi(a) {
    var b = a.alternate;
    return a === $fb74bc6f62fb4035$var$M || null !== b && b === $fb74bc6f62fb4035$var$M;
}
function $fb74bc6f62fb4035$var$Ai(a, b) {
    $fb74bc6f62fb4035$var$Jh = $fb74bc6f62fb4035$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $fb74bc6f62fb4035$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $fb74bc6f62fb4035$var$Cc(a, c);
    }
}
var $fb74bc6f62fb4035$var$Rh = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: $fb74bc6f62fb4035$var$P,
    useContext: $fb74bc6f62fb4035$var$P,
    useEffect: $fb74bc6f62fb4035$var$P,
    useImperativeHandle: $fb74bc6f62fb4035$var$P,
    useInsertionEffect: $fb74bc6f62fb4035$var$P,
    useLayoutEffect: $fb74bc6f62fb4035$var$P,
    useMemo: $fb74bc6f62fb4035$var$P,
    useReducer: $fb74bc6f62fb4035$var$P,
    useRef: $fb74bc6f62fb4035$var$P,
    useState: $fb74bc6f62fb4035$var$P,
    useDebugValue: $fb74bc6f62fb4035$var$P,
    useDeferredValue: $fb74bc6f62fb4035$var$P,
    useTransition: $fb74bc6f62fb4035$var$P,
    useMutableSource: $fb74bc6f62fb4035$var$P,
    useSyncExternalStore: $fb74bc6f62fb4035$var$P,
    useId: $fb74bc6f62fb4035$var$P,
    unstable_isNewReconciler: !1
}, $fb74bc6f62fb4035$var$Oh = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: function(a, b) {
        $fb74bc6f62fb4035$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $fb74bc6f62fb4035$var$eh,
    useEffect: $fb74bc6f62fb4035$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $fb74bc6f62fb4035$var$ki(4194308, 4, $fb74bc6f62fb4035$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $fb74bc6f62fb4035$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $fb74bc6f62fb4035$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $fb74bc6f62fb4035$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $fb74bc6f62fb4035$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $fb74bc6f62fb4035$var$xi.bind(null, $fb74bc6f62fb4035$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $fb74bc6f62fb4035$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $fb74bc6f62fb4035$var$hi,
    useDebugValue: $fb74bc6f62fb4035$var$ri,
    useDeferredValue: function(a) {
        return $fb74bc6f62fb4035$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $fb74bc6f62fb4035$var$hi(!1), b = a[0];
        a = $fb74bc6f62fb4035$var$vi.bind(null, a[1]);
        $fb74bc6f62fb4035$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $fb74bc6f62fb4035$var$M, e = $fb74bc6f62fb4035$var$Th();
        if ($fb74bc6f62fb4035$var$I) {
            if (void 0 === c) throw Error($fb74bc6f62fb4035$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $fb74bc6f62fb4035$var$Q) throw Error($fb74bc6f62fb4035$var$p(349));
            0 !== ($fb74bc6f62fb4035$var$Hh & 30) || $fb74bc6f62fb4035$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $fb74bc6f62fb4035$var$mi($fb74bc6f62fb4035$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $fb74bc6f62fb4035$var$bi(9, $fb74bc6f62fb4035$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $fb74bc6f62fb4035$var$Th(), b = $fb74bc6f62fb4035$var$Q.identifierPrefix;
        if ($fb74bc6f62fb4035$var$I) {
            var c = $fb74bc6f62fb4035$var$sg;
            var d = $fb74bc6f62fb4035$var$rg;
            c = (d & ~(1 << 32 - $fb74bc6f62fb4035$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $fb74bc6f62fb4035$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $fb74bc6f62fb4035$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $fb74bc6f62fb4035$var$Ph = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: $fb74bc6f62fb4035$var$si,
    useContext: $fb74bc6f62fb4035$var$eh,
    useEffect: $fb74bc6f62fb4035$var$$h,
    useImperativeHandle: $fb74bc6f62fb4035$var$qi,
    useInsertionEffect: $fb74bc6f62fb4035$var$ni,
    useLayoutEffect: $fb74bc6f62fb4035$var$oi,
    useMemo: $fb74bc6f62fb4035$var$ti,
    useReducer: $fb74bc6f62fb4035$var$Wh,
    useRef: $fb74bc6f62fb4035$var$ji,
    useState: function() {
        return $fb74bc6f62fb4035$var$Wh($fb74bc6f62fb4035$var$Vh);
    },
    useDebugValue: $fb74bc6f62fb4035$var$ri,
    useDeferredValue: function(a) {
        var b = $fb74bc6f62fb4035$var$Uh();
        return $fb74bc6f62fb4035$var$ui(b, $fb74bc6f62fb4035$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fb74bc6f62fb4035$var$Wh($fb74bc6f62fb4035$var$Vh)[0], b = $fb74bc6f62fb4035$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fb74bc6f62fb4035$var$Yh,
    useSyncExternalStore: $fb74bc6f62fb4035$var$Zh,
    useId: $fb74bc6f62fb4035$var$wi,
    unstable_isNewReconciler: !1
}, $fb74bc6f62fb4035$var$Qh = {
    readContext: $fb74bc6f62fb4035$var$eh,
    useCallback: $fb74bc6f62fb4035$var$si,
    useContext: $fb74bc6f62fb4035$var$eh,
    useEffect: $fb74bc6f62fb4035$var$$h,
    useImperativeHandle: $fb74bc6f62fb4035$var$qi,
    useInsertionEffect: $fb74bc6f62fb4035$var$ni,
    useLayoutEffect: $fb74bc6f62fb4035$var$oi,
    useMemo: $fb74bc6f62fb4035$var$ti,
    useReducer: $fb74bc6f62fb4035$var$Xh,
    useRef: $fb74bc6f62fb4035$var$ji,
    useState: function() {
        return $fb74bc6f62fb4035$var$Xh($fb74bc6f62fb4035$var$Vh);
    },
    useDebugValue: $fb74bc6f62fb4035$var$ri,
    useDeferredValue: function(a) {
        var b = $fb74bc6f62fb4035$var$Uh();
        return null === $fb74bc6f62fb4035$var$N ? b.memoizedState = a : $fb74bc6f62fb4035$var$ui(b, $fb74bc6f62fb4035$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $fb74bc6f62fb4035$var$Xh($fb74bc6f62fb4035$var$Vh)[0], b = $fb74bc6f62fb4035$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $fb74bc6f62fb4035$var$Yh,
    useSyncExternalStore: $fb74bc6f62fb4035$var$Zh,
    useId: $fb74bc6f62fb4035$var$wi,
    unstable_isNewReconciler: !1
};
function $fb74bc6f62fb4035$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $fb74bc6f62fb4035$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $fb74bc6f62fb4035$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $fb74bc6f62fb4035$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $fb74bc6f62fb4035$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $fb74bc6f62fb4035$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fb74bc6f62fb4035$var$R(), e = $fb74bc6f62fb4035$var$yi(a), f = $fb74bc6f62fb4035$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fb74bc6f62fb4035$var$nh(a, f, e);
        null !== b && ($fb74bc6f62fb4035$var$gi(b, a, e, d), $fb74bc6f62fb4035$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $fb74bc6f62fb4035$var$R(), e = $fb74bc6f62fb4035$var$yi(a), f = $fb74bc6f62fb4035$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $fb74bc6f62fb4035$var$nh(a, f, e);
        null !== b && ($fb74bc6f62fb4035$var$gi(b, a, e, d), $fb74bc6f62fb4035$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $fb74bc6f62fb4035$var$R(), d = $fb74bc6f62fb4035$var$yi(a), e = $fb74bc6f62fb4035$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $fb74bc6f62fb4035$var$nh(a, e, d);
        null !== b && ($fb74bc6f62fb4035$var$gi(b, a, d, c), $fb74bc6f62fb4035$var$oh(b, a, d));
    }
};
function $fb74bc6f62fb4035$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$fb74bc6f62fb4035$var$Ie(c, d) || !$fb74bc6f62fb4035$var$Ie(e, f) : !0;
}
function $fb74bc6f62fb4035$var$Gi(a, b, c) {
    var d = !1, e = $fb74bc6f62fb4035$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $fb74bc6f62fb4035$var$eh(f) : (e = $fb74bc6f62fb4035$var$Zf(b) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $fb74bc6f62fb4035$var$Yf(a, e) : $fb74bc6f62fb4035$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $fb74bc6f62fb4035$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $fb74bc6f62fb4035$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $fb74bc6f62fb4035$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $fb74bc6f62fb4035$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $fb74bc6f62fb4035$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $fb74bc6f62fb4035$var$eh(f) : (f = $fb74bc6f62fb4035$var$Zf(b) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, e.context = $fb74bc6f62fb4035$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($fb74bc6f62fb4035$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $fb74bc6f62fb4035$var$Ei.enqueueReplaceState(e, e.state, null), $fb74bc6f62fb4035$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $fb74bc6f62fb4035$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $fb74bc6f62fb4035$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $fb74bc6f62fb4035$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $fb74bc6f62fb4035$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $fb74bc6f62fb4035$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $fb74bc6f62fb4035$var$Ni(a, b, c) {
    c = $fb74bc6f62fb4035$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $fb74bc6f62fb4035$var$Oi || ($fb74bc6f62fb4035$var$Oi = !0, $fb74bc6f62fb4035$var$Pi = d);
        $fb74bc6f62fb4035$var$Li(a, b);
    };
    return c;
}
function $fb74bc6f62fb4035$var$Qi(a, b, c) {
    c = $fb74bc6f62fb4035$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $fb74bc6f62fb4035$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $fb74bc6f62fb4035$var$Li(a, b);
        "function" !== typeof d && (null === $fb74bc6f62fb4035$var$Ri ? $fb74bc6f62fb4035$var$Ri = new Set([
            this
        ]) : $fb74bc6f62fb4035$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $fb74bc6f62fb4035$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $fb74bc6f62fb4035$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $fb74bc6f62fb4035$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $fb74bc6f62fb4035$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $fb74bc6f62fb4035$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $fb74bc6f62fb4035$var$mh(-1, 1), b.tag = 2, $fb74bc6f62fb4035$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $fb74bc6f62fb4035$var$Wi = $fb74bc6f62fb4035$var$ua.ReactCurrentOwner, $fb74bc6f62fb4035$var$dh = !1;
function $fb74bc6f62fb4035$var$Xi(a, b, c, d) {
    b.child = null === a ? $fb74bc6f62fb4035$var$Vg(b, null, c, d) : $fb74bc6f62fb4035$var$Ug(b, a.child, c, d);
}
function $fb74bc6f62fb4035$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $fb74bc6f62fb4035$var$ch(b, e);
    d = $fb74bc6f62fb4035$var$Nh(a, b, c, d, f, e);
    c = $fb74bc6f62fb4035$var$Sh();
    if (null !== a && !$fb74bc6f62fb4035$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fb74bc6f62fb4035$var$Zi(a, b, e);
    $fb74bc6f62fb4035$var$I && c && $fb74bc6f62fb4035$var$vg(b);
    b.flags |= 1;
    $fb74bc6f62fb4035$var$Xi(a, b, d, e);
    return b.child;
}
function $fb74bc6f62fb4035$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$fb74bc6f62fb4035$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $fb74bc6f62fb4035$var$bj(a, b, f, d, e);
        a = $fb74bc6f62fb4035$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $fb74bc6f62fb4035$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $fb74bc6f62fb4035$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $fb74bc6f62fb4035$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $fb74bc6f62fb4035$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($fb74bc6f62fb4035$var$Ie(f, d) && a.ref === b.ref) {
            if ($fb74bc6f62fb4035$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($fb74bc6f62fb4035$var$dh = !0);
            else return b.lanes = a.lanes, $fb74bc6f62fb4035$var$Zi(a, b, e);
        }
    }
    return $fb74bc6f62fb4035$var$cj(a, b, c, d, e);
}
function $fb74bc6f62fb4035$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj), $fb74bc6f62fb4035$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj), $fb74bc6f62fb4035$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj);
            $fb74bc6f62fb4035$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$ej, $fb74bc6f62fb4035$var$fj), $fb74bc6f62fb4035$var$fj |= d;
    $fb74bc6f62fb4035$var$Xi(a, b, e, c);
    return b.child;
}
function $fb74bc6f62fb4035$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $fb74bc6f62fb4035$var$cj(a, b, c, d, e) {
    var f = $fb74bc6f62fb4035$var$Zf(c) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current;
    f = $fb74bc6f62fb4035$var$Yf(b, f);
    $fb74bc6f62fb4035$var$ch(b, e);
    c = $fb74bc6f62fb4035$var$Nh(a, b, c, d, f, e);
    d = $fb74bc6f62fb4035$var$Sh();
    if (null !== a && !$fb74bc6f62fb4035$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $fb74bc6f62fb4035$var$Zi(a, b, e);
    $fb74bc6f62fb4035$var$I && d && $fb74bc6f62fb4035$var$vg(b);
    b.flags |= 1;
    $fb74bc6f62fb4035$var$Xi(a, b, c, e);
    return b.child;
}
function $fb74bc6f62fb4035$var$hj(a, b, c, d, e) {
    if ($fb74bc6f62fb4035$var$Zf(c)) {
        var f = !0;
        $fb74bc6f62fb4035$var$cg(b);
    } else f = !1;
    $fb74bc6f62fb4035$var$ch(b, e);
    if (null === b.stateNode) $fb74bc6f62fb4035$var$ij(a, b), $fb74bc6f62fb4035$var$Gi(b, c, d), $fb74bc6f62fb4035$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $fb74bc6f62fb4035$var$eh(l) : (l = $fb74bc6f62fb4035$var$Zf(c) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, l = $fb74bc6f62fb4035$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $fb74bc6f62fb4035$var$Hi(b, g, d, l);
        $fb74bc6f62fb4035$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $fb74bc6f62fb4035$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $fb74bc6f62fb4035$var$Wf.current || $fb74bc6f62fb4035$var$jh ? ("function" === typeof m && ($fb74bc6f62fb4035$var$Di(b, c, m, d), k = b.memoizedState), (h = $fb74bc6f62fb4035$var$jh || $fb74bc6f62fb4035$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $fb74bc6f62fb4035$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $fb74bc6f62fb4035$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $fb74bc6f62fb4035$var$eh(k) : (k = $fb74bc6f62fb4035$var$Zf(c) ? $fb74bc6f62fb4035$var$Xf : $fb74bc6f62fb4035$var$H.current, k = $fb74bc6f62fb4035$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $fb74bc6f62fb4035$var$Hi(b, g, d, k);
        $fb74bc6f62fb4035$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $fb74bc6f62fb4035$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $fb74bc6f62fb4035$var$Wf.current || $fb74bc6f62fb4035$var$jh ? ("function" === typeof y && ($fb74bc6f62fb4035$var$Di(b, c, y, d), n = b.memoizedState), (l = $fb74bc6f62fb4035$var$jh || $fb74bc6f62fb4035$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $fb74bc6f62fb4035$var$jj(a, b, c, d, f, e);
}
function $fb74bc6f62fb4035$var$jj(a, b, c, d, e, f) {
    $fb74bc6f62fb4035$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $fb74bc6f62fb4035$var$dg(b, c, !1), $fb74bc6f62fb4035$var$Zi(a, b, f);
    d = b.stateNode;
    $fb74bc6f62fb4035$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $fb74bc6f62fb4035$var$Ug(b, a.child, null, f), b.child = $fb74bc6f62fb4035$var$Ug(b, null, h, f)) : $fb74bc6f62fb4035$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $fb74bc6f62fb4035$var$dg(b, c, !0);
    return b.child;
}
function $fb74bc6f62fb4035$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $fb74bc6f62fb4035$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $fb74bc6f62fb4035$var$ag(a, b.context, !1);
    $fb74bc6f62fb4035$var$yh(a, b.containerInfo);
}
function $fb74bc6f62fb4035$var$lj(a, b, c, d, e) {
    $fb74bc6f62fb4035$var$Ig();
    $fb74bc6f62fb4035$var$Jg(e);
    b.flags |= 256;
    $fb74bc6f62fb4035$var$Xi(a, b, c, d);
    return b.child;
}
var $fb74bc6f62fb4035$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $fb74bc6f62fb4035$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $fb74bc6f62fb4035$var$oj(a, b, c) {
    var d = b.pendingProps, e = $fb74bc6f62fb4035$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, e & 1);
    if (null === a) {
        $fb74bc6f62fb4035$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $fb74bc6f62fb4035$var$pj(g, d, 0, null), a = $fb74bc6f62fb4035$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $fb74bc6f62fb4035$var$nj(c), b.memoizedState = $fb74bc6f62fb4035$var$mj, a) : $fb74bc6f62fb4035$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $fb74bc6f62fb4035$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $fb74bc6f62fb4035$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $fb74bc6f62fb4035$var$Pg(h, f) : (f = $fb74bc6f62fb4035$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $fb74bc6f62fb4035$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $fb74bc6f62fb4035$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $fb74bc6f62fb4035$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $fb74bc6f62fb4035$var$qj(a, b) {
    b = $fb74bc6f62fb4035$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $fb74bc6f62fb4035$var$sj(a, b, c, d) {
    null !== d && $fb74bc6f62fb4035$var$Jg(d);
    $fb74bc6f62fb4035$var$Ug(b, a.child, null, c);
    a = $fb74bc6f62fb4035$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $fb74bc6f62fb4035$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $fb74bc6f62fb4035$var$Ki(Error($fb74bc6f62fb4035$var$p(422))), $fb74bc6f62fb4035$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $fb74bc6f62fb4035$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $fb74bc6f62fb4035$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $fb74bc6f62fb4035$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $fb74bc6f62fb4035$var$nj(g);
        b.memoizedState = $fb74bc6f62fb4035$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $fb74bc6f62fb4035$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($fb74bc6f62fb4035$var$p(419));
        d = $fb74bc6f62fb4035$var$Ki(f, d, void 0);
        return $fb74bc6f62fb4035$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($fb74bc6f62fb4035$var$dh || h) {
        d = $fb74bc6f62fb4035$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $fb74bc6f62fb4035$var$ih(a, e), $fb74bc6f62fb4035$var$gi(d, a, e, -1));
        }
        $fb74bc6f62fb4035$var$tj();
        d = $fb74bc6f62fb4035$var$Ki(Error($fb74bc6f62fb4035$var$p(421)));
        return $fb74bc6f62fb4035$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $fb74bc6f62fb4035$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(e.nextSibling);
    $fb74bc6f62fb4035$var$xg = b;
    $fb74bc6f62fb4035$var$I = !0;
    $fb74bc6f62fb4035$var$zg = null;
    null !== a && ($fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$rg, $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$sg, $fb74bc6f62fb4035$var$og[$fb74bc6f62fb4035$var$pg++] = $fb74bc6f62fb4035$var$qg, $fb74bc6f62fb4035$var$rg = a.id, $fb74bc6f62fb4035$var$sg = a.overflow, $fb74bc6f62fb4035$var$qg = b);
    b = $fb74bc6f62fb4035$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $fb74bc6f62fb4035$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $fb74bc6f62fb4035$var$bh(a.return, b, c);
}
function $fb74bc6f62fb4035$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $fb74bc6f62fb4035$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $fb74bc6f62fb4035$var$Xi(a, b, d.children, c);
    d = $fb74bc6f62fb4035$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $fb74bc6f62fb4035$var$vj(a, c, b);
            else if (19 === a.tag) $fb74bc6f62fb4035$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $fb74bc6f62fb4035$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $fb74bc6f62fb4035$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $fb74bc6f62fb4035$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $fb74bc6f62fb4035$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $fb74bc6f62fb4035$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $fb74bc6f62fb4035$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $fb74bc6f62fb4035$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $fb74bc6f62fb4035$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($fb74bc6f62fb4035$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $fb74bc6f62fb4035$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $fb74bc6f62fb4035$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $fb74bc6f62fb4035$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $fb74bc6f62fb4035$var$kj(b);
            $fb74bc6f62fb4035$var$Ig();
            break;
        case 5:
            $fb74bc6f62fb4035$var$Ah(b);
            break;
        case 1:
            $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$cg(b);
            break;
        case 4:
            $fb74bc6f62fb4035$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $fb74bc6f62fb4035$var$oj(a, b, c);
                $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1);
                a = $fb74bc6f62fb4035$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $fb74bc6f62fb4035$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $fb74bc6f62fb4035$var$dj(a, b, c);
    }
    return $fb74bc6f62fb4035$var$Zi(a, b, c);
}
var $fb74bc6f62fb4035$var$zj, $fb74bc6f62fb4035$var$Aj, $fb74bc6f62fb4035$var$Bj, $fb74bc6f62fb4035$var$Cj;
$fb74bc6f62fb4035$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$fb74bc6f62fb4035$var$Aj = function() {};
$fb74bc6f62fb4035$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $fb74bc6f62fb4035$var$Ya(a, e);
                d = $fb74bc6f62fb4035$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $fb74bc6f62fb4035$var$A({}, e, {
                    value: void 0
                });
                d = $fb74bc6f62fb4035$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $fb74bc6f62fb4035$var$gb(a, e);
                d = $fb74bc6f62fb4035$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $fb74bc6f62fb4035$var$Bf);
        }
        $fb74bc6f62fb4035$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($fb74bc6f62fb4035$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($fb74bc6f62fb4035$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $fb74bc6f62fb4035$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$fb74bc6f62fb4035$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $fb74bc6f62fb4035$var$Dj(a, b) {
    if (!$fb74bc6f62fb4035$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $fb74bc6f62fb4035$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $fb74bc6f62fb4035$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $fb74bc6f62fb4035$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $fb74bc6f62fb4035$var$S(b), null;
        case 1:
            return $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$$f(), $fb74bc6f62fb4035$var$S(b), null;
        case 3:
            d = b.stateNode;
            $fb74bc6f62fb4035$var$zh();
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H);
            $fb74bc6f62fb4035$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $fb74bc6f62fb4035$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $fb74bc6f62fb4035$var$zg && ($fb74bc6f62fb4035$var$Fj($fb74bc6f62fb4035$var$zg), $fb74bc6f62fb4035$var$zg = null));
            $fb74bc6f62fb4035$var$Aj(a, b);
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 5:
            $fb74bc6f62fb4035$var$Bh(b);
            var e = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $fb74bc6f62fb4035$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($fb74bc6f62fb4035$var$p(166));
                    $fb74bc6f62fb4035$var$S(b);
                    return null;
                }
                a = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
                if ($fb74bc6f62fb4035$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$fb74bc6f62fb4035$var$Of] = b;
                    d[$fb74bc6f62fb4035$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $fb74bc6f62fb4035$var$D("cancel", d);
                            $fb74bc6f62fb4035$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $fb74bc6f62fb4035$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $fb74bc6f62fb4035$var$lf.length; e++)$fb74bc6f62fb4035$var$D($fb74bc6f62fb4035$var$lf[e], d);
                            break;
                        case "source":
                            $fb74bc6f62fb4035$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $fb74bc6f62fb4035$var$D("error", d);
                            $fb74bc6f62fb4035$var$D("load", d);
                            break;
                        case "details":
                            $fb74bc6f62fb4035$var$D("toggle", d);
                            break;
                        case "input":
                            $fb74bc6f62fb4035$var$Za(d, f);
                            $fb74bc6f62fb4035$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $fb74bc6f62fb4035$var$D("invalid", d);
                            break;
                        case "textarea":
                            $fb74bc6f62fb4035$var$hb(d, f), $fb74bc6f62fb4035$var$D("invalid", d);
                    }
                    $fb74bc6f62fb4035$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $fb74bc6f62fb4035$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $fb74bc6f62fb4035$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $fb74bc6f62fb4035$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $fb74bc6f62fb4035$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $fb74bc6f62fb4035$var$Va(d);
                            $fb74bc6f62fb4035$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $fb74bc6f62fb4035$var$Va(d);
                            $fb74bc6f62fb4035$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $fb74bc6f62fb4035$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $fb74bc6f62fb4035$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$fb74bc6f62fb4035$var$Of] = b;
                    a[$fb74bc6f62fb4035$var$Pf] = d;
                    $fb74bc6f62fb4035$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $fb74bc6f62fb4035$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $fb74bc6f62fb4035$var$D("cancel", a);
                                $fb74bc6f62fb4035$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $fb74bc6f62fb4035$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $fb74bc6f62fb4035$var$lf.length; e++)$fb74bc6f62fb4035$var$D($fb74bc6f62fb4035$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $fb74bc6f62fb4035$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $fb74bc6f62fb4035$var$D("error", a);
                                $fb74bc6f62fb4035$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $fb74bc6f62fb4035$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $fb74bc6f62fb4035$var$Za(a, d);
                                e = $fb74bc6f62fb4035$var$Ya(a, d);
                                $fb74bc6f62fb4035$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $fb74bc6f62fb4035$var$A({}, d, {
                                    value: void 0
                                });
                                $fb74bc6f62fb4035$var$D("invalid", a);
                                break;
                            case "textarea":
                                $fb74bc6f62fb4035$var$hb(a, d);
                                e = $fb74bc6f62fb4035$var$gb(a, d);
                                $fb74bc6f62fb4035$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $fb74bc6f62fb4035$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $fb74bc6f62fb4035$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $fb74bc6f62fb4035$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $fb74bc6f62fb4035$var$ob(a, k) : "number" === typeof k && $fb74bc6f62fb4035$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($fb74bc6f62fb4035$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $fb74bc6f62fb4035$var$D("scroll", a) : null != k && $fb74bc6f62fb4035$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $fb74bc6f62fb4035$var$Va(a);
                                $fb74bc6f62fb4035$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $fb74bc6f62fb4035$var$Va(a);
                                $fb74bc6f62fb4035$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $fb74bc6f62fb4035$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $fb74bc6f62fb4035$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $fb74bc6f62fb4035$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $fb74bc6f62fb4035$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $fb74bc6f62fb4035$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($fb74bc6f62fb4035$var$p(166));
                c = $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$wh.current);
                $fb74bc6f62fb4035$var$xh($fb74bc6f62fb4035$var$uh.current);
                if ($fb74bc6f62fb4035$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$fb74bc6f62fb4035$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $fb74bc6f62fb4035$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $fb74bc6f62fb4035$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $fb74bc6f62fb4035$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$fb74bc6f62fb4035$var$Of] = b, b.stateNode = d;
            }
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 13:
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($fb74bc6f62fb4035$var$I && null !== $fb74bc6f62fb4035$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $fb74bc6f62fb4035$var$Hg(), $fb74bc6f62fb4035$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $fb74bc6f62fb4035$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($fb74bc6f62fb4035$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($fb74bc6f62fb4035$var$p(317));
                        f[$fb74bc6f62fb4035$var$Of] = b;
                    } else $fb74bc6f62fb4035$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $fb74bc6f62fb4035$var$S(b);
                    f = !1;
                } else null !== $fb74bc6f62fb4035$var$zg && ($fb74bc6f62fb4035$var$Fj($fb74bc6f62fb4035$var$zg), $fb74bc6f62fb4035$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($fb74bc6f62fb4035$var$L.current & 1) ? 0 === $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$T = 3) : $fb74bc6f62fb4035$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 4:
            return $fb74bc6f62fb4035$var$zh(), $fb74bc6f62fb4035$var$Aj(a, b), null === a && $fb74bc6f62fb4035$var$sf(b.stateNode.containerInfo), $fb74bc6f62fb4035$var$S(b), null;
        case 10:
            return $fb74bc6f62fb4035$var$ah(b.type._context), $fb74bc6f62fb4035$var$S(b), null;
        case 17:
            return $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$$f(), $fb74bc6f62fb4035$var$S(b), null;
        case 19:
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
            f = b.memoizedState;
            if (null === f) return $fb74bc6f62fb4035$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $fb74bc6f62fb4035$var$Dj(f, !1);
                else {
                    if (0 !== $fb74bc6f62fb4035$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $fb74bc6f62fb4035$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $fb74bc6f62fb4035$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, $fb74bc6f62fb4035$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $fb74bc6f62fb4035$var$B() > $fb74bc6f62fb4035$var$Gj && (b.flags |= 128, d = !0, $fb74bc6f62fb4035$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $fb74bc6f62fb4035$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $fb74bc6f62fb4035$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$fb74bc6f62fb4035$var$I) return $fb74bc6f62fb4035$var$S(b), null;
                    } else 2 * $fb74bc6f62fb4035$var$B() - f.renderingStartTime > $fb74bc6f62fb4035$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $fb74bc6f62fb4035$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $fb74bc6f62fb4035$var$B(), b.sibling = null, c = $fb74bc6f62fb4035$var$L.current, $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$L, d ? c & 1 | 2 : c & 1), b;
            $fb74bc6f62fb4035$var$S(b);
            return null;
        case 22:
        case 23:
            return $fb74bc6f62fb4035$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($fb74bc6f62fb4035$var$fj & 1073741824) && ($fb74bc6f62fb4035$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $fb74bc6f62fb4035$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($fb74bc6f62fb4035$var$p(156, b.tag));
}
function $fb74bc6f62fb4035$var$Ij(a, b) {
    $fb74bc6f62fb4035$var$wg(b);
    switch(b.tag){
        case 1:
            return $fb74bc6f62fb4035$var$Zf(b.type) && $fb74bc6f62fb4035$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $fb74bc6f62fb4035$var$zh(), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf), $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H), $fb74bc6f62fb4035$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $fb74bc6f62fb4035$var$Bh(b), null;
        case 13:
            $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($fb74bc6f62fb4035$var$p(340));
                $fb74bc6f62fb4035$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L), null;
        case 4:
            return $fb74bc6f62fb4035$var$zh(), null;
        case 10:
            return $fb74bc6f62fb4035$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $fb74bc6f62fb4035$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $fb74bc6f62fb4035$var$Jj = !1, $fb74bc6f62fb4035$var$U = !1, $fb74bc6f62fb4035$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $fb74bc6f62fb4035$var$V = null;
function $fb74bc6f62fb4035$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $fb74bc6f62fb4035$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $fb74bc6f62fb4035$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $fb74bc6f62fb4035$var$W(a, b, d);
    }
}
var $fb74bc6f62fb4035$var$Nj = !1;
function $fb74bc6f62fb4035$var$Oj(a, b) {
    $fb74bc6f62fb4035$var$Cf = $fb74bc6f62fb4035$var$dd;
    a = $fb74bc6f62fb4035$var$Me();
    if ($fb74bc6f62fb4035$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $fb74bc6f62fb4035$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $fb74bc6f62fb4035$var$dd = !1;
    for($fb74bc6f62fb4035$var$V = b; null !== $fb74bc6f62fb4035$var$V;)if (b = $fb74bc6f62fb4035$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $fb74bc6f62fb4035$var$V = a;
    else for(; null !== $fb74bc6f62fb4035$var$V;){
        b = $fb74bc6f62fb4035$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $fb74bc6f62fb4035$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($fb74bc6f62fb4035$var$p(163));
            }
        } catch (F) {
            $fb74bc6f62fb4035$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $fb74bc6f62fb4035$var$V = a;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
    n = $fb74bc6f62fb4035$var$Nj;
    $fb74bc6f62fb4035$var$Nj = !1;
    return n;
}
function $fb74bc6f62fb4035$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $fb74bc6f62fb4035$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $fb74bc6f62fb4035$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $fb74bc6f62fb4035$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $fb74bc6f62fb4035$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $fb74bc6f62fb4035$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$fb74bc6f62fb4035$var$Of], delete b[$fb74bc6f62fb4035$var$Pf], delete b[$fb74bc6f62fb4035$var$of], delete b[$fb74bc6f62fb4035$var$Qf], delete b[$fb74bc6f62fb4035$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $fb74bc6f62fb4035$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $fb74bc6f62fb4035$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $fb74bc6f62fb4035$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $fb74bc6f62fb4035$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $fb74bc6f62fb4035$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($fb74bc6f62fb4035$var$Vj(a, b, c), a = a.sibling; null !== a;)$fb74bc6f62fb4035$var$Vj(a, b, c), a = a.sibling;
}
function $fb74bc6f62fb4035$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($fb74bc6f62fb4035$var$Wj(a, b, c), a = a.sibling; null !== a;)$fb74bc6f62fb4035$var$Wj(a, b, c), a = a.sibling;
}
var $fb74bc6f62fb4035$var$X = null, $fb74bc6f62fb4035$var$Xj = !1;
function $fb74bc6f62fb4035$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$fb74bc6f62fb4035$var$Zj(a, b, c), c = c.sibling;
}
function $fb74bc6f62fb4035$var$Zj(a, b, c) {
    if ($fb74bc6f62fb4035$var$lc && "function" === typeof $fb74bc6f62fb4035$var$lc.onCommitFiberUnmount) try {
        $fb74bc6f62fb4035$var$lc.onCommitFiberUnmount($fb74bc6f62fb4035$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $fb74bc6f62fb4035$var$U || $fb74bc6f62fb4035$var$Lj(c, b);
        case 6:
            var d = $fb74bc6f62fb4035$var$X, e = $fb74bc6f62fb4035$var$Xj;
            $fb74bc6f62fb4035$var$X = null;
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            $fb74bc6f62fb4035$var$X = d;
            $fb74bc6f62fb4035$var$Xj = e;
            null !== $fb74bc6f62fb4035$var$X && ($fb74bc6f62fb4035$var$Xj ? (a = $fb74bc6f62fb4035$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $fb74bc6f62fb4035$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $fb74bc6f62fb4035$var$X && ($fb74bc6f62fb4035$var$Xj ? (a = $fb74bc6f62fb4035$var$X, c = c.stateNode, 8 === a.nodeType ? $fb74bc6f62fb4035$var$Kf(a.parentNode, c) : 1 === a.nodeType && $fb74bc6f62fb4035$var$Kf(a, c), $fb74bc6f62fb4035$var$bd(a)) : $fb74bc6f62fb4035$var$Kf($fb74bc6f62fb4035$var$X, c.stateNode));
            break;
        case 4:
            d = $fb74bc6f62fb4035$var$X;
            e = $fb74bc6f62fb4035$var$Xj;
            $fb74bc6f62fb4035$var$X = c.stateNode.containerInfo;
            $fb74bc6f62fb4035$var$Xj = !0;
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            $fb74bc6f62fb4035$var$X = d;
            $fb74bc6f62fb4035$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$fb74bc6f62fb4035$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $fb74bc6f62fb4035$var$Mj(c, b, g) : 0 !== (f & 4) && $fb74bc6f62fb4035$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        case 1:
            if (!$fb74bc6f62fb4035$var$U && ($fb74bc6f62fb4035$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $fb74bc6f62fb4035$var$W(c, b, h);
            }
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        case 21:
            $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($fb74bc6f62fb4035$var$U = (d = $fb74bc6f62fb4035$var$U) || null !== c.memoizedState, $fb74bc6f62fb4035$var$Yj(a, b, c), $fb74bc6f62fb4035$var$U = d) : $fb74bc6f62fb4035$var$Yj(a, b, c);
            break;
        default:
            $fb74bc6f62fb4035$var$Yj(a, b, c);
    }
}
function $fb74bc6f62fb4035$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $fb74bc6f62fb4035$var$Kj);
        b.forEach(function(b) {
            var d = $fb74bc6f62fb4035$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $fb74bc6f62fb4035$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $fb74bc6f62fb4035$var$X = h.stateNode;
                        $fb74bc6f62fb4035$var$Xj = !1;
                        break a;
                    case 3:
                        $fb74bc6f62fb4035$var$X = h.stateNode.containerInfo;
                        $fb74bc6f62fb4035$var$Xj = !0;
                        break a;
                    case 4:
                        $fb74bc6f62fb4035$var$X = h.stateNode.containerInfo;
                        $fb74bc6f62fb4035$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $fb74bc6f62fb4035$var$X) throw Error($fb74bc6f62fb4035$var$p(160));
            $fb74bc6f62fb4035$var$Zj(f, g, e);
            $fb74bc6f62fb4035$var$X = null;
            $fb74bc6f62fb4035$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $fb74bc6f62fb4035$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$fb74bc6f62fb4035$var$dk(b, a), b = b.sibling;
}
function $fb74bc6f62fb4035$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 4) {
                try {
                    $fb74bc6f62fb4035$var$Pj(3, a, a.return), $fb74bc6f62fb4035$var$Qj(3, a);
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
                try {
                    $fb74bc6f62fb4035$var$Pj(5, a, a.return);
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            d & 512 && null !== c && $fb74bc6f62fb4035$var$Lj(c, c.return);
            break;
        case 5:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            d & 512 && null !== c && $fb74bc6f62fb4035$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $fb74bc6f62fb4035$var$ob(e, "");
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $fb74bc6f62fb4035$var$ab(e, f);
                    $fb74bc6f62fb4035$var$vb(h, g);
                    var l = $fb74bc6f62fb4035$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $fb74bc6f62fb4035$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $fb74bc6f62fb4035$var$nb(e, q) : "children" === m ? $fb74bc6f62fb4035$var$ob(e, q) : $fb74bc6f62fb4035$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $fb74bc6f62fb4035$var$bb(e, f);
                            break;
                        case "textarea":
                            $fb74bc6f62fb4035$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $fb74bc6f62fb4035$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $fb74bc6f62fb4035$var$fb(e, !!f.multiple, f.defaultValue, !0) : $fb74bc6f62fb4035$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$fb74bc6f62fb4035$var$Pf] = f;
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($fb74bc6f62fb4035$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $fb74bc6f62fb4035$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $fb74bc6f62fb4035$var$bd(b.containerInfo);
            } catch (t) {
                $fb74bc6f62fb4035$var$W(a, a.return, t);
            }
            break;
        case 4:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            break;
        case 13:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($fb74bc6f62fb4035$var$fk = $fb74bc6f62fb4035$var$B()));
            d & 4 && $fb74bc6f62fb4035$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($fb74bc6f62fb4035$var$U = (l = $fb74bc6f62fb4035$var$U) || m, $fb74bc6f62fb4035$var$ck(b, a), $fb74bc6f62fb4035$var$U = l) : $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($fb74bc6f62fb4035$var$V = a, m = a.child; null !== m;){
                    for(q = $fb74bc6f62fb4035$var$V = m; null !== $fb74bc6f62fb4035$var$V;){
                        r = $fb74bc6f62fb4035$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $fb74bc6f62fb4035$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $fb74bc6f62fb4035$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $fb74bc6f62fb4035$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $fb74bc6f62fb4035$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $fb74bc6f62fb4035$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $fb74bc6f62fb4035$var$V = y) : $fb74bc6f62fb4035$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $fb74bc6f62fb4035$var$rb("display", g));
                            } catch (t) {
                                $fb74bc6f62fb4035$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $fb74bc6f62fb4035$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $fb74bc6f62fb4035$var$ck(b, a);
            $fb74bc6f62fb4035$var$ek(a);
            d & 4 && $fb74bc6f62fb4035$var$ak(a);
            break;
        case 21:
            break;
        default:
            $fb74bc6f62fb4035$var$ck(b, a), $fb74bc6f62fb4035$var$ek(a);
    }
}
function $fb74bc6f62fb4035$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($fb74bc6f62fb4035$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($fb74bc6f62fb4035$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($fb74bc6f62fb4035$var$ob(e, ""), d.flags &= -33);
                    var f = $fb74bc6f62fb4035$var$Uj(a);
                    $fb74bc6f62fb4035$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $fb74bc6f62fb4035$var$Uj(a);
                    $fb74bc6f62fb4035$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($fb74bc6f62fb4035$var$p(161));
            }
        } catch (k) {
            $fb74bc6f62fb4035$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $fb74bc6f62fb4035$var$hk(a, b, c) {
    $fb74bc6f62fb4035$var$V = a;
    $fb74bc6f62fb4035$var$ik(a, b, c);
}
function $fb74bc6f62fb4035$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $fb74bc6f62fb4035$var$V;){
        var e = $fb74bc6f62fb4035$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $fb74bc6f62fb4035$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $fb74bc6f62fb4035$var$U;
                h = $fb74bc6f62fb4035$var$Jj;
                var l = $fb74bc6f62fb4035$var$U;
                $fb74bc6f62fb4035$var$Jj = g;
                if (($fb74bc6f62fb4035$var$U = k) && !l) for($fb74bc6f62fb4035$var$V = e; null !== $fb74bc6f62fb4035$var$V;)g = $fb74bc6f62fb4035$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $fb74bc6f62fb4035$var$jk(e) : null !== k ? (k.return = g, $fb74bc6f62fb4035$var$V = k) : $fb74bc6f62fb4035$var$jk(e);
                for(; null !== f;)$fb74bc6f62fb4035$var$V = f, $fb74bc6f62fb4035$var$ik(f, b, c), f = f.sibling;
                $fb74bc6f62fb4035$var$V = e;
                $fb74bc6f62fb4035$var$Jj = h;
                $fb74bc6f62fb4035$var$U = l;
            }
            $fb74bc6f62fb4035$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $fb74bc6f62fb4035$var$V = f) : $fb74bc6f62fb4035$var$kk(a, b, c);
    }
}
function $fb74bc6f62fb4035$var$kk(a) {
    for(; null !== $fb74bc6f62fb4035$var$V;){
        var b = $fb74bc6f62fb4035$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $fb74bc6f62fb4035$var$U || $fb74bc6f62fb4035$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$fb74bc6f62fb4035$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $fb74bc6f62fb4035$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $fb74bc6f62fb4035$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $fb74bc6f62fb4035$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $fb74bc6f62fb4035$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($fb74bc6f62fb4035$var$p(163));
                }
                $fb74bc6f62fb4035$var$U || b.flags & 512 && $fb74bc6f62fb4035$var$Rj(b);
            } catch (r) {
                $fb74bc6f62fb4035$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $fb74bc6f62fb4035$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fb74bc6f62fb4035$var$V = c;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
}
function $fb74bc6f62fb4035$var$gk(a) {
    for(; null !== $fb74bc6f62fb4035$var$V;){
        var b = $fb74bc6f62fb4035$var$V;
        if (b === a) {
            $fb74bc6f62fb4035$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $fb74bc6f62fb4035$var$V = c;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
}
function $fb74bc6f62fb4035$var$jk(a) {
    for(; null !== $fb74bc6f62fb4035$var$V;){
        var b = $fb74bc6f62fb4035$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $fb74bc6f62fb4035$var$Qj(4, b);
                    } catch (k) {
                        $fb74bc6f62fb4035$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $fb74bc6f62fb4035$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $fb74bc6f62fb4035$var$Rj(b);
                    } catch (k) {
                        $fb74bc6f62fb4035$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $fb74bc6f62fb4035$var$Rj(b);
                    } catch (k) {
                        $fb74bc6f62fb4035$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $fb74bc6f62fb4035$var$W(b, b.return, k);
        }
        if (b === a) {
            $fb74bc6f62fb4035$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $fb74bc6f62fb4035$var$V = h;
            break;
        }
        $fb74bc6f62fb4035$var$V = b.return;
    }
}
var $fb74bc6f62fb4035$var$lk = Math.ceil, $fb74bc6f62fb4035$var$mk = $fb74bc6f62fb4035$var$ua.ReactCurrentDispatcher, $fb74bc6f62fb4035$var$nk = $fb74bc6f62fb4035$var$ua.ReactCurrentOwner, $fb74bc6f62fb4035$var$ok = $fb74bc6f62fb4035$var$ua.ReactCurrentBatchConfig, $fb74bc6f62fb4035$var$K = 0, $fb74bc6f62fb4035$var$Q = null, $fb74bc6f62fb4035$var$Y = null, $fb74bc6f62fb4035$var$Z = 0, $fb74bc6f62fb4035$var$fj = 0, $fb74bc6f62fb4035$var$ej = $fb74bc6f62fb4035$var$Uf(0), $fb74bc6f62fb4035$var$T = 0, $fb74bc6f62fb4035$var$pk = null, $fb74bc6f62fb4035$var$rh = 0, $fb74bc6f62fb4035$var$qk = 0, $fb74bc6f62fb4035$var$rk = 0, $fb74bc6f62fb4035$var$sk = null, $fb74bc6f62fb4035$var$tk = null, $fb74bc6f62fb4035$var$fk = 0, $fb74bc6f62fb4035$var$Gj = Infinity, $fb74bc6f62fb4035$var$uk = null, $fb74bc6f62fb4035$var$Oi = !1, $fb74bc6f62fb4035$var$Pi = null, $fb74bc6f62fb4035$var$Ri = null, $fb74bc6f62fb4035$var$vk = !1, $fb74bc6f62fb4035$var$wk = null, $fb74bc6f62fb4035$var$xk = 0, $fb74bc6f62fb4035$var$yk = 0, $fb74bc6f62fb4035$var$zk = null, $fb74bc6f62fb4035$var$Ak = -1, $fb74bc6f62fb4035$var$Bk = 0;
function $fb74bc6f62fb4035$var$R() {
    return 0 !== ($fb74bc6f62fb4035$var$K & 6) ? $fb74bc6f62fb4035$var$B() : -1 !== $fb74bc6f62fb4035$var$Ak ? $fb74bc6f62fb4035$var$Ak : $fb74bc6f62fb4035$var$Ak = $fb74bc6f62fb4035$var$B();
}
function $fb74bc6f62fb4035$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($fb74bc6f62fb4035$var$K & 2) && 0 !== $fb74bc6f62fb4035$var$Z) return $fb74bc6f62fb4035$var$Z & -$fb74bc6f62fb4035$var$Z;
    if (null !== $fb74bc6f62fb4035$var$Kg.transition) return 0 === $fb74bc6f62fb4035$var$Bk && ($fb74bc6f62fb4035$var$Bk = $fb74bc6f62fb4035$var$yc()), $fb74bc6f62fb4035$var$Bk;
    a = $fb74bc6f62fb4035$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $fb74bc6f62fb4035$var$jd(a.type);
    return a;
}
function $fb74bc6f62fb4035$var$gi(a, b, c, d) {
    if (50 < $fb74bc6f62fb4035$var$yk) throw $fb74bc6f62fb4035$var$yk = 0, $fb74bc6f62fb4035$var$zk = null, Error($fb74bc6f62fb4035$var$p(185));
    $fb74bc6f62fb4035$var$Ac(a, c, d);
    if (0 === ($fb74bc6f62fb4035$var$K & 2) || a !== $fb74bc6f62fb4035$var$Q) a === $fb74bc6f62fb4035$var$Q && (0 === ($fb74bc6f62fb4035$var$K & 2) && ($fb74bc6f62fb4035$var$qk |= c), 4 === $fb74bc6f62fb4035$var$T && $fb74bc6f62fb4035$var$Ck(a, $fb74bc6f62fb4035$var$Z)), $fb74bc6f62fb4035$var$Dk(a, d), 1 === c && 0 === $fb74bc6f62fb4035$var$K && 0 === (b.mode & 1) && ($fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$fg && $fb74bc6f62fb4035$var$jg());
}
function $fb74bc6f62fb4035$var$Dk(a, b) {
    var c = a.callbackNode;
    $fb74bc6f62fb4035$var$wc(a, b);
    var d = $fb74bc6f62fb4035$var$uc(a, a === $fb74bc6f62fb4035$var$Q ? $fb74bc6f62fb4035$var$Z : 0);
    if (0 === d) null !== c && $fb74bc6f62fb4035$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $fb74bc6f62fb4035$var$bc(c);
        if (1 === b) 0 === a.tag ? $fb74bc6f62fb4035$var$ig($fb74bc6f62fb4035$var$Ek.bind(null, a)) : $fb74bc6f62fb4035$var$hg($fb74bc6f62fb4035$var$Ek.bind(null, a)), $fb74bc6f62fb4035$var$Jf(function() {
            0 === ($fb74bc6f62fb4035$var$K & 6) && $fb74bc6f62fb4035$var$jg();
        }), c = null;
        else {
            switch($fb74bc6f62fb4035$var$Dc(d)){
                case 1:
                    c = $fb74bc6f62fb4035$var$fc;
                    break;
                case 4:
                    c = $fb74bc6f62fb4035$var$gc;
                    break;
                case 16:
                    c = $fb74bc6f62fb4035$var$hc;
                    break;
                case 536870912:
                    c = $fb74bc6f62fb4035$var$jc;
                    break;
                default:
                    c = $fb74bc6f62fb4035$var$hc;
            }
            c = $fb74bc6f62fb4035$var$Fk(c, $fb74bc6f62fb4035$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $fb74bc6f62fb4035$var$Gk(a, b) {
    $fb74bc6f62fb4035$var$Ak = -1;
    $fb74bc6f62fb4035$var$Bk = 0;
    if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(327));
    var c = a.callbackNode;
    if ($fb74bc6f62fb4035$var$Hk() && a.callbackNode !== c) return null;
    var d = $fb74bc6f62fb4035$var$uc(a, a === $fb74bc6f62fb4035$var$Q ? $fb74bc6f62fb4035$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $fb74bc6f62fb4035$var$Ik(a, d);
    else {
        b = d;
        var e = $fb74bc6f62fb4035$var$K;
        $fb74bc6f62fb4035$var$K |= 2;
        var f = $fb74bc6f62fb4035$var$Jk();
        if ($fb74bc6f62fb4035$var$Q !== a || $fb74bc6f62fb4035$var$Z !== b) $fb74bc6f62fb4035$var$uk = null, $fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$Kk(a, b);
        for(;;)try {
            $fb74bc6f62fb4035$var$Lk();
            break;
        } catch (h) {
            $fb74bc6f62fb4035$var$Mk(a, h);
        }
        $fb74bc6f62fb4035$var$$g();
        $fb74bc6f62fb4035$var$mk.current = f;
        $fb74bc6f62fb4035$var$K = e;
        null !== $fb74bc6f62fb4035$var$Y ? b = 0 : ($fb74bc6f62fb4035$var$Q = null, $fb74bc6f62fb4035$var$Z = 0, b = $fb74bc6f62fb4035$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $fb74bc6f62fb4035$var$xc(a), 0 !== e && (d = e, b = $fb74bc6f62fb4035$var$Nk(a, e)));
        if (1 === b) throw c = $fb74bc6f62fb4035$var$pk, $fb74bc6f62fb4035$var$Kk(a, 0), $fb74bc6f62fb4035$var$Ck(a, d), $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), c;
        if (6 === b) $fb74bc6f62fb4035$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$fb74bc6f62fb4035$var$Ok(e) && (b = $fb74bc6f62fb4035$var$Ik(a, d), 2 === b && (f = $fb74bc6f62fb4035$var$xc(a), 0 !== f && (d = f, b = $fb74bc6f62fb4035$var$Nk(a, f))), 1 === b)) throw c = $fb74bc6f62fb4035$var$pk, $fb74bc6f62fb4035$var$Kk(a, 0), $fb74bc6f62fb4035$var$Ck(a, d), $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($fb74bc6f62fb4035$var$p(345));
                case 2:
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                case 3:
                    $fb74bc6f62fb4035$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $fb74bc6f62fb4035$var$fk + 500 - $fb74bc6f62fb4035$var$B(), 10 < b)) {
                        if (0 !== $fb74bc6f62fb4035$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $fb74bc6f62fb4035$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $fb74bc6f62fb4035$var$Ff($fb74bc6f62fb4035$var$Pk.bind(null, a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk), b);
                        break;
                    }
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                case 4:
                    $fb74bc6f62fb4035$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $fb74bc6f62fb4035$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $fb74bc6f62fb4035$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $fb74bc6f62fb4035$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $fb74bc6f62fb4035$var$Ff($fb74bc6f62fb4035$var$Pk.bind(null, a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk), d);
                        break;
                    }
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                case 5:
                    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
                    break;
                default:
                    throw Error($fb74bc6f62fb4035$var$p(329));
            }
        }
    }
    $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B());
    return a.callbackNode === c ? $fb74bc6f62fb4035$var$Gk.bind(null, a) : null;
}
function $fb74bc6f62fb4035$var$Nk(a, b) {
    var c = $fb74bc6f62fb4035$var$sk;
    a.current.memoizedState.isDehydrated && ($fb74bc6f62fb4035$var$Kk(a, b).flags |= 256);
    a = $fb74bc6f62fb4035$var$Ik(a, b);
    2 !== a && (b = $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$tk = c, null !== b && $fb74bc6f62fb4035$var$Fj(b));
    return a;
}
function $fb74bc6f62fb4035$var$Fj(a) {
    null === $fb74bc6f62fb4035$var$tk ? $fb74bc6f62fb4035$var$tk = a : $fb74bc6f62fb4035$var$tk.push.apply($fb74bc6f62fb4035$var$tk, a);
}
function $fb74bc6f62fb4035$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$fb74bc6f62fb4035$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $fb74bc6f62fb4035$var$Ck(a, b) {
    b &= ~$fb74bc6f62fb4035$var$rk;
    b &= ~$fb74bc6f62fb4035$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $fb74bc6f62fb4035$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $fb74bc6f62fb4035$var$Ek(a) {
    if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(327));
    $fb74bc6f62fb4035$var$Hk();
    var b = $fb74bc6f62fb4035$var$uc(a, 0);
    if (0 === (b & 1)) return $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), null;
    var c = $fb74bc6f62fb4035$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $fb74bc6f62fb4035$var$xc(a);
        0 !== d && (b = d, c = $fb74bc6f62fb4035$var$Nk(a, d));
    }
    if (1 === c) throw c = $fb74bc6f62fb4035$var$pk, $fb74bc6f62fb4035$var$Kk(a, 0), $fb74bc6f62fb4035$var$Ck(a, b), $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B()), c;
    if (6 === c) throw Error($fb74bc6f62fb4035$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $fb74bc6f62fb4035$var$Pk(a, $fb74bc6f62fb4035$var$tk, $fb74bc6f62fb4035$var$uk);
    $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B());
    return null;
}
function $fb74bc6f62fb4035$var$Qk(a, b) {
    var c = $fb74bc6f62fb4035$var$K;
    $fb74bc6f62fb4035$var$K |= 1;
    try {
        return a(b);
    } finally{
        $fb74bc6f62fb4035$var$K = c, 0 === $fb74bc6f62fb4035$var$K && ($fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$fg && $fb74bc6f62fb4035$var$jg());
    }
}
function $fb74bc6f62fb4035$var$Rk(a) {
    null !== $fb74bc6f62fb4035$var$wk && 0 === $fb74bc6f62fb4035$var$wk.tag && 0 === ($fb74bc6f62fb4035$var$K & 6) && $fb74bc6f62fb4035$var$Hk();
    var b = $fb74bc6f62fb4035$var$K;
    $fb74bc6f62fb4035$var$K |= 1;
    var c = $fb74bc6f62fb4035$var$ok.transition, d = $fb74bc6f62fb4035$var$C;
    try {
        if ($fb74bc6f62fb4035$var$ok.transition = null, $fb74bc6f62fb4035$var$C = 1, a) return a();
    } finally{
        $fb74bc6f62fb4035$var$C = d, $fb74bc6f62fb4035$var$ok.transition = c, $fb74bc6f62fb4035$var$K = b, 0 === ($fb74bc6f62fb4035$var$K & 6) && $fb74bc6f62fb4035$var$jg();
    }
}
function $fb74bc6f62fb4035$var$Hj() {
    $fb74bc6f62fb4035$var$fj = $fb74bc6f62fb4035$var$ej.current;
    $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$ej);
}
function $fb74bc6f62fb4035$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $fb74bc6f62fb4035$var$Gf(c));
    if (null !== $fb74bc6f62fb4035$var$Y) for(c = $fb74bc6f62fb4035$var$Y.return; null !== c;){
        var d = c;
        $fb74bc6f62fb4035$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $fb74bc6f62fb4035$var$$f();
                break;
            case 3:
                $fb74bc6f62fb4035$var$zh();
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$Wf);
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$H);
                $fb74bc6f62fb4035$var$Eh();
                break;
            case 5:
                $fb74bc6f62fb4035$var$Bh(d);
                break;
            case 4:
                $fb74bc6f62fb4035$var$zh();
                break;
            case 13:
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
                break;
            case 19:
                $fb74bc6f62fb4035$var$E($fb74bc6f62fb4035$var$L);
                break;
            case 10:
                $fb74bc6f62fb4035$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $fb74bc6f62fb4035$var$Hj();
        }
        c = c.return;
    }
    $fb74bc6f62fb4035$var$Q = a;
    $fb74bc6f62fb4035$var$Y = a = $fb74bc6f62fb4035$var$Pg(a.current, null);
    $fb74bc6f62fb4035$var$Z = $fb74bc6f62fb4035$var$fj = b;
    $fb74bc6f62fb4035$var$T = 0;
    $fb74bc6f62fb4035$var$pk = null;
    $fb74bc6f62fb4035$var$rk = $fb74bc6f62fb4035$var$qk = $fb74bc6f62fb4035$var$rh = 0;
    $fb74bc6f62fb4035$var$tk = $fb74bc6f62fb4035$var$sk = null;
    if (null !== $fb74bc6f62fb4035$var$fh) {
        for(b = 0; b < $fb74bc6f62fb4035$var$fh.length; b++)if (c = $fb74bc6f62fb4035$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $fb74bc6f62fb4035$var$fh = null;
    }
    return a;
}
function $fb74bc6f62fb4035$var$Mk(a, b) {
    do {
        var c = $fb74bc6f62fb4035$var$Y;
        try {
            $fb74bc6f62fb4035$var$$g();
            $fb74bc6f62fb4035$var$Fh.current = $fb74bc6f62fb4035$var$Rh;
            if ($fb74bc6f62fb4035$var$Ih) {
                for(var d = $fb74bc6f62fb4035$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $fb74bc6f62fb4035$var$Ih = !1;
            }
            $fb74bc6f62fb4035$var$Hh = 0;
            $fb74bc6f62fb4035$var$O = $fb74bc6f62fb4035$var$N = $fb74bc6f62fb4035$var$M = null;
            $fb74bc6f62fb4035$var$Jh = !1;
            $fb74bc6f62fb4035$var$Kh = 0;
            $fb74bc6f62fb4035$var$nk.current = null;
            if (null === c || null === c.return) {
                $fb74bc6f62fb4035$var$T = 1;
                $fb74bc6f62fb4035$var$pk = b;
                $fb74bc6f62fb4035$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $fb74bc6f62fb4035$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $fb74bc6f62fb4035$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $fb74bc6f62fb4035$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $fb74bc6f62fb4035$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $fb74bc6f62fb4035$var$Si(f, l, b);
                            $fb74bc6f62fb4035$var$tj();
                            break a;
                        }
                        k = Error($fb74bc6f62fb4035$var$p(426));
                    }
                } else if ($fb74bc6f62fb4035$var$I && h.mode & 1) {
                    var J = $fb74bc6f62fb4035$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $fb74bc6f62fb4035$var$Vi(J, g, h, f, b);
                        $fb74bc6f62fb4035$var$Jg($fb74bc6f62fb4035$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $fb74bc6f62fb4035$var$Ji(k, h);
                4 !== $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$T = 2);
                null === $fb74bc6f62fb4035$var$sk ? $fb74bc6f62fb4035$var$sk = [
                    f
                ] : $fb74bc6f62fb4035$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $fb74bc6f62fb4035$var$Ni(f, k, b);
                            $fb74bc6f62fb4035$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $fb74bc6f62fb4035$var$Ri || !$fb74bc6f62fb4035$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $fb74bc6f62fb4035$var$Qi(f, h, b);
                                $fb74bc6f62fb4035$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $fb74bc6f62fb4035$var$Sk(c);
        } catch (na) {
            b = na;
            $fb74bc6f62fb4035$var$Y === c && null !== c && ($fb74bc6f62fb4035$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $fb74bc6f62fb4035$var$Jk() {
    var a = $fb74bc6f62fb4035$var$mk.current;
    $fb74bc6f62fb4035$var$mk.current = $fb74bc6f62fb4035$var$Rh;
    return null === a ? $fb74bc6f62fb4035$var$Rh : a;
}
function $fb74bc6f62fb4035$var$tj() {
    if (0 === $fb74bc6f62fb4035$var$T || 3 === $fb74bc6f62fb4035$var$T || 2 === $fb74bc6f62fb4035$var$T) $fb74bc6f62fb4035$var$T = 4;
    null === $fb74bc6f62fb4035$var$Q || 0 === ($fb74bc6f62fb4035$var$rh & 268435455) && 0 === ($fb74bc6f62fb4035$var$qk & 268435455) || $fb74bc6f62fb4035$var$Ck($fb74bc6f62fb4035$var$Q, $fb74bc6f62fb4035$var$Z);
}
function $fb74bc6f62fb4035$var$Ik(a, b) {
    var c = $fb74bc6f62fb4035$var$K;
    $fb74bc6f62fb4035$var$K |= 2;
    var d = $fb74bc6f62fb4035$var$Jk();
    if ($fb74bc6f62fb4035$var$Q !== a || $fb74bc6f62fb4035$var$Z !== b) $fb74bc6f62fb4035$var$uk = null, $fb74bc6f62fb4035$var$Kk(a, b);
    for(;;)try {
        $fb74bc6f62fb4035$var$Tk();
        break;
    } catch (e) {
        $fb74bc6f62fb4035$var$Mk(a, e);
    }
    $fb74bc6f62fb4035$var$$g();
    $fb74bc6f62fb4035$var$K = c;
    $fb74bc6f62fb4035$var$mk.current = d;
    if (null !== $fb74bc6f62fb4035$var$Y) throw Error($fb74bc6f62fb4035$var$p(261));
    $fb74bc6f62fb4035$var$Q = null;
    $fb74bc6f62fb4035$var$Z = 0;
    return $fb74bc6f62fb4035$var$T;
}
function $fb74bc6f62fb4035$var$Tk() {
    for(; null !== $fb74bc6f62fb4035$var$Y;)$fb74bc6f62fb4035$var$Uk($fb74bc6f62fb4035$var$Y);
}
function $fb74bc6f62fb4035$var$Lk() {
    for(; null !== $fb74bc6f62fb4035$var$Y && !$fb74bc6f62fb4035$var$cc();)$fb74bc6f62fb4035$var$Uk($fb74bc6f62fb4035$var$Y);
}
function $fb74bc6f62fb4035$var$Uk(a) {
    var b = $fb74bc6f62fb4035$var$Vk(a.alternate, a, $fb74bc6f62fb4035$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $fb74bc6f62fb4035$var$Sk(a) : $fb74bc6f62fb4035$var$Y = b;
    $fb74bc6f62fb4035$var$nk.current = null;
}
function $fb74bc6f62fb4035$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $fb74bc6f62fb4035$var$Ej(c, b, $fb74bc6f62fb4035$var$fj), null !== c) {
                $fb74bc6f62fb4035$var$Y = c;
                return;
            }
        } else {
            c = $fb74bc6f62fb4035$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $fb74bc6f62fb4035$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $fb74bc6f62fb4035$var$T = 6;
                $fb74bc6f62fb4035$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $fb74bc6f62fb4035$var$Y = b;
            return;
        }
        $fb74bc6f62fb4035$var$Y = b = a;
    }while (null !== b);
    0 === $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$T = 5);
}
function $fb74bc6f62fb4035$var$Pk(a, b, c) {
    var d = $fb74bc6f62fb4035$var$C, e = $fb74bc6f62fb4035$var$ok.transition;
    try {
        $fb74bc6f62fb4035$var$ok.transition = null, $fb74bc6f62fb4035$var$C = 1, $fb74bc6f62fb4035$var$Wk(a, b, c, d);
    } finally{
        $fb74bc6f62fb4035$var$ok.transition = e, $fb74bc6f62fb4035$var$C = d;
    }
    return null;
}
function $fb74bc6f62fb4035$var$Wk(a, b, c, d) {
    do $fb74bc6f62fb4035$var$Hk();
    while (null !== $fb74bc6f62fb4035$var$wk);
    if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($fb74bc6f62fb4035$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $fb74bc6f62fb4035$var$Bc(a, f);
    a === $fb74bc6f62fb4035$var$Q && ($fb74bc6f62fb4035$var$Y = $fb74bc6f62fb4035$var$Q = null, $fb74bc6f62fb4035$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $fb74bc6f62fb4035$var$vk || ($fb74bc6f62fb4035$var$vk = !0, $fb74bc6f62fb4035$var$Fk($fb74bc6f62fb4035$var$hc, function() {
        $fb74bc6f62fb4035$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $fb74bc6f62fb4035$var$ok.transition;
        $fb74bc6f62fb4035$var$ok.transition = null;
        var g = $fb74bc6f62fb4035$var$C;
        $fb74bc6f62fb4035$var$C = 1;
        var h = $fb74bc6f62fb4035$var$K;
        $fb74bc6f62fb4035$var$K |= 4;
        $fb74bc6f62fb4035$var$nk.current = null;
        $fb74bc6f62fb4035$var$Oj(a, c);
        $fb74bc6f62fb4035$var$dk(c, a);
        $fb74bc6f62fb4035$var$Oe($fb74bc6f62fb4035$var$Df);
        $fb74bc6f62fb4035$var$dd = !!$fb74bc6f62fb4035$var$Cf;
        $fb74bc6f62fb4035$var$Df = $fb74bc6f62fb4035$var$Cf = null;
        a.current = c;
        $fb74bc6f62fb4035$var$hk(c, a, e);
        $fb74bc6f62fb4035$var$dc();
        $fb74bc6f62fb4035$var$K = h;
        $fb74bc6f62fb4035$var$C = g;
        $fb74bc6f62fb4035$var$ok.transition = f;
    } else a.current = c;
    $fb74bc6f62fb4035$var$vk && ($fb74bc6f62fb4035$var$vk = !1, $fb74bc6f62fb4035$var$wk = a, $fb74bc6f62fb4035$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($fb74bc6f62fb4035$var$Ri = null);
    $fb74bc6f62fb4035$var$mc(c.stateNode, d);
    $fb74bc6f62fb4035$var$Dk(a, $fb74bc6f62fb4035$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($fb74bc6f62fb4035$var$Oi) throw $fb74bc6f62fb4035$var$Oi = !1, a = $fb74bc6f62fb4035$var$Pi, $fb74bc6f62fb4035$var$Pi = null, a;
    0 !== ($fb74bc6f62fb4035$var$xk & 1) && 0 !== a.tag && $fb74bc6f62fb4035$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $fb74bc6f62fb4035$var$zk ? $fb74bc6f62fb4035$var$yk++ : ($fb74bc6f62fb4035$var$yk = 0, $fb74bc6f62fb4035$var$zk = a) : $fb74bc6f62fb4035$var$yk = 0;
    $fb74bc6f62fb4035$var$jg();
    return null;
}
function $fb74bc6f62fb4035$var$Hk() {
    if (null !== $fb74bc6f62fb4035$var$wk) {
        var a = $fb74bc6f62fb4035$var$Dc($fb74bc6f62fb4035$var$xk), b = $fb74bc6f62fb4035$var$ok.transition, c = $fb74bc6f62fb4035$var$C;
        try {
            $fb74bc6f62fb4035$var$ok.transition = null;
            $fb74bc6f62fb4035$var$C = 16 > a ? 16 : a;
            if (null === $fb74bc6f62fb4035$var$wk) var d = !1;
            else {
                a = $fb74bc6f62fb4035$var$wk;
                $fb74bc6f62fb4035$var$wk = null;
                $fb74bc6f62fb4035$var$xk = 0;
                if (0 !== ($fb74bc6f62fb4035$var$K & 6)) throw Error($fb74bc6f62fb4035$var$p(331));
                var e = $fb74bc6f62fb4035$var$K;
                $fb74bc6f62fb4035$var$K |= 4;
                for($fb74bc6f62fb4035$var$V = a.current; null !== $fb74bc6f62fb4035$var$V;){
                    var f = $fb74bc6f62fb4035$var$V, g = f.child;
                    if (0 !== ($fb74bc6f62fb4035$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($fb74bc6f62fb4035$var$V = l; null !== $fb74bc6f62fb4035$var$V;){
                                    var m = $fb74bc6f62fb4035$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $fb74bc6f62fb4035$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $fb74bc6f62fb4035$var$V = q;
                                    else for(; null !== $fb74bc6f62fb4035$var$V;){
                                        m = $fb74bc6f62fb4035$var$V;
                                        var r = m.sibling, y = m.return;
                                        $fb74bc6f62fb4035$var$Sj(m);
                                        if (m === l) {
                                            $fb74bc6f62fb4035$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $fb74bc6f62fb4035$var$V = r;
                                            break;
                                        }
                                        $fb74bc6f62fb4035$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $fb74bc6f62fb4035$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $fb74bc6f62fb4035$var$V = g;
                    else b: for(; null !== $fb74bc6f62fb4035$var$V;){
                        f = $fb74bc6f62fb4035$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $fb74bc6f62fb4035$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $fb74bc6f62fb4035$var$V = x;
                            break b;
                        }
                        $fb74bc6f62fb4035$var$V = f.return;
                    }
                }
                var w = a.current;
                for($fb74bc6f62fb4035$var$V = w; null !== $fb74bc6f62fb4035$var$V;){
                    g = $fb74bc6f62fb4035$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $fb74bc6f62fb4035$var$V = u;
                    else b: for(g = w; null !== $fb74bc6f62fb4035$var$V;){
                        h = $fb74bc6f62fb4035$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $fb74bc6f62fb4035$var$Qj(9, h);
                            }
                        } catch (na) {
                            $fb74bc6f62fb4035$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $fb74bc6f62fb4035$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $fb74bc6f62fb4035$var$V = F;
                            break b;
                        }
                        $fb74bc6f62fb4035$var$V = h.return;
                    }
                }
                $fb74bc6f62fb4035$var$K = e;
                $fb74bc6f62fb4035$var$jg();
                if ($fb74bc6f62fb4035$var$lc && "function" === typeof $fb74bc6f62fb4035$var$lc.onPostCommitFiberRoot) try {
                    $fb74bc6f62fb4035$var$lc.onPostCommitFiberRoot($fb74bc6f62fb4035$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $fb74bc6f62fb4035$var$C = c, $fb74bc6f62fb4035$var$ok.transition = b;
        }
    }
    return !1;
}
function $fb74bc6f62fb4035$var$Xk(a, b, c) {
    b = $fb74bc6f62fb4035$var$Ji(c, b);
    b = $fb74bc6f62fb4035$var$Ni(a, b, 1);
    a = $fb74bc6f62fb4035$var$nh(a, b, 1);
    b = $fb74bc6f62fb4035$var$R();
    null !== a && ($fb74bc6f62fb4035$var$Ac(a, 1, b), $fb74bc6f62fb4035$var$Dk(a, b));
}
function $fb74bc6f62fb4035$var$W(a, b, c) {
    if (3 === a.tag) $fb74bc6f62fb4035$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $fb74bc6f62fb4035$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $fb74bc6f62fb4035$var$Ri || !$fb74bc6f62fb4035$var$Ri.has(d))) {
                a = $fb74bc6f62fb4035$var$Ji(c, a);
                a = $fb74bc6f62fb4035$var$Qi(b, a, 1);
                b = $fb74bc6f62fb4035$var$nh(b, a, 1);
                a = $fb74bc6f62fb4035$var$R();
                null !== b && ($fb74bc6f62fb4035$var$Ac(b, 1, a), $fb74bc6f62fb4035$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $fb74bc6f62fb4035$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $fb74bc6f62fb4035$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $fb74bc6f62fb4035$var$Q === a && ($fb74bc6f62fb4035$var$Z & c) === c && (4 === $fb74bc6f62fb4035$var$T || 3 === $fb74bc6f62fb4035$var$T && ($fb74bc6f62fb4035$var$Z & 130023424) === $fb74bc6f62fb4035$var$Z && 500 > $fb74bc6f62fb4035$var$B() - $fb74bc6f62fb4035$var$fk ? $fb74bc6f62fb4035$var$Kk(a, 0) : $fb74bc6f62fb4035$var$rk |= c);
    $fb74bc6f62fb4035$var$Dk(a, b);
}
function $fb74bc6f62fb4035$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $fb74bc6f62fb4035$var$sc, $fb74bc6f62fb4035$var$sc <<= 1, 0 === ($fb74bc6f62fb4035$var$sc & 130023424) && ($fb74bc6f62fb4035$var$sc = 4194304)));
    var c = $fb74bc6f62fb4035$var$R();
    a = $fb74bc6f62fb4035$var$ih(a, b);
    null !== a && ($fb74bc6f62fb4035$var$Ac(a, b, c), $fb74bc6f62fb4035$var$Dk(a, c));
}
function $fb74bc6f62fb4035$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $fb74bc6f62fb4035$var$Yk(a, c);
}
function $fb74bc6f62fb4035$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($fb74bc6f62fb4035$var$p(314));
    }
    null !== d && d.delete(b);
    $fb74bc6f62fb4035$var$Yk(a, c);
}
var $fb74bc6f62fb4035$var$Vk;
$fb74bc6f62fb4035$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $fb74bc6f62fb4035$var$Wf.current) $fb74bc6f62fb4035$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $fb74bc6f62fb4035$var$dh = !1, $fb74bc6f62fb4035$var$yj(a, b, c);
            $fb74bc6f62fb4035$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $fb74bc6f62fb4035$var$dh = !1, $fb74bc6f62fb4035$var$I && 0 !== (b.flags & 1048576) && $fb74bc6f62fb4035$var$ug(b, $fb74bc6f62fb4035$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $fb74bc6f62fb4035$var$ij(a, b);
            a = b.pendingProps;
            var e = $fb74bc6f62fb4035$var$Yf(b, $fb74bc6f62fb4035$var$H.current);
            $fb74bc6f62fb4035$var$ch(b, c);
            e = $fb74bc6f62fb4035$var$Nh(null, b, d, a, e, c);
            var f = $fb74bc6f62fb4035$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $fb74bc6f62fb4035$var$Zf(d) ? (f = !0, $fb74bc6f62fb4035$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $fb74bc6f62fb4035$var$kh(b), e.updater = $fb74bc6f62fb4035$var$Ei, b.stateNode = e, e._reactInternals = b, $fb74bc6f62fb4035$var$Ii(b, d, a, c), b = $fb74bc6f62fb4035$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $fb74bc6f62fb4035$var$I && f && $fb74bc6f62fb4035$var$vg(b), $fb74bc6f62fb4035$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $fb74bc6f62fb4035$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $fb74bc6f62fb4035$var$Zk(d);
                a = $fb74bc6f62fb4035$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $fb74bc6f62fb4035$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $fb74bc6f62fb4035$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $fb74bc6f62fb4035$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $fb74bc6f62fb4035$var$$i(null, b, d, $fb74bc6f62fb4035$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($fb74bc6f62fb4035$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $fb74bc6f62fb4035$var$kj(b);
                if (null === a) throw Error($fb74bc6f62fb4035$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $fb74bc6f62fb4035$var$lh(a, b);
                $fb74bc6f62fb4035$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $fb74bc6f62fb4035$var$Ji(Error($fb74bc6f62fb4035$var$p(423)), b);
                        b = $fb74bc6f62fb4035$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $fb74bc6f62fb4035$var$Ji(Error($fb74bc6f62fb4035$var$p(424)), b);
                        b = $fb74bc6f62fb4035$var$lj(a, b, d, c, e);
                        break a;
                    } else for($fb74bc6f62fb4035$var$yg = $fb74bc6f62fb4035$var$Lf(b.stateNode.containerInfo.firstChild), $fb74bc6f62fb4035$var$xg = b, $fb74bc6f62fb4035$var$I = !0, $fb74bc6f62fb4035$var$zg = null, c = $fb74bc6f62fb4035$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $fb74bc6f62fb4035$var$Ig();
                    if (d === e) {
                        b = $fb74bc6f62fb4035$var$Zi(a, b, c);
                        break a;
                    }
                    $fb74bc6f62fb4035$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $fb74bc6f62fb4035$var$Ah(b), null === a && $fb74bc6f62fb4035$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $fb74bc6f62fb4035$var$Ef(d, e) ? g = null : null !== f && $fb74bc6f62fb4035$var$Ef(d, f) && (b.flags |= 32), $fb74bc6f62fb4035$var$gj(a, b), $fb74bc6f62fb4035$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $fb74bc6f62fb4035$var$Eg(b), null;
        case 13:
            return $fb74bc6f62fb4035$var$oj(a, b, c);
        case 4:
            return $fb74bc6f62fb4035$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $fb74bc6f62fb4035$var$Ug(b, null, d, c) : $fb74bc6f62fb4035$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$Yi(a, b, d, e, c);
        case 7:
            return $fb74bc6f62fb4035$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $fb74bc6f62fb4035$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $fb74bc6f62fb4035$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $fb74bc6f62fb4035$var$G($fb74bc6f62fb4035$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($fb74bc6f62fb4035$var$He(f.value, g)) {
                        if (f.children === e.children && !$fb74bc6f62fb4035$var$Wf.current) {
                            b = $fb74bc6f62fb4035$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $fb74bc6f62fb4035$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $fb74bc6f62fb4035$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($fb74bc6f62fb4035$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $fb74bc6f62fb4035$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $fb74bc6f62fb4035$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $fb74bc6f62fb4035$var$ch(b, c), e = $fb74bc6f62fb4035$var$eh(e), d = d(e), b.flags |= 1, $fb74bc6f62fb4035$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $fb74bc6f62fb4035$var$Ci(d, b.pendingProps), e = $fb74bc6f62fb4035$var$Ci(d.type, e), $fb74bc6f62fb4035$var$$i(a, b, d, e, c);
        case 15:
            return $fb74bc6f62fb4035$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $fb74bc6f62fb4035$var$Ci(d, e), $fb74bc6f62fb4035$var$ij(a, b), b.tag = 1, $fb74bc6f62fb4035$var$Zf(d) ? (a = !0, $fb74bc6f62fb4035$var$cg(b)) : a = !1, $fb74bc6f62fb4035$var$ch(b, c), $fb74bc6f62fb4035$var$Gi(b, d, e), $fb74bc6f62fb4035$var$Ii(b, d, e, c), $fb74bc6f62fb4035$var$jj(null, b, d, !0, a, c);
        case 19:
            return $fb74bc6f62fb4035$var$xj(a, b, c);
        case 22:
            return $fb74bc6f62fb4035$var$dj(a, b, c);
    }
    throw Error($fb74bc6f62fb4035$var$p(156, b.tag));
};
function $fb74bc6f62fb4035$var$Fk(a, b) {
    return $fb74bc6f62fb4035$var$ac(a, b);
}
function $fb74bc6f62fb4035$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $fb74bc6f62fb4035$var$Bg(a, b, c, d) {
    return new $fb74bc6f62fb4035$var$$k(a, b, c, d);
}
function $fb74bc6f62fb4035$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $fb74bc6f62fb4035$var$Zk(a) {
    if ("function" === typeof a) return $fb74bc6f62fb4035$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $fb74bc6f62fb4035$var$Da) return 11;
        if (a === $fb74bc6f62fb4035$var$Ga) return 14;
    }
    return 2;
}
function $fb74bc6f62fb4035$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $fb74bc6f62fb4035$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $fb74bc6f62fb4035$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $fb74bc6f62fb4035$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $fb74bc6f62fb4035$var$ya:
            return $fb74bc6f62fb4035$var$Tg(c.children, e, f, b);
        case $fb74bc6f62fb4035$var$za:
            g = 8;
            e |= 8;
            break;
        case $fb74bc6f62fb4035$var$Aa:
            return a = $fb74bc6f62fb4035$var$Bg(12, c, b, e | 2), a.elementType = $fb74bc6f62fb4035$var$Aa, a.lanes = f, a;
        case $fb74bc6f62fb4035$var$Ea:
            return a = $fb74bc6f62fb4035$var$Bg(13, c, b, e), a.elementType = $fb74bc6f62fb4035$var$Ea, a.lanes = f, a;
        case $fb74bc6f62fb4035$var$Fa:
            return a = $fb74bc6f62fb4035$var$Bg(19, c, b, e), a.elementType = $fb74bc6f62fb4035$var$Fa, a.lanes = f, a;
        case $fb74bc6f62fb4035$var$Ia:
            return $fb74bc6f62fb4035$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $fb74bc6f62fb4035$var$Ba:
                    g = 10;
                    break a;
                case $fb74bc6f62fb4035$var$Ca:
                    g = 9;
                    break a;
                case $fb74bc6f62fb4035$var$Da:
                    g = 11;
                    break a;
                case $fb74bc6f62fb4035$var$Ga:
                    g = 14;
                    break a;
                case $fb74bc6f62fb4035$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($fb74bc6f62fb4035$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $fb74bc6f62fb4035$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $fb74bc6f62fb4035$var$Tg(a, b, c, d) {
    a = $fb74bc6f62fb4035$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $fb74bc6f62fb4035$var$pj(a, b, c, d) {
    a = $fb74bc6f62fb4035$var$Bg(22, a, d, b);
    a.elementType = $fb74bc6f62fb4035$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $fb74bc6f62fb4035$var$Qg(a, b, c) {
    a = $fb74bc6f62fb4035$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $fb74bc6f62fb4035$var$Sg(a, b, c) {
    b = $fb74bc6f62fb4035$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $fb74bc6f62fb4035$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $fb74bc6f62fb4035$var$zc(0);
    this.expirationTimes = $fb74bc6f62fb4035$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $fb74bc6f62fb4035$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $fb74bc6f62fb4035$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $fb74bc6f62fb4035$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $fb74bc6f62fb4035$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $fb74bc6f62fb4035$var$kh(f);
    return a;
}
function $fb74bc6f62fb4035$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $fb74bc6f62fb4035$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $fb74bc6f62fb4035$var$dl(a) {
    if (!a) return $fb74bc6f62fb4035$var$Vf;
    a = a._reactInternals;
    a: {
        if ($fb74bc6f62fb4035$var$Vb(a) !== a || 1 !== a.tag) throw Error($fb74bc6f62fb4035$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($fb74bc6f62fb4035$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($fb74bc6f62fb4035$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($fb74bc6f62fb4035$var$Zf(c)) return $fb74bc6f62fb4035$var$bg(a, c, b);
    }
    return b;
}
function $fb74bc6f62fb4035$var$el(a, b, c, d, e, f, g, h, k) {
    a = $fb74bc6f62fb4035$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $fb74bc6f62fb4035$var$dl(null);
    c = a.current;
    d = $fb74bc6f62fb4035$var$R();
    e = $fb74bc6f62fb4035$var$yi(c);
    f = $fb74bc6f62fb4035$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $fb74bc6f62fb4035$var$nh(c, f, e);
    a.current.lanes = e;
    $fb74bc6f62fb4035$var$Ac(a, e, d);
    $fb74bc6f62fb4035$var$Dk(a, d);
    return a;
}
function $fb74bc6f62fb4035$var$fl(a, b, c, d) {
    var e = b.current, f = $fb74bc6f62fb4035$var$R(), g = $fb74bc6f62fb4035$var$yi(e);
    c = $fb74bc6f62fb4035$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $fb74bc6f62fb4035$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $fb74bc6f62fb4035$var$nh(e, b, g);
    null !== a && ($fb74bc6f62fb4035$var$gi(a, e, g, f), $fb74bc6f62fb4035$var$oh(a, e, g));
    return g;
}
function $fb74bc6f62fb4035$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $fb74bc6f62fb4035$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $fb74bc6f62fb4035$var$il(a, b) {
    $fb74bc6f62fb4035$var$hl(a, b);
    (a = a.alternate) && $fb74bc6f62fb4035$var$hl(a, b);
}
function $fb74bc6f62fb4035$var$jl() {
    return null;
}
var $fb74bc6f62fb4035$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $fb74bc6f62fb4035$var$ll(a) {
    this._internalRoot = a;
}
$fb74bc6f62fb4035$var$ml.prototype.render = $fb74bc6f62fb4035$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($fb74bc6f62fb4035$var$p(409));
    $fb74bc6f62fb4035$var$fl(a, b, null, null);
};
$fb74bc6f62fb4035$var$ml.prototype.unmount = $fb74bc6f62fb4035$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $fb74bc6f62fb4035$var$Rk(function() {
            $fb74bc6f62fb4035$var$fl(null, a, null, null);
        });
        b[$fb74bc6f62fb4035$var$uf] = null;
    }
};
function $fb74bc6f62fb4035$var$ml(a) {
    this._internalRoot = a;
}
$fb74bc6f62fb4035$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $fb74bc6f62fb4035$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $fb74bc6f62fb4035$var$Qc.length && 0 !== b && b < $fb74bc6f62fb4035$var$Qc[c].priority; c++);
        $fb74bc6f62fb4035$var$Qc.splice(c, 0, a);
        0 === c && $fb74bc6f62fb4035$var$Vc(a);
    }
};
function $fb74bc6f62fb4035$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $fb74bc6f62fb4035$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $fb74bc6f62fb4035$var$pl() {}
function $fb74bc6f62fb4035$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $fb74bc6f62fb4035$var$gl(g);
                f.call(a);
            };
        }
        var g = $fb74bc6f62fb4035$var$el(b, d, a, 0, null, !1, !1, "", $fb74bc6f62fb4035$var$pl);
        a._reactRootContainer = g;
        a[$fb74bc6f62fb4035$var$uf] = g.current;
        $fb74bc6f62fb4035$var$sf(8 === a.nodeType ? a.parentNode : a);
        $fb74bc6f62fb4035$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $fb74bc6f62fb4035$var$gl(k);
            h.call(a);
        };
    }
    var k = $fb74bc6f62fb4035$var$bl(a, 0, !1, null, null, !1, !1, "", $fb74bc6f62fb4035$var$pl);
    a._reactRootContainer = k;
    a[$fb74bc6f62fb4035$var$uf] = k.current;
    $fb74bc6f62fb4035$var$sf(8 === a.nodeType ? a.parentNode : a);
    $fb74bc6f62fb4035$var$Rk(function() {
        $fb74bc6f62fb4035$var$fl(b, k, c, d);
    });
    return k;
}
function $fb74bc6f62fb4035$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $fb74bc6f62fb4035$var$gl(g);
                h.call(a);
            };
        }
        $fb74bc6f62fb4035$var$fl(b, g, a, e);
    } else g = $fb74bc6f62fb4035$var$ql(c, b, a, e, d);
    return $fb74bc6f62fb4035$var$gl(g);
}
$fb74bc6f62fb4035$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $fb74bc6f62fb4035$var$tc(b.pendingLanes);
                0 !== c && ($fb74bc6f62fb4035$var$Cc(b, c | 1), $fb74bc6f62fb4035$var$Dk(b, $fb74bc6f62fb4035$var$B()), 0 === ($fb74bc6f62fb4035$var$K & 6) && ($fb74bc6f62fb4035$var$Gj = $fb74bc6f62fb4035$var$B() + 500, $fb74bc6f62fb4035$var$jg()));
            }
            break;
        case 13:
            $fb74bc6f62fb4035$var$Rk(function() {
                var b = $fb74bc6f62fb4035$var$ih(a, 1);
                if (null !== b) {
                    var c = $fb74bc6f62fb4035$var$R();
                    $fb74bc6f62fb4035$var$gi(b, a, 1, c);
                }
            }), $fb74bc6f62fb4035$var$il(a, 1);
    }
};
$fb74bc6f62fb4035$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $fb74bc6f62fb4035$var$ih(a, 134217728);
        if (null !== b) {
            var c = $fb74bc6f62fb4035$var$R();
            $fb74bc6f62fb4035$var$gi(b, a, 134217728, c);
        }
        $fb74bc6f62fb4035$var$il(a, 134217728);
    }
};
$fb74bc6f62fb4035$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $fb74bc6f62fb4035$var$yi(a), c = $fb74bc6f62fb4035$var$ih(a, b);
        if (null !== c) {
            var d = $fb74bc6f62fb4035$var$R();
            $fb74bc6f62fb4035$var$gi(c, a, b, d);
        }
        $fb74bc6f62fb4035$var$il(a, b);
    }
};
$fb74bc6f62fb4035$var$Hc = function() {
    return $fb74bc6f62fb4035$var$C;
};
$fb74bc6f62fb4035$var$Ic = function(a, b) {
    var c = $fb74bc6f62fb4035$var$C;
    try {
        return $fb74bc6f62fb4035$var$C = a, b();
    } finally{
        $fb74bc6f62fb4035$var$C = c;
    }
};
$fb74bc6f62fb4035$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $fb74bc6f62fb4035$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $fb74bc6f62fb4035$var$Db(d);
                        if (!e) throw Error($fb74bc6f62fb4035$var$p(90));
                        $fb74bc6f62fb4035$var$Wa(d);
                        $fb74bc6f62fb4035$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $fb74bc6f62fb4035$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $fb74bc6f62fb4035$var$fb(a, !!c.multiple, b, !1);
    }
};
$fb74bc6f62fb4035$var$Gb = $fb74bc6f62fb4035$var$Qk;
$fb74bc6f62fb4035$var$Hb = $fb74bc6f62fb4035$var$Rk;
var $fb74bc6f62fb4035$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $fb74bc6f62fb4035$var$Cb,
        $fb74bc6f62fb4035$var$ue,
        $fb74bc6f62fb4035$var$Db,
        $fb74bc6f62fb4035$var$Eb,
        $fb74bc6f62fb4035$var$Fb,
        $fb74bc6f62fb4035$var$Qk
    ]
}, $fb74bc6f62fb4035$var$tl = {
    findFiberByHostInstance: $fb74bc6f62fb4035$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $fb74bc6f62fb4035$var$ul = {
    bundleType: $fb74bc6f62fb4035$var$tl.bundleType,
    version: $fb74bc6f62fb4035$var$tl.version,
    rendererPackageName: $fb74bc6f62fb4035$var$tl.rendererPackageName,
    rendererConfig: $fb74bc6f62fb4035$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $fb74bc6f62fb4035$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $fb74bc6f62fb4035$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $fb74bc6f62fb4035$var$tl.findFiberByHostInstance || $fb74bc6f62fb4035$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $fb74bc6f62fb4035$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$fb74bc6f62fb4035$var$vl.isDisabled && $fb74bc6f62fb4035$var$vl.supportsFiber) try {
        $fb74bc6f62fb4035$var$kc = $fb74bc6f62fb4035$var$vl.inject($fb74bc6f62fb4035$var$ul), $fb74bc6f62fb4035$var$lc = $fb74bc6f62fb4035$var$vl;
    } catch (a) {}
}
$fb74bc6f62fb4035$export$ae55be85d98224ed = $fb74bc6f62fb4035$var$sl;
$fb74bc6f62fb4035$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$fb74bc6f62fb4035$var$nl(b)) throw Error($fb74bc6f62fb4035$var$p(200));
    return $fb74bc6f62fb4035$var$cl(a, b, null, c);
};
$fb74bc6f62fb4035$export$882461b6382ed46c = function(a, b) {
    if (!$fb74bc6f62fb4035$var$nl(a)) throw Error($fb74bc6f62fb4035$var$p(299));
    var c = !1, d = "", e = $fb74bc6f62fb4035$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $fb74bc6f62fb4035$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$fb74bc6f62fb4035$var$uf] = b.current;
    $fb74bc6f62fb4035$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $fb74bc6f62fb4035$var$ll(b);
};
$fb74bc6f62fb4035$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($fb74bc6f62fb4035$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($fb74bc6f62fb4035$var$p(268, a));
    }
    a = $fb74bc6f62fb4035$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$fb74bc6f62fb4035$export$cd75ccfd720a3cd4 = function(a) {
    return $fb74bc6f62fb4035$var$Rk(a);
};
$fb74bc6f62fb4035$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$fb74bc6f62fb4035$var$ol(b)) throw Error($fb74bc6f62fb4035$var$p(200));
    return $fb74bc6f62fb4035$var$rl(null, a, b, !0, c);
};
$fb74bc6f62fb4035$export$757ceba2d55c277e = function(a, b, c) {
    if (!$fb74bc6f62fb4035$var$nl(a)) throw Error($fb74bc6f62fb4035$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $fb74bc6f62fb4035$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $fb74bc6f62fb4035$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$fb74bc6f62fb4035$var$uf] = b.current;
    $fb74bc6f62fb4035$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $fb74bc6f62fb4035$var$ml(b);
};
$fb74bc6f62fb4035$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$fb74bc6f62fb4035$var$ol(b)) throw Error($fb74bc6f62fb4035$var$p(200));
    return $fb74bc6f62fb4035$var$rl(null, a, b, !1, c);
};
$fb74bc6f62fb4035$export$502457920280e6be = function(a) {
    if (!$fb74bc6f62fb4035$var$ol(a)) throw Error($fb74bc6f62fb4035$var$p(40));
    return a._reactRootContainer ? ($fb74bc6f62fb4035$var$Rk(function() {
        $fb74bc6f62fb4035$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$fb74bc6f62fb4035$var$uf] = null;
        });
    }), !0) : !1;
};
$fb74bc6f62fb4035$export$c78a37762a8d58e1 = $fb74bc6f62fb4035$var$Qk;
$fb74bc6f62fb4035$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$fb74bc6f62fb4035$var$ol(c)) throw Error($fb74bc6f62fb4035$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($fb74bc6f62fb4035$var$p(38));
    return $fb74bc6f62fb4035$var$rl(a, b, c, !1, d);
};
$fb74bc6f62fb4035$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("6S2nq", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6ARwd"));

});
parcelRegister("6ARwd", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $4ccf9e8fffa0fa84$export$c4744153514ff05d; }, function (v) { return $4ccf9e8fffa0fa84$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $4ccf9e8fffa0fa84$export$3e506c1ccc9cc1a7; }, function (v) { return $4ccf9e8fffa0fa84$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $4ccf9e8fffa0fa84$export$e26fe2ed2fa76875; }, function (v) { return $4ccf9e8fffa0fa84$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $4ccf9e8fffa0fa84$export$502329bbf4b505b1; }, function (v) { return $4ccf9e8fffa0fa84$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $4ccf9e8fffa0fa84$export$6e3807111c4874c4; }, function (v) { return $4ccf9e8fffa0fa84$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $4ccf9e8fffa0fa84$export$c27134553091fb3a; }, function (v) { return $4ccf9e8fffa0fa84$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $4ccf9e8fffa0fa84$export$33ee1acdc04fd2a2; }, function (v) { return $4ccf9e8fffa0fa84$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $4ccf9e8fffa0fa84$export$b00a404bbd5edef2; }, function (v) { return $4ccf9e8fffa0fa84$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $4ccf9e8fffa0fa84$export$8352ce38b91d0c62; }, function (v) { return $4ccf9e8fffa0fa84$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $4ccf9e8fffa0fa84$export$d66a1c1c77bd778b; }, function (v) { return $4ccf9e8fffa0fa84$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $4ccf9e8fffa0fa84$export$d3dfb8e4810cb555; }, function (v) { return $4ccf9e8fffa0fa84$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $4ccf9e8fffa0fa84$export$839f9183b0465a69; }, function (v) { return $4ccf9e8fffa0fa84$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $4ccf9e8fffa0fa84$export$72fdf0e06517287b; }, function (v) { return $4ccf9e8fffa0fa84$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $4ccf9e8fffa0fa84$export$4b844e58a3e414b4; }, function (v) { return $4ccf9e8fffa0fa84$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $4ccf9e8fffa0fa84$export$816d2913ae6b83b1; }, function (v) { return $4ccf9e8fffa0fa84$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $4ccf9e8fffa0fa84$export$61bcfe829111a1d0; }, function (v) { return $4ccf9e8fffa0fa84$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $4ccf9e8fffa0fa84$export$7ee8c9beb337bc3f; }, function (v) { return $4ccf9e8fffa0fa84$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $4ccf9e8fffa0fa84$export$b5836b71941fa3ed; }, function (v) { return $4ccf9e8fffa0fa84$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $4ccf9e8fffa0fa84$export$cf845f2c119da08a; }, function (v) { return $4ccf9e8fffa0fa84$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4ccf9e8fffa0fa84$export$c4744153514ff05d;
var $4ccf9e8fffa0fa84$export$3e506c1ccc9cc1a7;
var $4ccf9e8fffa0fa84$export$e26fe2ed2fa76875;
var $4ccf9e8fffa0fa84$export$502329bbf4b505b1;
var $4ccf9e8fffa0fa84$export$6e3807111c4874c4;
var $4ccf9e8fffa0fa84$export$c27134553091fb3a;
var $4ccf9e8fffa0fa84$export$33ee1acdc04fd2a2;
var $4ccf9e8fffa0fa84$export$b00a404bbd5edef2;
var $4ccf9e8fffa0fa84$export$8352ce38b91d0c62;
var $4ccf9e8fffa0fa84$export$d66a1c1c77bd778b;
var $4ccf9e8fffa0fa84$export$d3dfb8e4810cb555;
var $4ccf9e8fffa0fa84$export$839f9183b0465a69;
var $4ccf9e8fffa0fa84$export$72fdf0e06517287b;
var $4ccf9e8fffa0fa84$export$4b844e58a3e414b4;
var $4ccf9e8fffa0fa84$export$816d2913ae6b83b1;
var $4ccf9e8fffa0fa84$export$61bcfe829111a1d0;
var $4ccf9e8fffa0fa84$export$7ee8c9beb337bc3f;
var $4ccf9e8fffa0fa84$export$b5836b71941fa3ed;
var $4ccf9e8fffa0fa84$export$cf845f2c119da08a;
"use strict";
function $4ccf9e8fffa0fa84$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $4ccf9e8fffa0fa84$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $4ccf9e8fffa0fa84$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $4ccf9e8fffa0fa84$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $4ccf9e8fffa0fa84$var$g(C, c)) n < e && 0 > $4ccf9e8fffa0fa84$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $4ccf9e8fffa0fa84$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $4ccf9e8fffa0fa84$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $4ccf9e8fffa0fa84$var$l = performance;
    $4ccf9e8fffa0fa84$export$c4744153514ff05d = function() {
        return $4ccf9e8fffa0fa84$var$l.now();
    };
} else {
    var $4ccf9e8fffa0fa84$var$p = Date, $4ccf9e8fffa0fa84$var$q = $4ccf9e8fffa0fa84$var$p.now();
    $4ccf9e8fffa0fa84$export$c4744153514ff05d = function() {
        return $4ccf9e8fffa0fa84$var$p.now() - $4ccf9e8fffa0fa84$var$q;
    };
}
var $4ccf9e8fffa0fa84$var$r = [], $4ccf9e8fffa0fa84$var$t = [], $4ccf9e8fffa0fa84$var$u = 1, $4ccf9e8fffa0fa84$var$v = null, $4ccf9e8fffa0fa84$var$y = 3, $4ccf9e8fffa0fa84$var$z = !1, $4ccf9e8fffa0fa84$var$A = !1, $4ccf9e8fffa0fa84$var$B = !1, $4ccf9e8fffa0fa84$var$D = "function" === typeof setTimeout ? setTimeout : null, $4ccf9e8fffa0fa84$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $4ccf9e8fffa0fa84$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $4ccf9e8fffa0fa84$var$G(a) {
    for(var b = $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$t); null !== b;){
        if (null === b.callback) $4ccf9e8fffa0fa84$var$k($4ccf9e8fffa0fa84$var$t);
        else if (b.startTime <= a) $4ccf9e8fffa0fa84$var$k($4ccf9e8fffa0fa84$var$t), b.sortIndex = b.expirationTime, $4ccf9e8fffa0fa84$var$f($4ccf9e8fffa0fa84$var$r, b);
        else break;
        b = $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$t);
    }
}
function $4ccf9e8fffa0fa84$var$H(a) {
    $4ccf9e8fffa0fa84$var$B = !1;
    $4ccf9e8fffa0fa84$var$G(a);
    if (!$4ccf9e8fffa0fa84$var$A) {
        if (null !== $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$r)) $4ccf9e8fffa0fa84$var$A = !0, $4ccf9e8fffa0fa84$var$I($4ccf9e8fffa0fa84$var$J);
        else {
            var b = $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$t);
            null !== b && $4ccf9e8fffa0fa84$var$K($4ccf9e8fffa0fa84$var$H, b.startTime - a);
        }
    }
}
function $4ccf9e8fffa0fa84$var$J(a, b) {
    $4ccf9e8fffa0fa84$var$A = !1;
    $4ccf9e8fffa0fa84$var$B && ($4ccf9e8fffa0fa84$var$B = !1, $4ccf9e8fffa0fa84$var$E($4ccf9e8fffa0fa84$var$L), $4ccf9e8fffa0fa84$var$L = -1);
    $4ccf9e8fffa0fa84$var$z = !0;
    var c = $4ccf9e8fffa0fa84$var$y;
    try {
        $4ccf9e8fffa0fa84$var$G(b);
        for($4ccf9e8fffa0fa84$var$v = $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$r); null !== $4ccf9e8fffa0fa84$var$v && (!($4ccf9e8fffa0fa84$var$v.expirationTime > b) || a && !$4ccf9e8fffa0fa84$var$M());){
            var d = $4ccf9e8fffa0fa84$var$v.callback;
            if ("function" === typeof d) {
                $4ccf9e8fffa0fa84$var$v.callback = null;
                $4ccf9e8fffa0fa84$var$y = $4ccf9e8fffa0fa84$var$v.priorityLevel;
                var e = d($4ccf9e8fffa0fa84$var$v.expirationTime <= b);
                b = $4ccf9e8fffa0fa84$export$c4744153514ff05d();
                "function" === typeof e ? $4ccf9e8fffa0fa84$var$v.callback = e : $4ccf9e8fffa0fa84$var$v === $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$r) && $4ccf9e8fffa0fa84$var$k($4ccf9e8fffa0fa84$var$r);
                $4ccf9e8fffa0fa84$var$G(b);
            } else $4ccf9e8fffa0fa84$var$k($4ccf9e8fffa0fa84$var$r);
            $4ccf9e8fffa0fa84$var$v = $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$r);
        }
        if (null !== $4ccf9e8fffa0fa84$var$v) var w = !0;
        else {
            var m = $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$t);
            null !== m && $4ccf9e8fffa0fa84$var$K($4ccf9e8fffa0fa84$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $4ccf9e8fffa0fa84$var$v = null, $4ccf9e8fffa0fa84$var$y = c, $4ccf9e8fffa0fa84$var$z = !1;
    }
}
var $4ccf9e8fffa0fa84$var$N = !1, $4ccf9e8fffa0fa84$var$O = null, $4ccf9e8fffa0fa84$var$L = -1, $4ccf9e8fffa0fa84$var$P = 5, $4ccf9e8fffa0fa84$var$Q = -1;
function $4ccf9e8fffa0fa84$var$M() {
    return $4ccf9e8fffa0fa84$export$c4744153514ff05d() - $4ccf9e8fffa0fa84$var$Q < $4ccf9e8fffa0fa84$var$P ? !1 : !0;
}
function $4ccf9e8fffa0fa84$var$R() {
    if (null !== $4ccf9e8fffa0fa84$var$O) {
        var a = $4ccf9e8fffa0fa84$export$c4744153514ff05d();
        $4ccf9e8fffa0fa84$var$Q = a;
        var b = !0;
        try {
            b = $4ccf9e8fffa0fa84$var$O(!0, a);
        } finally{
            b ? $4ccf9e8fffa0fa84$var$S() : ($4ccf9e8fffa0fa84$var$N = !1, $4ccf9e8fffa0fa84$var$O = null);
        }
    } else $4ccf9e8fffa0fa84$var$N = !1;
}
var $4ccf9e8fffa0fa84$var$S;
if ("function" === typeof $4ccf9e8fffa0fa84$var$F) $4ccf9e8fffa0fa84$var$S = function() {
    $4ccf9e8fffa0fa84$var$F($4ccf9e8fffa0fa84$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $4ccf9e8fffa0fa84$var$T = new MessageChannel, $4ccf9e8fffa0fa84$var$U = $4ccf9e8fffa0fa84$var$T.port2;
    $4ccf9e8fffa0fa84$var$T.port1.onmessage = $4ccf9e8fffa0fa84$var$R;
    $4ccf9e8fffa0fa84$var$S = function() {
        $4ccf9e8fffa0fa84$var$U.postMessage(null);
    };
} else $4ccf9e8fffa0fa84$var$S = function() {
    $4ccf9e8fffa0fa84$var$D($4ccf9e8fffa0fa84$var$R, 0);
};
function $4ccf9e8fffa0fa84$var$I(a) {
    $4ccf9e8fffa0fa84$var$O = a;
    $4ccf9e8fffa0fa84$var$N || ($4ccf9e8fffa0fa84$var$N = !0, $4ccf9e8fffa0fa84$var$S());
}
function $4ccf9e8fffa0fa84$var$K(a, b) {
    $4ccf9e8fffa0fa84$var$L = $4ccf9e8fffa0fa84$var$D(function() {
        a($4ccf9e8fffa0fa84$export$c4744153514ff05d());
    }, b);
}
$4ccf9e8fffa0fa84$export$3e506c1ccc9cc1a7 = 5;
$4ccf9e8fffa0fa84$export$e26fe2ed2fa76875 = 1;
$4ccf9e8fffa0fa84$export$502329bbf4b505b1 = 4;
$4ccf9e8fffa0fa84$export$6e3807111c4874c4 = 3;
$4ccf9e8fffa0fa84$export$c27134553091fb3a = null;
$4ccf9e8fffa0fa84$export$33ee1acdc04fd2a2 = 2;
$4ccf9e8fffa0fa84$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$4ccf9e8fffa0fa84$export$8352ce38b91d0c62 = function() {
    $4ccf9e8fffa0fa84$var$A || $4ccf9e8fffa0fa84$var$z || ($4ccf9e8fffa0fa84$var$A = !0, $4ccf9e8fffa0fa84$var$I($4ccf9e8fffa0fa84$var$J));
};
$4ccf9e8fffa0fa84$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $4ccf9e8fffa0fa84$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$4ccf9e8fffa0fa84$export$d3dfb8e4810cb555 = function() {
    return $4ccf9e8fffa0fa84$var$y;
};
$4ccf9e8fffa0fa84$export$839f9183b0465a69 = function() {
    return $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$r);
};
$4ccf9e8fffa0fa84$export$72fdf0e06517287b = function(a) {
    switch($4ccf9e8fffa0fa84$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $4ccf9e8fffa0fa84$var$y;
    }
    var c = $4ccf9e8fffa0fa84$var$y;
    $4ccf9e8fffa0fa84$var$y = b;
    try {
        return a();
    } finally{
        $4ccf9e8fffa0fa84$var$y = c;
    }
};
$4ccf9e8fffa0fa84$export$4b844e58a3e414b4 = function() {};
$4ccf9e8fffa0fa84$export$816d2913ae6b83b1 = function() {};
$4ccf9e8fffa0fa84$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $4ccf9e8fffa0fa84$var$y;
    $4ccf9e8fffa0fa84$var$y = a;
    try {
        return b();
    } finally{
        $4ccf9e8fffa0fa84$var$y = c;
    }
};
$4ccf9e8fffa0fa84$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $4ccf9e8fffa0fa84$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $4ccf9e8fffa0fa84$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $4ccf9e8fffa0fa84$var$f($4ccf9e8fffa0fa84$var$t, a), null === $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$r) && a === $4ccf9e8fffa0fa84$var$h($4ccf9e8fffa0fa84$var$t) && ($4ccf9e8fffa0fa84$var$B ? ($4ccf9e8fffa0fa84$var$E($4ccf9e8fffa0fa84$var$L), $4ccf9e8fffa0fa84$var$L = -1) : $4ccf9e8fffa0fa84$var$B = !0, $4ccf9e8fffa0fa84$var$K($4ccf9e8fffa0fa84$var$H, c - d))) : (a.sortIndex = e, $4ccf9e8fffa0fa84$var$f($4ccf9e8fffa0fa84$var$r, a), $4ccf9e8fffa0fa84$var$A || $4ccf9e8fffa0fa84$var$z || ($4ccf9e8fffa0fa84$var$A = !0, $4ccf9e8fffa0fa84$var$I($4ccf9e8fffa0fa84$var$J)));
    return a;
};
$4ccf9e8fffa0fa84$export$b5836b71941fa3ed = $4ccf9e8fffa0fa84$var$M;
$4ccf9e8fffa0fa84$export$cf845f2c119da08a = function(a) {
    var b = $4ccf9e8fffa0fa84$var$y;
    return function() {
        var c = $4ccf9e8fffa0fa84$var$y;
        $4ccf9e8fffa0fa84$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $4ccf9e8fffa0fa84$var$y = c;
        }
    };
};

});




parcelRegister("2jEfy", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $1afc93e7ad661c6f$export$306c0aa65ff9ec16; }, function (v) { return $1afc93e7ad661c6f$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1afc93e7ad661c6f$export$306c0aa65ff9ec16;
"use strict";

var $8ZuGG = parcelRequire("8ZuGG");
function $1afc93e7ad661c6f$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1afc93e7ad661c6f$var$k = "function" === typeof Object.is ? Object.is : $1afc93e7ad661c6f$var$h, $1afc93e7ad661c6f$var$l = $8ZuGG.useState, $1afc93e7ad661c6f$var$m = $8ZuGG.useEffect, $1afc93e7ad661c6f$var$n = $8ZuGG.useLayoutEffect, $1afc93e7ad661c6f$var$p = $8ZuGG.useDebugValue;
function $1afc93e7ad661c6f$var$q(a, b) {
    var d = b(), f = $1afc93e7ad661c6f$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $1afc93e7ad661c6f$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $1afc93e7ad661c6f$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $1afc93e7ad661c6f$var$m(function() {
        $1afc93e7ad661c6f$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $1afc93e7ad661c6f$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $1afc93e7ad661c6f$var$p(d);
    return d;
}
function $1afc93e7ad661c6f$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$1afc93e7ad661c6f$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $1afc93e7ad661c6f$var$t(a, b) {
    return b();
}
var $1afc93e7ad661c6f$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $1afc93e7ad661c6f$var$t : $1afc93e7ad661c6f$var$q;
$1afc93e7ad661c6f$export$306c0aa65ff9ec16 = void 0 !== $8ZuGG.useSyncExternalStore ? $8ZuGG.useSyncExternalStore : $1afc93e7ad661c6f$var$u;

});

parcelRegister("hi0mu", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $c96465ee8dcba95d$export$bf730a2d8bf68b42; }, function (v) { return $c96465ee8dcba95d$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c96465ee8dcba95d$export$bf730a2d8bf68b42;
"use strict";

var $8ZuGG = parcelRequire("8ZuGG");

var $hU7R8 = parcelRequire("hU7R8");
function $c96465ee8dcba95d$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c96465ee8dcba95d$var$q = "function" === typeof Object.is ? Object.is : $c96465ee8dcba95d$var$p, $c96465ee8dcba95d$var$r = $hU7R8.useSyncExternalStore, $c96465ee8dcba95d$var$t = $8ZuGG.useRef, $c96465ee8dcba95d$var$u = $8ZuGG.useEffect, $c96465ee8dcba95d$var$v = $8ZuGG.useMemo, $c96465ee8dcba95d$var$w = $8ZuGG.useDebugValue;
$c96465ee8dcba95d$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $c96465ee8dcba95d$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $c96465ee8dcba95d$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($c96465ee8dcba95d$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $c96465ee8dcba95d$var$r(a, c[0], c[1]);
    $c96465ee8dcba95d$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $c96465ee8dcba95d$var$w(d);
    return d;
};

});
parcelRegister("hU7R8", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2jEfy"));

});


parcelRegister("6vRlT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bdf05f220c62599$export$2e2bcd8739ae039; });
function $4bdf05f220c62599$export$2e2bcd8739ae039() {
    return $4bdf05f220c62599$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $4bdf05f220c62599$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("4KVmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3767f35f1676fd22$export$2e2bcd8739ae039; });
function $3767f35f1676fd22$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("fiQA5", function(module, exports) {
"use strict";

var $jVaIk = parcelRequire("jVaIk");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $b24152f370f6b99c$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $b24152f370f6b99c$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $b24152f370f6b99c$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $b24152f370f6b99c$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $b24152f370f6b99c$var$TYPE_STATICS = {};
$b24152f370f6b99c$var$TYPE_STATICS[$jVaIk.ForwardRef] = $b24152f370f6b99c$var$FORWARD_REF_STATICS;
$b24152f370f6b99c$var$TYPE_STATICS[$jVaIk.Memo] = $b24152f370f6b99c$var$MEMO_STATICS;
function $b24152f370f6b99c$var$getStatics(component) {
    // React v16.11 and below
    if ($jVaIk.isMemo(component)) return $b24152f370f6b99c$var$MEMO_STATICS;
     // React v16.12 and above
    return $b24152f370f6b99c$var$TYPE_STATICS[component["$$typeof"]] || $b24152f370f6b99c$var$REACT_STATICS;
}
var $b24152f370f6b99c$var$defineProperty = Object.defineProperty;
var $b24152f370f6b99c$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $b24152f370f6b99c$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $b24152f370f6b99c$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $b24152f370f6b99c$var$getPrototypeOf = Object.getPrototypeOf;
var $b24152f370f6b99c$var$objectPrototype = Object.prototype;
function $b24152f370f6b99c$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($b24152f370f6b99c$var$objectPrototype) {
            var inheritedComponent = $b24152f370f6b99c$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $b24152f370f6b99c$var$objectPrototype) $b24152f370f6b99c$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $b24152f370f6b99c$var$getOwnPropertyNames(sourceComponent);
        if ($b24152f370f6b99c$var$getOwnPropertySymbols) keys = keys.concat($b24152f370f6b99c$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $b24152f370f6b99c$var$getStatics(targetComponent);
        var sourceStatics = $b24152f370f6b99c$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$b24152f370f6b99c$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $b24152f370f6b99c$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $b24152f370f6b99c$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $b24152f370f6b99c$var$hoistNonReactStatics;

});
parcelRegister("jVaIk", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9pvYU"));

});
parcelRegister("9pvYU", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $6d9f41aefe39a81e$export$2b8d127b894957b9; }, function (v) { return $6d9f41aefe39a81e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $6d9f41aefe39a81e$export$cea3a54a6425200c; }, function (v) { return $6d9f41aefe39a81e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $6d9f41aefe39a81e$export$a7c73072b1a182ae; }, function (v) { return $6d9f41aefe39a81e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $6d9f41aefe39a81e$export$9f27bc3417b4524d; }, function (v) { return $6d9f41aefe39a81e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $6d9f41aefe39a81e$export$db77ccec0bb4ccac; }, function (v) { return $6d9f41aefe39a81e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $6d9f41aefe39a81e$export$8392c0c9d3dcbd35; }, function (v) { return $6d9f41aefe39a81e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $6d9f41aefe39a81e$export$ffb0004e005737fa; }, function (v) { return $6d9f41aefe39a81e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $6d9f41aefe39a81e$export$b624eff549462981; }, function (v) { return $6d9f41aefe39a81e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $6d9f41aefe39a81e$export$7897aa7841a5380c; }, function (v) { return $6d9f41aefe39a81e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $6d9f41aefe39a81e$export$602eac185826482c; }, function (v) { return $6d9f41aefe39a81e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $6d9f41aefe39a81e$export$e2c29f18771995cb; }, function (v) { return $6d9f41aefe39a81e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $6d9f41aefe39a81e$export$5f8d39834fd61797; }, function (v) { return $6d9f41aefe39a81e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $6d9f41aefe39a81e$export$74bf444e3cd11ea5; }, function (v) { return $6d9f41aefe39a81e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $6d9f41aefe39a81e$export$92387174baf9b227; }, function (v) { return $6d9f41aefe39a81e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $6d9f41aefe39a81e$export$ec112efeb987d9c6; }, function (v) { return $6d9f41aefe39a81e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $6d9f41aefe39a81e$export$b706b080d889d2c9; }, function (v) { return $6d9f41aefe39a81e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $6d9f41aefe39a81e$export$5be5a87408f70ddc; }, function (v) { return $6d9f41aefe39a81e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $6d9f41aefe39a81e$export$45a5e7f76e0caa8d; }, function (v) { return $6d9f41aefe39a81e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $6d9f41aefe39a81e$export$455c2e768291efa6; }, function (v) { return $6d9f41aefe39a81e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $6d9f41aefe39a81e$export$9522e17588c12572; }, function (v) { return $6d9f41aefe39a81e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $6d9f41aefe39a81e$export$2110ac352bb060b9; }, function (v) { return $6d9f41aefe39a81e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $6d9f41aefe39a81e$export$56885ab8b9c456ab; }, function (v) { return $6d9f41aefe39a81e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $6d9f41aefe39a81e$export$d927fcb6adf8f9de; }, function (v) { return $6d9f41aefe39a81e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $6d9f41aefe39a81e$export$b82d16f27459e05a; }, function (v) { return $6d9f41aefe39a81e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $6d9f41aefe39a81e$export$522c17b4f5e123e8; }, function (v) { return $6d9f41aefe39a81e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $6d9f41aefe39a81e$export$1aabd8a0274ecfd6; }, function (v) { return $6d9f41aefe39a81e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $6d9f41aefe39a81e$export$9b621391a187a31a; }, function (v) { return $6d9f41aefe39a81e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $6d9f41aefe39a81e$export$f5bbd400c2f4426f; }, function (v) { return $6d9f41aefe39a81e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6d9f41aefe39a81e$export$2b8d127b894957b9;
var $6d9f41aefe39a81e$export$cea3a54a6425200c;
var $6d9f41aefe39a81e$export$a7c73072b1a182ae;
var $6d9f41aefe39a81e$export$9f27bc3417b4524d;
var $6d9f41aefe39a81e$export$db77ccec0bb4ccac;
var $6d9f41aefe39a81e$export$8392c0c9d3dcbd35;
var $6d9f41aefe39a81e$export$ffb0004e005737fa;
var $6d9f41aefe39a81e$export$b624eff549462981;
var $6d9f41aefe39a81e$export$7897aa7841a5380c;
var $6d9f41aefe39a81e$export$602eac185826482c;
var $6d9f41aefe39a81e$export$e2c29f18771995cb;
var $6d9f41aefe39a81e$export$5f8d39834fd61797;
var $6d9f41aefe39a81e$export$74bf444e3cd11ea5;
var $6d9f41aefe39a81e$export$92387174baf9b227;
var $6d9f41aefe39a81e$export$ec112efeb987d9c6;
var $6d9f41aefe39a81e$export$b706b080d889d2c9;
var $6d9f41aefe39a81e$export$5be5a87408f70ddc;
var $6d9f41aefe39a81e$export$45a5e7f76e0caa8d;
var $6d9f41aefe39a81e$export$455c2e768291efa6;
var $6d9f41aefe39a81e$export$9522e17588c12572;
var $6d9f41aefe39a81e$export$2110ac352bb060b9;
var $6d9f41aefe39a81e$export$56885ab8b9c456ab;
var $6d9f41aefe39a81e$export$d927fcb6adf8f9de;
var $6d9f41aefe39a81e$export$b82d16f27459e05a;
var $6d9f41aefe39a81e$export$522c17b4f5e123e8;
var $6d9f41aefe39a81e$export$1aabd8a0274ecfd6;
var $6d9f41aefe39a81e$export$9b621391a187a31a;
var $6d9f41aefe39a81e$export$f5bbd400c2f4426f;
"use strict";
var $6d9f41aefe39a81e$var$b = "function" === typeof Symbol && Symbol.for, $6d9f41aefe39a81e$var$c = $6d9f41aefe39a81e$var$b ? Symbol.for("react.element") : 60103, $6d9f41aefe39a81e$var$d = $6d9f41aefe39a81e$var$b ? Symbol.for("react.portal") : 60106, $6d9f41aefe39a81e$var$e = $6d9f41aefe39a81e$var$b ? Symbol.for("react.fragment") : 60107, $6d9f41aefe39a81e$var$f = $6d9f41aefe39a81e$var$b ? Symbol.for("react.strict_mode") : 60108, $6d9f41aefe39a81e$var$g = $6d9f41aefe39a81e$var$b ? Symbol.for("react.profiler") : 60114, $6d9f41aefe39a81e$var$h = $6d9f41aefe39a81e$var$b ? Symbol.for("react.provider") : 60109, $6d9f41aefe39a81e$var$k = $6d9f41aefe39a81e$var$b ? Symbol.for("react.context") : 60110, $6d9f41aefe39a81e$var$l = $6d9f41aefe39a81e$var$b ? Symbol.for("react.async_mode") : 60111, $6d9f41aefe39a81e$var$m = $6d9f41aefe39a81e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6d9f41aefe39a81e$var$n = $6d9f41aefe39a81e$var$b ? Symbol.for("react.forward_ref") : 60112, $6d9f41aefe39a81e$var$p = $6d9f41aefe39a81e$var$b ? Symbol.for("react.suspense") : 60113, $6d9f41aefe39a81e$var$q = $6d9f41aefe39a81e$var$b ? Symbol.for("react.suspense_list") : 60120, $6d9f41aefe39a81e$var$r = $6d9f41aefe39a81e$var$b ? Symbol.for("react.memo") : 60115, $6d9f41aefe39a81e$var$t = $6d9f41aefe39a81e$var$b ? Symbol.for("react.lazy") : 60116, $6d9f41aefe39a81e$var$v = $6d9f41aefe39a81e$var$b ? Symbol.for("react.block") : 60121, $6d9f41aefe39a81e$var$w = $6d9f41aefe39a81e$var$b ? Symbol.for("react.fundamental") : 60117, $6d9f41aefe39a81e$var$x = $6d9f41aefe39a81e$var$b ? Symbol.for("react.responder") : 60118, $6d9f41aefe39a81e$var$y = $6d9f41aefe39a81e$var$b ? Symbol.for("react.scope") : 60119;
function $6d9f41aefe39a81e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6d9f41aefe39a81e$var$c:
                switch(a = a.type, a){
                    case $6d9f41aefe39a81e$var$l:
                    case $6d9f41aefe39a81e$var$m:
                    case $6d9f41aefe39a81e$var$e:
                    case $6d9f41aefe39a81e$var$g:
                    case $6d9f41aefe39a81e$var$f:
                    case $6d9f41aefe39a81e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6d9f41aefe39a81e$var$k:
                            case $6d9f41aefe39a81e$var$n:
                            case $6d9f41aefe39a81e$var$t:
                            case $6d9f41aefe39a81e$var$r:
                            case $6d9f41aefe39a81e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6d9f41aefe39a81e$var$d:
                return u;
        }
    }
}
function $6d9f41aefe39a81e$var$A(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$m;
}
$6d9f41aefe39a81e$export$2b8d127b894957b9 = $6d9f41aefe39a81e$var$l;
$6d9f41aefe39a81e$export$cea3a54a6425200c = $6d9f41aefe39a81e$var$m;
$6d9f41aefe39a81e$export$a7c73072b1a182ae = $6d9f41aefe39a81e$var$k;
$6d9f41aefe39a81e$export$9f27bc3417b4524d = $6d9f41aefe39a81e$var$h;
$6d9f41aefe39a81e$export$db77ccec0bb4ccac = $6d9f41aefe39a81e$var$c;
$6d9f41aefe39a81e$export$8392c0c9d3dcbd35 = $6d9f41aefe39a81e$var$n;
$6d9f41aefe39a81e$export$ffb0004e005737fa = $6d9f41aefe39a81e$var$e;
$6d9f41aefe39a81e$export$b624eff549462981 = $6d9f41aefe39a81e$var$t;
$6d9f41aefe39a81e$export$7897aa7841a5380c = $6d9f41aefe39a81e$var$r;
$6d9f41aefe39a81e$export$602eac185826482c = $6d9f41aefe39a81e$var$d;
$6d9f41aefe39a81e$export$e2c29f18771995cb = $6d9f41aefe39a81e$var$g;
$6d9f41aefe39a81e$export$5f8d39834fd61797 = $6d9f41aefe39a81e$var$f;
$6d9f41aefe39a81e$export$74bf444e3cd11ea5 = $6d9f41aefe39a81e$var$p;
$6d9f41aefe39a81e$export$92387174baf9b227 = function(a) {
    return $6d9f41aefe39a81e$var$A(a) || $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$l;
};
$6d9f41aefe39a81e$export$ec112efeb987d9c6 = $6d9f41aefe39a81e$var$A;
$6d9f41aefe39a81e$export$b706b080d889d2c9 = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$k;
};
$6d9f41aefe39a81e$export$5be5a87408f70ddc = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$h;
};
$6d9f41aefe39a81e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6d9f41aefe39a81e$var$c;
};
$6d9f41aefe39a81e$export$455c2e768291efa6 = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$n;
};
$6d9f41aefe39a81e$export$9522e17588c12572 = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$e;
};
$6d9f41aefe39a81e$export$2110ac352bb060b9 = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$t;
};
$6d9f41aefe39a81e$export$56885ab8b9c456ab = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$r;
};
$6d9f41aefe39a81e$export$d927fcb6adf8f9de = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$d;
};
$6d9f41aefe39a81e$export$b82d16f27459e05a = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$g;
};
$6d9f41aefe39a81e$export$522c17b4f5e123e8 = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$f;
};
$6d9f41aefe39a81e$export$1aabd8a0274ecfd6 = function(a) {
    return $6d9f41aefe39a81e$var$z(a) === $6d9f41aefe39a81e$var$p;
};
$6d9f41aefe39a81e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6d9f41aefe39a81e$var$e || a === $6d9f41aefe39a81e$var$m || a === $6d9f41aefe39a81e$var$g || a === $6d9f41aefe39a81e$var$f || a === $6d9f41aefe39a81e$var$p || a === $6d9f41aefe39a81e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6d9f41aefe39a81e$var$t || a.$$typeof === $6d9f41aefe39a81e$var$r || a.$$typeof === $6d9f41aefe39a81e$var$h || a.$$typeof === $6d9f41aefe39a81e$var$k || a.$$typeof === $6d9f41aefe39a81e$var$n || a.$$typeof === $6d9f41aefe39a81e$var$w || a.$$typeof === $6d9f41aefe39a81e$var$x || a.$$typeof === $6d9f41aefe39a81e$var$y || a.$$typeof === $6d9f41aefe39a81e$var$v);
};
$6d9f41aefe39a81e$export$f5bbd400c2f4426f = $6d9f41aefe39a81e$var$z;

});



parcelRegister("eNPsz", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $ac6d8f22d7a6dcc7$export$a7c73072b1a182ae; }, function (v) { return $ac6d8f22d7a6dcc7$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $ac6d8f22d7a6dcc7$export$9f27bc3417b4524d; }, function (v) { return $ac6d8f22d7a6dcc7$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac; }, function (v) { return $ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35; }, function (v) { return $ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $ac6d8f22d7a6dcc7$export$ffb0004e005737fa; }, function (v) { return $ac6d8f22d7a6dcc7$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $ac6d8f22d7a6dcc7$export$b624eff549462981; }, function (v) { return $ac6d8f22d7a6dcc7$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $ac6d8f22d7a6dcc7$export$7897aa7841a5380c; }, function (v) { return $ac6d8f22d7a6dcc7$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $ac6d8f22d7a6dcc7$export$602eac185826482c; }, function (v) { return $ac6d8f22d7a6dcc7$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $ac6d8f22d7a6dcc7$export$e2c29f18771995cb; }, function (v) { return $ac6d8f22d7a6dcc7$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $ac6d8f22d7a6dcc7$export$5f8d39834fd61797; }, function (v) { return $ac6d8f22d7a6dcc7$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5; }, function (v) { return $ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "SuspenseList", function () { return $ac6d8f22d7a6dcc7$export$998bcd577473dd93; }, function (v) { return $ac6d8f22d7a6dcc7$export$998bcd577473dd93 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $ac6d8f22d7a6dcc7$export$92387174baf9b227; }, function (v) { return $ac6d8f22d7a6dcc7$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $ac6d8f22d7a6dcc7$export$ec112efeb987d9c6; }, function (v) { return $ac6d8f22d7a6dcc7$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $ac6d8f22d7a6dcc7$export$b706b080d889d2c9; }, function (v) { return $ac6d8f22d7a6dcc7$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $ac6d8f22d7a6dcc7$export$5be5a87408f70ddc; }, function (v) { return $ac6d8f22d7a6dcc7$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d; }, function (v) { return $ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $ac6d8f22d7a6dcc7$export$455c2e768291efa6; }, function (v) { return $ac6d8f22d7a6dcc7$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $ac6d8f22d7a6dcc7$export$9522e17588c12572; }, function (v) { return $ac6d8f22d7a6dcc7$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $ac6d8f22d7a6dcc7$export$2110ac352bb060b9; }, function (v) { return $ac6d8f22d7a6dcc7$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $ac6d8f22d7a6dcc7$export$56885ab8b9c456ab; }, function (v) { return $ac6d8f22d7a6dcc7$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de; }, function (v) { return $ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $ac6d8f22d7a6dcc7$export$b82d16f27459e05a; }, function (v) { return $ac6d8f22d7a6dcc7$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $ac6d8f22d7a6dcc7$export$522c17b4f5e123e8; }, function (v) { return $ac6d8f22d7a6dcc7$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6; }, function (v) { return $ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isSuspenseList", function () { return $ac6d8f22d7a6dcc7$export$3d6c20d97e46b957; }, function (v) { return $ac6d8f22d7a6dcc7$export$3d6c20d97e46b957 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $ac6d8f22d7a6dcc7$export$9b621391a187a31a; }, function (v) { return $ac6d8f22d7a6dcc7$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f; }, function (v) { return $ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f = v; });
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ac6d8f22d7a6dcc7$export$a7c73072b1a182ae;
var $ac6d8f22d7a6dcc7$export$9f27bc3417b4524d;
var $ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac;
var $ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35;
var $ac6d8f22d7a6dcc7$export$ffb0004e005737fa;
var $ac6d8f22d7a6dcc7$export$b624eff549462981;
var $ac6d8f22d7a6dcc7$export$7897aa7841a5380c;
var $ac6d8f22d7a6dcc7$export$602eac185826482c;
var $ac6d8f22d7a6dcc7$export$e2c29f18771995cb;
var $ac6d8f22d7a6dcc7$export$5f8d39834fd61797;
var $ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5;
var $ac6d8f22d7a6dcc7$export$998bcd577473dd93;
var $ac6d8f22d7a6dcc7$export$92387174baf9b227;
var $ac6d8f22d7a6dcc7$export$ec112efeb987d9c6;
var $ac6d8f22d7a6dcc7$export$b706b080d889d2c9;
var $ac6d8f22d7a6dcc7$export$5be5a87408f70ddc;
var $ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d;
var $ac6d8f22d7a6dcc7$export$455c2e768291efa6;
var $ac6d8f22d7a6dcc7$export$9522e17588c12572;
var $ac6d8f22d7a6dcc7$export$2110ac352bb060b9;
var $ac6d8f22d7a6dcc7$export$56885ab8b9c456ab;
var $ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de;
var $ac6d8f22d7a6dcc7$export$b82d16f27459e05a;
var $ac6d8f22d7a6dcc7$export$522c17b4f5e123e8;
var $ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6;
var $ac6d8f22d7a6dcc7$export$3d6c20d97e46b957;
var $ac6d8f22d7a6dcc7$export$9b621391a187a31a;
var $ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f;
"use strict";
var $ac6d8f22d7a6dcc7$var$b = Symbol.for("react.element"), $ac6d8f22d7a6dcc7$var$c = Symbol.for("react.portal"), $ac6d8f22d7a6dcc7$var$d = Symbol.for("react.fragment"), $ac6d8f22d7a6dcc7$var$e = Symbol.for("react.strict_mode"), $ac6d8f22d7a6dcc7$var$f = Symbol.for("react.profiler"), $ac6d8f22d7a6dcc7$var$g = Symbol.for("react.provider"), $ac6d8f22d7a6dcc7$var$h = Symbol.for("react.context"), $ac6d8f22d7a6dcc7$var$k = Symbol.for("react.server_context"), $ac6d8f22d7a6dcc7$var$l = Symbol.for("react.forward_ref"), $ac6d8f22d7a6dcc7$var$m = Symbol.for("react.suspense"), $ac6d8f22d7a6dcc7$var$n = Symbol.for("react.suspense_list"), $ac6d8f22d7a6dcc7$var$p = Symbol.for("react.memo"), $ac6d8f22d7a6dcc7$var$q = Symbol.for("react.lazy"), $ac6d8f22d7a6dcc7$var$t = Symbol.for("react.offscreen"), $ac6d8f22d7a6dcc7$var$u;
$ac6d8f22d7a6dcc7$var$u = Symbol.for("react.module.reference");
function $ac6d8f22d7a6dcc7$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $ac6d8f22d7a6dcc7$var$b:
                switch(a = a.type, a){
                    case $ac6d8f22d7a6dcc7$var$d:
                    case $ac6d8f22d7a6dcc7$var$f:
                    case $ac6d8f22d7a6dcc7$var$e:
                    case $ac6d8f22d7a6dcc7$var$m:
                    case $ac6d8f22d7a6dcc7$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ac6d8f22d7a6dcc7$var$k:
                            case $ac6d8f22d7a6dcc7$var$h:
                            case $ac6d8f22d7a6dcc7$var$l:
                            case $ac6d8f22d7a6dcc7$var$q:
                            case $ac6d8f22d7a6dcc7$var$p:
                            case $ac6d8f22d7a6dcc7$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $ac6d8f22d7a6dcc7$var$c:
                return r;
        }
    }
}
$ac6d8f22d7a6dcc7$export$a7c73072b1a182ae = $ac6d8f22d7a6dcc7$var$h;
$ac6d8f22d7a6dcc7$export$9f27bc3417b4524d = $ac6d8f22d7a6dcc7$var$g;
$ac6d8f22d7a6dcc7$export$db77ccec0bb4ccac = $ac6d8f22d7a6dcc7$var$b;
$ac6d8f22d7a6dcc7$export$8392c0c9d3dcbd35 = $ac6d8f22d7a6dcc7$var$l;
$ac6d8f22d7a6dcc7$export$ffb0004e005737fa = $ac6d8f22d7a6dcc7$var$d;
$ac6d8f22d7a6dcc7$export$b624eff549462981 = $ac6d8f22d7a6dcc7$var$q;
$ac6d8f22d7a6dcc7$export$7897aa7841a5380c = $ac6d8f22d7a6dcc7$var$p;
$ac6d8f22d7a6dcc7$export$602eac185826482c = $ac6d8f22d7a6dcc7$var$c;
$ac6d8f22d7a6dcc7$export$e2c29f18771995cb = $ac6d8f22d7a6dcc7$var$f;
$ac6d8f22d7a6dcc7$export$5f8d39834fd61797 = $ac6d8f22d7a6dcc7$var$e;
$ac6d8f22d7a6dcc7$export$74bf444e3cd11ea5 = $ac6d8f22d7a6dcc7$var$m;
$ac6d8f22d7a6dcc7$export$998bcd577473dd93 = $ac6d8f22d7a6dcc7$var$n;
$ac6d8f22d7a6dcc7$export$92387174baf9b227 = function() {
    return !1;
};
$ac6d8f22d7a6dcc7$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ac6d8f22d7a6dcc7$export$b706b080d889d2c9 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$h;
};
$ac6d8f22d7a6dcc7$export$5be5a87408f70ddc = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$g;
};
$ac6d8f22d7a6dcc7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ac6d8f22d7a6dcc7$var$b;
};
$ac6d8f22d7a6dcc7$export$455c2e768291efa6 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$l;
};
$ac6d8f22d7a6dcc7$export$9522e17588c12572 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$d;
};
$ac6d8f22d7a6dcc7$export$2110ac352bb060b9 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$q;
};
$ac6d8f22d7a6dcc7$export$56885ab8b9c456ab = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$p;
};
$ac6d8f22d7a6dcc7$export$d927fcb6adf8f9de = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$c;
};
$ac6d8f22d7a6dcc7$export$b82d16f27459e05a = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$f;
};
$ac6d8f22d7a6dcc7$export$522c17b4f5e123e8 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$e;
};
$ac6d8f22d7a6dcc7$export$1aabd8a0274ecfd6 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$m;
};
$ac6d8f22d7a6dcc7$export$3d6c20d97e46b957 = function(a) {
    return $ac6d8f22d7a6dcc7$var$v(a) === $ac6d8f22d7a6dcc7$var$n;
};
$ac6d8f22d7a6dcc7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ac6d8f22d7a6dcc7$var$d || a === $ac6d8f22d7a6dcc7$var$f || a === $ac6d8f22d7a6dcc7$var$e || a === $ac6d8f22d7a6dcc7$var$m || a === $ac6d8f22d7a6dcc7$var$n || a === $ac6d8f22d7a6dcc7$var$t || "object" === typeof a && null !== a && (a.$$typeof === $ac6d8f22d7a6dcc7$var$q || a.$$typeof === $ac6d8f22d7a6dcc7$var$p || a.$$typeof === $ac6d8f22d7a6dcc7$var$g || a.$$typeof === $ac6d8f22d7a6dcc7$var$h || a.$$typeof === $ac6d8f22d7a6dcc7$var$l || a.$$typeof === $ac6d8f22d7a6dcc7$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$ac6d8f22d7a6dcc7$export$f5bbd400c2f4426f = $ac6d8f22d7a6dcc7$var$v;

});

parcelRegister("gyRZh", function(module, exports) {

$parcel$export(module.exports, "createSearchParams", function () { return $c0e9b31393d77828$export$a2e4e2dcc7b1f22f; });
$parcel$export(module.exports, "BrowserRouter", function () { return $c0e9b31393d77828$export$9ba4e89fdfa1fc54; });
$parcel$export(module.exports, "Link", function () { return $c0e9b31393d77828$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $c0e9b31393d77828$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("5WDNl")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("5WDNl")).useNavigate; });
/**
 * React Router DOM v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $h1d60 = parcelRequire("h1d60");

var $i7SlW = parcelRequire("i7SlW");
var $5WDNl = parcelRequire("5WDNl");

var $i7SlW = parcelRequire("i7SlW");
function $c0e9b31393d77828$var$_extends() {
    $c0e9b31393d77828$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c0e9b31393d77828$var$_extends.apply(this, arguments);
}
function $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $c0e9b31393d77828$var$defaultMethod = "get";
const $c0e9b31393d77828$var$defaultEncType = "application/x-www-form-urlencoded";
function $c0e9b31393d77828$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $c0e9b31393d77828$var$isButtonElement(object) {
    return $c0e9b31393d77828$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $c0e9b31393d77828$var$isFormElement(object) {
    return $c0e9b31393d77828$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $c0e9b31393d77828$var$isInputElement(object) {
    return $c0e9b31393d77828$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $c0e9b31393d77828$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $c0e9b31393d77828$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$c0e9b31393d77828$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $c0e9b31393d77828$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $c0e9b31393d77828$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $c0e9b31393d77828$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $c0e9b31393d77828$var$_formDataSupportsSubmitter = null;
function $c0e9b31393d77828$var$isFormDataSubmitterSupported() {
    if ($c0e9b31393d77828$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $c0e9b31393d77828$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $c0e9b31393d77828$var$_formDataSupportsSubmitter = true;
    }
    return $c0e9b31393d77828$var$_formDataSupportsSubmitter;
}
const $c0e9b31393d77828$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $c0e9b31393d77828$var$getFormEncType(encType) {
    if (encType != null && !$c0e9b31393d77828$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $c0e9b31393d77828$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($c0e9b31393d77828$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $i7SlW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || $c0e9b31393d77828$var$defaultMethod;
        encType = $c0e9b31393d77828$var$getFormEncType(target.getAttribute("enctype")) || $c0e9b31393d77828$var$defaultEncType;
        formData = new FormData(target);
    } else if ($c0e9b31393d77828$var$isButtonElement(target) || $c0e9b31393d77828$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $i7SlW.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $c0e9b31393d77828$var$defaultMethod;
        encType = $c0e9b31393d77828$var$getFormEncType(target.getAttribute("formenctype")) || $c0e9b31393d77828$var$getFormEncType(form.getAttribute("enctype")) || $c0e9b31393d77828$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$c0e9b31393d77828$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($c0e9b31393d77828$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $c0e9b31393d77828$var$defaultMethod;
        action = null;
        encType = $c0e9b31393d77828$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $c0e9b31393d77828$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $c0e9b31393d77828$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $c0e9b31393d77828$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $c0e9b31393d77828$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $c0e9b31393d77828$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $c0e9b31393d77828$export$1f3f55432a00e06d(routes, opts) {
    return (0, $i7SlW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c0e9b31393d77828$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $i7SlW.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c0e9b31393d77828$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5WDNl.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c0e9b31393d77828$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $i7SlW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $c0e9b31393d77828$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $i7SlW.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $c0e9b31393d77828$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $5WDNl.UNSAFE_mapRouteProperties),
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $c0e9b31393d77828$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $c0e9b31393d77828$var$_extends({}, state, {
        errors: $c0e9b31393d77828$var$deserializeErrors(state.errors)
    });
    return state;
}
function $c0e9b31393d77828$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $i7SlW.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $c0e9b31393d77828$export$7ad602f0e94e62d1 = /*#__PURE__*/ $8ZuGG.createContext({
    isTransitioning: false
});
const $c0e9b31393d77828$export$148fd98d095596d4 = /*#__PURE__*/ $8ZuGG.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $c0e9b31393d77828$var$START_TRANSITION = "startTransition";
const $c0e9b31393d77828$var$startTransitionImpl = $8ZuGG[$c0e9b31393d77828$var$START_TRANSITION];
const $c0e9b31393d77828$var$FLUSH_SYNC = "flushSync";
const $c0e9b31393d77828$var$flushSyncImpl = $h1d60[$c0e9b31393d77828$var$FLUSH_SYNC];
const $c0e9b31393d77828$var$USE_ID = "useId";
const $c0e9b31393d77828$var$useIdImpl = $8ZuGG[$c0e9b31393d77828$var$USE_ID];
function $c0e9b31393d77828$var$startTransitionSafe(cb) {
    if ($c0e9b31393d77828$var$startTransitionImpl) $c0e9b31393d77828$var$startTransitionImpl(cb);
    else cb();
}
function $c0e9b31393d77828$var$flushSyncSafe(cb) {
    if ($c0e9b31393d77828$var$flushSyncImpl) $c0e9b31393d77828$var$flushSyncImpl(cb);
    else cb();
}
class $c0e9b31393d77828$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $c0e9b31393d77828$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8ZuGG.useState(router.state);
    let [pendingState, setPendingState] = $8ZuGG.useState();
    let [vtContext, setVtContext] = $8ZuGG.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $8ZuGG.useState();
    let [transition, setTransition] = $8ZuGG.useState();
    let [interruption, setInterruption] = $8ZuGG.useState();
    let fetcherData = $8ZuGG.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $8ZuGG.useCallback((cb)=>{
        if (v7_startTransition) $c0e9b31393d77828$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $8ZuGG.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $c0e9b31393d77828$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $c0e9b31393d77828$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $c0e9b31393d77828$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $c0e9b31393d77828$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $c0e9b31393d77828$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8ZuGG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $8ZuGG.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $c0e9b31393d77828$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $8ZuGG.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $8ZuGG.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $8ZuGG.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $8ZuGG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8ZuGG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8ZuGG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $8ZuGG.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $c0e9b31393d77828$var$MemoizedDataRoutes = /*#__PURE__*/ $8ZuGG.memo($c0e9b31393d77828$var$DataRoutes);
function $c0e9b31393d77828$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $5WDNl.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $c0e9b31393d77828$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $8ZuGG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $i7SlW.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $c0e9b31393d77828$var$startTransitionImpl ? $c0e9b31393d77828$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $c0e9b31393d77828$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $8ZuGG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $i7SlW.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $c0e9b31393d77828$var$startTransitionImpl ? $c0e9b31393d77828$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $c0e9b31393d77828$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $c0e9b31393d77828$var$startTransitionImpl ? $c0e9b31393d77828$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement((0, $5WDNl.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $c0e9b31393d77828$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $c0e9b31393d77828$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $c0e9b31393d77828$export$a6c7ac8248d6e38a = /*#__PURE__*/ $8ZuGG.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(_ref7, $c0e9b31393d77828$var$_excluded);
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $c0e9b31393d77828$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($c0e9b31393d77828$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $i7SlW.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $5WDNl.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $c0e9b31393d77828$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $8ZuGG.createElement("a", $c0e9b31393d77828$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $c0e9b31393d77828$export$b0d92dbee9b5b60d = /*#__PURE__*/ $8ZuGG.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(_ref8, $c0e9b31393d77828$var$_excluded2);
    let path = (0, $5WDNl.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $5WDNl.useLocation)();
    let routerState = $8ZuGG.useContext((0, $5WDNl.UNSAFE_DataRouterStateContext));
    let { navigator: navigator, basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $c0e9b31393d77828$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $i7SlW.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$a6c7ac8248d6e38a, $c0e9b31393d77828$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $c0e9b31393d77828$export$a7fed597f4b8afd8 = /*#__PURE__*/ $8ZuGG.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $c0e9b31393d77828$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $c0e9b31393d77828$var$_objectWithoutPropertiesLoose(_ref9, $c0e9b31393d77828$var$_excluded3);
    let submit = $c0e9b31393d77828$export$47c85c6e3a081d3();
    let formAction = $c0e9b31393d77828$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $8ZuGG.createElement("form", $c0e9b31393d77828$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $c0e9b31393d77828$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $c0e9b31393d77828$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $c0e9b31393d77828$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($c0e9b31393d77828$var$DataRouterHook || ($c0e9b31393d77828$var$DataRouterHook = {}));
var $c0e9b31393d77828$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($c0e9b31393d77828$var$DataRouterStateHook || ($c0e9b31393d77828$var$DataRouterStateHook = {}));
// Internal hooks
function $c0e9b31393d77828$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $c0e9b31393d77828$var$useDataRouterContext(hookName) {
    let ctx = $8ZuGG.useContext((0, $5WDNl.UNSAFE_DataRouterContext));
    !ctx && (0, $i7SlW.UNSAFE_invariant)(false);
    return ctx;
}
function $c0e9b31393d77828$var$useDataRouterState(hookName) {
    let state = $8ZuGG.useContext((0, $5WDNl.UNSAFE_DataRouterStateContext));
    !state && (0, $i7SlW.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $c0e9b31393d77828$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $5WDNl.useNavigate)();
    let location = (0, $5WDNl.useLocation)();
    let path = (0, $5WDNl.useResolvedPath)(to, {
        relative: relative
    });
    return $8ZuGG.useCallback((event)=>{
        if ($c0e9b31393d77828$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $i7SlW.createPath)(location) === (0, $i7SlW.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $c0e9b31393d77828$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $8ZuGG.useRef($c0e9b31393d77828$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $8ZuGG.useRef(false);
    let location = (0, $5WDNl.useLocation)();
    let searchParams = $8ZuGG.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $c0e9b31393d77828$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $5WDNl.useNavigate)();
    let setSearchParams = $8ZuGG.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $c0e9b31393d77828$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $c0e9b31393d77828$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $c0e9b31393d77828$var$fetcherId = 0;
let $c0e9b31393d77828$var$getUniqueFetcherId = ()=>"__" + String(++$c0e9b31393d77828$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $c0e9b31393d77828$export$47c85c6e3a081d3() {
    let { router: router } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let currentRouteId = (0, $5WDNl.UNSAFE_useRouteId)();
    return $8ZuGG.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $c0e9b31393d77828$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $c0e9b31393d77828$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $c0e9b31393d77828$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $c0e9b31393d77828$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let routeContext = $8ZuGG.useContext((0, $5WDNl.UNSAFE_RouteContext));
    !routeContext && (0, $i7SlW.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $c0e9b31393d77828$var$_extends({}, (0, $5WDNl.useResolvedPath)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $5WDNl.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $i7SlW.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $i7SlW.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $c0e9b31393d77828$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.UseFetcher);
    let state = $c0e9b31393d77828$var$useDataRouterState($c0e9b31393d77828$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $8ZuGG.useContext($c0e9b31393d77828$export$148fd98d095596d4);
    let route = $8ZuGG.useContext((0, $5WDNl.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $i7SlW.UNSAFE_invariant)(false);
    !route && (0, $i7SlW.UNSAFE_invariant)(false);
    !(routeId != null) && (0, $i7SlW.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $c0e9b31393d77828$var$useIdImpl ? $c0e9b31393d77828$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $8ZuGG.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($c0e9b31393d77828$var$getUniqueFetcherId());
    // Registration/cleanup
    $8ZuGG.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $8ZuGG.useCallback((href, opts)=>{
        !routeId && (0, $i7SlW.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $c0e9b31393d77828$export$47c85c6e3a081d3();
    let submit = $8ZuGG.useCallback((target, opts)=>{
        submitImpl(target, $c0e9b31393d77828$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $8ZuGG.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $8ZuGG.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $8ZuGG.createElement($c0e9b31393d77828$export$a7fed597f4b8afd8, $c0e9b31393d77828$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $i7SlW.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $8ZuGG.useMemo(()=>$c0e9b31393d77828$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $c0e9b31393d77828$export$fa996778a3a31087() {
    let state = $c0e9b31393d77828$var$useDataRouterState($c0e9b31393d77828$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $c0e9b31393d77828$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $c0e9b31393d77828$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $c0e9b31393d77828$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $c0e9b31393d77828$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $c0e9b31393d77828$var$useDataRouterState($c0e9b31393d77828$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $8ZuGG.useContext((0, $5WDNl.UNSAFE_NavigationContext));
    let location = (0, $5WDNl.useLocation)();
    let matches = (0, $5WDNl.useMatches)();
    let navigation = (0, $5WDNl.useNavigation)();
    // Trigger manual scroll restoration while we're active
    $8ZuGG.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $c0e9b31393d77828$var$usePageHide($8ZuGG.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $c0e9b31393d77828$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $c0e9b31393d77828$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($c0e9b31393d77828$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8ZuGG.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $c0e9b31393d77828$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $c0e9b31393d77828$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8ZuGG.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($c0e9b31393d77828$var$_extends({}, location, {
                    pathname: (0, $i7SlW.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($c0e9b31393d77828$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $8ZuGG.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c0e9b31393d77828$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $8ZuGG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $c0e9b31393d77828$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $8ZuGG.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $c0e9b31393d77828$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $5WDNl.useBlocker)(when);
    $8ZuGG.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $8ZuGG.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $c0e9b31393d77828$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $8ZuGG.useContext($c0e9b31393d77828$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $i7SlW.UNSAFE_invariant)(false);
    let { basename: basename } = $c0e9b31393d77828$var$useDataRouterContext($c0e9b31393d77828$var$DataRouterHook.useViewTransitionState);
    let path = (0, $5WDNl.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $i7SlW.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $i7SlW.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $i7SlW.matchPath)(path.pathname, nextPath) != null || (0, $i7SlW.matchPath)(path.pathname, currentPath) != null;
}

});
parcelRegister("i7SlW", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $d3230ad07d4608b8$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $d3230ad07d4608b8$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $d3230ad07d4608b8$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $d3230ad07d4608b8$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $d3230ad07d4608b8$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $d3230ad07d4608b8$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $d3230ad07d4608b8$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $d3230ad07d4608b8$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $d3230ad07d4608b8$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "UNSAFE_decodePath", function () { return $d3230ad07d4608b8$export$30d21fd6d7295f52; });
$parcel$export(module.exports, "UNSAFE_convertRouteMatchToUiMatch", function () { return $d3230ad07d4608b8$export$b3fac024fad9e8ff; });
$parcel$export(module.exports, "joinPaths", function () { return $d3230ad07d4608b8$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $d3230ad07d4608b8$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getResolveToMatches", function () { return $d3230ad07d4608b8$export$a5784978eca585fa; });
$parcel$export(module.exports, "resolveTo", function () { return $d3230ad07d4608b8$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $d3230ad07d4608b8$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "UNSAFE_ErrorResponseImpl", function () { return $d3230ad07d4608b8$export$6c6580e81da25755; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $d3230ad07d4608b8$export$972111febbeef05b; });
$parcel$export(module.exports, "IDLE_FETCHER", function () { return $d3230ad07d4608b8$export$52eace9c284d3585; });
$parcel$export(module.exports, "IDLE_BLOCKER", function () { return $d3230ad07d4608b8$export$386d57f03f0b2883; });
$parcel$export(module.exports, "createRouter", function () { return $d3230ad07d4608b8$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.18.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $d3230ad07d4608b8$var$_extends() {
    $d3230ad07d4608b8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d3230ad07d4608b8$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $d3230ad07d4608b8$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($d3230ad07d4608b8$export$e19cd5f9376f8cee || ($d3230ad07d4608b8$export$e19cd5f9376f8cee = {}));
const $d3230ad07d4608b8$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $d3230ad07d4608b8$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $d3230ad07d4608b8$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $d3230ad07d4608b8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $d3230ad07d4608b8$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $d3230ad07d4608b8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to);
    }
    return $d3230ad07d4608b8$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $d3230ad07d4608b8$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $d3230ad07d4608b8$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $d3230ad07d4608b8$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $d3230ad07d4608b8$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $d3230ad07d4608b8$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $d3230ad07d4608b8$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $d3230ad07d4608b8$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $d3230ad07d4608b8$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $d3230ad07d4608b8$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $d3230ad07d4608b8$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $d3230ad07d4608b8$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $d3230ad07d4608b8$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $d3230ad07d4608b8$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $d3230ad07d4608b8$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $d3230ad07d4608b8$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($d3230ad07d4608b8$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
        let location = $d3230ad07d4608b8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $d3230ad07d4608b8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
        let location = $d3230ad07d4608b8$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $d3230ad07d4608b8$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $d3230ad07d4608b8$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $d3230ad07d4608b8$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($d3230ad07d4608b8$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($d3230ad07d4608b8$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $d3230ad07d4608b8$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($d3230ad07d4608b8$var$ResultType || ($d3230ad07d4608b8$var$ResultType = {}));
const $d3230ad07d4608b8$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $d3230ad07d4608b8$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $d3230ad07d4608b8$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $d3230ad07d4608b8$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $d3230ad07d4608b8$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($d3230ad07d4608b8$var$isIndexRoute(route)) {
            let indexRoute = $d3230ad07d4608b8$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $d3230ad07d4608b8$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $d3230ad07d4608b8$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $d3230ad07d4608b8$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $d3230ad07d4608b8$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $d3230ad07d4608b8$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $d3230ad07d4608b8$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $d3230ad07d4608b8$var$flattenRoutes(routes);
    $d3230ad07d4608b8$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $d3230ad07d4608b8$export$30d21fd6d7295f52(pathname);
        matches = $d3230ad07d4608b8$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $d3230ad07d4608b8$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $d3230ad07d4608b8$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $d3230ad07d4608b8$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $d3230ad07d4608b8$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $d3230ad07d4608b8$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $d3230ad07d4608b8$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $d3230ad07d4608b8$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $d3230ad07d4608b8$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $d3230ad07d4608b8$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $d3230ad07d4608b8$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $d3230ad07d4608b8$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $d3230ad07d4608b8$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $d3230ad07d4608b8$var$paramRe = /^:[\w-]+$/;
const $d3230ad07d4608b8$var$dynamicSegmentValue = 3;
const $d3230ad07d4608b8$var$indexRouteValue = 2;
const $d3230ad07d4608b8$var$emptySegmentValue = 1;
const $d3230ad07d4608b8$var$staticSegmentValue = 10;
const $d3230ad07d4608b8$var$splatPenalty = -2;
const $d3230ad07d4608b8$var$isSplat = (s)=>s === "*";
function $d3230ad07d4608b8$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($d3230ad07d4608b8$var$isSplat)) initialScore += $d3230ad07d4608b8$var$splatPenalty;
    if (index) initialScore += $d3230ad07d4608b8$var$indexRouteValue;
    return segments.filter((s)=>!$d3230ad07d4608b8$var$isSplat(s)).reduce((score, segment)=>score + ($d3230ad07d4608b8$var$paramRe.test(segment) ? $d3230ad07d4608b8$var$dynamicSegmentValue : segment === "" ? $d3230ad07d4608b8$var$emptySegmentValue : $d3230ad07d4608b8$var$staticSegmentValue), initialScore);
}
function $d3230ad07d4608b8$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $d3230ad07d4608b8$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $d3230ad07d4608b8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $d3230ad07d4608b8$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $d3230ad07d4608b8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $d3230ad07d4608b8$export$a5c6d149b50c1d86($d3230ad07d4608b8$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $d3230ad07d4608b8$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $d3230ad07d4608b8$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $d3230ad07d4608b8$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $d3230ad07d4608b8$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $d3230ad07d4608b8$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $d3230ad07d4608b8$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $d3230ad07d4608b8$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $d3230ad07d4608b8$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $d3230ad07d4608b8$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $d3230ad07d4608b8$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $d3230ad07d4608b8$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $d3230ad07d4608b8$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $d3230ad07d4608b8$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $d3230ad07d4608b8$var$normalizeSearch(search),
        hash: $d3230ad07d4608b8$var$normalizeHash(hash)
    };
}
function $d3230ad07d4608b8$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $d3230ad07d4608b8$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $d3230ad07d4608b8$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $d3230ad07d4608b8$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $d3230ad07d4608b8$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $d3230ad07d4608b8$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $d3230ad07d4608b8$export$8ccf933b0513f8d0(toArg);
    else {
        to = $d3230ad07d4608b8$var$_extends({}, toArg);
        $d3230ad07d4608b8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $d3230ad07d4608b8$var$getInvalidPathError("?", "pathname", "search", to));
        $d3230ad07d4608b8$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $d3230ad07d4608b8$var$getInvalidPathError("#", "pathname", "hash", to));
        $d3230ad07d4608b8$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $d3230ad07d4608b8$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $d3230ad07d4608b8$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $d3230ad07d4608b8$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $d3230ad07d4608b8$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $d3230ad07d4608b8$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $d3230ad07d4608b8$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $d3230ad07d4608b8$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $d3230ad07d4608b8$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $d3230ad07d4608b8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $d3230ad07d4608b8$export$42a99a7a4bc0e76a extends Error {
}
class $d3230ad07d4608b8$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $d3230ad07d4608b8$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $d3230ad07d4608b8$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $d3230ad07d4608b8$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $d3230ad07d4608b8$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $d3230ad07d4608b8$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $d3230ad07d4608b8$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $d3230ad07d4608b8$var$unwrapTrackedPromise(value) {
    if (!$d3230ad07d4608b8$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $d3230ad07d4608b8$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $d3230ad07d4608b8$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d3230ad07d4608b8$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $d3230ad07d4608b8$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $d3230ad07d4608b8$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $d3230ad07d4608b8$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $d3230ad07d4608b8$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $d3230ad07d4608b8$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $d3230ad07d4608b8$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $d3230ad07d4608b8$var$validMutationMethods = new Set($d3230ad07d4608b8$var$validMutationMethodsArr);
const $d3230ad07d4608b8$var$validRequestMethodsArr = [
    "get",
    ...$d3230ad07d4608b8$var$validMutationMethodsArr
];
const $d3230ad07d4608b8$var$validRequestMethods = new Set($d3230ad07d4608b8$var$validRequestMethodsArr);
const $d3230ad07d4608b8$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $d3230ad07d4608b8$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $d3230ad07d4608b8$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d3230ad07d4608b8$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $d3230ad07d4608b8$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $d3230ad07d4608b8$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $d3230ad07d4608b8$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $d3230ad07d4608b8$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $d3230ad07d4608b8$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d3230ad07d4608b8$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.unstable_dataStrategy || $d3230ad07d4608b8$var$defaultDataStrategy;
    let patchRoutesOnMissImpl = init.unstable_patchRoutesOnMiss;
    // Config driven behavior flags
    let future = $d3230ad07d4608b8$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $d3230ad07d4608b8$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnMissImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnMiss implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && patchRoutesOnMissImpl && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        // We need to run patchRoutesOnMiss in initialize()
        initialized = false;
        initialMatches = [];
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (typeof m.route.loader === "function" && m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $d3230ad07d4608b8$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Map of pending patchRoutesOnMiss() promises (keyed by path/matches) so
    // that we only kick them off once for a given combo
    let pendingPatchRoutes = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $d3230ad07d4608b8$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d3230ad07d4608b8$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $d3230ad07d4608b8$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$d3230ad07d4608b8$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $d3230ad07d4608b8$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $d3230ad07d4608b8$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $d3230ad07d4608b8$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $d3230ad07d4608b8$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d3230ad07d4608b8$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($d3230ad07d4608b8$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $d3230ad07d4608b8$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $d3230ad07d4608b8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $d3230ad07d4608b8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $d3230ad07d4608b8$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $d3230ad07d4608b8$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $d3230ad07d4608b8$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $d3230ad07d4608b8$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $d3230ad07d4608b8$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d3230ad07d4608b8$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $d3230ad07d4608b8$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $d3230ad07d4608b8$var$findNearestBoundary(matches).route.id,
            {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $d3230ad07d4608b8$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($d3230ad07d4608b8$var$isErrorResult(result) && $d3230ad07d4608b8$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $d3230ad07d4608b8$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $d3230ad07d4608b8$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $d3230ad07d4608b8$var$_extends({
            matches: updatedMatches || matches
        }, $d3230ad07d4608b8$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $d3230ad07d4608b8$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $d3230ad07d4608b8$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $d3230ad07d4608b8$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $d3230ad07d4608b8$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: $d3230ad07d4608b8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches);
            result = results[0];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $d3230ad07d4608b8$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) throw $d3230ad07d4608b8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $d3230ad07d4608b8$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $d3230ad07d4608b8$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($d3230ad07d4608b8$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let { boundaryId: boundaryId, error: error } = handleDiscoverRouteError(location.pathname, discoverResult);
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $d3230ad07d4608b8$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $d3230ad07d4608b8$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $d3230ad07d4608b8$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $d3230ad07d4608b8$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(request, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d3230ad07d4608b8$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $d3230ad07d4608b8$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $d3230ad07d4608b8$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $d3230ad07d4608b8$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $d3230ad07d4608b8$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $d3230ad07d4608b8$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $d3230ad07d4608b8$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $d3230ad07d4608b8$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $d3230ad07d4608b8$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d3230ad07d4608b8$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d3230ad07d4608b8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $d3230ad07d4608b8$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", fetchRequest, [
            match
        ], requestMatches);
        let actionResult = actionResults[0];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($d3230ad07d4608b8$var$isRedirectResult(actionResult) || $d3230ad07d4608b8$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($d3230ad07d4608b8$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $d3230ad07d4608b8$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($d3230ad07d4608b8$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($d3230ad07d4608b8$var$isDeferredResult(actionResult)) throw $d3230ad07d4608b8$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $d3230ad07d4608b8$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $d3230ad07d4608b8$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $d3230ad07d4608b8$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $d3230ad07d4608b8$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $d3230ad07d4608b8$var$findRedirect([
            ...loaderResults,
            ...fetcherResults
        ]);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(revalidationRequest, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $d3230ad07d4608b8$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $d3230ad07d4608b8$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $d3230ad07d4608b8$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $d3230ad07d4608b8$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $d3230ad07d4608b8$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, path, fetchRequest.signal);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                let { error: error } = handleDiscoverRouteError(path, discoverResult);
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $d3230ad07d4608b8$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $d3230ad07d4608b8$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", fetchRequest, [
            match
        ], matches);
        let result = results[0];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) result = await $d3230ad07d4608b8$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $d3230ad07d4608b8$export$3e9cee6b33872309(!$d3230ad07d4608b8$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $d3230ad07d4608b8$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $d3230ad07d4608b8$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $d3230ad07d4608b8$var$normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = $d3230ad07d4608b8$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $d3230ad07d4608b8$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $d3230ad07d4608b8$export$e19cd5f9376f8cee.Replace : $d3230ad07d4608b8$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d3230ad07d4608b8$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($d3230ad07d4608b8$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $d3230ad07d4608b8$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $d3230ad07d4608b8$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $d3230ad07d4608b8$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches) {
        try {
            let results = await $d3230ad07d4608b8$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties);
            return await Promise.all(results.map((result, i)=>{
                if ($d3230ad07d4608b8$var$isRedirectHandlerResult(result)) {
                    let response = result.result;
                    return {
                        type: $d3230ad07d4608b8$var$ResultType.redirect,
                        response: $d3230ad07d4608b8$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath)
                    };
                }
                return $d3230ad07d4608b8$var$convertHandlerResultToDataResult(result);
            }));
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            return matchesToLoad.map(()=>({
                    type: $d3230ad07d4608b8$var$ResultType.error,
                    error: e
                }));
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        let [loaderResults, ...fetcherResults] = await Promise.all([
            matchesToLoad.length ? callDataStrategy("loader", request, matchesToLoad, matches) : [],
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) {
                    let fetcherRequest = $d3230ad07d4608b8$var$createClientSideRequest(init.history, f.path, f.controller.signal);
                    return callDataStrategy("loader", fetcherRequest, [
                        f.match
                    ], f.matches).then((r)=>r[0]);
                } else return Promise.resolve({
                    type: $d3230ad07d4608b8$var$ResultType.error,
                    error: $d3230ad07d4608b8$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                });
            })
        ]);
        await Promise.all([
            $d3230ad07d4608b8$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $d3230ad07d4608b8$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $d3230ad07d4608b8$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $d3230ad07d4608b8$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $d3230ad07d4608b8$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $d3230ad07d4608b8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $d3230ad07d4608b8$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $d3230ad07d4608b8$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $d3230ad07d4608b8$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $d3230ad07d4608b8$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $d3230ad07d4608b8$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function handleDiscoverRouteError(pathname, discoverResult) {
        return {
            boundaryId: $d3230ad07d4608b8$var$findNearestBoundary(discoverResult.partialMatches).route.id,
            error: $d3230ad07d4608b8$var$getInternalRouterError(400, {
                type: "route-discovery",
                pathname: pathname,
                message: discoverResult.error != null && "message" in discoverResult.error ? discoverResult.error : String(discoverResult.error)
            })
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $d3230ad07d4608b8$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$d3230ad07d4608b8$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnMissImpl) {
            if (!matches) {
                let fogMatches = $d3230ad07d4608b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else {
                let leafRoute = matches[matches.length - 1].route;
                if (leafRoute.path && (leafRoute.path === "*" || leafRoute.path.endsWith("/*"))) {
                    // If we matched a splat, it might only be because we haven't yet fetched
                    // the children that would match with a higher score, so let's fetch
                    // around and find out
                    let partialMatches = $d3230ad07d4608b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    return {
                        active: true,
                        matches: partialMatches
                    };
                }
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal) {
        let partialMatches = matches;
        let route = partialMatches.length > 0 ? partialMatches[partialMatches.length - 1].route : null;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            try {
                await $d3230ad07d4608b8$var$loadLazyRouteChildren(patchRoutesOnMissImpl, pathname, partialMatches, routesToUse, manifest, mapRouteProperties, pendingPatchRoutes, signal);
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, pathname, basename);
            let matchedSplat = false;
            if (newMatches) {
                let leafRoute = newMatches[newMatches.length - 1].route;
                if (leafRoute.index) // If we found an index route, we can stop
                return {
                    type: "success",
                    matches: newMatches
                };
                if (leafRoute.path && leafRoute.path.length > 0) {
                    if (leafRoute.path === "*") // If we found a splat route, we can't be sure there's not a
                    // higher-scoring route down some partial matches trail so we need
                    // to check that out
                    matchedSplat = true;
                    else // If we found a non-splat route, we can stop
                    return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            let newPartialMatches = $d3230ad07d4608b8$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // If we are no longer partially matching anything, this was either a
            // legit splat match above, or it's a 404.  Also avoid loops if the
            // second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.map((m)=>m.route.id).join("-") === newPartialMatches.map((m)=>m.route.id).join("-")) return {
                type: "success",
                matches: matchedSplat ? newMatches : null
            };
            partialMatches = newPartialMatches;
            route = partialMatches[partialMatches.length - 1].route;
            if (route.path === "*") // The splat is still our most accurate partial, so run with it
            return {
                type: "success",
                matches: partialMatches
            };
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $d3230ad07d4608b8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $d3230ad07d4608b8$export$4d0306f8f6a4585b = Symbol("deferred");
function $d3230ad07d4608b8$export$3336b097a6fbc59a(routes, opts) {
    $d3230ad07d4608b8$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $d3230ad07d4608b8$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $d3230ad07d4608b8$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $d3230ad07d4608b8$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, unstable_dataStrategy: unstable_dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d3230ad07d4608b8$var$createLocation("", $d3230ad07d4608b8$export$fe53371bee54353d(url), null, "default");
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d3230ad07d4608b8$var$isValidMethod(method) && method !== "HEAD") {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $d3230ad07d4608b8$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($d3230ad07d4608b8$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $d3230ad07d4608b8$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, unstable_dataStrategy: unstable_dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $d3230ad07d4608b8$var$createLocation("", $d3230ad07d4608b8$export$fe53371bee54353d(url), null, "default");
        let matches = $d3230ad07d4608b8$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$d3230ad07d4608b8$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d3230ad07d4608b8$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $d3230ad07d4608b8$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $d3230ad07d4608b8$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $d3230ad07d4608b8$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, unstable_dataStrategy || null, false, match);
        if ($d3230ad07d4608b8$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$d3230ad07d4608b8$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $d3230ad07d4608b8$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($d3230ad07d4608b8$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $d3230ad07d4608b8$var$getTargetMatch(matches, location), requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $d3230ad07d4608b8$var$isResponse(result) ? result : $d3230ad07d4608b8$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `HandlerResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($d3230ad07d4608b8$var$isHandlerResult(e) && $d3230ad07d4608b8$var$isResponse(e.result)) {
                if (e.type === $d3230ad07d4608b8$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($d3230ad07d4608b8$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, unstable_dataStrategy);
            result = results[0];
            if (request.signal.aborted) $d3230ad07d4608b8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($d3230ad07d4608b8$var$isDeferredResult(result)) {
            let error = $d3230ad07d4608b8$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($d3230ad07d4608b8$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d3230ad07d4608b8$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $d3230ad07d4608b8$var$_extends({}, context, {
                statusCode: $d3230ad07d4608b8$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $d3230ad07d4608b8$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, null);
        return $d3230ad07d4608b8$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, unstable_dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $d3230ad07d4608b8$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy);
        if (request.signal.aborted) $d3230ad07d4608b8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $d3230ad07d4608b8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $d3230ad07d4608b8$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, unstable_dataStrategy) {
        let results = await $d3230ad07d4608b8$var$callDataStrategyImpl(unstable_dataStrategy || $d3230ad07d4608b8$var$defaultDataStrategy, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext);
        return await Promise.all(results.map((result, i)=>{
            if ($d3230ad07d4608b8$var$isRedirectHandlerResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $d3230ad07d4608b8$var$normalizeRelativeRoutingRedirectResponse(response, request, matchesToLoad[i].route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($d3230ad07d4608b8$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            return $d3230ad07d4608b8$var$convertHandlerResultToDataResult(result);
        }));
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $d3230ad07d4608b8$export$fec11da027c70692(routes, context, error) {
    let newContext = $d3230ad07d4608b8$var$_extends({}, context, {
        statusCode: $d3230ad07d4608b8$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $d3230ad07d4608b8$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $d3230ad07d4608b8$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $d3230ad07d4608b8$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $d3230ad07d4608b8$export$cae722b0cc860f13(to ? to : ".", $d3230ad07d4608b8$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $d3230ad07d4608b8$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$d3230ad07d4608b8$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $d3230ad07d4608b8$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $d3230ad07d4608b8$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $d3230ad07d4608b8$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$d3230ad07d4608b8$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d3230ad07d4608b8$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d3230ad07d4608b8$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $d3230ad07d4608b8$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $d3230ad07d4608b8$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$d3230ad07d4608b8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$d3230ad07d4608b8$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $d3230ad07d4608b8$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $d3230ad07d4608b8$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d3230ad07d4608b8$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d3230ad07d4608b8$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d3230ad07d4608b8$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($d3230ad07d4608b8$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $d3230ad07d4608b8$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $d3230ad07d4608b8$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $d3230ad07d4608b8$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $d3230ad07d4608b8$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[0] : undefined;
    let boundaryMatches = boundaryId ? $d3230ad07d4608b8$var$getLoaderMatchesUntilBoundary(matches, boundaryId) : matches;
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (typeof route.loader !== "function" || route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($d3230ad07d4608b8$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $d3230ad07d4608b8$var$shouldRevalidateLoader(match, $d3230ad07d4608b8$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $d3230ad07d4608b8$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $d3230ad07d4608b8$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $d3230ad07d4608b8$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $d3230ad07d4608b8$var$shouldRevalidateLoader(fetcherMatch, $d3230ad07d4608b8$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $d3230ad07d4608b8$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $d3230ad07d4608b8$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $d3230ad07d4608b8$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Idempotent utility to execute patchRoutesOnMiss() to lazily load route
 * definitions and update the routes/routeManifest
 */ async function $d3230ad07d4608b8$var$loadLazyRouteChildren(patchRoutesOnMissImpl, path, matches, routes, manifest, mapRouteProperties, pendingRouteChildren, signal) {
    let key = [
        path,
        ...matches.map((m)=>m.route.id)
    ].join("-");
    try {
        let pending = pendingRouteChildren.get(key);
        if (!pending) {
            pending = patchRoutesOnMissImpl({
                path: path,
                matches: matches,
                patch: (routeId, children)=>{
                    if (!signal.aborted) $d3230ad07d4608b8$var$patchRoutesImpl(routeId, children, routes, manifest, mapRouteProperties);
                }
            });
            pendingRouteChildren.set(key, pending);
        }
        if (pending && $d3230ad07d4608b8$var$isPromise(pending)) await pending;
    } finally{
        pendingRouteChildren.delete(key);
    }
}
function $d3230ad07d4608b8$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    if (routeId) {
        var _route$children;
        let route = manifest[routeId];
        $d3230ad07d4608b8$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        let dataChildren = $d3230ad07d4608b8$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            routeId,
            "patch",
            String(((_route$children = route.children) == null ? void 0 : _route$children.length) || "0")
        ], manifest);
        if (route.children) route.children.push(...dataChildren);
        else route.children = dataChildren;
    } else {
        let dataChildren = $d3230ad07d4608b8$export$4a6d22b32134ea5d(children, mapRouteProperties, [
            "patch",
            String(routesToUse.length || "0")
        ], manifest);
        routesToUse.push(...dataChildren);
    }
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $d3230ad07d4608b8$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $d3230ad07d4608b8$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $d3230ad07d4608b8$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$d3230ad07d4608b8$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $d3230ad07d4608b8$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
function $d3230ad07d4608b8$var$defaultDataStrategy(opts) {
    return Promise.all(opts.matches.map((m)=>m.resolve()));
}
async function $d3230ad07d4608b8$var$callDataStrategyImpl(dataStrategyImpl, type, request, matchesToLoad, matches, manifest, mapRouteProperties, requestContext) {
    let routeIdsToLoad = matchesToLoad.reduce((acc, m)=>acc.add(m.route.id), new Set());
    let loadedMatches = new Set();
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: matches.map((match)=>{
            let shouldLoad = routeIdsToLoad.has(match.route.id);
            // `resolve` encapsulates the route.lazy, executing the
            // loader/action, and mapping return values/thrown errors to a
            // HandlerResult.  Users can pass a callback to take fine-grained control
            // over the execution of the loader/action
            let resolve = (handlerOverride)=>{
                loadedMatches.add(match.route.id);
                return shouldLoad ? $d3230ad07d4608b8$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, requestContext) : Promise.resolve({
                    type: $d3230ad07d4608b8$var$ResultType.data,
                    result: undefined
                });
            };
            return $d3230ad07d4608b8$var$_extends({}, match, {
                shouldLoad: shouldLoad,
                resolve: resolve
            });
        }),
        request: request,
        params: matches[0].params,
        context: requestContext
    });
    // Throw if any loadRoute implementations not called since they are what
    // ensures a route is fully loaded
    matches.forEach((m)=>$d3230ad07d4608b8$export$3e9cee6b33872309(loadedMatches.has(m.route.id), '`match.resolve()` was not called for route id "' + m.route.id + '". ' + "You must call `match.resolve()` on every match passed to " + "`dataStrategy` to ensure all routes are properly loaded."));
    // Filter out any middleware-only matches for which we didn't need to run handlers
    return results.filter((_, i)=>routeIdsToLoad.has(matches[i].route.id));
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $d3230ad07d4608b8$var$callLoaderOrAction(type, request, match, manifest, mapRouteProperties, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<HandlerResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ('"' + type + '" [routeId: ' + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise;
        if (handlerOverride) handlerPromise = handlerOverride((ctx)=>actualHandler(ctx));
        else handlerPromise = (async ()=>{
            try {
                let val = await actualHandler();
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $d3230ad07d4608b8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await $d3230ad07d4608b8$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $d3230ad07d4608b8$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $d3230ad07d4608b8$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $d3230ad07d4608b8$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $d3230ad07d4608b8$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // HandlerResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $d3230ad07d4608b8$var$convertHandlerResultToDataResult(handlerResult) {
    let { result: result, type: type, status: status } = handlerResult;
    if ($d3230ad07d4608b8$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $d3230ad07d4608b8$var$ResultType.error,
                error: e
            };
        }
        if (type === $d3230ad07d4608b8$var$ResultType.error) return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: new $d3230ad07d4608b8$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $d3230ad07d4608b8$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $d3230ad07d4608b8$var$ResultType.error) return {
        type: $d3230ad07d4608b8$var$ResultType.error,
        error: result,
        statusCode: $d3230ad07d4608b8$export$972111febbeef05b(result) ? result.status : status
    };
    if ($d3230ad07d4608b8$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $d3230ad07d4608b8$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $d3230ad07d4608b8$var$ResultType.data,
        data: result,
        statusCode: status
    };
}
// Support relative routing in internal redirects
function $d3230ad07d4608b8$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $d3230ad07d4608b8$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $d3230ad07d4608b8$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $d3230ad07d4608b8$var$normalizeRedirectLocation(location, currentUrl, basename) {
    if ($d3230ad07d4608b8$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = $d3230ad07d4608b8$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $d3230ad07d4608b8$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($d3230ad07d4608b8$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $d3230ad07d4608b8$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $d3230ad07d4608b8$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d3230ad07d4608b8$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $d3230ad07d4608b8$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $d3230ad07d4608b8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $d3230ad07d4608b8$export$3e9cee6b33872309(!$d3230ad07d4608b8$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $d3230ad07d4608b8$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($d3230ad07d4608b8$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d3230ad07d4608b8$var$processLoaderData(state, matches, matchesToLoad, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $d3230ad07d4608b8$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $d3230ad07d4608b8$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($d3230ad07d4608b8$var$isErrorResult(result)) {
            let boundaryMatch = $d3230ad07d4608b8$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $d3230ad07d4608b8$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($d3230ad07d4608b8$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $d3230ad07d4608b8$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($d3230ad07d4608b8$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $d3230ad07d4608b8$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $d3230ad07d4608b8$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d3230ad07d4608b8$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $d3230ad07d4608b8$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $d3230ad07d4608b8$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d3230ad07d4608b8$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $d3230ad07d4608b8$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $d3230ad07d4608b8$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d3230ad07d4608b8$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (type === "route-discovery") errorMessage = 'Unable to match URL "' + pathname + '" - the `unstable_patchRoutesOnMiss()` ' + ("function threw the following error:\n" + message);
        else if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $d3230ad07d4608b8$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $d3230ad07d4608b8$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($d3230ad07d4608b8$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $d3230ad07d4608b8$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(path) : path;
    return $d3230ad07d4608b8$export$fe53371bee54353d($d3230ad07d4608b8$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $d3230ad07d4608b8$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $d3230ad07d4608b8$var$isPromise(val) {
    return typeof val === "object" && val != null && "then" in val;
}
function $d3230ad07d4608b8$var$isHandlerResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $d3230ad07d4608b8$var$ResultType.data || result.type === $d3230ad07d4608b8$var$ResultType.error);
}
function $d3230ad07d4608b8$var$isRedirectHandlerResult(result) {
    return $d3230ad07d4608b8$var$isResponse(result.result) && $d3230ad07d4608b8$var$redirectStatusCodes.has(result.result.status);
}
function $d3230ad07d4608b8$var$isDeferredResult(result) {
    return result.type === $d3230ad07d4608b8$var$ResultType.deferred;
}
function $d3230ad07d4608b8$var$isErrorResult(result) {
    return result.type === $d3230ad07d4608b8$var$ResultType.error;
}
function $d3230ad07d4608b8$var$isRedirectResult(result) {
    return (result && result.type) === $d3230ad07d4608b8$var$ResultType.redirect;
}
function $d3230ad07d4608b8$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $d3230ad07d4608b8$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $d3230ad07d4608b8$var$isRedirectResponse(result) {
    if (!$d3230ad07d4608b8$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $d3230ad07d4608b8$var$isValidMethod(method) {
    return $d3230ad07d4608b8$var$validRequestMethods.has(method.toLowerCase());
}
function $d3230ad07d4608b8$var$isMutationMethod(method) {
    return $d3230ad07d4608b8$var$validMutationMethods.has(method.toLowerCase());
}
async function $d3230ad07d4608b8$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$d3230ad07d4608b8$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($d3230ad07d4608b8$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $d3230ad07d4608b8$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $d3230ad07d4608b8$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $d3230ad07d4608b8$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $d3230ad07d4608b8$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $d3230ad07d4608b8$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $d3230ad07d4608b8$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $d3230ad07d4608b8$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $d3230ad07d4608b8$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $d3230ad07d4608b8$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d3230ad07d4608b8$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $d3230ad07d4608b8$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d3230ad07d4608b8$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $d3230ad07d4608b8$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $d3230ad07d4608b8$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $d3230ad07d4608b8$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $d3230ad07d4608b8$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $d3230ad07d4608b8$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $d3230ad07d4608b8$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($d3230ad07d4608b8$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $d3230ad07d4608b8$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($d3230ad07d4608b8$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $d3230ad07d4608b8$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

});

parcelRegister("5WDNl", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $45413cf8903a2186$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $45413cf8903a2186$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $45413cf8903a2186$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $45413cf8903a2186$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $45413cf8903a2186$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $45413cf8903a2186$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $45413cf8903a2186$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useNavigate", function () { return $45413cf8903a2186$export$9770f232ac06a008; });
$parcel$export(module.exports, "UNSAFE_useRoutesImpl", function () { return $45413cf8903a2186$export$5fcee62552a12fbf; });
$parcel$export(module.exports, "UNSAFE_useRouteId", function () { return $45413cf8903a2186$export$5fc8298006ad9e58; });
$parcel$export(module.exports, "useNavigation", function () { return $45413cf8903a2186$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $45413cf8903a2186$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "useBlocker", function () { return $45413cf8903a2186$export$b273b3273281a049; });
$parcel$export(module.exports, "Router", function () { return $45413cf8903a2186$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Navigate", function () { return $45413cf8903a2186$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Route", function () { return $45413cf8903a2186$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "Routes", function () { return $45413cf8903a2186$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "UNSAFE_mapRouteProperties", function () { return $45413cf8903a2186$export$52b333d321859367; });
/**
 * React Router v6.25.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $i7SlW = parcelRequire("i7SlW");
function $45413cf8903a2186$var$_extends() {
    $45413cf8903a2186$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $45413cf8903a2186$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $45413cf8903a2186$export$3add0d5dce533e2e = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$export$145dfa71566a64dc = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$var$AwaitContext = /*#__PURE__*/ $8ZuGG.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $45413cf8903a2186$export$26749e8557646306 = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$export$c7914228fb69b0f5 = /*#__PURE__*/ $8ZuGG.createContext(null);
const $45413cf8903a2186$export$9072aa6dd1f93057 = /*#__PURE__*/ $8ZuGG.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $45413cf8903a2186$var$RouteErrorContext = /*#__PURE__*/ $8ZuGG.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $45413cf8903a2186$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $45413cf8903a2186$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $i7SlW.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $45413cf8903a2186$export$9c954a9d03d32f4a() {
    return $8ZuGG.useContext($45413cf8903a2186$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $45413cf8903a2186$export$45d76561a5302f2b() {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    return $8ZuGG.useContext($45413cf8903a2186$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $45413cf8903a2186$export$1b3f31771c5d07c() {
    return $8ZuGG.useContext($45413cf8903a2186$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $45413cf8903a2186$export$6c330e8992e8a295(pattern) {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { pathname: pathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    return $8ZuGG.useMemo(()=>(0, $i7SlW.matchPath)(pattern, (0, $i7SlW.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $45413cf8903a2186$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $45413cf8903a2186$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $8ZuGG.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $45413cf8903a2186$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $45413cf8903a2186$var$useNavigateStable() : $45413cf8903a2186$var$useNavigateUnstable();
}
function $45413cf8903a2186$var$useNavigateUnstable() {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let dataRouterContext = $8ZuGG.useContext($45413cf8903a2186$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $i7SlW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = $8ZuGG.useRef(false);
    $45413cf8903a2186$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8ZuGG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $i7SlW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $i7SlW.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $45413cf8903a2186$var$OutletContext = /*#__PURE__*/ $8ZuGG.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $45413cf8903a2186$export$4138103a3ae699cc() {
    return $8ZuGG.useContext($45413cf8903a2186$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $45413cf8903a2186$export$a3be3530d8e40d0b(context) {
    let outlet = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $45413cf8903a2186$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $45413cf8903a2186$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $i7SlW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return $8ZuGG.useMemo(()=>(0, $i7SlW.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $45413cf8903a2186$export$5d3fca4a98652595(routes, locationArg) {
    return $45413cf8903a2186$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $45413cf8903a2186$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { navigator: navigator } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: parentMatches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $45413cf8903a2186$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $i7SlW.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $i7SlW.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $i7SlW.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $45413cf8903a2186$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $i7SlW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $i7SlW.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $45413cf8903a2186$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $i7SlW.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $45413cf8903a2186$var$DefaultErrorComponent() {
    let error = $45413cf8903a2186$export$ed527bf60f6e05f2();
    let message = (0, $i7SlW.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $8ZuGG.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $8ZuGG.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $45413cf8903a2186$var$defaultErrorElement = /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$DefaultErrorComponent, null);
class $45413cf8903a2186$var$RenderErrorBoundary extends $8ZuGG.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $45413cf8903a2186$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $8ZuGG.useContext($45413cf8903a2186$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $45413cf8903a2186$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $i7SlW.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $45413cf8903a2186$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $45413cf8903a2186$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $8ZuGG.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $45413cf8903a2186$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($45413cf8903a2186$var$DataRouterHook || {});
var $45413cf8903a2186$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($45413cf8903a2186$var$DataRouterStateHook || {});
function $45413cf8903a2186$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $45413cf8903a2186$var$useDataRouterContext(hookName) {
    let ctx = $8ZuGG.useContext($45413cf8903a2186$export$3add0d5dce533e2e);
    !ctx && (0, $i7SlW.UNSAFE_invariant)(false);
    return ctx;
}
function $45413cf8903a2186$var$useDataRouterState(hookName) {
    let state = $8ZuGG.useContext($45413cf8903a2186$export$145dfa71566a64dc);
    !state && (0, $i7SlW.UNSAFE_invariant)(false);
    return state;
}
function $45413cf8903a2186$var$useRouteContext(hookName) {
    let route = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    !route && (0, $i7SlW.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $45413cf8903a2186$var$useCurrentRouteId(hookName) {
    let route = $45413cf8903a2186$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $i7SlW.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $45413cf8903a2186$export$5fc8298006ad9e58() {
    return $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $45413cf8903a2186$export$d0fd4b7106de2769() {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $45413cf8903a2186$export$600dc272ed516c15() {
    let dataRouterContext = $45413cf8903a2186$var$useDataRouterContext($45413cf8903a2186$var$DataRouterHook.UseRevalidator);
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseRevalidator);
    return $8ZuGG.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $45413cf8903a2186$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseMatches);
    return $8ZuGG.useMemo(()=>matches.map((m)=>(0, $i7SlW.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $45413cf8903a2186$export$1448a5050d252c4d() {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseLoaderData);
    let routeId = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $45413cf8903a2186$export$fd5d37484eab868d(routeId) {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $45413cf8903a2186$export$fdc00f3f26066d5e() {
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseActionData);
    let routeId = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $45413cf8903a2186$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $8ZuGG.useContext($45413cf8903a2186$var$RouteErrorContext);
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseRouteError);
    let routeId = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $45413cf8903a2186$export$78a72ddb39bdd145() {
    let value = $8ZuGG.useContext($45413cf8903a2186$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $45413cf8903a2186$export$17f53340677d5831() {
    let value = $8ZuGG.useContext($45413cf8903a2186$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $45413cf8903a2186$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $45413cf8903a2186$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $45413cf8903a2186$var$useDataRouterContext($45413cf8903a2186$var$DataRouterHook.UseBlocker);
    let state = $45413cf8903a2186$var$useDataRouterState($45413cf8903a2186$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $8ZuGG.useState("");
    let blockerFunction = $8ZuGG.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $45413cf8903a2186$var$_extends({}, currentLocation, {
                pathname: (0, $i7SlW.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $45413cf8903a2186$var$_extends({}, nextLocation, {
                pathname: (0, $i7SlW.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $8ZuGG.useEffect(()=>{
        let key = String(++$45413cf8903a2186$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $8ZuGG.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $i7SlW.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $45413cf8903a2186$var$useNavigateStable() {
    let { router: router } = $45413cf8903a2186$var$useDataRouterContext($45413cf8903a2186$var$DataRouterHook.UseNavigateStable);
    let id = $45413cf8903a2186$var$useCurrentRouteId($45413cf8903a2186$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $8ZuGG.useRef(false);
    $45413cf8903a2186$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $8ZuGG.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $45413cf8903a2186$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $45413cf8903a2186$var$alreadyWarned = {};
function $45413cf8903a2186$var$warningOnce(key, cond, message) {
    if (!cond && !$45413cf8903a2186$var$alreadyWarned[key]) $45413cf8903a2186$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $45413cf8903a2186$var$START_TRANSITION = "startTransition";
const $45413cf8903a2186$var$startTransitionImpl = $8ZuGG[$45413cf8903a2186$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $45413cf8903a2186$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $8ZuGG.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        if (v7_startTransition && $45413cf8903a2186$var$startTransitionImpl) $45413cf8903a2186$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $8ZuGG.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $8ZuGG.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $8ZuGG.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $8ZuGG.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $45413cf8903a2186$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $45413cf8903a2186$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $45413cf8903a2186$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $8ZuGG.useRef();
    if (historyRef.current == null) historyRef.current = (0, $i7SlW.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $8ZuGG.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $8ZuGG.useCallback((newState)=>{
        v7_startTransition && $45413cf8903a2186$var$startTransitionImpl ? $45413cf8903a2186$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $8ZuGG.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $45413cf8903a2186$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    let { future: future, static: isStatic } = $8ZuGG.useContext($45413cf8903a2186$export$26749e8557646306);
    let { matches: matches } = $8ZuGG.useContext($45413cf8903a2186$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $45413cf8903a2186$export$45d76561a5302f2b();
    let navigate = $45413cf8903a2186$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $i7SlW.resolveTo)(to, (0, $i7SlW.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $8ZuGG.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $45413cf8903a2186$export$910ae8079b2c2852(props) {
    return $45413cf8903a2186$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $45413cf8903a2186$export$e7b0ac011bb776c6(_props) {
    (0, $i7SlW.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $45413cf8903a2186$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $i7SlW.Action).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$45413cf8903a2186$export$9c954a9d03d32f4a() && (0, $i7SlW.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $8ZuGG.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $45413cf8903a2186$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $i7SlW.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $8ZuGG.useMemo(()=>{
        let trailingPathname = (0, $i7SlW.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $45413cf8903a2186$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $45413cf8903a2186$export$5d3fca4a98652595($45413cf8903a2186$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $45413cf8903a2186$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$ResolveAwait, null, children));
}
var $45413cf8903a2186$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($45413cf8903a2186$var$AwaitRenderStatus || {});
const $45413cf8903a2186$var$neverSettledPromise = new Promise(()=>{});
class $45413cf8903a2186$var$AwaitErrorBoundary extends $8ZuGG.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $45413cf8903a2186$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $45413cf8903a2186$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $45413cf8903a2186$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $45413cf8903a2186$var$AwaitRenderStatus.error : "_data" in promise ? $45413cf8903a2186$var$AwaitRenderStatus.success : $45413cf8903a2186$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $45413cf8903a2186$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.error && promise._error instanceof (0, $i7SlW.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $45413cf8903a2186$var$neverSettledPromise;
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $45413cf8903a2186$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $8ZuGG.createElement($45413cf8903a2186$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $45413cf8903a2186$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $45413cf8903a2186$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $45413cf8903a2186$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $8ZuGG.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $8ZuGG.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $8ZuGG.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $45413cf8903a2186$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $45413cf8903a2186$export$e7b0ac011bb776c6) && (0, $i7SlW.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $i7SlW.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $45413cf8903a2186$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $45413cf8903a2186$export$daf73786167a7f72(matches) {
    return $45413cf8903a2186$var$_renderMatches(matches);
}
function $45413cf8903a2186$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $8ZuGG.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $8ZuGG.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $8ZuGG.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $45413cf8903a2186$export$f30f7e456d254e83(routes, opts) {
    return (0, $i7SlW.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: $45413cf8903a2186$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $i7SlW.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $45413cf8903a2186$export$52b333d321859367,
        unstable_dataStrategy: opts == null ? void 0 : opts.unstable_dataStrategy,
        unstable_patchRoutesOnMiss: opts == null ? void 0 : opts.unstable_patchRoutesOnMiss
    }).initialize();
}

});


parcelRegister("cufV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9174a278f18858f9$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $hUeXI = parcelRequire("hUeXI");

var $kTdw7 = parcelRequire("kTdw7");

var $jwMYJ = parcelRequire("jwMYJ");
/**
 * Returns the appropriate circle stroke color.
 */ function $9174a278f18858f9$var$getStrokeColor(appearance) {
    return appearance === "inherit" ? "var(--ds-icon-subtle, ".concat((0, $kTdw7.N500), ")") : "var(--ds-icon-inverse, ".concat((0, $kTdw7.N0), ")");
}
var $9174a278f18858f9$var$rotate = (0, $14VNY.keyframes)({
    to: {
        transform: "rotate(360deg)"
    }
});
var $9174a278f18858f9$var$rotateStyles = (0, $14VNY.css)({
    animation: "".concat($9174a278f18858f9$var$rotate, " 0.86s infinite"),
    animationTimingFunction: "cubic-bezier(0.4, 0.15, 0.6, 0.85)",
    transformOrigin: "center"
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $9174a278f18858f9$var$loadIn = (0, $14VNY.keyframes)({
    from: {
        transform: "rotate(50deg)",
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: "rotate(230deg)",
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $9174a278f18858f9$var$loadInStyles = (0, $14VNY.css)({
    animation: "".concat($9174a278f18858f9$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: "forwards",
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $9174a278f18858f9$var$wrapperStyles = (0, $14VNY.css)({
    display: "inline-flex",
    /**
   * Align better inline with text.
   */ verticalAlign: "middle"
});
var $9174a278f18858f9$var$circleStyles = (0, $14VNY.css)({
    fill: "none",
    strokeDasharray: 60,
    strokeDashoffset: "inherit",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    "@media screen and (forced-colors: active)": {
        filter: "grayscale(100%)",
        stroke: "CanvasText"
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $9174a278f18858f9$var$useLayoutEffect = typeof window === "undefined" ? (0, $8ZuGG.useEffect) : (0, $8ZuGG.useLayoutEffect);
/**
 * __Spinner__
 *
 * A spinner is an animated spinning icon that lets users know content is being loaded.
 *
 * - [Examples](https://atlassian.design/components/{spinner}/examples)
 * - [Code](https://atlassian.design/components/{spinner}/code)
 * - [Usage](https://atlassian.design/components/{spinner}/usage)
 */ var $9174a278f18858f9$var$Spinner = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "inherit" : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? "medium" : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === "number" ? providedSize : (0, $jwMYJ.presetSizes)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $9174a278f18858f9$var$getStrokeColor(appearance);
    var context = (0, $8ZuGG.useContext)((0, $hUeXI.default));
    $9174a278f18858f9$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $14VNY.jsx)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $9174a278f18858f9$var$wrapperStyles,
            $9174a278f18858f9$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $14VNY.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $9174a278f18858f9$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? "img" : "none"
    }, (0, $14VNY.jsx)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $9174a278f18858f9$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));
var $9174a278f18858f9$export$2e2bcd8739ae039 = $9174a278f18858f9$var$Spinner;

});
parcelRegister("14VNY", function(module, exports) {

$parcel$export(module.exports, "Global", function () { return $0c930110a49e6b20$export$98f03c5d19621d70; });
$parcel$export(module.exports, "css", function () { return $0c930110a49e6b20$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $0c930110a49e6b20$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "ClassNames", function () { return $0c930110a49e6b20$export$9b9c0f9d9f3552b8; });
$parcel$export(module.exports, "jsx", function () { return $0c930110a49e6b20$export$c8a8987d4410bf2d; });
$parcel$export(module.exports, "ThemeContext", function () { return (parcelRequire("h0dfV")).T; });
$parcel$export(module.exports, "withEmotionCache", function () { return (parcelRequire("h0dfV")).w; });

var $h0dfV = parcelRequire("h0dfV");

var $8ZuGG = parcelRequire("8ZuGG");

var $7xLFM = parcelRequire("7xLFM");

var $gnKJq = parcelRequire("gnKJq");

var $cEdpu = parcelRequire("cEdpu");
parcelRequire("l7WA8");
parcelRequire("dLcU7");
parcelRequire("1TDV2");

parcelRequire("fiQA5");
var $0c930110a49e6b20$var$pkg = {
    name: "@emotion/react",
    version: "11.11.4",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $0c930110a49e6b20$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $h0dfV.h).call(props, "css")) // $FlowFixMe
    return $8ZuGG.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $h0dfV.E);
    createElementArgArray[1] = (0, $h0dfV.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $8ZuGG.createElement.apply(null, createElementArgArray);
};
var $0c930110a49e6b20$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $0c930110a49e6b20$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $h0dfV.w)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $cEdpu.serializeStyles)([
        styles
    ], undefined, $8ZuGG.useContext((0, $h0dfV.T)));
    if (!(0, $h0dfV.i)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += " " + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $8ZuGG.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $8ZuGG.useRef();
    (0, $gnKJq.useInsertionEffectWithLayoutFallback)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector('style[data-emotion="' + key + " " + serialized.name + '"]');
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute("data-emotion", key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $gnKJq.useInsertionEffectWithLayoutFallback)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $7xLFM.insertStyles)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $0c930110a49e6b20$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cEdpu.serializeStyles)(args);
}
var $0c930110a49e6b20$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $0c930110a49e6b20$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $0c930110a49e6b20$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $0c930110a49e6b20$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $7xLFM.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $0c930110a49e6b20$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $gnKJq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $7xLFM.insertStyles)(cache, serializedArr[i], false);
    });
    return null;
};
var $0c930110a49e6b20$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $h0dfV.w)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $cEdpu.serializeStyles)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $7xLFM.registerStyles)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $0c930110a49e6b20$var$merge(cache.registered, css, $0c930110a49e6b20$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $8ZuGG.useContext((0, $h0dfV.T))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($0c930110a49e6b20$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $0c930110a49e6b20$var$isBrowser, $0c930110a49e6b20$var$isTestEnv, $0c930110a49e6b20$var$globalContext, $0c930110a49e6b20$var$globalKey;

});
parcelRegister("h0dfV", function(module, exports) {

$parcel$export(module.exports, "i", function () { return $c60cb818bddc1aa5$export$23f2a1d2818174ef; });
$parcel$export(module.exports, "h", function () { return $c60cb818bddc1aa5$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "C", function () { return $c60cb818bddc1aa5$export$e7094788287c5e9b; });
$parcel$export(module.exports, "w", function () { return $c60cb818bddc1aa5$export$efccba1c4a2ef57b; });
$parcel$export(module.exports, "T", function () { return $c60cb818bddc1aa5$export$971d5caa766a69d7; });
$parcel$export(module.exports, "c", function () { return $c60cb818bddc1aa5$export$db3b6bfb95261072; });
$parcel$export(module.exports, "E", function () { return $c60cb818bddc1aa5$export$a9c23c6ac3fc3eca; });

var $8ZuGG = parcelRequire("8ZuGG");

var $l7WA8 = parcelRequire("l7WA8");

var $6vRlT = parcelRequire("6vRlT");

var $1TDV2 = parcelRequire("1TDV2");

var $46RMY = parcelRequire("46RMY");

var $7xLFM = parcelRequire("7xLFM");

var $cEdpu = parcelRequire("cEdpu");

var $gnKJq = parcelRequire("gnKJq");
var $c60cb818bddc1aa5$export$23f2a1d2818174ef = true;
var $c60cb818bddc1aa5$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $c60cb818bddc1aa5$var$EmotionCacheContext = /* #__PURE__ */ $8ZuGG.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? /* #__PURE__ */ (0, $l7WA8.default)({
    key: "css"
}) : null);
var $c60cb818bddc1aa5$export$e7094788287c5e9b = $c60cb818bddc1aa5$var$EmotionCacheContext.Provider;
var $c60cb818bddc1aa5$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $8ZuGG.useContext)($c60cb818bddc1aa5$var$EmotionCacheContext);
};
var $c60cb818bddc1aa5$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $8ZuGG.useContext)($c60cb818bddc1aa5$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$c60cb818bddc1aa5$export$23f2a1d2818174ef) $c60cb818bddc1aa5$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $8ZuGG.useContext)($c60cb818bddc1aa5$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $l7WA8.default)({
                key: "css"
            });
            return /*#__PURE__*/ $8ZuGG.createElement($c60cb818bddc1aa5$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $c60cb818bddc1aa5$export$971d5caa766a69d7 = /* #__PURE__ */ $8ZuGG.createContext({});
var $c60cb818bddc1aa5$export$3b14a55fb2447963 = function useTheme() {
    return $8ZuGG.useContext($c60cb818bddc1aa5$export$971d5caa766a69d7);
};
var $c60cb818bddc1aa5$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === "function") {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $6vRlT.default)({}, outerTheme, theme);
};
var $c60cb818bddc1aa5$var$createCacheWithTheme = /* #__PURE__ */ (0, $1TDV2.default)(function(outerTheme) {
    return (0, $1TDV2.default)(function(theme) {
        return $c60cb818bddc1aa5$var$getTheme(outerTheme, theme);
    });
});
var $c60cb818bddc1aa5$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $8ZuGG.useContext($c60cb818bddc1aa5$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $c60cb818bddc1aa5$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $8ZuGG.createElement($c60cb818bddc1aa5$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $c60cb818bddc1aa5$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || "Component";
    var render = function render(props, ref) {
        var theme = $8ZuGG.useContext($c60cb818bddc1aa5$export$971d5caa766a69d7);
        return /*#__PURE__*/ $8ZuGG.createElement(Component, (0, $6vRlT.default)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $8ZuGG.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $46RMY.default)(WithTheme, Component);
}
var $c60cb818bddc1aa5$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split(".");
    return parts[parts.length - 1];
};
var $c60cb818bddc1aa5$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $c60cb818bddc1aa5$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $c60cb818bddc1aa5$var$getLastPart(match[1]);
    return undefined;
};
var $c60cb818bddc1aa5$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    "renderWithHooks",
    "processChild",
    "finishClassComponent",
    "renderToString"
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $c60cb818bddc1aa5$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $c60cb818bddc1aa5$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split("\n");
    for(var i = 0; i < lines.length; i++){
        var functionName = $c60cb818bddc1aa5$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($c60cb818bddc1aa5$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $c60cb818bddc1aa5$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $c60cb818bddc1aa5$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $c60cb818bddc1aa5$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $c60cb818bddc1aa5$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($c60cb818bddc1aa5$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$c60cb818bddc1aa5$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $c60cb818bddc1aa5$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $7xLFM.registerStyles)(cache, serialized, isStringTag);
    (0, $gnKJq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $7xLFM.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $c60cb818bddc1aa5$var$Emotion = /* #__PURE__ */ $c60cb818bddc1aa5$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$c60cb818bddc1aa5$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $7xLFM.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cEdpu.serializeStyles)(registeredStyles, undefined, $8ZuGG.useContext($c60cb818bddc1aa5$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($c60cb818bddc1aa5$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $c60cb818bddc1aa5$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($c60cb818bddc1aa5$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === "string"
    }), /*#__PURE__*/ $8ZuGG.createElement(WrappedComponent, newProps));
});
var $c60cb818bddc1aa5$export$a9c23c6ac3fc3eca = $c60cb818bddc1aa5$var$Emotion;

});
parcelRegister("l7WA8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f617b18df8ca3b86$export$2e2bcd8739ae039; });

var $7zRTz = parcelRequire("7zRTz");

var $84yE1 = parcelRequire("84yE1");
parcelRequire("1TDV2");
parcelRequire("knQRH");
var $f617b18df8ca3b86$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $84yE1.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $84yE1.token)(character)) break;
        (0, $84yE1.next)();
    }
    return (0, $84yE1.slice)(begin, (0, $84yE1.position));
};
var $f617b18df8ca3b86$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $84yE1.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $84yE1.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $f617b18df8ca3b86$var$identifierWithPointTracking((0, $84yE1.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $84yE1.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $84yE1.peek)() === 58 ? "&\f" : "";
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $84yE1.from)(character);
    }
    while (character = (0, $84yE1.next)());
    return parsed;
};
var $f617b18df8ca3b86$var$getRules = function getRules(value, points) {
    return (0, $84yE1.dealloc)($f617b18df8ca3b86$var$toRules((0, $84yE1.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $f617b18df8ca3b86$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $f617b18df8ca3b86$var$compat = function compat(element) {
    if (element.type !== "rule" || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== "rule"){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$f617b18df8ca3b86$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $f617b18df8ca3b86$var$fixedElements.set(element, true);
    var points = [];
    var rules = $f617b18df8ca3b86$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $f617b18df8ca3b86$var$removeLabel = function removeLabel(element) {
    if (element.type === "decl") {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = "";
            element.value = "";
        }
    }
};
var $f617b18df8ca3b86$var$ignoreFlag = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason";
var $f617b18df8ca3b86$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === "comm" && element.children.indexOf($f617b18df8ca3b86$var$ignoreFlag) > -1;
};
var $f617b18df8ca3b86$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== "rule" || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($f617b18df8ca3b86$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error('The pseudo class "' + unsafePseudoClass + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + unsafePseudoClass.split("-child")[0] + '-of-type".');
            });
        }
    };
};
var $f617b18df8ca3b86$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $f617b18df8ca3b86$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$f617b18df8ca3b86$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $f617b18df8ca3b86$var$nullifyElement = function nullifyElement(element) {
    element.type = "";
    element.value = "";
    element["return"] = "";
    element.children = "";
    element.props = "";
};
var $f617b18df8ca3b86$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$f617b18df8ca3b86$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $f617b18df8ca3b86$var$nullifyElement(element);
    } else if ($f617b18df8ca3b86$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $f617b18df8ca3b86$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $f617b18df8ca3b86$var$prefix(value, length) {
    switch((0, $84yE1.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $84yE1.WEBKIT) + "print-" + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $84yE1.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MOZ) + value + (0, $84yE1.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + value + value;
        // order
        case 6165:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + "flex-" + value + value;
        // align-items
        case 5187:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.replace)(value, /(\w+).+(:[^]+)/, (0, $84yE1.WEBKIT) + "box-$1$2" + (0, $84yE1.MS) + "flex-$1$2") + value;
        // align-self
        case 5443:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + "flex-item-" + (0, $84yE1.replace)(value, /flex-|-self/, "") + value;
        // align-content
        case 4675:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + "flex-line-pack" + (0, $84yE1.replace)(value, /align-content|flex-|-self/, "") + value;
        // flex-shrink
        case 5548:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, "shrink", "negative") + value;
        // flex-basis
        case 5292:
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, "basis", "preferred-size") + value;
        // flex-grow
        case 6060:
            return (0, $84yE1.WEBKIT) + "box-" + (0, $84yE1.replace)(value, "-grow", "") + (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, "grow", "positive") + value;
        // transition
        case 4554:
            return (0, $84yE1.WEBKIT) + (0, $84yE1.replace)(value, /([^-])(transform)/g, "$1" + (0, $84yE1.WEBKIT) + "$2") + value;
        // cursor
        case 6187:
            return (0, $84yE1.replace)((0, $84yE1.replace)((0, $84yE1.replace)(value, /(zoom-|grab)/, (0, $84yE1.WEBKIT) + "$1"), /(image-set)/, (0, $84yE1.WEBKIT) + "$1"), value, "") + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $84yE1.replace)(value, /(image-set\([^]*)/, (0, $84yE1.WEBKIT) + "$1" + "$`$1");
        // justify-content
        case 4968:
            return (0, $84yE1.replace)((0, $84yE1.replace)(value, /(.+:)(flex-)?(.*)/, (0, $84yE1.WEBKIT) + "box-pack:$3" + (0, $84yE1.MS) + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + (0, $84yE1.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $84yE1.replace)(value, /(.+)-inline(.+)/, (0, $84yE1.WEBKIT) + "$1$2") + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $84yE1.strlen)(value) - 1 - length > 6) switch((0, $84yE1.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $84yE1.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $84yE1.replace)(value, /(.+:)(.+)-([^]+)/, "$1" + (0, $84yE1.WEBKIT) + "$2-$3" + "$1" + (0, $84yE1.MOZ) + ((0, $84yE1.charat)(value, length + 3) == 108 ? "$3" : "$2-$3")) + value;
                // (s)tretch
                case 115:
                    return ~(0, $84yE1.indexof)(value, "stretch") ? $f617b18df8ca3b86$var$prefix((0, $84yE1.replace)(value, "stretch", "fill-available"), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $84yE1.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $84yE1.charat)(value, (0, $84yE1.strlen)(value) - 3 - (~(0, $84yE1.indexof)(value, "!important") && 10))){
                // stic(k)y
                case 107:
                    return (0, $84yE1.replace)(value, ":", ":" + (0, $84yE1.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $84yE1.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, "$1" + (0, $84yE1.WEBKIT) + ((0, $84yE1.charat)(value, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + (0, $84yE1.WEBKIT) + "$2$3" + "$1" + (0, $84yE1.MS) + "$2box$3") + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $84yE1.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, /[svh]\w+-[tblr]{2}/, "tb") + value;
                // vertical-r(l)
                case 108:
                    return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, /[svh]\w+-[tblr]{2}/, "tb-rl") + value;
                // horizontal(-)tb
                case 45:
                    return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + (0, $84yE1.replace)(value, /[svh]\w+-[tblr]{2}/, "lr") + value;
            }
            return (0, $84yE1.WEBKIT) + value + (0, $84yE1.MS) + value + value;
    }
    return value;
}
var $f617b18df8ca3b86$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $84yE1.DECLARATION:
                element["return"] = $f617b18df8ca3b86$var$prefix(element.value, element.length);
                break;
            case 0, $84yE1.KEYFRAMES:
                return (0, $84yE1.serialize)([
                    (0, $84yE1.copy)(element, {
                        value: (0, $84yE1.replace)(element.value, "@", "@" + (0, $84yE1.WEBKIT))
                    })
                ], callback);
            case 0, $84yE1.RULESET:
                if (element.length) return (0, $84yE1.combine)(element.props, function(value) {
                    switch((0, $84yE1.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ":read-only":
                        case ":read-write":
                            return (0, $84yE1.serialize)([
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(read-\w+)/, ":" + (0, $84yE1.MOZ) + "$1")
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case "::placeholder":
                            return (0, $84yE1.serialize)([
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(plac\w+)/, ":" + (0, $84yE1.WEBKIT) + "input-$1")
                                    ]
                                }),
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(plac\w+)/, ":" + (0, $84yE1.MOZ) + "$1")
                                    ]
                                }),
                                (0, $84yE1.copy)(element, {
                                    props: [
                                        (0, $84yE1.replace)(value, /:(plac\w+)/, (0, $84yE1.MS) + "input-$1")
                                    ]
                                })
                            ], callback);
                    }
                    return "";
                });
        }
    }
};
var $f617b18df8ca3b86$var$defaultStylisPlugins = [
    $f617b18df8ca3b86$var$prefixer
];
var $f617b18df8ca3b86$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === "css") {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute("data-emotion");
            if (dataEmotionAttribute.indexOf(" ") === -1) return;
            document.head.appendChild(node);
            node.setAttribute("data-s", "");
        });
    }
    var stylisPlugins = options.stylisPlugins || $f617b18df8ca3b86$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + key + ' "]'), function(node) {
        var attrib = node.getAttribute("data-emotion").split(" "); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $f617b18df8ca3b86$var$compat,
        $f617b18df8ca3b86$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $84yE1.stringify),
        (0, $84yE1.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $84yE1.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $84yE1.serialize)((0, $84yE1.compile)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7zRTz.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("7zRTz", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", function () { return $58459bc1bdd8093b$export$9d753cd7ae895cce; });
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $58459bc1bdd8093b$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $58459bc1bdd8093b$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    tag.setAttribute("data-s", "");
    return tag;
}
var $58459bc1bdd8093b$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($58459bc1bdd8093b$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $58459bc1bdd8093b$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("84yE1", function(module, exports) {

$parcel$export(module.exports, "MS", function () { return $c008aa41b6750289$export$71ad59f2e432cfe8; });
$parcel$export(module.exports, "MOZ", function () { return $c008aa41b6750289$export$2c0f367103c8d01c; });
$parcel$export(module.exports, "WEBKIT", function () { return $c008aa41b6750289$export$39dfd62a25e0fe93; });
$parcel$export(module.exports, "RULESET", function () { return $c008aa41b6750289$export$aa3a2e812ca8570d; });
$parcel$export(module.exports, "DECLARATION", function () { return $c008aa41b6750289$export$527d108ccf083c2b; });
$parcel$export(module.exports, "KEYFRAMES", function () { return $c008aa41b6750289$export$b44a8529a35fcb60; });
$parcel$export(module.exports, "from", function () { return $c008aa41b6750289$export$6788812c4e6611e6; });
$parcel$export(module.exports, "hash", function () { return $c008aa41b6750289$export$d6af199866bfb566; });
$parcel$export(module.exports, "charat", function () { return $c008aa41b6750289$export$a9db5e087081082d; });
$parcel$export(module.exports, "match", function () { return $c008aa41b6750289$export$4659b591c19bdf3d; });
$parcel$export(module.exports, "replace", function () { return $c008aa41b6750289$export$77ad94ebf1c2b9ed; });
$parcel$export(module.exports, "indexof", function () { return $c008aa41b6750289$export$f8e21b1e77979a08; });
$parcel$export(module.exports, "strlen", function () { return $c008aa41b6750289$export$36776f635604f274; });
$parcel$export(module.exports, "combine", function () { return $c008aa41b6750289$export$1be1fc439b849fdf; });
$parcel$export(module.exports, "position", function () { return $c008aa41b6750289$export$5880b8b5730aff45; });
$parcel$export(module.exports, "copy", function () { return $c008aa41b6750289$export$784d13d8ee351f07; });
$parcel$export(module.exports, "next", function () { return $c008aa41b6750289$export$48cfd1e771a65c4f; });
$parcel$export(module.exports, "peek", function () { return $c008aa41b6750289$export$4d3fb11e950abb9e; });
$parcel$export(module.exports, "slice", function () { return $c008aa41b6750289$export$58adb3bec8346d0f; });
$parcel$export(module.exports, "token", function () { return $c008aa41b6750289$export$9e1725a4cfeada27; });
$parcel$export(module.exports, "alloc", function () { return $c008aa41b6750289$export$2de70f21292aac9e; });
$parcel$export(module.exports, "dealloc", function () { return $c008aa41b6750289$export$45918ac1574455b1; });
$parcel$export(module.exports, "delimit", function () { return $c008aa41b6750289$export$410ac95b9ec204b8; });
$parcel$export(module.exports, "compile", function () { return $c008aa41b6750289$export$ef7acd7185315e22; });
$parcel$export(module.exports, "serialize", function () { return $c008aa41b6750289$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "stringify", function () { return $c008aa41b6750289$export$fac44ee5b035f737; });
$parcel$export(module.exports, "middleware", function () { return $c008aa41b6750289$export$5a7767152ae0305f; });
$parcel$export(module.exports, "rulesheet", function () { return $c008aa41b6750289$export$38bcb760f1d4871c; });
var $c008aa41b6750289$export$71ad59f2e432cfe8 = "-ms-";
var $c008aa41b6750289$export$2c0f367103c8d01c = "-moz-";
var $c008aa41b6750289$export$39dfd62a25e0fe93 = "-webkit-";
var $c008aa41b6750289$export$a29989082612d0d9 = "comm";
var $c008aa41b6750289$export$aa3a2e812ca8570d = "rule";
var $c008aa41b6750289$export$527d108ccf083c2b = "decl";
var $c008aa41b6750289$export$d3d35020fa5b54f0 = "@page";
var $c008aa41b6750289$export$500415a86c544f73 = "@media";
var $c008aa41b6750289$export$a763edbf796b780a = "@import";
var $c008aa41b6750289$export$2790aeb8b4e5c826 = "@charset";
var $c008aa41b6750289$export$1cc683e23b84b133 = "@viewport";
var $c008aa41b6750289$export$9447a5efea57e862 = "@supports";
var $c008aa41b6750289$export$ef011b4e114b1fba = "@document";
var $c008aa41b6750289$export$6aad947bda0f3f46 = "@namespace";
var $c008aa41b6750289$export$b44a8529a35fcb60 = "@keyframes";
var $c008aa41b6750289$export$2c16de31893252e6 = "@font-face";
var $c008aa41b6750289$export$3d846dd52e150c6f = "@counter-style";
var $c008aa41b6750289$export$22314bfbb57653fe = "@font-feature-values";
var $c008aa41b6750289$export$d773506282b3cfe6 = "@layer";
var $c008aa41b6750289$export$2335f513bbd82c6d = Math.abs;
var $c008aa41b6750289$export$6788812c4e6611e6 = String.fromCharCode;
var $c008aa41b6750289$export$e6e34fd1f2686227 = Object.assign;
function $c008aa41b6750289$export$d6af199866bfb566(e, r) {
    return $c008aa41b6750289$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 0)) << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 1)) << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 2)) << 2 ^ $c008aa41b6750289$export$a9db5e087081082d(e, 3) : 0;
}
function $c008aa41b6750289$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $c008aa41b6750289$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $c008aa41b6750289$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $c008aa41b6750289$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $c008aa41b6750289$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $c008aa41b6750289$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $c008aa41b6750289$export$36776f635604f274(e) {
    return e.length;
}
function $c008aa41b6750289$export$f9084667e487ed46(e) {
    return e.length;
}
function $c008aa41b6750289$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $c008aa41b6750289$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $c008aa41b6750289$export$53f1d5ea8de3d7c = 1;
var $c008aa41b6750289$export$4e0c71f277ca26b3 = 1;
var $c008aa41b6750289$export$f24224f1c91d8156 = 0;
var $c008aa41b6750289$export$5880b8b5730aff45 = 0;
var $c008aa41b6750289$export$c0306caf338ac095 = 0;
var $c008aa41b6750289$export$30a86d91af8ff6e6 = "";
function $c008aa41b6750289$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $c008aa41b6750289$export$53f1d5ea8de3d7c,
        column: $c008aa41b6750289$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $c008aa41b6750289$export$784d13d8ee351f07(e, r) {
    return $c008aa41b6750289$export$e6e34fd1f2686227($c008aa41b6750289$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $c008aa41b6750289$export$eba6f6f03b0a92e7() {
    return $c008aa41b6750289$export$c0306caf338ac095;
}
function $c008aa41b6750289$export$232faf9add678146() {
    $c008aa41b6750289$export$c0306caf338ac095 = $c008aa41b6750289$export$5880b8b5730aff45 > 0 ? $c008aa41b6750289$export$a9db5e087081082d($c008aa41b6750289$export$30a86d91af8ff6e6, --$c008aa41b6750289$export$5880b8b5730aff45) : 0;
    if ($c008aa41b6750289$export$4e0c71f277ca26b3--, $c008aa41b6750289$export$c0306caf338ac095 === 10) $c008aa41b6750289$export$4e0c71f277ca26b3 = 1, $c008aa41b6750289$export$53f1d5ea8de3d7c--;
    return $c008aa41b6750289$export$c0306caf338ac095;
}
function $c008aa41b6750289$export$48cfd1e771a65c4f() {
    $c008aa41b6750289$export$c0306caf338ac095 = $c008aa41b6750289$export$5880b8b5730aff45 < $c008aa41b6750289$export$f24224f1c91d8156 ? $c008aa41b6750289$export$a9db5e087081082d($c008aa41b6750289$export$30a86d91af8ff6e6, $c008aa41b6750289$export$5880b8b5730aff45++) : 0;
    if ($c008aa41b6750289$export$4e0c71f277ca26b3++, $c008aa41b6750289$export$c0306caf338ac095 === 10) $c008aa41b6750289$export$4e0c71f277ca26b3 = 1, $c008aa41b6750289$export$53f1d5ea8de3d7c++;
    return $c008aa41b6750289$export$c0306caf338ac095;
}
function $c008aa41b6750289$export$4d3fb11e950abb9e() {
    return $c008aa41b6750289$export$a9db5e087081082d($c008aa41b6750289$export$30a86d91af8ff6e6, $c008aa41b6750289$export$5880b8b5730aff45);
}
function $c008aa41b6750289$export$e88cb2efb12ae807() {
    return $c008aa41b6750289$export$5880b8b5730aff45;
}
function $c008aa41b6750289$export$58adb3bec8346d0f(e, r) {
    return $c008aa41b6750289$export$2f35ab04d2335697($c008aa41b6750289$export$30a86d91af8ff6e6, e, r);
}
function $c008aa41b6750289$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $c008aa41b6750289$export$2de70f21292aac9e(e) {
    return $c008aa41b6750289$export$53f1d5ea8de3d7c = $c008aa41b6750289$export$4e0c71f277ca26b3 = 1, $c008aa41b6750289$export$f24224f1c91d8156 = $c008aa41b6750289$export$36776f635604f274($c008aa41b6750289$export$30a86d91af8ff6e6 = e), $c008aa41b6750289$export$5880b8b5730aff45 = 0, [];
}
function $c008aa41b6750289$export$45918ac1574455b1(e) {
    return $c008aa41b6750289$export$30a86d91af8ff6e6 = "", e;
}
function $c008aa41b6750289$export$410ac95b9ec204b8(e) {
    return $c008aa41b6750289$export$87c2784dc9fc4ab($c008aa41b6750289$export$58adb3bec8346d0f($c008aa41b6750289$export$5880b8b5730aff45 - 1, $c008aa41b6750289$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $c008aa41b6750289$export$660b2ee2d4fb4eff(e) {
    return $c008aa41b6750289$export$45918ac1574455b1($c008aa41b6750289$export$5f8c09e3ae6f64e1($c008aa41b6750289$export$2de70f21292aac9e(e)));
}
function $c008aa41b6750289$export$7af1228ff777d175(e) {
    while($c008aa41b6750289$export$c0306caf338ac095 = $c008aa41b6750289$export$4d3fb11e950abb9e())if ($c008aa41b6750289$export$c0306caf338ac095 < 33) $c008aa41b6750289$export$48cfd1e771a65c4f();
    else break;
    return $c008aa41b6750289$export$9e1725a4cfeada27(e) > 2 || $c008aa41b6750289$export$9e1725a4cfeada27($c008aa41b6750289$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $c008aa41b6750289$export$5f8c09e3ae6f64e1(e) {
    while($c008aa41b6750289$export$48cfd1e771a65c4f())switch($c008aa41b6750289$export$9e1725a4cfeada27($c008aa41b6750289$export$c0306caf338ac095)){
        case 0:
            $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$c2ab62c7bf24634($c008aa41b6750289$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$410ac95b9ec204b8($c008aa41b6750289$export$c0306caf338ac095), e);
            break;
        default:
            $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$6788812c4e6611e6($c008aa41b6750289$export$c0306caf338ac095), e);
    }
    return e;
}
function $c008aa41b6750289$export$955ba06d119e085e(e, r) {
    while(--r && $c008aa41b6750289$export$48cfd1e771a65c4f())if ($c008aa41b6750289$export$c0306caf338ac095 < 48 || $c008aa41b6750289$export$c0306caf338ac095 > 102 || $c008aa41b6750289$export$c0306caf338ac095 > 57 && $c008aa41b6750289$export$c0306caf338ac095 < 65 || $c008aa41b6750289$export$c0306caf338ac095 > 70 && $c008aa41b6750289$export$c0306caf338ac095 < 97) break;
    return $c008aa41b6750289$export$58adb3bec8346d0f(e, $c008aa41b6750289$export$e88cb2efb12ae807() + (r < 6 && $c008aa41b6750289$export$4d3fb11e950abb9e() == 32 && $c008aa41b6750289$export$48cfd1e771a65c4f() == 32));
}
function $c008aa41b6750289$export$c889f2fcc19dbf12(e) {
    while($c008aa41b6750289$export$48cfd1e771a65c4f())switch($c008aa41b6750289$export$c0306caf338ac095){
        case e:
            return $c008aa41b6750289$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $c008aa41b6750289$export$c889f2fcc19dbf12($c008aa41b6750289$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $c008aa41b6750289$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $c008aa41b6750289$export$48cfd1e771a65c4f();
            break;
    }
    return $c008aa41b6750289$export$5880b8b5730aff45;
}
function $c008aa41b6750289$export$4254d4e2b3745c4c(e, r) {
    while($c008aa41b6750289$export$48cfd1e771a65c4f())if (e + $c008aa41b6750289$export$c0306caf338ac095 === 57) break;
    else if (e + $c008aa41b6750289$export$c0306caf338ac095 === 84 && $c008aa41b6750289$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $c008aa41b6750289$export$58adb3bec8346d0f(r, $c008aa41b6750289$export$5880b8b5730aff45 - 1) + "*" + $c008aa41b6750289$export$6788812c4e6611e6(e === 47 ? e : $c008aa41b6750289$export$48cfd1e771a65c4f());
}
function $c008aa41b6750289$export$c2ab62c7bf24634(e) {
    while(!$c008aa41b6750289$export$9e1725a4cfeada27($c008aa41b6750289$export$4d3fb11e950abb9e()))$c008aa41b6750289$export$48cfd1e771a65c4f();
    return $c008aa41b6750289$export$58adb3bec8346d0f(e, $c008aa41b6750289$export$5880b8b5730aff45);
}
function $c008aa41b6750289$export$ef7acd7185315e22(e) {
    return $c008aa41b6750289$export$45918ac1574455b1($c008aa41b6750289$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $c008aa41b6750289$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $c008aa41b6750289$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $c008aa41b6750289$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $c008aa41b6750289$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($c008aa41b6750289$export$f8e21b1e77979a08(j += $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $c008aa41b6750289$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $c008aa41b6750289$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $c008aa41b6750289$export$955ba06d119e085e($c008aa41b6750289$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($c008aa41b6750289$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$4a34f930e789283c($c008aa41b6750289$export$4254d4e2b3745c4c($c008aa41b6750289$export$48cfd1e771a65c4f(), $c008aa41b6750289$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $c008aa41b6750289$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $c008aa41b6750289$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $c008aa41b6750289$export$36776f635604f274(j) - l) $c008aa41b6750289$export$10d8903dec122b9d(p > 32 ? $c008aa41b6750289$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $c008aa41b6750289$export$f8483753829ec8f3($c008aa41b6750289$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $c008aa41b6750289$export$10d8903dec122b9d(y = $c008aa41b6750289$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $c008aa41b6750289$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $c008aa41b6750289$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $c008aa41b6750289$export$98e6a39c04603d36(e, y, y, n && $c008aa41b6750289$export$10d8903dec122b9d($c008aa41b6750289$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $c008aa41b6750289$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $c008aa41b6750289$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $c008aa41b6750289$export$232faf9add678146() == 125) continue;
            }
            switch(j += $c008aa41b6750289$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($c008aa41b6750289$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($c008aa41b6750289$export$4d3fb11e950abb9e() === 45) j += $c008aa41b6750289$export$410ac95b9ec204b8($c008aa41b6750289$export$48cfd1e771a65c4f());
                    v = $c008aa41b6750289$export$4d3fb11e950abb9e(), o = l = $c008aa41b6750289$export$36776f635604f274(g = j += $c008aa41b6750289$export$c2ab62c7bf24634($c008aa41b6750289$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $c008aa41b6750289$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $c008aa41b6750289$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $c008aa41b6750289$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $c008aa41b6750289$export$2f35ab04d2335697(e, v + 1, v = $c008aa41b6750289$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $c008aa41b6750289$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $c008aa41b6750289$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $c008aa41b6750289$export$35059013cd4a06db(e, r, a, s === 0 ? $c008aa41b6750289$export$aa3a2e812ca8570d : i, f, o, l);
}
function $c008aa41b6750289$export$4a34f930e789283c(e, r, a) {
    return $c008aa41b6750289$export$35059013cd4a06db(e, r, a, $c008aa41b6750289$export$a29989082612d0d9, $c008aa41b6750289$export$6788812c4e6611e6($c008aa41b6750289$export$eba6f6f03b0a92e7()), $c008aa41b6750289$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $c008aa41b6750289$export$f8483753829ec8f3(e, r, a, n) {
    return $c008aa41b6750289$export$35059013cd4a06db(e, r, a, $c008aa41b6750289$export$527d108ccf083c2b, $c008aa41b6750289$export$2f35ab04d2335697(e, 0, n), $c008aa41b6750289$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $c008aa41b6750289$export$82e9f45cca5ba907(n, c, s) {
    switch($c008aa41b6750289$export$d6af199866bfb566(n, c)){
        case 5103:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $c008aa41b6750289$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$2c0f367103c8d01c + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($c008aa41b6750289$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "box-$1$2" + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-item-" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$c008aa41b6750289$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $c008aa41b6750289$export$71ad59f2e432cfe8 + "grid-row-" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-line-pack" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + "box-" + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-grow", "") + $c008aa41b6750289$export$39dfd62a25e0fe93 + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $c008aa41b6750289$export$39dfd62a25e0fe93 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "box-pack:$3" + $c008aa41b6750289$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $c008aa41b6750289$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$c008aa41b6750289$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $c008aa41b6750289$export$71ad59f2e432cfe8 + "grid-column-align" + $c008aa41b6750289$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $c008aa41b6750289$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$c008aa41b6750289$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $c008aa41b6750289$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$c008aa41b6750289$export$f8e21b1e77979a08(s, "span") ? $c008aa41b6750289$export$4659b591c19bdf3d(s, /\d+/) : +$c008aa41b6750289$export$4659b591c19bdf3d(s, /\d+/) - +$c008aa41b6750289$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $c008aa41b6750289$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $c008aa41b6750289$export$71ad59f2e432cfe8 + $c008aa41b6750289$export$77ad94ebf1c2b9ed($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $c008aa41b6750289$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($c008aa41b6750289$export$36776f635604f274(n) - 1 - c > 6) switch($c008aa41b6750289$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($c008aa41b6750289$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $c008aa41b6750289$export$2c0f367103c8d01c + ($c008aa41b6750289$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$c008aa41b6750289$export$f8e21b1e77979a08(n, "stretch") ? $c008aa41b6750289$export$82e9f45cca5ba907($c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $c008aa41b6750289$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $c008aa41b6750289$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($c008aa41b6750289$export$a9db5e087081082d(n, c + 6) === 121) return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, ":", ":" + $c008aa41b6750289$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($c008aa41b6750289$export$a9db5e087081082d(n, $c008aa41b6750289$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + ($c008aa41b6750289$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $c008aa41b6750289$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, ":", ":" + $c008aa41b6750289$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $c008aa41b6750289$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $c008aa41b6750289$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $c008aa41b6750289$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $c008aa41b6750289$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $c008aa41b6750289$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $c008aa41b6750289$export$a763edbf796b780a:
        case $c008aa41b6750289$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $c008aa41b6750289$export$a29989082612d0d9:
            return "";
        case $c008aa41b6750289$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $c008aa41b6750289$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $c008aa41b6750289$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $c008aa41b6750289$export$36776f635604f274(a = $c008aa41b6750289$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $c008aa41b6750289$export$5a7767152ae0305f(e) {
    var r = $c008aa41b6750289$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $c008aa41b6750289$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $c008aa41b6750289$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $c008aa41b6750289$export$527d108ccf083c2b:
                n.return = $c008aa41b6750289$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $c008aa41b6750289$export$b44a8529a35fcb60:
                return $c008aa41b6750289$export$dfdc1655ccc5b9cb([
                    $c008aa41b6750289$export$784d13d8ee351f07(n, {
                        value: $c008aa41b6750289$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $c008aa41b6750289$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $c008aa41b6750289$export$aa3a2e812ca8570d:
                if (n.length) return $c008aa41b6750289$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($c008aa41b6750289$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $c008aa41b6750289$export$dfdc1655ccc5b9cb([
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $c008aa41b6750289$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $c008aa41b6750289$export$dfdc1655ccc5b9cb([
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c008aa41b6750289$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $c008aa41b6750289$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $c008aa41b6750289$export$784d13d8ee351f07(n, {
                                    props: [
                                        $c008aa41b6750289$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $c008aa41b6750289$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $c008aa41b6750289$export$76a88f7de6507443(e) {
    switch(e.type){
        case $c008aa41b6750289$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $c008aa41b6750289$export$1be1fc439b849fdf($c008aa41b6750289$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($c008aa41b6750289$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $c008aa41b6750289$export$2f35ab04d2335697(r, 1, $c008aa41b6750289$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $c008aa41b6750289$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $c008aa41b6750289$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $c008aa41b6750289$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

});

parcelRegister("1TDV2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1619e48fcd3745e5$export$2e2bcd8739ae039; });
var $1619e48fcd3745e5$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("knQRH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed6ef68b06ca0bb3$export$2e2bcd8739ae039; });
function $ed6ef68b06ca0bb3$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("46RMY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2fe172561ae78e4b$export$2e2bcd8739ae039; });

var $fiQA5 = parcelRequire("fiQA5");
// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $2fe172561ae78e4b$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(targetComponent, sourceComponent);
};

});

parcelRegister("7xLFM", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $57e0984ec08da152$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $57e0984ec08da152$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $57e0984ec08da152$export$6f077d94b33a01aa; });
var $57e0984ec08da152$var$isBrowser = true;
function $57e0984ec08da152$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $57e0984ec08da152$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $57e0984ec08da152$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $57e0984ec08da152$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $57e0984ec08da152$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cEdpu", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", function () { return $93539f6d1d0fd68d$export$6321afa313b251b5; });

var $23S62 = parcelRequire("23S62");

var $7Ug8O = parcelRequire("7Ug8O");

var $knQRH = parcelRequire("knQRH");
var $93539f6d1d0fd68d$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $93539f6d1d0fd68d$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $93539f6d1d0fd68d$var$hyphenateRegex = /[A-Z]|^ms/g;
var $93539f6d1d0fd68d$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $93539f6d1d0fd68d$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $93539f6d1d0fd68d$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $93539f6d1d0fd68d$var$processStyleName = /* #__PURE__ */ (0, $knQRH.default)(function(styleName) {
    return $93539f6d1d0fd68d$var$isCustomProperty(styleName) ? styleName : styleName.replace($93539f6d1d0fd68d$var$hyphenateRegex, "-$&").toLowerCase();
});
var $93539f6d1d0fd68d$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($93539f6d1d0fd68d$var$animationRegex, function(match, p1, p2) {
                $93539f6d1d0fd68d$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $93539f6d1d0fd68d$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7Ug8O.default)[key] !== 1 && !$93539f6d1d0fd68d$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $93539f6d1d0fd68d$var$contentValuePattern, $93539f6d1d0fd68d$var$contentValues, $93539f6d1d0fd68d$var$oldProcessStyleValue, $93539f6d1d0fd68d$var$msPattern, $93539f6d1d0fd68d$var$hyphenPattern, $93539f6d1d0fd68d$var$hyphenatedCache;
var $93539f6d1d0fd68d$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $93539f6d1d0fd68d$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $93539f6d1d0fd68d$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $93539f6d1d0fd68d$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $93539f6d1d0fd68d$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $93539f6d1d0fd68d$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $93539f6d1d0fd68d$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $93539f6d1d0fd68d$var$cursor;
                var result = interpolation(mergedProps);
                $93539f6d1d0fd68d$var$cursor = previousCursor;
                return $93539f6d1d0fd68d$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $93539f6d1d0fd68d$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $93539f6d1d0fd68d$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($93539f6d1d0fd68d$var$isProcessableValue(value)) string += $93539f6d1d0fd68d$var$processStyleName(_key) + ":" + $93539f6d1d0fd68d$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($93539f6d1d0fd68d$var$isProcessableValue(value[_i])) string += $93539f6d1d0fd68d$var$processStyleName(_key) + ":" + $93539f6d1d0fd68d$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $93539f6d1d0fd68d$var$handleInterpolation(mergedProps, registered, value);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $93539f6d1d0fd68d$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $93539f6d1d0fd68d$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $93539f6d1d0fd68d$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $93539f6d1d0fd68d$var$cursor;
var $93539f6d1d0fd68d$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $93539f6d1d0fd68d$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $93539f6d1d0fd68d$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $93539f6d1d0fd68d$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $93539f6d1d0fd68d$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $93539f6d1d0fd68d$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $23S62.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $93539f6d1d0fd68d$var$cursor
    };
};

});
parcelRegister("23S62", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1805d2fe0f3620a4$export$2e2bcd8739ae039; });
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $1805d2fe0f3620a4$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("7Ug8O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c1a48ae6a243c08$export$2e2bcd8739ae039; });
var $5c1a48ae6a243c08$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});


parcelRegister("gnKJq", function(module, exports) {

$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", function () { return $bed30b3dd07a523e$export$db21c7ffa21794e7; });
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", function () { return $bed30b3dd07a523e$export$811a713a7276cb9d; });

var $8ZuGG = parcelRequire("8ZuGG");
var $bed30b3dd07a523e$var$syncFallback = function syncFallback(create) {
    return create();
};
var $bed30b3dd07a523e$var$useInsertionEffect = $8ZuGG.useInsertionEffect ? $8ZuGG.useInsertionEffect : false;
var $bed30b3dd07a523e$export$db21c7ffa21794e7 = $bed30b3dd07a523e$var$useInsertionEffect || $bed30b3dd07a523e$var$syncFallback;
var $bed30b3dd07a523e$export$811a713a7276cb9d = $bed30b3dd07a523e$var$useInsertionEffect || $8ZuGG.useLayoutEffect;

});


parcelRegister("dLcU7", function(module, exports) {
function $a049aca429b9d120$var$_extends() {
    return module.exports = $a049aca429b9d120$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $a049aca429b9d120$var$_extends.apply(null, arguments);
}
module.exports = $a049aca429b9d120$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hUeXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d09345cda0eadd5a$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $d09345cda0eadd5a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)(null);

});

parcelRegister("kTdw7", function(module, exports) {

$parcel$export(module.exports, "R50", function () { return $f3536de48c65251d$export$4b84fd0e2c617bd; });
$parcel$export(module.exports, "R75", function () { return $f3536de48c65251d$export$b34b069eff244586; });
$parcel$export(module.exports, "R100", function () { return $f3536de48c65251d$export$be802dd0d8b57f35; });
$parcel$export(module.exports, "R200", function () { return $f3536de48c65251d$export$60847d42f9da92a6; });
$parcel$export(module.exports, "R300", function () { return $f3536de48c65251d$export$4a7404f376229999; });
$parcel$export(module.exports, "R400", function () { return $f3536de48c65251d$export$2010d0fb4295b346; });
$parcel$export(module.exports, "R500", function () { return $f3536de48c65251d$export$2837b5a1a71d5c02; });
$parcel$export(module.exports, "Y50", function () { return $f3536de48c65251d$export$8d9596b529bbb9cf; });
$parcel$export(module.exports, "Y75", function () { return $f3536de48c65251d$export$41060a744ab0b7ae; });
$parcel$export(module.exports, "Y100", function () { return $f3536de48c65251d$export$1cc05bbbf340e559; });
$parcel$export(module.exports, "Y200", function () { return $f3536de48c65251d$export$5aae31392d72caaa; });
$parcel$export(module.exports, "Y300", function () { return $f3536de48c65251d$export$c6930421db9fa514; });
$parcel$export(module.exports, "Y400", function () { return $f3536de48c65251d$export$59619663aa6500fb; });
$parcel$export(module.exports, "Y500", function () { return $f3536de48c65251d$export$874739ea9e379ab6; });
$parcel$export(module.exports, "G50", function () { return $f3536de48c65251d$export$8a6341c32b6a3ee6; });
$parcel$export(module.exports, "G75", function () { return $f3536de48c65251d$export$69a3bf21b9686c2b; });
$parcel$export(module.exports, "G100", function () { return $f3536de48c65251d$export$afbce1382ec95f73; });
$parcel$export(module.exports, "G200", function () { return $f3536de48c65251d$export$747d86715d4175de; });
$parcel$export(module.exports, "G300", function () { return $f3536de48c65251d$export$940e1f69e873f202; });
$parcel$export(module.exports, "G400", function () { return $f3536de48c65251d$export$a49394138f7b8e85; });
$parcel$export(module.exports, "G500", function () { return $f3536de48c65251d$export$6fa04827ac68a4fb; });
$parcel$export(module.exports, "B50", function () { return $f3536de48c65251d$export$226de0355ed012f8; });
$parcel$export(module.exports, "B75", function () { return $f3536de48c65251d$export$8c13c2ee36917869; });
$parcel$export(module.exports, "B100", function () { return $f3536de48c65251d$export$ecfc1dff386a3e7a; });
$parcel$export(module.exports, "B200", function () { return $f3536de48c65251d$export$215b7063051591f1; });
$parcel$export(module.exports, "B300", function () { return $f3536de48c65251d$export$e62e8919cca44969; });
$parcel$export(module.exports, "B400", function () { return $f3536de48c65251d$export$b3de0ae08da2ce64; });
$parcel$export(module.exports, "B500", function () { return $f3536de48c65251d$export$a6ee3d71bc067634; });
$parcel$export(module.exports, "P50", function () { return $f3536de48c65251d$export$363e4475840015bb; });
$parcel$export(module.exports, "P75", function () { return $f3536de48c65251d$export$4b0a4417ed59760f; });
$parcel$export(module.exports, "P100", function () { return $f3536de48c65251d$export$6011520a64d9a187; });
$parcel$export(module.exports, "P200", function () { return $f3536de48c65251d$export$a7175d4e9206bc80; });
$parcel$export(module.exports, "P300", function () { return $f3536de48c65251d$export$b48405b95304b5a1; });
$parcel$export(module.exports, "P400", function () { return $f3536de48c65251d$export$c71e4279dd54a18d; });
$parcel$export(module.exports, "P500", function () { return $f3536de48c65251d$export$147899de772240ec; });
$parcel$export(module.exports, "T50", function () { return $f3536de48c65251d$export$2cf711fe14c66f06; });
$parcel$export(module.exports, "T75", function () { return $f3536de48c65251d$export$7a8f4d33f6f9772c; });
$parcel$export(module.exports, "T100", function () { return $f3536de48c65251d$export$776c9c497ef08533; });
$parcel$export(module.exports, "T200", function () { return $f3536de48c65251d$export$69cb3ca10c1e330e; });
$parcel$export(module.exports, "T300", function () { return $f3536de48c65251d$export$9dc1ef0f3f48059b; });
$parcel$export(module.exports, "T400", function () { return $f3536de48c65251d$export$7c835c78b6fcdef8; });
$parcel$export(module.exports, "T500", function () { return $f3536de48c65251d$export$6036577f95c3877e; });
$parcel$export(module.exports, "N0", function () { return $f3536de48c65251d$export$29a4f05edc054374; });
$parcel$export(module.exports, "N10", function () { return $f3536de48c65251d$export$e655ef011c4aa1a2; });
$parcel$export(module.exports, "N20", function () { return $f3536de48c65251d$export$9fdfb749e33cdf97; });
$parcel$export(module.exports, "N30", function () { return $f3536de48c65251d$export$3e51e8f1440314ba; });
$parcel$export(module.exports, "N40", function () { return $f3536de48c65251d$export$1ce2d1575d444ceb; });
$parcel$export(module.exports, "N50", function () { return $f3536de48c65251d$export$8754fc7e6d8b3000; });
$parcel$export(module.exports, "N60", function () { return $f3536de48c65251d$export$c2e91cbeada39b8b; });
$parcel$export(module.exports, "N70", function () { return $f3536de48c65251d$export$5f71e19f3a7ad9de; });
$parcel$export(module.exports, "N80", function () { return $f3536de48c65251d$export$eaa8c8a70ac22806; });
$parcel$export(module.exports, "N90", function () { return $f3536de48c65251d$export$7c87d337fb91a97d; });
$parcel$export(module.exports, "N100", function () { return $f3536de48c65251d$export$d6447c357493214f; });
$parcel$export(module.exports, "N200", function () { return $f3536de48c65251d$export$f563ee71e9ee74cd; });
$parcel$export(module.exports, "N300", function () { return $f3536de48c65251d$export$e2ef2124cf4024b1; });
$parcel$export(module.exports, "N400", function () { return $f3536de48c65251d$export$eece5f492e429f08; });
$parcel$export(module.exports, "N500", function () { return $f3536de48c65251d$export$c39c0fe0f26207ae; });
$parcel$export(module.exports, "N600", function () { return $f3536de48c65251d$export$7090862dc3038a9f; });
$parcel$export(module.exports, "N700", function () { return $f3536de48c65251d$export$ad0bacf983b7ddaa; });
$parcel$export(module.exports, "N800", function () { return $f3536de48c65251d$export$7d61b15e0da132af; });
$parcel$export(module.exports, "N900", function () { return $f3536de48c65251d$export$fbda843f0a27fe96; });
$parcel$export(module.exports, "N10A", function () { return $f3536de48c65251d$export$791e57b27ca738ef; });
$parcel$export(module.exports, "N20A", function () { return $f3536de48c65251d$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $f3536de48c65251d$export$920c0d5c49070351; });
$parcel$export(module.exports, "N40A", function () { return $f3536de48c65251d$export$46987b49aab6d1a8; });
$parcel$export(module.exports, "N50A", function () { return $f3536de48c65251d$export$7d3359664e8bb0e5; });
$parcel$export(module.exports, "N60A", function () { return $f3536de48c65251d$export$d2d3bedfb276cac0; });
$parcel$export(module.exports, "N70A", function () { return $f3536de48c65251d$export$6e5e7499ff054f6d; });
$parcel$export(module.exports, "N80A", function () { return $f3536de48c65251d$export$59264b346c877fa7; });
$parcel$export(module.exports, "N90A", function () { return $f3536de48c65251d$export$d092757d7c64925c; });
$parcel$export(module.exports, "N100A", function () { return $f3536de48c65251d$export$486ab785e4bac3c6; });
$parcel$export(module.exports, "N200A", function () { return $f3536de48c65251d$export$fba592bbc6419fea; });
$parcel$export(module.exports, "N300A", function () { return $f3536de48c65251d$export$13609db0e6812ab8; });
$parcel$export(module.exports, "N400A", function () { return $f3536de48c65251d$export$fbae4efaa892d883; });
$parcel$export(module.exports, "N500A", function () { return $f3536de48c65251d$export$f13946d26f440ce6; });
$parcel$export(module.exports, "N600A", function () { return $f3536de48c65251d$export$19f58225ac52a306; });
$parcel$export(module.exports, "N700A", function () { return $f3536de48c65251d$export$6384f09da70e7b62; });
$parcel$export(module.exports, "N800A", function () { return $f3536de48c65251d$export$d0dccc730683edc2; });
$parcel$export(module.exports, "DN900", function () { return $f3536de48c65251d$export$2f6319cf7d736c2a; });
$parcel$export(module.exports, "DN800", function () { return $f3536de48c65251d$export$95126bc8884d6634; });
$parcel$export(module.exports, "DN700", function () { return $f3536de48c65251d$export$8338d8c35d44ff1; });
$parcel$export(module.exports, "DN600", function () { return $f3536de48c65251d$export$5368d76ae4fbbda7; });
$parcel$export(module.exports, "DN500", function () { return $f3536de48c65251d$export$9f0a771d16ec8d36; });
$parcel$export(module.exports, "DN400", function () { return $f3536de48c65251d$export$abcf8c38338b4aa5; });
$parcel$export(module.exports, "DN300", function () { return $f3536de48c65251d$export$97e81faa16a182c7; });
$parcel$export(module.exports, "DN200", function () { return $f3536de48c65251d$export$bfe21c59123ecf33; });
$parcel$export(module.exports, "DN100", function () { return $f3536de48c65251d$export$ee82aa2ea6a1558; });
$parcel$export(module.exports, "DN90", function () { return $f3536de48c65251d$export$682927c6ed76be02; });
$parcel$export(module.exports, "DN80", function () { return $f3536de48c65251d$export$91fd9994c5be9757; });
$parcel$export(module.exports, "DN70", function () { return $f3536de48c65251d$export$d281fbfe3cff2df6; });
$parcel$export(module.exports, "DN60", function () { return $f3536de48c65251d$export$3902c91d8b98a753; });
$parcel$export(module.exports, "DN50", function () { return $f3536de48c65251d$export$8e8133c1ba5845b5; });
$parcel$export(module.exports, "DN40", function () { return $f3536de48c65251d$export$33ff357f6620b39; });
$parcel$export(module.exports, "DN30", function () { return $f3536de48c65251d$export$633847cf062b69e0; });
$parcel$export(module.exports, "DN20", function () { return $f3536de48c65251d$export$9776a6e503bdbf76; });
$parcel$export(module.exports, "DN10", function () { return $f3536de48c65251d$export$6c813d5160dff5db; });
$parcel$export(module.exports, "DN0", function () { return $f3536de48c65251d$export$3d4f271a500072a; });
$parcel$export(module.exports, "DN800A", function () { return $f3536de48c65251d$export$fe151285c22759ec; });
$parcel$export(module.exports, "DN700A", function () { return $f3536de48c65251d$export$a101c6190d0da34; });
$parcel$export(module.exports, "DN600A", function () { return $f3536de48c65251d$export$4b16f52932fda51; });
$parcel$export(module.exports, "DN500A", function () { return $f3536de48c65251d$export$a74bcd7b9845b0d8; });
$parcel$export(module.exports, "DN400A", function () { return $f3536de48c65251d$export$9209c179316d1751; });
$parcel$export(module.exports, "DN300A", function () { return $f3536de48c65251d$export$88f55133f636c8dd; });
$parcel$export(module.exports, "DN200A", function () { return $f3536de48c65251d$export$51126f85d1009512; });
$parcel$export(module.exports, "DN100A", function () { return $f3536de48c65251d$export$a069b547bd23af78; });
$parcel$export(module.exports, "DN90A", function () { return $f3536de48c65251d$export$40cce05af3b2600a; });
$parcel$export(module.exports, "DN80A", function () { return $f3536de48c65251d$export$b78942185925a0d; });
$parcel$export(module.exports, "DN70A", function () { return $f3536de48c65251d$export$e058fb44b8eaafca; });
$parcel$export(module.exports, "DN60A", function () { return $f3536de48c65251d$export$92b0b8de26920c18; });
$parcel$export(module.exports, "DN50A", function () { return $f3536de48c65251d$export$67564f7459d3fc9e; });
$parcel$export(module.exports, "DN40A", function () { return $f3536de48c65251d$export$77868e1ca884ffa3; });
$parcel$export(module.exports, "DN30A", function () { return $f3536de48c65251d$export$2afd71d7d3ea2cd5; });
$parcel$export(module.exports, "DN20A", function () { return $f3536de48c65251d$export$f2a0acaab9972c70; });
$parcel$export(module.exports, "DN10A", function () { return $f3536de48c65251d$export$9ab70e67d6475361; });
$parcel$export(module.exports, "background", function () { return $f3536de48c65251d$export$8ce1fd94bee2f412; });
$parcel$export(module.exports, "backgroundActive", function () { return $f3536de48c65251d$export$b861914ea877b580; });
$parcel$export(module.exports, "backgroundHover", function () { return $f3536de48c65251d$export$3f1b020df94387af; });
$parcel$export(module.exports, "backgroundOnLayer", function () { return $f3536de48c65251d$export$c0183dbab98ca63e; });
$parcel$export(module.exports, "text", function () { return $f3536de48c65251d$export$6f093cfa640b7166; });
$parcel$export(module.exports, "textHover", function () { return $f3536de48c65251d$export$42f8e9c698766e7a; });
$parcel$export(module.exports, "textActive", function () { return $f3536de48c65251d$export$c2d157ca1c34b6e3; });
$parcel$export(module.exports, "subtleText", function () { return $f3536de48c65251d$export$1905ba28d7cf066f; });
$parcel$export(module.exports, "placeholderText", function () { return $f3536de48c65251d$export$bd9002130d306d39; });
$parcel$export(module.exports, "heading", function () { return $f3536de48c65251d$export$46e4a324ac90507f; });
$parcel$export(module.exports, "subtleHeading", function () { return $f3536de48c65251d$export$79f3f2b82beb0d36; });
$parcel$export(module.exports, "codeBlock", function () { return $f3536de48c65251d$export$7bb0d5c671655cc4; });
$parcel$export(module.exports, "link", function () { return $f3536de48c65251d$export$9c30223ca0a664fb; });
$parcel$export(module.exports, "linkHover", function () { return $f3536de48c65251d$export$7ed258b0728b004b; });
$parcel$export(module.exports, "linkActive", function () { return $f3536de48c65251d$export$dfa920d8decc8a59; });
$parcel$export(module.exports, "linkOutline", function () { return $f3536de48c65251d$export$6069e6ad5c78f632; });
$parcel$export(module.exports, "primary", function () { return $f3536de48c65251d$export$9ad721cf3b3debe0; });
$parcel$export(module.exports, "blue", function () { return $f3536de48c65251d$export$2aa0182783e7e9de; });
$parcel$export(module.exports, "teal", function () { return $f3536de48c65251d$export$8bf7dff220b82b4a; });
$parcel$export(module.exports, "purple", function () { return $f3536de48c65251d$export$e13cce2a2d16a9d4; });
$parcel$export(module.exports, "red", function () { return $f3536de48c65251d$export$a90204d1394caf30; });
$parcel$export(module.exports, "yellow", function () { return $f3536de48c65251d$export$594c5a8758200c32; });
$parcel$export(module.exports, "green", function () { return $f3536de48c65251d$export$955a2ebd2fb142ae; });
$parcel$export(module.exports, "skeleton", function () { return $f3536de48c65251d$export$2a0674ff2eb10214; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $gr7zj = parcelRequire("gr7zj");
var $f3536de48c65251d$export$4b84fd0e2c617bd = "#FFEBE6";
var $f3536de48c65251d$export$b34b069eff244586 = "#FFBDAD";
var $f3536de48c65251d$export$be802dd0d8b57f35 = "#FF8F73";
var $f3536de48c65251d$export$60847d42f9da92a6 = "#FF7452";
var $f3536de48c65251d$export$4a7404f376229999 = "#FF5630";
var $f3536de48c65251d$export$2010d0fb4295b346 = "#DE350B";
var $f3536de48c65251d$export$2837b5a1a71d5c02 = "#BF2600";
var $f3536de48c65251d$export$8d9596b529bbb9cf = "#FFFAE6";
var $f3536de48c65251d$export$41060a744ab0b7ae = "#FFF0B3";
var $f3536de48c65251d$export$1cc05bbbf340e559 = "#FFE380";
var $f3536de48c65251d$export$5aae31392d72caaa = "#FFC400";
var $f3536de48c65251d$export$c6930421db9fa514 = "#FFAB00";
var $f3536de48c65251d$export$59619663aa6500fb = "#FF991F";
var $f3536de48c65251d$export$874739ea9e379ab6 = "#FF8B00";
var $f3536de48c65251d$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $f3536de48c65251d$export$69a3bf21b9686c2b = "#ABF5D1";
var $f3536de48c65251d$export$afbce1382ec95f73 = "#79F2C0";
var $f3536de48c65251d$export$747d86715d4175de = "#57D9A3";
var $f3536de48c65251d$export$940e1f69e873f202 = "#36B37E";
var $f3536de48c65251d$export$a49394138f7b8e85 = "#00875A";
var $f3536de48c65251d$export$6fa04827ac68a4fb = "#006644";
var $f3536de48c65251d$export$226de0355ed012f8 = "#DEEBFF";
var $f3536de48c65251d$export$8c13c2ee36917869 = "#B3D4FF";
var $f3536de48c65251d$export$ecfc1dff386a3e7a = "#4C9AFF";
var $f3536de48c65251d$export$215b7063051591f1 = "#2684FF";
var $f3536de48c65251d$export$e62e8919cca44969 = "#0065FF";
var $f3536de48c65251d$export$b3de0ae08da2ce64 = "#0052CC";
var $f3536de48c65251d$export$a6ee3d71bc067634 = "#0747A6";
var $f3536de48c65251d$export$363e4475840015bb = "#EAE6FF";
var $f3536de48c65251d$export$4b0a4417ed59760f = "#C0B6F2";
var $f3536de48c65251d$export$6011520a64d9a187 = "#998DD9";
var $f3536de48c65251d$export$a7175d4e9206bc80 = "#8777D9";
var $f3536de48c65251d$export$b48405b95304b5a1 = "#6554C0";
var $f3536de48c65251d$export$c71e4279dd54a18d = "#5243AA";
var $f3536de48c65251d$export$147899de772240ec = "#403294";
var $f3536de48c65251d$export$2cf711fe14c66f06 = "#E6FCFF";
var $f3536de48c65251d$export$7a8f4d33f6f9772c = "#B3F5FF";
var $f3536de48c65251d$export$776c9c497ef08533 = "#79E2F2";
var $f3536de48c65251d$export$69cb3ca10c1e330e = "#00C7E6";
var $f3536de48c65251d$export$9dc1ef0f3f48059b = "#00B8D9";
var $f3536de48c65251d$export$7c835c78b6fcdef8 = "#00A3BF";
var $f3536de48c65251d$export$6036577f95c3877e = "#008DA6";
var $f3536de48c65251d$export$29a4f05edc054374 = "#FFFFFF";
var $f3536de48c65251d$export$e655ef011c4aa1a2 = "#FAFBFC";
var $f3536de48c65251d$export$9fdfb749e33cdf97 = "#F4F5F7";
var $f3536de48c65251d$export$3e51e8f1440314ba = "#EBECF0";
var $f3536de48c65251d$export$1ce2d1575d444ceb = "#DFE1E6";
var $f3536de48c65251d$export$8754fc7e6d8b3000 = "#C1C7D0";
var $f3536de48c65251d$export$c2e91cbeada39b8b = "#B3BAC5";
var $f3536de48c65251d$export$5f71e19f3a7ad9de = "#A5ADBA";
var $f3536de48c65251d$export$eaa8c8a70ac22806 = "#97A0AF";
var $f3536de48c65251d$export$7c87d337fb91a97d = "#8993A4";
var $f3536de48c65251d$export$d6447c357493214f = "#7A869A";
var $f3536de48c65251d$export$f563ee71e9ee74cd = "#6B778C";
var $f3536de48c65251d$export$e2ef2124cf4024b1 = "#5E6C84";
var $f3536de48c65251d$export$eece5f492e429f08 = "#505F79";
var $f3536de48c65251d$export$c39c0fe0f26207ae = "#42526E";
var $f3536de48c65251d$export$7090862dc3038a9f = "#344563";
var $f3536de48c65251d$export$ad0bacf983b7ddaa = "#253858";
var $f3536de48c65251d$export$7d61b15e0da132af = "#172B4D";
var $f3536de48c65251d$export$fbda843f0a27fe96 = "#091E42";
var $f3536de48c65251d$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $f3536de48c65251d$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $f3536de48c65251d$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $f3536de48c65251d$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $f3536de48c65251d$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $f3536de48c65251d$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $f3536de48c65251d$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $f3536de48c65251d$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $f3536de48c65251d$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $f3536de48c65251d$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $f3536de48c65251d$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $f3536de48c65251d$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $f3536de48c65251d$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $f3536de48c65251d$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $f3536de48c65251d$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $f3536de48c65251d$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $f3536de48c65251d$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $f3536de48c65251d$export$2f6319cf7d736c2a = "#E6EDFA";
var $f3536de48c65251d$export$95126bc8884d6634 = "#DCE5F5";
var $f3536de48c65251d$export$8338d8c35d44ff1 = "#CED9EB";
var $f3536de48c65251d$export$5368d76ae4fbbda7 = "#B8C7E0";
var $f3536de48c65251d$export$9f0a771d16ec8d36 = "#ABBBD6";
var $f3536de48c65251d$export$abcf8c38338b4aa5 = "#9FB0CC";
var $f3536de48c65251d$export$97e81faa16a182c7 = "#8C9CB8";
var $f3536de48c65251d$export$bfe21c59123ecf33 = "#7988A3";
var $f3536de48c65251d$export$ee82aa2ea6a1558 = "#67758F";
var $f3536de48c65251d$export$682927c6ed76be02 = "#56637A";
var $f3536de48c65251d$export$91fd9994c5be9757 = "#455166";
var $f3536de48c65251d$export$d281fbfe3cff2df6 = "#3B475C";
var $f3536de48c65251d$export$3902c91d8b98a753 = "#313D52";
var $f3536de48c65251d$export$8e8133c1ba5845b5 = "#283447";
var $f3536de48c65251d$export$33ff357f6620b39 = "#202B3D";
var $f3536de48c65251d$export$633847cf062b69e0 = "#1B2638";
var $f3536de48c65251d$export$9776a6e503bdbf76 = "#121A29";
var $f3536de48c65251d$export$6c813d5160dff5db = "#0E1624";
var $f3536de48c65251d$export$3d4f271a500072a = "#0D1424";
var $f3536de48c65251d$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $f3536de48c65251d$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $f3536de48c65251d$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $f3536de48c65251d$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $f3536de48c65251d$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $f3536de48c65251d$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $f3536de48c65251d$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $f3536de48c65251d$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $f3536de48c65251d$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $f3536de48c65251d$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $f3536de48c65251d$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $f3536de48c65251d$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $f3536de48c65251d$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $f3536de48c65251d$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $f3536de48c65251d$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $f3536de48c65251d$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $f3536de48c65251d$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";
var $f3536de48c65251d$export$8ce1fd94bee2f412 = (0, $gr7zj.default)({
    light: "var(--ds-surface, ".concat($f3536de48c65251d$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($f3536de48c65251d$export$633847cf062b69e0, ")")
});
var $f3536de48c65251d$export$b861914ea877b580 = (0, $gr7zj.default)({
    light: "var(--ds-background-selected, ".concat($f3536de48c65251d$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($f3536de48c65251d$export$8c13c2ee36917869, ")")
});
var $f3536de48c65251d$export$3f1b020df94387af = (0, $gr7zj.default)({
    light: "var(--ds-background-neutral-hovered, ".concat($f3536de48c65251d$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($f3536de48c65251d$export$d281fbfe3cff2df6, ")")
});
var $f3536de48c65251d$export$c0183dbab98ca63e = (0, $gr7zj.default)({
    light: "var(--ds-surface-overlay, ".concat($f3536de48c65251d$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($f3536de48c65251d$export$8e8133c1ba5845b5, ")")
});
var $f3536de48c65251d$export$6f093cfa640b7166 = (0, $gr7zj.default)({
    light: "var(--ds-text, ".concat($f3536de48c65251d$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($f3536de48c65251d$export$5368d76ae4fbbda7, ")")
});
var $f3536de48c65251d$export$42f8e9c698766e7a = (0, $gr7zj.default)({
    light: "var(--ds-text, ".concat($f3536de48c65251d$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($f3536de48c65251d$export$5368d76ae4fbbda7, ")")
});
var $f3536de48c65251d$export$c2d157ca1c34b6e3 = (0, $gr7zj.default)({
    light: "var(--ds-text-selected, ".concat($f3536de48c65251d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($f3536de48c65251d$export$b3de0ae08da2ce64, ")")
});
var $f3536de48c65251d$export$1905ba28d7cf066f = (0, $gr7zj.default)({
    light: "var(--ds-text-subtlest, ".concat($f3536de48c65251d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f3536de48c65251d$export$97e81faa16a182c7, ")")
});
var $f3536de48c65251d$export$bd9002130d306d39 = (0, $gr7zj.default)({
    light: "var(--ds-text-subtlest, ".concat($f3536de48c65251d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f3536de48c65251d$export$bfe21c59123ecf33, ")")
});
var $f3536de48c65251d$export$46e4a324ac90507f = (0, $gr7zj.default)({
    light: "var(--ds-text, ".concat($f3536de48c65251d$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($f3536de48c65251d$export$5368d76ae4fbbda7, ")")
});
var $f3536de48c65251d$export$79f3f2b82beb0d36 = (0, $gr7zj.default)({
    light: "var(--ds-text-subtlest, ".concat($f3536de48c65251d$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($f3536de48c65251d$export$97e81faa16a182c7, ")")
});
var $f3536de48c65251d$export$7bb0d5c671655cc4 = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$9fdfb749e33cdf97,
    dark: $f3536de48c65251d$export$8e8133c1ba5845b5
});
var $f3536de48c65251d$export$9c30223ca0a664fb = (0, $gr7zj.default)({
    light: "var(--ds-link, ".concat($f3536de48c65251d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($f3536de48c65251d$export$ecfc1dff386a3e7a, ")")
});
var $f3536de48c65251d$export$7ed258b0728b004b = (0, $gr7zj.default)({
    light: "var(--ds-link-pressed, ".concat($f3536de48c65251d$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($f3536de48c65251d$export$215b7063051591f1, ")")
});
var $f3536de48c65251d$export$dfa920d8decc8a59 = (0, $gr7zj.default)({
    light: "var(--ds-link-pressed, ".concat($f3536de48c65251d$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($f3536de48c65251d$export$ecfc1dff386a3e7a, ")")
});
var $f3536de48c65251d$export$6069e6ad5c78f632 = (0, $gr7zj.default)({
    light: "var(--ds-border-focused, ".concat($f3536de48c65251d$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($f3536de48c65251d$export$215b7063051591f1, ")")
});
var $f3536de48c65251d$export$9ad721cf3b3debe0 = (0, $gr7zj.default)({
    light: "var(--ds-background-brand-bold, ".concat($f3536de48c65251d$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($f3536de48c65251d$export$ecfc1dff386a3e7a, ")")
});
var $f3536de48c65251d$export$2aa0182783e7e9de = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$b3de0ae08da2ce64,
    dark: $f3536de48c65251d$export$ecfc1dff386a3e7a
});
var $f3536de48c65251d$export$8bf7dff220b82b4a = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$9dc1ef0f3f48059b,
    dark: $f3536de48c65251d$export$69cb3ca10c1e330e
});
var $f3536de48c65251d$export$e13cce2a2d16a9d4 = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$b48405b95304b5a1,
    dark: $f3536de48c65251d$export$6011520a64d9a187
});
var $f3536de48c65251d$export$a90204d1394caf30 = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$4a7404f376229999,
    dark: $f3536de48c65251d$export$4a7404f376229999
});
var $f3536de48c65251d$export$594c5a8758200c32 = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$c6930421db9fa514,
    dark: $f3536de48c65251d$export$c6930421db9fa514
});
var $f3536de48c65251d$export$955a2ebd2fb142ae = (0, $gr7zj.default)({
    light: $f3536de48c65251d$export$940e1f69e873f202,
    dark: $f3536de48c65251d$export$940e1f69e873f202
});
var $f3536de48c65251d$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($f3536de48c65251d$export$8d43898f60b96a82, ")");
};

});
parcelRegister("gr7zj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bf7509e6ef08428c$export$2e2bcd8739ae039; });
/* eslint-disable prefer-rest-params */ 
var $6hcAF = parcelRequire("6hcAF");
// Unpack custom variants, and get correct value for the current theme
function $bf7509e6ef08428c$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $6hcAF.default)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return "";
    };
}
function $bf7509e6ef08428c$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === "string") return $bf7509e6ef08428c$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $6hcAF.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return "";
    };
}

});
parcelRegister("6hcAF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $491e18d2ef84c906$export$2e2bcd8739ae039; });

var $5b7Z4 = parcelRequire("5b7Z4");
function $491e18d2ef84c906$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $5b7Z4.CHANNEL) in props.theme) return props.theme[0, $5b7Z4.CHANNEL];
        else if ("mode" in props.theme && (0, $5b7Z4.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $5b7Z4.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("5b7Z4", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", function () { return $3c542c43a726d225$export$44ffba16bd48dac6; });
$parcel$export(module.exports, "DEFAULT_THEME_MODE", function () { return $3c542c43a726d225$export$c93026a968943f95; });
$parcel$export(module.exports, "THEME_MODES", function () { return $3c542c43a726d225$export$6ba72c8346b4c57e; });
$parcel$export(module.exports, "borderRadius", function () { return $3c542c43a726d225$export$7a57f79000377ca2; });
$parcel$export(module.exports, "gridSize", function () { return $3c542c43a726d225$export$6d8204c2cb2e06b8; });
$parcel$export(module.exports, "fontSize", function () { return $3c542c43a726d225$export$85e3c3ca0c6fb93; });
$parcel$export(module.exports, "fontSizeSmall", function () { return $3c542c43a726d225$export$6746fe0d9c9fab54; });
$parcel$export(module.exports, "fontFamily", function () { return $3c542c43a726d225$export$a5975749f0374264; });
$parcel$export(module.exports, "codeFontFamily", function () { return $3c542c43a726d225$export$356129969ee49c55; });
$parcel$export(module.exports, "layers", function () { return $3c542c43a726d225$export$7be255094ccdc533; });

var $5pPqr = parcelRequire("5pPqr");

var $kTdw7 = parcelRequire("kTdw7");
var $3c542c43a726d225$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $3c542c43a726d225$export$c93026a968943f95 = "light";
var $3c542c43a726d225$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $3c542c43a726d225$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $3c542c43a726d225$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $3c542c43a726d225$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $3c542c43a726d225$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $3c542c43a726d225$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $3c542c43a726d225$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $3c542c43a726d225$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $kTdw7.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $3c542c43a726d225$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $3c542c43a726d225$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $3c542c43a726d225$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $3c542c43a726d225$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $3c542c43a726d225$export$ba1d834b86d72a09 = $3c542c43a726d225$export$a1b3edb637fb4f35;
var $3c542c43a726d225$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $kTdw7.skeleton)(), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $kTdw7.skeleton)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $kTdw7.N30A), ")")
            }
        }
    };
};

});
parcelRegister("5pPqr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f172d9224867a2e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "propDeprecationWarning", function () { return $3f172d9224867a2e$export$eb1decd851a5ae56; });

var $4w3PY = parcelRequire("4w3PY");

var $1RdT6 = parcelRequire("1RdT6");
function $3f172d9224867a2e$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $4w3PY.default)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $3f172d9224867a2e$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $1RdT6;
}

});
parcelRegister("4w3PY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $349d209b7f21e263$export$2e2bcd8739ae039; });
/* eslint-disable no-console */ var $349d209b7f21e263$var$printed = {};
function $349d209b7f21e263$export$2e2bcd8739ae039(message) {
    if ($349d209b7f21e263$var$printed[message]) return;
    $349d209b7f21e263$var$printed[message] = true;
    if (typeof window !== "undefined") console.warn(message);
}

});

parcelRegister("1RdT6", function(module, exports) {
// shim for using process in browser
var $15a583826a6f11e8$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $15a583826a6f11e8$var$cachedSetTimeout;
var $15a583826a6f11e8$var$cachedClearTimeout;
function $15a583826a6f11e8$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $15a583826a6f11e8$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $15a583826a6f11e8$var$cachedSetTimeout = setTimeout;
        else $15a583826a6f11e8$var$cachedSetTimeout = $15a583826a6f11e8$var$defaultSetTimout;
    } catch (e) {
        $15a583826a6f11e8$var$cachedSetTimeout = $15a583826a6f11e8$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $15a583826a6f11e8$var$cachedClearTimeout = clearTimeout;
        else $15a583826a6f11e8$var$cachedClearTimeout = $15a583826a6f11e8$var$defaultClearTimeout;
    } catch (e) {
        $15a583826a6f11e8$var$cachedClearTimeout = $15a583826a6f11e8$var$defaultClearTimeout;
    }
})();
function $15a583826a6f11e8$var$runTimeout(fun) {
    if ($15a583826a6f11e8$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($15a583826a6f11e8$var$cachedSetTimeout === $15a583826a6f11e8$var$defaultSetTimout || !$15a583826a6f11e8$var$cachedSetTimeout) && setTimeout) {
        $15a583826a6f11e8$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $15a583826a6f11e8$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $15a583826a6f11e8$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $15a583826a6f11e8$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $15a583826a6f11e8$var$runClearTimeout(marker) {
    if ($15a583826a6f11e8$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($15a583826a6f11e8$var$cachedClearTimeout === $15a583826a6f11e8$var$defaultClearTimeout || !$15a583826a6f11e8$var$cachedClearTimeout) && clearTimeout) {
        $15a583826a6f11e8$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $15a583826a6f11e8$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $15a583826a6f11e8$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $15a583826a6f11e8$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $15a583826a6f11e8$var$queue = [];
var $15a583826a6f11e8$var$draining = false;
var $15a583826a6f11e8$var$currentQueue;
var $15a583826a6f11e8$var$queueIndex = -1;
function $15a583826a6f11e8$var$cleanUpNextTick() {
    if (!$15a583826a6f11e8$var$draining || !$15a583826a6f11e8$var$currentQueue) return;
    $15a583826a6f11e8$var$draining = false;
    if ($15a583826a6f11e8$var$currentQueue.length) $15a583826a6f11e8$var$queue = $15a583826a6f11e8$var$currentQueue.concat($15a583826a6f11e8$var$queue);
    else $15a583826a6f11e8$var$queueIndex = -1;
    if ($15a583826a6f11e8$var$queue.length) $15a583826a6f11e8$var$drainQueue();
}
function $15a583826a6f11e8$var$drainQueue() {
    if ($15a583826a6f11e8$var$draining) return;
    var timeout = $15a583826a6f11e8$var$runTimeout($15a583826a6f11e8$var$cleanUpNextTick);
    $15a583826a6f11e8$var$draining = true;
    var len = $15a583826a6f11e8$var$queue.length;
    while(len){
        $15a583826a6f11e8$var$currentQueue = $15a583826a6f11e8$var$queue;
        $15a583826a6f11e8$var$queue = [];
        while(++$15a583826a6f11e8$var$queueIndex < len)if ($15a583826a6f11e8$var$currentQueue) $15a583826a6f11e8$var$currentQueue[$15a583826a6f11e8$var$queueIndex].run();
        $15a583826a6f11e8$var$queueIndex = -1;
        len = $15a583826a6f11e8$var$queue.length;
    }
    $15a583826a6f11e8$var$currentQueue = null;
    $15a583826a6f11e8$var$draining = false;
    $15a583826a6f11e8$var$runClearTimeout(timeout);
}
$15a583826a6f11e8$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $15a583826a6f11e8$var$queue.push(new $15a583826a6f11e8$var$Item(fun, args));
    if ($15a583826a6f11e8$var$queue.length === 1 && !$15a583826a6f11e8$var$draining) $15a583826a6f11e8$var$runTimeout($15a583826a6f11e8$var$drainQueue);
};
// v8 likes predictible objects
function $15a583826a6f11e8$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$15a583826a6f11e8$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$15a583826a6f11e8$var$process.title = "browser";
$15a583826a6f11e8$var$process.browser = true;
$15a583826a6f11e8$var$process.env = {};
$15a583826a6f11e8$var$process.argv = [];
$15a583826a6f11e8$var$process.version = ""; // empty string to avoid regexp issues
$15a583826a6f11e8$var$process.versions = {};
function $15a583826a6f11e8$var$noop() {}
$15a583826a6f11e8$var$process.on = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.addListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.once = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.off = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.removeListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.removeAllListeners = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.emit = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.prependListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.prependOnceListener = $15a583826a6f11e8$var$noop;
$15a583826a6f11e8$var$process.listeners = function(name) {
    return [];
};
$15a583826a6f11e8$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$15a583826a6f11e8$var$process.cwd = function() {
    return "/";
};
$15a583826a6f11e8$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$15a583826a6f11e8$var$process.umask = function() {
    return 0;
};

});






parcelRegister("jwMYJ", function(module, exports) {

$parcel$export(module.exports, "presetSizes", function () { return $e376ff99a5cfaeb8$export$4e9f1640bbe7a1a8; });
var $e376ff99a5cfaeb8$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};

});


parcelRegister("9Li6K", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $077a30f4e66457c5$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "UnexpectedApplicationErrorPage", function () { return $077a30f4e66457c5$export$4f726a446dcd19f1; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $lwBvV = parcelRequire("lwBvV");

var $7tB0e = parcelRequire("7tB0e");

var $gGDrC = parcelRequire("gGDrC");
class $077a30f4e66457c5$export$2e2bcd8739ae039 extends (0, $8ZuGG.Component) {
    componentDidCatch(error, errorInfo) {
        // Failed to fetch dynamically imported module:
        // Importing a module script failed.
        // error loading dynamically imported module:
        // Cannot find module
        if (/(import|find).*.module/i.test(error.message)) {
            this.setState({
                errorType: "network"
            });
            return;
        }
        this.setState({
            errorType: "unexpected"
        });
        const attributes = {
            errorName: error.name,
            errorMessage: error.message,
            errorComponentStack: errorInfo.componentStack || undefined,
            errorStack: error.stack
        };
        $lwBvV.withScope((scope)=>{
            Object.keys(errorInfo).forEach((key)=>{
                scope.setExtra(key, errorInfo[key]);
            });
            scope.setExtra("ErrorBoundary.action", "loadPageFailure");
            scope.setExtra("ErrorBoundary.pageId", $077a30f4e66457c5$export$2e2bcd8739ae039.pageId);
            Object.keys(attributes).forEach((key)=>{
                scope.setExtra(`ErrorBoundary.${key}`, attributes[key]);
            });
            $lwBvV.captureException(error);
        });
        this.props.analyticsClient.operationalEvent({
            page: $077a30f4e66457c5$export$2e2bcd8739ae039.pageId,
            action: "loadPageFailure",
            subject: "sli",
            attributes: attributes
        });
    }
    render() {
        const { errorType: errorType } = this.state;
        const anonymousId = this.props.analyticsClient.getAnonymousId();
        if (errorType === "network") return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.BaseErrorPage), {
            title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "error.boundary.error.title",
                defaultMessage: "Something went wrong"
            }),
            anonymousId: anonymousId,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "error.boundary.network.error",
                defaultMessage: "We were unable to load this page due to a network connectivity issue. Please check your network connection and try again.",
                tagName: "p"
            })
        });
        if (errorType === "unexpected") return /*#__PURE__*/ (0, $6rcps.jsx)($077a30f4e66457c5$export$4f726a446dcd19f1, {
            anonymousId: anonymousId
        });
        return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {};
    }
}
$077a30f4e66457c5$export$2e2bcd8739ae039.pageId = "unexpectedErrorPage";
const $077a30f4e66457c5$export$4f726a446dcd19f1 = ({ anonymousId: anonymousId })=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.BaseErrorPage), {
        title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "error.boundary.error.title",
            defaultMessage: "Something went wrong"
        }),
        anonymousId: anonymousId,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "error.boundary.unexpected.error",
            defaultMessage: "An unexpected error occurred. We are looking into it. Please try again later.",
            tagName: "p"
        })
    });

});
parcelRegister("lwBvV", function(module, exports) {

$parcel$export(module.exports, "captureException", function () { return $fab9af9c5ad20802$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureMessage", function () { return $fab9af9c5ad20802$export$45654777c133ae80; });
$parcel$export(module.exports, "captureEvent", function () { return $fab9af9c5ad20802$export$1462b974fdcf6ba2; });
$parcel$export(module.exports, "configureScope", function () { return $fab9af9c5ad20802$export$99d44f04437e9cb8; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $fab9af9c5ad20802$export$efda9a273d7a036d; });
$parcel$export(module.exports, "withScope", function () { return $fab9af9c5ad20802$export$ec58d9285c204497; });
$parcel$export(module.exports, "getCurrentScope", function () { return $fab9af9c5ad20802$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "getClient", function () { return $fab9af9c5ad20802$export$6bb76d6eba7e258c; });
$parcel$export(module.exports, "startSession", function () { return $fab9af9c5ad20802$export$c0d84948cecf78d8; });
$parcel$export(module.exports, "captureSession", function () { return $fab9af9c5ad20802$export$667e7b4d445d566b; });

var $h2E4a = parcelRequire("h2E4a");
var $h7OG0 = parcelRequire("h7OG0");
var $2GR2A = parcelRequire("2GR2A");
var $id9Yg = parcelRequire("id9Yg");
var $jc8x6 = parcelRequire("jc8x6");

var $1yNNB = parcelRequire("1yNNB");

var $dSDoS = parcelRequire("dSDoS");

var $ce2Qn = parcelRequire("ce2Qn");

var $36iHK = parcelRequire("36iHK");

var $auLrx = parcelRequire("auLrx");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $fab9af9c5ad20802$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().captureException(exception, (0, $auLrx.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $fab9af9c5ad20802$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === "string" ? captureContext : undefined;
    const context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $fab9af9c5ad20802$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $fab9af9c5ad20802$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $fab9af9c5ad20802$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $ce2Qn.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $fab9af9c5ad20802$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $ce2Qn.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $fab9af9c5ad20802$export$9a4fed82c350c2bd(callback) {
    return (0, $ce2Qn.runWithAsyncContext)(()=>{
        return callback((0, $ce2Qn.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $fab9af9c5ad20802$export$e57ac09b143d92a2(span, callback) {
    return $fab9af9c5ad20802$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $fab9af9c5ad20802$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fab9af9c5ad20802$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $fab9af9c5ad20802$export$c7be4b0125a10cba();
    const client = $fab9af9c5ad20802$export$6bb76d6eba7e258c();
    if (!client) (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Cannot capture check-in. No client defined.");
    else if (!client.captureCheckIn) (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Cannot capture check-in. Client does not support sending check-ins.");
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $jc8x6.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $fab9af9c5ad20802$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $fab9af9c5ad20802$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: "in_progress"
    }, upsertMonitorConfig);
    const now = (0, $id9Yg.timestampInSeconds)();
    function finishCheckIn(status) {
        $fab9af9c5ad20802$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $id9Yg.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn("error");
        throw e;
    }
    if ((0, $h7OG0.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn("ok");
    }, ()=>{
        finishCheckIn("error");
    });
    else finishCheckIn("ok");
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fab9af9c5ad20802$export$4909b86c8034bf73(timeout) {
    const client = $fab9af9c5ad20802$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Cannot flush events. No client defined.");
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $fab9af9c5ad20802$export$8360e631d277ea4d(timeout) {
    const client = $fab9af9c5ad20802$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Cannot flush events and disable SDK. No client defined.");
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $fab9af9c5ad20802$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $fab9af9c5ad20802$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $fab9af9c5ad20802$export$3f95c6f800b78024() {
    return !!$fab9af9c5ad20802$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $fab9af9c5ad20802$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $ce2Qn.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $fab9af9c5ad20802$export$c0d84948cecf78d8(context) {
    const client = $fab9af9c5ad20802$export$6bb76d6eba7e258c();
    const isolationScope = (0, $ce2Qn.getIsolationScope)();
    const currentScope = $fab9af9c5ad20802$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $1yNNB.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $h2E4a.GLOBAL_OBJ).navigator || {};
    const session = (0, $36iHK.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === "ok") (0, $36iHK.updateSession)(currentSession, {
        status: "exited"
    });
    $fab9af9c5ad20802$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $fab9af9c5ad20802$export$17a5be43989a0bc1() {
    const isolationScope = (0, $ce2Qn.getIsolationScope)();
    const currentScope = $fab9af9c5ad20802$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $36iHK.closeSession)(session);
    $fab9af9c5ad20802$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $fab9af9c5ad20802$var$_sendSessionUpdate() {
    const isolationScope = (0, $ce2Qn.getIsolationScope)();
    const currentScope = $fab9af9c5ad20802$export$c7be4b0125a10cba();
    const client = $fab9af9c5ad20802$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $fab9af9c5ad20802$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $fab9af9c5ad20802$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $fab9af9c5ad20802$var$_sendSessionUpdate();
}

});
parcelRegister("h2E4a", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", function () { return $c681b3e70fc1b628$export$f1a6cdb1459e81d1; });
$parcel$export(module.exports, "getGlobalObject", function () { return $c681b3e70fc1b628$export$256479dc0cea61c4; });
$parcel$export(module.exports, "getGlobalSingleton", function () { return $c681b3e70fc1b628$export$7e223ec222791509; });
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $c681b3e70fc1b628$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $c681b3e70fc1b628$export$f1a6cdb1459e81d1 = typeof globalThis == "object" && $c681b3e70fc1b628$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == "object" && $c681b3e70fc1b628$var$isGlobalObj(window) || typeof self == "object" && $c681b3e70fc1b628$var$isGlobalObj(self) || typeof $parcel$global == "object" && $c681b3e70fc1b628$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $c681b3e70fc1b628$export$256479dc0cea61c4() {
    return $c681b3e70fc1b628$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $c681b3e70fc1b628$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $c681b3e70fc1b628$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("h7OG0", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $c77a6664df7ee146$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $c77a6664df7ee146$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $c77a6664df7ee146$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $c77a6664df7ee146$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $c77a6664df7ee146$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $c77a6664df7ee146$export$844ec244b1367d54; });
$parcel$export(module.exports, "isParameterizedString", function () { return $c77a6664df7ee146$export$dbcbffa59149b824; });
$parcel$export(module.exports, "isPrimitive", function () { return $c77a6664df7ee146$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $c77a6664df7ee146$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $c77a6664df7ee146$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $c77a6664df7ee146$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $c77a6664df7ee146$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $c77a6664df7ee146$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $c77a6664df7ee146$export$bc2894c7158efbac; });
$parcel$export(module.exports, "isNaN", function () { return $c77a6664df7ee146$export$c9f5652083b8129d; });
$parcel$export(module.exports, "isVueViewModel", function () { return $c77a6664df7ee146$export$7916fad0ebc23f48; });
// eslint-disable-next-line @typescript-eslint/unbound-method
const $c77a6664df7ee146$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$e6127cc7fe7395c3(wat) {
    switch($c77a6664df7ee146$var$objectToString.call(wat)){
        case "[object Error]":
        case "[object Exception]":
        case "[object DOMException]":
            return true;
        default:
            return $c77a6664df7ee146$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$var$isBuiltin(wat, className) {
    return $c77a6664df7ee146$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$9f9636d330b71954(wat) {
    return $c77a6664df7ee146$var$isBuiltin(wat, "ErrorEvent");
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$ef9e2056653f0c8e(wat) {
    return $c77a6664df7ee146$var$isBuiltin(wat, "DOMError");
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$12e869b2a583f783(wat) {
    return $c77a6664df7ee146$var$isBuiltin(wat, "DOMException");
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$844ec244b1367d54(wat) {
    return $c77a6664df7ee146$var$isBuiltin(wat, "String");
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$dbcbffa59149b824(wat) {
    return typeof wat === "object" && wat !== null && "__sentry_template_string__" in wat && "__sentry_template_values__" in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$c3825b437cbdea5c(wat) {
    return wat === null || $c77a6664df7ee146$export$dbcbffa59149b824(wat) || typeof wat !== "object" && typeof wat !== "function";
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$53b83ca8eaab0383(wat) {
    return $c77a6664df7ee146$var$isBuiltin(wat, "Object");
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $c77a6664df7ee146$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $c77a6664df7ee146$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$49841c62b9eff15(wat) {
    return $c77a6664df7ee146$var$isBuiltin(wat, "RegExp");
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $c77a6664df7ee146$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$bc2894c7158efbac(wat) {
    return $c77a6664df7ee146$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$c9f5652083b8129d(wat) {
    return typeof wat === "number" && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $c77a6664df7ee146$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === "object" && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("2GR2A", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", function () { return $1f58a5c57353f167$export$2a2b1d2252a69ecb; });
$parcel$export(module.exports, "originalConsoleMethods", function () { return $1f58a5c57353f167$export$77c4ce905194557b; });
$parcel$export(module.exports, "consoleSandbox", function () { return $1f58a5c57353f167$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "logger", function () { return $1f58a5c57353f167$export$af88d00dbe7f521; });

var $fYUT5 = parcelRequire("fYUT5");

var $h2E4a = parcelRequire("h2E4a");
/** Prefix for logging strings */ const $1f58a5c57353f167$var$PREFIX = "Sentry Logger ";
const $1f58a5c57353f167$export$2a2b1d2252a69ecb = [
    "debug",
    "info",
    "warn",
    "error",
    "log",
    "assert",
    "trace"
];
/** This may be mutated by the console instrumentation. */ const $1f58a5c57353f167$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $1f58a5c57353f167$export$cda52e2a8927a2ca(callback) {
    if (!("console" in (0, $h2E4a.GLOBAL_OBJ))) return callback();
    const console = (0, $h2E4a.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($1f58a5c57353f167$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $1f58a5c57353f167$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $1f58a5c57353f167$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $fYUT5.DEBUG_BUILD) $1f58a5c57353f167$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $1f58a5c57353f167$export$cda52e2a8927a2ca(()=>{
                (0, $h2E4a.GLOBAL_OBJ).console[name](`${$1f58a5c57353f167$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $1f58a5c57353f167$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $1f58a5c57353f167$export$af88d00dbe7f521 = $1f58a5c57353f167$var$makeLogger();

});
parcelRegister("fYUT5", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $ba28964ebc58e799$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ba28964ebc58e799$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});


parcelRegister("id9Yg", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return $036be3d23f386e7a$export$7740643b9eeaf0c4; });
$parcel$export(module.exports, "timestampInSeconds", function () { return $036be3d23f386e7a$export$ee52dced521e3e18; });

var $h2E4a = parcelRequire("h2E4a");
const $036be3d23f386e7a$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $036be3d23f386e7a$export$7740643b9eeaf0c4() {
    return Date.now() / $036be3d23f386e7a$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $036be3d23f386e7a$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $h2E4a.GLOBAL_OBJ);
    if (!performance || !performance.now) return $036be3d23f386e7a$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $036be3d23f386e7a$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $036be3d23f386e7a$export$ee52dced521e3e18 = $036be3d23f386e7a$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $036be3d23f386e7a$export$c5907b5a8838db13 = $036be3d23f386e7a$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $036be3d23f386e7a$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $036be3d23f386e7a$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $h2E4a.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $036be3d23f386e7a$export$f9f8cce55af5194c = "none";
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === "number";
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $036be3d23f386e7a$export$f9f8cce55af5194c = "timeOrigin";
            return performance.timeOrigin;
        } else {
            $036be3d23f386e7a$export$f9f8cce55af5194c = "navigationStart";
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $036be3d23f386e7a$export$f9f8cce55af5194c = "dateNow";
    return dateNow;
})();

});

parcelRegister("jc8x6", function(module, exports) {

$parcel$export(module.exports, "uuid4", function () { return $df95c1c5089e15ab$export$19f53698e68b2496; });
$parcel$export(module.exports, "getEventDescription", function () { return $df95c1c5089e15ab$export$4157119e2b157127; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $df95c1c5089e15ab$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $df95c1c5089e15ab$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "checkOrSetAlreadyCaught", function () { return $df95c1c5089e15ab$export$6de4ffac6a2f1098; });
$parcel$export(module.exports, "arrayify", function () { return $df95c1c5089e15ab$export$3131421a7d01b4fb; });

var $h32bW = parcelRequire("h32bW");

var $l8auK = parcelRequire("l8auK");

var $h2E4a = parcelRequire("h2E4a");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $df95c1c5089e15ab$export$19f53698e68b2496() {
    const gbl = (0, $h2E4a.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, "");
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $df95c1c5089e15ab$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $df95c1c5089e15ab$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $df95c1c5089e15ab$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || "<unknown>";
    }
    return eventId || "<unknown>";
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $df95c1c5089e15ab$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || "";
    if (!firstException.type) firstException.type = type || "Error";
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $df95c1c5089e15ab$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $df95c1c5089e15ab$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: "generic",
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && "data" in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $df95c1c5089e15ab$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $df95c1c5089e15ab$export$d364f2020ab30578(input) {
    const match = input.match($df95c1c5089e15ab$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $df95c1c5089e15ab$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $l8auK.snipLine)(line, 0));
    frame.context_line = (0, $l8auK.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $l8auK.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $df95c1c5089e15ab$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $h32bW.addNonEnumerableProperty)(exception, "__sentry_captured__", true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $df95c1c5089e15ab$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("h32bW", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $c6946aaa509d103a$export$9563e054e6f787fb; });
$parcel$export(module.exports, "markFunctionWrapped", function () { return $c6946aaa509d103a$export$5c1499e2e5d010ae; });
$parcel$export(module.exports, "addNonEnumerableProperty", function () { return $c6946aaa509d103a$export$e73679ffaf56810e; });
$parcel$export(module.exports, "getOriginalFunction", function () { return $c6946aaa509d103a$export$e6cc1e135e2092e5; });
$parcel$export(module.exports, "urlEncode", function () { return $c6946aaa509d103a$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "convertToPlainObject", function () { return $c6946aaa509d103a$export$62ff257738bf57f5; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $c6946aaa509d103a$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $c6946aaa509d103a$export$d25f2688db1bb433; });

var $3VqIB = parcelRequire("3VqIB");

var $fYUT5 = parcelRequire("fYUT5");

var $h7OG0 = parcelRequire("h7OG0");

var $2GR2A = parcelRequire("2GR2A");

var $l8auK = parcelRequire("l8auK");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $c6946aaa509d103a$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") $c6946aaa509d103a$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $c6946aaa509d103a$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $fYUT5.DEBUG_BUILD) && (0, $2GR2A.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $c6946aaa509d103a$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $c6946aaa509d103a$export$e73679ffaf56810e(wrapped, "__sentry_original__", original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $c6946aaa509d103a$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $c6946aaa509d103a$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join("&");
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $c6946aaa509d103a$export$62ff257738bf57f5(value) {
    if ((0, $h7OG0.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$c6946aaa509d103a$var$getOwnProperties(value)
    };
    else if ((0, $h7OG0.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $c6946aaa509d103a$var$serializeEventTarget(value.target),
            currentTarget: $c6946aaa509d103a$var$serializeEventTarget(value.currentTarget),
            ...$c6946aaa509d103a$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== "undefined" && (0, $h7OG0.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $c6946aaa509d103a$var$serializeEventTarget(target) {
    try {
        return (0, $h7OG0.isElement)(target) ? (0, $3VqIB.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return "<unknown>";
    }
}
/** Filters out all but an object's own properties */ function $c6946aaa509d103a$var$getOwnProperties(obj) {
    if (typeof obj === "object" && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $c6946aaa509d103a$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($c6946aaa509d103a$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $l8auK.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $l8auK.truncate)(serialized, maxLength);
    }
    return "";
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $c6946aaa509d103a$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $c6946aaa509d103a$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $c6946aaa509d103a$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($c6946aaa509d103a$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== "undefined") returnValue[key] = $c6946aaa509d103a$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($c6946aaa509d103a$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $c6946aaa509d103a$var$isPojo(input) {
    if (!(0, $h7OG0.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === "Object";
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $c6946aaa509d103a$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === "symbol" || typeof wat === "bigint":
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $h7OG0.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("3VqIB", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $2dbb6bacc52a6703$export$5647df6b7814ac86; });
$parcel$export(module.exports, "getLocationHref", function () { return $2dbb6bacc52a6703$export$1cfafeee2987818b; });
$parcel$export(module.exports, "getComponentName", function () { return $2dbb6bacc52a6703$export$26727cfcc4d7e0fc; });

var $h7OG0 = parcelRequire("h7OG0");

var $h2E4a = parcelRequire("h2E4a");
// eslint-disable-next-line deprecation/deprecation
const $2dbb6bacc52a6703$var$WINDOW = (0, $h2E4a.getGlobalObject)();
const $2dbb6bacc52a6703$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2dbb6bacc52a6703$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return "<unknown>";
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = " > ";
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $2dbb6bacc52a6703$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $2dbb6bacc52a6703$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $2dbb6bacc52a6703$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return "";
    // @ts-expect-error WINDOW has HTMLElement
    if ($2dbb6bacc52a6703$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset["sentryComponent"]) return elem.dataset["sentryComponent"];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $h7OG0.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        "aria-label",
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join("");
}
/**
 * A safe form of location.href
 */ function $2dbb6bacc52a6703$export$1cfafeee2987818b() {
    try {
        return $2dbb6bacc52a6703$var$WINDOW.document.location.href;
    } catch (oO) {
        return "";
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2dbb6bacc52a6703$export$c660c1f3ab49225c(selector) {
    if ($2dbb6bacc52a6703$var$WINDOW.document && $2dbb6bacc52a6703$var$WINDOW.document.querySelector) return $2dbb6bacc52a6703$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $2dbb6bacc52a6703$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$2dbb6bacc52a6703$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset["sentryComponent"]) return currentElem.dataset["sentryComponent"];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("l8auK", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $f6227c66bd19b694$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $f6227c66bd19b694$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $f6227c66bd19b694$export$465e9d514283d4fd; });
$parcel$export(module.exports, "stringMatchesSomePattern", function () { return $f6227c66bd19b694$export$a7a5ec66062ea5d; });

var $h7OG0 = parcelRequire("h7OG0");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $f6227c66bd19b694$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $f6227c66bd19b694$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += " {snip}";
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $f6227c66bd19b694$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $h7OG0.isVueViewModel)(value)) output.push("[VueViewModel]");
            else output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $f6227c66bd19b694$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $h7OG0.isString)(value)) return false;
    if ((0, $h7OG0.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $h7OG0.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $f6227c66bd19b694$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$f6227c66bd19b694$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("1yNNB", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", function () { return $122f987b6e84c597$export$849dbeeeda01ae98; });
const $122f987b6e84c597$export$849dbeeeda01ae98 = "production";

});

parcelRegister("dSDoS", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $a1aee19402bbd439$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $a1aee19402bbd439$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("ce2Qn", function(module, exports) {

$parcel$export(module.exports, "getCurrentHub", function () { return $8e68ff8986a68878$export$a07cdf6544bbd7c; });
$parcel$export(module.exports, "getIsolationScope", function () { return $8e68ff8986a68878$export$68f3af03034c9e90; });
$parcel$export(module.exports, "runWithAsyncContext", function () { return $8e68ff8986a68878$export$70d775fb1f267027; });

var $2GR2A = parcelRequire("2GR2A");
var $id9Yg = parcelRequire("id9Yg");
var $h2E4a = parcelRequire("h2E4a");
var $h7OG0 = parcelRequire("h7OG0");
var $jc8x6 = parcelRequire("jc8x6");

var $1yNNB = parcelRequire("1yNNB");

var $dSDoS = parcelRequire("dSDoS");

var $oBNML = parcelRequire("oBNML");

var $36iHK = parcelRequire("36iHK");

var $a1ZBp = parcelRequire("a1ZBp");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $8e68ff8986a68878$export$24a86ef7798177e4 = parseFloat((0, $a1ZBp.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $8e68ff8986a68878$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $8e68ff8986a68878$export$8c41bb232f1008b1 {
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $h7OG0.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $jc8x6.uuid4)();
        const syntheticException = new Error("Sentry syntheticException");
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $jc8x6.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jc8x6.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $8e68ff8986a68878$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $id9Yg.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $2GR2A.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit("beforeAddBreadcrumb", finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $8e68ff8986a68878$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $8e68ff8986a68878$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod("startTransaction", context, customSamplingContext);
        if ((0, $dSDoS.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $2GR2A.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $2GR2A.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod("traceHeaders");
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $36iHK.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $1yNNB.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $h2E4a.GLOBAL_OBJ).navigator || {};
        const session = (0, $36iHK.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === "ok") (0, $36iHK.updateSession)(currentSession, {
            status: "exited"
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $8e68ff8986a68878$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $8e68ff8986a68878$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $oBNML.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $oBNML.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $8e68ff8986a68878$export$19eade501500c6c1() {
    (0, $h2E4a.GLOBAL_OBJ).__SENTRY__ = (0, $h2E4a.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $h2E4a.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $8e68ff8986a68878$export$4188a14ad302d1bc(hub) {
    const registry = $8e68ff8986a68878$export$19eade501500c6c1();
    const oldHub = $8e68ff8986a68878$export$bfa8a924a84a76b7(registry);
    $8e68ff8986a68878$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $8e68ff8986a68878$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $8e68ff8986a68878$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $8e68ff8986a68878$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $8e68ff8986a68878$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $8e68ff8986a68878$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $8e68ff8986a68878$var$getGlobalHub(registry = $8e68ff8986a68878$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$8e68ff8986a68878$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $8e68ff8986a68878$export$bfa8a924a84a76b7(registry).isOlderThan($8e68ff8986a68878$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $8e68ff8986a68878$export$849f05434e95d2f2(registry, new $8e68ff8986a68878$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $8e68ff8986a68878$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $8e68ff8986a68878$export$236689a79f5aa020(carrier, parent = $8e68ff8986a68878$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$8e68ff8986a68878$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $8e68ff8986a68878$export$bfa8a924a84a76b7(carrier).isOlderThan($8e68ff8986a68878$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $8e68ff8986a68878$export$849f05434e95d2f2(carrier, new $8e68ff8986a68878$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $8e68ff8986a68878$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $8e68ff8986a68878$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $8e68ff8986a68878$export$70d775fb1f267027(callback, options = {}) {
    const registry = $8e68ff8986a68878$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $8e68ff8986a68878$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $8e68ff8986a68878$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $h2E4a.getGlobalSingleton)("hub", ()=>new $8e68ff8986a68878$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $8e68ff8986a68878$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("oBNML", function(module, exports) {

$parcel$export(module.exports, "Scope", function () { return $049f90b18e8367c1$export$775b6bb06e53a214; });
$parcel$export(module.exports, "getGlobalScope", function () { return $049f90b18e8367c1$export$aa55d5ab8e05984f; });

var $id9Yg = parcelRequire("id9Yg");
var $h7OG0 = parcelRequire("h7OG0");
var $2GR2A = parcelRequire("2GR2A");
var $jc8x6 = parcelRequire("jc8x6");

var $4UoXr = parcelRequire("4UoXr");

var $36iHK = parcelRequire("36iHK");

var $l6HyN = parcelRequire("l6HyN");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $049f90b18e8367c1$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $049f90b18e8367c1$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $049f90b18e8367c1$export$775b6bb06e53a214 {
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $049f90b18e8367c1$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $049f90b18e8367c1$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $36iHK.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === "function" ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $049f90b18e8367c1$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $h7OG0.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $049f90b18e8367c1$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === "number" ? maxBreadcrumbs : $049f90b18e8367c1$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $id9Yg.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $l6HyN.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $4UoXr.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $4UoXr.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jc8x6.uuid4)();
        if (!this._client) {
            (0, $2GR2A.logger).warn("No client configured on scope - will not capture exception!");
            return eventId;
        }
        const syntheticException = new Error("Sentry syntheticException");
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jc8x6.uuid4)();
        if (!this._client) {
            (0, $2GR2A.logger).warn("No client configured on scope - will not capture message!");
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $jc8x6.uuid4)();
        if (!this._client) {
            (0, $2GR2A.logger).warn("No client configured on scope - will not capture event!");
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $049f90b18e8367c1$var$generatePropagationContext();
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $049f90b18e8367c1$export$aa55d5ab8e05984f() {
    if (!$049f90b18e8367c1$var$globalScope) $049f90b18e8367c1$var$globalScope = new $049f90b18e8367c1$export$775b6bb06e53a214();
    return $049f90b18e8367c1$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $049f90b18e8367c1$export$c83048efd17527d6(scope) {
    $049f90b18e8367c1$var$globalScope = scope;
}
function $049f90b18e8367c1$var$generatePropagationContext() {
    return {
        traceId: (0, $jc8x6.uuid4)(),
        spanId: (0, $jc8x6.uuid4)().substring(16)
    };
}

});
parcelRegister("4UoXr", function(module, exports) {

$parcel$export(module.exports, "getGlobalEventProcessors", function () { return $392fc07a70db65c0$export$3c4238858b85e8ac; });
$parcel$export(module.exports, "addGlobalEventProcessor", function () { return $392fc07a70db65c0$export$8e4e25f54d456511; });
$parcel$export(module.exports, "notifyEventProcessors", function () { return $392fc07a70db65c0$export$bf2a096c3e883e79; });

var $h2E4a = parcelRequire("h2E4a");
var $h7OG0 = parcelRequire("h7OG0");
var $2GR2A = parcelRequire("2GR2A");
var $a6X2M = parcelRequire("a6X2M");

var $dSDoS = parcelRequire("dSDoS");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $392fc07a70db65c0$export$3c4238858b85e8ac() {
    return (0, $h2E4a.getGlobalSingleton)("globalEventProcessors", ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $392fc07a70db65c0$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $392fc07a70db65c0$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $392fc07a70db65c0$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $a6X2M.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== "function") resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $dSDoS.DEBUG_BUILD) && processor.id && result === null && (0, $2GR2A.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $h7OG0.isThenable)(result)) result.then((final)=>$392fc07a70db65c0$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $392fc07a70db65c0$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("a6X2M", function(module, exports) {

$parcel$export(module.exports, "resolvedSyncPromise", function () { return $75c843cd50ec5a9c$export$1fda8aa4d135f8aa; });
$parcel$export(module.exports, "SyncPromise", function () { return $75c843cd50ec5a9c$export$6f292d4960313241; });
$parcel$export(module.exports, "rejectedSyncPromise", function () { return $75c843cd50ec5a9c$export$78e43115b553f358; });

var $h7OG0 = parcelRequire("h7OG0");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $75c843cd50ec5a9c$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($75c843cd50ec5a9c$var$States || ($75c843cd50ec5a9c$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $75c843cd50ec5a9c$export$1fda8aa4d135f8aa(value) {
    return new $75c843cd50ec5a9c$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $75c843cd50ec5a9c$export$78e43115b553f358(reason) {
    return new $75c843cd50ec5a9c$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $75c843cd50ec5a9c$export$6f292d4960313241 {
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $75c843cd50ec5a9c$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $75c843cd50ec5a9c$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($75c843cd50ec5a9c$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($75c843cd50ec5a9c$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $75c843cd50ec5a9c$var$States.PENDING) return;
            if ((0, $h7OG0.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $75c843cd50ec5a9c$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $75c843cd50ec5a9c$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $75c843cd50ec5a9c$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
    constructor(executor){
        $75c843cd50ec5a9c$export$6f292d4960313241.prototype.__init.call(this);
        $75c843cd50ec5a9c$export$6f292d4960313241.prototype.__init2.call(this);
        $75c843cd50ec5a9c$export$6f292d4960313241.prototype.__init3.call(this);
        $75c843cd50ec5a9c$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $75c843cd50ec5a9c$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
}

});


parcelRegister("36iHK", function(module, exports) {

$parcel$export(module.exports, "makeSession", function () { return $24207101a2c875ba$export$14a186326edbb264; });
$parcel$export(module.exports, "updateSession", function () { return $24207101a2c875ba$export$531818e825e774db; });
$parcel$export(module.exports, "closeSession", function () { return $24207101a2c875ba$export$56521d9ba90f62ee; });

var $h32bW = parcelRequire("h32bW");
var $id9Yg = parcelRequire("id9Yg");
var $jc8x6 = parcelRequire("jc8x6");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $24207101a2c875ba$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $id9Yg.timestampInSeconds)();
    const session = {
        sid: (0, $jc8x6.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: "ok",
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$24207101a2c875ba$var$sessionToJSON(session)
    };
    if (context) $24207101a2c875ba$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $24207101a2c875ba$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $id9Yg.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $jc8x6.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === "number") session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === "number") session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === "number") session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $24207101a2c875ba$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === "ok") context = {
        status: "exited"
    };
    $24207101a2c875ba$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $24207101a2c875ba$var$sessionToJSON(session) {
    return (0, $h32bW.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === "number" || typeof session.did === "string" ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("l6HyN", function(module, exports) {

$parcel$export(module.exports, "applyScopeDataToEvent", function () { return $f5dbf2aab00cd0fd$export$43988bc651a80216; });
$parcel$export(module.exports, "mergeScopeData", function () { return $f5dbf2aab00cd0fd$export$25ac7e259a513db4; });

var $jc8x6 = parcelRequire("jc8x6");
var $h32bW = parcelRequire("h32bW");

var $fBC4O = parcelRequire("fBC4O");

var $1RCKH = parcelRequire("1RCKH");

var $jeHIA = parcelRequire("jeHIA");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $f5dbf2aab00cd0fd$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $f5dbf2aab00cd0fd$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $f5dbf2aab00cd0fd$var$applySpanToEvent(event, span);
    $f5dbf2aab00cd0fd$var$applyFingerprintToEvent(event, fingerprint);
    $f5dbf2aab00cd0fd$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $f5dbf2aab00cd0fd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $f5dbf2aab00cd0fd$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $f5dbf2aab00cd0fd$export$b1a120a2871faa46(data, "extra", extra);
    $f5dbf2aab00cd0fd$export$b1a120a2871faa46(data, "tags", tags);
    $f5dbf2aab00cd0fd$export$b1a120a2871faa46(data, "user", user);
    $f5dbf2aab00cd0fd$export$b1a120a2871faa46(data, "contexts", contexts);
    $f5dbf2aab00cd0fd$export$b1a120a2871faa46(data, "sdkProcessingMetadata", sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $f5dbf2aab00cd0fd$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $f5dbf2aab00cd0fd$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $h32bW.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $h32bW.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $h32bW.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $h32bW.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $f5dbf2aab00cd0fd$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $f5dbf2aab00cd0fd$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $f5dbf2aab00cd0fd$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $jeHIA.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $1RCKH.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $fBC4O.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $jeHIA.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $f5dbf2aab00cd0fd$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $jc8x6.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("fBC4O", function(module, exports) {

$parcel$export(module.exports, "getDynamicSamplingContextFromClient", function () { return $b5c7d8f15b2b5366$export$366bad00d6815eed; });
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", function () { return $b5c7d8f15b2b5366$export$a117f995597e25df; });

var $h32bW = parcelRequire("h32bW");

var $1yNNB = parcelRequire("1yNNB");

var $lwBvV = parcelRequire("lwBvV");

var $1RCKH = parcelRequire("1RCKH");

var $jeHIA = parcelRequire("jeHIA");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $b5c7d8f15b2b5366$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $h32bW.dropUndefinedKeys)({
        environment: options.environment || (0, $1yNNB.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $b5c7d8f15b2b5366$export$a117f995597e25df(span) {
    const client = (0, $lwBvV.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $b5c7d8f15b2b5366$export$366bad00d6815eed((0, $jeHIA.spanToJSON)(span).trace_id || "", client, (0, $lwBvV.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $1RCKH.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $jeHIA.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== "url") dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $jeHIA.spanIsSampled)(txn));
    client.emit && client.emit("createDsc", dsc);
    return dsc;
}

});
parcelRegister("1RCKH", function(module, exports) {

$parcel$export(module.exports, "getRootSpan", function () { return $15b8cd0a5da53813$export$c4c6a79b1260ca1b; });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $15b8cd0a5da53813$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("jeHIA", function(module, exports) {

$parcel$export(module.exports, "spanToTraceContext", function () { return $e0113ca06551d220$export$46c6fbd1d265ebf0; });
$parcel$export(module.exports, "spanToJSON", function () { return $e0113ca06551d220$export$92d8c23565496537; });
$parcel$export(module.exports, "spanIsSampled", function () { return $e0113ca06551d220$export$5caecac1caaf3a71; });

var $h32bW = parcelRequire("h32bW");
var $3G4gf = parcelRequire("3G4gf");
var $id9Yg = parcelRequire("id9Yg");
// These are aligned with OpenTelemetry trace flags
const $e0113ca06551d220$export$208d5b368507fb8b = 0x0;
const $e0113ca06551d220$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $e0113ca06551d220$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $e0113ca06551d220$export$92d8c23565496537(span);
    return (0, $h32bW.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $e0113ca06551d220$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $e0113ca06551d220$export$5caecac1caaf3a71(span);
    return (0, $3G4gf.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $e0113ca06551d220$export$3f7581298f56c6d7(input) {
    if (typeof input === "number") return $e0113ca06551d220$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $e0113ca06551d220$var$ensureTimestampInSeconds(input.getTime());
    return (0, $id9Yg.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $e0113ca06551d220$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $e0113ca06551d220$export$92d8c23565496537(span) {
    if ($e0113ca06551d220$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === "function") // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $e0113ca06551d220$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === "function";
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $e0113ca06551d220$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $e0113ca06551d220$export$eb571cd9b5d98de8);
}

});
parcelRegister("3G4gf", function(module, exports) {

$parcel$export(module.exports, "generateSentryTraceHeader", function () { return $2ad89984bfafbc43$export$f35d907436da45cf; });

var $3lwsT = parcelRequire("3lwsT");

var $jc8x6 = parcelRequire("jc8x6");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $2ad89984bfafbc43$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $2ad89984bfafbc43$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($2ad89984bfafbc43$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === "1") parentSampled = true;
    else if (matches[3] === "0") parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $2ad89984bfafbc43$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $2ad89984bfafbc43$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $3lwsT.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $jc8x6.uuid4)(),
            spanId: (0, $jc8x6.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $jc8x6.uuid4)(),
            parentSpanId: parentSpanId || (0, $jc8x6.uuid4)().substring(16),
            spanId: (0, $jc8x6.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $2ad89984bfafbc43$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $2ad89984bfafbc43$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $3lwsT.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $jc8x6.uuid4)(),
        spanId: (0, $jc8x6.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $jc8x6.uuid4)(),
        parentSpanId: parentSpanId || (0, $jc8x6.uuid4)().substring(16),
        spanId: (0, $jc8x6.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $2ad89984bfafbc43$export$f35d907436da45cf(traceId = (0, $jc8x6.uuid4)(), spanId = (0, $jc8x6.uuid4)().substring(16), sampled) {
    let sampledString = "";
    if (sampled !== undefined) sampledString = sampled ? "-1" : "-0";
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("3lwsT", function(module, exports) {

$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", function () { return $26fc841f3840d610$export$5b96ee2c8421f107; });

var $fYUT5 = parcelRequire("fYUT5");

var $h7OG0 = parcelRequire("h7OG0");

var $2GR2A = parcelRequire("2GR2A");
const $26fc841f3840d610$export$9ca9946bd449ac06 = "baggage";
const $26fc841f3840d610$export$6e69537d67fa20f = "sentry-";
const $26fc841f3840d610$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $26fc841f3840d610$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $26fc841f3840d610$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $h7OG0.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $26fc841f3840d610$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $26fc841f3840d610$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($26fc841f3840d610$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($26fc841f3840d610$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $26fc841f3840d610$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$26fc841f3840d610$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $26fc841f3840d610$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $26fc841f3840d610$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(",").map((baggageEntry)=>baggageEntry.split("=").map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $26fc841f3840d610$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $26fc841f3840d610$export$bdd844ddb2def819) {
            (0, $fYUT5.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, "");
}

});






parcelRegister("a1ZBp", function(module, exports) {

$parcel$export(module.exports, "SDK_VERSION", function () { return $74d9c851bd138ada$export$31499a9cd224b78c; });
const $74d9c851bd138ada$export$31499a9cd224b78c = "7.118.0";

});


parcelRegister("auLrx", function(module, exports) {

$parcel$export(module.exports, "prepareEvent", function () { return $7a4181f304951cb5$export$2d67fb380bd11267; });
$parcel$export(module.exports, "parseEventHintOrCaptureContext", function () { return $7a4181f304951cb5$export$76b5f966996d1653; });

var $jc8x6 = parcelRequire("jc8x6");
var $id9Yg = parcelRequire("id9Yg");
var $h2E4a = parcelRequire("h2E4a");
var $6KYYx = parcelRequire("6KYYx");
var $l8auK = parcelRequire("l8auK");

var $1yNNB = parcelRequire("1yNNB");

var $4UoXr = parcelRequire("4UoXr");

var $oBNML = parcelRequire("oBNML");

var $l6HyN = parcelRequire("l6HyN");

var $jeHIA = parcelRequire("jeHIA");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $7a4181f304951cb5$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $jc8x6.uuid4)(),
        timestamp: event.timestamp || (0, $id9Yg.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $7a4181f304951cb5$var$applyClientOptions(prepared, options);
    $7a4181f304951cb5$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $7a4181f304951cb5$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $7a4181f304951cb5$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $jc8x6.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $oBNML.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $l6HyN.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $l6HyN.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $l6HyN.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $4UoXr.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $4UoXr.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $7a4181f304951cb5$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === "number" && normalizeDepth > 0) return $7a4181f304951cb5$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $7a4181f304951cb5$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!("environment" in event)) event.environment = "environment" in options ? environment : (0, $1yNNB.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $l8auK.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $l8auK.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $l8auK.truncate)(request.url, maxValueLength);
}
const $7a4181f304951cb5$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $7a4181f304951cb5$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $h2E4a.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $7a4181f304951cb5$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $7a4181f304951cb5$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $7a4181f304951cb5$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: "sourcemap",
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $7a4181f304951cb5$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $7a4181f304951cb5$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $6KYYx.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $6KYYx.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $6KYYx.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $6KYYx.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $6KYYx.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $jeHIA.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $6KYYx.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $7a4181f304951cb5$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $oBNML.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $7a4181f304951cb5$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($7a4181f304951cb5$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($7a4181f304951cb5$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $7a4181f304951cb5$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $oBNML.Scope) || typeof hint === "function";
}
const $7a4181f304951cb5$var$captureContextKeys = [
    "user",
    "level",
    "extra",
    "contexts",
    "tags",
    "fingerprint",
    "requestSession",
    "propagationContext"
];
function $7a4181f304951cb5$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$7a4181f304951cb5$var$captureContextKeys.includes(key));
}

});
parcelRegister("6KYYx", function(module, exports) {

$parcel$export(module.exports, "normalize", function () { return $4eb6566541c4b9e3$export$a3295358bff77e; });
$parcel$export(module.exports, "normalizeToSize", function () { return $4eb6566541c4b9e3$export$23fbbb20bed71033; });

var $h7OG0 = parcelRequire("h7OG0");

var $dltwJ = parcelRequire("dltwJ");

var $h32bW = parcelRequire("h32bW");

var $cd716 = parcelRequire("cd716");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4eb6566541c4b9e3$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $4eb6566541c4b9e3$export$588732934346abbf("", input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $4eb6566541c4b9e3$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $4eb6566541c4b9e3$export$a3295358bff77e(object, depth);
    if ($4eb6566541c4b9e3$var$jsonSize(normalized) > maxSize) return $4eb6566541c4b9e3$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $4eb6566541c4b9e3$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $dltwJ.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        "number",
        "boolean",
        "string"
    ].includes(typeof value) && !(0, $h7OG0.isNaN)(value)) return value;
    const stringified = $4eb6566541c4b9e3$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith("[object ")) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value["__sentry_skip_normalization__"]) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value["__sentry_override_normalization_depth__"] === "number" ? value["__sentry_override_normalization_depth__"] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace("object ", "");
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return "[Circular ~]";
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === "function") try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $4eb6566541c4b9e3$export$588732934346abbf("", jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $h32bW.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = "[MaxProperties ~]";
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $4eb6566541c4b9e3$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $4eb6566541c4b9e3$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
        if (key === "domainEmitter") return "[DomainEmitter]";
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== "undefined" && value === window) return "[Window]";
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== "undefined" && value === document) return "[Document]";
        if ((0, $h7OG0.isVueViewModel)(value)) return "[VueViewModel]";
        // React's SyntheticEvent thingy
        if ((0, $h7OG0.isSyntheticEvent)(value)) return "[SyntheticEvent]";
        if (typeof value === "number" && value !== value) return "[NaN]";
        if (typeof value === "function") return `[Function: ${(0, $cd716.getFunctionName)(value)}]`;
        if (typeof value === "symbol") return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === "bigint") return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $4eb6566541c4b9e3$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $4eb6566541c4b9e3$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : "null prototype";
}
/** Calculates bytes size of input string */ function $4eb6566541c4b9e3$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4eb6566541c4b9e3$var$jsonSize(value) {
    return $4eb6566541c4b9e3$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $4eb6566541c4b9e3$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, "/")// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, "\\$&");
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, "/").replace(/webpack:\/?/g, "") // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, "ig"), "app:///");
}

});
parcelRegister("dltwJ", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", function () { return $9b7423fbe579bc8c$export$8115b0b78e956ab3; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $9b7423fbe579bc8c$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === "function";
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("cd716", function(module, exports) {

$parcel$export(module.exports, "createStackParser", function () { return $8e3c244db4555454$export$a5739666fb2d03d4; });
$parcel$export(module.exports, "stackParserFromStackParserOptions", function () { return $8e3c244db4555454$export$1d5cf88b347146d4; });
$parcel$export(module.exports, "getFunctionName", function () { return $8e3c244db4555454$export$aad197c7121a6651; });

var $2moHm = parcelRequire("2moHm");
const $8e3c244db4555454$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $8e3c244db4555454$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $8e3c244db4555454$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $8e3c244db4555454$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split("\n");
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $8e3c244db4555454$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($8e3c244db4555454$var$WEBPACK_ERROR_REGEXP, "$1") : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $8e3c244db4555454$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $8e3c244db4555454$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $8e3c244db4555454$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $8e3c244db4555454$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $8e3c244db4555454$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($8e3c244db4555454$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($8e3c244db4555454$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || "")) localStack.pop();
    }
    return localStack.slice(0, $8e3c244db4555454$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || "?"
        }));
}
const $8e3c244db4555454$var$defaultFunctionName = "<anonymous>";
/**
 * Safely extract function name from itself
 */ function $8e3c244db4555454$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $8e3c244db4555454$var$defaultFunctionName;
        return fn.name || $8e3c244db4555454$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $8e3c244db4555454$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $8e3c244db4555454$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $2moHm.node)(getModule)
    ];
}

});
parcelRegister("2moHm", function(module, exports) {

$parcel$export(module.exports, "node", function () { return $1b80cb6c3dfb1d27$export$35059013cd4a06db; });
/**
 * Does this filename look like it's part of the app code?
 */ function $1b80cb6c3dfb1d27$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith("/") && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith(".") && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes("node_modules/");
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $1b80cb6c3dfb1d27$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf(".");
                if (functionName[methodStart - 1] === ".") methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf(".Module");
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === "<anonymous>") {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || "<anonymous>";
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith("file://") ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === "native";
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $1b80cb6c3dfb1d27$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("7tB0e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c735d48d28f3ba6d$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "BaseErrorPage", function () { return $c735d48d28f3ba6d$export$7ef2fc65256b3bd8; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $5v6A7 = parcelRequire("5v6A7");

var $kTdw7 = parcelRequire("kTdw7");

var $HBurV = parcelRequire("HBurV");

var $3ir1n = parcelRequire("3ir1n");
let $c735d48d28f3ba6d$var$_ = (t)=>t, $c735d48d28f3ba6d$var$t;
function $c735d48d28f3ba6d$export$2e2bcd8739ae039({ title: title, children: children }) {
    const anonymousId = (0, $3ir1n.useAnalyticsAnonymousId)();
    return /*#__PURE__*/ (0, $6rcps.jsx)($c735d48d28f3ba6d$export$7ef2fc65256b3bd8, {
        title: title,
        anonymousId: anonymousId,
        children: children
    });
}
function $c735d48d28f3ba6d$export$7ef2fc65256b3bd8({ title: title, anonymousId: anonymousId, children: children }) {
    return /*#__PURE__*/ (0, $6rcps.jsxs)($c735d48d28f3ba6d$var$ErrorContainer, {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5v6A7.AtlassianLogo), {
                size: "large",
                label: "Atlassian",
                textColor: (0, $kTdw7).B400,
                iconColor: (0, $kTdw7).B200,
                iconGradientStart: (0, $kTdw7).B400,
                iconGradientStop: (0, $kTdw7).B200
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                children: /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                    height: "150",
                    alt: "",
                    className: "error-image"
                })
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("h2", {
                className: "error-title",
                children: title
            }),
            !!children && /*#__PURE__*/ (0, $6rcps.jsx)("div", {
                className: "error-content",
                children: children
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("small", {
                className: "error-diagnostic-details",
                children: /*#__PURE__*/ (0, $6rcps.jsx)("code", {
                    children: anonymousId || "\u2014"
                })
            })
        ]
    });
}
const $c735d48d28f3ba6d$var$ErrorContainer = (0, $3XNKR.default).div($c735d48d28f3ba6d$var$t || ($c735d48d28f3ba6d$var$t = $c735d48d28f3ba6d$var$_`
  margin-right: auto;
  margin-left: auto;
  max-width: 900px;
  padding: 100px 10px 0px 10px;
  text-align: center;

  .error-image {
    padding: 24px 0px;
  }

  .error-title {
    padding-top: 0px;
  }

  .error-content {
    padding-top: 16px;
  }

  .error-action {
    padding-top: 24px;
  }

  .error-diagnostic-details {
    display: block;
    padding-top: 24px;
  }
`));

});
parcelRegister("3XNKR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e2d7a12e34bd1cd$export$2e2bcd8739ae039; });

var $6pyCD = parcelRequire("6pyCD");
parcelRequire("dLcU7");
parcelRequire("8ZuGG");
parcelRequire("55TnP");

parcelRequire("fGnKS");
parcelRequire("cEdpu");
parcelRequire("gnKJq");
var $2e2d7a12e34bd1cd$var$tags = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "tspan"
];
var $2e2d7a12e34bd1cd$export$2e2bcd8739ae039 = (0, $6pyCD.default).bind();
$2e2d7a12e34bd1cd$var$tags.forEach(function(tagName) {
    // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
    $2e2d7a12e34bd1cd$export$2e2bcd8739ae039[tagName] = $2e2d7a12e34bd1cd$export$2e2bcd8739ae039(tagName);
});

});
parcelRegister("6pyCD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4aafef1f82fb1e7b$export$2e2bcd8739ae039; });

var $6vRlT = parcelRequire("6vRlT");

var $8ZuGG = parcelRequire("8ZuGG");

var $55TnP = parcelRequire("55TnP");
parcelRequire("14VNY");
var $h0dfV = parcelRequire("h0dfV");

var $fGnKS = parcelRequire("fGnKS");

var $cEdpu = parcelRequire("cEdpu");

var $gnKJq = parcelRequire("gnKJq");
var $4aafef1f82fb1e7b$var$testOmitPropsOnStringTag = (0, $55TnP.default);
var $4aafef1f82fb1e7b$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== "theme";
};
var $4aafef1f82fb1e7b$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === "string" && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $4aafef1f82fb1e7b$var$testOmitPropsOnStringTag : $4aafef1f82fb1e7b$var$testOmitPropsOnComponent;
};
var $4aafef1f82fb1e7b$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== "function" && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $4aafef1f82fb1e7b$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $4aafef1f82fb1e7b$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $fGnKS.registerStyles)(cache, serialized, isStringTag);
    (0, $gnKJq.useInsertionEffectAlwaysWithSyncFallback)(function() {
        return (0, $fGnKS.insertStyles)(cache, serialized, isStringTag);
    });
    return null;
};
var $4aafef1f82fb1e7b$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $4aafef1f82fb1e7b$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $4aafef1f82fb1e7b$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp("as");
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $h0dfV.w)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = "";
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $8ZuGG.useContext((0, $h0dfV.T));
            }
            if (typeof props.className === "string") className = (0, $fGnKS.getRegisteredStyles)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $cEdpu.serializeStyles)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $4aafef1f82fb1e7b$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === "as") continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            newProps.ref = ref;
            return /*#__PURE__*/ $8ZuGG.createElement($8ZuGG.Fragment, null, /*#__PURE__*/ $8ZuGG.createElement($4aafef1f82fb1e7b$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === "string"
            }), /*#__PURE__*/ $8ZuGG.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === "string" ? baseTag : baseTag.displayName || baseTag.name || "Component") + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, "toString", {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, (0, $6vRlT.default)({}, options, nextOptions, {
                shouldForwardProp: $4aafef1f82fb1e7b$var$composeShouldForwardProps(Styled, nextOptions, true)
            })).apply(void 0, styles);
        };
        return Styled;
    };
};

});
parcelRegister("55TnP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3b58615cfbda0159$export$2e2bcd8739ae039; });

var $knQRH = parcelRequire("knQRH");
var $3b58615cfbda0159$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $3b58615cfbda0159$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $knQRH.default)(function(prop) {
    return $3b58615cfbda0159$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});

});

parcelRegister("fGnKS", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", function () { return $b6ad348918cb0c76$export$95d99596f328fd52; });
$parcel$export(module.exports, "registerStyles", function () { return $b6ad348918cb0c76$export$580009a5da2a8b4b; });
$parcel$export(module.exports, "insertStyles", function () { return $b6ad348918cb0c76$export$6f077d94b33a01aa; });
var $b6ad348918cb0c76$var$isBrowser = true;
function $b6ad348918cb0c76$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $b6ad348918cb0c76$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $b6ad348918cb0c76$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $b6ad348918cb0c76$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $b6ad348918cb0c76$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : "", current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});



parcelRegister("5v6A7", function(module, exports) {

$parcel$export(module.exports, "AtlassianLogo", function () { return $4014f3f29de65686$export$765cacec8b0843f3; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $4014f3f29de65686$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 198 32" focusable="false" aria-hidden="true" height="32" fill="none">\n      <path fill='.concat(colors.iconColor, ' d="M22.878 24.378 12.293 3.208c-.208-.458-.416-.541-.666-.541-.209 0-.459.083-.709.5-1.5 2.375-2.167 5.125-2.167 8 0 4.001 2.042 7.752 5.043 13.794.333.667.583.792 1.166.792h7.335c.542 0 .833-.208.833-.625 0-.208-.041-.333-.25-.75M7.501 14.377c-.833-1.25-1.083-1.334-1.292-1.334s-.333.083-.708.834L.208 24.46c-.166.334-.208.459-.208.625 0 .334.292.667.917.667h7.46c.5 0 .874-.416 1.083-1.208.25-1 .333-1.876.333-2.917 0-2.917-1.292-5.751-2.292-7.251z"/>\n      <path fill=').concat(colors.atlassianLogoTextColor, ' d="M107.447 10.828c0 2.972 1.345 5.308 6.795 6.37 3.185.707 3.893 1.203 3.893 2.265 0 1.061-.708 1.698-2.973 1.698-2.619 0-5.733-.92-7.785-2.123v4.813c1.627.778 3.751 1.698 7.785 1.698 5.662 0 7.856-2.548 7.856-6.228m0 .07c0-3.538-1.84-5.166-7.148-6.298-2.902-.637-3.61-1.274-3.61-2.194 0-1.133 1.062-1.628 2.973-1.628 2.335 0 4.6.708 6.794 1.698v-4.6c-1.557-.779-3.892-1.345-6.653-1.345-5.237 0-7.927 2.265-7.927 5.945m72.475-5.803v20.17h4.318V9.979l1.769 4.035 6.087 11.324h5.379V5.166h-4.247v13.022l-1.628-3.821-4.883-9.201zm-27.319 0h-4.671v20.17h4.671zm-10.05 14.154c0-3.538-1.841-5.166-7.149-6.298-2.902-.637-3.609-1.274-3.609-2.194 0-1.133 1.061-1.628 2.972-1.628 2.336 0 4.601.708 6.795 1.699v-4.6c-1.557-.78-3.893-1.346-6.653-1.346-5.238 0-7.927 2.265-7.927 5.946 0 2.972 1.344 5.308 6.794 6.37 3.185.707 3.893 1.203 3.893 2.264 0 1.062-.708 1.699-2.973 1.699-2.618 0-5.733-.92-7.785-2.123v4.812c1.628.779 3.751 1.699 7.785 1.699 5.592 0 7.857-2.548 7.857-6.3M71.069 5.166v20.17h9.625l1.486-4.387h-6.44V5.166zm-19.039 0v4.317h5.167v15.854h4.741V9.483h5.592V5.166zm-6.866 0h-6.157L32 25.336h5.379l.99-3.396c1.204.353 2.478.566 3.752.566s2.548-.213 3.751-.567l.991 3.398h5.379c-.07 0-7.078-20.171-7.078-20.171M42.05 18.259c-.92 0-1.77-.141-2.548-.354L42.05 9.13l2.548 8.776a9.6 9.6 0 0 1-2.548.354zM97.326 5.166H91.17l-7.078 20.17h5.38l.99-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.114 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a9.6 9.6 0 0 1-2.548.354m75.306-13.093h-6.157l-7.007 20.17h5.379l.991-3.396c1.203.353 2.477.566 3.751.566s2.548-.213 3.751-.567l.991 3.398h5.379zm-3.043 13.093c-.92 0-1.77-.141-2.548-.354l2.548-8.776 2.548 8.776a10 10 0 0 1-2.548.354"/>\n    </svg>');
    } else {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        return '\n      <svg viewBox="0 0 190 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n        <defs>\n          <linearGradient x1="99.684716%" y1="15.8138128%" x2="39.8444399%" y2="97.4388388%" id="'.concat(id, '">\n            <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n            <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n          </linearGradient>\n        </defs>\n        <g stroke="none" stroke-width="1" fill="').concat(colors.atlassianLogoTextColor, '" >\n          <path fill="url(#').concat(id, ')" d="M6.90502605,15.6123193 C6.76436383,15.4302139 6.53773035,15.3340846 6.30742588,15.35884 C6.0771214,15.3835955 5.876643,15.525635 5.7787929,15.7333781 L0.0719979599,27.0218487 C-0.0337056449,27.2310259 -0.0224063827,27.4794358 0.101860917,27.6783741 C0.226128216,27.8773125 0.445645594,27.9984148 0.68202605,27.9984369 L8.62844459,27.9984369 C8.88847261,28.0044096 9.12761649,27.8581627 9.23847268,27.6253781 C10.9526159,24.1210252 9.91378448,18.7926722 6.90502605,15.6123193 Z"></path>\n          <path fill="').concat(colors.iconColor, '" d="M11.0859556,5.33713587 C8.19309829,9.74089822 7.85921851,15.3267488 10.2073011,20.0371359 L14.0383488,27.6176065 C14.1538739,27.8462194 14.3900332,27.9906411 14.6483769,27.9906653 L22.5933685,27.9906653 C22.829749,27.9906431 23.0492663,27.8695408 23.1735336,27.6706025 C23.2978009,27.4716641 23.3091002,27.2232543 23.2033966,27.014077 C23.2033966,27.014077 12.5147056,5.8619594 12.2460792,5.33290058 C12.1377032,5.11315026 11.9118188,4.97410225 11.6646746,4.97500451 C11.4175304,4.97590676 11.1926893,5.11660025 11.0859556,5.33713587 L11.0859556,5.33713587 Z"></path>\n          <path d="M104.2774,14.3919316 C104.2774,17.1872257 105.588069,19.4065198 110.714802,20.3862846 C113.773504,21.0215787 114.414212,21.5100493 114.414212,22.5187551 C114.414212,23.4985198 113.772077,24.1327551 111.617715,24.1327551 C109.013896,24.0864379 106.462135,23.403307 104.189999,22.1442846 L104.189999,26.6972257 C105.733976,27.4465198 107.772754,28.2822846 111.559566,28.2822846 C116.919251,28.2822846 119.045788,25.9175787 119.045788,22.4033434 M119.045788,22.4033434 C119.045788,19.0892257 117.268858,17.5327551 112.25878,16.4668728 C109.491535,15.8615787 108.821574,15.2566375 108.821574,14.3919316 C108.821574,13.297814 109.811889,12.835814 111.646968,12.835814 C113.860906,12.835814 116.045591,13.4986375 118.113622,14.4208728 L118.113622,10.0691081 C116.130615,9.17615406 113.970906,8.73311319 111.792518,8.7724022 C106.840589,8.7724022 104.2774,10.9048728 104.2774,14.3919316" fill="inherit"></path>\n          <polygon fill="inherit" points="173.129997 9.07000017 173.129997 28.0038825 177.20791 28.0038825 177.20791 13.5657649 178.926691 17.3983531 184.694132 28.0038825 189.820865 28.0038825 189.820865 9.07000017 185.742952 9.07000017 185.742952 21.2891766 184.198975 17.7442355 179.567399 9.07000017"></polygon>\n          <rect fill="inherit" x="142.740005" y="9.07000017" width="4.45677247" height="18.9338824"></rect>\n          <path d="M137.600792,22.4033434 C137.600792,19.0892257 135.823862,17.5327551 130.813784,16.4668728 C128.046539,15.8615787 127.376579,15.2566375 127.376579,14.3919316 C127.376579,13.297814 128.366893,12.835814 130.201972,12.835814 C132.41591,12.835814 134.600595,13.4986375 136.668626,14.4208728 L136.668626,10.0691081 C134.685619,9.17615406 132.52591,8.73311319 130.347522,8.7724022 C125.395593,8.7724022 122.832404,10.9048728 122.832404,14.3919316 C122.832404,17.1872257 124.143073,19.4065198 129.269806,20.3862846 C132.328508,21.0215787 132.969216,21.5100493 132.969216,22.5187551 C132.969216,23.4985198 132.327081,24.1327551 130.172719,24.1327551 C127.568901,24.0864379 125.017139,23.403307 122.745003,22.1442846 L122.745003,26.6972257 C124.28898,27.4465198 126.327758,28.2822846 130.11457,28.2822846 C135.474256,28.2822846 137.600792,25.9175787 137.600792,22.4033434" fill="inherit"></path>\n          <polygon fill="inherit" points="69.6599979 9.07000017 69.6599979 28.0038825 78.8204081 28.0038825 80.2627142 23.9115296 74.1456665 23.9115296 74.1456665 9.07000017"></polygon>\n          <polygon fill="inherit" points="51.5549984 9.07000017 51.5549984 13.1620002 56.5069282 13.1620002 56.5069282 28.0038825 60.9925967 28.0038825 60.9925967 13.1620002 66.2941332 13.1620002 66.2941332 9.07000017"></polygon>\n          <path d="M45.0573091,9.07000017 L39.1785647,9.07000017 L32.5050001,28.0038825 L37.6014102,28.0038825 L38.5474889,24.815059 C40.877531,25.4919503 43.3551322,25.4919503 45.6851743,24.815059 L46.6312529,28.0038825 L51.7287333,28.0038825 L45.0573091,9.07000017 Z M42.1177585,21.4007061 C41.287584,21.4006584 40.4616854,21.2831148 39.6651602,21.0516472 L42.1177585,12.7889413 L44.5703569,21.0544708 C43.7736914,21.2849831 42.9477956,21.4015755 42.1177585,21.4007061 L42.1177585,21.4007061 Z" fill="inherit"></path>\n          <path d="M94.6019534,9.07000017 L88.7235658,9.07000017 L82.0500011,28.0038825 L87.1474815,28.0038825 L88.0935601,24.815059 C90.4236023,25.4919503 92.9012034,25.4919503 95.2312455,24.815059 L96.1773242,28.0038825 L101.274805,28.0038825 L94.6019534,9.07000017 Z M91.6627596,21.4007061 C90.8325851,21.4006584 90.0066865,21.2831148 89.2101613,21.0516472 L91.6627596,12.7889413 L94.1153579,21.0544708 C93.3186924,21.2849831 92.4927966,21.4015755 91.6627596,21.4007061 L91.6627596,21.4007061 Z" fill="inherit"></path>\n          <path d="M163.256954,9.07000017 L157.378566,9.07000017 L150.705002,28.0038825 L155.802482,28.0038825 L156.748561,24.815059 C159.078603,25.4919503 161.556204,25.4919503 163.886246,24.815059 L164.832325,28.0038825 L169.930162,28.0038825 L163.256954,9.07000017 Z M160.315977,21.4007061 C159.485802,21.4006584 158.659903,21.2831148 157.863378,21.0516472 L160.315977,12.7889413 L162.768575,21.0544708 C161.971909,21.2849831 161.146014,21.4015755 160.315977,21.4007061 L160.315977,21.4007061 Z" fill="inherit"></path>\n        </g>\n      </svg>');
    }
};
var $4014f3f29de65686$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Atlassian" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        svg: $4014f3f29de65686$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});
parcelRegister("ihgai", function(module, exports) {

$parcel$export(module.exports, "generateUID", function () { return $d4e65a8e39796d95$export$bdbb4cbb3078e58d; });
$parcel$export(module.exports, "uid", function () { return $d4e65a8e39796d95$export$e2a22331486dcca0; });
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $d4e65a8e39796d95$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $d4e65a8e39796d95$export$e2a22331486dcca0 = $d4e65a8e39796d95$export$bdbb4cbb3078e58d();

});

parcelRegister("kdKsS", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $eb891076d3ad27db$export$470e5c2be1411c89; });

var $d6jri = parcelRequire("d6jri");
function $eb891076d3ad27db$export$ba05d765b8392e5e(flagResolver) {
    (0, $d6jri.setBooleanResolver)(flagResolver);
}
function $eb891076d3ad27db$export$470e5c2be1411c89(name) {
    return (0, $d6jri.resolveBooleanFlag)(name);
}

});
parcelRegister("d6jri", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $989aea1fa09f10d6$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $989aea1fa09f10d6$export$6333b6aff9fc6275; });

var $iWGvy = parcelRequire("iWGvy");

var $1RdT6 = parcelRequire("1RdT6");
var $989aea1fa09f10d6$var$pkgName = "@atlaskit/platform-feature-flags";
var $989aea1fa09f10d6$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $989aea1fa09f10d6$var$hasProcessEnv = typeof $1RdT6 !== "undefined" && typeof $1RdT6.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $989aea1fa09f10d6$var$ENV_ENABLE_PLATFORM_FF = $989aea1fa09f10d6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $989aea1fa09f10d6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $989aea1fa09f10d6$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $989aea1fa09f10d6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $989aea1fa09f10d6$var$ENV_ENABLE_PLATFORM_FF || $989aea1fa09f10d6$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $989aea1fa09f10d6$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $989aea1fa09f10d6$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$989aea1fa09f10d6$var$globalVar[$989aea1fa09f10d6$export$7e41b1b2bdee3f98] = $989aea1fa09f10d6$var$globalVar[$989aea1fa09f10d6$export$7e41b1b2bdee3f98] || $989aea1fa09f10d6$var$DEFAULT_PFF_GLOBAL;
function $989aea1fa09f10d6$export$f2b591175b3e424c(resolver) {
    $989aea1fa09f10d6$var$globalVar[$989aea1fa09f10d6$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $989aea1fa09f10d6$export$6333b6aff9fc6275(flagKey) {
    if ($989aea1fa09f10d6$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $iWGvy.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $989aea1fa09f10d6$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $989aea1fa09f10d6$var$globalVar[$989aea1fa09f10d6$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("iWGvy", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $038f3418a1a5bd41$export$1c9f709888824e05; });
var $038f3418a1a5bd41$var$_ref, $038f3418a1a5bd41$var$_process, $038f3418a1a5bd41$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $038f3418a1a5bd41$var$TESTS_MODE = ($038f3418a1a5bd41$var$_ref = (globalThis === null || globalThis === void 0 || ($038f3418a1a5bd41$var$_process = globalThis.process) === null || $038f3418a1a5bd41$var$_process === void 0 || ($038f3418a1a5bd41$var$_process = $038f3418a1a5bd41$var$_process.env) === null || $038f3418a1a5bd41$var$_process === void 0 ? void 0 : $038f3418a1a5bd41$var$_process.JEST_WORKER_ID) !== undefined, $038f3418a1a5bd41$var$_ref !== void 0) ? $038f3418a1a5bd41$var$_ref : false;
var $038f3418a1a5bd41$var$DEBUG_MODE = !$038f3418a1a5bd41$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($038f3418a1a5bd41$var$_process2 = globalThis.process) === null || $038f3418a1a5bd41$var$_process2 === void 0 || ($038f3418a1a5bd41$var$_process2 = $038f3418a1a5bd41$var$_process2.env) === null || $038f3418a1a5bd41$var$_process2 === void 0 ? void 0 : $038f3418a1a5bd41$var$_process2.NODE_ENV) !== "production";
var $038f3418a1a5bd41$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$038f3418a1a5bd41$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});



parcelRegister("9XpDE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73fd830b04d9973a$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $6KhR5 = parcelRequire("6KhR5");

var $rG0so = parcelRequire("rG0so");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ var $73fd830b04d9973a$var$useThemeObserver = function useThemeObserver() {
    var _useState = (0, $8ZuGG.useState)((0, $6KhR5.default)()), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), theme = _useState2[0], setTheme = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        var observer = new (0, $rG0so.default)(function(theme) {
            return setTheme(theme);
        });
        observer.observe();
        return function() {
            return observer.disconnect();
        };
    }, []);
    return theme;
};
var $73fd830b04d9973a$export$2e2bcd8739ae039 = $73fd830b04d9973a$var$useThemeObserver;

});
parcelRegister("kg5sN", function(module, exports) {

var $lyp2R = parcelRequire("lyp2R");

var $6rVvO = parcelRequire("6rVvO");

var $2x5xA = parcelRequire("2x5xA");

var $aPRr2 = parcelRequire("aPRr2");
function $ebf98a36867d8032$var$_slicedToArray(r, e) {
    return $lyp2R(r) || $6rVvO(r, e) || $2x5xA(r, e) || $aPRr2();
}
module.exports = $ebf98a36867d8032$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("lyp2R", function(module, exports) {
function $fb10335f983b8360$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $fb10335f983b8360$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6rVvO", function(module, exports) {
function $0136394bddc77a25$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $0136394bddc77a25$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2x5xA", function(module, exports) {

var $hqFoN = parcelRequire("hqFoN");
function $1d82f61c5a84e354$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $hqFoN(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $hqFoN(r, a) : void 0;
    }
}
module.exports = $1d82f61c5a84e354$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("hqFoN", function(module, exports) {
function $cb04fa518a2bd634$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $cb04fa518a2bd634$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("aPRr2", function(module, exports) {
function $7e381de30a43b6c0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7e381de30a43b6c0$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6KhR5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e94e3a1851e6841$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $bDRHl = parcelRequire("bDRHl");

var $icabj = parcelRequire("icabj");

var $juoNE = parcelRequire("juoNE");
function $4e94e3a1851e6841$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e94e3a1851e6841$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e94e3a1851e6841$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e94e3a1851e6841$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4e94e3a1851e6841$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $icabj.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $4e94e3a1851e6841$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $bDRHl.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $bDRHl.THEME_DATA_ATTRIBUTE)) || "";
    return $4e94e3a1851e6841$var$_objectSpread($4e94e3a1851e6841$var$_objectSpread({}, (0, $juoNE.themeStringToObject)(theme)), $4e94e3a1851e6841$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $4e94e3a1851e6841$export$2e2bcd8739ae039 = $4e94e3a1851e6841$var$getGlobalTheme;

});
parcelRegister("6bkHe", function(module, exports) {

var $ew1M2 = parcelRequire("ew1M2");
function $4803d2fd1087824c$var$_defineProperty(e, r, t) {
    return (r = $ew1M2(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $4803d2fd1087824c$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ew1M2", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $a9156e1677ad8f90$var$_typeof = $cd8Dz.default;

var $laBp3 = parcelRequire("laBp3");
function $a9156e1677ad8f90$var$toPropertyKey(t) {
    var i = $laBp3(t, "string");
    return "symbol" == $a9156e1677ad8f90$var$_typeof(i) ? i : i + "";
}
module.exports = $a9156e1677ad8f90$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("cd8Dz", function(module, exports) {
function $8e3d661f96587760$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $8e3d661f96587760$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8e3d661f96587760$var$_typeof(o);
}
module.exports = $8e3d661f96587760$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("laBp3", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $f6978ba3dabac565$var$_typeof = $cd8Dz.default;
function $f6978ba3dabac565$var$toPrimitive(t, r) {
    if ("object" != $f6978ba3dabac565$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f6978ba3dabac565$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $f6978ba3dabac565$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("bDRHl", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $879cfd9098b1225a$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $879cfd9098b1225a$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", function () { return $879cfd9098b1225a$export$2112803007239c61; });
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", function () { return $879cfd9098b1225a$export$352e418ed5b6193a; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $879cfd9098b1225a$export$dddac1532e822863; });
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", function () { return $879cfd9098b1225a$export$9d7b58831ae93caa; });
var $879cfd9098b1225a$export$4ef52930e33717cd = "data-theme";
var $879cfd9098b1225a$export$a00eac3f8684bcd0 = "data-color-mode";
var $879cfd9098b1225a$export$2112803007239c61 = "data-contrast-mode";
var $879cfd9098b1225a$export$352e418ed5b6193a = "data-custom-theme";
var $879cfd9098b1225a$export$2faeed762aac6741 = "light";
var $879cfd9098b1225a$export$6f0c6fb8c80fcc92 = "ds";
var $879cfd9098b1225a$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $879cfd9098b1225a$export$dddac1532e822863 = "--".concat($879cfd9098b1225a$export$6f0c6fb8c80fcc92, "-token-not-found");
var $879cfd9098b1225a$export$9d7b58831ae93caa = "--".concat($879cfd9098b1225a$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("icabj", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $d3f13ec9455b1634$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $d3f13ec9455b1634$export$7d43e72a58e3283f; });
$parcel$export(module.exports, "themeStateDefaults", function () { return $d3f13ec9455b1634$export$9aedcfa7336a207; });
$parcel$export(module.exports, "default", function () { return $d3f13ec9455b1634$export$2e2bcd8739ae039; });
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ var $d3f13ec9455b1634$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $d3f13ec9455b1634$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $d3f13ec9455b1634$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $d3f13ec9455b1634$export$ba8a43b83ecc69f8 = [];
var $d3f13ec9455b1634$export$92ba366331403db2 = [].concat($d3f13ec9455b1634$export$7d43e72a58e3283f, $d3f13ec9455b1634$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $d3f13ec9455b1634$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $d3f13ec9455b1634$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $d3f13ec9455b1634$export$2e2bcd8739ae039 = $d3f13ec9455b1634$var$themeConfig;

});

parcelRegister("juoNE", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $e3040e69abf4c83a$export$f19b488f7c0547ee; });
$parcel$export(module.exports, "themeObjectToString", function () { return $e3040e69abf4c83a$export$62c37ab81302621a; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kg5sN = parcelRequire("kg5sN");

var $icabj = parcelRequire("icabj");
var $e3040e69abf4c83a$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $e3040e69abf4c83a$var$customThemeOptions = "UNSAFE_themeOptions";
var $e3040e69abf4c83a$var$isThemeKind = function isThemeKind(themeKind) {
    return $e3040e69abf4c83a$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $e3040e69abf4c83a$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $icabj.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $e3040e69abf4c83a$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $e3040e69abf4c83a$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $e3040e69abf4c83a$var$isColorMode(id)) themeObject[kind] = id;
        if ($e3040e69abf4c83a$var$isThemeKind(kind) && $e3040e69abf4c83a$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $e3040e69abf4c83a$var$customThemeOptions) try {
            themeObject[$e3040e69abf4c83a$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $e3040e69abf4c83a$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $e3040e69abf4c83a$var$isColorMode(id) || // custom theme state
        kind === $e3040e69abf4c83a$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(id) === "object" || // other theme states
        $e3040e69abf4c83a$var$isThemeKind(kind) && typeof id === "string" && $e3040e69abf4c83a$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});


parcelRegister("rG0so", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05331b5240b91af4$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $bDRHl = parcelRequire("bDRHl");

var $6KhR5 = parcelRequire("6KhR5");
/**
 * A MutationObserver which watches the `<html>` element for changes to the theme.
 *
 * In React, use the {@link useThemeObserver `useThemeObserver`} hook instead.
 *
 * @param {function} callback - A callback function which fires when the theme changes.
 *
 * @example
 * ```
 * const observer = new ThemeMutationObserver((theme) => {});
 * observer.observe();
 * ```
 */ var $05331b5240b91af4$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ThemeMutationObserver(callback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ThemeMutationObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "legacyObserver", null);
        this.callback = callback;
        ThemeMutationObserver.callbacks.add(callback);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ThemeMutationObserver, [
        {
            key: "observe",
            value: function observe() {
                if (!ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer = new MutationObserver(function() {
                        var theme = (0, $6KhR5.default)();
                        ThemeMutationObserver.callbacks.forEach(function(callback) {
                            return callback(theme);
                        });
                    });
                    // Observer only needs to be configured once
                    ThemeMutationObserver.observer.observe(document.documentElement, {
                        attributeFilter: [
                            (0, $bDRHl.THEME_DATA_ATTRIBUTE),
                            (0, $bDRHl.COLOR_MODE_ATTRIBUTE)
                        ]
                    });
                }
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                if (this.callback) ThemeMutationObserver.callbacks.delete(this.callback);
                if (ThemeMutationObserver.callbacks.size === 0 && ThemeMutationObserver.observer) {
                    ThemeMutationObserver.observer.disconnect();
                    ThemeMutationObserver.observer = null;
                }
            }
        }
    ]);
    return ThemeMutationObserver;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($05331b5240b91af4$export$2e2bcd8739ae039, "observer", null);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($05331b5240b91af4$export$2e2bcd8739ae039, "callbacks", new Set());

});
parcelRegister("kD1JK", function(module, exports) {
function $f048cc14fcf93c3c$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $f048cc14fcf93c3c$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fhRQI", function(module, exports) {

var $ew1M2 = parcelRequire("ew1M2");
function $b21236dcd6ad9443$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $ew1M2(o.key), o);
    }
}
function $b21236dcd6ad9443$var$_createClass(e, r, t) {
    return r && $b21236dcd6ad9443$var$_defineProperties(e.prototype, r), t && $b21236dcd6ad9443$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $b21236dcd6ad9443$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("azw9d", function(module, exports) {

$parcel$export(module.exports, "defaultLogoParams", function () { return $7b261c23a21b46e2$export$438460117ae6b7ee; });
$parcel$export(module.exports, "sizes", function () { return $7b261c23a21b46e2$export$c647cb0ee6e282fe; });
/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $7b261c23a21b46e2$export$438460117ae6b7ee = {
    iconColor: "inherit",
    iconGradientStart: "inherit",
    iconGradientStop: "inherit",
    label: "",
    size: "medium",
    textColor: "currentColor"
};
var $7b261c23a21b46e2$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $7b261c23a21b46e2$export$31d7044b7540a6d8 = $7b261c23a21b46e2$export$438460117ae6b7ee;

});

parcelRegister("czQZy", function(module, exports) {

$parcel$export(module.exports, "getColorsFromAppearanceOldLogos", function () { return $9281dc00800b5ccc$export$362a25f017e2bc8a; });
$parcel$export(module.exports, "getColorsFromAppearance", function () { return $9281dc00800b5ccc$export$bbacc3980e0f3029; });
$parcel$export(module.exports, "getColorsForLoom", function () { return $9281dc00800b5ccc$export$7818df200941dbbf; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $kTdw7 = parcelRequire("kTdw7");
var $9281dc00800b5ccc$export$362a25f017e2bc8a = function getColorsFromAppearanceOldLogos(appearance) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case "brand":
            iconGradientStart = (0, $kTdw7.B400);
            iconGradientStop = (0, $kTdw7.B200);
            iconColor = (0, $kTdw7.B200);
            textColor = "var(--ds-text, ".concat((0, $kTdw7.N800), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $kTdw7.B400);
            break;
        case "neutral":
            iconGradientStart = (0, $kTdw7.N600);
            iconGradientStop = (0, $kTdw7.N100);
            iconColor = (0, $kTdw7.N100);
            textColor = (0, $kTdw7.N400);
            atlassianLogoTextColor = (0, $kTdw7.N400);
            break;
        case "inverse":
            iconGradientStart = (0, $kTdw7.N50);
            iconGradientStop = (0, $kTdw7.N0);
            iconColor = (0, $kTdw7.N0);
            textColor = "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")");
            atlassianLogoTextColor = "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")");
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $9281dc00800b5ccc$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance, colorMode) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#357DE8";
            textColor = "#E2E3E4";
            atlassianLogoTextColor = "#357DE8";
            break;
        case "neutral":
            iconColor = "#96999E";
            textColor = "#BFC1C4";
            atlassianLogoTextColor = "#96999E";
            break;
        case "inverse":
            iconColor = "#101214";
            textColor = "#101214";
            atlassianLogoTextColor = "#101214";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#1868DB";
            textColor = "#101214";
            atlassianLogoTextColor = "#1868DB";
            break;
        case "neutral":
            iconColor = "#6C6F77";
            textColor = "#3B3D42";
            atlassianLogoTextColor = "#6C6F77";
            break;
        case "inverse":
            iconColor = (0, $kTdw7.N0);
            textColor = (0, $kTdw7.N0);
            atlassianLogoTextColor = (0, $kTdw7.N0);
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};
var $9281dc00800b5ccc$export$7818df200941dbbf = function getColorsForLoom(appearance, colorMode) {
    var iconColor = $9281dc00800b5ccc$export$bbacc3980e0f3029(appearance, colorMode).iconColor;
    var textColor = $9281dc00800b5ccc$export$bbacc3980e0f3029(appearance, colorMode).textColor;
    if (colorMode === "dark") switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#EFF0FF";
            break;
    }
    else switch(appearance){
        case "brand":
            iconColor = "#625DF5";
            textColor = "#252434";
            break;
    }
    return {
        iconColor: iconColor,
        textColor: textColor
    };
};

});

parcelRegister("gm61b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be835e77f0f1f2cf$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $14VNY = parcelRequire("14VNY");

var $azw9d = parcelRequire("azw9d");
var $be835e77f0f1f2cf$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconGradientStart",
    "iconGradientStop",
    "iconColor",
    "textColor",
    "testId"
];
var $be835e77f0f1f2cf$var$CSS_VAR_COLOR = "--logo-color";
var $be835e77f0f1f2cf$var$CSS_VAR_FILL = "--logo-fill";
var $be835e77f0f1f2cf$var$baseWrapperStyles = (0, $14VNY.css)({
    display: "inline-block",
    position: "relative",
    color: "var(".concat($be835e77f0f1f2cf$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($be835e77f0f1f2cf$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: "none",
    whiteSpace: "normal",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "> svg": {
        height: "100%",
        fill: "inherit"
    }
});
var $be835e77f0f1f2cf$var$stopColorStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    stop: {
        stopColor: "currentColor"
    }
});
var $be835e77f0f1f2cf$var$sizeStyles = Object.entries((0, $azw9d.sizes)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $14VNY.css)({
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $be835e77f0f1f2cf$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconGradientStart = _ref3.iconGradientStart, iconGradientStop = _ref3.iconGradientStop, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref3, $be835e77f0f1f2cf$var$_excluded);
    var shouldApplyStopColor = iconGradientStart === "inherit" && iconGradientStop === "inherit" && appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $14VNY.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        css: [
            $be835e77f0f1f2cf$var$baseWrapperStyles,
            shouldApplyStopColor && $be835e77f0f1f2cf$var$stopColorStyles,
            size && $be835e77f0f1f2cf$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref4, $be835e77f0f1f2cf$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref4, $be835e77f0f1f2cf$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? "img" : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $be835e77f0f1f2cf$export$2e2bcd8739ae039 = $be835e77f0f1f2cf$var$Wrapper;

});
parcelRegister("1Wcv5", function(module, exports) {

var $kaWll = parcelRequire("kaWll");
function $1694e7857a6f2566$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $kaWll(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $1694e7857a6f2566$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("kaWll", function(module, exports) {
function $eb01ff91cc764aae$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $eb01ff91cc764aae$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("HBurV", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "Error.b0f67bec.svg";

});

parcelRegister("3ir1n", function(module, exports) {

$parcel$export(module.exports, "appendReferer", function () { return $ebca23e70cbbbff7$export$b75bb5b493e221ea; });
$parcel$export(module.exports, "appendReasonViewingScreen", function () { return $ebca23e70cbbbff7$export$b68d90d94a86fe33; });
$parcel$export(module.exports, "AnalyticsClientImpl", function () { return $ebca23e70cbbbff7$export$17499c710c4e1d; });
$parcel$export(module.exports, "AnalyticsClientContext", function () { return $ebca23e70cbbbff7$export$70089efe93d43959; });
$parcel$export(module.exports, "useAnalyticsClient", function () { return $ebca23e70cbbbff7$export$923054f18cb06572; });
$parcel$export(module.exports, "useAnalyticsAnonymousId", function () { return $ebca23e70cbbbff7$export$e126afa8615733f3; });
$parcel$export(module.exports, "usePageViewedEvent", function () { return $ebca23e70cbbbff7$export$a07d7c1ce880cd05; });
$parcel$export(module.exports, "useButtonClickedEvent", function () { return $ebca23e70cbbbff7$export$4fb7f377b48b9cbc; });
$parcel$export(module.exports, "useLinkClickedEvent", function () { return $ebca23e70cbbbff7$export$65af8b3e3ac7d8ee; });
$parcel$export(module.exports, "useFormSubmittedEvent", function () { return $ebca23e70cbbbff7$export$69c70ee0cb243a51; });
$parcel$export(module.exports, "useOperationalEvent", function () { return $ebca23e70cbbbff7$export$87ff6dcd457142b0; });
/*
 * Its confusing that we have two analytic clients, so this comment may help to understand what is going on.
 * This is a new client which we are migrating to. We should have both for a transition period.
 */ 
var $lk8Tl = parcelRequire("lk8Tl");

var $8f2pb = parcelRequire("8f2pb");

var $gKvjl = parcelRequire("gKvjl");
var $4cW1f = parcelRequire("4cW1f");

var $fvOZR = parcelRequire("fvOZR");

var $8ZuGG = parcelRequire("8ZuGG");

var $day6I = parcelRequire("day6I");

var $kQqSk = parcelRequire("kQqSk");

var $kZj5j = parcelRequire("kZj5j");

var $fsfV4 = parcelRequire("fsfV4");
parcelRequire("62Jrh");
var $kQMDY = parcelRequire("kQMDY");
const $ebca23e70cbbbff7$var$tags = [
    "identity"
];
function $ebca23e70cbbbff7$var$getEnv() {
    switch(0, $lk8Tl.currentEnv){
        case "local":
            return (0, $4cW1f.envType).LOCAL;
        case "dev":
            return (0, $4cW1f.envType).DEV;
        case "stg":
        case "stg-fedm":
            return (0, $4cW1f.envType).STAGING;
        case "prod":
        case "prod-fedm":
            return (0, $4cW1f.envType).PROD;
        default:
            return (0, $4cW1f.envType).DEV;
    }
}
function $ebca23e70cbbbff7$export$b75bb5b493e221ea(eventAttributes) {
    try {
        const referer = new URL(document.referrer);
        referer.search = ""; // lets minimise possibility of tokens in referer by cleaning up query params
        return {
            ...eventAttributes,
            referer: referer.toString()
        };
    } catch (e) {
        return eventAttributes;
    }
}
function $ebca23e70cbbbff7$export$b68d90d94a86fe33(eventAttributes, userFlow) {
    if (userFlow) return {
        ...eventAttributes,
        reasonViewingScreen: userFlow
    };
    return eventAttributes;
}
function $ebca23e70cbbbff7$var$determinePlatform(microbranding) {
    if ((0, $day6I.isMobileOidc)(microbranding.oidcContext) || microbranding.isEmbedded) return (0, $4cW1f.platformType).MOBILE_WEB;
    return (0, $4cW1f.platformType).WEB;
}
let $ebca23e70cbbbff7$var$analyticsClient;
function $ebca23e70cbbbff7$export$77ce8f76f8d1e1d1({ microbranding: microbranding, locality: locality, tenantCloudId: tenantCloudId, userId: userId }) {
    const platform = $ebca23e70cbbbff7$var$determinePlatform(microbranding);
    const locale = locality || "en";
    const env = $ebca23e70cbbbff7$var$getEnv();
    const apiHost = [
        "prod",
        "staging"
    ].includes((0, $lk8Tl.currentEnvType)) ? window.location.host + "/gateway/api/gasv3/api/v1" : undefined;
    if (!$ebca23e70cbbbff7$var$analyticsClient) $ebca23e70cbbbff7$var$analyticsClient = new (0, $gKvjl.default)({
        env: env,
        product: "identity",
        origin: (0, $4cW1f.originType).WEB,
        platform: platform,
        locale: locale,
        perimeter: (0, $lk8Tl.currentPerimeter)
    }, {
        apiHost: apiHost
    });
    if (userId) $ebca23e70cbbbff7$var$analyticsClient.setUserInfo((0, $4cW1f.userType).ATLASSIAN_ACCOUNT, userId);
    if (tenantCloudId) $ebca23e70cbbbff7$var$analyticsClient.setTenantInfo((0, $4cW1f.tenantType).CLOUD_ID, tenantCloudId);
    else $ebca23e70cbbbff7$var$analyticsClient.setTenantInfo((0, $4cW1f.tenantType).NONE);
    return $ebca23e70cbbbff7$var$analyticsClient;
}
class $ebca23e70cbbbff7$export$17499c710c4e1d {
    formSubmittedEvent(page, formId, attributes) {
        return this.uiEvent({
            page: page,
            action: "submitted",
            subject: "form",
            subjectId: formId,
            attributes: attributes
        });
    }
    buttonClickedEvent(page, buttonId, attributes) {
        return this.uiEvent({
            page: page,
            action: "clicked",
            subject: "button",
            subjectId: buttonId,
            attributes: attributes
        });
    }
    linkClickedEvent(page, linkId, attributes) {
        return this.uiEvent({
            page: page,
            action: "clicked",
            subject: "link",
            subjectId: linkId,
            attributes: attributes
        });
    }
    checkboxChangedEvent(page, checkboxId, attributes) {
        return this.uiEvent({
            page: page,
            action: "changed",
            subject: "checkbox",
            subjectId: checkboxId,
            attributes: attributes
        });
    }
    trackingEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $8f2pb.addBreadcrumb)({
            category: "tracking",
            message: `UI ${event.action} tracking event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: {
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                ...attributes
            }
        });
        try {
            this.client.sendTrackEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $ebca23e70cbbbff7$var$tags
            });
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                event: event
            });
        }
    }
    operationalEvent(event, callback) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $8f2pb.addBreadcrumb)({
            category: "operational",
            message: `${event.action} operational event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: {
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                ...attributes
            }
        });
        try {
            this.client.sendOperationalEvent({
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                attributes: attributes,
                tags: $ebca23e70cbbbff7$var$tags
            }, callback);
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                event: event
            });
            if (callback) callback(error);
        }
    }
    async pageViewedEvent(page, eventAttributes) {
        const attributes = this.enrichAttributes(eventAttributes);
        (0, $8f2pb.addBreadcrumb)({
            category: "pageViewed",
            message: "Page viewed event of page id " + page,
            data: {
                source: page,
                ...attributes
            }
        });
        try {
            const metric = (0, $kQMDY.getPageLoadMetric)(page);
            if (metric.getData().state !== "finished") metric.stop();
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                page: page
            });
        }
        try {
            await this.client.sendScreenEvent({
                name: page,
                attributes: attributes
            });
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                page: page
            });
        }
    }
    errorShownEvent(page, subjectId, eventAttributes) {
        return this.uiEvent({
            page: page,
            action: "shown",
            subject: "error",
            subjectId: subjectId,
            attributes: eventAttributes
        });
    }
    uiEvent(event) {
        const attributes = this.enrichAttributes(event.attributes);
        (0, $8f2pb.addBreadcrumb)({
            category: "ui",
            message: `UI ${event.action} event occured at ${event.subject} ${event.subjectId} on page ${event.page}`,
            data: {
                // this has to be a flat structure
                source: event.page,
                actionSubject: event.subject,
                action: event.action,
                actionSubjectId: event.subjectId,
                ...attributes
            }
        });
        return new Promise((resolve)=>{
            try {
                this.client.sendUIEvent({
                    source: event.page,
                    actionSubject: event.subject,
                    action: event.action,
                    actionSubjectId: event.subjectId,
                    attributes: attributes,
                    tags: $ebca23e70cbbbff7$var$tags
                }, ()=>resolve());
            } catch (error) {
                (0, $8f2pb.captureException)(error, {
                    event: event
                });
                // error is already captured, no point in putting the burden upon consumers by rejecting since they likely want to proceed
                resolve();
            }
        });
    }
    stopApdexEvent(apdexEvent) {
        try {
            this.client.stopApdexEvent(apdexEvent);
        } catch (error) {
            (0, $8f2pb.captureException)(error, {
                event: apdexEvent
            });
        }
    }
    stopInitialLoadApdexEvent(task) {
        this.stopApdexEvent({
            task: task,
            type: "initialLoad",
            additionalAttributes: {
                properties: {
                    firstPaint: (0, $fsfV4.getFirstPaint)(),
                    firstContentfulPaint: (0, $fsfV4.getFirstContentfulPaint)()
                }
            }
        });
    }
    getInstance() {
        return this.client;
    }
    getAnonymousId() {
        return this.client.getAnonymousId();
    }
    setFfsId(ffsId) {
        this.ffsId = ffsId;
    }
    enrichAttributes(eventAttributes) {
        const originTracingProperties = (0, $kQqSk.default)(window.location.href, {
            mapAttribute: (value)=>typeof value === "string" ? (0, $fvOZR.dangerouslyCreateSafeString)(value) : value
        });
        const applicationData = (0, $kZj5j.lookupApplication)(this.cobranding);
        const application = applicationData ? applicationData.application : "unknown";
        const applicationAnalyticAttributes = {
            firstProductAccessed: application,
            experience: applicationData === null || applicationData === void 0 ? void 0 : applicationData.experience
        };
        return {
            ...applicationAnalyticAttributes,
            ...originTracingProperties,
            isMobileApp: this.microbranding.isMobileApp,
            ...eventAttributes,
            ffsId: this.ffsId,
            isInPopup: Boolean(window.opener && window.opener !== window)
        };
    }
    constructor(args){
        const { microbranding: microbranding, cobranding: cobranding, locale: locale, tenantCloudId: tenantCloudId, userId: userId, client: client = $ebca23e70cbbbff7$export$77ce8f76f8d1e1d1({
            microbranding: microbranding,
            locality: locale,
            tenantCloudId: tenantCloudId,
            userId: userId
        }) } = args;
        try {
            (0, $8f2pb.setLocale)(locale);
            this.microbranding = microbranding;
            this.cobranding = cobranding;
            this.client = client;
        } catch (error) {
            (0, $8f2pb.captureException)(error);
        }
    }
}
const $ebca23e70cbbbff7$export$70089efe93d43959 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createContext(null);
const $ebca23e70cbbbff7$export$923054f18cb06572 = ()=>{
    const context = (0, $8ZuGG.useContext)($ebca23e70cbbbff7$export$70089efe93d43959);
    if (!context) throw new Error("useAnalyticsClient used outside of AnalyticsProvider.");
    return context;
};
const $ebca23e70cbbbff7$export$e126afa8615733f3 = ()=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return analyticsClient.getAnonymousId();
};
const $ebca23e70cbbbff7$export$1397d31414038d5e = (event)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.trackingEvent(event);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
const $ebca23e70cbbbff7$export$a07d7c1ce880cd05 = (page, eventAttributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.pageViewedEvent(page, eventAttributes);
    }, [
        page
    ]); // eslint-disable-line react-hooks/exhaustive-deps
};
const $ebca23e70cbbbff7$export$4fb7f377b48b9cbc = (page, buttonId, attributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(page, buttonId, attributes);
    }, [
        analyticsClient,
        page,
        buttonId,
        attributes
    ]);
};
const $ebca23e70cbbbff7$export$65af8b3e3ac7d8ee = (page, linkId, attributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.linkClickedEvent(page, linkId, attributes);
    }, [
        analyticsClient,
        page,
        linkId,
        attributes
    ]);
};
const $ebca23e70cbbbff7$export$69c70ee0cb243a51 = (page, formId, attributes)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    return (0, $8ZuGG.useCallback)(()=>{
        analyticsClient.formSubmittedEvent(page, formId, attributes);
    }, [
        analyticsClient,
        page,
        formId,
        attributes
    ]);
};
const $ebca23e70cbbbff7$export$87ff6dcd457142b0 = (operationalEvent, callback)=>{
    const analyticsClient = $ebca23e70cbbbff7$export$923054f18cb06572();
    (0, $8ZuGG.useEffect)(()=>{
        analyticsClient.operationalEvent(operationalEvent, callback);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

});
parcelRegister("lk8Tl", function(module, exports) {

$parcel$export(module.exports, "currentEnv", function () { return $00d210f41ba7523f$export$d1418d82198b4abb; });
$parcel$export(module.exports, "currentEnvType", function () { return $00d210f41ba7523f$export$fc28d431ec5ff0ef; });
$parcel$export(module.exports, "idacOrigin", function () { return $00d210f41ba7523f$export$7fd1ab530687106; });
$parcel$export(module.exports, "currentPerimeter", function () { return $00d210f41ba7523f$export$84a0517db04c70cb; });
$parcel$export(module.exports, "getCurrentPerimeter", function () { return $00d210f41ba7523f$export$f5f19d126eeca848; });
$parcel$export(module.exports, "isFedM", function () { return $00d210f41ba7523f$export$9db7980b9f442a4c; });
$parcel$export(module.exports, "getConfig", function () { return $00d210f41ba7523f$export$44487a86467333c3; });
function $00d210f41ba7523f$var$inferEnvFromHostname(hostname) {
    if (hostname === "localhost") return "local";
    if (hostname.endsWith(".dev.internal.atlassian.com") || hostname.endsWith(".dev.atlassian.com")) return "dev";
    if (hostname.endsWith(".stg.internal.atlassian.com") || hostname.endsWith(".stg.atlassian.com")) return "stg";
    if (hostname.endsWith(".stg.atlassian-us-gov-mod.com")) return "stg-fedm";
    if (hostname.endsWith(".atlassian-us-gov-mod.com")) return "prod-fedm";
    if (hostname.endsWith(".atlassian.com")) return "prod";
    return "unknown";
}
const $00d210f41ba7523f$export$d1418d82198b4abb = $00d210f41ba7523f$var$inferEnvFromHostname(window.location.hostname);
const $00d210f41ba7523f$var$envTypes = {
    local: "dev",
    dev: "dev",
    stg: "staging",
    "stg-fedm": "staging",
    prod: "prod",
    "prod-fedm": "prod",
    unknown: "unknown"
};
const $00d210f41ba7523f$export$fc28d431ec5ff0ef = $00d210f41ba7523f$var$envTypes[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$var$idacOrigins = {
    local: "http://localhost:8080",
    dev: "https://id.dev.internal.atlassian.com",
    stg: "https://id.stg.internal.atlassian.com",
    "stg-fedm": "https://id.stg.atlassian-us-gov-mod.com",
    prod: "https://id.atlassian.com",
    "prod-fedm": "https://id.atlassian-us-gov-mod.com",
    unknown: "https://id.atlassian.com"
};
const $00d210f41ba7523f$export$7fd1ab530687106 = $00d210f41ba7523f$var$idacOrigins[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$var$perimeters = {
    local: "commercial",
    dev: "commercial",
    stg: "commercial",
    "stg-fedm": "fedramp-moderate",
    prod: "commercial",
    "prod-fedm": "fedramp-moderate",
    unknown: "commercial"
};
const $00d210f41ba7523f$var$config = {
    dev: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
            smsEnrollmentRecaptchaEnterpriseNewKey: "6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O"
        }
    },
    staging: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
            smsEnrollmentRecaptchaEnterpriseNewKey: "6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O"
        }
    },
    prod: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: "6LeLRz0kAAAAAPIWGnreLcE0BJaZ17REyxkFhM0E",
            smsEnrollmentRecaptchaEnterpriseNewKey: "6LcjUrgpAAAAANvg2hgPsYsHNO9F21kQVCQwUPoF"
        }
    },
    unknown: {
        recaptcha: {
            smsEnrollmentRecaptchaEnterpriseInvisibleKey: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
            smsEnrollmentRecaptchaEnterpriseNewKey: "6Ld_RrgpAAAAAC6NtADmI_b9uTwxyDieSQbL0A4O"
        }
    }
};
const $00d210f41ba7523f$export$84a0517db04c70cb = $00d210f41ba7523f$var$perimeters[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$export$f5f19d126eeca848 = ()=>$00d210f41ba7523f$var$perimeters[$00d210f41ba7523f$export$d1418d82198b4abb];
const $00d210f41ba7523f$export$9db7980b9f442a4c = ()=>$00d210f41ba7523f$export$f5f19d126eeca848() === "fedramp-moderate";
const $00d210f41ba7523f$export$44487a86467333c3 = ()=>$00d210f41ba7523f$var$config[$00d210f41ba7523f$export$fc28d431ec5ff0ef];

});

parcelRegister("8f2pb", function(module, exports) {

$parcel$export(module.exports, "initClient", function () { return $b5769c9141eb31bc$export$c4b69426a5efa3b7; });
$parcel$export(module.exports, "setUserId", function () { return $b5769c9141eb31bc$export$7f5abdb7f5093137; });
$parcel$export(module.exports, "addBreadcrumb", function () { return $b5769c9141eb31bc$export$efda9a273d7a036d; });
$parcel$export(module.exports, "setLocale", function () { return $b5769c9141eb31bc$export$c8aadf3621e41efb; });
$parcel$export(module.exports, "captureException", function () { return $b5769c9141eb31bc$export$f5282963edea4a68; });
$parcel$export(module.exports, "captureErrorMessage", function () { return $b5769c9141eb31bc$export$53b98cb085651af4; });
$parcel$export(module.exports, "captureMessage", function () { return $b5769c9141eb31bc$export$45654777c133ae80; });

var $lwBvV = parcelRequire("lwBvV");
var $6acdb = parcelRequire("6acdb");

var $lk8Tl = parcelRequire("lk8Tl");

var $day6I = parcelRequire("day6I");
// Only turn on debug for non production and non test runs (i.e. Jest);
const $b5769c9141eb31bc$var$debug = (0, $lk8Tl.currentEnv) !== "prod" && true;
// https://hello.atlassian.net/wiki/spaces/OBSERVABILITY/pages/3370131692/Sentry+FedRAMP+-+Getting+Started#Sentry-DSN-in-FedRAMP
const $b5769c9141eb31bc$var$fedMSentryDSN = "https://1c864dd6ac671ce6296e7cc6710a21a0@sentry.atlassian-us-gov-mod.com/22";
const $b5769c9141eb31bc$var$commercialSentryDSN = "https://1271fcf5ddad45a1846153219eb726bd@o55978.ingest.sentry.io/4504172801622016";
$6acdb.init({
    dsn: (0, $lk8Tl.isFedM)() ? $b5769c9141eb31bc$var$fedMSentryDSN : $b5769c9141eb31bc$var$commercialSentryDSN,
    debug: $b5769c9141eb31bc$var$debug,
    environment: (0, $lk8Tl.currentEnv),
    release: "5.0.797",
    sampleRate: 0.1,
    beforeSend (event) {
        var _event_request;
        // Remove URL queryparams, they can contain PII
        if ((_event_request = event.request) === null || _event_request === void 0 ? void 0 : _event_request.url) {
            event.request.url = event.request.url.split("?")[0];
            delete event.request.query_string;
        }
        return event;
    },
    beforeBreadcrumb (breadcrumb) {
        // Don't send breadcrumbs that may contain PII
        if ([
            "navigation",
            "fetch",
            "xhr"
        ].includes(breadcrumb.category || "")) return null;
        return breadcrumb;
    },
    denyUrls: [
        /^chrome:\/\//,
        /^chrome-extension:\/\//,
        /accounts\.google\.com/,
        /recaptcha.net/
    ],
    ignoreErrors: [
        /^null/,
        /Loading chunk.\d+.failed/,
        /^[^.]+\w+ is not defined/,
        "NetworkError",
        "Failed to fetch",
        "SecurityError",
        "Object Not Found Matching Id",
        "Non-Error promise rejection captured with value:",
        "ResizeObserver loop limit exceeded"
    ]
});
function $b5769c9141eb31bc$export$c4b69426a5efa3b7(microbranding) {
    $lwBvV.configureScope((scope)=>{
        // We're not going to send all of microbranding just in case someone
        // puts PII into microbranding later on
        scope.setExtra("isEmbedded", microbranding.isEmbedded);
        scope.setExtra("isMobileOidc", (0, $day6I.isMobileOidc)(microbranding.oidcContext));
    });
}
function $b5769c9141eb31bc$export$7f5abdb7f5093137(userId) {
    $lwBvV.configureScope((scope)=>{
        scope.setUser({
            id: userId
        });
    });
}
function $b5769c9141eb31bc$export$efda9a273d7a036d(breadcrumb) {
    if (!breadcrumb.level) breadcrumb.level = "info";
    $lwBvV.addBreadcrumb(breadcrumb);
}
function $b5769c9141eb31bc$export$c8aadf3621e41efb(locale) {
    if (locale) $lwBvV.configureScope((scope)=>{
        scope.setTag("locale", locale);
    });
}
function $b5769c9141eb31bc$export$f5282963edea4a68(ex, payload) {
    if (payload) $lwBvV.withScope((scope)=>{
        Object.keys(payload).forEach((key)=>{
            scope.setExtra(key, payload[key]);
        });
        $lwBvV.captureException(ex);
    });
    else $lwBvV.captureException(ex);
}
function $b5769c9141eb31bc$export$53b98cb085651af4(msg, payload = {}) {
    $b5769c9141eb31bc$export$45654777c133ae80(msg, payload, "error");
}
function $b5769c9141eb31bc$export$45654777c133ae80(msg, payload, severity) {
    if (payload) $lwBvV.withScope((scope)=>{
        Object.keys(payload).forEach((key)=>{
            scope.setExtra(key, payload[key]);
        });
        $lwBvV.captureMessage(msg, severity);
    });
    else $lwBvV.captureMessage(msg, severity);
}

});
parcelRegister("6acdb", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $47cd2638a325795a$export$2cd8252107eb640b; });

var $lwBvV = parcelRequire("lwBvV");
var $huwzD = parcelRequire("huwzD");
var $ce2Qn = parcelRequire("ce2Qn");
var $9B4Sg = parcelRequire("9B4Sg");
var $fT8lW = parcelRequire("fT8lW");
var $2zLQC = parcelRequire("2zLQC");
var $hfNjL = parcelRequire("hfNjL");

var $5Zo6K = parcelRequire("5Zo6K");
var $2GR2A = parcelRequire("2GR2A");
var $cd716 = parcelRequire("cd716");
var $ewsHc = parcelRequire("ewsHc");

var $76D8m = parcelRequire("76D8m");

var $9B6JL = parcelRequire("9B6JL");

var $4Stk1 = parcelRequire("4Stk1");

var $4Df2Y = parcelRequire("4Df2Y");

var $8RvDZ = parcelRequire("8RvDZ");

var $4U7MB = parcelRequire("4U7MB");

var $7pKyI = parcelRequire("7pKyI");

var $kGXwn = parcelRequire("kGXwn");

var $b5aUb = parcelRequire("b5aUb");

var $gUnN9 = parcelRequire("gUnN9");

var $cIWmp = parcelRequire("cIWmp");

var $jG9b5 = parcelRequire("jG9b5");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $47cd2638a325795a$export$5ef831fccfce35e5 = [
    (0, $2zLQC.inboundFiltersIntegration)(),
    (0, $huwzD.functionToStringIntegration)(),
    (0, $b5aUb.browserApiErrorsIntegration)(),
    (0, $4Df2Y.breadcrumbsIntegration)(),
    (0, $4U7MB.globalHandlersIntegration)(),
    (0, $kGXwn.linkedErrorsIntegration)(),
    (0, $8RvDZ.dedupeIntegration)(),
    (0, $7pKyI.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $47cd2638a325795a$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$47cd2638a325795a$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $47cd2638a325795a$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $47cd2638a325795a$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === "string") options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $4Stk1.WINDOW).SENTRY_RELEASE && (0, $4Stk1.WINDOW).SENTRY_RELEASE.id) options.release = (0, $4Stk1.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $cd716.stackParserFromStackParserOptions)(options.stackParser || (0, $gUnN9.defaultStackParser)),
        integrations: (0, $9B4Sg.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $ewsHc.supportsFetch)() ? (0, $cIWmp.makeFetchTransport) : (0, $jG9b5.makeXHRTransport))
    };
    (0, $hfNjL.initAndBind)((0, $76D8m.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $47cd2638a325795a$var$startSessionTracking();
}
const $47cd2638a325795a$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $ce2Qn.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $4Stk1.WINDOW).document) {
        (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).error("Global document not defined in showReportDialog call");
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).error("DSN not configured for showReportDialog call");
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $4Stk1.WINDOW).document.createElement("script");
    script.async = true;
    script.crossOrigin = "anonymous";
    script.src = (0, $fT8lW.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === "__sentry_reportdialog_closed__") try {
                onClose();
            } finally{
                (0, $4Stk1.WINDOW).removeEventListener("message", reportDialogClosedMessageHandler);
            }
        };
        (0, $4Stk1.WINDOW).addEventListener("message", reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $4Stk1.WINDOW).document.head || (0, $4Stk1.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).error("Not injecting report dialog. No injection point found in HTML");
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $47cd2638a325795a$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $47cd2638a325795a$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $47cd2638a325795a$export$4997ffc0176396a6(fn) {
    return (0, $4Stk1.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $47cd2638a325795a$var$startSessionTracking() {
    if (typeof (0, $4Stk1.WINDOW).document === "undefined") {
        (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Session tracking in non-browser environment with @sentry/browser is not supported.");
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $lwBvV.startSession)({
        ignoreDuration: true
    });
    (0, $lwBvV.captureSession)();
    // We want to create a session for every navigation as well
    (0, $5Zo6K.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $lwBvV.startSession)({
                ignoreDuration: true
            });
            (0, $lwBvV.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $47cd2638a325795a$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $lwBvV.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("huwzD", function(module, exports) {

$parcel$export(module.exports, "functionToStringIntegration", function () { return $cbbe817b3ba5ebce$export$7918117e9202e4fb; });

var $h32bW = parcelRequire("h32bW");

var $lwBvV = parcelRequire("lwBvV");

var $9B4Sg = parcelRequire("9B4Sg");
let $cbbe817b3ba5ebce$var$originalFunctionToString;
const $cbbe817b3ba5ebce$var$INTEGRATION_NAME = "FunctionToString";
const $cbbe817b3ba5ebce$var$SETUP_CLIENTS = new WeakMap();
const $cbbe817b3ba5ebce$var$_functionToStringIntegration = ()=>{
    return {
        name: $cbbe817b3ba5ebce$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $cbbe817b3ba5ebce$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $h32bW.getOriginalFunction)(this);
                    const context = $cbbe817b3ba5ebce$var$SETUP_CLIENTS.has((0, $lwBvV.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $cbbe817b3ba5ebce$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $cbbe817b3ba5ebce$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $cbbe817b3ba5ebce$export$7918117e9202e4fb = (0, $9B4Sg.defineIntegration)($cbbe817b3ba5ebce$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $cbbe817b3ba5ebce$export$da4704525c20ae79 = (0, $9B4Sg.convertIntegrationFnToClass)($cbbe817b3ba5ebce$var$INTEGRATION_NAME, $cbbe817b3ba5ebce$export$7918117e9202e4fb);

});
parcelRegister("9B4Sg", function(module, exports) {

$parcel$export(module.exports, "getIntegrationsToSetup", function () { return $6fcb59b25bd4ef8b$export$68bc4c01ab8ae766; });
$parcel$export(module.exports, "setupIntegrations", function () { return $6fcb59b25bd4ef8b$export$51abed9797baa598; });
$parcel$export(module.exports, "setupIntegration", function () { return $6fcb59b25bd4ef8b$export$e7390a03b70a6f2f; });
$parcel$export(module.exports, "afterSetupIntegrations", function () { return $6fcb59b25bd4ef8b$export$35abcfd71227c6ca; });
$parcel$export(module.exports, "convertIntegrationFnToClass", function () { return $6fcb59b25bd4ef8b$export$afa219bf23651160; });
$parcel$export(module.exports, "defineIntegration", function () { return $6fcb59b25bd4ef8b$export$2323046b9414659f; });

var $jc8x6 = parcelRequire("jc8x6");
var $2GR2A = parcelRequire("2GR2A");

var $dSDoS = parcelRequire("dSDoS");

var $4UoXr = parcelRequire("4UoXr");

var $lwBvV = parcelRequire("lwBvV");

var $ce2Qn = parcelRequire("ce2Qn");
const $6fcb59b25bd4ef8b$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $6fcb59b25bd4ef8b$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $6fcb59b25bd4ef8b$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === "function") integrations = (0, $jc8x6.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $6fcb59b25bd4ef8b$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $6fcb59b25bd4ef8b$var$findIndex(finalIntegrations, (integration)=>integration.name === "Debug");
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $6fcb59b25bd4ef8b$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $6fcb59b25bd4ef8b$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $6fcb59b25bd4ef8b$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $6fcb59b25bd4ef8b$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($6fcb59b25bd4ef8b$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $4UoXr.addGlobalEventProcessor), (0, $ce2Qn.getCurrentHub));
        $6fcb59b25bd4ef8b$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === "function") integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === "function") {
        const callback = integration.preprocessEvent.bind(integration);
        client.on("preprocessEvent", (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === "function") {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $6fcb59b25bd4ef8b$export$2d8f5188773bcddd(integration) {
    const client = (0, $lwBvV.getClient)();
    if (!client || !client.addIntegration) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $6fcb59b25bd4ef8b$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $6fcb59b25bd4ef8b$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $6fcb59b25bd4ef8b$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("fT8lW", function(module, exports) {

$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", function () { return $b91278cb876d6345$export$9964600bfe84e6a3; });
$parcel$export(module.exports, "getReportDialogEndpoint", function () { return $b91278cb876d6345$export$671c7ed8e40a7a57; });

var $49Pps = parcelRequire("49Pps");
var $h32bW = parcelRequire("h32bW");
const $b91278cb876d6345$var$SENTRY_API_VERSION = "7";
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $b91278cb876d6345$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : "";
    const port = dsn.port ? `:${dsn.port}` : "";
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ""}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $b91278cb876d6345$var$_getIngestEndpoint(dsn) {
    return `${$b91278cb876d6345$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $b91278cb876d6345$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $h32bW.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $b91278cb876d6345$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $b91278cb876d6345$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === "string" ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === "string" || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$b91278cb876d6345$var$_getIngestEndpoint(dsn)}?${$b91278cb876d6345$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $b91278cb876d6345$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $49Pps.makeDsn)(dsnLike);
    if (!dsn) return "";
    const endpoint = `${$b91278cb876d6345$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $49Pps.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === "dsn") continue;
        if (key === "onClose") continue;
        if (key === "user") {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("49Pps", function(module, exports) {

$parcel$export(module.exports, "dsnToString", function () { return $306fe191a49c5454$export$44d472fbb931a776; });
$parcel$export(module.exports, "makeDsn", function () { return $306fe191a49c5454$export$128827c3562ec0cb; });

var $fYUT5 = parcelRequire("fYUT5");

var $2GR2A = parcelRequire("2GR2A");
/** Regular expression used to parse a Dsn. */ const $306fe191a49c5454$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $306fe191a49c5454$var$isValidProtocol(protocol) {
    return protocol === "http" || protocol === "https";
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $306fe191a49c5454$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ""}` + `@${host}${port ? `:${port}` : ""}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $306fe191a49c5454$export$b892860177f70a30(str) {
    const match = $306fe191a49c5454$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $2GR2A.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = "", host, port = "", lastPath] = match.slice(1);
    let path = "";
    let projectId = lastPath;
    const split = projectId.split("/");
    if (split.length > 1) {
        path = split.slice(0, -1).join("/");
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $306fe191a49c5454$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $306fe191a49c5454$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || "",
        pass: components.pass || "",
        host: components.host,
        port: components.port || "",
        path: components.path || "",
        projectId: components.projectId
    };
}
function $306fe191a49c5454$var$validateDsn(dsn) {
    if (!(0, $fYUT5.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        "protocol",
        "publicKey",
        "host",
        "projectId"
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $2GR2A.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $2GR2A.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$306fe191a49c5454$var$isValidProtocol(protocol)) {
        (0, $2GR2A.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $2GR2A.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $306fe191a49c5454$export$128827c3562ec0cb(from) {
    const components = typeof from === "string" ? $306fe191a49c5454$export$b892860177f70a30(from) : $306fe191a49c5454$var$dsnFromComponents(from);
    if (!components || !$306fe191a49c5454$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("2zLQC", function(module, exports) {

$parcel$export(module.exports, "inboundFiltersIntegration", function () { return $1e03f72fa2faf4aa$export$cb3c5c2ceb9818ba; });

var $jc8x6 = parcelRequire("jc8x6");
var $2GR2A = parcelRequire("2GR2A");
var $l8auK = parcelRequire("l8auK");

var $dSDoS = parcelRequire("dSDoS");

var $9B4Sg = parcelRequire("9B4Sg");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $1e03f72fa2faf4aa$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $1e03f72fa2faf4aa$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $1e03f72fa2faf4aa$var$INTEGRATION_NAME = "InboundFilters";
const $1e03f72fa2faf4aa$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $1e03f72fa2faf4aa$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $1e03f72fa2faf4aa$var$_mergeOptions(options, clientOptions);
            return $1e03f72fa2faf4aa$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $1e03f72fa2faf4aa$export$cb3c5c2ceb9818ba = (0, $9B4Sg.defineIntegration)($1e03f72fa2faf4aa$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $1e03f72fa2faf4aa$export$2ffbb5359dcc6be4 = (0, $9B4Sg.convertIntegrationFnToClass)($1e03f72fa2faf4aa$var$INTEGRATION_NAME, $1e03f72fa2faf4aa$export$cb3c5c2ceb9818ba);
function $1e03f72fa2faf4aa$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $1e03f72fa2faf4aa$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $1e03f72fa2faf4aa$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $1e03f72fa2faf4aa$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $1e03f72fa2faf4aa$var$_isSentryError(event)) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $jc8x6.getEventDescription)(event)}`);
        return true;
    }
    if ($1e03f72fa2faf4aa$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $jc8x6.getEventDescription)(event)}`);
        return true;
    }
    if ($1e03f72fa2faf4aa$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $jc8x6.getEventDescription)(event)}`);
        return true;
    }
    if ($1e03f72fa2faf4aa$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $jc8x6.getEventDescription)(event)}.\nUrl: ${$1e03f72fa2faf4aa$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$1e03f72fa2faf4aa$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $jc8x6.getEventDescription)(event)}.\nUrl: ${$1e03f72fa2faf4aa$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $1e03f72fa2faf4aa$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $1e03f72fa2faf4aa$var$_getPossibleEventMessages(event).some((message)=>(0, $l8auK.stringMatchesSomePattern)(message, ignoreErrors));
}
function $1e03f72fa2faf4aa$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== "transaction" || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $l8auK.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $1e03f72fa2faf4aa$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $1e03f72fa2faf4aa$var$_getEventFilterUrl(event);
    return !url ? false : (0, $l8auK.stringMatchesSomePattern)(url, denyUrls);
}
function $1e03f72fa2faf4aa$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $1e03f72fa2faf4aa$var$_getEventFilterUrl(event);
    return !url ? true : (0, $l8auK.stringMatchesSomePattern)(url, allowUrls);
}
function $1e03f72fa2faf4aa$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $dSDoS.DEBUG_BUILD) && possibleMessages.length === 0) (0, $2GR2A.logger).error(`Could not extract message for event ${(0, $jc8x6.getEventDescription)(event)}`);
    return possibleMessages;
}
function $1e03f72fa2faf4aa$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === "SentryError";
    } catch (e) {
    // ignore
    }
    return false;
}
function $1e03f72fa2faf4aa$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== "<anonymous>" && frame.filename !== "[native code]") return frame.filename || null;
    }
    return null;
}
function $1e03f72fa2faf4aa$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $1e03f72fa2faf4aa$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).error(`Cannot extract url for event ${(0, $jc8x6.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("hfNjL", function(module, exports) {

$parcel$export(module.exports, "initAndBind", function () { return $c8fa17db7a43f4a7$export$5333c3f1c58d9bc1; });

var $2GR2A = parcelRequire("2GR2A");

var $dSDoS = parcelRequire("dSDoS");

var $lwBvV = parcelRequire("lwBvV");

var $ce2Qn = parcelRequire("ce2Qn");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $c8fa17db7a43f4a7$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $dSDoS.DEBUG_BUILD) (0, $2GR2A.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $2GR2A.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn("[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.");
        });
    }
    const scope = (0, $lwBvV.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $c8fa17db7a43f4a7$export$ecb76f41d43c0e43(client);
    $c8fa17db7a43f4a7$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $c8fa17db7a43f4a7$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $ce2Qn.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $c8fa17db7a43f4a7$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("5Zo6K", function(module, exports) {

$parcel$export(module.exports, "addHistoryInstrumentationHandler", function () { return $45c5599566a4f66e$export$3f18c56c58114e75; });

var $h32bW = parcelRequire("h32bW");



var $h2E4a = parcelRequire("h2E4a");

var $bS2U3 = parcelRequire("bS2U3");

var $dLHuQ = parcelRequire("dLHuQ");
const $45c5599566a4f66e$var$WINDOW = (0, $h2E4a.GLOBAL_OBJ);
let $45c5599566a4f66e$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $45c5599566a4f66e$export$3f18c56c58114e75(handler) {
    const type = "history";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $45c5599566a4f66e$var$instrumentHistory);
}
function $45c5599566a4f66e$var$instrumentHistory() {
    if (!(0, $bS2U3.supportsHistory)()) return;
    const oldOnPopState = $45c5599566a4f66e$var$WINDOW.onpopstate;
    $45c5599566a4f66e$var$WINDOW.onpopstate = function(...args) {
        const to = $45c5599566a4f66e$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $45c5599566a4f66e$var$lastHref;
        $45c5599566a4f66e$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $dLHuQ.triggerHandlers)("history", handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $45c5599566a4f66e$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $45c5599566a4f66e$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $dLHuQ.triggerHandlers)("history", handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $h32bW.fill)($45c5599566a4f66e$var$WINDOW.history, "pushState", historyReplacementFunction);
    (0, $h32bW.fill)($45c5599566a4f66e$var$WINDOW.history, "replaceState", historyReplacementFunction);
}

});
parcelRegister("bS2U3", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", function () { return $8a46fd5fd9cbf43f$export$67fc34576016d6ec; });

var $h2E4a = parcelRequire("h2E4a");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $8a46fd5fd9cbf43f$var$WINDOW = (0, $h2E4a.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $8a46fd5fd9cbf43f$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $8a46fd5fd9cbf43f$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = "history" in $8a46fd5fd9cbf43f$var$WINDOW && !!$8a46fd5fd9cbf43f$var$WINDOW.history.pushState && !!$8a46fd5fd9cbf43f$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("dLHuQ", function(module, exports) {

$parcel$export(module.exports, "addHandler", function () { return $a06167a39ee0423f$export$a4e09611e30da72e; });
$parcel$export(module.exports, "maybeInstrument", function () { return $a06167a39ee0423f$export$e18d6c5462c01368; });
$parcel$export(module.exports, "triggerHandlers", function () { return $a06167a39ee0423f$export$b18c893e424d3127; });

var $fYUT5 = parcelRequire("fYUT5");

var $2GR2A = parcelRequire("2GR2A");

var $cd716 = parcelRequire("cd716");
// We keep the handlers globally
const $a06167a39ee0423f$var$handlers = {};
const $a06167a39ee0423f$var$instrumented = {};
/** Add a handler function. */ function $a06167a39ee0423f$export$a4e09611e30da72e(type, handler) {
    $a06167a39ee0423f$var$handlers[type] = $a06167a39ee0423f$var$handlers[type] || [];
    $a06167a39ee0423f$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $a06167a39ee0423f$export$b17eab759a1cb5fe() {
    Object.keys($a06167a39ee0423f$var$handlers).forEach((key)=>{
        $a06167a39ee0423f$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $a06167a39ee0423f$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$a06167a39ee0423f$var$instrumented[type]) {
        instrumentFn();
        $a06167a39ee0423f$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $a06167a39ee0423f$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $a06167a39ee0423f$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fYUT5.DEBUG_BUILD) && (0, $2GR2A.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $cd716.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("ewsHc", function(module, exports) {

$parcel$export(module.exports, "supportsFetch", function () { return $a92a503b113b4ec7$export$edf3cb81fd7d2a3e; });
$parcel$export(module.exports, "isNativeFetch", function () { return $a92a503b113b4ec7$export$18cf36ed71d733e7; });
$parcel$export(module.exports, "supportsNativeFetch", function () { return $a92a503b113b4ec7$export$c82d238e23c40b21; });

var $fYUT5 = parcelRequire("fYUT5");

var $2GR2A = parcelRequire("2GR2A");

var $h2E4a = parcelRequire("h2E4a");
// eslint-disable-next-line deprecation/deprecation
const $a92a503b113b4ec7$var$WINDOW = (0, $h2E4a.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $a92a503b113b4ec7$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $a92a503b113b4ec7$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $a92a503b113b4ec7$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $a92a503b113b4ec7$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in $a92a503b113b4ec7$var$WINDOW)) return false;
    try {
        new Headers();
        new Request("http://www.example.com");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $a92a503b113b4ec7$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $a92a503b113b4ec7$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === "string") return true;
    if (!$a92a503b113b4ec7$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($a92a503b113b4ec7$export$18cf36ed71d733e7($a92a503b113b4ec7$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $a92a503b113b4ec7$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        const sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $a92a503b113b4ec7$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fYUT5.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $a92a503b113b4ec7$export$531055a6c684a70a() {
    return "ReportingObserver" in $a92a503b113b4ec7$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $a92a503b113b4ec7$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$a92a503b113b4ec7$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("76D8m", function(module, exports) {

$parcel$export(module.exports, "BrowserClient", function () { return $52c7731c6344f372$export$1df9218a526d318d; });

var $jCXnd = parcelRequire("jCXnd");
var $3Szl6 = parcelRequire("3Szl6");

var $iUmR0 = parcelRequire("iUmR0");
var $49Pps = parcelRequire("49Pps");
var $dLku1 = parcelRequire("dLku1");
var $2GR2A = parcelRequire("2GR2A");

var $9B6JL = parcelRequire("9B6JL");

var $1S5EX = parcelRequire("1S5EX");

var $4Stk1 = parcelRequire("4Stk1");

var $lmR7a = parcelRequire("lmR7a");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $52c7731c6344f372$export$1df9218a526d318d extends (0, $3Szl6.BaseClient) {
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $1S5EX.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = "info", hint) {
        return (0, $1S5EX.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).warn("SDK not enabled, will not capture user feedback.");
            return;
        }
        const envelope = (0, $lmR7a.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || "javascript";
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).log("No outcomes to send");
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).log("No dsn provided, will not send outcomes");
            return;
        }
        (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).log("Sending outcomes:", outcomes);
        const envelope = (0, $iUmR0.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $49Pps.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $4Stk1.WINDOW).SENTRY_SDK_SOURCE || (0, $dLku1.getSDKSource)();
        (0, $jCXnd.applySdkMetadata)(options, "browser", [
            "browser"
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $4Stk1.WINDOW).document) (0, $4Stk1.WINDOW).document.addEventListener("visibilitychange", ()=>{
            if ((0, $4Stk1.WINDOW).document.visibilityState === "hidden") this._flushOutcomes();
        });
    }
}

});
parcelRegister("jCXnd", function(module, exports) {

$parcel$export(module.exports, "applySdkMetadata", function () { return $e49f9f40f0d716e6$export$b9f95b027256052c; });

var $a1ZBp = parcelRequire("a1ZBp");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $e49f9f40f0d716e6$export$b9f95b027256052c(options, name, names = [
    name
], source = "npm") {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $a1ZBp.SDK_VERSION)
            })),
        version: (0, $a1ZBp.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("3Szl6", function(module, exports) {

$parcel$export(module.exports, "BaseClient", function () { return $2d31d3e201096680$export$4f22f74eddb7716a; });

var $iblUR = parcelRequire("iblUR");
var $jc8x6 = parcelRequire("jc8x6");
var $h7OG0 = parcelRequire("h7OG0");
var $2GR2A = parcelRequire("2GR2A");
var $49Pps = parcelRequire("49Pps");
var $a6X2M = parcelRequire("a6X2M");
var $gwKkF = parcelRequire("gwKkF");

var $fT8lW = parcelRequire("fT8lW");

var $dSDoS = parcelRequire("dSDoS");

var $4x1rT = parcelRequire("4x1rT");

var $lwBvV = parcelRequire("lwBvV");

var $ce2Qn = parcelRequire("ce2Qn");

var $9B4Sg = parcelRequire("9B4Sg");

var $a3esW = parcelRequire("a3esW");

var $36iHK = parcelRequire("36iHK");

var $fBC4O = parcelRequire("fBC4O");

var $auLrx = parcelRequire("auLrx");
const $2d31d3e201096680$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $2d31d3e201096680$export$4f22f74eddb7716a {
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $jc8x6.checkOrSetAlreadyCaught)(exception)) {
            (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).log($2d31d3e201096680$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $h7OG0.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $h7OG0.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $jc8x6.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).log($2d31d3e201096680$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === "string")) (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Discarded session because of missing or non-string release");
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $36iHK.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $a6X2M.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $9B4Sg.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $9B4Sg.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit("beforeSendEvent", event, hint);
        let env = (0, $4x1rT.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $iblUR.addItemToEnvelope)(env, (0, $iblUR.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit("afterSendEvent", event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $4x1rT.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $a3esW.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $9B4Sg.setupIntegrations)(this, integrations);
        (0, $9B4Sg.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === "ok";
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $36iHK.updateSession)(session, {
                ...crashed && {
                    status: "crashed"
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $a6X2M.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $ce2Qn.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit("preprocessEvent", event, hint);
        return (0, $auLrx.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $fBC4O.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $dSDoS.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === "log") (0, $2GR2A.logger).log(sentryError.message);
                else (0, $2GR2A.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $2d31d3e201096680$var$isTransactionEvent(event);
        const isError = $2d31d3e201096680$var$isErrorEvent(event);
        const eventType = event.type || "error";
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === "number" && Math.random() > sampleRate) {
            this.recordDroppedEvent("sample_rate", "error", event);
            return (0, $a6X2M.rejectedSyncPromise)(new (0, $gwKkF.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, "log"));
        }
        const dataCategory = eventType === "replay_event" ? "replay" : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent("event_processor", dataCategory, event);
                throw new (0, $gwKkF.SentryError)("An event processor returned `null`, will not send event.", "log");
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $2d31d3e201096680$var$processBeforeSend(options, prepared, hint);
            return $2d31d3e201096680$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent("before_send", dataCategory, event);
                throw new (0, $gwKkF.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, "log");
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = "custom";
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $gwKkF.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $gwKkF.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit("beforeEnvelope", envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).error("Error while sending event:", reason);
        });
        else (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).error("Transport disabled");
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(":");
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $49Pps.makeDsn)(options.dsn);
        else (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn("No DSN provided, client will not send events.");
        if (this._dsn) {
            const url = (0, $fT8lW.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $2d31d3e201096680$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $h7OG0.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $h7OG0.isPlainObject)(event) && event !== null) throw new (0, $gwKkF.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $gwKkF.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $h7OG0.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $gwKkF.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $2d31d3e201096680$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($2d31d3e201096680$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($2d31d3e201096680$var$isTransactionEvent(event) && beforeSendTransaction) return beforeSendTransaction(event, hint);
    return event;
}
function $2d31d3e201096680$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $2d31d3e201096680$var$isTransactionEvent(event) {
    return event.type === "transaction";
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $2d31d3e201096680$export$9aac0b9f77928fbf(callback) {
    const client = (0, $lwBvV.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("iblUR", function(module, exports) {

$parcel$export(module.exports, "createEnvelope", function () { return $d3ca412c0c679837$export$f93f7f385160c44e; });
$parcel$export(module.exports, "addItemToEnvelope", function () { return $d3ca412c0c679837$export$d650323442802f6f; });
$parcel$export(module.exports, "forEachEnvelopeItem", function () { return $d3ca412c0c679837$export$c56c55acf0136fd3; });
$parcel$export(module.exports, "serializeEnvelope", function () { return $d3ca412c0c679837$export$32f9b428425aac85; });
$parcel$export(module.exports, "createAttachmentEnvelopeItem", function () { return $d3ca412c0c679837$export$d8fc80952cc31fa4; });
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", function () { return $d3ca412c0c679837$export$b11169581eeaf237; });
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", function () { return $d3ca412c0c679837$export$d369f3b2758f6743; });
$parcel$export(module.exports, "createEventEnvelopeHeaders", function () { return $d3ca412c0c679837$export$92b6093782fe661b; });

var $49Pps = parcelRequire("49Pps");

var $6KYYx = parcelRequire("6KYYx");

var $h32bW = parcelRequire("h32bW");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $d3ca412c0c679837$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $d3ca412c0c679837$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $d3ca412c0c679837$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $d3ca412c0c679837$export$604a45d95a155e2b(envelope, types) {
    return $d3ca412c0c679837$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $d3ca412c0c679837$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $d3ca412c0c679837$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === "string") parts = typeof next === "string" ? parts + next : [
            $d3ca412c0c679837$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === "string" ? $d3ca412c0c679837$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === "string" || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $6KYYx.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === "string" ? parts : $d3ca412c0c679837$var$concatBuffers(parts);
}
function $d3ca412c0c679837$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $d3ca412c0c679837$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === "string" ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === "number" ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $d3ca412c0c679837$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === "string" ? $d3ca412c0c679837$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $h32bW.dropUndefinedKeys)({
            type: "attachment",
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $d3ca412c0c679837$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: "session",
    sessions: "session",
    attachment: "attachment",
    transaction: "transaction",
    event: "error",
    client_report: "internal",
    user_report: "default",
    profile: "profile",
    replay_event: "replay",
    replay_recording: "replay",
    check_in: "monitor",
    feedback: "feedback",
    span: "span",
    statsd: "metric_bucket"
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $d3ca412c0c679837$export$b11169581eeaf237(type) {
    return $d3ca412c0c679837$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $d3ca412c0c679837$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $d3ca412c0c679837$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $49Pps.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $h32bW.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("gwKkF", function(module, exports) {

$parcel$export(module.exports, "SentryError", function () { return $c083931d072df5be$export$5949942ba2a7c0e2; });
/** An error emitted by Sentry SDKs and related utilities. */ class $c083931d072df5be$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = "warn"){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("4x1rT", function(module, exports) {

$parcel$export(module.exports, "createSessionEnvelope", function () { return $34cb5e3254838c9a$export$124b03c077baa2f3; });
$parcel$export(module.exports, "createEventEnvelope", function () { return $34cb5e3254838c9a$export$c31057337a18010f; });

var $iblUR = parcelRequire("iblUR");
var $49Pps = parcelRequire("49Pps");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $34cb5e3254838c9a$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $34cb5e3254838c9a$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $iblUR.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $49Pps.dsnToString)(dsn)
        }
    };
    const envelopeItem = "aggregates" in session ? [
        {
            type: "sessions"
        },
        session
    ] : [
        {
            type: "session"
        },
        session.toJSON()
    ];
    return (0, $iblUR.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $34cb5e3254838c9a$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $iblUR.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== "replay_event" ? event.type : "event";
    $34cb5e3254838c9a$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $iblUR.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $iblUR.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("a3esW", function(module, exports) {

$parcel$export(module.exports, "createMetricEnvelope", function () { return $751567d2a3cd3436$export$f23eb96e33154901; });

var $iblUR = parcelRequire("iblUR");
var $49Pps = parcelRequire("49Pps");

var $60tgC = parcelRequire("60tgC");
/**
 * Create envelope from a metric aggregate.
 */ function $751567d2a3cd3436$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $49Pps.dsnToString)(dsn);
    const item = $751567d2a3cd3436$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $iblUR.createEnvelope)(headers, [
        item
    ]);
}
function $751567d2a3cd3436$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $60tgC.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: "statsd",
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("60tgC", function(module, exports) {

$parcel$export(module.exports, "serializeMetricBuckets", function () { return $45f971fe6a67f8f7$export$66decd709db01dc8; });

var $h32bW = parcelRequire("h32bW");
/**
 * Generate bucket key from metric properties.
 */ function $45f971fe6a67f8f7$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $h32bW.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $45f971fe6a67f8f7$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $45f971fe6a67f8f7$export$66decd709db01dc8(metricBucketItems) {
    let out = "";
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(",")}` : "";
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $45f971fe6a67f8f7$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, "_");
}
/** Sanitizes metric keys */ function $45f971fe6a67f8f7$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, "_");
}
function $45f971fe6a67f8f7$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, "");
}
const $45f971fe6a67f8f7$var$tagValueReplacements = [
    [
        "\n",
        "\\n"
    ],
    [
        "\r",
        "\\r"
    ],
    [
        "	",
        "\\t"
    ],
    [
        "\\",
        "\\\\"
    ],
    [
        "|",
        "\\u{7c}"
    ],
    [
        ",",
        "\\u{2c}"
    ]
];
function $45f971fe6a67f8f7$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $45f971fe6a67f8f7$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $45f971fe6a67f8f7$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $45f971fe6a67f8f7$var$getCharOrReplacement(char), "");
}
/**
 * Sanitizes tags.
 */ function $45f971fe6a67f8f7$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $45f971fe6a67f8f7$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $45f971fe6a67f8f7$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("iUmR0", function(module, exports) {

$parcel$export(module.exports, "createClientReportEnvelope", function () { return $dc3f2f4a90b9f6e8$export$f3b9ed77c03eeb00; });

var $iblUR = parcelRequire("iblUR");

var $id9Yg = parcelRequire("id9Yg");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $dc3f2f4a90b9f6e8$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: "client_report"
        },
        {
            timestamp: timestamp || (0, $id9Yg.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $iblUR.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("dLku1", function(module, exports) {

$parcel$export(module.exports, "getSDKSource", function () { return $a04f8daf75eebc7a$export$8ad33f488b1ab046; });
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $a04f8daf75eebc7a$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== "undefined" && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $a04f8daf75eebc7a$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("9B6JL", function(module, exports) {

$parcel$export(module.exports, "DEBUG_BUILD", function () { return $6fcccb9d7aaf8b19$export$16a28057038b10ef; });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $6fcccb9d7aaf8b19$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === "undefined" || __SENTRY_DEBUG__;

});

parcelRegister("1S5EX", function(module, exports) {

$parcel$export(module.exports, "exceptionFromError", function () { return $15cf397c8c179809$export$a6c2d27607295951; });
$parcel$export(module.exports, "eventFromException", function () { return $15cf397c8c179809$export$ea3ec7e569b823fc; });
$parcel$export(module.exports, "eventFromUnknownInput", function () { return $15cf397c8c179809$export$9dd56ed1ef0c3420; });
$parcel$export(module.exports, "eventFromMessage", function () { return $15cf397c8c179809$export$5425b53185d13d6c; });

var $lwBvV = parcelRequire("lwBvV");

var $jc8x6 = parcelRequire("jc8x6");
var $h32bW = parcelRequire("h32bW");
var $h7OG0 = parcelRequire("h7OG0");
var $6KYYx = parcelRequire("6KYYx");
var $a6X2M = parcelRequire("a6X2M");
/**
 * This function creates an exception from a JavaScript Error
 */ function $15cf397c8c179809$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $15cf397c8c179809$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $15cf397c8c179809$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
/**
 * @hidden
 */ function $15cf397c8c179809$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $lwBvV.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $h7OG0.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? "UnhandledRejection" : "Error",
                    value: $15cf397c8c179809$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $6KYYx.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $15cf397c8c179809$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $15cf397c8c179809$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $15cf397c8c179809$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $15cf397c8c179809$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || "";
    const popSize = $15cf397c8c179809$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $15cf397c8c179809$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $15cf397c8c179809$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === "number") return ex.framesToPop;
        if ($15cf397c8c179809$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $15cf397c8c179809$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $15cf397c8c179809$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $15cf397c8c179809$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $jc8x6.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = "error";
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $a6X2M.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $15cf397c8c179809$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = "info", hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $15cf397c8c179809$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $a6X2M.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $15cf397c8c179809$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $h7OG0.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $15cf397c8c179809$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $h7OG0.isDOMError)(exception) || (0, $h7OG0.isDOMException)(exception)) {
        const domException = exception;
        if ("stack" in exception) event = $15cf397c8c179809$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $h7OG0.isDOMError)(domException) ? "DOMError" : "DOMException");
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $15cf397c8c179809$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $jc8x6.addExceptionTypeValue)(event, message);
        }
        if ("code" in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            "DOMException.code": `${domException.code}`
        };
        return event;
    }
    if ((0, $h7OG0.isError)(exception)) // we have a real Error object, do nothing
    return $15cf397c8c179809$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $h7OG0.isPlainObject)(exception) || (0, $h7OG0.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $15cf397c8c179809$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $jc8x6.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $15cf397c8c179809$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $jc8x6.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $jc8x6.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $15cf397c8c179809$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $15cf397c8c179809$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $h7OG0.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $15cf397c8c179809$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $h32bW.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? "promise rejection" : "exception";
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $h7OG0.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $h7OG0.isEvent)(exception)) {
        const className = $15cf397c8c179809$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $15cf397c8c179809$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("4Stk1", function(module, exports) {

$parcel$export(module.exports, "WINDOW", function () { return $38d2f34f0ab218fd$export$56d8a8a25bd48b81; });
$parcel$export(module.exports, "shouldIgnoreOnError", function () { return $38d2f34f0ab218fd$export$b79738ab10c590b2; });
$parcel$export(module.exports, "wrap", function () { return $38d2f34f0ab218fd$export$4997ffc0176396a6; });


var $lwBvV = parcelRequire("lwBvV");

var $jc8x6 = parcelRequire("jc8x6");
var $h32bW = parcelRequire("h32bW");
var $h2E4a = parcelRequire("h2E4a");
const $38d2f34f0ab218fd$export$56d8a8a25bd48b81 = (0, $h2E4a.GLOBAL_OBJ);
let $38d2f34f0ab218fd$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $38d2f34f0ab218fd$export$b79738ab10c590b2() {
    return $38d2f34f0ab218fd$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $38d2f34f0ab218fd$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $38d2f34f0ab218fd$var$ignoreOnError++;
    setTimeout(()=>{
        $38d2f34f0ab218fd$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $38d2f34f0ab218fd$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== "function") return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $h32bW.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$38d2f34f0ab218fd$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $38d2f34f0ab218fd$export$1265a142ff5ba165();
            (0, $lwBvV.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $jc8x6.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $jc8x6.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $lwBvV.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $h32bW.markFunctionWrapped)(sentryWrapped, fn);
    (0, $h32bW.addNonEnumerableProperty)(fn, "__sentry_wrapped__", sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("lmR7a", function(module, exports) {

$parcel$export(module.exports, "createUserFeedbackEnvelope", function () { return $f8e4da7f36beaf01$export$24a4dfcb686ee5bf; });

var $iblUR = parcelRequire("iblUR");
var $49Pps = parcelRequire("49Pps");
/**
 * Creates an envelope from a user feedback.
 */ function $f8e4da7f36beaf01$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $49Pps.dsnToString)(dsn)
        }
    };
    const item = $f8e4da7f36beaf01$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $iblUR.createEnvelope)(headers, [
        item
    ]);
}
function $f8e4da7f36beaf01$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: "user_report"
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("4Df2Y", function(module, exports) {

$parcel$export(module.exports, "breadcrumbsIntegration", function () { return $35f679f70637f97b$export$c079d904b326663a; });

var $lwBvV = parcelRequire("lwBvV");
var $9B4Sg = parcelRequire("9B4Sg");

var $eenPW = parcelRequire("eenPW");
var $3niCL = parcelRequire("3niCL");
var $cV1Z8 = parcelRequire("cV1Z8");
var $5Zo6K = parcelRequire("5Zo6K");
var $7X4qZ = parcelRequire("7X4qZ");
var $3VqIB = parcelRequire("3VqIB");
var $jc8x6 = parcelRequire("jc8x6");
var $2GR2A = parcelRequire("2GR2A");
var $v2WIs = parcelRequire("v2WIs");
var $l8auK = parcelRequire("l8auK");
var $6HxPH = parcelRequire("6HxPH");

var $9B6JL = parcelRequire("9B6JL");

var $4Stk1 = parcelRequire("4Stk1");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $35f679f70637f97b$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $35f679f70637f97b$var$INTEGRATION_NAME = "Breadcrumbs";
const $35f679f70637f97b$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $35f679f70637f97b$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $3niCL.addConsoleInstrumentationHandler)($35f679f70637f97b$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $eenPW.addClickKeypressInstrumentationHandler)($35f679f70637f97b$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $7X4qZ.addXhrInstrumentationHandler)($35f679f70637f97b$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $cV1Z8.addFetchInstrumentationHandler)($35f679f70637f97b$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $5Zo6K.addHistoryInstrumentationHandler)($35f679f70637f97b$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on("beforeSendEvent", $35f679f70637f97b$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $35f679f70637f97b$export$c079d904b326663a = (0, $9B4Sg.defineIntegration)($35f679f70637f97b$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $35f679f70637f97b$export$2dc68d50d56fbbd = (0, $9B4Sg.convertIntegrationFnToClass)($35f679f70637f97b$var$INTEGRATION_NAME, $35f679f70637f97b$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $35f679f70637f97b$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $lwBvV.getClient)() !== client) return;
        (0, $lwBvV.addBreadcrumb)({
            category: `sentry.${event.type === "transaction" ? "transaction" : "event"}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $jc8x6.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $35f679f70637f97b$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $lwBvV.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === "object" ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === "object" && typeof dom.maxStringLength === "number" ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $35f679f70637f97b$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$35f679f70637f97b$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$35f679f70637f97b$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $35f679f70637f97b$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === "string") keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $35f679f70637f97b$var$_isEvent(event) ? event.target : event;
            target = (0, $3VqIB.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $3VqIB.getComponentName)(element);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            "ui.component_name": componentName
        };
        (0, $lwBvV.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $35f679f70637f97b$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $lwBvV.getClient)() !== client) return;
        const breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $6HxPH.severityLevelFromString)(handlerData.level),
            message: (0, $l8auK.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $l8auK.safeJoin)(handlerData.args.slice(1), " ") || "console.assert"}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $lwBvV.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $35f679f70637f97b$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $lwBvV.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $7X4qZ.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $lwBvV.addBreadcrumb)({
            category: "xhr",
            data: data,
            type: "http"
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $35f679f70637f97b$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $lwBvV.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $lwBvV.addBreadcrumb)({
                category: "fetch",
                data: data,
                level: "error",
                type: "http"
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $lwBvV.addBreadcrumb)({
                category: "fetch",
                data: data,
                type: "http"
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $35f679f70637f97b$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $lwBvV.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $v2WIs.parseUrl)((0, $4Stk1.WINDOW).location.href);
        let parsedFrom = from ? (0, $v2WIs.parseUrl)(from) : undefined;
        const parsedTo = (0, $v2WIs.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $lwBvV.addBreadcrumb)({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $35f679f70637f97b$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("eenPW", function(module, exports) {

$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", function () { return $a5c4dcfb50ca7e22$export$5aeffd3db2cf9df7; });

var $jc8x6 = parcelRequire("jc8x6");

var $h32bW = parcelRequire("h32bW");

var $h2E4a = parcelRequire("h2E4a");

var $dLHuQ = parcelRequire("dLHuQ");
const $a5c4dcfb50ca7e22$var$WINDOW = (0, $h2E4a.GLOBAL_OBJ);
const $a5c4dcfb50ca7e22$var$DEBOUNCE_DURATION = 1000;
let $a5c4dcfb50ca7e22$var$debounceTimerID;
let $a5c4dcfb50ca7e22$var$lastCapturedEventType;
let $a5c4dcfb50ca7e22$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $a5c4dcfb50ca7e22$export$5aeffd3db2cf9df7(handler) {
    const type = "dom";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $a5c4dcfb50ca7e22$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $a5c4dcfb50ca7e22$export$3014bbf0af0e1d4a() {
    if (!$a5c4dcfb50ca7e22$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $dLHuQ.triggerHandlers).bind(null, "dom");
    const globalDOMEventHandler = $a5c4dcfb50ca7e22$var$makeDOMEventHandler(triggerDOMHandler, true);
    $a5c4dcfb50ca7e22$var$WINDOW.document.addEventListener("click", globalDOMEventHandler, false);
    $a5c4dcfb50ca7e22$var$WINDOW.document.addEventListener("keypress", globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        "EventTarget",
        "Node"
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $a5c4dcfb50ca7e22$var$WINDOW[target] && $a5c4dcfb50ca7e22$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $h32bW.fill)(proto, "addEventListener", function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $a5c4dcfb50ca7e22$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $h32bW.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === "click" || type == "keypress") try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $a5c4dcfb50ca7e22$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $a5c4dcfb50ca7e22$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $a5c4dcfb50ca7e22$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $a5c4dcfb50ca7e22$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== "keypress") return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $a5c4dcfb50ca7e22$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event["_sentryCaptured"]) return;
        const target = $a5c4dcfb50ca7e22$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($a5c4dcfb50ca7e22$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $h32bW.addNonEnumerableProperty)(event, "_sentryCaptured", true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $h32bW.addNonEnumerableProperty)(target, "_sentryId", (0, $jc8x6.uuid4)());
        const name = event.type === "keypress" ? "input" : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$a5c4dcfb50ca7e22$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $a5c4dcfb50ca7e22$var$lastCapturedEventType = event.type;
            $a5c4dcfb50ca7e22$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($a5c4dcfb50ca7e22$var$debounceTimerID);
        $a5c4dcfb50ca7e22$var$debounceTimerID = $a5c4dcfb50ca7e22$var$WINDOW.setTimeout(()=>{
            $a5c4dcfb50ca7e22$var$lastCapturedEventTargetId = undefined;
            $a5c4dcfb50ca7e22$var$lastCapturedEventType = undefined;
        }, $a5c4dcfb50ca7e22$var$DEBOUNCE_DURATION);
    };
}
function $a5c4dcfb50ca7e22$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("3niCL", function(module, exports) {

$parcel$export(module.exports, "addConsoleInstrumentationHandler", function () { return $2751f7728fc05217$export$1d6e0d073f9e6723; });

var $2GR2A = parcelRequire("2GR2A");

var $h32bW = parcelRequire("h32bW");

var $h2E4a = parcelRequire("h2E4a");

var $dLHuQ = parcelRequire("dLHuQ");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $2751f7728fc05217$export$1d6e0d073f9e6723(handler) {
    const type = "console";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $2751f7728fc05217$var$instrumentConsole);
}
function $2751f7728fc05217$var$instrumentConsole() {
    if (!("console" in (0, $h2E4a.GLOBAL_OBJ))) return;
    (0, $2GR2A.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $h2E4a.GLOBAL_OBJ).console)) return;
        (0, $h32bW.fill)((0, $h2E4a.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $2GR2A.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $dLHuQ.triggerHandlers)("console", handlerData);
                const log = (0, $2GR2A.originalConsoleMethods)[level];
                log && log.apply((0, $h2E4a.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("cV1Z8", function(module, exports) {

$parcel$export(module.exports, "addFetchInstrumentationHandler", function () { return $967c591b46c2b76a$export$f75d3c772c923df0; });

var $h32bW = parcelRequire("h32bW");

var $ewsHc = parcelRequire("ewsHc");

var $h2E4a = parcelRequire("h2E4a");

var $dLHuQ = parcelRequire("dLHuQ");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $967c591b46c2b76a$export$f75d3c772c923df0(handler) {
    const type = "fetch";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $967c591b46c2b76a$var$instrumentFetch);
}
function $967c591b46c2b76a$var$instrumentFetch() {
    if (!(0, $ewsHc.supportsNativeFetch)()) return;
    (0, $h32bW.fill)((0, $h2E4a.GLOBAL_OBJ), "fetch", function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $967c591b46c2b76a$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $dLHuQ.triggerHandlers)("fetch", {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $h2E4a.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $dLHuQ.triggerHandlers)("fetch", finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $dLHuQ.triggerHandlers)("fetch", erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $967c591b46c2b76a$var$hasProp(obj, prop) {
    return !!obj && typeof obj === "object" && !!obj[prop];
}
function $967c591b46c2b76a$var$getUrlFromResource(resource) {
    if (typeof resource === "string") return resource;
    if (!resource) return "";
    if ($967c591b46c2b76a$var$hasProp(resource, "url")) return resource.url;
    if (resource.toString) return resource.toString();
    return "";
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $967c591b46c2b76a$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: "GET",
        url: ""
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $967c591b46c2b76a$var$getUrlFromResource(url),
            method: $967c591b46c2b76a$var$hasProp(options, "method") ? String(options.method).toUpperCase() : "GET"
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $967c591b46c2b76a$var$getUrlFromResource(arg),
        method: $967c591b46c2b76a$var$hasProp(arg, "method") ? String(arg.method).toUpperCase() : "GET"
    };
}

});

parcelRegister("7X4qZ", function(module, exports) {

$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", function () { return $5ca17baa88f9d60b$export$55b6bb1e45c6cf59; });
$parcel$export(module.exports, "addXhrInstrumentationHandler", function () { return $5ca17baa88f9d60b$export$26ace48dd54c9aea; });

var $h7OG0 = parcelRequire("h7OG0");

var $h32bW = parcelRequire("h32bW");

var $h2E4a = parcelRequire("h2E4a");

var $dLHuQ = parcelRequire("dLHuQ");
const $5ca17baa88f9d60b$var$WINDOW = (0, $h2E4a.GLOBAL_OBJ);
const $5ca17baa88f9d60b$export$55b6bb1e45c6cf59 = "__sentry_xhr_v3__";
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $5ca17baa88f9d60b$export$26ace48dd54c9aea(handler) {
    const type = "xhr";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $5ca17baa88f9d60b$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $5ca17baa88f9d60b$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$5ca17baa88f9d60b$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $h32bW.fill)(xhrproto, "open", function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $h7OG0.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $5ca17baa88f9d60b$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$5ca17baa88f9d60b$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === "POST" && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$5ca17baa88f9d60b$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $dLHuQ.triggerHandlers)("xhr", handlerData);
                }
            };
            if ("onreadystatechange" in this && typeof this.onreadystatechange === "function") (0, $h32bW.fill)(this, "onreadystatechange", function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener("readystatechange", onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $h32bW.fill)(this, "setRequestHeader", function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$5ca17baa88f9d60b$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $h7OG0.isString)(header) && (0, $h7OG0.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $h32bW.fill)(xhrproto, "send", function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$5ca17baa88f9d60b$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $dLHuQ.triggerHandlers)("xhr", handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $5ca17baa88f9d60b$var$parseUrl(url) {
    if ((0, $h7OG0.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("v2WIs", function(module, exports) {

$parcel$export(module.exports, "parseUrl", function () { return $05d52e62b6717cfb$export$7a5253c0f62e0150; });
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $05d52e62b6717cfb$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || "";
    const fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $05d52e62b6717cfb$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $05d52e62b6717cfb$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ",").length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $05d52e62b6717cfb$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, "[filtered]:[filtered]@")// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, "").replace(/(:443)$/, "") || "";
    return `${protocol ? `${protocol}://` : ""}${filteredHost}${path}`;
}

});

parcelRegister("6HxPH", function(module, exports) {

$parcel$export(module.exports, "severityLevelFromString", function () { return $4e1100c1306068a7$export$d771ef054122c30a; });
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $4e1100c1306068a7$export$411d0ffdba845b6c = [
    "fatal",
    "error",
    "warning",
    "log",
    "info",
    "debug"
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $4e1100c1306068a7$export$e01cef29b4327697(level) {
    return $4e1100c1306068a7$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $4e1100c1306068a7$export$d771ef054122c30a(level) {
    return level === "warn" ? "warning" : $4e1100c1306068a7$export$411d0ffdba845b6c.includes(level) ? level : "log";
}

});


parcelRegister("8RvDZ", function(module, exports) {

$parcel$export(module.exports, "dedupeIntegration", function () { return $673bd1d33cf21242$export$6d39aa44cd0c7567; });

var $9B4Sg = parcelRequire("9B4Sg");

var $2GR2A = parcelRequire("2GR2A");

var $9B6JL = parcelRequire("9B6JL");
const $673bd1d33cf21242$var$INTEGRATION_NAME = "Dedupe";
const $673bd1d33cf21242$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $673bd1d33cf21242$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($673bd1d33cf21242$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Event dropped due to being a duplicate of previously captured event.");
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $673bd1d33cf21242$export$6d39aa44cd0c7567 = (0, $9B4Sg.defineIntegration)($673bd1d33cf21242$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $673bd1d33cf21242$export$688d98c249d31ad3 = (0, $9B4Sg.convertIntegrationFnToClass)($673bd1d33cf21242$var$INTEGRATION_NAME, $673bd1d33cf21242$export$6d39aa44cd0c7567);
function $673bd1d33cf21242$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($673bd1d33cf21242$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($673bd1d33cf21242$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $673bd1d33cf21242$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$673bd1d33cf21242$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$673bd1d33cf21242$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $673bd1d33cf21242$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $673bd1d33cf21242$var$_getExceptionFromEvent(previousEvent);
    const currentException = $673bd1d33cf21242$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$673bd1d33cf21242$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$673bd1d33cf21242$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $673bd1d33cf21242$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $673bd1d33cf21242$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $673bd1d33cf21242$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $673bd1d33cf21242$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join("") === previousFingerprint.join(""));
    } catch (_oO) {
        return false;
    }
}
function $673bd1d33cf21242$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $673bd1d33cf21242$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("4U7MB", function(module, exports) {

$parcel$export(module.exports, "globalHandlersIntegration", function () { return $39226de7690d5078$export$66acc70e8cf2b71a; });

var $lwBvV = parcelRequire("lwBvV");
var $9B4Sg = parcelRequire("9B4Sg");

var $eWNNz = parcelRequire("eWNNz");
var $56IZr = parcelRequire("56IZr");
var $3VqIB = parcelRequire("3VqIB");
var $h7OG0 = parcelRequire("h7OG0");
var $2GR2A = parcelRequire("2GR2A");

var $9B6JL = parcelRequire("9B6JL");

var $1S5EX = parcelRequire("1S5EX");

var $4Stk1 = parcelRequire("4Stk1");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $39226de7690d5078$var$INTEGRATION_NAME = "GlobalHandlers";
const $39226de7690d5078$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $39226de7690d5078$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $39226de7690d5078$var$_installGlobalOnErrorHandler(client);
                $39226de7690d5078$var$globalHandlerLog("onerror");
            }
            if (_options.onunhandledrejection) {
                $39226de7690d5078$var$_installGlobalOnUnhandledRejectionHandler(client);
                $39226de7690d5078$var$globalHandlerLog("onunhandledrejection");
            }
        }
    };
};
const $39226de7690d5078$export$66acc70e8cf2b71a = (0, $9B4Sg.defineIntegration)($39226de7690d5078$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $39226de7690d5078$export$204155decbc90e5a = (0, $9B4Sg.convertIntegrationFnToClass)($39226de7690d5078$var$INTEGRATION_NAME, $39226de7690d5078$export$66acc70e8cf2b71a);
function $39226de7690d5078$var$_installGlobalOnErrorHandler(client) {
    (0, $eWNNz.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $39226de7690d5078$var$getOptions();
        if ((0, $lwBvV.getClient)() !== client || (0, $4Stk1.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $h7OG0.isString)(msg) ? $39226de7690d5078$var$_eventFromIncompleteOnError(msg, url, line, column) : $39226de7690d5078$var$_enhanceEventWithInitialFrame((0, $1S5EX.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = "error";
        (0, $lwBvV.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onerror"
            }
        });
    });
}
function $39226de7690d5078$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $56IZr.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $39226de7690d5078$var$getOptions();
        if ((0, $lwBvV.getClient)() !== client || (0, $4Stk1.shouldIgnoreOnError)()) return;
        const error = $39226de7690d5078$var$_getUnhandledRejectionError(e);
        const event = (0, $h7OG0.isPrimitive)(error) ? $39226de7690d5078$var$_eventFromRejectionWithPrimitive(error) : (0, $1S5EX.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = "error";
        (0, $lwBvV.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: "onunhandledrejection"
            }
        });
    });
}
function $39226de7690d5078$var$_getUnhandledRejectionError(error) {
    if ((0, $h7OG0.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ("reason" in e) return e.reason;
        else if ("detail" in e && "reason" in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $39226de7690d5078$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: "UnhandledRejection",
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $39226de7690d5078$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $h7OG0.isErrorEvent)(msg) ? msg.message : msg;
    let name = "Error";
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $39226de7690d5078$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $39226de7690d5078$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $h7OG0.isString)(url) && url.length > 0 ? url : (0, $3VqIB.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: "?",
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $39226de7690d5078$var$globalHandlerLog(type) {
    (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).log(`Global Handler attached: ${type}`);
}
function $39226de7690d5078$var$getOptions() {
    const client = (0, $lwBvV.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("eWNNz", function(module, exports) {

$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", function () { return $ae1d1c6cc63ca112$export$55b5c3ba2194f0c6; });

var $h2E4a = parcelRequire("h2E4a");

var $dLHuQ = parcelRequire("dLHuQ");
let $ae1d1c6cc63ca112$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ae1d1c6cc63ca112$export$55b5c3ba2194f0c6(handler) {
    const type = "error";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $ae1d1c6cc63ca112$var$instrumentError);
}
function $ae1d1c6cc63ca112$var$instrumentError() {
    $ae1d1c6cc63ca112$var$_oldOnErrorHandler = (0, $h2E4a.GLOBAL_OBJ).onerror;
    (0, $h2E4a.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $dLHuQ.triggerHandlers)("error", handlerData);
        if ($ae1d1c6cc63ca112$var$_oldOnErrorHandler && !$ae1d1c6cc63ca112$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $ae1d1c6cc63ca112$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $h2E4a.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("56IZr", function(module, exports) {

$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", function () { return $3b80695c049fda18$export$8bf4fc6858821a4e; });

var $h2E4a = parcelRequire("h2E4a");

var $dLHuQ = parcelRequire("dLHuQ");
let $3b80695c049fda18$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $3b80695c049fda18$export$8bf4fc6858821a4e(handler) {
    const type = "unhandledrejection";
    (0, $dLHuQ.addHandler)(type, handler);
    (0, $dLHuQ.maybeInstrument)(type, $3b80695c049fda18$var$instrumentUnhandledRejection);
}
function $3b80695c049fda18$var$instrumentUnhandledRejection() {
    $3b80695c049fda18$var$_oldOnUnhandledRejectionHandler = (0, $h2E4a.GLOBAL_OBJ).onunhandledrejection;
    (0, $h2E4a.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $dLHuQ.triggerHandlers)("unhandledrejection", handlerData);
        if ($3b80695c049fda18$var$_oldOnUnhandledRejectionHandler && !$3b80695c049fda18$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $3b80695c049fda18$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $h2E4a.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("7pKyI", function(module, exports) {

$parcel$export(module.exports, "httpContextIntegration", function () { return $565efbd1908461f5$export$1378794447170364; });

var $9B4Sg = parcelRequire("9B4Sg");

var $4Stk1 = parcelRequire("4Stk1");
const $565efbd1908461f5$var$INTEGRATION_NAME = "HttpContext";
const $565efbd1908461f5$var$_httpContextIntegration = ()=>{
    return {
        name: $565efbd1908461f5$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $4Stk1.WINDOW).navigator && !(0, $4Stk1.WINDOW).location && !(0, $4Stk1.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $4Stk1.WINDOW).location && (0, $4Stk1.WINDOW).location.href;
            const { referrer: referrer } = (0, $4Stk1.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $4Stk1.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    "User-Agent": userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $565efbd1908461f5$export$1378794447170364 = (0, $9B4Sg.defineIntegration)($565efbd1908461f5$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $565efbd1908461f5$export$5d2ee9a544b09a94 = (0, $9B4Sg.convertIntegrationFnToClass)($565efbd1908461f5$var$INTEGRATION_NAME, $565efbd1908461f5$export$1378794447170364);

});

parcelRegister("kGXwn", function(module, exports) {

$parcel$export(module.exports, "linkedErrorsIntegration", function () { return $f105e690282fd369$export$ebabb00eb7f3a395; });

var $9B4Sg = parcelRequire("9B4Sg");

var $ctH8z = parcelRequire("ctH8z");

var $1S5EX = parcelRequire("1S5EX");
const $f105e690282fd369$var$DEFAULT_KEY = "cause";
const $f105e690282fd369$var$DEFAULT_LIMIT = 5;
const $f105e690282fd369$var$INTEGRATION_NAME = "LinkedErrors";
const $f105e690282fd369$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $f105e690282fd369$var$DEFAULT_LIMIT;
    const key = options.key || $f105e690282fd369$var$DEFAULT_KEY;
    return {
        name: $f105e690282fd369$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $ctH8z.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $1S5EX.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $f105e690282fd369$export$ebabb00eb7f3a395 = (0, $9B4Sg.defineIntegration)($f105e690282fd369$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f105e690282fd369$export$8d1e60aaf616fb4f = (0, $9B4Sg.convertIntegrationFnToClass)($f105e690282fd369$var$INTEGRATION_NAME, $f105e690282fd369$export$ebabb00eb7f3a395);

});
parcelRegister("ctH8z", function(module, exports) {

$parcel$export(module.exports, "applyAggregateErrorsToEvent", function () { return $9159a7a47d570d19$export$b91c38ed7d8ae9b2; });

var $h7OG0 = parcelRequire("h7OG0");

var $l8auK = parcelRequire("l8auK");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $9159a7a47d570d19$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $h7OG0.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $9159a7a47d570d19$var$truncateAggregateExceptions($9159a7a47d570d19$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $9159a7a47d570d19$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $h7OG0.isInstanceOf)(error[key], Error)) {
        $9159a7a47d570d19$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $9159a7a47d570d19$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $9159a7a47d570d19$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $h7OG0.isInstanceOf)(childError, Error)) {
            $9159a7a47d570d19$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $9159a7a47d570d19$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $9159a7a47d570d19$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $9159a7a47d570d19$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === "AggregateError" && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $9159a7a47d570d19$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: "generic",
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: "chained",
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $9159a7a47d570d19$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $l8auK.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("b5aUb", function(module, exports) {

$parcel$export(module.exports, "browserApiErrorsIntegration", function () { return $81189ee5d4745fe4$export$59bfe9f1c76150e; });

var $9B4Sg = parcelRequire("9B4Sg");

var $h32bW = parcelRequire("h32bW");
var $cd716 = parcelRequire("cd716");

var $4Stk1 = parcelRequire("4Stk1");
const $81189ee5d4745fe4$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "BroadcastChannel",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "SharedWorker",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
const $81189ee5d4745fe4$var$INTEGRATION_NAME = "TryCatch";
const $81189ee5d4745fe4$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $81189ee5d4745fe4$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $h32bW.fill)((0, $4Stk1.WINDOW), "setTimeout", $81189ee5d4745fe4$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $h32bW.fill)((0, $4Stk1.WINDOW), "setInterval", $81189ee5d4745fe4$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $h32bW.fill)((0, $4Stk1.WINDOW), "requestAnimationFrame", $81189ee5d4745fe4$var$_wrapRAF);
            if (_options.XMLHttpRequest && "XMLHttpRequest" in (0, $4Stk1.WINDOW)) (0, $h32bW.fill)(XMLHttpRequest.prototype, "send", $81189ee5d4745fe4$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $81189ee5d4745fe4$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($81189ee5d4745fe4$var$_wrapEventTarget);
            }
        }
    };
};
const $81189ee5d4745fe4$export$59bfe9f1c76150e = (0, $9B4Sg.defineIntegration)($81189ee5d4745fe4$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $81189ee5d4745fe4$export$f1a018517668e6d3 = (0, $9B4Sg.convertIntegrationFnToClass)($81189ee5d4745fe4$var$INTEGRATION_NAME, $81189ee5d4745fe4$export$59bfe9f1c76150e);
function $81189ee5d4745fe4$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $4Stk1.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $cd716.getFunctionName)(original)
                },
                handled: false,
                type: "instrument"
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81189ee5d4745fe4$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $4Stk1.wrap)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $cd716.getFunctionName)(original)
                    },
                    handled: false,
                    type: "instrument"
                }
            })
        ]);
    };
}
function $81189ee5d4745fe4$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            "onload",
            "onerror",
            "onprogress",
            "onreadystatechange"
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $h32bW.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $cd716.getFunctionName)(original)
                        },
                        handled: false,
                        type: "instrument"
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $h32bW.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $cd716.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $4Stk1.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $81189ee5d4745fe4$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $4Stk1.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
    (0, $h32bW.fill)(proto, "addEventListener", function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === "function") // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $4Stk1.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: "handleEvent",
                            handler: (0, $cd716.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $4Stk1.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $cd716.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: "instrument"
                    }
                }),
                options
            ]);
        };
    });
    (0, $h32bW.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("gUnN9", function(module, exports) {

$parcel$export(module.exports, "defaultStackParser", function () { return $c4f454db5e3cb878$export$2b2b997d81bf3907; });

var $cd716 = parcelRequire("cd716");
// global reference to slice
const $c4f454db5e3cb878$var$UNKNOWN_FUNCTION = "?";
const $c4f454db5e3cb878$var$OPERA10_PRIORITY = 10;
const $c4f454db5e3cb878$var$OPERA11_PRIORITY = 20;
const $c4f454db5e3cb878$var$CHROME_PRIORITY = 30;
const $c4f454db5e3cb878$var$WINJS_PRIORITY = 40;
const $c4f454db5e3cb878$var$GECKO_PRIORITY = 50;
function $c4f454db5e3cb878$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $c4f454db5e3cb878$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $c4f454db5e3cb878$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $c4f454db5e3cb878$var$chromeStackParserFn = (line)=>{
    const parts = $c4f454db5e3cb878$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
        if (isEval) {
            const subMatch = $c4f454db5e3cb878$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $c4f454db5e3cb878$var$extractSafariExtensionDetails(parts[1] || $c4f454db5e3cb878$var$UNKNOWN_FUNCTION, parts[2]);
        return $c4f454db5e3cb878$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $c4f454db5e3cb878$export$263a749fff749872 = [
    $c4f454db5e3cb878$var$CHROME_PRIORITY,
    $c4f454db5e3cb878$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $c4f454db5e3cb878$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $c4f454db5e3cb878$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $c4f454db5e3cb878$var$gecko = (line)=>{
    const parts = $c4f454db5e3cb878$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
        if (isEval) {
            const subMatch = $c4f454db5e3cb878$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ""; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $c4f454db5e3cb878$var$UNKNOWN_FUNCTION;
        [func, filename] = $c4f454db5e3cb878$var$extractSafariExtensionDetails(func, filename);
        return $c4f454db5e3cb878$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $c4f454db5e3cb878$export$cdba47a5dd2804d = [
    $c4f454db5e3cb878$var$GECKO_PRIORITY,
    $c4f454db5e3cb878$var$gecko
];
const $c4f454db5e3cb878$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $c4f454db5e3cb878$var$winjs = (line)=>{
    const parts = $c4f454db5e3cb878$var$winjsRegex.exec(line);
    return parts ? $c4f454db5e3cb878$var$createFrame(parts[2], parts[1] || $c4f454db5e3cb878$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $c4f454db5e3cb878$export$179460296da408e8 = [
    $c4f454db5e3cb878$var$WINJS_PRIORITY,
    $c4f454db5e3cb878$var$winjs
];
const $c4f454db5e3cb878$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $c4f454db5e3cb878$var$opera10 = (line)=>{
    const parts = $c4f454db5e3cb878$var$opera10Regex.exec(line);
    return parts ? $c4f454db5e3cb878$var$createFrame(parts[2], parts[3] || $c4f454db5e3cb878$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $c4f454db5e3cb878$export$f892b52c880ffc7a = [
    $c4f454db5e3cb878$var$OPERA10_PRIORITY,
    $c4f454db5e3cb878$var$opera10
];
const $c4f454db5e3cb878$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $c4f454db5e3cb878$var$opera11 = (line)=>{
    const parts = $c4f454db5e3cb878$var$opera11Regex.exec(line);
    return parts ? $c4f454db5e3cb878$var$createFrame(parts[5], parts[3] || parts[4] || $c4f454db5e3cb878$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $c4f454db5e3cb878$export$af11af13f09fb0dc = [
    $c4f454db5e3cb878$var$OPERA11_PRIORITY,
    $c4f454db5e3cb878$var$opera11
];
const $c4f454db5e3cb878$export$7197c0fe6554c079 = [
    $c4f454db5e3cb878$export$263a749fff749872,
    $c4f454db5e3cb878$export$cdba47a5dd2804d,
    $c4f454db5e3cb878$export$179460296da408e8
];
const $c4f454db5e3cb878$export$2b2b997d81bf3907 = (0, $cd716.createStackParser)(...$c4f454db5e3cb878$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $c4f454db5e3cb878$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf("safari-extension") !== -1;
    const isSafariWebExtension = func.indexOf("safari-web-extension") !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf("@") !== -1 ? func.split("@")[0] : $c4f454db5e3cb878$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("cIWmp", function(module, exports) {

$parcel$export(module.exports, "makeFetchTransport", function () { return $9436dd3f760fc8ad$export$b2311068c46d7cc8; });

var $ejIyj = parcelRequire("ejIyj");

var $a6X2M = parcelRequire("a6X2M");

var $bOaUY = parcelRequire("bOaUY");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $9436dd3f760fc8ad$export$b2311068c46d7cc8(options, nativeFetch = (0, $bOaUY.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: "POST",
            referrerPolicy: "origin",
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                        "retry-after": response.headers.get("Retry-After")
                    }
                };
            });
        } catch (e) {
            (0, $bOaUY.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $a6X2M.rejectedSyncPromise)(e);
        }
    }
    return (0, $ejIyj.createTransport)(options, makeRequest);
}

});
parcelRegister("ejIyj", function(module, exports) {

$parcel$export(module.exports, "createTransport", function () { return $a6c5663707c94371$export$d09f50d9ab7f7b69; });

var $iblUR = parcelRequire("iblUR");
var $hA63Q = parcelRequire("hA63Q");
var $2GR2A = parcelRequire("2GR2A");
var $VKwxn = parcelRequire("VKwxn");
var $a6X2M = parcelRequire("a6X2M");
var $gwKkF = parcelRequire("gwKkF");

var $dSDoS = parcelRequire("dSDoS");
const $a6c5663707c94371$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $a6c5663707c94371$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $VKwxn.makePromiseBuffer)(options.bufferSize || $a6c5663707c94371$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $iblUR.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $iblUR.envelopeItemTypeToDataCategory)(type);
            if ((0, $hA63Q.isRateLimited)(rateLimits, dataCategory)) {
                const event = $a6c5663707c94371$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent("ratelimit_backoff", dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $a6X2M.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $iblUR.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $iblUR.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $a6c5663707c94371$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $iblUR.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $iblUR.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $hA63Q.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss("network_error");
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $gwKkF.SentryError)) {
                (0, $dSDoS.DEBUG_BUILD) && (0, $2GR2A.logger).error("Skipped sending event because buffer is full.");
                recordEnvelopeLoss("queue_overflow");
                return (0, $a6X2M.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $a6c5663707c94371$var$getEventForEnvelopeItem(item, type) {
    if (type !== "event" && type !== "transaction") return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("hA63Q", function(module, exports) {

$parcel$export(module.exports, "isRateLimited", function () { return $ccca8010f748e332$export$6c91fec22056810a; });
$parcel$export(module.exports, "updateRateLimits", function () { return $ccca8010f748e332$export$699aff705e0d49d4; });
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $ccca8010f748e332$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $ccca8010f748e332$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $ccca8010f748e332$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $ccca8010f748e332$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $ccca8010f748e332$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $ccca8010f748e332$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $ccca8010f748e332$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers["x-sentry-rate-limits"];
    const retryAfterHeader = headers && headers["retry-after"];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(",")){
        const [retryAfter, categories, , , namespaces] = limit.split(":", 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(";")){
            if (category === "metric_bucket") // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(";").includes("custom")) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $ccca8010f748e332$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("VKwxn", function(module, exports) {

$parcel$export(module.exports, "makePromiseBuffer", function () { return $0ad969a486fac138$export$85a4f67f852183e6; });

var $gwKkF = parcelRequire("gwKkF");

var $a6X2M = parcelRequire("a6X2M");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $0ad969a486fac138$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $a6X2M.rejectedSyncPromise)(new (0, $gwKkF.SentryError)("Not adding Promise because buffer limit was reached."));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $a6X2M.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $a6X2M.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("bOaUY", function(module, exports) {

$parcel$export(module.exports, "getNativeFetchImplementation", function () { return $898cd54cb9b0f237$export$8be2119ce08e3379; });
$parcel$export(module.exports, "clearCachedFetchImplementation", function () { return $898cd54cb9b0f237$export$d499686d2dd738c6; });

var $ewsHc = parcelRequire("ewsHc");
var $2GR2A = parcelRequire("2GR2A");

var $9B6JL = parcelRequire("9B6JL");

var $4Stk1 = parcelRequire("4Stk1");
let $898cd54cb9b0f237$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $898cd54cb9b0f237$export$8be2119ce08e3379() {
    if ($898cd54cb9b0f237$var$cachedFetchImpl) return $898cd54cb9b0f237$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $ewsHc.isNativeFetch)((0, $4Stk1.WINDOW).fetch)) return $898cd54cb9b0f237$var$cachedFetchImpl = (0, $4Stk1.WINDOW).fetch.bind((0, $4Stk1.WINDOW));
    const document = (0, $4Stk1.WINDOW).document;
    let fetchImpl = (0, $4Stk1.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") try {
        const sandbox = document.createElement("iframe");
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $9B6JL.DEBUG_BUILD) && (0, $2GR2A.logger).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", e);
    }
    return $898cd54cb9b0f237$var$cachedFetchImpl = fetchImpl.bind((0, $4Stk1.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $898cd54cb9b0f237$export$d499686d2dd738c6() {
    $898cd54cb9b0f237$var$cachedFetchImpl = undefined;
}

});


parcelRegister("jG9b5", function(module, exports) {

$parcel$export(module.exports, "makeXHRTransport", function () { return $e5390f12c053cd02$export$5e1441cee30d5a39; });

var $ejIyj = parcelRequire("ejIyj");

var $a6X2M = parcelRequire("a6X2M");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $e5390f12c053cd02$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $e5390f12c053cd02$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $a6X2M.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $e5390f12c053cd02$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        "x-sentry-rate-limits": xhr.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": xhr.getResponseHeader("Retry-After")
                    }
                });
            };
            xhr.open("POST", options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $ejIyj.createTransport)(options, makeRequest);
}

});


parcelRegister("day6I", function(module, exports) {

$parcel$export(module.exports, "isOidcDisplayMode", function () { return $d2de09e6652f2e8e$export$62d34b9f4d1e3978; });
$parcel$export(module.exports, "isMobileOidc", function () { return $d2de09e6652f2e8e$export$eb7f7bf9cc131875; });
function $d2de09e6652f2e8e$export$62d34b9f4d1e3978(context, ...display) {
    if (!context || !context.display) return false;
    return display.includes(context.display);
}
function $d2de09e6652f2e8e$export$eb7f7bf9cc131875(context) {
    // currently we assume that any oidc with proper display param is a mobile oidc
    return !!context && !!context.display;
}

});


parcelRegister("gKvjl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0325917775c78225$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $4cW1f = parcelRequire("4cW1f");

var $4l8no = parcelRequire("4l8no");

var $hYg0S = parcelRequire("hYg0S");

var $e3fMT = parcelRequire("e3fMT");

var $bpuBL = parcelRequire("bpuBL");

var $k1dMP = parcelRequire("k1dMP");

var $bhY6y = parcelRequire("bhY6y");

var $arXeP = parcelRequire("arXeP");

var $df3ME = parcelRequire("df3ME");

var $eh37k = parcelRequire("eh37k");

var $2vX01 = parcelRequire("2vX01");

var $gErWv = parcelRequire("gErWv");

var $ce60p = parcelRequire("ce60p");

var $dtn8z = parcelRequire("dtn8z");

var $dRf7A = parcelRequire("dRf7A");

var $5E2Q9 = parcelRequire("5E2Q9");

var $6QXdB = parcelRequire("6QXdB");

var $ctYUa = parcelRequire("ctYUa");

var $fBSnV = parcelRequire("fBSnV");
function $0325917775c78225$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0325917775c78225$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0325917775c78225$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0325917775c78225$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $0325917775c78225$export$5df9262e102d0c32 = "/gateway/api/gasv3/api/v1";
const $0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY = "last.screen.event";
class $0325917775c78225$export$2e2bcd8739ae039 {
    constructor(productInfo, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_useStargate", (useStargate)=>{
            if (useStargate == null) return true;
            return useStargate;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_endsWith", (str, suffix)=>str.indexOf(suffix, str.length - suffix.length) !== -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_changeInternalUserId", (userId, anonymousId)=>{
            this.eventProcessor.getUser().setUserId(userId);
            if (anonymousId && anonymousId !== this.eventProcessor.getUser().getAnonymousId()) // Setting anonymous id can take a long time. Reading is a lot faster.
            // Only update if it has changed.
            this.eventProcessor.getUser().setAnonymousId(anonymousId);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_createSubproductGetter", (subproduct)=>(0, $hYg0S.default)(subproduct, "Cannot get subproduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_createEmbeddedProductGetter", (embeddedProduct)=>(0, $hYg0S.default)(embeddedProduct, "Cannot get embeddedProduct from the callback. Proceeding without it."));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getLastScreenEvent", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY) || "");
            } catch (err) {
                this._safeSessionStorage.removeItem($0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_setLastScreenEvent", (event)=>{
            this._safeSessionStorage.setItem($0325917775c78225$var$LAST_SCREEN_EVENT_STORAGE_KEY, JSON.stringify({
                name: event.name,
                attributes: event.attributes
            }));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldEventBeDelayed", (event)=>{
            // TODO: this is a temporary restriction for the purposes of the Track All Changes project
            // The delay mechanism has a chance of event loss, which we can only accept for our own data at this point.
            // Once the delay queue implementation has been improved and measured to confirm that it is reliable enough,
            // then we will be able to open it up for other products to use by removing this check.
            if (!event.tags || event.tags.indexOf("measurement") === -1) return false;
            const isEventHighPriority = event.highPriority !== false; // defaults to true if excluded
            return this.eventDelayQueue.isDelayingLowPriorityEvents() && !isEventHighPriority;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_fireEvent", (identifier, builtEvent, context, callback)=>{
            switch(builtEvent.eventType){
                case (0, $4cW1f.eventType).UI:
                case (0, $4cW1f.eventType).OPERATIONAL:
                case (0, $4cW1f.eventType).TRACK:
                    return this.eventProcessor.track(identifier, builtEvent, context, callback);
                case (0, $4cW1f.eventType).SCREEN:
                    return this.eventProcessor.page(identifier, builtEvent, context, callback);
                case (0, $4cW1f.eventType).IDENTIFY:
                    return this.eventProcessor.identify(identifier, builtEvent, context, callback);
                default:
                    throw new Error(`No handler has been defined for events of type ${builtEvent.eventType}`);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_fireDelayedEvent", (identifier, builtEvent, context, userInfo)=>{
            try {
                // User information can change while the delay period is active, so we need to restore the values that
                // were active when the event was originally fired.
                this._changeInternalUserId(userInfo.userId, userInfo.anonymousId);
                builtEvent.tags = [
                    ...builtEvent.tags || [],
                    "sentWithDelay"
                ];
                // The callbacks for delayed events are fired immediately, so there is nothing to pass through for this argument.
                this._fireEvent(identifier, builtEvent, context, undefined);
            } finally{
                this._changeInternalUserId(this._userInfo.userId, this._userInfo.anonymousId);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_delayEvent", (identifier, builtEvent, context, userInfo, callback)=>{
            this.eventDelayQueue.push(identifier, builtEvent, context, userInfo);
            // Fire the callback immediately, as we can consider the event successfully processed at this point
            if (callback) callback();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_processEvent", (identifier, builtEvent, context, callback)=>{
            this._testingCache.saveEvent(builtEvent);
            if (this._shouldEventBeDelayed(builtEvent)) {
                this._delayEvent(identifier, builtEvent, context, this._userInfo, callback);
                return Promise.resolve();
            } else return this._fireEvent(identifier, builtEvent, context, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setEmbeddedProduct", (embeddedProduct)=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(embeddedProduct);
            this.resetUIViewedTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearEmbeddedProduct", ()=>{
            this._productInfo.embeddedProduct = this._createEmbeddedProductGetter(null);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setSubproduct", (subproduct)=>{
            this._productInfo.subproduct = this._createSubproductGetter(subproduct);
            this.resetUIViewedTimers();
        });
        /**
      * Calling this function in the intialisation of the client in product
      * captures specified 'origin tracing' URL params and fires a single origin landed event
      * <p>
      * This function expects a mapping between the keys for any URL parameters
      *  that should be captured and removed for origin tracing
      * Multiple parameters may be captured simultaneously if multiple key: handler function pairs are provided
      * Each handler function should return an object with two items
      * a) 'originTracingAttributes' - an object that will be added to the 'origin landed' event's attributes under 'originTracing
      * b) 'taskSessionId' (optional) - an Id string that will be added to the tasksessions for any event that fires from the tab, with the key
      *    matching the URL parameter, for the purpose of attributing subsequent analytics event to the origin land.
      * </p>
      * The general use case for this feature is for allowing attributation of user behaviour to a out of product or cross product link,
      * e.g. from a share or email
      *
      * An example calling this function using an external decoding library, with taskSessionId specified to persist
      * analyticsWebClient.setOriginTracingHandlers({
           atlOrigin: encodedOrigin => {
               const { id, product } = OriginTracing.fromEncoded(encodedOrigin);
               return { originTracingAttributes: {'id': id, 'product': product}, taskSessionId: id };
           },
       });
      *
      * @param  {Object} originParamHandlerMapping a dictionary of mappings between origin url param keys and handler functions
      * @this {AnalyticsWebClient}
      */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setOriginTracingHandlers", (originParamHandlerMapping)=>{
            const capturedOriginTraces = this.originTracing.handleOriginParameters(originParamHandlerMapping, this._historyReplaceFn);
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (typeof capturedOriginTraces[x].taskSessionId !== "undefined") this.task.createTaskSessionWithProvidedId(x, capturedOriginTraces[x].taskSessionId);
            });
            const originAttributes = {};
            Object.keys(capturedOriginTraces).forEach((x)=>{
                if (capturedOriginTraces[x].originTracingAttributes) originAttributes[x] = capturedOriginTraces[x].originTracingAttributes;
                else // eslint-disable-next-line no-console
                console.warn(`Handling method for origin parameter ${x} has not returned any attributes`);
            });
            if (Object.keys(capturedOriginTraces).length > 0) return this.sendOperationalEvent({
                action: "landed",
                actionSubject: "origin",
                source: "webClient",
                attributes: {
                    originTracesLanded: originAttributes
                }
            }, // eslint-disable-next-line @typescript-eslint/no-empty-function
            ()=>{});
            return Promise.resolve();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setTenantInfo", (tenantIdType, tenantId)=>{
            if (!tenantIdType) throw new Error("Missing tenantIdType");
            if (tenantIdType !== (0, $4cW1f.tenantType).NONE && !tenantId) throw new Error("Missing tenantId");
            if (!(0, $4cW1f.isType)((0, $4cW1f.tenantType), tenantIdType)) throw new Error(`Invalid tenantIdType '${tenantIdType}', ` + `must be an tenantType: [${(0, $4cW1f.objectValues)((0, $4cW1f.tenantType))}]`);
            this._tenantInfo = {
                tenantIdType: tenantIdType,
                tenantId: tenantId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearTenantInfo", ()=>{
            this._tenantInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setOrgInfo", (orgId)=>{
            if (!orgId) throw new Error("Missing orgId");
            this._orgInfo = {
                orgId: orgId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearOrgInfo", ()=>{
            this._orgInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setWorkspaceInfo", (workspaceId)=>{
            if (!workspaceId) throw new Error("Missing workspaceId");
            this._workspaceInfo = {
                workspaceId: workspaceId
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearWorkspaceInfo", ()=>{
            this._workspaceInfo = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setUserInfo", (userIdType, userId)=>{
            (0, $k1dMP.validateIdentifyEvent)(userIdType, userId);
            this._changeInternalUserId(userId);
            this._userInfo = {
                userIdType: userIdType,
                userId: userId,
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearUserInfo", ()=>{
            this._changeInternalUserId(undefined);
            this._userInfo = {
                anonymousId: this.eventProcessor.getUser().getAnonymousId()
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setAlias", (aliasKeyType, alias)=>{
            if (!aliasKeyType) throw new Error("Missing aliasType");
            if (!(0, $4cW1f.isType)((0, $4cW1f.aliasType), aliasKeyType)) throw new Error(`Invalid aliasType '${aliasKeyType}', ` + `must be an aliasType: [${(0, $4cW1f.objectValues)((0, $4cW1f.aliasType))}]`);
            this._aliases[aliasKeyType] = alias;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearAlias", ()=>{
            this._aliases = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setGroup", (groupsKeyType, group)=>{
            if (!groupsKeyType) throw new Error("Missing groupType");
            if (!(0, $4cW1f.isType)((0, $4cW1f.groupType), groupsKeyType)) throw new Error(`Invalid groupType '${groupsKeyType}', ` + `must be an groupType: [${(0, $4cW1f.objectValues)((0, $4cW1f.groupType))}]`);
            this._groups[groupsKeyType] = group;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearGroup", ()=>{
            this._groups = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getAnonymousId", ()=>this._userInfo.anonymousId);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setUIViewedAttributes", (uiViewedAttributes)=>{
            if (!uiViewedAttributes) throw new Error("Missing uiViewedAttributes");
            if (typeof uiViewedAttributes !== "object" || Array.isArray(uiViewedAttributes)) throw new Error("Invalid uiViewedAttributes type, should be a non array object");
            this._uiViewedAttributes = $0325917775c78225$var$_objectSpread({}, uiViewedAttributes);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getUIViewedAttributes", ()=>{
            return this._uiViewedAttributes;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearUIViewedAttributes", ()=>{
            this._uiViewedAttributes = {};
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendIdentifyEvent", (userIdType, userId, callback)=>{
            this.setUserInfo(userIdType, userId);
            const builtEvent = {
                userIdType: userIdType,
                eventType: (0, $4cW1f.eventType).IDENTIFY
            };
            return this._processEvent(userId, builtEvent, this._context, callback);
        });
        /**
     * @deprecated
     * please use {@link sendScreenEvent instead)
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendPageEvent", (name, callback)=>{
            return this.sendScreenEvent(name, callback);
        });
        /**
     * send screen event
     * @param event The event / For retrocompatibility event name is still supported here.
     * @param callback
     * @param attributes. Deprecated, will get ignored if using an event object as first param.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendScreenEvent", (event, callback, attributes)=>{
            let screenName;
            let screenAttributes;
            let screenContainers;
            let screenTags;
            if (typeof event === "object") {
                /* This is for retrocompatibility */ screenName = event.name;
                screenAttributes = event.attributes;
                screenContainers = event.containers;
                screenTags = event.tags;
            } else {
                screenName = event;
                screenAttributes = attributes;
            }
            (0, $k1dMP.validateScreenEvent)(screenName);
            (0, $k1dMP.validateContainers)(screenContainers);
            const builtEvent = (0, $e3fMT.buildScreenEvent)(this._productInfo, this._tenantInfo, this._userInfo, screenAttributes, // TODO: Remove the as any and move into a place where we know event is an object
            event.nonPrivacySafeAttributes, screenTags, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, event, screenContainers, this._aliases, this._groups);
            const builtEventWithName = $0325917775c78225$var$_objectSpread({
                name: screenName
            }, builtEvent);
            this._setLastScreenEvent(builtEventWithName);
            return this._processEvent(screenName, builtEventWithName, this._context, (0, $ctYUa.default)(callback, builtEventWithName));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendTrackEvent", (event, callback)=>{
            (0, $k1dMP.validateTrackEvent)(event);
            const builtEvent = (0, $e3fMT.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $4cW1f.eventType).TRACK, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $e3fMT.buildActionName)(event), builtEvent, this._context, (0, $ctYUa.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendUIEvent", (event, callback)=>{
            (0, $k1dMP.validateUIEvent)(event);
            const builtEvent = (0, $e3fMT.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $4cW1f.eventType).UI, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $e3fMT.buildActionName)(event), builtEvent, this._context, (0, $ctYUa.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendOperationalEvent", (event, callback)=>{
            (0, $k1dMP.validateOperationalEvent)(event);
            const builtEvent = (0, $e3fMT.buildActionEvent)(this._productInfo, this._tenantInfo, this._userInfo, event, (0, $4cW1f.eventType).OPERATIONAL, this._tabTracking.getCurrentTabId(), this._sessionTracking.getCurrentSessionId(), this.task.getAllTaskSessions(), this._orgInfo, this._pageLoadId, this._workspaceInfo, this._aliases, this._groups);
            return this._processEvent((0, $e3fMT.buildActionName)(event), builtEvent, this._context, (0, $ctYUa.default)(callback, builtEvent));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startUIViewedEvent", (callback)=>{
            this.stopUIViewedEvent();
            this._uiViewedEvent = new (0, $5E2Q9.default)(this._productInfo, ()=>({
                    embeddedProduct: this._productInfo.embeddedProduct(),
                    subproduct: this._productInfo.subproduct(),
                    tenantIdType: this._tenantInfo.tenantIdType,
                    tenantId: this._tenantInfo.tenantId,
                    userId: this._userInfo.userId,
                    lastScreenEvent: this._getLastScreenEvent(),
                    attributes: this._uiViewedAttributes
                }), (event)=>this.sendUIEvent(event, callback));
            this._uiViewedEvent.start();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopUIViewedEvent", ()=>{
            if (this._uiViewedEvent) {
                this._uiViewedEvent.stop();
                this._uiViewedEvent = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "resetUIViewedTimers", ()=>{
            if (this._uiViewedEvent) this._uiViewedEvent.resetTimers();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startApdexEvent", (apdexEvent)=>{
            this._apdexEvent.start(apdexEvent);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getApdexStart", (apdexEvent)=>this._apdexEvent.getStart(apdexEvent));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopApdexEvent", (apdexEvent, callback)=>{
            this._apdexEvent.stop(apdexEvent, callback);
        });
        // TODO If we ever make another breaking change, merge these two optional args into an `options` object arg.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startLowPriorityEventDelay", (timeout, callback)=>{
            this.eventDelayQueue.startLowPriorityEventDelay(timeout, callback);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopLowPriorityEventDelay", ()=>{
            this.eventDelayQueue.stopLowPriorityEventDelay();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "onEvent", (_analyticsId, analyticsData)=>{
            if (!analyticsData) throw new Error("Missing analyticsData");
            if (!analyticsData.eventType) throw new Error("Missing analyticsData.eventType");
            if (analyticsData.eventType === (0, $4cW1f.eventType).TRACK) return this.sendTrackEvent(analyticsData);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).UI) return this.sendUIEvent(analyticsData);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).OPERATIONAL) return this.sendOperationalEvent(analyticsData);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).SCREEN) return this.sendScreenEvent(analyticsData.name, null, analyticsData.attributes);
            else if (analyticsData.eventType === (0, $4cW1f.eventType).IDENTIFY) return this.sendIdentifyEvent(analyticsData.userIdType, analyticsData.userId);
            throw new Error(`Invalid analyticsData.eventType '${analyticsData.eventType}', ` + `must be an eventType: [${(0, $4cW1f.objectValues)((0, $4cW1f.eventType))}]`);
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.env) throw new Error("Missing productInfo.env");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!(0, $4cW1f.isType)((0, $4cW1f.envType), productInfo.env)) throw new Error(`Invalid productInfo.env '${productInfo.env}', ` + `must be an envType: [${(0, $4cW1f.objectValues)((0, $4cW1f.envType))}]`);
        if (productInfo.perimeter && !(0, $4cW1f.isType)((0, $4cW1f.perimeterType), productInfo.perimeter)) throw new Error(`Invalid productInfo.perimeter '${productInfo.perimeter}', ` + `must be an perimeterType: [${(0, $4cW1f.objectValues)((0, $4cW1f.perimeterType))}]`);
        if (!productInfo.origin) productInfo.origin = (0, $4cW1f.originType).WEB;
        else if (!(0, $4cW1f.isType)((0, $4cW1f.originType), productInfo.origin)) throw new Error(`Invalid productInfo.origin '${productInfo.origin}', ` + `must be an originType: [${(0, $4cW1f.objectValues)((0, $4cW1f.originType))}]`);
        if (!productInfo.platform) productInfo.platform = productInfo.origin === (0, $4cW1f.originType).WEB ? (0, $4cW1f.platformType).WEB : (0, $4cW1f.platformType).DESKTOP;
        else (0, $k1dMP.validatePlatform)(productInfo);
        this.logger = settings.logger || console;
        this._productInfo = $0325917775c78225$var$_objectSpread($0325917775c78225$var$_objectSpread({}, productInfo), {}, {
            subproduct: this._createSubproductGetter(productInfo.subproduct),
            embeddedProduct: this._createEmbeddedProductGetter(productInfo.embeddedProduct)
        });
        this._tenantInfo = {};
        this._orgInfo = {};
        this._uiViewedAttributes = {};
        this._context = (0, $e3fMT.buildContext)(this._productInfo);
        this._safeSessionStorage = new (0, $gErWv.default)();
        const _useStargate = this._useStargate(settings.useStargate);
        const apiHost = settings.apiHost || (0, $eh37k.selectHost)({
            useStargate: _useStargate,
            env: productInfo.env,
            useLegacyUrl: settings.useLegacyUrl,
            perimeter: productInfo.perimeter,
            envOverride: productInfo.envOverride
        });
        const apiHostProtocol = settings.apiHostProtocol || "https";
        const minRetryDelay = settings.minRetryDelay || 1000;
        const retryQueueOptions = {
            maxRetryDelay: 60000,
            minRetryDelay: minRetryDelay,
            backoffFactor: 2,
            flushWaitMs: settings.flushWaitInterval,
            flushBeforeUnload: settings.flushBeforeUnload
        };
        const retryQueuePrefix = `awc-${productInfo.env}`;
        const xidPromiseGetter = ()=>(0, $fBSnV.XIDPromise)(settings.xidConsent, settings.xidPromiseFn);
        const disableCookiePersistence = settings.disableCookiePersistence || false;
        this.eventProcessor = new (0, $bhY6y.default)({
            apiHost: apiHost,
            apiHostProtocol: apiHostProtocol,
            product: productInfo.product,
            retryQueuePrefix: retryQueuePrefix,
            retryQueueOptions: retryQueueOptions,
            xidPromiseGetter: xidPromiseGetter,
            logger: this.logger,
            disableCookiePersistence: disableCookiePersistence
        });
        this._userInfo = {
            anonymousId: this.eventProcessor.getUser().getAnonymousId(settings === null || settings === void 0 ? void 0 : settings.customAnonymousIdGenerator)
        };
        this._pageVisibility = new (0, $df3ME.default)();
        this._tabTracking = new (0, $ce60p.default)();
        this._sessionTracking = new (0, $2vX01.default)({
            sessionExpiryTime: settings.sessionExpiryTime,
            onNewSessionStarted: settings.onNewSessionStarted
        });
        this.task = new (0, $dtn8z.default)();
        this.originTracing = new (0, $arXeP.default)();
        // Init Apdex
        this._apdexEvent = new (0, $4l8no.default)(this.sendOperationalEvent, this._pageVisibility);
        this._historyReplaceFn = typeof settings.historyReplaceFn === "function" ? settings.historyReplaceFn : (0, $6QXdB.defaultHistoryReplaceFn);
        this.eventDelayQueue = new (0, $bpuBL.default)(this._fireDelayedEvent, settings.delayQueueCompressors || []);
        this._testingCache = new (0, $dRf7A.default)();
        this._pageLoadId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
        this._workspaceInfo = {};
        this._aliases = {};
        this._groups = {};
    }
}

});
parcelRegister("gaCcd", function(module, exports) {

var $9mvsX = parcelRequire("9mvsX");

var $diJJr = parcelRequire("diJJr");
function $bc5b3573e5269f31$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $9mvsX)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $diJJr(rnds);
}
module.exports = $bc5b3573e5269f31$var$v4;

});
parcelRegister("9mvsX", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $6d0e939c6bd928d4$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof window.msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
if ($6d0e939c6bd928d4$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $6d0e939c6bd928d4$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $6d0e939c6bd928d4$var$getRandomValues($6d0e939c6bd928d4$var$rnds8);
        return $6d0e939c6bd928d4$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $6d0e939c6bd928d4$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $6d0e939c6bd928d4$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $6d0e939c6bd928d4$var$rnds;
    };
}

});

parcelRegister("diJJr", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $9af06e33de1a996d$var$byteToHex = [];
for(var $9af06e33de1a996d$var$i = 0; $9af06e33de1a996d$var$i < 256; ++$9af06e33de1a996d$var$i)$9af06e33de1a996d$var$byteToHex[$9af06e33de1a996d$var$i] = ($9af06e33de1a996d$var$i + 0x100).toString(16).substr(1);
function $9af06e33de1a996d$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $9af06e33de1a996d$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
module.exports = $9af06e33de1a996d$var$bytesToUuid;

});


parcelRegister("4cW1f", function(module, exports) {

$parcel$export(module.exports, "envType", function () { return $310549d3c4ba6d2c$export$56ac8ebc9870b1b9; });
$parcel$export(module.exports, "eventType", function () { return $310549d3c4ba6d2c$export$4c045e605d532c98; });
$parcel$export(module.exports, "platformType", function () { return $310549d3c4ba6d2c$export$6b4f396210e539f3; });
$parcel$export(module.exports, "originType", function () { return $310549d3c4ba6d2c$export$f73e9fcd368bb695; });
$parcel$export(module.exports, "tenantType", function () { return $310549d3c4ba6d2c$export$496f06ac2a964da2; });
$parcel$export(module.exports, "userType", function () { return $310549d3c4ba6d2c$export$1827adfd178b4870; });
$parcel$export(module.exports, "apdexType", function () { return $310549d3c4ba6d2c$export$99b37380a464d794; });
$parcel$export(module.exports, "desktopPlatforms", function () { return $310549d3c4ba6d2c$export$809831be6c4c6227; });
$parcel$export(module.exports, "webPlatforms", function () { return $310549d3c4ba6d2c$export$19c579398ad213e7; });
$parcel$export(module.exports, "originTracingType", function () { return $310549d3c4ba6d2c$export$62a500c02dc63ee; });
$parcel$export(module.exports, "objectValues", function () { return $310549d3c4ba6d2c$export$ad1854f4a08c15f8; });
$parcel$export(module.exports, "isType", function () { return $310549d3c4ba6d2c$export$26b9f946b448f23e; });
$parcel$export(module.exports, "perimeterType", function () { return $310549d3c4ba6d2c$export$bdd41749d2096e4b; });
$parcel$export(module.exports, "aliasType", function () { return $310549d3c4ba6d2c$export$a8c99e46b781d936; });
$parcel$export(module.exports, "groupType", function () { return $310549d3c4ba6d2c$export$e73680b18d9b7c6e; });
// These types have been converted from frozen objects to enums.
// We cannot change their name, or even capitalise them without breaking API.
let $310549d3c4ba6d2c$export$56ac8ebc9870b1b9 = /*#__PURE__*/ function(envType) {
    envType["LOCAL"] = "local";
    envType["DEV"] = "dev";
    envType["STAGING"] = "staging";
    envType["PROD"] = "prod";
    return envType;
}({});
let $310549d3c4ba6d2c$export$4c045e605d532c98 = /*#__PURE__*/ function(eventType) {
    eventType["TRACK"] = "track";
    eventType["UI"] = "ui";
    eventType["OPERATIONAL"] = "operational";
    eventType["SCREEN"] = "screen";
    eventType["IDENTIFY"] = "identify";
    return eventType;
}({});
let $310549d3c4ba6d2c$export$6b4f396210e539f3 = /*#__PURE__*/ function(platformType) {
    platformType["MAC"] = "mac";
    platformType["LINUX"] = "linux";
    platformType["WINDOWS"] = "windows";
    platformType["DESKTOP"] = "desktop";
    platformType["WEB"] = "web";
    platformType["MOBILE_WEB"] = "mobileWeb";
    return platformType;
}({});
let $310549d3c4ba6d2c$export$f73e9fcd368bb695 = /*#__PURE__*/ function(originType) {
    originType["DESKTOP"] = "desktop";
    originType["WEB"] = "web";
    return originType;
}({});
let $310549d3c4ba6d2c$export$496f06ac2a964da2 = /*#__PURE__*/ function(tenantType) {
    tenantType["CLOUD_ID"] = "cloudId";
    tenantType["ORG_ID"] = "orgId";
    tenantType["OPSGENIE_CUSTOMER_ID"] = "opsgenieCustomerId";
    tenantType["HALP_TEAM_ID"] = "halpTeamId";
    tenantType["LOOM_ORG_ID"] = "loomOrgId";
    tenantType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    tenantType["TRELLO_WORKSPACE_ID"] = "trelloWorkspaceId";
    tenantType["NONE"] = "none";
    return tenantType;
}({});
let $310549d3c4ba6d2c$export$1827adfd178b4870 = /*#__PURE__*/ function(userType) {
    userType["ATLASSIAN_ACCOUNT"] = "atlassianAccount";
    userType["HASHED_EMAIL"] = "hashedEmail";
    userType["LOOM"] = "loom";
    userType["TRELLO"] = "trello";
    userType["OPSGENIE"] = "opsgenie";
    userType["HALP"] = "halp";
    return userType;
}({});
let $310549d3c4ba6d2c$export$99b37380a464d794 = /*#__PURE__*/ function(apdexType) {
    apdexType["TRANSITION"] = "transition";
    apdexType["INITIAL_LOAD"] = "initialLoad";
    return apdexType;
}({});
const $310549d3c4ba6d2c$export$809831be6c4c6227 = Object.freeze([
    $310549d3c4ba6d2c$export$6b4f396210e539f3.DESKTOP,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.MAC,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.LINUX,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.WINDOWS
]);
const $310549d3c4ba6d2c$export$19c579398ad213e7 = Object.freeze([
    $310549d3c4ba6d2c$export$6b4f396210e539f3.WEB,
    $310549d3c4ba6d2c$export$6b4f396210e539f3.MOBILE_WEB
]);
let $310549d3c4ba6d2c$export$62a500c02dc63ee = /*#__PURE__*/ function(originTracingType) {
    originTracingType["ATL_ORIGIN"] = "atlOrigin";
    return originTracingType;
}({});
function $310549d3c4ba6d2c$export$ad1854f4a08c15f8(object) {
    return Object.values(object);
}
function $310549d3c4ba6d2c$export$26b9f946b448f23e(type, value) {
    return Object.values(type).indexOf(value) > -1;
}
let $310549d3c4ba6d2c$export$bdd41749d2096e4b = /*#__PURE__*/ function(perimeterType) {
    perimeterType["C5"] = "c5";
    perimeterType["COMMERCIAL"] = "commercial";
    perimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    perimeterType["FEDRAMP_HIGH"] = "fedramp-high";
    return perimeterType;
}({});
let $310549d3c4ba6d2c$export$a8c99e46b781d936 = /*#__PURE__*/ function(aliasType) {
    return aliasType;
}({});
let $310549d3c4ba6d2c$export$e73680b18d9b7c6e = /*#__PURE__*/ function(groupType) {
    groupType["TRANSACTION_ACCOUNT_ID"] = "transactionAccountId";
    return groupType;
}({});
let $310549d3c4ba6d2c$export$12b75c708da5a04b = /*#__PURE__*/ function(envOverrides) {
    return envOverrides;
}({});

});

parcelRegister("4l8no", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $328f9ef61eb8ca89$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $df3ME = parcelRequire("df3ME");

var $l9txO = parcelRequire("l9txO");
function $328f9ef61eb8ca89$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $328f9ef61eb8ca89$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $328f9ef61eb8ca89$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $328f9ef61eb8ca89$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $328f9ef61eb8ca89$export$2e2bcd8739ae039 {
    start(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        this._startedEvents.set(eventKey, true);
        this._isActiveEvents.set(eventKey, !this._pageVisibility.getIsHidden());
        this._performance.clearMarks(eventStartName);
        this._performance.mark(eventStartName);
    }
    getStart(event) {
        this._validateStartEvent(event);
        if (!this._performance.isAvailable()) return undefined;
        const eventKey = this._getEventKey(event);
        const eventStartName = `${eventKey}-start`;
        return this._getEventTimingByName(eventStartName);
    }
    stop(event, callback) {
        this._validateStopEvent(event);
        if (!this._performance.isAvailable()) return;
        const apdexFields = this._getApdexFields(event);
        const visibilityFields = this._getVisibilityFields(event);
        this._sendEvent($328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread({}, event), apdexFields), visibilityFields), callback);
    }
    onVisibilityChange(isActive) {
        if (!isActive) {
            this._wasPreviouslyHidden = true;
            Array.from(this._isActiveEvents.keys()).forEach((key)=>this._isActiveEvents.set(key, false));
        }
    }
    constructor(onEvent, pageVisibility){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getEventKey", ({ task: task, taskId: taskId })=>taskId ? `${task}.${taskId}` : task);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getEventTimingByName", (name)=>{
            const eventTimings = this._performance.getEntriesByName(name);
            const eventTiming = eventTimings[eventTimings.length - 1];
            return eventTiming;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getApdexFields", (event)=>{
            const apdexTimings = this._getApdexTimings(event);
            const apdexScore = this._calculateApdex({
                duration: apdexTimings.duration,
                threshold: event.threshold
            });
            return $328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread({}, apdexTimings), {}, {
                apdex: apdexScore
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getApdexTimings", (event)=>{
            const eventKey = this._getEventKey(event);
            const eventStartName = `${eventKey}-start`;
            const startTime = event.startTime || this._getStartTime(event, eventStartName);
            const stopTime = event.stopTime || this._getStopTime();
            // We do some clean up of the marks and started events
            this._cleanApdexState(eventKey);
            return {
                startTime: startTime,
                stopTime: stopTime,
                duration: stopTime - startTime
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getStartTime", (event, eventName)=>{
            let startTime;
            const timeOrigin = this._performance.getTimeOrigin();
            if (event.type === (0, $4cW1f.apdexType).INITIAL_LOAD) startTime = timeOrigin;
            else {
                const eventTiming = this._getEventTimingByName(eventName);
                startTime = timeOrigin + eventTiming.startTime;
            }
            return startTime;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getStopTime", ()=>this._performance.getTimeOrigin() + this._performance.now());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_cleanApdexState", (eventKey)=>{
            this._performance.clearMarks(`${eventKey}-start`);
            this._performance.clearMarks(`${eventKey}-stop`);
            this._startedEvents.delete(eventKey);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getVisibilityFields", (event)=>{
            let isActiveTab;
            /**
       * For initialLoad type:
       * 1. if tab was not ever hidden (!_wasPreviouslyHidden)
       *
       * For transition type:
       * 1. active status is tracked in active events map (_isActiveEvents)
       *
       * For any type, if startTime or stopTime is specified:
       * 1. If currently active (!_isHidden)
       */ if (event.type === (0, $4cW1f.apdexType).INITIAL_LOAD) isActiveTab = !this._wasPreviouslyHidden;
            else if (event.type === (0, $4cW1f.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                isActiveTab = this._isActiveEvents.get(eventKey);
            }
            if (event.startTime || event.stopTime) isActiveTab = !this._pageVisibility.getIsHidden();
            return {
                isActiveTab: isActiveTab
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_calculateApdex", ({ duration: duration, threshold: threshold = this._threshold })=>{
            let apdex;
            const satisfiedThreshold = threshold;
            const tolerableThreshold = threshold * 4;
            if (duration <= satisfiedThreshold) apdex = 1;
            else if (duration <= tolerableThreshold) apdex = 0.5;
            else apdex = 0;
            return apdex;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_validateStartEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex start event');
            if (!event.task) throw new Error('Missing "task" in Apdex start event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex start event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex start event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_validateStopEvent", (event)=>{
            if (!event) throw new Error('Missing "event" in Apdex stop event');
            if (!event.task) throw new Error('Missing "task" in Apdex stop event');
            if (typeof event.task !== "string") throw new Error('Invalid "task" in Apdex stop event');
            if (event.taskId && typeof event.taskId !== "string") throw new Error('Invalid "taskId" in Apdex stop event');
            if (!event.type) throw new Error('Missing "type" in Apdex stop event');
            if (event.type && !(0, $4cW1f.isType)((0, $4cW1f.apdexType), event.type)) throw new Error('Invalid "type" in Apdex stop event');
            if (event.threshold && typeof event.threshold !== "number") throw new Error('Invalid "threshold" in Apdex stop event');
            /*
       * For a transition, if the startTime was not specified,
       * the start event should have been present.
       */ if (!event.startTime && event.type === (0, $4cW1f.apdexType).TRANSITION) {
                const eventKey = this._getEventKey(event);
                if (!this._startedEvents.has(eventKey)) throw new Error(`Apdex event transition "${eventKey}" was not started`);
            }
            if (event.startTime && !(typeof event.startTime === "number" && event.startTime >= 0)) throw new Error('Invalid "startTime" in Apdex stop event');
            if (event.stopTime && typeof event.stopTime !== "number") throw new Error('Invalid "stopTime" in Apdex stop event');
            if (event.stopTime <= event.startTime) throw new Error('"stopTime" should be greater than "startTime" in Apdex stop event');
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldSendEvent", (event)=>{
            if (!event) return false;
            if (typeof event.apdex !== "number") return false;
            return true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_sendEvent", (event, callback)=>{
            if (this._shouldSendEvent(event)) this._onEvent({
                source: "ui",
                action: "readyForUser",
                actionSubject: "ui",
                attributes: $328f9ef61eb8ca89$var$_objectSpread($328f9ef61eb8ca89$var$_objectSpread({}, event.additionalAttributes), {}, {
                    task: event.task,
                    taskId: event.taskId,
                    type: event.type,
                    threshold: event.threshold || this._threshold,
                    apdex: event.apdex,
                    startTime: event.startTime,
                    stopTime: event.stopTime,
                    duration: event.duration,
                    isActiveTab: event.isActiveTab
                })
            }, callback);
        });
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        if (!(pageVisibility instanceof (0, $df3ME.default))) throw new Error("Invalid pageVisibility, must be PageVisibility class");
        this._startedEvents = new Map();
        this._performance = new (0, $l9txO.default)();
        this._onEvent = onEvent;
        this._threshold = 1000;
        this._wasPreviouslyHidden = pageVisibility.getIsHidden();
        this._isActiveEvents = new Map();
        this._pageVisibility = pageVisibility;
        this._pageVisibility.addCallback("apdexEvent", (isHidden)=>{
            this.onVisibilityChange(!isHidden);
        });
    }
}

});
parcelRegister("df3ME", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $027ce59ebd9a7a07$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");
class $027ce59ebd9a7a07$export$2e2bcd8739ae039 {
    addCallback(name, fn) {
        if (typeof name !== "string") throw new Error("Invalid name, must be string");
        if (typeof fn !== "function") throw new Error("Invalid callback, must be function");
        this._callbacks.set(name, fn);
    }
    removeCallback(name) {
        if (this._callbacks.has(name)) this._callbacks.delete(name);
    }
    getIsHidden() {
        return this._isHidden;
    }
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_bindEventListeners", ()=>{
            document.addEventListener(this._visibilityChange, this._handleVisibilityChange, false);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_handleVisibilityChange", ()=>{
            const isHidden = document[this._hidden];
            this._isHidden = isHidden;
            this._callbacks.forEach((callbackFn)=>callbackFn(isHidden));
        });
        this._isHidden = false;
        this._callbacks = new Map();
        this._hidden = undefined;
        this._visibilityChange = undefined;
        if (typeof document !== "undefined") {
            if (typeof document.hidden !== "undefined") {
                // Opera 12.10 and Firefox 18 and later support
                this._isHidden = document.hidden;
                this._hidden = "hidden";
                this._visibilityChange = "visibilitychange";
            } else if (typeof document.msHidden !== "undefined") {
                this._isHidden = document.msHidden;
                this._hidden = "msHidden";
                this._visibilityChange = "msvisibilitychange";
            } else if (typeof document.webkitHidden !== "undefined") {
                this._isHidden = document.webkitHidden;
                this._hidden = "webkitHidden";
                this._visibilityChange = "webkitvisibilitychange";
            }
            if (typeof document.addEventListener !== "undefined" && this._hidden !== undefined) this._bindEventListeners();
        }
    }
}

});

parcelRegister("l9txO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f6615b1d27239a48$export$2e2bcd8739ae039; });
class $f6615b1d27239a48$export$2e2bcd8739ae039 {
    clearMarks(...args) {
        if (!this._performance || !this._performance.clearMarks) return;
        this._performance.clearMarks(...args);
    }
    mark(...args) {
        if (!this._performance || !this._performance.mark) return;
        this._performance.mark(...args);
    }
    getEntriesByName(...args) {
        if (!this._performance || !this._performance.getEntriesByName) return [];
        return this._performance.getEntriesByName(...args);
    }
    getTimeOrigin() {
        if (!this._performance || !this._performance.timeOrigin && !this._performance.timing) return 0;
        return this._performance.timeOrigin || this._performance.timing.navigationStart;
    }
    now() {
        if (!this._performance || !this._performance.now) return Date.now ? Date.now() : +new Date();
        return this._performance.now();
    }
    isAvailable() {
        return !!this._performance && !!this._performance.clearMarks && !!this._performance.mark && !!this._performance.getEntriesByName && !!this._performance.timing;
    }
    constructor(){
        this._performance = window.performance;
    }
}

});


parcelRegister("hYg0S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1547622e874d526$export$2e2bcd8739ae039; });
/**
 * Wraps {possibleFn} into a error-safe function and handles cases where {possibleFn}
 * is a function or object
 *
 * @param possibleFn - function that returns and object or the object itself
 * @param errorMessage - error message to log if {possibleFn} is a function and
 *                        throws an error when called
 * @returns {Function}
 */ const $d1547622e874d526$var$isFunction = (possibleFn)=>typeof possibleFn === "function";
var $d1547622e874d526$export$2e2bcd8739ae039 = (possibleFn, errorMessage)=>{
    return ()=>{
        if ($d1547622e874d526$var$isFunction(possibleFn)) try {
            return possibleFn();
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(`${errorMessage} - ${e instanceof Error ? e.message : String(e)}`);
            return undefined;
        }
        return possibleFn;
    };
};

});

parcelRegister("e3fMT", function(module, exports) {

$parcel$export(module.exports, "buildActionFields", function () { return $a3ad9798af913352$export$655ecf7241feac42; });
$parcel$export(module.exports, "buildScreenEvent", function () { return $a3ad9798af913352$export$c7d9a5f56acc4b19; });
$parcel$export(module.exports, "buildActionName", function () { return $a3ad9798af913352$export$9c5623a792efc9b0; });
$parcel$export(module.exports, "buildContext", function () { return $a3ad9798af913352$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "buildActionEvent", function () { return $a3ad9798af913352$export$7bf451af4a8e3dd9; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $ixNt4 = parcelRequire("ixNt4");
function $a3ad9798af913352$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3ad9798af913352$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3ad9798af913352$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3ad9798af913352$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a3ad9798af913352$var$libraryVersion = "4.26.0";
function $a3ad9798af913352$var$buildTenantFields(tenantInfo) {
    return {
        tenantIdType: tenantInfo.tenantIdType,
        tenantId: tenantInfo.tenantId
    };
}
function $a3ad9798af913352$var$buildUserFields(userInfo) {
    return {
        userIdType: userInfo.userIdType
    };
}
function $a3ad9798af913352$var$buildOrgFields(orgInfo) {
    return {
        orgId: orgInfo.orgId
    };
}
function $a3ad9798af913352$var$buildWorkspaceFields(workspaceInfo) {
    return {
        workspaceId: workspaceInfo.workspaceId
    };
}
function $a3ad9798af913352$var$buildAliases(aliases) {
    if ($a3ad9798af913352$var$isNotEmptyObject(aliases)) return {
        aliases: aliases
    };
    return undefined;
}
function $a3ad9798af913352$var$buildGroups(groups) {
    if ($a3ad9798af913352$var$isNotEmptyObject(groups)) return {
        groups: groups
    };
    return undefined;
}
function $a3ad9798af913352$var$buildEventOverrides(event) {
    if (event.anonymousId) return {
        anonymousId: event.anonymousId
    };
    return {};
}
function $a3ad9798af913352$var$getProductField(field, override) {
    return override === undefined ? field : override;
}
function $a3ad9798af913352$var$buildProductFields(productInfo, productOverrides) {
    const overrides = productOverrides || {};
    const env = $a3ad9798af913352$var$getProductField(productInfo.env, overrides.env);
    const product = $a3ad9798af913352$var$getProductField(productInfo.product, overrides.product);
    const subproduct = $a3ad9798af913352$var$getProductField(productInfo.subproduct(), overrides.subproduct);
    const version = $a3ad9798af913352$var$getProductField(productInfo.version, overrides.version);
    const origin = $a3ad9798af913352$var$getProductField(productInfo.origin, overrides.origin);
    const platform = $a3ad9798af913352$var$getProductField(productInfo.platform, overrides.platform);
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $a3ad9798af913352$var$isNotEmptyObject(obj) {
    return (0, $ixNt4.isPlainObject)(obj) && Object.keys(obj).length > 0;
}
function $a3ad9798af913352$var$buildAttributesWithName(name, attrObject) {
    return $a3ad9798af913352$var$isNotEmptyObject(attrObject) ? {
        [name]: attrObject
    } : undefined;
}
function $a3ad9798af913352$var$buildAttributes(attributes) {
    return $a3ad9798af913352$var$buildAttributesWithName("attributes", attributes);
}
function $a3ad9798af913352$export$3f5115a568819c1a(containers) {
    const validContainers = {};
    Object.keys(containers).forEach((key)=>{
        const value = containers[key];
        validContainers[key] = {
            id: value.id,
            type: value.type
        };
    });
    return validContainers;
}
function $a3ad9798af913352$export$f045f238d77c002a(containers) {
    if ($a3ad9798af913352$var$isNotEmptyObject(containers)) {
        const validContainers = $a3ad9798af913352$export$3f5115a568819c1a(containers);
        return $a3ad9798af913352$var$buildAttributesWithName("containers", validContainers);
    }
    return undefined;
}
function $a3ad9798af913352$export$655ecf7241feac42(event, actionEventType) {
    return $a3ad9798af913352$var$_objectSpread({
        containerType: event.containerType,
        containerId: event.containerId,
        source: event.source,
        objectType: event.objectType,
        objectId: event.objectId,
        actionSubject: event.actionSubject,
        action: event.action,
        actionSubjectId: event.actionSubjectId,
        attributes: event.attributes,
        nonPrivacySafeAttributes: event.nonPrivacySafeAttributes,
        tags: event.tags,
        highPriority: event.highPriority,
        eventType: actionEventType
    }, $a3ad9798af913352$export$f045f238d77c002a(event.containers));
}
function $a3ad9798af913352$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes) {
    return $a3ad9798af913352$var$buildAttributesWithName("nonPrivacySafeAttributes", nonPrivacySafeAttributes);
}
function $a3ad9798af913352$export$c7d9a5f56acc4b19(productInfo, tenantInfo, userInfo, attributes, nonPrivacySafeAttributes, tags, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, event, containers, aliases, groups) {
    const productFields = $a3ad9798af913352$var$buildProductFields(productInfo);
    const tenantFields = $a3ad9798af913352$var$buildTenantFields(tenantInfo);
    const userFields = $a3ad9798af913352$var$buildUserFields(userInfo);
    const orgFields = $a3ad9798af913352$var$buildOrgFields(orgInfo);
    const workspaceFields = $a3ad9798af913352$var$buildWorkspaceFields(workspaceInfo);
    const overrides = {
        title: "",
        path: "",
        url: "",
        referrer: "",
        search: "",
        eventType: (0, $4cW1f.eventType).SCREEN
    };
    return $a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread({}, productFields), tenantFields), userFields), orgFields), overrides), $a3ad9798af913352$var$buildAttributes(attributes)), $a3ad9798af913352$var$buildNonPrivacySafeAttributes(nonPrivacySafeAttributes)), $a3ad9798af913352$export$f045f238d77c002a(containers)), $a3ad9798af913352$var$buildEventOverrides(event)), {}, {
        tags: tags,
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $a3ad9798af913352$var$buildAliases(aliases)), $a3ad9798af913352$var$buildGroups(groups));
}
function $a3ad9798af913352$export$9c5623a792efc9b0(event) {
    return `${event.actionSubject} ${event.action}`;
}
function $a3ad9798af913352$export$3a7fe28f9bf4f3d9(productInfo) {
    const screen = window.screen || {};
    return {
        context: {
            locale: productInfo.locale,
            screen: {
                width: screen.width,
                height: screen.height,
                density: window.devicePixelRatio
            },
            library: {
                name: "analytics.js",
                version: $a3ad9798af913352$var$libraryVersion
            }
        }
    };
}
function $a3ad9798af913352$export$e3d99b4bfec06f6e(event) {
    const { env: env, product: product, subproduct: subproduct, version: version, origin: origin, platform: platform } = event;
    return {
        env: env,
        product: product,
        subproduct: subproduct,
        version: version,
        origin: origin,
        platform: platform
    };
}
function $a3ad9798af913352$export$7bf451af4a8e3dd9(productInfo, tenantInfo, userInfo, event, actionEventType, tabId, sessionId, taskSessions, orgInfo, pageLoadId, workspaceInfo, aliases, groups) {
    const productFields = $a3ad9798af913352$var$buildProductFields(productInfo, $a3ad9798af913352$export$e3d99b4bfec06f6e(event));
    const tenantFields = $a3ad9798af913352$var$buildTenantFields(tenantInfo);
    const orgFields = $a3ad9798af913352$var$buildOrgFields(orgInfo);
    const workspaceFields = $a3ad9798af913352$var$buildWorkspaceFields(workspaceInfo);
    const userFields = $a3ad9798af913352$var$buildUserFields(userInfo);
    const actionFields = $a3ad9798af913352$export$655ecf7241feac42(event, actionEventType);
    return $a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread($a3ad9798af913352$var$_objectSpread({}, productFields), tenantFields), orgFields), userFields), actionFields), $a3ad9798af913352$var$buildEventOverrides(event)), {}, {
        tabId: tabId,
        sessionId: sessionId,
        taskSessions: taskSessions,
        pageLoadId: pageLoadId
    }, workspaceFields), $a3ad9798af913352$var$buildAliases(aliases)), $a3ad9798af913352$var$buildGroups(groups));
}

});
parcelRegister("ixNt4", function(module, exports) {

$parcel$export(module.exports, "isPlainObject", function () { return $d801ae5590779e5d$export$53b83ca8eaab0383; });
// Modified from https://github.com/jonschlinkert/is-plain-object/blob/master/index.js
function $d801ae5590779e5d$var$isObject(val) {
    return val !== null && typeof val === "object" && Array.isArray(val) === false;
}
function $d801ae5590779e5d$var$isObjectObject(o) {
    return $d801ae5590779e5d$var$isObject(o) === true && Object.prototype.toString.call(o) === "[object Object]";
}
function $d801ae5590779e5d$export$53b83ca8eaab0383(o) {
    if ($d801ae5590779e5d$var$isObjectObject(o) === false) return false;
    // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor !== "function") return false;
    // If has modified prototype
    const prot = ctor.prototype;
    if ($d801ae5590779e5d$var$isObjectObject(prot) === false) return false;
    // If constructor does not have an Object-specific method
    if (!("isPrototypeOf" in prot)) return false;
    // Most likely a plain Object
    return true;
}

});


parcelRegister("bpuBL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $84e9c5a3bcd544fd$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $cquUO = parcelRequire("cquUO");

var $d5qix = parcelRequire("d5qix");

var $hgxKq = parcelRequire("hgxKq");
class $84e9c5a3bcd544fd$export$2e2bcd8739ae039 {
    constructor(fireDelayedEvent, compressors){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.delayQueue.push(identifier, builtEvent, context, userInfo);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startLowPriorityEventDelay", (timeout = (0, $cquUO.DEFAULT_DELAY_TIMEOUT), callback)=>{
            if (Number.isNaN(timeout) || timeout <= 0) throw new Error(`Invalid timeout period: ${timeout}, must be a number greater than 0`);
            if (this.delayTimeout) clearTimeout(this.delayTimeout);
            const delayTimeoutPeriod = timeout ? Math.min(timeout, (0, $cquUO.MAX_DELAY_TIMEOUT)) : (0, $cquUO.MAX_DELAY_TIMEOUT);
            this.delayCallback = callback;
            this.delayTimeout = setTimeout(()=>this.stopLowPriorityEventDelay((0, $hgxKq.StopLowPriorityEventDelayReason).TIMEOUT), delayTimeoutPeriod);
            // If the queue is still flushing from a previous delay period, then we should cancel that flush
            // to stop it from negatively impacting the performance of the new critical section
            this.delayQueue.cancelFlush();
            this.isDelaying = true;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopLowPriorityEventDelay", (reason = (0, $hgxKq.StopLowPriorityEventDelayReason).MANUAL)=>{
            var _this$delayCallback;
            if (this.delayTimeout) {
                clearTimeout(this.delayTimeout);
                this.delayTimeout = undefined;
            }
            this.delayQueue.startFlush();
            this.isDelaying = false;
            (_this$delayCallback = this.delayCallback) === null || _this$delayCallback === void 0 || _this$delayCallback.call(this, reason);
            this.delayCallback = undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "isDelayingLowPriorityEvents", ()=>this.isDelaying);
        this.isDelaying = false;
        this.delayQueue = new (0, $d5qix.default)(fireDelayedEvent, compressors);
    }
}

});
parcelRegister("cquUO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_DELAY_TIMEOUT", function () { return $90bfe4dd5119da5e$export$cf090d5281b5ae06; });
$parcel$export(module.exports, "MAX_DELAY_TIMEOUT", function () { return $90bfe4dd5119da5e$export$8575e30be0feb909; });
const $90bfe4dd5119da5e$export$cf090d5281b5ae06 = 10000;
const $90bfe4dd5119da5e$export$8575e30be0feb909 = 30000;

});

parcelRegister("d5qix", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $987024340dca7573$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $e3fMT = parcelRequire("e3fMT");

var $dbpk1 = parcelRequire("dbpk1");

var $6BF99 = parcelRequire("6BF99");
// We want to throttle the flush rate so that we don't have a huge upfront performance hit from starting the flush,
// and so that the underlying Segment client has some time to process some events in its queue before more are added.
const $987024340dca7573$var$FLUSH_BATCH_SIZE = 7; // aligns with the default batch size of Segment's BatchableQueue
const $987024340dca7573$var$FLUSH_BATCH_BACKOFF_PERIOD = 100;
class $987024340dca7573$export$2e2bcd8739ae039 {
    constructor(processFn, compressionRules){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "push", (identifier, builtEvent, context, userInfo)=>{
            this.eventArgs.push({
                identifier: identifier,
                builtEvent: builtEvent,
                context: context,
                userInfo: userInfo
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "size", ()=>this.eventArgs.length);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startFlush", ()=>{
            try {
                this.eventArgs = this.compressEventArgs(this.eventArgs);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.warn("Failed to perform compression on the delayed analytics events. " + `Error: ${e.message}. Sending ${this.eventArgs.length} uncompressed events instead`);
            }
            this.flushNextBatch();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "cancelFlush", ()=>{
            if (this.flushBatchTimeout) {
                clearTimeout(this.flushBatchTimeout);
                this.flushBatchTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "flushNextBatch", ()=>{
            const batch = this.eventArgs.splice(0, $987024340dca7573$var$FLUSH_BATCH_SIZE);
            batch.forEach((item)=>this.processFn(item.identifier, item.builtEvent, item.context, item.userInfo));
            if (this.eventArgs.length > 0) this.flushBatchTimeout = setTimeout(()=>this.flushNextBatch(), $987024340dca7573$var$FLUSH_BATCH_BACKOFF_PERIOD);
            else this.flushBatchTimeout = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compressEventArgs", (eventArgs)=>{
            const [compressibleEventArgs, incompressibleEventArgs] = (0, $dbpk1.partition)(eventArgs, (args)=>this.compressor.canCompress(args.builtEvent));
            // Events can only be compressed together if they share the same context and user info, since these are top-level
            // fields that need to exist on the fired event and can only be set to a single value.
            // We can achieve this by grouping our events by context prior to passing them to the compressor.
            const contextGroups = compressibleEventArgs.reduce((groups, args)=>{
                const matchingGroup = groups.find((group)=>(0, $dbpk1.equals)(group.userInfo, args.userInfo) && (0, $dbpk1.equals)(group.context, args.context));
                if (matchingGroup) matchingGroup.eventArgs.push(args);
                else groups.push({
                    userInfo: args.userInfo,
                    context: args.context,
                    eventArgs: [
                        args
                    ]
                });
                return groups;
            }, []);
            // Run the compressor on each group
            const allCompressedEventArgs = contextGroups.reduce((acc, group)=>{
                try {
                    const events = group.eventArgs.map((args)=>args.builtEvent);
                    const compressedEvents = this.compressor.compress(events);
                    const compressedEventArgs = compressedEvents.map((compressedEvent)=>({
                            identifier: (0, $e3fMT.buildActionName)(compressedEvent),
                            builtEvent: compressedEvent,
                            userInfo: group.userInfo,
                            context: group.context
                        }));
                    return acc.concat(compressedEventArgs);
                } catch (e) {
                    // If anything goes wrong while compressing this group, then just fall back on the
                    // uncompressed events instead. The event compressor already handles errors with invalid
                    // generator functions or results, but this is an extra layer of defense to prevent data
                    // loss in the event of an unexpected error.
                    // eslint-disable-next-line no-console
                    console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.eventArgs.length} uncompressed events instead`);
                    return group.eventArgs;
                }
            }, []);
            incompressibleEventArgs.forEach((args)=>allCompressedEventArgs.push(args));
            return allCompressedEventArgs;
        });
        this.processFn = processFn;
        this.flushBatchTimeout = null;
        this.eventArgs = [];
        this.compressor = new (0, $6BF99.default)(compressionRules);
    }
}

});
parcelRegister("dbpk1", function(module, exports) {

$parcel$export(module.exports, "mapKeys", function () { return $998ff1dd287e0bb2$export$781522908e4e76a1; });
$parcel$export(module.exports, "pick", function () { return $998ff1dd287e0bb2$export$357523c63a2253b9; });
$parcel$export(module.exports, "omitBy", function () { return $998ff1dd287e0bb2$export$d7a617dda645b4e3; });
$parcel$export(module.exports, "pickBy", function () { return $998ff1dd287e0bb2$export$b460b275d6c6aa0; });
$parcel$export(module.exports, "omit", function () { return $998ff1dd287e0bb2$export$30a06c8d3562193f; });
$parcel$export(module.exports, "equals", function () { return $998ff1dd287e0bb2$export$e9bab7fafb253603; });
$parcel$export(module.exports, "partition", function () { return $998ff1dd287e0bb2$export$b29f828819edca8d; });
/* eslint-disable no-return-assign, no-sequences */ // https://www.30secondsofcode.org/js/s/map-keys
const $998ff1dd287e0bb2$export$781522908e4e76a1 = (obj, fn)=>Object.keys(obj).reduce((acc, k)=>{
        const key = fn(obj[k], k, obj);
        acc[key] = obj[k];
        return acc;
    }, {});
// https://www.30secondsofcode.org/js/s/pick
const $998ff1dd287e0bb2$export$357523c63a2253b9 = (obj, arr)=>arr.reduce((acc, curr)=>(curr in obj && (acc[curr] = obj[curr]), acc), {});
// https://www.30secondsofcode.org/js/s/omit-by
const $998ff1dd287e0bb2$export$d7a617dda645b4e3 = (obj, fn)=>Object.keys(obj).filter((k)=>!fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/pick-by
const $998ff1dd287e0bb2$export$b460b275d6c6aa0 = (obj, fn)=>Object.keys(obj).filter((k)=>fn(obj[k], k)).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/omit
const $998ff1dd287e0bb2$export$30a06c8d3562193f = (obj, arr)=>Object.keys(obj).filter((k)=>arr.indexOf(k) < 0).reduce((acc, key)=>(acc[key] = obj[key], acc), {});
// https://www.30secondsofcode.org/js/s/equals
const $998ff1dd287e0bb2$export$e9bab7fafb253603 = (a, b)=>{
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    if (!a || !b || typeof a !== "object" && typeof b !== "object") return a === b;
    if (a.prototype !== b.prototype) return false;
    const keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k)=>$998ff1dd287e0bb2$export$e9bab7fafb253603(a[k], b[k]));
};
// https://www.30secondsofcode.org/js/s/partition
const $998ff1dd287e0bb2$export$b29f828819edca8d = (arr, fn)=>arr.reduce(// eslint-disable-next-line no-shadow
    (acc, val, i, arr)=>{
        acc[fn(val, i, arr) ? 0 : 1].push(val);
        return acc;
    }, [
        [],
        []
    ]);

});

parcelRegister("6BF99", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cf61da61b37289a$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $e3fMT = parcelRequire("e3fMT");

var $dbpk1 = parcelRequire("dbpk1");

var $eJEam = parcelRequire("eJEam");
function $4cf61da61b37289a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cf61da61b37289a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cf61da61b37289a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cf61da61b37289a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $4cf61da61b37289a$export$2e2bcd8739ae039 {
    constructor(compressionRules = []){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "canCompress", (event)=>this.compressionRules.some((compressionRule)=>compressionRule.canCompress(event)));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compress", (events)=>{
            const groups = this.createGroups(events);
            return groups.reduce((allCompressedEvents, group)=>{
                const groupCompressedEvents = this.compressGroup(group);
                return allCompressedEvents.concat(groupCompressedEvents);
            }, []);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createGroups", (events)=>// Group events based on contextual fields. These fields are anything that is added by the client itself,
            // rather than passed in by the caller (eg. product, org. and tenant info)
            events.reduce((groups, event)=>{
                const matchingCompressor = this.compressionRules.find((compressor)=>compressor.canCompress(event));
                let contextFields;
                if (matchingCompressor) {
                    const actionFields = (0, $e3fMT.buildActionFields)(event, event.eventType);
                    contextFields = (0, $dbpk1.omit)(event, Object.keys(actionFields));
                }
                const matchingGroup = groups.find((group)=>matchingCompressor === group.compressor && (0, $dbpk1.equals)(contextFields, group.contextFields));
                if (matchingGroup) matchingGroup.events.push(event);
                else groups.push({
                    contextFields: contextFields,
                    compressor: matchingCompressor,
                    events: [
                        event
                    ]
                });
                return groups;
            }, []));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compressGroup", (group)=>{
            // If this group doesn't have any compressor, then the event args are already in their final format
            if (!group.compressor) return group.events;
            try {
                // Run the compressor on the group to generate some new events.
                // The compression function is only expected to return the action fields for each
                // event that it generates, since all other fields are generated by the client.
                const compressedEventActionFields = group.compressor.compress(group.events);
                // Add the context fields to each of the resulting events to inflate them into a full action event
                return compressedEventActionFields.map((actionFields)=>$4cf61da61b37289a$var$_objectSpread($4cf61da61b37289a$var$_objectSpread({}, actionFields), group.contextFields));
            } catch (e) {
                // If we fail to compress the events, then just fall back the uncompressed events
                // so that no data is lost. This can happen if the compression function throws an error
                // or returns some invalid event payloads.
                // eslint-disable-next-line no-console
                console.warn("Failed to compress some analytics events. " + `Error: ${e.message}. Sending ${group.events.length} uncompressed events instead`);
                return group.events;
            }
        });
        if (!Array.isArray(compressionRules)) throw new Error("Event compressors must be constructed with an array of CompressionRules");
        if (!compressionRules.every((rule)=>rule instanceof (0, $eJEam.CompressionRule))) throw new Error("Event compressors can only be constructed with instances of CompressionRule");
        this.compressionRules = compressionRules;
    }
}

});
parcelRegister("eJEam", function(module, exports) {

$parcel$export(module.exports, "CompressionRule", function () { return $aba46cca50b1b2e4$export$89b3253ddfd2e6e8; });

var $6bkHe = parcelRequire("6bkHe");

var $k1dMP = parcelRequire("k1dMP");

var $dbpk1 = parcelRequire("dbpk1");
class $aba46cca50b1b2e4$export$89b3253ddfd2e6e8 {
    /**
   * @callback EventPredicate
   * @param {object} event An analytics event
   * @returns {boolean} A flag indicating whether or not the event matches the conditions
   */ /**
   * @callback CompressionFunction
   * @param {Array.<Object>} events A collection of analytics events that match the predicate of this compression rule
   * @returns {Array.<Object>} compressedEvents The compressed analytics events to fire
   */ /**
   * This constructor defines a new rule for compressing analytics events.
   * @param {EventPredicate} predicate
   * @param {CompressionFunction} compressFn
   */ constructor(predicate, compressFn){
        /**
     * This function returns a flag indicating whether or not this instance is capable of compressing the given event.
     * @param event
     * @returns {boolean}
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "canCompress", (event)=>{
            try {
                return event && (0, $k1dMP.isActionEventType)(event.eventType) && this.predicate(event);
            } catch (e) {
                return false;
            }
        });
        /**
     * This function compresses as many events in the given collection as possible.<p>
     * Any events in the given collection that do not match the conditions of {@link canCompress} will be left uncompressed and
     * appended to the end of the resulting array.
     *
     * @param events A collection of analytic events to compress
     * @returns {Array.<Object>} The action fields for the resulting compressed events
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "compress", (events)=>{
            const [compatibleEvents, incompatibleEvents] = (0, $dbpk1.partition)(events, (event)=>this.canCompress(event));
            const compressedEvents = this.compressFn(compatibleEvents);
            if (!compressedEvents) throw new Error("No events were returned from the compression function");
            compressedEvents.forEach((event)=>{
                (0, $k1dMP.validateActionEventType)(event.eventType);
                (0, $k1dMP.validateActionEvent)(event);
            });
            return compressedEvents.concat(incompatibleEvents);
        });
        if (typeof predicate !== "function") throw new Error("Invalid predicate, must be a function that accepts an event and returns a boolean");
        if (typeof compressFn !== "function") throw new Error("Invalid compressFn, must be a function that both accepts and returns an array of events");
        this.predicate = predicate;
        this.compressFn = compressFn;
    }
}

});
parcelRegister("k1dMP", function(module, exports) {

$parcel$export(module.exports, "validateContainers", function () { return $e92e985ceb13a2f5$export$e63ea5d8477971d3; });
$parcel$export(module.exports, "isActionEventType", function () { return $e92e985ceb13a2f5$export$d19cebda16f7579a; });
$parcel$export(module.exports, "validateActionEventType", function () { return $e92e985ceb13a2f5$export$4a8d7476662aebcc; });
$parcel$export(module.exports, "validateActionEvent", function () { return $e92e985ceb13a2f5$export$e0c121325c66ed4c; });
$parcel$export(module.exports, "validateScreenEvent", function () { return $e92e985ceb13a2f5$export$dc993432a592dc27; });
$parcel$export(module.exports, "validateTrackEvent", function () { return $e92e985ceb13a2f5$export$8c014fd74b0c8b99; });
$parcel$export(module.exports, "validateUIEvent", function () { return $e92e985ceb13a2f5$export$e5bac0930c812e90; });
$parcel$export(module.exports, "validateOperationalEvent", function () { return $e92e985ceb13a2f5$export$1e561554275607ef; });
$parcel$export(module.exports, "validateIdentifyEvent", function () { return $e92e985ceb13a2f5$export$c16a4e16aa4026c0; });
$parcel$export(module.exports, "validatePlatform", function () { return $e92e985ceb13a2f5$export$801b46c35394d316; });

var $4cW1f = parcelRequire("4cW1f");

var $ixNt4 = parcelRequire("ixNt4");
const $e92e985ceb13a2f5$var$actionEventTypes = Object.freeze([
    (0, $4cW1f.eventType).OPERATIONAL,
    (0, $4cW1f.eventType).TRACK,
    (0, $4cW1f.eventType).UI
]);
function $e92e985ceb13a2f5$export$df8ff30e3c960006(container) {
    if (!(0, $ixNt4.isPlainObject)(container)) throw new Error("properties.containers must be an Object");
    if (!("id" in container)) throw new Error("properties.containers is missing field 'id'");
    if (typeof container.id !== "string") throw new Error("properties.containers.id must be of type String");
    if ("type" in container && typeof container.type !== "string") throw new Error("properties.containers.type must be of type String");
}
function $e92e985ceb13a2f5$export$e63ea5d8477971d3(containers) {
    if (!containers) return;
    if (containers && containers.constructor !== Object) throw new Error("properties.containers must be an Object");
    Object.values(containers).forEach((container)=>$e92e985ceb13a2f5$export$df8ff30e3c960006(container));
}
function $e92e985ceb13a2f5$export$d19cebda16f7579a(type) {
    switch(type){
        case (0, $4cW1f.eventType).OPERATIONAL:
        case (0, $4cW1f.eventType).TRACK:
        case (0, $4cW1f.eventType).UI:
            return true;
        default:
            return false;
    }
}
function $e92e985ceb13a2f5$export$4a8d7476662aebcc(type) {
    if (!$e92e985ceb13a2f5$export$d19cebda16f7579a(type)) throw new Error(`Invalid action event type: ${type}, must be one of: [${$e92e985ceb13a2f5$var$actionEventTypes}]`);
    return true;
}
function $e92e985ceb13a2f5$export$e0c121325c66ed4c(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
    if (!event.action) throw new Error("Missing event.action");
    $e92e985ceb13a2f5$export$e63ea5d8477971d3(event.containers);
}
function $e92e985ceb13a2f5$export$dc993432a592dc27(name) {
    if (!name) throw new Error("Missing name");
}
function $e92e985ceb13a2f5$export$8c014fd74b0c8b99(event) {
    $e92e985ceb13a2f5$export$e0c121325c66ed4c(event);
}
function $e92e985ceb13a2f5$export$39d6334da9a44984(event) {
    if (!event) throw new Error("Missing event");
    if (!event.source) throw new Error("Missing event.source");
    if (!event.actionSubject) throw new Error("Missing event.actionSubject");
}
function $e92e985ceb13a2f5$export$e5bac0930c812e90(event) {
    $e92e985ceb13a2f5$export$e0c121325c66ed4c(event);
}
function $e92e985ceb13a2f5$export$1e561554275607ef(event) {
    $e92e985ceb13a2f5$export$e0c121325c66ed4c(event);
}
function $e92e985ceb13a2f5$export$c16a4e16aa4026c0(userIdType, userId) {
    if (!userIdType) throw new Error("Missing userIdType");
    if (!userId) throw new Error("Missing userId");
    if (!(0, $4cW1f.isType)((0, $4cW1f.userType), userIdType)) throw new Error(`Invalid userIdType '${userIdType}', ` + `must be an userType: [${(0, $4cW1f.objectValues)((0, $4cW1f.userType))}]`);
}
function $e92e985ceb13a2f5$export$801b46c35394d316(productInfo) {
    if (!(0, $4cW1f.isType)((0, $4cW1f.platformType), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + `must be a platformType: [${(0, $4cW1f.objectValues)((0, $4cW1f.platformType))}]`);
    if (productInfo.origin === (0, $4cW1f.originType).DESKTOP && !(0, $4cW1f.isType)((0, $4cW1f.desktopPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', ` + "must be one of [mac, linux, windows]");
    if (productInfo.origin === (0, $4cW1f.originType).WEB && !(0, $4cW1f.isType)((0, $4cW1f.webPlatforms), productInfo.platform)) throw new Error(`Invalid productInfo.platform '${productInfo.platform}', must be one of [web, mobileWeb]`);
}

});




parcelRegister("hgxKq", function(module, exports) {

$parcel$export(module.exports, "StopLowPriorityEventDelayReason", function () { return $c91e1bea4a01ea64$export$fa6e3729c21cb8f; });
let $c91e1bea4a01ea64$export$fa6e3729c21cb8f = /*#__PURE__*/ function(StopLowPriorityEventDelayReason) {
    StopLowPriorityEventDelayReason["TIMEOUT"] = "timeout";
    StopLowPriorityEventDelayReason["MANUAL"] = "manual";
    return StopLowPriorityEventDelayReason;
}({});

});


parcelRegister("bhY6y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $837fe7c84ea3bd0a$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $iqSwv = parcelRequire("iqSwv");

var $elE98 = parcelRequire("elE98");

var $gINol = parcelRequire("gINol");

var $3q4zO = parcelRequire("3q4zO");

var $bEXZy = parcelRequire("bEXZy");

var $hng8D = parcelRequire("hng8D");

var $ePQx8 = parcelRequire("ePQx8");

var $jV8Tw = parcelRequire("jV8Tw");
function $837fe7c84ea3bd0a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $837fe7c84ea3bd0a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $837fe7c84ea3bd0a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $837fe7c84ea3bd0a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $837fe7c84ea3bd0a$export$2e2bcd8739ae039 {
    getUser() {
        return this.user;
    }
    async track(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hng8D.SegmentEventTypes).TRACK, builtEvent);
        const eventWithoutMessageId = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hng8D.SegmentEventTypes).TRACK,
            properties: (0, $jV8Tw.prepareEventProperties)(builtEvent),
            event: eventName
        });
        const event = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    async page(eventName, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hng8D.SegmentEventTypes).PAGE, builtEvent);
        const eventWithoutMessageId = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hng8D.SegmentEventTypes).PAGE,
            properties: (0, $jV8Tw.prepareEventProperties)(builtEvent),
            name: eventName
        });
        const event = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    // Segment uses the identifier to update user id which we have already done in the analyticsWebClient.ts
    async identify(_identifier, builtEvent, context, callback) {
        const baseEvent = this.buildBaseEvent(context, (0, $hng8D.SegmentEventTypes).IDENTIFY, builtEvent);
        const eventWithoutMessageId = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, baseEvent), {}, {
            type: (0, $hng8D.SegmentEventTypes).IDENTIFY,
            traits: (0, $jV8Tw.prepareEventProperties)(builtEvent)
        });
        const event = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, eventWithoutMessageId), {}, {
            messageId: this.createMessageId()
        });
        const packagedEvent = this.packageEvent(event);
        await this.resilienceQueue.addItem(packagedEvent);
        if (callback) callback();
    }
    buildBaseEvent(context, type, overrides) {
        const clonedContext = (0, $jV8Tw.prepareEventProperties)(context);
        const segmentContext = (0, $jV8Tw.buildContext)(clonedContext);
        return {
            context: segmentContext,
            timestamp: new Date().toISOString(),
            type: type,
            userId: this.user.getUserId(),
            anonymousId: overrides.anonymousId || this.user.getAnonymousId()
        };
    }
    createMessageId() {
        return `ajs-${(0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))()}`;
    }
    packageEvent(event) {
        const { apiHost: apiHost, apiHostProtocol: apiHostProtocol } = this.options;
        return {
            headers: {
                "Content-Type": "text/plain"
            },
            msg: event,
            url: `${apiHostProtocol}://${apiHost}/${event.type.charAt(0)}`
        };
    }
    async attachXIDs(items) {
        if (this.xidPromiseCallback) return (0, $gINol.attachXidToMultipleEvents)(items, this.xidPromiseCallback);
        return Promise.resolve(items);
    }
    constructor(options){
        var _this$options;
        // Using anonymous function so it can have the BatchFlushCallback type associated with it
        // And to allow it to not need bind when passing through to ResilieceQueue.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sendEvents", async (items, callback)=>{
            const httpRetryCount = this.resilienceQueue.getGlobalRetryCount();
            const metricsPayload = this.metrics.getMetricsPayload();
            const metadata = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, metricsPayload), {}, {
                httpRetryCount: httpRetryCount
            });
            for(let key in metadata)// @ts-ignore Some keys maybe a string, but these will never equal 0
            if (metadata[key] === 0) // @ts-ignore Save space in requests by removing metrics with no impact
            delete metadata[key];
            const eventsWithXID = await this.attachXIDs(items);
            // Calculating sentAt after the XID generation as this may take some time.
            const sentAt = new Date().toISOString();
            const unpackagedEvents = eventsWithXID.map((item)=>{
                item.msg.sentAt = sentAt;
                return item.msg;
            });
            const batchBody = {
                batch: unpackagedEvents,
                sentAt: sentAt,
                metadata: metadata
            };
            try {
                const response = await (0, $bEXZy.sendEvents)({
                    url: this.gasv3BatchUrl,
                    batch: batchBody,
                    timeout: this.options.requestTimeout
                });
                this.metrics.subtractFromMetrics(metricsPayload);
                callback(null, response);
            } catch (error) {
                callback(error, null);
            }
        });
        this.options = $837fe7c84ea3bd0a$var$_objectSpread($837fe7c84ea3bd0a$var$_objectSpread({}, options), {}, {
            requestTimeout: options.requestTimeout || (0, $3q4zO.DEFAULT_REQUEST_TIMEOUT),
            retryQueueOptions: options.retryQueueOptions || {},
            logger: options.logger || console,
            disableCookiePersistence: options.disableCookiePersistence || false
        });
        this.user = new (0, $ePQx8.default)((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.disableCookiePersistence);
        this.xidPromiseCallback = options.xidPromiseGetter();
        this.gasv3BatchUrl = `${options.apiHostProtocol}://${options.apiHost}/batch`;
        this.metrics = (0, $elE98.default)();
        this.resilienceQueue = (0, $iqSwv.default)(options.retryQueuePrefix, options.product, this.options.retryQueueOptions, this.options.logger);
        this.resilienceQueue.start(this.sendEvents);
    }
}

});
parcelRegister("iqSwv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6b4f2dfe20a7db1$export$2e2bcd8739ae039; });

var $jywt9 = parcelRequire("jywt9");

var $d6b4f2dfe20a7db1$export$2e2bcd8739ae039 = (retryQueuePrefix, product, options, logger)=>{
    return new (0, $jywt9.default)(retryQueuePrefix, product, options || {}, logger);
};

});
parcelRegister("jywt9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3ca61056fb55376$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $hL8CT = parcelRequire("hL8CT");
var $aoj6L = parcelRequire("aoj6L");

var $6DH9M = parcelRequire("6DH9M");
var $9zdCO = parcelRequire("9zdCO");
var $eiDyS = parcelRequire("eiDyS");

var $elE98 = parcelRequire("elE98");

var $oBsJE = parcelRequire("oBsJE");

var $6Znl6 = parcelRequire("6Znl6");
var $1td0A = parcelRequire("1td0A");

var $3aKbs = parcelRequire("3aKbs");
function $e3ca61056fb55376$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3ca61056fb55376$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3ca61056fb55376$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3ca61056fb55376$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e3ca61056fb55376$var$ONE_MINUTE = 60000;
const $e3ca61056fb55376$var$LONG_POLLING_OPTIONS = {
    backoffFactor: 0,
    backoffJitterPercentage: 0,
    flushWaitMs: $e3ca61056fb55376$var$ONE_MINUTE,
    minRetryDelay: $e3ca61056fb55376$var$ONE_MINUTE,
    maxRetryDelay: $e3ca61056fb55376$var$ONE_MINUTE
};
const $e3ca61056fb55376$export$d219df4fe04c04a7 = {
    backoffFactor: 2,
    backoffJitterPercentage: 0.2,
    batchFlushSize: 7,
    flushBeforeUnload: false,
    flushWaitMs: 500,
    maxAttempts: 10,
    // TODO figure out this number. For indexeddb we are sharing the queue with all tabs
    maxItems: 1000,
    maxRetryDelay: 30000,
    minRetryDelay: 1000
};
class $e3ca61056fb55376$export$2e2bcd8739ae039 {
    start(flushCallback) {
        this.batchFlushCallback = flushCallback;
        this.longPollingScheduler.schedule();
    }
    stop() {
        this.scheduler.stop();
        this.longPollingScheduler.stop();
    }
    async addItem(item) {
        // Since Jira and Confluence use `.toJSON` on objects that should be strings
        // And expect us to use `JSON.stringify` on these objects,
        // And indexeddb strips these functions from the objects when adding them to the DB,
        // We must run this silly stringify and parse before passing the event to the resilience meechanism.
        // Planning on removing this in v4
        const jsonStringifiedAndParsedItem = JSON.parse(JSON.stringify(item));
        const { numberOfEvictedItems: numberOfEvictedItems } = await this.resilience.addItem(jsonStringifiedAndParsedItem, {}, (0, $eiDyS.GuardPolicy).EVICT);
        this.scheduler.schedule();
        this.metricsCollector.addToEventCount();
        if (numberOfEvictedItems > 0) this.metricsCollector.addToItemsDiscardedByOverflowCounter(numberOfEvictedItems);
    }
    getGlobalRetryCount() {
        return this.scheduler.getFailureCount();
    }
    async scheduleCallback(done) {
        // Even though we stopped the scheduler, it can be restarted with a call to schedule.
        // This could be triggered by a new event or the longPollingScheduler
        if (this.networkStatus.getNetworkStatus() === (0, $3aKbs.NetworkStatusEnum).OFFLINE) {
            done((0, $1td0A.DoneState).NOOP);
            return;
        }
        try {
            const result = await this.resilience.processItems(this.flush.bind(this), this.options.batchFlushSize);
            done(result);
        } catch (error) {
            if (error.name === (0, $6DH9M.CallbackProcessingErrorName)) {
                done((0, $1td0A.DoneState).ERROR);
                return;
            }
        // TODO we can probably log here but throwing is useless as it will just be shallowed by the Scheduler
        // In theory something else should catch all other errors from indexeddb and this should never happen.
        } finally{
            await this.checkEventCountAndReschedule();
        }
    }
    async checkEventCountAndReschedule() {
        const eventWaitingCount = await this.resilience.getItemCount();
        if (eventWaitingCount > 0) this.scheduler.schedule({
            immediate: eventWaitingCount >= this.options.batchFlushSize
        });
    }
    async scheduleLongCallBack(done) {
        // Eventually we will want to send data about how many queues were purged
        const numberOfQueuesPurged = (0, $hL8CT.default)(this.queuePrefix);
        this.metricsCollector.addToPurgedQueuesMetrics(numberOfQueuesPurged);
        // Eventually we will want to send data about how attempted reclaims and actual reclaims were made
        const reclaimMetrics = await (0, $aoj6L.default)(this.queuePrefix, async (localStorageItems)=>{
            const itemsToAdd = localStorageItems.map((localStorageItem)=>({
                    item: localStorageItem.item,
                    retryAttempts: localStorageItem.attemptNumber,
                    id: localStorageItem.id
                }));
            const { items: addedEvents } = await this.resilience.bulkAddItem(itemsToAdd, (0, $eiDyS.GuardPolicy).IGNORE);
            if (addedEvents.length === itemsToAdd.length) return {
                status: "successful"
            };
            else return {
                status: "partial",
                acceptedItemIds: addedEvents.map((event)=>event.id)
            };
        });
        this.metricsCollector.addToReclaimMetrics(reclaimMetrics);
        // We dont want to flush events from here as there maybe issues with analytics-service
        // Scheduler has all the context and can schedule the next batch accordingly
        await this.checkEventCountAndReschedule();
        done((0, $1td0A.DoneState).SUCCESS);
        this.longPollingScheduler.schedule();
    }
    flush(wrappedItems, otherMetadata) {
        this.metricsCollector.setResilienceMechanism(this.resilience.storeType());
        const { batchFlushCallback: batchFlushCallback } = this;
        if (!batchFlushCallback) throw new Error("batchFlushCallback has not been set. Call PullBatchableQueue#start first.");
        return new Promise((resolve, reject)=>{
            if (wrappedItems.length <= 0) {
                resolve((0, $1td0A.DoneState).NOOP);
                return;
            }
            const items = wrappedItems.map((wrappedItem)=>{
                const item = wrappedItem.item;
                if (wrappedItem.retryAttempts > 0 && item.msg) {
                    if (!item.msg._metadata) item.msg._metadata = {};
                    item.msg._metadata.failedAttempts = wrappedItem.retryAttempts;
                }
                return item;
            });
            batchFlushCallback(items, (error)=>{
                if (error) {
                    if (otherMetadata.numberOfDeletedItems > 0) this.metricsCollector.addToItemsDiscardedByRetryCounter(otherMetadata.numberOfDeletedItems);
                    reject(error);
                } else resolve((0, $1td0A.DoneState).SUCCESS);
            });
        });
    }
    buildOptions(options) {
        return {
            backoffFactor: (options === null || options === void 0 ? void 0 : options.backoffFactor) || $e3ca61056fb55376$export$d219df4fe04c04a7.backoffFactor,
            backoffJitterPercentage: (options === null || options === void 0 ? void 0 : options.backoffJitterPercentage) !== undefined ? options.backoffJitterPercentage : $e3ca61056fb55376$export$d219df4fe04c04a7.backoffJitterPercentage,
            batchFlushSize: (options === null || options === void 0 ? void 0 : options.batchFlushSize) || $e3ca61056fb55376$export$d219df4fe04c04a7.batchFlushSize,
            flushBeforeUnload: (options === null || options === void 0 ? void 0 : options.flushBeforeUnload) || $e3ca61056fb55376$export$d219df4fe04c04a7.flushBeforeUnload,
            flushWaitMs: (options === null || options === void 0 ? void 0 : options.flushWaitMs) || $e3ca61056fb55376$export$d219df4fe04c04a7.flushWaitMs,
            maxItems: (options === null || options === void 0 ? void 0 : options.maxItems) || $e3ca61056fb55376$export$d219df4fe04c04a7.maxItems,
            maxAttempts: (options === null || options === void 0 ? void 0 : options.maxAttempts) || $e3ca61056fb55376$export$d219df4fe04c04a7.maxAttempts,
            maxRetryDelay: (options === null || options === void 0 ? void 0 : options.maxRetryDelay) || $e3ca61056fb55376$export$d219df4fe04c04a7.maxRetryDelay,
            minRetryDelay: (options === null || options === void 0 ? void 0 : options.minRetryDelay) || $e3ca61056fb55376$export$d219df4fe04c04a7.minRetryDelay
        };
    }
    constructor(queuePrefix, product, options, logger){
        this.queuePrefix = queuePrefix;
        // Avoiding using options in ResilienceDB at this stage as
        // the options are optimised for the PushBatchableQueue
        this.resilience = new (0, $9zdCO.default)(product, {
            logger: logger,
            maxAttempts: options === null || options === void 0 ? void 0 : options.maxAttempts,
            maxEventLimit: options === null || options === void 0 ? void 0 : options.maxItems
        });
        this.options = this.buildOptions(options);
        this.scheduler = new (0, $6Znl6.default)($e3ca61056fb55376$var$_objectSpread($e3ca61056fb55376$var$_objectSpread({}, this.options), {}, {
            waitInterval: options !== null && options !== void 0 && options.flushBeforeUnload ? 0 : this.options.flushWaitMs
        }), this.scheduleCallback.bind(this));
        this.longPollingScheduler = new (0, $6Znl6.default)($e3ca61056fb55376$var$_objectSpread($e3ca61056fb55376$var$_objectSpread({}, $e3ca61056fb55376$var$LONG_POLLING_OPTIONS), {}, {
            waitInterval: $e3ca61056fb55376$var$LONG_POLLING_OPTIONS.flushWaitMs
        }), this.scheduleLongCallBack.bind(this));
        this.metricsCollector = (0, $elE98.default)();
        this.networkStatus = new (0, $oBsJE.default)((status)=>{
            if (status === (0, $3aKbs.NetworkStatusEnum).OFFLINE) this.scheduler.stop();
            else this.checkEventCountAndReschedule();
        });
    }
}

});
parcelRegister("hL8CT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cedd84703b62a442$export$2e2bcd8739ae039; });

var $iTucC = parcelRequire("iTucC");

var $Z6SsK = parcelRequire("Z6SsK");
// For more details on this funciton, see https://hello.atlassian.net/wiki/spaces/MEASURE/pages/585086028/Investigation+Local+storage+full
// TL;DR
// If a queue looses its `ack` key in localstorage, it will never get claimed.
// There is a small chance that this can happen.
// This function is to run through queues and clean any that have been orphaned.
// Keys stolen from https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L55
const $cedd84703b62a442$var$validSuffixs = Object.values((0, $iTucC.LocalStorageKeySuffix));
var $cedd84703b62a442$export$2e2bcd8739ae039 = (prefix)=>{
    if (typeof prefix !== "string" || prefix.length === 0) // We do not want to start deleting everything in localstorage
    return 0;
    try {
        const queueStates = Object.keys(localStorage).filter((key)=>key && key.startsWith(`${prefix}.`) || false).map((key)=>key.split(".")).filter((splitKeys)=>splitKeys.length === 3 && $cedd84703b62a442$var$validSuffixs.includes(splitKeys[2])).reduce((accumulator, currentKeys)=>{
            const [, id, suffix] = currentKeys;
            if (accumulator[id] === undefined) accumulator[id] = {};
            accumulator[id][suffix] = true;
            return accumulator;
        }, {});
        const queuesToPurge = Object.keys(queueStates).filter((id)=>queueStates[id][(0, $iTucC.LocalStorageKeySuffix).ACK] !== true);
        queuesToPurge.forEach((id)=>{
            const { queue: queue, inProgress: inProgress, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = (0, $Z6SsK.createLocalStorageKeys)(prefix, id);
            localStorage.removeItem(inProgress);
            localStorage.removeItem(queue);
            localStorage.removeItem(reclaimStart);
            localStorage.removeItem(reclaimEnd);
        });
        return queuesToPurge.length;
    } catch (_error) {
    // Ignore errors from localStorage.
    }
    return 0;
};

});
parcelRegister("iTucC", function(module, exports) {

$parcel$export(module.exports, "LocalStorageKeySuffix", function () { return $dc14ca9ee2ad94de$export$ecfa71cbc9b28241; });
$parcel$export(module.exports, "Timers", function () { return $dc14ca9ee2ad94de$export$8bb2c1fb2b1765a9; });
let $dc14ca9ee2ad94de$export$ecfa71cbc9b28241 = /*#__PURE__*/ function(LocalStorageKeySuffix) {
    LocalStorageKeySuffix["IN_PROGRESS"] = "inProgress";
    LocalStorageKeySuffix["QUEUE"] = "queue";
    LocalStorageKeySuffix["RECLAIM_START"] = "reclaimStart";
    LocalStorageKeySuffix["RECLAIM_END"] = "reclaimEnd";
    LocalStorageKeySuffix["ACK"] = "ack";
    return LocalStorageKeySuffix;
}({});
let $dc14ca9ee2ad94de$export$8bb2c1fb2b1765a9 = /*#__PURE__*/ function(Timers) {
    Timers[Timers["RECLAIM_TIMEOUT"] = 10000] = "RECLAIM_TIMEOUT";
    Timers[Timers["RECLAIM_WAIT"] = 500] = "RECLAIM_WAIT";
    Timers[Timers["RECLAIM_WAIT_THRESHOLD"] = 2000] = "RECLAIM_WAIT_THRESHOLD";
    return Timers;
}({});

});

parcelRegister("Z6SsK", function(module, exports) {

$parcel$export(module.exports, "createLocalStorageKeys", function () { return $0b7b08557aba156e$export$8433d54f767cbec5; });

var $iTucC = parcelRequire("iTucC");
const $0b7b08557aba156e$export$8433d54f767cbec5 = (queuePrefix, queueId)=>({
        [(0, $iTucC.LocalStorageKeySuffix).ACK]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).ACK}`,
        [(0, $iTucC.LocalStorageKeySuffix).QUEUE]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).QUEUE}`,
        [(0, $iTucC.LocalStorageKeySuffix).IN_PROGRESS]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).IN_PROGRESS}`,
        [(0, $iTucC.LocalStorageKeySuffix).RECLAIM_START]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).RECLAIM_START}`,
        [(0, $iTucC.LocalStorageKeySuffix).RECLAIM_END]: `${queuePrefix}.${queueId}.${(0, $iTucC.LocalStorageKeySuffix).RECLAIM_END}`
    });

});


parcelRegister("aoj6L", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $790af7bf2c760041$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $iTucC = parcelRequire("iTucC");

var $Z6SsK = parcelRequire("Z6SsK");
function $790af7bf2c760041$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $790af7bf2c760041$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $790af7bf2c760041$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $790af7bf2c760041$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Code we need to mimic:
// https://github.com/segmentio/localstorage-retry/blob/master/lib/index.js#L262-L357
// Note we do not want to run this library due to the performance, duplication and memory leak issues.
const $790af7bf2c760041$var$promisedSetTimeout = (msToWait)=>new Promise((resolve)=>{
        setTimeout(resolve, msToWait);
    });
const $790af7bf2c760041$var$findOtherQueues = (queuePrefix)=>{
    try {
        return Object.keys(localStorage).filter((key)=>key.startsWith(queuePrefix)).map((key)=>key.split(".")).filter((split)=>{
            if (split.length === 3 && split[0] === queuePrefix && split[2] === (0, $iTucC.LocalStorageKeySuffix).ACK) try {
                const ackTimestamp = localStorage.getItem(split.join("."));
                if (ackTimestamp) {
                    const ackTimestampNumber = parseInt(ackTimestamp);
                    return (0, $iTucC.Timers).RECLAIM_TIMEOUT + ackTimestampNumber < Date.now();
                }
            } catch (error) {
            // ignore and drop value
            }
            return false;
        }).map((split)=>split[1]);
    } catch (_error) {
    // Ignore errors from accessing localStorage.
    }
    return [];
};
const $790af7bf2c760041$var$tryReclaim = async (options, callback)=>{
    const { ack: ack, reclaimStart: reclaimStart, reclaimEnd: reclaimEnd } = options.storageKeys;
    const start = Date.now();
    localStorage.setItem(reclaimStart, options.reclaimProcessId);
    localStorage.setItem(ack, start.toString());
    await $790af7bf2c760041$var$promisedSetTimeout((0, $iTucC.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $iTucC.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimStart.");
    localStorage.setItem(reclaimEnd, options.reclaimProcessId);
    await $790af7bf2c760041$var$promisedSetTimeout((0, $iTucC.Timers).RECLAIM_WAIT);
    if (// Prevent duplicates when extracting events from localstorage due to CPU / Memory pressure on client
    Date.now() > start + (0, $iTucC.Timers).RECLAIM_WAIT_THRESHOLD || // Either the parent has caught up and removed our claim, or someone else started a claim instead
    localStorage.getItem(reclaimStart) !== options.reclaimProcessId || localStorage.getItem(reclaimEnd) !== options.reclaimProcessId) throw new Error("Took to long to callback, reclaim abandonded. After reclaimEnd.");
    return $790af7bf2c760041$var$reclaim(options, callback);
};
const $790af7bf2c760041$var$reclaim = async (options, callback)=>{
    const { queue: queue, inProgress: inProgress } = options.storageKeys;
    // Queue is an array of events while inProgress is an object with a uuid for key
    // Either of these queues may legitimately be missing.
    const eventsInQueue = JSON.parse(localStorage.getItem(queue) || "[]");
    const eventsInProgress = JSON.parse(localStorage.getItem(inProgress) || "{}");
    const arrayOfEventsInProgress = Object.entries(eventsInProgress).map(([key, item])=>{
        const itemWithId = $790af7bf2c760041$var$_objectSpread($790af7bf2c760041$var$_objectSpread({}, item), {}, {
            // LocalStorage-retry would add the attemptCounter after failure, rather than
            // as it was being processed
            attemptNumber: item.attemptNumber + 1,
            id: key
        });
        return itemWithId;
    });
    const eventsToProcess = [
        ...eventsInQueue,
        ...arrayOfEventsInProgress
    ];
    if (eventsToProcess.length > 0) {
        const result = await callback(eventsToProcess);
        if (result.status === "successful") $790af7bf2c760041$var$clearLocalStorageKeys(options.storageKeys);
        else if (result.status === "partial") {
            // Dont delete all events if we are only able to take some of them.
            const leftover = eventsToProcess.filter((event)=>!result.acceptedItemIds.includes(event.id));
            // This way around, we can almost ensure that we wont hit memory quota exceeded errors.
            // However, there is a very small chance that we may lose events if the process exits between these two commands.
            localStorage.removeItem(inProgress);
            localStorage.setItem(queue, JSON.stringify(leftover));
            return {
                fullReclaim: false
            };
        }
    } else $790af7bf2c760041$var$clearLocalStorageKeys(options.storageKeys);
    return {
        fullReclaim: true
    };
};
// Exterminate
const $790af7bf2c760041$var$clearLocalStorageKeys = (keys)=>{
    // Always good to do queue and inprogress first to reduce duplications
    // and to free up more space in localstorage
    localStorage.removeItem(keys.queue);
    localStorage.removeItem(keys.inProgress);
    localStorage.removeItem(keys.reclaimEnd);
    localStorage.removeItem(keys.reclaimStart);
    // This has to be last or we risk leaving things in localStorage that have to be purged
    localStorage.removeItem(keys.ack);
};
var $790af7bf2c760041$export$2e2bcd8739ae039 = async (queuePrefix, callback)=>{
    if (typeof queuePrefix !== "string" || queuePrefix.length === 0) // We do not want to start deleting everything in localstorage
    return {
        fullReclaims: 0,
        partialReclaims: 0,
        failedReclaims: 0
    };
    const reclaimProcessId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
    const queuesToReclaim = $790af7bf2c760041$var$findOtherQueues(queuePrefix);
    const claims = queuesToReclaim.map((id)=>$790af7bf2c760041$var$tryReclaim({
            queuePrefix: queuePrefix,
            reclaimProcessId: reclaimProcessId,
            storageKeys: (0, $Z6SsK.createLocalStorageKeys)(queuePrefix, id)
        }, callback));
    const settledClaims = await Promise.allSettled(claims);
    const failedReclaims = settledClaims.filter((claim)=>claim.status === "rejected");
    const successfulClaims = settledClaims.filter((settledValue)=>settledValue.status === "fulfilled").map((result)=>result.value);
    const fullReclaims = successfulClaims.filter((claim)=>claim.fullReclaim);
    const partialReclaims = successfulClaims.filter((claim)=>!claim.fullReclaim);
    return {
        failedReclaims: failedReclaims.length,
        partialReclaims: partialReclaims.length,
        fullReclaims: fullReclaims.length
    };
};

});

parcelRegister("6DH9M", function(module, exports) {

$parcel$export(module.exports, "CallbackProcessingErrorName", function () { return $4d57dc9ec8a8480f$export$a409c8de90e11e14; });
$parcel$export(module.exports, "default", function () { return $4d57dc9ec8a8480f$export$2e2bcd8739ae039; });
const $4d57dc9ec8a8480f$export$a409c8de90e11e14 = "CallbackProcessingError";
class $4d57dc9ec8a8480f$export$2e2bcd8739ae039 extends Error {
    constructor(error){
        const messageFromError = error && typeof error === "object" && "toString" in error && typeof error.toString === "function" && error.toString();
        const messageFromString = typeof error === "string" && error;
        const message = messageFromError || messageFromString || "Argument passed to CallbackProcessingError was not an Error or string.";
        super(`Error thrown while processing events in callback: ${message}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $4d57dc9ec8a8480f$export$2e2bcd8739ae039.prototype);
        this.name = $4d57dc9ec8a8480f$export$a409c8de90e11e14;
    }
}

});

parcelRegister("9zdCO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f71f39066bdb532$export$2e2bcd8739ae039; });

var $5hDYj = parcelRequire("5hDYj");

var $eiDyS = parcelRequire("eiDyS");

var $6DH9M = parcelRequire("6DH9M");
var $6f71f39066bdb532$export$2e2bcd8739ae039 = (0, $5hDYj.default);

});
parcelRegister("5hDYj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d8d8bdd5311ecc5$export$2e2bcd8739ae039; });

var $eiDyS = parcelRequire("eiDyS");

var $1RmJs = parcelRequire("1RmJs");
var $63xVP = parcelRequire("63xVP");

var $19pAq = parcelRequire("19pAq");

var $5gj4Y = parcelRequire("5gj4Y");

var $2vBjM = parcelRequire("2vBjM");
class $3d8d8bdd5311ecc5$export$2e2bcd8739ae039 {
    getResilienceMechanism(namespace, options) {
        if (!options.useMemory) try {
            return new (0, $19pAq.default)(namespace, options);
        } catch (error) {
            if (!(error instanceof (0, $1RmJs.default))) {
                var _options$logger;
                (_options$logger = options.logger) === null || _options$logger === void 0 || _options$logger.warn("Attempted to create IndexedDbResilience but failed. Using memory instead.");
            }
        }
        return new (0, $5gj4Y.default)(this.namespace, options);
    }
    addItem(item, options, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.addItem(item, options, policy));
    }
    bulkAddItem(itemOptions, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        return this.runOrFailOver(()=>this.resilience.bulkAddItem(itemOptions, policy));
    }
    getItems(count) {
        return this.runOrFailOver(()=>this.resilience.getItems(count));
    }
    deleteItems(itemIds) {
        return this.runOrFailOver(()=>this.resilience.deleteItems(itemIds));
    }
    getItemCount() {
        return this.runOrFailOver(()=>this.resilience.getItemCount());
    }
    processItems(processFn, count) {
        return this.runOrFailOver(()=>this.resilience.processItems(processFn, count));
    }
    storeType() {
        return this.resilience.storeType();
    }
    async runOrFailOver(runnable) {
        try {
            return await runnable();
        } catch (error) {
            if ((0, $63xVP.shouldIgnoreResilienceDbError)(error)) throw error;
            else if (this.resilience.storeType() === (0, $eiDyS.StoreType).INDEXEDDB) await this.failOver();
            return runnable();
        }
    }
    async failOver() {
        // Attempt to get any events we can and put them into memory
        const oldResilience = this.resilience;
        const newResilience = new (0, $5gj4Y.default)(this.namespace, this.options);
        this.resilience = newResilience;
        try {
            const { items: items } = await oldResilience.getItems(this.options.maxEventLimit);
            if (items.length > 0) {
                const bulkAddItemsResponse = await newResilience.bulkAddItemWrapperType(items, (0, $eiDyS.GuardPolicy).IGNORE);
                const addedItemIds = bulkAddItemsResponse.items.map((item)=>item.id);
                await oldResilience.deleteItems(addedItemIds);
            }
        } catch (error) {
            this.options.logger.warn("Unexpected error from ResilienceDb, switching to MemoryDb");
        // Dont need to catch. We are just getting events if we can
        }
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.options = (0, $2vBjM.createOptionsWithDefaults)(options);
        if (!namespace || namespace.length === 0 || typeof namespace !== "string") throw new Error("Invalid namespace provided");
        this.resilience = this.getResilienceMechanism(namespace, options);
    }
}

});
parcelRegister("eiDyS", function(module, exports) {

$parcel$export(module.exports, "NAMESPACE_AND_TIME_ADDED_INDEX", function () { return $a6916f3457e73dad$export$d21fbb25eb37b5bf; });
$parcel$export(module.exports, "RESILIENCE_DB_NAME", function () { return $a6916f3457e73dad$export$8cad224051643259; });
$parcel$export(module.exports, "RESILIENCE_STORE_NAME", function () { return $a6916f3457e73dad$export$3d8420be07b276ab; });
$parcel$export(module.exports, "TIME_TO_PROCESS_AFTER_INDEX", function () { return $a6916f3457e73dad$export$a512a65455fce2a6; });
$parcel$export(module.exports, "TIME_ADDED_INDEX", function () { return $a6916f3457e73dad$export$89d9c1ff8ac91862; });
$parcel$export(module.exports, "RETRY_INDEX", function () { return $a6916f3457e73dad$export$a37d385bcd713809; });
$parcel$export(module.exports, "INDEXEDDB_TIMEOUT", function () { return $a6916f3457e73dad$export$6d8635fed0e4b14d; });
$parcel$export(module.exports, "StoreType", function () { return $a6916f3457e73dad$export$39337ab5872e9457; });
$parcel$export(module.exports, "GuardPolicy", function () { return $a6916f3457e73dad$export$7710d69e6f450f20; });
const $a6916f3457e73dad$export$d21fbb25eb37b5bf = "namespace-timeAdded";
const $a6916f3457e73dad$export$8cad224051643259 = "analytics-web-client";
const $a6916f3457e73dad$export$3d8420be07b276ab = "analytics-resilience";
const $a6916f3457e73dad$export$a512a65455fce2a6 = "timeToBeProcessedAfter";
const $a6916f3457e73dad$export$89d9c1ff8ac91862 = "timeAdded";
const $a6916f3457e73dad$export$a37d385bcd713809 = "retryAttempts";
const $a6916f3457e73dad$export$6d8635fed0e4b14d = 15000;
let $a6916f3457e73dad$export$39337ab5872e9457 = /*#__PURE__*/ function(StoreType) {
    StoreType["INDEXEDDB"] = "indexeddb";
    StoreType["MEMORY"] = "memory";
    return StoreType;
}({});
let $a6916f3457e73dad$export$7710d69e6f450f20 = /*#__PURE__*/ function(GuardPolicy) {
    GuardPolicy["IGNORE"] = "ignore";
    GuardPolicy["ABANDON"] = "abandon";
    GuardPolicy["EVICT"] = "evict";
    return GuardPolicy;
}({});

});

parcelRegister("1RmJs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15ac5fd10b566fa7$export$2e2bcd8739ae039; });
const $15ac5fd10b566fa7$export$fc14cf6dcea0f8ed = "NoIndexedDbError";
class $15ac5fd10b566fa7$export$2e2bcd8739ae039 extends Error {
    constructor(){
        super("window.indexeddb is undefined.");
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $15ac5fd10b566fa7$export$2e2bcd8739ae039.prototype);
        this.name = $15ac5fd10b566fa7$export$fc14cf6dcea0f8ed;
    }
}

});

parcelRegister("63xVP", function(module, exports) {

$parcel$export(module.exports, "shouldIgnoreResilienceDbError", function () { return $468d580908194a36$export$74101021e0969375; });

var $3DoBM = parcelRequire("3DoBM");

var $6DH9M = parcelRequire("6DH9M");

var $7Hmy4 = parcelRequire("7Hmy4");
const $468d580908194a36$export$74101021e0969375 = (error)=>{
    if (error && typeof error === "object" && "name" in error) {
        const errorWithName = error;
        return typeof errorWithName.name === "string" && (errorWithName.name === (0, $3DoBM.AbandonWriteErrorName) || errorWithName.name === (0, $6DH9M.CallbackProcessingErrorName) || errorWithName.name === (0, $7Hmy4.InvalidPolicyErrorName));
    }
    return false;
};

});
parcelRegister("3DoBM", function(module, exports) {

$parcel$export(module.exports, "AbandonWriteErrorName", function () { return $2a581a58cc55b1e9$export$ba95206613c96b28; });
$parcel$export(module.exports, "default", function () { return $2a581a58cc55b1e9$export$2e2bcd8739ae039; });
const $2a581a58cc55b1e9$export$ba95206613c96b28 = "AbandonWriteError";
class $2a581a58cc55b1e9$export$2e2bcd8739ae039 extends Error {
    constructor(source){
        super(`Event Limit reached. Abandoning write to: ${source}`);
        // Must reset the prototypes after calling super of builtin classes
        // https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, $2a581a58cc55b1e9$export$2e2bcd8739ae039.prototype);
        this.name = $2a581a58cc55b1e9$export$ba95206613c96b28;
    }
}

});

parcelRegister("7Hmy4", function(module, exports) {

$parcel$export(module.exports, "InvalidPolicyErrorName", function () { return $59ae0a3b0b4a1f8f$export$7e7aee9a953465ec; });
$parcel$export(module.exports, "default", function () { return $59ae0a3b0b4a1f8f$export$2e2bcd8739ae039; });
const $59ae0a3b0b4a1f8f$export$7e7aee9a953465ec = "InvalidPolicyError";
class $59ae0a3b0b4a1f8f$export$2e2bcd8739ae039 extends Error {
    constructor(policy, method){
        super(`Method '${method}' cannot be called with policy '${policy}'.`);
        this.name = $59ae0a3b0b4a1f8f$export$7e7aee9a953465ec;
    }
}

});


parcelRegister("19pAq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d6a7aa2df9331d9$export$2e2bcd8739ae039; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $6bkHe = parcelRequire("6bkHe");

var $eiDyS = parcelRequire("eiDyS");

var $g4hTj = parcelRequire("g4hTj");

var $6DH9M = parcelRequire("6DH9M");
var $7Hmy4 = parcelRequire("7Hmy4");
var $1RmJs = parcelRequire("1RmJs");
var $63xVP = parcelRequire("63xVP");

var $9woOY = parcelRequire("9woOY");

var $2vBjM = parcelRequire("2vBjM");
const $0d6a7aa2df9331d9$var$_excluded = [
    "item"
], $0d6a7aa2df9331d9$var$_excluded2 = [
    "items"
];
function $0d6a7aa2df9331d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d6a7aa2df9331d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d6a7aa2df9331d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d6a7aa2df9331d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $0d6a7aa2df9331d9$export$2e2bcd8739ae039 {
    storeType() {
        return (0, $eiDyS.StoreType).INDEXEDDB;
    }
    constructor(_namespace, _options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startDB", async ()=>{
            return new Promise(async (resolve, reject)=>{
                if (typeof window !== "undefined") {
                    const dbTimeout = window.setTimeout(()=>{
                        this.logger.warn("IndexedDB timed out.");
                        reject(new (0, $1RmJs.default)());
                    }, (0, $eiDyS.INDEXEDDB_TIMEOUT));
                    /*
           * The database version number can never change.
           * An upgrade transaction is limited to only one connection to the database.
           * Once this is done, we cannot open any connections with older versions of the schema.
           * https://www.w3.org/TR/IndexedDB/#upgrade-transaction-construct
           *
           * Due to the nature of how AWC is used (multiple tabs that are very long lived),
           * we will not be able to run version upgrades via indexeddb.
           *
           * This does not mean we cant change what is stored in the tables,
           * this limitation just prevents us from:
           *   - Creating new ObjectStores in this database connection, and
           *   - Creating new indexes on our ObjectStores
           *
           * Any upgrades we wish to run in the future will have to create a new database,
           * and migrate all the data from older databases.
           *
           * This also means any migrations we make will have to be supported until we have evidence
           * that no events are coming from old versions of the database.
           * This may take a long time.
           */ const request = window.indexedDB.open((0, $eiDyS.RESILIENCE_DB_NAME), 1);
                    request.onupgradeneeded = (event)=>{
                        if (event.oldVersion !== 0) throw new Error("We cannot upgrade the database. Do not do this.");
                        const db = request.result;
                        const store = db.createObjectStore((0, $eiDyS.RESILIENCE_STORE_NAME), {
                            keyPath: "id"
                        });
                        store.createIndex((0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX), (0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $eiDyS.RETRY_INDEX), (0, $eiDyS.RETRY_INDEX), {
                            unique: false
                        });
                        store.createIndex((0, $eiDyS.TIME_ADDED_INDEX), (0, $eiDyS.TIME_ADDED_INDEX), {
                            unique: false
                        });
                        // Compound key index of product - timeAdded.
                        store.createIndex((0, $eiDyS.NAMESPACE_AND_TIME_ADDED_INDEX), [
                            "namespace",
                            "timeAdded"
                        ], {
                            unique: false
                        });
                    };
                    try {
                        await (0, $2vBjM.requestToPromise)(request);
                        return resolve(request.result);
                    } catch (error) {
                        this.logger.warn("IndexedDB failed to initialise.", error);
                        reject(new (0, $1RmJs.default)());
                    } finally{
                        window.clearTimeout(dbTimeout);
                    }
                } else {
                    this.logger.warn("IndexedDB failed to initialise. No 'window' object.");
                    reject(new (0, $1RmJs.default)());
                }
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "addItem", async (item, options = {}, policy = (0, $eiDyS.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const value = (0, $2vBjM.convertToItemWrapper)(item, namespace, options);
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            if (policy === (0, $eiDyS.GuardPolicy).IGNORE) throw new (0, $7Hmy4.default)(policy, "IndexedDbConnector#addItem");
            try {
                if (!value.namespace || value.namespace.length === 0 || typeof value.namespace !== "string") throw new Error("Namespace not specified");
                // Making space for 1 event, if required.
                const bulkAddResult = await this.globalEventLimitGuard.insertItems(objectStore, [
                    value
                ], policy);
                if (bulkAddResult.items.length === 1) return {
                    item: bulkAddResult.items[0],
                    numberOfEvictedItems: bulkAddResult.numberOfEvictedItems
                };
                // Should never happen as the Policy and EventCountGuard should cause another pathway
                throw new Error(`Incorrect number of items added. Expected: 1, got: ${bulkAddResult.items.length}`);
            } catch (error) {
                if ((0, $63xVP.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "bulkAddItem", async (itemOptions, policy = (0, $eiDyS.GuardPolicy).ABANDON)=>{
            const { logger: logger, namespace: namespace } = this;
            const items = itemOptions.map((_ref)=>{
                let { item: item } = _ref, options = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $0d6a7aa2df9331d9$var$_excluded);
                return (0, $2vBjM.convertToItemWrapper)(item, namespace, options);
            });
            const { objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                return await this.globalEventLimitGuard.insertItems(objectStore, items, policy);
            } catch (error) {
                if ((0, $63xVP.shouldIgnoreResilienceDbError)(error)) throw error;
                logger.log("Failed to add item to table", error);
                throw new Error("Request to add item to table failed");
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItems", async (count = (0, $g4hTj.GET_ITEM_COUNT))=>{
            const fixedCount = count > 0 ? count : (0, $g4hTj.GET_ITEM_COUNT);
            const { logger: logger } = this;
            const maxAttempts = this.options.maxAttempts;
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            const timeIndex = objectStore.index((0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.openCursor(upperBoundOpenKeyRange);
            const getResult = await new Promise(async (resolve, reject)=>{
                const items = [];
                let numberOfDeletedItems = 0;
                request.onerror = (error)=>{
                    logger.error("Failed to open cursor:", error);
                    reject("Failed to open cursor");
                };
                // Requests for Cursors call onsuccess multiple times and cannot be converted to promises
                request.onsuccess = (event)=>{
                    const cursor = event.target.result;
                    if (cursor) {
                        // Prevent mutation of the value we are returning
                        const value = $0d6a7aa2df9331d9$var$_objectSpread({}, cursor.value);
                        items.push(value);
                        // Mutations seem to be required for testing indexeddb library
                        const updatedValue = cursor.value;
                        updatedValue.retryAttempts += 1;
                        updatedValue.timeToBeProcessedAfter = Date.now() + (0, $g4hTj.VISIBILITY_TIMEOUT);
                        if (updatedValue.retryAttempts >= maxAttempts) {
                            ++numberOfDeletedItems;
                            const request = cursor.delete();
                            (0, $2vBjM.monitorErrorsOnRequest)(request, logger);
                        } else {
                            const request = cursor.update(updatedValue);
                            (0, $2vBjM.monitorErrorsOnRequest)(request, logger);
                        }
                        if (items.length < fixedCount) cursor.continue();
                        else resolve({
                            items: items,
                            numberOfDeletedItems: numberOfDeletedItems
                        });
                    } else resolve({
                        items: items,
                        numberOfDeletedItems: numberOfDeletedItems
                    });
                };
            });
            await (0, $2vBjM.commitTransaction)(transaction, this.logger);
            return getResult;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "deleteItems", async (itemIds)=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readwrite");
            try {
                const deletePromises = itemIds.map((id)=>this.deleteItem(objectStore, id));
                await (0, $2vBjM.commitTransaction)(transaction, this.logger);
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItemCount", async ()=>{
            const { transaction: transaction, objectStore: objectStore } = await this.getObjectStoreAndTransaction("readonly");
            const timeIndex = objectStore.index((0, $eiDyS.TIME_TO_PROCESS_AFTER_INDEX));
            const upperBoundOpenKeyRange = IDBKeyRange.upperBound(Date.now());
            const request = timeIndex.count(upperBoundOpenKeyRange);
            const event = await (0, $2vBjM.requestToPromise)(request);
            await (0, $2vBjM.commitTransaction)(transaction, this.logger);
            return event.target.result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "processItems", async (processFn, count = (0, $g4hTj.GET_ITEM_COUNT))=>{
            const _await$this$getItems = await this.getItems(count), { items: items } = _await$this$getItems, partialResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_await$this$getItems, $0d6a7aa2df9331d9$var$_excluded2);
            try {
                const result = await processFn(items, partialResult);
                const itemIds = items.map((item)=>item.id);
                // We should not await this delete as a rejected promise would get caught by the catch statement
                await this.deleteItems(itemIds);
                return result;
            } catch (error) {
                // Eventually we will need a intermediate class to catch all errors but we should ignore this error
                // This allows libraries beneath to distinguish between a success or failure in processing to update schedulers or anything else
                // To provide back off or any other mechanism to allow what ever is cauing the errors to recover
                throw new (0, $6DH9M.default)(error);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "deleteItem", async (objectStore, id)=>{
            const { logger: logger } = this;
            try {
                await (0, $2vBjM.requestToPromise)(objectStore.delete(id));
            } catch (error) {
                logger.error("Failed to delete item:", id, error);
                throw error;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getObjectStoreAndTransaction", async (mode)=>{
            const transaction = (await this.db).transaction((0, $eiDyS.RESILIENCE_STORE_NAME), mode);
            const objectStore = transaction.objectStore((0, $eiDyS.RESILIENCE_STORE_NAME));
            return {
                transaction: transaction,
                objectStore: objectStore
            };
        });
        this.options = (0, $2vBjM.createOptionsWithDefaults)(_options);
        this.namespace = _namespace;
        this.logger = this.options.logger;
        if (!window.indexedDB) throw new (0, $1RmJs.default)();
        this.db = this.startDB();
        // We just swallow any errors as we know that these are intermittent errors
        // when switching from indexeddb -> localStorage
        this.db.catch(()=>{});
        /**
     *
     * This class will enforce the number of analytics events we can store in our IndexedDB object store
     * if asked before adding items to the object store.
     */ this.globalEventLimitGuard = new (0, $9woOY.default)(this.options.maxEventLimit, this.namespace, this.logger, this.deleteItem);
    }
}

});
parcelRegister("g4hTj", function(module, exports) {

$parcel$export(module.exports, "GET_ITEM_COUNT", function () { return $bb2ae5dd09334ff6$export$b6df3d334cec060f; });
$parcel$export(module.exports, "VISIBILITY_TIMEOUT", function () { return $bb2ae5dd09334ff6$export$14ef152a03a4b6ee; });
$parcel$export(module.exports, "MAX_ATTEMPTS", function () { return $bb2ae5dd09334ff6$export$da9ab7b2fd5998e8; });
$parcel$export(module.exports, "EVENT_COUNT_LIMIT", function () { return $bb2ae5dd09334ff6$export$1188664dfff364c8; });
const $bb2ae5dd09334ff6$export$b6df3d334cec060f = 7;
const $bb2ae5dd09334ff6$export$14ef152a03a4b6ee = 60000;
const $bb2ae5dd09334ff6$export$da9ab7b2fd5998e8 = 10;
const $bb2ae5dd09334ff6$export$1188664dfff364c8 = 5000;

});

parcelRegister("9woOY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6eea5b29e858d614$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $eiDyS = parcelRequire("eiDyS");

var $3DoBM = parcelRequire("3DoBM");

var $2vBjM = parcelRequire("2vBjM");
class $6eea5b29e858d614$export$2e2bcd8739ae039 {
    /**
   * This function checks the number of events currently in AWC IndexedDB object store and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * The indexed is treated as effectively: partitioned by product and sorted by timeAdded.
   *
   * This function can be re-used when the bulk add functionality is added in IndexedDbConnector.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ async insertItems(objectStore, items, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        const itemsToAdd = [
            ...items
        ];
        let numberOfEvictedItems = 0;
        switch(policy){
            case (0, $eiDyS.GuardPolicy).ABANDON:
                await this.throwIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $eiDyS.GuardPolicy).EVICT:
                numberOfEvictedItems = await this.evictIfNotEnoughSpace(objectStore, items.length);
                break;
            case (0, $eiDyS.GuardPolicy).IGNORE:
                // Removed items from `itemsToAdd` if there is insufficient space
                await this.calculateHowManyEventsWeCanAdd(objectStore, itemsToAdd);
                break;
        }
        const promises = itemsToAdd.map((item)=>(0, $2vBjM.requestToPromise)(objectStore.add(item)));
        await Promise.all(promises);
        await (0, $2vBjM.commitTransaction)(objectStore.transaction, this.logger);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async throwIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) throw new (0, $3DoBM.default)(`Not enough space in IndexedDb. Needed ${requiredSpace} but only had ${freeSpace}`);
    }
    async evictIfNotEnoughSpace(objectStore, requiredSpace) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < requiredSpace) {
            const extraSpace = requiredSpace - freeSpace;
            await this.deleteOldestNEvents(objectStore, extraSpace);
            return extraSpace;
        }
        return 0;
    }
    async calculateHowManyEventsWeCanAdd(objectStore, items) {
        const freeSpace = await this.calculateFreeSpace(objectStore);
        if (freeSpace < items.length) {
            const numberOfItemsToRemove = items.length - freeSpace;
            const start = items.length - numberOfItemsToRemove;
            items.splice(start, numberOfItemsToRemove);
        }
    }
    async calculateFreeSpace(objectStore) {
        const numberOfEventsInDb = await this.getCountofEventsInObjectStore(objectStore);
        return this.eventLimit - numberOfEventsInDb;
    }
    /**
   * This query returns the count of items held in AWC IndexedDB object store per product.
   */ async getCountofEventsInObjectStore(objectStore) {
        const productTimeAddedIndex = objectStore.index((0, $eiDyS.NAMESPACE_AND_TIME_ADDED_INDEX));
        const keyRangeValues = IDBKeyRange.bound([
            this.namespace,
            0
        ], [
            this.namespace,
            Date.now()
        ]);
        const request = productTimeAddedIndex.count(keyRangeValues);
        const event = await (0, $2vBjM.requestToPromise)(request);
        return event.target.result;
    }
    constructor(eventLimit, namespace, logger, deleteItemHandler){
        /**
     * This query fetches the oldest events currently stored in AWC IndexedDb object store
     * and deletes them sequentially
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "deleteOldestNEvents", async (objectStore, count)=>{
            var _target;
            const productTimeAddedIndex = objectStore.index((0, $eiDyS.NAMESPACE_AND_TIME_ADDED_INDEX));
            const keyRangeValues = IDBKeyRange.bound([
                this.namespace,
                0
            ], [
                this.namespace,
                Date.now()
            ]);
            const getAllRequest = productTimeAddedIndex.getAllKeys(keyRangeValues, count);
            const event = await (0, $2vBjM.requestToPromise)(getAllRequest);
            const result = event === null || event === void 0 || (_target = event.target) === null || _target === void 0 ? void 0 : _target.result;
            // Adding extra safety
            if (result && Array.isArray(result) && result.length > 0) try {
                const deletePromises = result.map((item)=>this.deleteItemHandler(objectStore, item));
                await Promise.all(deletePromises);
            } catch (error) {
                this.logger.warn("Failed to delete items from indexeddb.", error);
                throw error;
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.namespace = namespace;
        this.logger = logger;
        this.deleteItemHandler = deleteItemHandler;
    }
}

});
parcelRegister("2vBjM", function(module, exports) {

$parcel$export(module.exports, "convertToItemWrapper", function () { return $1d3b6c97cbeab58a$export$aec476f33d77be11; });
$parcel$export(module.exports, "createOptionsWithDefaults", function () { return $1d3b6c97cbeab58a$export$ddc6718318090f71; });
$parcel$export(module.exports, "requestToPromise", function () { return $1d3b6c97cbeab58a$export$85ceed0783e42041; });
$parcel$export(module.exports, "commitTransaction", function () { return $1d3b6c97cbeab58a$export$feab8418f018df89; });
$parcel$export(module.exports, "monitorErrorsOnRequest", function () { return $1d3b6c97cbeab58a$export$342d941b6f724995; });

var $gaCcd = parcelRequire("gaCcd");

var $g4hTj = parcelRequire("g4hTj");
const $1d3b6c97cbeab58a$export$aec476f33d77be11 = (item, namespace, { id: id, retryAttempts: retryAttempts, timeToProcessOffset: timeToProcessOffset })=>({
        item: item,
        id: id || (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))(),
        retryAttempts: retryAttempts || 0,
        timeToBeProcessedAfter: Date.now() + (timeToProcessOffset || 0),
        namespace: namespace,
        timeAdded: Date.now()
    });
const $1d3b6c97cbeab58a$export$ddc6718318090f71 = (options)=>({
        logger: options.logger || console,
        useMemory: options.useMemory || false,
        maxAttempts: options.maxAttempts || (0, $g4hTj.MAX_ATTEMPTS),
        // This is so that we can customise `maxEventLimit`, primarily for testing.
        maxEventLimit: options.maxEventLimit || (0, $g4hTj.EVENT_COUNT_LIMIT)
    });
const $1d3b6c97cbeab58a$export$85ceed0783e42041 = (request)=>{
    return new Promise((resolve, reject)=>{
        request.onsuccess = (event)=>{
            resolve(event);
        };
        request.onerror = (event)=>{
            reject(event);
        };
    });
};
const $1d3b6c97cbeab58a$export$2a5213bce1720b42 = (transaction)=>{
    return new Promise((resolve, reject)=>{
        // We will have to see how much cost there is to waiting for the transaction to complete in the real world.
        // In theory in some cases we could return as soon as the request is complete and
        // just monitor errors on transactions with the logger.
        // This maybe more of an issue in Safari and other older browsers where commit isnt available
        // and we would have to wait for the transaction to complete itself.
        transaction.oncomplete = ()=>{
            resolve();
        };
        transaction.onerror = (event)=>{
            reject(event);
        };
        transaction.onabort = (event)=>{
            reject(event);
        };
    });
};
const $1d3b6c97cbeab58a$export$feab8418f018df89 = (transaction, logger)=>{
    try {
        if (typeof transaction.commit === "function") transaction.commit();
    } catch (error) {
        logger.error("Failed to force commit transaction:", error);
        throw error;
    }
    return $1d3b6c97cbeab58a$export$2a5213bce1720b42(transaction);
};
const $1d3b6c97cbeab58a$export$342d941b6f724995 = (request, logger)=>{
    request.onerror = (event)=>{
        logger.warn("Error thrown from request:", event);
    };
};

});



parcelRegister("5gj4Y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d4d3f21ff20df70$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $eiDyS = parcelRequire("eiDyS");

var $g4hTj = parcelRequire("g4hTj");

var $6DH9M = parcelRequire("6DH9M");
var $7Hmy4 = parcelRequire("7Hmy4");

var $901dJ = parcelRequire("901dJ");

var $2vBjM = parcelRequire("2vBjM");
const $3d4d3f21ff20df70$var$_excluded = [
    "item"
], $3d4d3f21ff20df70$var$_excluded2 = [
    "items"
];
function $3d4d3f21ff20df70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d4d3f21ff20df70$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d4d3f21ff20df70$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d4d3f21ff20df70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $3d4d3f21ff20df70$export$2e2bcd8739ae039 {
    /**
   * This method is used mainly to write new events to MemoryDB and uses the MEMORY_DB_GUARD_POLICY.EVICT_OLDEST_IF_LIMIT_EXECEEDED policy
   * to removes oldest events when limit is reached.
   */ async addItem(item, options = {}, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        if (policy === (0, $eiDyS.GuardPolicy).IGNORE) throw new (0, $7Hmy4.default)(policy, "IndexedDbConnector#addItem");
        const storedValue = (0, $2vBjM.convertToItemWrapper)(item, this.namespace, options);
        // Delegated responsiblity to event limit guard to insert to memory stored
        const bulkAddItemsResult = await this.globalEventLimitGuard.insertItemsToMemoryStore([
            storedValue
        ], policy);
        return Promise.resolve({
            item: bulkAddItemsResult.items[0],
            numberOfEvictedItems: bulkAddItemsResult.numberOfEvictedItems
        });
    }
    bulkAddItem(itemOptions, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        const items = itemOptions.map((_ref)=>{
            let { item: item } = _ref, addOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $3d4d3f21ff20df70$var$_excluded);
            return (0, $2vBjM.convertToItemWrapper)(item, this.namespace, addOptions);
        });
        return this.bulkAddItemWrapperType(items, policy);
    }
    /**
   * This method is used mainly to write events to MemoryDB when unknown errors are thrown from IndexedDB.
   */ bulkAddItemWrapperType(items, policy = (0, $eiDyS.GuardPolicy).ABANDON) {
        return Promise.resolve(this.globalEventLimitGuard.insertItemsToMemoryStore(items, policy));
    }
    getItems(count = (0, $g4hTj.GET_ITEM_COUNT)) {
        return Promise.resolve(this.synchronousGetItems(count));
    }
    synchronousGetItems(count = (0, $g4hTj.GET_ITEM_COUNT)) {
        const fixedCount = count > 0 ? count : (0, $g4hTj.GET_ITEM_COUNT);
        const now = Date.now();
        const wrappedItems = [];
        const itemsToRemove = [];
        for (let wrappedItem of this.memoryStore){
            if (wrappedItem.timeToBeProcessedAfter <= now) {
                wrappedItems.push($3d4d3f21ff20df70$var$_objectSpread({}, wrappedItem));
                // Mutates the item in the memoryStore array, but not whats inside of wrappedItems
                wrappedItem.timeToBeProcessedAfter += (0, $g4hTj.VISIBILITY_TIMEOUT);
                wrappedItem.retryAttempts += 1;
                if (wrappedItem.retryAttempts >= this.options.maxAttempts) itemsToRemove.push(wrappedItem);
            }
            if (wrappedItems.length >= fixedCount) break;
        }
        itemsToRemove.forEach((item)=>{
            const index = this.memoryStore.indexOf(item);
            this.memoryStore.splice(index, 1);
        });
        return {
            items: wrappedItems,
            numberOfDeletedItems: itemsToRemove.length
        };
    }
    deleteItems(itemIds) {
        this.memoryStore = this.memoryStore.filter((item)=>!itemIds.includes(item.id));
        return Promise.resolve(void 0);
    }
    getItemCount() {
        const now = Date.now();
        const count = this.memoryStore.filter((item)=>item.timeToBeProcessedAfter <= now).length;
        return Promise.resolve(count);
    }
    async processItems(processFn, count) {
        const _this$synchronousGetI = this.synchronousGetItems(count), { items: items } = _this$synchronousGetI, partialGetResult = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_this$synchronousGetI, $3d4d3f21ff20df70$var$_excluded2);
        const itemIds = items.map((i)=>i.id);
        try {
            const result = await processFn(items, partialGetResult);
            await this.deleteItems(itemIds);
            return result;
        } catch (error) {
            throw new (0, $6DH9M.default)(error);
        }
    }
    storeType() {
        return (0, $eiDyS.StoreType).MEMORY;
    }
    /**
   * This function is adding items to the tail of the memoryStore and as it adds new items it keeps the
   * memory store sorted by timeAdded property. This makes evictions easier and adding elements to
   * memoryStore much faster.
   *
   * @param itemsToAdd
   */ addItems(itemsToAdd) {
        this.memoryStore.push(...itemsToAdd);
        // Sorting everytime, intentionally.
        this.memoryStore.sort(function(a, b) {
            return a.timeAdded - b.timeAdded;
        });
    }
    /**
   * This function checks the number of events currently in AWC MemoryDb and if necessary,
   * will evict the oldest events in favour of the events we want to add.
   *
   * @param countOfEventsToAdd - The number of events we are proposing to add.
   */ evictEventsIfNeeded(eventLimit) {
        const numberOfEventsInDb = this.memoryStore.length;
        // The number of analytics events currently in MemoryDb and
        // the Z events we are proposing to add will exceed our event count limit.
        if (numberOfEventsInDb > eventLimit) {
            const m = numberOfEventsInDb - eventLimit;
            // Removing oldest M events
            this.memoryStore.splice(0, m);
            return m;
        }
        return 0;
    }
    constructor(namespace, options = {}){
        this.namespace = namespace;
        this.memoryStore = [];
        this.options = (0, $2vBjM.createOptionsWithDefaults)(options);
        /**
     * This class will enforce the number of analytics events we can store in our MemoryDb
     */ this.globalEventLimitGuard = new (0, $901dJ.default)(this.options.maxEventLimit, {
            addItems: this.addItems.bind(this),
            getItemCount: this.getItemCount.bind(this),
            evictEventsIfNeeded: this.evictEventsIfNeeded.bind(this)
        });
    }
}

});
parcelRegister("901dJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68d50f829dbfcc2b$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $eiDyS = parcelRequire("eiDyS");

var $3DoBM = parcelRequire("3DoBM");
class $68d50f829dbfcc2b$export$2e2bcd8739ae039 {
    async handleAbandonIfLimitWillExceedPolicy(itemsToAdd) {
        const itemCount = await this.memoryItemHandlers.getItemCount();
        if (itemCount + itemsToAdd.length > this.eventLimit) throw new (0, $3DoBM.default)((0, $eiDyS.StoreType).MEMORY);
        this.memoryItemHandlers.addItems(itemsToAdd);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: 0
        };
    }
    handleEvictOldestIfLimitExceededPolicy(itemsToAdd) {
        this.memoryItemHandlers.addItems(itemsToAdd);
        const numberOfEvictedItems = this.memoryItemHandlers.evictEventsIfNeeded(this.eventLimit);
        return {
            items: itemsToAdd,
            numberOfEvictedItems: numberOfEvictedItems
        };
    }
    async handleAddAsManyAsPossible(itemsToAdd) {
        const freeSpace = this.eventLimit - await this.memoryItemHandlers.getItemCount();
        const partialEventsToAdd = freeSpace > itemsToAdd.length ? itemsToAdd : itemsToAdd.slice(0, freeSpace);
        this.memoryItemHandlers.addItems(partialEventsToAdd);
        return {
            items: partialEventsToAdd,
            numberOfEvictedItems: 0
        };
    }
    constructor(eventLimit, memoryItemHandlers){
        /**
     * Unlike IndexedDb, we cannot take advantage of any index. So we are,
     * treating the memory store as a sorted set when adding items.
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "insertItemsToMemoryStore", (itemsToAdd, policy)=>{
            switch(policy){
                case (0, $eiDyS.GuardPolicy).ABANDON:
                    return this.handleAbandonIfLimitWillExceedPolicy(itemsToAdd);
                case (0, $eiDyS.GuardPolicy).EVICT:
                    return Promise.resolve(this.handleEvictOldestIfLimitExceededPolicy(itemsToAdd));
                case (0, $eiDyS.GuardPolicy).IGNORE:
                    return this.handleAddAsManyAsPossible(itemsToAdd);
            }
        });
        if (eventLimit > 0) this.eventLimit = eventLimit;
        else throw Error("Event Limit has to be set higher than 1");
        this.memoryItemHandlers = memoryItemHandlers;
    }
}

});




parcelRegister("elE98", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7222b149beef640$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $3aKbs = parcelRequire("3aKbs");
class $a7222b149beef640$export$4b62ee5120ab50a8 {
    addToItemsDiscardedByRetryCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByRetry += numberOfDeletedEvents;
    }
    addToEventCount() {
        this.eventCount++;
    }
    addToItemsDiscardedByOverflowCounter(numberOfDeletedEvents = 1) {
        this.itemsDiscardedByOverflow += numberOfDeletedEvents;
    }
    setResilienceMechanism(mechanism) {
        this.resilienceMechanism = mechanism;
    }
    /* <Localstorage specific> */ addToReclaimMetrics(reclaimMetrics) {
        this.localstorageNumberOfFullReclaims += reclaimMetrics.fullReclaims;
        this.localstorageNumberOfPartialReclaims += reclaimMetrics.partialReclaims;
        this.localstorageNumberOfFailedReclaims += reclaimMetrics.failedReclaims;
    }
    addToPurgedQueuesMetrics(numberOfQueuesPurged) {
        this.localstorageNumberOfQueuesPurged += numberOfQueuesPurged;
    }
    /* </Localstorage specific> */ subtractFromMetrics(sentMetrics) {
        this.itemsDiscardedByRetry = this.subtractFromCount(this.itemsDiscardedByRetry, sentMetrics.itemsDiscardedByRetry);
        this.eventCount = this.subtractFromCount(this.eventCount, sentMetrics.eventCount);
        this.itemsDiscardedByOverflow = this.subtractFromCount(this.itemsDiscardedByOverflow, sentMetrics.itemsDiscardedByOverflow);
        // Localstorage specific
        this.localstorageNumberOfFullReclaims = this.subtractFromCount(this.localstorageNumberOfFullReclaims, sentMetrics.fullReclaims);
        this.localstorageNumberOfPartialReclaims = this.subtractFromCount(this.localstorageNumberOfPartialReclaims, sentMetrics.partialReclaims);
        this.localstorageNumberOfFailedReclaims = this.subtractFromCount(this.localstorageNumberOfFailedReclaims, sentMetrics.failedReclaims);
        this.localstorageNumberOfQueuesPurged = this.subtractFromCount(this.localstorageNumberOfQueuesPurged, sentMetrics.localstorageQueuesPurged);
    }
    subtractFromCount(count, subtract) {
        return Math.max(count - (subtract || 0), 0);
    }
    getMetricsPayload() {
        return {
            itemsDiscardedByRetry: this.itemsDiscardedByRetry,
            eventCount: this.eventCount,
            itemsDiscardedByOverflow: this.itemsDiscardedByOverflow,
            resilienceMechanism: this.resilienceMechanism,
            // Localstorage specific
            localstorageQueuesPurged: this.localstorageNumberOfQueuesPurged,
            fullReclaims: this.localstorageNumberOfFullReclaims,
            partialReclaims: this.localstorageNumberOfPartialReclaims,
            failedReclaims: this.localstorageNumberOfFailedReclaims
        };
    }
    constructor(){
        // Number of events discarded due to exceeding retry limits.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "itemsDiscardedByRetry", 0);
        // Number of events created by the product in current tab.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "eventCount", 0);
        // Number of events discarded due to reaching queue max size.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "itemsDiscardedByOverflow", 0);
        // Will be used in the future when we get more resilience mechanisms
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "resilienceMechanism", (0, $3aKbs.ResilienceMechanism).INDEXEDDB);
        /* --- LocalStorage specific metrics --- */ // Emitted by purgeOrphanedQueues to tell us how many queues we have had to clean up due to
        // https://github.com/segmentio/localstorage-retry/pull/17
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfQueuesPurged", 0);
        // Emitted by reclaimEvents to tell us how many queues were seen in the process of reclaim.
        // We will only emit metrics for queues that are not currently being maintained (i.e. `ack` is not being updated).
        // Queue was found, all events removed and put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfFullReclaims", 0);
        // Queue was found but not all events were able to be put into resilienceDb.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfPartialReclaims", 0);
        // Reclaim failed for a queue and reclaim was abandonded.
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "localstorageNumberOfFailedReclaims", 0);
    }
}
let $a7222b149beef640$var$cachedMetricsClient = null;
var $a7222b149beef640$export$2e2bcd8739ae039 = ()=>{
    if (!$a7222b149beef640$var$cachedMetricsClient) $a7222b149beef640$var$cachedMetricsClient = new $a7222b149beef640$export$4b62ee5120ab50a8();
    return $a7222b149beef640$var$cachedMetricsClient;
};

});
parcelRegister("3aKbs", function(module, exports) {

$parcel$export(module.exports, "ResilienceMechanism", function () { return $24f62168b9020486$export$c75161629e3ec34e; });
$parcel$export(module.exports, "NetworkStatusEnum", function () { return $24f62168b9020486$export$ee138fa712d11b84; });
let $24f62168b9020486$export$c75161629e3ec34e = /*#__PURE__*/ function(ResilienceMechanism) {
    ResilienceMechanism["INDEXEDDB"] = "indexeddb";
    ResilienceMechanism["MEMORY"] = "memory";
    return ResilienceMechanism;
}({});
let $24f62168b9020486$export$ee138fa712d11b84 = /*#__PURE__*/ function(NetworkStatusEnum) {
    NetworkStatusEnum[NetworkStatusEnum["ONLINE"] = 0] = "ONLINE";
    NetworkStatusEnum[NetworkStatusEnum["OFFLINE"] = 1] = "OFFLINE";
    return NetworkStatusEnum;
}({});

});


parcelRegister("oBsJE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $049f4d45a8004e54$export$2e2bcd8739ae039; });

var $3aKbs = parcelRequire("3aKbs");
class $049f4d45a8004e54$export$2e2bcd8739ae039 {
    getNetworkStatus() {
        if (window.navigator.onLine) return (0, $3aKbs.NetworkStatusEnum).ONLINE;
        return (0, $3aKbs.NetworkStatusEnum).OFFLINE;
    }
    constructor(networkChangeCallback){
        if (typeof window !== "undefined") {
            window.addEventListener("offline", ()=>networkChangeCallback((0, $3aKbs.NetworkStatusEnum).OFFLINE));
            window.addEventListener("online", ()=>networkChangeCallback((0, $3aKbs.NetworkStatusEnum).ONLINE));
        }
    }
}

});

parcelRegister("6Znl6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $516a8b4c133db775$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $94xq4 = parcelRequire("94xq4");

var $1td0A = parcelRequire("1td0A");
const $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT = {
    minRetryDelay: 1000,
    maxRetryDelay: 30000,
    backoffFactor: 2,
    backoffJitterPercentage: 0,
    waitInterval: 500,
    callbackTimeoutPeriod: 5000
};
let $516a8b4c133db775$export$8bb92baee001fc60 = /*#__PURE__*/ function(QueuedScheduleTypes) {
    QueuedScheduleTypes[QueuedScheduleTypes["NONE"] = 0] = "NONE";
    QueuedScheduleTypes[QueuedScheduleTypes["IMMEDIATE"] = 1] = "IMMEDIATE";
    QueuedScheduleTypes[QueuedScheduleTypes["WAIT"] = 2] = "WAIT";
    return QueuedScheduleTypes;
}({});
class $516a8b4c133db775$export$2e2bcd8739ae039 {
    constructor(retryOptions, callback){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "schedule", ({ immediate: immediate } = {
            immediate: false
        })=>{
            if (typeof window === "undefined") return;
            if (this.operationInFlight) {
                if (immediate) this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.IMMEDIATE;
                else if (this.queuedSchedule !== $516a8b4c133db775$export$8bb92baee001fc60.IMMEDIATE) this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.WAIT;
            // Only run immediately if we have no failures
            } else if ((immediate || this.options.waitInterval <= 0) && this.failureCount === 0) {
                this.clearTimeout();
                this.run();
            // Backoff
            } else if (this.failureCount > 0 && this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.calculateBackoff());
            else if (this.scheduledTimeout === null) this.scheduledTimeout = window.setTimeout(this.run, this.options.waitInterval);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stop", ()=>{
            this.clearTimeout();
            this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.NONE;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getFailureCount", ()=>this.failureCount);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getCallbackStatus", ()=>{
            return this.callbackTimer.getCallbackStatus();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clearTimeout", ()=>{
            if (typeof window !== "undefined" && this.scheduledTimeout !== null) {
                window.clearTimeout(this.scheduledTimeout);
                this.scheduledTimeout = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "run", ()=>{
            this.operationInFlight = true;
            this.clearTimeout();
            try {
                this.callbackTimer.executeCallbackWithTimeout(// callback to execute
                this.callback, // when callback completes, call this function
                this.done, // on timeout, do this instead
                ()=>this.done((0, $1td0A.DoneState).ERROR));
            } catch (err) {
                this.done(err);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "done", (state)=>{
            this.operationInFlight = false;
            if (state === (0, $1td0A.DoneState).ERROR || this.callbackTimer.getCallbackStatus() === (0, $94xq4.CallbackStatus).TIMED_OUT) {
                this.failureCount++;
                this.clearTimeout();
            } else if (state === (0, $1td0A.DoneState).SUCCESS) this.failureCount = 0;
            this.processQueuedSchedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "processQueuedSchedule", ()=>{
            if (this.queuedSchedule !== $516a8b4c133db775$export$8bb92baee001fc60.NONE) {
                const immediate = this.queuedSchedule === $516a8b4c133db775$export$8bb92baee001fc60.IMMEDIATE;
                this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.NONE;
                this.schedule({
                    immediate: immediate
                });
            } else if (this.failureCount > 0) // This will schedule tasks when this._done was called with a truthy value
            // For example, when this.callback(this._done) was not called within
            // this.callbackTimeoutPeriod
            this.schedule();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "calculateBackoff", ()=>{
            const { minRetryDelay: minRetryDelay, maxRetryDelay: maxRetryDelay, backoffFactor: backoffFactor, backoffJitterPercentage: backoffJitterPercentage } = this.options;
            let ms = minRetryDelay * backoffFactor ** this.failureCount;
            if (backoffJitterPercentage) {
                const rand = Math.random();
                const deviation = Math.floor(rand * backoffJitterPercentage * ms);
                if (Math.floor(rand * 10) < 5) ms -= deviation;
                else ms += deviation;
            }
            return Number(Math.min(ms, maxRetryDelay).toPrecision(1));
        });
        this.options = {
            minRetryDelay: retryOptions.minRetryDelay || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.minRetryDelay,
            maxRetryDelay: retryOptions.maxRetryDelay || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.maxRetryDelay,
            backoffFactor: retryOptions.backoffFactor || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.backoffFactor,
            backoffJitterPercentage: retryOptions.backoffJitterPercentage || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.backoffJitterPercentage,
            waitInterval: retryOptions.waitInterval !== undefined ? retryOptions.waitInterval : $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.waitInterval,
            callbackTimeoutPeriod: retryOptions.callbackTimeoutPeriod || $516a8b4c133db775$var$SCHEDULER_OPTIONS_DEFAULT.callbackTimeoutPeriod
        };
        this.scheduledTimeout = null;
        this.failureCount = 0;
        this.callback = callback;
        this.operationInFlight = false;
        this.queuedSchedule = $516a8b4c133db775$export$8bb92baee001fc60.NONE;
        this.callbackTimer = new (0, $94xq4.CallbackWithTimeout)(this.options.callbackTimeoutPeriod);
    }
}

});
parcelRegister("94xq4", function(module, exports) {

$parcel$export(module.exports, "CallbackStatus", function () { return $69ae692c29fd415b$export$ef3353088fca369c; });
$parcel$export(module.exports, "CallbackWithTimeout", function () { return $69ae692c29fd415b$export$590a718599f8f8b3; });

var $6bkHe = parcelRequire("6bkHe");
let $69ae692c29fd415b$export$ef3353088fca369c = /*#__PURE__*/ function(CallbackStatus) {
    CallbackStatus["IDLE"] = "idle";
    CallbackStatus["RUNNING"] = "running";
    CallbackStatus["COMPLETED"] = "completed";
    CallbackStatus["TIMED_OUT"] = "timedOut";
    return CallbackStatus;
}({});
let $69ae692c29fd415b$export$def7d978353eaa0 = /*#__PURE__*/ function(CallbackEvent) {
    CallbackEvent["EXECUTE"] = "execute";
    CallbackEvent["COMPLETE"] = "complete";
    CallbackEvent["TIMEOUT"] = "timeout";
    return CallbackEvent;
}({});
class $69ae692c29fd415b$export$590a718599f8f8b3 {
    // This is a state machine to control the flow of execution.
    // IDLE -> RUNNING -> COMPLETED
    // IDLE -> RUNNING -> TIMEDOUT
    transitionCallbackStatus(currentStatus, event) {
        switch(currentStatus){
            case $69ae692c29fd415b$export$ef3353088fca369c.IDLE:
            case $69ae692c29fd415b$export$ef3353088fca369c.TIMED_OUT:
            case $69ae692c29fd415b$export$ef3353088fca369c.COMPLETED:
                if (event === $69ae692c29fd415b$export$def7d978353eaa0.EXECUTE) this.callbackStatus = $69ae692c29fd415b$export$ef3353088fca369c.RUNNING;
                break;
            case $69ae692c29fd415b$export$ef3353088fca369c.RUNNING:
                switch(event){
                    case $69ae692c29fd415b$export$def7d978353eaa0.COMPLETE:
                        this.callbackStatus = $69ae692c29fd415b$export$ef3353088fca369c.COMPLETED;
                        break;
                    case $69ae692c29fd415b$export$def7d978353eaa0.TIMEOUT:
                        this.callbackStatus = $69ae692c29fd415b$export$ef3353088fca369c.TIMED_OUT;
                        break;
                }
                break;
            default:
                this.callbackStatus = currentStatus;
        }
    }
    // Start a timeout. If this.callback(this._done) does not finish
    // by this.options.callbackTimeoutPeriod time period,
    // we will call done with a true value.
    executeCallbackWithTimeout(callback, onDone, onTimeout) {
        if (typeof window === "undefined") return;
        this.transitionCallbackStatus(this.callbackStatus, $69ae692c29fd415b$export$def7d978353eaa0.EXECUTE);
        // Setting timeout
        this.timeoutHandle = window.setTimeout(()=>{
            this.transitionCallbackStatus(this.callbackStatus, $69ae692c29fd415b$export$def7d978353eaa0.TIMEOUT);
            onTimeout();
        }, this.timeoutPeriod);
        // Executing callback
        callback((state)=>{
            this.cancelTimeout();
            if (this.getCallbackStatus() !== $69ae692c29fd415b$export$ef3353088fca369c.TIMED_OUT) {
                this.transitionCallbackStatus(this.callbackStatus, $69ae692c29fd415b$export$def7d978353eaa0.COMPLETE);
                onDone(state);
            }
        });
    }
    getCallbackStatus() {
        return this.callbackStatus;
    }
    // This allows us to cancel the timeout function, for example, if the callback finishes before the timeout period
    // or, if the user wants to manually cancel the timeout
    cancelTimeout() {
        if (typeof window !== "undefined" && this.timeoutPeriod > 0 && this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
            this.timeoutHandle = undefined;
        }
    }
    constructor(timeoutPeriod){
        // Milliseconds to wait
        // Tracks the settimeout; so that we can clear the timeout
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "timeoutHandle", undefined);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "callbackStatus", $69ae692c29fd415b$export$ef3353088fca369c.IDLE);
        if (timeoutPeriod > 0) {
            this.timeoutPeriod = timeoutPeriod;
            return;
        }
        throw new Error("CallbackWithTimeout requires timeout period higher than 0");
    }
}

});

parcelRegister("1td0A", function(module, exports) {

$parcel$export(module.exports, "DoneState", function () { return $11229718ddc7d24c$export$f93c40fda808dd0c; });
// Clients can optionally provide the callbackTimeoutPeriod parameter
let $11229718ddc7d24c$export$f93c40fda808dd0c = /*#__PURE__*/ function(DoneState) {
    DoneState[DoneState["NOOP"] = 0] = "NOOP";
    DoneState[DoneState["SUCCESS"] = 1] = "SUCCESS";
    DoneState[DoneState["ERROR"] = 2] = "ERROR";
    return DoneState;
}({});

});




parcelRegister("gINol", function(module, exports) {

$parcel$export(module.exports, "attachXidToMultipleEvents", function () { return $c2c7118957ab383c$export$c21270cab66ab290; });

var $6bkHe = parcelRequire("6bkHe");

var $hng8D = parcelRequire("hng8D");
function $c2c7118957ab383c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2c7118957ab383c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2c7118957ab383c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2c7118957ab383c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2c7118957ab383c$export$c9c3aaf655d6f275(item, xidCallback) {
    if (!(xidCallback && xidCallback instanceof Function)) return item;
    if (item.msg.type === (0, $hng8D.SegmentEventTypes).PAGE || item.msg.type === (0, $hng8D.SegmentEventTypes).TRACK) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.properties = $c2c7118957ab383c$var$_objectSpread($c2c7118957ab383c$var$_objectSpread({}, item.msg.properties), {}, {
            xid: xid
        });
    } else if (item.msg.traits && item.msg.type === (0, $hng8D.SegmentEventTypes).IDENTIFY) {
        const xid = xidCallback();
        if (xid && Array.isArray(xid)) item.msg.traits = $c2c7118957ab383c$var$_objectSpread($c2c7118957ab383c$var$_objectSpread({}, item.msg.traits), {}, {
            xid: xid
        });
    }
    return item;
}
async function $c2c7118957ab383c$export$c21270cab66ab290(items, xidItemPromiseCallback) {
    try {
        const xidCallback = await xidItemPromiseCallback;
        return items.map((item)=>$c2c7118957ab383c$export$c9c3aaf655d6f275(item, xidCallback));
    } catch (error) {
        return items;
    }
}

});
parcelRegister("hng8D", function(module, exports) {

$parcel$export(module.exports, "SegmentEventTypes", function () { return $ca611a65dc6359c5$export$ddf929981dc6feb3; });
// Segment event types copied from our backend
// https://bitbucket.org/atlassian/analytics-service/src/master/api/src/main/java/com/atlassian/dataservices/analytics/service/api/segment/
let $ca611a65dc6359c5$export$ddf929981dc6feb3 = /*#__PURE__*/ function(SegmentEventTypes) {
    SegmentEventTypes["IDENTIFY"] = "identify";
    SegmentEventTypes["PAGE"] = "page";
    SegmentEventTypes["TRACK"] = "track";
    return SegmentEventTypes;
}({});
let $ca611a65dc6359c5$export$8d8db47b9b0efb63 = /*#__PURE__*/ function(CrossDomainIdentifierType) {
    CrossDomainIdentifierType["XC"] = "xc";
    CrossDomainIdentifierType["UID"] = "uid";
    return CrossDomainIdentifierType;
}({});
let $ca611a65dc6359c5$export$2140495465f9e528 = /*#__PURE__*/ function(CrossDomainIdentifierState) {
    CrossDomainIdentifierState["NEW"] = "NEW";
    CrossDomainIdentifierState["CHANGED"] = "CHANGED";
    CrossDomainIdentifierState["EXISTING"] = "EXISTING";
    CrossDomainIdentifierState["TIMEOUT"] = "TIMEOUT";
    CrossDomainIdentifierState["ERROR"] = "ERROR";
    CrossDomainIdentifierState["UNAVAILABLE"] = "UNAVAILABLE";
    CrossDomainIdentifierState["MALFORMED"] = "MALFORMED";
    CrossDomainIdentifierState["UNKNOWN"] = "UNKNOWN";
    return CrossDomainIdentifierState;
}({});

});


parcelRegister("3q4zO", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_REQUEST_TIMEOUT", function () { return $27d759a5d505afd1$export$9175ce0e1c95daf2; });
const $27d759a5d505afd1$export$9175ce0e1c95daf2 = 10000; // 10 seconds

});

parcelRegister("bEXZy", function(module, exports) {

$parcel$export(module.exports, "sendEvents", function () { return $87d1f748c0ebbe63$export$8e8f0180c1b41fad; });

var $6bkHe = parcelRequire("6bkHe");

var $tazez = parcelRequire("tazez");
function $87d1f748c0ebbe63$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $87d1f748c0ebbe63$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $87d1f748c0ebbe63$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $87d1f748c0ebbe63$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $87d1f748c0ebbe63$export$8e8f0180c1b41fad = async (options)=>{
    var _createOrGetAbortCont;
    const signal = (_createOrGetAbortCont = $87d1f748c0ebbe63$var$createOrGetAbortController(options)) === null || _createOrGetAbortCont === void 0 ? void 0 : _createOrGetAbortCont.signal;
    const corsOptions = $87d1f748c0ebbe63$var$getCorsForUrl(options.url);
    const response = await fetch(options.url, $87d1f748c0ebbe63$var$_objectSpread({
        method: "POST",
        // Content-type has to be text/plain in order to prevent unnecessary `OPTIONS` requests.
        headers: {
            "Content-Type": "text/plain"
        },
        body: JSON.stringify(options.batch),
        signal: signal
    }, corsOptions));
    if (response.status === 429 || response.status >= 500 && response.status < 600) throw new Error(`HTTP Error ${response.status} (${response.statusText})`);
    return response;
};
const $87d1f748c0ebbe63$var$createOrGetAbortController = (options)=>{
    if (options.abortController) return options.abortController;
    else if (options.timeout) {
        const abortController = new AbortController();
        // After a fetch has completed, calling abort is ignored.
        setTimeout(()=>{
            abortController.abort();
        }, options.timeout);
        return abortController;
    }
};
// To ensure we always have cookies, we should check if the origins match.
// If they dont, we need to set mode to `cors` and credentials to `include`.
const $87d1f748c0ebbe63$var$getCorsForUrl = (0, $tazez.default)((url)=>{
    const origin = new URL(url).origin;
    if (origin === location.origin) return {};
    else return {
        mode: "cors",
        credentials: "include"
    };
});

});
parcelRegister("tazez", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $057ae7fdf9f17f1d$export$2e2bcd8739ae039; });
var $057ae7fdf9f17f1d$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $057ae7fdf9f17f1d$var$isEqual(first, second) {
    if (first === second) return true;
    if ($057ae7fdf9f17f1d$var$safeIsNaN(first) && $057ae7fdf9f17f1d$var$safeIsNaN(second)) return true;
    return false;
}
function $057ae7fdf9f17f1d$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$057ae7fdf9f17f1d$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $057ae7fdf9f17f1d$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $057ae7fdf9f17f1d$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});


parcelRegister("ePQx8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $acce9427d49cc345$export$2e2bcd8739ae039; });

var $1X2vc = parcelRequire("1X2vc");

var $gaCcd = parcelRequire("gaCcd");

var $1zj8U = parcelRequire("1zj8U");
var $cGSp4 = parcelRequire("cGSp4");

var $3wkHk = parcelRequire("3wkHk");
// Cookie is stale, if anonymousId was generated 7 days ago.
const $acce9427d49cc345$var$ANONYMOUS_ID_COOKIE_STALE_DAYS = 7;
const $acce9427d49cc345$var$SAFE = "SAFE";
const $acce9427d49cc345$var$UNSAFE = "UNSAFE";
const $acce9427d49cc345$var$NOT_FOUND = "NOT_FOUND";
const $acce9427d49cc345$var$COOKIE = "COOKIE";
const $acce9427d49cc345$var$LOCAL_STORAGE = "LOCAL_STORAGE";
class $acce9427d49cc345$export$2e2bcd8739ae039 {
    getUserId() {
        return this.userId || null;
    }
    setUserId(userId) {
        this.userId = userId;
    }
    getAnonymousId(customAnonymousIdGenerator) {
        /**
     * Prefer localStorage as there cant be duplicate keys, and its faster. Also update cookie, if stale.
     * If not set in localStorage, check cookies. Also set localStorage for future attempts.
     * If not in cookies, generate a new one. Set both cookie and localStorage keys.
     */ return this.getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() || this.getAnonymousIdFromCookieAndUpdateLocalStorage() || this.generateNewAnonymousId(customAnonymousIdGenerator);
    }
    setAnonymousId(anonymousId) {
        const stringifyAnonymosId = JSON.stringify(anonymousId);
        this.cookie.set((0, $1zj8U.AWCCookiesKeys).AJS_ANONYMOUS_ID, stringifyAnonymosId);
        this.lastAnonymousIdCookieUpdate = Date.now();
        return this.store.setItem((0, $1zj8U.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), stringifyAnonymosId);
    }
    getAnonymousIdFromStorage(source) {
        const rawStorageAnonidValue = source === $acce9427d49cc345$var$LOCAL_STORAGE ? this.store.getItem((0, $1zj8U.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey()) : this.cookie.get((0, $1zj8U.AWCCookiesKeys).AJS_ANONYMOUS_ID);
        if (rawStorageAnonidValue) {
            const unsafeValue = {
                type: $acce9427d49cc345$var$UNSAFE,
                anonymousId: rawStorageAnonidValue
            };
            try {
                const parsedAnonId = JSON.parse(rawStorageAnonidValue);
                if (parsedAnonId && typeof parsedAnonId === "string") return {
                    type: $acce9427d49cc345$var$SAFE,
                    anonymousId: parsedAnonId
                };
                return unsafeValue;
            } catch (err) {
                /*
         * Segments new Analytics-next client will store strings as strings without stringifing.
         * The legacy Segment client and AWC always stringify and parse cookies and values.
         * If the new Segment analytics-client stores a cookie and local storage value first, it will
         * breaking old clients.
         *
         * Additionally, JSON.parse can cause exceptions to be thrown in some browsers; see AAP-324.
         *
         * Intentionally swalling errors here and returning the original value found in storage to avoid ping-pong.
         */ return unsafeValue;
            }
        }
        return {
            type: $acce9427d49cc345$var$NOT_FOUND
        };
    }
    getAnonymousIdFromLocalStorageAndUpdateCookieIfStale() {
        const localStorageValue = this.getAnonymousIdFromStorage($acce9427d49cc345$var$LOCAL_STORAGE);
        let shouldUpdateCookie = false;
        if (!this.lastAnonymousIdCookieUpdate || (0, $1X2vc.default)(new Date(), new Date(this.lastAnonymousIdCookieUpdate)) >= $acce9427d49cc345$var$ANONYMOUS_ID_COOKIE_STALE_DAYS) shouldUpdateCookie = true;
        switch(localStorageValue.type){
            case $acce9427d49cc345$var$SAFE:
                if (shouldUpdateCookie) this.setAnonymousId(localStorageValue.anonymousId);
                return localStorageValue.anonymousId;
            case $acce9427d49cc345$var$UNSAFE:
                return localStorageValue.anonymousId;
            case $acce9427d49cc345$var$NOT_FOUND:
            default:
                return null;
        }
    }
    getAnonymousIdFromCookieAndUpdateLocalStorage() {
        const cookieValue = this.getAnonymousIdFromStorage($acce9427d49cc345$var$COOKIE);
        switch(cookieValue.type){
            case $acce9427d49cc345$var$SAFE:
            case $acce9427d49cc345$var$UNSAFE:
                this.store.setItem((0, $1zj8U.AllAnalyticsCookies).AJS_ANONYMOUS_ID.getKey(), JSON.stringify(cookieValue.anonymousId));
                return cookieValue.anonymousId;
            case $acce9427d49cc345$var$NOT_FOUND:
            default:
                return null;
        }
    }
    generateNewAnonymousId(customAnonymousIdGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))) {
        const newAnonId = customAnonymousIdGenerator();
        this.setAnonymousId(newAnonId);
        return newAnonId;
    }
    constructor(disableCookiePersistence){
        this.store = new (0, $3wkHk.default)({
            useStoragePrefix: false
        });
        this.cookie = new (0, $cGSp4.default)(disableCookiePersistence);
    }
}

});
parcelRegister("1X2vc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16bd3e0be5accb72$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $5TqF7 = parcelRequire("5TqF7");

var $kqhx7 = parcelRequire("kqhx7");
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $16bd3e0be5accb72$var$compareLocalAsc(dateLeft, dateRight) {
    var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    else return diff;
}
function $16bd3e0be5accb72$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kqhx7.default)(2, arguments);
    var dateLeft = (0, $eSxdi.default)(dirtyDateLeft);
    var dateRight = (0, $eSxdi.default)(dirtyDateRight);
    var sign = $16bd3e0be5accb72$var$compareLocalAsc(dateLeft, dateRight);
    var difference = Math.abs((0, $5TqF7.default)(dateLeft, dateRight));
    dateLeft.setDate(dateLeft.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    var isLastDayNotFull = Number($16bd3e0be5accb72$var$compareLocalAsc(dateLeft, dateRight) === -sign);
    var result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}

});
parcelRegister("eSxdi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad4fdf55700979f1$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");

var $kqhx7 = parcelRequire("kqhx7");
function $ad4fdf55700979f1$export$2e2bcd8739ae039(argument) {
    (0, $kqhx7.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $8p0zh.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});
parcelRegister("8p0zh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $61e119534a0b324c$export$2e2bcd8739ae039; });
function $61e119534a0b324c$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $61e119534a0b324c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $61e119534a0b324c$export$2e2bcd8739ae039(o);
}

});

parcelRegister("kqhx7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ede3d615aefdc26d$export$2e2bcd8739ae039; });
function $ede3d615aefdc26d$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("5TqF7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44a6c55ab082050c$export$2e2bcd8739ae039; });

var $2EOLL = parcelRequire("2EOLL");

var $afvqM = parcelRequire("afvqM");

var $kqhx7 = parcelRequire("kqhx7");
var $44a6c55ab082050c$var$MILLISECONDS_IN_DAY = 86400000;
function $44a6c55ab082050c$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $kqhx7.default)(2, arguments);
    var startOfDayLeft = (0, $afvqM.default)(dirtyDateLeft);
    var startOfDayRight = (0, $afvqM.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $2EOLL.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $2EOLL.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $44a6c55ab082050c$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("2EOLL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ef6b2ef7ba2174c$export$2e2bcd8739ae039; });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $1ef6b2ef7ba2174c$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("afvqM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7763afa254a4bbfe$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $7763afa254a4bbfe$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});



parcelRegister("1zj8U", function(module, exports) {

$parcel$export(module.exports, "AWCCookiesKeys", function () { return $1247e8a98fdc3168$export$202d555a5dbfd90c; });
$parcel$export(module.exports, "AllAnalyticsCookies", function () { return $1247e8a98fdc3168$export$d4cb17942ea57c95; });
let $1247e8a98fdc3168$export$202d555a5dbfd90c = /*#__PURE__*/ function(AWCCookiesKeys) {
    AWCCookiesKeys["AWC_TLD_TEST"] = "AWC_TLD_TEST";
    AWCCookiesKeys["AWC_ANALYTICS_DEBUG"] = "AWC_ANALYTICS_DEBUG";
    AWCCookiesKeys["AJS_ANONYMOUS_ID"] = "AJS_ANONYMOUS_ID";
    return AWCCookiesKeys;
}({});
class $1247e8a98fdc3168$var$CookieSchema {
    getAttributes() {
        return this.options;
    }
    getKey() {
        return this.key;
    }
    constructor(key, options){
        this.key = key;
        this.options = options;
    }
}
const $1247e8a98fdc3168$var$isSecure = ()=>{
    try {
        return window && window.location && window.location.protocol === "https:";
    } catch (err) {
        return false;
    }
};
const $1247e8a98fdc3168$export$d4cb17942ea57c95 = {
    [$1247e8a98fdc3168$export$202d555a5dbfd90c.AWC_TLD_TEST]: new $1247e8a98fdc3168$var$CookieSchema("__awc_tld_test__", {
        expires: 365,
        secure: $1247e8a98fdc3168$var$isSecure(),
        path: "/"
    }),
    [$1247e8a98fdc3168$export$202d555a5dbfd90c.AWC_ANALYTICS_DEBUG]: new $1247e8a98fdc3168$var$CookieSchema("atlassian_analytics_debug", {
        expires: 365,
        secure: $1247e8a98fdc3168$var$isSecure(),
        path: "/"
    }),
    [$1247e8a98fdc3168$export$202d555a5dbfd90c.AJS_ANONYMOUS_ID]: new $1247e8a98fdc3168$var$CookieSchema("ajs_anonymous_id", {
        expires: 365,
        secure: $1247e8a98fdc3168$var$isSecure(),
        path: "/"
    })
};

});

parcelRegister("cGSp4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93d39ba6a81c9615$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8USlx = parcelRequire("8USlx");

var $1zj8U = parcelRequire("1zj8U");

var $6lPXC = parcelRequire("6lPXC");

var $3tNVa = parcelRequire("3tNVa");
function $93d39ba6a81c9615$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93d39ba6a81c9615$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93d39ba6a81c9615$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93d39ba6a81c9615$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $93d39ba6a81c9615$export$2e2bcd8739ae039 {
    set(name, value, options) {
        // no-op
        if (!(0, $1zj8U.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not set.`);
            return;
        }
        return this.cookieLike.set((0, $1zj8U.AllAnalyticsCookies)[name].getKey(), value, $93d39ba6a81c9615$var$_objectSpread($93d39ba6a81c9615$var$_objectSpread({}, (0, $1zj8U.AllAnalyticsCookies)[name].getAttributes()), {}, {
            // Function is memoized so we only calculate this once per page load
            domain: (0, $3tNVa.getTld)()
        }, options));
    }
    get(name) {
        if (!(0, $1zj8U.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not fetched.`);
            return;
        }
        return this.cookieLike.get((0, $1zj8U.AllAnalyticsCookies)[name].getKey());
    }
    remove(name, options) {
        if (!(0, $1zj8U.AllAnalyticsCookies)[name]) {
            // eslint-disable-next-line no-console
            console.warn(`Unknown cookie key ${name} provided, not removed.`);
            return;
        }
        this.cookieLike.remove((0, $1zj8U.AllAnalyticsCookies)[name].getKey(), $93d39ba6a81c9615$var$_objectSpread({}, options));
    }
    constructor(disableCookiePersistence){
        this.cookieLike = (0, $3tNVa.canUseCookie)(disableCookiePersistence) ? (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))) : new (0, $6lPXC.default)();
    }
}

});
parcelRegister("8USlx", function(module, exports) {
(function(factory) {
    var registeredInModuleLoader;
    if (typeof define === "function" && define.amd) {
        define(factory);
        registeredInModuleLoader = true;
    }
    module.exports = factory();
    registeredInModuleLoader = true;
    if (!registeredInModuleLoader) {
        var OldCookies = window.Cookies;
        var api = window.Cookies = factory();
        api.noConflict = function() {
            window.Cookies = OldCookies;
            return api;
        };
    }
})(function() {
    function extend() {
        var i = 0;
        var result = {};
        for(; i < arguments.length; i++){
            var attributes = arguments[i];
            for(var key in attributes)result[key] = attributes[key];
        }
        return result;
    }
    function decode(s) {
        return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function init(converter) {
        function api() {}
        function set(key, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = extend({
                path: "/"
            }, api.defaults, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
            // We're using "expires" because "max-age" is not supported by IE
            attributes.expires = attributes.expires ? attributes.expires.toUTCString() : "";
            try {
                var result = JSON.stringify(value);
                if (/^[\{\[]/.test(result)) value = result;
            } catch (e) {}
            value = converter.write ? converter.write(value, key) : encodeURIComponent(String(value)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
            key = encodeURIComponent(String(key)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = key + "=" + value + stringifiedAttributes;
        }
        function get(key, json) {
            if (typeof document === "undefined") return;
            var jar = {};
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var i = 0;
            for(; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var cookie = parts.slice(1).join("=");
                if (!json && cookie.charAt(0) === '"') cookie = cookie.slice(1, -1);
                try {
                    var name = decode(parts[0]);
                    cookie = (converter.read || converter)(cookie, name) || decode(cookie);
                    if (json) try {
                        cookie = JSON.parse(cookie);
                    } catch (e) {}
                    jar[name] = cookie;
                    if (key === name) break;
                } catch (e) {}
            }
            return key ? jar[key] : jar;
        }
        api.set = set;
        api.get = function(key) {
            return get(key, false);
        };
        api.getJSON = function(key) {
            return get(key, true);
        };
        api.remove = function(key, attributes) {
            set(key, "", extend(attributes, {
                expires: -1
            }));
        };
        api.defaults = {};
        api.withConverter = init;
        return api;
    }
    return init(function() {});
});

});

parcelRegister("6lPXC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $49fd028715114a9b$export$2e2bcd8739ae039; });

var $3wkHk = parcelRequire("3wkHk");
class $49fd028715114a9b$export$2e2bcd8739ae039 {
    set(name, value) {
        this.safeStorage.setItem(name, value);
        return value;
    }
    get(name) {
        const value = this.safeStorage.getItem(name);
        return value || undefined;
    }
    remove(name) {
        this.safeStorage.removeItem(name);
    }
    constructor(){
        this.safeStorage = new (0, $3wkHk.default)({
            useStoragePrefix: false
        });
    }
}

});
parcelRegister("3wkHk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29046a66738f8b40$export$2e2bcd8739ae039; });

var $gukCd = parcelRequire("gukCd");

var $dRrH7 = parcelRequire("dRrH7");
class $29046a66738f8b40$export$2e2bcd8739ae039 extends (0, $dRrH7.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.localStorage || (0, $gukCd.default);
        } catch (err) {
            storageToUse = (0, $gukCd.default);
        }
        super(storageToUse, options);
    }
}

});
parcelRegister("gukCd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c00f707b4bc25dd4$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");
class $c00f707b4bc25dd4$export$90e3e001bcac59c7 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_data", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "length", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setItem", (key, value)=>{
            this._data[key] = value;
            this.length = Object.keys(this._data).length;
            return value;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItem", (key)=>{
            if (key in this._data) return this._data[key];
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "removeItem", (key)=>{
            if (key in this._data) delete this._data[key];
            this.length = Object.keys(this._data).length;
            return null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clear", ()=>{
            this._data = {};
            this.length = 0;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "key", (index)=>Object.keys(this._data)[index]);
    }
}
var // eslint-disable-next-line import/no-anonymous-default-export
$c00f707b4bc25dd4$export$2e2bcd8739ae039 = new $c00f707b4bc25dd4$export$90e3e001bcac59c7();

});

parcelRegister("dRrH7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a175b51ed57ac6da$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $gukCd = parcelRequire("gukCd");
const $a175b51ed57ac6da$export$41c06fdd37b7e9a5 = "awc";
const $a175b51ed57ac6da$export$770aa8bc07b3de03 = "awcInMemoryStorageFallback";
function $a175b51ed57ac6da$export$48c17662a6902497(store) {
    const TEST_VALUE = "test_value";
    if (!store) return false;
    try {
        const key = "awc.storage.support";
        store.setItem(key, TEST_VALUE);
        const value = store.getItem(key);
        store.removeItem(key);
        // handle localStorage silently failing
        return value === TEST_VALUE;
    } catch (e) {
        // Can throw if localStorage is disabled
        return false;
    }
}
function $a175b51ed57ac6da$export$6325979d1c67607f(e) {
    let quotaExceeded = false;
    if (e.code) switch(e.code){
        case 22:
            quotaExceeded = true;
            break;
        case 1014:
            // Firefox
            if (e.name === "NS_ERROR_DOM_QUOTA_REACHED") quotaExceeded = true;
            break;
        default:
            break;
    }
    else if (e.number === -2147024882) // Internet Explorer 8
    quotaExceeded = true;
    return quotaExceeded;
}
class $a175b51ed57ac6da$export$2e2bcd8739ae039 {
    constructor(storageToUse, options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getStore", ()=>this._store);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getItem", (key)=>this._store.getItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "removeItem", (key)=>this._store.removeItem(this.createKey(key)));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setItem", (key, value)=>{
            try {
                this._store.setItem(this.createKey(key), value);
            } catch (err) {
                if ($a175b51ed57ac6da$export$6325979d1c67607f(err)) {
                    this.swapToInMemory();
                    this._store.setItem(this.createKey(key), value);
                }
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "swapToInMemory", ()=>{
            if (this._store === (0, $gukCd.default) || typeof window === "undefined") return;
            const keys = Object.keys(this._store || {});
            let inMemoryStorage;
            if ($a175b51ed57ac6da$export$48c17662a6902497(window[$a175b51ed57ac6da$export$770aa8bc07b3de03])) inMemoryStorage = window[$a175b51ed57ac6da$export$770aa8bc07b3de03];
            else {
                inMemoryStorage = (0, $gukCd.default);
                if (!window[$a175b51ed57ac6da$export$770aa8bc07b3de03]) // If not already attached to window then attach our instance of InMemoryStorage
                // We need to do this because if there are multiple instances of Analytics Client in multiple scopes,
                // there is no way to guarantee the throttling behaviour of the UI viewed event across those instances without a global singleton
                window[$a175b51ed57ac6da$export$770aa8bc07b3de03] = (0, $gukCd.default);
            }
            keys.forEach((key)=>{
                if (key.indexOf(this.getPrefix()) === 0) {
                    const value = this._store.getItem(key);
                    if (value) inMemoryStorage.setItem(key, value);
                }
            });
            this._store = inMemoryStorage;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clear", ()=>this._store.clear());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "key", (index)=>this._store.key(index));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getPrefix", ()=>this._prefix);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createKey", (key)=>{
            if (this._prefix) return `${this.getPrefix()}.${key}`;
            return key;
        });
        this.options = options;
        const prefixes = [];
        if (options.useStoragePrefix === undefined || options.useStoragePrefix) prefixes.push($a175b51ed57ac6da$export$41c06fdd37b7e9a5);
        if (options.envPrefix && options.envPrefix !== (0, $4cW1f.envType).PROD) prefixes.push(options.envPrefix);
        this._prefix = prefixes.join("-");
        if ($a175b51ed57ac6da$export$48c17662a6902497(storageToUse)) this._store = storageToUse;
        else this.swapToInMemory();
    }
}

});



parcelRegister("3tNVa", function(module, exports) {

$parcel$export(module.exports, "canUseCookie", function () { return $288acdcfb2e394fa$export$a9330601ee8f4d95; });
$parcel$export(module.exports, "getTld", function () { return $288acdcfb2e394fa$export$de6821eed3d5f32d; });

var $8USlx = parcelRequire("8USlx");

var $tazez = parcelRequire("tazez");

var $1zj8U = parcelRequire("1zj8U");
const $288acdcfb2e394fa$export$a9330601ee8f4d95 = (disableCookiePersistence = false)=>{
    if (disableCookiePersistence) return false;
    return !(location.protocol === "file:" || location.protocol === "chrome-extension:");
};
const $288acdcfb2e394fa$export$eb80e1beaa8dacf8 = (0, $1zj8U.AllAnalyticsCookies).AWC_TLD_TEST.getKey();
const $288acdcfb2e394fa$export$19164982d36535d8 = "tld_test";
const $288acdcfb2e394fa$export$de6821eed3d5f32d = (0, $tazez.default)(()=>{
    if (typeof location === "undefined") return "";
    const { hostname: hostname } = location;
    const splitHostname = hostname.split(".");
    for(let i = 1; i <= splitHostname.length; i++){
        const domainParts = splitHostname.slice(i * -1);
        const domain = `.${domainParts.join(".")}`;
        (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).set($288acdcfb2e394fa$export$eb80e1beaa8dacf8, $288acdcfb2e394fa$export$19164982d36535d8, {
            domain: domain
        });
        if ((0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).get($288acdcfb2e394fa$export$eb80e1beaa8dacf8) === $288acdcfb2e394fa$export$19164982d36535d8) {
            (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).remove($288acdcfb2e394fa$export$eb80e1beaa8dacf8, {
                domain: domain
            });
            return domain;
        }
    }
    return hostname;
});

});



parcelRegister("jV8Tw", function(module, exports) {

$parcel$export(module.exports, "buildContext", function () { return $e80a3d76bbee9286$export$3a7fe28f9bf4f3d9; });
$parcel$export(module.exports, "prepareEventProperties", function () { return $e80a3d76bbee9286$export$44d22e5fb02cc68e; });

var $6bkHe = parcelRequire("6bkHe");

var $8BgFy = parcelRequire("8BgFy");
function $e80a3d76bbee9286$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e80a3d76bbee9286$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e80a3d76bbee9286$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e80a3d76bbee9286$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e80a3d76bbee9286$export$3a7fe28f9bf4f3d9 = (context)=>{
    return $e80a3d76bbee9286$var$_objectSpread($e80a3d76bbee9286$var$_objectSpread({}, context.context), {}, {
        userAgent: navigator.userAgent
    });
};
const $e80a3d76bbee9286$export$44d22e5fb02cc68e = (properties)=>{
    const propertiesWithoutUndefined = $e80a3d76bbee9286$export$2250ccecd1e040fd(properties);
    return (0, (/*@__PURE__*/$parcel$interopDefault($8BgFy)))(propertiesWithoutUndefined);
};
const $e80a3d76bbee9286$export$2250ccecd1e040fd = (obj)=>{
    if (obj === null || typeof obj !== "object") return obj;
    const clone = {};
    Object.keys(obj).forEach((key)=>{
        const value = $e80a3d76bbee9286$var$getValueOfObject(obj, key);
        if (value !== undefined) {
            if (Array.isArray(value)) clone[key] = value.map((i)=>$e80a3d76bbee9286$export$2250ccecd1e040fd(i));
            else if (typeof value === "object" && value !== null) clone[key] = $e80a3d76bbee9286$export$2250ccecd1e040fd(value);
            else clone[key] = value;
        }
    });
    return clone;
};
// Using ts-ignore everywhere urked me
const $e80a3d76bbee9286$var$getValueOfObject = (obj, key)=>{
    // @ts-ignore This is an object
    return obj[key];
};

});
parcelRegister("8BgFy", function(module, exports) {
"use strict";

var $fmpz9 = parcelRequire("fmpz9");
/**
 * Expose `traverse`.
 */ module.exports = $642eb59236162e8c$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $642eb59236162e8c$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === "object") return $642eb59236162e8c$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $642eb59236162e8c$var$traverseArray(input, strict);
    else if ($fmpz9.is(input, strict)) return $fmpz9.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $642eb59236162e8c$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $642eb59236162e8c$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $642eb59236162e8c$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $642eb59236162e8c$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("fmpz9", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $b2ecbdf483b1869e$export$98e6a39c04603d36; }, function (v) { return $b2ecbdf483b1869e$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "is", function () { return $b2ecbdf483b1869e$export$226b3eccf92c9ed9; }, function (v) { return $b2ecbdf483b1869e$export$226b3eccf92c9ed9 = v; });
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $b2ecbdf483b1869e$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $b2ecbdf483b1869e$export$226b3eccf92c9ed9;
"use strict";
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $b2ecbdf483b1869e$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$b2ecbdf483b1869e$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $b2ecbdf483b1869e$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + "00").substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === " ") offset = new Date().getTimezoneOffset();
    else if (arr[9] !== "Z" && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === "+") offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$b2ecbdf483b1869e$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== "string") return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $b2ecbdf483b1869e$var$matcher.test(string);
};

});




parcelRegister("arXeP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79ba6078cb3d598f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $6QXdB = parcelRequire("6QXdB");
class $79ba6078cb3d598f$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "handleOriginParameters", (originParamHandlerMapping, historyReplaceFn)=>{
            // Collect all the parameter labels to be handled
            const originParamLabelList = Object.keys(originParamHandlerMapping);
            if (!(originParamLabelList.length > 0)) throw new Error("Empty parameter mapping provided");
            // Check if the parameter labels are valid. If any invalid labels are found throw an exception.
            const invalidParams = originParamLabelList.filter((x)=>Object.values((0, $4cW1f.originTracingType)).indexOf(x) < 0);
            if (invalidParams.length > 0) throw new Error(`Invalid Origin Tracing Parameter(s) supplied: ${invalidParams.join()}!`);
            const isCaptureParam = (_, key)=>originParamLabelList.indexOf(key) >= 0;
            // Capture and remove params from URL
            const capturedURLParams = (0, $6QXdB.default)(isCaptureParam, historyReplaceFn);
            // Apply provided handler function to extract origin trace ID from each URL parameter
            const applyHandlerFunction = (key)=>{
                const x = originParamHandlerMapping[key](capturedURLParams[key]);
                return {
                    [key]: x
                };
            };
            const extractedOriginID = Object.keys(capturedURLParams).map(applyHandlerFunction).reduce((accumulator, currentValue)=>Object.assign(accumulator, currentValue), {});
            return extractedOriginID;
        });
        this._originStore = {};
    }
}

});
parcelRegister("6QXdB", function(module, exports) {

$parcel$export(module.exports, "defaultHistoryReplaceFn", function () { return $4fd588f4b5e1a682$export$600dd5bf1b049f11; });
$parcel$export(module.exports, "default", function () { return $4fd588f4b5e1a682$export$2e2bcd8739ae039; });

var $hUgeU = parcelRequire("hUgeU");

var $dbpk1 = parcelRequire("dbpk1");
const $4fd588f4b5e1a682$export$600dd5bf1b049f11 = (newUrl)=>window.history.replaceState({}, "", newUrl);
const $4fd588f4b5e1a682$var$urlParamExtractor = (isCaptureParam, historyReplaceFn = $4fd588f4b5e1a682$export$600dd5bf1b049f11)=>{
    // Extract target parameters and values from URL if present
    const originalUrl = window.location.href;
    const fragmentHash = window.location.hash;
    const removedFragmentURL = fragmentHash !== "" ? originalUrl.replace(fragmentHash, "") : originalUrl;
    const { url: url, query: query } = (0, $hUgeU.parseUrl)(removedFragmentURL);
    const captureParams = (0, $dbpk1.pickBy)(query, isCaptureParam);
    // Do not modify URL if no matches
    if (Object.keys(captureParams).length > 0) {
        const queryWithoutCaptureParams = (0, $dbpk1.omitBy)(query, isCaptureParam);
        // Replace the URL minus captured parameters
        if (Object.keys(queryWithoutCaptureParams).length > 0) {
            const newUrl = `${url}?${(0, $hUgeU.stringify)(queryWithoutCaptureParams)}${fragmentHash}`;
            historyReplaceFn(newUrl);
        } else historyReplaceFn(`${url}${fragmentHash}`);
    }
    return captureParams;
};
var $4fd588f4b5e1a682$export$2e2bcd8739ae039 = $4fd588f4b5e1a682$var$urlParamExtractor;

});
parcelRegister("hUgeU", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $035d3ae4ecba6f6b$export$f9380c9a627682d3; }, function (v) { return $035d3ae4ecba6f6b$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $035d3ae4ecba6f6b$export$98e6a39c04603d36; }, function (v) { return $035d3ae4ecba6f6b$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $035d3ae4ecba6f6b$export$fac44ee5b035f737; }, function (v) { return $035d3ae4ecba6f6b$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $035d3ae4ecba6f6b$export$7a5253c0f62e0150; }, function (v) { return $035d3ae4ecba6f6b$export$7a5253c0f62e0150 = v; });
$parcel$export(module.exports, "stringifyUrl", function () { return $035d3ae4ecba6f6b$export$a8c1621ea79325d3; }, function (v) { return $035d3ae4ecba6f6b$export$a8c1621ea79325d3 = v; });
$parcel$export(module.exports, "pick", function () { return $035d3ae4ecba6f6b$export$357523c63a2253b9; }, function (v) { return $035d3ae4ecba6f6b$export$357523c63a2253b9 = v; });
var $035d3ae4ecba6f6b$export$f9380c9a627682d3;
var $035d3ae4ecba6f6b$export$98e6a39c04603d36;
var $035d3ae4ecba6f6b$export$fac44ee5b035f737;
var $035d3ae4ecba6f6b$export$7a5253c0f62e0150;
var $035d3ae4ecba6f6b$export$a8c1621ea79325d3;
var $035d3ae4ecba6f6b$export$357523c63a2253b9;
var $035d3ae4ecba6f6b$export$44c361b8ec72ef7f;
"use strict";

var $aG5yl = parcelRequire("aG5yl");

var $lPnyU = parcelRequire("lPnyU");

var $eAj7f = parcelRequire("eAj7f");

var $lREDO = parcelRequire("lREDO");
const $035d3ae4ecba6f6b$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $035d3ae4ecba6f6b$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $035d3ae4ecba6f6b$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            "[",
                            $035d3ae4ecba6f6b$var$encode(index, options),
                            "]=",
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            "[]=",
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            ":list=",
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $035d3ae4ecba6f6b$var$encode(key, options),
                                keyValueSep,
                                $035d3ae4ecba6f6b$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $035d3ae4ecba6f6b$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $035d3ae4ecba6f6b$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $035d3ae4ecba6f6b$var$encode(key, options),
                            "=",
                            $035d3ae4ecba6f6b$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $035d3ae4ecba6f6b$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $035d3ae4ecba6f6b$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $035d3ae4ecba6f6b$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$035d3ae4ecba6f6b$var$decode(item, options)) : value === null ? value : $035d3ae4ecba6f6b$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $035d3ae4ecba6f6b$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$035d3ae4ecba6f6b$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $035d3ae4ecba6f6b$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $035d3ae4ecba6f6b$var$encode(value, options) {
    if (options.encode) return options.strict ? $aG5yl(value) : encodeURIComponent(value);
    return value;
}
function $035d3ae4ecba6f6b$var$decode(value, options) {
    if (options.decode) return $lPnyU(value);
    return value;
}
function $035d3ae4ecba6f6b$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $035d3ae4ecba6f6b$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $035d3ae4ecba6f6b$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $035d3ae4ecba6f6b$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $035d3ae4ecba6f6b$var$extract(input) {
    input = $035d3ae4ecba6f6b$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $035d3ae4ecba6f6b$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $035d3ae4ecba6f6b$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $035d3ae4ecba6f6b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $035d3ae4ecba6f6b$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $eAj7f(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $035d3ae4ecba6f6b$var$decode(value, options);
        formatter($035d3ae4ecba6f6b$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $035d3ae4ecba6f6b$var$parseValue(value[k], options);
        else ret[key] = $035d3ae4ecba6f6b$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $035d3ae4ecba6f6b$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$035d3ae4ecba6f6b$export$f9380c9a627682d3 = $035d3ae4ecba6f6b$var$extract;
$035d3ae4ecba6f6b$export$98e6a39c04603d36 = $035d3ae4ecba6f6b$var$parse;
$035d3ae4ecba6f6b$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $035d3ae4ecba6f6b$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $035d3ae4ecba6f6b$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $035d3ae4ecba6f6b$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $035d3ae4ecba6f6b$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $035d3ae4ecba6f6b$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $035d3ae4ecba6f6b$var$encode(key, options) + "=" + $035d3ae4ecba6f6b$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$035d3ae4ecba6f6b$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $eAj7f(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $035d3ae4ecba6f6b$var$parse($035d3ae4ecba6f6b$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $035d3ae4ecba6f6b$var$decode(hash, options)
    } : {});
};
$035d3ae4ecba6f6b$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$035d3ae4ecba6f6b$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $035d3ae4ecba6f6b$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $035d3ae4ecba6f6b$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $035d3ae4ecba6f6b$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $035d3ae4ecba6f6b$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $035d3ae4ecba6f6b$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$035d3ae4ecba6f6b$var$encodeFragmentIdentifier] ? $035d3ae4ecba6f6b$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$035d3ae4ecba6f6b$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$035d3ae4ecba6f6b$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $035d3ae4ecba6f6b$export$7a5253c0f62e0150(input, options);
    return $035d3ae4ecba6f6b$export$a8c1621ea79325d3({
        url: url,
        query: $lREDO(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$035d3ae4ecba6f6b$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $035d3ae4ecba6f6b$export$357523c63a2253b9(input, exclusionFilter, options);
};

});
parcelRegister("aG5yl", function(module, exports) {
"use strict";
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("lPnyU", function(module, exports) {
"use strict";
var $fe40a35433c4412a$var$token = "%[a-f0-9]{2}";
var $fe40a35433c4412a$var$singleMatcher = new RegExp("(" + $fe40a35433c4412a$var$token + ")|([^%]+?)", "gi");
var $fe40a35433c4412a$var$multiMatcher = new RegExp("(" + $fe40a35433c4412a$var$token + ")+", "gi");
function $fe40a35433c4412a$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $fe40a35433c4412a$var$decodeComponents(left), $fe40a35433c4412a$var$decodeComponents(right));
}
function $fe40a35433c4412a$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($fe40a35433c4412a$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $fe40a35433c4412a$var$decodeComponents(tokens, i).join("");
            tokens = input.match($fe40a35433c4412a$var$singleMatcher) || [];
        }
        return input;
    }
}
function $fe40a35433c4412a$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $fe40a35433c4412a$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $fe40a35433c4412a$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $fe40a35433c4412a$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $fe40a35433c4412a$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("eAj7f", function(module, exports) {
"use strict";
module.exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("lREDO", function(module, exports) {
"use strict";
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});




parcelRegister("eh37k", function(module, exports) {

$parcel$export(module.exports, "selectHost", function () { return $a645123f076c2e80$export$18c0b81944902eae; });

var $4cW1f = parcelRequire("4cW1f");
const $a645123f076c2e80$var$PROD_HOST = "as.atlassian.com/api/v1";
const $a645123f076c2e80$var$STARGATE_PROD_HOST = "api-private.atlassian.com/gasv3/api/v1";
const $a645123f076c2e80$var$STAGING_HOST = "as.staging.atl-paas.net/api/v1";
const $a645123f076c2e80$var$STARGATE_STAGING_HOST = "api-private.stg.atlassian.com/gasv3/api/v1";
const $a645123f076c2e80$var$FEDRAMP_STAGING_HOST = "as.staging.atl-paas-us-gov-mod.net/api/v1";
const $a645123f076c2e80$var$FEDRAMP_PROD_HOST = "as.atlassian-us-gov-mod.com/api/v1";
const $a645123f076c2e80$var$STARGATE_FEDRAMP_STAGING_HOST = "api.stg.atlassian-us-gov-mod.com/gasv3/api/v1";
const $a645123f076c2e80$var$STARGATE_FEDRAMP_PROD_HOST = "api.atlassian-us-gov-mod.com/gasv3/api/v1";
const $a645123f076c2e80$var$STARGATE_PROXY_PATH = "/gateway/api/gasv3/api/v1";
const $a645123f076c2e80$var$handleFedRampStagingDirect = ()=>{
    return $a645123f076c2e80$var$FEDRAMP_STAGING_HOST;
};
const $a645123f076c2e80$var$handleFedRampStagingStargate = ()=>{
    return $a645123f076c2e80$var$STARGATE_FEDRAMP_STAGING_HOST;
};
const $a645123f076c2e80$var$handleFedRampModerate = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, envOverride: envOverride })=>{
    if (env === (0, $4cW1f.envType).LOCAL || env === (0, $4cW1f.envType).DEV) throw Error("No LOCAL or DEV environments for FedRAMP.");
    if (env === (0, $4cW1f.envType).PROD && envOverride) throw Error("Cannot override to FedRAMP Sandbox for Prod.");
    if (!useStargate) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$FEDRAMP_PROD_HOST : $a645123f076c2e80$var$handleFedRampStagingDirect();
    if (useLegacyUrl) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$STARGATE_FEDRAMP_PROD_HOST : $a645123f076c2e80$var$handleFedRampStagingStargate();
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $a645123f076c2e80$var$STARGATE_PROXY_PATH;
};
const $a645123f076c2e80$var$handleCommercial = ({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl })=>{
    if (!useStargate) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$PROD_HOST : $a645123f076c2e80$var$STAGING_HOST;
    if (useLegacyUrl) return env === (0, $4cW1f.envType).PROD ? $a645123f076c2e80$var$STARGATE_PROD_HOST : $a645123f076c2e80$var$STARGATE_STAGING_HOST;
    /**
   * Stargate proxy path now needs to be the default to work around browser restrictions with cookies.
   * For more details, see:
   *  - https://experimentation-platform.atlassian.net/browse/MHD-326, and
   *  - https://hello.atlassian.net/wiki/spaces/I/pages/1217206437/api-private+is+broken+is+your+product+impacted
   */ return window.location.host + $a645123f076c2e80$var$STARGATE_PROXY_PATH;
};
function $a645123f076c2e80$export$18c0b81944902eae({ useStargate: useStargate, env: env, useLegacyUrl: useLegacyUrl, perimeter: perimeter, envOverride: envOverride }) {
    if (perimeter === (0, $4cW1f.perimeterType).FEDRAMP_MODERATE) return $a645123f076c2e80$var$handleFedRampModerate({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl,
        envOverride: envOverride
    });
    return $a645123f076c2e80$var$handleCommercial({
        useStargate: useStargate,
        env: env,
        useLegacyUrl: useLegacyUrl
    });
}

});

parcelRegister("2vX01", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1d4c3e13a419a8d3$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $3wkHk = parcelRequire("3wkHk");
const $1d4c3e13a419a8d3$var$SESSION_ID_STORAGE_KEY = "session.id";
const $1d4c3e13a419a8d3$var$SESSION_EXPIRY_STORAGE_KEY = "session.expiry";
const $1d4c3e13a419a8d3$var$ONLY_NUMBERS_REGEX = /^\d+$/;
const $1d4c3e13a419a8d3$export$285f6bddd927a06d = 1800000; // 30 minutes
const $1d4c3e13a419a8d3$export$a92e915d70316eb2 = 5000; // 5 seconds
const $1d4c3e13a419a8d3$export$de43760b2dc10c19 = 0.9; // 90% of expiry
const $1d4c3e13a419a8d3$export$5702a91a6f42969f = ()=>{};
class $1d4c3e13a419a8d3$export$2e2bcd8739ae039 {
    getCurrentSessionId() {
        const sessionId = this._safeLocalStorage.getItem($1d4c3e13a419a8d3$var$SESSION_ID_STORAGE_KEY);
        const sessionExpiry = parseInt(this._safeLocalStorage.getItem($1d4c3e13a419a8d3$var$SESSION_EXPIRY_STORAGE_KEY) || "0", 10) || 0;
        this._debouncedUpdateSessionExpiry(sessionExpiry);
        if (!sessionId || sessionExpiry <= Date.now() || Number.isNaN(sessionExpiry)) return this._generateNewSessionId();
        // Old versions of sessionId were UUIDs which caused issues for Amplitude which only accepts
        // integers for this field. In these scenarios we want to regenerate the sessionId as an integer
        if (!$1d4c3e13a419a8d3$var$ONLY_NUMBERS_REGEX.test(sessionId)) return this._generateNewSessionId();
        return sessionId;
    }
    constructor(options = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_generateNewSessionId", ()=>{
            const newSessionId = Date.now().toString();
            this._safeLocalStorage.setItem($1d4c3e13a419a8d3$var$SESSION_ID_STORAGE_KEY, newSessionId);
            // COMMENTS-123 - When a new session starts, call the callback if it is given
            this._onNewSessionStarted && this._onNewSessionStarted();
            return newSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_updateSessionExpiry", ()=>{
            const expiry = Date.now() + this._sessionExpiryTime;
            this._safeLocalStorage.setItem($1d4c3e13a419a8d3$var$SESSION_EXPIRY_STORAGE_KEY, expiry.toString());
            return expiry;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_debouncedUpdateSessionExpiry", (currentExpiry)=>{
            const { _updateSessionExpiry: _updateSessionExpiry } = this;
            // If the current expiry is out of date by more than 10% of the expiry, update immediately
            if (currentExpiry < Date.now() + this._sessionExpiryDebounceThresholdPercentage * this._sessionExpiryTime) return _updateSessionExpiry();
            else {
                if (this._sessionExpiryDebounceTimer) clearTimeout(this._sessionExpiryDebounceTimer);
                // @ts-ignore Something wrong with our types... this is legit
                this._sessionExpiryDebounceTimer = setTimeout(()=>{
                    _updateSessionExpiry();
                }, this._sessionExpiryDebounce);
            }
        });
        this._sessionExpiryTime = options.sessionExpiryTime || $1d4c3e13a419a8d3$export$285f6bddd927a06d;
        this._sessionExpiryDebounce = options.sessionExpiryDebounce || $1d4c3e13a419a8d3$export$a92e915d70316eb2;
        this._sessionExpiryDebounceThresholdPercentage = options.sessionExpiryDebounceThresholdPercentage || $1d4c3e13a419a8d3$export$de43760b2dc10c19;
        this._onNewSessionStarted = options.onNewSessionStarted ? options.onNewSessionStarted : $1d4c3e13a419a8d3$export$5702a91a6f42969f;
        this._safeLocalStorage = new (0, $3wkHk.default)();
    }
}

});

parcelRegister("gErWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0320df34060cc310$export$2e2bcd8739ae039; });

var $gukCd = parcelRequire("gukCd");

var $dRrH7 = parcelRequire("dRrH7");
class $0320df34060cc310$export$2e2bcd8739ae039 extends (0, $dRrH7.default) {
    constructor(options){
        let storageToUse;
        try {
            storageToUse = window.sessionStorage || (0, $gukCd.default);
        } catch (err) {
            storageToUse = (0, $gukCd.default);
        }
        super(storageToUse, options);
    }
}

});

parcelRegister("ce60p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e6b7369ddd5fc3f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $gaCcd = parcelRequire("gaCcd");

var $gErWv = parcelRequire("gErWv");
const $8e6b7369ddd5fc3f$var$STORAGE_KEY = "tab.id";
class $8e6b7369ddd5fc3f$export$2e2bcd8739ae039 {
    getCurrentTabId() {
        let tabId = this._safeSessionStorage.getItem($8e6b7369ddd5fc3f$var$STORAGE_KEY);
        if (!tabId) tabId = this._generateNewTabId();
        return tabId;
    }
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_generateNewTabId", ()=>{
            const newTabId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
            this._safeSessionStorage.setItem($8e6b7369ddd5fc3f$var$STORAGE_KEY, newTabId);
            return newTabId;
        });
        this._safeSessionStorage = new (0, $gErWv.default)();
    }
}

});

parcelRegister("dtn8z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9cefee5cfd893684$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $hUgeU = parcelRequire("hUgeU");

var $gaCcd = parcelRequire("gaCcd");

var $4cW1f = parcelRequire("4cW1f");

var $dbpk1 = parcelRequire("dbpk1");

var $gErWv = parcelRequire("gErWv");

var $6QXdB = parcelRequire("6QXdB");
function $9cefee5cfd893684$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9cefee5cfd893684$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9cefee5cfd893684$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9cefee5cfd893684$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9cefee5cfd893684$var$STORAGE_KEY = "taskSessions";
const $9cefee5cfd893684$var$INIT_KEY = "taskSessionsInit";
const $9cefee5cfd893684$var$AWC_PARAM_PREFIX = "awc.";
const $9cefee5cfd893684$var$TASK_SESSION_RELOAD_TIME = 3000;
class $9cefee5cfd893684$export$2e2bcd8739ae039 {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_taskSessionsNotRecentlyInitialised", (currentTimestamp)=>this._safeSessionStorage.getItem($9cefee5cfd893684$var$STORAGE_KEY) === null || this._safeSessionStorage.getItem($9cefee5cfd893684$var$INIT_KEY) === null || parseInt(this._safeSessionStorage.getItem($9cefee5cfd893684$var$INIT_KEY) || "0", 10) < currentTimestamp - $9cefee5cfd893684$var$TASK_SESSION_RELOAD_TIME);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_removeTaskSessionPrefix", (_, taskSessionName)=>taskSessionName.split($9cefee5cfd893684$var$AWC_PARAM_PREFIX)[1]);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_isTaskSessionQueryParam", (_, taskSessionName)=>taskSessionName.startsWith($9cefee5cfd893684$var$AWC_PARAM_PREFIX));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getAllTaskSessions", ()=>{
            try {
                return JSON.parse(this._safeSessionStorage.getItem($9cefee5cfd893684$var$STORAGE_KEY) || "");
            } catch (e) {
                return {};
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_writeToSessionStorage", (taskSessions)=>{
            try {
                this._safeSessionStorage.setItem($9cefee5cfd893684$var$STORAGE_KEY, JSON.stringify(taskSessions));
            // eslint-disable-next-line no-empty
            } catch (e) {}
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_appendTaskSessions", (newTaskSessions)=>{
            const currentState = this.getAllTaskSessions();
            const newState = currentState === null ? newTaskSessions : Object.assign(currentState, newTaskSessions);
            this._writeToSessionStorage(newState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_safelyRemoveKey", (currentState, taskSessionName)=>{
            if (currentState === null) return {};
            delete currentState[taskSessionName];
            return currentState;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createTaskSession", (taskSessionName)=>{
            const taskSessionId = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
            return taskSessionId;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "createTaskSessionWithProvidedId", (taskSessionName, taskSessionId)=>{
            if (typeof taskSessionId !== "string") throw new TypeError("invalid taskSessionId, must be string");
            const newTaskSessions = {};
            newTaskSessions[taskSessionName] = taskSessionId;
            this._appendTaskSessions(newTaskSessions);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "completeTaskSession", (taskSessionName)=>{
            const currentState = this.getAllTaskSessions();
            const updatedState = this._safelyRemoveKey(currentState, taskSessionName);
            this._writeToSessionStorage(updatedState);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "formatTaskSessionQueryString", ({ uri: uri, includedTaskSessions: includedTaskSessions })=>{
            const { url: url, query: query } = (0, $hUgeU.parseUrl)(uri);
            const currentState = this.getAllTaskSessions();
            // Use specified task sessions, otherwise all tasksessions excluding originTracing sessions
            const filteredTaskSessions = includedTaskSessions ? (0, $dbpk1.pick)(currentState, includedTaskSessions) : (0, $dbpk1.omit)(currentState, Object.values((0, $4cW1f.originTracingType)));
            if (Object.keys(filteredTaskSessions).length === 0) return uri;
            const queryWithTaskSessions = $9cefee5cfd893684$var$_objectSpread($9cefee5cfd893684$var$_objectSpread({}, (0, $dbpk1.mapKeys)(filteredTaskSessions, (_, taskSessionName)=>$9cefee5cfd893684$var$AWC_PARAM_PREFIX + taskSessionName)), query);
            return `${url}?${(0, $hUgeU.stringify)(queryWithTaskSessions)}`;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stripQueryParameters", ()=>{
            const extractedTaskSessions = (0, $dbpk1.mapKeys)((0, $6QXdB.default)(this._isTaskSessionQueryParam), this._removeTaskSessionPrefix);
            this._appendTaskSessions(extractedTaskSessions);
        });
        const _currentTimestamp = Date.now();
        this._safeSessionStorage = new (0, $gErWv.default)();
        // Wrapping all sessionStorage calls in try catch to stop any error propogation, taskSessions should gracefully fail.
        try {
            if (this._taskSessionsNotRecentlyInitialised(_currentTimestamp)) {
                this._writeToSessionStorage({});
                this._safeSessionStorage.setItem($9cefee5cfd893684$var$INIT_KEY, _currentTimestamp.toString());
            }
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}

});

parcelRegister("dRf7A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $029a83f13071ad40$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8USlx = parcelRequire("8USlx");

var $1zj8U = parcelRequire("1zj8U");
const $029a83f13071ad40$var$MAX_CACHE_SIZE = 100;
const $029a83f13071ad40$var$COOKIE_NAME = (0, $1zj8U.AllAnalyticsCookies).AWC_ANALYTICS_DEBUG.getKey();
const $029a83f13071ad40$var$DEBUG_TAG = "synthetic";
const $029a83f13071ad40$var$getDebugCookie = ()=>{
    try {
        return JSON.parse((0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).get($029a83f13071ad40$var$COOKIE_NAME) || "false");
    } catch (error) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).remove($029a83f13071ad40$var$COOKIE_NAME);
    }
    return false;
};
class $029a83f13071ad40$var$TestingCache {
    constructor(){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_bind", ()=>{
            if (typeof window === "undefined" || window.testAnalytics) return;
            window.testAnalytics = {
                eventCache: [],
                events: ()=>window.testAnalytics.eventCache,
                clear: ()=>{
                    window.testAnalytics.eventCache = [];
                    try {
                        localStorage.removeItem("awc.ui.viewed.last.sent");
                        localStorage.removeItem("awc-staging.ui.viewed.last.sent");
                        localStorage.removeItem("awc-dev.ui.viewed.last.sent");
                        localStorage.removeItem("awc-local.ui.viewed.last.sent");
                    } catch (_error) {
                    // Ignore errors from localStorage.
                    }
                }
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_cache", (event)=>{
            if (typeof window === "undefined") return;
            if (window.testAnalytics.eventCache.length >= $029a83f13071ad40$var$MAX_CACHE_SIZE) window.testAnalytics.eventCache = window.testAnalytics.eventCache.slice(1, window.testAnalytics.eventCache.length);
            window.testAnalytics.eventCache.push(event);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldCacheEvent", ()=>this._isDebugCookieEnabled);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "saveEvent", (event)=>{
            if (event && this._shouldCacheEvent()) {
                if (!window.testAnalytics) this._bind();
                if (event.tags instanceof Array) event.tags.push($029a83f13071ad40$var$DEBUG_TAG);
                else event.tags = [
                    $029a83f13071ad40$var$DEBUG_TAG
                ];
                this._cache(event);
            }
        });
        this._isDebugCookieEnabled = $029a83f13071ad40$var$getDebugCookie();
        if (this._isDebugCookieEnabled) this._bind();
    }
}
var $029a83f13071ad40$export$2e2bcd8739ae039 = $029a83f13071ad40$var$TestingCache;

});

parcelRegister("5E2Q9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41c2e42e71f4882a$export$2e2bcd8739ae039; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $6bkHe = parcelRequire("6bkHe");

var $4cW1f = parcelRequire("4cW1f");

var $3wkHk = parcelRequire("3wkHk");
const $41c2e42e71f4882a$var$_excluded = [
    "embeddedProduct"
];
function $41c2e42e71f4882a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $41c2e42e71f4882a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $41c2e42e71f4882a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $41c2e42e71f4882a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $41c2e42e71f4882a$var$DEFAULT_DELAY = 2000; // 2 seconds
const $41c2e42e71f4882a$var$DEFAULT_THROTTLE = 3600000; // 1 hour
const $41c2e42e71f4882a$var$DEFAULT_STORAGE_KEY = "ui.viewed.last.sent";
class $41c2e42e71f4882a$export$2e2bcd8739ae039 {
    constructor(productInfo, getContext, onEvent, settings = {}){
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "start", ()=>{
            this._startInterval();
            this._bindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stop", ()=>{
            this._stopInterval();
            this._unbindEventListeners();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "resetTimers", ()=>{
            if (this._intervalId) {
                this.stop();
                this.start();
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_bindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.addEventListener("focus", this._focusListener);
                window.addEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_unbindEventListeners", ()=>{
            if (typeof window !== "undefined") {
                window.removeEventListener("focus", this._focusListener);
                window.removeEventListener("blur", this._blurListener);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_startInterval", ()=>{
            clearInterval(this._intervalId);
            this._intervalId = setInterval(this._handleInterval, this._delay);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_stopInterval", ()=>{
            if (this._intervalId) {
                clearInterval(this._intervalId);
                this._intervalId = null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getProductKey", (product, subproduct)=>{
            let productKey = product;
            if (subproduct) productKey += `-${subproduct}`;
            return productKey;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_getLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            const p = t[productKey] || null;
            return p;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_parseLocalStorageData", ()=>{
            const data = this._safeLocalStorage.getItem(this._storageKey);
            try {
                return JSON.parse(data || "");
            } catch (error) {
                this._safeLocalStorage.removeItem(this._storageKey);
                return null;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_setLastSentTimestamp", (productKey, tenantId, userId)=>{
            const json = this._parseLocalStorageData() || {};
            const u = json[userId] || {};
            const t = u[tenantId] || {};
            t[productKey] = Date.now();
            u[tenantId] = t;
            json[userId] = u;
            this._safeLocalStorage.setItem(this._storageKey, JSON.stringify(json));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_shouldSendEvent", (productKey, tenantIdType, tenantId, userId)=>{
            if (!document.hasFocus()) return false;
            if (tenantIdType !== (0, $4cW1f.tenantType).NONE && !tenantId || !userId) return false;
            const sinceLastSent = Date.now() - this._getLastSentTimestamp(productKey, tenantId, userId);
            return sinceLastSent > this._throttle;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_handleInterval", ()=>{
            const _this$_getContext = this._getContext(), { embeddedProduct: embeddedProduct } = _this$_getContext, context = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_this$_getContext, $41c2e42e71f4882a$var$_excluded);
            this._sendEvent(this._product, context);
            if (embeddedProduct) this._sendEvent(embeddedProduct, context, true);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_sendEvent", (product, context, isEmbeddedProduct = false)=>{
            const { subproduct: subproduct, tenantIdType: tenantIdType, tenantId: tenantId, userId: userId, lastScreenEvent: lastScreenEvent, attributes: attributes } = context;
            const productKey = this._getProductKey(product, subproduct);
            if (this._shouldSendEvent(productKey, tenantIdType, tenantId, userId)) {
                this._setLastSentTimestamp(productKey, tenantId, userId);
                const event = this._createEvent(product, subproduct, isEmbeddedProduct, lastScreenEvent, attributes);
                this._onEvent(event);
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_createEvent", (product, subproduct, isEmbeddedProduct, lastScreenEvent, extraAttributes)=>{
            const event = {
                product: product,
                source: "ui",
                action: "viewed",
                actionSubject: "ui",
                attributes: extraAttributes
            };
            if (isEmbeddedProduct) {
                // Clear the subproduct and version as they don't relate to the embedded product
                event.subproduct = null;
                event.version = null;
                event.attributes = $41c2e42e71f4882a$var$_objectSpread($41c2e42e71f4882a$var$_objectSpread({}, event.attributes), {}, {
                    embeddedInEnv: this._productInfo.env,
                    embeddedInProduct: this._productInfo.product,
                    embeddedInSubproduct: subproduct,
                    embeddedInVersion: this._productInfo.version,
                    embeddedInOrigin: this._productInfo.origin,
                    embeddedInPlatform: this._productInfo.platform
                });
            }
            if (lastScreenEvent) event.attributes = $41c2e42e71f4882a$var$_objectSpread($41c2e42e71f4882a$var$_objectSpread({}, event.attributes), {}, {
                lastScreenEvent: {
                    name: lastScreenEvent.name,
                    attributes: lastScreenEvent.attributes
                }
            });
            return event;
        });
        if (!productInfo) throw new Error("Missing productInfo");
        if (!productInfo.product) throw new Error("Missing productInfo.product");
        if (!getContext) throw new Error("Missing getContext callback");
        if (typeof getContext !== "function") throw new Error("Invalid getContext, must be function");
        if (!onEvent) throw new Error("Missing onEvent callback");
        if (typeof onEvent !== "function") throw new Error("Invalid onEvent, must be function");
        this._productInfo = productInfo;
        this._product = productInfo.product;
        this._getContext = getContext;
        this._onEvent = onEvent;
        this._delay = settings.delay || $41c2e42e71f4882a$var$DEFAULT_DELAY;
        this._throttle = settings.throttle || $41c2e42e71f4882a$var$DEFAULT_THROTTLE;
        this._storageKey = settings.storageKey || $41c2e42e71f4882a$var$DEFAULT_STORAGE_KEY;
        this._safeLocalStorage = new (0, $3wkHk.default)({
            envPrefix: this._productInfo.env
        });
        this._focusListener = ()=>{
            this._startInterval();
        };
        this._blurListener = ()=>{
            this._stopInterval();
        };
    }
}

});

parcelRegister("ctYUa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91676fe72e7d292e$export$2e2bcd8739ae039; });
function $91676fe72e7d292e$export$2e2bcd8739ae039(callback, event) {
    if (!callback || typeof callback !== "function") return null;
    return ()=>{
        callback(event);
    };
}

});

parcelRegister("fBSnV", function(module, exports) {

$parcel$export(module.exports, "XIDPromise", function () { return $b5d47f6dcd743d47$export$fbe53bbbe682bcdd; });

var $h7Mqs = parcelRequire("h7Mqs");
const $b5d47f6dcd743d47$export$fbe53bbbe682bcdd = (xidConsent, xidPromiseFn)=>{
    if (xidConsent && xidPromiseFn && typeof xidPromiseFn === "function") {
        const timeoutPromise = ()=>{
            return new Promise((resolve)=>{
                setTimeout(()=>resolve(()=>(0, $h7Mqs.createTimeoutXid)()), (0, $h7Mqs.XID_TIMEOUT));
            });
        };
        const xidPromise = ()=>{
            return xidPromiseFn().catch(()=>()=>(0, $h7Mqs.createUnknownXid)());
        };
        return Promise.race([
            xidPromise(),
            timeoutPromise()
        ]);
    }
    return undefined;
};

});
parcelRegister("h7Mqs", function(module, exports) {

$parcel$export(module.exports, "XID_TIMEOUT", function () { return $c778a7722e8a548b$export$545bcbd53afabfa3; });
$parcel$export(module.exports, "createTimeoutXid", function () { return $c778a7722e8a548b$export$af4087e36d63846; });
$parcel$export(module.exports, "createUnknownXid", function () { return $c778a7722e8a548b$export$fa341d0c750d705b; });

var $2Z6zh = parcelRequire("2Z6zh");
const $c778a7722e8a548b$export$545bcbd53afabfa3 = 5000;
const $c778a7722e8a548b$export$af4087e36d63846 = ()=>[
        {
            type: (0, $2Z6zh.XIDItemType).XC,
            state: "TIMEOUT"
        },
        {
            type: (0, $2Z6zh.XIDItemType).UID,
            state: "TIMEOUT"
        }
    ];
const $c778a7722e8a548b$export$fa341d0c750d705b = ()=>[
        {
            type: (0, $2Z6zh.XIDItemType).XC,
            state: "UNKNOWN"
        },
        {
            type: (0, $2Z6zh.XIDItemType).UID,
            state: "UNKNOWN"
        }
    ];

});
parcelRegister("2Z6zh", function(module, exports) {

$parcel$export(module.exports, "XIDItemType", function () { return $22c65f8e00aa90a1$export$92ca0438bcb0d396; });
let $22c65f8e00aa90a1$export$92ca0438bcb0d396 = /*#__PURE__*/ function(XIDItemType) {
    XIDItemType["XC"] = "xc";
    XIDItemType["UID"] = "uid";
    return XIDItemType;
}({});
let $22c65f8e00aa90a1$export$c9079017d1f5aab9 = /*#__PURE__*/ function(XIDState) {
    XIDState["NEW"] = "NEW";
    XIDState["CHANGED"] = "CHANGED";
    XIDState["EXISTING"] = "EXISTING";
    XIDState["TIMEOUT"] = "TIMEOUT";
    XIDState["ERROR"] = "ERROR";
    XIDState["UNAVAILABLE"] = "UNAVAILABLE";
    XIDState["MALFORMED"] = "MALFORMED";
    XIDState["UNKNOWN"] = "UNKNOWN";
    return XIDState;
}({});

});




parcelRegister("fvOZR", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // identity function for calling harmony imports with the correct context
        /******/ __webpack_require__.i = function(value) {
            return value;
        };
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                /******/ configurable: false,
                /******/ enumerable: true,
                /******/ get: getter
            });
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = 7);
    /******/ }([
        /* 0 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var GAS_BULK_URL = exports.GAS_BULK_URL = "https://mgas.prod.public.atl-paas.net/v1/events";
            var CLOUD_ANALYTICS_URL = exports.CLOUD_ANALYTICS_URL = "/rest/analytics/1.0/publish/bulk";
            var CONFLUENCE_URL_PREFIX = exports.CONFLUENCE_URL_PREFIX = "/wiki";
            var BATCH_INTERVAL_MS = exports.BATCH_INTERVAL_MS = 5000;
        /***/ },
        /* 1 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var SafeString = exports.SafeString = function SafeString(value) {
                var _this = this;
                _classCallCheck(this, SafeString);
                this.value = value;
                this.valueOf = this.toString = this.toJSON = function() {
                    return _this.value;
                };
            };
            /**
 * Use this when you explicitly need to collect user entered data. Such as NPS survey responses.
 * @param value
 */ var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = function dangerouslyCreateSafeString(value) {
                return new SafeString(value);
            };
            var isSafeString = exports.isSafeString = function isSafeString(value) {
                return value instanceof SafeString;
            };
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {Array} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString}
 */ var markAsSafe = exports.markAsSafe = function markAsSafe() {
                for(var _len = arguments.length, allowedStrings = Array(_len), _key = 0; _key < _len; _key++)allowedStrings[_key] = arguments[_key];
                return function(value) {
                    return allowedStrings.includes(value) ? Object.freeze(new SafeString(value)) : value;
                };
            };
        /***/ },
        /* 2 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.BaseAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
                return typeof obj;
            } : function(obj) {
                return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _Beacon = __webpack_require__(8);
            var _PrivacySafeString = __webpack_require__(1);
            var _AnalyticsLogger = __webpack_require__(9);
            var _AnalyticsLogger2 = _interopRequireDefault(_AnalyticsLogger);
            function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                    default: obj
                };
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var isNumberOrNumericString = function isNumberOrNumericString(value) {
                return !isNaN(value);
            };
            var isNull = function isNull(value) {
                return value === null;
            };
            var isBoolean = function isBoolean(value) {
                return value === true || value === false;
            };
            /**
 * Is of a type that will not reveal any PII
 * OR
 * is explicitly marked as being safe of PII
 * @param value
 */ var isPrivacySafe = function isPrivacySafe(value) {
                return isNull(value) || isBoolean(value) || isNumberOrNumericString(value) || (0, _PrivacySafeString.isSafeString)(value);
            };
            /**
 * Extend this to include "whitelisted" keys where the values will be deemed safe
 * @param key
 */ var isPrivacySafeAttributeKey = function isPrivacySafeAttributeKey(key) {
                return key === "spaceKey";
            };
            /*eslint no-unused-vars: ["error", { "argsIgnorePattern": "name|properties|events" }]*/ /**
 * Abstract analytics client implementation
 */ var BaseAnalytics = exports.BaseAnalytics = function() {
                function BaseAnalytics() {
                    var _this = this;
                    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    _classCallCheck(this, BaseAnalytics);
                    this.eventPrefix = options.eventPrefix || "";
                    this.devMode = options.devMode;
                    this.batch_interval_ms = options.batchIntervalMs || _default.BATCH_INTERVAL_MS;
                    this.options = options;
                    this._requestQueue = [];
                    if (typeof window !== "undefined" && window.addEventListener) window.addEventListener("unload", function() {
                        _this.handlePageUnload();
                    });
                }
                _createClass(BaseAnalytics, [
                    {
                        key: "url",
                        value: function url() {
                            throw new Error("override url()");
                        }
                    },
                    {
                        key: "createRequest",
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            throw new Error("You must override createRequest().");
                        }
                    },
                    {
                        key: "trigger",
                        value: function trigger(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                                immediate: false
                            };
                            if (!name) throw new Error("Name must be provided when sending an event.");
                            var eventName = "" + (this.eventPrefix ? this.eventPrefix + "." : "") + name;
                            var request = this.createRequest(eventName, this.sanitizeAnalyticsData(properties));
                            if (this.devMode) _AnalyticsLogger2.default.log(JSON.stringify(request, null, 2));
                            if (options.immediate) this.sendEventsToRemote([
                                request
                            ]);
                            else {
                                this.pushToQueue(request);
                                this.startInterval();
                            }
                        }
                    },
                    {
                        key: "setQueue",
                        value: function setQueue(newQueue) {
                            this._requestQueue = newQueue;
                        }
                    },
                    {
                        key: "getQueue",
                        value: function getQueue() {
                            return this._requestQueue;
                        }
                    },
                    {
                        key: "pushToQueue",
                        value: function pushToQueue(request) {
                            this.getQueue().push(request);
                        }
                    },
                    {
                        key: "processQueue",
                        value: function processQueue() {
                            var events = this.getQueue().splice(0);
                            if (events.length > 0) this.sendEventsToRemote(events);
                        }
                    },
                    {
                        key: "handlePageUnload",
                        value: function handlePageUnload() {
                            this.processQueue();
                            this.stopInterval();
                        }
                    },
                    {
                        key: "startInterval",
                        value: function startInterval() {
                            var _this2 = this;
                            if (typeof this._intervalId === "number") return;
                            this._intervalId = setInterval(function() {
                                return _this2.processQueue();
                            }, this.batch_interval_ms);
                        }
                    },
                    {
                        key: "stopInterval",
                        value: function stopInterval() {
                            if (typeof this._intervalId === "number") {
                                clearInterval(this._intervalId);
                                this._intervalId = null;
                            }
                        }
                    },
                    {
                        key: "emptyQueue",
                        value: function emptyQueue() {
                            this._requestQueue = [];
                        }
                    },
                    {
                        key: "sendEventsToRemote",
                        value: function sendEventsToRemote(events) {
                            var payload = this.constructor.createPayload(events);
                            if (this.devMode) {
                                _AnalyticsLogger2.default.log("sending " + events.length + " events.");
                                return;
                            }
                            var successfullyQueued = false;
                            if (_Beacon.Beacon.isSupported()) successfullyQueued = _Beacon.Beacon.sendAsJson(this.url(), payload);
                            if (!successfullyQueued) this.doPost(payload);
                        }
                    },
                    {
                        key: "doPost",
                        value: function doPost(postBody) {
                            var xhr = void 0;
                            if (typeof window !== "undefined" && window.XMLHttpRequest) // IE7+, Firefox, Chrome, Opera, Safari
                            xhr = new window.XMLHttpRequest();
                            else return;
                            xhr.open("POST", this.url(), true);
                            if (typeof xhr.setRequestHeader !== "undefined") {
                                xhr.setRequestHeader("Content-Type", "application/json");
                                xhr.setRequestHeader("Accept", "application/json, text/javascript, */*;");
                            }
                            var decoratedPostBody = this.decorateEventsWithType(postBody);
                            xhr.send(JSON.stringify(decoratedPostBody));
                        }
                    },
                    {
                        key: "decorateEventsWithType",
                        value: function decorateEventsWithType(postBody) {
                            return postBody.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                        }
                    },
                    {
                        key: "sanitizeAnalyticsData",
                        value: function sanitizeAnalyticsData(data) {
                            var _this3 = this;
                            if (isNull(data) || typeof data === "undefined") return data;
                            if ((typeof data === "undefined" ? "undefined" : _typeof(data)) !== "object") return {};
                            // return the data with privacy unsafe data filtered out
                            return Object.keys(data).reduce(function(filteredData, key) {
                                var value = data[key];
                                if (isPrivacySafeAttributeKey(key) || isPrivacySafe(value)) filteredData[key] = value;
                                else if (_this3.devMode) _AnalyticsLogger2.default.warn("Stripping out potentially privacy-unsafe analytics attribute: '" + key + "' -> '" + value + "'");
                                return filteredData;
                            }, {});
                        }
                    },
                    {
                        key: "updateOptions",
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                        }
                    }
                ], [
                    {
                        key: "createPayload",
                        value: function createPayload(events) {
                            throw new Error("You must override createPayload().");
                        }
                    }
                ]);
                return BaseAnalytics;
            }();
        /***/ },
        /* 3 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.CloudAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Common code for cloud, shared by JiraAnalytics and ConfluenceAnalytics
 */ var CloudAnalytics = exports.CloudAnalytics = function(_BaseAnalytics) {
                _inherits(CloudAnalytics, _BaseAnalytics);
                function CloudAnalytics() {
                    _classCallCheck(this, CloudAnalytics);
                    return _possibleConstructorReturn(this, (CloudAnalytics.__proto__ || Object.getPrototypeOf(CloudAnalytics)).apply(this, arguments));
                }
                _createClass(CloudAnalytics, [
                    {
                        key: "createRequest",
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                properties: properties,
                                serverTime: Date.now()
                            };
                        }
                    }
                ], [
                    {
                        key: "createPayload",
                        value: function createPayload(events) {
                            return this.adjustEventTimings(events);
                        }
                    },
                    {
                        key: "adjustEventTimings",
                        value: function adjustEventTimings(events) {
                            var now = Date.now();
                            return events.map(function(event) {
                                return {
                                    name: event.name,
                                    properties: event.properties,
                                    timeDelta: event.serverTime - now
                                };
                            });
                        }
                    }
                ]);
                return CloudAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 4 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.ConfluenceAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for Confluence
 * Defaults to /wiki
 */ var ConfluenceAnalytics = exports.ConfluenceAnalytics = function(_CloudAnalytics) {
                _inherits(ConfluenceAnalytics, _CloudAnalytics);
                function ConfluenceAnalytics() {
                    _classCallCheck(this, ConfluenceAnalytics);
                    return _possibleConstructorReturn(this, (ConfluenceAnalytics.__proto__ || Object.getPrototypeOf(ConfluenceAnalytics)).apply(this, arguments));
                }
                _createClass(ConfluenceAnalytics, [
                    {
                        key: "url",
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname + _default.CONFLUENCE_URL_PREFIX;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return ConfluenceAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 5 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.GasAnalytics = undefined;
            var _extends = Object.assign || function(target) {
                for(var i = 1; i < arguments.length; i++){
                    var source = arguments[i];
                    for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
                }
                return target;
            };
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _BaseAnalytics2 = __webpack_require__(2);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for the GAS API ({@link https://extranet.atlassian.com/display/MOD/Public+Analytics+aka+GAS})
 */ var GasAnalytics = exports.GasAnalytics = function(_BaseAnalytics) {
                _inherits(GasAnalytics, _BaseAnalytics);
                /**
    * @constructor
    * @param {object} options - Required: server, product, user.
    */ function GasAnalytics(options) {
                    _classCallCheck(this, GasAnalytics);
                    var _this = _possibleConstructorReturn(this, (GasAnalytics.__proto__ || Object.getPrototypeOf(GasAnalytics)).call(this, options));
                    if (!options.server) throw new Error("You must specify a GAS server value.");
                    if (!options.product) throw new Error("You must specify a GAS product value.");
                    if (!options.user && !options.user_id) throw new Error("You must specify a GAS user or user_id value.");
                    return _this;
                }
                _createClass(GasAnalytics, [
                    {
                        key: "url",
                        value: function url() {
                            return _default.GAS_BULK_URL;
                        }
                    },
                    {
                        key: "createRequest",
                        value: function createRequest(name) {
                            var properties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                            return {
                                name: name,
                                server: this.options.server,
                                product: this.options.product,
                                user: this.options.user,
                                serverTime: Date.now(),
                                cloud_id: this.options.cloud_id || null,
                                user_id: this.options.user_id || null,
                                user_id_type: this.options.user_id_type || null,
                                properties: properties
                            };
                        }
                    },
                    {
                        key: "decorateEventsWithType",
                        value: function decorateEventsWithType(postBody) {
                            if (!postBody.events) return;
                            postBody.events = postBody.events.map(function(event) {
                                event.properties = event.properties || {};
                                event.properties._type = "xhr";
                                return event;
                            });
                            return postBody;
                        }
                    },
                    {
                        key: "updateOptions",
                        value: function updateOptions(newOptions) {
                            this.options = _extends({}, this.options, newOptions);
                            this.setQueue(this.getQueue().map(function(queuedEvent) {
                                return _extends({}, queuedEvent, newOptions);
                            }));
                        }
                    }
                ], [
                    {
                        key: "createPayload",
                        value: function createPayload(events) {
                            return {
                                events: events
                            };
                        }
                    }
                ]);
                return GasAnalytics;
            }(_BaseAnalytics2.BaseAnalytics);
        /***/ },
        /* 6 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.JiraAnalytics = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _default = __webpack_require__(0);
            var _CloudAnalytics2 = __webpack_require__(3);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            function _possibleConstructorReturn(self, call) {
                if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return call && (typeof call === "object" || typeof call === "function") ? call : self;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
            }
            /**
 * Analytics client for JIRA
 */ var JiraAnalytics = exports.JiraAnalytics = function(_CloudAnalytics) {
                _inherits(JiraAnalytics, _CloudAnalytics);
                function JiraAnalytics() {
                    _classCallCheck(this, JiraAnalytics);
                    return _possibleConstructorReturn(this, (JiraAnalytics.__proto__ || Object.getPrototypeOf(JiraAnalytics)).apply(this, arguments));
                }
                _createClass(JiraAnalytics, [
                    {
                        key: "url",
                        /**
     * Override if context path changes
     * @param baseUrl
     * @returns {string}
     */ value: function url() {
                            var baseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.location.hostname;
                            return baseUrl + _default.CLOUD_ANALYTICS_URL;
                        }
                    }
                ]);
                return JiraAnalytics;
            }(_CloudAnalytics2.CloudAnalytics);
        /***/ },
        /* 7 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports.dangerouslyCreateSafeString = exports.isSafeString = exports.markAsSafe = undefined;
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            var _GasAnalytics = __webpack_require__(5);
            var _JiraAnalytics = __webpack_require__(6);
            var _ConfluenceAnalytics = __webpack_require__(4);
            var _PrivacySafeString = __webpack_require__(1);
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            /**
 * Get singleton Analytics Client that is appropriate for your product or app.
 */ var AnalyticsClientFactory = function() {
                function AnalyticsClientFactory() {
                    _classCallCheck(this, AnalyticsClientFactory);
                }
                _createClass(AnalyticsClientFactory, [
                    {
                        key: "getGasClient",
                        /**
     * Get a Gas Analytics Client.
     * @param {object} options - {
     *  server: "String - required",
     *  product: "String - required",
     *  user: "String - required",
     *  eventPrefix: "String - optional - default: ''",
     *  devMode: "Boolean - optional - default: false",
     *  batchIntervalMs: "Integer - optional - default: 5000"
     * }
     * @returns {GasAnalytics}
     */ value: function getGasClient(options) {
                            if (this._gasClient) return this._gasClient;
                            return this._gasClient = new _GasAnalytics.GasAnalytics(options);
                        }
                    },
                    {
                        key: "getJiraClient",
                        value: function getJiraClient(options) {
                            if (this._jiraClient) return this._jiraClient;
                            return this._jiraClient = new _JiraAnalytics.JiraAnalytics(options);
                        }
                    },
                    {
                        key: "getConfluenceClient",
                        value: function getConfluenceClient(options) {
                            if (this._confluenceClient) return this._confluenceClient;
                            return this._confluenceClient = new _ConfluenceAnalytics.ConfluenceAnalytics(options);
                        }
                    }
                ]);
                return AnalyticsClientFactory;
            }();
            exports.default = new AnalyticsClientFactory();
            /**
 * Provide a list of acceptable values to ensure we do not unintentionally capture user data
 * @param {...String} allowedStrings - Static string values representing allowed words for this property
 * @returns {SafeString} - a function that will check if the value (argument) is in the list of allowedStrings
 */ var markAsSafe = exports.markAsSafe = _PrivacySafeString.markAsSafe;
            var isSafeString = exports.isSafeString = _PrivacySafeString.isSafeString;
            var dangerouslyCreateSafeString = exports.dangerouslyCreateSafeString = _PrivacySafeString.dangerouslyCreateSafeString;
        /***/ },
        /* 8 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            var _createClass = function() {
                function defineProperties(target, props) {
                    for(var i = 0; i < props.length; i++){
                        var descriptor = props[i];
                        descriptor.enumerable = descriptor.enumerable || false;
                        descriptor.configurable = true;
                        if ("value" in descriptor) descriptor.writable = true;
                        Object.defineProperty(target, descriptor.key, descriptor);
                    }
                }
                return function(Constructor, protoProps, staticProps) {
                    if (protoProps) defineProperties(Constructor.prototype, protoProps);
                    if (staticProps) defineProperties(Constructor, staticProps);
                    return Constructor;
                };
            }();
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
            }
            var _isSupported = null;
            /**
 * Light wrapper around navigator.sendBeacon()
 */ var Beacon = exports.Beacon = function() {
                function Beacon() {
                    _classCallCheck(this, Beacon);
                }
                _createClass(Beacon, null, [
                    {
                        key: "sendAsJson",
                        /**
         * Send the specified object as JSON using Beacon API.
         *
         * See:
         * - https://developer.mozilla.org/en-US/docs/Web/API/Beacon_API
         * - https://w3c.github.io/beacon/#dom-navigator-sendbeacon
         *
         * Returns a boolean to indicate that the data was successfully queued.
         *
         * If we've exceeded our quota for sendBeacon on this page, this method
         * will return false.
         *
         * See: https://www.w3.org/TR/beacon/#sec-sendBeacon-method
         *
         * @param url
         * @param object
         * @returns {boolean}
         */ value: function sendAsJson(url, object) {
                            var blob = new Blob([
                                JSON.stringify(object)
                            ], {
                                type: "text/plain"
                            });
                            return navigator.sendBeacon(url, blob);
                        }
                    },
                    {
                        key: "isSupported",
                        value: function isSupported() {
                            if (typeof _isSupported !== "boolean") _isSupported = this.isSendBeaconSupported() && this.isBlobSupported();
                            return _isSupported;
                        }
                    },
                    {
                        key: "isSendBeaconSupported",
                        value: function isSendBeaconSupported() {
                            // Modified from: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/network/beacon.js
                            return "sendBeacon" in navigator && typeof navigator.sendBeacon === "function";
                        }
                    },
                    {
                        key: "isBlobSupported",
                        value: function isBlobSupported() {
                            // Source: https://github.com/Modernizr/Modernizr/blob/master/feature-detects/blob.js
                            try {
                                return new Blob(), true;
                            } catch (e) {
                                return false;
                            }
                        }
                    }
                ]);
                return Beacon;
            }();
        /***/ },
        /* 9 */ /***/ function(module1, exports, __webpack_require__) {
            "use strict";
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            /**
 * Prettifier with a standard prefix for all log messages
 */ /*eslint no-console: 0*/ exports.default = {
                log: function log(message) {
                    console.log("%cAnalytics: " + message, "color: #0052CC; font-size: small");
                },
                warn: function warn(message) {
                    console.warn("%cAnalytics: " + message, "color: #DE350B; font-size: small");
                },
                error: function error(message) {
                    // This might not work in some browsers... but ignore this for now.
                    console.error("%cAnalytics: " + message, "color: #FF5630; font-size: small");
                }
            };
        /***/ }
    ]);
});

});

parcelRegister("kQqSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $071ec5b1002c271c$export$2e2bcd8739ae039; });

var $jSnDV = parcelRequire("jSnDV");

var $kLQmS = parcelRequire("kLQmS");
const $071ec5b1002c271c$var$cache = new Map();
var $071ec5b1002c271c$export$2e2bcd8739ae039 = (url, options)=>{
    if (!$071ec5b1002c271c$var$cache.has(url)) $071ec5b1002c271c$var$cache.set(url, $071ec5b1002c271c$var$getOriginTracingAttributesFromUrl(url, options));
    return $071ec5b1002c271c$var$cache.get(url);
};
function $071ec5b1002c271c$var$getOriginTracingAttributesFromUrl(url, options) {
    let mapAttribute = (v)=>v;
    if (options && options.mapAttribute) mapAttribute = options.mapAttribute;
    let origin = (0, $kLQmS.default).createEmpty();
    try {
        const urlOrigin = (0, $kLQmS.default).fromUrl(url);
        const continueUrl = $071ec5b1002c271c$var$getQueryParam(url, "continue");
        const continueOrigin = (0, $kLQmS.default).fromUrl(continueUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const destUrl = $071ec5b1002c271c$var$getQueryParam(continueUrl, "dest-url");
        const destOrigin = (0, $kLQmS.default).fromUrl(destUrl);
        // @ts-ignore Argument of type 'string | string[]' is not assignable to parameter of type 'string'.
        const nestedContinueUrl = $071ec5b1002c271c$var$getQueryParam(continueUrl, "continue");
        const nestedContinueOrigin = (0, $kLQmS.default).fromUrl(nestedContinueUrl);
        origin = !urlOrigin.isEmpty() && urlOrigin || !continueOrigin.isEmpty() && continueOrigin || !destOrigin.isEmpty() && destOrigin || !nestedContinueOrigin.isEmpty() && nestedContinueOrigin || (0, $kLQmS.default).createEmpty();
    } catch (e) {
    //will fail only on malformed urls, we don't care about that
    }
    return origin.toAnalyticsAttributes({
        transformValue: mapAttribute
    });
}
function $071ec5b1002c271c$var$getQueryParam(url, paramName) {
    if (!url) return undefined;
    // Base is only needed for URL() to resolve relative paths. It could be arbitrary.
    const BASE = "http://atlassian.com/";
    const query = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(new URL(url, BASE).search);
    return query[paramName] || undefined;
}

});
parcelRegister("jSnDV", function(module, exports) {

$parcel$export(module.exports, "extract", function () { return $e78566742ab5fae0$export$f9380c9a627682d3; }, function (v) { return $e78566742ab5fae0$export$f9380c9a627682d3 = v; });
$parcel$export(module.exports, "parse", function () { return $e78566742ab5fae0$export$98e6a39c04603d36; }, function (v) { return $e78566742ab5fae0$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $e78566742ab5fae0$export$fac44ee5b035f737; }, function (v) { return $e78566742ab5fae0$export$fac44ee5b035f737 = v; });
$parcel$export(module.exports, "parseUrl", function () { return $e78566742ab5fae0$export$7a5253c0f62e0150; }, function (v) { return $e78566742ab5fae0$export$7a5253c0f62e0150 = v; });
var $e78566742ab5fae0$export$f9380c9a627682d3;
var $e78566742ab5fae0$export$98e6a39c04603d36;
var $e78566742ab5fae0$export$fac44ee5b035f737;
var $e78566742ab5fae0$export$7a5253c0f62e0150;
"use strict";

var $gOBOZ = parcelRequire("gOBOZ");

var $lir0C = parcelRequire("lir0C");

var $lPnyU = parcelRequire("lPnyU");
function $e78566742ab5fae0$var$encoderForArrayFormat(opts) {
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, index) {
                return value === null ? [
                    $e78566742ab5fae0$var$encode(key, opts),
                    "[",
                    index,
                    "]"
                ].join("") : [
                    $e78566742ab5fae0$var$encode(key, opts),
                    "[",
                    $e78566742ab5fae0$var$encode(index, opts),
                    "]=",
                    $e78566742ab5fae0$var$encode(value, opts)
                ].join("");
            };
        case "bracket":
            return function(key, value) {
                return value === null ? $e78566742ab5fae0$var$encode(key, opts) : [
                    $e78566742ab5fae0$var$encode(key, opts),
                    "[]=",
                    $e78566742ab5fae0$var$encode(value, opts)
                ].join("");
            };
        default:
            return function(key, value) {
                return value === null ? $e78566742ab5fae0$var$encode(key, opts) : [
                    $e78566742ab5fae0$var$encode(key, opts),
                    "=",
                    $e78566742ab5fae0$var$encode(value, opts)
                ].join("");
            };
    }
}
function $e78566742ab5fae0$var$parserForArrayFormat(opts) {
    var result;
    switch(opts.arrayFormat){
        case "index":
            return function(key, value, accumulator) {
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return function(key, value, accumulator) {
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                } else if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        default:
            return function(key, value, accumulator) {
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $e78566742ab5fae0$var$encode(value, opts) {
    if (opts.encode) return opts.strict ? $gOBOZ(value) : encodeURIComponent(value);
    return value;
}
function $e78566742ab5fae0$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    else if (typeof input === "object") return $e78566742ab5fae0$var$keysSorter(Object.keys(input)).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(key) {
        return input[key];
    });
    return input;
}
function $e78566742ab5fae0$var$extract(str) {
    var queryStart = str.indexOf("?");
    if (queryStart === -1) return "";
    return str.slice(queryStart + 1);
}
function $e78566742ab5fae0$var$parse(str, opts) {
    opts = $lir0C({
        arrayFormat: "none"
    }, opts);
    var formatter = $e78566742ab5fae0$var$parserForArrayFormat(opts);
    // Create an object with no prototype
    // https://github.com/sindresorhus/query-string/issues/47
    var ret = Object.create(null);
    if (typeof str !== "string") return ret;
    str = str.trim().replace(/^[?#&]/, "");
    if (!str) return ret;
    str.split("&").forEach(function(param) {
        var parts = param.replace(/\+/g, " ").split("=");
        // Firefox (pre 40) decodes `%3D` to `=`
        // https://github.com/sindresorhus/query-string/pull/37
        var key = parts.shift();
        var val = parts.length > 0 ? parts.join("=") : undefined;
        // missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        val = val === undefined ? null : $lPnyU(val);
        formatter($lPnyU(key), val, ret);
    });
    return Object.keys(ret).sort().reduce(function(result, key) {
        var val = ret[key];
        if (Boolean(val) && typeof val === "object" && !Array.isArray(val)) // Sort object keys, not values
        result[key] = $e78566742ab5fae0$var$keysSorter(val);
        else result[key] = val;
        return result;
    }, Object.create(null));
}
$e78566742ab5fae0$export$f9380c9a627682d3 = $e78566742ab5fae0$var$extract;
$e78566742ab5fae0$export$98e6a39c04603d36 = $e78566742ab5fae0$var$parse;
$e78566742ab5fae0$export$fac44ee5b035f737 = function(obj, opts) {
    var defaults = {
        encode: true,
        strict: true,
        arrayFormat: "none"
    };
    opts = $lir0C(defaults, opts);
    if (opts.sort === false) opts.sort = function() {};
    var formatter = $e78566742ab5fae0$var$encoderForArrayFormat(opts);
    return obj ? Object.keys(obj).sort(opts.sort).map(function(key) {
        var val = obj[key];
        if (val === undefined) return "";
        if (val === null) return $e78566742ab5fae0$var$encode(key, opts);
        if (Array.isArray(val)) {
            var result = [];
            val.slice().forEach(function(val2) {
                if (val2 === undefined) return;
                result.push(formatter(key, val2, result.length));
            });
            return result.join("&");
        }
        return $e78566742ab5fae0$var$encode(key, opts) + "=" + $e78566742ab5fae0$var$encode(val, opts);
    }).filter(function(x) {
        return x.length > 0;
    }).join("&") : "";
};
$e78566742ab5fae0$export$7a5253c0f62e0150 = function(str, opts) {
    return {
        url: str.split("?")[0] || "",
        query: $e78566742ab5fae0$var$parse($e78566742ab5fae0$var$extract(str), opts)
    };
};

});
parcelRegister("gOBOZ", function(module, exports) {
"use strict";
module.exports = function(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
};

});

parcelRegister("lir0C", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $f8103adc227edd07$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $f8103adc227edd07$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f8103adc227edd07$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $f8103adc227edd07$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $f8103adc227edd07$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $f8103adc227edd07$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $f8103adc227edd07$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($f8103adc227edd07$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($f8103adc227edd07$var$getOwnPropertySymbols) {
            symbols = $f8103adc227edd07$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($f8103adc227edd07$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});


parcelRegister("kLQmS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1f0d1a0753c92bf$export$2e2bcd8739ae039; });

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $gaCcd = parcelRequire("gaCcd");

var $aOTJ4 = parcelRequire("aOTJ4");

var $fOkfd = parcelRequire("fOkfd");
function $f1f0d1a0753c92bf$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f1f0d1a0753c92bf$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, result);
    };
}
function $f1f0d1a0753c92bf$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f1f0d1a0753c92bf$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $f1f0d1a0753c92bf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f1f0d1a0753c92bf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f1f0d1a0753c92bf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f1f0d1a0753c92bf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f1f0d1a0753c92bf$var$packageVersion = "6.1.5";
var $f1f0d1a0753c92bf$var$originParamName = "atlOrigin";
var $f1f0d1a0753c92bf$var$originVersioningAttributes = {
    originLibrary: "origin-tracing.js@".concat($f1f0d1a0753c92bf$var$packageVersion)
};
var $f1f0d1a0753c92bf$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function OriginTracer(_ref) {
        var _ref$id = _ref.id, id = _ref$id === void 0 ? OriginTracer.generateId() : _ref$id, product = _ref.product, _ref$dangerouslySkipV = _ref.dangerouslySkipValidation, dangerouslySkipValidation = _ref$dangerouslySkipV === void 0 ? false : _ref$dangerouslySkipV;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, OriginTracer);
        this.id = id;
        this.product = product;
        if (!dangerouslySkipValidation) this.validate();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(OriginTracer, [
        {
            key: "encode",
            value: function encode() {
                return (0, $aOTJ4.encode)({
                    id: this.id,
                    product: this.product
                });
            }
        },
        {
            key: "addToUrl",
            value: function addToUrl(url) {
                var _this = this;
                return $f1f0d1a0753c92bf$var$replaceQuery(url, function(originalQueryString) {
                    var params = new ((0, $fOkfd.getEnv)()).URLSearchParams(originalQueryString);
                    params.set($f1f0d1a0753c92bf$var$originParamName, _this.encode());
                    return params.toString();
                });
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "isMalformed",
            value: function isMalformed() {
                return !this.isEmpty() && !this.isValid();
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                var _objectSpread2;
                var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$transformValue = _ref2.transformValue, transformValue = _ref2$transformValue === void 0 ? function(v) {
                    return v === null ? undefined : v;
                } : _ref2$transformValue, _ref2$hasGeneratedId = _ref2.hasGeneratedId, hasGeneratedId = _ref2$hasGeneratedId === void 0 ? false : _ref2$hasGeneratedId;
                // `originIdGenerated` should be used in analytic events that generated this originId.
                // Subsequent events should use `originId`.
                // No two events should have the same value of originIdGenerated.
                var originIdProp = hasGeneratedId ? "originIdGenerated" : "originId";
                return $f1f0d1a0753c92bf$var$_objectSpread((_objectSpread2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, originIdProp, transformValue(this.id)), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "originProduct", transformValue(this.product)), _objectSpread2), $f1f0d1a0753c92bf$var$originVersioningAttributes);
            }
        },
        {
            key: "validate",
            value: function validate() {
                if (!OriginTracer.isValidId(this.id)) throw new TypeError("Invalid Origin id");
                if (!OriginTracer.isValidProduct(this.product)) throw new TypeError("Missing/invalid Origin product");
            }
        }
    ], [
        {
            key: "isValidId",
            value: function isValidId(value) {
                return typeof value === "string" && /^[-_a-zA-Z0-9]{1,36}$/.test(value);
            }
        },
        {
            key: "isValidProduct",
            value: function isValidProduct(value) {
                return typeof value === "string" && /^[-_a-zA-Z0-9]{1,20}$/.test(value);
            }
        },
        {
            key: "generateId",
            value: function generateId() {
                var id = (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
                // Dash positions are fixed so they don't add to uniqueness.
                // Remove them to save space in the encoded form.
                return id.replace(/-/g, "");
            }
        },
        {
            key: "createEmpty",
            value: function createEmpty() {
                return new $f1f0d1a0753c92bf$var$EmptyOriginTracer();
            }
        },
        {
            key: "createMalformed",
            value: function createMalformed() {
                return new $f1f0d1a0753c92bf$var$MalformedOriginTracer();
            }
        },
        {
            key: "fromUrl",
            value: function fromUrl(url) {
                var params = new ((0, $fOkfd.getEnv)()).URLSearchParams();
                $f1f0d1a0753c92bf$var$replaceQuery(url, function(queryString) {
                    params = new ((0, $fOkfd.getEnv)()).URLSearchParams(queryString);
                });
                return OriginTracer.fromEncoded(params.get($f1f0d1a0753c92bf$var$originParamName));
            }
        },
        {
            key: "fromEncoded",
            value: function fromEncoded(encoded) {
                if (!encoded) return OriginTracer.createEmpty();
                try {
                    return OriginTracer.decode(encoded);
                } catch (e) {
                    return OriginTracer.createMalformed();
                }
            }
        },
        {
            key: "removeFromUrl",
            value: function removeFromUrl(url) {
                return $f1f0d1a0753c92bf$var$replaceQuery(url, function(queryString) {
                    var params = new ((0, $fOkfd.getEnv)()).URLSearchParams(queryString);
                    params.delete($f1f0d1a0753c92bf$var$originParamName);
                    return params.toString();
                });
            }
        },
        {
            key: "decode",
            value: function decode(encodedOrigin) {
                var originData = (0, $aOTJ4.decode)(encodedOrigin);
                return new OriginTracer(originData);
            }
        }
    ]);
    return OriginTracer;
}();
var $f1f0d1a0753c92bf$var$EmptyOriginTracer = /*#__PURE__*/ function(_OriginTracer) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(EmptyOriginTracer, _OriginTracer);
    var _super = $f1f0d1a0753c92bf$var$_createSuper(EmptyOriginTracer);
    function EmptyOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, EmptyOriginTracer);
        return _super.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(EmptyOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return true;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $f1f0d1a0753c92bf$var$_objectSpread({}, $f1f0d1a0753c92bf$var$originVersioningAttributes);
            }
        }
    ]);
    return EmptyOriginTracer;
}($f1f0d1a0753c92bf$export$2e2bcd8739ae039);
var $f1f0d1a0753c92bf$var$MalformedOriginTracer = /*#__PURE__*/ function(_OriginTracer2) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(MalformedOriginTracer, _OriginTracer2);
    var _super2 = $f1f0d1a0753c92bf$var$_createSuper(MalformedOriginTracer);
    function MalformedOriginTracer() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, MalformedOriginTracer);
        return _super2.call(this, {
            id: null,
            product: null,
            dangerouslySkipValidation: true
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(MalformedOriginTracer, [
        {
            key: "isValid",
            value: function isValid() {
                return false;
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return false;
            }
        },
        {
            key: "toAnalyticsAttributes",
            value: function toAnalyticsAttributes() {
                return $f1f0d1a0753c92bf$var$_objectSpread({
                    originMalformed: true
                }, $f1f0d1a0753c92bf$var$originVersioningAttributes);
            }
        }
    ]);
    return MalformedOriginTracer;
}($f1f0d1a0753c92bf$export$2e2bcd8739ae039);
function $f1f0d1a0753c92bf$var$replaceQuery(url, replacer) {
    var urlWithQueryStringRegex = /(^[^?#]*)(?:\?)?([^#]*?)(#.*|$)$/;
    // If we get passed window.location, we don't want to call window.location.replace()
    var urlString = String(url);
    return urlString.replace(urlWithQueryStringRegex, function(_wholeMatch, beforeQuery, queryString, afterQuery) {
        var newQueryString = replacer(queryString);
        if (newQueryString) newQueryString = "?".concat(newQueryString);
        return "".concat(beforeQuery).concat(newQueryString).concat(afterQuery);
    });
}

});
parcelRegister("7Ar6h", function(module, exports) {

var $5LDYA = parcelRequire("5LDYA");
function $5860eabc943f0341$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $5LDYA(t, e);
}
module.exports = $5860eabc943f0341$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5LDYA", function(module, exports) {
function $433059ffae2f1c2a$var$_setPrototypeOf(t, e) {
    return module.exports = $433059ffae2f1c2a$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $433059ffae2f1c2a$var$_setPrototypeOf(t, e);
}
module.exports = $433059ffae2f1c2a$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("h2r7j", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $c677a868bff4c3dd$var$_typeof = $cd8Dz.default;

var $5T1eV = parcelRequire("5T1eV");
function $c677a868bff4c3dd$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $c677a868bff4c3dd$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $5T1eV(t);
}
module.exports = $c677a868bff4c3dd$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5T1eV", function(module, exports) {
function $44930d02bcdd8f64$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $44930d02bcdd8f64$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("hOtqI", function(module, exports) {
function $cf7def55664962b4$var$_getPrototypeOf(t) {
    return module.exports = $cf7def55664962b4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $cf7def55664962b4$var$_getPrototypeOf(t);
}
module.exports = $cf7def55664962b4$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aOTJ4", function(module, exports) {

$parcel$export(module.exports, "encode", function () { return $7e09cce1e858966f$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decode", function () { return $7e09cce1e858966f$export$2f872c0f2117be69; });

var $c4OTP = parcelRequire("c4OTP");

var $fOkfd = parcelRequire("fOkfd");
var $7e09cce1e858966f$var$productShorthands = {
    confluence: "c",
    jira: "j",
    stride: "s",
    bitbucket: "b",
    trello: "t"
};
function $7e09cce1e858966f$export$c564cdbbe6da493(originData) {
    var json = JSON.stringify($7e09cce1e858966f$export$4bc4b533a565aabe(originData));
    var base64 = (0, $fOkfd.getEnv)().btoa(json);
    return (0, $c4OTP.base64ToBase64Url)(base64);
}
function $7e09cce1e858966f$export$2f872c0f2117be69(encodedOriginString) {
    var base64 = (0, $c4OTP.base64UrlToBase64)(encodedOriginString);
    var json = (0, $fOkfd.getEnv)().atob(base64);
    return $7e09cce1e858966f$export$46d5cda6b884b7ab(JSON.parse(json));
}
function $7e09cce1e858966f$export$4bc4b533a565aabe(_ref) {
    var id = _ref.id, product = _ref.product;
    return {
        i: id,
        p: product && product in $7e09cce1e858966f$var$productShorthands ? $7e09cce1e858966f$var$productShorthands[product] : product
    };
}
function $7e09cce1e858966f$export$46d5cda6b884b7ab(originJSONObject) {
    var originData = {};
    if (originJSONObject.i) originData.id = originJSONObject.i;
    if (originJSONObject.p) originData.product = $7e09cce1e858966f$var$expandProductShorthand(originJSONObject.p);
    return originData;
}
function $7e09cce1e858966f$var$expandProductShorthand(maybeShorthand) {
    var products = Object.keys($7e09cce1e858966f$var$productShorthands);
    for(var i = 0; i < products.length; i++){
        var product = products[i];
        var shorthand = $7e09cce1e858966f$var$productShorthands[product];
        if (maybeShorthand === shorthand) return product;
    }
    return maybeShorthand;
}

});
parcelRegister("c4OTP", function(module, exports) {

$parcel$export(module.exports, "base64ToBase64Url", function () { return $8cad57543df4384a$export$3b91e21dac1023c6; });
$parcel$export(module.exports, "base64UrlToBase64", function () { return $8cad57543df4384a$export$47c5265a25535d02; });
/**
 * This file converts between Base64 and Base 64 Encoding with URL and Filename Safe Alphabet,
 * the latter of which has URL-safe characters only (drops =, + and /).
 *
 * Why not use a library? The popular libs use Buffer to be able to
 * encode any data to base64. We don't need this capability, and it causes
 * Webpack to include 30KB of a Buffer polyfill.
 * Webpack's/UglifyJS's Tree Shaking seems to be unable to drop it.
 *
 * See: RFC 4648 section 5 (https://tools.ietf.org/html/rfc4648#section-5)
 */ function $8cad57543df4384a$export$3b91e21dac1023c6(base64) {
    if (base64 == null) return "";
    return String(base64).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}
function $8cad57543df4384a$export$47c5265a25535d02(base64url) {
    if (base64url == null) return "";
    var base64 = String(base64url).replace(/-/g, "+").replace(/_/g, "/");
    var padLength = (4 - base64url.length % 4) % 4;
    var pad = "===".slice(0, padLength);
    return base64 + pad;
}

});

parcelRegister("fOkfd", function(module, exports) {

$parcel$export(module.exports, "getEnv", function () { return $b82b3aa01bd9c4ad$export$4bd44a2aa29d3d6e; });

var $bERfd = parcelRequire("bERfd");

var $b82b3aa01bd9c4ad$export$d3cd91e0fdbfdbc0 = function getEnvGlobals() {
    return {
        atob: // atob/btoa need to be bound because they throw an illegal invocation error when called as a method (obj.atob())
        typeof atob === "function" && atob.bind(undefined) || typeof (0, $bERfd.Buffer) !== "undefined" && function(encoded) {
            return (0, $bERfd.Buffer).from(encoded, "base64").toString();
        },
        btoa: typeof btoa === "function" && btoa.bind(undefined) || typeof (0, $bERfd.Buffer) !== "undefined" && function(str) {
            return (0, $bERfd.Buffer).from(str).toString("base64");
        },
        URLSearchParams: typeof URLSearchParams === "function" && URLSearchParams || (0, (parcelRequire("jtc4e")).URLSearchParams)
    };
};
var $b82b3aa01bd9c4ad$var$env;
var $b82b3aa01bd9c4ad$export$4bd44a2aa29d3d6e = function getEnv() {
    return $b82b3aa01bd9c4ad$var$env || ($b82b3aa01bd9c4ad$var$env = $b82b3aa01bd9c4ad$var$validateEnv($b82b3aa01bd9c4ad$export$d3cd91e0fdbfdbc0()));
};
var $b82b3aa01bd9c4ad$var$validateEnv = function validateEnv(env) {
    if (!(env.atob && env.btoa && env.URLSearchParams)) throw new TypeError("Origin-Tracing: missing environment APIs. Required: btoa(), atob(), URLSearchParams() (or in Node: Buffer, require('url').URLSearchParams).");
    return env;
};

});
parcelRegister("bERfd", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $87ccbb5a8215b715$export$a143d493d941bafc; }, function (v) { return $87ccbb5a8215b715$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $87ccbb5a8215b715$export$f99ded8fe4b79145; }, function (v) { return $87ccbb5a8215b715$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $87ccbb5a8215b715$export$a143d493d941bafc;
var $87ccbb5a8215b715$export$e4cf37d7f6fb9e0a;
var $87ccbb5a8215b715$export$f99ded8fe4b79145;
var $87ccbb5a8215b715$export$599f31c3813fae4d;
"use strict";

var $ayKrL = parcelRequire("ayKrL");

var $ego1F = parcelRequire("ego1F");
const $87ccbb5a8215b715$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$87ccbb5a8215b715$export$a143d493d941bafc = $87ccbb5a8215b715$var$Buffer;
$87ccbb5a8215b715$export$e4cf37d7f6fb9e0a = $87ccbb5a8215b715$var$SlowBuffer;
$87ccbb5a8215b715$export$f99ded8fe4b79145 = 50;
const $87ccbb5a8215b715$var$K_MAX_LENGTH = 0x7fffffff;
$87ccbb5a8215b715$export$599f31c3813fae4d = $87ccbb5a8215b715$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $87ccbb5a8215b715$var$Buffer.TYPED_ARRAY_SUPPORT = $87ccbb5a8215b715$var$typedArraySupport();
if (!$87ccbb5a8215b715$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $87ccbb5a8215b715$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($87ccbb5a8215b715$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$87ccbb5a8215b715$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($87ccbb5a8215b715$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$87ccbb5a8215b715$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $87ccbb5a8215b715$var$createBuffer(length) {
    if (length > $87ccbb5a8215b715$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $87ccbb5a8215b715$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $87ccbb5a8215b715$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $87ccbb5a8215b715$var$allocUnsafe(arg);
    }
    return $87ccbb5a8215b715$var$from(arg, encodingOrOffset, length);
}
$87ccbb5a8215b715$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $87ccbb5a8215b715$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $87ccbb5a8215b715$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $87ccbb5a8215b715$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($87ccbb5a8215b715$var$isInstance(value, ArrayBuffer) || value && $87ccbb5a8215b715$var$isInstance(value.buffer, ArrayBuffer)) return $87ccbb5a8215b715$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($87ccbb5a8215b715$var$isInstance(value, SharedArrayBuffer) || value && $87ccbb5a8215b715$var$isInstance(value.buffer, SharedArrayBuffer))) return $87ccbb5a8215b715$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $87ccbb5a8215b715$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $87ccbb5a8215b715$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $87ccbb5a8215b715$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $87ccbb5a8215b715$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $87ccbb5a8215b715$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($87ccbb5a8215b715$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($87ccbb5a8215b715$var$Buffer, Uint8Array);
function $87ccbb5a8215b715$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $87ccbb5a8215b715$var$alloc(size, fill, encoding) {
    $87ccbb5a8215b715$var$assertSize(size);
    if (size <= 0) return $87ccbb5a8215b715$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $87ccbb5a8215b715$var$createBuffer(size).fill(fill, encoding) : $87ccbb5a8215b715$var$createBuffer(size).fill(fill);
    return $87ccbb5a8215b715$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $87ccbb5a8215b715$var$Buffer.alloc = function(size, fill, encoding) {
    return $87ccbb5a8215b715$var$alloc(size, fill, encoding);
};
function $87ccbb5a8215b715$var$allocUnsafe(size) {
    $87ccbb5a8215b715$var$assertSize(size);
    return $87ccbb5a8215b715$var$createBuffer(size < 0 ? 0 : $87ccbb5a8215b715$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $87ccbb5a8215b715$var$Buffer.allocUnsafe = function(size) {
    return $87ccbb5a8215b715$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $87ccbb5a8215b715$var$Buffer.allocUnsafeSlow = function(size) {
    return $87ccbb5a8215b715$var$allocUnsafe(size);
};
function $87ccbb5a8215b715$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$87ccbb5a8215b715$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $87ccbb5a8215b715$var$byteLength(string, encoding) | 0;
    let buf = $87ccbb5a8215b715$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $87ccbb5a8215b715$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $87ccbb5a8215b715$var$checked(array.length) | 0;
    const buf = $87ccbb5a8215b715$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $87ccbb5a8215b715$var$fromArrayView(arrayView) {
    if ($87ccbb5a8215b715$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $87ccbb5a8215b715$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $87ccbb5a8215b715$var$fromArrayLike(arrayView);
}
function $87ccbb5a8215b715$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $87ccbb5a8215b715$var$Buffer.prototype);
    return buf;
}
function $87ccbb5a8215b715$var$fromObject(obj) {
    if ($87ccbb5a8215b715$var$Buffer.isBuffer(obj)) {
        const len = $87ccbb5a8215b715$var$checked(obj.length) | 0;
        const buf = $87ccbb5a8215b715$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $87ccbb5a8215b715$var$numberIsNaN(obj.length)) return $87ccbb5a8215b715$var$createBuffer(0);
        return $87ccbb5a8215b715$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $87ccbb5a8215b715$var$fromArrayLike(obj.data);
}
function $87ccbb5a8215b715$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $87ccbb5a8215b715$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $87ccbb5a8215b715$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $87ccbb5a8215b715$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $87ccbb5a8215b715$var$Buffer.alloc(+length);
}
$87ccbb5a8215b715$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $87ccbb5a8215b715$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$87ccbb5a8215b715$var$Buffer.compare = function compare(a, b) {
    if ($87ccbb5a8215b715$var$isInstance(a, Uint8Array)) a = $87ccbb5a8215b715$var$Buffer.from(a, a.offset, a.byteLength);
    if ($87ccbb5a8215b715$var$isInstance(b, Uint8Array)) b = $87ccbb5a8215b715$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(a) || !$87ccbb5a8215b715$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$87ccbb5a8215b715$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$87ccbb5a8215b715$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $87ccbb5a8215b715$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $87ccbb5a8215b715$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($87ccbb5a8215b715$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$87ccbb5a8215b715$var$Buffer.isBuffer(buf)) buf = $87ccbb5a8215b715$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$87ccbb5a8215b715$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $87ccbb5a8215b715$var$byteLength(string, encoding) {
    if ($87ccbb5a8215b715$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $87ccbb5a8215b715$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $87ccbb5a8215b715$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $87ccbb5a8215b715$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $87ccbb5a8215b715$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$87ccbb5a8215b715$var$Buffer.byteLength = $87ccbb5a8215b715$var$byteLength;
function $87ccbb5a8215b715$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $87ccbb5a8215b715$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $87ccbb5a8215b715$var$utf8Slice(this, start, end);
        case "ascii":
            return $87ccbb5a8215b715$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $87ccbb5a8215b715$var$latin1Slice(this, start, end);
        case "base64":
            return $87ccbb5a8215b715$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $87ccbb5a8215b715$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$87ccbb5a8215b715$var$Buffer.prototype._isBuffer = true;
function $87ccbb5a8215b715$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$87ccbb5a8215b715$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$87ccbb5a8215b715$var$swap(this, i, i + 1);
    return this;
};
$87ccbb5a8215b715$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $87ccbb5a8215b715$var$swap(this, i, i + 3);
        $87ccbb5a8215b715$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$87ccbb5a8215b715$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $87ccbb5a8215b715$var$swap(this, i, i + 7);
        $87ccbb5a8215b715$var$swap(this, i + 1, i + 6);
        $87ccbb5a8215b715$var$swap(this, i + 2, i + 5);
        $87ccbb5a8215b715$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$87ccbb5a8215b715$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $87ccbb5a8215b715$var$utf8Slice(this, 0, length);
    return $87ccbb5a8215b715$var$slowToString.apply(this, arguments);
};
$87ccbb5a8215b715$var$Buffer.prototype.toLocaleString = $87ccbb5a8215b715$var$Buffer.prototype.toString;
$87ccbb5a8215b715$var$Buffer.prototype.equals = function equals(b) {
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $87ccbb5a8215b715$var$Buffer.compare(this, b) === 0;
};
$87ccbb5a8215b715$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $87ccbb5a8215b715$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($87ccbb5a8215b715$var$customInspectSymbol) $87ccbb5a8215b715$var$Buffer.prototype[$87ccbb5a8215b715$var$customInspectSymbol] = $87ccbb5a8215b715$var$Buffer.prototype.inspect;
$87ccbb5a8215b715$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($87ccbb5a8215b715$var$isInstance(target, Uint8Array)) target = $87ccbb5a8215b715$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $87ccbb5a8215b715$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($87ccbb5a8215b715$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $87ccbb5a8215b715$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($87ccbb5a8215b715$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $87ccbb5a8215b715$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $87ccbb5a8215b715$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $87ccbb5a8215b715$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$87ccbb5a8215b715$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$87ccbb5a8215b715$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $87ccbb5a8215b715$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$87ccbb5a8215b715$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $87ccbb5a8215b715$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $87ccbb5a8215b715$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($87ccbb5a8215b715$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $87ccbb5a8215b715$var$utf8Write(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $87ccbb5a8215b715$var$asciiWrite(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$asciiToBytes(string), buf, offset, length);
}
function $87ccbb5a8215b715$var$base64Write(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$base64ToBytes(string), buf, offset, length);
}
function $87ccbb5a8215b715$var$ucs2Write(buf, string, offset, length) {
    return $87ccbb5a8215b715$var$blitBuffer($87ccbb5a8215b715$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$87ccbb5a8215b715$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $87ccbb5a8215b715$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $87ccbb5a8215b715$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $87ccbb5a8215b715$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $87ccbb5a8215b715$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $87ccbb5a8215b715$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$87ccbb5a8215b715$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $87ccbb5a8215b715$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $ayKrL.fromByteArray(buf);
    else return $ayKrL.fromByteArray(buf.slice(start, end));
}
function $87ccbb5a8215b715$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $87ccbb5a8215b715$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $87ccbb5a8215b715$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $87ccbb5a8215b715$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $87ccbb5a8215b715$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $87ccbb5a8215b715$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $87ccbb5a8215b715$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $87ccbb5a8215b715$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $87ccbb5a8215b715$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $87ccbb5a8215b715$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $87ccbb5a8215b715$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$87ccbb5a8215b715$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $87ccbb5a8215b715$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $87ccbb5a8215b715$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$87ccbb5a8215b715$var$Buffer.prototype.readUintLE = $87ccbb5a8215b715$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUintBE = $87ccbb5a8215b715$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint8 = $87ccbb5a8215b715$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint16LE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint16BE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint32LE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$87ccbb5a8215b715$var$Buffer.prototype.readUint32BE = $87ccbb5a8215b715$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$87ccbb5a8215b715$var$Buffer.prototype.readBigUInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$87ccbb5a8215b715$var$Buffer.prototype.readBigUInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$87ccbb5a8215b715$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$87ccbb5a8215b715$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$87ccbb5a8215b715$var$Buffer.prototype.readBigInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$87ccbb5a8215b715$var$Buffer.prototype.readBigInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $87ccbb5a8215b715$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $87ccbb5a8215b715$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$87ccbb5a8215b715$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return $ego1F.read(this, offset, true, 23, 4);
};
$87ccbb5a8215b715$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 4, this.length);
    return $ego1F.read(this, offset, false, 23, 4);
};
$87ccbb5a8215b715$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 8, this.length);
    return $ego1F.read(this, offset, true, 52, 8);
};
$87ccbb5a8215b715$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkOffset(offset, 8, this.length);
    return $ego1F.read(this, offset, false, 52, 8);
};
function $87ccbb5a8215b715$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$87ccbb5a8215b715$var$Buffer.prototype.writeUintLE = $87ccbb5a8215b715$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUintBE = $87ccbb5a8215b715$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint8 = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint16LE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint16BE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint32LE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeUint32BE = $87ccbb5a8215b715$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $87ccbb5a8215b715$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $87ccbb5a8215b715$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $87ccbb5a8215b715$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $87ccbb5a8215b715$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$87ccbb5a8215b715$var$Buffer.prototype.writeBigUInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$87ccbb5a8215b715$var$Buffer.prototype.writeBigUInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$87ccbb5a8215b715$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $87ccbb5a8215b715$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$87ccbb5a8215b715$var$Buffer.prototype.writeBigInt64LE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$87ccbb5a8215b715$var$Buffer.prototype.writeBigInt64BE = $87ccbb5a8215b715$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $87ccbb5a8215b715$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $87ccbb5a8215b715$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $87ccbb5a8215b715$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $ego1F.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$87ccbb5a8215b715$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeFloat(this, value, offset, true, noAssert);
};
$87ccbb5a8215b715$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeFloat(this, value, offset, false, noAssert);
};
function $87ccbb5a8215b715$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $87ccbb5a8215b715$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $ego1F.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$87ccbb5a8215b715$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeDouble(this, value, offset, true, noAssert);
};
$87ccbb5a8215b715$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $87ccbb5a8215b715$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$87ccbb5a8215b715$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$87ccbb5a8215b715$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$87ccbb5a8215b715$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$87ccbb5a8215b715$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $87ccbb5a8215b715$var$Buffer.isBuffer(val) ? val : $87ccbb5a8215b715$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $87ccbb5a8215b715$var$errors = {};
function $87ccbb5a8215b715$var$E(sym, getMessage, Base) {
    $87ccbb5a8215b715$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$87ccbb5a8215b715$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$87ccbb5a8215b715$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$87ccbb5a8215b715$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $87ccbb5a8215b715$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $87ccbb5a8215b715$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $87ccbb5a8215b715$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $87ccbb5a8215b715$var$checkBounds(buf, offset, byteLength) {
    $87ccbb5a8215b715$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $87ccbb5a8215b715$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $87ccbb5a8215b715$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $87ccbb5a8215b715$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $87ccbb5a8215b715$var$checkBounds(buf, offset, byteLength);
}
function $87ccbb5a8215b715$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $87ccbb5a8215b715$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $87ccbb5a8215b715$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $87ccbb5a8215b715$var$validateNumber(value, type);
        throw new $87ccbb5a8215b715$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $87ccbb5a8215b715$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $87ccbb5a8215b715$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $87ccbb5a8215b715$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $87ccbb5a8215b715$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($87ccbb5a8215b715$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $87ccbb5a8215b715$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $87ccbb5a8215b715$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $87ccbb5a8215b715$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $87ccbb5a8215b715$var$base64ToBytes(str) {
    return $ayKrL.toByteArray($87ccbb5a8215b715$var$base64clean(str));
}
function $87ccbb5a8215b715$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $87ccbb5a8215b715$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $87ccbb5a8215b715$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $87ccbb5a8215b715$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $87ccbb5a8215b715$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $87ccbb5a8215b715$var$BufferBigIntNotDefined : fn;
}
function $87ccbb5a8215b715$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("ayKrL", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $7b011bb862b1802d$export$d622b2ad8d90c771; }, function (v) { return $7b011bb862b1802d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $7b011bb862b1802d$export$6100ba28696e12de; }, function (v) { return $7b011bb862b1802d$export$6100ba28696e12de = v; });
var $7b011bb862b1802d$export$a48f0734ac7c2329;
var $7b011bb862b1802d$export$d622b2ad8d90c771;
var $7b011bb862b1802d$export$6100ba28696e12de;
"use strict";
$7b011bb862b1802d$export$a48f0734ac7c2329 = $7b011bb862b1802d$var$byteLength;
$7b011bb862b1802d$export$d622b2ad8d90c771 = $7b011bb862b1802d$var$toByteArray;
$7b011bb862b1802d$export$6100ba28696e12de = $7b011bb862b1802d$var$fromByteArray;
var $7b011bb862b1802d$var$lookup = [];
var $7b011bb862b1802d$var$revLookup = [];
var $7b011bb862b1802d$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $7b011bb862b1802d$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $7b011bb862b1802d$var$i = 0, $7b011bb862b1802d$var$len = $7b011bb862b1802d$var$code.length; $7b011bb862b1802d$var$i < $7b011bb862b1802d$var$len; ++$7b011bb862b1802d$var$i){
    $7b011bb862b1802d$var$lookup[$7b011bb862b1802d$var$i] = $7b011bb862b1802d$var$code[$7b011bb862b1802d$var$i];
    $7b011bb862b1802d$var$revLookup[$7b011bb862b1802d$var$code.charCodeAt($7b011bb862b1802d$var$i)] = $7b011bb862b1802d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$7b011bb862b1802d$var$revLookup["-".charCodeAt(0)] = 62;
$7b011bb862b1802d$var$revLookup["_".charCodeAt(0)] = 63;
function $7b011bb862b1802d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $7b011bb862b1802d$var$byteLength(b64) {
    var lens = $7b011bb862b1802d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7b011bb862b1802d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $7b011bb862b1802d$var$toByteArray(b64) {
    var tmp;
    var lens = $7b011bb862b1802d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $7b011bb862b1802d$var$Arr($7b011bb862b1802d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i)] << 18 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i)] << 2 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i)] << 10 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $7b011bb862b1802d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $7b011bb862b1802d$var$tripletToBase64(num) {
    return $7b011bb862b1802d$var$lookup[num >> 18 & 0x3F] + $7b011bb862b1802d$var$lookup[num >> 12 & 0x3F] + $7b011bb862b1802d$var$lookup[num >> 6 & 0x3F] + $7b011bb862b1802d$var$lookup[num & 0x3F];
}
function $7b011bb862b1802d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($7b011bb862b1802d$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $7b011bb862b1802d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($7b011bb862b1802d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($7b011bb862b1802d$var$lookup[tmp >> 2] + $7b011bb862b1802d$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($7b011bb862b1802d$var$lookup[tmp >> 10] + $7b011bb862b1802d$var$lookup[tmp >> 4 & 0x3F] + $7b011bb862b1802d$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("ego1F", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $a625325f636fb803$export$aafa59e2e03f2942; }, function (v) { return $a625325f636fb803$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $a625325f636fb803$export$68d8715fc104d294; }, function (v) { return $a625325f636fb803$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $a625325f636fb803$export$aafa59e2e03f2942;
var $a625325f636fb803$export$68d8715fc104d294;
$a625325f636fb803$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$a625325f636fb803$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("jtc4e", function(module, exports) {
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */ "use strict";

var $CqzF9 = parcelRequire("CqzF9");
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */ var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/, /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */ delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */ nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    javascript: true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $2PCIc = parcelRequire("2PCIc");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && typeof url === "object" && url instanceof Url) return url;
    var u = new Url();
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (typeof url !== "string") throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
    /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */ var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */ rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $2PCIc.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */ if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */ /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */ // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */ var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */ atSign = rest.lastIndexOf("@", hostEnd);
        /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */ if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */ this.hostname = this.hostname || "";
        /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */ var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */ newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */ this.hostname = $CqzF9.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */ if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */ if (!unsafeProtocol[lowerProto]) /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */ for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $2PCIc.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    // to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */ if (typeof obj === "string") obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && typeof this.query === "object" && Object.keys(this.query).length) query = $2PCIc.stringify(this.query, {
        arrayFormat: "repeat",
        addQueryPrefix: false
    });
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */ if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if (typeof relative === "string") {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */ result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        // urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
            result.pathname = "/";
            result.path = result.pathname;
        }
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */ if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */ if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */ if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (relative.search != null) {
        /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */ if (psychotic) {
            result.host = srcPath.shift();
            result.hostname = result.host;
            /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.hostname = authInHost.shift();
                result.host = result.hostname;
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        // to support http.request
        if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */ result.pathname = null;
        // to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */ var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */ var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        result.host = result.hostname;
        /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */ var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.hostname = authInHost.shift();
            result.host = result.hostname;
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (srcPath.length > 0) result.pathname = srcPath.join("/");
    else {
        result.pathname = null;
        result.path = null;
    }
    // to support request.http
    if (result.pathname !== null || result.search !== null) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;

});
parcelRegister("CqzF9", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw new RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.4.1",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) // in Node.js, io.js, or RingoJS v0.8.0+
        freeModule.exports = punycode;
        else // in Narwhal or RingoJS v0.7.0-
        for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else // in Rhino or a web browser
    root.punycode = punycode;
})(this);

});

parcelRegister("2PCIc", function(module, exports) {
"use strict";

var $43tWe = parcelRequire("43tWe");

var $7qo3i = parcelRequire("7qo3i");

var $3Y0nC = parcelRequire("3Y0nC");
module.exports = {
    formats: $3Y0nC,
    parse: $7qo3i,
    stringify: $43tWe
};

});
parcelRegister("43tWe", function(module, exports) {
"use strict";

var $5qr0W = parcelRequire("5qr0W");

var $jwHUs = parcelRequire("jwHUs");

var $3Y0nC = parcelRequire("3Y0nC");
var $2f3eaa5b844f0ec5$var$has = Object.prototype.hasOwnProperty;
var $2f3eaa5b844f0ec5$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $2f3eaa5b844f0ec5$var$isArray = Array.isArray;
var $2f3eaa5b844f0ec5$var$push = Array.prototype.push;
var $2f3eaa5b844f0ec5$var$pushToArray = function(arr, valueOrArray) {
    $2f3eaa5b844f0ec5$var$push.apply(arr, $2f3eaa5b844f0ec5$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $2f3eaa5b844f0ec5$var$toISO = Date.prototype.toISOString;
var $2f3eaa5b844f0ec5$var$defaultFormat = $3Y0nC.default;
var $2f3eaa5b844f0ec5$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $jwHUs.encode,
    encodeValuesOnly: false,
    format: $2f3eaa5b844f0ec5$var$defaultFormat,
    formatter: $3Y0nC.formatters[$2f3eaa5b844f0ec5$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $2f3eaa5b844f0ec5$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $2f3eaa5b844f0ec5$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $2f3eaa5b844f0ec5$var$sentinel = {};
var $2f3eaa5b844f0ec5$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($2f3eaa5b844f0ec5$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($2f3eaa5b844f0ec5$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $2f3eaa5b844f0ec5$var$isArray(obj)) obj = $jwHUs.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $2f3eaa5b844f0ec5$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($2f3eaa5b844f0ec5$var$isNonNullishPrimitive(obj) || $jwHUs.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $2f3eaa5b844f0ec5$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $2f3eaa5b844f0ec5$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $2f3eaa5b844f0ec5$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $jwHUs.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($2f3eaa5b844f0ec5$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $2f3eaa5b844f0ec5$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $2f3eaa5b844f0ec5$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $2f3eaa5b844f0ec5$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $5qr0W();
        valueSideChannel.set($2f3eaa5b844f0ec5$var$sentinel, sideChannel);
        $2f3eaa5b844f0ec5$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $2f3eaa5b844f0ec5$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $2f3eaa5b844f0ec5$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $2f3eaa5b844f0ec5$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $2f3eaa5b844f0ec5$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $3Y0nC.default;
    if (typeof opts.format !== "undefined") {
        if (!$2f3eaa5b844f0ec5$var$has.call($3Y0nC.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $3Y0nC.formatters[format];
    var filter = $2f3eaa5b844f0ec5$var$defaults.filter;
    if (typeof opts.filter === "function" || $2f3eaa5b844f0ec5$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $2f3eaa5b844f0ec5$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $2f3eaa5b844f0ec5$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $2f3eaa5b844f0ec5$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $2f3eaa5b844f0ec5$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $2f3eaa5b844f0ec5$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $2f3eaa5b844f0ec5$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $2f3eaa5b844f0ec5$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $2f3eaa5b844f0ec5$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $2f3eaa5b844f0ec5$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $2f3eaa5b844f0ec5$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $2f3eaa5b844f0ec5$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $2f3eaa5b844f0ec5$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $2f3eaa5b844f0ec5$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $2f3eaa5b844f0ec5$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $2f3eaa5b844f0ec5$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($2f3eaa5b844f0ec5$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $2f3eaa5b844f0ec5$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $5qr0W();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $2f3eaa5b844f0ec5$var$pushToArray(keys, $2f3eaa5b844f0ec5$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};

});
parcelRegister("5qr0W", function(module, exports) {
"use strict";

var $5PyeX = parcelRequire("5PyeX");

var $8gueU = parcelRequire("8gueU");

var $7W61V = parcelRequire("7W61V");

var $awICJ = parcelRequire("awICJ");
var $3f3455eb56ed33c9$var$$WeakMap = $5PyeX("%WeakMap%", true);
var $3f3455eb56ed33c9$var$$Map = $5PyeX("%Map%", true);
var $3f3455eb56ed33c9$var$$weakMapGet = $8gueU("WeakMap.prototype.get", true);
var $3f3455eb56ed33c9$var$$weakMapSet = $8gueU("WeakMap.prototype.set", true);
var $3f3455eb56ed33c9$var$$weakMapHas = $8gueU("WeakMap.prototype.has", true);
var $3f3455eb56ed33c9$var$$mapGet = $8gueU("Map.prototype.get", true);
var $3f3455eb56ed33c9$var$$mapSet = $8gueU("Map.prototype.set", true);
var $3f3455eb56ed33c9$var$$mapHas = $8gueU("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $3f3455eb56ed33c9$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $3f3455eb56ed33c9$var$listGet = function(objects, key) {
    var node = $3f3455eb56ed33c9$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $3f3455eb56ed33c9$var$listSet = function(objects, key, value) {
    var node = $3f3455eb56ed33c9$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $3f3455eb56ed33c9$var$listHas = function(objects, key) {
    return !!$3f3455eb56ed33c9$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $awICJ("Side channel does not contain " + $7W61V(key));
        },
        get: function(key) {
            if ($3f3455eb56ed33c9$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $3f3455eb56ed33c9$var$$weakMapGet($wm, key);
            } else if ($3f3455eb56ed33c9$var$$Map) {
                if ($m) return $3f3455eb56ed33c9$var$$mapGet($m, key);
            } else {
                if ($o) return $3f3455eb56ed33c9$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($3f3455eb56ed33c9$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $3f3455eb56ed33c9$var$$weakMapHas($wm, key);
            } else if ($3f3455eb56ed33c9$var$$Map) {
                if ($m) return $3f3455eb56ed33c9$var$$mapHas($m, key);
            } else {
                if ($o) return $3f3455eb56ed33c9$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($3f3455eb56ed33c9$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $3f3455eb56ed33c9$var$$WeakMap();
                $3f3455eb56ed33c9$var$$weakMapSet($wm, key, value);
            } else if ($3f3455eb56ed33c9$var$$Map) {
                if (!$m) $m = new $3f3455eb56ed33c9$var$$Map();
                $3f3455eb56ed33c9$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $3f3455eb56ed33c9$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("5PyeX", function(module, exports) {
"use strict";
var $43ec468c529faf46$var$undefined1;

var $7UHmp = parcelRequire("7UHmp");

var $7T6Bh = parcelRequire("7T6Bh");

var $ifeGt = parcelRequire("ifeGt");

var $kEzhq = parcelRequire("kEzhq");

var $laFZ2 = parcelRequire("laFZ2");

var $awICJ = parcelRequire("awICJ");

var $eIXnd = parcelRequire("eIXnd");
var $43ec468c529faf46$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $43ec468c529faf46$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $43ec468c529faf46$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $43ec468c529faf46$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($43ec468c529faf46$var$$gOPD) try {
    $43ec468c529faf46$var$$gOPD({}, "");
} catch (e) {
    $43ec468c529faf46$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $43ec468c529faf46$var$throwTypeError = function() {
    throw new $awICJ();
};
var $43ec468c529faf46$var$ThrowTypeError = $43ec468c529faf46$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $43ec468c529faf46$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $43ec468c529faf46$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $43ec468c529faf46$var$throwTypeError;
        }
    }
}() : $43ec468c529faf46$var$throwTypeError;

var $43ec468c529faf46$var$hasSymbols = (parcelRequire("3U9bK"))();

var $43ec468c529faf46$var$hasProto = (parcelRequire("lX0VW"))();
var $43ec468c529faf46$var$getProto = Object.getPrototypeOf || ($43ec468c529faf46$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $43ec468c529faf46$var$needsEval = {};
var $43ec468c529faf46$var$TypedArray = typeof Uint8Array === "undefined" || !$43ec468c529faf46$var$getProto ? undefined : $43ec468c529faf46$var$getProto(Uint8Array);
var $43ec468c529faf46$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $43ec468c529faf46$var$hasSymbols && $43ec468c529faf46$var$getProto ? $43ec468c529faf46$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $43ec468c529faf46$var$needsEval,
    "%AsyncGenerator%": $43ec468c529faf46$var$needsEval,
    "%AsyncGeneratorFunction%": $43ec468c529faf46$var$needsEval,
    "%AsyncIteratorPrototype%": $43ec468c529faf46$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $7UHmp,
    "%eval%": eval,
    "%EvalError%": $7T6Bh,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $43ec468c529faf46$var$$Function,
    "%GeneratorFunction%": $43ec468c529faf46$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $43ec468c529faf46$var$hasSymbols && $43ec468c529faf46$var$getProto ? $43ec468c529faf46$var$getProto($43ec468c529faf46$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$43ec468c529faf46$var$hasSymbols || !$43ec468c529faf46$var$getProto ? undefined : $43ec468c529faf46$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $ifeGt,
    "%ReferenceError%": $kEzhq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$43ec468c529faf46$var$hasSymbols || !$43ec468c529faf46$var$getProto ? undefined : $43ec468c529faf46$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $43ec468c529faf46$var$hasSymbols && $43ec468c529faf46$var$getProto ? $43ec468c529faf46$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $43ec468c529faf46$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $laFZ2,
    "%ThrowTypeError%": $43ec468c529faf46$var$ThrowTypeError,
    "%TypedArray%": $43ec468c529faf46$var$TypedArray,
    "%TypeError%": $awICJ,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $eIXnd,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($43ec468c529faf46$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $43ec468c529faf46$var$errorProto = $43ec468c529faf46$var$getProto($43ec468c529faf46$var$getProto(e));
    $43ec468c529faf46$var$INTRINSICS["%Error.prototype%"] = $43ec468c529faf46$var$errorProto;
}
var $43ec468c529faf46$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $43ec468c529faf46$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $43ec468c529faf46$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $43ec468c529faf46$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $43ec468c529faf46$var$getProto) value = $43ec468c529faf46$var$getProto(gen.prototype);
    }
    $43ec468c529faf46$var$INTRINSICS[name] = value;
    return value;
};
var $43ec468c529faf46$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gKYYg = parcelRequire("gKYYg");

var $iHO7O = parcelRequire("iHO7O");
var $43ec468c529faf46$var$$concat = $gKYYg.call(Function.call, Array.prototype.concat);
var $43ec468c529faf46$var$$spliceApply = $gKYYg.call(Function.apply, Array.prototype.splice);
var $43ec468c529faf46$var$$replace = $gKYYg.call(Function.call, String.prototype.replace);
var $43ec468c529faf46$var$$strSlice = $gKYYg.call(Function.call, String.prototype.slice);
var $43ec468c529faf46$var$$exec = $gKYYg.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $43ec468c529faf46$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $43ec468c529faf46$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $43ec468c529faf46$var$stringToPath = function stringToPath(string) {
    var first = $43ec468c529faf46$var$$strSlice(string, 0, 1);
    var last = $43ec468c529faf46$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $laFZ2("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $laFZ2("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $43ec468c529faf46$var$$replace(string, $43ec468c529faf46$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $43ec468c529faf46$var$$replace(subString, $43ec468c529faf46$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $43ec468c529faf46$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($iHO7O($43ec468c529faf46$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $43ec468c529faf46$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($iHO7O($43ec468c529faf46$var$INTRINSICS, intrinsicName)) {
        var value = $43ec468c529faf46$var$INTRINSICS[intrinsicName];
        if (value === $43ec468c529faf46$var$needsEval) value = $43ec468c529faf46$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $awICJ("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $laFZ2("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $awICJ("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $awICJ('"allowMissing" argument must be a boolean');
    if ($43ec468c529faf46$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $laFZ2("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $43ec468c529faf46$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $43ec468c529faf46$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $43ec468c529faf46$var$$spliceApply(parts, $43ec468c529faf46$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $43ec468c529faf46$var$$strSlice(part, 0, 1);
        var last = $43ec468c529faf46$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $laFZ2("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($iHO7O($43ec468c529faf46$var$INTRINSICS, intrinsicRealName)) value = $43ec468c529faf46$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $awICJ("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($43ec468c529faf46$var$$gOPD && i + 1 >= parts.length) {
                var desc = $43ec468c529faf46$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $iHO7O(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $43ec468c529faf46$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("7UHmp", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("7T6Bh", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("ifeGt", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("kEzhq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("laFZ2", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("awICJ", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("eIXnd", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("3U9bK", function(module, exports) {
"use strict";
var $2d7dbab53792d100$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $3uyHl = parcelRequire("3uyHl");
module.exports = function hasNativeSymbols() {
    if (typeof $2d7dbab53792d100$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $2d7dbab53792d100$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $3uyHl();
};

});
parcelRegister("3uyHl", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("lX0VW", function(module, exports) {
"use strict";
var $ffafd50fce0ca95c$var$test = {
    __proto__: null,
    foo: {}
};
var $ffafd50fce0ca95c$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $ffafd50fce0ca95c$var$test
    }).foo === $ffafd50fce0ca95c$var$test.foo && !($ffafd50fce0ca95c$var$test instanceof $ffafd50fce0ca95c$var$$Object);
};

});

parcelRegister("gKYYg", function(module, exports) {
"use strict";

var $hh6CO = parcelRequire("hh6CO");
module.exports = Function.prototype.bind || $hh6CO;

});
parcelRegister("hh6CO", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $c93929c3e52d8951$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $c93929c3e52d8951$var$toStr = Object.prototype.toString;
var $c93929c3e52d8951$var$max = Math.max;
var $c93929c3e52d8951$var$funcType = "[object Function]";
var $c93929c3e52d8951$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $c93929c3e52d8951$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $c93929c3e52d8951$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $c93929c3e52d8951$var$toStr.apply(target) !== $c93929c3e52d8951$var$funcType) throw new TypeError($c93929c3e52d8951$var$ERROR_MESSAGE + target);
    var args = $c93929c3e52d8951$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $c93929c3e52d8951$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $c93929c3e52d8951$var$concatty(args, arguments));
    };
    var boundLength = $c93929c3e52d8951$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $c93929c3e52d8951$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("iHO7O", function(module, exports) {
"use strict";
var $d9e31ff37bfe796b$var$call = Function.prototype.call;
var $d9e31ff37bfe796b$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gKYYg = parcelRequire("gKYYg");
/** @type {import('.')} */ module.exports = $gKYYg.call($d9e31ff37bfe796b$var$call, $d9e31ff37bfe796b$var$$hasOwn);

});


parcelRegister("8gueU", function(module, exports) {
"use strict";

var $5PyeX = parcelRequire("5PyeX");

var $3xq49 = parcelRequire("3xq49");
var $604746444f23636d$var$$indexOf = $3xq49($5PyeX("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $5PyeX(name, !!allowMissing);
    if (typeof intrinsic === "function" && $604746444f23636d$var$$indexOf(name, ".prototype.") > -1) return $3xq49(intrinsic);
    return intrinsic;
};

});
parcelRegister("3xq49", function(module, exports) {
"use strict";

var $gKYYg = parcelRequire("gKYYg");

var $5PyeX = parcelRequire("5PyeX");

var $4arBy = parcelRequire("4arBy");

var $awICJ = parcelRequire("awICJ");
var $2938ac526d070600$var$$apply = $5PyeX("%Function.prototype.apply%");
var $2938ac526d070600$var$$call = $5PyeX("%Function.prototype.call%");
var $2938ac526d070600$var$$reflectApply = $5PyeX("%Reflect.apply%", true) || $gKYYg.call($2938ac526d070600$var$$call, $2938ac526d070600$var$$apply);

var $9Sh5q = parcelRequire("9Sh5q");
var $2938ac526d070600$var$$max = $5PyeX("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $awICJ("a function is required");
    var func = $2938ac526d070600$var$$reflectApply($gKYYg, $2938ac526d070600$var$$call, arguments);
    return $4arBy(func, 1 + $2938ac526d070600$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $2938ac526d070600$var$applyBind = function applyBind() {
    return $2938ac526d070600$var$$reflectApply($gKYYg, $2938ac526d070600$var$$apply, arguments);
};
if ($9Sh5q) $9Sh5q(module.exports, "apply", {
    value: $2938ac526d070600$var$applyBind
});
else module.exports.apply = $2938ac526d070600$var$applyBind;

});
parcelRegister("4arBy", function(module, exports) {
"use strict";

var $5PyeX = parcelRequire("5PyeX");

var $gj18j = parcelRequire("gj18j");

var $308d8256086822b5$var$hasDescriptors = (parcelRequire("1Zvws"))();

var $jULaB = parcelRequire("jULaB");

var $awICJ = parcelRequire("awICJ");
var $308d8256086822b5$var$$floor = $5PyeX("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $awICJ("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $308d8256086822b5$var$$floor(length) !== length) throw new $awICJ("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $jULaB) {
        var desc = $jULaB(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($308d8256086822b5$var$hasDescriptors) $gj18j(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $gj18j(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("gj18j", function(module, exports) {
"use strict";

var $9Sh5q = parcelRequire("9Sh5q");

var $laFZ2 = parcelRequire("laFZ2");

var $awICJ = parcelRequire("awICJ");

var $jULaB = parcelRequire("jULaB");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $awICJ("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $awICJ("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $awICJ("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $awICJ("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $awICJ("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $awICJ("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$jULaB && $jULaB(obj, property);
    if ($9Sh5q) $9Sh5q(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $laFZ2("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("9Sh5q", function(module, exports) {
"use strict";

var $5PyeX = parcelRequire("5PyeX");
/** @type {import('.')} */ var $7306693506f9d8cb$var$$defineProperty = $5PyeX("%Object.defineProperty%", true) || false;
if ($7306693506f9d8cb$var$$defineProperty) try {
    $7306693506f9d8cb$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $7306693506f9d8cb$var$$defineProperty = false;
}
module.exports = $7306693506f9d8cb$var$$defineProperty;

});

parcelRegister("jULaB", function(module, exports) {
"use strict";

var $5PyeX = parcelRequire("5PyeX");
var $e7f7d64721d8215f$var$$gOPD = $5PyeX("%Object.getOwnPropertyDescriptor%", true);
if ($e7f7d64721d8215f$var$$gOPD) try {
    $e7f7d64721d8215f$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $e7f7d64721d8215f$var$$gOPD = null;
}
module.exports = $e7f7d64721d8215f$var$$gOPD;

});


parcelRegister("1Zvws", function(module, exports) {
"use strict";

var $9Sh5q = parcelRequire("9Sh5q");
var $1733f0a586e4b8be$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$9Sh5q;
};
$1733f0a586e4b8be$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$9Sh5q) return null;
    try {
        return $9Sh5q([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $1733f0a586e4b8be$var$hasPropertyDescriptors;

});




parcelRegister("7W61V", function(module, exports) {
var $5c72a0a07d18d12b$var$hasMap = typeof Map === "function" && Map.prototype;
var $5c72a0a07d18d12b$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $5c72a0a07d18d12b$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $5c72a0a07d18d12b$var$mapSize = $5c72a0a07d18d12b$var$hasMap && $5c72a0a07d18d12b$var$mapSizeDescriptor && typeof $5c72a0a07d18d12b$var$mapSizeDescriptor.get === "function" ? $5c72a0a07d18d12b$var$mapSizeDescriptor.get : null;
var $5c72a0a07d18d12b$var$mapForEach = $5c72a0a07d18d12b$var$hasMap && Map.prototype.forEach;
var $5c72a0a07d18d12b$var$hasSet = typeof Set === "function" && Set.prototype;
var $5c72a0a07d18d12b$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $5c72a0a07d18d12b$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $5c72a0a07d18d12b$var$setSize = $5c72a0a07d18d12b$var$hasSet && $5c72a0a07d18d12b$var$setSizeDescriptor && typeof $5c72a0a07d18d12b$var$setSizeDescriptor.get === "function" ? $5c72a0a07d18d12b$var$setSizeDescriptor.get : null;
var $5c72a0a07d18d12b$var$setForEach = $5c72a0a07d18d12b$var$hasSet && Set.prototype.forEach;
var $5c72a0a07d18d12b$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $5c72a0a07d18d12b$var$weakMapHas = $5c72a0a07d18d12b$var$hasWeakMap ? WeakMap.prototype.has : null;
var $5c72a0a07d18d12b$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $5c72a0a07d18d12b$var$weakSetHas = $5c72a0a07d18d12b$var$hasWeakSet ? WeakSet.prototype.has : null;
var $5c72a0a07d18d12b$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $5c72a0a07d18d12b$var$weakRefDeref = $5c72a0a07d18d12b$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $5c72a0a07d18d12b$var$booleanValueOf = Boolean.prototype.valueOf;
var $5c72a0a07d18d12b$var$objectToString = Object.prototype.toString;
var $5c72a0a07d18d12b$var$functionToString = Function.prototype.toString;
var $5c72a0a07d18d12b$var$$match = String.prototype.match;
var $5c72a0a07d18d12b$var$$slice = String.prototype.slice;
var $5c72a0a07d18d12b$var$$replace = String.prototype.replace;
var $5c72a0a07d18d12b$var$$toUpperCase = String.prototype.toUpperCase;
var $5c72a0a07d18d12b$var$$toLowerCase = String.prototype.toLowerCase;
var $5c72a0a07d18d12b$var$$test = RegExp.prototype.test;
var $5c72a0a07d18d12b$var$$concat = Array.prototype.concat;
var $5c72a0a07d18d12b$var$$join = Array.prototype.join;
var $5c72a0a07d18d12b$var$$arrSlice = Array.prototype.slice;
var $5c72a0a07d18d12b$var$$floor = Math.floor;
var $5c72a0a07d18d12b$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $5c72a0a07d18d12b$var$gOPS = Object.getOwnPropertySymbols;
var $5c72a0a07d18d12b$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $5c72a0a07d18d12b$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $5c72a0a07d18d12b$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $5c72a0a07d18d12b$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $5c72a0a07d18d12b$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $5c72a0a07d18d12b$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $5c72a0a07d18d12b$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $5c72a0a07d18d12b$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$5c72a0a07d18d12b$var$$floor(-num) : $5c72a0a07d18d12b$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $5c72a0a07d18d12b$var$$slice.call(str, intStr.length + 1);
            return $5c72a0a07d18d12b$var$$replace.call(intStr, sepRegex, "$&_") + "." + $5c72a0a07d18d12b$var$$replace.call($5c72a0a07d18d12b$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $5c72a0a07d18d12b$var$$replace.call(str, sepRegex, "$&_");
}

var $lRV8A = parcelRequire("lRV8A");
var $5c72a0a07d18d12b$var$inspectCustom = $lRV8A.custom;
var $5c72a0a07d18d12b$var$inspectSymbol = $5c72a0a07d18d12b$var$isSymbol($5c72a0a07d18d12b$var$inspectCustom) ? $5c72a0a07d18d12b$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($5c72a0a07d18d12b$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($5c72a0a07d18d12b$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $5c72a0a07d18d12b$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($5c72a0a07d18d12b$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($5c72a0a07d18d12b$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $5c72a0a07d18d12b$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $5c72a0a07d18d12b$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $5c72a0a07d18d12b$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $5c72a0a07d18d12b$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $5c72a0a07d18d12b$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($5c72a0a07d18d12b$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $5c72a0a07d18d12b$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($5c72a0a07d18d12b$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$5c72a0a07d18d12b$var$isRegExp(obj)) {
        var name = $5c72a0a07d18d12b$var$nameOf(obj);
        var keys = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $5c72a0a07d18d12b$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($5c72a0a07d18d12b$var$isSymbol(obj)) {
        var symString = $5c72a0a07d18d12b$var$hasShammedSymbols ? $5c72a0a07d18d12b$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $5c72a0a07d18d12b$var$symToString.call(obj);
        return typeof obj === "object" && !$5c72a0a07d18d12b$var$hasShammedSymbols ? $5c72a0a07d18d12b$var$markBoxed(symString) : symString;
    }
    if ($5c72a0a07d18d12b$var$isElement(obj)) {
        var s = "<" + $5c72a0a07d18d12b$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $5c72a0a07d18d12b$var$wrapQuotes($5c72a0a07d18d12b$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $5c72a0a07d18d12b$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($5c72a0a07d18d12b$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        if (indent && !$5c72a0a07d18d12b$var$singleLineValues(xs)) return "[" + $5c72a0a07d18d12b$var$indentedJoin(xs, indent) + "]";
        return "[ " + $5c72a0a07d18d12b$var$$join.call(xs, ", ") + " ]";
    }
    if ($5c72a0a07d18d12b$var$isError(obj)) {
        var parts = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$5c72a0a07d18d12b$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $5c72a0a07d18d12b$var$$join.call($5c72a0a07d18d12b$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $5c72a0a07d18d12b$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($5c72a0a07d18d12b$var$inspectSymbol && typeof obj[$5c72a0a07d18d12b$var$inspectSymbol] === "function" && $lRV8A) return $lRV8A(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($5c72a0a07d18d12b$var$isMap(obj)) {
        var mapParts = [];
        if ($5c72a0a07d18d12b$var$mapForEach) $5c72a0a07d18d12b$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $5c72a0a07d18d12b$var$collectionOf("Map", $5c72a0a07d18d12b$var$mapSize.call(obj), mapParts, indent);
    }
    if ($5c72a0a07d18d12b$var$isSet(obj)) {
        var setParts = [];
        if ($5c72a0a07d18d12b$var$setForEach) $5c72a0a07d18d12b$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $5c72a0a07d18d12b$var$collectionOf("Set", $5c72a0a07d18d12b$var$setSize.call(obj), setParts, indent);
    }
    if ($5c72a0a07d18d12b$var$isWeakMap(obj)) return $5c72a0a07d18d12b$var$weakCollectionOf("WeakMap");
    if ($5c72a0a07d18d12b$var$isWeakSet(obj)) return $5c72a0a07d18d12b$var$weakCollectionOf("WeakSet");
    if ($5c72a0a07d18d12b$var$isWeakRef(obj)) return $5c72a0a07d18d12b$var$weakCollectionOf("WeakRef");
    if ($5c72a0a07d18d12b$var$isNumber(obj)) return $5c72a0a07d18d12b$var$markBoxed(inspect(Number(obj)));
    if ($5c72a0a07d18d12b$var$isBigInt(obj)) return $5c72a0a07d18d12b$var$markBoxed(inspect($5c72a0a07d18d12b$var$bigIntValueOf.call(obj)));
    if ($5c72a0a07d18d12b$var$isBoolean(obj)) return $5c72a0a07d18d12b$var$markBoxed($5c72a0a07d18d12b$var$booleanValueOf.call(obj));
    if ($5c72a0a07d18d12b$var$isString(obj)) return $5c72a0a07d18d12b$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (typeof globalThis !== "undefined" && obj === globalThis || typeof $parcel$global !== "undefined" && obj === $parcel$global) return "{ [object globalThis] }";
    if (!$5c72a0a07d18d12b$var$isDate(obj) && !$5c72a0a07d18d12b$var$isRegExp(obj)) {
        var ys = $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect);
        var isPlainObject = $5c72a0a07d18d12b$var$gPO ? $5c72a0a07d18d12b$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $5c72a0a07d18d12b$var$toStringTag && Object(obj) === obj && $5c72a0a07d18d12b$var$toStringTag in obj ? $5c72a0a07d18d12b$var$$slice.call($5c72a0a07d18d12b$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $5c72a0a07d18d12b$var$$join.call($5c72a0a07d18d12b$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $5c72a0a07d18d12b$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $5c72a0a07d18d12b$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $5c72a0a07d18d12b$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $5c72a0a07d18d12b$var$quote(s) {
    return $5c72a0a07d18d12b$var$$replace.call(String(s), /"/g, "&quot;");
}
function $5c72a0a07d18d12b$var$isArray(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object Array]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
function $5c72a0a07d18d12b$var$isDate(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object Date]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
function $5c72a0a07d18d12b$var$isRegExp(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object RegExp]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
function $5c72a0a07d18d12b$var$isError(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object Error]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
function $5c72a0a07d18d12b$var$isString(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object String]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
function $5c72a0a07d18d12b$var$isNumber(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object Number]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
function $5c72a0a07d18d12b$var$isBoolean(obj) {
    return $5c72a0a07d18d12b$var$toStr(obj) === "[object Boolean]" && (!$5c72a0a07d18d12b$var$toStringTag || !(typeof obj === "object" && $5c72a0a07d18d12b$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $5c72a0a07d18d12b$var$isSymbol(obj) {
    if ($5c72a0a07d18d12b$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$5c72a0a07d18d12b$var$symToString) return false;
    try {
        $5c72a0a07d18d12b$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$5c72a0a07d18d12b$var$bigIntValueOf) return false;
    try {
        $5c72a0a07d18d12b$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $5c72a0a07d18d12b$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $5c72a0a07d18d12b$var$has(obj, key) {
    return $5c72a0a07d18d12b$var$hasOwn.call(obj, key);
}
function $5c72a0a07d18d12b$var$toStr(obj) {
    return $5c72a0a07d18d12b$var$objectToString.call(obj);
}
function $5c72a0a07d18d12b$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $5c72a0a07d18d12b$var$$match.call($5c72a0a07d18d12b$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $5c72a0a07d18d12b$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $5c72a0a07d18d12b$var$isMap(x) {
    if (!$5c72a0a07d18d12b$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $5c72a0a07d18d12b$var$mapSize.call(x);
        try {
            $5c72a0a07d18d12b$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isWeakMap(x) {
    if (!$5c72a0a07d18d12b$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $5c72a0a07d18d12b$var$weakMapHas.call(x, $5c72a0a07d18d12b$var$weakMapHas);
        try {
            $5c72a0a07d18d12b$var$weakSetHas.call(x, $5c72a0a07d18d12b$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isWeakRef(x) {
    if (!$5c72a0a07d18d12b$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $5c72a0a07d18d12b$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isSet(x) {
    if (!$5c72a0a07d18d12b$var$setSize || !x || typeof x !== "object") return false;
    try {
        $5c72a0a07d18d12b$var$setSize.call(x);
        try {
            $5c72a0a07d18d12b$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isWeakSet(x) {
    if (!$5c72a0a07d18d12b$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $5c72a0a07d18d12b$var$weakSetHas.call(x, $5c72a0a07d18d12b$var$weakSetHas);
        try {
            $5c72a0a07d18d12b$var$weakMapHas.call(x, $5c72a0a07d18d12b$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $5c72a0a07d18d12b$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $5c72a0a07d18d12b$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $5c72a0a07d18d12b$var$inspectString($5c72a0a07d18d12b$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $5c72a0a07d18d12b$var$$replace.call($5c72a0a07d18d12b$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $5c72a0a07d18d12b$var$lowbyte);
    return $5c72a0a07d18d12b$var$wrapQuotes(s, "single", opts);
}
function $5c72a0a07d18d12b$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $5c72a0a07d18d12b$var$$toUpperCase.call(n.toString(16));
}
function $5c72a0a07d18d12b$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $5c72a0a07d18d12b$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $5c72a0a07d18d12b$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $5c72a0a07d18d12b$var$indentedJoin(entries, indent) : $5c72a0a07d18d12b$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $5c72a0a07d18d12b$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($5c72a0a07d18d12b$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $5c72a0a07d18d12b$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $5c72a0a07d18d12b$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $5c72a0a07d18d12b$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $5c72a0a07d18d12b$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $5c72a0a07d18d12b$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $5c72a0a07d18d12b$var$arrObjKeys(obj, inspect) {
    var isArr = $5c72a0a07d18d12b$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $5c72a0a07d18d12b$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $5c72a0a07d18d12b$var$gOPS === "function" ? $5c72a0a07d18d12b$var$gOPS(obj) : [];
    var symMap;
    if ($5c72a0a07d18d12b$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$5c72a0a07d18d12b$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($5c72a0a07d18d12b$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($5c72a0a07d18d12b$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $5c72a0a07d18d12b$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($5c72a0a07d18d12b$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("lRV8A", function(module, exports) {
"use strict";

});



parcelRegister("jwHUs", function(module, exports) {
"use strict";

var $3Y0nC = parcelRequire("3Y0nC");
var $e37310fd4effed3f$var$has = Object.prototype.hasOwnProperty;
var $e37310fd4effed3f$var$isArray = Array.isArray;
var $e37310fd4effed3f$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $e37310fd4effed3f$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($e37310fd4effed3f$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $e37310fd4effed3f$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $e37310fd4effed3f$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($e37310fd4effed3f$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$e37310fd4effed3f$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($e37310fd4effed3f$var$isArray(target) && !$e37310fd4effed3f$var$isArray(source)) mergeTarget = $e37310fd4effed3f$var$arrayToObject(target, options);
    if ($e37310fd4effed3f$var$isArray(target) && $e37310fd4effed3f$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($e37310fd4effed3f$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($e37310fd4effed3f$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $e37310fd4effed3f$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $e37310fd4effed3f$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $e37310fd4effed3f$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $e37310fd4effed3f$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $e37310fd4effed3f$var$limit){
        var segment = string.length >= $e37310fd4effed3f$var$limit ? string.slice(j, j + $e37310fd4effed3f$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $3Y0nC.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $e37310fd4effed3f$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $e37310fd4effed3f$var$hexTable[0xC0 | c >> 6] + $e37310fd4effed3f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $e37310fd4effed3f$var$hexTable[0xE0 | c >> 12] + $e37310fd4effed3f$var$hexTable[0x80 | c >> 6 & 0x3F] + $e37310fd4effed3f$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $e37310fd4effed3f$var$hexTable[0xF0 | c >> 18] + $e37310fd4effed3f$var$hexTable[0x80 | c >> 12 & 0x3F] + $e37310fd4effed3f$var$hexTable[0x80 | c >> 6 & 0x3F] + $e37310fd4effed3f$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $e37310fd4effed3f$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $e37310fd4effed3f$var$compactQueue(queue);
    return value;
};
var $e37310fd4effed3f$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $e37310fd4effed3f$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $e37310fd4effed3f$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $e37310fd4effed3f$var$maybeMap = function maybeMap(val, fn) {
    if ($e37310fd4effed3f$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $e37310fd4effed3f$var$arrayToObject,
    assign: $e37310fd4effed3f$var$assign,
    combine: $e37310fd4effed3f$var$combine,
    compact: $e37310fd4effed3f$var$compact,
    decode: $e37310fd4effed3f$var$decode,
    encode: $e37310fd4effed3f$var$encode,
    isBuffer: $e37310fd4effed3f$var$isBuffer,
    isRegExp: $e37310fd4effed3f$var$isRegExp,
    maybeMap: $e37310fd4effed3f$var$maybeMap,
    merge: $e37310fd4effed3f$var$merge
};

});
parcelRegister("3Y0nC", function(module, exports) {
"use strict";
var $2e374521000e7610$var$replace = String.prototype.replace;
var $2e374521000e7610$var$percentTwenties = /%20/g;
var $2e374521000e7610$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
module.exports = {
    "default": $2e374521000e7610$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $2e374521000e7610$var$replace.call(value, $2e374521000e7610$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $2e374521000e7610$var$Format.RFC1738,
    RFC3986: $2e374521000e7610$var$Format.RFC3986
};

});



parcelRegister("7qo3i", function(module, exports) {
"use strict";

var $jwHUs = parcelRequire("jwHUs");
var $567d9e5e51296175$var$has = Object.prototype.hasOwnProperty;
var $567d9e5e51296175$var$isArray = Array.isArray;
var $567d9e5e51296175$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $jwHUs.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $567d9e5e51296175$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $567d9e5e51296175$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $567d9e5e51296175$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $567d9e5e51296175$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $567d9e5e51296175$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $567d9e5e51296175$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $567d9e5e51296175$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $567d9e5e51296175$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $567d9e5e51296175$var$defaults.decoder, charset, "key");
            val = $jwHUs.maybeMap($567d9e5e51296175$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $567d9e5e51296175$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $567d9e5e51296175$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $567d9e5e51296175$var$isArray(val) ? [
            val
        ] : val;
        var existing = $567d9e5e51296175$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $jwHUs.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $567d9e5e51296175$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $567d9e5e51296175$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $567d9e5e51296175$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $567d9e5e51296175$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $567d9e5e51296175$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push("[" + key.slice(segment.index) + "]");
    return $567d9e5e51296175$var$parseObject(keys, val, options, valuesParsed);
};
var $567d9e5e51296175$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $567d9e5e51296175$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $567d9e5e51296175$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $567d9e5e51296175$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $567d9e5e51296175$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $567d9e5e51296175$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $567d9e5e51296175$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $567d9e5e51296175$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $567d9e5e51296175$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $567d9e5e51296175$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $567d9e5e51296175$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $567d9e5e51296175$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $567d9e5e51296175$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $jwHUs.isRegExp(opts.delimiter) ? opts.delimiter : $567d9e5e51296175$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $567d9e5e51296175$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $567d9e5e51296175$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $567d9e5e51296175$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $567d9e5e51296175$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $567d9e5e51296175$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $567d9e5e51296175$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $567d9e5e51296175$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $567d9e5e51296175$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $jwHUs.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $jwHUs.compact(obj);
};

});







parcelRegister("kZj5j", function(module, exports) {

$parcel$export(module.exports, "applications", function () { return $99aa4c86835578dc$export$e7ad650a602a37dc; });
$parcel$export(module.exports, "applicationSelector", function () { return $99aa4c86835578dc$export$5b2ad1bf581a1d7b; });
$parcel$export(module.exports, "lookupApplication", function () { return $99aa4c86835578dc$export$105c92f8798550c7; });
$parcel$export(module.exports, "cobrandingURLParams", function () { return $99aa4c86835578dc$export$5a5f77d52a5485dc; });
$parcel$export(module.exports, "getMicrobrandingFromUrl", function () { return $99aa4c86835578dc$export$dace4fb1afc7ad6b; });
$parcel$export(module.exports, "isTrelloDesktop", function () { return $99aa4c86835578dc$export$5824ecd2b22a2ece; });

var $jSnDV = parcelRequire("jSnDV");
parcelRequire("6jPF3");
var $hzjk7 = parcelRequire("hzjk7");
const $99aa4c86835578dc$export$e7ad650a602a37dc = {
    admin: {
        name: "Adminhub",
        useInLoginPrompt: false
    },
    access: {
        name: "Adminhub",
        useInLoginPrompt: false
    },
    ace: {
        name: "Atlassian Community Events",
        useInLoginPrompt: false
    },
    atlas: {
        name: "Atlas",
        useInLoginPrompt: true
    },
    bitbucket: {
        name: "Bitbucket",
        useInLoginPrompt: true
    },
    cac: {
        name: "Documentation",
        useInLoginPrompt: true
    },
    dac: {
        name: "Developer Portal",
        useInLoginPrompt: true
    },
    experts: {
        name: "Partner Program",
        useInLoginPrompt: true
    },
    "itap-uat-backend": {
        name: "itap-uat-backend",
        useInLoginPrompt: false
    },
    jac: {
        name: "Atlassian Bug Reporting & Feature Requests"
    },
    mpac: {
        name: "Marketplace",
        useInLoginPrompt: true
    },
    profile: {
        name: "Atlassian"
    },
    "manage-profile": {
        name: "Atlassian account",
        useInLoginPrompt: false
    },
    sac: {
        name: "Support",
        useInLoginPrompt: true
    },
    teamcentral: {
        name: "Team Central",
        useInLoginPrompt: false
    },
    trello: {
        name: "Trello",
        useInLoginPrompt: true
    },
    mac: {
        name: "My Atlassian",
        useInLoginPrompt: true
    },
    jira: {
        name: "Jira",
        useInLoginPrompt: true
    },
    loom: {
        name: "Loom",
        useInLoginPrompt: true
    },
    "jira-align": {
        name: "Jira Align",
        useInLoginPrompt: true
    },
    confluence: {
        name: "Confluence",
        useInLoginPrompt: true
    },
    ondemand: {
        name: "Atlassian Cloud",
        useInLoginPrompt: false
    },
    opsgenie: {
        name: "Opsgenie",
        useInLoginPrompt: true
    },
    start: {
        name: "Start",
        useInLoginPrompt: false
    },
    megamanzero: {
        name: "MegamanZero",
        useInLoginPrompt: false
    },
    pollinator: {
        // for functional testing
        name: "Pollinator",
        useInLoginPrompt: false
    },
    wac: {
        name: "Atlassian",
        useInLoginPrompt: false
    },
    compass: {
        name: "Compass",
        useInLoginPrompt: true
    },
    sourcetree: {
        name: "Sourcetree",
        useInLoginPrompt: false
    },
    statuspage: {
        name: "Statuspage"
    },
    uac: {
        name: "UAC",
        useInLoginPrompt: false
    }
};
const $99aa4c86835578dc$export$5b2ad1bf581a1d7b = (0, $hzjk7.createSelector)((state)=>state.cobranding, (cobranding)=>$99aa4c86835578dc$export$105c92f8798550c7(cobranding));
function $99aa4c86835578dc$export$105c92f8798550c7(cobranding) {
    const applicationFromContinue = $99aa4c86835578dc$var$applicationFromContinueUrl();
    const { application: applicationFromQueryParameter, experience: experienceFromQueryParameter } = $99aa4c86835578dc$var$applicationFromApplicationQueryParameter();
    const application = cobranding.derivedApplication || applicationFromContinue || applicationFromQueryParameter;
    const experience = cobranding.experience || experienceFromQueryParameter;
    if (application) {
        const appData = $99aa4c86835578dc$export$e7ad650a602a37dc[application];
        if (appData) return {
            application: application,
            experience: experience,
            ...appData
        };
    }
    return null;
}
const $99aa4c86835578dc$export$5a5f77d52a5485dc = (location, productHint)=>{
    const params = $jSnDV.parse(location.search);
    const allParams = productHint !== undefined && productHint !== null ? {
        ...params,
        productHint: productHint
    } : {
        ...params
    };
    const filteredCobrandingParams = Object.keys(allParams).filter((key)=>[
            "continue",
            "application",
            "display",
            "productHint"
        ].includes(key)).reduce((o, key)=>{
        o[key] = allParams[key];
        return o;
    }, {});
    const cobrandingURLParams = filteredCobrandingParams && Object.keys(filteredCobrandingParams).length ? {
        ...filteredCobrandingParams
    } : "";
    return cobrandingURLParams;
};
function $99aa4c86835578dc$export$dace4fb1afc7ad6b(location) {
    const params = $jSnDV.parse(location.search);
    return Object.keys(params).filter((key)=>[
            "application",
            "continue",
            "tenant"
        ].includes(key)).reduce((o, key)=>{
        o[key] = params[key];
        return o;
    }, {});
}
const $99aa4c86835578dc$export$ae5bd94b7585e9d5 = [
    "/admin",
    "/login",
    "/logout",
    "/impersonate",
    "/home",
    "/people",
    "/trusted-admin"
];
/**
 * Determine the cobranding application from the `?continue=...` URL param as a last resort.
 *
 * **This code should _only_ be relied upon for situations where passing an `?application=...`
 * param or product hint is not possible**, such as within Slack's direct initiate flow. In OIDC
 * flows applications should pass a product hint, and in all other flows applications should pass
 * an `?application=...` param to id.a.c.
 */ function $99aa4c86835578dc$var$applicationFromContinueUrl() {
    const params = $jSnDV.parse(window.location.search);
    const continueParam = params.continue;
    if (!continueParam) return null;
    try {
        const continueUrl = new URL(continueParam, window.location.origin);
        const { hostname: hostname, pathname: pathname, searchParams: searchParams } = continueUrl;
        if ([
            "bitbucket.org",
            "integration.bb-inf.net"
        ].includes(hostname)) return "bitbucket";
        else if ([
            ".opsgenie.com",
            ".opsgeni.us"
        ].some((domain)=>hostname.endsWith(domain))) return "opsgenie";
        else if ([
            "manage.statuspage.io",
            "manage.statuspagestaging.com"
        ].includes(hostname)) return "statuspage";
        else if ([
            "trello.com",
            "trellis.coffee"
        ].includes(hostname)) return "trello";
        else if ([
            "atlassian.com",
            "www.atlassian.com",
            "wac.stg.internal.atlassian.com"
        ].includes(hostname)) return "wac";
        else if ([
            "team.atlassian.com",
            "team.stg.atlassian.com"
        ].includes(hostname)) return "atlas";
        else if ([
            ".atlassian.net",
            "atlassian-fex.net",
            ".jira-dev.com"
        ].some((domain)=>hostname.endsWith(domain))) {
            const unwrappedContinueUrl = pathname === "/login" && searchParams.get("dest-url") ? new URL(searchParams.get("dest-url"), continueUrl) : continueUrl;
            const { pathname: unwrappedPathname } = unwrappedContinueUrl;
            if (unwrappedPathname === "/wiki" || unwrappedPathname.startsWith("/wiki/")) return "confluence";
            else if (unwrappedPathname === "/compass" || unwrappedPathname.startsWith("/compass/")) return "compass";
            else if (// Root could be Jira or Conflience
            unwrappedPathname !== "/" && !$99aa4c86835578dc$export$ae5bd94b7585e9d5.some((prefix)=>unwrappedPathname === prefix || unwrappedPathname.startsWith(`${prefix}/`))) return "jira";
        }
    } catch (error) {
    // Malformed URL, ignore
    }
    return null;
}
function $99aa4c86835578dc$var$applicationFromApplicationQueryParameter() {
    try {
        var _get;
        const [application, experience] = ((_get = new URLSearchParams(window.location.search).get("application")) === null || _get === void 0 ? void 0 : _get.split("--")) || [];
        if (application && $99aa4c86835578dc$var$isValidApplication(application)) return {
            application: application,
            experience: experience
        };
    } catch (error) {
    // Malformed query parameter, ignore
    }
    return {
        application: null,
        experience: null
    };
}
function $99aa4c86835578dc$export$5824ecd2b22a2ece() {
    const userAgent = window.navigator.userAgent;
    return userAgent.includes("TrelloDesktop");
}
const $99aa4c86835578dc$export$e248db7c9a3cd59 = (app)=>app && $99aa4c86835578dc$export$e7ad650a602a37dc[app] ? $99aa4c86835578dc$export$e7ad650a602a37dc[app].name : "Atlassian";
const $99aa4c86835578dc$var$isValidApplication = (application)=>Object.keys($99aa4c86835578dc$export$e7ad650a602a37dc).includes(application);

});
parcelRegister("6jPF3", function(module, exports) {

$parcel$export(module.exports, "configureStore", function () { return $499c9742106f24f5$export$7d8a5b498da695ac; });
$parcel$export(module.exports, "createSelector", function () { return (parcelRequire("hzjk7")).createSelector; });

var $ePY9n = parcelRequire("ePY9n");

var $l2d2N = parcelRequire("l2d2N");

var $hzjk7 = parcelRequire("hzjk7");

var $bE8SV = parcelRequire("bE8SV");

var $1RdT6 = parcelRequire("1RdT6");
var $499c9742106f24f5$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $499c9742106f24f5$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $499c9742106f24f5$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from) {
    for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
    return to;
};
var $499c9742106f24f5$var$__defProp = Object.defineProperty;
var $499c9742106f24f5$var$__defProps = Object.defineProperties;
var $499c9742106f24f5$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $499c9742106f24f5$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $499c9742106f24f5$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $499c9742106f24f5$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $499c9742106f24f5$var$__defNormalProp = function(obj, key, value) {
    return key in obj ? $499c9742106f24f5$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
};
var $499c9742106f24f5$var$__spreadValues = function(a, b) {
    for(var prop in b || (b = {}))if ($499c9742106f24f5$var$__hasOwnProp.call(b, prop)) $499c9742106f24f5$var$__defNormalProp(a, prop, b[prop]);
    if ($499c9742106f24f5$var$__getOwnPropSymbols) for(var _i = 0, _c = $499c9742106f24f5$var$__getOwnPropSymbols(b); _i < _c.length; _i++){
        var prop = _c[_i];
        if ($499c9742106f24f5$var$__propIsEnum.call(b, prop)) $499c9742106f24f5$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $499c9742106f24f5$var$__spreadProps = function(a, b) {
    return $499c9742106f24f5$var$__defProps(a, $499c9742106f24f5$var$__getOwnPropDescs(b));
};
var $499c9742106f24f5$var$__async = function(__this, __arguments, generator) {
    return new Promise(function(resolve, reject) {
        var fulfilled = function(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function(value) {
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function(x) {
            return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $499c9742106f24f5$export$a5d3c27355e35910 = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var selector = (0, $hzjk7.createSelector).apply(void 0, args);
    var wrappedSelector = function(value) {
        var rest = [];
        for(var _i = 1; _i < arguments.length; _i++)rest[_i - 1] = arguments[_i];
        return selector.apply(void 0, $499c9742106f24f5$var$__spreadArray([
            (0, $ePY9n.isDraft)(value) ? (0, $ePY9n.current)(value) : value
        ], rest));
    };
    return wrappedSelector;
};
var $499c9742106f24f5$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $l2d2N.compose;
    return (0, $l2d2N.compose).apply(null, arguments);
};
var $499c9742106f24f5$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function $499c9742106f24f5$export$53b83ca8eaab0383(value) {
    if (typeof value !== "object" || value === null) return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/tsHelpers.ts
var $499c9742106f24f5$var$hasMatchFunction = function(v) {
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $499c9742106f24f5$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) throw new Error("prepareAction did not return an object");
            return $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = function() {
        return "" + type;
    };
    actionCreator.type = type;
    actionCreator.match = function(action) {
        return action.type === type;
    };
    return actionCreator;
}
function $499c9742106f24f5$export$b956e38827fca970(action) {
    return $499c9742106f24f5$export$53b83ca8eaab0383(action) && "type" in action;
}
function $499c9742106f24f5$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && $499c9742106f24f5$var$hasMatchFunction(action);
}
function $499c9742106f24f5$export$ebd532f9034651f3(action) {
    return $499c9742106f24f5$export$b956e38827fca970(action) && typeof action.type === "string" && Object.keys(action).every($499c9742106f24f5$var$isValidKey);
}
function $499c9742106f24f5$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
function $499c9742106f24f5$export$e2b5c5db9e2009fd(actionCreator) {
    return "" + actionCreator;
}
// src/actionCreatorInvariantMiddleware.ts
function $499c9742106f24f5$var$getMessage(type) {
    var splitType = type ? ("" + type).split("/") : [];
    var actionName = splitType[splitType.length - 1] || "actionCreator";
    return 'Detected an action creator with type "' + (type || "unknown") + "\" being dispatched. \nMake sure you're calling the action creator before dispatching, i.e. `dispatch(" + actionName + "())` instead of `dispatch(" + actionName + ")`. This is necessary even if the action has no payload.";
}
function $499c9742106f24f5$export$6a1fcb4ceef578f(options) {
    if (options === void 0) options = {};
    var _c, isActionCreator2;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
function $499c9742106f24f5$var$getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function(fn) {
            var started = Date.now();
            try {
                return fn();
            } finally{
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function() {
            if (elapsed > maxDelay) console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
        }
    };
}
var $499c9742106f24f5$export$20df1e9bd1a54f25 = /** @class */ function(_super) {
    $499c9742106f24f5$var$__extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function() {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (MiddlewareArray.bind.apply(MiddlewareArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (MiddlewareArray.bind.apply(MiddlewareArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array);
var $499c9742106f24f5$export$490d10040a0cbe8a = /** @class */ function(_super) {
    $499c9742106f24f5$var$__extends(EnhancerArray, _super);
    function EnhancerArray() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, EnhancerArray.prototype);
        return _this;
    }
    Object.defineProperty(EnhancerArray, Symbol.species, {
        get: function() {
            return EnhancerArray;
        },
        enumerable: false,
        configurable: true
    });
    EnhancerArray.prototype.concat = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        return _super.prototype.concat.apply(this, arr);
    };
    EnhancerArray.prototype.prepend = function() {
        var arr = [];
        for(var _i = 0; _i < arguments.length; _i++)arr[_i] = arguments[_i];
        if (arr.length === 1 && Array.isArray(arr[0])) return new (EnhancerArray.bind.apply(EnhancerArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr[0].concat(this))))();
        return new (EnhancerArray.bind.apply(EnhancerArray, $499c9742106f24f5$var$__spreadArray([
            void 0
        ], arr.concat(this))))();
    };
    return EnhancerArray;
}(Array);
function $499c9742106f24f5$var$freezeDraftable(val) {
    return (0, $ePY9n.isDraftable)(val) ? (0, $ePY9n.default)(val, function() {}) : val;
}
// src/immutableStateInvariantMiddleware.ts
var $499c9742106f24f5$var$isProduction = true;
var $499c9742106f24f5$var$prefix = "Invariant failed";
function $499c9742106f24f5$var$invariant(condition, message) {
    if (condition) return;
    if ($499c9742106f24f5$var$isProduction) throw new Error($499c9742106f24f5$var$prefix);
    throw new Error($499c9742106f24f5$var$prefix + ": " + (message || ""));
}
function $499c9742106f24f5$var$stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, $499c9742106f24f5$var$getSerialize(serializer, decycler), indent);
}
function $499c9742106f24f5$var$getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler) decycler = function(_, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
    };
    return function(key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function $499c9742106f24f5$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $499c9742106f24f5$var$trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = $499c9742106f24f5$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function() {
            return $499c9742106f24f5$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $499c9742106f24f5$var$trackProperties(isImmutable, ignorePaths, obj, path, checkedObjects) {
    if (ignorePaths === void 0) ignorePaths = [];
    if (path === void 0) path = "";
    if (checkedObjects === void 0) checkedObjects = new Set();
    var tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(var key in obj){
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $499c9742106f24f5$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $499c9742106f24f5$var$detectMutations(isImmutable, ignoredPaths, trackedProperty, obj, sameParentRef, path) {
    if (ignoredPaths === void 0) ignoredPaths = [];
    if (sameParentRef === void 0) sameParentRef = false;
    if (path === void 0) path = "";
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    var keysToDetect = {};
    for(var key in trackedProperty.children)keysToDetect[key] = true;
    for(var key in obj)keysToDetect[key] = true;
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_1 = function(key) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        var result = $499c9742106f24f5$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return {
            value: result
        };
    };
    for(var key in keysToDetect){
        var state_1 = _loop_1(key);
        if (typeof state_1 === "object") return state_1.value;
    }
    return {
        wasMutated: false
    };
}
function $499c9742106f24f5$export$9181bb1a5474289(options) {
    if (options === void 0) options = {};
    var _c, isImmutable, ignoredPaths, _d, warnAfter, ignore, track;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/serializableStateInvariantMiddleware.ts
function $499c9742106f24f5$export$77670485918dab4e(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || $499c9742106f24f5$export$53b83ca8eaab0383(val);
}
function $499c9742106f24f5$export$ada5dca0b571bc7(value, path, isSerializable, getEntries, ignoredPaths, cache) {
    if (path === void 0) path = "";
    if (isSerializable === void 0) isSerializable = $499c9742106f24f5$export$77670485918dab4e;
    if (ignoredPaths === void 0) ignoredPaths = [];
    var foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    var _loop_2 = function(key, nestedValue) {
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            var hasMatches = ignoredPaths.some(function(ignored) {
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) return "continue";
        }
        if (!isSerializable(nestedValue)) return {
            value: {
                keyPath: nestedPath,
                value: nestedValue
            }
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $499c9742106f24f5$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return {
                value: foundNestedSerializable
            };
        }
    };
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var state_2 = _loop_2(key, nestedValue);
        if (typeof state_2 === "object") return state_2.value;
    }
    if (cache && $499c9742106f24f5$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $499c9742106f24f5$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for(var _i = 0, _c = Object.values(value); _i < _c.length; _i++){
        var nestedValue = _c[_i];
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$499c9742106f24f5$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $499c9742106f24f5$export$6dea1aad6dac5ac2(options) {
    if (options === void 0) options = {};
    var _c, isSerializable, getEntries, _d, ignoredActions, _e, ignoredActionPaths, _f, ignoredPaths, _g, warnAfter, _h, ignoreState, _j, ignoreActions, _k, disableCache, cache;
    return function() {
        return function(next) {
            return function(action) {
                return next(action);
            };
        };
    };
}
// src/getDefaultMiddleware.ts
function $499c9742106f24f5$var$isBoolean(x) {
    return typeof x === "boolean";
}
function $499c9742106f24f5$var$curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return $499c9742106f24f5$export$36c1185aeee5b0a6(options);
    };
}
function $499c9742106f24f5$export$36c1185aeee5b0a6(options) {
    if (options === void 0) options = {};
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e, _f = options.actionCreatorCheck, actionCreatorCheck = _f === void 0 ? true : _f;
    var middlewareArray = new $499c9742106f24f5$export$20df1e9bd1a54f25();
    if (thunk) {
        if ($499c9742106f24f5$var$isBoolean(thunk)) middlewareArray.push((0, $bE8SV.default));
        else middlewareArray.push((0, $bE8SV.default).withExtraArgument(thunk.extraArgument));
    }
    var immutableOptions, serializableOptions, actionCreatorOptions;
    return middlewareArray;
}
// src/configureStore.ts
var $499c9742106f24f5$var$IS_PRODUCTION = true;
function $499c9742106f24f5$export$7d8a5b498da695ac(options) {
    var curriedGetDefaultMiddleware = $499c9742106f24f5$var$curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ($499c9742106f24f5$export$53b83ca8eaab0383(reducer)) rootReducer = (0, $l2d2N.combineReducers)(reducer);
    else throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!$499c9742106f24f5$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error("when using a middleware builder function, an array of middleware must be returned");
    }
    if (!$499c9742106f24f5$var$IS_PRODUCTION && finalMiddleware.some(function(item) {
        return typeof item !== "function";
    })) throw new Error("each middleware provided to configureStore must be a function");
    var middlewareEnhancer = (0, $l2d2N.applyMiddleware).apply(void 0, finalMiddleware);
    var finalCompose = (0, $l2d2N.compose);
    if (devTools) finalCompose = $499c9742106f24f5$var$composeWithDevTools($499c9742106f24f5$var$__spreadValues({
        trace: !$499c9742106f24f5$var$IS_PRODUCTION
    }, typeof devTools === "object" && devTools));
    var defaultEnhancers = new $499c9742106f24f5$export$490d10040a0cbe8a(middlewareEnhancer);
    var storeEnhancers = defaultEnhancers;
    if (Array.isArray(enhancers)) storeEnhancers = $499c9742106f24f5$var$__spreadArray([
        middlewareEnhancer
    ], enhancers);
    else if (typeof enhancers === "function") storeEnhancers = enhancers(defaultEnhancers);
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return (0, $l2d2N.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $499c9742106f24f5$var$executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function(typeOrActionCreator, reducer) {
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error("`builder.addCase` cannot be called with an empty action type");
            if (type in actionsMap) throw new Error("`builder.addCase` cannot be called with two reducers for the same action type");
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function(matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase: function(reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $499c9742106f24f5$var$isStateFunction(x) {
    return typeof x === "function";
}
var $499c9742106f24f5$var$hasWarnedAboutObjectNotation = false;
function $499c9742106f24f5$export$473eb76d322d0290(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) actionMatchers = [];
    var _c = typeof mapOrBuilderCallback === "function" ? $499c9742106f24f5$var$executeReducerBuilderCallback(mapOrBuilderCallback) : [
        mapOrBuilderCallback,
        actionMatchers,
        defaultCaseReducer
    ], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if ($499c9742106f24f5$var$isStateFunction(initialState)) getInitialState = function() {
        return $499c9742106f24f5$var$freezeDraftable(initialState());
    };
    else {
        var frozenInitialState_1 = $499c9742106f24f5$var$freezeDraftable(initialState);
        getInitialState = function() {
            return frozenInitialState_1;
        };
    }
    function reducer(state, action) {
        if (state === void 0) state = getInitialState();
        var caseReducers = $499c9742106f24f5$var$__spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function(_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function(_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function(cr) {
            return !!cr;
        }).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce(function(previousState, caseReducer) {
            if (caseReducer) {
                if ((0, $ePY9n.isDraft)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $ePY9n.isDraftable)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, $ePY9n.default)(previousState, function(draft) {
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var $499c9742106f24f5$var$hasWarnedAboutObjectNotation2 = false;
function $499c9742106f24f5$var$getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function $499c9742106f24f5$export$4d8d9bd83c24ae8b(options) {
    var name = options.name;
    if (!name) throw new Error("`name` is a required option for createSlice");
    typeof $1RdT6;
    var initialState = typeof options.initialState == "function" ? options.initialState : $499c9742106f24f5$var$freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function(reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = $499c9742106f24f5$var$getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        } else caseReducer = maybeReducerWithPrepare;
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? $499c9742106f24f5$export$309c7a02b0b0bc62(type, prepareCallback) : $499c9742106f24f5$export$309c7a02b0b0bc62(type);
    });
    function buildReducer() {
        var _c = typeof options.extraReducers === "function" ? $499c9742106f24f5$var$executeReducerBuilderCallback(options.extraReducers) : [
            options.extraReducers
        ], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return $499c9742106f24f5$export$473eb76d322d0290(initialState, function(builder) {
            for(var key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
            for(var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++){
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function $499c9742106f24f5$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $499c9742106f24f5$var$createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) additionalState = {};
        return Object.assign($499c9742106f24f5$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $499c9742106f24f5$var$createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function(state) {
            return state.ids;
        };
        var selectEntities = function(state) {
            return state.entities;
        };
        var selectAll = $499c9742106f24f5$export$a5d3c27355e35910(selectIds, selectEntities, function(ids, entities) {
            return ids.map(function(id) {
                return entities[id];
            });
        });
        var selectId = function(_, id) {
            return id;
        };
        var selectById = function(entities, id) {
            return entities[id];
        };
        var selectTotal = $499c9742106f24f5$export$a5d3c27355e35910(selectIds, function(ids) {
            return ids.length;
        });
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: $499c9742106f24f5$export$a5d3c27355e35910(selectEntities, selectId, selectById)
        };
        var selectGlobalizedEntities = $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectEntities);
        return {
            selectIds: $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectAll),
            selectTotal: $499c9742106f24f5$export$a5d3c27355e35910(selectState, selectTotal),
            selectById: $499c9742106f24f5$export$a5d3c27355e35910(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
function $499c9742106f24f5$var$createSingleArgumentStateOperator(mutator) {
    var operator = $499c9742106f24f5$var$createStateOperator(function(_, state) {
        return mutator(state);
    });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $499c9742106f24f5$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $499c9742106f24f5$export$ebd532f9034651f3(arg2);
        }
        var runMutator = function(draft) {
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ((0, $ePY9n.isDraft)(state)) {
            runMutator(state);
            return state;
        } else return (0, $ePY9n.default)(state, runMutator);
    };
}
// src/entities/utils.ts
function $499c9742106f24f5$var$selectIdValue(entity, selectId) {
    var key = selectId(entity);
    return key;
}
function $499c9742106f24f5$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $499c9742106f24f5$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for(var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++){
        var entity = newEntities_1[_i];
        var id = $499c9742106f24f5$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $499c9742106f24f5$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = $499c9742106f24f5$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++){
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = $499c9742106f24f5$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        for(var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++){
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function(key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter(function(id) {
            return id in state.entities;
        });
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = $499c9742106f24f5$var$selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function(update) {
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                changes: $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function(update) {
                return takeNewKey(newKeys, update, state);
            }).length > 0;
            if (didMutateIds) state.ids = Object.keys(state.entities);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $499c9742106f24f5$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $499c9742106f24f5$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $499c9742106f24f5$var$createStateOperator(addOneMutably),
        addMany: $499c9742106f24f5$var$createStateOperator(addManyMutably),
        setOne: $499c9742106f24f5$var$createStateOperator(setOneMutably),
        setMany: $499c9742106f24f5$var$createStateOperator(setManyMutably),
        setAll: $499c9742106f24f5$var$createStateOperator(setAllMutably),
        updateOne: $499c9742106f24f5$var$createStateOperator(updateOneMutably),
        updateMany: $499c9742106f24f5$var$createStateOperator(updateManyMutably),
        upsertOne: $499c9742106f24f5$var$createStateOperator(upsertOneMutably),
        upsertMany: $499c9742106f24f5$var$createStateOperator(upsertManyMutably),
        removeOne: $499c9742106f24f5$var$createStateOperator(removeOneMutably),
        removeMany: $499c9742106f24f5$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $499c9742106f24f5$var$createSortedStateAdapter(selectId, sort) {
    var _c = $499c9742106f24f5$var$createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function(model) {
            return !($499c9742106f24f5$var$selectIdValue(model, selectId) in state.entities);
        });
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $499c9742106f24f5$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for(var _i = 0, updates_1 = updates; _i < updates_1.length; _i++){
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = $499c9742106f24f5$var$splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function(model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $499c9742106f24f5$var$createStateOperator(addOneMutably),
        updateOne: $499c9742106f24f5$var$createStateOperator(updateOneMutably),
        upsertOne: $499c9742106f24f5$var$createStateOperator(upsertOneMutably),
        setOne: $499c9742106f24f5$var$createStateOperator(setOneMutably),
        setMany: $499c9742106f24f5$var$createStateOperator(setManyMutably),
        setAll: $499c9742106f24f5$var$createStateOperator(setAllMutably),
        addMany: $499c9742106f24f5$var$createStateOperator(addManyMutably),
        updateMany: $499c9742106f24f5$var$createStateOperator(updateManyMutably),
        upsertMany: $499c9742106f24f5$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $499c9742106f24f5$export$abcf4037b41e0df(options) {
    if (options === void 0) options = {};
    var _c = $499c9742106f24f5$var$__spreadValues({
        sortComparer: false,
        selectId: function(instance) {
            return instance.id;
        }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = $499c9742106f24f5$var$createInitialStateFactory();
    var selectorsFactory = $499c9742106f24f5$var$createSelectorsFactory();
    var stateAdapter = sortComparer ? $499c9742106f24f5$var$createSortedStateAdapter(selectId, sortComparer) : $499c9742106f24f5$var$createUnsortedStateAdapter(selectId);
    return $499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues($499c9742106f24f5$var$__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var $499c9742106f24f5$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $499c9742106f24f5$export$ac4959f4f1338dfc = function(size) {
    if (size === void 0) size = 21;
    var id = "";
    var i = size;
    while(i--)id += $499c9742106f24f5$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var $499c9742106f24f5$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $499c9742106f24f5$var$RejectWithValue = /** @class */ function() {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}();
var $499c9742106f24f5$var$FulfillWithMeta = /** @class */ function() {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}();
var $499c9742106f24f5$export$c97c53d0b2d5d81e = function(value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for(var _i = 0, commonProperties_1 = $499c9742106f24f5$var$commonProperties; _i < commonProperties_1.length; _i++){
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") simpleError[property] = value[property];
        }
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $499c9742106f24f5$export$6abd22dc03e5063f = function() {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = $499c9742106f24f5$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", function(payload, requestId, arg, meta) {
            return {
                payload: payload,
                meta: $499c9742106f24f5$var$__spreadProps($499c9742106f24f5$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                })
            };
        });
        var pending = $499c9742106f24f5$export$309c7a02b0b0bc62(typePrefix + "/pending", function(requestId, arg, meta) {
            return {
                payload: void 0,
                meta: $499c9742106f24f5$var$__spreadProps($499c9742106f24f5$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                })
            };
        });
        var rejected = $499c9742106f24f5$export$309c7a02b0b0bc62(typePrefix + "/rejected", function(error, requestId, arg, payload, meta) {
            return {
                payload: payload,
                error: (options && options.serializeError || $499c9742106f24f5$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: $499c9742106f24f5$var$__spreadProps($499c9742106f24f5$var$__spreadValues({}, meta || {}), {
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            };
        });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ function() {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function() {},
                    dispatchEvent: function() {
                        return false;
                    },
                    onabort: function() {},
                    removeEventListener: function() {},
                    reason: void 0,
                    throwIfAborted: function() {}
                };
            }
            class_1.prototype.abort = function() {};
            return class_1;
        }();
        function actionCreator(arg) {
            return function(dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : $499c9742106f24f5$export$ac4959f4f1338dfc();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function() {
                    return $499c9742106f24f5$var$__async(this, null, function() {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return $499c9742106f24f5$var$__generator(this, function(_c) {
                            switch(_c.label){
                                case 0:
                                    _c.trys.push([
                                        0,
                                        4,
                                        ,
                                        5
                                    ]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                                        getState: getState,
                                        extra: extra
                                    });
                                    if (!$499c9742106f24f5$var$isThenable(conditionResult)) return [
                                        3 /*break*/ ,
                                        2
                                    ];
                                    return [
                                        4 /*yield*/ ,
                                        conditionResult
                                    ];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) throw {
                                        name: "ConditionError",
                                        message: "Aborted due to condition callback returning false."
                                    };
                                    started = true;
                                    abortedPromise = new Promise(function(_, reject) {
                                        return abortController.signal.addEventListener("abort", function() {
                                            return reject({
                                                name: "AbortError",
                                                message: abortReason || "Aborted"
                                            });
                                        });
                                    });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                                        requestId: requestId,
                                        arg: arg
                                    }, {
                                        getState: getState,
                                        extra: extra
                                    })));
                                    return [
                                        4 /*yield*/ ,
                                        Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function(value, meta) {
                                                    return new $499c9742106f24f5$var$RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function(value, meta) {
                                                    return new $499c9742106f24f5$var$FulfillWithMeta(value, meta);
                                                }
                                            })).then(function(result) {
                                                if (result instanceof $499c9742106f24f5$var$RejectWithValue) throw result;
                                                if (result instanceof $499c9742106f24f5$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])
                                    ];
                                case 3:
                                    finalAction = _c.sent();
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof $499c9742106f24f5$var$RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [
                                        3 /*break*/ ,
                                        5
                                    ];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) dispatch(finalAction);
                                    return [
                                        2 /*return*/ ,
                                        finalAction
                                    ];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function() {
                        return promise2.then($499c9742106f24f5$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function() {
        return createAsyncThunk2;
    };
    return createAsyncThunk2;
}();
function $499c9742106f24f5$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $499c9742106f24f5$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/matchers.ts
var $499c9742106f24f5$var$matches = function(matcher, action) {
    if ($499c9742106f24f5$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $499c9742106f24f5$export$2c3435c7647f7b0d() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.some(function(matcher) {
            return $499c9742106f24f5$var$matches(matcher, action);
        });
    };
}
function $499c9742106f24f5$export$9dd1fb32974da385() {
    var matchers = [];
    for(var _i = 0; _i < arguments.length; _i++)matchers[_i] = arguments[_i];
    return function(action) {
        return matchers.every(function(matcher) {
            return $499c9742106f24f5$var$matches(matcher, action);
        });
    };
}
function $499c9742106f24f5$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $499c9742106f24f5$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $499c9742106f24f5$export$872dec21e9a69476() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$872dec21e9a69476()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.pending;
        });
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$a5c5d27e3994c5be() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.rejected;
        });
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$fcc3388fb56de601() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    var hasFlag = function(action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return function(action) {
        var combinedMatcher = $499c9742106f24f5$export$9dd1fb32974da385($499c9742106f24f5$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$fcc3388fb56de601()(asyncThunks[0]);
    return function(action) {
        var combinedMatcher = $499c9742106f24f5$export$9dd1fb32974da385($499c9742106f24f5$export$a5c5d27e3994c5be.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$1da80a6ef1307441() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$1da80a6ef1307441()(asyncThunks[0]);
    return function(action) {
        var matchers = asyncThunks.map(function(asyncThunk) {
            return asyncThunk.fulfilled;
        });
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function $499c9742106f24f5$export$6aa4142d99c1abce() {
    var asyncThunks = [];
    for(var _i = 0; _i < arguments.length; _i++)asyncThunks[_i] = arguments[_i];
    if (asyncThunks.length === 0) return function(action) {
        return $499c9742106f24f5$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    };
    if (!$499c9742106f24f5$var$isAsyncThunkArray(asyncThunks)) return $499c9742106f24f5$export$6aa4142d99c1abce()(asyncThunks[0]);
    return function(action) {
        var matchers = [];
        for(var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++){
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = $499c9742106f24f5$export$2c3435c7647f7b0d.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var $499c9742106f24f5$var$assertFunction = function(func, expected) {
    if (typeof func !== "function") throw new TypeError(expected + " is not a function");
};
var $499c9742106f24f5$var$noop = function() {};
var $499c9742106f24f5$var$catchRejection = function(promise2, onError) {
    if (onError === void 0) onError = $499c9742106f24f5$var$noop;
    promise2.catch(onError);
    return promise2;
};
var $499c9742106f24f5$var$addAbortSignalListener = function(abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return function() {
        return abortSignal.removeEventListener("abort", callback);
    };
};
var $499c9742106f24f5$var$abortControllerWithReason = function(abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var $499c9742106f24f5$var$task = "task";
var $499c9742106f24f5$var$listener = "listener";
var $499c9742106f24f5$var$completed = "completed";
var $499c9742106f24f5$var$cancelled = "cancelled";
var $499c9742106f24f5$var$taskCancelled = "task-" + $499c9742106f24f5$var$cancelled;
var $499c9742106f24f5$var$taskCompleted = "task-" + $499c9742106f24f5$var$completed;
var $499c9742106f24f5$var$listenerCancelled = $499c9742106f24f5$var$listener + "-" + $499c9742106f24f5$var$cancelled;
var $499c9742106f24f5$var$listenerCompleted = $499c9742106f24f5$var$listener + "-" + $499c9742106f24f5$var$completed;
var $499c9742106f24f5$export$cb1bdac908fed7f = /** @class */ function() {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = $499c9742106f24f5$var$task + " " + $499c9742106f24f5$var$cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}();
// src/listenerMiddleware/task.ts
var $499c9742106f24f5$var$validateActive = function(signal) {
    if (signal.aborted) throw new $499c9742106f24f5$export$cb1bdac908fed7f(signal.reason);
};
function $499c9742106f24f5$var$raceWithSignal(signal, promise2) {
    var cleanup = $499c9742106f24f5$var$noop;
    return new Promise(function(resolve, reject) {
        var notifyRejection = function() {
            return reject(new $499c9742106f24f5$export$cb1bdac908fed7f(signal.reason));
        };
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $499c9742106f24f5$var$addAbortSignalListener(signal, notifyRejection);
        promise2.finally(function() {
            return cleanup();
        }).then(resolve, reject);
    }).finally(function() {
        cleanup = $499c9742106f24f5$var$noop;
    });
}
var $499c9742106f24f5$var$runTask = function(task2, cleanUp) {
    return $499c9742106f24f5$var$__async(void 0, null, function() {
        var value, error_1;
        return $499c9742106f24f5$var$__generator(this, function(_c) {
            switch(_c.label){
                case 0:
                    _c.trys.push([
                        0,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4 /*yield*/ ,
                        Promise.resolve()
                    ];
                case 1:
                    _c.sent();
                    return [
                        4 /*yield*/ ,
                        task2()
                    ];
                case 2:
                    value = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: "ok",
                            value: value
                        }
                    ];
                case 3:
                    error_1 = _c.sent();
                    return [
                        2 /*return*/ ,
                        {
                            status: error_1 instanceof $499c9742106f24f5$export$cb1bdac908fed7f ? "cancelled" : "rejected",
                            error: error_1
                        }
                    ];
                case 4:
                    cleanUp == null || cleanUp();
                    return [
                        7 /*endfinally*/ 
                    ];
                case 5:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
};
var $499c9742106f24f5$var$createPause = function(signal) {
    return function(promise2) {
        return $499c9742106f24f5$var$catchRejection($499c9742106f24f5$var$raceWithSignal(signal, promise2).then(function(output) {
            $499c9742106f24f5$var$validateActive(signal);
            return output;
        }));
    };
};
var $499c9742106f24f5$var$createDelay = function(signal) {
    var pause = $499c9742106f24f5$var$createPause(signal);
    return function(timeoutMs) {
        return pause(new Promise(function(resolve) {
            return setTimeout(resolve, timeoutMs);
        }));
    };
};
// src/listenerMiddleware/index.ts
var $499c9742106f24f5$var$assign = Object.assign;
var $499c9742106f24f5$var$INTERNAL_NIL_TOKEN = {};
var $499c9742106f24f5$var$alm = "listenerMiddleware";
var $499c9742106f24f5$var$createFork = function(parentAbortSignal, parentBlockingPromises) {
    var linkControllers = function(controller) {
        return $499c9742106f24f5$var$addAbortSignalListener(parentAbortSignal, function() {
            return $499c9742106f24f5$var$abortControllerWithReason(controller, parentAbortSignal.reason);
        });
    };
    return function(taskExecutor, opts) {
        $499c9742106f24f5$var$assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = $499c9742106f24f5$var$runTask(function() {
            return $499c9742106f24f5$var$__async(void 0, null, function() {
                var result2;
                return $499c9742106f24f5$var$__generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            $499c9742106f24f5$var$validateActive(parentAbortSignal);
                            $499c9742106f24f5$var$validateActive(childAbortController.signal);
                            return [
                                4 /*yield*/ ,
                                taskExecutor({
                                    pause: $499c9742106f24f5$var$createPause(childAbortController.signal),
                                    delay: $499c9742106f24f5$var$createDelay(childAbortController.signal),
                                    signal: childAbortController.signal
                                })
                            ];
                        case 1:
                            result2 = _c.sent();
                            $499c9742106f24f5$var$validateActive(childAbortController.signal);
                            return [
                                2 /*return*/ ,
                                result2
                            ];
                    }
                });
            });
        }, function() {
            return $499c9742106f24f5$var$abortControllerWithReason(childAbortController, $499c9742106f24f5$var$taskCompleted);
        });
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result);
        return {
            result: $499c9742106f24f5$var$createPause(parentAbortSignal)(result),
            cancel: function() {
                $499c9742106f24f5$var$abortControllerWithReason(childAbortController, $499c9742106f24f5$var$taskCancelled);
            }
        };
    };
};
var $499c9742106f24f5$var$createTakePattern = function(startListening, signal) {
    var take = function(predicate, timeout) {
        return $499c9742106f24f5$var$__async(void 0, null, function() {
            var unsubscribe, tuplePromise, promises, output;
            return $499c9742106f24f5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        $499c9742106f24f5$var$validateActive(signal);
                        unsubscribe = function() {};
                        tuplePromise = new Promise(function(resolve, reject) {
                            var stopListening = startListening({
                                predicate: predicate,
                                effect: function(action, listenerApi) {
                                    listenerApi.unsubscribe();
                                    resolve([
                                        action,
                                        listenerApi.getState(),
                                        listenerApi.getOriginalState()
                                    ]);
                                }
                            });
                            unsubscribe = function() {
                                stopListening();
                                reject();
                            };
                        });
                        promises = [
                            tuplePromise
                        ];
                        if (timeout != null) promises.push(new Promise(function(resolve) {
                            return setTimeout(resolve, timeout, null);
                        }));
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            ,
                            3,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            $499c9742106f24f5$var$raceWithSignal(signal, Promise.race(promises))
                        ];
                    case 2:
                        output = _c.sent();
                        $499c9742106f24f5$var$validateActive(signal);
                        return [
                            2 /*return*/ ,
                            output
                        ];
                    case 3:
                        unsubscribe();
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return function(predicate, timeout) {
        return $499c9742106f24f5$var$catchRejection(take(predicate, timeout));
    };
};
var $499c9742106f24f5$var$getListenerEntryPropsFrom = function(options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) predicate = $499c9742106f24f5$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    $499c9742106f24f5$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $499c9742106f24f5$var$createListenerEntry = function(options) {
    var _c = $499c9742106f24f5$var$getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = $499c9742106f24f5$export$ac4959f4f1338dfc();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function() {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var $499c9742106f24f5$var$cancelActiveListeners = function(entry) {
    entry.pending.forEach(function(controller) {
        $499c9742106f24f5$var$abortControllerWithReason(controller, $499c9742106f24f5$var$listenerCancelled);
    });
};
var $499c9742106f24f5$var$createClearListenerMiddleware = function(listenerMap) {
    return function() {
        listenerMap.forEach($499c9742106f24f5$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $499c9742106f24f5$var$safelyNotifyError = function(errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(function() {
            throw errorHandlerError;
        }, 0);
    }
};
var $499c9742106f24f5$export$f03a6b845d3fb58b = $499c9742106f24f5$export$309c7a02b0b0bc62($499c9742106f24f5$var$alm + "/add");
var $499c9742106f24f5$export$b1b8022855fb2b71 = $499c9742106f24f5$export$309c7a02b0b0bc62($499c9742106f24f5$var$alm + "/removeAll");
var $499c9742106f24f5$export$b03e9483f936dccb = $499c9742106f24f5$export$309c7a02b0b0bc62($499c9742106f24f5$var$alm + "/remove");
var $499c9742106f24f5$var$defaultErrorHandler = function() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    console.error.apply(console, $499c9742106f24f5$var$__spreadArray([
        $499c9742106f24f5$var$alm + "/error"
    ], args));
};
function $499c9742106f24f5$export$1228acebbbcb485b(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) middlewareOptions = {};
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? $499c9742106f24f5$var$defaultErrorHandler : _c;
    $499c9742106f24f5$var$assertFunction(onError, "onError");
    var insertEntry = function(entry) {
        entry.unsubscribe = function() {
            return listenerMap.delete(entry.id);
        };
        listenerMap.set(entry.id, entry);
        return function(cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) $499c9742106f24f5$var$cancelActiveListeners(entry);
        };
    };
    var findListenerEntry = function(comparator) {
        for(var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++){
            var entry = _c[_i];
            if (comparator(entry)) return entry;
        }
        return void 0;
    };
    var startListening = function(options) {
        var entry = findListenerEntry(function(existingEntry) {
            return existingEntry.effect === options.effect;
        });
        if (!entry) entry = $499c9742106f24f5$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    var stopListening = function(options) {
        var _c = $499c9742106f24f5$var$getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function(entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $499c9742106f24f5$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    var notifyListener = function(entry, action, api, getOriginalState) {
        return $499c9742106f24f5$var$__async(_this, null, function() {
            var internalTaskController, take, autoJoinPromises, listenerError_1;
            return $499c9742106f24f5$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        internalTaskController = new AbortController();
                        take = $499c9742106f24f5$var$createTakePattern(startListening, internalTaskController.signal);
                        autoJoinPromises = [];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([
                            1,
                            3,
                            4,
                            6
                        ]);
                        entry.pending.add(internalTaskController);
                        return [
                            4 /*yield*/ ,
                            Promise.resolve(entry.effect(action, $499c9742106f24f5$var$assign({}, api, {
                                getOriginalState: getOriginalState,
                                condition: function(predicate, timeout) {
                                    return take(predicate, timeout).then(Boolean);
                                },
                                take: take,
                                delay: $499c9742106f24f5$var$createDelay(internalTaskController.signal),
                                pause: $499c9742106f24f5$var$createPause(internalTaskController.signal),
                                extra: extra,
                                signal: internalTaskController.signal,
                                fork: $499c9742106f24f5$var$createFork(internalTaskController.signal, autoJoinPromises),
                                unsubscribe: entry.unsubscribe,
                                subscribe: function() {
                                    listenerMap.set(entry.id, entry);
                                },
                                cancelActiveListeners: function() {
                                    entry.pending.forEach(function(controller, _, set) {
                                        if (controller !== internalTaskController) {
                                            $499c9742106f24f5$var$abortControllerWithReason(controller, $499c9742106f24f5$var$listenerCancelled);
                                            set.delete(controller);
                                        }
                                    });
                                }
                            })))
                        ];
                    case 2:
                        _c.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 3:
                        listenerError_1 = _c.sent();
                        if (!(listenerError_1 instanceof $499c9742106f24f5$export$cb1bdac908fed7f)) $499c9742106f24f5$var$safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 4:
                        return [
                            4 /*yield*/ ,
                            Promise.allSettled(autoJoinPromises)
                        ];
                    case 5:
                        _c.sent();
                        $499c9742106f24f5$var$abortControllerWithReason(internalTaskController, $499c9742106f24f5$var$listenerCompleted);
                        entry.pending.delete(internalTaskController);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    var clearListenerMiddleware = $499c9742106f24f5$var$createClearListenerMiddleware(listenerMap);
    var middleware = function(api) {
        return function(next) {
            return function(action) {
                if (!$499c9742106f24f5$export$b956e38827fca970(action)) return next(action);
                if ($499c9742106f24f5$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($499c9742106f24f5$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($499c9742106f24f5$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                var originalState = api.getState();
                var getOriginalState = function() {
                    if (originalState === $499c9742106f24f5$var$INTERNAL_NIL_TOKEN) throw new Error($499c9742106f24f5$var$alm + ": getOriginalState can only be called synchronously");
                    return originalState;
                };
                var result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        var currentState = api.getState();
                        var listenerEntries = Array.from(listenerMap.values());
                        for(var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++){
                            var entry = listenerEntries_1[_i];
                            var runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $499c9742106f24f5$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $499c9742106f24f5$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
        };
    };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var $499c9742106f24f5$export$8fb31c0f05df007b = "RTK_autoBatch";
var $499c9742106f24f5$export$39fcd5145ec5e4e2 = function() {
    return function(payload) {
        var _c;
        return {
            payload: payload,
            meta: (_c = {}, _c[$499c9742106f24f5$export$8fb31c0f05df007b] = true, _c)
        };
    };
};
var $499c9742106f24f5$var$promise;
var $499c9742106f24f5$var$queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : globalThis) : function(cb) {
    return ($499c9742106f24f5$var$promise || ($499c9742106f24f5$var$promise = Promise.resolve())).then(cb).catch(function(err) {
        return setTimeout(function() {
            throw err;
        }, 0);
    });
};
var $499c9742106f24f5$var$createQueueWithTimer = function(timeout) {
    return function(notify) {
        setTimeout(notify, timeout);
    };
};
var $499c9742106f24f5$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $499c9742106f24f5$var$createQueueWithTimer(10);
var $499c9742106f24f5$export$676277d7dca0f396 = function(options) {
    if (options === void 0) options = {
        type: "raf"
    };
    return function(next) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var store = next.apply(void 0, args);
            var notifying = true;
            var shouldNotifyAtEndOfTick = false;
            var notificationQueued = false;
            var listeners = new Set();
            var queueCallback = options.type === "tick" ? $499c9742106f24f5$var$queueMicrotaskShim : options.type === "raf" ? $499c9742106f24f5$var$rAF : options.type === "callback" ? options.queueNotification : $499c9742106f24f5$var$createQueueWithTimer(options.timeout);
            var notifyListeners = function() {
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach(function(l) {
                        return l();
                    });
                }
            };
            return Object.assign({}, store, {
                subscribe: function(listener2) {
                    var wrappedListener = function() {
                        return notifying && listener2();
                    };
                    var unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return function() {
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                dispatch: function(action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[$499c9742106f24f5$export$8fb31c0f05df007b]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
    };
};
// src/index.ts
(0, $ePY9n.enableES5)();

});
parcelRegister("ePY9n", function(module, exports) {

$parcel$export(module.exports, "isDraft", function () { return r; });
$parcel$export(module.exports, "isDraftable", function () { return t; });
$parcel$export(module.exports, "immerable", function () { return L; });
$parcel$export(module.exports, "original", function () { return e; });
$parcel$export(module.exports, "freeze", function () { return d; });
$parcel$export(module.exports, "nothing", function () { return H; });
$parcel$export(module.exports, "current", function () { return R; });
$parcel$export(module.exports, "enableES5", function () { return F; });
$parcel$export(module.exports, "enablePatches", function () { return T; });
$parcel$export(module.exports, "enableMapSet", function () { return C; });
$parcel$export(module.exports, "enableAllPlugins", function () { return J; });
$parcel$export(module.exports, "castDraft", function () { return K; });
$parcel$export(module.exports, "castImmutable", function () { return $; });
$parcel$export(module.exports, "Immer", function () { return un; });
$parcel$export(module.exports, "produce", function () { return fn; });
$parcel$export(module.exports, "produceWithPatches", function () { return cn; });
$parcel$export(module.exports, "setAutoFreeze", function () { return sn; });
$parcel$export(module.exports, "setUseProxies", function () { return vn; });
$parcel$export(module.exports, "applyPatches", function () { return pn; });
$parcel$export(module.exports, "createDraft", function () { return ln; });
$parcel$export(module.exports, "finishDraft", function () { return dn; });
$parcel$export(module.exports, "default", function () { return $acd47caf6d999104$export$2e2bcd8739ae039; });
function n(n) {
    for(var r = arguments.length, t = Array(r > 1 ? r - 1 : 0), e = 1; e < r; e++)t[e - 1] = arguments[e];
    var i, o;
    throw Error("[Immer] minified error nr: " + n + (t.length ? " " + t.map(function(n) {
        return "'" + n + "'";
    }).join(",") : "") + ". Find the full error at: https://bit.ly/3cXEKWf");
}
function r(n) {
    return !!n && !!n[Q];
}
function t(n) {
    var r;
    return !!n && (function(n) {
        if (!n || "object" != typeof n) return !1;
        var r = Object.getPrototypeOf(n);
        if (null === r) return !0;
        var t = Object.hasOwnProperty.call(r, "constructor") && r.constructor;
        return t === Object || "function" == typeof t && Function.toString.call(t) === Z;
    }(n) || Array.isArray(n) || !!n[L] || !!(null === (r = n.constructor) || void 0 === r ? void 0 : r[L]) || s(n) || v(n));
}
function e(t) {
    return r(t) || n(23, t), t[Q].t;
}
function i(n, r, t) {
    void 0 === t && (t = !1), 0 === o(n) ? (t ? Object.keys : nn)(n).forEach(function(e) {
        t && "symbol" == typeof e || r(e, n[e], n);
    }) : n.forEach(function(t, e) {
        return r(e, t, n);
    });
}
function o(n) {
    var r = n[Q];
    return r ? r.i > 3 ? r.i - 4 : r.i : Array.isArray(n) ? 1 : s(n) ? 2 : v(n) ? 3 : 0;
}
function u(n, r) {
    return 2 === o(n) ? n.has(r) : Object.prototype.hasOwnProperty.call(n, r);
}
function a(n, r) {
    return 2 === o(n) ? n.get(r) : n[r];
}
function f(n, r, t) {
    var e = o(n);
    2 === e ? n.set(r, t) : 3 === e ? n.add(t) : n[r] = t;
}
function c(n, r) {
    return n === r ? 0 !== n || 1 / n == 1 / r : n != n && r != r;
}
function s(n) {
    return X && n instanceof Map;
}
function v(n) {
    return q && n instanceof Set;
}
function p(n) {
    return n.o || n.t;
}
function l(n) {
    if (Array.isArray(n)) return Array.prototype.slice.call(n);
    var r = rn(n);
    delete r[Q];
    for(var t = nn(r), e = 0; e < t.length; e++){
        var i = t[e], o = r[i];
        !1 === o.writable && (o.writable = !0, o.configurable = !0), (o.get || o.set) && (r[i] = {
            configurable: !0,
            writable: !0,
            enumerable: o.enumerable,
            value: n[i]
        });
    }
    return Object.create(Object.getPrototypeOf(n), r);
}
function d(n, e) {
    return void 0 === e && (e = !1), y(n) || r(n) || !t(n) || (o(n) > 1 && (n.set = n.add = n.clear = n.delete = h), Object.freeze(n), e && i(n, function(n, r) {
        return d(r, !0);
    }, !0)), n;
}
function h() {
    n(2);
}
function y(n) {
    return null == n || "object" != typeof n || Object.isFrozen(n);
}
function b(r) {
    var t = tn[r];
    return t || n(18, r), t;
}
function m(n, r) {
    tn[n] || (tn[n] = r);
}
function _() {
    return U;
}
function j(n, r) {
    r && (b("Patches"), n.u = [], n.s = [], n.v = r);
}
function g(n) {
    O(n), n.p.forEach(S), n.p = null;
}
function O(n) {
    n === U && (U = n.l);
}
function w(n) {
    return U = {
        p: [],
        l: U,
        h: n,
        m: !0,
        _: 0
    };
}
function S(n) {
    var r = n[Q];
    0 === r.i || 1 === r.i ? r.j() : r.g = !0;
}
function P(r, e) {
    e._ = e.p.length;
    var i = e.p[0], o = void 0 !== r && r !== i;
    return e.h.O || b("ES5").S(e, r, o), o ? (i[Q].P && (g(e), n(4)), t(r) && (r = M(e, r), e.l || x(e, r)), e.u && b("Patches").M(i[Q].t, r, e.u, e.s)) : r = M(e, i, []), g(e), e.u && e.v(e.u, e.s), r !== H ? r : void 0;
}
function M(n, r, t) {
    if (y(r)) return r;
    var e = r[Q];
    if (!e) return i(r, function(i, o) {
        return A(n, e, r, i, o, t);
    }, !0), r;
    if (e.A !== n) return r;
    if (!e.P) return x(n, e.t, !0), e.t;
    if (!e.I) {
        e.I = !0, e.A._--;
        var o = 4 === e.i || 5 === e.i ? e.o = l(e.k) : e.o, u = o, a = !1;
        3 === e.i && (u = new Set(o), o.clear(), a = !0), i(u, function(r, i) {
            return A(n, e, o, r, i, t, a);
        }), x(n, o, !1), t && n.u && b("Patches").N(e, t, n.u, n.s);
    }
    return e.o;
}
function A(e, i, o, a, c, s, v) {
    if (r(c)) {
        var p = M(e, c, s && i && 3 !== i.i && !u(i.R, a) ? s.concat(a) : void 0);
        if (f(o, a, p), !r(p)) return;
        e.m = !1;
    } else v && o.add(c);
    if (t(c) && !y(c)) {
        if (!e.h.D && e._ < 1) return;
        M(e, c), i && i.A.l || x(e, c);
    }
}
function x(n, r, t) {
    void 0 === t && (t = !1), !n.l && n.h.D && n.m && d(r, t);
}
function z(n, r) {
    var t = n[Q];
    return (t ? p(t) : n)[r];
}
function I(n, r) {
    if (r in n) for(var t = Object.getPrototypeOf(n); t;){
        var e = Object.getOwnPropertyDescriptor(t, r);
        if (e) return e;
        t = Object.getPrototypeOf(t);
    }
}
function k(n) {
    n.P || (n.P = !0, n.l && k(n.l));
}
function E(n) {
    n.o || (n.o = l(n.t));
}
function N(n, r, t) {
    var e = s(r) ? b("MapSet").F(r, t) : v(r) ? b("MapSet").T(r, t) : n.O ? function(n, r) {
        var t = Array.isArray(n), e = {
            i: t ? 1 : 0,
            A: r ? r.A : _(),
            P: !1,
            I: !1,
            R: {},
            l: r,
            t: n,
            k: null,
            o: null,
            j: null,
            C: !1
        }, i = e, o = en;
        t && (i = [
            e
        ], o = on);
        var u = Proxy.revocable(i, o), a = u.revoke, f = u.proxy;
        return e.k = f, e.j = a, f;
    }(r, t) : b("ES5").J(r, t);
    return (t ? t.A : _()).p.push(e), e;
}
function R(e) {
    return r(e) || n(22, e), function n(r) {
        if (!t(r)) return r;
        var e, u = r[Q], c = o(r);
        if (u) {
            if (!u.P && (u.i < 4 || !b("ES5").K(u))) return u.t;
            u.I = !0, e = D(r, c), u.I = !1;
        } else e = D(r, c);
        return i(e, function(r, t) {
            u && a(u.t, r) === t || f(e, r, n(t));
        }), 3 === c ? new Set(e) : e;
    }(e);
}
function D(n, r) {
    switch(r){
        case 2:
            return new Map(n);
        case 3:
            return Array.from(n);
    }
    return l(n);
}
function F() {
    function t(n, r) {
        var t = s[n];
        return t ? t.enumerable = r : s[n] = t = {
            configurable: !0,
            enumerable: r,
            get: function() {
                var r = this[Q];
                return en.get(r, n);
            },
            set: function(r) {
                var t = this[Q];
                en.set(t, n, r);
            }
        }, t;
    }
    function e(n) {
        for(var r = n.length - 1; r >= 0; r--){
            var t = n[r][Q];
            if (!t.P) switch(t.i){
                case 5:
                    a(t) && k(t);
                    break;
                case 4:
                    o(t) && k(t);
            }
        }
    }
    function o(n) {
        for(var r = n.t, t = n.k, e = nn(t), i = e.length - 1; i >= 0; i--){
            var o = e[i];
            if (o !== Q) {
                var a = r[o];
                if (void 0 === a && !u(r, o)) return !0;
                var f = t[o], s = f && f[Q];
                if (s ? s.t !== a : !c(f, a)) return !0;
            }
        }
        var v = !!r[Q];
        return e.length !== nn(r).length + (v ? 0 : 1);
    }
    function a(n) {
        var r = n.k;
        if (r.length !== n.t.length) return !0;
        var t = Object.getOwnPropertyDescriptor(r, r.length - 1);
        if (t && !t.get) return !0;
        for(var e = 0; e < r.length; e++)if (!r.hasOwnProperty(e)) return !0;
        return !1;
    }
    function f(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var s = {};
    m("ES5", {
        J: function(n, r) {
            var e = Array.isArray(n), i = function(n, r) {
                if (n) {
                    for(var e = Array(r.length), i = 0; i < r.length; i++)Object.defineProperty(e, "" + i, t(i, !0));
                    return e;
                }
                var o = rn(r);
                delete o[Q];
                for(var u = nn(o), a = 0; a < u.length; a++){
                    var f = u[a];
                    o[f] = t(f, n || !!o[f].enumerable);
                }
                return Object.create(Object.getPrototypeOf(r), o);
            }(e, n), o = {
                i: e ? 5 : 4,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                R: {},
                l: r,
                t: n,
                k: i,
                o: null,
                g: !1,
                C: !1
            };
            return Object.defineProperty(i, Q, {
                value: o,
                writable: !0
            }), i;
        },
        S: function(n, t, o) {
            o ? r(t) && t[Q].A === n && e(n.p) : (n.u && function n(r) {
                if (r && "object" == typeof r) {
                    var t = r[Q];
                    if (t) {
                        var e = t.t, o = t.k, f = t.R, c = t.i;
                        if (4 === c) i(o, function(r) {
                            r !== Q && (void 0 !== e[r] || u(e, r) ? f[r] || n(o[r]) : (f[r] = !0, k(t)));
                        }), i(e, function(n) {
                            void 0 !== o[n] || u(o, n) || (f[n] = !1, k(t));
                        });
                        else if (5 === c) {
                            if (a(t) && (k(t), f.length = !0), o.length < e.length) for(var s = o.length; s < e.length; s++)f[s] = !1;
                            else for(var v = e.length; v < o.length; v++)f[v] = !0;
                            for(var p = Math.min(o.length, e.length), l = 0; l < p; l++)o.hasOwnProperty(l) || (f[l] = !0), void 0 === f[l] && n(o[l]);
                        }
                    }
                }
            }(n.p[0]), e(n.p));
        },
        K: function(n) {
            return 4 === n.i ? o(n) : a(n);
        }
    });
}
function T() {
    function e(n) {
        if (!t(n)) return n;
        if (Array.isArray(n)) return n.map(e);
        if (s(n)) return new Map(Array.from(n.entries()).map(function(n) {
            return [
                n[0],
                e(n[1])
            ];
        }));
        if (v(n)) return new Set(Array.from(n).map(e));
        var r = Object.create(Object.getPrototypeOf(n));
        for(var i in n)r[i] = e(n[i]);
        return u(n, L) && (r[L] = n[L]), r;
    }
    function f(n) {
        return r(n) ? e(n) : n;
    }
    var c = "add";
    m("Patches", {
        $: function(r, t) {
            return t.forEach(function(t) {
                for(var i = t.path, u = t.op, f = r, s = 0; s < i.length - 1; s++){
                    var v = o(f), p = i[s];
                    "string" != typeof p && "number" != typeof p && (p = "" + p), 0 !== v && 1 !== v || "__proto__" !== p && "constructor" !== p || n(24), "function" == typeof f && "prototype" === p && n(24), "object" != typeof (f = a(f, p)) && n(15, i.join("/"));
                }
                var l = o(f), d = e(t.value), h = i[i.length - 1];
                switch(u){
                    case "replace":
                        switch(l){
                            case 2:
                                return f.set(h, d);
                            case 3:
                                n(16);
                            default:
                                return f[h] = d;
                        }
                    case c:
                        switch(l){
                            case 1:
                                return "-" === h ? f.push(d) : f.splice(h, 0, d);
                            case 2:
                                return f.set(h, d);
                            case 3:
                                return f.add(d);
                            default:
                                return f[h] = d;
                        }
                    case "remove":
                        switch(l){
                            case 1:
                                return f.splice(h, 1);
                            case 2:
                                return f.delete(h);
                            case 3:
                                return f.delete(t.value);
                            default:
                                return delete f[h];
                        }
                    default:
                        n(17, u);
                }
            }), r;
        },
        N: function(n, r, t, e) {
            switch(n.i){
                case 0:
                case 4:
                case 2:
                    return function(n, r, t, e) {
                        var o = n.t, s = n.o;
                        i(n.R, function(n, i) {
                            var v = a(o, n), p = a(s, n), l = i ? u(o, n) ? "replace" : c : "remove";
                            if (v !== p || "replace" !== l) {
                                var d = r.concat(n);
                                t.push("remove" === l ? {
                                    op: l,
                                    path: d
                                } : {
                                    op: l,
                                    path: d,
                                    value: p
                                }), e.push(l === c ? {
                                    op: "remove",
                                    path: d
                                } : "remove" === l ? {
                                    op: c,
                                    path: d,
                                    value: f(v)
                                } : {
                                    op: "replace",
                                    path: d,
                                    value: f(v)
                                });
                            }
                        });
                    }(n, r, t, e);
                case 5:
                case 1:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.R, u = n.o;
                        if (u.length < i.length) {
                            var a = [
                                u,
                                i
                            ];
                            i = a[0], u = a[1];
                            var s = [
                                e,
                                t
                            ];
                            t = s[0], e = s[1];
                        }
                        for(var v = 0; v < i.length; v++)if (o[v] && u[v] !== i[v]) {
                            var p = r.concat([
                                v
                            ]);
                            t.push({
                                op: "replace",
                                path: p,
                                value: f(u[v])
                            }), e.push({
                                op: "replace",
                                path: p,
                                value: f(i[v])
                            });
                        }
                        for(var l = i.length; l < u.length; l++){
                            var d = r.concat([
                                l
                            ]);
                            t.push({
                                op: c,
                                path: d,
                                value: f(u[l])
                            });
                        }
                        i.length < u.length && e.push({
                            op: "replace",
                            path: r.concat([
                                "length"
                            ]),
                            value: i.length
                        });
                    }(n, r, t, e);
                case 3:
                    return function(n, r, t, e) {
                        var i = n.t, o = n.o, u = 0;
                        i.forEach(function(n) {
                            if (!o.has(n)) {
                                var i = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: "remove",
                                    path: i,
                                    value: n
                                }), e.unshift({
                                    op: c,
                                    path: i,
                                    value: n
                                });
                            }
                            u++;
                        }), u = 0, o.forEach(function(n) {
                            if (!i.has(n)) {
                                var o = r.concat([
                                    u
                                ]);
                                t.push({
                                    op: c,
                                    path: o,
                                    value: n
                                }), e.unshift({
                                    op: "remove",
                                    path: o,
                                    value: n
                                });
                            }
                            u++;
                        });
                    }(n, r, t, e);
            }
        },
        M: function(n, r, t, e) {
            t.push({
                op: "replace",
                path: [],
                value: r === H ? void 0 : r
            }), e.push({
                op: "replace",
                path: [],
                value: n
            });
        }
    });
}
function C() {
    function r(n, r) {
        function t() {
            this.constructor = n;
        }
        a(n, r), n.prototype = (t.prototype = r.prototype, new t);
    }
    function e(n) {
        n.o || (n.R = new Map, n.o = new Map(n.t));
    }
    function o(n) {
        n.o || (n.o = new Set, n.t.forEach(function(r) {
            if (t(r)) {
                var e = N(n.A.h, r, n);
                n.p.set(r, e), n.o.add(e);
            } else n.o.add(r);
        }));
    }
    function u(r) {
        r.g && n(3, JSON.stringify(p(r)));
    }
    var a = function(n, r) {
        return (a = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(n, r) {
            n.__proto__ = r;
        } || function(n, r) {
            for(var t in r)r.hasOwnProperty(t) && (n[t] = r[t]);
        })(n, r);
    }, f = function() {
        function n(n, r) {
            return this[Q] = {
                i: 2,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                R: void 0,
                t: n,
                k: this,
                C: !1,
                g: !1
            }, this;
        }
        r(n, Map);
        var o = n.prototype;
        return Object.defineProperty(o, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), o.has = function(n) {
            return p(this[Q]).has(n);
        }, o.set = function(n, r) {
            var t = this[Q];
            return u(t), p(t).has(n) && p(t).get(n) === r || (e(t), k(t), t.R.set(n, !0), t.o.set(n, r), t.R.set(n, !0)), this;
        }, o.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), e(r), k(r), r.t.has(n) ? r.R.set(n, !1) : r.R.delete(n), r.o.delete(n), !0;
        }, o.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (e(n), k(n), n.R = new Map, i(n.t, function(r) {
                n.R.set(r, !1);
            }), n.o.clear());
        }, o.forEach = function(n, r) {
            var t = this;
            p(this[Q]).forEach(function(e, i) {
                n.call(r, t.get(i), i, t);
            });
        }, o.get = function(n) {
            var r = this[Q];
            u(r);
            var i = p(r).get(n);
            if (r.I || !t(i)) return i;
            if (i !== r.t.get(n)) return i;
            var o = N(r.A.h, i, r);
            return e(r), r.o.set(n, o), o;
        }, o.keys = function() {
            return p(this[Q]).keys();
        }, o.values = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.values();
            }, n.next = function() {
                var n = t.next();
                return n.done ? n : {
                    done: !1,
                    value: r.get(n.value)
                };
            }, n;
        }, o.entries = function() {
            var n, r = this, t = this.keys();
            return (n = {})[V] = function() {
                return r.entries();
            }, n.next = function() {
                var n = t.next();
                if (n.done) return n;
                var e = r.get(n.value);
                return {
                    done: !1,
                    value: [
                        n.value,
                        e
                    ]
                };
            }, n;
        }, o[V] = function() {
            return this.entries();
        }, n;
    }(), c = function() {
        function n(n, r) {
            return this[Q] = {
                i: 3,
                l: r,
                A: r ? r.A : _(),
                P: !1,
                I: !1,
                o: void 0,
                t: n,
                k: this,
                p: new Map,
                g: !1,
                C: !1
            }, this;
        }
        r(n, Set);
        var t = n.prototype;
        return Object.defineProperty(t, "size", {
            get: function() {
                return p(this[Q]).size;
            }
        }), t.has = function(n) {
            var r = this[Q];
            return u(r), r.o ? !!r.o.has(n) || !(!r.p.has(n) || !r.o.has(r.p.get(n))) : r.t.has(n);
        }, t.add = function(n) {
            var r = this[Q];
            return u(r), this.has(n) || (o(r), k(r), r.o.add(n)), this;
        }, t.delete = function(n) {
            if (!this.has(n)) return !1;
            var r = this[Q];
            return u(r), o(r), k(r), r.o.delete(n) || !!r.p.has(n) && r.o.delete(r.p.get(n));
        }, t.clear = function() {
            var n = this[Q];
            u(n), p(n).size && (o(n), k(n), n.o.clear());
        }, t.values = function() {
            var n = this[Q];
            return u(n), o(n), n.o.values();
        }, t.entries = function() {
            var n = this[Q];
            return u(n), o(n), n.o.entries();
        }, t.keys = function() {
            return this.values();
        }, t[V] = function() {
            return this.values();
        }, t.forEach = function(n, r) {
            for(var t = this.values(), e = t.next(); !e.done;)n.call(r, e.value, e.value, this), e = t.next();
        }, n;
    }();
    m("MapSet", {
        F: function(n, r) {
            return new f(n, r);
        },
        T: function(n, r) {
            return new c(n, r);
        }
    });
}
function J() {
    F(), C(), T();
}
function K(n) {
    return n;
}
function $(n) {
    return n;
}
var G, U, W = "undefined" != typeof Symbol && "symbol" == typeof Symbol("x"), X = "undefined" != typeof Map, q = "undefined" != typeof Set, B = "undefined" != typeof Proxy && void 0 !== Proxy.revocable && "undefined" != typeof Reflect, H = W ? Symbol.for("immer-nothing") : ((G = {})["immer-nothing"] = !0, G), L = W ? Symbol.for("immer-draftable") : "__$immer_draftable", Q = W ? Symbol.for("immer-state") : "__$immer_state", V = "undefined" != typeof Symbol && Symbol.iterator || "@@iterator", Y = {
    0: "Illegal state",
    1: "Immer drafts cannot have computed properties",
    2: "This object has been frozen and should not be mutated",
    3: function(n) {
        return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + n;
    },
    4: "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
    5: "Immer forbids circular references",
    6: "The first or second argument to `produce` must be a function",
    7: "The third argument to `produce` must be a function or undefined",
    8: "First argument to `createDraft` must be a plain object, an array, or an immerable object",
    9: "First argument to `finishDraft` must be a draft returned by `createDraft`",
    10: "The given draft is already finalized",
    11: "Object.defineProperty() cannot be used on an Immer draft",
    12: "Object.setPrototypeOf() cannot be used on an Immer draft",
    13: "Immer only supports deleting array indices",
    14: "Immer only supports setting array indices and the 'length' property",
    15: function(n) {
        return "Cannot apply patch, path doesn't resolve: " + n;
    },
    16: 'Sets cannot have "replace" patches.',
    17: function(n) {
        return "Unsupported patch operation: " + n;
    },
    18: function(n) {
        return "The plugin for '" + n + "' has not been loaded into Immer. To enable the plugin, import and call `enable" + n + "()` when initializing your application.";
    },
    20: "Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",
    21: function(n) {
        return "produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '" + n + "'";
    },
    22: function(n) {
        return "'current' expects a draft, got: " + n;
    },
    23: function(n) {
        return "'original' expects a draft, got: " + n;
    },
    24: "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
}, Z = "" + Object.prototype.constructor, nn = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : void 0 !== Object.getOwnPropertySymbols ? function(n) {
    return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n));
} : Object.getOwnPropertyNames, rn = Object.getOwnPropertyDescriptors || function(n) {
    var r = {};
    return nn(n).forEach(function(t) {
        r[t] = Object.getOwnPropertyDescriptor(n, t);
    }), r;
}, tn = {}, en = {
    get: function(n, r) {
        if (r === Q) return n;
        var e = p(n);
        if (!u(e, r)) return function(n, r, t) {
            var e, i = I(r, t);
            return i ? "value" in i ? i.value : null === (e = i.get) || void 0 === e ? void 0 : e.call(n.k) : void 0;
        }(n, e, r);
        var i = e[r];
        return n.I || !t(i) ? i : i === z(n.t, r) ? (E(n), n.o[r] = N(n.A.h, i, n)) : i;
    },
    has: function(n, r) {
        return r in p(n);
    },
    ownKeys: function(n) {
        return Reflect.ownKeys(p(n));
    },
    set: function(n, r, t) {
        var e = I(p(n), r);
        if (null == e ? void 0 : e.set) return e.set.call(n.k, t), !0;
        if (!n.P) {
            var i = z(p(n), r), o = null == i ? void 0 : i[Q];
            if (o && o.t === t) return n.o[r] = t, n.R[r] = !1, !0;
            if (c(t, i) && (void 0 !== t || u(n.t, r))) return !0;
            E(n), k(n);
        }
        return n.o[r] === t && (void 0 !== t || r in n.o) || Number.isNaN(t) && Number.isNaN(n.o[r]) || (n.o[r] = t, n.R[r] = !0), !0;
    },
    deleteProperty: function(n, r) {
        return void 0 !== z(n.t, r) || r in n.t ? (n.R[r] = !1, E(n), k(n)) : delete n.R[r], n.o && delete n.o[r], !0;
    },
    getOwnPropertyDescriptor: function(n, r) {
        var t = p(n), e = Reflect.getOwnPropertyDescriptor(t, r);
        return e ? {
            writable: !0,
            configurable: 1 !== n.i || "length" !== r,
            enumerable: e.enumerable,
            value: t[r]
        } : e;
    },
    defineProperty: function() {
        n(11);
    },
    getPrototypeOf: function(n) {
        return Object.getPrototypeOf(n.t);
    },
    setPrototypeOf: function() {
        n(12);
    }
}, on = {};
i(en, function(n, r) {
    on[n] = function() {
        return arguments[0] = arguments[0][0], r.apply(this, arguments);
    };
}), on.deleteProperty = function(r, t) {
    return on.set.call(this, r, t, void 0);
}, on.set = function(r, t, e) {
    return en.set.call(this, r[0], t, e, r[0]);
};
var un = function() {
    function e(r) {
        var e = this;
        this.O = B, this.D = !0, this.produce = function(r, i, o) {
            if ("function" == typeof r && "function" != typeof i) {
                var u = i;
                i = r;
                var a = e;
                return function(n) {
                    var r = this;
                    void 0 === n && (n = u);
                    for(var t = arguments.length, e = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)e[o - 1] = arguments[o];
                    return a.produce(n, function(n) {
                        var t;
                        return (t = i).call.apply(t, [
                            r,
                            n
                        ].concat(e));
                    });
                };
            }
            var f;
            if ("function" != typeof i && n(6), void 0 !== o && "function" != typeof o && n(7), t(r)) {
                var c = w(e), s = N(e, r, void 0), v = !0;
                try {
                    f = i(s), v = !1;
                } finally{
                    v ? g(c) : O(c);
                }
                return "undefined" != typeof Promise && f instanceof Promise ? f.then(function(n) {
                    return j(c, o), P(n, c);
                }, function(n) {
                    throw g(c), n;
                }) : (j(c, o), P(f, c));
            }
            if (!r || "object" != typeof r) {
                if (void 0 === (f = i(r)) && (f = r), f === H && (f = void 0), e.D && d(f, !0), o) {
                    var p = [], l = [];
                    b("Patches").M(r, f, p, l), o(p, l);
                }
                return f;
            }
            n(21, r);
        }, this.produceWithPatches = function(n, r) {
            if ("function" == typeof n) return function(r) {
                for(var t = arguments.length, i = Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)i[o - 1] = arguments[o];
                return e.produceWithPatches(r, function(r) {
                    return n.apply(void 0, [
                        r
                    ].concat(i));
                });
            };
            var t, i, o = e.produce(n, r, function(n, r) {
                t = n, i = r;
            });
            return "undefined" != typeof Promise && o instanceof Promise ? o.then(function(n) {
                return [
                    n,
                    t,
                    i
                ];
            }) : [
                o,
                t,
                i
            ];
        }, "boolean" == typeof (null == r ? void 0 : r.useProxies) && this.setUseProxies(r.useProxies), "boolean" == typeof (null == r ? void 0 : r.autoFreeze) && this.setAutoFreeze(r.autoFreeze);
    }
    var i = e.prototype;
    return i.createDraft = function(e) {
        t(e) || n(8), r(e) && (e = R(e));
        var i = w(this), o = N(this, e, void 0);
        return o[Q].C = !0, O(i), o;
    }, i.finishDraft = function(r, t) {
        var e = r && r[Q];
        var i = e.A;
        return j(i, t), P(void 0, i);
    }, i.setAutoFreeze = function(n) {
        this.D = n;
    }, i.setUseProxies = function(r) {
        r && !B && n(20), this.O = r;
    }, i.applyPatches = function(n, t) {
        var e;
        for(e = t.length - 1; e >= 0; e--){
            var i = t[e];
            if (0 === i.path.length && "replace" === i.op) {
                n = i.value;
                break;
            }
        }
        e > -1 && (t = t.slice(e + 1));
        var o = b("Patches").$;
        return r(n) ? o(n, t) : this.produce(n, function(n) {
            return o(n, t);
        });
    }, e;
}(), an = new un, fn = an.produce, cn = an.produceWithPatches.bind(an), sn = an.setAutoFreeze.bind(an), vn = an.setUseProxies.bind(an), pn = an.applyPatches.bind(an), ln = an.createDraft.bind(an), dn = an.finishDraft.bind(an);
var $acd47caf6d999104$export$2e2bcd8739ae039 = fn;

});

parcelRegister("l2d2N", function(module, exports) {

$parcel$export(module.exports, "createStore", function () { return $f503e72ddc215ec0$export$f51a9068ac82ea43; });
$parcel$export(module.exports, "combineReducers", function () { return $f503e72ddc215ec0$export$66e4520cdb265d18; });
$parcel$export(module.exports, "compose", function () { return $f503e72ddc215ec0$export$f672e0b6f7222cd7; });
$parcel$export(module.exports, "applyMiddleware", function () { return $f503e72ddc215ec0$export$9ff26e0402cc7b7; });

var $jQssh = parcelRequire("jQssh");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $f503e72ddc215ec0$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $f503e72ddc215ec0$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $f503e72ddc215ec0$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $f503e72ddc215ec0$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $f503e72ddc215ec0$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $f503e72ddc215ec0$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $f503e72ddc215ec0$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f503e72ddc215ec0$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $f503e72ddc215ec0$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($f503e72ddc215ec0$var$isDate(val)) return "date";
    if ($f503e72ddc215ec0$var$isError(val)) return "error";
    var constructorName = $f503e72ddc215ec0$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $f503e72ddc215ec0$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $f503e72ddc215ec0$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $f503e72ddc215ec0$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $f503e72ddc215ec0$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $f503e72ddc215ec0$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(1));
        return enhancer($f503e72ddc215ec0$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$f503e72ddc215ec0$var$isPlainObject(action)) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $f503e72ddc215ec0$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$f503e72ddc215ec0$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $f503e72ddc215ec0$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$f503e72ddc215ec0$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $f503e72ddc215ec0$export$8928921ea2d3b126 = $f503e72ddc215ec0$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $f503e72ddc215ec0$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $f503e72ddc215ec0$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $f503e72ddc215ec0$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$f503e72ddc215ec0$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $f503e72ddc215ec0$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $f503e72ddc215ec0$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $f503e72ddc215ec0$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $f503e72ddc215ec0$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $f503e72ddc215ec0$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $f503e72ddc215ec0$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $f503e72ddc215ec0$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $f503e72ddc215ec0$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $f503e72ddc215ec0$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $f503e72ddc215ec0$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $f503e72ddc215ec0$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $f503e72ddc215ec0$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $f503e72ddc215ec0$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($f503e72ddc215ec0$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $f503e72ddc215ec0$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $jQssh.default)((0, $jQssh.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("jQssh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e728f2405e04dc44$export$2e2bcd8739ae039; });

var $kSFIZ = parcelRequire("kSFIZ");
function $e728f2405e04dc44$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e728f2405e04dc44$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e728f2405e04dc44$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $kSFIZ.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e728f2405e04dc44$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});
parcelRegister("kSFIZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f33937734f016206$export$2e2bcd8739ae039; });

var $jxVuk = parcelRequire("jxVuk");
function $f33937734f016206$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $jxVuk.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("jxVuk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3adb15822cb3fd3$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");

var $lSAJ7 = parcelRequire("lSAJ7");
function $e3adb15822cb3fd3$export$2e2bcd8739ae039(t) {
    var i = (0, $lSAJ7.default)(t, "string");
    return "symbol" == (0, $8p0zh.default)(i) ? i : i + "";
}

});
parcelRegister("lSAJ7", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fedb2148e204fbf8$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");
function $fedb2148e204fbf8$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $8p0zh.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $8p0zh.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});





parcelRegister("hzjk7", function(module, exports) {

$parcel$export(module.exports, "createSelector", function () { return $cca4b1ce389a842c$export$595d22ed68ca2841; });

var $l6ob1 = parcelRequire("l6ob1");
function $cca4b1ce389a842c$var$getDependencies(funcs) {
    var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    if (!dependencies.every(function(dep) {
        return typeof dep === "function";
    })) {
        var dependencyTypes = dependencies.map(function(dep) {
            return typeof dep === "function" ? "function " + (dep.name || "unnamed") + "()" : typeof dep;
        }).join(", ");
        throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
    }
    return dependencies;
}
function $cca4b1ce389a842c$export$5943f4447f6ef248(memoize) {
    for(var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)memoizeOptionsFromArgs[_key - 1] = arguments[_key];
    var createSelector = function createSelector() {
        for(var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)funcs[_key2] = arguments[_key2];
        var _recomputations = 0;
        var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
        // So, start by declaring the default value here.
        // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)
        var directlyPassedOptions = {
            memoizeOptions: undefined
        }; // Normally, the result func or "output selector" is the last arg
        var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc; // and pop the real result func off
            resultFunc = funcs.pop();
        }
        if (typeof resultFunc !== "function") throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
         // Determine which set of options we're using. Prefer options passed directly,
        // but fall back to options given to createSelectorCreator.
        var _directlyPassedOption = directlyPassedOptions, _directlyPassedOption2 = _directlyPassedOption.memoizeOptions, memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
        // is an array. In most libs I've looked at, it's an equality function or options object.
        // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
        // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
        // we wrap it in an array so we can apply it.
        var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [
            memoizeOptions
        ];
        var dependencies = $cca4b1ce389a842c$var$getDependencies(funcs);
        var memoizedResultFunc = memoize.apply(void 0, [
            function recomputationWrapper() {
                _recomputations++; // apply arguments instead of spreading for performance.
                return resultFunc.apply(null, arguments);
            }
        ].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
        var selector = memoize(function dependenciesChecker() {
            var params = [];
            var length = dependencies.length;
            for(var i = 0; i < length; i++)// apply arguments instead of spreading and mutate a local list of params for performance.
            // @ts-ignore
            params.push(dependencies[i].apply(null, arguments));
             // apply arguments instead of spreading for performance.
            _lastResult = memoizedResultFunc.apply(null, params);
            return _lastResult;
        });
        Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            lastResult: function lastResult() {
                return _lastResult;
            },
            recomputations: function recomputations() {
                return _recomputations;
            },
            resetRecomputations: function resetRecomputations() {
                return _recomputations = 0;
            }
        });
        return selector;
    }; // @ts-ignore
    return createSelector;
}
var $cca4b1ce389a842c$export$595d22ed68ca2841 = /* #__PURE__ */ $cca4b1ce389a842c$export$5943f4447f6ef248((0, $l6ob1.defaultMemoize));
var $cca4b1ce389a842c$export$75979cfcd91bf38f = function createStructuredSelector(selectors, selectorCreator) {
    if (selectorCreator === void 0) selectorCreator = $cca4b1ce389a842c$export$595d22ed68ca2841;
    if (typeof selectors !== "object") throw new Error("createStructuredSelector expects first argument to be an object " + ("where each property is a selector, instead received a " + typeof selectors));
    var objectKeys = Object.keys(selectors);
    var resultSelector = selectorCreator(objectKeys.map(function(key) {
        return selectors[key];
    }), function() {
        for(var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)values[_key3] = arguments[_key3];
        return values.reduce(function(composition, value, index) {
            composition[objectKeys[index]] = value;
            return composition;
        }, {});
    });
    return resultSelector;
};

});
parcelRegister("l6ob1", function(module, exports) {

$parcel$export(module.exports, "defaultMemoize", function () { return $f5cce98200f3fd7b$export$281bff7f05488aa2; });
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var $f5cce98200f3fd7b$var$NOT_FOUND = "NOT_FOUND";
function $f5cce98200f3fd7b$var$createSingletonCache(equals) {
    var entry;
    return {
        get: function get(key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $f5cce98200f3fd7b$var$NOT_FOUND;
        },
        put: function put(key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries: function getEntries() {
            return entry ? [
                entry
            ] : [];
        },
        clear: function clear() {
            entry = undefined;
        }
    };
}
function $f5cce98200f3fd7b$var$createLruCache(maxSize, equals) {
    var entries = [];
    function get(key) {
        var cacheIndex = entries.findIndex(function(entry) {
            return equals(key, entry.key);
        }); // We found a cached entry
        if (cacheIndex > -1) {
            var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        } // No entry found in cache, return sentinel
        return $f5cce98200f3fd7b$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $f5cce98200f3fd7b$var$NOT_FOUND) {
            // TODO Is unshift slow?
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $f5cce98200f3fd7b$export$e0b28855d0126ccc = function defaultEqualityCheck(a, b) {
    return a === b;
};
function $f5cce98200f3fd7b$export$823674481ed171f9(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
         // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
        var length = prev.length;
        for(var i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $f5cce98200f3fd7b$export$281bff7f05488aa2(func, equalityCheckOrOptions) {
    var providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    var _providedOptions$equa = providedOptions.equalityCheck, equalityCheck = _providedOptions$equa === void 0 ? $f5cce98200f3fd7b$export$e0b28855d0126ccc : _providedOptions$equa, _providedOptions$maxS = providedOptions.maxSize, maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS, resultEqualityCheck = providedOptions.resultEqualityCheck;
    var comparator = $f5cce98200f3fd7b$export$823674481ed171f9(equalityCheck);
    var cache = maxSize === 1 ? $f5cce98200f3fd7b$var$createSingletonCache(comparator) : $f5cce98200f3fd7b$var$createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons
    function memoized() {
        var value = cache.get(arguments);
        if (value === $f5cce98200f3fd7b$var$NOT_FOUND) {
            // @ts-ignore
            value = func.apply(null, arguments);
            if (resultEqualityCheck) {
                var entries = cache.getEntries();
                var matchingEntry = entries.find(function(entry) {
                    return resultEqualityCheck(entry.value, value);
                });
                if (matchingEntry) value = matchingEntry.value;
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = function() {
        return cache.clear();
    };
    return memoized;
}

});


parcelRegister("bE8SV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87aa527f68be589e$export$2e2bcd8739ae039; });
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */ function $87aa527f68be589e$var$createThunkMiddleware(extraArgument) {
    // Standard Redux middleware definition pattern:
    // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
    var middleware = function middleware(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                // The thunk middleware looks for any functions that were passed to `store.dispatch`.
                // If this "action" is really a function, call it and return the result.
                if (typeof action === "function") // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
                return action(dispatch, getState, extraArgument);
                 // Otherwise, pass the action down the middleware chain as usual
                return next(action);
            };
        };
    };
    return middleware;
}
var $87aa527f68be589e$var$thunk = $87aa527f68be589e$var$createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks
$87aa527f68be589e$var$thunk.withExtraArgument = $87aa527f68be589e$var$createThunkMiddleware;
var $87aa527f68be589e$export$2e2bcd8739ae039 = $87aa527f68be589e$var$thunk;

});



parcelRegister("fsfV4", function(module, exports) {

$parcel$export(module.exports, "getFirstPaint", function () { return $07a87e2b7b0395e0$export$819e7a0b13f5961; });
$parcel$export(module.exports, "getFirstContentfulPaint", function () { return $07a87e2b7b0395e0$export$3086fa1a9fb7f683; });
const $07a87e2b7b0395e0$var$perf = typeof window !== "undefined" ? window.performance : null;
function $07a87e2b7b0395e0$export$819e7a0b13f5961() {
    try {
        if (!$07a87e2b7b0395e0$var$perf) return null;
        const fp = $07a87e2b7b0395e0$var$perf.getEntriesByType("paint").find(({ name: name })=>name === "first-paint");
        return fp ? Math.round(fp.startTime) : null;
    } catch (err) {
        return null;
    }
}
function $07a87e2b7b0395e0$export$3086fa1a9fb7f683() {
    try {
        if (!$07a87e2b7b0395e0$var$perf) return null;
        const fcp = $07a87e2b7b0395e0$var$perf.getEntriesByType("paint").find(({ name: name })=>name === "first-contentful-paint");
        return fcp ? Math.round(fcp.startTime) : null;
    } catch (err) {
        return null;
    }
}

});

parcelRegister("62Jrh", function(module, exports) {
$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return (parcelRequire("HylXk")).BrowserMetricsBoundary; });
$parcel$export(module.exports, "startBrowserMetrics", function () { return (parcelRequire("2xiyk")).startBrowserMetrics; });
$parcel$export(module.exports, "getPageLoadMetric", function () { return (parcelRequire("kQMDY")).getPageLoadMetric; });
parcelRequire("HylXk");
parcelRequire("2xiyk");
parcelRequire("kQMDY");

});
parcelRegister("HylXk", function(module, exports) {

$parcel$export(module.exports, "BrowserMetricsBoundary", function () { return $6ce40601bc19e9d0$export$e338054fa926c14d; });

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $7HBoF = parcelRequire("7HBoF");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");
const $6ce40601bc19e9d0$export$e338054fa926c14d = ({ children: children })=>{
    const prevPathname = (0, $8ZuGG.useRef)();
    const { pathname: pathname } = (0, $5WDNl.useLocation)();
    /*
   * Here we only want to capture transition page loads (i.e. clientside route changes).
   *
   * Initial page loads (with a full trip to the server) are already recorded separately,
   * by calling startPageLoad before the react app is bootstrapped.
   *
   * And if startPageLoad were called again here, that initial page load will be overridden
   * and incorrectly recorded as a transition.
   */ (0, $8ZuGG.useLayoutEffect)(()=>{
        if (!pathname) return;
        if (!prevPathname.current) {
            prevPathname.current = pathname;
            return;
        }
        // `isInitial: false` is the default, but made explicit here for clarity
        (0, $7HBoF.browserMetrics).startPageLoad({
            isInitial: false
        });
    }, [
        pathname,
        prevPathname
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};

});
parcelRegister("7HBoF", function(module, exports) {

$parcel$export(module.exports, "browserMetrics", function () { return $59b98ecadb70c473$export$c08e7affcf78b064; });

var $6bkHe = parcelRequire("6bkHe");

var $1EyXZ = parcelRequire("1EyXZ");

var $1XCKE = parcelRequire("1XCKE");

var $5EyB3 = parcelRequire("5EyB3");

var $a3buC = parcelRequire("a3buC");

var $djDSg = parcelRequire("djDSg");

var $eqyfk = parcelRequire("eqyfk");

var $e1hkl = parcelRequire("e1hkl");

var $3GjBI = parcelRequire("3GjBI");
function $59b98ecadb70c473$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $59b98ecadb70c473$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $59b98ecadb70c473$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $59b98ecadb70c473$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $59b98ecadb70c473$var$makeBrowserMetrics = function makeBrowserMetrics() {
    var bm = {
        init: function init(config) {
            var _config$events$BMEven, _config$ssr;
            (0, $a3buC.visibilityChangeObserver).start();
            if ((_config$events$BMEven = config.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) !== null && _config$events$BMEven !== void 0 && _config$events$BMEven.enabled) (0, $djDSg.webVitalsObserver).start();
            if (config.debug) {
                (0, $1XCKE.logger).enable();
                (0, $e1hkl.submitter).setDebug(true);
                (0, $5EyB3.pageLoadMetaMetric).setDebug(true);
            }
            (0, $e1hkl.submitter).configure(config);
            if ((_config$ssr = config.ssr) !== null && _config$ssr !== void 0 && _config$ssr.getDoneMark) (0, $1EyXZ.SSRGetDoneMark).setGetDoneMark(config.ssr.getDoneMark);
        },
        setRoute: function setRoute(newRoute) {
            (0, $eqyfk.Route).setRoute(newRoute);
        },
        startPageLoad: function startPageLoad(params) {
            (0, $5EyB3.pageLoadMetaMetric).startPageLoad($59b98ecadb70c473$var$_objectSpread({
                isInitial: false,
                cancelStarted: true
            }, params));
        },
        getPageLoadMetric: function getPageLoadMetric() {
            return 0, $5EyB3.pageLoadMetaMetric;
        },
        experimental__addPageLoadTimingFromPerformanceMarks: function experimental__addPageLoadTimingFromPerformanceMarks(name, startMark, stopMark) {
            var initialOnly = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
            if (initialOnly && !(0, $5EyB3.pageLoadMetaMetric).isInitialLoad()) return;
            var start = performance.getEntriesByName(startMark);
            var stop = performance.getEntriesByName(stopMark);
            if (start.length > 0 && stop.length > 0) {
                if ((0, $5EyB3.pageLoadMetaMetric).isDebugMode()) try {
                    performance.measure(name, startMark, stopMark);
                } catch (e) {}
                var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getData();
                if (pageLoadData.start !== null) {
                    var _startMark = start[start.length - 1];
                    var timing = {
                        startTime: Math.round(_startMark.startTime - pageLoadData.start),
                        duration: Math.round(stop[stop.length - 1].startTime - _startMark.startTime)
                    };
                    (0, $5EyB3.pageLoadMetaMetric).experimental__addExplicitTiming(name, timing);
                }
            }
        }
    };
    return bm;
};
var $59b98ecadb70c473$export$c08e7affcf78b064 = $59b98ecadb70c473$var$makeBrowserMetrics();

});
parcelRegister("1EyXZ", function(module, exports) {

$parcel$export(module.exports, "SSRGetDoneMark", function () { return $1344a685454f4217$export$9e87a201397ac0a9; });
var $1344a685454f4217$export$9e87a201397ac0a9 = {
    getDoneMark: function() {
        return null;
    },
    setGetDoneMark: function setGetDoneMark(fn) {
        $1344a685454f4217$export$9e87a201397ac0a9.getDoneMark = fn;
    }
};

});

parcelRegister("1XCKE", function(module, exports) {

$parcel$export(module.exports, "logger", function () { return $16d95c5ba96729d0$export$af88d00dbe7f521; });
var $16d95c5ba96729d0$export$af88d00dbe7f521 = {
    enabled: false,
    enable: function enable() {
        this.enabled = true;
    },
    log: function log() {
        if (this.enabled) {
            var _console;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            // eslint-disable-next-line no-console
            (_console = console).log.apply(_console, [
                "BM log: "
            ].concat(args));
        }
    },
    logCond: function logCond(condition) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        if (this.enabled && condition && args.length > 1) this.log.apply(this, args);
    }
};

});

parcelRegister("5EyB3", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetaMetric", function () { return $010fed859e568f72$export$24b7a1a311eb05dc; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5T1eV = parcelRequire("5T1eV");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $3GjBI = parcelRequire("3GjBI");

var $k6Eo3 = parcelRequire("k6Eo3");

var $h5wBz = parcelRequire("h5wBz");
var $010fed859e568f72$var$_excluded = [
    "cancelStarted"
];
function $010fed859e568f72$var$_createSuper(t) {
    var r = $010fed859e568f72$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $010fed859e568f72$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($010fed859e568f72$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $010fed859e568f72$export$9609608c00ea5077 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(PageLoadMetaMetric, _BasePageLoadMetric);
    var _super = $010fed859e568f72$var$_createSuper(PageLoadMetaMetric);
    function PageLoadMetaMetric() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PageLoadMetaMetric);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "activePageLoadMetric", null);
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PageLoadMetaMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false,
                    cancelStarted: false
                };
                var cancelStarted = _ref.cancelStarted, startPageLoadParams = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $010fed859e568f72$var$_excluded);
                if (cancelStarted || this.state !== (0, $k6Eo3.MetricState).STARTED) (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageLoadMetaMetric.prototype), "startPageLoad", this).call(this, startPageLoadParams);
            }
        },
        {
            key: "setActive",
            value: function setActive(metric) {
                this.activePageLoadMetric = metric;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(debug) {
                this.config.debug = debug;
            }
        },
        {
            key: "isDebugMode",
            value: function isDebugMode() {
                return this.config.debug;
            }
        },
        {
            key: "isInitialLoad",
            value: function isInitialLoad() {
                return this.isInitial;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.activePageLoadMetric && this.activePageLoadMetric.cancel();
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageLoadMetaMetric.prototype), "clear", this).call(this);
            }
        },
        {
            key: "include",
            value: function include(metric) {
                if (!this.config.include) this.config.include = [
                    metric
                ];
                else this.config.include.push(metric);
            }
        },
        {
            key: "experimental__addExplicitTiming",
            value: function experimental__addExplicitTiming(name, timing) {
                if (this.explicitTimings === null) this.explicitTimings = {};
                this.explicitTimings[name] = timing;
            }
        }
    ]);
    return PageLoadMetaMetric;
}((0, $h5wBz.BasePageLoadMetric));
var $010fed859e568f72$export$24b7a1a311eb05dc = new $010fed859e568f72$export$9609608c00ea5077({
    type: (0, $3GjBI.BMEventsType).PAGE_LOAD,
    key: "page_load_meta_metric"
});

});
parcelRegister("c3k3z", function(module, exports) {

var $6N3CA = parcelRequire("6N3CA");
function $8c6552ab0d0f5ef7$var$_get() {
    return module.exports = $8c6552ab0d0f5ef7$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $6N3CA(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $8c6552ab0d0f5ef7$var$_get.apply(null, arguments);
}
module.exports = $8c6552ab0d0f5ef7$var$_get, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("6N3CA", function(module, exports) {

var $hOtqI = parcelRequire("hOtqI");
function $4f1a20c9c2cc61b6$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $hOtqI(t)););
    return t;
}
module.exports = $4f1a20c9c2cc61b6$var$_superPropBase, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("3GjBI", function(module, exports) {

$parcel$export(module.exports, "BMEventsType", function () { return $2ae480ec8951598f$export$9c73e297d4be9159; });
$parcel$export(module.exports, "StorableBMEventsType", function () { return $2ae480ec8951598f$export$9b7037ec30489597; });
$parcel$export(module.exports, "BMPageLoadMetrics", function () { return $2ae480ec8951598f$export$74c1fb0997d51e2a; });
$parcel$export(module.exports, "BMPageSegmentLoadMetrics", function () { return $2ae480ec8951598f$export$88195ac8200d03a6; });
$parcel$export(module.exports, "BMInteractionMetrics", function () { return $2ae480ec8951598f$export$6e28252a002afdb2; });
$parcel$export(module.exports, "PageSegmentPageLoadMetricsOptions", function () { return $2ae480ec8951598f$export$474154836bfd8dd9; });
$parcel$export(module.exports, "PageVisibleFields", function () { return $2ae480ec8951598f$export$e89802082dab5633; });
$parcel$export(module.exports, "PageVisibleValueOrigin", function () { return $2ae480ec8951598f$export$983b017156c2aee2; });
$parcel$export(module.exports, "isDetailedPageLoadSlo", function () { return $2ae480ec8951598f$export$5866f95702a15142; });
$parcel$export(module.exports, "isDetailedPageSegmentLoadSlo", function () { return $2ae480ec8951598f$export$f087a59bd717e49d; });
$parcel$export(module.exports, "isInteractionMetricsSlo", function () { return $2ae480ec8951598f$export$b10c1d9a7db7765b; });
$parcel$export(module.exports, "IncludeSSRFeatureFlagsConfig", function () { return $2ae480ec8951598f$export$60c0193054fc3040; });

var $k6Eo3 = parcelRequire("k6Eo3");
var $2ae480ec8951598f$export$9c73e297d4be9159 = /*#__PURE__*/ function(BMEventsType) {
    BMEventsType["PAGE_LOAD"] = "PAGE_LOAD";
    BMEventsType["PAGE_SEGMENT_LOAD"] = "PAGE_SEGMENT_LOAD";
    BMEventsType["INLINE_RESULT"] = "INLINE_RESULT";
    BMEventsType["CUSTOM"] = "CUSTOM";
    BMEventsType["WEB_VITALS"] = "WEB_VITALS";
    return BMEventsType;
}({});
var $2ae480ec8951598f$export$9b7037ec30489597 = /*#__PURE__*/ function(StorableBMEventsType) {
    StorableBMEventsType["PAGE_LOAD"] = "page-load";
    StorableBMEventsType["PAGE_SEGMENT_LOAD"] = "page-segment-load";
    StorableBMEventsType["INLINE_RESULT"] = "inline-result";
    StorableBMEventsType["CUSTOM"] = "custom";
    StorableBMEventsType["WEB_VITALS"] = "web-vitals";
    return StorableBMEventsType;
}({});
var $2ae480ec8951598f$export$74c1fb0997d51e2a = /*#__PURE__*/ function(BMPageLoadMetrics) {
    BMPageLoadMetrics["fmp"] = "fmp";
    BMPageLoadMetrics["tti"] = "tti";
    return BMPageLoadMetrics;
}({});
var $2ae480ec8951598f$export$88195ac8200d03a6 = /*#__PURE__*/ function(BMPageSegmentLoadMetrics) {
    BMPageSegmentLoadMetrics["fmp"] = "fmp";
    BMPageSegmentLoadMetrics["tti"] = "tti";
    return BMPageSegmentLoadMetrics;
}({});
var $2ae480ec8951598f$export$6e28252a002afdb2 = /*#__PURE__*/ function(BMInteractionMetrics) {
    BMInteractionMetrics["response"] = "response";
    BMInteractionMetrics["result"] = "result";
    return BMInteractionMetrics;
}({});
var $2ae480ec8951598f$export$474154836bfd8dd9 = /*#__PURE__*/ function(PageSegmentPageLoadMetricsOptions) {
    PageSegmentPageLoadMetricsOptions["OFF"] = "OFF";
    PageSegmentPageLoadMetricsOptions["IF_PRESENT"] = "IF_PRESENT";
    PageSegmentPageLoadMetricsOptions["WAIT_UNTIL_PRESENT"] = "WAIT_UNTIL_PRESENT";
    return PageSegmentPageLoadMetricsOptions;
}({});
var $2ae480ec8951598f$export$e89802082dab5633 = /*#__PURE__*/ function(PageVisibleFields) {
    PageVisibleFields["pageVisibleState"] = "page-visible-state";
    PageVisibleFields["pageVisibleValue"] = "page-visible-value";
    return PageVisibleFields;
}({});
var $2ae480ec8951598f$export$983b017156c2aee2 = /*#__PURE__*/ function(PageVisibleValueOrigin) {
    PageVisibleValueOrigin["documentHidden"] = "document-hidden";
    PageVisibleValueOrigin["pageVisibleState"] = "page-visible-state";
    return PageVisibleValueOrigin;
}({});
var $2ae480ec8951598f$export$5866f95702a15142 = function isDetailedPageLoadSlo(data) {
    return Boolean(data.initial);
};
var $2ae480ec8951598f$export$f087a59bd717e49d = function isDetailedPageSegmentLoadSlo(data) {
    return Boolean(data.initial);
};
var $2ae480ec8951598f$export$153c4c72fa5eeece = function isPageLoadMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.fmp !== undefined || obj.tti !== undefined);
};
var $2ae480ec8951598f$export$b10c1d9a7db7765b = function isInteractionMetricsSlo(data) {
    var obj = data;
    return Boolean(obj.result !== undefined || obj.response !== undefined);
};
var $2ae480ec8951598f$export$60c0193054fc3040 = /*#__PURE__*/ function(IncludeSSRFeatureFlagsConfig) {
    IncludeSSRFeatureFlagsConfig["NEVER"] = "never";
    IncludeSSRFeatureFlagsConfig["WHEN_FMP"] = "when-fmp";
    IncludeSSRFeatureFlagsConfig["WHEN_AVAILABLE"] = "when-available";
    return IncludeSSRFeatureFlagsConfig;
}({});

});
parcelRegister("k6Eo3", function(module, exports) {

$parcel$export(module.exports, "MetricState", function () { return $ea33b232d012041d$export$1e458f18c0c7bfe3; });
$parcel$export(module.exports, "PageVisibleState", function () { return $ea33b232d012041d$export$a12c67b37a306b13; });
$parcel$export(module.exports, "BaseMetric", function () { return $ea33b232d012041d$export$2bce4ffdd840e878; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kg5sN = parcelRequire("kg5sN");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $8x86A = parcelRequire("8x86A");

var $1XCKE = parcelRequire("1XCKE");

var $a3buC = parcelRequire("a3buC");

var $ggnMj = parcelRequire("ggnMj");
function $ea33b232d012041d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea33b232d012041d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea33b232d012041d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea33b232d012041d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ea33b232d012041d$export$1e458f18c0c7bfe3 = /*#__PURE__*/ function(MetricState) {
    MetricState["NOT_STARTED"] = "not-started";
    MetricState["STARTED"] = "started";
    MetricState["FINISHED"] = "finished";
    MetricState["CANCELLED"] = "cancelled";
    return MetricState;
}({});
var $ea33b232d012041d$export$a12c67b37a306b13 = /*#__PURE__*/ function(PageVisibleState) {
    PageVisibleState["VISIBLE"] = "visible";
    PageVisibleState["MIXED"] = "mixed";
    PageVisibleState["HIDDEN"] = "hidden";
    return PageVisibleState;
}({});
function $ea33b232d012041d$var$getPageVisibleState() {
    return typeof document !== "undefined" && document.visibilityState === "visible" ? $ea33b232d012041d$export$a12c67b37a306b13.VISIBLE : $ea33b232d012041d$export$a12c67b37a306b13.HIDDEN;
}
var $ea33b232d012041d$export$2bce4ffdd840e878 = /*#__PURE__*/ function() {
    function BaseMetric(config) {
        var _this = this, _this$config$timings;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, BaseMetric);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "state", $ea33b232d012041d$export$1e458f18c0c7bfe3.NOT_STARTED);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "stopTime", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "marks", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "onStopCallbacks", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "custom", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "submetrics", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "route", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "untilOnStopCallback", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "pageVisibleState", $ea33b232d012041d$var$getPageVisibleState());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "setPageVisibleStateToMixed", function() {
            _this.pageVisibleState = $ea33b232d012041d$export$a12c67b37a306b13.MIXED;
        });
        this.config = config;
        this.key = config.key.replace(/ /gi, "-");
        this.type = config.type;
        (_this$config$timings = this.config.timings) === null || _this$config$timings === void 0 || _this$config$timings.forEach(function(entry) {
            if ((0, $8x86A.restrictedTimingKeys).includes(entry.key)) {
                // eslint-disable-next-line no-console
                console.warn("Entry ".concat(entry.key, " is restricted and has been renamed to custom__").concat(entry.key));
                entry.key = "custom__".concat(entry.key);
            }
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(BaseMetric, [
        {
            key: "untilMetrics",
            get: function get() {
                var until = this.config.until;
                if (!until) return [];
                else if (Array.isArray(until)) return this.getConfiguredUntilMetricArray(until);
                return this.getConfiguredUntilMetricArray([
                    until
                ]);
            }
        },
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$startTime = _ref.startTime, startTime = _ref$startTime === void 0 ? window.performance.now() : _ref$startTime;
                this.clear();
                (0, $1XCKE.logger).logCond(!!this.config.debug, this.key, startTime);
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.STARTED;
                this.startTime = startTime;
                this.pageVisibleState = $ea33b232d012041d$var$getPageVisibleState();
                (0, $a3buC.visibilityChangeObserver).subscribe(this.setPageVisibleStateToMixed);
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var stopArguments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var _stopArguments$stopTi = stopArguments.stopTime, stopTime = _stopArguments$stopTi === void 0 ? window.performance.now() : _stopArguments$stopTi;
                if (this.state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.STARTED || this.startTime === null) {
                    (0, $1XCKE.logger).log("metric ".concat(this.config.key, " has been stopped while not being started before; current state: ").concat(this.state));
                    return false;
                }
                if (stopTime < this.startTime) {
                    (0, $1XCKE.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(this.startTime, "; stopTime: ").concat(stopTime));
                    return false;
                }
                this.stopTime = stopTime;
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED;
                this.handleStop(stopArguments);
                (0, $a3buC.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var _this2 = this;
                var _stopArguments$custom = stopArguments.customData, customData = _stopArguments$custom === void 0 ? null : _stopArguments$custom;
                if (customData) this.custom = $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, this.custom), customData);
                this.config.include && this.config.include.forEach(function(metric) {
                    var included = metric.getData();
                    if (included.state === $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED && included.start !== null && included.start >= (_this2.startTime || 0)) _this2.addSubMetric(metric.getData());
                });
                this.onStopCallbacks.forEach(function(_ref2) {
                    var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref2, 1), success = _ref3[0];
                    success(stopArguments);
                });
                this.onStopCallbacks = [];
                (0, $1XCKE.logger).logCond(!!this.config.debug, this.key, this.config.debug && this.getData());
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                this.marks[_mark] = timestamp;
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                if (this.state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.STARTED) return;
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.CANCELLED;
                this.cancelUntil();
                this.onStopCallbacks.forEach(function(_ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref4, 2), cancel = _ref5[1];
                    cancel();
                });
                this.onStopCallbacks = [];
                (0, $a3buC.visibilityChangeObserver).unsubscribe(this.setPageVisibleStateToMixed);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                this.state = mergeData.state;
                this.pageVisibleState = mergeData.pageVisibleState;
                this.startTime = mergeData.start;
                this.stopTime = mergeData.stop;
                this.marks = $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, this.marks), mergeData.marks);
                this.submetrics = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.submetrics), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(mergeData.submetrics));
                this.onStopCallbacks = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.onStopCallbacks), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(mergeData.onStopCallbacks));
            }
        },
        {
            key: "onStop",
            value: function onStop(success, cancel) {
                this.onStopCallbacks.push([
                    success,
                    cancel
                ]);
            }
        },
        {
            key: "removeOnStopCallback",
            value: function removeOnStopCallback(success) {
                var index = this.onStopCallbacks.findIndex(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref6, 1), successCallback = _ref7[0];
                    return success === successCallback;
                });
                if (index > -1) this.onStopCallbacks.splice(index, 1);
            }
        },
        {
            key: "getData",
            value: function getData() {
                return {
                    key: this.key,
                    state: this.state,
                    start: this.startTime,
                    stop: this.stopTime,
                    //todo ranges
                    // ranges: this.makeRanges()
                    marks: this.marks,
                    // todo make copy
                    custom: this.custom,
                    submetrics: this.submetrics,
                    config: this.config,
                    route: this.route,
                    pageVisibleState: this.pageVisibleState,
                    type: this.config.type
                };
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, this.getData()), {}, {
                    onStopCallbacks: this.onStopCallbacks
                });
            }
        },
        {
            key: "addSubMetric",
            value: function addSubMetric(data) {
                this.submetrics.push(data);
            }
        },
        {
            key: "getConfiguredUntilMetric",
            value: function getConfiguredUntilMetric(metricOrConfig) {
                return metricOrConfig instanceof BaseMetric ? (0, $ggnMj.UntilExperience).fromMetric(metricOrConfig) : (0, $ggnMj.UntilExperience).fromConfig(metricOrConfig);
            }
        },
        {
            key: "getConfiguredUntilMetricArray",
            value: function getConfiguredUntilMetricArray(metricArray) {
                var _this3 = this;
                if (!metricArray.length) return [];
                return metricArray.map(function(metric) {
                    return _this3.getConfiguredUntilMetric(metric);
                });
            }
        },
        {
            key: "isUntilFinished",
            value: function isUntilFinished() {
                return this.untilMetrics.every(function(metric) {
                    return metric.experience.getData().state === $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED;
                });
            }
        },
        {
            key: "handleAllUntilFinished",
            value: function handleAllUntilFinished() {
                // Order by ascending stop time
                var sorted = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.untilMetrics).sort(function(m1, m2) {
                    return m1.getDependencyStopTime() - m2.getDependencyStopTime();
                });
                // Find the latest page segment to become fully interactive
                var latestFullyInteractiveSegment = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(this.untilMetrics).reduce(function(currentLatestSegment, metric) {
                    var _currentLatestSegment, _metric$getFullyInter;
                    var currentLatestStopTime = (_currentLatestSegment = currentLatestSegment === null || currentLatestSegment === void 0 ? void 0 : currentLatestSegment.getFullyInteractiveStopTime()) !== null && _currentLatestSegment !== void 0 ? _currentLatestSegment : 0;
                    var metricStopTime = (_metric$getFullyInter = metric.getFullyInteractiveStopTime()) !== null && _metric$getFullyInter !== void 0 ? _metric$getFullyInter : 0;
                    return metricStopTime > currentLatestStopTime ? metric : currentLatestSegment;
                }, undefined);
                // Accumulate the custom data from each metric, later metrics take priority
                var accumulatedCustomData = {};
                sorted.forEach(function(metric) {
                    Object.assign(accumulatedCustomData, metric.experience.getData().custom);
                });
                var latestSegment = sorted[sorted.length - 1];
                var latestFullyInteractiveStopTime = latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getFullyInteractiveStopTime();
                this.stop({
                    stopTime: latestSegment.getDependencyStopTime(),
                    customData: $ea33b232d012041d$var$_objectSpread($ea33b232d012041d$var$_objectSpread({}, accumulatedCustomData), {}, {
                        segment: latestSegment.getKey(),
                        segmentOverrided: latestSegment.getIsSegmentLoadOverrided()
                    }, latestFullyInteractiveStopTime ? {
                        latestFullyInteractiveSegment: latestFullyInteractiveSegment === null || latestFullyInteractiveSegment === void 0 ? void 0 : latestFullyInteractiveSegment.getKey(),
                        latestFullyInteractiveStopTime: latestFullyInteractiveStopTime
                    } : {})
                });
            }
        },
        {
            key: "watchUntil",
            value: function watchUntil() {
                var _this4 = this;
                if (!this.untilMetrics.length) return;
                if (this.isUntilFinished()) {
                    // Already finished, handle it immediately
                    this.handleAllUntilFinished();
                    return;
                }
                // If not currently finished, register stop callbacks to re-check
                this.untilOnStopCallback = function() {
                    if (_this4.isUntilFinished()) _this4.handleAllUntilFinished();
                };
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.FINISHED) metric.experience.onStop(_this4.untilOnStopCallback, function() {
                        return _this4.cancel();
                    });
                });
            }
        },
        {
            key: "cancelUntil",
            value: function cancelUntil() {
                var _this5 = this;
                this.untilMetrics.forEach(function(metric) {
                    if (metric.experience.getData().state !== $ea33b232d012041d$export$1e458f18c0c7bfe3.CANCELLED && _this5.untilOnStopCallback) metric.experience.removeOnStopCallback(_this5.untilOnStopCallback);
                });
            }
        },
        {
            key: "clear",
            value: function clear() {
                // todo before clearing - handle cancelling existing onStop / unsubscribe submetrics
                this.cancelUntil();
                this.state = $ea33b232d012041d$export$1e458f18c0c7bfe3.NOT_STARTED;
                this.startTime = null;
                this.stopTime = null;
                this.marks = {};
                this.custom = null;
                this.submetrics = [];
                this.route = null;
                this.pageVisibleState = $ea33b232d012041d$var$getPageVisibleState();
            }
        }
    ]);
    return BaseMetric;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ea33b232d012041d$export$2bce4ffdd840e878, "FMP", "fmp");

});
parcelRegister("cF8Kw", function(module, exports) {

var $5PW6D = parcelRequire("5PW6D");

var $2gzKi = parcelRequire("2gzKi");

var $2x5xA = parcelRequire("2x5xA");

var $aBSeI = parcelRequire("aBSeI");
function $938019caab71e88e$var$_toConsumableArray(r) {
    return $5PW6D(r) || $2gzKi(r) || $2x5xA(r) || $aBSeI();
}
module.exports = $938019caab71e88e$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5PW6D", function(module, exports) {

var $hqFoN = parcelRequire("hqFoN");
function $43fec9ce3ec2cc84$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $hqFoN(r);
}
module.exports = $43fec9ce3ec2cc84$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("2gzKi", function(module, exports) {
function $1a68cdbc4b71ab15$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $1a68cdbc4b71ab15$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("aBSeI", function(module, exports) {
function $7b976e47e7cf3fa8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $7b976e47e7cf3fa8$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("8x86A", function(module, exports) {

$parcel$export(module.exports, "restrictedTimingKeys", function () { return $6367b1548ca78ebd$export$1d17377365286b00; });
$parcel$export(module.exports, "clsWaitTimeMs", function () { return $6367b1548ca78ebd$export$df21d285cfcda81e; });
var $6367b1548ca78ebd$export$1d17377365286b00 = [
    "ssr"
];
var $6367b1548ca78ebd$export$df21d285cfcda81e = 7500;

});

parcelRegister("a3buC", function(module, exports) {

$parcel$export(module.exports, "visibilityChangeObserver", function () { return $7513196d4c09d629$export$13e680397ec8f3eb; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
var $7513196d4c09d629$var$VisibilityChangeObserver = /*#__PURE__*/ function() {
    function VisibilityChangeObserver() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VisibilityChangeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "observers", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "broadcast", function() {
            _this.observers.forEach(function(fn) {
                return fn();
            });
            _this.observers = [];
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VisibilityChangeObserver, [
        {
            key: "start",
            value: function start() {
                document.addEventListener("visibilitychange", this.broadcast);
                /**
       * According to https://developer.mozilla.org/en-US/docs/Web/API/Document/visibilitychange_event
       * Safari doesn’t fire visibilitychange as expected when the value of the visibilityState property transitions to hidden;
       * so for that case, you need to also include code to listen for the pagehide event.
       */ window.addEventListener("pagehide", this.broadcast);
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                this.observers.push(callback);
            }
        },
        {
            key: "unsubscribe",
            value: function unsubscribe(callback) {
                this.observers = this.observers.filter(function(fn) {
                    return fn !== callback;
                });
            }
        }
    ]);
    return VisibilityChangeObserver;
}();
var $7513196d4c09d629$export$13e680397ec8f3eb = new $7513196d4c09d629$var$VisibilityChangeObserver();

});

parcelRegister("ggnMj", function(module, exports) {

$parcel$export(module.exports, "UntilExperience", function () { return $bd7095d5b47b60e3$export$3fcc0936ee2cc852; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
var $bd7095d5b47b60e3$export$3fcc0936ee2cc852 = /*#__PURE__*/ function() {
    function UntilExperience(experience, useFmpAsUntilStopTime) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, UntilExperience);
        this.experience = experience;
        this.useFmpAsUntilStopTime = useFmpAsUntilStopTime;
    }
    /**
   * If FMP mark is present, return that
   * otherwise return the eventual load
   */ (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(UntilExperience, [
        {
            key: "getFmp",
            value: function getFmp() {
                var _marks$UntilExperienc;
                var _this$experience$getD = this.experience.getData(), marks = _this$experience$getD.marks, stop = _this$experience$getD.stop;
                return (_marks$UntilExperienc = marks[UntilExperience.FMP]) !== null && _marks$UntilExperienc !== void 0 ? _marks$UntilExperienc : stop;
            }
        },
        {
            key: "getDependencyStopTime",
            value: function getDependencyStopTime() {
                if (this.useFmpAsUntilStopTime) return this.getFmp();
                return this.experience.getData().stop;
            }
        },
        {
            key: "getFullyInteractiveStopTime",
            value: function getFullyInteractiveStopTime() {
                return this.experience.getData().stop;
            }
        },
        {
            key: "getIsSegmentLoadOverrided",
            value: function getIsSegmentLoadOverrided() {
                if (this.useFmpAsUntilStopTime) {
                    var _this$experience$getD2 = this.experience.getData(), marks = _this$experience$getD2.marks;
                    return marks[UntilExperience.FMP] ? true : false;
                }
                return false;
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return this.experience.getData().key;
            }
        }
    ], [
        {
            key: "fromConfig",
            value: function fromConfig(config) {
                return new UntilExperience(config.experience, config.useFmpAsUntilStopTime);
            }
        },
        {
            key: "fromMetric",
            value: function fromMetric(metric) {
                return new UntilExperience(metric);
            }
        }
    ]);
    return UntilExperience;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($bd7095d5b47b60e3$export$3fcc0936ee2cc852, "FMP", "fmp");

});



parcelRegister("h5wBz", function(module, exports) {

$parcel$export(module.exports, "BasePageLoadMetric", function () { return $c70c31f38521f58b$export$fd1447b187f590fe; });

var $cF8Kw = parcelRequire("cF8Kw");

var $siHsk = parcelRequire("siHsk");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5T1eV = parcelRequire("5T1eV");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $1XCKE = parcelRequire("1XCKE");

var $k6Eo3 = parcelRequire("k6Eo3");
function $c70c31f38521f58b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c70c31f38521f58b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c70c31f38521f58b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c70c31f38521f58b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c70c31f38521f58b$var$_createSuper(t) {
    var r = $c70c31f38521f58b$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $c70c31f38521f58b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c70c31f38521f58b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c70c31f38521f58b$export$fd1447b187f590fe = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(BasePageLoadMetric, _BaseMetric);
    var _super = $c70c31f38521f58b$var$_createSuper(BasePageLoadMetric);
    function BasePageLoadMetric(args) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, BasePageLoadMetric);
        _this = _super.call(this, args);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "isInitial", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "explicitTimings", null);
        _this.config = args;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(BasePageLoadMetric, [
        {
            key: "start",
            value: function start() {
                (0, (/*@__PURE__*/$parcel$interopDefault($siHsk)))(arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {});
                // please use startPageLoad
                return;
            }
        },
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                // todo this should update meta page load metric
                this.isInitial = params.isInitial;
                if (params.isInitial) (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "start", this).call(this, {
                    startTime: 0
                });
                else (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "start", this).call(this, params);
                (0, $1XCKE.logger).logCond(!!this.config.debug, this.key, this.startTime);
            }
        },
        {
            key: "stopPageLoad",
            value: function stopPageLoad(pageLoadMetaMetricData) {
                var stopArguments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    stopTime: window.performance.now()
                };
                if (pageLoadMetaMetricData.state !== (0, $k6Eo3.MetricState).STARTED || pageLoadMetaMetricData.start === null || stopArguments.stopTime === undefined) {
                    (0, $1XCKE.logger).log("meta metric has been stopped while not being started before; current state: ".concat(this.state));
                    return false;
                }
                if (stopArguments.stopTime < pageLoadMetaMetricData.start) {
                    (0, $1XCKE.logger).log("metric ".concat(this.config.key, " has been stopped with stopTime lower than startTime; startTime: ").concat(pageLoadMetaMetricData.start, "; stopTime: ").concat(stopArguments.stopTime));
                    return false;
                }
                this.merge(pageLoadMetaMetricData);
                this.stopTime = stopArguments.stopTime;
                this.state = (0, $k6Eo3.MetricState).FINISHED;
                this.handleStop(stopArguments);
                return true;
            }
        },
        {
            key: "handleStop",
            value: function handleStop(stopArguments) {
                var until = this.config.until;
                var fmpWasMarked = BasePageLoadMetric.FMP in this.marks;
                if (!fmpWasMarked && until) {
                    // Extract the maximum FMP value from the until metrics
                    var untilArr = Array.isArray(until) ? this.getConfiguredUntilMetricArray(until) : this.getConfiguredUntilMetricArray([
                        until
                    ]);
                    var untilFmpMarks = untilArr.map(function(metric) {
                        return metric.getFmp();
                    });
                    if (untilFmpMarks.every(Number.isFinite)) this.markFMP(Math.max.apply(Math, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(untilFmpMarks)));
                }
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "handleStop", this).call(this, stopArguments);
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === BasePageLoadMetric.FMP) return;
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "merge", this).call(this, mergeData);
                this.isInitial = mergeData.isInitial;
                this.explicitTimings = this.explicitTimings || mergeData.explicitTimings ? $c70c31f38521f58b$var$_objectSpread($c70c31f38521f58b$var$_objectSpread({}, mergeData.explicitTimings), this.explicitTimings) : null;
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "mark", this).call(this, BasePageLoadMetric.FMP, timestamp);
            }
        },
        {
            key: "getPageLoadData",
            value: function getPageLoadData() {
                return {
                    isInitial: this.isInitial,
                    explicitTimings: this.explicitTimings
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $c70c31f38521f58b$var$_objectSpread($c70c31f38521f58b$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "getData", this).call(this)), this.getPageLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $c70c31f38521f58b$var$_objectSpread($c70c31f38521f58b$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageLoadData());
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.explicitTimings = null;
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(BasePageLoadMetric.prototype), "clear", this).call(this);
            }
        }
    ]);
    return BasePageLoadMetric;
}((0, $k6Eo3.BaseMetric));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($c70c31f38521f58b$export$fd1447b187f590fe, "FMP", "fmp");

});
parcelRegister("siHsk", function(module, exports) {
function $05511f0ce57ee028$var$_objectDestructuringEmpty(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}
module.exports = $05511f0ce57ee028$var$_objectDestructuringEmpty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("djDSg", function(module, exports) {

$parcel$export(module.exports, "webVitalsObserver", function () { return $9b1bfae904dc6b23$export$253d38dccbb37615; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");


var $9b1bfae904dc6b23$var$WebVitalsObserver = /*#__PURE__*/ function() {
    function WebVitalsObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, WebVitalsObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "data", {
            "metric:ttci": null,
            "metric:ttfb": null,
            "metric:fid": null,
            "metric:fcp": null,
            "metric:lcp": null,
            "metric:cls": null
        });
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(WebVitalsObserver, [
        {
            key: "start",
            value: function start() {
                this.ttciDetermined = this.registerTTCI();
                this.webVitalsDetermined = this.registerWebVitals();
            }
        },
        {
            key: "registerWebVitals",
            value: function() {
                var _registerWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                    var _this = this;
                    var _yield$import, getCLS, getFCP, getFID, getLCP, getTTFB;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return (parcelRequire("dxOty"));
                            case 3:
                                _yield$import = _context.sent;
                                getCLS = _yield$import.getCLS;
                                getFCP = _yield$import.getFCP;
                                getFID = _yield$import.getFID;
                                getLCP = _yield$import.getLCP;
                                getTTFB = _yield$import.getTTFB;
                                _context.next = 11;
                                return Promise.all([
                                    getTTFB,
                                    getFID,
                                    getFCP,
                                    getLCP,
                                    getCLS
                                ].map(function(fx) {
                                    return new Promise(function(resolve) {
                                        fx(function(_ref) {
                                            var name = _ref.name, value = _ref.value;
                                            // round FCP, FID, LCP, TTFB to nearest integer.
                                            // CLS is rounded to two decimal places.
                                            var metricName = name.toLowerCase();
                                            var metricValue = metricName === "cls" ? parseFloat(value.toFixed(2)) : Math.round(value);
                                            _this.data["metric:".concat(metricName)] = metricValue;
                                            resolve();
                                        });
                                    });
                                }));
                            case 11:
                                _context.next = 15;
                                break;
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](0);
                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            13
                        ]
                    ]);
                }));
                function registerWebVitals() {
                    return _registerWebVitals.apply(this, arguments);
                }
                return registerWebVitals;
            }()
        },
        {
            key: "registerTTCI",
            value: function() {
                var _registerTTCI = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2() {
                    var _this2 = this;
                    var ttiPolyfill;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                _context2.prev = 0;
                                _context2.next = 3;
                                return (parcelRequire("h3CqE"));
                            case 3:
                                ttiPolyfill = _context2.sent;
                                _context2.next = 6;
                                return ttiPolyfill.getFirstConsistentlyInteractive().then(function(value) {
                                    // according to the docs:
                                    // If no TTI value can be found, or if the browser doesn't support all the APIs required to detect TTI,
                                    // the promise resolves to null.
                                    _this2.data["metric:ttci"] = typeof value === "number" ? Math.round(value) : value;
                                    return true;
                                });
                            case 6:
                                _context2.next = 10;
                                break;
                            case 8:
                                _context2.prev = 8;
                                _context2.t0 = _context2["catch"](0);
                            case 10:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }));
                function registerTTCI() {
                    return _registerTTCI.apply(this, arguments);
                }
                return registerTTCI;
            }()
        }
    ]);
    return WebVitalsObserver;
}();
var $9b1bfae904dc6b23$export$253d38dccbb37615 = new $9b1bfae904dc6b23$var$WebVitalsObserver();

});
parcelRegister("7f5qq", function(module, exports) {
function $545e247a57d186a7$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $545e247a57d186a7$var$_asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $545e247a57d186a7$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $545e247a57d186a7$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
module.exports = $545e247a57d186a7$var$_asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("5msJs", function(module, exports) {
// TODO(Babel 8): Remove this file.

var $3e754b711716897c$var$runtime = (parcelRequire("jwOVh"))();
module.exports = $3e754b711716897c$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $3e754b711716897c$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $3e754b711716897c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($3e754b711716897c$var$runtime);
}

});
parcelRegister("jwOVh", function(module, exports) {

var $cd8Dz = parcelRequire("cd8Dz");
var $e37881b6e69c288a$var$_typeof = $cd8Dz.default;
function $e37881b6e69c288a$var$_regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    module.exports = $e37881b6e69c288a$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == $e37881b6e69c288a$var$_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError($e37881b6e69c288a$var$_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var t = r.pop();
                if (t in e) return next.value = t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        "catch": function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
module.exports = $e37881b6e69c288a$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dxOty", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("69GGh")).then(()=>parcelRequire("jn0m1"));

});
parcelRegister("1VTzg", function(module, exports) {
"use strict";

var $gTxUZ = parcelRequire("gTxUZ");
module.exports = $gTxUZ(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName("script");
        if ([].concat(existingScripts).some(function isCurrentBundle(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement("link");
        preloadLink.href = bundle;
        preloadLink.rel = "preload";
        preloadLink.as = "script";
        document.head.appendChild(preloadLink);
        var script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(script);
    });
});

});
parcelRegister("gTxUZ", function(module, exports) {
"use strict";
var $c4cc17d3e4784de9$var$cachedBundles = {};
var $c4cc17d3e4784de9$var$cachedPreloads = {};
var $c4cc17d3e4784de9$var$cachedPrefetches = {};
function $c4cc17d3e4784de9$var$getCache(type) {
    switch(type){
        case "preload":
            return $c4cc17d3e4784de9$var$cachedPreloads;
        case "prefetch":
            return $c4cc17d3e4784de9$var$cachedPrefetches;
        default:
            return $c4cc17d3e4784de9$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $c4cc17d3e4784de9$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("h3CqE", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("38OVK")).then(()=>parcelRequire("8Kz3C"));

});


parcelRegister("eqyfk", function(module, exports) {

$parcel$export(module.exports, "Route", function () { return $a80e0f0135cf4d97$export$e7b0ac011bb776c6; });
var $a80e0f0135cf4d97$export$e7b0ac011bb776c6 = {
    route: "",
    setRoute: function setRoute(newRoute) {
        this.route = newRoute;
    },
    getRoute: function getRoute() {
        return this.route;
    }
};

});

parcelRegister("e1hkl", function(module, exports) {

$parcel$export(module.exports, "submitter", function () { return $a34e99832a236614$export$c21a25872e3f5a2b; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $cEEqZ = parcelRequire("cEEqZ");

var $3GjBI = parcelRequire("3GjBI");

var $d5QIn = parcelRequire("d5QIn");

var $6Uhl4 = parcelRequire("6Uhl4");
var $a34e99832a236614$export$c21a25872e3f5a2b = {
    debug: false,
    config: {
        gasv3: undefined,
        configChunk: null,
        useVisibleState: false,
        histogram: {},
        enableReactUFOTracker: false
    },
    configure: function configure(config) {
        this.config.gasv3 = config.endpoints.eventPipelineClient;
        this.config.enableReactUFOTracker = config.enableReactUFOTracker;
        this.config.configChunk = (0, $6Uhl4.makeShareableGlobalConfig)(config);
        if (config.events.all && config.events.all.sfxEvents) this.config.useVisibleState = config.events.all.sfxEvents.activeTab === (0, $3GjBI.PageVisibleFields).pageVisibleState;
    },
    setDebug: function setDebug(debug) {
        this.debug = debug;
    },
    queue: function queue(data) {
        var _this = this;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
            var chunk, payload, client, attributes;
            return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        if (_this.config.enableReactUFOTracker) (0, $cEEqZ.addBrowserMetricEvent)(data);
                        if (_this.config.configChunk) {
                            _context.next = 4;
                            break;
                        }
                        // eslint-disable-next-line no-console
                        _this.debug && console.warn("Submitter is not configured");
                        return _context.abrupt("return", null);
                    case 4:
                        _context.next = 6;
                        return _this.config.configChunk;
                    case 6:
                        chunk = _context.sent;
                        _context.next = 9;
                        return (0, $d5QIn.eventDataProcessor)(chunk[data.config.type], data);
                    case 9:
                        payload = _context.sent;
                        if (!(payload === null)) {
                            _context.next = 12;
                            break;
                        }
                        return _context.abrupt("return");
                    case 12:
                        if (!(_this.config.gasv3 !== undefined)) {
                            _context.next = 18;
                            break;
                        }
                        _context.next = 15;
                        return _this.config.gasv3;
                    case 15:
                        client = _context.sent;
                        attributes = {
                            task: payload["event:key"],
                            properties: payload
                        };
                        client && client.sendOperationalEvent({
                            actionSubject: "performance",
                            attributes: attributes,
                            source: "performance",
                            action: "measured"
                        });
                    case 18:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }))();
    }
};

});
parcelRegister("cEEqZ", function(module, exports) {

$parcel$export(module.exports, "addBrowserMetricEvent", function () { return $936895e14ce66993$export$4a759336b50e86e3; });

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $cF8Kw = parcelRequire("cF8Kw");

var $a6HGw = parcelRequire("a6HGw");

var $9HsPi = parcelRequire("9HsPi");

var $dyWhr = parcelRequire("dyWhr");

var $dxun7 = parcelRequire("dxun7");

var $bAdsy = parcelRequire("bAdsy");

var $gwJNC = parcelRequire("gwJNC");

var $iww5R = parcelRequire("iww5R");

var $bT8qz = parcelRequire("bT8qz");

var $csWGA = parcelRequire("csWGA");
function $936895e14ce66993$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $936895e14ce66993$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $936895e14ce66993$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $936895e14ce66993$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $936895e14ce66993$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $936895e14ce66993$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $936895e14ce66993$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $936895e14ce66993$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $936895e14ce66993$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $936895e14ce66993$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $936895e14ce66993$var$PreviousInteractionLog = {
    name: undefined,
    isAborted: undefined
};
var $936895e14ce66993$export$d8f52e8f804021e8 = new (0, $csWGA.default)();
var $936895e14ce66993$var$interactionQueue = [];
var $936895e14ce66993$var$segmentCache = new Map();
var $936895e14ce66993$var$CLEANUP_TIMEOUT = 60000;
var $936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX = 15000;
var $936895e14ce66993$var$segmentObservers = [];
function $936895e14ce66993$export$2b3954d2e8509985() {
    var interactionId = (0, $gwJNC.getInteractionId)();
    if (!interactionId.current) return;
    return (0, $bT8qz.default).get(interactionId.current);
}
function $936895e14ce66993$var$labelStackToString(labelStack, name) {
    var _stack$map;
    var stack = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(labelStack !== null && labelStack !== void 0 ? labelStack : []);
    if (name) stack.push({
        name: name
    });
    return (_stack$map = stack.map(function(l) {
        return l.name;
    })) === null || _stack$map === void 0 ? void 0 : _stack$map.join("/");
}
function $936895e14ce66993$var$labelStackToIdString(labelStack) {
    var _labelStack$map;
    return labelStack === null || labelStack === void 0 || (_labelStack$map = labelStack.map(function(l) {
        return "segmentId" in l ? "".concat(l.name, ":").concat(l.segmentId) : "".concat(l.name);
    })) === null || _labelStack$map === void 0 ? void 0 : _labelStack$map.join("/");
}
function $936895e14ce66993$var$addSegmentObserver(observer) {
    $936895e14ce66993$var$segmentObservers.push(observer);
    var _iterator = $936895e14ce66993$var$_createForOfIteratorHelper($936895e14ce66993$var$segmentCache.values()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var segmentInfo = _step.value;
            observer.onAdd(segmentInfo);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $936895e14ce66993$var$removeSegmentObserver(observer) {
    var index = $936895e14ce66993$var$segmentObservers.findIndex(function(obs) {
        return obs === observer;
    });
    if (index !== -1) $936895e14ce66993$var$segmentObservers.splice(index, 1);
}
function $936895e14ce66993$export$cd7f480d6b8286c3(interactionId) {
    (0, $bT8qz.default).delete(interactionId);
}
function $936895e14ce66993$export$f6f1cf5bedf83c71(ufoName) {
    var routeName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ufoName;
    var interaction = $936895e14ce66993$export$2b3954d2e8509985();
    if (!interaction || interaction.type !== "page_load" && interaction.type !== "transition") return;
    interaction.ufoName = ufoName;
    interaction.routeName = routeName;
}
function $936895e14ce66993$export$12f2b6cb85d59904(interactionId, data) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(key) {
        interaction.metaData[key] = data[key];
    });
}
function $936895e14ce66993$export$e4380431c2bdabee(interactionId, labelStack, data) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) Object.keys(data).forEach(function(i) {
        interaction.customData.push({
            labelStack: labelStack,
            data: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, i, data[i])
        });
    });
}
function $936895e14ce66993$export$27cacb7d7f3fe20a(interactionId, labelStack, data) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        interaction.customTimings.push({
            labelStack: labelStack,
            data: data
        });
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) for(var _i = 0, _Object$entries = Object.entries(data); _i < _Object$entries.length; _i++){
            var _Object$entries$_i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_Object$entries[_i], 2), key = _Object$entries$_i[0], timingData = _Object$entries$_i[1];
            var startTime = timingData.startTime, endTime = timingData.endTime;
            try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, key), " [custom_timing]"), {
                    start: startTime,
                    end: endTime
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
function $936895e14ce66993$export$728e28c22a0fba4(interactionId, type, name, labelStack) {
    var time = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) interaction.marks.push({
        type: type,
        name: name,
        labelStack: labelStack,
        time: time
    });
    if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) performance.mark("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $936895e14ce66993$export$c4b23cc624bd2fb(type, name, labelStack) {
    var time = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : performance.now();
    (0, $bT8qz.default).forEach(function(interaction) {
        interaction.marks.push({
            type: type,
            name: name,
            labelStack: labelStack,
            time: time
        });
    });
    if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) performance.mark("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
        startTime: time
    });
}
function $936895e14ce66993$export$2c1d6e17cfa9bbc7(interactionId, type, name, labelStack, start) {
    var end = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : performance.now();
    var size = arguments.length > 6 ? arguments[6] : undefined;
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
                start: start,
                end: end
            });
        } catch (e) {
        // do nothing
        }
    }
}
function $936895e14ce66993$export$943a8b2b5d6b1809(type, name, labelStack, start) {
    var end = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : performance.now();
    var size = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    (0, $bT8qz.default).forEach(function(interaction) {
        interaction.spans.push({
            type: type,
            name: name,
            labelStack: labelStack,
            start: start,
            end: end,
            size: size
        });
    });
    if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [").concat(type, "]"), {
            start: start,
            end: end
        });
    } catch (e) {
    // do nothing
    }
}
function $936895e14ce66993$export$9e04fe1a58571ec(moduleId, timestamp) {
    $936895e14ce66993$export$c4b23cc624bd2fb("bundle_preload", moduleId, null, timestamp);
}
function $936895e14ce66993$export$6f228d1fdc911d7(identifier, start, end) {
    $936895e14ce66993$export$943a8b2b5d6b1809("bundle_load", identifier, null, start, end - start);
}
var $936895e14ce66993$var$moduleLoadingRequests = {};
function $936895e14ce66993$export$f5a8f10de74904da(input) {
    var result = input !== null && input !== void 0 ? input : "";
    result = result.replace(/^\.\/src\/packages\//, "");
    result = result.replace(/^\.\/node_modules\//, "");
    result = result.replace(/(\/src)?\/(index|main)\.(tsx|ts|js|jsx)$/, "");
    return result;
}
function $936895e14ce66993$var$addHoldCriterion(id, labelStack, name, startTime) {
    var _window$__CRITERION__;
    if (!((_window$__CRITERION__ = window.__CRITERION__) !== null && _window$__CRITERION__ !== void 0 && _window$__CRITERION__.addUFOHold)) return;
    window.__CRITERION__.addUFOHold(id, $936895e14ce66993$var$labelStackToString(labelStack), name, startTime);
}
function $936895e14ce66993$var$removeHoldCriterion(id) {
    var _window$__CRITERION__2;
    if (!((_window$__CRITERION__2 = window.__CRITERION__) !== null && _window$__CRITERION__2 !== void 0 && _window$__CRITERION__2.removeUFOHold)) return;
    window.__CRITERION__.removeUFOHold(id);
}
function $936895e14ce66993$export$7606887303596f82(interactionId, labelStack, name) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    var id = (0, $a6HGw.v4)();
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start
        });
        $936895e14ce66993$var$addHoldCriterion(id, labelStack, name, start);
        return function() {
            var end = performance.now();
            if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack, name), " [hold]"), {
                    start: start,
                    end: end
                });
            } catch (e) {
            // do nothing
            }
            $936895e14ce66993$var$removeHoldCriterion(id);
            var currentInteraction = (0, $bT8qz.default).get(interactionId);
            var currentHold = interaction.holdActive.get(id);
            if (currentInteraction != null && currentHold != null) {
                currentInteraction.holdInfo.push($936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, currentHold), {}, {
                    end: end
                }));
                interaction.holdActive.delete(id);
            }
        };
    }
    return function() {};
}
function $936895e14ce66993$export$10582acd678c213(interactionId, labelStack, name, id, ignoreOnSubmit) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        var start = performance.now();
        interaction.holdActive.set(id, {
            labelStack: labelStack,
            name: name,
            start: start,
            ignoreOnSubmit: ignoreOnSubmit
        });
        $936895e14ce66993$var$addHoldCriterion(id, labelStack, name, start);
    }
    return function() {};
}
function $936895e14ce66993$export$4983dfbbb996f7ae(interactionId, id) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        var end = performance.now();
        var currentInteraction = (0, $bT8qz.default).get(interactionId);
        var currentHold = interaction.holdActive.get(id);
        if (currentInteraction != null && currentHold != null) {
            currentInteraction.holdInfo.push($936895e14ce66993$var$_objectSpread($936895e14ce66993$var$_objectSpread({}, currentHold), {}, {
                end: end
            }));
            interaction.holdActive.delete(id);
            $936895e14ce66993$var$removeHoldCriterion(id);
        }
    }
}
function $936895e14ce66993$export$2df109852219d16e(interactionId) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction) return interaction.type;
    return null;
}
var $936895e14ce66993$export$9591b52b33ccc510 = {
    onPreload: function onPreload(moduleId, _priority) {
        $936895e14ce66993$export$9e04fe1a58571ec($936895e14ce66993$export$f5a8f10de74904da(moduleId), performance.now());
    },
    onLoadStart: function onLoadStart(info) {
        var timeoutId = setTimeout(function() {
            delete $936895e14ce66993$var$moduleLoadingRequests[info.identifier];
        }, 30000);
        var request = {
            start: performance.now(),
            timeoutId: timeoutId
        };
        $936895e14ce66993$var$moduleLoadingRequests[info.identifier] = request;
    },
    onLoadComplete: function onLoadComplete(info) {
        var request = $936895e14ce66993$var$moduleLoadingRequests[info.identifier];
        if (request) {
            clearTimeout(request.timeoutId);
            delete $936895e14ce66993$var$moduleLoadingRequests[info.identifier];
            $936895e14ce66993$export$6f228d1fdc911d7($936895e14ce66993$export$f5a8f10de74904da(info.identifier), request.start, performance.now());
        }
    },
    placeholderFallBackMounted: function placeholderFallBackMounted(id, moduleId) {
        var interactionId = (0, $gwJNC.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $936895e14ce66993$export$10582acd678c213(currentInteractionId, [], moduleId, id);
    },
    placeholderFallBackUnmounted: function placeholderFallBackUnmounted(id) {
        var interactionId = (0, $gwJNC.getInteractionId)();
        var currentInteractionId = interactionId.current;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $936895e14ce66993$export$4983dfbbb996f7ae(currentInteractionId, id);
    }
};
function $936895e14ce66993$export$239c33984d9b1367(interactionId, name, labelStack, errorType, errorMessage, errorStack, forcedError) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) interaction.errors.push({
        name: name,
        labelStack: labelStack,
        errorType: errorType,
        errorMessage: errorMessage,
        errorStack: errorStack,
        forcedError: forcedError
    });
}
function $936895e14ce66993$export$7379c15afd3840fa(name, labelStack, errorType, errorMessage, errorStack) {
    (0, $bT8qz.default).forEach(function(interaction) {
        interaction.errors.push({
            name: name,
            labelStack: labelStack,
            errorType: errorType,
            errorMessage: errorMessage,
            errorStack: errorStack
        });
    });
}
var $936895e14ce66993$export$53d6f611de951a13 = function addProfilerTimings(interactionId, labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
    var _getConfig;
    if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack), " [react-profiler] ").concat(type), {
            start: startTime,
            duration: actualDuration
        });
    } catch (e) {
    // do nothing
    }
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) interaction.reactProfilerTimings.push({
        labelStack: labelStack,
        type: type,
        actualDuration: actualDuration,
        baseDuration: baseDuration,
        startTime: startTime,
        commitTime: commitTime
    });
    else if ((_getConfig = (0, $dyWhr.getConfig)()) !== null && _getConfig !== void 0 && (_getConfig = _getConfig.postInteractionLog) !== null && _getConfig !== void 0 && _getConfig.enabled) $936895e14ce66993$export$d8f52e8f804021e8.addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime);
};
var $936895e14ce66993$var$pushToQueue = function pushToQueue(id, data) {
    $936895e14ce66993$var$interactionQueue.push({
        id: id,
        data: data
    });
};
var $936895e14ce66993$var$handleInteraction = $936895e14ce66993$var$pushToQueue;
function $936895e14ce66993$var$callCleanUpCallbacks(interaction) {
    interaction.cleanupCallbacks.reverse().forEach(function(cleanUpCallback) {
        cleanUpCallback();
    });
}
var $936895e14ce66993$var$finishInteraction = function finishInteraction(id, data) {
    var _getConfig2;
    var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    // eslint-disable-next-line no-param-reassign
    data.end = endTime;
    try {
        // for Firefox 102 and older
        performance.measure("\uD83D\uDEF8 [".concat(data.type, "] ").concat(data.ufoName, " [ttai]"), {
            start: data.start,
            end: data.end
        });
    } catch (e) {
    // do nothing
    }
    if (data.featureFlags) // eslint-disable-next-line no-param-reassign
    data.featureFlags.during = Object.fromEntries((0, $bAdsy.currentFeatureFlagsAccessed));
    (0, $dxun7.clearActiveTrace)();
    $936895e14ce66993$var$callCleanUpCallbacks(data);
    if ((_getConfig2 = (0, $dyWhr.getConfig)()) !== null && _getConfig2 !== void 0 && (_getConfig2 = _getConfig2.vc) !== null && _getConfig2 !== void 0 && _getConfig2.stopVCAtInteractionFinish) data.vc = (0, $iww5R.getVCObserver)().getVCRawData();
    $936895e14ce66993$export$cd7f480d6b8286c3(id);
    $936895e14ce66993$var$PreviousInteractionLog.name = data.ufoName || "unknown";
    $936895e14ce66993$var$PreviousInteractionLog.isAborted = data.abortReason != null;
    if (data.ufoName) $936895e14ce66993$var$handleInteraction(id, data);
    if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) {
        var profilerTimingMap = new Map();
        data.reactProfilerTimings.forEach(function(profilerTiming) {
            var labelStackId = $936895e14ce66993$var$labelStackToIdString(profilerTiming.labelStack);
            if (labelStackId) {
                var _profilerTimingMap$ge, _timing$start, _timing$end;
                var timing = (_profilerTimingMap$ge = profilerTimingMap.get(labelStackId)) !== null && _profilerTimingMap$ge !== void 0 ? _profilerTimingMap$ge : {
                    labelStack: profilerTiming.labelStack
                };
                timing.start = profilerTiming.startTime < ((_timing$start = timing.start) !== null && _timing$start !== void 0 ? _timing$start : Number.MAX_SAFE_INTEGER) ? profilerTiming.startTime : timing.start;
                timing.end = profilerTiming.commitTime > ((_timing$end = timing.end) !== null && _timing$end !== void 0 ? _timing$end : Number.MIN_SAFE_INTEGER) ? profilerTiming.commitTime : timing.end;
                profilerTimingMap.set(labelStackId, timing);
            }
        });
        try {
            // for Firefox 102 and older
            var _iterator2 = $936895e14ce66993$var$_createForOfIteratorHelper(profilerTimingMap.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _step2$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step2.value, 2), _step2$value$ = _step2$value[1], labelStack = _step2$value$.labelStack, start = _step2$value$.start, end = _step2$value$.end;
                    performance.measure("\uD83D\uDEF8 ".concat($936895e14ce66993$var$labelStackToString(labelStack), " [segment_ttai]"), {
                        start: start,
                        end: end
                    });
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        } catch (e) {
        // do nothing
        }
    }
    try {
        // dispatch a global window event to notify the measure is completed
        window.dispatchEvent(new CustomEvent("UFO_FINISH_INTERACTION", {
            detail: data
        }));
    } catch (error) {
    // do nothing
    }
};
var $936895e14ce66993$export$9e614a29a1ac213e = function sinkInteractionHandler(sinkFn) {
    if ($936895e14ce66993$var$handleInteraction === $936895e14ce66993$var$pushToQueue) {
        $936895e14ce66993$var$handleInteraction = sinkFn;
        $936895e14ce66993$var$interactionQueue.forEach(function(interaction) {
            sinkFn(interaction.id, interaction.data);
        });
        $936895e14ce66993$var$interactionQueue.length = 0;
    }
};
var $936895e14ce66993$export$8a1ba7bef607358a = function sinkPostInteractionLogHandler(sinkFn) {
    $936895e14ce66993$export$d8f52e8f804021e8.sinkHandler(sinkFn);
};
function $936895e14ce66993$export$673be905888f8839(interactionId, endTime) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (noMoreHolds) {
            var _getConfig3;
            $936895e14ce66993$var$finishInteraction(interactionId, interaction, endTime);
            if ((_getConfig3 = (0, $dyWhr.getConfig)()) !== null && _getConfig3 !== void 0 && (_getConfig3 = _getConfig3.postInteractionLog) !== null && _getConfig3 !== void 0 && _getConfig3.enabled) $936895e14ce66993$export$d8f52e8f804021e8.onInteractionComplete(interaction);
        }
    }
}
function $936895e14ce66993$var$callCancelCallbacks(interaction) {
    interaction.cancelCallbacks.reverse().forEach(function(cancelCallback) {
        cancelCallback();
    });
}
function $936895e14ce66993$export$5def58af4fd46132(interactionId, abortReason) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        $936895e14ce66993$var$callCancelCallbacks(interaction);
        interaction.abortReason = abortReason;
        $936895e14ce66993$var$finishInteraction(interactionId, interaction);
    }
}
function $936895e14ce66993$export$c4a545284f55edf2(interactionId, interactionName) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        $936895e14ce66993$var$callCancelCallbacks(interaction);
        interaction.abortReason = "new_interaction";
        interaction.abortedByInteractionName = interactionName;
        $936895e14ce66993$var$finishInteraction(interactionId, interaction);
    }
}
function $936895e14ce66993$export$614a7af2affc5dff(abortReason, abortedByInteractionName) {
    (0, $bT8qz.default).forEach(function(interaction, interactionId) {
        var noMoreHolds = interaction.holdActive.size === 0;
        if (!noMoreHolds) {
            $936895e14ce66993$var$callCancelCallbacks(interaction);
            // eslint-disable-next-line no-param-reassign
            interaction.abortReason = abortReason;
            if (abortedByInteractionName != null) // eslint-disable-next-line no-param-reassign
            interaction.abortedByInteractionName = abortedByInteractionName;
        }
        $936895e14ce66993$var$finishInteraction(interactionId, interaction);
    });
}
function $936895e14ce66993$export$7b9261a96cfe427b(id, cancelCallback) {
    var interaction = (0, $bT8qz.default).get(id);
    interaction === null || interaction === void 0 || interaction.cancelCallbacks.push(cancelCallback);
}
function $936895e14ce66993$export$1a1ed1e1fdb2006b(interactionId, ufoName, type, startTime, rate, labelStack, routeName) {
    var _getConfig4;
    var trace = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
    if ((_getConfig4 = (0, $dyWhr.getConfig)()) !== null && _getConfig4 !== void 0 && (_getConfig4 = _getConfig4.postInteractionLog) !== null && _getConfig4 !== void 0 && _getConfig4.enabled) $936895e14ce66993$export$d8f52e8f804021e8.reset();
    var previousTime = startTime;
    var timeoutTime = $936895e14ce66993$var$CLEANUP_TIMEOUT;
    var timerID = setTimeout(function() {
        $936895e14ce66993$export$5def58af4fd46132(interactionId, "timeout");
    }, $936895e14ce66993$var$CLEANUP_TIMEOUT);
    function changeTimeout(newTime) {
        // we compare if the time left is lower than the new time to no
        // extend the timeout beyond the initial waiting time
        var currentTime = performance.now();
        var timeLeft = timeoutTime - (currentTime - previousTime);
        if (timeLeft < newTime) return;
        clearTimeout(this.timerID);
        var newTimerID = setTimeout(function() {
            $936895e14ce66993$export$5def58af4fd46132(interactionId, "timeout");
        }, newTime);
        timeoutTime = newTime;
        previousTime = currentTime;
        this.timerID = newTimerID;
    }
    var addFeatureFlagsToInteraction = (0, $9HsPi.default)((0, $dyWhr.getCapabilityRate)("feature_flag_access"));
    var metrics = {
        id: interactionId,
        start: startTime,
        end: 0,
        ufoName: ufoName,
        type: type,
        previousInteractionName: $936895e14ce66993$var$PreviousInteractionLog.name,
        isPreviousInteractionAborted: $936895e14ce66993$var$PreviousInteractionLog.isAborted === true,
        marks: [],
        customData: [],
        customTimings: [],
        spans: [],
        requestInfo: [],
        reactProfilerTimings: [],
        holdInfo: [],
        holdActive: new Map(),
        // measure when we execute this code
        // from this we can measure the input delay -
        // how long the browser took to hand execution back to JS)
        measureStart: performance.now(),
        rate: rate,
        cancelCallbacks: [],
        metaData: {},
        errors: [],
        apdex: [],
        labelStack: labelStack,
        routeName: routeName !== null && routeName !== void 0 ? routeName : ufoName,
        featureFlags: addFeatureFlagsToInteraction ? {
            prior: Object.fromEntries((0, $bAdsy.allFeatureFlagsAccessed)),
            during: {}
        } : undefined,
        knownSegments: [],
        cleanupCallbacks: [],
        awaitReactProfilerCount: 0,
        redirects: [],
        timerID: timerID,
        changeTimeout: changeTimeout,
        trace: trace
    };
    if (addFeatureFlagsToInteraction) (0, $bAdsy.currentFeatureFlagsAccessed).clear();
    (0, $bT8qz.default).set(interactionId, metrics);
    var segmentObserver = {
        onAdd: function onAdd(segment) {
            metrics.knownSegments.push(segment);
        },
        onRemove: function onRemove() {}
    };
    $936895e14ce66993$var$addSegmentObserver(segmentObserver);
    metrics.cleanupCallbacks.push(function() {
        $936895e14ce66993$var$removeSegmentObserver(segmentObserver);
    });
    metrics.cleanupCallbacks.push(function() {
        clearTimeout(metrics.timerID);
    });
    var awaitBM3TTIList = (0, $dyWhr.getAwaitBM3TTIList)();
    if (awaitBM3TTIList.includes(ufoName)) $936895e14ce66993$export$10582acd678c213(interactionId, [], ufoName, ufoName, true);
    if (type === "transition") {
        (0, $iww5R.getVCObserver)().start({
            startTime: startTime
        });
        $936895e14ce66993$export$d8f52e8f804021e8.startVCObserver({
            startTime: startTime
        });
    }
}
function $936895e14ce66993$export$4a759336b50e86e3(event) {
    var interaction = $936895e14ce66993$export$2b3954d2e8509985();
    if (interaction) {
        var _event$config;
        interaction.legacyMetrics = interaction.legacyMetrics || [];
        interaction.legacyMetrics.push(event);
        if ((interaction.type === "page_load" || interaction.type === "transition") && ((_event$config = event.config) === null || _event$config === void 0 ? void 0 : _event$config.type) === "PAGE_LOAD") {
            interaction.changeTimeout($936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $936895e14ce66993$export$4983dfbbb996f7ae(interaction.id, interaction.ufoName);
        }
    }
}
function $936895e14ce66993$export$ad216cc25852d44b(apdex) {
    (0, $bT8qz.default).forEach(function(interaction, key) {
        interaction.apdex.push(apdex);
        try {
            var _apdex$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdex.key, " [bm3_tti]"), {
                start: (_apdex$startTime = apdex.startTime) !== null && _apdex$startTime !== void 0 ? _apdex$startTime : interaction.start,
                end: apdex.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $936895e14ce66993$export$4983dfbbb996f7ae(key, interaction.ufoName);
        }
    });
}
function $936895e14ce66993$export$35220fd6cdd1b731(interactionId, apdexInfo) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        interaction.apdex.push(apdexInfo);
        try {
            var _apdexInfo$startTime;
            // for Firefox 102 and older
            performance.measure("\uD83D\uDEF8 ".concat(apdexInfo.key, " [bm3_tti]"), {
                start: (_apdexInfo$startTime = apdexInfo.startTime) !== null && _apdexInfo$startTime !== void 0 ? _apdexInfo$startTime : interaction.start,
                end: apdexInfo.stopTime
            });
        } catch (e) {
        // do nothing
        }
        if (interaction.type === "page_load" || interaction.type === "transition") {
            interaction.changeTimeout($936895e14ce66993$var$CLEANUP_TIMEOUT_AFTER_APDEX);
            $936895e14ce66993$export$4983dfbbb996f7ae(interactionId, interaction.ufoName);
        }
    }
}
function $936895e14ce66993$export$57d55b4569823d8f(interactionId, labelStack, requestInfo) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) interaction.requestInfo.push($936895e14ce66993$var$_objectSpread({
        labelStack: labelStack
    }, requestInfo));
}
function $936895e14ce66993$var$isSegmentLabel(obj) {
    return obj && typeof obj.name === "string" && typeof obj.segmentId === "string";
}
function $936895e14ce66993$var$getSegmentCacheKey(labelStack) {
    return labelStack.map(function(l) {
        if ($936895e14ce66993$var$isSegmentLabel(l)) return "".concat(l.name, "_").concat(l.segmentId);
        return l.name;
    }).join("|");
}
function $936895e14ce66993$export$1c43f9ac826b6462(labelStack) {
    var key = $936895e14ce66993$var$getSegmentCacheKey(labelStack);
    var existingSegment = $936895e14ce66993$var$segmentCache.get(key);
    if (!existingSegment) {
        var segmentInfo = {
            labelStack: labelStack
        };
        $936895e14ce66993$var$segmentCache.set(key, segmentInfo);
        $936895e14ce66993$var$segmentObservers.forEach(function(observer) {
            observer.onAdd(segmentInfo);
        });
    }
}
function $936895e14ce66993$export$d0365e48b58231c3(labelStack) {
    var key = $936895e14ce66993$var$getSegmentCacheKey(labelStack);
    var segmentInfo = $936895e14ce66993$var$segmentCache.get(key);
    if (segmentInfo) {
        $936895e14ce66993$var$segmentCache.delete(JSON.stringify(labelStack));
        $936895e14ce66993$var$segmentObservers.forEach(function(observer) {
            observer.onRemove(segmentInfo);
        });
    }
}
function $936895e14ce66993$export$bbf14d79614d9818(interactionId, fromUfoName, nextUfoName, nextRouteName, time) {
    var interaction = (0, $bT8qz.default).get(interactionId);
    if (interaction != null) {
        interaction.ufoName = nextUfoName;
        interaction.routeName = nextRouteName;
        interaction.redirects.push({
            fromInteractionName: fromUfoName,
            time: time
        });
        if (window.__REACT_UFO_ENABLE_PERF_TRACING || false) {
            var prevRedirect = interaction.redirects.at(-2);
            try {
                var _prevRedirect$time;
                // for Firefox 102 and older
                performance.measure("\uD83D\uDEF8 ".concat(nextUfoName, " [redirect]"), {
                    start: (_prevRedirect$time = prevRedirect === null || prevRedirect === void 0 ? void 0 : prevRedirect.time) !== null && _prevRedirect$time !== void 0 ? _prevRedirect$time : interaction.start,
                    end: time
                });
            } catch (e) {
            // do nothing
            }
        }
    }
}
var $936895e14ce66993$export$6ce04c7ca6810a7e = [];
var $936895e14ce66993$var$defaultLabelStack = [
    {
        name: "custom"
    }
];
function $936895e14ce66993$export$5342dcad19138a1c(name, start) {
    var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : performance.now();
    var size = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var labelStack = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : $936895e14ce66993$var$defaultLabelStack;
    var customSpan = {
        type: "custom",
        name: name,
        start: start,
        end: end,
        labelStack: labelStack,
        size: size
    };
    $936895e14ce66993$export$6ce04c7ca6810a7e.push(customSpan);
}

});
parcelRegister("a6HGw", function(module, exports) {

var $2CvmD = parcelRequire("2CvmD");

var $gaCcd = parcelRequire("gaCcd");
var $75bc59d865218414$var$uuid = $gaCcd;
$75bc59d865218414$var$uuid.v1 = $2CvmD;
$75bc59d865218414$var$uuid.v4 = $gaCcd;
module.exports = $75bc59d865218414$var$uuid;

});
parcelRegister("2CvmD", function(module, exports) {

var $9mvsX = parcelRequire("9mvsX");

var $diJJr = parcelRequire("diJJr");
// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $1e8775a88be993f8$var$_nodeId;
var $1e8775a88be993f8$var$_clockseq;
// Previous uuid creation time
var $1e8775a88be993f8$var$_lastMSecs = 0;
var $1e8775a88be993f8$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $1e8775a88be993f8$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $1e8775a88be993f8$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $1e8775a88be993f8$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $9mvsX();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $1e8775a88be993f8$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $1e8775a88be993f8$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $1e8775a88be993f8$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $1e8775a88be993f8$var$_lastMSecs + (nsecs - $1e8775a88be993f8$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $1e8775a88be993f8$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
    $1e8775a88be993f8$var$_lastMSecs = msecs;
    $1e8775a88be993f8$var$_lastNSecs = nsecs;
    $1e8775a88be993f8$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $diJJr(b);
}
module.exports = $1e8775a88be993f8$var$v1;

});


parcelRegister("9HsPi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $70fe7d8078cc2f59$export$2e2bcd8739ae039; });
/**
 * A random function that passes one in rate times.
 * E.g. coinflip(2) is the same as if you flipped a coin.
 * It will pass 50% of the time
 * @param rate The change that it will pass (1 in <rate> times)
 * @returns bool, if it passes or not
 */ function $70fe7d8078cc2f59$export$2e2bcd8739ae039(rate) {
    if (rate === 0) return false;
    else if (rate === 1) return true;
    else return Math.random() * rate <= 1;
}

});

parcelRegister("dyWhr", function(module, exports) {

$parcel$export(module.exports, "getConfig", function () { return $9dfba891a747bf0b$export$44487a86467333c3; });
$parcel$export(module.exports, "getCapabilityRate", function () { return $9dfba891a747bf0b$export$29b9ffb14861a1d; });
$parcel$export(module.exports, "getAwaitBM3TTIList", function () { return $9dfba891a747bf0b$export$2d311b3fd18dcab1; });
var $9dfba891a747bf0b$var$config;
function $9dfba891a747bf0b$export$10d6139a8fb42158(newConfig) {
    $9dfba891a747bf0b$var$config = newConfig;
}
function $9dfba891a747bf0b$export$44487a86467333c3() {
    return $9dfba891a747bf0b$var$config;
}
function $9dfba891a747bf0b$export$9466a8f085fa7d4e(name, interactionKind) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config = $9dfba891a747bf0b$var$config, killswitch = _config.killswitch, rates = _config.rates, rules = _config.rules, kind = _config.kind, autoGeneratedRate = _config.autoGeneratedRate;
        if (killswitch != null) {
            // Specifically kill certain events
            if (killswitch.includes(name)) return 0;
        }
        if (rates != null) {
            // Decide the rate explicitly
            if (rates[name] != null) return rates[name];
        }
        if (rules != null) for(var i = 0; i < rules.length; i++){
            var rule = rules[i];
            var test = rule.test, rate = rule.rate;
            if (test != null && rate != null) {
                var regexp = new RegExp(test, "ig");
                if (regexp.test(name)) return rate;
            }
        }
        var isAutogenerated = name === null || name === void 0 ? void 0 : name.startsWith("auto-generated");
        if (isAutogenerated) {
            var _rate = autoGeneratedRate;
            if (_rate != null) return _rate;
        }
        if (kind != null) {
            var _rate2 = kind[interactionKind];
            if (_rate2 != null) return _rate2;
        }
        return 0;
    } catch (e) {
        // Fallback
        return 0;
    }
}
function $9dfba891a747bf0b$export$1d459f020c06ae34(name, interactionType) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config2 = $9dfba891a747bf0b$var$config, postInteractionLog = _config2.postInteractionLog;
        if (!(postInteractionLog !== null && postInteractionLog !== void 0 && postInteractionLog.enabled)) return 0;
        if (postInteractionLog.rates && typeof postInteractionLog.rates[name] === "number") return postInteractionLog.rates[name];
        if (postInteractionLog.kind && typeof postInteractionLog.kind[interactionType] === "number") return postInteractionLog.kind[interactionType];
        return 0;
    } catch (e) {
        return 0;
    }
}
function $9dfba891a747bf0b$export$29b9ffb14861a1d(capability) {
    try {
        if (!$9dfba891a747bf0b$var$config) return 0;
        var _config3 = $9dfba891a747bf0b$var$config, capabilityRate = _config3.capability;
        if (capabilityRate != null) {
            var rate = capabilityRate[capability];
            if (rate != null) return rate;
        }
        return 0;
    } catch (_unused) {
        return 0;
    }
}
var $9dfba891a747bf0b$var$validTypingMethods = [
    "timeout",
    "timeoutNoAlloc",
    "mutationObserver"
];
function $9dfba891a747bf0b$export$7e32aae12bf9b50f() {
    var defaultMethod = "timeout";
    try {
        if (!$9dfba891a747bf0b$var$config) return defaultMethod;
        var _config4 = $9dfba891a747bf0b$var$config, typingMethod = _config4.typingMethod;
        if (typingMethod != null && $9dfba891a747bf0b$var$validTypingMethods.find(function(m) {
            return m === typingMethod;
        })) return typingMethod;
        else return defaultMethod;
    } catch (e) {
        return defaultMethod;
    }
}
function $9dfba891a747bf0b$export$2d311b3fd18dcab1() {
    try {
        if (!$9dfba891a747bf0b$var$config) return [];
        var _config5 = $9dfba891a747bf0b$var$config, awaitBM3TTI = _config5.awaitBM3TTI;
        if (awaitBM3TTI != null) return awaitBM3TTI;
        else return [];
    } catch (e) {
        return [];
    }
}
function $9dfba891a747bf0b$export$e2ea675800536898() {
    try {
        if (!$9dfba891a747bf0b$var$config) return false;
        var _config6 = $9dfba891a747bf0b$var$config, removePageSegmentsUFOPrefixes = _config6.removePageSegmentsUFOPrefixes;
        if (removePageSegmentsUFOPrefixes != null) return removePageSegmentsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $9dfba891a747bf0b$export$525ba53ca98e9db() {
    try {
        if (!$9dfba891a747bf0b$var$config) return false;
        var _config7 = $9dfba891a747bf0b$var$config, removeInteractionsUFOPrefixes = _config7.removeInteractionsUFOPrefixes;
        if (removeInteractionsUFOPrefixes != null) return removeInteractionsUFOPrefixes;
        else return false;
    } catch (e) {
        return false;
    }
}
function $9dfba891a747bf0b$export$4f4649ef27b6f5d6() {
    try {
        if (!$9dfba891a747bf0b$var$config) return undefined;
        var _config8 = $9dfba891a747bf0b$var$config, ufoNameOverrides = _config8.ufoNameOverrides;
        if (ufoNameOverrides != null) return ufoNameOverrides;
        return undefined;
    } catch (e) {
        return undefined;
    }
}
function $9dfba891a747bf0b$export$3c170167645a0eff() {
    try {
        if (!$9dfba891a747bf0b$var$config) return undefined;
        var _config9 = $9dfba891a747bf0b$var$config, doNotAbortActivePressInteraction = _config9.doNotAbortActivePressInteraction;
        return doNotAbortActivePressInteraction;
    } catch (e) {
        return undefined;
    }
}
function $9dfba891a747bf0b$export$d6dc9444bd15f70f() {
    try {
        if (!$9dfba891a747bf0b$var$config) return undefined;
        var _config10 = $9dfba891a747bf0b$var$config, doNotAbortActivePressInteractionOnTransition = _config10.doNotAbortActivePressInteractionOnTransition;
        return doNotAbortActivePressInteractionOnTransition;
    } catch (e) {
        return undefined;
    }
}

});

parcelRegister("dxun7", function(module, exports) {

$parcel$export(module.exports, "clearActiveTrace", function () { return $9db5eaa2a7fdf48e$export$17ab21d7be720b; });

var $i013n = parcelRequire("i013n");
var $9db5eaa2a7fdf48e$var$state = {
    context: null
};
var $9db5eaa2a7fdf48e$export$295213bc4d0c54ad = function generateSpanId() {
    return Array.from(new Array(16), function() {
        return Math.floor(Math.random() * 16).toString(16);
    }).join("");
};
var $9db5eaa2a7fdf48e$export$f2e521e495a88544 = function setInteractionActiveTrace(interactionId, experienceType) {
    $9db5eaa2a7fdf48e$export$a1002be327997103(interactionId.replace(/-/g, ""), $9db5eaa2a7fdf48e$export$295213bc4d0c54ad(), experienceType);
};
var $9db5eaa2a7fdf48e$export$a1002be327997103 = function setActiveTrace(traceId, spanId, type) {
    $9db5eaa2a7fdf48e$var$state.context = {
        traceId: traceId,
        spanId: spanId,
        type: type
    };
};
var $9db5eaa2a7fdf48e$export$b6ac780db3a3cc77 = function getActiveTrace() {
    return $9db5eaa2a7fdf48e$var$state.context || undefined;
};
var $9db5eaa2a7fdf48e$export$17ab21d7be720b = function clearActiveTrace() {
    $9db5eaa2a7fdf48e$var$state.context = null;
};
var $9db5eaa2a7fdf48e$export$6e17cce6446848f9 = function getActiveTraceHttpRequestHeaders(_url) {
    if ($9db5eaa2a7fdf48e$var$state.context === null) return null;
    var _state$context = $9db5eaa2a7fdf48e$var$state.context, traceId = _state$context.traceId, spanId = _state$context.spanId;
    return (0, $i013n.makeTraceHttpRequestHeaders)(traceId, spanId);
};

});
parcelRegister("i013n", function(module, exports) {

$parcel$export(module.exports, "makeTraceHttpRequestHeaders", function () { return $0361b1bb0f16350b$export$1115c5277eb10d5e; });
var $0361b1bb0f16350b$export$1115c5277eb10d5e = function makeTraceHttpRequestHeaders(traceId, spanId) {
    return {
        "X-B3-TraceId": traceId,
        "X-B3-SpanId": spanId
    };
};

});


parcelRegister("bAdsy", function(module, exports) {

$parcel$export(module.exports, "allFeatureFlagsAccessed", function () { return $86ed7f48046c7a45$export$5b78c989c8db2561; });
$parcel$export(module.exports, "currentFeatureFlagsAccessed", function () { return $86ed7f48046c7a45$export$2a5c8df26bb89760; });

var $9AokE = parcelRequire("9AokE");
var $86ed7f48046c7a45$export$5b78c989c8db2561 = new Map();
var $86ed7f48046c7a45$export$2a5c8df26bb89760 = new Map();
var $86ed7f48046c7a45$export$47fade9662f71000 = function addFeatureFlagAccessed(featureFlagName, featureFlagValue) {
    try {
        // Inform Criterion about FF being accessed
        if (globalThis.__CRITERION__ && typeof globalThis.__CRITERION__.addFeatureFlagAccessed === "function") globalThis.__CRITERION__.addFeatureFlagAccessed(featureFlagName, featureFlagValue);
    } catch (_e) {
    // ignore the criterion error
    }
    var value = (0, $9AokE.redactValue)(featureFlagValue);
    $86ed7f48046c7a45$export$5b78c989c8db2561.set(featureFlagName, value);
    $86ed7f48046c7a45$export$2a5c8df26bb89760.set(featureFlagName, value);
};

});
parcelRegister("9AokE", function(module, exports) {

$parcel$export(module.exports, "redactValue", function () { return $6faa59b112917a35$export$fcc03ee4c944962f; });

var $cd8Dz = parcelRequire("cd8Dz");

var $9653u = parcelRequire("9653u");
var $6faa59b112917a35$var$startsAsObject = function startsAsObject(value) {
    try {
        if (value.charAt(0) === "{") return true;
    } catch (e) {
        return false;
    }
    return false;
};
var $6faa59b112917a35$var$isObject = function isObject(value) {
    return value && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value) === "object" && value.constructor === Object;
};
var $6faa59b112917a35$var$isString = function isString(input) {
    var result;
    try {
        result = typeof input === "string" || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
var $6faa59b112917a35$export$7b4abba432e57989 = function shouldRedactValue(value) {
    return $6faa59b112917a35$var$isString(value) && $6faa59b112917a35$var$startsAsObject(value) || $6faa59b112917a35$var$isObject(value);
};
var $6faa59b112917a35$export$fcc03ee4c944962f = function redactValue(featureFlagValue) {
    return $6faa59b112917a35$export$7b4abba432e57989(featureFlagValue) ? (0, $9653u.NON_BOOLEAN_VALUE) : featureFlagValue;
};

});
parcelRegister("9653u", function(module, exports) {

$parcel$export(module.exports, "NON_BOOLEAN_VALUE", function () { return $69f8987299d79f04$export$42f4885608027d0c; });
var $69f8987299d79f04$export$42f4885608027d0c = "non_boolean";

});



parcelRegister("gwJNC", function(module, exports) {

$parcel$export(module.exports, "getInteractionId", function () { return $c0832945140f051f$export$37bca3107733ac1e; });

var $8ZuGG = parcelRequire("8ZuGG");
var $c0832945140f051f$export$3109542b68df9ba1 = {
    current: null
};
var // We use a context to allow modals to have their own lifecycle
$c0832945140f051f$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $8ZuGG.createContext)($c0832945140f051f$export$3109542b68df9ba1);
var $c0832945140f051f$export$37bca3107733ac1e = function getInteractionId() {
    return $c0832945140f051f$export$3109542b68df9ba1;
};
var $c0832945140f051f$export$9f6000531b78127e = function useInteractionId() {
    return $c0832945140f051f$export$3109542b68df9ba1;
};

});

parcelRegister("iww5R", function(module, exports) {

$parcel$export(module.exports, "getVCObserver", function () { return $d7c41c3c6fb73eee$export$b3bc47985717b49e; });

var $gXYFp = parcelRequire("gXYFp");
var $d7c41c3c6fb73eee$var$instance = null;
var $d7c41c3c6fb73eee$export$b3bc47985717b49e = function getVCObserver() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if ($d7c41c3c6fb73eee$var$instance === null) $d7c41c3c6fb73eee$var$instance = new (0, $gXYFp.VCObserver)(opts);
    return $d7c41c3c6fb73eee$var$instance;
};

});
parcelRegister("gXYFp", function(module, exports) {

$parcel$export(module.exports, "VCObserver", function () { return $c5a137362d5a59ec$export$1f70d263701b1d01; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $5fgWT = parcelRequire("5fgWT");

var $6JLzw = parcelRequire("6JLzw");

var $5LoHE = parcelRequire("5LoHE");
var $c5a137362d5a59ec$var$_excluded = [
    "__debug__element"
];
function $c5a137362d5a59ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c5a137362d5a59ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c5a137362d5a59ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c5a137362d5a59ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c5a137362d5a59ec$var$abortReason = {
    scroll: "scroll",
    keypress: "keypress",
    resize: "resize",
    error: "error"
};
var $c5a137362d5a59ec$var$UNUSED_SECTOR = 0;
function $c5a137362d5a59ec$var$filterComponentsLog(log) {
    return Object.fromEntries(Object.entries(log).map(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), timestamp = _ref2[0], entries = _ref2[1];
        return [
            Number(timestamp),
            entries.map(function(entry) {
                var __debug__element = entry.__debug__element, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(entry, $c5a137362d5a59ec$var$_excluded);
                return rest;
            })
        ];
    }));
}
var $c5a137362d5a59ec$export$1f70d263701b1d01 = /*#__PURE__*/ function() {
    function VCObserver(options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, VCObserver);
        /* abort logic */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "abortReason", {
            reason: null,
            info: "",
            timestamp: -1,
            blocking: false
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "outOfBoundaryInfo", "");
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "viewport", {
            w: 0,
            h: 0
        });
        /* heatmap */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "arraySize", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "componentsLog", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcRatios", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "active", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "startTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "ssr", {
            reactRendered: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbind", []);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getAbortReasonInfo", function() {
            if (_this.abortReason.reason === null) return null;
            var info = _this.abortReason.info !== "" ? " ".concat(_this.abortReason.info) : "";
            return "".concat(_this.abortReason.reason).concat(info);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getVCRawData", function() {
            _this.measureStart();
            if (!_this.active) {
                _this.measureStop();
                return null;
            }
            _this.stop();
            var abortReasonInfo = _this.getAbortReasonInfo();
            _this.measureStop();
            return {
                abortReasonInfo: abortReasonInfo,
                abortReason: $c5a137362d5a59ec$var$_objectSpread({}, _this.abortReason),
                heatmap: _this.ssrInclusiveHeatmap,
                oldHeatmap: _this.heatmap,
                outOfBoundaryInfo: _this.outOfBoundaryInfo,
                totalTime: Math.round(_this.totalTime + _this.observers.getTotalTime()),
                componentsLog: $c5a137362d5a59ec$var$_objectSpread({}, _this.componentsLog),
                viewport: $c5a137362d5a59ec$var$_objectSpread({}, _this.viewport),
                oldDomUpdatesEnabled: _this.oldDomUpdatesEnabled,
                devToolsEnabled: _this.devToolsEnabled,
                ratios: _this.vcRatios
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getVCResult", function(_ref3) {
            var _objectSpread2, _objectSpread3;
            var start = _ref3.start, stop = _ref3.stop, tti = _ref3.tti, prefix = _ref3.prefix, ssr = _ref3.ssr, vc = _ref3.vc;
            var startTime = performance.now();
            // add local measurement
            var fullPrefix = prefix !== undefined && prefix !== "" ? "".concat(prefix, ":") : "";
            var rawData = vc !== undefined ? vc : _this.getVCRawData();
            if (rawData === null) return {};
            var abortReason = rawData.abortReason, abortReasonInfo = rawData.abortReasonInfo, heatmap = rawData.heatmap, oldHeatmap = rawData.oldHeatmap, outOfBoundaryInfo = rawData.outOfBoundaryInfo, totalTime = rawData.totalTime, componentsLog = rawData.componentsLog, viewport = rawData.viewport, devToolsEnabled = rawData.devToolsEnabled, ratios = rawData.ratios;
            if (abortReasonInfo !== null && abortReason.blocking) {
                var _ref4;
                // exposing data to devtools
                try {
                    if (devToolsEnabled && !_this.isPostInteraction) window.__vcNotAvailableReason = abortReasonInfo;
                } catch (e) {}
                return _ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref4, "".concat(fullPrefix, "vc:state"), false), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref4, "".concat(fullPrefix, "vc:abort:reason"), abortReasonInfo), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref4, "".concat(fullPrefix, "vc:abort:timestamp"), abortReason.timestamp), _ref4;
            }
            var _VCObserver$calculate = VCObserver.calculateVC({
                heatmap: heatmap,
                ssr: ssr,
                componentsLog: $c5a137362d5a59ec$var$_objectSpread({}, componentsLog),
                viewport: viewport
            }), VC = _VCObserver$calculate.VC, VCBox = _VCObserver$calculate.VCBox, VCEntries = _VCObserver$calculate.VCEntries, totalPainted = _VCObserver$calculate.totalPainted;
            try {
                if (!_this.isPostInteraction) VCObserver.VCParts.forEach(function(key) {
                    var duration = VC[key];
                    if (duration !== null && duration !== undefined) performance.measure("VC".concat(key), {
                        start: start,
                        duration: duration
                    });
                });
            } catch (e) {
            /* empty */ }
            var ssrVC = VCObserver.calculateVC({
                heatmap: oldHeatmap,
                ssr: ssr,
                componentsLog: $c5a137362d5a59ec$var$_objectSpread({}, componentsLog),
                viewport: viewport
            });
            var outOfBoundary = outOfBoundaryInfo ? (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, "".concat(fullPrefix, "vc:oob"), outOfBoundaryInfo) : {};
            //const oldDomUpdates = oldDomUpdatesEnabled ? { [`${fullPrefix}vc:old:dom`]: ssrVC.VCBox } : {};
            var stopTime = performance.now();
            // exposing data to devtools
            try {
                if (!_this.isPostInteraction && devToolsEnabled) {
                    window.__vc = {
                        entries: VCEntries.rel,
                        log: componentsLog,
                        metrics: {
                            "75": VC["75"],
                            "80": VC["80"],
                            "85": VC["85"],
                            "90": VC["90"],
                            "95": VC["95"],
                            "98": VC["98"],
                            "99": VC["99"],
                            tti: tti,
                            ttai: stop - start
                        },
                        heatmap: heatmap,
                        ratios: ratios
                    };
                    // Emitting a custom event to make it available in the Chrome extension
                    window.dispatchEvent(new CustomEvent("vcReady", {
                        detail: {
                            log: $c5a137362d5a59ec$var$filterComponentsLog(componentsLog),
                            entries: VCEntries.rel
                        }
                    }));
                }
            } catch (e) {
            /*  do nothing */ }
            return $c5a137362d5a59ec$var$_objectSpread($c5a137362d5a59ec$var$_objectSpread((_objectSpread2 = {
                "metrics:vc": VC
            }, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:state"), true), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:clean"), !abortReasonInfo), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:dom"), VCBox), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:updates"), VCEntries.rel.slice(0, 50)), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:size"), viewport), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:time"), Math.round(totalTime + (stopTime - startTime))), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:total"), totalPainted), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread2, "".concat(fullPrefix, "vc:ratios"), ratios), _objectSpread2), outOfBoundary), {}, (_objectSpread3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread3, "".concat(fullPrefix, "vc:attrs"), ssrVC.VC), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_objectSpread3, "".concat(fullPrefix, "vc:ignored"), _this.getIgnoredElements(componentsLog)), _objectSpread3));
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "handleUpdate", function(rawTime, intersectionRect, targetName, element, type, ignoreReason) {
            _this.measureStart();
            if (_this.abortReason.reason === null || _this.abortReason.blocking === false) {
                var time = Math.round(rawTime - _this.startTime);
                var mappedValues = _this.mapPixelsToHeatmap(intersectionRect.left, intersectionRect.top, intersectionRect.width, intersectionRect.height);
                _this.vcRatios[targetName] = _this.getElementRatio(mappedValues);
                if (!ignoreReason) _this.applyChangesToHeatMap(mappedValues, time, _this.heatmap);
                if (!ignoreReason && type !== "attr") _this.applyChangesToHeatMap(mappedValues, time, _this.ssrInclusiveHeatmap);
                if (!_this.componentsLog[time]) _this.componentsLog[time] = [];
                _this.componentsLog[time].push({
                    __debug__element: _this.devToolsEnabled ? new WeakRef(element) : null,
                    intersectionRect: intersectionRect,
                    targetName: targetName,
                    ignoreReason: ignoreReason
                });
            }
            // devtools export
            _this.measureStop();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "mapPixelsToHeatmap", function(left, top, width, height) {
            var _this$viewport = _this.viewport, w = _this$viewport.w, h = _this$viewport.h;
            var l = Math.floor(left / w * _this.arraySize);
            var t = Math.floor(top / h * _this.arraySize);
            var r = Math.ceil((left + width) / w * _this.arraySize);
            var b = Math.ceil((top + height) / h * _this.arraySize);
            // that info is temporary to get info why it goes over boundary
            if (_this.outOfBoundaryInfo === "") {
                var outOfBoundaryInfo = "";
                if (r > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(left, " ").concat(width);
                if (b > _this.arraySize) outOfBoundaryInfo += " r ".concat(r, " ! ").concat(top, " ").concat(height);
                _this.outOfBoundaryInfo = outOfBoundaryInfo;
            }
            // correct values to min - 0, max - arraySize
            var result = {
                l: Math.max(0, l),
                t: Math.max(0, t),
                r: Math.min(_this.arraySize, r),
                b: Math.min(_this.arraySize, b)
            };
            return result;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getElementRatio", function(mappedValues) {
            var r = mappedValues.r, l = mappedValues.l, b = mappedValues.b, t = mappedValues.t;
            return (r - l) * (b - t) / (_this.arraySize * _this.arraySize);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "abortReasonCallback", function(key, time) {
            switch(key){
                case "wheel":
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.scroll, time);
                    break;
                case "keydown":
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.keypress, time);
                    break;
                case "resize":
                    _this.setAbortReason($c5a137362d5a59ec$var$abortReason.resize, time);
                    break;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "attachAbortListeners", function() {
            var _window;
            _this.detachAbortListeners();
            var unbinds = (0, $5fgWT.attachAbortListeners)(window, _this.viewport, _this.abortReasonCallback);
            if ((_window = window) !== null && _window !== void 0 && _window.__SSR_ABORT_LISTENERS__) {
                var _window2;
                Object.entries(window.__SSR_ABORT_LISTENERS__.aborts).forEach(function(_ref6) {
                    var _ref7 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref6, 2), key = _ref7[0], time = _ref7[1];
                    if (time) _this.abortReasonCallback(key, time);
                });
                unbinds = unbinds.concat(window.__SSR_ABORT_LISTENERS__.unbinds);
                (_window2 = window) === null || _window2 === void 0 || delete _window2.__SSR_ABORT_LISTENERS__;
            }
            _this.unbind = unbinds;
        });
        this.arraySize = options.heatmapSize || 200;
        this.devToolsEnabled = options.devToolsEnabled || false;
        this.oldDomUpdatesEnabled = options.oldDomUpdates || false;
        this.observers = new (0, $5LoHE.Observers)({
            selectorConfig: options.selectorConfig || {
                id: false,
                testId: false,
                role: false,
                className: true,
                dataVC: true
            }
        });
        this.heatmap = this.getCleanHeatmap();
        this.ssrInclusiveHeatmap = this.getCleanHeatmap();
        this.isPostInteraction = options.isPostInteraction || false;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(VCObserver, [
        {
            key: "start",
            value: function start(_ref8) {
                var startTime = _ref8.startTime;
                this.active = true;
                if (this.observers.isBrowserSupported()) {
                    this.setViewportSize();
                    this.resetState();
                    this.startTime = startTime;
                    this.attachAbortListeners();
                    this.observers.subscribeResults(this.handleUpdate);
                    this.observers.observe();
                } else this.setAbortReason("not-supported", startTime);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.observers.disconnect();
                this.detachAbortListeners();
            }
        },
        {
            key: "getIgnoredElements",
            value: function getIgnoredElements(componentsLog) {
                return Object.values(componentsLog).flat().filter(function(_ref9) {
                    var ignoreReason = _ref9.ignoreReason;
                    return Boolean(ignoreReason);
                }).map(function(_ref10) {
                    var targetName = _ref10.targetName, ignoreReason = _ref10.ignoreReason;
                    return {
                        targetName: targetName,
                        ignoreReason: ignoreReason
                    };
                });
            }
        },
        {
            key: "setSSRElement",
            value: function setSSRElement(element) {
                this.observers.setReactRootElement(element);
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStart(startTime);
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.observers.setReactRootRenderStop(stopTime);
            }
        },
        {
            key: "setAbortReason",
            value: function setAbortReason(abort, timestamp) {
                var info = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
                if (this.abortReason.reason === null || this.abortReason.blocking === false) {
                    this.abortReason.reason = abort;
                    this.abortReason.info = info;
                    this.abortReason.timestamp = timestamp;
                    this.abortReason.blocking = abort !== $c5a137362d5a59ec$var$abortReason.scroll;
                    if (this.abortReason.blocking) this.detachAbortListeners();
                }
            }
        },
        {
            key: "resetState",
            value: function resetState() {
                this.abortReason = {
                    reason: null,
                    info: "",
                    timestamp: -1,
                    blocking: false
                };
                this.detachAbortListeners();
                this.heatmap = this.getCleanHeatmap();
                this.ssrInclusiveHeatmap = this.getCleanHeatmap();
                this.totalTime = 0;
                this.componentsLog = {};
                this.vcRatios = {};
            }
        },
        {
            key: "getCleanHeatmap",
            value: function getCleanHeatmap() {
                var _this2 = this;
                return Array(this.arraySize).fill("").map(function() {
                    return Array(_this2.arraySize).fill($c5a137362d5a59ec$var$UNUSED_SECTOR);
                });
            }
        },
        {
            key: "setViewportSize",
            value: function setViewportSize() {
                this.viewport.w = (0, $6JLzw.getViewportWidth)();
                this.viewport.h = (0, $6JLzw.getViewportHeight)();
            }
        },
        {
            key: "applyChangesToHeatMap",
            value: function applyChangesToHeatMap(a, time, heatmap) {
                var l = a.l, t = a.t, r = a.r, b = a.b;
                var localHeatmap = heatmap;
                for(var row = t; row < b; row++){
                    for(var col = l; col < r; col++)if (localHeatmap[row] === undefined) {
                        try {
                            this.setAbortReason($c5a137362d5a59ec$var$abortReason.error, time, "index - ".concat(row));
                        } catch (e) {
                            this.setAbortReason($c5a137362d5a59ec$var$abortReason.error, time, "row error");
                        }
                        return;
                    } else localHeatmap[row][col] = time;
                }
            }
        },
        {
            key: "detachAbortListeners",
            value: function detachAbortListeners() {
                this.unbind.forEach(function(fn) {
                    return fn();
                });
                this.unbind = [];
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ], [
        {
            key: "calculateVC",
            value: function calculateVC(_ref11) {
                var heatmap = _ref11.heatmap, _ref11$ssr = _ref11.ssr, ssr = _ref11$ssr === void 0 ? $c5a137362d5a59ec$var$UNUSED_SECTOR : _ref11$ssr, componentsLog = _ref11.componentsLog, viewport = _ref11.viewport;
                var lastUpdate = {};
                var totalPainted = 0;
                if (ssr !== $c5a137362d5a59ec$var$UNUSED_SECTOR) {
                    var _window$document;
                    var element = {
                        __debug__element: new WeakRef((_window$document = window.document) === null || _window$document === void 0 ? void 0 : _window$document.body),
                        intersectionRect: {
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            x: 0,
                            y: 0,
                            width: viewport.w,
                            height: viewport.h,
                            toJSON: function toJSON() {
                                return {};
                            }
                        },
                        targetName: "SSR"
                    };
                    if (!componentsLog[ssr]) componentsLog[ssr] = [];
                    componentsLog[ssr].push(element);
                }
                heatmap.forEach(function(line) {
                    line.forEach(function(entry) {
                        var rounded = Math.floor(entry === $c5a137362d5a59ec$var$UNUSED_SECTOR && ssr !== $c5a137362d5a59ec$var$UNUSED_SECTOR ? ssr : entry);
                        totalPainted += rounded !== $c5a137362d5a59ec$var$UNUSED_SECTOR ? 1 : 0;
                        if (rounded !== $c5a137362d5a59ec$var$UNUSED_SECTOR) lastUpdate[rounded] = lastUpdate[rounded] ? lastUpdate[rounded] + 1 : 1;
                    });
                });
                var entries = Object.entries(lastUpdate).map(function(a) {
                    return [
                        parseInt(a[0], 10),
                        a[1]
                    ];
                }).sort(function(a, b) {
                    return a[0] > b[0] ? 1 : -1;
                });
                var VC = VCObserver.makeVCReturnObj();
                var VCBox = VCObserver.makeVCReturnObj();
                entries.reduce(function() {
                    var acc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                    var v = arguments.length > 1 ? arguments[1] : undefined;
                    var VCRatio = v[1] / totalPainted + acc;
                    var time = v[0];
                    VCObserver.VCParts.forEach(function(key) {
                        var value = parseInt(key, 10);
                        if ((VC[key] === null || VC[key] === undefined) && VCRatio >= value / 100) {
                            var _componentsLog$time;
                            VC[key] = time;
                            VCBox[key] = (_componentsLog$time = componentsLog[time]) === null || _componentsLog$time === void 0 ? void 0 : _componentsLog$time.map(function(v) {
                                return v.targetName;
                            });
                        }
                    });
                    return VCRatio;
                }, 0);
                var VCEntries = entries.reduce(function(acc, _ref12, i) {
                    var _acc$abs, _componentsLog$timest;
                    var _ref13 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref12, 2), timestamp = _ref13[0], entryPainted = _ref13[1];
                    var currentlyPainted = entryPainted + (((_acc$abs = acc.abs[i - 1]) === null || _acc$abs === void 0 ? void 0 : _acc$abs[1]) || 0);
                    var currentlyPaintedRatio = Math.round(currentlyPainted / totalPainted * 1000) / 10;
                    var logEntry = (_componentsLog$timest = componentsLog[timestamp]) === null || _componentsLog$timest === void 0 ? void 0 : _componentsLog$timest.map(function(v) {
                        return v.targetName;
                    });
                    acc.abs.push([
                        timestamp,
                        currentlyPainted
                    ]);
                    acc.rel.push({
                        time: timestamp,
                        vc: currentlyPaintedRatio,
                        elements: logEntry
                    });
                    return acc;
                }, {
                    abs: [],
                    rel: []
                });
                return {
                    VC: VC,
                    VCBox: VCBox,
                    VCEntries: VCEntries,
                    totalPainted: totalPainted
                };
            }
        },
        {
            key: "makeVCReturnObj",
            value: function makeVCReturnObj() {
                var vc = {};
                VCObserver.VCParts.forEach(function(v) {
                    vc[v] = null;
                });
                return vc;
            }
        }
    ]);
    return VCObserver;
}();
/** config * */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($c5a137362d5a59ec$export$1f70d263701b1d01, "VCParts", [
    "25",
    "50",
    "75",
    "80",
    "85",
    "90",
    "95",
    "98",
    "99"
]);

});
parcelRegister("5fgWT", function(module, exports) {

$parcel$export(module.exports, "attachAbortListeners", function () { return $3d1b80260f375eff$export$9010aa71841a6887; });

var $k6Bkl = parcelRequire("k6Bkl");

var $4yfn0 = parcelRequire("4yfn0");

var $6JLzw = parcelRequire("6JLzw");
var $3d1b80260f375eff$export$9010aa71841a6887 = function attachAbortListeners(window, initialViewPort, callback) {
    var unbindWheel = (0, $k6Bkl.bind)(window, {
        type: (0, $4yfn0.AbortEvent).wheel,
        listener: function listener(e) {
            callback((0, $4yfn0.AbortEvent).wheel, e.timeStamp);
        },
        options: {
            passive: true,
            once: true
        }
    });
    var unbindKeydown = (0, $k6Bkl.bind)(window, {
        type: (0, $4yfn0.AbortEvent).keydown,
        listener: function listener(e) {
            callback((0, $4yfn0.AbortEvent).keydown, e.timeStamp);
        },
        options: {
            once: true
        }
    });
    var unbindResize = (0, $k6Bkl.bind)(window, {
        type: (0, $4yfn0.AbortEvent).resize,
        listener: function listener(e) {
            if ((0, $6JLzw.getViewportWidth)() !== initialViewPort.w || (0, $6JLzw.getViewportHeight)() !== initialViewPort.h) {
                callback((0, $4yfn0.AbortEvent).resize, e.timeStamp);
                unbindResize();
            }
        }
    });
    return [
        unbindWheel,
        unbindKeydown,
        unbindResize
    ];
};

});
parcelRegister("k6Bkl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $d4F9Q = parcelRequire("d4F9Q");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $d4F9Q.bind;
    }
});

var $4uBc4 = parcelRequire("4uBc4");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $4uBc4.bindAll;
    }
});

});
parcelRegister("d4F9Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $984b932fb32c81ba$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $984b932fb32c81ba$var$bind;

});

parcelRegister("4uBc4", function(module, exports) {
"use strict";
var $3456d0a5d95794ea$var$__assign = module.exports && module.exports.__assign || function() {
    $3456d0a5d95794ea$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3456d0a5d95794ea$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $d4F9Q = parcelRequire("d4F9Q");
function $3456d0a5d95794ea$var$toOptions(value) {
    if (typeof value === "undefined") return undefined;
    if (typeof value === "boolean") return {
        capture: value
    };
    return value;
}
function $3456d0a5d95794ea$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $3456d0a5d95794ea$var$__assign($3456d0a5d95794ea$var$__assign({}, original), {
        options: $3456d0a5d95794ea$var$__assign($3456d0a5d95794ea$var$__assign({}, $3456d0a5d95794ea$var$toOptions(sharedOptions)), $3456d0a5d95794ea$var$toOptions(original.options))
    });
    return binding;
}
function $3456d0a5d95794ea$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $3456d0a5d95794ea$var$getBinding(original, sharedOptions);
        return (0, $d4F9Q.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $3456d0a5d95794ea$var$bindAll;

});


parcelRegister("4yfn0", function(module, exports) {

$parcel$export(module.exports, "AbortEvent", function () { return $35064292a01a1bd2$export$199edc0307b5587f; });
var $35064292a01a1bd2$export$199edc0307b5587f = {
    wheel: "wheel",
    keydown: "keydown",
    resize: "resize"
};

});

parcelRegister("6JLzw", function(module, exports) {

$parcel$export(module.exports, "getViewportWidth", function () { return $4e7bd8dc080c6a46$export$a497a1dcb4408212; });
$parcel$export(module.exports, "getViewportHeight", function () { return $4e7bd8dc080c6a46$export$4f01c15d21ef9cc6; });
function $4e7bd8dc080c6a46$export$a497a1dcb4408212() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentWidth;
    try {
        documentWidth = document.documentElement.clientWidth || 0;
    } catch (e) {
        documentWidth = 0;
    }
    return Math.max(documentWidth, window.innerWidth || 0);
}
function $4e7bd8dc080c6a46$export$4f01c15d21ef9cc6() {
    var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.document;
    var documentHeight;
    try {
        documentHeight = document.documentElement.clientHeight || 0;
    } catch (e) {
        documentHeight = 0;
    }
    return Math.max(documentHeight, window.innerHeight || 0);
}

});


parcelRegister("5LoHE", function(module, exports) {

$parcel$export(module.exports, "Observers", function () { return $432481128c46df98$export$b65d046240060e78; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $9lRp1 = parcelRequire("9lRp1");

var $4vNNx = parcelRequire("4vNNx");
function $432481128c46df98$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $432481128c46df98$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $432481128c46df98$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $432481128c46df98$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $432481128c46df98$var$state = {
    normal: 1,
    waitingForFirstRender: 2,
    ignoring: 3
};
var $432481128c46df98$export$b65d046240060e78 = /*#__PURE__*/ function() {
    function Observers(opts) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Observers);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "observedMutations", new WeakMap());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "elementsInView", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "callbacks", new Set());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "totalTime", 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_startMeasureTimestamp", -1);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "ssr", {
            state: $432481128c46df98$var$state.normal,
            reactRootElement: null,
            renderStart: -1,
            renderStop: -1
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "selectorConfig", {
            id: false,
            testId: false,
            role: false,
            className: true,
            dataVC: true
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "subscribeResults", function(cb) {
            _this.callbacks.add(cb);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "observeElement", function(node, mutation, type, ignoreReason) {
            var _this$intersectionObs;
            (_this$intersectionObs = _this.intersectionObserver) === null || _this$intersectionObs === void 0 || _this$intersectionObs.observe(node);
            _this.observedMutations.set(node, {
                mutation: mutation,
                ignoreReason: ignoreReason,
                type: type
            });
        });
        this.selectorConfig = $432481128c46df98$var$_objectSpread($432481128c46df98$var$_objectSpread({}, this.selectorConfig), opts.selectorConfig);
        this.intersectionObserver = this.getIntersectionObserver();
        this.mutationObserver = this.getMutationObserver();
        this.ssrPlaceholderHandler = new (0, $4vNNx.SSRPlaceholderHandlers)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Observers, [
        {
            key: "isBrowserSupported",
            value: function isBrowserSupported() {
                return typeof window.IntersectionObserver === "function" && typeof window.MutationObserver === "function";
            }
        },
        {
            key: "observe",
            value: function observe() {
                var _this$mutationObserve;
                this.totalTime = 0;
                this.ssr = {
                    state: $432481128c46df98$var$state.normal,
                    reactRootElement: null,
                    renderStart: -1,
                    renderStop: -1
                };
                (_this$mutationObserve = this.mutationObserver) === null || _this$mutationObserve === void 0 || _this$mutationObserve.observe(document.body, {
                    attributeFilter: [
                        "hidden",
                        "style",
                        "src"
                    ],
                    attributeOldValue: true,
                    attributes: true,
                    childList: true,
                    subtree: true
                });
            }
        },
        {
            key: "disconnect",
            value: function disconnect() {
                var _this$mutationObserve2, _this$intersectionObs2;
                (_this$mutationObserve2 = this.mutationObserver) === null || _this$mutationObserve2 === void 0 || _this$mutationObserve2.disconnect();
                (_this$intersectionObs2 = this.intersectionObserver) === null || _this$intersectionObs2 === void 0 || _this$intersectionObs2.disconnect();
                this.observedMutations = new WeakMap();
                this.elementsInView = new Set();
                this.callbacks = new Set();
                this.ssr.reactRootElement = null;
                this.ssrPlaceholderHandler.clear();
            }
        },
        {
            key: "getTotalTime",
            value: function getTotalTime() {
                return this.totalTime;
            }
        },
        {
            key: "setReactRootElement",
            value: function setReactRootElement(element) {
                this.ssr.reactRootElement = element;
            }
        },
        {
            key: "setReactRootRenderStart",
            value: function setReactRootRenderStart() {
                var startTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStart = startTime;
                this.ssr.state = $432481128c46df98$var$state.waitingForFirstRender;
            }
        },
        {
            key: "setReactRootRenderStop",
            value: function setReactRootRenderStop() {
                var stopTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : performance.now();
                this.ssr.renderStop = stopTime;
            }
        },
        {
            key: "getMutationObserver",
            value: function getMutationObserver() {
                var _this2 = this;
                return this.isBrowserSupported() ? new MutationObserver(function(mutations) {
                    _this2.measureStart();
                    mutations.forEach(function(mutation) {
                        // patching element if timestamp not automatically added
                        // eslint-disable-next-line no-param-reassign
                        mutation.timestamp = mutation.timestamp === undefined ? performance.now() : mutation.timestamp;
                        var ignoreReason = "";
                        if (_this2.ssr.state === $432481128c46df98$var$state.waitingForFirstRender && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            _this2.ssr.state = $432481128c46df98$var$state.ignoring;
                            if (_this2.ssr.renderStop === -1) // arbitrary 500ms DOM update window
                            _this2.ssr.renderStop = mutation.timestamp + 500;
                            ignoreReason = "ssr-hydration";
                        }
                        if (_this2.ssr.state === $432481128c46df98$var$state.ignoring && mutation.timestamp > _this2.ssr.renderStart && mutation.target === _this2.ssr.reactRootElement) {
                            if (mutation.timestamp <= _this2.ssr.renderStop) ignoreReason = "ssr-hydration";
                            else _this2.ssr.state = $432481128c46df98$var$state.normal;
                        }
                        if (mutation.type === "childList") {
                            mutation.addedNodes.forEach(function(node) {
                                if ((0, $9lRp1.isContainedWithinMediaWrapper)(node)) ignoreReason = "image";
                                if (node instanceof HTMLElement) {
                                    if (_this2.ssrPlaceholderHandler.isPlaceholder(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.checkIfExistedAndSizeMatching(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    if (_this2.ssrPlaceholderHandler.isPlaceholderReplacement(node) || _this2.ssrPlaceholderHandler.isPlaceholderIgnored(node)) {
                                        _this2.ssrPlaceholderHandler.validateReactComponentMatchToPlaceholder(node).then(function(result) {
                                            if (result === false) _this2.observeElement(node, mutation, "html", ignoreReason);
                                        });
                                        return;
                                    }
                                    _this2.observeElement(node, mutation, "html", ignoreReason);
                                }
                                if (node instanceof Text && node.parentElement != null) _this2.observeElement(node.parentElement, mutation, "text", ignoreReason);
                            });
                            mutation.removedNodes.forEach(function(node) {
                                if (node instanceof Element) {
                                    var _this2$intersectionOb;
                                    _this2.elementsInView.delete(node);
                                    (_this2$intersectionOb = _this2.intersectionObserver) === null || _this2$intersectionOb === void 0 || _this2$intersectionOb.unobserve(node);
                                }
                            });
                        } else if (mutation.type === "attributes") {
                            if (mutation.target instanceof HTMLElement) _this2.observeElement(mutation.target, mutation, "attr", ignoreReason);
                        }
                    });
                    _this2.measureStop();
                }) : null;
            }
        },
        {
            key: "getElementName",
            value: function getElementName(element) {
                try {
                    var tagName = element.localName;
                    var dataVCAttr = element.getAttribute("data-vc");
                    var dataVC = this.selectorConfig.dataVC && dataVCAttr ? '[data-vc="'.concat(dataVCAttr, '"]') : "";
                    var id = this.selectorConfig.id && element.id ? "#".concat(element.id) : "";
                    var testId = this.selectorConfig.testId ? element.getAttribute("data-testid") || element.getAttribute("data-test-id") : "";
                    testId = testId ? "[testid=".concat(testId, "]") : "";
                    var role = this.selectorConfig.role ? element.getAttribute("role") : "";
                    role = role ? "[role=".concat(role, "]") : "";
                    var classList = this.selectorConfig.className ? Array.from(element.classList).join(".") : "";
                    classList = classList === "" ? "" : ".".concat(classList);
                    var attrs = dataVC ? dataVC : [
                        id,
                        testId,
                        role
                    ].join("");
                    var idString = "";
                    if (attrs === "" && classList === "") {
                        var parent = element.parentElement ? this.getElementName(element.parentElement) : "unknown";
                        idString = "".concat(parent, " > ").concat(tagName);
                    } else idString = [
                        tagName,
                        attrs || classList
                    ].join("");
                    return idString;
                } catch (e) {
                    return "error";
                }
            }
        },
        {
            key: "getIntersectionObserver",
            value: function getIntersectionObserver() {
                var _this3 = this;
                return this.isBrowserSupported() ? new IntersectionObserver(function(entries) {
                    _this3.measureStart();
                    entries.forEach(function(_ref) {
                        var isIntersecting = _ref.isIntersecting, ir = _ref.intersectionRect, target = _ref.target;
                        var data = _this3.observedMutations.get(target);
                        _this3.observedMutations.delete(target);
                        if (isIntersecting && ir.width > 0 && ir.height > 0) {
                            if (!(target instanceof HTMLElement)) return;
                            if (!(data !== null && data !== void 0 && data.mutation)) // ignore intersection report without recent mutation
                            return;
                            _this3.callbacks.forEach(function(callback) {
                                var elementName;
                                try {
                                    elementName = _this3.getElementName(target);
                                } catch (e) {
                                    elementName = "error";
                                }
                                callback(data.mutation.timestamp || performance.now(), ir, elementName, target, data.type, data.ignoreReason);
                            });
                            _this3.elementsInView.add(target);
                        } else _this3.elementsInView.delete(target);
                    });
                    _this3.measureStop();
                }) : null;
            }
        },
        {
            key: "measureStart",
            value: function measureStart() {
                this._startMeasureTimestamp = performance.now();
            }
        },
        {
            key: "measureStop",
            value: function measureStop() {
                if (this._startMeasureTimestamp === -1) return;
                this.totalTime += performance.now() - this._startMeasureTimestamp;
                this._startMeasureTimestamp = -1;
            }
        }
    ]);
    return Observers;
}();

});
parcelRegister("9lRp1", function(module, exports) {

$parcel$export(module.exports, "isContainedWithinMediaWrapper", function () { return $6cef7fdd9ef830ed$export$f61fbc3b9c4a9019; });

var $kUpWi = parcelRequire("kUpWi");
var $6cef7fdd9ef830ed$export$f61fbc3b9c4a9019 = function isContainedWithinMediaWrapper(node) {
    while(node){
        if (node instanceof Element && node.hasAttribute((0, $kUpWi.MEDIA_WRAPPER_TAG))) return true;
        node = node.parentNode;
    }
    return false;
};

});
parcelRegister("kUpWi", function(module, exports) {

$parcel$export(module.exports, "MEDIA_WRAPPER_TAG", function () { return $f38d2894daa98858$export$7674290405cc25b0; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");
var $f38d2894daa98858$export$7674290405cc25b0 = "data-media-vc-wrapper";
function $f38d2894daa98858$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $f38d2894daa98858$export$7674290405cc25b0, true), children);
}

});


parcelRegister("4vNNx", function(module, exports) {

$parcel$export(module.exports, "SSRPlaceholderHandlers", function () { return $3490af80719fae72$export$c0102f1a1198d10f; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
var $3490af80719fae72$var$EQUALITY_THRESHOLD = 0.1;
var $3490af80719fae72$var$ANCESTOR_LOOKUP_LIMIT = 10;
var $3490af80719fae72$export$c0102f1a1198d10f = /*#__PURE__*/ function() {
    function SSRPlaceholderHandlers() {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, SSRPlaceholderHandlers);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "staticPlaceholders", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "callbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "getSizeCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "reactValidateCallbacks", new Map());
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "intersectionObserverCallback", function(_ref) {
            var target = _ref.target, boundingClientRect = _ref.boundingClientRect;
            _this.intersectionObserver.unobserve(target);
            if (!(target instanceof HTMLElement)) // impossible case - keep typescript healthy
            return;
            var staticKey = target.dataset.ssrPlaceholder || "";
            if (staticKey) {
                if (_this.staticPlaceholders.has(staticKey) && _this.callbacks.has(staticKey)) {
                    // validation
                    var _resolve = _this.callbacks.get(staticKey);
                    if (!_resolve) return;
                    var rect = _this.staticPlaceholders.get(staticKey);
                    var hasSameSizePosition = _this.hasSameSizePosition(rect, boundingClientRect);
                    _resolve(hasSameSizePosition);
                    _this.callbacks.delete(staticKey);
                }
            } else {
                // react component check
                var key = target.dataset.ssrPlaceholderReplace || "";
                var _resolve2 = _this.reactValidateCallbacks.get(key);
                if (!_resolve2) return;
                var _rect = _this.staticPlaceholders.get(key);
                var _hasSameSizePosition = _this.hasSameSizePosition(_rect, boundingClientRect);
                _resolve2(_hasSameSizePosition);
                _this.staticPlaceholders.delete(staticKey);
                _this.reactValidateCallbacks.delete(staticKey);
            }
        });
        this.intersectionObserver = new IntersectionObserver(function(entries) {
            return entries.filter(function(entry) {
                return entry.intersectionRatio > 0;
            }).forEach(_this.intersectionObserverCallback);
        });
        if (window.document) try {
            var existingElements = document.querySelectorAll("[data-ssr-placeholder]");
            existingElements.forEach(function(el) {
                var _el$dataset;
                if (el instanceof HTMLElement && el !== null && el !== void 0 && (_el$dataset = el.dataset) !== null && _el$dataset !== void 0 && _el$dataset.ssrPlaceholder) {
                    var _window$__SSR_PLACEHO;
                    var width = -1;
                    var height = -1;
                    var x = -1;
                    var y = -1;
                    var boundingClientRect = (_window$__SSR_PLACEHO = window.__SSR_PLACEHOLDERS_DIMENSIONS__) === null || _window$__SSR_PLACEHO === void 0 ? void 0 : _window$__SSR_PLACEHO[el.dataset.ssrPlaceholder];
                    if (boundingClientRect) {
                        width = boundingClientRect.width;
                        height = boundingClientRect.height;
                        x = boundingClientRect.x;
                        y = boundingClientRect.y;
                    }
                    _this.staticPlaceholders.set(el.dataset.ssrPlaceholder, {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    });
                    _this.intersectionObserver.observe(el);
                }
            });
        } catch (e) {} finally{
            delete window.__SSR_PLACEHOLDERS_DIMENSIONS__;
        }
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(SSRPlaceholderHandlers, [
        {
            key: "clear",
            value: function clear() {
                this.staticPlaceholders = new Map();
                this.callbacks = new Map();
                this.getSizeCallbacks = new Map();
                this.reactValidateCallbacks = new Map();
            }
        },
        {
            key: "isPlaceholder",
            value: function isPlaceholder(element) {
                return Boolean(element.dataset.ssrPlaceholder);
            }
        },
        {
            key: "isPlaceholderReplacement",
            value: function isPlaceholderReplacement(element) {
                return Boolean(element.dataset.ssrPlaceholderReplace);
            }
        },
        {
            key: "isPlaceholderIgnored",
            value: function isPlaceholderIgnored(element) {
                // data-ssr-placeholder-ignored doesn't have a value.
                return "ssrPlaceholderIgnored" in element.dataset;
            }
        },
        {
            key: "findNearestPlaceholderContainerIfIgnored",
            value: function findNearestPlaceholderContainerIfIgnored(element) {
                if (!this.isPlaceholderIgnored(element)) return element;
                var ancestor = element.parentElement;
                var i = 0;
                while(ancestor && i < $3490af80719fae72$var$ANCESTOR_LOOKUP_LIMIT){
                    if (this.isPlaceholder(ancestor) || this.isPlaceholderReplacement(ancestor)) return ancestor;
                    ancestor = ancestor.parentElement;
                    i++;
                }
                return element;
            }
        },
        {
            key: "checkIfExistedAndSizeMatching",
            value: function checkIfExistedAndSizeMatching(el) {
                var _this2 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholder || "";
                return new Promise(function(resolve) {
                    if (!_this2.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this2.callbacks.set(id, resolve);
                        _this2.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "getSize",
            value: function getSize(el) {
                var _this3 = this;
                return new Promise(function(resolve) {
                    _this3.getSizeCallbacks.set(el.dataset.ssrPlaceholder || "", resolve);
                    _this3.intersectionObserver.observe(el);
                });
            }
        },
        {
            key: "validateReactComponentMatchToPlaceholder",
            value: function validateReactComponentMatchToPlaceholder(el) {
                var _this4 = this;
                el = this.findNearestPlaceholderContainerIfIgnored(el);
                var id = el.dataset.ssrPlaceholderReplace || "";
                return new Promise(function(resolve) {
                    if (!_this4.staticPlaceholders.has(id)) {
                        resolve(false);
                        return;
                    } else {
                        _this4.reactValidateCallbacks.set(id, resolve);
                        _this4.intersectionObserver.observe(el);
                    }
                });
            }
        },
        {
            key: "hasSameSizePosition",
            value: function hasSameSizePosition(rect, boundingClientRect) {
                return rect && Math.abs(rect.x - boundingClientRect.x) < $3490af80719fae72$var$EQUALITY_THRESHOLD && Math.abs(rect.y - boundingClientRect.y) < $3490af80719fae72$var$EQUALITY_THRESHOLD && Math.abs(rect.width - boundingClientRect.width) < $3490af80719fae72$var$EQUALITY_THRESHOLD && Math.abs(rect.height - boundingClientRect.height) < $3490af80719fae72$var$EQUALITY_THRESHOLD || false;
            }
        }
    ]);
    return SSRPlaceholderHandlers;
}();

});




parcelRegister("bT8qz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8a7b5e4fe3fb7057$export$2e2bcd8739ae039; });
var $8a7b5e4fe3fb7057$var$interactions = new Map();
var $8a7b5e4fe3fb7057$export$2e2bcd8739ae039 = $8a7b5e4fe3fb7057$var$interactions;

});

parcelRegister("csWGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $91359f589dae3d71$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $dyWhr = parcelRequire("dyWhr");

var $gXYFp = parcelRequire("gXYFp");
function $91359f589dae3d71$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91359f589dae3d71$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91359f589dae3d71$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91359f589dae3d71$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $91359f589dae3d71$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT = 3000;
var $91359f589dae3d71$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function PostInteractionLog() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PostInteractionLog);
        /**
     * Basic info about interaction that has just finished
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "lastInteractionFinish", null);
        /**
     * Array of observed react render timings
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "reactProfilerTimings", []);
        /**
     * Store the scheduled sink timeout Id so that it can be cancelled when needed
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sinkTimeoutId", null);
        /**
     * independent VC observer, that observes until `custom.post-interaction-logs` event is sent
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcObserver", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "vcObserverSSRConfig", null);
        /**
     * Handler function to process / send the observation data
     */ (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "sinkHandlerFn", function() {});
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PostInteractionLog, [
        {
            key: "initializeVCObserver",
            value: function initializeVCObserver(options) {
                if (this.vcObserver === null) this.vcObserver = new (0, $gXYFp.VCObserver)($91359f589dae3d71$var$_objectSpread($91359f589dae3d71$var$_objectSpread({}, options), {}, {
                    isPostInteraction: true
                }));
            }
        },
        {
            key: "startVCObserver",
            value: function startVCObserver(_ref) {
                var _this$vcObserver;
                var startTime = _ref.startTime;
                (_this$vcObserver = this.vcObserver) === null || _this$vcObserver === void 0 || _this$vcObserver.start({
                    startTime: startTime
                });
            }
        },
        {
            key: "setVCObserverSSRConfig",
            value: function setVCObserverSSRConfig(vcObserverSSRConfig) {
                this.vcObserverSSRConfig = vcObserverSSRConfig;
            }
        },
        {
            key: "setLastInteractionFinishVCResult",
            value: function setLastInteractionFinishVCResult(result) {
                this.lastInteractionFinishVCResult = result;
            }
        },
        {
            key: "sinkHandler",
            value: /**
     * Set the fn that would be invoked to process / send the observation data
     */ function sinkHandler(sinkHandlerFn) {
                this.sinkHandlerFn = sinkHandlerFn;
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.lastInteractionFinish = null;
                this.reactProfilerTimings = [];
                if (this.sinkTimeoutId != null) {
                    clearTimeout(this.sinkTimeoutId);
                    this.sinkTimeoutId = null;
                }
                this.setVCObserverSSRConfig(null);
            }
        },
        {
            key: "hasData",
            value: function hasData() {
                var _this$reactProfilerTi;
                return ((_this$reactProfilerTi = this.reactProfilerTimings) === null || _this$reactProfilerTi === void 0 ? void 0 : _this$reactProfilerTi.length) > 0;
            }
        },
        {
            key: "sendPostInteractionLog",
            value: function sendPostInteractionLog() {
                var _this$vcObserver2;
                if (!this.hasData() || !this.lastInteractionFinish || !this.sinkHandlerFn) {
                    this.reset();
                    return;
                }
                this.sinkHandlerFn({
                    lastInteractionFinish: this.lastInteractionFinish,
                    reactProfilerTimings: this.reactProfilerTimings,
                    // NOTE: invoking `getVCResult` at latest possible point in time here (not earlier) to get the most accurate result (from performance.now())
                    postInteractionFinishVCResult: (_this$vcObserver2 = this.vcObserver) === null || _this$vcObserver2 === void 0 ? void 0 : _this$vcObserver2.getVCResult($91359f589dae3d71$var$_objectSpread({
                        start: this.lastInteractionFinish.start,
                        stop: performance.now(),
                        tti: -1,
                        // no need for TTI value here
                        prefix: "ufo"
                    }, this.vcObserverSSRConfig)),
                    lastInteractionFinishVCResult: this.lastInteractionFinishVCResult
                });
                this.reset();
            }
        },
        {
            key: "onInteractionComplete",
            value: function onInteractionComplete(_ref2) {
                var _getConfig, _this = this;
                var ufoName = _ref2.ufoName, start = _ref2.start, end = _ref2.end, id = _ref2.id, abortReason = _ref2.abortReason, abortedByInteractionName = _ref2.abortedByInteractionName, routeName = _ref2.routeName, type = _ref2.type;
                this.lastInteractionFinish = {
                    ufoName: ufoName,
                    start: start,
                    end: end,
                    id: id,
                    abortReason: abortReason,
                    abortedByInteractionName: abortedByInteractionName,
                    routeName: routeName,
                    type: type
                };
                var timeout = ((_getConfig = (0, $dyWhr.getConfig)()) === null || _getConfig === void 0 ? void 0 : _getConfig.timeWindowForLateMutationsInMilliseconds) || $91359f589dae3d71$var$POST_INTERACTION_LOG_SEND_DEFAULT_TIMEOUT;
                this.sinkTimeoutId = window.setTimeout(function() {
                    _this.sendPostInteractionLog();
                }, timeout);
            }
        },
        {
            key: "addProfilerTimings",
            value: function addProfilerTimings(labelStack, type, actualDuration, baseDuration, startTime, commitTime) {
                if (this.lastInteractionFinish != null) this.reactProfilerTimings.push({
                    type: type,
                    actualDuration: actualDuration,
                    baseDuration: baseDuration,
                    startTime: startTime,
                    commitTime: commitTime,
                    labelStack: labelStack
                });
            }
        }
    ]);
    return PostInteractionLog;
}();

});


parcelRegister("d5QIn", function(module, exports) {

$parcel$export(module.exports, "eventDataProcessor", function () { return $9884a20e8cb3484c$export$896b6e121bbaec25; });

var $7f5qq = parcelRequire("7f5qq");

var $cF8Kw = parcelRequire("cF8Kw");

var $5msJs = parcelRequire("5msJs");

var $8x86A = parcelRequire("8x86A");

var $1XCKE = parcelRequire("1XCKE");

var $Bk1e4 = parcelRequire("Bk1e4");

var $gocvX = parcelRequire("gocvX");

var $e6ZnV = parcelRequire("e6ZnV");

var $9mkAi = parcelRequire("9mkAi");

var $cQNCx = parcelRequire("cQNCx");

var $kYbr3 = parcelRequire("kYbr3");

var $cpvBo = parcelRequire("cpvBo");

var $fhqC4 = parcelRequire("fhqC4");

var $5VPaW = parcelRequire("5VPaW");

var $cuNOM = parcelRequire("cuNOM");

var $77zOH = parcelRequire("77zOH");

var $4JYIi = parcelRequire("4JYIi");

var $bP9ZI = parcelRequire("bP9ZI");

var $2DojN = parcelRequire("2DojN");

var $ftaQE = parcelRequire("ftaQE");

var $i66wZ = parcelRequire("i66wZ");

var $cAwKl = parcelRequire("cAwKl");

var $eAI62 = parcelRequire("eAI62");

var $ga3Hy = parcelRequire("ga3Hy");

var $53L6N = parcelRequire("53L6N");

var $cAixy = parcelRequire("cAixy");

var $9mw2J = parcelRequire("9mw2J");

var $jBB3H = parcelRequire("jBB3H");

var $fSse0 = parcelRequire("fSse0");

var $1kXKB = parcelRequire("1kXKB");

var $5Yry2 = parcelRequire("5Yry2");

var $172aY = parcelRequire("172aY");

var $7irdm = parcelRequire("7irdm");

var $3a6EI = parcelRequire("3a6EI");

var $gFYoT = parcelRequire("gFYoT");

var $kL8Kz = parcelRequire("kL8Kz");

var $kXHg1 = parcelRequire("kXHg1");

var $e7t4r = parcelRequire("e7t4r");

var $i1AZl = parcelRequire("i1AZl");

var $3GjBI = parcelRequire("3GjBI");
function $9884a20e8cb3484c$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $9884a20e8cb3484c$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $9884a20e8cb3484c$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $9884a20e8cb3484c$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $9884a20e8cb3484c$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $9884a20e8cb3484c$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $9884a20e8cb3484c$var$defaultSet = [
    (0, $fhqC4.eventKey),
    (0, $bP9ZI.eventType),
    (0, $cuNOM.eventProduct),
    (0, $4JYIi.eventRoute),
    (0, $kYbr3.eventId),
    (0, $5VPaW.eventLocalTime),
    (0, $77zOH.eventRegion),
    (0, $gocvX.appFramework),
    (0, $e6ZnV.appVersion),
    (0, $9mkAi.bmVersion),
    (0, $7irdm.telemetryBrowser),
    (0, $3a6EI.telemetryCpu),
    (0, $gFYoT.telemetryMemory),
    (0, $kL8Kz.telemetryNetwork),
    (0, $cQNCx.customData),
    (0, $2DojN.featureFlags),
    (0, $ftaQE.hostname),
    (0, $1kXKB.productCustomData),
    (0, $kXHg1.appTimings),
    (0, $i1AZl.resourceTimings)
];
var $9884a20e8cb3484c$var$pageLoadCommon = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $cpvBo.eventInitial),
    (0, $53L6N.pageLoadMetrics),
    (0, $e7t4r.bundleEvalTimings)
]);
var $9884a20e8cb3484c$var$initialPageLoadSet = [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))($9884a20e8cb3484c$var$pageLoadCommon), [
    (0, $cAwKl.initialPageLoadMetrics),
    (0, $ga3Hy.navigationMetrics),
    (0, $172aY.ssrSuccess),
    (0, $5Yry2.ssrFeatureFlags)
]);
var $9884a20e8cb3484c$var$spaTransitionSet = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))($9884a20e8cb3484c$var$pageLoadCommon);
var $9884a20e8cb3484c$var$pageSegmentLoadSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $cAixy.pageSegmentLoadMetrics),
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $cpvBo.eventInitial),
    (0, $e7t4r.bundleEvalTimings)
]);
var $9884a20e8cb3484c$var$interactionSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $eAI62.interactionMetrics)
]);
var $9884a20e8cb3484c$var$customMetricSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $jBB3H.pageVisibleState),
    (0, $fSse0.pageVisibleValue),
    (0, $i66wZ.customEventMetrics)
]);
// pageVisibleState and pageVisibleValue has been handled within webVitalsMetrics.
var $9884a20e8cb3484c$var$webVitalsMetricSet = [].concat($9884a20e8cb3484c$var$defaultSet, [
    (0, $9mw2J.webVitalsMetrics)
]);
// Function that returns a promise which resolves after clsWaitTimeMs + 500ms
// so that clsData is guaranteed to be attached to window
var $9884a20e8cb3484c$var$waitForCLS = function waitForCLS() {
    var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $8x86A.clsWaitTimeMs) + 500;
    return new Promise(function(resolve) {
        return setTimeout(resolve, delay);
    });
};
var $9884a20e8cb3484c$export$896b6e121bbaec25 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(globalConfig, data) {
        var set, plugins, _iterator, _step, plugin, result, pluginResults, generated;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(data.start === null || data.stop === null)) {
                        _context.next = 3;
                        break;
                    }
                    (0, $1XCKE.logger).log('eventDataProcessor: Metric "'.concat(data.key, '" start or stop are incorrect; start: ').concat(data.start, "; stop: ").concat(data.stop));
                    return _context.abrupt("return", null);
                case 3:
                    set = [];
                    if (data.config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && (0, $Bk1e4.isPageLoadMetricData)(data) && data.isInitial) set = $9884a20e8cb3484c$var$initialPageLoadSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && (0, $Bk1e4.isPageLoadMetricData)(data) && !data.isInitial) set = $9884a20e8cb3484c$var$spaTransitionSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD && (0, $Bk1e4.isPageSegmentLoadMetricData)(data)) set = $9884a20e8cb3484c$var$pageSegmentLoadSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).INLINE_RESULT) set = $9884a20e8cb3484c$var$interactionSet;
                    if (data.config.type === (0, $3GjBI.BMEventsType).CUSTOM) set = $9884a20e8cb3484c$var$customMetricSet;
                    if (!(data.config.type === (0, $3GjBI.BMEventsType).WEB_VITALS)) {
                        _context.next = 13;
                        break;
                    }
                    set = $9884a20e8cb3484c$var$webVitalsMetricSet;
                    // Wait for CLS to be recorded before proceeding to run plugin and attach CLS data
                    _context.next = 13;
                    return $9884a20e8cb3484c$var$waitForCLS();
                case 13:
                    //TODO if type is different - do not send at all
                    plugins = [];
                    _iterator = $9884a20e8cb3484c$var$_createForOfIteratorHelper(set);
                    _context.prev = 15;
                    _iterator.s();
                case 17:
                    if ((_step = _iterator.n()).done) {
                        _context.next = 25;
                        break;
                    }
                    plugin = _step.value;
                    _context.next = 21;
                    return plugin(data.config, data, // some plugins support page load specific data with special check
                    globalConfig);
                case 21:
                    result = _context.sent;
                    if (result) plugins.push(result);
                case 23:
                    _context.next = 17;
                    break;
                case 25:
                    _context.next = 30;
                    break;
                case 27:
                    _context.prev = 27;
                    _context.t0 = _context["catch"](15);
                    _iterator.e(_context.t0);
                case 30:
                    _context.prev = 30;
                    _iterator.f();
                    return _context.finish(30);
                case 33:
                    _context.next = 35;
                    return Promise.all(plugins);
                case 35:
                    pluginResults = _context.sent;
                    generated = {};
                    pluginResults.forEach(function(pluginResult) {
                        if (pluginResult === null) return;
                        Object.keys(pluginResult).forEach(function(key) {
                            var keyResult = pluginResult[key];
                            if (keyResult !== null && keyResult !== undefined) generated[key] = keyResult;
                        });
                    });
                    return _context.abrupt("return", generated);
                case 39:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                15,
                27,
                30,
                33
            ]
        ]);
    }));
    return function eventDataProcessor(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

});
parcelRegister("Bk1e4", function(module, exports) {

$parcel$export(module.exports, "isPageLoadMetricData", function () { return $0702fc20896e96af$export$b0e12e7abb0bff11; });
$parcel$export(module.exports, "isPageSegmentLoadMetricData", function () { return $0702fc20896e96af$export$83d0099ee6dbb5b0; });
$parcel$export(module.exports, "isPageLoadConfig", function () { return $0702fc20896e96af$export$8672fa27ba8bba88; });
$parcel$export(module.exports, "isPageSegmentLoadConfig", function () { return $0702fc20896e96af$export$abe063537ef4987b; });
$parcel$export(module.exports, "isInteractionConfig", function () { return $0702fc20896e96af$export$ae68674b6a9353be; });
$parcel$export(module.exports, "isCustomConfig", function () { return $0702fc20896e96af$export$b493eb8b2ba87421; });

var $3GjBI = parcelRequire("3GjBI");
var $0702fc20896e96af$export$b0e12e7abb0bff11 = function isPageLoadMetricData(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_LOAD;
};
var $0702fc20896e96af$export$83d0099ee6dbb5b0 = function isPageSegmentLoadMetricData(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $0702fc20896e96af$export$8672fa27ba8bba88 = function isPageLoadConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_LOAD;
};
var $0702fc20896e96af$export$abe063537ef4987b = function isPageSegmentLoadConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD;
};
var $0702fc20896e96af$export$ae68674b6a9353be = function isInteractionConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).INLINE_RESULT;
};
var $0702fc20896e96af$export$b493eb8b2ba87421 = function isCustomConfig(data) {
    return data.type === (0, $3GjBI.BMEventsType).CUSTOM;
};

});

parcelRegister("gocvX", function(module, exports) {

$parcel$export(module.exports, "appFramework", function () { return $bee8985109d261b2$export$e34e4529b979f74c; });
var $bee8985109d261b2$export$e34e4529b979f74c = function appFramework(_config, _data, globalConfig) {
    if (!globalConfig.app.framework) return null;
    return {
        "app:framework:name": globalConfig.app.framework.name,
        "app:framework:version": globalConfig.app.framework.version
    };
};

});

parcelRegister("e6ZnV", function(module, exports) {

$parcel$export(module.exports, "appVersion", function () { return $a4613e0023f30ae3$export$82ae485178b37419; });
var $a4613e0023f30ae3$export$82ae485178b37419 = function appVersion(_config, _data, globalConfig) {
    var pluginData = {
        "app:web:version": globalConfig.app.version.web
    };
    if (globalConfig.app.version.ssr) pluginData["app:ssr:version"] = globalConfig.app.version.ssr;
    return pluginData;
};

});

parcelRegister("9mkAi", function(module, exports) {

$parcel$export(module.exports, "bmVersion", function () { return $6d0622c3d2edc540$export$5cafa465fc876895; });
var $6d0622c3d2edc540$export$5cafa465fc876895 = function bmVersion() {
    return {
        "bm:version": 3
    };
};

});

parcelRegister("cQNCx", function(module, exports) {

$parcel$export(module.exports, "customData", function () { return $95b0d4ff8c73e7be$export$f7e743c7db162193; });

var $kg5sN = parcelRequire("kg5sN");
var $95b0d4ff8c73e7be$export$f7e743c7db162193 = function customData(_config, data) {
    var custom = {};
    var changed = false;
    if (data.custom) Object.entries(data.custom).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        changed = true;
        custom["custom:".concat(key)] = value;
    });
    return changed ? custom : null;
};

});

parcelRegister("kYbr3", function(module, exports) {

$parcel$export(module.exports, "eventId", function () { return $f4424813674ac020$export$aed28df7ac07d79a; });
var $f4424813674ac020$export$aed28df7ac07d79a = function eventId(config) {
    return {
        "event:id": config.key
    };
};

});

parcelRegister("cpvBo", function(module, exports) {

$parcel$export(module.exports, "eventInitial", function () { return $909055616d5c162b$export$fa8e91d436b3ef8b; });

var $Bk1e4 = parcelRequire("Bk1e4");
var $909055616d5c162b$export$fa8e91d436b3ef8b = function eventInitial(_config, data) {
    if (!(0, $Bk1e4.isPageLoadMetricData)(data) && !(0, $Bk1e4.isPageSegmentLoadMetricData)(data)) return null;
    return {
        "event:initial": data.isInitial
    };
};

});

parcelRegister("fhqC4", function(module, exports) {

$parcel$export(module.exports, "eventKey", function () { return $b1fd1658296089dc$export$10be2d3a558d3f88; });

var $7WJZg = parcelRequire("7WJZg");
var $b1fd1658296089dc$export$10be2d3a558d3f88 = function eventKey(config, _data, globalConfig) {
    return {
        "event:key": "".concat(globalConfig.product, ".fe.").concat((0, $7WJZg.mapEventType)(config.type), ".").concat(config.key)
    };
};

});
parcelRegister("7WJZg", function(module, exports) {

$parcel$export(module.exports, "mapEventType", function () { return $5c919f46408fbf93$export$b334d07f11140768; });

var $3GjBI = parcelRequire("3GjBI");
var $5c919f46408fbf93$export$b334d07f11140768 = function mapEventType(type) {
    switch(type){
        case (0, $3GjBI.BMEventsType).CUSTOM:
            return (0, $3GjBI.StorableBMEventsType).CUSTOM;
        case (0, $3GjBI.BMEventsType).INLINE_RESULT:
            return (0, $3GjBI.StorableBMEventsType).INLINE_RESULT;
        case (0, $3GjBI.BMEventsType).PAGE_LOAD:
            return (0, $3GjBI.StorableBMEventsType).PAGE_LOAD;
        case (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD:
            return (0, $3GjBI.StorableBMEventsType).PAGE_SEGMENT_LOAD;
        case (0, $3GjBI.BMEventsType).WEB_VITALS:
            return (0, $3GjBI.StorableBMEventsType).WEB_VITALS;
        default:
            return "unknown";
    }
};

});


parcelRegister("5VPaW", function(module, exports) {

$parcel$export(module.exports, "eventLocalTime", function () { return $4519f90490e347e5$export$5219854ae7ec45da; });

var $jCQKV = parcelRequire("jCQKV");
var $4519f90490e347e5$export$5219854ae7ec45da = function eventLocalTime() {
    return {
        "event:localHour": parseInt((0, $jCQKV.default)(new Date(), "H"), 10),
        "event:localDayOfWeek": parseInt((0, $jCQKV.default)(new Date(), "i"), 10)
    };
};

});
parcelRegister("jCQKV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e49a7d23cacbd9d4$export$2e2bcd8739ae039; });

var $lHYNI = parcelRequire("lHYNI");

var $aFEuq = parcelRequire("aFEuq");

var $eSxdi = parcelRequire("eSxdi");

var $fvbMt = parcelRequire("fvbMt");

var $8IH0c = parcelRequire("8IH0c");

var $2EOLL = parcelRequire("2EOLL");

var $eVjVQ = parcelRequire("eVjVQ");

var $cRwqP = parcelRequire("cRwqP");

var $kqhx7 = parcelRequire("kqhx7");

var $41GN3 = parcelRequire("41GN3");

var $3KblA = parcelRequire("3KblA");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $e49a7d23cacbd9d4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $e49a7d23cacbd9d4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $e49a7d23cacbd9d4$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $e49a7d23cacbd9d4$var$doubleQuoteRegExp = /''/g;
var $e49a7d23cacbd9d4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $e49a7d23cacbd9d4$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $kqhx7.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3KblA.default);
    var firstWeekContainsDate = (0, $cRwqP.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $cRwqP.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $eSxdi.default)(dirtyDate);
    if (!(0, $lHYNI.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $2EOLL.default)(originalDate);
    var utcDate = (0, $aFEuq.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($e49a7d23cacbd9d4$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $8IH0c.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($e49a7d23cacbd9d4$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $e49a7d23cacbd9d4$var$cleanEscapedString(substring);
        var formatter = (0, $fvbMt.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $eVjVQ.isProtectedWeekYearToken)(substring)) (0, $eVjVQ.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $eVjVQ.isProtectedDayOfYearToken)(substring)) (0, $eVjVQ.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($e49a7d23cacbd9d4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $e49a7d23cacbd9d4$var$cleanEscapedString(input) {
    var matched = input.match($e49a7d23cacbd9d4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($e49a7d23cacbd9d4$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("lHYNI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcdcc6e37afa7610$export$2e2bcd8739ae039; });

var $86hYx = parcelRequire("86hYx");

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $fcdcc6e37afa7610$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    if (!(0, $86hYx.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $eSxdi.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("86hYx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e5cd3cd3dc03531$export$2e2bcd8739ae039; });

var $8p0zh = parcelRequire("8p0zh");

var $kqhx7 = parcelRequire("kqhx7");
function $5e5cd3cd3dc03531$export$2e2bcd8739ae039(value) {
    (0, $kqhx7.default)(1, arguments);
    return value instanceof Date || (0, $8p0zh.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});


parcelRegister("aFEuq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c4d2426c0031a92$export$2e2bcd8739ae039; });

var $i24z8 = parcelRequire("i24z8");

var $kqhx7 = parcelRequire("kqhx7");

var $cRwqP = parcelRequire("cRwqP");
function $7c4d2426c0031a92$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kqhx7.default)(2, arguments);
    var amount = (0, $cRwqP.default)(dirtyAmount);
    return (0, $i24z8.default)(dirtyDate, -amount);
}

});
parcelRegister("i24z8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d20bf48777e67bc0$export$2e2bcd8739ae039; });

var $cRwqP = parcelRequire("cRwqP");

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $d20bf48777e67bc0$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $kqhx7.default)(2, arguments);
    var timestamp = (0, $eSxdi.default)(dirtyDate).getTime();
    var amount = (0, $cRwqP.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("cRwqP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95d3978f89c2fdc8$export$2e2bcd8739ae039; });
function $95d3978f89c2fdc8$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("fvbMt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b492e3b1fd13622b$export$2e2bcd8739ae039; });

var $8RAMF = parcelRequire("8RAMF");

var $gLgJI = parcelRequire("gLgJI");

var $44Mvq = parcelRequire("44Mvq");

var $lMhfJ = parcelRequire("lMhfJ");

var $guA3V = parcelRequire("guA3V");

var $90IUR = parcelRequire("90IUR");

var $9ERJW = parcelRequire("9ERJW");
var $b492e3b1fd13622b$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $b492e3b1fd13622b$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $9ERJW.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $guA3V.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $90IUR.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $90IUR.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $44Mvq.default)(date);
        // Padding
        return (0, $90IUR.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $90IUR.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $90IUR.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $90IUR.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $9ERJW.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $90IUR.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $lMhfJ.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $90IUR.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $gLgJI.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $90IUR.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $9ERJW.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $8RAMF.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $90IUR.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $90IUR.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $90IUR.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $90IUR.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $b492e3b1fd13622b$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $9ERJW.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $9ERJW.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $90IUR.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $90IUR.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $9ERJW.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $9ERJW.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $9ERJW.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $b492e3b1fd13622b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $b492e3b1fd13622b$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $b492e3b1fd13622b$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $b492e3b1fd13622b$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $b492e3b1fd13622b$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $90IUR.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $90IUR.default)(timestamp, token.length);
    }
};
function $b492e3b1fd13622b$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $90IUR.default)(minutes, 2);
}
function $b492e3b1fd13622b$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $90IUR.default)(Math.abs(offset) / 60, 2);
    }
    return $b492e3b1fd13622b$var$formatTimezone(offset, dirtyDelimiter);
}
function $b492e3b1fd13622b$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $90IUR.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $90IUR.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $b492e3b1fd13622b$export$2e2bcd8739ae039 = $b492e3b1fd13622b$var$formatters;

});
parcelRegister("8RAMF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673fce7af3bbd47a$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
var $673fce7af3bbd47a$var$MILLISECONDS_IN_DAY = 86400000;
function $673fce7af3bbd47a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $673fce7af3bbd47a$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("gLgJI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c33e049a71cddf32$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $6vSLh = parcelRequire("6vSLh");

var $gzZin = parcelRequire("gzZin");

var $kqhx7 = parcelRequire("kqhx7");
var $c33e049a71cddf32$var$MILLISECONDS_IN_WEEK = 604800000;
function $c33e049a71cddf32$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var diff = (0, $6vSLh.default)(date).getTime() - (0, $gzZin.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c33e049a71cddf32$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("6vSLh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4be01ddbb0dd69c0$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");
function $4be01ddbb0dd69c0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $eSxdi.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gzZin", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c11f763762953489$export$2e2bcd8739ae039; });

var $44Mvq = parcelRequire("44Mvq");

var $6vSLh = parcelRequire("6vSLh");

var $kqhx7 = parcelRequire("kqhx7");
function $c11f763762953489$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var year = (0, $44Mvq.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $6vSLh.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("44Mvq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f7d2963e879dde2$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");

var $6vSLh = parcelRequire("6vSLh");
function $2f7d2963e879dde2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $6vSLh.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $6vSLh.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("lMhfJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fdab76b0d8931cb9$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $dRAqc = parcelRequire("dRAqc");

var $hhfjv = parcelRequire("hhfjv");

var $kqhx7 = parcelRequire("kqhx7");
var $fdab76b0d8931cb9$var$MILLISECONDS_IN_WEEK = 604800000;
function $fdab76b0d8931cb9$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var diff = (0, $dRAqc.default)(date, options).getTime() - (0, $hhfjv.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $fdab76b0d8931cb9$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("dRAqc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a17c7a2fcf864c1f$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");

var $cRwqP = parcelRequire("cRwqP");

var $41GN3 = parcelRequire("41GN3");
function $a17c7a2fcf864c1f$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kqhx7.default)(1, arguments);
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var weekStartsOn = (0, $cRwqP.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $eSxdi.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("41GN3", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", function () { return $2ee872afb5943c02$export$430a3269e24b912e; });
var $2ee872afb5943c02$var$defaultOptions = {};
function $2ee872afb5943c02$export$430a3269e24b912e() {
    return $2ee872afb5943c02$var$defaultOptions;
}
function $2ee872afb5943c02$export$95365be1b0704abc(newOptions) {
    $2ee872afb5943c02$var$defaultOptions = newOptions;
}

});


parcelRegister("hhfjv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c93fe72e225a05ce$export$2e2bcd8739ae039; });

var $guA3V = parcelRequire("guA3V");

var $kqhx7 = parcelRequire("kqhx7");

var $dRAqc = parcelRequire("dRAqc");

var $cRwqP = parcelRequire("cRwqP");

var $41GN3 = parcelRequire("41GN3");
function $c93fe72e225a05ce$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kqhx7.default)(1, arguments);
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var firstWeekContainsDate = (0, $cRwqP.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $guA3V.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $dRAqc.default)(firstWeek, options);
    return date;
}

});
parcelRegister("guA3V", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c01b6becc08f15d6$export$2e2bcd8739ae039; });

var $eSxdi = parcelRequire("eSxdi");

var $kqhx7 = parcelRequire("kqhx7");

var $dRAqc = parcelRequire("dRAqc");

var $cRwqP = parcelRequire("cRwqP");

var $41GN3 = parcelRequire("41GN3");
function $c01b6becc08f15d6$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $kqhx7.default)(1, arguments);
    var date = (0, $eSxdi.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $41GN3.getDefaultOptions)();
    var firstWeekContainsDate = (0, $cRwqP.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $dRAqc.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $dRAqc.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("90IUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68f6f48c33db0e43$export$2e2bcd8739ae039; });
function $68f6f48c33db0e43$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("9ERJW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7081891fd2f86bb4$export$2e2bcd8739ae039; });

var $90IUR = parcelRequire("90IUR");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $7081891fd2f86bb4$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $90IUR.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $90IUR.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $90IUR.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $90IUR.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $90IUR.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $90IUR.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $90IUR.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $90IUR.default)(fractionalSeconds, token.length);
    }
};
var $7081891fd2f86bb4$export$2e2bcd8739ae039 = $7081891fd2f86bb4$var$formatters;

});


parcelRegister("8IH0c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6593ca2313117d01$export$2e2bcd8739ae039; });
var $6593ca2313117d01$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $6593ca2313117d01$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $6593ca2313117d01$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $6593ca2313117d01$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $6593ca2313117d01$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $6593ca2313117d01$var$timeLongFormatter(timePattern, formatLong));
};
var $6593ca2313117d01$var$longFormatters = {
    p: $6593ca2313117d01$var$timeLongFormatter,
    P: $6593ca2313117d01$var$dateTimeLongFormatter
};
var $6593ca2313117d01$export$2e2bcd8739ae039 = $6593ca2313117d01$var$longFormatters;

});

parcelRegister("eVjVQ", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", function () { return $add5d99cf63fde86$export$c6cc36aa33304772; });
$parcel$export(module.exports, "isProtectedWeekYearToken", function () { return $add5d99cf63fde86$export$c6b49d6dceb604a1; });
$parcel$export(module.exports, "throwProtectedError", function () { return $add5d99cf63fde86$export$8073c1ae88f0e727; });
var $add5d99cf63fde86$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $add5d99cf63fde86$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $add5d99cf63fde86$export$c6cc36aa33304772(token) {
    return $add5d99cf63fde86$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $add5d99cf63fde86$export$c6b49d6dceb604a1(token) {
    return $add5d99cf63fde86$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $add5d99cf63fde86$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("3KblA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b9e784a0f833d0f$export$2e2bcd8739ae039; });

var $fN68j = parcelRequire("fN68j");
var $2b9e784a0f833d0f$export$2e2bcd8739ae039 = (0, $fN68j.default);

});
parcelRegister("fN68j", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7f03086d92d856b$export$2e2bcd8739ae039; });

var $3Pwbo = parcelRequire("3Pwbo");

var $d6o4i = parcelRequire("d6o4i");

var $aiDY0 = parcelRequire("aiDY0");

var $2pcC1 = parcelRequire("2pcC1");

var $1RRm6 = parcelRequire("1RRm6");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $b7f03086d92d856b$var$locale = {
    code: "en-US",
    formatDistance: (0, $3Pwbo.default),
    formatLong: (0, $d6o4i.default),
    formatRelative: (0, $aiDY0.default),
    localize: (0, $2pcC1.default),
    match: (0, $1RRm6.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b7f03086d92d856b$export$2e2bcd8739ae039 = $b7f03086d92d856b$var$locale;

});
parcelRegister("3Pwbo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c9f1956570a4633$export$2e2bcd8739ae039; });
var $2c9f1956570a4633$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $2c9f1956570a4633$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $2c9f1956570a4633$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $2c9f1956570a4633$export$2e2bcd8739ae039 = $2c9f1956570a4633$var$formatDistance;

});

parcelRegister("d6o4i", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $989e8162eb89b61a$export$2e2bcd8739ae039; });

var $dYzKH = parcelRequire("dYzKH");
var $989e8162eb89b61a$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $989e8162eb89b61a$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $989e8162eb89b61a$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $989e8162eb89b61a$var$formatLong = {
    date: (0, $dYzKH.default)({
        formats: $989e8162eb89b61a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $dYzKH.default)({
        formats: $989e8162eb89b61a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $dYzKH.default)({
        formats: $989e8162eb89b61a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $989e8162eb89b61a$export$2e2bcd8739ae039 = $989e8162eb89b61a$var$formatLong;

});
parcelRegister("dYzKH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a2cc9c9d2a0ad66c$export$2e2bcd8739ae039; });
function $a2cc9c9d2a0ad66c$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("aiDY0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77fa9661b36ee9ee$export$2e2bcd8739ae039; });
var $77fa9661b36ee9ee$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $77fa9661b36ee9ee$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $77fa9661b36ee9ee$var$formatRelativeLocale[token];
};
var $77fa9661b36ee9ee$export$2e2bcd8739ae039 = $77fa9661b36ee9ee$var$formatRelative;

});

parcelRegister("2pcC1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c07b31eca56cbac$export$2e2bcd8739ae039; });

var $67K3N = parcelRequire("67K3N");
var $1c07b31eca56cbac$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $1c07b31eca56cbac$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $1c07b31eca56cbac$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $1c07b31eca56cbac$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $1c07b31eca56cbac$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $1c07b31eca56cbac$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $1c07b31eca56cbac$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $1c07b31eca56cbac$var$localize = {
    ordinalNumber: $1c07b31eca56cbac$var$ordinalNumber,
    era: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $67K3N.default)({
        values: $1c07b31eca56cbac$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $1c07b31eca56cbac$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $1c07b31eca56cbac$export$2e2bcd8739ae039 = $1c07b31eca56cbac$var$localize;

});
parcelRegister("67K3N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4757201ae6eb393b$export$2e2bcd8739ae039; });
function $4757201ae6eb393b$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("1RRm6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15c420fbf03d303f$export$2e2bcd8739ae039; });

var $iPUN3 = parcelRequire("iPUN3");

var $gLBHn = parcelRequire("gLBHn");
var $15c420fbf03d303f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $15c420fbf03d303f$var$parseOrdinalNumberPattern = /\d+/i;
var $15c420fbf03d303f$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $15c420fbf03d303f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $15c420fbf03d303f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $15c420fbf03d303f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $15c420fbf03d303f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $15c420fbf03d303f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $15c420fbf03d303f$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $15c420fbf03d303f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $15c420fbf03d303f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $15c420fbf03d303f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $15c420fbf03d303f$var$match = {
    ordinalNumber: (0, $gLBHn.default)({
        matchPattern: $15c420fbf03d303f$var$matchOrdinalNumberPattern,
        parsePattern: $15c420fbf03d303f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $15c420fbf03d303f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $15c420fbf03d303f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $15c420fbf03d303f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $15c420fbf03d303f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $iPUN3.default)({
        matchPatterns: $15c420fbf03d303f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $15c420fbf03d303f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $15c420fbf03d303f$export$2e2bcd8739ae039 = $15c420fbf03d303f$var$match;

});
parcelRegister("iPUN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db690abe2489105d$export$2e2bcd8739ae039; });
function $db690abe2489105d$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $db690abe2489105d$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $db690abe2489105d$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $db690abe2489105d$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $db690abe2489105d$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("gLBHn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c34e4745ab4f0a1a$export$2e2bcd8739ae039; });
function $c34e4745ab4f0a1a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});






parcelRegister("cuNOM", function(module, exports) {

$parcel$export(module.exports, "eventProduct", function () { return $918eee2e0119c8be$export$a7df4e8088db8843; });
var $918eee2e0119c8be$export$a7df4e8088db8843 = function eventProduct(_config, _data, globalConfig) {
    return {
        "event:product": "".concat(globalConfig.product)
    };
};

});

parcelRegister("77zOH", function(module, exports) {

$parcel$export(module.exports, "eventRegion", function () { return $52f4f8543a6ce682$export$d0117b71adcdebc0; });
var $52f4f8543a6ce682$export$d0117b71adcdebc0 = function eventRegion(_config, _data, globalConfig) {
    return {
        "event:region": "".concat(globalConfig.region)
    };
};

});

parcelRegister("4JYIi", function(module, exports) {

$parcel$export(module.exports, "eventRoute", function () { return $373a75d784d6cb11$export$44d3627af289ca16; });
var $373a75d784d6cb11$export$44d3627af289ca16 = function eventRoute(_config, data) {
    if (!data.route) return null;
    return {
        "event:route": data.route
    };
};

});

parcelRegister("bP9ZI", function(module, exports) {

$parcel$export(module.exports, "eventType", function () { return $89bc35d05e24abe7$export$4c045e605d532c98; });

var $7WJZg = parcelRequire("7WJZg");
var $89bc35d05e24abe7$export$4c045e605d532c98 = function eventType(config) {
    return {
        "event:type": (0, $7WJZg.mapEventType)(config.type)
    };
};

});

parcelRegister("2DojN", function(module, exports) {

$parcel$export(module.exports, "featureFlags", function () { return $1eb2166ae740bf43$export$e62953d023125748; });

var $6bkHe = parcelRequire("6bkHe");
function $1eb2166ae740bf43$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1eb2166ae740bf43$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1eb2166ae740bf43$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1eb2166ae740bf43$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1eb2166ae740bf43$export$e62953d023125748 = function featureFlags(config, _data, globalConfig) {
    var _config$featureFlags;
    var localFeatureFlags = ((_config$featureFlags = config.featureFlags) === null || _config$featureFlags === void 0 ? void 0 : _config$featureFlags.reduce(function(acc, ffName) {
        acc[ffName] = globalConfig.ffClient.getValue(ffName);
        return acc;
    }, {})) || null;
    if ((!globalConfig.featureFlags || Object.keys(globalConfig.featureFlags).length === 0) && (!localFeatureFlags || Object.keys(localFeatureFlags).length === 0)) return null;
    return {
        featureFlags: $1eb2166ae740bf43$var$_objectSpread($1eb2166ae740bf43$var$_objectSpread({}, localFeatureFlags), globalConfig.featureFlags)
    };
};

});

parcelRegister("ftaQE", function(module, exports) {

$parcel$export(module.exports, "hostname", function () { return $b431faad2a1f11e2$export$640106f6dc7d2706; });
var $b431faad2a1f11e2$export$640106f6dc7d2706 = function hostname(_config, _data, globalConfig) {
    return {
        hostname: globalConfig.hostname
    };
};

});

parcelRegister("i66wZ", function(module, exports) {

$parcel$export(module.exports, "customEventMetrics", function () { return $d2cdda7518611ae3$export$cab039265c52a2e9; });

var $Bk1e4 = parcelRequire("Bk1e4");
var $d2cdda7518611ae3$export$cab039265c52a2e9 = function customEventMetrics(config, data, globalConfig) {
    var _config$slo, _config$histogram;
    if (!(0, $Bk1e4.isCustomConfig)(config)) return null;
    var payload = {
        "metric:duration": Math.round(data.stop - data.start)
    };
    if (((_config$slo = config.slo) === null || _config$slo === void 0 ? void 0 : _config$slo.threshold) !== undefined) {
        var _config$slo2, _config$slo3;
        payload["metric:duration:slo"] = payload["metric:duration"] <= ((_config$slo2 = config.slo) === null || _config$slo2 === void 0 ? void 0 : _config$slo2.threshold);
        payload["metric:duration:slo:threshold"] = (_config$slo3 = config.slo) === null || _config$slo3 === void 0 ? void 0 : _config$slo3.threshold;
    }
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.duration) payload["metric:duration:histogramBuckets"] = config.histogram.duration;
    else if (globalConfig.histogram) payload["metric:duration:histogramBuckets"] = globalConfig.histogram.duration;
    return payload;
};

});

parcelRegister("cAwKl", function(module, exports) {

$parcel$export(module.exports, "initialPageLoadMetrics", function () { return $92a23f97decfbace$export$cc95aa3f6ea8e5cb; });
var $92a23f97decfbace$export$cc95aa3f6ea8e5cb = function initialPageLoadMetrics() {
    var metrics = {};
    performance.getEntriesByType("paint").forEach(function(entry) {
        if (entry.name === "first-paint") metrics["metric:fp"] = Math.round(entry.startTime);
        if (entry.name === "first-contentful-paint") metrics["metric:fcp"] = Math.round(entry.startTime);
    });
    return metrics;
};

});

parcelRegister("eAI62", function(module, exports) {

$parcel$export(module.exports, "interactionMetrics", function () { return $a9f6a21a2eddddc5$export$86db56030b57ba34; });

var $Bk1e4 = parcelRequire("Bk1e4");

var $3GjBI = parcelRequire("3GjBI");
var $a9f6a21a2eddddc5$export$86db56030b57ba34 = function interactionMetrics(config, data, globalConfig) {
    var _config$histogram;
    if (!(0, $Bk1e4.isInteractionConfig)(config)) return null;
    var result = {
        "metric:result": Math.round(data.stop - data.start)
    };
    if ((_config$histogram = config.histogram) !== null && _config$histogram !== void 0 && _config$histogram.result) result["metric:result:histogramBuckets"] = config.histogram.result;
    else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        if (histogram.result !== undefined) result["metric:result:histogramBuckets"] = histogram[(0, $3GjBI.BMInteractionMetrics).result];
    }
    if (config.slo && (0, $3GjBI.isInteractionMetricsSlo)(config.slo) && config.slo.result) {
        result["metric:result:slo"] = result["metric:result"] <= config.slo.result.threshold;
        result["metric:result:slo:threshold"] = config.slo.result.threshold;
    }
    if (data.marks["feedback"]) {
        var _config$histogram2;
        result["metric:response"] = Math.round((data.marks["feedback"] || data.stop) - data.start);
        if ((_config$histogram2 = config.histogram) !== null && _config$histogram2 !== void 0 && _config$histogram2.response) result["metric:response:histogramBuckets"] = config.histogram[(0, $3GjBI.BMInteractionMetrics).response];
        else if (globalConfig.histogram) {
            var _histogram = globalConfig.histogram;
            if (_histogram.result !== undefined) result["metric:response:histogramBuckets"] = _histogram[(0, $3GjBI.BMInteractionMetrics).response];
        }
        if (config.slo && (0, $3GjBI.isInteractionMetricsSlo)(config.slo) && config.slo.response) {
            result["metric:response:slo"] = result["metric:response"] <= config.slo.response.threshold;
            result["metric:response:slo:threshold"] = config.slo.response.threshold;
        }
    }
    return result;
};

});

parcelRegister("ga3Hy", function(module, exports) {

$parcel$export(module.exports, "navigationMetrics", function () { return $bc4073919ce4d01e$export$b88d990436be0f8a; });
var $bc4073919ce4d01e$export$b88d990436be0f8a = function navigationMetrics() {
    var entries = performance.getEntriesByType("navigation");
    if (entries.length === 0) return null;
    var navigation = entries[0];
    var metrics = {
        // From https://www.w3.org/TR/resource-timing/
        redirectStart: Math.round(navigation.redirectStart),
        redirectEnd: Math.round(navigation.redirectEnd),
        fetchStart: Math.round(navigation.fetchStart),
        domainLookupStart: Math.round(navigation.domainLookupStart),
        domainLookupEnd: Math.round(navigation.domainLookupEnd),
        connectStart: Math.round(navigation.connectStart),
        connectEnd: Math.round(navigation.connectEnd),
        secureConnectionStart: Math.round(navigation.secureConnectionStart),
        requestStart: Math.round(navigation.requestStart),
        responseStart: Math.round(navigation.responseStart),
        responseEnd: Math.round(navigation.responseEnd),
        encodedBodySize: Math.round(navigation.encodedBodySize),
        decodedBodySize: Math.round(navigation.decodedBodySize),
        transferSize: Math.round(navigation.transferSize),
        // From https://www.w3.org/TR/navigation-timing-2/
        redirectCount: navigation.redirectCount,
        type: navigation.type,
        unloadEventEnd: Math.round(navigation.unloadEventEnd),
        unloadEventStart: Math.round(navigation.unloadEventStart),
        workerStart: Math.round(navigation.workerStart)
    };
    return {
        "metrics:navigation": metrics
    };
};

});

parcelRegister("53L6N", function(module, exports) {

$parcel$export(module.exports, "pageLoadMetrics", function () { return $3af1c659a6659c41$export$2878bf482e539059; });

var $Bk1e4 = parcelRequire("Bk1e4");

var $3GjBI = parcelRequire("3GjBI");
var $3af1c659a6659c41$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $3GjBI.isDetailedPageLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $3af1c659a6659c41$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $3af1c659a6659c41$export$2878bf482e539059 = function pageLoadMetrics(config, data, globalConfig) {
    if (!(0, $Bk1e4.isPageLoadConfig)(config)) throw new Error("Browser Metrics: cannot gather page load data for non-page-load config");
    var fmp = data.marks[(0, $3GjBI.BMPageLoadMetrics).fmp] || data.stop;
    var result = {
        "metric:fmp": Math.round(fmp - data.start),
        "metric:tti": Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result["metric:fmp:histogramBuckets"] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).fmp, config.histogram);
        result["metric:tti:histogramBuckets"] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result["metric:fmp:histogramBuckets"] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).fmp, histogram);
        result["metric:tti:histogramBuckets"] = $3af1c659a6659c41$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageLoadMetrics).tti, histogram);
    }
    if (config.slo && config.slo.fmp) {
        var threshold = $3af1c659a6659c41$var$getThreshold(data.isInitial, config.slo.fmp);
        result["metric:fmp:slo"] = result["metric:fmp"] <= threshold;
        result["metric:fmp:slo:threshold"] = threshold;
    }
    if (config.slo && config.slo.tti) {
        var _threshold = $3af1c659a6659c41$var$getThreshold(data.isInitial, config.slo.tti);
        result["metric:tti:slo"] = result["metric:tti"] <= _threshold;
        result["metric:tti:slo:threshold"] = _threshold;
    }
    return result;
};

});

parcelRegister("cAixy", function(module, exports) {

$parcel$export(module.exports, "pageSegmentLoadMetrics", function () { return $92973a8a109c40cb$export$ba86cb47f2f22db5; });

var $5EyB3 = parcelRequire("5EyB3");

var $Bk1e4 = parcelRequire("Bk1e4");

var $3GjBI = parcelRequire("3GjBI");
var $92973a8a109c40cb$var$getThreshold = function getThreshold(isInitial, metric) {
    return (0, $3GjBI.isDetailedPageSegmentLoadSlo)(metric) ? isInitial ? metric.initial.threshold : metric.transition.threshold : metric.threshold;
};
var $92973a8a109c40cb$var$getHistogram = function getHistogram(isInitial, metric, histogram) {
    return isInitial ? histogram.initial[metric] : histogram.transition[metric];
};
var $92973a8a109c40cb$export$ba86cb47f2f22db5 = function pageSegmentLoadMetrics(config, data, globalConfig) {
    var _config$slo, _config$slo2;
    if (!(0, $Bk1e4.isPageSegmentLoadConfig)(config)) throw new Error("Browser Metrics: cannot gather page segment load data for non-page-segment-load config");
    var fmp = data.marks[(0, $3GjBI.BMPageSegmentLoadMetrics).fmp] || data.stop;
    var result = {
        "metric:fmp": Math.round(fmp - data.start),
        "metric:tti": Math.round(data.stop - data.start)
    };
    if (config.histogram) {
        result["metric:fmp:histogramBuckets"] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).fmp, config.histogram);
        result["metric:tti:histogramBuckets"] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).tti, config.histogram);
    } else if (globalConfig.histogram) {
        var histogram = globalConfig.histogram;
        result["metric:fmp:histogramBuckets"] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).fmp, histogram);
        result["metric:tti:histogramBuckets"] = $92973a8a109c40cb$var$getHistogram(data.isInitial, (0, $3GjBI.BMPageSegmentLoadMetrics).tti, histogram);
    }
    if ((_config$slo = config.slo) !== null && _config$slo !== void 0 && _config$slo.fmp) {
        var threshold = $92973a8a109c40cb$var$getThreshold(data.isInitial, config.slo.fmp);
        result["metric:fmp:slo"] = result["metric:fmp"] <= threshold;
        result["metric:fmp:slo:threshold"] = threshold;
    }
    if ((_config$slo2 = config.slo) !== null && _config$slo2 !== void 0 && _config$slo2.tti) {
        var _threshold = $92973a8a109c40cb$var$getThreshold(data.isInitial, config.slo.tti);
        result["metric:tti:slo"] = result["metric:tti"] <= _threshold;
        result["metric:tti:slo:threshold"] = _threshold;
    }
    if (config.includePageLoadTimings === (0, $3GjBI.PageSegmentPageLoadMetricsOptions).IF_PRESENT || config.includePageLoadTimings === (0, $3GjBI.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT) {
        var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getData();
        var _fmp = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round((pageLoadData.marks[(0, $3GjBI.BMPageLoadMetrics).fmp] || pageLoadData.stop) - pageLoadData.start) : null;
        var tti = pageLoadData.stop !== null && pageLoadData.start !== null ? Math.round(pageLoadData.stop - pageLoadData.start) : null;
        result["pageLoad"] = {
            fmp: _fmp,
            tti: tti
        };
    }
    return result;
};

});

parcelRegister("9mw2J", function(module, exports) {

$parcel$export(module.exports, "webVitalsMetrics", function () { return $6d0f06325a18bb7d$export$3731db279f590f30; });

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $k6Eo3 = parcelRequire("k6Eo3");

var $a3buC = parcelRequire("a3buC");

var $djDSg = parcelRequire("djDSg");

var $fSse0 = parcelRequire("fSse0");
function $6d0f06325a18bb7d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d0f06325a18bb7d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d0f06325a18bb7d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d0f06325a18bb7d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6d0f06325a18bb7d$export$3731db279f590f30 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(config, data, globalConfig) {
        var _globalConfig$webVita, _globalConfig$webVita2, _globalConfig$webVita3;
        var pageVisibleState, setPageVisibleStateToMixed, ttciEnabled, webVitalMetrics;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    pageVisibleState = data.pageVisibleState;
                    setPageVisibleStateToMixed = function setPageVisibleStateToMixed() {
                        pageVisibleState = (0, $k6Eo3.PageVisibleState).MIXED;
                    };
                    (0, $a3buC.visibilityChangeObserver).subscribe(setPageVisibleStateToMixed);
                    ttciEnabled = ((_globalConfig$webVita = globalConfig.webVitals) === null || _globalConfig$webVita === void 0 ? void 0 : _globalConfig$webVita.ttciEnabled) !== undefined ? (_globalConfig$webVita2 = globalConfig.webVitals) === null || _globalConfig$webVita2 === void 0 ? void 0 : _globalConfig$webVita2.ttciEnabled : true;
                    _context.next = 6;
                    return $6d0f06325a18bb7d$export$193ae490b52081dd(ttciEnabled, ((_globalConfig$webVita3 = globalConfig.webVitals) === null || _globalConfig$webVita3 === void 0 ? void 0 : _globalConfig$webVita3.timeout) || 30000);
                case 6:
                    webVitalMetrics = _context.sent;
                    (0, $a3buC.visibilityChangeObserver).unsubscribe(setPageVisibleStateToMixed);
                    return _context.abrupt("return", $6d0f06325a18bb7d$var$_objectSpread($6d0f06325a18bb7d$var$_objectSpread({}, webVitalMetrics), {}, {
                        "pageVisible:state": pageVisibleState
                    }, (0, $fSse0.pageVisibleValue)(config, data, globalConfig)));
                case 9:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function webVitalsMetrics(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();
var $6d0f06325a18bb7d$export$193ae490b52081dd = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(ttciEnabled, timeout) {
        var timeoutWindow;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    _context2.next = 2;
                    return ttciEnabled ? (0, $djDSg.webVitalsObserver).ttciDetermined : Promise.resolve();
                case 2:
                    // wait up to $timeout ms longer for web-vitals until returning
                    timeoutWindow = new Promise(function(resolve) {
                        return setTimeout(resolve, timeout);
                    });
                    _context2.next = 5;
                    return Promise.race([
                        timeoutWindow,
                        (0, $djDSg.webVitalsObserver).webVitalsDetermined
                    ]);
                case 5:
                    return _context2.abrupt("return", (0, $djDSg.webVitalsObserver).data);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function webVitalsMetricCustomTimeout(_x4, _x5) {
        return _ref2.apply(this, arguments);
    };
}();

});
parcelRegister("fSse0", function(module, exports) {

$parcel$export(module.exports, "pageVisibleValue", function () { return $b8f1cb066af754a0$export$177b923114656380; });

var $k6Eo3 = parcelRequire("k6Eo3");
var $3GjBI = parcelRequire("3GjBI");
var $b8f1cb066af754a0$export$177b923114656380 = function pageVisibleValue(_config, data, globalConfig) {
    var value = globalConfig.pageVisibleValueOrigin === (0, $3GjBI.PageVisibleValueOrigin).documentHidden ? !document.hidden || false : data.pageVisibleState === (0, $k6Eo3.PageVisibleState).VISIBLE;
    return {
        "pageVisible:value": value
    };
};

});


parcelRegister("jBB3H", function(module, exports) {

$parcel$export(module.exports, "pageVisibleState", function () { return $e45e3815f7cb532e$export$723b4c298aca63af; });
var $e45e3815f7cb532e$export$723b4c298aca63af = function pageVisibleState(_config, data) {
    return {
        "pageVisible:state": data.pageVisibleState
    };
};

});

parcelRegister("1kXKB", function(module, exports) {

$parcel$export(module.exports, "productCustomData", function () { return $0f9601ea9205a8bb$export$fa2af6e412815a74; });

var $kg5sN = parcelRequire("kg5sN");

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");
var $0f9601ea9205a8bb$export$fa2af6e412815a74 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(_config, data, globalConfig) {
        var result, pluginOutputs;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!(!globalConfig.custom && !globalConfig.plugins)) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return", null);
                case 2:
                    result = {};
                    if (globalConfig.custom) Object.entries(globalConfig.custom).forEach(function(_ref2) {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref2, 2), key = _ref3[0], value = _ref3[1];
                        result["".concat(globalConfig.product, ":").concat(key)] = value;
                    });
                    if (!globalConfig.plugins) {
                        _context.next = 9;
                        break;
                    }
                    _context.next = 7;
                    return Promise.all(globalConfig.plugins.map(function(plugin) {
                        return plugin({
                            start: data.start,
                            stop: data.stop,
                            key: data.key
                        });
                    }));
                case 7:
                    pluginOutputs = _context.sent;
                    pluginOutputs.forEach(function(pluginOutput) {
                        if (pluginOutput === null) return;
                        Object.entries(pluginOutput).forEach(function(_ref4) {
                            var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref4, 2), key = _ref5[0], value = _ref5[1];
                            result["".concat(globalConfig.product, ":").concat(key)] = value;
                        });
                    });
                case 9:
                    return _context.abrupt("return", result);
                case 10:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function productCustomData(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

});

parcelRegister("5Yry2", function(module, exports) {

$parcel$export(module.exports, "ssrFeatureFlags", function () { return $4597ecd358795bbd$export$fdbea518c19dfa8; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $3GjBI = parcelRequire("3GjBI");
var $4597ecd358795bbd$var$retrieveFeatureFlags = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(getFeatureFlags) {
        var featureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.prev = 0;
                    _context.next = 3;
                    return getFeatureFlags();
                case 3:
                    featureFlags = _context.sent;
                    if (!featureFlags) {
                        _context.next = 6;
                        break;
                    }
                    return _context.abrupt("return", {
                        "ssr:featureFlags": featureFlags
                    });
                case 6:
                    _context.next = 10;
                    break;
                case 8:
                    _context.prev = 8;
                    _context.t0 = _context["catch"](0);
                case 10:
                    return _context.abrupt("return", null);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function retrieveFeatureFlags(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $4597ecd358795bbd$export$fdbea518c19dfa8 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(config, _data, globalConfig) {
        var _globalConfig$ssr, _config$ssr, _globalConfig$ssr2, _config$ssr2;
        var includeFeatureFlags;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((_globalConfig$ssr = globalConfig.ssr) !== null && _globalConfig$ssr !== void 0 && _globalConfig$ssr.getFeatureFlags) {
                        _context2.next = 2;
                        break;
                    }
                    return _context2.abrupt("return", null);
                case 2:
                    includeFeatureFlags = ((_config$ssr = config.ssr) === null || _config$ssr === void 0 ? void 0 : _config$ssr.includeFeatureFlags) || ((_globalConfig$ssr2 = globalConfig.ssr) === null || _globalConfig$ssr2 === void 0 ? void 0 : _globalConfig$ssr2.includeFeatureFlags) || (0, $3GjBI.IncludeSSRFeatureFlagsConfig).WHEN_FMP;
                    if (!(includeFeatureFlags === (0, $3GjBI.IncludeSSRFeatureFlagsConfig).WHEN_AVAILABLE || (_config$ssr2 = config.ssr) !== null && _config$ssr2 !== void 0 && _config$ssr2.doneAsFmp && includeFeatureFlags === (0, $3GjBI.IncludeSSRFeatureFlagsConfig).WHEN_FMP)) {
                        _context2.next = 7;
                        break;
                    }
                    _context2.next = 6;
                    return $4597ecd358795bbd$var$retrieveFeatureFlags(globalConfig.ssr.getFeatureFlags);
                case 6:
                    return _context2.abrupt("return", _context2.sent);
                case 7:
                    return _context2.abrupt("return", null);
                case 8:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function ssrFeatureFlags(_x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
    };
}();

});

parcelRegister("172aY", function(module, exports) {

$parcel$export(module.exports, "ssrSuccess", function () { return $0cf821fe9da0d88c$export$a3dc8251cf55b2e0; });
var $0cf821fe9da0d88c$export$a3dc8251cf55b2e0 = function ssrSuccess(config, _data, globalConfig) {
    if (config.ssr && config.ssr.doneAsFmp && globalConfig.ssr && globalConfig.ssr.getDoneMark && globalConfig.ssr.getDoneMark()) return {
        "ssr:success": true
    };
    return null;
};

});

parcelRegister("7irdm", function(module, exports) {

$parcel$export(module.exports, "telemetryBrowser", function () { return $54ff531318b206d9$export$386b10ac64a50b1; });

var $aP7bp = parcelRequire("aP7bp");
var $54ff531318b206d9$export$386b10ac64a50b1 = function telemetryBrowser() {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($aP7bp))).getParser) return null;
    var browser = (0, (/*@__PURE__*/$parcel$interopDefault($aP7bp))).getParser(window.navigator.userAgent);
    return {
        "telemetry:browser:name": browser.getBrowserName(),
        "telemetry:browser:version": browser.getBrowserVersion()
    };
};

});
parcelRegister("aP7bp", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("3a6EI", function(module, exports) {

$parcel$export(module.exports, "telemetryCpu", function () { return $24d777f06af76a24$export$9f84cb359ed29139; });
var $24d777f06af76a24$export$9f84cb359ed29139 = function telemetryCpu() {
    if (!navigator.hardwareConcurrency) return null;
    return {
        "telemetry:cpus": navigator.hardwareConcurrency
    };
};

});

parcelRegister("gFYoT", function(module, exports) {

$parcel$export(module.exports, "telemetryMemory", function () { return $c23f53f4c1304807$export$496c14d72b257e07; });
var $c23f53f4c1304807$export$496c14d72b257e07 = function telemetryMemory() {
    // @ts-ignore: deviceMemory is exposed in some browsers
    if (!navigator.deviceMemory) return null;
    return {
        // @ts-ignore
        "telemetry:memory": navigator.deviceMemory
    };
};

});

parcelRegister("kL8Kz", function(module, exports) {

$parcel$export(module.exports, "telemetryNetwork", function () { return $f1cefc0b3edf133d$export$88bf7b55f7fc4e8e; });
var $f1cefc0b3edf133d$export$88bf7b55f7fc4e8e = function telemetryNetwork() {
    // @ts-ignore: connection is available in some browsers
    // eslint-disable-next-line compat/compat
    if (!navigator.connection) return null;
    return {
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:effectiveType": navigator.connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:rtt": navigator.connection.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        "telemetry:network:downlink": navigator.connection.downlink
    };
};

});

parcelRegister("kXHg1", function(module, exports) {

$parcel$export(module.exports, "appTimings", function () { return $f42adf5ac7f68b0b$export$e952f50a4f2d02da; });

var $6bkHe = parcelRequire("6bkHe");

var $3GjBI = parcelRequire("3GjBI");

var $dxnjK = parcelRequire("dxnjK");

var $47XSr = parcelRequire("47XSr");
function $f42adf5ac7f68b0b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f42adf5ac7f68b0b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f42adf5ac7f68b0b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f42adf5ac7f68b0b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f42adf5ac7f68b0b$export$e952f50a4f2d02da = function appTimings(config, data, globalConfig) {
    var explicitTimings = config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && data.explicitTimings || null;
    var timings = (0, $dxnjK.customTimings)(config, data);
    var ssr = config.type === (0, $3GjBI.BMEventsType).PAGE_LOAD && data.isInitial ? (0, $47XSr.ssrTimings)(config, data, globalConfig) : null;
    var timingsApp = (explicitTimings || timings || ssr) && $f42adf5ac7f68b0b$var$_objectSpread($f42adf5ac7f68b0b$var$_objectSpread($f42adf5ac7f68b0b$var$_objectSpread({}, explicitTimings), timings), ssr);
    if (!timingsApp) return null;
    return {
        "timings:app": timingsApp
    };
};

});
parcelRegister("dxnjK", function(module, exports) {

$parcel$export(module.exports, "customTimings", function () { return $9db071d23450f8d8$export$6126f85083a72c6e; });

var $X0Yhh = parcelRequire("X0Yhh");
var $9db071d23450f8d8$var$retrieveTimings = function retrieveTimings(config, data) {
    var relativeTo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var prefix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
    var configTimings = config.timings || [];
    var timings = configTimings.reduce(function(entries, timing) {
        if (timing.startMark && !data.marks[timing.startMark]) return entries;
        if (timing.endMark && !data.marks[timing.endMark]) return entries;
        if (data.start === null || data.stop === null) return null;
        var startTime = Math.round((data.marks[timing.startMark] !== undefined ? data.marks[timing.startMark] : data.start) - data.start + relativeTo);
        var duration = Math.round((data.marks[timing.endMark] !== undefined ? data.marks[timing.endMark] : data.stop) - data.start - startTime + relativeTo);
        entries["".concat(prefix).concat(timing.key)] = {
            startTime: startTime,
            duration: duration
        };
        return entries;
    }, {});
    return timings;
};
var $9db071d23450f8d8$export$6126f85083a72c6e = function customTimings(config, data) {
    if (!config.timings && data.submetrics.length === 0) return null;
    var timings = $9db071d23450f8d8$var$retrieveTimings(config, data);
    data.submetrics.forEach(function(submetric) {
        if (submetric.start !== null && submetric.stop !== null) {
            var submetricPrefix = "include:".concat(submetric.config.key);
            timings[submetricPrefix] = {
                startTime: Math.round(submetric.start - data.start),
                duration: Math.round(submetric.stop - submetric.start)
            };
            Object.assign(timings, $9db071d23450f8d8$var$retrieveTimings(submetric.config, submetric, submetric.start - data.start, submetricPrefix + (0, $X0Yhh.NESTED_METRIC_SEPARATOR)));
        }
    });
    if (Object.keys(timings).length === 0) return null;
    return timings;
};

});
parcelRegister("X0Yhh", function(module, exports) {

$parcel$export(module.exports, "NESTED_METRIC_SEPARATOR", function () { return $0b1643aac1c9ebdb$export$b98e411ae80c806f; });
var $0b1643aac1c9ebdb$export$b98e411ae80c806f = "/";

});


parcelRegister("47XSr", function(module, exports) {

$parcel$export(module.exports, "ssrTimings", function () { return $3016433789c0aa1c$export$130f411261a599c5; });

var $cd8Dz = parcelRequire("cd8Dz");

var $X0Yhh = parcelRequire("X0Yhh");
var $3016433789c0aa1c$var$filterEntry = function filterEntry(entry) {
    return !(!entry || (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(entry) !== "object" || entry.startTime < 0 || entry.duration < 0);
};
var $3016433789c0aa1c$var$mapEntry = function mapEntry(entry) {
    return {
        startTime: Math.round(entry.startTime),
        duration: Math.round(entry.duration)
    };
};
var $3016433789c0aa1c$var$SSR_PREFIX = "ssr";
var $3016433789c0aa1c$var$mapKey = function mapKey(key) {
    if (key === "total") return $3016433789c0aa1c$var$SSR_PREFIX;
    return "".concat($3016433789c0aa1c$var$SSR_PREFIX).concat((0, $X0Yhh.NESTED_METRIC_SEPARATOR)).concat(key);
};
var $3016433789c0aa1c$export$130f411261a599c5 = function ssrTimings(_config, _data, globalConfig) {
    if (!globalConfig.ssr || !globalConfig.ssr.getTimings) return null;
    var timings = globalConfig.ssr.getTimings();
    if (!timings) return null;
    var ssrTimings = Object.entries(timings).reduce(function(acc, entry) {
        if ($3016433789c0aa1c$var$filterEntry(entry[1])) acc[$3016433789c0aa1c$var$mapKey(entry[0])] = $3016433789c0aa1c$var$mapEntry(entry[1]);
        return acc;
    }, {});
    if (!ssrTimings || Object.keys(ssrTimings).length === 0) return null;
    return ssrTimings;
};

});


parcelRegister("e7t4r", function(module, exports) {

$parcel$export(module.exports, "bundleEvalTimings", function () { return $a47844fa2c3096c4$export$1a2bb347935fc536; });

var $kg5sN = parcelRequire("kg5sN");
var $a47844fa2c3096c4$var$bundleEvalTimingsInternal = function bundleEvalTimingsInternal(_config, data, globalConfig) {
    var _globalConfig$enableB;
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    var started = {};
    var timings = {};
    var enableBundleEvalTimings = (_globalConfig$enableB = globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.enableBundleEvalTimings) !== null && _globalConfig$enableB !== void 0 ? _globalConfig$enableB : true;
    performance.getEntriesByType("mark").forEach(function(mark) {
        if (!globalConfig.bundleEvalTimings) return;
        var result = globalConfig.bundleEvalTimings.mapPerformanceMark(mark.name);
        if (!result) return;
        var type = result.type, name = result.name;
        if (type === "start" && data.start !== null && mark.startTime >= data.start) {
            started[name] = mark;
            return;
        }
        if (type === "end" && started[name]) {
            timings[name] = {
                startTime: Math.round(started[name].startTime - data.start),
                duration: Math.round(mark.startTime - started[name].startTime)
            };
            delete started[name];
        }
    });
    if (globalConfig.bundleEvalTimings && globalConfig.bundleEvalTimings.additionalTimings && data.start !== null && enableBundleEvalTimings) {
        var result = globalConfig.bundleEvalTimings.additionalTimings(data.start);
        if (result) Object.entries(result).forEach(function(_ref) {
            var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
            timings[key] = value;
        });
    }
    if (Object.keys(timings).length === 0) return null;
    return {
        "timings:bundleEval": timings
    };
};
var $a47844fa2c3096c4$export$1a2bb347935fc536 = function bundleEvalTimings() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return new Promise(function(resolve) {
        setTimeout(function() {
            resolve($a47844fa2c3096c4$var$bundleEvalTimingsInternal.apply(void 0, args));
        });
    });
};

});

parcelRegister("i1AZl", function(module, exports) {

$parcel$export(module.exports, "resourceTimings", function () { return $d1f503255d80ddd9$export$81a7d52441a06b50; });

var $6bkHe = parcelRequire("6bkHe");
function $d1f503255d80ddd9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d1f503255d80ddd9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d1f503255d80ddd9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d1f503255d80ddd9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d1f503255d80ddd9$var$cacheableTypes = [
    "script",
    "link"
];
var $d1f503255d80ddd9$var$resourceTypes = [
    "fetch",
    "xmlhttprequest"
];
var $d1f503255d80ddd9$var$CACHE_NETWORK = "network";
var $d1f503255d80ddd9$var$CACHE_MEMORY = "memory";
var $d1f503255d80ddd9$var$CACHE_DISK = "disk";
var $d1f503255d80ddd9$var$calculateTransferType = function calculateTransferType(type, duration, size) {
    if (!$d1f503255d80ddd9$var$cacheableTypes.includes(type)) return $d1f503255d80ddd9$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $d1f503255d80ddd9$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $d1f503255d80ddd9$var$CACHE_DISK;
    if (size === undefined) return null;
    return $d1f503255d80ddd9$var$CACHE_NETWORK;
};
var $d1f503255d80ddd9$var$hasAccessToResourceSize = function hasAccessToResourceSize(url, type, hasTimingHeaders) {
    return !$d1f503255d80ddd9$var$cacheableTypes.includes(type) || url.includes("localhost") || url.includes(window.location.hostname) || hasTimingHeaders(url);
};
var $d1f503255d80ddd9$var$getReportedInitiatorTypes = function getReportedInitiatorTypes(xhrEnabled) {
    if (xhrEnabled) return [
        "script",
        "link",
        "fetch",
        "xmlhttprequest"
    ];
    return [
        "script",
        "link",
        "fetch"
    ];
};
var $d1f503255d80ddd9$var$withoutHeaders = function withoutHeaders() {
    return false;
};
var $d1f503255d80ddd9$var$evaluateAccessToResourceTimings = function evaluateAccessToResourceTimings(entry) {
    if (entry.responseStart === 0 && entry.startTime > entry.responseStart) return false;
    return true;
};
var $d1f503255d80ddd9$var$getEvaluatedTimingHeader = function getEvaluatedTimingHeader(entry) {
    var enabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $d1f503255d80ddd9$var$withoutHeaders;
    if (!enabled) return null;
    var manualResolution = entry.name.includes("localhost") || entry.name.includes(window.location.hostname) || hasTimingHeaders(entry.name);
    var autoResolution = $d1f503255d80ddd9$var$evaluateAccessToResourceTimings(entry);
    return {
        m_h: manualResolution,
        a_h: autoResolution
    };
};
var $d1f503255d80ddd9$var$getSizeObject = function getSizeObject(size) {
    return size !== undefined ? {
        size: size
    } : null;
};
var $d1f503255d80ddd9$var$getNetworkData = function getNetworkData(item, eventStart) {
    var hasTimingHeaders = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $d1f503255d80ddd9$var$withoutHeaders;
    var name = item.name, duration = item.duration, size = item.transferSize, type = item.initiatorType, responseStart = item.responseStart;
    var ttfb = Math.round(responseStart - eventStart);
    if (!$d1f503255d80ddd9$var$hasAccessToResourceSize(name, type, hasTimingHeaders)) return {};
    if ($d1f503255d80ddd9$var$cacheableTypes.includes(type)) {
        var transferType = $d1f503255d80ddd9$var$calculateTransferType(type, duration, size);
        if (!transferType) return $d1f503255d80ddd9$var$_objectSpread({
            ttfb: ttfb
        }, $d1f503255d80ddd9$var$getSizeObject(size));
        if (transferType !== $d1f503255d80ddd9$var$CACHE_NETWORK) return {
            transferType: transferType
        };
        return $d1f503255d80ddd9$var$_objectSpread({
            ttfb: ttfb,
            transferType: transferType
        }, $d1f503255d80ddd9$var$getSizeObject(size));
    }
    return $d1f503255d80ddd9$var$_objectSpread({
        ttfb: ttfb
    }, $d1f503255d80ddd9$var$getSizeObject(size));
};
var $d1f503255d80ddd9$export$81a7d52441a06b50 = function resourceTimings(_config, data, globalConfig) {
    var performance = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : window.performance;
    if (data.start === null) return null;
    var resources = performance.getEntriesByType("resource").filter(function(entry) {
        return entry.startTime >= data.start;
    });
    if (!resources.length) return null;
    var resourceTiming = {};
    var xhrFilter = globalConfig.resourceTimings.xhrFilter;
    var reportedInitiatorTypes = $d1f503255d80ddd9$var$getReportedInitiatorTypes(!!xhrFilter);
    resources.forEach(function(item) {
        if (!reportedInitiatorTypes.includes(item.initiatorType)) return;
        var name = item.name, startTime = item.startTime, duration = item.duration, workerStart = item.workerStart, fetchStart = item.fetchStart, type = item.initiatorType;
        if (!name) return;
        if (type === "xmlhttprequest" && (xhrFilter === undefined || xhrFilter(name) === false)) return;
        var url = $d1f503255d80ddd9$var$resourceTypes.includes(type) ? globalConfig.resourceTimings.sanitiseEndpoints(name) : globalConfig.resourceTimings.mapResources(name);
        if (resourceTiming[url]) return;
        resourceTiming[url] = $d1f503255d80ddd9$var$_objectSpread($d1f503255d80ddd9$var$_objectSpread({
            startTime: Math.round(startTime - data.start),
            duration: Math.round(duration),
            workerStart: Math.max(Math.round(workerStart - data.start), 0),
            fetchStart: Math.max(Math.round(fetchStart - data.start), 0),
            type: type
        }, $d1f503255d80ddd9$var$getNetworkData(item, data.start, globalConfig.resourceTimings.hasTimingHeaders)), $d1f503255d80ddd9$var$getEvaluatedTimingHeader(item, globalConfig.resourceTimings.experimental__reportEvaluatedTimingHeaders, globalConfig.resourceTimings.hasTimingHeaders));
    });
    return {
        "timings:resource": resourceTiming
    };
};

});


parcelRegister("6Uhl4", function(module, exports) {

$parcel$export(module.exports, "makeShareableGlobalConfig", function () { return $50756c323b5a667d$export$5b4fb14409a2a825; });

var $7f5qq = parcelRequire("7f5qq");

var $6bkHe = parcelRequire("6bkHe");

var $cF8Kw = parcelRequire("cF8Kw");

var $5msJs = parcelRequire("5msJs");

var $3GjBI = parcelRequire("3GjBI");
function $50756c323b5a667d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $50756c323b5a667d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $50756c323b5a667d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $50756c323b5a667d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $50756c323b5a667d$var$makeFeatureFlags = function makeFeatureFlags(allFeatureFlags, eventTypeFeatureFlags) {
    var featureFlagsForType = [];
    if (allFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(allFeatureFlags));
    if (eventTypeFeatureFlags) featureFlagsForType.push.apply(featureFlagsForType, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(eventTypeFeatureFlags));
    return featureFlagsForType;
};
var $50756c323b5a667d$var$makeGlobalConfigPerType = function makeGlobalConfigPerType(global, ffClient, allEventsConfig, eventConfig) {
    var _ref, _eventConfig$pageVisi;
    var allEventsConfigCustom = allEventsConfig && allEventsConfig.custom;
    var eventConfigCustom = eventConfig && eventConfig.custom;
    var custom = (allEventsConfigCustom || eventConfigCustom) && $50756c323b5a667d$var$_objectSpread($50756c323b5a667d$var$_objectSpread({}, allEventsConfigCustom), eventConfigCustom) || undefined;
    var allEventsConfigPlugins = allEventsConfig && allEventsConfig.plugins;
    var eventConfigPlugins = eventConfig && eventConfig.plugins;
    var plugins = (allEventsConfigPlugins || eventConfigPlugins) && [].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(allEventsConfigPlugins || []), (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(eventConfigPlugins || [])) || undefined;
    var pageVisibleValueOrigin = (_ref = (_eventConfig$pageVisi = eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.pageVisibleValueOrigin) !== null && _eventConfig$pageVisi !== void 0 ? _eventConfig$pageVisi : allEventsConfig === null || allEventsConfig === void 0 ? void 0 : allEventsConfig.pageVisibleValueOrigin) !== null && _ref !== void 0 ? _ref : (0, $3GjBI.PageVisibleValueOrigin).documentHidden;
    return Object.freeze($50756c323b5a667d$var$_objectSpread($50756c323b5a667d$var$_objectSpread({}, global), {}, {
        featureFlags: Object.freeze($50756c323b5a667d$var$makeFeatureFlags(allEventsConfig && allEventsConfig.featureFlags, eventConfig && eventConfig.featureFlags).reduce(function(acc, value) {
            acc[value] = ffClient.getValue(value);
            return acc;
        }, {})),
        custom: custom,
        plugins: plugins,
        histogram: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.histogram,
        pageVisibleValueOrigin: pageVisibleValueOrigin,
        enableBundleEvalTimings: eventConfig === null || eventConfig === void 0 ? void 0 : eventConfig.enableBundleEvalTimings
    }));
};
var $50756c323b5a667d$export$5b4fb14409a2a825 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(globalConfig) {
        var _globalConfig$events$, _globalConfig$events$2, _globalConfig$events$3, _ref3;
        var ffClient, global;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    _context.next = 2;
                    return globalConfig.plugins.featureFlags.client;
                case 2:
                    ffClient = _context.sent;
                    global = {
                        app: globalConfig.info.app,
                        product: globalConfig.info.product,
                        region: globalConfig.info.region,
                        resourceTimings: globalConfig.plugins.resourceTimings,
                        bundleEvalTimings: globalConfig.plugins.bundleEvalTimings,
                        ffClient: ffClient,
                        hostname: globalConfig.info.hostname || window.location.hostname,
                        ssr: globalConfig.ssr,
                        enableReactUFOTracker: globalConfig.enableReactUFOTracker,
                        webVitals: {
                            enabled: (_globalConfig$events$ = globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$ === void 0 ? void 0 : _globalConfig$events$.enabled,
                            timeout: (_globalConfig$events$2 = globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$2 === void 0 ? void 0 : _globalConfig$events$2.timeout,
                            ttciEnabled: (_globalConfig$events$3 = globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS]) === null || _globalConfig$events$3 === void 0 ? void 0 : _globalConfig$events$3.ttciEnabled
                        }
                    };
                    return _context.abrupt("return", (_ref3 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref3, (0, $3GjBI.BMEventsType).PAGE_LOAD, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).PAGE_LOAD])), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref3, (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD])), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref3, (0, $3GjBI.BMEventsType).INLINE_RESULT, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).INLINE_RESULT])), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref3, (0, $3GjBI.BMEventsType).CUSTOM, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).CUSTOM])), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref3, (0, $3GjBI.BMEventsType).WEB_VITALS, $50756c323b5a667d$var$makeGlobalConfigPerType(global, ffClient, globalConfig.events.all, globalConfig.events[(0, $3GjBI.BMEventsType).WEB_VITALS])), _ref3));
                case 5:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function makeShareableGlobalConfig(_x) {
        return _ref2.apply(this, arguments);
    };
}();

});




parcelRegister("2xiyk", function(module, exports) {

$parcel$export(module.exports, "startBrowserMetrics", function () { return $a958aca08a0edc84$export$7cf313435eb9a801; });

var $7HBoF = parcelRequire("7HBoF");

var $3GjBI = parcelRequire("3GjBI");

var $8ZuGG = parcelRequire("8ZuGG");

var $lk8Tl = parcelRequire("lk8Tl");
parcelRequire("7C0Dg");
var $c48Nq = parcelRequire("c48Nq");
const $a958aca08a0edc84$export$7cf313435eb9a801 = (analyticsClient)=>{
    var _50797;
    const info = {
        app: {
            version: {
                web: (_50797 = "5.0.797") !== null && _50797 !== void 0 ? _50797 : "no-version"
            },
            framework: {
                name: "react",
                version: $8ZuGG.version
            }
        },
        product: "identity",
        // Region is used for "Split by" in Perf Portal.
        region: "unknown"
    };
    const endpoints = {
        eventPipelineClient: Promise.resolve(analyticsClient.getInstance())
    };
    const events = {
        [(0, $3GjBI.BMEventsType).WEB_VITALS]: {
            enabled: true
        }
    };
    const plugins = {
        featureFlags: {
            client: Promise.resolve({
                getValue: (flag)=>(0, $c48Nq.isBooleanFeatureFlagSet)(flag, false)
            })
        },
        resourceTimings: {
            /**
       * Browser Metrics track all the network calls and add them automatically to the performance events.
       * To ensure we're not recording any UGC / PII, we need to provide a sanitise method.
       */ sanitiseEndpoints: (url)=>{
                // Remove sensitive PII data (i.e. all URL params)
                return url.split("?")[0];
            },
            /**
       * Takes a URL and removes hashes, cache busting parameters, versioning, and other unique identifiers specific to the build of the app.
       * This is so that URLs that exist as a part of a browser metrics payload will not be deemed unique due to having different hashes.
       *
       * * For example, when `url` is:
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.449/static/js/login.28848bff.chunk.js`
       * - `https://aid-frontend.prod.atl-paas.net/atlassian-id/front-end/5.0.450/static/js/login.66eb7699.chunk.js`
       *
       * Then both of the above should be cleaned to `login.js`, which will be treated as the same URL for reporting purposes.
       */ mapResources: (url)=>{
                // url = https://aid-frontend.prod.atl-paas.net/.../static/js/login.28848bff.chunk.js
                if (!url.includes("aid-frontend")) // This is an external URL where we can't gurantee the URL structure, therefore cannot do any mapping.
                return url;
                var _url_split_pop;
                // hashedFileName = login.28848bff.chunk.js
                const hashedFileName = (_url_split_pop = url.split("/").pop()) !== null && _url_split_pop !== void 0 ? _url_split_pop : "unknown";
                const parts = hashedFileName.split(".");
                const ext = parts.length > 1 ? parts.pop() : "unknown";
                // Returning login.js
                return `${parts[0]}.${ext}`;
            },
            // If url supports TimingAllowOrigin header, then BM calculates cache status of static resources:
            hasTimingHeaders: ()=>false
        }
    };
    (0, $7HBoF.browserMetrics).init({
        info: info,
        endpoints: endpoints,
        plugins: plugins,
        events: events,
        debug: (0, $lk8Tl.currentEnvType) !== "prod"
    });
    (0, $7HBoF.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("7C0Dg", function(module, exports) {
$parcel$export(module.exports, "getFfsId", function () { return (parcelRequire("c48Nq")).getFfsId; });
$parcel$export(module.exports, "initializeFeatureFlagClient", function () { return (parcelRequire("c48Nq")).initializeFeatureFlagClient; });
$parcel$export(module.exports, "isBooleanFeatureFlagSet", function () { return (parcelRequire("c48Nq")).isBooleanFeatureFlagSet; });
parcelRequire("c48Nq");

});
parcelRegister("c48Nq", function(module, exports) {

$parcel$export(module.exports, "getFfsId", function () { return $8a643d22619fea4d$export$3b0e089e98b45efa; });
$parcel$export(module.exports, "initializeFeatureFlagClient", function () { return $8a643d22619fea4d$export$50f848dc68dcc216; });
$parcel$export(module.exports, "isBooleanFeatureFlagSet", function () { return $8a643d22619fea4d$export$7cdd1752e02827a9; });

var $7kAbE = parcelRequire("7kAbE");
var $2sWVC = parcelRequire("2sWVC");

var $8USlx = parcelRequire("8USlx");

var $lk8Tl = parcelRequire("lk8Tl");
const $8a643d22619fea4d$var$FFS_ID_KEY = "atlassian.account.ffs.id";
function $8a643d22619fea4d$export$3b0e089e98b45efa() {
    const ffsId = (0, (/*@__PURE__*/$parcel$interopDefault($8USlx))).get($8a643d22619fea4d$var$FFS_ID_KEY);
    return ffsId && ffsId.replace(/(^")|("$)/g, "");
}
const $8a643d22619fea4d$var$FF_ENV_MAP = {
    unknown: (0, $2sWVC.EnvironmentType).LOCAL,
    dev: (0, $2sWVC.EnvironmentType).DEV,
    staging: (0, $2sWVC.EnvironmentType).STAGING,
    prod: (0, $2sWVC.EnvironmentType).PROD
};
// Corresponding Launch Darkly Instance: https://app.launchdarkly.com/identity/production/features
// API keys are found at https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
const $8a643d22619fea4d$var$LD_API_KEYS = {
    commercial: {
        [(0, $2sWVC.EnvironmentType).LOCAL]: "e91005d2-b812-461e-b15d-d564d1006cf2",
        [(0, $2sWVC.EnvironmentType).DEV]: "e91005d2-b812-461e-b15d-d564d1006cf2",
        [(0, $2sWVC.EnvironmentType).STAGING]: "c1b4f462-6a1b-4805-9b2a-3ebd77b6d0ac",
        [(0, $2sWVC.EnvironmentType).PROD]: "41ebe9bd-4502-4a8d-b018-9de8cd0aabc7"
    },
    "fedramp-moderate": {
        [(0, $2sWVC.EnvironmentType).LOCAL]: "7c485929-ab26-4fa3-bdf9-5d4e0aea9496",
        [(0, $2sWVC.EnvironmentType).DEV]: "7c485929-ab26-4fa3-bdf9-5d4e0aea9496",
        [(0, $2sWVC.EnvironmentType).STAGING]: "7c485929-ab26-4fa3-bdf9-5d4e0aea9496",
        [(0, $2sWVC.EnvironmentType).PROD]: "977f05ed-a0cf-46db-8e04-996d257f9fab"
    }
};
let $8a643d22619fea4d$var$ffClient;
const $8a643d22619fea4d$export$f0810b170d76b1c1 = $8a643d22619fea4d$var$FF_ENV_MAP[0, $lk8Tl.currentEnvType];
const $8a643d22619fea4d$export$9d37dcd3c36573d5 = $8a643d22619fea4d$var$LD_API_KEYS[0, $lk8Tl.currentPerimeter][$8a643d22619fea4d$export$f0810b170d76b1c1];
const $8a643d22619fea4d$export$50f848dc68dcc216 = (analyticsClient)=>{
    if (!$8a643d22619fea4d$var$ffClient) {
        const options = {
            productKey: "identity",
            environment: $8a643d22619fea4d$export$f0810b170d76b1c1,
            ...(0, $lk8Tl.currentPerimeter) === "fedramp-moderate" && {
                // perimeter should be undefined for commercial env
                perimeter: (0, $2sWVC.PerimeterType).FEDRAMP_MODERATE
            }
        };
        const user = {
            isAnonymous: true
        };
        const ffsId = $8a643d22619fea4d$export$3b0e089e98b45efa();
        if (ffsId) user.identifier = {
            type: (0, $2sWVC.Identifiers).FF_CLIENT_ANONYMOUS_ID,
            value: ffsId
        };
        $8a643d22619fea4d$var$ffClient = new (0, $7kAbE.default)($8a643d22619fea4d$export$9d37dcd3c36573d5, analyticsClient.client, user, options);
    }
    return $8a643d22619fea4d$var$ffClient;
};
const $8a643d22619fea4d$var$defaultValues = {
    "identity.aid_signup.apple.auth.enabled": true,
    "identity.aid_signup.microsoft.auth.enabled": true,
    "identity.aid-frontend.apple.login.outage.advisory.enabled": false,
    "identity.aid-frontend.google.login.outage.advisory.enabled": false,
    "identity.aid-frontend.google.one.tap.enabled": false,
    "identity.aid-frontend.microsoft.login.outage.advisory.enabled": false,
    "identity.aid-frontend.slack.login.outage.advisory.enabled": false,
    "identity.id-authentication.sms-enrollment-new-captcha.enabled": false,
    "identity.sign-in-service.check-username.recaptcha.enabled": false,
    "identity.sign-in-with-slack.enabled": false
};
const $8a643d22619fea4d$export$7cdd1752e02827a9 = (flagKey, shouldSendExposureEvent = true)=>{
    var _window_featureFlagOverrides;
    /**
   * window.featureFlagOverrides are used by Storybook and for quicker local-dev loop
   * as it skips @atlassiansox/feature-flag-web-client and LD client's caching.
   */ const overide = (_window_featureFlagOverrides = window.featureFlagOverrides) === null || _window_featureFlagOverrides === void 0 ? void 0 : _window_featureFlagOverrides[flagKey];
    if (typeof overide === "boolean") return overide;
    const defaultValue = $8a643d22619fea4d$var$defaultValues[flagKey];
    if (!$8a643d22619fea4d$var$ffClient) return defaultValue;
    return $8a643d22619fea4d$var$ffClient.getFlagValue(flagKey, defaultValue, {
        shouldSendExposureEvent: shouldSendExposureEvent
    });
};

});
parcelRegister("7kAbE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $556678a1537bf8bd$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $i0pbJ = parcelRequire("i0pbJ");
var $556678a1537bf8bd$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function FeatureFlagClient(apiKey, analyticsWebClient, featureFlagUser, options) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, FeatureFlagClient);
        this.client = new (0, $i0pbJ.default)(apiKey, analyticsWebClient, featureFlagUser, options);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(FeatureFlagClient, [
        {
            key: "ready",
            value: function ready() {
                return this.client.ready();
            }
        },
        {
            key: "setAutomaticExposuresEnabled",
            value: function setAutomaticExposuresEnabled(enabled, predicate) {
                this.client.setAutomaticExposuresEnabled(enabled, predicate);
            }
        },
        {
            key: "getFlagValue",
            value: function getFlagValue(flagKey, defaultValue, options) {
                return this.client.getFlagValue(flagKey, defaultValue, options);
            }
        },
        {
            key: "getFlagDetails",
            value: function getFlagDetails(flagKey, defaultValue, options) {
                return this.client.getFlagDetails(flagKey, defaultValue, options);
            }
        },
        {
            key: "getFlags",
            value: function getFlags() {
                return this.client.getFlags();
            }
        },
        {
            key: "on",
            value: function on(flagKey, defaultValue, callback, options) {
                return this.client.on(flagKey, defaultValue, callback, options);
            }
        },
        {
            key: "onAnyFlagUpdated",
            value: function onAnyFlagUpdated(callback) {
                return this.client.onAnyFlagUpdated(callback);
            }
        },
        {
            key: "updateFeatureFlagUser",
            value: function updateFeatureFlagUser(featureFlagUser) {
                return this.client.updateFeatureFlagUser(featureFlagUser);
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.client.destroy();
            }
        }
    ]);
    return FeatureFlagClient;
}();

});
parcelRegister("i0pbJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1bbc3f371c7e37e$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $ip4mj = parcelRequire("ip4mj");

var $2sWVC = parcelRequire("2sWVC");

var $2u6Nc = parcelRequire("2u6Nc");

var $iJA0o = parcelRequire("iJA0o");

var $8igLI = parcelRequire("8igLI");

var $8aAEs = parcelRequire("8aAEs");
var $5FFZZ = parcelRequire("5FFZZ");

var $jjo0J = parcelRequire("jjo0J");

var $j2ILk = parcelRequire("j2ILk");

var $gOk8y = parcelRequire("gOk8y");

var $kTkzm = parcelRequire("kTkzm");

var $dDO62 = parcelRequire("dDO62");
var $d1bbc3f371c7e37e$export$eb7ed84def39a430 = 10000;
var $d1bbc3f371c7e37e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Client(apiKey, analyticsWebClient, originalFeatureFlagUser, options) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Client);
        // Should be done ASAP to prevent calls to console before usage
        (0, $iJA0o.default)(options === null || options === void 0 ? void 0 : options.loggerOptions);
        (0, $dDO62.validateConstructorArgs)(apiKey, analyticsWebClient, originalFeatureFlagUser, options);
        var featureFlagUser = (0, $jjo0J.default)(originalFeatureFlagUser);
        var user = (0, $j2ILk.default).processAnonymousUser(featureFlagUser);
        this.featureFlagUpdateBroadcastHandler = this.featureFlagUpdateBroadcastHandler.bind(this);
        this.featureFlagUpdateHttpHandler = this.featureFlagUpdateHttpHandler.bind(this);
        this.featureFlagUpdateFailedHandler = this.featureFlagUpdateFailedHandler.bind(this);
        this.readyResolver = new (0, $gOk8y.default)({
            readyTimeoutInMilliseconds: options.readyTimeoutInMilliseconds
        });
        this.exposureEvents = new (0, $2u6Nc.default)(analyticsWebClient);
        this.storage = new (0, $8igLI.default)(options.environment, options.productKey, apiKey, user);
        this.broadcast = new (0, $8aAEs.default)(apiKey, user, this.featureFlagUpdateBroadcastHandler);
        this.restoreFlagStateFromStorage();
        this.userData = user;
        this.refresh = new (0, $kTkzm.default)(apiKey, options.environment, this.userData, this.featureFlagUpdateHttpHandler, {
            interval: options.pollingInterval
        }, this.dataVersion, this.lastUpdatedTimestamp, this.featureFlagUpdateFailedHandler, {}, options.useGatewayURL, options.perimeter);
        this.refresh.start();
        this.subscriptions = new (0, $5FFZZ.default)();
        // Dont run on startup to prevent slowdown
        setTimeout(function() {
            return _this.storage.purgeStaleFlagState();
        }, $d1bbc3f371c7e37e$export$eb7ed84def39a430);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Client, [
        {
            key: "ready",
            value: function ready() {
                return this.readyResolver.getPromise();
            }
        },
        {
            key: "getFlagValue",
            value: function getFlagValue(flagKey, defaultValue, options) {
                var validatedFlag = this.getFlagDetails(flagKey, defaultValue, options);
                return validatedFlag.value;
            }
        },
        {
            key: "getFlagDetails",
            value: function getFlagDetails(flagKey, defaultValue, options) {
                (0, $dDO62.validateDefaultValue)(defaultValue);
                var flag = this.flags[flagKey];
                var validatedFlag = (0, $dDO62.validateFlag)(flag, defaultValue, this.refresh.getStatus(), options);
                var shouldSendExposureEvent = (options === null || options === void 0 ? void 0 : options.shouldSendExposureEvent) !== false && !this.shouldIgnoreExposureForMissingFlag(flagKey, validatedFlag);
                if (shouldSendExposureEvent) {
                    // If the shouldSendExposureEvent is not defined at all, we may fire an automatic event.
                    var isExplicitlyRequested = (options === null || options === void 0 ? void 0 : options.shouldSendExposureEvent) === true;
                    this.exposureEvents.sendExposureEvent(flagKey, validatedFlag, isExplicitlyRequested, options === null || options === void 0 ? void 0 : options.exposureData);
                }
                return validatedFlag;
            }
        },
        {
            key: "shouldIgnoreExposureForMissingFlag",
            value: function shouldIgnoreExposureForMissingFlag(flagKey, validatedFlag) {
                var _validatedFlag$evalua;
                if (((_validatedFlag$evalua = validatedFlag.evaluationDetail) === null || _validatedFlag$evalua === void 0 ? void 0 : _validatedFlag$evalua.errorKind) !== (0, $2sWVC.EvaluationErrorKind).FLAG_NOT_FOUND) return false;
                if (!flagKey.startsWith("platform.")) return false;
                return true;
            }
        },
        {
            key: "getFlags",
            value: function getFlags() {
                return (0, $jjo0J.default)(this.flags);
            }
        },
        {
            key: "on",
            value: function on(flagKey, defaultValue, callback, options) {
                (0, $dDO62.validateDefaultValue)(defaultValue);
                return this.subscriptions.on(flagKey, defaultValue, callback, this.getFlagValue.bind(this), options);
            }
        },
        {
            key: "onAnyFlagUpdated",
            value: function onAnyFlagUpdated(callback) {
                return this.subscriptions.onAnyFlagUpdated(callback);
            }
        },
        {
            key: "updateFeatureFlagUser",
            value: function updateFeatureFlagUser(originalFeatureFlagUser) {
                if (!originalFeatureFlagUser) throw new Error("featureFlagUser is missing");
                var featureFlagUser = (0, $jjo0J.default)(originalFeatureFlagUser);
                var user = (0, $j2ILk.default).processAnonymousUser(featureFlagUser);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(this.userData) === (0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(user)) return this.ready();
                this.readyResolver.reset();
                this.userData = user;
                this.storage.updateUserContext(user);
                var storedData = this.storage.getFlagsState();
                if (storedData) {
                    var changedFlagKeys = this.updateInMemoryFlags((0, $dDO62.flagStateToFlagUpdate)(this.flags, storedData));
                    this.sendSubscriptionUpdates(changedFlagKeys);
                    this.readyResolver.triggerReady((0, $gOk8y.READY_CACHE));
                }
                this.lastUpdatedTimestamp = (storedData === null || storedData === void 0 ? void 0 : storedData.timestamp) || 0;
                this.dataVersion = storedData === null || storedData === void 0 ? void 0 : storedData.version;
                this.refresh.stop();
                this.refresh.updateUserContext(user, this.dataVersion, this.lastUpdatedTimestamp);
                this.refresh.start();
                this.broadcast.updateUserContext(user);
                return this.ready();
            }
        },
        {
            key: "addFlag",
            value: function addFlag(flagKey, flag) {
                this.flags[flagKey] = flag;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.refresh.stop();
                this.subscriptions.stop();
                this.broadcast.stop();
                this.readyResolver.triggerReady({
                    reason: (0, $2sWVC.ReadyReason).CLIENT_ERROR,
                    message: "Client got destroyed."
                });
            }
        },
        {
            key: "setAutomaticExposuresEnabled",
            value: function setAutomaticExposuresEnabled(enabled, predicate) {
                this.exposureEvents.setAutomaticExposuresEnabled(enabled, predicate);
            }
        },
        {
            key: "restoreFlagStateFromStorage",
            value: function restoreFlagStateFromStorage() {
                var storedData = this.storage.getFlagsState();
                this.flags = (storedData === null || storedData === void 0 ? void 0 : storedData.flags) || {};
                this.lastUpdatedTimestamp = (storedData === null || storedData === void 0 ? void 0 : storedData.timestamp) || 0;
                this.dataVersion = storedData === null || storedData === void 0 ? void 0 : storedData.version;
                if (storedData !== null && storedData !== undefined) this.readyResolver.triggerReady((0, $gOk8y.READY_CACHE));
                else {
                    // Attempt to recover old flags
                    var oldFlagState = this.storage.getFlagsFromOldState();
                    if (oldFlagState) {
                        // Do not update lastUpdatedTimestamp or dataVersion
                        // to force refresh to run immediately without the cache
                        this.flags = oldFlagState.flags;
                        this.readyResolver.triggerReady((0, $gOk8y.READY_CACHE));
                    }
                }
            }
        },
        {
            key: "getCurrentFeatureFlagState",
            value: function getCurrentFeatureFlagState() {
                return {
                    timestamp: this.lastUpdatedTimestamp,
                    version: this.dataVersion,
                    flags: this.flags
                };
            }
        },
        {
            key: "featureFlagUpdateFailedHandler",
            value: function featureFlagUpdateFailedHandler(statusCode, rawBody) {
                this.readyResolver.triggerReady({
                    reason: (0, $dDO62.getReasonForStatusCode)(statusCode),
                    message: (0, $dDO62.getReadyMessageForStatusCode)(statusCode),
                    serverResponse: rawBody
                });
            }
        },
        {
            key: "featureFlagUpdateHttpHandler",
            value: function featureFlagUpdateHttpHandler(update) {
                if (this.dataVersion) this.processFeatureFlagUpdate(update);
                else // If dataVersion is undefined, then the request had no versionData.
                // This would mean that the API cannot tell us what flags to delete,
                // and has just given us every flag available at its latest state.
                // We should replace all flags instead of merging the flags.
                this.processFeatureFlagUpdate((0, $dDO62.flagStateToFlagUpdate)(this.flags, update));
                // broadcast the flag state to other tabs
                this.broadcast.sendFeatureFlagState(this.getCurrentFeatureFlagState());
            }
        },
        {
            key: "featureFlagUpdateBroadcastHandler",
            value: function featureFlagUpdateBroadcastHandler(featureFlagState) {
                // return if broadcasted ff state is stale
                if (featureFlagState.timestamp < this.lastUpdatedTimestamp) return;
                this.processFeatureFlagUpdate((0, $dDO62.flagStateToFlagUpdate)(this.flags, featureFlagState));
            }
        },
        {
            key: "processFeatureFlagUpdate",
            value: function processFeatureFlagUpdate(update) {
                this.lastUpdatedTimestamp = Date.now();
                this.dataVersion = update.versionData || this.dataVersion;
                var changedFlagKeys = this.updateInMemoryFlags(update);
                this.sendSubscriptionUpdates(changedFlagKeys);
                this.refresh.setVersionAndTimestamp(this.dataVersion, this.lastUpdatedTimestamp);
                this.storage.setFlagsState(this.getCurrentFeatureFlagState());
                this.readyResolver.triggerReady((0, $gOk8y.READY_FETCH));
            }
        },
        {
            key: "updateInMemoryFlags",
            value: function updateInMemoryFlags(update) {
                var _update$deletedFlags, _this2 = this;
                var changedFlags = [];
                (_update$deletedFlags = update.deletedFlags) === null || _update$deletedFlags === void 0 || _update$deletedFlags.forEach(function(flagKey) {
                    if (flagKey in _this2.flags) {
                        delete _this2.flags[flagKey];
                        changedFlags.push(flagKey);
                    }
                });
                Object.keys(update.flags).forEach(function(flagKey) {
                    if ((0, $dDO62.hasFlagValueChanged)(_this2.flags[flagKey], update.flags[flagKey])) changedFlags.push(flagKey);
                    _this2.flags[flagKey] = update.flags[flagKey];
                });
                return changedFlags;
            }
        },
        {
            key: "sendSubscriptionUpdates",
            value: function sendSubscriptionUpdates(changedFlagKeys) {
                var _this3 = this;
                if (changedFlagKeys.length > 0) {
                    this.subscriptions.anyFlagUpdated();
                    changedFlagKeys.forEach(function(flagKey) {
                        return _this3.subscriptions.flagValueUpdated(flagKey);
                    });
                }
            }
        }
    ]);
    return Client;
}();

});
parcelRegister("ip4mj", function(module, exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

});

parcelRegister("2sWVC", function(module, exports) {

$parcel$export(module.exports, "Identifiers", function () { return $1cbbe83a65f4f864$export$9c27ea27f5856c02; });
$parcel$export(module.exports, "EvaluationReason", function () { return $1cbbe83a65f4f864$export$c62558b199e46828; });
$parcel$export(module.exports, "EvaluationErrorKind", function () { return $1cbbe83a65f4f864$export$d7bcec3eec83269a; });
$parcel$export(module.exports, "ExposureType", function () { return $1cbbe83a65f4f864$export$5cea6b86291cee7a; });
$parcel$export(module.exports, "EnvironmentType", function () { return $1cbbe83a65f4f864$export$76c40c36845e9385; });
$parcel$export(module.exports, "PerimeterType", function () { return $1cbbe83a65f4f864$export$c42b7bbc5e7ba555; });
$parcel$export(module.exports, "ReadyReason", function () { return $1cbbe83a65f4f864$export$efeb3009918d958; });
$parcel$export(module.exports, "LogLevel", function () { return $1cbbe83a65f4f864$export$243e62d78d3b544d; });
var $1cbbe83a65f4f864$export$9c27ea27f5856c02 = /*#__PURE__*/ function(Identifiers) {
    Identifiers["ANALYTICS_ANONYMOUS_ID"] = "analyticsAnonymousId";
    Identifiers["ATLASSIAN_ACCOUNT_ID"] = "atlassianAccountId";
    Identifiers["ATLASSIAN_ORG_ID"] = "atlassianOrgId";
    Identifiers["TENANT_ID"] = "tenantId";
    Identifiers["TRELLO_ANONYMOUS_ID"] = "trelloAnonymousId";
    Identifiers["TRELLO_USER_ID"] = "trelloUserId";
    Identifiers["FF_CLIENT_ANONYMOUS_ID"] = "ffClientAnonymousId";
    return Identifiers;
}({});
var $1cbbe83a65f4f864$export$c62558b199e46828 = /*#__PURE__*/ function(EvaluationReason) {
    EvaluationReason["OFF"] = "OFF";
    EvaluationReason["FALLTHROUGH"] = "FALLTHROUGH";
    EvaluationReason["RULE_MATCH"] = "RULE_MATCH";
    EvaluationReason["TARGET_MATCH"] = "TARGET_MATCH";
    EvaluationReason["PREREQUISITE_FAILED"] = "PREREQUISITE_FAILED";
    EvaluationReason["ERROR"] = "ERROR";
    EvaluationReason["INELIGIBLE"] = "INELIGIBLE";
    EvaluationReason["OVERRIDE"] = "OVERRIDE";
    return EvaluationReason;
}({});
var $1cbbe83a65f4f864$export$d7bcec3eec83269a = /*#__PURE__*/ function(EvaluationErrorKind) {
    EvaluationErrorKind["CLIENT_NOT_READY"] = "CLIENT_NOT_READY";
    EvaluationErrorKind["FLAG_NOT_FOUND"] = "FLAG_NOT_FOUND";
    EvaluationErrorKind["WRONG_TYPE"] = "WRONG_TYPE";
    EvaluationErrorKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    EvaluationErrorKind["SERVER_ERROR"] = "SERVER_ERROR";
    EvaluationErrorKind["OTHER"] = "OTHER";
    return EvaluationErrorKind;
}({});
var $1cbbe83a65f4f864$export$5cea6b86291cee7a = /*#__PURE__*/ function(ExposureType) {
    ExposureType["OptIn"] = "optInExposure";
    ExposureType["Automatic"] = "autoExposure";
    ExposureType["HasCustomAttributes"] = "hasCustomAttributes";
    return ExposureType;
}({});
var $1cbbe83a65f4f864$export$76c40c36845e9385 = /*#__PURE__*/ function(EnvironmentType) {
    EnvironmentType["LOCAL"] = "local";
    EnvironmentType["DEV"] = "dev";
    EnvironmentType["STAGING"] = "staging";
    EnvironmentType["PROD"] = "prod";
    return EnvironmentType;
}({});
var $1cbbe83a65f4f864$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $1cbbe83a65f4f864$export$efeb3009918d958 = /*#__PURE__*/ function(ReadyReason) {
    ReadyReason["CACHE"] = "CACHE";
    ReadyReason["FETCH"] = "FETCH";
    ReadyReason["CLIENT_ERROR"] = "CLIENT_ERROR";
    ReadyReason["SERVER_ERROR"] = "SERVER_ERROR";
    return ReadyReason;
}({});
var $1cbbe83a65f4f864$export$243e62d78d3b544d = /*#__PURE__*/ function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["LOG"] = 3] = "LOG";
    LogLevel[LogLevel["WARN"] = 4] = "WARN";
    LogLevel[LogLevel["ERROR"] = 5] = "ERROR";
    return LogLevel;
}({});

});

parcelRegister("2u6Nc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cf3a6f330e55c52$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $2sWVC = parcelRequire("2sWVC");

var $12mDE = parcelRequire("12mDE");
function $1cf3a6f330e55c52$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cf3a6f330e55c52$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cf3a6f330e55c52$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cf3a6f330e55c52$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1cf3a6f330e55c52$export$82541edf19e5e3b0 = 3600000;
var $1cf3a6f330e55c52$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function ExposureEvents(analyticsWebClient) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ExposureEvents);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "spamBuster", {});
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "automaticExposuresEnabled", false);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "automaticExposuresPredicate", function() {
            return true;
        });
        this.analyticsWebClient = analyticsWebClient;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ExposureEvents, [
        {
            key: "sendExposureEvent",
            value: function sendExposureEvent(flagKey, validatedFlag, isExplicitlyRequested, exposureData) {
                var evaluationDetail = validatedFlag.evaluationDetail, _validatedFlag$tracki = validatedFlag.trackingInfo, trackingInfo = _validatedFlag$tracki === void 0 ? {
                    samplingRate: 0
                } : _validatedFlag$tracki;
                // Only attach custom exposure data to opt-in exposure events.
                // This is done because the compression and storage for automatic exposure events do not currently
                // support custom attributes. By intentionally excluding them, we ensure that we are not collecting
                // data that will eventually be dropped further in the pipeline.
                // See https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1316354396/RFC-002+Automatic+exposure+event+collection+in+the+Fx3+web+client for more information.
                var customAttributes = isExplicitlyRequested ? exposureData : {};
                var hasCustomAttributes = customAttributes ? Object.keys(customAttributes).length > 0 : false;
                var exposureAttributes = {
                    flagKey: flagKey,
                    value: validatedFlag.value,
                    reason: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.reason,
                    ruleId: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.ruleId,
                    errorKind: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.errorKind
                };
                var allAttributes = $1cf3a6f330e55c52$var$_objectSpread($1cf3a6f330e55c52$var$_objectSpread({}, customAttributes), exposureAttributes);
                var shouldSendExposureEvent = this.shouldSendExposureEvent(allAttributes, trackingInfo, isExplicitlyRequested);
                if (shouldSendExposureEvent) {
                    var actionSubject = "feature";
                    var action = "exposed";
                    var source = "@atlassiansox/feature-flag-web-client";
                    var highPriority = isExplicitlyRequested;
                    this.analyticsWebClient.sendOperationalEvent({
                        actionSubject: actionSubject,
                        action: action,
                        attributes: exposureAttributes,
                        tags: [
                            "measurement",
                            isExplicitlyRequested ? (0, $2sWVC.ExposureType).OptIn : (0, $2sWVC.ExposureType).Automatic
                        ],
                        source: source,
                        highPriority: highPriority
                    });
                    // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
                    // events. In order not to break existing users of this feature immediately, we're sending an
                    // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
                    // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
                    if (hasCustomAttributes) this.analyticsWebClient.sendOperationalEvent({
                        actionSubject: actionSubject,
                        action: action,
                        attributes: allAttributes,
                        tags: [
                            "measurement",
                            (0, $2sWVC.ExposureType).OptIn,
                            (0, $2sWVC.ExposureType).HasCustomAttributes
                        ],
                        source: source,
                        highPriority: highPriority
                    });
                    this.markExposureAsTracked(exposureAttributes);
                }
            }
        },
        {
            key: "shouldSendExposureEvent",
            value: function shouldSendExposureEvent(exposureAttributes, trackingInfo, isExplicitlyRequested) {
                if (this.hasAlreadyTrackedExposure(exposureAttributes)) return false;
                if (isExplicitlyRequested) return true;
                var samplingRate = trackingInfo.samplingRate;
                var shouldSendAutomaticEvent = this.automaticExposuresEnabled && samplingRate === 1 && this.automaticExposuresPredicate(exposureAttributes);
                return shouldSendAutomaticEvent;
            }
        },
        {
            key: "hasAlreadyTrackedExposure",
            value: function hasAlreadyTrackedExposure(attributes) {
                var encode = (0, $12mDE.encodeObject)(attributes);
                if (this.spamBuster[encode] === undefined || this.spamBuster[encode] + $1cf3a6f330e55c52$export$82541edf19e5e3b0 < Date.now()) return false;
                return true;
            }
        },
        {
            key: "markExposureAsTracked",
            value: function markExposureAsTracked(attributes) {
                var encode = (0, $12mDE.encodeObject)(attributes);
                this.spamBuster[encode] = Date.now();
            }
        },
        {
            key: "setAutomaticExposuresEnabled",
            value: function setAutomaticExposuresEnabled(enabled) {
                var predicate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function() {
                    return true;
                };
                this.automaticExposuresEnabled = enabled;
                this.automaticExposuresPredicate = predicate;
            }
        }
    ]);
    return ExposureEvents;
}();

});
parcelRegister("12mDE", function(module, exports) {

$parcel$export(module.exports, "encodeObject", function () { return $0c1789e730c2b823$export$c57605e441fcb142; });

var $ip4mj = parcelRequire("ip4mj");
function $0c1789e730c2b823$export$c57605e441fcb142(obj) {
    return btoa((0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(obj));
}

});


parcelRegister("iJA0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da385be2f9de837f$export$2e2bcd8739ae039; });

var $8sfRz = parcelRequire("8sfRz");
var $da385be2f9de837f$var$logger;
var $da385be2f9de837f$export$2e2bcd8739ae039 = function(options) {
    if (!$da385be2f9de837f$var$logger) $da385be2f9de837f$var$logger = new (0, $8sfRz.default)(options);
    return $da385be2f9de837f$var$logger;
};

});
parcelRegister("8sfRz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $627d3e51b5580ead$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $aHckM = parcelRequire("aHckM");

var $2sWVC = parcelRequire("2sWVC");
var $627d3e51b5580ead$var$getDefaultLogLevel = function getDefaultLogLevel() {
    return (0, $2sWVC.LogLevel).INFO;
};
var $627d3e51b5580ead$export$7b4b69781b3b411 = "@atlassiansox/feature-flag-web-client@".concat((0, $aHckM.version), " -");
var $627d3e51b5580ead$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function LoggerWrapper() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, LoggerWrapper);
        this.isEnabled = options.enabled !== undefined ? options.enabled : true;
        this.logger = options.logger || console;
        this.logLevel = options.level || $627d3e51b5580ead$var$getDefaultLogLevel();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(LoggerWrapper, [
        {
            key: "debug",
            value: function debug() {
                if (this.shouldLog((0, $2sWVC.LogLevel).DEBUG)) {
                    var _this$logger;
                    for(var _len = arguments.length, data = new Array(_len), _key = 0; _key < _len; _key++)data[_key] = arguments[_key];
                    (_this$logger = this.logger).debug.apply(_this$logger, [
                        $627d3e51b5580ead$export$7b4b69781b3b411
                    ].concat(data));
                }
            }
        },
        {
            key: "info",
            value: function info() {
                if (this.shouldLog((0, $2sWVC.LogLevel).INFO)) {
                    var _this$logger2;
                    for(var _len2 = arguments.length, data = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)data[_key2] = arguments[_key2];
                    (_this$logger2 = this.logger).info.apply(_this$logger2, [
                        $627d3e51b5580ead$export$7b4b69781b3b411
                    ].concat(data));
                }
            }
        },
        {
            key: "log",
            value: function log() {
                if (this.shouldLog((0, $2sWVC.LogLevel).LOG)) {
                    var _this$logger3;
                    for(var _len3 = arguments.length, data = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)data[_key3] = arguments[_key3];
                    (_this$logger3 = this.logger).log.apply(_this$logger3, [
                        $627d3e51b5580ead$export$7b4b69781b3b411
                    ].concat(data));
                }
            }
        },
        {
            key: "warn",
            value: function warn() {
                if (this.shouldLog((0, $2sWVC.LogLevel).WARN)) {
                    var _this$logger4;
                    for(var _len4 = arguments.length, data = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)data[_key4] = arguments[_key4];
                    (_this$logger4 = this.logger).warn.apply(_this$logger4, [
                        $627d3e51b5580ead$export$7b4b69781b3b411
                    ].concat(data));
                }
            }
        },
        {
            key: "error",
            value: function error() {
                if (this.shouldLog((0, $2sWVC.LogLevel).ERROR)) {
                    var _this$logger5;
                    for(var _len5 = arguments.length, data = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)data[_key5] = arguments[_key5];
                    (_this$logger5 = this.logger).error.apply(_this$logger5, [
                        $627d3e51b5580ead$export$7b4b69781b3b411
                    ].concat(data));
                }
            }
        },
        {
            key: "shouldLog",
            value: function shouldLog(checkLevel) {
                return this.isEnabled && checkLevel >= this.logLevel;
            }
        }
    ]);
    return LoggerWrapper;
}();

});
parcelRegister("aHckM", function(module, exports) {

$parcel$export(module.exports, "version", function () { return $7c977cd843b7ad98$export$83d89fbfd8236492; });
/// <reference types="node" />
var $7c977cd843b7ad98$export$83d89fbfd8236492 = "8.5.0";

});



parcelRegister("8igLI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $609d030bf3949f45$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $9m7Dh = parcelRequire("9m7Dh");

var $7Knxl = parcelRequire("7Knxl");

var $12mDE = parcelRequire("12mDE");

var $2uhhI = parcelRequire("2uhhI");
var $609d030bf3949f45$export$9959634951c336e9 = "feature-flags-atl";
var $609d030bf3949f45$var$VERSIONED_STORAGE_KEY_PREFIX = "".concat($609d030bf3949f45$export$9959634951c336e9, ".").concat((0, $9m7Dh.CURRENT_FFS_API_VERSION));
var $609d030bf3949f45$var$STORAGE_KEY_FLAG_STATE_PREFIX = "".concat($609d030bf3949f45$var$VERSIONED_STORAGE_KEY_PREFIX, ".flags");
var $609d030bf3949f45$var$STORAGE_KEY_USER_LAST_KEY_PREFIX = "".concat($609d030bf3949f45$var$VERSIONED_STORAGE_KEY_PREFIX, ".last-user");
var $609d030bf3949f45$var$STORAGE_KEY_ANON_ID = "".concat($609d030bf3949f45$export$9959634951c336e9, ".anonId");
var $609d030bf3949f45$var$STORAGE_KEY_DETECT_SUPPORT = "".concat($609d030bf3949f45$export$9959634951c336e9, ".storage.support");
var $609d030bf3949f45$var$StorageExceedQuota = false;
var $609d030bf3949f45$export$c0ed3e38b50302b2 = 604800000;
var $609d030bf3949f45$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Storage(env, product, apiKey, user) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Storage);
        this.env = env;
        this.product = product;
        this.apiKey = apiKey;
        this.user = user;
        this.key = this.getKey();
        this.lastUserUpdateKey = this.getLastUpdatedKey();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Storage, [
        {
            key: "updateUserContext",
            value: function updateUserContext(user) {
                this.user = user;
                this.key = this.getKey();
                this.lastUserUpdateKey = this.getLastUpdatedKey();
            }
        },
        {
            key: "getFlagsState",
            value: function getFlagsState() {
                return this.getObjectFromLocalstorage(this.key);
            }
        },
        {
            key: "getFlagsFromOldState",
            value: function getFlagsFromOldState() {
                var oldKey = this.getObjectFromLocalstorage(this.lastUserUpdateKey);
                if (oldKey) return this.getObjectFromLocalstorage(oldKey.value);
                return null;
            }
        },
        {
            key: "setFlagsState",
            value: function setFlagsState(data) {
                var _this = this;
                Storage.setItem(this.key, JSON.stringify(data), function() {
                    return _this.setLastUpdatedPrimaryKey();
                });
            }
        },
        {
            key: "purgeStaleFlagState",
            value: function purgeStaleFlagState() {
                var _this2 = this;
                try {
                    Object.keys(window.localStorage).filter(function(key) {
                        return key.startsWith($609d030bf3949f45$export$9959634951c336e9) && key !== _this2.key && key !== _this2.lastUserUpdateKey && key !== $609d030bf3949f45$var$STORAGE_KEY_ANON_ID;
                    }).forEach(function(key) {
                        var value = _this2.getObjectFromLocalstorage(key);
                        if (value && Date.now() - value.timestamp >= $609d030bf3949f45$export$c0ed3e38b50302b2) Storage.removeItem(key);
                    });
                } catch (error) {
                // This could fail due to localstorage permissions being restricted, in this case do nothing
                }
            }
        },
        {
            key: "getObjectFromLocalstorage",
            value: function getObjectFromLocalstorage(key) {
                var rawData = Storage.getItem(key);
                if (!rawData) return null;
                try {
                    return JSON.parse(rawData);
                } catch (error) {
                    return null;
                }
            }
        },
        {
            key: "setLastUpdatedPrimaryKey",
            value: function setLastUpdatedPrimaryKey() {
                var value = {
                    value: this.key,
                    timestamp: Date.now()
                };
                Storage.setItem(this.lastUserUpdateKey, JSON.stringify(value));
            }
        },
        {
            key: "getLastUpdatedKey",
            value: function getLastUpdatedKey() {
                var partialUser = {
                    identifier: this.user.identifier
                };
                return "".concat($609d030bf3949f45$var$STORAGE_KEY_USER_LAST_KEY_PREFIX, ".").concat(this.env, ".").concat(this.product, ".").concat((0, $12mDE.encodeObject)(partialUser));
            }
        },
        {
            key: "getKey",
            value: function getKey() {
                return "".concat($609d030bf3949f45$var$STORAGE_KEY_FLAG_STATE_PREFIX, ".").concat(this.env, ".").concat(this.product, ".").concat(this.apiKey, ".").concat((0, $12mDE.encodeObject)(this.user));
            }
        }
    ], [
        {
            key: "getAnonymousId",
            value: function getAnonymousId() {
                return Storage.getItem($609d030bf3949f45$var$STORAGE_KEY_ANON_ID);
            }
        },
        {
            key: "setAnonymousId",
            value: function setAnonymousId(anonymousId) {
                Storage.setItem($609d030bf3949f45$var$STORAGE_KEY_ANON_ID, anonymousId);
            }
        },
        {
            key: "setItem",
            value: function setItem(key, value, callbackIfSuccessful) {
                try {
                    window.localStorage.setItem(key, value);
                    $609d030bf3949f45$var$StorageExceedQuota = false;
                    callbackIfSuccessful && callbackIfSuccessful();
                } catch (error) {
                    if (Storage.isQuotaExceeded(error)) $609d030bf3949f45$var$StorageExceedQuota = true;
                // This could fail due to localstorage being full or localstorage permissions being restricted.
                // In either case, we do nothing.
                }
            }
        },
        {
            key: "getItem",
            value: function getItem(key) {
                try {
                    return window.localStorage.getItem(key);
                } catch (error) {
                    // This could fail due to localstorage permissions being restricted, in this case do nothing
                    return null;
                }
            }
        },
        {
            key: "removeItem",
            value: function removeItem(key) {
                try {
                    window.localStorage.removeItem(key);
                } catch (error) {
                // This could fail due to localstorage permissions being restricted, in this case do nothing
                }
            }
        },
        {
            key: "isQuotaExceeded",
            value: function isQuotaExceeded(e) {
                // according to https://developer.mozilla.org/en-US/docs/Web/API/DOMException
                // DOMException.code is deprecated API should no longer be used
                if (e instanceof DOMException) switch(e.name){
                    case "QUOTA_EXCEEDED_ERR":
                        // Safari
                        return true;
                    case "QuotaExceededError":
                        // Chrome
                        return true;
                    case "NS_ERROR_DOM_QUOTA_REACHED":
                        // Firefox
                        return true;
                    default:
                        return false;
                }
                // Internet Explorer 8
                if (e instanceof (0, $2uhhI.IE8Exception)) return e.number === -2147024882;
                return false;
            }
        },
        {
            key: "getStorageStatus",
            value: function getStorageStatus() {
                var TEST_VALUE = "test_value";
                try {
                    if (!window.localStorage) return (0, $7Knxl.ClientStorageState).NOT_AVAILABLE;
                    if ($609d030bf3949f45$var$StorageExceedQuota) return (0, $7Knxl.ClientStorageState).FULL;
                    window.localStorage.setItem($609d030bf3949f45$var$STORAGE_KEY_DETECT_SUPPORT, TEST_VALUE);
                    var value = window.localStorage.getItem($609d030bf3949f45$var$STORAGE_KEY_DETECT_SUPPORT);
                    window.localStorage.removeItem($609d030bf3949f45$var$STORAGE_KEY_DETECT_SUPPORT);
                    // handle localStorage silently failing
                    return value === TEST_VALUE ? (0, $7Knxl.ClientStorageState).AVAILABLE : (0, $7Knxl.ClientStorageState).ERRORED;
                } catch (e) {
                    if (Storage.isQuotaExceeded(e)) return (0, $7Knxl.ClientStorageState).FULL;
                    // permission issue or localStorage disabled
                    return (0, $7Knxl.ClientStorageState).NOT_AVAILABLE;
                }
            }
        }
    ]);
    return Storage;
}();

});
parcelRegister("9m7Dh", function(module, exports) {

$parcel$export(module.exports, "CURRENT_FFS_API_VERSION", function () { return $6cfc16cc567195c5$export$17f647755de6efe5; });

var $8BIhN = parcelRequire("8BIhN");
var $6cfc16cc567195c5$export$17f647755de6efe5 = (0, $8BIhN.FeatureFlagServiceApiVersion).V2;

});
parcelRegister("8BIhN", function(module, exports) {

$parcel$export(module.exports, "RefreshStatus", function () { return $644421b99a08a61c$export$b16e70dacd3d8ec1; });
$parcel$export(module.exports, "FeatureFlagServiceApiVersion", function () { return $644421b99a08a61c$export$af3cbe85f963d434; });
var $644421b99a08a61c$export$b16e70dacd3d8ec1 = /*#__PURE__*/ function(RefreshStatus) {
    RefreshStatus["INITIALISED"] = "INITIALISED";
    RefreshStatus["SUCCESS"] = "SUCCESS";
    RefreshStatus["ERROR"] = "ERROR";
    return RefreshStatus;
}({});
var $644421b99a08a61c$export$af3cbe85f963d434 = /*#__PURE__*/ function(FeatureFlagServiceApiVersion) {
    FeatureFlagServiceApiVersion["V1"] = "v1";
    FeatureFlagServiceApiVersion["V2"] = "v2";
    return FeatureFlagServiceApiVersion;
}({});

});


parcelRegister("7Knxl", function(module, exports) {

$parcel$export(module.exports, "ClientCauseReason", function () { return $5a3f163344196321$export$5fecd71898488841; });
$parcel$export(module.exports, "ClientStorageState", function () { return $5a3f163344196321$export$4689f45dd8b7804a; });
$parcel$export(module.exports, "ClientUserState", function () { return $5a3f163344196321$export$ac0a0bad9c4cb9be; });
var $5a3f163344196321$export$df576fce7d800dd2 = /*#__PURE__*/ function(ClientVisibilityState) {
    ClientVisibilityState["VISIBLE"] = "visible";
    ClientVisibilityState["HIDDEN"] = "hidden";
    ClientVisibilityState["PRERENDER"] = "prerender";
    return ClientVisibilityState;
}({});
var $5a3f163344196321$export$5fecd71898488841 = /*#__PURE__*/ function(ClientCauseReason) {
    ClientCauseReason["INITIALIZATION"] = "initialization";
    ClientCauseReason["POLLING"] = "polling";
    ClientCauseReason["RETRY"] = "retry";
    return ClientCauseReason;
}({});
var $5a3f163344196321$export$4689f45dd8b7804a = /*#__PURE__*/ function(ClientStorageState) {
    ClientStorageState["AVAILABLE"] = "available";
    ClientStorageState["NOT_AVAILABLE"] = "notAvailable";
    ClientStorageState["FULL"] = "full";
    ClientStorageState["ERRORED"] = "errored";
    return ClientStorageState;
}({});
var $5a3f163344196321$export$ac0a0bad9c4cb9be = /*#__PURE__*/ function(ClientUserState) {
    ClientUserState["NEW"] = "new";
    ClientUserState["SAME"] = "same";
    ClientUserState["SWITCHED"] = "switched";
    return ClientUserState;
}({});

});

parcelRegister("2uhhI", function(module, exports) {

$parcel$export(module.exports, "IE8Exception", function () { return $1cfbca80270cc143$export$bde183916164b024; });

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $5T1eV = parcelRequire("5T1eV");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $3Fq9h = parcelRequire("3Fq9h");

var $6bkHe = parcelRequire("6bkHe");
function $1cfbca80270cc143$var$_createSuper(t) {
    var r = $1cfbca80270cc143$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $1cfbca80270cc143$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1cfbca80270cc143$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1cfbca80270cc143$export$bde183916164b024 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(IE8Exception, _Error);
    var _super = $1cfbca80270cc143$var$_createSuper(IE8Exception);
    function IE8Exception() {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, IE8Exception);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "number", 0);
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(IE8Exception);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3Fq9h)))(Error));

});
parcelRegister("3Fq9h", function(module, exports) {

var $hOtqI = parcelRequire("hOtqI");

var $5LDYA = parcelRequire("5LDYA");

var $c42RG = parcelRequire("c42RG");

var $eI5Z6 = parcelRequire("eI5Z6");
function $2ab97bff5a1af503$var$_wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return module.exports = $2ab97bff5a1af503$var$_wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !$c42RG(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return $eI5Z6(t, arguments, $hOtqI(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), $5LDYA(Wrapper, t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ab97bff5a1af503$var$_wrapNativeSuper(t);
}
module.exports = $2ab97bff5a1af503$var$_wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("c42RG", function(module, exports) {
function $8c8814aeb2116d69$var$_isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}
module.exports = $8c8814aeb2116d69$var$_isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eI5Z6", function(module, exports) {

var $eOnrh = parcelRequire("eOnrh");

var $5LDYA = parcelRequire("5LDYA");
function $ab59d1223c898fdf$var$_construct(t, e, r) {
    if ($eOnrh()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && $5LDYA(p, r.prototype), p;
}
module.exports = $ab59d1223c898fdf$var$_construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("eOnrh", function(module, exports) {
function $ac87eab59da1723b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (module.exports = $ac87eab59da1723b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $ac87eab59da1723b$var$_isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

});





parcelRegister("8aAEs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f2bb0243b40b3e8$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $9m7Dh = parcelRequire("9m7Dh");

var $12mDE = parcelRequire("12mDE");
var $5f2bb0243b40b3e8$export$dce59ee845588a78 = "flagData";
var $5f2bb0243b40b3e8$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Broadcast(apiKey, user, stateUpdateCallback) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Broadcast);
        this.apiKey = apiKey;
        this.stateUpdateCallback = stateUpdateCallback;
        this.setupChannel(user);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Broadcast, [
        {
            key: "updateUserContext",
            value: function updateUserContext(user) {
                this.stop();
                this.setupChannel(user);
            }
        },
        {
            key: "sendFeatureFlagState",
            value: function sendFeatureFlagState(featureFlagState) {
                var _this$channel;
                (_this$channel = this.channel) === null || _this$channel === void 0 || _this$channel.postMessage(featureFlagState);
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$channel2;
                (_this$channel2 = this.channel) === null || _this$channel2 === void 0 || _this$channel2.close();
            }
        },
        {
            key: "setupChannel",
            value: function setupChannel(user) {
                var _this = this;
                try {
                    // Keep reference to old channel so we can check the name of the current subscription
                    // is the same as the channel we received a message for.
                    // Due to a bug in Firefox which events can be recieved after
                    // the channel has been closed.
                    // eslint-disable-next-line compat/compat
                    var channel = new BroadcastChannel(this.createChannelName(user));
                    channel.onmessage = function(e) {
                        var _this$channel3;
                        if (channel.name === ((_this$channel3 = _this.channel) === null || _this$channel3 === void 0 ? void 0 : _this$channel3.name)) _this.stateUpdateCallback(e.data);
                    };
                    this.channel = channel;
                } catch (error) {
                // This could fail due to BroadcastChannel not available.
                // In that case, we do nothing.
                }
            }
        },
        {
            key: "createChannelName",
            value: function createChannelName(user) {
                return "".concat($5f2bb0243b40b3e8$export$dce59ee845588a78, ".").concat((0, $9m7Dh.CURRENT_FFS_API_VERSION), ".").concat(this.apiKey, ".").concat((0, $12mDE.encodeObject)(user));
            }
        }
    ]);
    return Broadcast;
}();

});

parcelRegister("5FFZZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42115c2e6fef372c$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $gMThW = parcelRequire("gMThW");
var $42115c2e6fef372c$export$c7a884b40e38e22 = "flagKey.";
var $42115c2e6fef372c$export$a6fc48f32d426837 = "allFlags";
var $42115c2e6fef372c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Subscriptions);
        this.emitter = (0, $gMThW.default)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Subscriptions, [
        {
            key: "on",
            value: function on(flagKey, defaultValue, callback, getFlagValue, options) {
                var _this = this;
                var wrapCallback = function wrapCallback() {
                    return callback(getFlagValue(flagKey, defaultValue, options));
                };
                this.emitter.on($42115c2e6fef372c$export$c7a884b40e38e22 + flagKey, wrapCallback);
                return function() {
                    return _this.emitter.off($42115c2e6fef372c$export$c7a884b40e38e22 + flagKey, wrapCallback);
                };
            }
        },
        {
            key: "onAnyFlagUpdated",
            value: function onAnyFlagUpdated(callback) {
                var _this2 = this;
                this.emitter.on($42115c2e6fef372c$export$a6fc48f32d426837, callback);
                return function() {
                    return _this2.emitter.off($42115c2e6fef372c$export$a6fc48f32d426837, callback);
                };
            }
        },
        {
            key: "anyFlagUpdated",
            value: function anyFlagUpdated() {
                this.emitter.emit($42115c2e6fef372c$export$a6fc48f32d426837);
            }
        },
        {
            key: "flagValueUpdated",
            value: function flagValueUpdated(flagKey) {
                this.emitter.emit($42115c2e6fef372c$export$c7a884b40e38e22 + flagKey);
            }
        },
        {
            key: "stop",
            value: function stop() {
                // There is no way to clear the emitter so instead we're creating a new one
                this.emitter = (0, $gMThW.default)();
            }
        }
    ]);
    return Subscriptions;
}();

});
parcelRegister("gMThW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c38c042784cf3273$export$2e2bcd8739ae039; });
function $c38c042784cf3273$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i && i.push(e) || n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && i.splice(i.indexOf(e) >>> 0, 1);
        },
        emit: function(t, e) {
            (n.get(t) || []).slice().map(function(n) {
                n(e);
            }), (n.get("*") || []).slice().map(function(n) {
                n(t, e);
            });
        }
    };
}

});


parcelRegister("jjo0J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e0f26abaab5c42c6$export$2e2bcd8739ae039; });
function $e0f26abaab5c42c6$export$2e2bcd8739ae039(obj) {
    var str = JSON.stringify(obj);
    return JSON.parse(str);
}

});

parcelRegister("j2ILk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ddd0ed16fab4a254$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $2sWVC = parcelRequire("2sWVC");

var $8igLI = parcelRequire("8igLI");

var $dDO62 = parcelRequire("dDO62");
function $ddd0ed16fab4a254$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ddd0ed16fab4a254$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ddd0ed16fab4a254$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ddd0ed16fab4a254$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $ddd0ed16fab4a254$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Anonymous() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Anonymous);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Anonymous, null, [
        {
            key: "processAnonymousUser",
            value: function processAnonymousUser(featureFlagUser) {
                var identifier = featureFlagUser.identifier;
                if (identifier) return $ddd0ed16fab4a254$var$_objectSpread($ddd0ed16fab4a254$var$_objectSpread({}, featureFlagUser), {}, {
                    identifier: identifier
                });
                identifier = {
                    type: (0, $2sWVC.Identifiers).FF_CLIENT_ANONYMOUS_ID,
                    value: Anonymous.generateAnonymousId()
                };
                return $ddd0ed16fab4a254$var$_objectSpread($ddd0ed16fab4a254$var$_objectSpread({}, featureFlagUser), {}, {
                    isAnonymous: true,
                    identifier: identifier
                });
            }
        },
        {
            key: "generateAnonymousId",
            value: function generateAnonymousId() {
                var storedAnonymousId = (0, $8igLI.default).getAnonymousId();
                if (storedAnonymousId) return storedAnonymousId;
                var anonymousId = (0, $dDO62.uuidv4)();
                (0, $8igLI.default).setAnonymousId(anonymousId);
                return anonymousId;
            }
        }
    ]);
    return Anonymous;
}();

});
parcelRegister("dDO62", function(module, exports) {

$parcel$export(module.exports, "flagResponseToFlagUpdate", function () { return $9ee5c6ffe4d89688$export$dc45e8a94b492900; });
$parcel$export(module.exports, "flagStateToFlagUpdate", function () { return $9ee5c6ffe4d89688$export$bc46a39c6aaa1a9f; });
$parcel$export(module.exports, "hasFlagValueChanged", function () { return $9ee5c6ffe4d89688$export$9a91a5f34fa368e3; });
$parcel$export(module.exports, "validateFlag", function () { return $9ee5c6ffe4d89688$export$d1b582ce55c8d054; });
$parcel$export(module.exports, "validateConstructorArgs", function () { return $9ee5c6ffe4d89688$export$722f04998ab00d3e; });
$parcel$export(module.exports, "validateDefaultValue", function () { return $9ee5c6ffe4d89688$export$7e12dedaaa5cae0c; });
$parcel$export(module.exports, "uuidv4", function () { return $9ee5c6ffe4d89688$export$abe4376e1bf796d6; });
$parcel$export(module.exports, "getReadyMessageForStatusCode", function () { return $9ee5c6ffe4d89688$export$3f53053e801279bc; });
$parcel$export(module.exports, "getReasonForStatusCode", function () { return $9ee5c6ffe4d89688$export$99195c9b6ce7887; });

var $cd8Dz = parcelRequire("cd8Dz");

var $ip4mj = parcelRequire("ip4mj");

var $gaCcd = parcelRequire("gaCcd");

var $2sWVC = parcelRequire("2sWVC");

var $2sWVC = parcelRequire("2sWVC");

var $iJA0o = parcelRequire("iJA0o");

var $jjo0J = parcelRequire("jjo0J");

var $8BIhN = parcelRequire("8BIhN");
function $9ee5c6ffe4d89688$export$5216b3b13b0ac716(featureFlag) {
    var rawFlag = {
        value: featureFlag.value,
        trackingInfo: featureFlag.trackingInfo || {
            samplingRate: 0
        }
    };
    if (featureFlag.reason) rawFlag.evaluationDetail = {
        reason: featureFlag.reason,
        ruleId: featureFlag.ruleId
    };
    return rawFlag;
}
function $9ee5c6ffe4d89688$export$dc45e8a94b492900(response) {
    var _response$featureFlag;
    var flags = {};
    (_response$featureFlag = response.featureFlagValues) === null || _response$featureFlag === void 0 || _response$featureFlag.forEach(function(featureFlag) {
        flags[featureFlag.key] = $9ee5c6ffe4d89688$export$5216b3b13b0ac716(featureFlag);
    });
    return {
        flags: flags,
        deletedFlags: response.deletedFlags || [],
        versionData: response.versionData
    };
}
function $9ee5c6ffe4d89688$export$bc46a39c6aaa1a9f(currentFlags, newFlagState) {
    var newFlags = (newFlagState === null || newFlagState === void 0 ? void 0 : newFlagState.flags) || {};
    var deletedFlags = Object.keys(currentFlags).filter(function(flagKey) {
        return newFlags[flagKey] === undefined;
    });
    var versionData = $9ee5c6ffe4d89688$var$getVersionData(newFlagState);
    return {
        flags: newFlags,
        deletedFlags: deletedFlags,
        versionData: versionData
    };
}
var $9ee5c6ffe4d89688$var$getVersionData = function getVersionData(flagState) {
    if ("version" in flagState) return flagState.version;
    else if ("versionData" in flagState) return flagState.versionData;
    return undefined;
};
function $9ee5c6ffe4d89688$export$9a91a5f34fa368e3(oldFlag, newFlag) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(oldFlag === null || oldFlag === void 0 ? void 0 : oldFlag.value) !== (0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(newFlag === null || newFlag === void 0 ? void 0 : newFlag.value);
}
function $9ee5c6ffe4d89688$export$9ef179a791292774(status) {
    switch(status){
        case (0, $8BIhN.RefreshStatus).INITIALISED:
            return (0, $2sWVC.EvaluationErrorKind).CLIENT_NOT_READY;
        case (0, $8BIhN.RefreshStatus).ERROR:
            return (0, $2sWVC.EvaluationErrorKind).SERVER_ERROR;
        case (0, $8BIhN.RefreshStatus).SUCCESS:
            return (0, $2sWVC.EvaluationErrorKind).FLAG_NOT_FOUND;
        default:
            return (0, $2sWVC.EvaluationErrorKind).OTHER;
    }
}
function $9ee5c6ffe4d89688$export$d1b582ce55c8d054(flag, defaultValue, refreshStatus, options) {
    var _options$oneOf;
    if (!flag) return {
        value: defaultValue,
        evaluationDetail: {
            reason: (0, $2sWVC.EvaluationReason).ERROR,
            errorKind: $9ee5c6ffe4d89688$export$9ef179a791292774(refreshStatus)
        }
    };
    if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(flag.value) !== (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(defaultValue)) return {
        value: defaultValue,
        trackingInfo: flag.trackingInfo,
        evaluationDetail: {
            reason: (0, $2sWVC.EvaluationReason).ERROR,
            errorKind: (0, $2sWVC.EvaluationErrorKind).WRONG_TYPE
        }
    };
    if (options !== null && options !== void 0 && (_options$oneOf = options.oneOf) !== null && _options$oneOf !== void 0 && _options$oneOf.length && options.oneOf.indexOf(flag.value) < 0) return {
        value: defaultValue,
        trackingInfo: flag.trackingInfo,
        evaluationDetail: {
            reason: (0, $2sWVC.EvaluationReason).ERROR,
            errorKind: (0, $2sWVC.EvaluationErrorKind).VALIDATION_ERROR
        }
    };
    return (0, $jjo0J.default)(flag);
}
function $9ee5c6ffe4d89688$export$7ee701e290d9865(str) {
    return !str || /^\s*$/.test(str);
}
function $9ee5c6ffe4d89688$export$f6e2535fb5126e54(func) {
    return typeof func === "function";
}
function $9ee5c6ffe4d89688$export$722f04998ab00d3e(apiKey, analyticsWebClient, featureFlagUser, options) {
    if ($9ee5c6ffe4d89688$export$7ee701e290d9865(apiKey)) throw new Error("apiKey is missing");
    if (!$9ee5c6ffe4d89688$export$f6e2535fb5126e54(analyticsWebClient === null || analyticsWebClient === void 0 ? void 0 : analyticsWebClient.sendOperationalEvent)) throw new Error("analyticsWebClient.sendOperationalEvent is missing or not a function");
    if (!featureFlagUser) throw new Error("featureFlagUser is missing");
    if ($9ee5c6ffe4d89688$export$7ee701e290d9865(options === null || options === void 0 ? void 0 : options.productKey)) throw new Error("options.productKey is missing");
    if (Object.values((0, $2sWVC.EnvironmentType)).indexOf(options === null || options === void 0 ? void 0 : options.environment) === -1) throw new Error("options.environment is missing or invalid");
    if (options.pollingInterval !== undefined && options.pollingInterval !== null) {
        var prodMinInterval = 60000;
        var nonProdMinInterval = 1000;
        if (options.pollingInterval <= prodMinInterval) {
            if (options.environment === (0, $2sWVC.EnvironmentType).PROD) {
                // eslint-disable-next-line no-param-reassign
                options.pollingInterval = prodMinInterval;
                (0, $iJA0o.default)().log("options.pollingInterval needs to be greater than ".concat(prodMinInterval));
            } else if (options.pollingInterval <= nonProdMinInterval) throw new Error("options.pollingInterval needs to be greater than ".concat(nonProdMinInterval));
            else (0, $iJA0o.default)().log("options.pollingInterval needs to be greater than ".concat(prodMinInterval, " in Production"));
        }
    }
}
function $9ee5c6ffe4d89688$export$7e12dedaaa5cae0c(value) {
    if (value === undefined || value === null) throw new Error("defaultValue is missing");
}
function $9ee5c6ffe4d89688$export$abe4376e1bf796d6() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($gaCcd)))();
}
function $9ee5c6ffe4d89688$export$3f53053e801279bc(statusCode) {
    switch(statusCode){
        case 0:
            return "Request took too long to finish, client aborted the request.";
        case 400:
            return "Service returned bad request response code. The version data maybe malformed or out of sync with the server.";
        case 401:
            return "Service returned unauthorized response code. Ensure that the API token is valid for this environment.";
        case 429:
            return "Service rate limit exceeded.";
        case 500:
        case 502:
        case 503:
        case 504:
            return "Service is unavailable, status code: ".concat(statusCode);
        default:
            return "Unsure what went wrong, status code: ".concat(statusCode);
    }
}
function $9ee5c6ffe4d89688$export$99195c9b6ce7887(statusCode) {
    if (statusCode && statusCode >= 500) return (0, $2sWVC.ReadyReason).SERVER_ERROR;
    return (0, $2sWVC.ReadyReason).CLIENT_ERROR;
}

});


parcelRegister("gOk8y", function(module, exports) {

$parcel$export(module.exports, "READY_CACHE", function () { return $c3d0efa7e6621b21$export$e9d7d3e7ce9845ce; });
$parcel$export(module.exports, "READY_FETCH", function () { return $c3d0efa7e6621b21$export$1adcf19635eea12f; });
$parcel$export(module.exports, "default", function () { return $c3d0efa7e6621b21$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $2sWVC = parcelRequire("2sWVC");
var $c3d0efa7e6621b21$export$4dcc978f06b5a9ec = 3000;
var $c3d0efa7e6621b21$export$afc6624fce981981 = {
    reason: (0, $2sWVC.ReadyReason).CLIENT_ERROR,
    message: "Client timed out."
};
var $c3d0efa7e6621b21$export$fa405bbf47d510e2 = {
    reason: (0, $2sWVC.ReadyReason).CLIENT_ERROR,
    message: "Request took too long to finish, client aborted the request."
};
var $c3d0efa7e6621b21$export$e9d7d3e7ce9845ce = {
    reason: (0, $2sWVC.ReadyReason).CACHE
};
var $c3d0efa7e6621b21$export$1adcf19635eea12f = {
    reason: (0, $2sWVC.ReadyReason).FETCH
};
var $c3d0efa7e6621b21$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Ready() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, readyTimeoutInMilliseconds = _ref.readyTimeoutInMilliseconds;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Ready);
        this.readyTimeoutInMilliseconds = readyTimeoutInMilliseconds || $c3d0efa7e6621b21$export$4dcc978f06b5a9ec;
        this.initialisePromise();
        this.initialiseDefaultPromise(this.readyTimeoutInMilliseconds);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Ready, [
        {
            key: "initialiseDefaultPromise",
            value: function initialiseDefaultPromise(timeout) {
                this.defaultReadyPromise = new Promise(function(resolve) {
                    setTimeout(function() {
                        resolve({
                            reason: (0, $2sWVC.ReadyReason).CLIENT_ERROR,
                            message: "Client timed out."
                        });
                    }, timeout);
                });
            }
        },
        {
            key: "initialisePromise",
            value: function initialisePromise() {
                var _this = this;
                /*
          A promise can only be resolved by calling the `resolve` function in the constructor callback.
          Since we need resolve the promise by external input, we must save the reference to this resolve function.
          This is safe as the callback function is called synchronously as defined by the ES spec.
        */ this.readyPromise = new Promise(function(resolve) {
                    _this.resolveReadyPromise = resolve;
                });
            }
        },
        {
            key: "getPromise",
            value: function getPromise() {
                return Promise.race([
                    this.readyPromise,
                    this.defaultReadyPromise
                ]);
            }
        },
        {
            key: "triggerReady",
            value: function triggerReady(response) {
                if (this.resolveReadyPromise !== undefined) {
                    this.resolveReadyPromise(response);
                    this.resolveReadyPromise = undefined;
                }
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.resolveReadyPromise === undefined) this.initialisePromise();
                this.initialiseDefaultPromise(this.readyTimeoutInMilliseconds);
            }
        }
    ]);
    return Ready;
}();

});

parcelRegister("kTkzm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f358e65e37306925$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $ip4mj = parcelRequire("ip4mj");

var $26ULl = parcelRequire("26ULl");

var $2wrqf = parcelRequire("2wrqf");

var $7Knxl = parcelRequire("7Knxl");

var $iJA0o = parcelRequire("iJA0o");

var $8PlXg = parcelRequire("8PlXg");

var $8BIhN = parcelRequire("8BIhN");

var $dDO62 = parcelRequire("dDO62");
function $f358e65e37306925$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f358e65e37306925$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f358e65e37306925$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f358e65e37306925$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $f358e65e37306925$export$9f07cc6db84eac61 = {
    minWaitInterval: 300000,
    // 300 second = 5 mins
    maxWaitInterval: 1200000,
    // 1200 second = 20 mins
    backOffFactor: 2,
    backOffJitter: 0.1,
    // Jitter is upto 10% of wait time
    interval: 300000,
    // 300 second = 5 mins
    tabHiddenPollingFactor: 12,
    // for hidden tabs, use hiddenTabFactor * interval for polling = 1 hour (default)
    maxInstantRetryTimes: 0
};
var $f358e65e37306925$export$2b558311ac69763c = $f358e65e37306925$var$_objectSpread($f358e65e37306925$var$_objectSpread({}, $f358e65e37306925$export$9f07cc6db84eac61), {}, {
    minWaitInterval: 500,
    interval: 500,
    maxInstantRetryTimes: 1
});
var $f358e65e37306925$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Refresh(apiKey, env, user, onFeatureFlagUpdate, pollingConfig, version) {
        var lastUpdateTimestamp = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
        var onError = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : function() {};
        var noCachePollingConfig = arguments.length > 8 ? arguments[8] : undefined;
        var useGatewayURL = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : false;
        var perimeter = arguments.length > 10 ? arguments[10] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Refresh);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "failureCount", 0);
        this.logger = (0, $iJA0o.default)();
        this.user = user;
        this.onFeatureFlagUpdate = onFeatureFlagUpdate;
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
        this.pollingConfig = {
            minWaitInterval: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.minWaitInterval) || $f358e65e37306925$export$9f07cc6db84eac61.minWaitInterval,
            maxWaitInterval: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.maxWaitInterval) || $f358e65e37306925$export$9f07cc6db84eac61.maxWaitInterval,
            backOffFactor: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.backOffFactor) || $f358e65e37306925$export$9f07cc6db84eac61.backOffFactor,
            backOffJitter: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.backOffJitter) !== undefined ? pollingConfig.backOffJitter : $f358e65e37306925$export$9f07cc6db84eac61.backOffJitter,
            interval: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.interval) || $f358e65e37306925$export$9f07cc6db84eac61.interval,
            tabHiddenPollingFactor: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.tabHiddenPollingFactor) || $f358e65e37306925$export$9f07cc6db84eac61.tabHiddenPollingFactor,
            maxInstantRetryTimes: 0 // Force this to 0 so this never reschdules instantly with cache
        };
        this.noCachePollingConfig = {
            minWaitInterval: (noCachePollingConfig === null || noCachePollingConfig === void 0 ? void 0 : noCachePollingConfig.minWaitInterval) || $f358e65e37306925$export$2b558311ac69763c.minWaitInterval,
            maxWaitInterval: (noCachePollingConfig === null || noCachePollingConfig === void 0 ? void 0 : noCachePollingConfig.maxWaitInterval) || $f358e65e37306925$export$2b558311ac69763c.maxWaitInterval,
            backOffFactor: (noCachePollingConfig === null || noCachePollingConfig === void 0 ? void 0 : noCachePollingConfig.backOffFactor) || $f358e65e37306925$export$2b558311ac69763c.backOffFactor,
            backOffJitter: (noCachePollingConfig === null || noCachePollingConfig === void 0 ? void 0 : noCachePollingConfig.backOffJitter) !== undefined ? noCachePollingConfig.backOffJitter : $f358e65e37306925$export$2b558311ac69763c.backOffJitter,
            interval: (noCachePollingConfig === null || noCachePollingConfig === void 0 ? void 0 : noCachePollingConfig.interval) || $f358e65e37306925$export$2b558311ac69763c.interval,
            tabHiddenPollingFactor: (pollingConfig === null || pollingConfig === void 0 ? void 0 : pollingConfig.tabHiddenPollingFactor) || $f358e65e37306925$export$9f07cc6db84eac61.tabHiddenPollingFactor,
            maxInstantRetryTimes: (noCachePollingConfig === null || noCachePollingConfig === void 0 ? void 0 : noCachePollingConfig.maxInstantRetryTimes) !== undefined ? noCachePollingConfig.maxInstantRetryTimes : $f358e65e37306925$export$2b558311ac69763c.maxInstantRetryTimes
        };
        this.onError = onError;
        this.fetcher = new (0, $26ULl.default)(apiKey, env, undefined, useGatewayURL, perimeter);
        this.metadataManager = new (0, $8PlXg.default)(this.pollingConfig);
        this.status = (0, $8BIhN.RefreshStatus).INITIALISED;
        this.updateMetadataOnInitialisation();
        this.visibilityChangeHandler = this.visibilityChangeHandler.bind(this);
    }
    // start refresh by fetchAndReschedule
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Refresh, [
        {
            key: "start",
            value: function start() {
                this.stop();
                this.bindVisibilityChange();
                this.fetchAndReschedule();
            }
        },
        {
            key: "stop",
            value: function stop() {
                if (this.timerId) {
                    window.clearTimeout(this.timerId);
                    this.timerId = undefined;
                    this.unbindVisibilityChange();
                }
            }
        },
        {
            key: "updateUserContext",
            value: function updateUserContext(user, version) {
                var lastUpdateTimestamp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                this.user = user;
                this.version = version;
                this.lastUpdateTimestamp = lastUpdateTimestamp;
                this.failureCount = 0;
                this.updateMetadataOnUserChange();
            }
        },
        {
            key: "setVersionAndTimestamp",
            value: function setVersionAndTimestamp(version, lastUpdateTimestamp) {
                this.version = version;
                this.lastUpdateTimestamp = lastUpdateTimestamp;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "visibilityChangeHandler",
            value: function visibilityChangeHandler() {
                // cancel existing schedule
                window.clearTimeout(this.timerId);
                this.timerId = undefined;
                // get current tab hidden state (for unsupported browser isTabHidden() will return false), so
                // if isTabHidden true: create a new schedule with a longer interval
                // if isTabHidden false: do a fetchAndReschedule (conditional do a fetch, schedule with normal interval)
                if (Refresh.isTabHidden()) this.schedule();
                else this.fetchAndReschedule();
            }
        },
        {
            key: "bindVisibilityChange",
            value: // bind tab visibility change callback
            function bindVisibilityChange() {
                document.addEventListener("visibilitychange", this.visibilityChangeHandler);
            }
        },
        {
            key: "unbindVisibilityChange",
            value: function unbindVisibilityChange() {
                document.removeEventListener("visibilitychange", this.visibilityChangeHandler);
            }
        },
        {
            key: "schedule",
            value: function schedule() {
                var _this = this;
                this.timerId = window.setTimeout(function() {
                    _this.fetchAndReschedule();
                }, this.calculateInterval());
            }
        },
        {
            key: "fetchAndReschedule",
            value: function fetchAndReschedule() {
                var _this2 = this;
                var fetchedUser = (0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(this.user);
                if (this.isFetchRequired()) this.fetcher.fetchFeatureFlags(this.user, this.metadataManager.get(), this.version).then(function(resp) {
                    if (fetchedUser === (0, (/*@__PURE__*/$parcel$interopDefault($ip4mj)))(_this2.user)) {
                        _this2.failureCount = 0;
                        _this2.onFeatureFlagUpdate((0, $dDO62.flagResponseToFlagUpdate)(resp));
                        _this2.schedule();
                        _this2.status = (0, $8BIhN.RefreshStatus).SUCCESS;
                    }
                    _this2.updateMetadataOnRequestComplete();
                }).catch(function(err) {
                    // 401 means client info or apiKey invalid, will have no retry
                    // 400 means version data or request body invalid, will have at most `maxInstantRetryTimes` instant retries
                    // other 4xx or 5xx will do `maxInstantRetryTimes` instant retries and continue to do backoff retries
                    if (err instanceof (0, $2wrqf.ResponseError) && err.status === 401) {
                        // no retry needed
                        var message = "Feature flag service returned ".concat(err.status, ', "').concat(err.body, '". This request will not be retried until the user data has been changed.');
                        _this2.logger.error(message);
                        _this2.onError(err.status, err.body);
                    } else if (err instanceof (0, $2wrqf.ResponseError) && err.status === 400) {
                        if (_this2.version) {
                            // 400 could be caused by corrupted version data, so clear it and schedule a retry
                            _this2.failureCount += 1;
                            // a user with no cache will retry instantly for maxInstantRetryTimes
                            // onError will be called after all allowed attempts fail
                            if (_this2.failureCount > _this2.getPollingConfig().maxInstantRetryTimes) _this2.onError(err.status, err.body);
                            _this2.logger.error("Feature flag service returned ".concat(err.status, ', "').concat(err.body, '". Clear version data and retry.'));
                            _this2.setVersionAndTimestamp(undefined, 0);
                            _this2.schedule();
                        } else {
                            // no retry needed
                            var _message = "Feature flag service returned ".concat(err.status, ', "').concat(err.body, '". This request will not be retried until the user data has been changed.');
                            _this2.logger.error(_message);
                            _this2.onError(err.status, err.body);
                        }
                    } else if (err.name === "AbortError") {
                        _this2.failureCount += 1;
                        // a user with no cache will retry instantly for maxInstantRetryTimes
                        // onError will be called after all allowed attempts fail or timeout
                        if (_this2.failureCount > _this2.getPollingConfig().maxInstantRetryTimes) _this2.onError(0);
                        _this2.schedule();
                    } else {
                        _this2.failureCount += 1;
                        // a user with no cache will retry instantly for maxInstantRetryTimes
                        // onError will be called after all allowed attempts fail or timeout
                        if (_this2.failureCount > _this2.getPollingConfig().maxInstantRetryTimes) {
                            if (err instanceof (0, $2wrqf.ResponseError)) _this2.onError(err.status, err.body);
                            else _this2.onError();
                        }
                        _this2.schedule();
                    }
                    _this2.status = (0, $8BIhN.RefreshStatus).ERROR;
                    _this2.updateMetadataOnRequestComplete();
                });
                else {
                    this.schedule();
                    this.status = (0, $8BIhN.RefreshStatus).SUCCESS;
                }
            }
        },
        {
            key: "isFetchRequired",
            value: function isFetchRequired() {
                return Date.now() - this.getPollingConfig().interval >= this.lastUpdateTimestamp;
            }
        },
        {
            key: "updateMetadataOnUserChange",
            value: function updateMetadataOnUserChange() {
                // if fetch required, it will be a INITIALIZATION fetch, otherwise it's going to be a delay POLLING fetch
                this.metadataManager.updateClientCauseReason(this.isFetchRequired() ? (0, $7Knxl.ClientCauseReason).INITIALIZATION : (0, $7Knxl.ClientCauseReason).POLLING);
                // always set user state to SWITCHED user for next fetch
                this.metadataManager.updateClientUserState((0, $7Knxl.ClientUserState).SWITCHED);
            }
        },
        {
            key: "updateMetadataOnInitialisation",
            value: function updateMetadataOnInitialisation() {
                // if fetch required, it will be a INITIALIZATION fetch, otherwise it's going to be a delay POLLING fetch
                this.metadataManager.updateClientCauseReason(this.isFetchRequired() ? (0, $7Knxl.ClientCauseReason).INITIALIZATION : (0, $7Knxl.ClientCauseReason).POLLING);
                // no cache (lastUpdateTimestamp === 0) means we fetch for NEW user, if we have cache we fetch for SAME user
                this.metadataManager.updateClientUserState(this.lastUpdateTimestamp === 0 ? (0, $7Knxl.ClientUserState).NEW : (0, $7Knxl.ClientUserState).SAME);
            }
        },
        {
            key: "updateMetadataOnRequestComplete",
            value: function updateMetadataOnRequestComplete() {
                if (this.failureCount) // when current fetch failed, next fetch will be a RETRY
                // the calling user has not changed
                this.metadataManager.updateClientCauseReason((0, $7Knxl.ClientCauseReason).RETRY);
                else {
                    // when current fetch success, next fetch will be a POLLING
                    // and the calling user will be SAME user
                    this.metadataManager.updateClientCauseReason((0, $7Knxl.ClientCauseReason).POLLING);
                    this.metadataManager.updateClientUserState((0, $7Knxl.ClientUserState).SAME);
                }
            }
        },
        {
            key: "calculateInterval",
            value: function calculateInterval() {
                var _this$getPollingConfi = this.getPollingConfig(), interval = _this$getPollingConfi.interval, tabHiddenPollingFactor = _this$getPollingConfi.tabHiddenPollingFactor, minWaitInterval = _this$getPollingConfi.minWaitInterval, maxWaitInterval = _this$getPollingConfi.maxWaitInterval, backOffFactor = _this$getPollingConfi.backOffFactor, backOffJitter = _this$getPollingConfi.backOffJitter, maxInstantRetryTimes = _this$getPollingConfi.maxInstantRetryTimes;
                if (maxInstantRetryTimes !== undefined && maxInstantRetryTimes !== 0 && maxInstantRetryTimes >= this.failureCount) return 0;
                if (this.failureCount === 0) return Refresh.isTabHidden() ? interval * tabHiddenPollingFactor : interval;
                var ms = minWaitInterval * Math.pow(backOffFactor, this.failureCount - 1);
                if (backOffJitter) {
                    var rand = Math.random();
                    var deviation = Math.floor(rand * backOffJitter * ms);
                    if (Math.floor(rand * 10) < 5) ms -= deviation;
                    else ms += deviation;
                }
                return Number(Math.min(ms, maxWaitInterval));
            }
        },
        {
            key: "getPollingConfig",
            value: function getPollingConfig() {
                if (this.version === undefined && this.lastUpdateTimestamp === 0) return this.noCachePollingConfig;
                return this.pollingConfig;
            }
        }
    ], [
        {
            key: "isTabHidden",
            value: function isTabHidden() {
                return document.visibilityState === "hidden";
            }
        }
    ]);
    return Refresh;
}();

});
parcelRegister("26ULl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18982c29796df217$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $9m7Dh = parcelRequire("9m7Dh");

var $2sWVC = parcelRequire("2sWVC");

var $2wrqf = parcelRequire("2wrqf");
var $18982c29796df217$var$REQUEST_TIMEOUT = 2000;
var $18982c29796df217$var$PROD_FEDRAMP_BASE_URL = "https://api.atlassian-us-gov-mod.com/flags";
var $18982c29796df217$var$PROD_BASE_URL = "https://api.atlassian.com/flags";
var $18982c29796df217$var$STAGING_FEDRAMP_BASE_URL = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $18982c29796df217$var$STAGING_BASE_URL = "https://api.stg.atlassian.com/flags";
var $18982c29796df217$var$DEV_BASE_URL = "https://api.dev.atlassian.com/flags";
var $18982c29796df217$var$GATEWAY_BASE_URL = "/gateway/api/flags";
var $18982c29796df217$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher(apiKey) {
        var serviceEnv = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, $2sWVC.EnvironmentType).PROD;
        var baseUrl = arguments.length > 2 ? arguments[2] : undefined;
        var useGatewayURL = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var perimeter = arguments.length > 4 ? arguments[4] : undefined;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Fetcher);
        this.apiKey = apiKey;
        this.baseUrl = Fetcher.buildBaseUrl(serviceEnv, baseUrl, useGatewayURL, perimeter);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Fetcher, [
        {
            key: "fetchFeatureFlags",
            value: function() {
                var _fetchFeatureFlags = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(user, metadata, version) {
                    var requestBody, controller, timeoutId, response, successfulResponse;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                requestBody = {
                                    apiKey: this.apiKey,
                                    identifier: user.identifier,
                                    isAnonymous: user.isAnonymous,
                                    additionalIdentifiers: user.additionalIdentifiers,
                                    customAttributes: user.custom,
                                    versionData: version,
                                    metadata: metadata
                                }; // in case there are still IE users, check AbortController before init,
                                // IE has no timeout applied on fetch since AbortController isn't available
                                controller = typeof AbortController !== "undefined" ? new AbortController() : null;
                                timeoutId = setTimeout(function() {
                                    return controller === null || controller === void 0 ? void 0 : controller.abort();
                                }, $18982c29796df217$var$REQUEST_TIMEOUT);
                                _context.prev = 3;
                                _context.next = 6;
                                return fetch("".concat(this.baseUrl, "/api/").concat((0, $9m7Dh.CURRENT_FFS_API_VERSION), "/frontend/featureFlagValues"), {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": metadata.client.name,
                                        "X-Client-Version": metadata.client.version,
                                        "X-Api-Key": this.apiKey
                                    },
                                    body: JSON.stringify(requestBody),
                                    signal: controller === null || controller === void 0 ? void 0 : controller.signal
                                });
                            case 6:
                                response = _context.sent;
                                _context.next = 9;
                                return Fetcher.handleResponseError(response);
                            case 9:
                                successfulResponse = _context.sent;
                                return _context.abrupt("return", Fetcher.extractBody(successfulResponse));
                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context["catch"](3);
                                return _context.abrupt("return", Promise.reject(_context.t0));
                            case 16:
                                _context.prev = 16;
                                clearTimeout(timeoutId);
                                return _context.finish(16);
                            case 19:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            3,
                            13,
                            16,
                            19
                        ]
                    ]);
                }));
                function fetchFeatureFlags(_x, _x2, _x3) {
                    return _fetchFeatureFlags.apply(this, arguments);
                }
                return fetchFeatureFlags;
            }()
        }
    ], [
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                if (response.ok) {
                                    _context2.next = 5;
                                    break;
                                }
                                _context2.next = 3;
                                return response.text();
                            case 3:
                                body = _context2.sent;
                                throw new (0, $2wrqf.ResponseError)(response.status, body);
                            case 5:
                                return _context2.abrupt("return", response);
                            case 6:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2);
                }));
                function handleResponseError(_x4) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractBody",
            value: function() {
                var _extractBody = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(response) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (!(response.status === 204)) {
                                    _context3.next = 2;
                                    break;
                                }
                                return _context3.abrupt("return", {});
                            case 2:
                                return _context3.abrupt("return", response.text().then(function(text) {
                                    return JSON.parse(text || "{}");
                                }));
                            case 3:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function extractBody(_x5) {
                    return _extractBody.apply(this, arguments);
                }
                return extractBody;
            }()
        },
        {
            key: "buildBaseUrl",
            value: function buildBaseUrl(serviceEnv, baseUrl) {
                var useGatewayURL = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                var perimeter = arguments.length > 3 ? arguments[3] : undefined;
                if (baseUrl) return baseUrl;
                if (useGatewayURL) return $18982c29796df217$var$GATEWAY_BASE_URL;
                if (serviceEnv === (0, $2sWVC.EnvironmentType).DEV || serviceEnv === (0, $2sWVC.EnvironmentType).LOCAL) return $18982c29796df217$var$DEV_BASE_URL;
                if (serviceEnv === (0, $2sWVC.EnvironmentType).STAGING) {
                    if (perimeter === (0, $2sWVC.PerimeterType).FEDRAMP_MODERATE) return $18982c29796df217$var$STAGING_FEDRAMP_BASE_URL;
                    return $18982c29796df217$var$STAGING_BASE_URL;
                }
                if (serviceEnv === (0, $2sWVC.EnvironmentType).PROD && perimeter === (0, $2sWVC.PerimeterType).FEDRAMP_MODERATE) return $18982c29796df217$var$PROD_FEDRAMP_BASE_URL;
                return $18982c29796df217$var$PROD_BASE_URL;
            }
        }
    ]);
    return Fetcher;
}();

});
parcelRegister("2wrqf", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $1d63d76abb09bcd6$export$286baf652d0b1206; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5T1eV = parcelRequire("5T1eV");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $3Fq9h = parcelRequire("3Fq9h");
function $1d63d76abb09bcd6$var$_createSuper(t) {
    var r = $1d63d76abb09bcd6$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $1d63d76abb09bcd6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($1d63d76abb09bcd6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $1d63d76abb09bcd6$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(ResponseError, _Error);
    var _super = $1d63d76abb09bcd6$var$_createSuper(ResponseError);
    function ResponseError(status, body) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ResponseError);
        // Extending error requires this workaround, see https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        _this = _super.call(this, "Response Error: ".concat(status));
        Object.setPrototypeOf((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), ResponseError.prototype);
        _this._status = status;
        _this._body = body;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ResponseError, [
        {
            key: "status",
            get: function get() {
                return this._status;
            }
        },
        {
            key: "body",
            get: function get() {
                return this._body;
            }
        }
    ]);
    return ResponseError;
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3Fq9h)))(Error));

});


parcelRegister("8PlXg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $66d41de8bacf6157$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $8igLI = parcelRequire("8igLI");

var $aHckM = parcelRequire("aHckM");
var $66d41de8bacf6157$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function MetadataManager(pollingConfig) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, MetadataManager);
        this.pollingSeconds = pollingConfig.interval / 1000;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(MetadataManager, [
        {
            key: "updateClientCauseReason",
            value: function updateClientCauseReason(reason) {
                this.clientCauseReason = reason;
            }
        },
        {
            key: "updateClientUserState",
            value: function updateClientUserState(state) {
                this.clientUserState = state;
            }
        },
        {
            key: "get",
            value: function get() {
                var metadata = {
                    client: {
                        name: "feature-flag-web-client",
                        version: (0, $aHckM.version)
                    },
                    config: {
                        pollingSeconds: this.pollingSeconds
                    },
                    state: {
                        // Need to cast VisibilityState (type) to ClientVisibilityState (enum)
                        visibility: document.visibilityState,
                        storage: (0, $8igLI.default).getStorageStatus(),
                        userContext: this.clientUserState,
                        cause: this.clientCauseReason
                    }
                };
                return metadata;
            }
        }
    ]);
    return MetadataManager;
}();

});







parcelRegister("kQMDY", function(module, exports) {

$parcel$export(module.exports, "getPageLoadMetric", function () { return $359eacf0ab7b90aa$export$74b8bc7a2c5f037b; });

var $hZ7M7 = parcelRequire("hZ7M7");
const $359eacf0ab7b90aa$var$cachedMetrics = new Map();
const $359eacf0ab7b90aa$export$74b8bc7a2c5f037b = (pageId)=>{
    // Convert to kebab case to comply with naming convention:
    // https://hello.atlassian.net/wiki/spaces/APD/pages/1435310934/RUNBOOK+Get+the+Experience+Event+Key#Naming-conventions
    const page = pageId.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[\s_]+/g, "-").toLowerCase();
    let metric = $359eacf0ab7b90aa$var$cachedMetrics.get(page);
    if (!metric) {
        metric = (0, $hZ7M7.metrics).pageLoad({
            key: page
        });
        $359eacf0ab7b90aa$var$cachedMetrics.set(page, metric);
    }
    return metric;
};

});
parcelRegister("hZ7M7", function(module, exports) {

$parcel$export(module.exports, "metrics", function () { return $d17e2a21aa623649$export$b0c5c2fac8144e54; });

var $h5Ilp = parcelRequire("h5Ilp");

var $7t0cD = parcelRequire("7t0cD");
var $d17e2a21aa623649$export$b0c5c2fac8144e54 = {
    pageLoad: (0, $7t0cD.pageLoad),
    pageSegmentLoad: (0, $7t0cD.pageSegmentLoad),
    interaction: (0, $7t0cD.interaction),
    custom: (0, $7t0cD.custom),
    concurrent: (0, $h5Ilp.concurrent)
};

});
parcelRegister("h5Ilp", function(module, exports) {

$parcel$export(module.exports, "concurrent", function () { return $c7154d25447135d3$export$370df09ecc3de059; });

var $6bkHe = parcelRequire("6bkHe");

var $3GjBI = parcelRequire("3GjBI");

var $7t0cD = parcelRequire("7t0cD");
function $c7154d25447135d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c7154d25447135d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c7154d25447135d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c7154d25447135d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c7154d25447135d3$var$concurrentMetrics = {};
var $c7154d25447135d3$var$getKey = function getKey(config, type) {
    return "".concat(type, "--").concat(config.key);
};
var $c7154d25447135d3$var$validateConfig = function validateConfig(config) {
    if (config.include) throw new Error('"include" is not supported in concurrent actions');
    if (config.until) throw new Error('"until" is not supported in concurrent actions');
};
var $c7154d25447135d3$var$ensurePath = function ensurePath(config, type) {
    var key = $c7154d25447135d3$var$getKey(config, type);
    if (!(key in $c7154d25447135d3$var$concurrentMetrics)) $c7154d25447135d3$var$concurrentMetrics[key] = {};
};
var $c7154d25447135d3$var$getMetricFromCache = function getMetricFromCache(concurrentId, config, type) {
    var concurrentKey = $c7154d25447135d3$var$getKey(config, type);
    if (concurrentKey in $c7154d25447135d3$var$concurrentMetrics && $c7154d25447135d3$var$concurrentMetrics[concurrentKey][String(concurrentId)]) return $c7154d25447135d3$var$concurrentMetrics[concurrentKey][String(concurrentId)];
    if (!(concurrentKey in $c7154d25447135d3$var$concurrentMetrics)) $c7154d25447135d3$var$concurrentMetrics[concurrentKey] = {};
};
var $c7154d25447135d3$var$makeConcurrentMetric = function makeConcurrentMetric(concurrentId, config, type) {
    $c7154d25447135d3$var$validateConfig(config);
    $c7154d25447135d3$var$ensurePath(config, type);
    var metricFromCache = $c7154d25447135d3$var$getMetricFromCache(concurrentId, config, type);
    if (metricFromCache) return metricFromCache;
    var metricFactory = type === (0, $3GjBI.BMEventsType).INLINE_RESULT ? (0, $7t0cD.interaction) : (0, $7t0cD.custom);
    var metric = metricFactory(config);
    $c7154d25447135d3$var$concurrentMetrics[$c7154d25447135d3$var$getKey(config, type)][String(concurrentId)] = metric;
    return metric;
};
var $c7154d25447135d3$export$370df09ecc3de059 = {
    pageSegmentLoad: function pageSegmentLoad(config) {
        return function(concurrentId) {
            return $c7154d25447135d3$var$makeConcurrentMetric(concurrentId, $c7154d25447135d3$var$_objectSpread({}, config), (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD);
        };
    },
    interaction: function interaction(config) {
        return function(concurrentId) {
            return $c7154d25447135d3$var$makeConcurrentMetric(concurrentId, $c7154d25447135d3$var$_objectSpread({}, config), (0, $3GjBI.BMEventsType).INLINE_RESULT);
        };
    },
    custom: function custom(config) {
        return function(concurrentId) {
            return $c7154d25447135d3$var$makeConcurrentMetric(concurrentId, $c7154d25447135d3$var$_objectSpread({}, config), (0, $3GjBI.BMEventsType).CUSTOM);
        };
    }
};

});
parcelRegister("7t0cD", function(module, exports) {

$parcel$export(module.exports, "pageLoad", function () { return $56fb6620455df9e9$export$791d520f7e8058a5; });
$parcel$export(module.exports, "pageSegmentLoad", function () { return $56fb6620455df9e9$export$94114666844d5f66; });
$parcel$export(module.exports, "interaction", function () { return $56fb6620455df9e9$export$92473e6020ad89b4; });
$parcel$export(module.exports, "custom", function () { return $56fb6620455df9e9$export$4c00f665f0d4b443; });

var $6bkHe = parcelRequire("6bkHe");

var $gey0Z = parcelRequire("gey0Z");

var $ktpKo = parcelRequire("ktpKo");

var $irfSx = parcelRequire("irfSx");

var $3GjBI = parcelRequire("3GjBI");
function $56fb6620455df9e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $56fb6620455df9e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $56fb6620455df9e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $56fb6620455df9e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $56fb6620455df9e9$export$791d520f7e8058a5 = function pageLoad(config) {
    return new (0, $ktpKo.PageLoadMetric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).PAGE_LOAD
    }));
};
var $56fb6620455df9e9$export$94114666844d5f66 = function pageSegmentLoad(config) {
    return new (0, $irfSx.PageSegmentLoadMetric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).PAGE_SEGMENT_LOAD
    }));
};
var $56fb6620455df9e9$export$92473e6020ad89b4 = function interaction(config) {
    return new (0, $gey0Z.Metric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).INLINE_RESULT
    }));
};
var $56fb6620455df9e9$export$4c00f665f0d4b443 = function custom(config) {
    return new (0, $gey0Z.Metric)($56fb6620455df9e9$var$_objectSpread($56fb6620455df9e9$var$_objectSpread({}, config), {}, {
        type: (0, $3GjBI.BMEventsType).CUSTOM
    }));
};

});
parcelRegister("gey0Z", function(module, exports) {

$parcel$export(module.exports, "Metric", function () { return $bd1856cc44b38b75$export$efdd3e096bc27746; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $eqyfk = parcelRequire("eqyfk");

var $e1hkl = parcelRequire("e1hkl");

var $k6Eo3 = parcelRequire("k6Eo3");
function $bd1856cc44b38b75$var$_createSuper(t) {
    var r = $bd1856cc44b38b75$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $bd1856cc44b38b75$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($bd1856cc44b38b75$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $bd1856cc44b38b75$export$efdd3e096bc27746 = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(Metric, _BaseMetric);
    var _super = $bd1856cc44b38b75$var$_createSuper(Metric);
    function Metric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Metric);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Metric, [
        {
            key: "start",
            value: function start() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, startTime = _ref.startTime;
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(Metric.prototype), "start", this).call(this, {
                    startTime: startTime
                });
                this.route = (0, $eqyfk.Route).getRoute();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stoppedSuccessfully = (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(Metric.prototype), "stop", this).call(this, params);
                if (stoppedSuccessfully && !this.config.virtual) (0, $e1hkl.submitter).queue(this.getData());
                return stoppedSuccessfully;
            }
        }
    ]);
    return Metric;
}((0, $k6Eo3.BaseMetric));

});

parcelRegister("ktpKo", function(module, exports) {

$parcel$export(module.exports, "PageLoadMetric", function () { return $ee7a7cee80995e9b$export$3c51073271a9eac3; });

var $7f5qq = parcelRequire("7f5qq");

var $6bkHe = parcelRequire("6bkHe");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $5msJs = parcelRequire("5msJs");

var $1EyXZ = parcelRequire("1EyXZ");

var $1XCKE = parcelRequire("1XCKE");

var $eqyfk = parcelRequire("eqyfk");

var $e1hkl = parcelRequire("e1hkl");

var $3GjBI = parcelRequire("3GjBI");

var $h5wBz = parcelRequire("h5wBz");

var $5EyB3 = parcelRequire("5EyB3");

var $lY7Rr = parcelRequire("lY7Rr");
function $ee7a7cee80995e9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ee7a7cee80995e9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ee7a7cee80995e9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ee7a7cee80995e9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ee7a7cee80995e9b$var$_createSuper(t) {
    var r = $ee7a7cee80995e9b$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $ee7a7cee80995e9b$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ee7a7cee80995e9b$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ee7a7cee80995e9b$export$3c51073271a9eac3 = /*#__PURE__*/ function(_BasePageLoadMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(PageLoadMetric, _BasePageLoadMetric);
    var _super = $ee7a7cee80995e9b$var$_createSuper(PageLoadMetric);
    function PageLoadMetric() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PageLoadMetric);
        return _super.apply(this, arguments);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PageLoadMetric, [
        {
            key: "startPageLoad",
            value: function startPageLoad() {
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
                    isInitial: false
                };
                (0, $5EyB3.pageLoadMetaMetric).startPageLoad($ee7a7cee80995e9b$var$_objectSpread($ee7a7cee80995e9b$var$_objectSpread({}, params), {}, {
                    cancelStarted: "startTime" in params
                }));
                this.watchUntil();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var stopTime = params.stopTime || window.performance.now();
                var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getDataToMerge();
                var metaMetricStopped = (0, $5EyB3.pageLoadMetaMetric).stop(params);
                if (!metaMetricStopped) return false;
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[(0, $h5wBz.BasePageLoadMetric).FMP]) {
                        var mark = (0, $1EyXZ.SSRGetDoneMark).getDoneMark();
                        if (mark) (0, $5EyB3.pageLoadMetaMetric).markFMP(mark);
                    } else (0, $5EyB3.pageLoadMetaMetric).markFMP(this.marks[(0, $h5wBz.BasePageLoadMetric).FMP]);
                }
                this.route = (0, $eqyfk.Route).getRoute();
                var metricStopped = this.stopPageLoad(pageLoadData, $ee7a7cee80995e9b$var$_objectSpread($ee7a7cee80995e9b$var$_objectSpread({}, params), {}, {
                    stopTime: stopTime
                }));
                if (!metricStopped) return false;
                var data = this.getData();
                if (!this.config.virtual) (0, $e1hkl.submitter).queue(data);
                (0, $1XCKE.logger).logCond(!!this.config.debug, "page-load", "stop", this.getData);
                this.enqueueWebVitals();
                return true;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                (0, $5EyB3.pageLoadMetaMetric).mark(_mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, $5EyB3.pageLoadMetaMetric).markFMP(timestamp);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var pageLoadMetaData = (0, $5EyB3.pageLoadMetaMetric).getData();
                return $ee7a7cee80995e9b$var$_objectSpread($ee7a7cee80995e9b$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageLoadMetric.prototype), "getData", this).call(this)), {}, {
                    // marks and explicitTimings are available only in pageLoadMeta
                    marks: pageLoadMetaData.marks,
                    explicitTimings: pageLoadMetaData.explicitTimings
                });
            }
        },
        {
            key: "enqueueWebVitals",
            value: function() {
                var _enqueueWebVitals = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee() {
                    var _configChunk$BMEvents;
                    var configChunk, webVitalMetric;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(this.config.virtual || !this.isInitial)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 2:
                                _context.next = 4;
                                return (0, $e1hkl.submitter).config.configChunk;
                            case 4:
                                configChunk = _context.sent;
                                if (configChunk !== null && configChunk !== void 0 && (_configChunk$BMEvents = configChunk[(0, $3GjBI.BMEventsType).WEB_VITALS].webVitals) !== null && _configChunk$BMEvents !== void 0 && _configChunk$BMEvents.enabled) {
                                    _context.next = 7;
                                    break;
                                }
                                return _context.abrupt("return", false);
                            case 7:
                                webVitalMetric = new (0, $lY7Rr.WebVitalsMetric)({
                                    key: this.config.key,
                                    route: this.route,
                                    startTime: this.startTime,
                                    stopTime: this.stopTime,
                                    pageVisibleState: this.pageVisibleState
                                });
                                (0, $e1hkl.submitter).queue(webVitalMetric.getData());
                                (0, $1XCKE.logger).logCond(!!this.config.debug, "web-vitals", webVitalMetric.getData);
                                return _context.abrupt("return", true);
                            case 11:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function enqueueWebVitals() {
                    return _enqueueWebVitals.apply(this, arguments);
                }
                return enqueueWebVitals;
            }()
        }
    ]);
    return PageLoadMetric;
}((0, $h5wBz.BasePageLoadMetric));

});
parcelRegister("lY7Rr", function(module, exports) {

$parcel$export(module.exports, "WebVitalsMetric", function () { return $ffe54c9d8566e3f6$export$dc0d85d4d6503cd7; });

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $3GjBI = parcelRequire("3GjBI");

var $k6Eo3 = parcelRequire("k6Eo3");
function $ffe54c9d8566e3f6$var$_createSuper(t) {
    var r = $ffe54c9d8566e3f6$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $ffe54c9d8566e3f6$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ffe54c9d8566e3f6$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ffe54c9d8566e3f6$export$dc0d85d4d6503cd7 = /*#__PURE__*/ function(_BaseMetric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(WebVitalsMetric, _BaseMetric);
    var _super = $ffe54c9d8566e3f6$var$_createSuper(WebVitalsMetric);
    function WebVitalsMetric(_ref) {
        var _this;
        var key = _ref.key, route = _ref.route, startTime = _ref.startTime, stopTime = _ref.stopTime, pageVisibleState = _ref.pageVisibleState;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, WebVitalsMetric);
        _this = _super.call(this, {
            type: (0, $3GjBI.BMEventsType).WEB_VITALS,
            key: key
        });
        _this.route = route;
        _this.startTime = startTime;
        _this.stopTime = stopTime;
        _this.state = (0, $k6Eo3.MetricState).FINISHED;
        _this.pageVisibleState = pageVisibleState;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(WebVitalsMetric);
}((0, $k6Eo3.BaseMetric));

});


parcelRegister("irfSx", function(module, exports) {

$parcel$export(module.exports, "PageSegmentLoadMetric", function () { return $d6c710ca3497cde9$export$24c8bfcd77494cc1; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5T1eV = parcelRequire("5T1eV");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $1EyXZ = parcelRequire("1EyXZ");

var $3GjBI = parcelRequire("3GjBI");

var $k6Eo3 = parcelRequire("k6Eo3");

var $gey0Z = parcelRequire("gey0Z");

var $5EyB3 = parcelRequire("5EyB3");
function $d6c710ca3497cde9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d6c710ca3497cde9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d6c710ca3497cde9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d6c710ca3497cde9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d6c710ca3497cde9$var$_createSuper(t) {
    var r = $d6c710ca3497cde9$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $d6c710ca3497cde9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d6c710ca3497cde9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d6c710ca3497cde9$export$24c8bfcd77494cc1 = /*#__PURE__*/ function(_Metric) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(PageSegmentLoadMetric, _Metric);
    var _super = $d6c710ca3497cde9$var$_createSuper(PageSegmentLoadMetric);
    function PageSegmentLoadMetric(config) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, PageSegmentLoadMetric);
        _this = _super.call(this, config);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "isInitial", true);
        _this.config = config;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(PageSegmentLoadMetric, [
        {
            key: "startFromPageLoad",
            value: function startFromPageLoad() {
                var _pageLoadMetaData$sta;
                var pageLoadMetaData = (0, $5EyB3.pageLoadMetaMetric).getData();
                this.start({
                    startTime: (_pageLoadMetaData$sta = pageLoadMetaData.start) !== null && _pageLoadMetaData$sta !== void 0 ? _pageLoadMetaData$sta : undefined
                });
                this.isInitial = pageLoadMetaData.isInitial;
                this.pageVisibleState = pageLoadMetaData.pageVisibleState;
            }
        },
        {
            key: "mark",
            value: function mark(_mark) {
                var timestamp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.performance.now();
                if (_mark === PageSegmentLoadMetric.FMP) return;
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "mark", this).call(this, _mark, timestamp);
            }
        },
        {
            key: "markFMP",
            value: function markFMP(timestamp) {
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "mark", this).call(this, PageSegmentLoadMetric.FMP, timestamp);
            }
        },
        {
            key: "getPageSegmentLoadData",
            value: function getPageSegmentLoadData() {
                return {
                    isInitial: this.isInitial
                };
            }
        },
        {
            key: "getData",
            value: function getData() {
                return $d6c710ca3497cde9$var$_objectSpread($d6c710ca3497cde9$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "getData", this).call(this)), this.getPageSegmentLoadData());
            }
        },
        {
            key: "getDataToMerge",
            value: function getDataToMerge() {
                return $d6c710ca3497cde9$var$_objectSpread($d6c710ca3497cde9$var$_objectSpread({}, (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "getDataToMerge", this).call(this)), this.getPageSegmentLoadData());
            }
        },
        {
            key: "merge",
            value: function merge(mergeData) {
                (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "merge", this).call(this, mergeData);
                this.isInitial = mergeData.isInitial;
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this$config$ssr, _this2 = this;
                var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var pageLoadData = (0, $5EyB3.pageLoadMetaMetric).getData();
                if (pageLoadData.isInitial && (_this$config$ssr = this.config.ssr) !== null && _this$config$ssr !== void 0 && _this$config$ssr.doneAsFmp) {
                    if (!this.marks[PageSegmentLoadMetric.FMP]) {
                        var mark = (0, $1EyXZ.SSRGetDoneMark).getDoneMark();
                        if (mark) this.markFMP(mark);
                    }
                }
                if (this.config.includePageLoadTimings !== (0, $3GjBI.PageSegmentPageLoadMetricsOptions).WAIT_UNTIL_PRESENT || pageLoadData.state === (0, $k6Eo3.MetricState).FINISHED) return (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "stop", this).call(this, params);
                var now = performance.now();
                if (pageLoadData.state === (0, $k6Eo3.MetricState).STARTED) (0, $5EyB3.pageLoadMetaMetric).onStop(function() {
                    (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(PageSegmentLoadMetric.prototype), "stop", _this2).call(_this2, $d6c710ca3497cde9$var$_objectSpread($d6c710ca3497cde9$var$_objectSpread({}, params), {}, {
                        stopTime: params.stopTime || now
                    }));
                }, function() {
                    _this2.cancel();
                });
                return true;
            }
        }
    ]);
    return PageSegmentLoadMetric;
}((0, $gey0Z.Metric));
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($d6c710ca3497cde9$export$24c8bfcd77494cc1, "FMP", "fmp");

});








parcelRegister("gGDrC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c25f2a7418101254$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $iSD9t = parcelRequire("iSD9t");

var $7tq3X = parcelRequire("7tq3X");
function $c25f2a7418101254$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $67Ijb.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $67Ijb.__rest)(nextProps, [
        "values"
    ]);
    return (0, $7tq3X.shallowEqual)(nextValues, values) && (0, $7tq3X.shallowEqual)(otherProps, nextOtherProps);
}
function $c25f2a7418101254$var$FormattedMessage(props) {
    var intl = (0, $iSD9t.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $8ZuGG.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === "function") return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $8ZuGG.createElement(Component, null, $8ZuGG.Children.toArray(nodes));
    return $8ZuGG.createElement($8ZuGG.Fragment, null, nodes);
}
$c25f2a7418101254$var$FormattedMessage.displayName = "FormattedMessage";
var $c25f2a7418101254$var$MemoizedFormattedMessage = $8ZuGG.memo($c25f2a7418101254$var$FormattedMessage, $c25f2a7418101254$var$areEqual);
$c25f2a7418101254$var$MemoizedFormattedMessage.displayName = "MemoizedFormattedMessage";
var $c25f2a7418101254$export$2e2bcd8739ae039 = $c25f2a7418101254$var$MemoizedFormattedMessage;

});
parcelRegister("67Ijb", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $4755c441f34c720a$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $4755c441f34c720a$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $4755c441f34c720a$export$3c9a16f847548506; });
$parcel$export(module.exports, "__spreadArray", function () { return $4755c441f34c720a$export$1216008129fb82ed; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $4755c441f34c720a$var$extendStatics = function(d, b) {
    $4755c441f34c720a$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $4755c441f34c720a$var$extendStatics(d, b);
};
function $4755c441f34c720a$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $4755c441f34c720a$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $4755c441f34c720a$export$18ce0697a983be9b = function() {
    $4755c441f34c720a$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $4755c441f34c720a$export$18ce0697a983be9b.apply(this, arguments);
};
function $4755c441f34c720a$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $4755c441f34c720a$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $4755c441f34c720a$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $4755c441f34c720a$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $4755c441f34c720a$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $4755c441f34c720a$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $4755c441f34c720a$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $4755c441f34c720a$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $4755c441f34c720a$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $4755c441f34c720a$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $4755c441f34c720a$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $4755c441f34c720a$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $4755c441f34c720a$export$45d3717a4c69092e(o, m, p);
}
function $4755c441f34c720a$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $4755c441f34c720a$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $4755c441f34c720a$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($4755c441f34c720a$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $4755c441f34c720a$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $4755c441f34c720a$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $4755c441f34c720a$export$10c90e4f7922046c(v) {
    return this instanceof $4755c441f34c720a$export$10c90e4f7922046c ? (this.v = v, this) : new $4755c441f34c720a$export$10c90e4f7922046c(v);
}
function $4755c441f34c720a$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $4755c441f34c720a$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $4755c441f34c720a$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $4755c441f34c720a$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $4755c441f34c720a$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $4755c441f34c720a$export$19a8beecd37a4c45 === "function" ? $4755c441f34c720a$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $4755c441f34c720a$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $4755c441f34c720a$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $4755c441f34c720a$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4755c441f34c720a$export$45d3717a4c69092e(result, mod, k);
    }
    $4755c441f34c720a$var$__setModuleDefault(result, mod);
    return result;
}
function $4755c441f34c720a$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $4755c441f34c720a$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $4755c441f34c720a$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $4755c441f34c720a$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $4755c441f34c720a$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $4755c441f34c720a$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $4755c441f34c720a$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $4755c441f34c720a$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $4755c441f34c720a$export$2e2bcd8739ae039 = {
    __extends: $4755c441f34c720a$export$a8ba968b8961cb8a,
    __assign: $4755c441f34c720a$export$18ce0697a983be9b,
    __rest: $4755c441f34c720a$export$3c9a16f847548506,
    __decorate: $4755c441f34c720a$export$29e00dfd3077644b,
    __param: $4755c441f34c720a$export$d5ad3fd78186038f,
    __metadata: $4755c441f34c720a$export$f1db080c865becb9,
    __awaiter: $4755c441f34c720a$export$1050f835b63b671e,
    __generator: $4755c441f34c720a$export$67ebef60e6f28a6,
    __createBinding: $4755c441f34c720a$export$45d3717a4c69092e,
    __exportStar: $4755c441f34c720a$export$f33643c0debef087,
    __values: $4755c441f34c720a$export$19a8beecd37a4c45,
    __read: $4755c441f34c720a$export$8d051b38c9118094,
    __spread: $4755c441f34c720a$export$afc72e2116322959,
    __spreadArrays: $4755c441f34c720a$export$6388937ca91ccae8,
    __spreadArray: $4755c441f34c720a$export$1216008129fb82ed,
    __await: $4755c441f34c720a$export$10c90e4f7922046c,
    __asyncGenerator: $4755c441f34c720a$export$e427f37a30a4de9b,
    __asyncDelegator: $4755c441f34c720a$export$bbd80228419bb833,
    __asyncValues: $4755c441f34c720a$export$e3b29a3d6162315f,
    __makeTemplateObject: $4755c441f34c720a$export$4fb47efe1390b86f,
    __importStar: $4755c441f34c720a$export$c21735bcef00d192,
    __importDefault: $4755c441f34c720a$export$da59b14a69baef04,
    __classPrivateFieldGet: $4755c441f34c720a$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $4755c441f34c720a$export$d40a35129aaff81f,
    __classPrivateFieldIn: $4755c441f34c720a$export$81fdc39f203e4e04,
    __addDisposableResource: $4755c441f34c720a$export$88ac25d8e944e405,
    __disposeResources: $4755c441f34c720a$export$8f076105dc360e92
};

});

parcelRegister("iSD9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbeba3e564b77d86$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $aqUEs = parcelRequire("aqUEs");

var $7tq3X = parcelRequire("7tq3X");
function $dbeba3e564b77d86$export$2e2bcd8739ae039() {
    var intl = $8ZuGG.useContext((0, $aqUEs.Context));
    (0, $7tq3X.invariantIntlContext)(intl);
    return intl;
}

});
parcelRegister("aqUEs", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $798846e583df1767$export$2881499e37b75b9a; });
$parcel$export(module.exports, "Context", function () { return $798846e583df1767$export$841858b892ce1f4c; });

var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $fiQA5 = parcelRequire("fiQA5");

var $7tq3X = parcelRequire("7tq3X");
function $798846e583df1767$var$getDisplayName(Component) {
    return Component.displayName || Component.name || "Component";
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $798846e583df1767$var$IntlContext = typeof window !== "undefined" && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $8ZuGG.createContext(null)) : $8ZuGG.createContext(null);
var $798846e583df1767$var$IntlConsumer = $798846e583df1767$var$IntlContext.Consumer, $798846e583df1767$var$IntlProvider = $798846e583df1767$var$IntlContext.Provider;
var $798846e583df1767$export$2881499e37b75b9a = $798846e583df1767$var$IntlProvider;
var $798846e583df1767$export$841858b892ce1f4c = $798846e583df1767$var$IntlContext;
function $798846e583df1767$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? "intl" : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $8ZuGG.createElement($798846e583df1767$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $7tq3X.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $8ZuGG.createElement(WrappedComponent, (0, $67Ijb.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($798846e583df1767$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))($8ZuGG.forwardRef(function(props, ref) {
        return $8ZuGG.createElement(WithIntl, (0, $67Ijb.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(WithIntl, WrappedComponent);
}

});
parcelRegister("7tq3X", function(module, exports) {

$parcel$export(module.exports, "invariantIntlContext", function () { return $570f755facdf1903$export$45c4bbf6e55bba1f; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $570f755facdf1903$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "assignUniqueKeysToParts", function () { return $570f755facdf1903$export$cfec03d26465fa63; });
$parcel$export(module.exports, "shallowEqual", function () { return $570f755facdf1903$export$d36bdfa510afb180; });

var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $7K6E3 = parcelRequire("7K6E3");

var $f8XZf = parcelRequire("f8XZf");
function $570f755facdf1903$export$45c4bbf6e55bba1f(intl) {
    (0, $7K6E3.invariant)(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $570f755facdf1903$export$b52f8d6fc0d47415 = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, (0, $f8XZf.DEFAULT_INTL_CONFIG)), {
    textComponent: $8ZuGG.Fragment
});
function $570f755facdf1903$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($8ZuGG.Children.toArray(parts));
    };
}
function $570f755facdf1903$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}

});
parcelRegister("7K6E3", function(module, exports) {

$parcel$export(module.exports, "invariant", function () { return $5a31fbde7b3ca162$export$f5708dca728d7177; });
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */ function $5a31fbde7b3ca162$export$f535bb00660c42db(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function $5a31fbde7b3ca162$export$76d90c956114f2c2(s, times) {
    if (typeof s.repeat === "function") return s.repeat(times);
    var arr = new Array(times);
    for(var i = 0; i < arr.length; i++)arr[i] = s;
    return arr.join("");
}
function $5a31fbde7b3ca162$export$489176b9ebc725cc(map, pl, field, value) {
    if (!map.get(pl)) map.set(pl, Object.create(null));
    var slots = map.get(pl);
    slots[field] = value;
}
function $5a31fbde7b3ca162$export$d21499e79b5c28e2(map, pl, props) {
    for(var _i = 0, _a = Object.keys(props); _i < _a.length; _i++){
        var k = _a[_i];
        $5a31fbde7b3ca162$export$489176b9ebc725cc(map, pl, k, props[k]);
    }
}
function $5a31fbde7b3ca162$export$3fae2929ed23c202(map, pl, field) {
    return $5a31fbde7b3ca162$export$ca4e2274c058dd9f(map, pl, field)[field];
}
function $5a31fbde7b3ca162$export$ca4e2274c058dd9f(map, pl) {
    var fields = [];
    for(var _i = 2; _i < arguments.length; _i++)fields[_i - 2] = arguments[_i];
    var slots = map.get(pl);
    if (!slots) throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    return fields.reduce(function(all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function $5a31fbde7b3ca162$export$25c75e09b890f24e(patternPart) {
    return patternPart.type === "literal";
}
function $5a31fbde7b3ca162$export$fdab3c20aae16ddf(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value
    });
}
function $5a31fbde7b3ca162$export$e4e12d57dd938668(target, name, value) {
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: true,
        writable: true,
        value: value
    });
}
var $5a31fbde7b3ca162$export$9049a02e759202e4 = /-u(?:-[0-9a-z]{2,8})+/gi;
function $5a31fbde7b3ca162$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}

});

parcelRegister("f8XZf", function(module, exports) {

$parcel$export(module.exports, "filterProps", function () { return $b06622817ee75087$export$d697c39a2985a4c; });
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", function () { return $b06622817ee75087$export$b52f8d6fc0d47415; });
$parcel$export(module.exports, "createIntlCache", function () { return $b06622817ee75087$export$51c4f4e973f2dc00; });
$parcel$export(module.exports, "createFormatters", function () { return $b06622817ee75087$export$c3f4cd5551df13fd; });
$parcel$export(module.exports, "getNamedFormat", function () { return $b06622817ee75087$export$4ee1db8ce44a209b; });

var $67Ijb = parcelRequire("67Ijb");
parcelRequire("jdODR");
var $ck9OU = parcelRequire("ck9OU");

var $gv1Yy = parcelRequire("gv1Yy");

var $eczN4 = parcelRequire("eczN4");
function $b06622817ee75087$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $b06622817ee75087$var$defaultErrorHandler = function(error) {};
var $b06622817ee75087$var$defaultWarnHandler = function(warning) {};
var $b06622817ee75087$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: "en",
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $b06622817ee75087$var$defaultErrorHandler,
    onWarn: $b06622817ee75087$var$defaultWarnHandler
};
function $b06622817ee75087$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $b06622817ee75087$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $b06622817ee75087$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $b06622817ee75087$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $gv1Yy.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b06622817ee75087$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $gv1Yy.strategies).variadic
    });
    var getNumberFormat = (0, $gv1Yy.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b06622817ee75087$var$createFastMemoizeCache(cache.number),
        strategy: (0, $gv1Yy.strategies).variadic
    });
    var getPluralRules = (0, $gv1Yy.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $67Ijb.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $b06622817ee75087$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $gv1Yy.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $gv1Yy.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $ck9OU.IntlMessageFormat)(message, locales, overrideFormats, (0, $67Ijb.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.message),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $gv1Yy.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $gv1Yy.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.list),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getDisplayNames: (0, $gv1Yy.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $b06622817ee75087$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $gv1Yy.strategies).variadic
        })
    };
}
function $b06622817ee75087$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $eczN4.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("jdODR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", function () { return (parcelRequire("f8FMY")).ErrorCode; });
$parcel$export(module.exports, "FormatError", function () { return (parcelRequire("f8FMY")).FormatError; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return (parcelRequire("gIvaJ")).isFormatXMLElementFn; });

$parcel$export(module.exports, "IntlMessageFormat", function () { return (parcelRequire("ck9OU")).IntlMessageFormat; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $ck9OU = parcelRequire("ck9OU");
parcelRequire("f8FMY");
parcelRequire("gIvaJ");
var $dfe683a875b0f3ae$export$2e2bcd8739ae039 = (0, $ck9OU.IntlMessageFormat);

});
parcelRegister("ck9OU", function(module, exports) {

$parcel$export(module.exports, "IntlMessageFormat", function () { return $8f8ef85f4dc8f292$export$d342343268debc40; });
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $67Ijb = parcelRequire("67Ijb");

var $c9zsJ = parcelRequire("c9zsJ");

var $gv1Yy = parcelRequire("gv1Yy");

var $gIvaJ = parcelRequire("gIvaJ");
// -- MessageFormat --------------------------------------------------------
function $8f8ef85f4dc8f292$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $8f8ef85f4dc8f292$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $8f8ef85f4dc8f292$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $67Ijb.__assign)({}, defaultConfig));
}
function $8f8ef85f4dc8f292$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $8f8ef85f4dc8f292$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $gv1Yy.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $8f8ef85f4dc8f292$var$createFastMemoizeCache(cache.number),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getDateTimeFormat: (0, $gv1Yy.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $8f8ef85f4dc8f292$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $gv1Yy.strategies).variadic
        }),
        getPluralRules: (0, $gv1Yy.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $67Ijb.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $8f8ef85f4dc8f292$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $gv1Yy.strategies).variadic
        })
    };
}
var $8f8ef85f4dc8f292$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $gIvaJ.PART_TYPE).literal || typeof all[all.length - 1] !== "string") all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || "";
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $gIvaJ.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === "string") {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError("IntlMessageFormat.__parse must be set to process `message` of type `string`");
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $67Ijb.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError("A message must be provided as a String or AST.");
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $8f8ef85f4dc8f292$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $8f8ef85f4dc8f292$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === "undefined") return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === "string" ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $c9zsJ.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: "currency"
            },
            percent: {
                style: "percent"
            }
        },
        date: {
            short: {
                month: "numeric",
                day: "numeric",
                year: "2-digit"
            },
            medium: {
                month: "short",
                day: "numeric",
                year: "numeric"
            },
            long: {
                month: "long",
                day: "numeric",
                year: "numeric"
            },
            full: {
                weekday: "long",
                month: "long",
                day: "numeric",
                year: "numeric"
            }
        },
        time: {
            short: {
                hour: "numeric",
                minute: "numeric"
            },
            medium: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric"
            },
            long: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            },
            full: {
                hour: "numeric",
                minute: "numeric",
                second: "numeric",
                timeZoneName: "short"
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("c9zsJ", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", function () { return (parcelRequire("9xfwH")).isArgumentElement; });
$parcel$export(module.exports, "isDateElement", function () { return (parcelRequire("9xfwH")).isDateElement; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return (parcelRequire("9xfwH")).isDateTimeSkeleton; });
$parcel$export(module.exports, "isLiteralElement", function () { return (parcelRequire("9xfwH")).isLiteralElement; });
$parcel$export(module.exports, "isNumberElement", function () { return (parcelRequire("9xfwH")).isNumberElement; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return (parcelRequire("9xfwH")).isNumberSkeleton; });
$parcel$export(module.exports, "isPluralElement", function () { return (parcelRequire("9xfwH")).isPluralElement; });
$parcel$export(module.exports, "isPoundElement", function () { return (parcelRequire("9xfwH")).isPoundElement; });
$parcel$export(module.exports, "isSelectElement", function () { return (parcelRequire("9xfwH")).isSelectElement; });
$parcel$export(module.exports, "isTagElement", function () { return (parcelRequire("9xfwH")).isTagElement; });
$parcel$export(module.exports, "isTimeElement", function () { return (parcelRequire("9xfwH")).isTimeElement; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("9xfwH")).TYPE; });

$parcel$export(module.exports, "parse", function () { return $8d91d56446ae4c21$export$98e6a39c04603d36; });

var $67Ijb = parcelRequire("67Ijb");

var $jfA3D = parcelRequire("jfA3D");

var $5lBAM = parcelRequire("5lBAM");

var $9xfwH = parcelRequire("9xfwH");
function $8d91d56446ae4c21$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $9xfwH.isSelectElement)(el) || (0, $9xfwH.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $8d91d56446ae4c21$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $9xfwH.isNumberElement)(el) && (0, $9xfwH.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $9xfwH.isDateElement)(el) || (0, $9xfwH.isTimeElement)(el)) && (0, $9xfwH.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $9xfwH.isTagElement)(el)) $8d91d56446ae4c21$var$pruneLocation(el.children);
    });
}
function $8d91d56446ae4c21$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $67Ijb.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $5lBAM.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $jfA3D.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $8d91d56446ae4c21$var$pruneLocation(result.val);
    return result.val;
}
var $8d91d56446ae4c21$export$d3c1bfa0f7d806e9 = (0, $5lBAM.Parser);

});
parcelRegister("jfA3D", function(module, exports) {

$parcel$export(module.exports, "ErrorKind", function () { return $e03b635226fde957$export$896afd8541959ee5; });
var $e03b635226fde957$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($e03b635226fde957$export$896afd8541959ee5 || ($e03b635226fde957$export$896afd8541959ee5 = {}));

});

parcelRegister("5lBAM", function(module, exports) {

$parcel$export(module.exports, "Parser", function () { return $3e4c12f47abf381d$export$7acfa6ed01010e37; });

var $67Ijb = parcelRequire("67Ijb");

var $jfA3D = parcelRequire("jfA3D");

var $9xfwH = parcelRequire("9xfwH");

var $flpAn = parcelRequire("flpAn");
parcelRequire("cyIiz");
var $dD2LQ = parcelRequire("dD2LQ");
var $dHvuO = parcelRequire("dHvuO");

var $6Vsua = parcelRequire("6Vsua");
var $3e4c12f47abf381d$var$_a;
var $3e4c12f47abf381d$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $flpAn.SPACE_SEPARATOR_REGEX).source, "*"));
var $3e4c12f47abf381d$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $flpAn.SPACE_SEPARATOR_REGEX).source, "*$"));
function $3e4c12f47abf381d$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $3e4c12f47abf381d$var$hasNativeStartsWith = !!String.prototype.startsWith && "_a".startsWith("a", 1);
var $3e4c12f47abf381d$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $3e4c12f47abf381d$var$hasNativeFromEntries = !!Object.fromEntries;
var $3e4c12f47abf381d$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $3e4c12f47abf381d$var$hasTrimStart = !!String.prototype.trimStart;
var $3e4c12f47abf381d$var$hasTrimEnd = !!String.prototype.trimEnd;
var $3e4c12f47abf381d$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $3e4c12f47abf381d$var$isSafeInteger = $3e4c12f47abf381d$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === "number" && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $3e4c12f47abf381d$var$re = $3e4c12f47abf381d$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y = (($3e4c12f47abf381d$var$_a = $3e4c12f47abf381d$var$re.exec("a")) === null || $3e4c12f47abf381d$var$_a === void 0 ? void 0 : $3e4c12f47abf381d$var$_a[0]) === "a";
} catch (_) {
    $3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $3e4c12f47abf381d$var$startsWith = $3e4c12f47abf381d$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $3e4c12f47abf381d$var$fromCodePoint = $3e4c12f47abf381d$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = "";
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + " is not a valid code point");
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $3e4c12f47abf381d$var$fromEntries = // native
$3e4c12f47abf381d$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $3e4c12f47abf381d$var$codePointAt = $3e4c12f47abf381d$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $3e4c12f47abf381d$var$trimStart = $3e4c12f47abf381d$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($3e4c12f47abf381d$var$SPACE_SEPARATOR_START_REGEX, "");
};
var $3e4c12f47abf381d$var$trimEnd = $3e4c12f47abf381d$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($3e4c12f47abf381d$var$SPACE_SEPARATOR_END_REGEX, "");
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $3e4c12f47abf381d$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $3e4c12f47abf381d$var$matchIdentifierAtIndex;
if ($3e4c12f47abf381d$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $3e4c12f47abf381d$var$IDENTIFIER_PREFIX_RE_1 = $3e4c12f47abf381d$var$RE("([^\\p{White_Space}\\p{Pattern_Syntax}]*)", "yu");
    $3e4c12f47abf381d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $3e4c12f47abf381d$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $3e4c12f47abf381d$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : "";
    };
} else // IE11
$3e4c12f47abf381d$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $3e4c12f47abf381d$var$codePointAt(s, index);
        if (c === undefined || $3e4c12f47abf381d$var$_isWhiteSpace(c) || $3e4c12f47abf381d$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $3e4c12f47abf381d$var$fromCodePoint.apply(void 0, match);
};
var $3e4c12f47abf381d$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error("parser can only be used once");
        return this.parseMessage(0, "", false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal")) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $9xfwH.TYPE).pound,
                    location: $3e4c12f47abf381d$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $jfA3D.ErrorKind).UNMATCHED_CLOSING_TAG, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $3e4c12f47abf381d$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf("/>")) // Self closing tag
        return {
            val: {
                type: (0, $9xfwH.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf(">")) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf("</")) {
                if (this.isEOF() || !$3e4c12f47abf381d$var$_isAlpha(this.char())) return this.error((0, $jfA3D.ErrorKind).INVALID_TAG, $3e4c12f47abf381d$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $jfA3D.ErrorKind).UNMATCHED_CLOSING_TAG, $3e4c12f47abf381d$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf(">")) return this.error((0, $jfA3D.ErrorKind).INVALID_TAG, $3e4c12f47abf381d$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $9xfwH.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $jfA3D.ErrorKind).UNCLOSED_TAG, $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $jfA3D.ErrorKind).INVALID_TAG, $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $3e4c12f47abf381d$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = "";
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $3e4c12f47abf381d$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $9xfwH.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$3e4c12f47abf381d$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return "<";
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === "plural" || parentArgType === "selectordinal") break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $3e4c12f47abf381d$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === "plural" || parentArgType === "selectordinal") || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $3e4c12f47abf381d$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $jfA3D.ErrorKind).EMPTY_ARGUMENT, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $jfA3D.ErrorKind).MALFORMED_ARGUMENT, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $9xfwH.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $jfA3D.ErrorKind).MALFORMED_ARGUMENT, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $3e4c12f47abf381d$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $3e4c12f47abf381d$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case "":
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_TYPE, $3e4c12f47abf381d$var$createLocation(typeStartPosition, typeEndPosition));
            case "number":
            case "date":
            case "time":
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(",")) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $3e4c12f47abf381d$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_STYLE, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $3e4c12f47abf381d$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $3e4c12f47abf381d$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, "::", 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $3e4c12f47abf381d$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === "number") {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $9xfwH.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $jfA3D.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $6Vsua.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $9xfwH.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $dD2LQ.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === "date" ? (0, $9xfwH.TYPE).date : (0, $9xfwH.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === "number" ? (0, $9xfwH.TYPE).number : argType === "date" ? (0, $9xfwH.TYPE).date : (0, $9xfwH.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case "plural":
            case "selectordinal":
            case "select":
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(",")) return this.error((0, $jfA3D.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $3e4c12f47abf381d$var$createLocation(typeEndPosition_1, (0, $67Ijb.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== "select" && identifierAndLocation.value === "offset") {
                    if (!this.bumpIf(":")) return this.error((0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $jfA3D.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === "select") return {
                    val: {
                        type: (0, $9xfwH.TYPE).select,
                        value: value,
                        options: $3e4c12f47abf381d$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $9xfwH.TYPE).plural,
                        value: value,
                        options: $3e4c12f47abf381d$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === "plural" ? "cardinal" : "ordinal",
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $jfA3D.ErrorKind).INVALID_ARGUMENT_TYPE, $3e4c12f47abf381d$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $jfA3D.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $jfA3D.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $3e4c12f47abf381d$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $dHvuO.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $jfA3D.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $9xfwH.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $dHvuO.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== "select" && this.bumpIf("=")) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $jfA3D.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $3e4c12f47abf381d$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === "select" ? (0, $jfA3D.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $jfA3D.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === "other") hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf("{")) return this.error(parentArgType === "select" ? (0, $jfA3D.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $3e4c12f47abf381d$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === "select" ? (0, $jfA3D.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $jfA3D.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $jfA3D.ErrorKind).MISSING_OTHER_CLAUSE, $3e4c12f47abf381d$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf("+")) ;
        else if (this.bumpIf("-")) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $3e4c12f47abf381d$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$3e4c12f47abf381d$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error("out of bound");
        var code = $3e4c12f47abf381d$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($3e4c12f47abf381d$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $3e4c12f47abf381d$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $3e4c12f47abf381d$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $3e4c12f47abf381d$var$_isAlphaOrSlash(codepoint) {
    return $3e4c12f47abf381d$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $3e4c12f47abf381d$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3e4c12f47abf381d$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $3e4c12f47abf381d$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("9xfwH", function(module, exports) {

$parcel$export(module.exports, "TYPE", function () { return $6f133d57d9eeaa00$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "SKELETON_TYPE", function () { return $6f133d57d9eeaa00$export$906452485466fa53; });
$parcel$export(module.exports, "isLiteralElement", function () { return $6f133d57d9eeaa00$export$cfa10c5697238752; });
$parcel$export(module.exports, "isArgumentElement", function () { return $6f133d57d9eeaa00$export$4f55724281bdfaf9; });
$parcel$export(module.exports, "isNumberElement", function () { return $6f133d57d9eeaa00$export$e11187b219e191e1; });
$parcel$export(module.exports, "isDateElement", function () { return $6f133d57d9eeaa00$export$32d811605da75f40; });
$parcel$export(module.exports, "isTimeElement", function () { return $6f133d57d9eeaa00$export$34ec46f596b1702f; });
$parcel$export(module.exports, "isSelectElement", function () { return $6f133d57d9eeaa00$export$dcfe1c11d168b5a1; });
$parcel$export(module.exports, "isPluralElement", function () { return $6f133d57d9eeaa00$export$6c796d116f0a4fbc; });
$parcel$export(module.exports, "isPoundElement", function () { return $6f133d57d9eeaa00$export$c0ece297bdd0c082; });
$parcel$export(module.exports, "isTagElement", function () { return $6f133d57d9eeaa00$export$5c83de34745812b; });
$parcel$export(module.exports, "isNumberSkeleton", function () { return $6f133d57d9eeaa00$export$3f9a19cd4152eda3; });
$parcel$export(module.exports, "isDateTimeSkeleton", function () { return $6f133d57d9eeaa00$export$7680c41f1a55f4cf; });
var $6f133d57d9eeaa00$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($6f133d57d9eeaa00$export$b87f371cbc396fcf || ($6f133d57d9eeaa00$export$b87f371cbc396fcf = {}));
var $6f133d57d9eeaa00$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($6f133d57d9eeaa00$export$906452485466fa53 || ($6f133d57d9eeaa00$export$906452485466fa53 = {}));
function $6f133d57d9eeaa00$export$cfa10c5697238752(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.literal;
}
function $6f133d57d9eeaa00$export$4f55724281bdfaf9(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.argument;
}
function $6f133d57d9eeaa00$export$e11187b219e191e1(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.number;
}
function $6f133d57d9eeaa00$export$32d811605da75f40(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.date;
}
function $6f133d57d9eeaa00$export$34ec46f596b1702f(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.time;
}
function $6f133d57d9eeaa00$export$dcfe1c11d168b5a1(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.select;
}
function $6f133d57d9eeaa00$export$6c796d116f0a4fbc(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.plural;
}
function $6f133d57d9eeaa00$export$c0ece297bdd0c082(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.pound;
}
function $6f133d57d9eeaa00$export$5c83de34745812b(el) {
    return el.type === $6f133d57d9eeaa00$export$b87f371cbc396fcf.tag;
}
function $6f133d57d9eeaa00$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === "object" && el.type === $6f133d57d9eeaa00$export$906452485466fa53.number);
}
function $6f133d57d9eeaa00$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === "object" && el.type === $6f133d57d9eeaa00$export$906452485466fa53.dateTime);
}
function $6f133d57d9eeaa00$export$f0ac572c1121c662(value) {
    return {
        type: $6f133d57d9eeaa00$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $6f133d57d9eeaa00$export$425e864b0ba114f1(value, style) {
    return {
        type: $6f133d57d9eeaa00$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("flpAn", function(module, exports) {

$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", function () { return $b2bca9f36880188e$export$523451f94304dd6c; });
// @generated from regex-gen.ts
var $b2bca9f36880188e$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $b2bca9f36880188e$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("cyIiz", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return (parcelRequire("dD2LQ")).parseDateTimeSkeleton; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return (parcelRequire("dHvuO")).parseNumberSkeleton; });
$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return (parcelRequire("dHvuO")).parseNumberSkeletonFromString; });
parcelRequire("dD2LQ");
parcelRequire("dHvuO");

});
parcelRegister("dD2LQ", function(module, exports) {

$parcel$export(module.exports, "parseDateTimeSkeleton", function () { return $9ec111154ef35987$export$f7b99fb377fe69fa; });
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $9ec111154ef35987$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $9ec111154ef35987$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($9ec111154ef35987$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case "G":
                result.era = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            // Year
            case "y":
                result.year = len === 2 ? "2-digit" : "numeric";
                break;
            case "Y":
            case "u":
            case "U":
            case "r":
                throw new RangeError("`Y/u/U/r` (year) patterns are not supported, use `y` instead");
            // Quarter
            case "q":
            case "Q":
                throw new RangeError("`q/Q` (quarter) patterns are not supported");
            // Month
            case "M":
            case "L":
                result.month = [
                    "numeric",
                    "2-digit",
                    "short",
                    "long",
                    "narrow"
                ][len - 1];
                break;
            // Week
            case "w":
            case "W":
                throw new RangeError("`w/W` (week) patterns are not supported");
            case "d":
                result.day = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "D":
            case "F":
            case "g":
                throw new RangeError("`D/F/g` (day) patterns are not supported, use `d` instead");
            // Weekday
            case "E":
                result.weekday = len === 4 ? "long" : len === 5 ? "narrow" : "short";
                break;
            case "e":
                if (len < 4) throw new RangeError("`e..eee` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            case "c":
                if (len < 4) throw new RangeError("`c..ccc` (weekday) patterns are not supported");
                result.weekday = [
                    "short",
                    "long",
                    "narrow",
                    "short"
                ][len - 4];
                break;
            // Period
            case "a":
                result.hour12 = true;
                break;
            case "b":
            case "B":
                throw new RangeError("`b/B` (period) patterns are not supported, use `a` instead");
            // Hour
            case "h":
                result.hourCycle = "h12";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "H":
                result.hourCycle = "h23";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "K":
                result.hourCycle = "h11";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "k":
                result.hourCycle = "h24";
                result.hour = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "j":
            case "J":
            case "C":
                throw new RangeError("`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead");
            // Minute
            case "m":
                result.minute = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            // Second
            case "s":
                result.second = [
                    "numeric",
                    "2-digit"
                ][len - 1];
                break;
            case "S":
            case "A":
                throw new RangeError("`S/A` (second) patterns are not supported, use `s` instead");
            // Zone
            case "z":
                result.timeZoneName = len < 4 ? "short" : "long";
                break;
            case "Z":
            case "O":
            case "v":
            case "V":
            case "X":
            case "x":
                throw new RangeError("`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead");
        }
        return "";
    });
    return result;
}

});

parcelRegister("dHvuO", function(module, exports) {

$parcel$export(module.exports, "parseNumberSkeletonFromString", function () { return $9f97b8eee5fb553f$export$71cee2f16fba2480; });
$parcel$export(module.exports, "parseNumberSkeleton", function () { return $9f97b8eee5fb553f$export$47c6f8480bda3e11; });

var $67Ijb = parcelRequire("67Ijb");

var $kc2K8 = parcelRequire("kc2K8");
function $9f97b8eee5fb553f$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error("Number skeleton cannot be empty");
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $kc2K8.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split("/");
        if (stemAndOptions.length === 0) throw new Error("Invalid number skeleton");
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error("Invalid number skeleton");
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $9f97b8eee5fb553f$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, "");
}
var $9f97b8eee5fb553f$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $9f97b8eee5fb553f$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $9f97b8eee5fb553f$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $9f97b8eee5fb553f$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $9f97b8eee5fb553f$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === "r") result.roundingPriority = "morePrecision";
    else if (str[str.length - 1] === "s") result.roundingPriority = "lessPrecision";
    str.replace($9f97b8eee5fb553f$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== "string") {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === "+") result.minimumSignificantDigits = g1.length;
        else if (g1[0] === "#") result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === "string" ? g2.length : 0);
        }
        return "";
    });
    return result;
}
function $9f97b8eee5fb553f$var$parseSign(str) {
    switch(str){
        case "sign-auto":
            return {
                signDisplay: "auto"
            };
        case "sign-accounting":
        case "()":
            return {
                currencySign: "accounting"
            };
        case "sign-always":
        case "+!":
            return {
                signDisplay: "always"
            };
        case "sign-accounting-always":
        case "()!":
            return {
                signDisplay: "always",
                currencySign: "accounting"
            };
        case "sign-except-zero":
        case "+?":
            return {
                signDisplay: "exceptZero"
            };
        case "sign-accounting-except-zero":
        case "()?":
            return {
                signDisplay: "exceptZero",
                currencySign: "accounting"
            };
        case "sign-never":
        case "+_":
            return {
                signDisplay: "never"
            };
    }
}
function $9f97b8eee5fb553f$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === "E" && stem[1] === "E") {
        result = {
            notation: "engineering"
        };
        stem = stem.slice(2);
    } else if (stem[0] === "E") {
        result = {
            notation: "scientific"
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === "+!") {
            result.signDisplay = "always";
            stem = stem.slice(2);
        } else if (signDisplay === "+?") {
            result.signDisplay = "exceptZero";
            stem = stem.slice(2);
        }
        if (!$9f97b8eee5fb553f$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error("Malformed concise eng/scientific notation");
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $9f97b8eee5fb553f$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $9f97b8eee5fb553f$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $9f97b8eee5fb553f$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case "percent":
            case "%":
                result.style = "percent";
                continue;
            case "%x100":
                result.style = "percent";
                result.scale = 100;
                continue;
            case "currency":
                result.style = "currency";
                result.currency = token.options[0];
                continue;
            case "group-off":
            case ",_":
                result.useGrouping = false;
                continue;
            case "precision-integer":
            case ".":
                result.maximumFractionDigits = 0;
                continue;
            case "measure-unit":
            case "unit":
                result.style = "unit";
                result.unit = $9f97b8eee5fb553f$var$icuUnitToEcma(token.options[0]);
                continue;
            case "compact-short":
            case "K":
                result.notation = "compact";
                result.compactDisplay = "short";
                continue;
            case "compact-long":
            case "KK":
                result.notation = "compact";
                result.compactDisplay = "long";
                continue;
            case "scientific":
                result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), {
                    notation: "scientific"
                }), token.options.reduce(function(all, opt) {
                    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, all), $9f97b8eee5fb553f$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "engineering":
                result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), {
                    notation: "engineering"
                }), token.options.reduce(function(all, opt) {
                    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, all), $9f97b8eee5fb553f$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case "notation-simple":
                result.notation = "standard";
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case "unit-width-narrow":
                result.currencyDisplay = "narrowSymbol";
                result.unitDisplay = "narrow";
                continue;
            case "unit-width-short":
                result.currencyDisplay = "code";
                result.unitDisplay = "short";
                continue;
            case "unit-width-full-name":
                result.currencyDisplay = "name";
                result.unitDisplay = "long";
                continue;
            case "unit-width-iso-code":
                result.currencyDisplay = "symbol";
                continue;
            case "scale":
                result.scale = parseFloat(token.options[0]);
                continue;
            case "rounding-mode-floor":
                result.roundingMode = "floor";
                continue;
            case "rounding-mode-ceiling":
                result.roundingMode = "ceil";
                continue;
            case "rounding-mode-down":
                result.roundingMode = "trunc";
                continue;
            case "rounding-mode-up":
                result.roundingMode = "expand";
                continue;
            case "rounding-mode-half-even":
                result.roundingMode = "halfEven";
                continue;
            case "rounding-mode-half-down":
                result.roundingMode = "halfTrunc";
                continue;
            case "rounding-mode-half-up":
                result.roundingMode = "halfExpand";
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case "integer-width":
                if (token.options.length > 1) throw new RangeError("integer-width stems only accept a single optional option");
                token.options[0].replace($9f97b8eee5fb553f$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error("We currently do not support maximum integer digits");
                    else if (g5) throw new Error("We currently do not support exact integer digits");
                    return "";
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($9f97b8eee5fb553f$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($9f97b8eee5fb553f$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError("Fraction-precision stems only accept a single optional option");
            token.stem.replace($9f97b8eee5fb553f$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === "*") result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === "#") result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return "";
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === "w") result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), {
                trailingZeroDisplay: "stripIfInteger"
            });
            else if (opt) result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), $9f97b8eee5fb553f$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($9f97b8eee5fb553f$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), $9f97b8eee5fb553f$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $9f97b8eee5fb553f$var$parseSign(token.stem);
        if (signOpts) result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $9f97b8eee5fb553f$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("kc2K8", function(module, exports) {

$parcel$export(module.exports, "WHITE_SPACE_REGEX", function () { return $eb370e5938ac123f$export$2b8db14d8bcaece7; });
// @generated from regex-gen.ts
var $eb370e5938ac123f$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("6Vsua", function(module, exports) {

$parcel$export(module.exports, "getBestPattern", function () { return $50ae2995bc40116c$export$29c5368be8904d27; });

var $8BB2d = parcelRequire("8BB2d");
function $50ae2995bc40116c$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = "";
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === "j") {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = "a";
            var hourChar = $50ae2995bc40116c$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == "H" || hourChar == "k") dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === "J") skeletonCopy += "H";
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $50ae2995bc40116c$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case "h24":
            return "k";
        case "h23":
            return "H";
        case "h12":
            return "h";
        case "h11":
            return "K";
        default:
            throw new Error("Invalid hourCycle");
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== "root") regionTag = locale.maximize().region;
    var hourCycles = (0, $8BB2d.timeData)[regionTag || ""] || (0, $8BB2d.timeData)[languageTag || ""] || (0, $8BB2d.timeData)["".concat(languageTag, "-001")] || (0, $8BB2d.timeData)["001"];
    return hourCycles[0];
}

});
parcelRegister("8BB2d", function(module, exports) {

$parcel$export(module.exports, "timeData", function () { return $643e81c68df697a3$export$a8c9209db4084317; });
// @generated from time-data-gen.ts
// prettier-ignore  
var $643e81c68df697a3$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});




parcelRegister("gv1Yy", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $c03112e7fee4dee7$export$fc10aeed3a532e2a; });
$parcel$export(module.exports, "strategies", function () { return $c03112e7fee4dee7$export$c5491a8691a23b9e; });
//
// Main
//
function $c03112e7fee4dee7$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $c03112e7fee4dee7$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $c03112e7fee4dee7$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $c03112e7fee4dee7$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $c03112e7fee4dee7$var$isPrimitive(value) {
    return value == null || typeof value === "number" || typeof value === "boolean"; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $c03112e7fee4dee7$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $c03112e7fee4dee7$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c03112e7fee4dee7$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === "undefined") {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $c03112e7fee4dee7$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $c03112e7fee4dee7$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $c03112e7fee4dee7$var$monadic : $c03112e7fee4dee7$var$variadic;
    return $c03112e7fee4dee7$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $c03112e7fee4dee7$var$strategyVariadic(fn, options) {
    return $c03112e7fee4dee7$var$assemble(fn, this, $c03112e7fee4dee7$var$variadic, options.cache.create(), options.serializer);
}
function $c03112e7fee4dee7$var$strategyMonadic(fn, options) {
    return $c03112e7fee4dee7$var$assemble(fn, this, $c03112e7fee4dee7$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $c03112e7fee4dee7$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
function $c03112e7fee4dee7$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$c03112e7fee4dee7$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$c03112e7fee4dee7$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $c03112e7fee4dee7$var$cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new $c03112e7fee4dee7$var$ObjectWithoutPrototypeCache();
    }
};
var $c03112e7fee4dee7$export$c5491a8691a23b9e = {
    variadic: $c03112e7fee4dee7$var$strategyVariadic,
    monadic: $c03112e7fee4dee7$var$strategyMonadic
};

});

parcelRegister("gIvaJ", function(module, exports) {

$parcel$export(module.exports, "PART_TYPE", function () { return $c2b8ef8a94f80586$export$49694c2877b44c57; });
$parcel$export(module.exports, "isFormatXMLElementFn", function () { return $c2b8ef8a94f80586$export$df0c12a2d414a163; });
$parcel$export(module.exports, "formatToParts", function () { return $c2b8ef8a94f80586$export$275d4a3bb5f66fda; });
parcelRequire("c9zsJ");
var $9xfwH = parcelRequire("9xfwH");

var $f8FMY = parcelRequire("f8FMY");
var $c2b8ef8a94f80586$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($c2b8ef8a94f80586$export$49694c2877b44c57 || ($c2b8ef8a94f80586$export$49694c2877b44c57 = {}));
function $c2b8ef8a94f80586$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $c2b8ef8a94f80586$export$49694c2877b44c57.literal || part.type !== $c2b8ef8a94f80586$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $c2b8ef8a94f80586$export$df0c12a2d414a163(el) {
    return typeof el === "function";
}
function $c2b8ef8a94f80586$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $9xfwH.isLiteralElement)(els[0])) return [
        {
            type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $9xfwH.isLiteralElement)(el)) {
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $9xfwH.isPoundElement)(el)) {
            if (typeof currentPluralValue === "number") result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $f8FMY.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $9xfwH.isArgumentElement)(el)) {
            if (!value || typeof value === "string" || typeof value === "number") value = typeof value === "string" || typeof value === "number" ? String(value) : "";
            result.push({
                type: typeof value === "string" ? $c2b8ef8a94f80586$export$49694c2877b44c57.literal : $c2b8ef8a94f80586$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $9xfwH.isDateElement)(el)) {
            var style = typeof el.style === "string" ? formats.date[el.style] : (0, $9xfwH.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $9xfwH.isTimeElement)(el)) {
            var style = typeof el.style === "string" ? formats.time[el.style] : (0, $9xfwH.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $9xfwH.isNumberElement)(el)) {
            var style = typeof el.style === "string" ? formats.number[el.style] : (0, $9xfwH.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $c2b8ef8a94f80586$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $9xfwH.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$c2b8ef8a94f80586$export$df0c12a2d414a163(formatFn)) throw new (0, $f8FMY.InvalidValueTypeError)(value_1, "function", originalMessage);
            var parts = $c2b8ef8a94f80586$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === "string" ? $c2b8ef8a94f80586$export$49694c2877b44c57.literal : $c2b8ef8a94f80586$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $9xfwH.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $f8FMY.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c2b8ef8a94f80586$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $9xfwH.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $f8FMY.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $f8FMY.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $f8FMY.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $c2b8ef8a94f80586$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $c2b8ef8a94f80586$var$mergeLiteral(result);
}

});
parcelRegister("f8FMY", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", function () { return $b05804c0e9d00735$export$d4e71bc0b80dc0fb; });
$parcel$export(module.exports, "FormatError", function () { return $b05804c0e9d00735$export$7369836851cc1329; });
$parcel$export(module.exports, "InvalidValueError", function () { return $b05804c0e9d00735$export$565c3afc07dfa382; });
$parcel$export(module.exports, "InvalidValueTypeError", function () { return $b05804c0e9d00735$export$cbc0db47c750f7c9; });
$parcel$export(module.exports, "MissingValueError", function () { return $b05804c0e9d00735$export$8bfc137e4d23fdf0; });

var $67Ijb = parcelRequire("67Ijb");
var $b05804c0e9d00735$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($b05804c0e9d00735$export$d4e71bc0b80dc0fb || ($b05804c0e9d00735$export$d4e71bc0b80dc0fb = {}));
var $b05804c0e9d00735$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $b05804c0e9d00735$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, 'Invalid values for "'.concat(variableId, '": "').concat(value, '". Options are "').concat(Object.keys(options).join('", "'), '"'), $b05804c0e9d00735$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($b05804c0e9d00735$export$7369836851cc1329);
var $b05804c0e9d00735$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, 'Value for "'.concat(value, '" must be of type ').concat(type), $b05804c0e9d00735$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($b05804c0e9d00735$export$7369836851cc1329);
var $b05804c0e9d00735$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, 'The intl string context variable "'.concat(variableId, '" was not provided to the string "').concat(originalMessage, '"'), $b05804c0e9d00735$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($b05804c0e9d00735$export$7369836851cc1329);

});




parcelRegister("eczN4", function(module, exports) {

$parcel$export(module.exports, "UnsupportedFormatterError", function () { return $a56df2ead684ea09$export$549f97e137a05c90; });
$parcel$export(module.exports, "InvalidConfigError", function () { return $a56df2ead684ea09$export$3ca04dd7fb305893; });
$parcel$export(module.exports, "MissingDataError", function () { return $a56df2ead684ea09$export$c1eaf877d81384b6; });
$parcel$export(module.exports, "IntlFormatError", function () { return $a56df2ead684ea09$export$e3b7eee1dbc44895; });
$parcel$export(module.exports, "MessageFormatError", function () { return $a56df2ead684ea09$export$74a601a3d3f31621; });
$parcel$export(module.exports, "MissingTranslationError", function () { return $a56df2ead684ea09$export$2ddcb436d0aa3688; });

var $67Ijb = parcelRequire("67Ijb");
var $a56df2ead684ea09$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($a56df2ead684ea09$export$557d6acb76e8a244 || ($a56df2ead684ea09$export$557d6acb76e8a244 = {}));
var $a56df2ead684ea09$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : "")) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === "function") // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $a56df2ead684ea09$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);
var $a56df2ead684ea09$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($a56df2ead684ea09$export$e3b7eee1dbc44895);
var $a56df2ead684ea09$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $a56df2ead684ea09$export$557d6acb76e8a244.MISSING_TRANSLATION, 'Missing message: "'.concat(descriptor.id, '" for locale "').concat(locale, '", using ').concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === "string" ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : "id", " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($a56df2ead684ea09$export$c016d36112f6ddf8);

});







parcelRegister("3VrrU", function(module, exports) {

$parcel$export(module.exports, "defineMessages", function () { return $2dbbfcca6e7db2d0$export$1adfeb024f5185b; });

var $h5j41 = parcelRequire("h5j41");


var $iSD9t = parcelRequire("iSD9t");

var $4OQoZ = parcelRequire("4OQoZ");




var $gGDrC = parcelRequire("gGDrC");


function $2dbbfcca6e7db2d0$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $2dbbfcca6e7db2d0$export$747d244ee58120dd(msg) {
    return msg;
}
var $2dbbfcca6e7db2d0$export$40ae3194919d16b = (0, $h5j41.createFormattedComponent)("formatDate");
var $2dbbfcca6e7db2d0$export$5b390a54f8a846f7 = (0, $h5j41.createFormattedComponent)("formatTime");
var $2dbbfcca6e7db2d0$export$db80edc1e6b2f63d = (0, $h5j41.createFormattedComponent)("formatNumber");
var $2dbbfcca6e7db2d0$export$f52b44e459e6e71d = (0, $h5j41.createFormattedComponent)("formatList");
var $2dbbfcca6e7db2d0$export$c2336ea5aaab92fa = (0, $h5j41.createFormattedComponent)("formatDisplayName");
var $2dbbfcca6e7db2d0$export$7fdc7d2c91ce149b = (0, $h5j41.createFormattedDateTimePartsComponent)("formatDate");
var $2dbbfcca6e7db2d0$export$ec35873761676c2a = (0, $h5j41.createFormattedDateTimePartsComponent)("formatTime");

});
parcelRegister("h5j41", function(module, exports) {

$parcel$export(module.exports, "createFormattedDateTimePartsComponent", function () { return $c701b101618df8e9$export$7448277f6036d2ab; });
$parcel$export(module.exports, "createFormattedComponent", function () { return $c701b101618df8e9$export$b37e14176d001dec; });

var $67Ijb = parcelRequire("67Ijb");

var $8ZuGG = parcelRequire("8ZuGG");

var $iSD9t = parcelRequire("iSD9t");
var $c701b101618df8e9$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($c701b101618df8e9$var$DisplayName || ($c701b101618df8e9$var$DisplayName = {}));
var $c701b101618df8e9$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($c701b101618df8e9$var$DisplayNameParts || ($c701b101618df8e9$var$DisplayNameParts = {}));
var $c701b101618df8e9$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $iSD9t.default)();
    var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$c701b101618df8e9$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
var $c701b101618df8e9$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $iSD9t.default)();
    var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$c701b101618df8e9$export$54d4989ed3eea1ea.displayName = "FormattedNumberParts";
function $c701b101618df8e9$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $iSD9t.default)();
        var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === "string" ? new Date(value || 0) : value;
        var formattedParts = name === "formatDate" ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $c701b101618df8e9$var$DisplayNameParts[name];
    return ComponentParts;
}
function $c701b101618df8e9$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $iSD9t.default)();
        var value = props.value, children = props.children, formatProps = (0, $67Ijb.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === "function") return children(formattedValue);
        var Text = intl.textComponent || $8ZuGG.Fragment;
        return $8ZuGG.createElement(Text, null, formattedValue);
    };
    Component.displayName = $c701b101618df8e9$var$DisplayName[name];
    return Component;
}

});

parcelRegister("4OQoZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $38247adf5897e304$export$2e2bcd8739ae039; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");

var $aqUEs = parcelRequire("aqUEs");

var $3m0Mm = parcelRequire("3m0Mm");
function $38247adf5897e304$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $38247adf5897e304$var$IntlProvider = /** @class */ function(_super) {
    (0, $67Ijb.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $f8XZf.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $3m0Mm.createIntl)($38247adf5897e304$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $38247adf5897e304$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $38247adf5897e304$var$processIntlConfig(props);
        if (!(0, $7tq3X.shallowEqual)(prevConfig, config)) return {
            intl: (0, $3m0Mm.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $7tq3X.invariantIntlContext)(this.state.intl);
        return $8ZuGG.createElement((0, $aqUEs.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = "IntlProvider";
    IntlProvider.defaultProps = (0, $7tq3X.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($8ZuGG.PureComponent);
var $38247adf5897e304$export$2e2bcd8739ae039 = $38247adf5897e304$var$IntlProvider;

});
parcelRegister("3m0Mm", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $271407e3c988b392$export$7e4cbedfdd7b4c0d; });
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $67Ijb = parcelRequire("67Ijb");

var $5Mwjf = parcelRequire("5Mwjf");
var $bjYjS = parcelRequire("bjYjS");

var $8ZuGG = parcelRequire("8ZuGG");

var $7tq3X = parcelRequire("7tq3X");

var $gIvaJ = parcelRequire("gIvaJ");
function $271407e3c988b392$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $gIvaJ.isFormatXMLElementFn)(v) ? (0, $7tq3X.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $271407e3c988b392$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $271407e3c988b392$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $bjYjS.formatMessage).apply(void 0, (0, $67Ijb.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return $8ZuGG.Children.toArray(chunks);
    return chunks;
};
var $271407e3c988b392$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $67Ijb.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $271407e3c988b392$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $5Mwjf.createIntl)((0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, (0, $7tq3X.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, coreIntl), {
        formatMessage: $271407e3c988b392$var$formatMessage.bind(null, resolvedConfig, // @ts-expect-error fix this
        coreIntl.formatters),
        // @ts-expect-error fix this
        $t: $271407e3c988b392$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};

});
parcelRegister("5Mwjf", function(module, exports) {

$parcel$export(module.exports, "createIntl", function () { return $435a7f698e952ae7$export$7e4cbedfdd7b4c0d; });

var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $eczN4 = parcelRequire("eczN4");

var $atxLr = parcelRequire("atxLr");

var $cdU2A = parcelRequire("cdU2A");

var $dGVJ3 = parcelRequire("dGVJ3");

var $i5Sq1 = parcelRequire("i5Sq1");

var $bjYjS = parcelRequire("bjYjS");

var $ldlYY = parcelRequire("ldlYY");

var $fotED = parcelRequire("fotED");
function $435a7f698e952ae7$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === "string";
}
function $435a7f698e952ae7$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $435a7f698e952ae7$var$messagesContainString(config.messages || {})) config.onWarn('[@formatjs/intl] "defaultRichTextElements" was specified but "message" was not pre-compiled. \nPlease consider using "@formatjs/cli" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution');
}
function $435a7f698e952ae7$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $f8XZf.createFormatters)(cache);
    var resolvedConfig = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, (0, $f8XZf.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $eczN4.InvalidConfigError)('"locale" was not configured, using "'.concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details')));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || "en";
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $eczN4.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.NumberFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $eczN4.MissingDataError)('Missing locale data for locale: "'.concat(locale, '" in Intl.DateTimeFormat. Using default locale: "').concat(defaultLocale, '" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details')));
    $435a7f698e952ae7$var$verifyConfigMessages(resolvedConfig);
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $atxLr.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $atxLr.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $cdU2A.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $dGVJ3.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $dGVJ3.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $dGVJ3.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $dGVJ3.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $dGVJ3.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $i5Sq1.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        // @ts-expect-error TODO: will get to this later
        formatMessage: (0, $bjYjS.formatMessage).bind(null, resolvedConfig, formatters),
        // @ts-expect-error TODO: will get to this later
        $t: (0, $bjYjS.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $ldlYY.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $ldlYY.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $fotED.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("atxLr", function(module, exports) {

$parcel$export(module.exports, "formatNumber", function () { return $7a06cdad1b364a81$export$f5dd818bff069720; });
$parcel$export(module.exports, "formatNumberToParts", function () { return $7a06cdad1b364a81$export$6871080848f10b2f; });

var $eczN4 = parcelRequire("eczN4");

var $f8XZf = parcelRequire("f8XZf");
var $7a06cdad1b364a81$var$NUMBER_FORMAT_OPTIONS = [
    "style",
    "currency",
    "unit",
    "unitDisplay",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    // ES2020 NumberFormat
    "compactDisplay",
    "currencyDisplay",
    "currencySign",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "numberingSystem",
    // ES2023 NumberFormat
    "trailingZeroDisplay",
    "roundingPriority",
    "roundingIncrement",
    "roundingMode"
];
function $7a06cdad1b364a81$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $f8XZf.getNamedFormat)(formats, "number", format, onError) || {};
    var filteredOptions = (0, $f8XZf.filterProps)(options, $7a06cdad1b364a81$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $7a06cdad1b364a81$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7a06cdad1b364a81$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return String(value);
}
function $7a06cdad1b364a81$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7a06cdad1b364a81$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting number.", config.locale, e));
    }
    return [];
}

});

parcelRegister("cdU2A", function(module, exports) {

$parcel$export(module.exports, "formatRelativeTime", function () { return $8e622b7723ad49a6$export$b4ea3b48dcf921f6; });

var $f8XZf = parcelRequire("f8XZf");

var $f8FMY = parcelRequire("f8FMY");

var $eczN4 = parcelRequire("eczN4");
var $8e622b7723ad49a6$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    "numeric",
    "style"
];
function $8e622b7723ad49a6$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $f8XZf.getNamedFormat)(formats, "relative", format, onError) || {};
    var filteredOptions = (0, $f8XZf.filterProps)(options, $8e622b7723ad49a6$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $8e622b7723ad49a6$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = "second";
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $f8FMY.FormatError)('Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-relativetimeformat"\n', (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    try {
        return $8e622b7723ad49a6$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting relative time.", config.locale, e));
    }
    return String(value);
}

});

parcelRegister("dGVJ3", function(module, exports) {

$parcel$export(module.exports, "formatDate", function () { return $029284071db7694b$export$3ae94a2503e890a1; });
$parcel$export(module.exports, "formatTime", function () { return $029284071db7694b$export$3203edd9e5edd663; });
$parcel$export(module.exports, "formatDateTimeRange", function () { return $029284071db7694b$export$a7fc3a91cb2ec376; });
$parcel$export(module.exports, "formatDateToParts", function () { return $029284071db7694b$export$dc1f059bce486b1; });
$parcel$export(module.exports, "formatTimeToParts", function () { return $029284071db7694b$export$af6e5d7a5c73edeb; });

var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $eczN4 = parcelRequire("eczN4");
var $029284071db7694b$var$DATE_TIME_FORMAT_OPTIONS = [
    "formatMatcher",
    "timeZone",
    "hour12",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "hourCycle",
    "dateStyle",
    "timeStyle",
    "calendar",
    // 'dayPeriod',
    "numberingSystem",
    "fractionalSecondDigits"
];
function $029284071db7694b$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $f8XZf.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $029284071db7694b$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === "time" && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, filteredOptions), {
        hour: "numeric",
        minute: "numeric"
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $029284071db7694b$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return String(date);
}
function $029284071db7694b$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return String(date);
}
function $029284071db7694b$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0, $f8XZf.filterProps)(options, $029284071db7694b$var$DATE_TIME_FORMAT_OPTIONS, timeZone ? {
        timeZone: timeZone
    } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)("Error formatting date time range.", config.locale, e));
    }
    return String(from);
}
function $029284071db7694b$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, "date", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting date.", config.locale, e));
    }
    return [];
}
function $029284071db7694b$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === "string" ? new Date(value || 0) : value;
    try {
        return $029284071db7694b$export$a7f9565e3c81cd54(config, "time", getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $eczN4.IntlFormatError)("Error formatting time.", config.locale, e));
    }
    return [];
}

});

parcelRegister("i5Sq1", function(module, exports) {

$parcel$export(module.exports, "formatPlural", function () { return $d2c2e80a84533d3d$export$bbbd05c900f3568d; });

var $f8XZf = parcelRequire("f8XZf");

var $eczN4 = parcelRequire("eczN4");

var $f8FMY = parcelRequire("f8FMY");
var $d2c2e80a84533d3d$var$PLURAL_FORMAT_OPTIONS = [
    "type"
];
function $d2c2e80a84533d3d$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $f8FMY.FormatError)('Intl.PluralRules is not available in this environment.\nTry polyfilling it using "@formatjs/intl-pluralrules"\n', (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $d2c2e80a84533d3d$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)("Error formatting plural.", locale, e));
    }
    return "other";
}

});

parcelRegister("bjYjS", function(module, exports) {

$parcel$export(module.exports, "formatMessage", function () { return $83e0424c274dd68e$export$25868d1e8e76735f; });

var $67Ijb = parcelRequire("67Ijb");

var $7K6E3 = parcelRequire("7K6E3");
parcelRequire("jdODR");
var $ck9OU = parcelRequire("ck9OU");

var $eczN4 = parcelRequire("eczN4");
parcelRequire("c9zsJ");
var $9xfwH = parcelRequire("9xfwH");
function $83e0424c274dd68e$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $67Ijb.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $83e0424c274dd68e$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $83e0424c274dd68e$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $ck9OU.IntlMessageFormat).formats;
    return (0, $67Ijb.__assign)((0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, mfFormats), f1), {
        date: $83e0424c274dd68e$var$deepMergeOptions($83e0424c274dd68e$var$setTimeZoneInOptions(mfFormats.date, timeZone), $83e0424c274dd68e$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $83e0424c274dd68e$var$deepMergeOptions($83e0424c274dd68e$var$setTimeZoneInOptions(mfFormats.time, timeZone), $83e0424c274dd68e$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $83e0424c274dd68e$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ""
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $7K6E3.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $9xfwH.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === "string" && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, defaultRichTextElements), values || {});
    formats = $83e0424c274dd68e$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $83e0424c274dd68e$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === "") return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $eczN4.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $eczN4.MessageFormatError)('Error formatting default message for: "'.concat(id, '", rendering default message verbatim'), locale, messageDescriptor, e));
            return typeof defaultMessage === "string" ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $67Ijb.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $eczN4.MessageFormatError)('Error formatting message: "'.concat(id, '", using ').concat(defaultMessage ? "default message" : "id", " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $eczN4.MessageFormatError)('Error formatting the default message for: "'.concat(id, '", rendering message verbatim'), locale, messageDescriptor, e));
    }
    if (typeof message === "string") return message;
    if (typeof defaultMessage === "string") return defaultMessage;
    return id;
};

});

parcelRegister("ldlYY", function(module, exports) {

$parcel$export(module.exports, "formatList", function () { return $f71bdd240b06797b$export$e8b8be48b45905bb; });
$parcel$export(module.exports, "formatListToParts", function () { return $f71bdd240b06797b$export$6f284aad1934db69; });

var $67Ijb = parcelRequire("67Ijb");

var $f8XZf = parcelRequire("f8XZf");

var $f8FMY = parcelRequire("f8FMY");

var $eczN4 = parcelRequire("eczN4");
var $f71bdd240b06797b$var$LIST_FORMAT_OPTIONS = [
    "type",
    "style"
];
var $f71bdd240b06797b$var$now = Date.now();
function $f71bdd240b06797b$var$generateToken(i) {
    return "".concat($f71bdd240b06797b$var$now, "_").concat(i, "_").concat($f71bdd240b06797b$var$now);
}
function $f71bdd240b06797b$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $f71bdd240b06797b$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== "string") all.push(val);
        else if (typeof all[all.length - 1] === "string") all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? "" : results;
}
function $f71bdd240b06797b$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $f8FMY.FormatError)('Intl.ListFormat is not available in this environment.\nTry polyfilling it using "@formatjs/intl-listformat"\n', (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $f71bdd240b06797b$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function(v, i) {
            if (typeof v === "object") {
                var id = $f71bdd240b06797b$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === "literal" ? part : (0, $67Ijb.__assign)((0, $67Ijb.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)("Error formatting list.", locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("fotED", function(module, exports) {

$parcel$export(module.exports, "formatDisplayName", function () { return $b35019a7d7691e6f$export$62fe1a4d9e891fa2; });

var $f8XZf = parcelRequire("f8XZf");

var $f8FMY = parcelRequire("f8FMY");

var $eczN4 = parcelRequire("eczN4");
var $b35019a7d7691e6f$var$DISPLAY_NAMES_OPTONS = [
    "style",
    "type",
    "fallback",
    "languageDisplay"
];
function $b35019a7d7691e6f$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $f8FMY.FormatError)('Intl.DisplayNames is not available in this environment.\nTry polyfilling it using "@formatjs/intl-displaynames"\n', (0, $f8FMY.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $f8XZf.filterProps)(options, $b35019a7d7691e6f$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $eczN4.IntlFormatError)("Error formatting display name.", locale, e));
    }
}

});





parcelRegister("7CMue", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aba9957b1ef14ebb$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $8EIEv = parcelRequire("8EIEv");

var $5b7Z4 = parcelRequire("5b7Z4");
var $kTdw7 = parcelRequire("kTdw7");

var $g5rao = parcelRequire("g5rao");

var $bIbAv = parcelRequire("bIbAv");

var $cugIF = parcelRequire("cugIF");

var $hB9Ab = parcelRequire("hB9Ab");

var $yrE6A = parcelRequire("yrE6A");

var $b2Jk5 = parcelRequire("b2Jk5");

var $cufV0 = parcelRequire("cufV0");

var $cDJ3z = parcelRequire("cDJ3z");

var $kOqgB = parcelRequire("kOqgB");
let $aba9957b1ef14ebb$var$_ = (t)=>t, $aba9957b1ef14ebb$var$t, $aba9957b1ef14ebb$var$t1, $aba9957b1ef14ebb$var$t2, $aba9957b1ef14ebb$var$t3, $aba9957b1ef14ebb$var$t4, $aba9957b1ef14ebb$var$t5;
const $aba9957b1ef14ebb$var$maxMobileScreen = `( max-width: ${(0, $5b7Z4.gridSize)() * 100}px )`;
const $aba9957b1ef14ebb$var$smallMobileScreen = `( max-width: ${(0, $5b7Z4.gridSize)() * 47}px )`;
const $aba9957b1ef14ebb$export$bad5896fb5d45c0b = (0, $3XNKR.default).div($aba9957b1ef14ebb$var$t || ($aba9957b1ef14ebb$var$t = $aba9957b1ef14ebb$var$_`
  color: ${0};
  margin-top: ${0}px;
  font-size: 14px;
  text-align: center;
  line-height: 20px;

  ${0}
`), (0, $g5rao.default)("color.text.subtle", (0, $kTdw7).N500), (0, $5b7Z4.gridSize)() * 3, (0, $b2Jk5.listStyles));
const $aba9957b1ef14ebb$export$ba9d4abe45514a38 = (0, $3XNKR.default).div($aba9957b1ef14ebb$var$t1 || ($aba9957b1ef14ebb$var$t1 = $aba9957b1ef14ebb$var$_`
  color: ${0};
  padding-top: ${0}px;
  font-size: 11px;
  text-align: center;
  line-height: 14px;

  ${0}
`), (0, $g5rao.default)("color.text.subtle", (0, $kTdw7).N500), (0, $5b7Z4.gridSize)() * 2, (0, $b2Jk5.listStyles));
const $aba9957b1ef14ebb$var$Whitebox = (0, $3XNKR.default).section($aba9957b1ef14ebb$var$t2 || ($aba9957b1ef14ebb$var$t2 = $aba9957b1ef14ebb$var$_`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: ${0};
  padding: ${0}px ${0}px;

  background: ${0};
  border-radius: ${0}px;
  box-shadow: ${0};
  box-sizing: border-box;
  color: ${0};

  @media ${0} {
    padding: ${0}px ${0}px;
    background: transparent;
    box-shadow: none;
    min-height: 100%;
    width: ${0};
  }

  @media ${0} {
    padding: ${0}px ${0}px;
  }
`), ({ width: width })=>width || (0, $b2Jk5.whiteboxWidthDesktop), (0, $5b7Z4.gridSize)() * 4, (0, $5b7Z4.gridSize)() * 5, (0, $bIbAv.colorPalette).primaryWhite, (0, $5b7Z4.borderRadius)(), ({ noBorder: noBorder })=>noBorder ? "none" : "0 0 10px rgba(0, 0, 0, 0.1)", (0, $g5rao.default)("color.text.subtle", (0, $kTdw7).N500), $aba9957b1ef14ebb$var$maxMobileScreen, (0, $5b7Z4.gridSize)() * 4, (0, $5b7Z4.gridSize)() * 2, (0, $b2Jk5.whiteboxWidthHandheld), $aba9957b1ef14ebb$var$smallMobileScreen, (0, $5b7Z4.gridSize)() * 2, (0, $5b7Z4.gridSize)() * 2);
const $aba9957b1ef14ebb$var$Container = (0, $3XNKR.default).div($aba9957b1ef14ebb$var$t3 || ($aba9957b1ef14ebb$var$t3 = $aba9957b1ef14ebb$var$_`
  min-height: calc(100% - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px 0;

  @media ${0} {
    height: 100%;
    margin: 0;
    justify-content: flex-start;
  }
`), $aba9957b1ef14ebb$var$maxMobileScreen);
const $aba9957b1ef14ebb$var$FooterSpacer = (0, $3XNKR.default).div($aba9957b1ef14ebb$var$t4 || ($aba9957b1ef14ebb$var$t4 = $aba9957b1ef14ebb$var$_`
  @media ${0} {
    margin: auto;
  }
`), $aba9957b1ef14ebb$var$maxMobileScreen);
const $aba9957b1ef14ebb$var$SpinnerContainer = (0, $3XNKR.default).div($aba9957b1ef14ebb$var$t5 || ($aba9957b1ef14ebb$var$t5 = $aba9957b1ef14ebb$var$_`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${0}px;
`), (0, $5b7Z4.gridSize)() * 3);
const $aba9957b1ef14ebb$export$c0881a38d60c6658 = ({ header: header, children: children, footer: footer, whiteboxFooter: whiteboxFooter, isLoading: isLoading, pageId: pageId, noCobranding: noCobranding })=>{
    const { cobranding: cobranding, isMobileApp: isMobileApp } = (0, $cugIF.useCobranding)();
    const resolvedCobranding = noCobranding ? (0, $cugIF.SimpleCobranding).NO_COBRANDING : cobranding;
    const { background: Background, logo: logo, footerProducts: footerProducts, whiteboxWidth: whiteboxWidth, hideWhiteboxBorder: hideWhiteboxBorder } = (0, $hB9Ab.getCobrandedComponents)(resolvedCobranding);
    const isGlobalStateLoading = (0, $kOqgB.useAppSelector)((state)=>state.globalStateLoading);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $8EIEv.default), {
        children: /*#__PURE__*/ (0, $6rcps.jsx)(Background, {
            children: /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$var$Container, {
                id: "WhiteboxContainer",
                children: /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$var$Whitebox, {
                    width: whiteboxWidth,
                    noBorder: hideWhiteboxBorder,
                    role: "main",
                    children: isLoading || isGlobalStateLoading ? /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$var$SpinnerContainer, {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
                            testId: "whitebox-spinner",
                            size: "large"
                        })
                    }) : /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)((0, $yrE6A.ProductHeading), {
                                suffix: header,
                                children: logo && (0, $b2Jk5.renderProductLogo)(logo)
                            }),
                            children,
                            whiteboxFooter && /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$export$bad5896fb5d45c0b, {
                                children: whiteboxFooter
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)($aba9957b1ef14ebb$var$FooterSpacer, {}),
                            /*#__PURE__*/ (0, $6rcps.jsxs)($aba9957b1ef14ebb$export$ba9d4abe45514a38, {
                                children: [
                                    footerProducts && /*#__PURE__*/ (0, $6rcps.jsx)((0, $cDJ3z.default), {
                                        renderText: !isMobileApp,
                                        pageId: pageId,
                                        footerProducts: footerProducts
                                    }),
                                    footer
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
};
var $aba9957b1ef14ebb$export$2e2bcd8739ae039 = $aba9957b1ef14ebb$export$c0881a38d60c6658;

});
parcelRegister("8EIEv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64d4b232eb4edaee$export$2e2bcd8739ae039; });

var $81Vbb = parcelRequire("81Vbb");

var $2tdac = parcelRequire("2tdac");

var $k9Z8Q = parcelRequire("k9Z8Q");
var // Page already has a jsdoc where it is defined
// eslint-disable-next-line @repo/internal/react/require-jsdoc
$64d4b232eb4edaee$export$2e2bcd8739ae039 = (0, $81Vbb.default);

});
parcelRegister("81Vbb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d8ac55a16f22269$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $14VNY = parcelRequire("14VNY");

var $k1kY3 = parcelRequire("k1kY3");
var $5d8ac55a16f22269$var$bannerStyles = (0, $14VNY.css)({
    width: "100%",
    position: "fixed"
});
var $5d8ac55a16f22269$var$bannerContainerStyles = (0, $14VNY.css)({
    width: "100%",
    position: "relative",
    zIndex: 3,
    flex: "1 0 auto",
    transition: "height 0.25s ease-in-out"
});
var $5d8ac55a16f22269$var$pageContentStyles = (0, $14VNY.css)({
    minWidth: 0,
    position: "relative",
    zIndex: 1,
    flex: "1 1 auto"
});
var $5d8ac55a16f22269$var$wrapperStyles = (0, $14VNY.css)({
    display: "flex",
    width: "100%",
    minHeight: "100%",
    flexDirection: "column"
});
var $5d8ac55a16f22269$var$mainContainerStyles = (0, $14VNY.css)({
    display: "flex",
    flex: "1 1 auto"
});
var $5d8ac55a16f22269$var$navigationStyles = (0, $14VNY.css)({
    position: "relative",
    zIndex: 2
});
/**
 * __Page__
 *
 * Used to build page layouts.
 *
 * Has built in support for positioning [banners](https://atlassian.design/components/banner/examples)
 * and the deprecated `@atlaskit/navigation`.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $5d8ac55a16f22269$var$Page = function Page(_ref) {
    var _ref$isBannerOpen = _ref.isBannerOpen, isBannerOpen = _ref$isBannerOpen === void 0 ? false : _ref$isBannerOpen, _ref$bannerHeight = _ref.bannerHeight, bannerHeight = _ref$bannerHeight === void 0 ? (0, $k1kY3.defaultBannerHeight) : _ref$bannerHeight, banner = _ref.banner, navigation = _ref.navigation, children = _ref.children, testId = _ref.testId;
    return (0, $14VNY.jsx)("div", {
        css: $5d8ac55a16f22269$var$wrapperStyles,
        "data-testid": testId
    }, banner ? (0, $14VNY.jsx)("div", {
        css: $5d8ac55a16f22269$var$bannerContainerStyles,
        style: {
            height: isBannerOpen ? "".concat(bannerHeight, "px") : "0"
        },
        "aria-hidden": !isBannerOpen,
        "data-testid": testId ? "".concat(testId, "--banner-container") : undefined
    }, (0, $14VNY.jsx)("div", {
        css: $5d8ac55a16f22269$var$bannerStyles
    }, banner)) : null, (0, $14VNY.jsx)("div", {
        css: $5d8ac55a16f22269$var$mainContainerStyles
    }, (0, $14VNY.jsx)("div", {
        css: $5d8ac55a16f22269$var$navigationStyles
    }, navigation), (0, $14VNY.jsx)("div", {
        css: $5d8ac55a16f22269$var$pageContentStyles
    }, children)));
};
var $5d8ac55a16f22269$export$2e2bcd8739ae039 = $5d8ac55a16f22269$var$Page;

});
parcelRegister("k1kY3", function(module, exports) {

$parcel$export(module.exports, "defaultGridColumns", function () { return $e9342a612e689295$export$74797698e12f8baa; });
$parcel$export(module.exports, "defaultGridColumnWidth", function () { return $e9342a612e689295$export$b8241a1616ab1b96; });
$parcel$export(module.exports, "spacingMapping", function () { return $e9342a612e689295$export$2a89a65a43bab52d; });
$parcel$export(module.exports, "defaultSpacing", function () { return $e9342a612e689295$export$8ec7372efd74b753; });
$parcel$export(module.exports, "defaultBannerHeight", function () { return $e9342a612e689295$export$d77f83c3d17a7b8a; });
$parcel$export(module.exports, "defaultMedium", function () { return $e9342a612e689295$export$f8725d21f81f3e01; });
$parcel$export(module.exports, "defaultLayout", function () { return $e9342a612e689295$export$2303d2bd9eeff99a; });
$parcel$export(module.exports, "varColumnsNum", function () { return $e9342a612e689295$export$9ddc3632bbfb8966; });
$parcel$export(module.exports, "varColumnSpan", function () { return $e9342a612e689295$export$8b7e31f391e6e681; });
$parcel$export(module.exports, "varGridSpacing", function () { return $e9342a612e689295$export$936829b4511db3e4; });
var $e9342a612e689295$export$3aaf3a78c909ea56 = 8;
var $e9342a612e689295$export$74797698e12f8baa = 12;
var $e9342a612e689295$export$b8241a1616ab1b96 = $e9342a612e689295$export$3aaf3a78c909ea56 * 10;
var $e9342a612e689295$export$2a89a65a43bab52d = {
    comfortable: $e9342a612e689295$export$3aaf3a78c909ea56 * 5,
    cosy: $e9342a612e689295$export$3aaf3a78c909ea56 * 2,
    compact: $e9342a612e689295$export$3aaf3a78c909ea56 * 0.5
};
var $e9342a612e689295$export$8ec7372efd74b753 = "cosy";
var $e9342a612e689295$export$d77f83c3d17a7b8a = 52;
var $e9342a612e689295$export$f8725d21f81f3e01 = 0;
var $e9342a612e689295$export$2303d2bd9eeff99a = "fixed";
var $e9342a612e689295$export$9ddc3632bbfb8966 = "--ds-columns-num";
var $e9342a612e689295$export$8b7e31f391e6e681 = "--ds-column-span";
var $e9342a612e689295$export$936829b4511db3e4 = "--ds-grid-spacing";

});


parcelRegister("2tdac", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1cc88034a9248267$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k1kY3 = parcelRequire("k1kY3");

var $aDRO1 = parcelRequire("aDRO1");

var $k9Z8Q = parcelRequire("k9Z8Q");

var $cjoER = parcelRequire("cjoER");
/**
 * __Grid__
 *
 * A grid contains one or more `GridColumn` to provide a grid layout.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $1cc88034a9248267$var$GridWrapper = function GridWrapper(_ref) {
    var _ref2, _ref3, _theme$isNestedGrid;
    var spacingProp = _ref.spacing, columnsProp = _ref.columns, layout = _ref.layout, testId = _ref.testId, children = _ref.children, theme = _ref.theme;
    /**
   * isRoot is `true` only in the default context (i.e. no ancestor Grid).
   */ var _useContext = (0, $8ZuGG.useContext)((0, $cjoER.GridContext)), isRoot = _useContext.isRoot;
    var _useContext2 = (0, $8ZuGG.useContext)((0, $k9Z8Q.GridColumnContext)), medium = _useContext2.medium;
    /**
   * The colspan of the current containing GridColumn provides
   * the default amount of columns in a nested grid.
   */ var defaultColumns = medium > 0 ? medium : (0, $k1kY3.defaultGridColumns);
    /**
   * This is to account for the eventual removal of the `theme` prop. In theory, this should not be exposed.
   * However, consumers are still using it - there should be a major rerelease with the complete removal of this prop later.
   */ var spacing = (_ref2 = spacingProp !== null && spacingProp !== void 0 ? spacingProp : theme === null || theme === void 0 ? void 0 : theme.spacing) !== null && _ref2 !== void 0 ? _ref2 : (0, $k1kY3.defaultSpacing);
    var columns = (_ref3 = columnsProp !== null && columnsProp !== void 0 ? columnsProp : theme === null || theme === void 0 ? void 0 : theme.columns) !== null && _ref3 !== void 0 ? _ref3 : defaultColumns;
    var isNested = (_theme$isNestedGrid = theme === null || theme === void 0 ? void 0 : theme.isNestedGrid) !== null && _theme$isNestedGrid !== void 0 ? _theme$isNestedGrid : !isRoot;
    var contextValue = (0, $8ZuGG.useMemo)(function() {
        return {
            isRoot: false,
            isNested: isNested,
            spacing: spacing,
            columns: columns
        };
    }, [
        spacing,
        columns,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cjoER.GridContext).Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aDRO1.Grid), {
        layout: layout,
        testId: testId
    }, children));
};
var $1cc88034a9248267$export$2e2bcd8739ae039 = $1cc88034a9248267$var$GridWrapper;

});
parcelRegister("aDRO1", function(module, exports) {

$parcel$export(module.exports, "Grid", function () { return $7bf748a03bd7bacf$export$ef2184bd89960b14; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $k1kY3 = parcelRequire("k1kY3");

var $cjoER = parcelRequire("cjoER");
var $7bf748a03bd7bacf$var$gridStyles = (0, $14VNY.css)({
    display: "flex",
    margin: "0 auto",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    padding: "0 calc(var(".concat((0, $k1kY3.varGridSpacing), ") / 2)"),
    position: "relative",
    alignItems: "flex-start",
    flexWrap: "wrap"
});
var $7bf748a03bd7bacf$var$gridLayoutStyles = {
    fixed: (0, $14VNY.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        maxWidth: "calc(var(".concat((0, $k1kY3.varColumnsNum), ") * ").concat((0, $k1kY3.defaultGridColumnWidth), "px)")
    }),
    fluid: (0, $14VNY.css)({
        maxWidth: "100%"
    })
};
var $7bf748a03bd7bacf$var$nestedGridStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "0 calc(-1 * var(".concat((0, $k1kY3.varGridSpacing), "))")
});
var $7bf748a03bd7bacf$export$ef2184bd89960b14 = function Grid(_ref) {
    var _ref2;
    var _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? (0, $k1kY3.defaultLayout) : _ref$layout, testId = _ref.testId, children = _ref.children;
    var _useContext = (0, $8ZuGG.useContext)((0, $cjoER.GridContext)), isNested = _useContext.isNested, columns = _useContext.columns, spacing = _useContext.spacing;
    return (0, $14VNY.jsx)("div", {
        css: [
            $7bf748a03bd7bacf$var$gridStyles,
            $7bf748a03bd7bacf$var$gridLayoutStyles[layout],
            isNested && $7bf748a03bd7bacf$var$nestedGridStyles
        ],
        style: (_ref2 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref2, (0, $k1kY3.varColumnsNum), columns), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref2, (0, $k1kY3.varGridSpacing), "".concat((0, $k1kY3.spacingMapping)[spacing], "px")), _ref2),
        "data-testid": testId
    }, children);
};

});
parcelRegister("cjoER", function(module, exports) {

$parcel$export(module.exports, "GridContext", function () { return $8f6a62f6792d79c1$export$11cae3e04ab99fae; });

var $8ZuGG = parcelRequire("8ZuGG");

var $k1kY3 = parcelRequire("k1kY3");
var $8f6a62f6792d79c1$export$11cae3e04ab99fae = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    isRoot: true,
    isNested: false,
    spacing: (0, $k1kY3.defaultSpacing),
    columns: (0, $k1kY3.defaultGridColumns)
});

});


parcelRegister("k9Z8Q", function(module, exports) {

$parcel$export(module.exports, "GridColumnContext", function () { return $ead4135dcdd62c08$export$1229ad7112b989f5; });
$parcel$export(module.exports, "default", function () { return $ead4135dcdd62c08$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $k1kY3 = parcelRequire("k1kY3");

var $cjoER = parcelRequire("cjoER");
var $ead4135dcdd62c08$var$_gridColumnWidthStyle;
/**
 * Determines the method by which column width is calculated.
 */ var $ead4135dcdd62c08$var$ColumnVariant = /*#__PURE__*/ function(ColumnVariant) {
    ColumnVariant["Auto"] = "auto";
    ColumnVariant["Bounded"] = "bounded";
    ColumnVariant["FullWidth"] = "fullWidth";
    return ColumnVariant;
}($ead4135dcdd62c08$var$ColumnVariant || {});
var $ead4135dcdd62c08$var$getVariant = function getVariant(_ref) {
    var medium = _ref.medium, columns = _ref.columns;
    if (medium === (0, $k1kY3.defaultMedium)) return $ead4135dcdd62c08$var$ColumnVariant.Auto;
    else if (medium < columns) return $ead4135dcdd62c08$var$ColumnVariant.Bounded;
    return $ead4135dcdd62c08$var$ColumnVariant.FullWidth;
};
/**
 * IE11 and Edge both have rounding issues for flexbox which is why a width of
 * 99.9999% is used. Using 100% here causes columns to wrap prematurely.
 */ var $ead4135dcdd62c08$var$availableWidth = "99.9999%";
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $ead4135dcdd62c08$var$singleColumnWidth = "(".concat($ead4135dcdd62c08$var$availableWidth, " / var(").concat((0, $k1kY3.varColumnsNum), "))");
var $ead4135dcdd62c08$var$gridColumnStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: "calc(".concat($ead4135dcdd62c08$var$singleColumnWidth, " - var(").concat((0, $k1kY3.varGridSpacing), "))"),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: "0 calc(var(".concat((0, $k1kY3.varGridSpacing), ") / 2)"),
    flexGrow: 1,
    flexShrink: 0,
    wordWrap: "break-word"
});
var $ead4135dcdd62c08$var$gridColumnWidthStyles = ($ead4135dcdd62c08$var$_gridColumnWidthStyle = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ead4135dcdd62c08$var$_gridColumnWidthStyle, $ead4135dcdd62c08$var$ColumnVariant.Auto, (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(100% - var(".concat((0, $k1kY3.varGridSpacing), "))"),
    flexBasis: "auto"
})), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ead4135dcdd62c08$var$_gridColumnWidthStyle, $ead4135dcdd62c08$var$ColumnVariant.Bounded, (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(".concat($ead4135dcdd62c08$var$singleColumnWidth, " *  var(").concat((0, $k1kY3.varColumnSpan), ") - var(").concat((0, $k1kY3.varGridSpacing), "))"),
    flexBasis: "100%"
})), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($ead4135dcdd62c08$var$_gridColumnWidthStyle, $ead4135dcdd62c08$var$ColumnVariant.FullWidth, (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: "calc(100% - var(".concat((0, $k1kY3.varGridSpacing), "))"),
    flexBasis: "100%"
})), $ead4135dcdd62c08$var$_gridColumnWidthStyle);
var $ead4135dcdd62c08$export$1229ad7112b989f5 = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    medium: (0, $k1kY3.defaultMedium)
});
/**
 * __Grid column__
 *
 * A grid column can span one or more column positions within a grid.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/page)
 */ var $ead4135dcdd62c08$var$GridColumn = function GridColumn(_ref2) {
    var _ref2$medium = _ref2.medium, medium = _ref2$medium === void 0 ? (0, $k1kY3.defaultMedium) : _ref2$medium, children = _ref2.children, testId = _ref2.testId;
    var _useContext = (0, $8ZuGG.useContext)((0, $cjoER.GridContext)), columns = _useContext.columns;
    var contextValue = (0, $8ZuGG.useMemo)(function() {
        return {
            medium: medium
        };
    }, [
        medium
    ]);
    /**
   * The real column span,
   * obtained by clamping the passed `medium` value within the allowed range.
   */ var colSpan = Math.max(1, Math.min(medium, columns));
    /**
   * How we should calculate the column width.
   */ var variant = $ead4135dcdd62c08$var$getVariant({
        medium: medium,
        columns: columns
    });
    return (0, $14VNY.jsx)($ead4135dcdd62c08$export$1229ad7112b989f5.Provider, {
        value: contextValue
    }, (0, $14VNY.jsx)("div", {
        css: [
            $ead4135dcdd62c08$var$gridColumnStyles,
            $ead4135dcdd62c08$var$gridColumnWidthStyles[variant]
        ],
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $k1kY3.varColumnSpan), variant === $ead4135dcdd62c08$var$ColumnVariant.Auto ? "auto" : colSpan),
        "data-testid": testId
    }, children));
};
var $ead4135dcdd62c08$export$2e2bcd8739ae039 = $ead4135dcdd62c08$var$GridColumn;

});



parcelRegister("g5rao", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bb622fb74f57fb5b$export$2e2bcd8739ae039; });



var $aBY8N = parcelRequire("aBY8N");

var $bDRHl = parcelRequire("bDRHl");

var $1RdT6 = parcelRequire("1RdT6");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $bb622fb74f57fb5b$var$token(path, fallback) {
    var token = (0, $aBY8N.default)[path];
    typeof $1RdT6;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $bDRHl.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $bb622fb74f57fb5b$export$2e2bcd8739ae039 = $bb622fb74f57fb5b$var$token;

});
parcelRegister("aBY8N", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b9c02d3484ec41e$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ var $7b9c02d3484ec41e$var$tokens = {
    "color.text": "--ds-text",
    "color.text.accent.lime": "--ds-text-accent-lime",
    "color.text.accent.lime.bolder": "--ds-text-accent-lime-bolder",
    "color.text.accent.red": "--ds-text-accent-red",
    "color.text.accent.red.bolder": "--ds-text-accent-red-bolder",
    "color.text.accent.orange": "--ds-text-accent-orange",
    "color.text.accent.orange.bolder": "--ds-text-accent-orange-bolder",
    "color.text.accent.yellow": "--ds-text-accent-yellow",
    "color.text.accent.yellow.bolder": "--ds-text-accent-yellow-bolder",
    "color.text.accent.green": "--ds-text-accent-green",
    "color.text.accent.green.bolder": "--ds-text-accent-green-bolder",
    "color.text.accent.teal": "--ds-text-accent-teal",
    "color.text.accent.teal.bolder": "--ds-text-accent-teal-bolder",
    "color.text.accent.blue": "--ds-text-accent-blue",
    "color.text.accent.blue.bolder": "--ds-text-accent-blue-bolder",
    "color.text.accent.purple": "--ds-text-accent-purple",
    "color.text.accent.purple.bolder": "--ds-text-accent-purple-bolder",
    "color.text.accent.magenta": "--ds-text-accent-magenta",
    "color.text.accent.magenta.bolder": "--ds-text-accent-magenta-bolder",
    "color.text.accent.gray": "--ds-text-accent-gray",
    "color.text.accent.gray.bolder": "--ds-text-accent-gray-bolder",
    "color.text.disabled": "--ds-text-disabled",
    "color.text.inverse": "--ds-text-inverse",
    "color.text.selected": "--ds-text-selected",
    "color.text.brand": "--ds-text-brand",
    "color.text.danger": "--ds-text-danger",
    "color.text.warning": "--ds-text-warning",
    "color.text.warning.inverse": "--ds-text-warning-inverse",
    "color.text.success": "--ds-text-success",
    "color.text.discovery": "--ds-text-discovery",
    "color.text.information": "--ds-text-information",
    "color.text.subtlest": "--ds-text-subtlest",
    "color.text.subtle": "--ds-text-subtle",
    "color.link": "--ds-link",
    "color.link.pressed": "--ds-link-pressed",
    "color.link.visited": "--ds-link-visited",
    "color.link.visited.pressed": "--ds-link-visited-pressed",
    "color.icon": "--ds-icon",
    "color.icon.accent.lime": "--ds-icon-accent-lime",
    "color.icon.accent.red": "--ds-icon-accent-red",
    "color.icon.accent.orange": "--ds-icon-accent-orange",
    "color.icon.accent.yellow": "--ds-icon-accent-yellow",
    "color.icon.accent.green": "--ds-icon-accent-green",
    "color.icon.accent.teal": "--ds-icon-accent-teal",
    "color.icon.accent.blue": "--ds-icon-accent-blue",
    "color.icon.accent.purple": "--ds-icon-accent-purple",
    "color.icon.accent.magenta": "--ds-icon-accent-magenta",
    "color.icon.accent.gray": "--ds-icon-accent-gray",
    "color.icon.disabled": "--ds-icon-disabled",
    "color.icon.inverse": "--ds-icon-inverse",
    "color.icon.selected": "--ds-icon-selected",
    "color.icon.brand": "--ds-icon-brand",
    "color.icon.danger": "--ds-icon-danger",
    "color.icon.warning": "--ds-icon-warning",
    "color.icon.warning.inverse": "--ds-icon-warning-inverse",
    "color.icon.success": "--ds-icon-success",
    "color.icon.discovery": "--ds-icon-discovery",
    "color.icon.information": "--ds-icon-information",
    "color.icon.subtlest": "--ds-icon-subtlest",
    "color.icon.subtle": "--ds-icon-subtle",
    "color.border": "--ds-border",
    "color.border.accent.lime": "--ds-border-accent-lime",
    "color.border.accent.red": "--ds-border-accent-red",
    "color.border.accent.orange": "--ds-border-accent-orange",
    "color.border.accent.yellow": "--ds-border-accent-yellow",
    "color.border.accent.green": "--ds-border-accent-green",
    "color.border.accent.teal": "--ds-border-accent-teal",
    "color.border.accent.blue": "--ds-border-accent-blue",
    "color.border.accent.purple": "--ds-border-accent-purple",
    "color.border.accent.magenta": "--ds-border-accent-magenta",
    "color.border.accent.gray": "--ds-border-accent-gray",
    "color.border.disabled": "--ds-border-disabled",
    "color.border.focused": "--ds-border-focused",
    "color.border.input": "--ds-border-input",
    "color.border.inverse": "--ds-border-inverse",
    "color.border.selected": "--ds-border-selected",
    "color.border.brand": "--ds-border-brand",
    "color.border.danger": "--ds-border-danger",
    "color.border.warning": "--ds-border-warning",
    "color.border.success": "--ds-border-success",
    "color.border.discovery": "--ds-border-discovery",
    "color.border.information": "--ds-border-information",
    "color.border.bold": "--ds-border-bold",
    "color.background.accent.lime.subtlest": "--ds-background-accent-lime-subtlest",
    "color.background.accent.lime.subtlest.hovered": "--ds-background-accent-lime-subtlest-hovered",
    "color.background.accent.lime.subtlest.pressed": "--ds-background-accent-lime-subtlest-pressed",
    "color.background.accent.lime.subtler": "--ds-background-accent-lime-subtler",
    "color.background.accent.lime.subtler.hovered": "--ds-background-accent-lime-subtler-hovered",
    "color.background.accent.lime.subtler.pressed": "--ds-background-accent-lime-subtler-pressed",
    "color.background.accent.lime.subtle": "--ds-background-accent-lime-subtle",
    "color.background.accent.lime.subtle.hovered": "--ds-background-accent-lime-subtle-hovered",
    "color.background.accent.lime.subtle.pressed": "--ds-background-accent-lime-subtle-pressed",
    "color.background.accent.lime.bolder": "--ds-background-accent-lime-bolder",
    "color.background.accent.lime.bolder.hovered": "--ds-background-accent-lime-bolder-hovered",
    "color.background.accent.lime.bolder.pressed": "--ds-background-accent-lime-bolder-pressed",
    "color.background.accent.red.subtlest": "--ds-background-accent-red-subtlest",
    "color.background.accent.red.subtlest.hovered": "--ds-background-accent-red-subtlest-hovered",
    "color.background.accent.red.subtlest.pressed": "--ds-background-accent-red-subtlest-pressed",
    "color.background.accent.red.subtler": "--ds-background-accent-red-subtler",
    "color.background.accent.red.subtler.hovered": "--ds-background-accent-red-subtler-hovered",
    "color.background.accent.red.subtler.pressed": "--ds-background-accent-red-subtler-pressed",
    "color.background.accent.red.subtle": "--ds-background-accent-red-subtle",
    "color.background.accent.red.subtle.hovered": "--ds-background-accent-red-subtle-hovered",
    "color.background.accent.red.subtle.pressed": "--ds-background-accent-red-subtle-pressed",
    "color.background.accent.red.bolder": "--ds-background-accent-red-bolder",
    "color.background.accent.red.bolder.hovered": "--ds-background-accent-red-bolder-hovered",
    "color.background.accent.red.bolder.pressed": "--ds-background-accent-red-bolder-pressed",
    "color.background.accent.orange.subtlest": "--ds-background-accent-orange-subtlest",
    "color.background.accent.orange.subtlest.hovered": "--ds-background-accent-orange-subtlest-hovered",
    "color.background.accent.orange.subtlest.pressed": "--ds-background-accent-orange-subtlest-pressed",
    "color.background.accent.orange.subtler": "--ds-background-accent-orange-subtler",
    "color.background.accent.orange.subtler.hovered": "--ds-background-accent-orange-subtler-hovered",
    "color.background.accent.orange.subtler.pressed": "--ds-background-accent-orange-subtler-pressed",
    "color.background.accent.orange.subtle": "--ds-background-accent-orange-subtle",
    "color.background.accent.orange.subtle.hovered": "--ds-background-accent-orange-subtle-hovered",
    "color.background.accent.orange.subtle.pressed": "--ds-background-accent-orange-subtle-pressed",
    "color.background.accent.orange.bolder": "--ds-background-accent-orange-bolder",
    "color.background.accent.orange.bolder.hovered": "--ds-background-accent-orange-bolder-hovered",
    "color.background.accent.orange.bolder.pressed": "--ds-background-accent-orange-bolder-pressed",
    "color.background.accent.yellow.subtlest": "--ds-background-accent-yellow-subtlest",
    "color.background.accent.yellow.subtlest.hovered": "--ds-background-accent-yellow-subtlest-hovered",
    "color.background.accent.yellow.subtlest.pressed": "--ds-background-accent-yellow-subtlest-pressed",
    "color.background.accent.yellow.subtler": "--ds-background-accent-yellow-subtler",
    "color.background.accent.yellow.subtler.hovered": "--ds-background-accent-yellow-subtler-hovered",
    "color.background.accent.yellow.subtler.pressed": "--ds-background-accent-yellow-subtler-pressed",
    "color.background.accent.yellow.subtle": "--ds-background-accent-yellow-subtle",
    "color.background.accent.yellow.subtle.hovered": "--ds-background-accent-yellow-subtle-hovered",
    "color.background.accent.yellow.subtle.pressed": "--ds-background-accent-yellow-subtle-pressed",
    "color.background.accent.yellow.bolder": "--ds-background-accent-yellow-bolder",
    "color.background.accent.yellow.bolder.hovered": "--ds-background-accent-yellow-bolder-hovered",
    "color.background.accent.yellow.bolder.pressed": "--ds-background-accent-yellow-bolder-pressed",
    "color.background.accent.green.subtlest": "--ds-background-accent-green-subtlest",
    "color.background.accent.green.subtlest.hovered": "--ds-background-accent-green-subtlest-hovered",
    "color.background.accent.green.subtlest.pressed": "--ds-background-accent-green-subtlest-pressed",
    "color.background.accent.green.subtler": "--ds-background-accent-green-subtler",
    "color.background.accent.green.subtler.hovered": "--ds-background-accent-green-subtler-hovered",
    "color.background.accent.green.subtler.pressed": "--ds-background-accent-green-subtler-pressed",
    "color.background.accent.green.subtle": "--ds-background-accent-green-subtle",
    "color.background.accent.green.subtle.hovered": "--ds-background-accent-green-subtle-hovered",
    "color.background.accent.green.subtle.pressed": "--ds-background-accent-green-subtle-pressed",
    "color.background.accent.green.bolder": "--ds-background-accent-green-bolder",
    "color.background.accent.green.bolder.hovered": "--ds-background-accent-green-bolder-hovered",
    "color.background.accent.green.bolder.pressed": "--ds-background-accent-green-bolder-pressed",
    "color.background.accent.teal.subtlest": "--ds-background-accent-teal-subtlest",
    "color.background.accent.teal.subtlest.hovered": "--ds-background-accent-teal-subtlest-hovered",
    "color.background.accent.teal.subtlest.pressed": "--ds-background-accent-teal-subtlest-pressed",
    "color.background.accent.teal.subtler": "--ds-background-accent-teal-subtler",
    "color.background.accent.teal.subtler.hovered": "--ds-background-accent-teal-subtler-hovered",
    "color.background.accent.teal.subtler.pressed": "--ds-background-accent-teal-subtler-pressed",
    "color.background.accent.teal.subtle": "--ds-background-accent-teal-subtle",
    "color.background.accent.teal.subtle.hovered": "--ds-background-accent-teal-subtle-hovered",
    "color.background.accent.teal.subtle.pressed": "--ds-background-accent-teal-subtle-pressed",
    "color.background.accent.teal.bolder": "--ds-background-accent-teal-bolder",
    "color.background.accent.teal.bolder.hovered": "--ds-background-accent-teal-bolder-hovered",
    "color.background.accent.teal.bolder.pressed": "--ds-background-accent-teal-bolder-pressed",
    "color.background.accent.blue.subtlest": "--ds-background-accent-blue-subtlest",
    "color.background.accent.blue.subtlest.hovered": "--ds-background-accent-blue-subtlest-hovered",
    "color.background.accent.blue.subtlest.pressed": "--ds-background-accent-blue-subtlest-pressed",
    "color.background.accent.blue.subtler": "--ds-background-accent-blue-subtler",
    "color.background.accent.blue.subtler.hovered": "--ds-background-accent-blue-subtler-hovered",
    "color.background.accent.blue.subtler.pressed": "--ds-background-accent-blue-subtler-pressed",
    "color.background.accent.blue.subtle": "--ds-background-accent-blue-subtle",
    "color.background.accent.blue.subtle.hovered": "--ds-background-accent-blue-subtle-hovered",
    "color.background.accent.blue.subtle.pressed": "--ds-background-accent-blue-subtle-pressed",
    "color.background.accent.blue.bolder": "--ds-background-accent-blue-bolder",
    "color.background.accent.blue.bolder.hovered": "--ds-background-accent-blue-bolder-hovered",
    "color.background.accent.blue.bolder.pressed": "--ds-background-accent-blue-bolder-pressed",
    "color.background.accent.purple.subtlest": "--ds-background-accent-purple-subtlest",
    "color.background.accent.purple.subtlest.hovered": "--ds-background-accent-purple-subtlest-hovered",
    "color.background.accent.purple.subtlest.pressed": "--ds-background-accent-purple-subtlest-pressed",
    "color.background.accent.purple.subtler": "--ds-background-accent-purple-subtler",
    "color.background.accent.purple.subtler.hovered": "--ds-background-accent-purple-subtler-hovered",
    "color.background.accent.purple.subtler.pressed": "--ds-background-accent-purple-subtler-pressed",
    "color.background.accent.purple.subtle": "--ds-background-accent-purple-subtle",
    "color.background.accent.purple.subtle.hovered": "--ds-background-accent-purple-subtle-hovered",
    "color.background.accent.purple.subtle.pressed": "--ds-background-accent-purple-subtle-pressed",
    "color.background.accent.purple.bolder": "--ds-background-accent-purple-bolder",
    "color.background.accent.purple.bolder.hovered": "--ds-background-accent-purple-bolder-hovered",
    "color.background.accent.purple.bolder.pressed": "--ds-background-accent-purple-bolder-pressed",
    "color.background.accent.magenta.subtlest": "--ds-background-accent-magenta-subtlest",
    "color.background.accent.magenta.subtlest.hovered": "--ds-background-accent-magenta-subtlest-hovered",
    "color.background.accent.magenta.subtlest.pressed": "--ds-background-accent-magenta-subtlest-pressed",
    "color.background.accent.magenta.subtler": "--ds-background-accent-magenta-subtler",
    "color.background.accent.magenta.subtler.hovered": "--ds-background-accent-magenta-subtler-hovered",
    "color.background.accent.magenta.subtler.pressed": "--ds-background-accent-magenta-subtler-pressed",
    "color.background.accent.magenta.subtle": "--ds-background-accent-magenta-subtle",
    "color.background.accent.magenta.subtle.hovered": "--ds-background-accent-magenta-subtle-hovered",
    "color.background.accent.magenta.subtle.pressed": "--ds-background-accent-magenta-subtle-pressed",
    "color.background.accent.magenta.bolder": "--ds-background-accent-magenta-bolder",
    "color.background.accent.magenta.bolder.hovered": "--ds-background-accent-magenta-bolder-hovered",
    "color.background.accent.magenta.bolder.pressed": "--ds-background-accent-magenta-bolder-pressed",
    "color.background.accent.gray.subtlest": "--ds-background-accent-gray-subtlest",
    "color.background.accent.gray.subtlest.hovered": "--ds-background-accent-gray-subtlest-hovered",
    "color.background.accent.gray.subtlest.pressed": "--ds-background-accent-gray-subtlest-pressed",
    "color.background.accent.gray.subtler": "--ds-background-accent-gray-subtler",
    "color.background.accent.gray.subtler.hovered": "--ds-background-accent-gray-subtler-hovered",
    "color.background.accent.gray.subtler.pressed": "--ds-background-accent-gray-subtler-pressed",
    "color.background.accent.gray.subtle": "--ds-background-accent-gray-subtle",
    "color.background.accent.gray.subtle.hovered": "--ds-background-accent-gray-subtle-hovered",
    "color.background.accent.gray.subtle.pressed": "--ds-background-accent-gray-subtle-pressed",
    "color.background.accent.gray.bolder": "--ds-background-accent-gray-bolder",
    "color.background.accent.gray.bolder.hovered": "--ds-background-accent-gray-bolder-hovered",
    "color.background.accent.gray.bolder.pressed": "--ds-background-accent-gray-bolder-pressed",
    "color.background.disabled": "--ds-background-disabled",
    "color.background.input": "--ds-background-input",
    "color.background.input.hovered": "--ds-background-input-hovered",
    "color.background.input.pressed": "--ds-background-input-pressed",
    "color.background.inverse.subtle": "--ds-background-inverse-subtle",
    "color.background.inverse.subtle.hovered": "--ds-background-inverse-subtle-hovered",
    "color.background.inverse.subtle.pressed": "--ds-background-inverse-subtle-pressed",
    "color.background.neutral": "--ds-background-neutral",
    "color.background.neutral.hovered": "--ds-background-neutral-hovered",
    "color.background.neutral.pressed": "--ds-background-neutral-pressed",
    "color.background.neutral.subtle": "--ds-background-neutral-subtle",
    "color.background.neutral.subtle.hovered": "--ds-background-neutral-subtle-hovered",
    "color.background.neutral.subtle.pressed": "--ds-background-neutral-subtle-pressed",
    "color.background.neutral.bold": "--ds-background-neutral-bold",
    "color.background.neutral.bold.hovered": "--ds-background-neutral-bold-hovered",
    "color.background.neutral.bold.pressed": "--ds-background-neutral-bold-pressed",
    "color.background.selected": "--ds-background-selected",
    "color.background.selected.hovered": "--ds-background-selected-hovered",
    "color.background.selected.pressed": "--ds-background-selected-pressed",
    "color.background.selected.bold": "--ds-background-selected-bold",
    "color.background.selected.bold.hovered": "--ds-background-selected-bold-hovered",
    "color.background.selected.bold.pressed": "--ds-background-selected-bold-pressed",
    "color.background.brand.subtlest": "--ds-background-brand-subtlest",
    "color.background.brand.subtlest.hovered": "--ds-background-brand-subtlest-hovered",
    "color.background.brand.subtlest.pressed": "--ds-background-brand-subtlest-pressed",
    "color.background.brand.bold": "--ds-background-brand-bold",
    "color.background.brand.bold.hovered": "--ds-background-brand-bold-hovered",
    "color.background.brand.bold.pressed": "--ds-background-brand-bold-pressed",
    "color.background.brand.boldest": "--ds-background-brand-boldest",
    "color.background.brand.boldest.hovered": "--ds-background-brand-boldest-hovered",
    "color.background.brand.boldest.pressed": "--ds-background-brand-boldest-pressed",
    "color.background.danger": "--ds-background-danger",
    "color.background.danger.hovered": "--ds-background-danger-hovered",
    "color.background.danger.pressed": "--ds-background-danger-pressed",
    "color.background.danger.bold": "--ds-background-danger-bold",
    "color.background.danger.bold.hovered": "--ds-background-danger-bold-hovered",
    "color.background.danger.bold.pressed": "--ds-background-danger-bold-pressed",
    "color.background.warning": "--ds-background-warning",
    "color.background.warning.hovered": "--ds-background-warning-hovered",
    "color.background.warning.pressed": "--ds-background-warning-pressed",
    "color.background.warning.bold": "--ds-background-warning-bold",
    "color.background.warning.bold.hovered": "--ds-background-warning-bold-hovered",
    "color.background.warning.bold.pressed": "--ds-background-warning-bold-pressed",
    "color.background.success": "--ds-background-success",
    "color.background.success.hovered": "--ds-background-success-hovered",
    "color.background.success.pressed": "--ds-background-success-pressed",
    "color.background.success.bold": "--ds-background-success-bold",
    "color.background.success.bold.hovered": "--ds-background-success-bold-hovered",
    "color.background.success.bold.pressed": "--ds-background-success-bold-pressed",
    "color.background.discovery": "--ds-background-discovery",
    "color.background.discovery.hovered": "--ds-background-discovery-hovered",
    "color.background.discovery.pressed": "--ds-background-discovery-pressed",
    "color.background.discovery.bold": "--ds-background-discovery-bold",
    "color.background.discovery.bold.hovered": "--ds-background-discovery-bold-hovered",
    "color.background.discovery.bold.pressed": "--ds-background-discovery-bold-pressed",
    "color.background.information": "--ds-background-information",
    "color.background.information.hovered": "--ds-background-information-hovered",
    "color.background.information.pressed": "--ds-background-information-pressed",
    "color.background.information.bold": "--ds-background-information-bold",
    "color.background.information.bold.hovered": "--ds-background-information-bold-hovered",
    "color.background.information.bold.pressed": "--ds-background-information-bold-pressed",
    "color.blanket": "--ds-blanket",
    "color.blanket.selected": "--ds-blanket-selected",
    "color.blanket.danger": "--ds-blanket-danger",
    "color.interaction.hovered": "--ds-interaction-hovered",
    "color.interaction.pressed": "--ds-interaction-pressed",
    "color.skeleton": "--ds-skeleton",
    "color.skeleton.subtle": "--ds-skeleton-subtle",
    "color.chart.categorical.1": "--ds-chart-categorical-1",
    "color.chart.categorical.1.hovered": "--ds-chart-categorical-1-hovered",
    "color.chart.categorical.2": "--ds-chart-categorical-2",
    "color.chart.categorical.2.hovered": "--ds-chart-categorical-2-hovered",
    "color.chart.categorical.3": "--ds-chart-categorical-3",
    "color.chart.categorical.3.hovered": "--ds-chart-categorical-3-hovered",
    "color.chart.categorical.4": "--ds-chart-categorical-4",
    "color.chart.categorical.4.hovered": "--ds-chart-categorical-4-hovered",
    "color.chart.categorical.5": "--ds-chart-categorical-5",
    "color.chart.categorical.5.hovered": "--ds-chart-categorical-5-hovered",
    "color.chart.categorical.6": "--ds-chart-categorical-6",
    "color.chart.categorical.6.hovered": "--ds-chart-categorical-6-hovered",
    "color.chart.categorical.7": "--ds-chart-categorical-7",
    "color.chart.categorical.7.hovered": "--ds-chart-categorical-7-hovered",
    "color.chart.categorical.8": "--ds-chart-categorical-8",
    "color.chart.categorical.8.hovered": "--ds-chart-categorical-8-hovered",
    "color.chart.lime.bold": "--ds-chart-lime-bold",
    "color.chart.lime.bold.hovered": "--ds-chart-lime-bold-hovered",
    "color.chart.lime.bolder": "--ds-chart-lime-bolder",
    "color.chart.lime.bolder.hovered": "--ds-chart-lime-bolder-hovered",
    "color.chart.lime.boldest": "--ds-chart-lime-boldest",
    "color.chart.lime.boldest.hovered": "--ds-chart-lime-boldest-hovered",
    "color.chart.neutral": "--ds-chart-neutral",
    "color.chart.neutral.hovered": "--ds-chart-neutral-hovered",
    "color.chart.red.bold": "--ds-chart-red-bold",
    "color.chart.red.bold.hovered": "--ds-chart-red-bold-hovered",
    "color.chart.red.bolder": "--ds-chart-red-bolder",
    "color.chart.red.bolder.hovered": "--ds-chart-red-bolder-hovered",
    "color.chart.red.boldest": "--ds-chart-red-boldest",
    "color.chart.red.boldest.hovered": "--ds-chart-red-boldest-hovered",
    "color.chart.orange.bold": "--ds-chart-orange-bold",
    "color.chart.orange.bold.hovered": "--ds-chart-orange-bold-hovered",
    "color.chart.orange.bolder": "--ds-chart-orange-bolder",
    "color.chart.orange.bolder.hovered": "--ds-chart-orange-bolder-hovered",
    "color.chart.orange.boldest": "--ds-chart-orange-boldest",
    "color.chart.orange.boldest.hovered": "--ds-chart-orange-boldest-hovered",
    "color.chart.yellow.bold": "--ds-chart-yellow-bold",
    "color.chart.yellow.bold.hovered": "--ds-chart-yellow-bold-hovered",
    "color.chart.yellow.bolder": "--ds-chart-yellow-bolder",
    "color.chart.yellow.bolder.hovered": "--ds-chart-yellow-bolder-hovered",
    "color.chart.yellow.boldest": "--ds-chart-yellow-boldest",
    "color.chart.yellow.boldest.hovered": "--ds-chart-yellow-boldest-hovered",
    "color.chart.green.bold": "--ds-chart-green-bold",
    "color.chart.green.bold.hovered": "--ds-chart-green-bold-hovered",
    "color.chart.green.bolder": "--ds-chart-green-bolder",
    "color.chart.green.bolder.hovered": "--ds-chart-green-bolder-hovered",
    "color.chart.green.boldest": "--ds-chart-green-boldest",
    "color.chart.green.boldest.hovered": "--ds-chart-green-boldest-hovered",
    "color.chart.teal.bold": "--ds-chart-teal-bold",
    "color.chart.teal.bold.hovered": "--ds-chart-teal-bold-hovered",
    "color.chart.teal.bolder": "--ds-chart-teal-bolder",
    "color.chart.teal.bolder.hovered": "--ds-chart-teal-bolder-hovered",
    "color.chart.teal.boldest": "--ds-chart-teal-boldest",
    "color.chart.teal.boldest.hovered": "--ds-chart-teal-boldest-hovered",
    "color.chart.blue.bold": "--ds-chart-blue-bold",
    "color.chart.blue.bold.hovered": "--ds-chart-blue-bold-hovered",
    "color.chart.blue.bolder": "--ds-chart-blue-bolder",
    "color.chart.blue.bolder.hovered": "--ds-chart-blue-bolder-hovered",
    "color.chart.blue.boldest": "--ds-chart-blue-boldest",
    "color.chart.blue.boldest.hovered": "--ds-chart-blue-boldest-hovered",
    "color.chart.purple.bold": "--ds-chart-purple-bold",
    "color.chart.purple.bold.hovered": "--ds-chart-purple-bold-hovered",
    "color.chart.purple.bolder": "--ds-chart-purple-bolder",
    "color.chart.purple.bolder.hovered": "--ds-chart-purple-bolder-hovered",
    "color.chart.purple.boldest": "--ds-chart-purple-boldest",
    "color.chart.purple.boldest.hovered": "--ds-chart-purple-boldest-hovered",
    "color.chart.magenta.bold": "--ds-chart-magenta-bold",
    "color.chart.magenta.bold.hovered": "--ds-chart-magenta-bold-hovered",
    "color.chart.magenta.bolder": "--ds-chart-magenta-bolder",
    "color.chart.magenta.bolder.hovered": "--ds-chart-magenta-bolder-hovered",
    "color.chart.magenta.boldest": "--ds-chart-magenta-boldest",
    "color.chart.magenta.boldest.hovered": "--ds-chart-magenta-boldest-hovered",
    "color.chart.gray.bold": "--ds-chart-gray-bold",
    "color.chart.gray.bold.hovered": "--ds-chart-gray-bold-hovered",
    "color.chart.gray.bolder": "--ds-chart-gray-bolder",
    "color.chart.gray.bolder.hovered": "--ds-chart-gray-bolder-hovered",
    "color.chart.gray.boldest": "--ds-chart-gray-boldest",
    "color.chart.gray.boldest.hovered": "--ds-chart-gray-boldest-hovered",
    "color.chart.brand": "--ds-chart-brand",
    "color.chart.brand.hovered": "--ds-chart-brand-hovered",
    "color.chart.danger": "--ds-chart-danger",
    "color.chart.danger.hovered": "--ds-chart-danger-hovered",
    "color.chart.danger.bold": "--ds-chart-danger-bold",
    "color.chart.danger.bold.hovered": "--ds-chart-danger-bold-hovered",
    "color.chart.warning": "--ds-chart-warning",
    "color.chart.warning.hovered": "--ds-chart-warning-hovered",
    "color.chart.warning.bold": "--ds-chart-warning-bold",
    "color.chart.warning.bold.hovered": "--ds-chart-warning-bold-hovered",
    "color.chart.success": "--ds-chart-success",
    "color.chart.success.hovered": "--ds-chart-success-hovered",
    "color.chart.success.bold": "--ds-chart-success-bold",
    "color.chart.success.bold.hovered": "--ds-chart-success-bold-hovered",
    "color.chart.discovery": "--ds-chart-discovery",
    "color.chart.discovery.hovered": "--ds-chart-discovery-hovered",
    "color.chart.discovery.bold": "--ds-chart-discovery-bold",
    "color.chart.discovery.bold.hovered": "--ds-chart-discovery-bold-hovered",
    "color.chart.information": "--ds-chart-information",
    "color.chart.information.hovered": "--ds-chart-information-hovered",
    "color.chart.information.bold": "--ds-chart-information-bold",
    "color.chart.information.bold.hovered": "--ds-chart-information-bold-hovered",
    "elevation.surface": "--ds-surface",
    "elevation.surface.hovered": "--ds-surface-hovered",
    "elevation.surface.pressed": "--ds-surface-pressed",
    "elevation.surface.overlay": "--ds-surface-overlay",
    "elevation.surface.overlay.hovered": "--ds-surface-overlay-hovered",
    "elevation.surface.overlay.pressed": "--ds-surface-overlay-pressed",
    "elevation.surface.raised": "--ds-surface-raised",
    "elevation.surface.raised.hovered": "--ds-surface-raised-hovered",
    "elevation.surface.raised.pressed": "--ds-surface-raised-pressed",
    "elevation.surface.sunken": "--ds-surface-sunken",
    "elevation.shadow.overflow": "--ds-shadow-overflow",
    "elevation.shadow.overflow.perimeter": "--ds-shadow-overflow-perimeter",
    "elevation.shadow.overflow.spread": "--ds-shadow-overflow-spread",
    "elevation.shadow.overlay": "--ds-shadow-overlay",
    "elevation.shadow.raised": "--ds-shadow-raised",
    "opacity.disabled": "--ds-opacity-disabled",
    "opacity.loading": "--ds-opacity-loading",
    "utility.UNSAFE.textTransformUppercase": "--ds-UNSAFE-textTransformUppercase",
    "utility.UNSAFE.transparent": "--ds-UNSAFE-transparent",
    "utility.elevation.surface.current": "--ds-elevation-surface-current",
    "border.radius.050": "--ds-border-radius-050",
    "border.radius": "--ds-border-radius",
    "border.radius.100": "--ds-border-radius-100",
    "border.radius.200": "--ds-border-radius-200",
    "border.radius.300": "--ds-border-radius-300",
    "border.radius.400": "--ds-border-radius-400",
    "border.radius.circle": "--ds-border-radius-circle",
    "border.width": "--ds-border-width",
    "border.width.0": "--ds-border-width-0",
    "border.width.indicator": "--ds-border-width-indicator",
    "border.width.outline": "--ds-border-width-outline",
    "space.0": "--ds-space-0",
    "space.025": "--ds-space-025",
    "space.050": "--ds-space-050",
    "space.075": "--ds-space-075",
    "space.100": "--ds-space-100",
    "space.150": "--ds-space-150",
    "space.200": "--ds-space-200",
    "space.250": "--ds-space-250",
    "space.300": "--ds-space-300",
    "space.400": "--ds-space-400",
    "space.500": "--ds-space-500",
    "space.600": "--ds-space-600",
    "space.800": "--ds-space-800",
    "space.1000": "--ds-space-1000",
    "space.negative.025": "--ds-space-negative-025",
    "space.negative.050": "--ds-space-negative-050",
    "space.negative.075": "--ds-space-negative-075",
    "space.negative.100": "--ds-space-negative-100",
    "space.negative.150": "--ds-space-negative-150",
    "space.negative.200": "--ds-space-negative-200",
    "space.negative.250": "--ds-space-negative-250",
    "space.negative.300": "--ds-space-negative-300",
    "space.negative.400": "--ds-space-negative-400",
    "font.letterSpacing.0": "--ds-font-letterSpacing-0",
    "font.letterSpacing.100": "--ds-font-letterSpacing-100",
    "font.letterSpacing.200": "--ds-font-letterSpacing-200",
    "font.letterSpacing.300": "--ds-font-letterSpacing-300",
    "font.letterSpacing.400": "--ds-font-letterSpacing-400",
    "font.heading.xxlarge": "--ds-font-heading-xxlarge",
    "font.heading.xlarge": "--ds-font-heading-xlarge",
    "font.heading.large": "--ds-font-heading-large",
    "font.heading.medium": "--ds-font-heading-medium",
    "font.heading.small": "--ds-font-heading-small",
    "font.heading.xsmall": "--ds-font-heading-xsmall",
    "font.heading.xxsmall": "--ds-font-heading-xxsmall",
    "font.body.large": "--ds-font-body-large",
    "font.body": "--ds-font-body",
    "font.body.small": "--ds-font-body-small",
    "font.body.UNSAFE_small": "--ds-font-body-UNSAFE_small",
    "font.code": "--ds-font-code",
    "font.weight.regular": "--ds-font-weight-regular",
    "font.weight.medium": "--ds-font-weight-medium",
    "font.weight.semibold": "--ds-font-weight-semibold",
    "font.weight.bold": "--ds-font-weight-bold",
    "font.family.heading": "--ds-font-family-heading",
    "font.family.body": "--ds-font-family-body",
    "font.family.code": "--ds-font-family-code",
    "font.family.monospace": "--ds-font-family-monospace",
    "font.family.sans": "--ds-font-family-sans",
    "font.family.brand.heading": "--ds-font-family-brand-heading",
    "font.family.brand.body": "--ds-font-family-brand-body",
    "font.size.050": "--ds-font-size-050",
    "font.size.075": "--ds-font-size-075",
    "font.size.100": "--ds-font-size-100",
    "font.size.200": "--ds-font-size-200",
    "font.size.300": "--ds-font-size-300",
    "font.size.400": "--ds-font-size-400",
    "font.size.500": "--ds-font-size-500",
    "font.size.600": "--ds-font-size-600",
    "font.lineHeight.1": "--ds-font-lineHeight-1",
    "font.lineHeight.100": "--ds-font-lineHeight-100",
    "font.lineHeight.200": "--ds-font-lineHeight-200",
    "font.lineHeight.300": "--ds-font-lineHeight-300",
    "font.lineHeight.400": "--ds-font-lineHeight-400",
    "font.lineHeight.500": "--ds-font-lineHeight-500",
    "font.lineHeight.600": "--ds-font-lineHeight-600"
};
var $7b9c02d3484ec41e$export$2e2bcd8739ae039 = $7b9c02d3484ec41e$var$tokens;

});


parcelRegister("bIbAv", function(module, exports) {

$parcel$export(module.exports, "colorPalette", function () { return $cf3b96607083b7a8$export$569885e57444f84a; });

var $kTdw7 = parcelRequire("kTdw7");
const $cf3b96607083b7a8$export$569885e57444f84a = {
    primaryNavy: (0, $kTdw7).N800,
    primaryBlue: (0, $kTdw7).B500,
    primaryWhite: (0, $kTdw7).N0,
    secondaryRed: (0, $kTdw7).R300,
    secondaryYellow: (0, $kTdw7).Y300,
    secondaryGreen: (0, $kTdw7).G300,
    secondaryCyan: (0, $kTdw7).P300,
    secondaryPurple: (0, $kTdw7).T300
};

});

parcelRegister("cugIF", function(module, exports) {

$parcel$export(module.exports, "SimpleCobranding", function () { return $bf1386dd22286070$export$d04480ee89603948; });
$parcel$export(module.exports, "AdvancedCobranding", function () { return $bf1386dd22286070$export$6e3d039ab597dde7; });
$parcel$export(module.exports, "isSimpleCobranding", function () { return $bf1386dd22286070$export$4289c1cc8b535433; });
$parcel$export(module.exports, "isAdvancedCobranding", function () { return $bf1386dd22286070$export$4d91d2f372f755c7; });
$parcel$export(module.exports, "getCurrentCobranding", function () { return $bf1386dd22286070$export$7a6337ee64e317c4; });
$parcel$export(module.exports, "CobrandingProvider", function () { return $bf1386dd22286070$export$c5b813538c5440a9; });
$parcel$export(module.exports, "useCobranding", function () { return $bf1386dd22286070$export$808c37e33518fa32; });

var $8ZuGG = parcelRequire("8ZuGG");

var $kZj5j = parcelRequire("kZj5j");

var $2O78M = parcelRequire("2O78M");
var $bf1386dd22286070$export$d04480ee89603948;
(function(SimpleCobranding) {
    SimpleCobranding["NO_COBRANDING"] = "no-cobranding";
    SimpleCobranding["BITBUCKET"] = "bitbucket";
    SimpleCobranding["COMPASS"] = "compass";
    SimpleCobranding["CONFLUENCE"] = "confluence";
    SimpleCobranding["JIRA"] = "jira";
    SimpleCobranding["OPSGENIE"] = "opsgenie";
    SimpleCobranding["STATUSPAGE"] = "statuspage";
    SimpleCobranding["TRELLO"] = "trello";
    SimpleCobranding["WAC"] = "wac";
    SimpleCobranding["ATLAS"] = "atlas";
    SimpleCobranding["LOOM"] = "loom";
    SimpleCobranding["JIRA_ALIGN"] = "jira-align";
    SimpleCobranding["WAC_SIGNUP_OTP_EXPERIMENT_JIRA"] = "wac-signup-otp-experiment-jira";
    SimpleCobranding["WAC_SIGNUP_OTP_EXPERIMENT_CONFLUENCE"] = "wac-signup-otp-experiment-confluence";
})($bf1386dd22286070$export$d04480ee89603948 || ($bf1386dd22286070$export$d04480ee89603948 = {}));
var $bf1386dd22286070$export$6e3d039ab597dde7;
(function(AdvancedCobranding) {
    AdvancedCobranding["DEMO"] = "demo";
    AdvancedCobranding["ATLAS_66195"] = "atlas-66195";
    AdvancedCobranding["CFIND_2409"] = "cfind-2409";
})($bf1386dd22286070$export$6e3d039ab597dde7 || ($bf1386dd22286070$export$6e3d039ab597dde7 = {}));
const $bf1386dd22286070$export$4289c1cc8b535433 = (value)=>Object.values($bf1386dd22286070$export$d04480ee89603948).includes(value);
const $bf1386dd22286070$export$4d91d2f372f755c7 = (value)=>Object.values($bf1386dd22286070$export$6e3d039ab597dde7).includes(value);
const $bf1386dd22286070$var$getDisabledApplicationKeys = (dynamicConfigs)=>{
    const disabledApplicationKeys = dynamicConfigs.getStringList((0, $2O78M.AidFrontendDynamicConfig).DISABLED_COBRANDING_APPLICATION_KEYS);
    if ("value" in disabledApplicationKeys) return disabledApplicationKeys.value;
    return [];
};
const $bf1386dd22286070$var$getApplicationKey = (applicationData)=>{
    return `${applicationData.application}${applicationData.experience ? `--${applicationData.experience}` : ""}`;
};
function $bf1386dd22286070$export$7a6337ee64e317c4(cobranding, dynamicConfigs) {
    const applicationData = (0, $kZj5j.lookupApplication)(cobranding);
    if (applicationData) {
        const disabledApplicationKeys = $bf1386dd22286070$var$getDisabledApplicationKeys(dynamicConfigs);
        const applicationKey = $bf1386dd22286070$var$getApplicationKey(applicationData);
        if (disabledApplicationKeys.includes(applicationKey)) {
            console.log(`Cobranding disabled for application: ${applicationKey}`);
            return "no-cobranding";
        }
        switch(applicationData.application){
            case "atlas":
                return "atlas";
            case "bitbucket":
                return "bitbucket";
            case "compass":
                return "compass";
            case "confluence":
                return "confluence";
            case "jira":
                return "jira";
            case "loom":
                return "loom";
            case "jira-align":
                return "jira-align";
            case "opsgenie":
                return "opsgenie";
            case "statuspage":
                return "statuspage";
            case "trello":
                return "trello";
            case "wac":
                switch(applicationData.experience){
                    case "otp-jira":
                        return "wac-signup-otp-experiment-jira";
                    case "otp-confluence":
                        return "wac-signup-otp-experiment-confluence";
                    case "atlas-66195":
                        return "atlas-66195";
                    case "cfind-2409":
                        return "cfind-2409";
                    default:
                        return "wac";
                }
            case "pollinator":
                if (applicationData.experience) {
                    if (applicationData.experience.startsWith("jira")) return "jira";
                    if (applicationData.experience.startsWith("confluence")) return "confluence";
                    if (applicationData.experience === "demo") return "demo";
                }
                return "no-cobranding";
        }
    }
    return "no-cobranding";
}
const $bf1386dd22286070$var$CobrandingContext = /*#__PURE__*/ (0, $8ZuGG.createContext)({
    cobranding: "no-cobranding",
    isMobileApp: false
});
const $bf1386dd22286070$export$c5b813538c5440a9 = $bf1386dd22286070$var$CobrandingContext.Provider;
const $bf1386dd22286070$export$b9c89a068720407f = $bf1386dd22286070$var$CobrandingContext.Consumer;
const $bf1386dd22286070$export$808c37e33518fa32 = ()=>(0, $8ZuGG.useContext)($bf1386dd22286070$var$CobrandingContext);

});
parcelRegister("2O78M", function(module, exports) {

$parcel$export(module.exports, "AidFrontendDynamicConfig", function () { return $21067df3bfaef431$export$72c0add96dbeed4e; });
var $21067df3bfaef431$export$72c0add96dbeed4e;
(function(AidFrontendDynamicConfig) {
    // https://console.statsig.com/LqivKg6ADZZaGczRfBKfX/dynamic_configs/aid-frontend_disabled_cobranding_application_keys
    AidFrontendDynamicConfig["DISABLED_COBRANDING_APPLICATION_KEYS"] = "aid-frontend_disabled_cobranding_application_keys";
})($21067df3bfaef431$export$72c0add96dbeed4e || ($21067df3bfaef431$export$72c0add96dbeed4e = {}));

});


parcelRegister("hB9Ab", function(module, exports) {

$parcel$export(module.exports, "getCobrandedComponents", function () { return $63370adffb00ee7e$export$7f88f5c61e80b9ef; });

var $cugIF = parcelRequire("cugIF");

var $g1Kgy = parcelRequire("g1Kgy");

var $astB0 = parcelRequire("astB0");

var $1Szkf = parcelRequire("1Szkf");

var $gUezr = parcelRequire("gUezr");

var $2erun = parcelRequire("2erun");

var $7lF7s = parcelRequire("7lF7s");

var $gAd27 = parcelRequire("gAd27");

var $ccCNm = parcelRequire("ccCNm");

var $lw2Cv = parcelRequire("lw2Cv");

var $3b3Yv = parcelRequire("3b3Yv");

var $gyHmd = parcelRequire("gyHmd");

var $i1r2g = parcelRequire("i1r2g");

var $4YCdO = parcelRequire("4YCdO");

var $8liMg = parcelRequire("8liMg");
const $63370adffb00ee7e$var$cobrandingMap = {
    [(0, $cugIF.SimpleCobranding).NO_COBRANDING]: (0, $g1Kgy.default),
    [(0, $cugIF.SimpleCobranding).BITBUCKET]: (0, $astB0.default),
    [(0, $cugIF.SimpleCobranding).COMPASS]: (0, $1Szkf.default),
    [(0, $cugIF.SimpleCobranding).CONFLUENCE]: (0, $gUezr.default),
    [(0, $cugIF.SimpleCobranding).JIRA]: (0, $2erun.default),
    [(0, $cugIF.SimpleCobranding).LOOM]: (0, $4YCdO.default),
    [(0, $cugIF.SimpleCobranding).JIRA_ALIGN]: (0, $8liMg.default),
    [(0, $cugIF.SimpleCobranding).OPSGENIE]: (0, $7lF7s.default),
    [(0, $cugIF.SimpleCobranding).STATUSPAGE]: (0, $gAd27.default),
    [(0, $cugIF.SimpleCobranding).TRELLO]: (0, $ccCNm.default),
    [(0, $cugIF.SimpleCobranding).WAC]: (0, $lw2Cv.default),
    [(0, $cugIF.SimpleCobranding).ATLAS]: (0, $3b3Yv.default),
    [(0, $cugIF.SimpleCobranding).WAC_SIGNUP_OTP_EXPERIMENT_JIRA]: (0, $gyHmd.default),
    [(0, $cugIF.SimpleCobranding).WAC_SIGNUP_OTP_EXPERIMENT_CONFLUENCE]: (0, $i1r2g.default)
};
const $63370adffb00ee7e$export$7f88f5c61e80b9ef = (cobranding)=>{
    if ((0, $cugIF.isSimpleCobranding)(cobranding)) return $63370adffb00ee7e$var$cobrandingMap[cobranding];
    else {
        console.warn(`[COBRANDING] ${cobranding} is globally configured for advanced-cobranding but corresponding configuration for ${window.location.pathname} was not provided. Loading SimpleCobranding.NO_BRANDING as fallback.`);
        return $63370adffb00ee7e$var$cobrandingMap[(0, $cugIF.SimpleCobranding).NO_COBRANDING];
    }
};

});
parcelRegister("g1Kgy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1846838c2bc9e83f$export$2e2bcd8739ae039; });

var $5v6A7 = parcelRequire("5v6A7");

var $b2Jk5 = parcelRequire("b2Jk5");

var $cx88G = parcelRequire("cx88G");

var $1CA01 = parcelRequire("1CA01");
const $1846838c2bc9e83f$export$f2683fd6d2de1a37 = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($cx88G))), (0, (/*@__PURE__*/$parcel$interopDefault($1CA01))));
const $1846838c2bc9e83f$var$DefaultCobranding = {
    background: $1846838c2bc9e83f$export$f2683fd6d2de1a37,
    logo: {
        component: (0, $5v6A7.AtlassianLogo)
    },
    footerProducts: "Jira, Confluence, Trello"
};
var $1846838c2bc9e83f$export$2e2bcd8739ae039 = $1846838c2bc9e83f$var$DefaultCobranding;

});
parcelRegister("b2Jk5", function(module, exports) {

$parcel$export(module.exports, "whiteboxWidthDesktop", function () { return $03e1c506857a731b$export$4dacb4c23fc28876; });
$parcel$export(module.exports, "whiteboxWidthHandheld", function () { return $03e1c506857a731b$export$6bfb439877eddd98; });
$parcel$export(module.exports, "linkStyles", function () { return $03e1c506857a731b$export$4ea5976125a01ffa; });
$parcel$export(module.exports, "listStyles", function () { return $03e1c506857a731b$export$f9b6c540022859c0; });
$parcel$export(module.exports, "DefaultBackground", function () { return $03e1c506857a731b$export$cffd0b81d0e051b1; });
$parcel$export(module.exports, "backgroundWithSideImages", function () { return $03e1c506857a731b$export$c9af51660ef2db22; });
$parcel$export(module.exports, "backgroundWithImage", function () { return $03e1c506857a731b$export$860f6dae4486c905; });
$parcel$export(module.exports, "renderProductLogo", function () { return $03e1c506857a731b$export$390d73d0230797c4; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $ihLLY = parcelRequire("ihLLY");

var $bIbAv = parcelRequire("bIbAv");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");
let $03e1c506857a731b$var$_ = (t)=>t, $03e1c506857a731b$var$t, $03e1c506857a731b$var$t1, $03e1c506857a731b$var$t2, $03e1c506857a731b$var$t3, $03e1c506857a731b$var$t4, $03e1c506857a731b$var$t5, $03e1c506857a731b$var$t6, $03e1c506857a731b$var$t7, $03e1c506857a731b$var$t8, $03e1c506857a731b$var$t9;
const $03e1c506857a731b$export$4dacb4c23fc28876 = `${(0, $5b7Z4.gridSize)() * 50}px`;
const $03e1c506857a731b$export$6bfb439877eddd98 = `${(0, $5b7Z4.gridSize)() * 40}px`;
const $03e1c506857a731b$export$7970b24609d80d2d = (0, $3XNKR.default).div($03e1c506857a731b$var$t1 || ($03e1c506857a731b$var$t1 = $03e1c506857a731b$var$_`
  ${0};
`), (0, $ihLLY.media).handheld($03e1c506857a731b$var$t || ($03e1c506857a731b$var$t = $03e1c506857a731b$var$_`
    display: none;
  `)));
const $03e1c506857a731b$export$97b346657ff4770f = (0, $3XNKR.default).div($03e1c506857a731b$var$t3 || ($03e1c506857a731b$var$t3 = $03e1c506857a731b$var$_`
  display: none;

  ${0};
`), (0, $ihLLY.media).handheld($03e1c506857a731b$var$t2 || ($03e1c506857a731b$var$t2 = $03e1c506857a731b$var$_`
    display: inline-block;
  `)));
const $03e1c506857a731b$export$4ea5976125a01ffa = (color)=>`
   a {
      color: ${color};

      &:hover {
        color: ${color};
      }
      &.hover {
        color: ${color};
      }
      &.primary-action {
        color: ${color};
      }
   }
`;
const $03e1c506857a731b$export$f9b6c540022859c0 = `
    ul {
      display: flex;
      justify-content: center;
      list-style: none;
      padding: 0;
    }
`;
const $03e1c506857a731b$export$79accfaaa957e0a3 = {
    textColor: (0, $kTdw7).B400,
    iconColor: (0, $kTdw7).B200,
    iconGradientStart: (0, $kTdw7).B400
};
const $03e1c506857a731b$export$f77c0d2e3bde3a8b = {
    textColor: (0, $kTdw7).N500,
    iconColor: (0, $kTdw7).N300,
    iconGradientStart: (0, $kTdw7).N500
};
const $03e1c506857a731b$export$cffd0b81d0e051b1 = (0, $3XNKR.default).div($03e1c506857a731b$var$t5 || ($03e1c506857a731b$var$t5 = $03e1c506857a731b$var$_`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: -1;
  background-color: ${0};
  ${0}
`), (0, $kTdw7).N10, (0, $ihLLY.media).handheld($03e1c506857a731b$var$t4 || ($03e1c506857a731b$var$t4 = $03e1c506857a731b$var$_`
    background: ${0};
    color: ${0};
  `), (0, $bIbAv.colorPalette).primaryWhite, (0, $bIbAv.colorPalette).primaryNavy));
function $03e1c506857a731b$export$c9af51660ef2db22(leftImageSrc, rightImageSrc) {
    const scalingImagesMaxWidth = `${(0, $5b7Z4.gridSize)() * 150}px`; //50 grid size for whitebox + 2 * 50 grid size for images
    const widescreenBackgroundImageSize = `calc((100vw - ${$03e1c506857a731b$export$4dacb4c23fc28876})/2 - ${(0, $5b7Z4.gridSize)() * 4}px) auto`;
    return (0, $3XNKR.default)($03e1c506857a731b$export$cffd0b81d0e051b1)($03e1c506857a731b$var$t7 || ($03e1c506857a731b$var$t7 = $03e1c506857a731b$var$_`
    background-image: url(${0}), url(${0});
    background-repeat: no-repeat, no-repeat;
    background-attachment: fixed, fixed;
    background-size: ${0}px auto, ${0}px auto;
    background-position: left bottom, right bottom;

    @media (max-width: ${0}) {
      background-size: ${0}, ${0}, cover;
    }

    ${0}
  `), leftImageSrc, rightImageSrc, (0, $5b7Z4.gridSize)() * 46, (0, $5b7Z4.gridSize)() * 46, scalingImagesMaxWidth, widescreenBackgroundImageSize, widescreenBackgroundImageSize, (0, $ihLLY.media).handheld($03e1c506857a731b$var$t6 || ($03e1c506857a731b$var$t6 = $03e1c506857a731b$var$_`
      background: ${0};
      color: ${0};
    `), (0, $bIbAv.colorPalette).primaryWhite, (0, $bIbAv.colorPalette).primaryNavy));
}
function $03e1c506857a731b$export$860f6dae4486c905(bgImageSrc) {
    return (0, $3XNKR.default)($03e1c506857a731b$export$cffd0b81d0e051b1)($03e1c506857a731b$var$t9 || ($03e1c506857a731b$var$t9 = $03e1c506857a731b$var$_`
    background-image: url(${0});
    background-position: center;
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-size: cover;

    ${0}
  `), bgImageSrc, (0, $ihLLY.media).handheld($03e1c506857a731b$var$t8 || ($03e1c506857a731b$var$t8 = $03e1c506857a731b$var$_`
      background: ${0};
      color: ${0};
    `), (0, $bIbAv.colorPalette).primaryWhite, (0, $bIbAv.colorPalette).primaryNavy));
}
const $03e1c506857a731b$export$390d73d0230797c4 = (props)=>{
    if ("renderLogo" in props) // is a custom logo
    return props.renderLogo();
    const { component: AtlaskitLogo } = props;
    return /*#__PURE__*/ (0, $6rcps.jsx)(AtlaskitLogo, {
        appearance: "brand",
        size: "large"
    });
};

});
parcelRegister("ihLLY", function(module, exports) {

$parcel$export(module.exports, "media", function () { return $6097029e68378a82$export$987d49ffe1b0900f; });
$parcel$export(module.exports, "screenSizeMatcher", function () { return $6097029e68378a82$export$417d65d80b205866; });
$parcel$export(module.exports, "screenSize", function () { return $6097029e68378a82$export$463d066e8ee12fba; });

var $14VNY = parcelRequire("14VNY");

var $5b7Z4 = parcelRequire("5b7Z4");
let $6097029e68378a82$var$_ = (t)=>t, $6097029e68378a82$var$t;
const $6097029e68378a82$var$mobileMaxWidth = `${(0, $5b7Z4.gridSize)() * 100}px`;
const $6097029e68378a82$var$mediaQueryCss = (query)=>(...args)=>{
        // @ts-ignore
        const inner = (0, $14VNY.css)(...args);
        return (0, $14VNY.css)($6097029e68378a82$var$t || ($6097029e68378a82$var$t = $6097029e68378a82$var$_`
    @media ${0} {
      ${0}
    }
  `), query, inner);
    };
const $6097029e68378a82$var$mediaQuery = {
    handheldQuery: `(max-width: ${$6097029e68378a82$var$mobileMaxWidth})`
};
const $6097029e68378a82$export$987d49ffe1b0900f = {
    handheld: $6097029e68378a82$var$mediaQueryCss($6097029e68378a82$var$mediaQuery.handheldQuery),
    ...$6097029e68378a82$var$mediaQuery
};
const $6097029e68378a82$export$417d65d80b205866 = window.matchMedia && window.matchMedia($6097029e68378a82$export$987d49ffe1b0900f.handheldQuery);
const $6097029e68378a82$export$463d066e8ee12fba = ()=>$6097029e68378a82$export$417d65d80b205866 ? $6097029e68378a82$export$417d65d80b205866.matches ? "mobile" : "desktop" : "unknown";
const $6097029e68378a82$var$maxWidth = (screenSize)=>{
    switch(screenSize){
        case "mobile":
            return $6097029e68378a82$var$mobileMaxWidth;
        default:
            return "100%";
    }
};
const $6097029e68378a82$export$d7b7311ec04a3e8f = (screenSize, name)=>{
    const viewport = {};
    viewport[screenSize] = {
        name: name ? name : screenSize,
        styles: {
            width: $6097029e68378a82$var$maxWidth(screenSize),
            height: "100%"
        }
    };
    return viewport;
};

});


parcelRegister("cx88G", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "default_left.dfc31853.svg";

});

parcelRegister("1CA01", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "default_right.a801c0cc.svg";

});


parcelRegister("astB0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b699deb75020641c$export$2e2bcd8739ae039; });

var $4n0t6 = parcelRequire("4n0t6");

var $iOGBn = parcelRequire("iOGBn");
const $b699deb75020641c$var$BitbucketCobranding = {
    background: (0, $iOGBn.BitbucketBackground),
    logo: {
        component: (0, $4n0t6.BitbucketLogo)
    },
    footerProducts: "Bitbucket, Jira, Confluence"
};
var $b699deb75020641c$export$2e2bcd8739ae039 = $b699deb75020641c$var$BitbucketCobranding;

});
parcelRegister("4n0t6", function(module, exports) {

$parcel$export(module.exports, "BitbucketLogo", function () { return $32e9ac67a8779256$export$bd40525f5333524b; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $32e9ac67a8779256$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 158 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n        <path fill='.concat(colors.iconColor, ' d="m20.46 15.152-1.619 9.885c-.105.598-.527.95-1.125.95H3.996c-.599 0-1.02-.352-1.126-.95L.02 7.412c-.105-.598.211-.985.774-.985h20.123c.563 0 .88.387.774.985l-.774 4.644c-.106.668-.493.95-1.126.95H7.69c-.176 0-.281.105-.246.316l.95 5.84c.035.141.14.247.281.247h4.363c.14 0 .246-.106.281-.247l.668-4.221c.07-.528.423-.739.915-.739h4.75c.703 0 .914.352.809.95"/>\n        <path fill=').concat(colors.textColor, ' d="M153.212 20.787c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545c-.46.123-.981.245-1.778.245-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zm-13.537-8.494c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-23.82.613h-2.638V3.799h2.638v13.585l6.593-7.176h3.435l-7.207 7.544 7.513 7.79h-3.588l-6.746-7.176zm-5.648-2.76v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-27.843-3.588v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.982 1.81-2.79 2.821-4.846 2.821-3.526 0-5.55-2.422-5.55-6.654m-5.388-1.319c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v2.699h-2.637V3.798h2.637v9.17c.982-2.025 2.822-3.067 5.183-3.067 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-14.974-5.06c0 1.35.797 2.27 2.422 2.27.614 0 1.196-.123 1.656-.215v2.545a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.187h-2.484v-2.454h2.484v-3.25h2.576v3.25h4.078v2.453h-4.078zM53.328 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S56.242 8 55.168 8s-1.84-.676-1.84-1.84m.49 19.38V10.207h2.638V25.54zm-9.828-9.046h-6.194v6.287h6.256c2.637 0 3.833-.951 3.833-2.975 0-2.147-1.134-3.312-3.894-3.312m-.889-8.464h-5.305v6.01h5.305c2.607 0 3.68-1.195 3.68-3.127 0-1.963-1.165-2.883-3.68-2.883m-8.065 17.51V5.394h8.433c4.11 0 6.103 2.024 6.103 5.274 0 2.423-1.104 3.926-3.373 4.478 2.974.49 4.446 2.116 4.446 4.968 0 3.22-2.177 5.428-6.685 5.428z"/>\n      </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) {
            colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
            id = "bitbucketLogo-".concat(appearance);
        }
        return '\n    <svg viewBox="0 0 137 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n      <defs>\n        <linearGradient x1="100.866322%" y1="25.6261254%" x2="46.5685299%" y2="75.2076031%" id="'.concat(id, '">\n          <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n          <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n        </linearGradient>\n      </defs>\n      <g stroke="none" stroke-width="1" fill-rule="evenodd">\n        <path d="M22.38125,13.1176316 L15.3425,13.1176316 L14.16125,20.0504386 L9.28624997,20.0504386 L3.52999997,26.9266667 C3.71244766,27.0853527 3.94506033,27.173594 4.18624997,27.175614 L19.46375,27.175614 C19.8352946,27.180424 20.1543287,26.9108682 20.21375,26.5419298 L22.38125,13.1176316 Z" fill="url(#').concat(id, ')" fill-rule="nonzero"></path>\n        <path fill="').concat(colors.iconColor, '" fill-rule="nonzero" d="M0.759678147,6 C0.53811485,5.99712567 0.326627812,6.09294508 0.181948325,6.26175474 C0.0372688368,6.4305644 -0.0257933559,6.65508453 0.00967814748,6.87508772 L3.19342815,26.315614 C3.23255884,26.5521357 3.35340224,26.7671859 3.53467815,26.9228947 L3.53467815,26.9228947 C3.71712584,27.0815808 3.94973851,27.169822 4.19092815,27.1718421 L10.1009281,20.0504386 L9.27217815,20.0504386 L7.97092815,13.1176316 L22.3859281,13.1176316 L23.3984281,6.88263158 C23.4360238,6.66342534 23.375521,6.43870373 23.2330921,6.26853487 C23.0906632,6.09836602 22.880829,6.00009878 22.6596781,6 L0.759678147,6 Z"></path>\n        <path fill="').concat(colors.textColor, '" d="M32,8.352 L38.63,8.352 C42.114,8.352 43.804,10.068 43.804,12.824 C43.804,14.878 42.868,16.152 40.944,16.62 C43.466,17.036 44.714,18.414 44.714,20.832 C44.714,23.562 42.868,25.434 39.046,25.434 L32,25.434 L32,8.352 Z M38.318,10.588 L34.34,10.588 L34.34,15.684 L38.318,15.684 C40.528,15.684 41.438,14.67 41.438,13.032 C41.438,11.368 40.45,10.588 38.318,10.588 Z M39.072,17.764 L34.34,17.764 L34.34,23.094 L39.124,23.094 C41.36,23.094 42.374,22.288 42.374,20.572 C42.374,18.752 41.412,17.764 39.072,17.764 Z M47.236,9.002 C47.236,9.99 47.886,10.562 48.796,10.562 C49.706,10.562 50.356,9.99 50.356,9.002 C50.356,8.014 49.706,7.442 48.796,7.442 C47.886,7.442 47.236,8.014 47.236,9.002 Z M47.652,25.434 L49.888,25.434 L49.888,12.434 L47.652,12.434 L47.652,25.434 Z M56.362,21.326 L56.362,14.514 L59.82,14.514 L59.82,12.434 L56.362,12.434 L56.362,9.678 L54.178,9.678 L54.178,12.434 L52.072,12.434 L52.072,14.514 L54.178,14.514 L54.178,21.378 C54.178,23.796 55.53,25.434 58.312,25.434 C58.988,25.434 59.43,25.33 59.82,25.226 L59.82,23.068 C59.43,23.146 58.936,23.25 58.416,23.25 C57.038,23.25 56.362,22.47 56.362,21.326 Z M74.51,18.934 C74.51,22.6 72.69,25.694 69.05,25.694 C67.152,25.694 65.696,24.836 64.916,23.146 L64.916,25.434 L62.68,25.434 L62.68,7 L64.916,7 L64.916,14.774 C65.748,13.058 67.308,12.174 69.31,12.174 C72.768,12.174 74.51,15.112 74.51,18.934 Z M72.274,18.934 C72.274,15.814 71.026,14.254 68.712,14.254 C66.71,14.254 64.916,15.528 64.916,18.414 L64.916,19.454 C64.916,22.34 66.554,23.614 68.452,23.614 C70.974,23.614 72.274,21.95 72.274,18.934 Z M76.85,20.052 C76.85,23.64 78.566,25.694 81.556,25.694 C83.298,25.694 84.832,24.836 85.664,23.302 L85.664,25.434 L87.9,25.434 L87.9,12.434 L85.664,12.434 L85.664,19.662 C85.664,22.288 84.234,23.666 82.154,23.666 C80.022,23.666 79.086,22.626 79.086,20.286 L79.086,12.434 L76.85,12.434 L76.85,20.052 Z M100.458,23.094 C99.652,23.38 98.82,23.562 97.494,23.562 C94.088,23.562 92.684,21.43 92.684,18.908 C92.684,16.386 94.062,14.254 97.442,14.254 C98.664,14.254 99.548,14.488 100.38,14.878 L100.38,12.798 C99.366,12.33 98.456,12.174 97.286,12.174 C92.658,12.174 90.5,14.982 90.5,18.908 C90.5,22.886 92.658,25.694 97.286,25.694 C98.482,25.694 99.678,25.512 100.458,25.096 L100.458,23.094 Z M105.242,25.434 L105.242,19.35 L110.962,25.434 L114.004,25.434 L107.634,18.83 L113.744,12.434 L110.832,12.434 L105.242,18.518 L105.242,7 L103.006,7 L103.006,25.434 L105.242,25.434 Z M126.224,24.914 C125.158,25.486 123.52,25.694 122.194,25.694 C117.332,25.694 115.2,22.886 115.2,18.908 C115.2,14.982 117.384,12.174 121.336,12.174 C125.34,12.174 126.952,14.956 126.952,18.908 L126.952,19.922 L117.462,19.922 C117.774,22.132 119.204,23.562 122.272,23.562 C123.78,23.562 125.054,23.276 126.224,22.86 L126.224,24.914 Z M121.232,14.202 C118.866,14.202 117.67,15.736 117.436,17.998 L124.69,17.998 C124.56,15.58 123.468,14.202 121.232,14.202 Z M132.698,21.326 L132.698,14.514 L136.156,14.514 L136.156,12.434 L132.698,12.434 L132.698,9.678 L130.514,9.678 L130.514,12.434 L128.408,12.434 L128.408,14.514 L130.514,14.514 L130.514,21.378 C130.514,23.796 131.866,25.434 134.648,25.434 C135.324,25.434 135.766,25.33 136.156,25.226 L136.156,23.068 C135.766,23.146 135.272,23.25 134.752,23.25 C133.374,23.25 132.698,22.47 132.698,21.326 Z"></path>\n      </g>\n    </svg>');
    }
};
var $32e9ac67a8779256$export$bd40525f5333524b = function BitbucketLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Bitbucket" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $32e9ac67a8779256$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("iOGBn", function(module, exports) {

$parcel$export(module.exports, "BitbucketBackground", function () { return $db2df15c0f2661e8$export$7a8deb158bc23a3c; });

var $8ZuGG = parcelRequire("8ZuGG");

var $hkiBI = parcelRequire("hkiBI");

var $5GyOg = parcelRequire("5GyOg");
var $db2df15c0f2661e8$export$7a8deb158bc23a3c = function BitbucketBackground(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5GyOg.DesktopOnlyBackground), {
        background: (0, $hkiBI.BitbucketLightTheme)
    }, children);
};

});
parcelRegister("hkiBI", function(module, exports) {

$parcel$export(module.exports, "BitbucketLightTheme", function () { return $c9d2bcf6106a5376$export$880f50d5c5924242; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eOtKa = parcelRequire("eOtKa");

var $j69BP = parcelRequire("j69BP");

var $4tjeQ = parcelRequire("4tjeQ");

var $c0yO5 = parcelRequire("c0yO5");

var $g800D = parcelRequire("g800D");

var $lWA6j = parcelRequire("lWA6j");

var $bMmao = parcelRequire("bMmao");

var $epoDP = parcelRequire("epoDP");
var $c9d2bcf6106a5376$export$880f50d5c5924242 = function BitbucketLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": "testId-bitbucket-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eOtKa.Background), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4tjeQ.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $j69BP.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bMmao.SecondaryNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lWA6j.PageHeader), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $c0yO5.PageActions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $g800D.PageContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $epoDP.Sidebar), null));
};

});
parcelRegister("eOtKa", function(module, exports) {

$parcel$export(module.exports, "Background", function () { return $ac8ccea5bc424eb3$export$668799e4797757a8; });
$parcel$export(module.exports, "DarkBackground", function () { return $ac8ccea5bc424eb3$export$ede4ebd46660008d; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3XNKR = parcelRequire("3XNKR");
var $ac8ccea5bc424eb3$export$668799e4797757a8 = (0, $3XNKR.default).div({
    position: "fixed",
    background: "#fff",
    height: "100%",
    width: "100%"
});
var $ac8ccea5bc424eb3$export$ede4ebd46660008d = (0, $3XNKR.default).div({
    position: "fixed",
    background: "#2c333a",
    width: "100%",
    height: "100%"
});

});

parcelRegister("j69BP", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $de7608075fe88186$export$4b85d3515bd863a5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");
var $de7608075fe88186$export$4b85d3515bd863a5 = function Search() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($de7608075fe88186$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($de7608075fe88186$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $de7608075fe88186$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    top: 0,
    right: 0
});
var $de7608075fe88186$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "412",
        height: "56",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M356 12h32v32h-32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SearchA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M386.93 27.996c0-8.246-6.685-14.931-14.931-14.931-8.247 0-14.932 6.685-14.932 14.931 0 8.247 6.685 14.932 14.932 14.932 8.246 0 14.931-6.685 14.931-14.932Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M378.394 39.69a4.277 4.277 0 0 1-2.655-3.95 4.172 4.172 0 0 1 1.471-3.218c5.888-4.944 2.235-14.518-5.364-14.364-7.444.127-10.831 9.523-5.054 14.364a4.178 4.178 0 0 1 1.471 3.218 4.27 4.27 0 0 1-2.654 3.95c-.463.192-.917.406-1.366.632-.125.064-.242.139-.365.206a14.862 14.862 0 0 0 8.124 2.407c3 0 5.792-.888 8.129-2.41a16.828 16.828 0 0 0-1.735-.835h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SearchB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "238",
        height: "32",
        x: "25",
        y: "12",
        fill: "#F4F5F7",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M46 27a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.89a6 6 0 1 1 1.414-1.414l2.816 2.817a1 1 0 0 1-1.414 1.414l-2.816-2.816Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M274 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M280.485 33.669a2 2 0 0 0 2.829 0l-2.829-2.83a2.004 2.004 0 0 0-.434 2.18c.101.244.248.464.434.65Zm4.897-12.191-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.046 5.046 0 0 0 .64-6.356 1.01 1.01 0 1 0-1.354-1.494c-.023.025-.046.049-.066.075a5.044 5.044 0 0 0-4.72-.457 5.03 5.03 0 0 0-1.638 1.095v.001Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M314 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M336 28c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-7.172-4.84a3.97 3.97 0 0 1 1.062 1.89 3.988 3.988 0 0 1-2.536 4.698.507.507 0 0 0-.35.472v.782a1.005 1.005 0 0 1-1.002 1.002A1.003 1.003 0 0 1 325 31.002v-2.014a.998.998 0 0 1 1-.987h-.007a2.004 2.004 0 0 0 2.003-2 2.003 2.003 0 0 0-3.405-1.386 2 2 0 0 0-.602 1.388c-.002.551-.45.998-1.002.998a.993.993 0 0 1-.982-.904L322 25.95c.017-2.504 2.321-4.436 4.933-3.842a3.973 3.973 0 0 1 1.895 1.052ZM327 34a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SearchA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M357 13h30v30h-30z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SearchB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M24 11h314v34H24z"
    }))));
};

});

parcelRegister("4tjeQ", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $3418cb3531fc71cb$export$8b251419efc915eb; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9ram4 = parcelRequire("9ram4");
var $3418cb3531fc71cb$export$8b251419efc915eb = function Header() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($3418cb3531fc71cb$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Line), null));
};
var $3418cb3531fc71cb$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 1440,
        height: 56,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M52 16h120v24H52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#253858",
        d: "M77.445 20.2h6.523c3.18 0 4.717 1.51 4.717 3.935 0 1.825-.863 2.946-2.615 3.337 2.291.364 3.45 1.59 3.45 3.727 0 2.398-1.67 4.066-5.175 4.066h-6.9V20.2Zm2.156 6.437h4.097c2.022 0 2.857-.886 2.857-2.346s-.89-2.163-2.857-2.163h-4.097v4.51Zm0 1.851v4.692h4.852c2.048 0 2.965-.704 2.965-2.215 0-1.617-.89-2.477-3.019-2.477h-4.798Zm13.423-9.097c.836 0 1.429.495 1.429 1.382 0 .86-.593 1.381-1.429 1.381-.835 0-1.428-.495-1.428-1.381 0-.887.593-1.382 1.428-1.382Zm-1.05 4.405h2.048v11.47h-2.049v-11.47Zm9.81 9.619c.486 0 .917-.105 1.294-.157v1.903c-.35.104-.754.183-1.374.183-2.534 0-3.774-1.434-3.774-3.572v-6.151h-1.914v-1.825h1.914v-2.424h1.995v2.424h3.153v1.825h-3.153v6.073c0 1.017.62 1.72 1.859 1.72Zm5.93-.183v2.007h-2.048V19h2.048v6.855c.755-1.511 2.184-2.293 4.016-2.293 3.154 0 4.744 2.58 4.744 5.969 0 3.232-1.671 5.969-4.986 5.969-1.725 0-3.046-.756-3.774-2.268Zm3.477-7.82c-1.833 0-3.45 1.121-3.45 3.676V30c0 2.554 1.483 3.675 3.235 3.675 2.291 0 3.477-1.46 3.477-4.118-.027-2.79-1.159-4.145-3.262-4.145Zm7.413-1.616h2.048v6.934c0 2.06.863 2.971 2.804 2.971 1.886 0 3.207-1.225 3.207-3.545v-6.36h2.049v11.47h-2.049v-1.877c-.755 1.355-2.156 2.111-3.747 2.111-2.722 0-4.285-1.825-4.285-4.979v-6.725h-.027Zm21.536 11.157c-.701.364-1.806.52-2.884.52-4.232 0-6.199-2.475-6.199-5.994 0-3.467 1.967-5.944 6.199-5.944 1.078 0 1.887.13 2.83.548v1.825c-.754-.34-1.563-.548-2.668-.548-3.073 0-4.34 1.877-4.34 4.119 0 2.241 1.294 4.118 4.394 4.118 1.213 0 1.967-.156 2.695-.417v1.773h-.027Zm2.318.312V19h2.049v10.166l5.094-5.37h2.669l-5.58 5.63 5.822 5.84h-2.776l-5.229-5.37v5.37h-2.049Zm16.793.235c-4.448 0-6.388-2.476-6.388-5.995 0-3.467 1.994-5.943 5.606-5.943 3.666 0 5.121 2.45 5.121 5.943v.886h-8.652c.297 1.955 1.59 3.206 4.394 3.206 1.374 0 2.533-.26 3.612-.625v1.824c-.971.522-2.48.704-3.693.704Zm-4.34-6.803h6.631c-.108-2.138-1.105-3.337-3.154-3.337-2.156 0-3.261 1.356-3.477 3.337Zm15.795 4.718c.485 0 .917-.105 1.294-.157v1.903c-.35.104-.755.183-1.375.183-2.533 0-3.773-1.434-3.773-3.572v-6.151h-1.914v-1.825h1.914v-2.424h1.994v2.424H172v1.825h-3.154v6.073c0 1.017.62 1.72 1.86 1.72Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M52.54 20.642c-.324 0-.594.287-.54.6l2.291 13.424c.054.339.35.6.728.6h10.97c.27 0 .486-.183.54-.444l2.29-13.58c.054-.313-.188-.6-.539-.6H52.54Zm9.649 9.697h-3.504l-.944-4.796h5.31l-.862 4.796Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#c)",
        d: "M68.092 25.543h-5.068l-.835 4.796h-3.504l-4.151 4.744s.188.182.485.182h10.97c.27 0 .485-.182.54-.443l1.563-9.28Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#d)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M196 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 203.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M290 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        width: 71,
        height: 6,
        x: 297.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M384 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 71,
        height: 6,
        x: 391.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M478 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 56,
        height: 6,
        x: 486,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#e)",
        opacity: 0.6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M548 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#344563",
        fillRule: "evenodd",
        d: "M548.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#0052CC",
        d: "M482 54a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v2h-78v-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 61,
        height: 32,
        x: 289.5,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 44,
        height: 6,
        x: 297.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 61,
        height: 32,
        x: 383.5,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 44,
        height: 6,
        x: 391.5,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 61,
        height: 32,
        x: 580,
        y: 12,
        fill: "#B3D4FF",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 44,
        height: 6,
        x: 588,
        y: 25,
        fill: "#091E42",
        fillOpacity: 0.13,
        rx: 3
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M18 16h24v24H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#A5ADBA",
        fillRule: "evenodd",
        d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M52 0h589v56H52z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M52 16h120v24H52z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "d"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M192 0h449v56H192z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "e"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M548 18h8v20h-8z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "c",
        x1: 69.254,
        x2: 61.106,
        y1: 26.89,
        y2: 33.467,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 0.176,
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    }))));
};

});
parcelRegister("9ram4", function(module, exports) {

$parcel$export(module.exports, "Wrapper", function () { return $01c5e9fbc121c9dc$export$e6dfd72ab29f8598; });
$parcel$export(module.exports, "Line", function () { return $01c5e9fbc121c9dc$export$17d680238e50603e; });
$parcel$export(module.exports, "DarkModeLine", function () { return $01c5e9fbc121c9dc$export$e7439992f3f52d0; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $01c5e9fbc121c9dc$export$e6dfd72ab29f8598 = (0, $3XNKR.default).div({
    position: "fixed",
    top: 0,
    left: 0,
    "@media (min-width: 1200px)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.small, path.small": {
            visibility: "hidden"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.medium, path.medium": {
            visibility: "hidden"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.large, path.large": {
            visibility: "visible"
        }
    },
    "@media (min-width: 1000px) and (max-width: 1200px)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.small, path.small": {
            visibility: "hidden"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.large, path.large": {
            visibility: "hidden"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.medium, path.medium": {
            visibility: "visible"
        }
    },
    "@media (max-width: 1000px)": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.medium, path.medium": {
            visibility: "hidden"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.large, path.large": {
            visibility: "hidden"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "rect.small, path.small": {
            visibility: "visible"
        }
    }
});
var $01c5e9fbc121c9dc$export$17d680238e50603e = (0, $3XNKR.default).div({
    display: "inline-block",
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    left: 0,
    height: "2px",
    width: "100%",
    background: "#dfe1e6",
    zIndex: 1
});
var $01c5e9fbc121c9dc$export$e7439992f3f52d0 = (0, $3XNKR.default).div({
    display: "inline-block",
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    left: 0,
    height: "2px",
    width: "100%",
    background: "#454f59",
    zIndex: 1
});

});
parcelRegister("d2jyZ", function(module, exports) {

$parcel$export(module.exports, "HEADER_HEIGHT", function () { return $97daa328576f9f51$export$cdb7fd9d999c7168; });
$parcel$export(module.exports, "SECONDARY_NAV_WIDTH", function () { return $97daa328576f9f51$export$6cfc56c8a5804224; });
var $97daa328576f9f51$export$cdb7fd9d999c7168 = 56;
var $97daa328576f9f51$export$6cfc56c8a5804224 = 240;

});



parcelRegister("c0yO5", function(module, exports) {

$parcel$export(module.exports, "PageActions", function () { return $8be07c092066b364$export$a9e583a1195b23df; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");

var $145Wl = parcelRequire("145Wl");
var $8be07c092066b364$export$a9e583a1195b23df = function PageActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($8be07c092066b364$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($8be07c092066b364$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $8be07c092066b364$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: "".concat((0, $145Wl.SIDEBAR_WIDTH), "px"),
    background: "#fff"
});
var $8be07c092066b364$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "292",
        height: "112",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageActionsA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "32",
        x: "24",
        y: "56",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "104",
        height: "6",
        x: "32",
        y: "69",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "80",
        height: "32",
        x: "150",
        y: "56",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "64",
        height: "6",
        x: "158",
        y: "69",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "236",
        y: "56",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M240 60h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        d: "M245 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM252 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM259 74a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageActionsA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M24 56h244v32H24z"
    }))));
};

});
parcelRegister("145Wl", function(module, exports) {

$parcel$export(module.exports, "SIDEBAR_WIDTH", function () { return $0c6ac5c2229cbe36$export$780035d9fe48eb32; });
var $0c6ac5c2229cbe36$export$780035d9fe48eb32 = 333;

});


parcelRegister("g800D", function(module, exports) {

$parcel$export(module.exports, "PageContent", function () { return $bbdd668c1d8b71af$export$16800ac069904dff; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");

var $145Wl = parcelRequire("145Wl");
var $bbdd668c1d8b71af$export$16800ac069904dff = function PageContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bbdd668c1d8b71af$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bbdd668c1d8b71af$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($bbdd668c1d8b71af$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $bbdd668c1d8b71af$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT) + 150, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH) + 24, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    right: "".concat((0, $145Wl.SIDEBAR_WIDTH) + 24, "px"),
    minHeight: "661px"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $bbdd668c1d8b71af$var$ImageWrapper = (0, $3XNKR.default).div({
    display: "flex",
    justifyContent: "center"
});
var $bbdd668c1d8b71af$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "820",
        height: "619",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M32 16c0-8.837-7.163-16-16-16S0 7.163 0 16s7.163 16 16 16 16-7.163 16-16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0065FF",
        d: "M24.466 25.316ZM17.472 30.51l.026-.105.023-.095-1.26.653 1.308-.87c.018-.098.029-.195.026-.29a.653.653 0 0 0-.059-.256c-.115-.038-.202-.168-.205-.33-.002-.197.118-.358.267-.363.084 0 .156.046.207.123.223.148.343.435.374.711l3.67-2.442c1.862-.822 2.445-1.505 2.607-1.935h.005-.005c.117-.31.018-.487.018-.487-.136-1.2-.799-1.85-1.587-2.191-1.01.602-2.494 1.093-3.07.632l.036.497c.015.023.054.066.105.12l.025.028c.07.075.151.167.22.251.09.113.152.215.113.256-.171.085-.343.18-.512.287-1.664 1.03-3.228 2.908-3.725 3.558-.028-.02-.069-.053-.12-.094-.576-.74-2.13-2.563-3.76-3.53a5.293 5.293 0 0 0-.62-.32c-.008-.013-.013-.026-.02-.039a.234.234 0 0 1 .074-.077c.002 0 .005-.005.01-.007l.059-.039c.15-.084.358-.15.407-.228l.118-1.54s-.008 0-.02-.006c-.006.264-.024.556-.057.873-.566.476-2.056-.015-3.072-.617-.78.343-1.439.988-1.572 2.184 0 0-.102.179.02.491-1.251.4-2.521.873-3.417 1.38a15.954 15.954 0 0 0 10.056 5.192c-.029-.482-.093-.906-.203-1.226l-.035-.1c-.085-.236-.18-.502-.17-.791 0-.029.006-.057.01-.085L6.355 25.87c.397-.151.812-.295 1.229-.433.228.43.865 1.063 2.547 1.805l3.679 2.253c.056-.17.156-.328.297-.448a.387.387 0 0 1 .358-.213c.213.005.379.167.374.364-.005.197-.18.353-.392.348h-.008a.426.426 0 0 0-.092.243v.036l1.452.888s.005.013.01.02l-1.441-.739c.025.118.066.238.112.366l.039.105c.138.4.215.911.24 1.475.41.03.825.053 1.245.053.468 0 .931-.025 1.39-.064-.031-.555-.01-1.052.082-1.426l-.003.008Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0065FF",
        d: "M18.181 29.97c-.015.205-.064.397-.11.581l-.026.102c-.076.313-.094.738-.069 1.222a15.969 15.969 0 0 0 9.92-5.177 13.857 13.857 0 0 0-1.815-.822l-7.897 4.094h-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#PageContentB)",
        d: "M20.2 24.164c-.068-.085-.15-.174-.22-.251a.155.155 0 0 1-.015-.013c-.002 0-.007-.01-.01-.013a1.6 1.6 0 0 1-.105-.12l-.036-.497-.012-.007a12.55 12.55 0 0 1-.057-.817c-.005-.033-.005-.064-.008-.092-.04-.522-.076-1.1-.104-1.626-.59.569-1.411 1.13-2.57 1.582a2.062 2.062 0 0 1-.748.154h-1.08c-.262 0-.512-.061-.748-.154-.952-.37-1.677-.816-2.232-1.28-.013.382-.031.781-.052 1.16V22.39c.013 0-.094 1.543-.094 1.543-.049.077-.256.144-.407.228l-.06.039c-.002 0-.004.005-.01.007a.263.263 0 0 0-.074.077c.008.013.013.026.02.039.208.092.413.2.62.32 1.631.967 3.185 2.787 3.761 3.53l.12.095c.497-.653 2.061-2.53 3.725-3.559.17-.105.34-.2.512-.287.039-.04-.023-.14-.113-.256l-.002-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0747A6",
        d: "M14.48 30.367a2.964 2.964 0 0 1-.113-.366l1.441.74-.01-.021-1.452-.888v-.036a.42.42 0 0 1 .092-.243h.008c.213.005.387-.151.392-.349.005-.197-.164-.358-.374-.363a.387.387 0 0 0-.358.212.962.962 0 0 0-.297.448L10.13 27.25c-1.682-.743-2.32-1.372-2.547-1.805-.417.138-.832.281-1.229.433l7.414 3.814c-.003.028-.008.056-.01.084-.01.29.084.556.169.791l.035.1c.11.318.177.745.203 1.226.197.024.396.041.596.057-.026-.566-.102-1.075-.24-1.475l-.039-.105-.003-.002ZM18.045 30.653l.026-.102c.049-.187.095-.379.11-.581l7.898-4.093c-.52-.2-1.068-.387-1.61-.561h-.011c-.164.43-.745 1.113-2.606 1.935l-3.67 2.442c-.029-.279-.152-.563-.375-.711-.05-.075-.125-.126-.207-.123-.151.005-.271.166-.266.363.002.164.09.292.205.33.03.062.056.15.058.257 0 .094-.007.19-.025.289l-1.308.87 1.26-.652c-.009.03-.016.06-.024.094l-.025.105c-.093.374-.113.868-.082 1.426.197-.018.391-.038.586-.061-.023-.482-.008-.91.069-1.221l-.003-.006Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#172B4D",
        d: "M12.145 23.26c.036-.317.05-.61.056-.873V22.188c.02-.38.038-.779.051-1.16-1.779-1.485-1.797-3.149-1.797-3.149-.008-.08-.015-.154-.02-.23h-.082c-.5-2.128-.855-3.91-.031-3.828a.81.81 0 0 1 .24.062c.034-.036.267-.512.423-.812a.684.684 0 0 1 .39-.338c.836-.286 1.453-.15 1.453-.15.044-.2.103-.387.172-.564.156-.32.396-.763.722-1.18a4.685 4.685 0 0 1 1.51-1.131c.077-.021.156-.036.236-.047 1.812.067 4.669 2.517 5.273 4.053.123.31.305.261.484.125.171-.13.335-.343.433-.391.035.023.074.046.105.074.34.673.291 1.564.048 2.57-.051.18-.1.34-.146.474-.21.601-.302.937-.55 1.042a9.71 9.71 0 0 1-.026.274s-.015 1.449-1.459 2.849a69.25 69.25 0 0 0 .113 1.718 12.744 12.744 0 0 0 .056.817l.013.007c.576.463 2.06-.03 3.07-.632.647-.387 1.1-.814.987-1.065a2.796 2.796 0 0 1-.166-.52c-.03-.535-.064-1.093-.102-1.664.025-1.556.156-3.63-.745-6.438-.057-.295-.113-.592-.177-.884-.274-1.236-.793-2.516-1.602-3.591a6.662 6.662 0 0 0-5.464-2.852c-2.82 0-5.232 1.759-6.215 4.247a9.924 9.924 0 0 0-.755 2.196c-.228 1.027-.3 2.084-.308 3.141-.53 3.037.32 5.051-.268 6.367-.113.251.345.684 1 1.07 1.017.602 2.504 1.093 3.073.617l.005-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#A96935",
        d: "M21.12 17.603c.248-.108.34-.443.55-1.042.047-.13.098-.295.146-.474.244-1.006.292-1.897-.048-2.57a.512.512 0 0 0-.105-.074c-.097.048-.261.26-.433.391.023.305.036.615.036.924 0 1.05-.059 1.905-.146 2.845ZM10.325 13.816c-.822-.08-.469 1.7.03 3.827.026.003.054 0 .082 0a30.21 30.21 0 0 1-.148-2.89c0-.317.013-.632.036-.942v.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C4743D",
        d: "M15.237 22.461h1.08c.262 0 .512-.061.748-.153 1.157-.45 1.982-1.011 2.57-1.582 1.447-1.398 1.46-2.85 1.46-2.85.007-.092.017-.184.025-.273.087-.943.146-1.795.146-2.845 0-.312-.013-.62-.036-.924-.177.136-.36.185-.484-.125-.604-1.539-3.463-3.989-5.273-4.053-.08.01-.159.026-.236.046-.26.12-.93.469-1.51 1.132-.323.417-.566.86-.722 1.18-.07.177-.126.364-.172.563 0 0-.617-.135-1.454.151a.684.684 0 0 0-.389.338c-.156.3-.392.776-.422.812a.921.921 0 0 0-.24-.062c-.024.31-.037.625-.037.942 0 1.068.062 1.93.149 2.89l.02.231s.016 1.667 1.797 3.149c.556.463 1.28.909 2.233 1.28.235.092.489.153.747.153Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "160",
        height: "32",
        x: "40",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "6",
        x: "48",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M171 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M179.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "208",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M212 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M223.793 9.793a.993.993 0 0 0-.217 1.09c.05.121.124.231.217.324L227.586 15H218a1 1 0 1 0 0 2h9.586l-3.793 3.793a.994.994 0 0 0-.217 1.09 1.002 1.002 0 0 0 1.632.324l5.499-5.5a.997.997 0 0 0 .293-.679v-.057a.995.995 0 0 0-.293-.678l-5.499-5.5a.997.997 0 0 0-1.09-.217.997.997 0 0 0-.325.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "100",
        height: "32",
        x: "248",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "60",
        height: "6",
        x: "256",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M319 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M327.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "99",
        height: "32",
        x: "720",
        fill: "#B3D4FF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "59",
        height: "6",
        x: "728",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M790 4h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".25",
        fillRule: "evenodd",
        d: "M798.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "52",
        height: "14",
        x: "40",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "44",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "206",
        height: "6",
        x: "108",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "53",
        height: "6",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M0 106h77v2H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "53",
        height: "6",
        x: "77",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M77 106h77v2H77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "53",
        height: "6",
        x: "154",
        y: "90",
        fill: "#4C9AFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#4C9AFF",
        d: "M154 106h77v2h-77z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M231 106h589v2H231z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "160",
        height: "32",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "6",
        x: "8",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M131 136h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M139.292 146.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FAFBFC",
        d: "M268 230h62v389h-62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "250",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "294",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "316",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "295",
        y: "344",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3",
        transform: "rotate(-180 295 344)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "360",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "456",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "280",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "15",
        height: "6",
        x: "303",
        y: "500",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        d: "M268 188h551v42H268z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M280 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M288.292 207.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "312",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "676",
        y: "204",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "48",
        height: "6",
        x: "695",
        y: "206",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M751 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M765 201.187a10.734 10.734 0 0 0-2-.187c-4.963 0-9 3.37-9 7.513s4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.031.164.033a.52.52 0 0 0 .429-.231.516.516 0 0 0 .045-.485v-.002s-1.563-2.26-.766-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-.171-.006-.342-.02-.513h-2.008c.02.169.03.34.03.513 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51 0-3.038 3.141-5.51 7.002-5.51.695 0 1.366.08 2 .229v-2.045Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M770 202a1 1 0 0 0-2 0v4a1 1 0 0 0 2 0v-4Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M771 203h-4a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M783 197h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M795 211a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122A1.503 1.503 0 0 1 795 211Zm-4.5 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Zm9 0a1.507 1.507 0 0 1-1.061-.439 1.507 1.507 0 0 1 0-2.122 1.507 1.507 0 0 1 2.122 0 1.503 1.503 0 0 1 0 2.122 1.503 1.503 0 0 1-1.061.439Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 228h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "240",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "75",
        height: "6",
        x: "370",
        y: "237",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 250h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 254h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 259.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "257",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 288h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "300",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "209",
        height: "6",
        x: "370",
        y: "297",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 308h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "320",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "317",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FFEBE6",
        d: "M330 330h489v20H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "6",
        height: "2",
        x: "347",
        y: "339",
        fill: "#D9D9D9",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "83",
        height: "6",
        x: "370",
        y: "337",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#E3FCEF",
        d: "M330 350h489v100H330z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M344 354h12v12h-12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M350.5 359.5v-2a.504.504 0 0 0-.146-.354.504.504 0 0 0-.708 0 .504.504 0 0 0-.146.354v2h-2a.504.504 0 0 0-.354.146.504.504 0 0 0 0 .708.504.504 0 0 0 .354.146h2v2c0 .133.053.26.146.354a.504.504 0 0 0 .708 0 .504.504 0 0 0 .146-.354v-2h2c.133 0 .26-.053.354-.146a.504.504 0 0 0 0-.708.504.504 0 0 0-.354-.146h-2Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "370",
        y: "357",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M344 374h465v68H344z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C0B6F2",
        d: "M375.904 393.998c0-6.574-5.33-11.904-11.904-11.904s-11.904 5.33-11.904 11.904 5.33 11.904 11.904 11.904 11.904-5.33 11.904-11.904Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#998DD9",
        d: "M369.098 403.32a3.41 3.41 0 0 1-2.116-3.151 3.324 3.324 0 0 1 1.171-2.565c4.694-3.942 1.782-11.574-4.276-11.453-5.935.102-8.634 7.592-4.03 11.453a3.324 3.324 0 0 1 1.171 2.565 3.408 3.408 0 0 1-2.116 3.151c-.368.153-.731.322-1.088.505-.098.051-.194.109-.292.165a11.85 11.85 0 0 0 6.476 1.918c2.391 0 4.616-.709 6.482-1.922a15.005 15.005 0 0 0-.518-.271 12.696 12.696 0 0 0-.866-.393l.002-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "119",
        height: "6",
        x: "388",
        y: "391",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "303.948",
        height: "6",
        x: "352",
        y: "414",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "191.135",
        height: "6",
        x: "352",
        y: "428",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentH)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 448h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "460",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "135",
        height: "6",
        x: "370",
        y: "457",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentI)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M338 488h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "350",
        cy: "500",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "105",
        height: "6",
        x: "370",
        y: "497",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M268.5 188.5h550v430h-550z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "80",
        height: "32",
        x: "739",
        y: "132",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "64",
        height: "6",
        x: "747",
        y: "145",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 196h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 206.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "205",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 236h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 246.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "245",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "184",
        height: "20",
        x: "48",
        y: "278",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "79",
        height: "6",
        x: "80",
        y: "285",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M46 276h24v24H46z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M54.292 286.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 316h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 326.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "325",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 356h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 366.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "365",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 396h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M24.292 406.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "56",
        y: "405",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 436h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 446.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "445",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M32 476h24v24H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        fillRule: "evenodd",
        d: "M40.292 486.293a1.01 1.01 0 0 0 0 1.419l2.94 2.965c.217.215.5.322.778.322.28 0 .556-.107.77-.322l2.93-2.955a1.01 1.01 0 0 0-.323-1.637.996.996 0 0 0-.762 0 .998.998 0 0 0-.322.218l-2.298 2.317-2.307-2.327a1 1 0 0 0-.703-.293.995.995 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "72",
        y: "485",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        d: "M.5 188.5h239v430H.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h32v32H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M268 188h551v431H268z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentD"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 230h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 290h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 310h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentG"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M352 382h24v24h-24z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentH"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 450h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentI"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M330 490h489v20H330z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "PageContentB",
        x1: "15.944",
        x2: "15.944",
        y1: "35.84",
        y2: "20.992",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#C4743D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".43",
        stopColor: "#BB703A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#A96935"
    }))));
};

});

parcelRegister("lWA6j", function(module, exports) {

$parcel$export(module.exports, "PageHeader", function () { return $ff9b04a156353dec$export$53f1cd6809577fc5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $ff9b04a156353dec$export$53f1cd6809577fc5 = function PageHeader() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($ff9b04a156353dec$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($ff9b04a156353dec$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $ff9b04a156353dec$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px")
});
var $ff9b04a156353dec$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "467",
        height: "112",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "100",
        height: "6",
        x: "24",
        y: "39",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "54",
        height: "6",
        x: "137",
        y: "39",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#6B778C",
        d: "m129.372 49.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "419.328",
        height: "20",
        x: "24",
        y: "68",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }));
};

});

parcelRegister("bMmao", function(module, exports) {

$parcel$export(module.exports, "SecondaryNav", function () { return $89355f41a2509b9e$export$b982c89a8be501e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $2Md0t = parcelRequire("2Md0t");
var $89355f41a2509b9e$export$b982c89a8be501e8 = function SecondaryNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($89355f41a2509b9e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($89355f41a2509b9e$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $89355f41a2509b9e$var$Wrapper = (0, $3XNKR.default)((0, $2Md0t.SecondaryNavWrapper))({
    borderRight: "24px solid #fff"
});
var $89355f41a2509b9e$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "240",
        height: "775",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        d: "M0 0h240v775H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SecondaryNavA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 88h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "84",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "96",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "124",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "136",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 168h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "164",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "176",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "208",
        height: "40",
        x: "16",
        y: "200",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 208h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "204",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "216",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "244",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "256",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "284",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "8",
        x: "66",
        y: "296",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "120",
        height: "12",
        x: "74",
        y: "38",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "40",
        height: "40",
        x: "18",
        y: "24",
        fill: "#DEEBFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SecondaryNavA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M16 80h208v240H16z"
    }))));
};

});
parcelRegister("2Md0t", function(module, exports) {

$parcel$export(module.exports, "SecondaryNavWrapper", function () { return $205a27523e352653$export$fd2a3539d2004332; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $205a27523e352653$export$fd2a3539d2004332 = function SecondaryNavWrapper(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($205a27523e352653$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($205a27523e352653$var$Wrapper, null, children));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $205a27523e352653$var$Background = (0, $3XNKR.default).div({
    display: "inline-block",
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    left: 0,
    height: "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px"),
    background: "#f4f5f7"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $205a27523e352653$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    left: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px")
});

});


parcelRegister("epoDP", function(module, exports) {

$parcel$export(module.exports, "Sidebar", function () { return $a7d683c73ea113ce$export$1ba59dacbcbf90fe; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");

var $145Wl = parcelRequire("145Wl");
var $a7d683c73ea113ce$export$1ba59dacbcbf90fe = function Sidebar() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($a7d683c73ea113ce$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($a7d683c73ea113ce$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($a7d683c73ea113ce$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $a7d683c73ea113ce$var$Background = (0, $3XNKR.default).div({
    display: "inline-block",
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    right: 0,
    height: "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $145Wl.SIDEBAR_WIDTH) - 2, "px"),
    background: "#fafbfc",
    borderLeft: "2px solid #dfe1e6"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $a7d683c73ea113ce$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    right: 0,
    borderLeft: "24px solid #fff"
});
var $a7d683c73ea113ce$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "333",
        height: "776",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("mask", {
        id: "SidebarH",
        fill: "#fff"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M0 0h333v776H0V0Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FAFBFC",
        d: "M0 0h333v776H0V0Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "32",
        y: "40",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 70h269v175H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "81",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "78",
        height: "6",
        x: "80",
        y: "90",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 81h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 91.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.986.986 0 0 0-1.084-.217.997.997 0 0 0-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 117h269v-1H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SidebarB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M71.944 135.997c0-6.597-5.348-11.945-11.945-11.945s-11.945 5.348-11.945 11.945 5.348 11.945 11.945 11.945 11.945-5.348 11.945-11.945Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M65.115 145.352a3.421 3.421 0 0 1-2.124-3.16 3.338 3.338 0 0 1 1.177-2.575c4.71-3.955 1.788-11.614-4.29-11.491-5.957.102-8.666 7.619-4.044 11.491a3.344 3.344 0 0 1 1.177 2.575 3.416 3.416 0 0 1-2.124 3.16c-.37.154-.733.325-1.092.505-.1.052-.194.112-.292.165a11.882 11.882 0 0 0 6.499 1.926c2.4 0 4.633-.71 6.503-1.928a13.607 13.607 0 0 0-1.388-.668h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "133",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SidebarC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M72 176c0-6.627-5.373-12-12-12s-12 5.373-12 12 5.373 12 12 12 12-5.373 12-12Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M65.12 185.395a3.43 3.43 0 0 1-1.77-1.648l3.01.006c.719.004 1.212-.818.853-1.448a5.53 5.53 0 0 1-.622-2.561v-4.867a6.833 6.833 0 0 0-1.758-4.662c-3.493-3.825-9.956-2.25-11.202 2.838-.44 1.194-.196 5.357-.253 6.666a5.478 5.478 0 0 1-.628 2.561.983.983 0 0 0 .854 1.452l3.015.006a3.431 3.431 0 0 1-1.776 1.658c-.292.125-.586.252-.87.396-.175.084-.346.177-.515.269a11.943 11.943 0 0 0 6.544 1.943c2.407 0 4.646-.711 6.524-1.932a10.607 10.607 0 0 0-.538-.28 13.187 13.187 0 0 0-.87-.396l.003-.001Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "130",
        height: "6",
        x: "80",
        y: "173",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M48 204h24v24H48z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M61 215v-7.007a.996.996 0 0 0-1-.993c-.556 0-1 .445-1 .993V215h-7.007a.999.999 0 0 0-.993 1c0 .557.445 1 .993 1H59v7.007c0 .548.448.993 1 .993.556 0 1-.445 1-.993V217h7.007a.998.998 0 0 0 .993-1c0-.556-.445-1-.993-1H61Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "90",
        height: "6",
        x: "80",
        y: "213",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 261h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "272",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "281",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M218 292a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 272h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 282.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 307.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 335a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "170",
        height: "6",
        x: "80",
        y: "324",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        fillRule: "evenodd",
        d: "M60 375a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "139",
        height: "6",
        x: "80",
        y: "364",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M50 397h20v20H50z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#36B37E",
        fillRule: "evenodd",
        d: "M68.333 407a8.333 8.333 0 1 1-16.666 0 8.333 8.333 0 0 1 16.666 0Zm-10.514-.776a.833.833 0 0 1 .27.187l1.078 1.077 2.744-2.744a.847.847 0 0 1 .27-.187.846.846 0 0 1 .645-.005.838.838 0 0 1 .517.778.837.837 0 0 1-.254.593l-3.333 3.333a.834.834 0 0 1-1.179 0l-1.666-1.667a.84.84 0 0 1-.255-.592.834.834 0 0 1 1.163-.773Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "194",
        height: "6",
        x: "80",
        y: "404",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 452h269v174H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "463",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "472",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 463h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M273.292 473.293a1.01 1.01 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.996.996 0 0 0-.762 0 .997.997 0 0 0-.322.218l-2.298 2.317-2.307-2.327a.994.994 0 0 0-1.084-.217c-.12.051-.23.124-.322.217Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M32 498.731h269v-.994H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "512",
        fill: "#0052CC",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M57.207 515.793a1 1 0 0 1 0 1.414l-3.5 3.5a1 1 0 0 1-1.414 0l-1.5-1.5a1 1 0 1 1 1.414-1.414l.793.793 2.793-2.793a1 1 0 0 1 1.414 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "515",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "552",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "553",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "131",
        height: "6",
        x: "76",
        y: "555",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "48",
        y: "592",
        fill: "#fff",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "49",
        y: "593",
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "76",
        y: "595",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 643h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "654",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "663",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 678v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 669.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        filter: "url(#SidebarG)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M32 707h269v48H32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        x: "44",
        y: "718",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "80",
        y: "727",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M265 742v-24h24v24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M275.293 733.708a1.009 1.009 0 0 0 1.419 0l2.965-2.939c.215-.218.322-.5.322-.779s-.107-.556-.322-.769l-2.955-2.93a1.008 1.008 0 0 0-1.637.322.996.996 0 0 0 0 .762c.051.121.125.23.218.322l2.317 2.298-2.327 2.307a.99.99 0 0 0 0 1.406Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".13",
        d: "M2 776V0h-4v776h4Z",
        mask: "url(#SidebarH)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarA",
        width: "271",
        height: "179",
        x: "31",
        y: "68",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarD",
        width: "271",
        height: "178",
        x: "31",
        y: "259",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarE",
        width: "271",
        height: "178",
        x: "31",
        y: "450",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarF",
        width: "271",
        height: "52",
        x: "31",
        y: "641",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("filter", {
        id: "SidebarG",
        width: "271",
        height: "52",
        x: "31",
        y: "705",
        colorInterpolationFilters: "sRGB",
        filterUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        in: "SourceAlpha",
        result: "hardAlpha",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feOffset", {
        dy: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feGaussianBlur", {
        stdDeviation: ".5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feColorMatrix", {
        values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.25 0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in2: "effect1_dropShadow_943_3604",
        result: "effect2_dropShadow_943_3604"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("feBlend", {
        in: "SourceGraphic",
        in2: "effect2_dropShadow_943_3604",
        result: "shape"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SidebarB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M48 124h24v24H48z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SidebarC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M48 164h24v24H48z"
    }))));
};

});


parcelRegister("5GyOg", function(module, exports) {

$parcel$export(module.exports, "DesktopOnlyBackground", function () { return $423be07f465abaef$export$5e40b6732fa22ace; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");

var $yS2bK = parcelRequire("yS2bK");
var $423be07f465abaef$var$maxMobileScreen = "( max-width: 800px )";
var $423be07f465abaef$export$5e40b6732fa22ace = function DesktopOnlyBackground(_ref) {
    var Background = _ref.background, children = _ref.children;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).useState(function() {
        return window.matchMedia($423be07f465abaef$var$maxMobileScreen).matches;
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_React$useState, 2), isSmallScreen = _React$useState2[0], setIsSmallScreen = _React$useState2[1];
    (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).useLayoutEffect(function() {
        var smallScreen = window.matchMedia($423be07f465abaef$var$maxMobileScreen);
        var unbind = (0, $k6Bkl.bind)(smallScreen, {
            type: "change",
            listener: function listener(e) {
                setIsSmallScreen(e.matches);
            }
        });
        return unbind;
    }, []);
    return isSmallScreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $yS2bK.default), {
        isTinted: true
    }, children));
};

});
parcelRegister("yS2bK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $068d172d20cdada2$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $6TKFD = parcelRequire("6TKFD");

var $5AVd4 = parcelRequire("5AVd4");

var $e1SaG = parcelRequire("e1SaG");

var $dx5Qj = parcelRequire("dx5Qj");
function $068d172d20cdada2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $068d172d20cdada2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $068d172d20cdada2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $068d172d20cdada2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $068d172d20cdada2$var$packageName = "@atlaskit/blanket";
var $068d172d20cdada2$var$packageVersion = "13.3.1";
var $068d172d20cdada2$var$analyticsAttributes = {
    componentName: "blanket",
    packageName: $068d172d20cdada2$var$packageName,
    packageVersion: $068d172d20cdada2$var$packageVersion
};
var $068d172d20cdada2$var$baseStyles = (0, $14VNY.css)({
    position: "fixed",
    zIndex: (0, $dx5Qj.layers).blanket(),
    inset: 0,
    backgroundColor: "var(--ds-blanket, ".concat((0, $e1SaG.N100A), ")"),
    overflowY: "auto",
    pointerEvents: "initial"
});
var $068d172d20cdada2$var$shouldAllowClickThroughStyles = (0, $14VNY.css)({
    pointerEvents: "none"
});
var $068d172d20cdada2$var$invisibleStyles = (0, $14VNY.css)({
    backgroundColor: "transparent"
});
/**
 * __Blanket__
 *
 * A Blanket provides the overlay layer for components such as a modal dialog or a tooltip
 *
 * - [Examples](https://atlaskit.atlassian.com/examples/design-system/blanket/basic-usage)
 */ var $068d172d20cdada2$var$Blanket = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function Blanket(_ref, ref) {
    var _ref$shouldAllowClick = _ref.shouldAllowClickThrough, shouldAllowClickThrough = _ref$shouldAllowClick === void 0 ? false : _ref$shouldAllowClick, _ref$isTinted = _ref.isTinted, isTinted = _ref$isTinted === void 0 ? false : _ref$isTinted, _ref$onBlanketClicked = _ref.onBlanketClicked, onBlanketClicked = _ref$onBlanketClicked === void 0 ? (0, $5AVd4.default) : _ref$onBlanketClicked, testId = _ref.testId, children = _ref.children, analyticsContext = _ref.analyticsContext;
    var mouseDownTarget = (0, $8ZuGG.useRef)(null);
    var onBlanketClickedWithAnalytics = (0, $6TKFD.usePlatformLeafEventHandler)($068d172d20cdada2$var$_objectSpread({
        fn: onBlanketClicked,
        action: "clicked",
        analyticsData: analyticsContext
    }, $068d172d20cdada2$var$analyticsAttributes));
    var blanketClickOutsideChildren = (0, $8ZuGG.useCallback)(function(e) {
        return e.currentTarget === e.target && mouseDownTarget.current === e.target ? onBlanketClickedWithAnalytics(e) : undefined;
    }, [
        onBlanketClickedWithAnalytics
    ]);
    var onClick = shouldAllowClickThrough ? undefined : blanketClickOutsideChildren;
    var onMouseDown = (0, $8ZuGG.useCallback)(function(e) {
        mouseDownTarget.current = e.target;
    }, []);
    return(/**
     * It is not normally acceptable to add click and key handlers to non-interactive
     * elements as this is an accessibility anti-pattern. However, because this
     * instance is to enable light dismiss functionality instead of creating an
     * inaccessible custom element, we can add role="presentation" so that there
     * are no negative impacts to assistive technologies.
     */ (0, $14VNY.jsx)("div", {
        role: "presentation",
        css: [
            $068d172d20cdada2$var$baseStyles,
            shouldAllowClickThrough && $068d172d20cdada2$var$shouldAllowClickThroughStyles,
            !isTinted && $068d172d20cdada2$var$invisibleStyles
        ],
        onClick: onClick,
        onMouseDown: onMouseDown,
        "data-testid": testId,
        ref: ref
    }, children));
}));
$068d172d20cdada2$var$Blanket.displayName = "Blanket";
var $068d172d20cdada2$export$2e2bcd8739ae039 = $068d172d20cdada2$var$Blanket;

});
parcelRegister("6TKFD", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $505c14e6ba00db70$export$a4687b0234b40e28; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $2cC97 = parcelRequire("2cC97");

var $cFH1I = parcelRequire("cFH1I");
function $505c14e6ba00db70$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $505c14e6ba00db70$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $505c14e6ba00db70$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $505c14e6ba00db70$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $505c14e6ba00db70$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $2cC97.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $cFH1I.useTrackedRef)(analyticsData);
    var fnRef = (0, $cFH1I.useTrackedRef)(fn);
    var handler = (0, $8ZuGG.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $505c14e6ba00db70$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("2cC97", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $19aa4ac1b5c68a36$export$5bf35293e545f20c; });

var $bzd3R = parcelRequire("bzd3R");

var $gWyTh = parcelRequire("gWyTh");

var $7TxDb = parcelRequire("7TxDb");
function $19aa4ac1b5c68a36$export$5bf35293e545f20c() {
    var analyticsContext = (0, $7TxDb.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $bzd3R.useCallbackOne)(function(payload) {
        return new (0, $gWyTh.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("bzd3R", function(module, exports) {

$parcel$export(module.exports, "useCallbackOne", function () { return $86bd18475f5e9458$export$33752cf3ee811995; });

var $8ZuGG = parcelRequire("8ZuGG");
function $86bd18475f5e9458$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $86bd18475f5e9458$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $8ZuGG.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $8ZuGG.useRef)(true);
    var committed = (0, $8ZuGG.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $86bd18475f5e9458$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $8ZuGG.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $86bd18475f5e9458$export$33752cf3ee811995(callback, inputs) {
    return $86bd18475f5e9458$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $86bd18475f5e9458$export$1538c33de8887b59 = $86bd18475f5e9458$export$b6feb8998cd9b342;
var $86bd18475f5e9458$export$35808ee640e87ca7 = $86bd18475f5e9458$export$33752cf3ee811995;

});

parcelRegister("gWyTh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55d20abb6d14a7d$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5T1eV = parcelRequire("5T1eV");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $8TJCj = parcelRequire("8TJCj");
function $c55d20abb6d14a7d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c55d20abb6d14a7d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, result);
    };
}
function $c55d20abb6d14a7d$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c55d20abb6d14a7d$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $c55d20abb6d14a7d$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $c55d20abb6d14a7d$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $c55d20abb6d14a7d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $c55d20abb6d14a7d$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $8TJCj.default));

});
parcelRegister("8TJCj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $01abfb3b5d7cd489$export$2e2bcd8739ae039; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
function $01abfb3b5d7cd489$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $01abfb3b5d7cd489$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $01abfb3b5d7cd489$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $01abfb3b5d7cd489$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $01abfb3b5d7cd489$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $01abfb3b5d7cd489$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $01abfb3b5d7cd489$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $01abfb3b5d7cd489$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(updater) === "object") this.payload = $01abfb3b5d7cd489$var$_objectSpread($01abfb3b5d7cd489$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("7TxDb", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $5bf7c1dfd5baa8fb$export$d1f587f82ad51c4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $akh0H = parcelRequire("akh0H");
var $5bf7c1dfd5baa8fb$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $8ZuGG.useContext)((0, $akh0H.default));
};

});
parcelRegister("akh0H", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7848f785188f7358$export$2e2bcd8739ae039; });

var $3V24g = parcelRequire("3V24g");
var $7848f785188f7358$export$2e2bcd8739ae039 = (0, $3V24g.default);

});
parcelRegister("3V24g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2da84c99bab289db$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
var $2da84c99bab289db$var$AnalyticsNextContext = (0, $8ZuGG.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2da84c99bab289db$export$2e2bcd8739ae039 = $2da84c99bab289db$var$AnalyticsNextContext;

});




parcelRegister("cFH1I", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $939ab09057f9c948$export$1d27a74659855e44; });

var $8ZuGG = parcelRequire("8ZuGG");
var $939ab09057f9c948$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $8ZuGG.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("5AVd4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $412cb13d53fa6229$export$2e2bcd8739ae039; });
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $412cb13d53fa6229$export$2e2bcd8739ae039() {}

});

parcelRegister("e1SaG", function(module, exports) {

$parcel$export(module.exports, "B200", function () { return $a36b2dff15cb36d3$export$215b7063051591f1; });
$parcel$export(module.exports, "N20A", function () { return $a36b2dff15cb36d3$export$8d43898f60b96a82; });
$parcel$export(module.exports, "N30A", function () { return $a36b2dff15cb36d3$export$920c0d5c49070351; });
$parcel$export(module.exports, "N100A", function () { return $a36b2dff15cb36d3$export$486ab785e4bac3c6; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
var $a36b2dff15cb36d3$export$4b84fd0e2c617bd = "#FFEBE6";
var $a36b2dff15cb36d3$export$b34b069eff244586 = "#FFBDAD";
var $a36b2dff15cb36d3$export$be802dd0d8b57f35 = "#FF8F73";
var $a36b2dff15cb36d3$export$60847d42f9da92a6 = "#FF7452";
var $a36b2dff15cb36d3$export$4a7404f376229999 = "#FF5630";
var $a36b2dff15cb36d3$export$2010d0fb4295b346 = "#DE350B";
var $a36b2dff15cb36d3$export$2837b5a1a71d5c02 = "#BF2600";
var $a36b2dff15cb36d3$export$8d9596b529bbb9cf = "#FFFAE6";
var $a36b2dff15cb36d3$export$41060a744ab0b7ae = "#FFF0B3";
var $a36b2dff15cb36d3$export$1cc05bbbf340e559 = "#FFE380";
var $a36b2dff15cb36d3$export$5aae31392d72caaa = "#FFC400";
var $a36b2dff15cb36d3$export$c6930421db9fa514 = "#FFAB00";
var $a36b2dff15cb36d3$export$59619663aa6500fb = "#FF991F";
var $a36b2dff15cb36d3$export$874739ea9e379ab6 = "#FF8B00";
var $a36b2dff15cb36d3$export$8a6341c32b6a3ee6 = "#E3FCEF";
var $a36b2dff15cb36d3$export$69a3bf21b9686c2b = "#ABF5D1";
var $a36b2dff15cb36d3$export$afbce1382ec95f73 = "#79F2C0";
var $a36b2dff15cb36d3$export$747d86715d4175de = "#57D9A3";
var $a36b2dff15cb36d3$export$940e1f69e873f202 = "#36B37E";
var $a36b2dff15cb36d3$export$a49394138f7b8e85 = "#00875A";
var $a36b2dff15cb36d3$export$6fa04827ac68a4fb = "#006644";
var $a36b2dff15cb36d3$export$226de0355ed012f8 = "#DEEBFF";
var $a36b2dff15cb36d3$export$8c13c2ee36917869 = "#B3D4FF";
var $a36b2dff15cb36d3$export$ecfc1dff386a3e7a = "#4C9AFF";
var $a36b2dff15cb36d3$export$215b7063051591f1 = "#2684FF";
var $a36b2dff15cb36d3$export$e62e8919cca44969 = "#0065FF";
var $a36b2dff15cb36d3$export$b3de0ae08da2ce64 = "#0052CC";
var $a36b2dff15cb36d3$export$a6ee3d71bc067634 = "#0747A6";
var $a36b2dff15cb36d3$export$363e4475840015bb = "#EAE6FF";
var $a36b2dff15cb36d3$export$4b0a4417ed59760f = "#C0B6F2";
var $a36b2dff15cb36d3$export$6011520a64d9a187 = "#998DD9";
var $a36b2dff15cb36d3$export$a7175d4e9206bc80 = "#8777D9";
var $a36b2dff15cb36d3$export$b48405b95304b5a1 = "#6554C0";
var $a36b2dff15cb36d3$export$c71e4279dd54a18d = "#5243AA";
var $a36b2dff15cb36d3$export$147899de772240ec = "#403294";
var $a36b2dff15cb36d3$export$2cf711fe14c66f06 = "#E6FCFF";
var $a36b2dff15cb36d3$export$7a8f4d33f6f9772c = "#B3F5FF";
var $a36b2dff15cb36d3$export$776c9c497ef08533 = "#79E2F2";
var $a36b2dff15cb36d3$export$69cb3ca10c1e330e = "#00C7E6";
var $a36b2dff15cb36d3$export$9dc1ef0f3f48059b = "#00B8D9";
var $a36b2dff15cb36d3$export$7c835c78b6fcdef8 = "#00A3BF";
var $a36b2dff15cb36d3$export$6036577f95c3877e = "#008DA6";
var $a36b2dff15cb36d3$export$29a4f05edc054374 = "#FFFFFF";
var $a36b2dff15cb36d3$export$e655ef011c4aa1a2 = "#FAFBFC";
var $a36b2dff15cb36d3$export$9fdfb749e33cdf97 = "#F4F5F7";
var $a36b2dff15cb36d3$export$3e51e8f1440314ba = "#EBECF0";
var $a36b2dff15cb36d3$export$1ce2d1575d444ceb = "#DFE1E6";
var $a36b2dff15cb36d3$export$8754fc7e6d8b3000 = "#C1C7D0";
var $a36b2dff15cb36d3$export$c2e91cbeada39b8b = "#B3BAC5";
var $a36b2dff15cb36d3$export$5f71e19f3a7ad9de = "#A5ADBA";
var $a36b2dff15cb36d3$export$eaa8c8a70ac22806 = "#97A0AF";
var $a36b2dff15cb36d3$export$7c87d337fb91a97d = "#8993A4";
var $a36b2dff15cb36d3$export$d6447c357493214f = "#7A869A";
var $a36b2dff15cb36d3$export$f563ee71e9ee74cd = "#6B778C";
var $a36b2dff15cb36d3$export$e2ef2124cf4024b1 = "#5E6C84";
var $a36b2dff15cb36d3$export$eece5f492e429f08 = "#505F79";
var $a36b2dff15cb36d3$export$c39c0fe0f26207ae = "#42526E";
var $a36b2dff15cb36d3$export$7090862dc3038a9f = "#344563";
var $a36b2dff15cb36d3$export$ad0bacf983b7ddaa = "#253858";
var $a36b2dff15cb36d3$export$7d61b15e0da132af = "#172B4D";
var $a36b2dff15cb36d3$export$fbda843f0a27fe96 = "#091E42";
var $a36b2dff15cb36d3$export$791e57b27ca738ef = "rgba(9, 30, 66, 0.02)";
var $a36b2dff15cb36d3$export$8d43898f60b96a82 = "rgba(9, 30, 66, 0.04)";
var $a36b2dff15cb36d3$export$920c0d5c49070351 = "rgba(9, 30, 66, 0.08)";
var $a36b2dff15cb36d3$export$46987b49aab6d1a8 = "rgba(9, 30, 66, 0.13)";
var $a36b2dff15cb36d3$export$7d3359664e8bb0e5 = "rgba(9, 30, 66, 0.25)";
var $a36b2dff15cb36d3$export$d2d3bedfb276cac0 = "rgba(9, 30, 66, 0.31)";
var $a36b2dff15cb36d3$export$6e5e7499ff054f6d = "rgba(9, 30, 66, 0.36)";
var $a36b2dff15cb36d3$export$59264b346c877fa7 = "rgba(9, 30, 66, 0.42)";
var $a36b2dff15cb36d3$export$d092757d7c64925c = "rgba(9, 30, 66, 0.48)";
var $a36b2dff15cb36d3$export$486ab785e4bac3c6 = "rgba(9, 30, 66, 0.54)";
var $a36b2dff15cb36d3$export$fba592bbc6419fea = "rgba(9, 30, 66, 0.60)";
var $a36b2dff15cb36d3$export$13609db0e6812ab8 = "rgba(9, 30, 66, 0.66)";
var $a36b2dff15cb36d3$export$fbae4efaa892d883 = "rgba(9, 30, 66, 0.71)";
var $a36b2dff15cb36d3$export$f13946d26f440ce6 = "rgba(9, 30, 66, 0.77)";
var $a36b2dff15cb36d3$export$19f58225ac52a306 = "rgba(9, 30, 66, 0.82)";
var $a36b2dff15cb36d3$export$6384f09da70e7b62 = "rgba(9, 30, 66, 0.89)";
var $a36b2dff15cb36d3$export$d0dccc730683edc2 = "rgba(9, 30, 66, 0.95)";
var $a36b2dff15cb36d3$export$2f6319cf7d736c2a = "#E6EDFA";
var $a36b2dff15cb36d3$export$95126bc8884d6634 = "#DCE5F5";
var $a36b2dff15cb36d3$export$8338d8c35d44ff1 = "#CED9EB";
var $a36b2dff15cb36d3$export$5368d76ae4fbbda7 = "#B8C7E0";
var $a36b2dff15cb36d3$export$9f0a771d16ec8d36 = "#ABBBD6";
var $a36b2dff15cb36d3$export$abcf8c38338b4aa5 = "#9FB0CC";
var $a36b2dff15cb36d3$export$97e81faa16a182c7 = "#8C9CB8";
var $a36b2dff15cb36d3$export$bfe21c59123ecf33 = "#7988A3";
var $a36b2dff15cb36d3$export$ee82aa2ea6a1558 = "#67758F";
var $a36b2dff15cb36d3$export$682927c6ed76be02 = "#56637A";
var $a36b2dff15cb36d3$export$91fd9994c5be9757 = "#455166";
var $a36b2dff15cb36d3$export$d281fbfe3cff2df6 = "#3B475C";
var $a36b2dff15cb36d3$export$3902c91d8b98a753 = "#313D52";
var $a36b2dff15cb36d3$export$8e8133c1ba5845b5 = "#283447";
var $a36b2dff15cb36d3$export$33ff357f6620b39 = "#202B3D";
var $a36b2dff15cb36d3$export$633847cf062b69e0 = "#1B2638";
var $a36b2dff15cb36d3$export$9776a6e503bdbf76 = "#121A29";
var $a36b2dff15cb36d3$export$6c813d5160dff5db = "#0E1624";
var $a36b2dff15cb36d3$export$3d4f271a500072a = "#0D1424";
var $a36b2dff15cb36d3$export$fe151285c22759ec = "rgba(13, 20, 36, 0.06)";
var $a36b2dff15cb36d3$export$a101c6190d0da34 = "rgba(13, 20, 36, 0.14)";
var $a36b2dff15cb36d3$export$4b16f52932fda51 = "rgba(13, 20, 36, 0.18)";
var $a36b2dff15cb36d3$export$a74bcd7b9845b0d8 = "rgba(13, 20, 36, 0.29)";
var $a36b2dff15cb36d3$export$9209c179316d1751 = "rgba(13, 20, 36, 0.36)";
var $a36b2dff15cb36d3$export$88f55133f636c8dd = "rgba(13, 20, 36, 0.40)";
var $a36b2dff15cb36d3$export$51126f85d1009512 = "rgba(13, 20, 36, 0.47)";
var $a36b2dff15cb36d3$export$a069b547bd23af78 = "rgba(13, 20, 36, 0.53)";
var $a36b2dff15cb36d3$export$40cce05af3b2600a = "rgba(13, 20, 36, 0.63)";
var $a36b2dff15cb36d3$export$b78942185925a0d = "rgba(13, 20, 36, 0.73)";
var $a36b2dff15cb36d3$export$e058fb44b8eaafca = "rgba(13, 20, 36, 0.78)";
var $a36b2dff15cb36d3$export$92b0b8de26920c18 = "rgba(13, 20, 36, 0.81)";
var $a36b2dff15cb36d3$export$67564f7459d3fc9e = "rgba(13, 20, 36, 0.85)";
var $a36b2dff15cb36d3$export$77868e1ca884ffa3 = "rgba(13, 20, 36, 0.89)";
var $a36b2dff15cb36d3$export$2afd71d7d3ea2cd5 = "rgba(13, 20, 36, 0.92)";
var $a36b2dff15cb36d3$export$f2a0acaab9972c70 = "rgba(13, 20, 36, 0.95)";
var $a36b2dff15cb36d3$export$9ab70e67d6475361 = "rgba(13, 20, 36, 0.97)";

});

parcelRegister("dx5Qj", function(module, exports) {

$parcel$export(module.exports, "layers", function () { return $9da2e3b03d6a08c1$export$7be255094ccdc533; });

var $5pPqr = parcelRequire("5pPqr");

var $e1SaG = parcelRequire("e1SaG");
var $9da2e3b03d6a08c1$export$44ffba16bd48dac6 = "__ATLASKIT_THEME__";
var $9da2e3b03d6a08c1$export$c93026a968943f95 = "light";
var $9da2e3b03d6a08c1$export$6ba72c8346b4c57e = [
    "light",
    "dark"
];
var $9da2e3b03d6a08c1$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $9da2e3b03d6a08c1$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $9da2e3b03d6a08c1$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $9da2e3b03d6a08c1$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $9da2e3b03d6a08c1$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $9da2e3b03d6a08c1$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $9da2e3b03d6a08c1$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $e1SaG.B200), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $9da2e3b03d6a08c1$export$6d8204c2cb2e06b8() / 4;
    (0, $5pPqr.default)("@atlaskit/theme", "focus ring mixin", "Please use `@atlaskit/focus-ring` instead.");
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $9da2e3b03d6a08c1$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $9da2e3b03d6a08c1$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $9da2e3b03d6a08c1$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $5pPqr.default)("@atlaskit/theme", "visually hidden mixin", "Please use `@atlaskit/visually-hidden` instead.");
    return {
        border: "0 !important",
        clip: "rect(1px, 1px, 1px, 1px) !important",
        height: "1px !important",
        overflow: "hidden !important",
        padding: "0 !important",
        position: "absolute !important",
        width: "1px !important",
        whiteSpace: "nowrap !important"
    };
};
var $9da2e3b03d6a08c1$export$ba1d834b86d72a09 = $9da2e3b03d6a08c1$export$a1b3edb637fb4f35;
var $9da2e3b03d6a08c1$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $e1SaG.N20A), ")"),
            animationDuration: "1.5s",
            animationIterationCount: "infinite",
            animationTimingFunction: "linear",
            animationDirection: "alternate"
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $e1SaG.N20A), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $e1SaG.N30A), ")")
            }
        }
    };
};

});





parcelRegister("1Szkf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $65abeb54cec403dc$export$2e2bcd8739ae039; });

var $cx88G = parcelRequire("cx88G");

var $1CA01 = parcelRequire("1CA01");

var $lBSst = parcelRequire("lBSst");

var $b2Jk5 = parcelRequire("b2Jk5");
const $65abeb54cec403dc$export$a882740fcd1752cc = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($cx88G))), (0, (/*@__PURE__*/$parcel$interopDefault($1CA01))));
const $65abeb54cec403dc$var$CompassCobranding = {
    background: $65abeb54cec403dc$export$a882740fcd1752cc,
    logo: {
        component: (0, $lBSst.CompassLogo)
    },
    footerProducts: "Trello, Jira, Confluence"
};
var $65abeb54cec403dc$export$2e2bcd8739ae039 = $65abeb54cec403dc$var$CompassCobranding;

});
parcelRegister("lBSst", function(module, exports) {

$parcel$export(module.exports, "CompassLogo", function () { return $fbb74bf5c8c09956$export$eb7d748e4f9c9676; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $fbb74bf5c8c09956$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 155 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n    <path fill='.concat(colors.iconColor, ' d="M11.903 14.993v5.942H5.95v-5.942zV9.055H1.043c-.58.004-1.047.47-1.043 1.04v15.756a1.04 1.04 0 0 0 1.028 1.054H16.8a1.04 1.04 0 0 0 1.043-1.04V14.993zm0-11.879v5.941h5.967v5.938h5.936V4.153A1.04 1.04 0 0 0 22.778 3.1h-.015z"/>\n    <path fill="').concat(colors.textColor, '" d="M154.46 21.37c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.521-5.336-1.134v-2.791c1.318.767 3.526 1.503 5.458 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.889-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-13.626 0c0 2.545-1.656 4.477-5.766 4.477-2.3 0-4.17-.521-5.336-1.134v-2.791c1.319.767 3.527 1.503 5.459 1.503 2.024 0 3.067-.828 3.067-2.024 0-1.166-.89-1.84-3.803-2.546-3.404-.828-4.845-2.146-4.845-4.661 0-2.668 2.054-4.293 5.55-4.293 1.994 0 3.803.49 4.938 1.104v2.729c-1.84-.92-3.343-1.41-4.968-1.41-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.122 2.085 5.122 4.753m-25.873-3.496c0 3.68 1.472 5.52 4.201 5.52 2.361 0 4.477-1.503 4.477-4.907v-1.226c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m8.678 7.667v-2.76c-.981 2.024-2.821 3.066-5.182 3.066-4.079 0-6.134-3.465-6.134-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.638v15.334zm-16.09-7.667c0-3.68-1.472-5.52-4.201-5.52-2.362 0-4.478 1.503-4.478 4.907v1.226c0 3.404 1.932 4.907 4.171 4.907 2.975 0 4.508-1.963 4.508-5.52m-3.803 7.973c-2.238 0-3.956-1.012-4.876-3.005v8.679h-2.637V10.207h2.637v2.76c.982-2.024 2.822-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.146 7.973-6.44 7.973m-21.583-8.832v8.526h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526H69.13V10.207h2.637v2.515c.982-1.81 2.791-2.821 4.846-2.821 2.606 0 4.385 1.318 5.152 3.741.858-2.361 2.913-3.741 5.458-3.741 3.435 0 5.336 2.33 5.336 6.654v8.986h-2.637v-8.526c0-3.158-1.104-4.722-3.619-4.722-2.453 0-4.14 1.625-4.14 4.722m-23.335 8.832c-4.6 0-7.299-3.404-7.299-8.004s2.699-7.942 7.299-7.942c4.57 0 7.237 3.342 7.237 7.942s-2.668 8.004-7.237 8.004m0-13.493c-3.282 0-4.723 2.576-4.723 5.49s1.441 5.55 4.723 5.55c3.25 0 4.661-2.637 4.661-5.55s-1.41-5.49-4.661-5.49m-9.233 9.629v2.668c-1.258.828-3.251 1.196-5.336 1.196-6.624 0-10.366-3.986-10.366-10.334 0-6.134 3.742-10.427 10.304-10.427 1.963 0 3.926.368 5.367 1.41v2.669c-1.441-.92-3.036-1.411-5.367-1.411-4.722 0-7.544 3.128-7.544 7.759s2.914 7.697 7.698 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n  </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '\n    <svg\n      fill="none"\n      viewBox="0 0 138 32"\n      height="32"\n      xmlns="http://www.w3.org/2000/svg"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <linearGradient\n        id="'.concat(id, '"\n        gradientUnits="userSpaceOnUse"\n        x1="14.8536"\n        x2="5.87437"\n        y1="8.27633"\n        y2="17.2556"\n      >\n        <stop offset="20%" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n        <stop offset="100%" stop-color="').concat(colors.iconGradientStop, '" />\n      </linearGradient>\n      <path\n        clip-rule="evenodd"\n        d="m41.7694 22.8121c-1.1334.7473-2.9293 1.0769-4.8099 1.0769-5.9589 0-9.3183-3.5917-9.3183-9.3089 0-5.50994 3.3594-9.39361 9.2712-9.39361 1.7676 0 3.5352.31396 4.835 1.25584v2.40178c-1.2998-.82885-2.7346-1.25583-4.835-1.25583-4.2541 0-6.7972 2.82562-6.7972 6.99182 0 4.1663 2.6247 6.9354 6.9448 6.9354 1.6361.0146 3.2515-.3656 4.7094-1.1083zm2.2985-6.1318c0-4.1443 2.43-7.15827 6.5743-7.15827 4.1442 0 6.5115 3.00147 6.5115 7.15827s-2.405 7.221-6.521 7.221-6.5648-3.0799-6.5648-7.221zm2.3201 0c0 2.6247 1.2998 4.9982 4.2542 4.9982 2.9543 0 4.2007-2.3735 4.2007-4.9982s-1.2558-4.948-4.2007-4.948c-2.945 0-4.2542 2.3233-4.2542 4.948zm22.9026 6.9327h2.3766v-7.6794c0-2.7911 1.5321-4.2542 3.7298-4.2542 2.2637 0 3.2589 1.4097 3.2589 4.2542v7.6794h2.3767v-8.0939c0-3.8962-1.7142-5.99659-4.8067-5.99659-2.2919 0-4.1443 1.24329-4.9166 3.37189-.6907-2.182-2.295-3.37189-4.6434-3.37189-.891-.0185-1.7698.2091-2.5397.65779-.77.4487-1.4012 1.101-1.8244 1.8853v-2.2668h-2.3766v13.8142h2.3766v-7.6794c0-2.7911 1.5322-4.2542 3.7299-4.2542 2.2636 0 3.2589 1.1051 3.2589 3.5917zm18.0022-2.4305v7.8175h-2.3767v-19.20168h2.3767v2.48658c.8854-1.821 2.5431-2.76287 4.6686-2.76287 3.6733 0 5.5256 3.13957 5.5256 7.18337 0 3.8962-1.9339 7.1834-5.8019 7.1834-2.0313 0-3.5791-.9105-4.3923-2.7063zm4.0267-9.4502c-2.1474.0033-4.0267 1.36-4.0267 4.4205v1.1052c0 3.0674 1.7393 4.4205 3.7675 4.4205 2.6781 0 4.0595-1.7676 4.0595-4.9731-.0251-3.3118-1.3472-4.9695-3.8003-4.9731zm13.6115 12.1565c2.129 0 3.787-.9388 4.669-2.7629l.003 2.4866h2.377v-13.81418h-2.377v2.43318c-.832-1.7958-2.38-2.70947-4.395-2.70947-3.868 0-5.8022 3.29027-5.8022 7.18337 0 4.0626 1.8522 7.1834 5.5252 7.1834zm4.669-6.6308c0 3.0674-1.906 4.4205-4.034 4.4205-2.459 0-3.784-1.6577-3.793-4.9731 0-3.2024 1.381-4.9731 4.059-4.9731 2.029 0 3.768 1.3563 3.768 4.4205zm10.307 6.6313c-1.66.0436-3.306-.3004-4.81-1.0047v-2.5117c1.509.8373 3.196 1.3013 4.92 1.3532 1.824 0 2.763-.7472 2.763-1.8241s-.804-1.6577-3.426-2.2919c-3.067-.7472-4.367-1.934-4.367-4.2008 0-2.4018 1.853-3.86796 5.002-3.86796 1.54-.02192 3.064.31902 4.448.99526v2.4583c-1.657-.8289-3.01-1.2559-4.477-1.2559-1.739 0-2.678.606-2.678 1.6829 0 .967.663 1.5698 3.203 2.1977 3.067.7441 4.615 1.8837 4.615 4.2792 0 2.2511-1.491 3.9905-5.193 3.9905zm7.461-1.0047c1.506.7075 3.158 1.0516 4.822 1.0046 3.686 0 5.177-1.7393 5.177-3.9904 0-2.3955-1.548-3.5351-4.612-4.2792-2.543-.6279-3.205-1.2307-3.205-2.1977 0-1.0769.938-1.6829 2.678-1.6829 1.466 0 2.819.427 4.477 1.2559v-2.4583c-1.385-.67624-2.909-1.01718-4.449-.99526-3.149 0-5.001 1.46616-5.001 3.86796 0 2.2668 1.299 3.4536 4.367 4.2008 2.625.6342 3.425 1.215 3.425 2.2919s-.939 1.8241-2.763 1.8241c-1.723-.0518-3.409-.5158-4.916-1.3532z"\n        fill="').concat(colors.textColor, '"\n        fill-rule="evenodd"\n      />\n      <path\n        d="m10.4644 12.6278v5.309h-5.23365v-5.309h5.23365v-5.3059h-9.547447c-.122288.00081-.243196.0259-.355701.07383-.112505.04794-.214364.11775-.29966.20538-.085295.08763-.152328.19134-.1972019.3051-.0448742.11376-.06669581.2353-.06419744.35757v14.06532c-.00249837.1223.01932324.2438.06419744.3576.0448739.1137.1119069.2175.1972019.3051.085296.0876.187155.1574.29966.2054.112505.0479.233413.073.355701.0738h13.851847c.1223-.0008.2432-.0259.3557-.0738.1125-.048.2144-.1178.2997-.2054s.1523-.1914.1972-.3051c.0449-.1138.0667-.2353.0642-.3576v-9.7013z"\n        fill="url(#').concat(id, ')"\n      />\n      <path\n        d="m10.4636 2.01256v5.30904h5.2463v5.3059h5.218v-9.68562c.0025-.12227-.0194-.24381-.0642-.35757-.0449-.11376-.1119-.21747-.1972-.3051s-.1872-.15744-.2997-.20537c-.1125-.04794-.2334-.07303-.3557-.07384z"\n        fill="').concat(colors.iconColor, '"\n      />\n    </svg>');
    }
};
var $fbb74bf5c8c09956$export$eb7d748e4f9c9676 = function CompassLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Compass" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $fbb74bf5c8c09956$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("gUezr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1c5f42528db2859$export$2e2bcd8739ae039; });

var $dec5c = parcelRequire("dec5c");

var $36vhv = parcelRequire("36vhv");
const $f1c5f42528db2859$var$ConfluenceCobranding = {
    background: (0, $36vhv.ConfluenceBackground),
    logo: {
        component: (0, $dec5c.ConfluenceLogo)
    },
    footerProducts: "Confluence, Jira, Trello"
};
var $f1c5f42528db2859$export$2e2bcd8739ae039 = $f1c5f42528db2859$var$ConfluenceCobranding;

});
parcelRegister("dec5c", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLogo", function () { return $9a15f49548875a42$export$1b2e4fe6ef471556; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $9a15f49548875a42$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        // Currently the user can style the confluence icon using only iconGradientStop and iconGradientStart
        // the following is used to mimic this edge case as these two props aren't used on the new logos
        if (colors.iconColor === "inherit") colors.iconColor = iconGradientStop;
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 180 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M20.602 20.234c-6.584-3.183-8.507-3.66-11.281-3.66-3.255 0-6.03 1.355-8.507 5.16l-.407.622c-.333.513-.407.696-.407.915s.111.403.518.659l4.18 2.598c.221.146.406.22.591.22.222 0 .37-.11.592-.44l.666-1.024c1.035-1.574 1.96-2.086 3.144-2.086 1.035 0 2.256.293 3.772 1.025l4.365 2.049c.444.22.925.11 1.146-.403l2.072-4.537c.222-.512.074-.842-.444-1.098M1.406 12.22c6.583 3.184 8.507 3.66 11.28 3.66 3.256 0 6.03-1.354 8.508-5.16l.407-.622c.332-.512.406-.695.406-.915s-.11-.402-.518-.658L17.31 5.927c-.222-.147-.407-.22-.592-.22-.222 0-.37.11-.592.44l-.665 1.024c-1.036 1.573-1.96 2.086-3.144 2.086-1.036 0-2.257-.293-3.773-1.025L4.18 6.183c-.444-.22-.925-.11-1.147.402L.962 11.123c-.222.512-.074.841.444 1.098"/>\n      <path fill="').concat(colors.textColor, '" d="M172.49 12.293c-2.791 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.63 2.576-7.942 7.238-7.942 4.722 0 6.624 3.281 6.624 7.942v1.196h-11.194c.368 2.607 2.055 4.294 5.674 4.294 1.778 0 3.281-.338 4.661-.828zm-15.093-2.147v2.362c-.92.49-2.331.705-3.742.705-5.458 0-8.004-3.312-8.004-8.004 0-4.63 2.546-7.942 8.004-7.942 1.38 0 2.454.184 3.65.736v2.453c-.982-.46-2.024-.736-3.466-.736-3.986 0-5.612 2.515-5.612 5.49s1.656 5.489 5.674 5.489c1.564 0 2.545-.215 3.496-.552m-14.503-6.226v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.791-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-22.921-4.262c-2.79 0-4.201 1.809-4.477 4.477h8.556c-.154-2.852-1.441-4.477-4.079-4.477m5.888 12.634c-1.257.675-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.63 2.576-7.942 7.237-7.942 4.723 0 6.624 3.281 6.624 7.942v1.196h-11.193c.368 2.607 2.054 4.294 5.673 4.294 1.778 0 3.281-.338 4.661-.828zm-29.1-5.734v-8.986h2.637v9.262c0 2.76 1.104 3.986 3.619 3.986 2.453 0 4.14-1.625 4.14-4.722v-8.526h2.637v15.334h-2.637v-2.515c-.981 1.81-2.791 2.821-4.845 2.821-3.527 0-5.551-2.422-5.551-6.654m-2.231 6.317c-.215.061-.674.122-1.35.122-2.514 0-4.108-1.196-4.108-4.017V3.798h2.637v17.51c0 1.38.92 1.871 2.055 1.871.275 0 .459 0 .766-.03zM88.157 8.582v1.625h3.956v2.454h-3.956v12.88h-2.576V12.66h-2.484v-2.454h2.484V8.521c0-2.852 1.595-4.784 4.876-4.784a6.3 6.3 0 0 1 1.779.245v2.423a8.7 8.7 0 0 0-1.656-.154c-1.626 0-2.423.95-2.423 2.33m-7.327 7.974v8.986h-2.637v-9.262c0-2.76-1.104-3.986-3.619-3.986-2.453 0-4.14 1.625-4.14 4.722v8.526h-2.637V10.207h2.637v2.515c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.422 5.551 6.654m-23.336 9.292c-4.6 0-7.298-3.404-7.298-8.004s2.698-7.942 7.298-7.942c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.493c-3.28 0-4.722 2.576-4.722 5.49s1.441 5.55 4.722 5.55c3.251 0 4.662-2.637 4.662-5.55s-1.41-5.49-4.662-5.49m-9.233 9.629v2.668c-1.257.828-3.25 1.196-5.336 1.196-6.624 0-10.365-3.986-10.365-10.334 0-6.134 3.741-10.427 10.304-10.427 1.963 0 3.925.368 5.367 1.41v2.669c-1.442-.92-3.036-1.411-5.367-1.411-4.723 0-7.544 3.128-7.544 7.759s2.913 7.697 7.697 7.697c2.116 0 3.772-.49 5.244-1.227"/>\n    </svg>\n    ');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '<svg viewBox="0 0 158 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n    <defs>\n      <linearGradient x1="99.140087%" y1="112.745465%" x2="33.8589812%" y2="37.7675389%" id="'.concat(id, '-1">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n      <linearGradient x1="14.1838118%" y1="5.80047897%" x2="61.141783%" y2="70.9663868%" id="').concat(id, '-2">\n        <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%"></stop>\n        <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke="none" stroke-width="1" fill-rule="nonzero">\n      <path fill="').concat(colors.textColor, '" fill-rule="evenodd" d="M45.312,20.984 C44.064,21.608 42.66,22.024 40.866,22.024 C36.81,22.024 34.34,19.424 34.34,15.498 C34.34,11.572 36.732,8.92 40.736,8.92 C42.712,8.92 44.064,9.336 45.286,10.116 L45.286,7.854 C44.064,6.97 42.4,6.658 40.736,6.658 C35.172,6.658 32,10.298 32,15.498 C32,20.88 35.172,24.26 40.788,24.26 C42.556,24.26 44.246,23.948 45.312,23.246 L45.312,20.984 Z M53.918,24.26 C50.018,24.26 47.73,21.374 47.73,17.474 C47.73,13.574 50.018,10.74 53.918,10.74 C57.792,10.74 60.054,13.574 60.054,17.474 C60.054,21.374 57.792,24.26 53.918,24.26 Z M53.918,12.82 C51.136,12.82 49.914,15.004 49.914,17.474 C49.914,19.944 51.136,22.18 53.918,22.18 C56.674,22.18 57.87,19.944 57.87,17.474 C57.87,15.004 56.674,12.82 53.918,12.82 Z M73.704,16.382 C73.704,12.794 71.988,10.74 68.998,10.74 C67.256,10.74 65.722,11.598 64.89,13.132 L64.89,11 L62.654,11 L62.654,24 L64.89,24 L64.89,16.772 C64.89,14.146 66.32,12.768 68.4,12.768 C70.532,12.768 71.468,13.808 71.468,16.148 L71.468,24 L73.704,24 L73.704,16.382 Z M79.918,9.622 C79.918,8.452 80.594,7.646 81.972,7.646 C82.492,7.646 82.986,7.698 83.376,7.776 L83.376,5.722 C82.986,5.618 82.544,5.514 81.868,5.514 C79.086,5.514 77.734,7.152 77.734,9.57 L77.734,11 L75.628,11 L75.628,13.08 L77.734,13.08 L77.734,24 L79.918,24 L79.918,13.08 L83.272,13.08 L83.272,11 L79.918,11 L79.918,9.622 Z M90.318,23.974 L90.318,21.972 C90.058,21.998 89.902,21.998 89.668,21.998 C88.706,21.998 87.926,21.582 87.926,20.412 L87.926,5.566 L85.69,5.566 L85.69,20.672 C85.69,23.064 87.042,24.078 89.174,24.078 C89.746,24.078 90.136,24.026 90.318,23.974 Z M92.216,18.618 C92.216,22.206 93.932,24.26 96.922,24.26 C98.664,24.26 100.198,23.402 101.03,21.868 L101.03,24 L103.266,24 L103.266,11 L101.03,11 L101.03,18.228 C101.03,20.854 99.6,22.232 97.52,22.232 C95.388,22.232 94.452,21.192 94.452,18.852 L94.452,11 L92.216,11 L92.216,18.618 Z M116.89,23.48 C115.824,24.052 114.186,24.26 112.86,24.26 C107.998,24.26 105.866,21.452 105.866,17.474 C105.866,13.548 108.05,10.74 112.002,10.74 C116.006,10.74 117.618,13.522 117.618,17.474 L117.618,18.488 L108.128,18.488 C108.44,20.698 109.87,22.128 112.938,22.128 C114.446,22.128 115.72,21.842 116.89,21.426 L116.89,23.48 Z M111.898,12.768 C109.532,12.768 108.336,14.302 108.102,16.564 L115.356,16.564 C115.226,14.146 114.134,12.768 111.898,12.768 Z M131.32,16.382 C131.32,12.794 129.604,10.74 126.614,10.74 C124.872,10.74 123.338,11.598 122.506,13.132 L122.506,11 L120.27,11 L120.27,24 L122.506,24 L122.506,16.772 C122.506,14.146 123.936,12.768 126.016,12.768 C128.148,12.768 129.084,13.808 129.084,16.148 L129.084,24 L131.32,24 L131.32,16.382 Z M143.618,21.66 C142.812,21.946 141.98,22.128 140.654,22.128 C137.248,22.128 135.844,19.996 135.844,17.474 C135.844,14.952 137.222,12.82 140.602,12.82 C141.824,12.82 142.708,13.054 143.54,13.444 L143.54,11.364 C142.526,10.896 141.616,10.74 140.446,10.74 C135.818,10.74 133.66,13.548 133.66,17.474 C133.66,21.452 135.818,24.26 140.446,24.26 C141.642,24.26 142.838,24.078 143.618,23.662 L143.618,21.66 Z M156.41,23.48 C155.344,24.052 153.706,24.26 152.38,24.26 C147.518,24.26 145.386,21.452 145.386,17.474 C145.386,13.548 147.57,10.74 151.522,10.74 C155.526,10.74 157.138,13.522 157.138,17.474 L157.138,18.488 L147.648,18.488 C147.96,20.698 149.39,22.128 152.458,22.128 C153.966,22.128 155.24,21.842 156.41,21.426 L156.41,23.48 Z M151.418,12.768 C149.052,12.768 147.856,14.302 147.622,16.564 L154.876,16.564 C154.746,14.146 153.654,12.768 151.418,12.768 Z"></path>\n      <path fill="url(#').concat(id, '-1)" d="M0.85465057,21.7022581 C0.61090057,22.0783871 0.33715057,22.5148387 0.10465057,22.8625806 C-0.10345498,23.195346 0.00826440879,23.6245091 0.35590057,23.8277419 L5.23090057,26.6664516 C5.40202309,26.7664253 5.60840847,26.7971801 5.80372052,26.7518112 C5.99903257,26.7064423 6.16690583,26.5887513 6.26965057,26.4251613 C6.46465057,26.1164516 6.71590057,25.7154839 6.98965057,25.286129 C8.92090057,22.27 10.8634006,22.6390323 14.3659006,24.2216129 L19.1996506,26.3967742 C19.3827218,26.4792261 19.5932727,26.4880304 19.7833166,26.4211804 C19.9733605,26.3543303 20.1267047,26.2175221 20.2084006,26.0419355 L22.5296506,21.0741935 C22.6936507,20.7193919 22.5267777,20.3056906 22.1546506,20.1445161 C21.1346506,19.6903226 19.1059006,18.7854839 17.2796506,17.9516129 C10.7096506,14.9354839 5.12590057,15.1341935 0.85465057,21.7022581 Z"></path>\n      <path fill="url(#').concat(id, '-2)" d="M22.7130274,10.4325806 C22.9567774,10.0564516 23.2305274,9.62 23.4630274,9.27225806 C23.6711329,8.93949274 23.5594135,8.51032964 23.2117774,8.30709677 L18.3367774,5.4683871 C18.1633186,5.35902032 17.9495842,5.32289142 17.7468362,5.36866556 C17.5440883,5.4144397 17.3706168,5.53798759 17.2680274,5.70967742 C17.0730274,6.0183871 16.8217774,6.41935484 16.5480274,6.84870968 C14.6167774,9.86483871 12.6742774,9.49580645 9.17177736,7.91322581 L4.35302736,5.7416129 C4.16995613,5.65916098 3.95940527,5.65035674 3.76936133,5.71720675 C3.5793174,5.78405675 3.42597321,5.92086501 3.34427736,6.09645161 L1.02302736,11.0641935 C0.85902727,11.4189952 1.02590019,11.8326965 1.39802736,11.993871 C2.41802736,12.4480645 4.44677736,13.3529032 6.27302736,14.1867742 C12.8580274,17.1993548 18.4417774,17.0006452 22.7130274,10.4325806 Z"></path>\n    </g>\n  </svg>');
    }
};
var $9a15f49548875a42$export$1b2e4fe6ef471556 = function ConfluenceLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Confluence" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $9a15f49548875a42$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("36vhv", function(module, exports) {

$parcel$export(module.exports, "ConfluenceBackground", function () { return $242a327ae309efbc$export$b0d291b61d581ffd; });

var $8ZuGG = parcelRequire("8ZuGG");

var $kjzjs = parcelRequire("kjzjs");

var $bHkgo = parcelRequire("bHkgo");

var $e1ZEO = parcelRequire("e1ZEO");

var $5GyOg = parcelRequire("5GyOg");
var $242a327ae309efbc$export$b0d291b61d581ffd = function ConfluenceBackground(_ref) {
    var allowDarkMode = _ref.allowDarkMode, children = _ref.children;
    var isDarkMode = allowDarkMode && (0, $kjzjs.default)().colorMode === "dark";
    var Background = isDarkMode ? (0, $bHkgo.ConfluenceDarkTheme) : (0, $e1ZEO.ConfluenceLightTheme);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5GyOg.DesktopOnlyBackground), {
        background: Background
    }, children);
};

});
parcelRegister("kjzjs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eca0f962c73cec04$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $h4cSb = parcelRequire("h4cSb");

var $lwjqb = parcelRequire("lwjqb");

var $529n6 = parcelRequire("529n6");
function $eca0f962c73cec04$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $eca0f962c73cec04$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $eca0f962c73cec04$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $eca0f962c73cec04$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $eca0f962c73cec04$var$isThemeColorMode = function isThemeColorMode(colorMode) {
    return (0, $lwjqb.themeColorModes).find(function(mode) {
        return mode === colorMode;
    }) !== undefined;
};
var $eca0f962c73cec04$var$getGlobalTheme = function getGlobalTheme() {
    if (typeof document === "undefined") return {};
    var element = document.documentElement;
    var colorMode = element.getAttribute((0, $h4cSb.COLOR_MODE_ATTRIBUTE)) || "";
    var theme = element.getAttribute((0, $h4cSb.THEME_DATA_ATTRIBUTE)) || "";
    return $eca0f962c73cec04$var$_objectSpread($eca0f962c73cec04$var$_objectSpread({}, (0, $529n6.themeStringToObject)(theme)), $eca0f962c73cec04$var$isThemeColorMode(colorMode) && {
        colorMode: colorMode
    });
};
var $eca0f962c73cec04$export$2e2bcd8739ae039 = $eca0f962c73cec04$var$getGlobalTheme;

});
parcelRegister("h4cSb", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $c6cccbaedc026509$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $c6cccbaedc026509$export$a00eac3f8684bcd0; });
var $c6cccbaedc026509$export$4ef52930e33717cd = "data-theme";
var $c6cccbaedc026509$export$a00eac3f8684bcd0 = "data-color-mode";
var $c6cccbaedc026509$export$2112803007239c61 = "data-contrast-mode";
var $c6cccbaedc026509$export$352e418ed5b6193a = "data-custom-theme";
var $c6cccbaedc026509$export$2faeed762aac6741 = "light";
var $c6cccbaedc026509$export$6f0c6fb8c80fcc92 = "ds";
var $c6cccbaedc026509$export$4d0c7bbf80185957 = [
    "opacity",
    "font",
    "space",
    "border"
];
var $c6cccbaedc026509$export$dddac1532e822863 = "--".concat($c6cccbaedc026509$export$6f0c6fb8c80fcc92, "-token-not-found");
var $c6cccbaedc026509$export$9d7b58831ae93caa = "--".concat($c6cccbaedc026509$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});

parcelRegister("lwjqb", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", function () { return $faaba6c748597a4d$export$83993de8eb66733; });
$parcel$export(module.exports, "themeIds", function () { return $faaba6c748597a4d$export$7d43e72a58e3283f; });

var $i2LcI = parcelRequire("i2LcI");
var $faaba6c748597a4d$export$83993de8eb66733 = [
    "light",
    "dark",
    "auto"
];
var $faaba6c748597a4d$export$8ce7e340c74e86c5 = [
    "more",
    "no-preference",
    "auto"
];
var $faaba6c748597a4d$export$7d43e72a58e3283f = [
    "light-increased-contrast",
    "light",
    "light-future",
    "light-brand-refresh",
    "dark",
    "dark-future",
    "dark-increased-contrast",
    "dark-brand-refresh",
    "legacy-light",
    "legacy-dark",
    "spacing",
    "shape",
    "typography-adg3",
    "typography-modernized",
    "typography-refreshed"
];
var $faaba6c748597a4d$export$ba8a43b83ecc69f8 = [];
var $faaba6c748597a4d$export$92ba366331403db2 = [].concat($faaba6c748597a4d$export$7d43e72a58e3283f, $faaba6c748597a4d$export$ba8a43b83ecc69f8);
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ var $faaba6c748597a4d$var$themeConfig = {
    "atlassian-light": {
        id: "light",
        displayName: "Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-light-future": {
        id: "light-future",
        displayName: "Future Light Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        override: "light"
    },
    "atlassian-light-increased-contrast": {
        id: "light-increased-contrast",
        displayName: "Light Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "light"
        },
        extends: "light",
        increasesContrastFor: "light"
    },
    "atlassian-dark": {
        id: "dark",
        displayName: "Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-dark-future": {
        id: "dark-future",
        displayName: "Future Dark Theme",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        override: "light"
    },
    "atlassian-dark-increased-contrast": {
        id: "dark-increased-contrast",
        displayName: "Dark Theme (increased contrast)",
        palette: "defaultPalette",
        attributes: {
            type: "color",
            mode: "dark"
        },
        extends: "dark",
        increasesContrastFor: "dark"
    },
    "atlassian-legacy-light": {
        id: "legacy-light",
        displayName: "Light Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-legacy-dark": {
        id: "legacy-dark",
        displayName: "Dark Theme (legacy)",
        palette: "legacyPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    },
    "atlassian-spacing": {
        id: "spacing",
        displayName: "Atlassian Spacing",
        palette: "spacingScale",
        attributes: {
            type: "spacing"
        }
    },
    "atlassian-typography-adg3": {
        id: "typography-adg3",
        displayName: "ADG3 Typography",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-shape": {
        id: "shape",
        displayName: "Atlassian Shape",
        palette: "shapePalette",
        attributes: {
            type: "shape"
        }
    },
    "atlassian-typography-modernized": {
        id: "typography-modernized",
        displayName: "Atlassian Typography (Modernized)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-typography-refreshed": {
        id: "typography-refreshed",
        displayName: "Atlassian Typography (Refreshed)",
        palette: "typographyPalette",
        attributes: {
            type: "typography"
        }
    },
    "atlassian-light-brand-refresh": {
        id: "light-brand-refresh",
        displayName: "Light theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "light"
        }
    },
    "atlassian-dark-brand-refresh": {
        id: "dark-brand-refresh",
        displayName: "Dark theme (Brand refresh)",
        palette: "brandRefreshPalette",
        attributes: {
            type: "color",
            mode: "dark"
        }
    }
};
var $faaba6c748597a4d$export$9aedcfa7336a207 = {
    colorMode: "auto",
    contrastMode: "auto",
    dark: "dark",
    light: "light",
    shape: undefined,
    spacing: "spacing",
    typography: function typography() {
        if ((0, $i2LcI.fg)("platform-default-typography-modernized")) return "typography-modernized";
        return undefined;
    },
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $faaba6c748597a4d$export$2e2bcd8739ae039 = $faaba6c748597a4d$var$themeConfig;

});
parcelRegister("i2LcI", function(module, exports) {

$parcel$export(module.exports, "getBooleanFF", function () { return $d22d07a1220a8be7$export$470e5c2be1411c89; });
$parcel$export(module.exports, "fg", function () { return $d22d07a1220a8be7$export$b40ec24ac8275656; });

var $aSXOk = parcelRequire("aSXOk");
function $d22d07a1220a8be7$export$ba05d765b8392e5e(flagResolver) {
    (0, $aSXOk.setBooleanResolver)(flagResolver);
}
function $d22d07a1220a8be7$export$470e5c2be1411c89(name) {
    return (0, $aSXOk.resolveBooleanFlag)(name);
}
function $d22d07a1220a8be7$export$b40ec24ac8275656(name) {
    return (0, $aSXOk.resolveBooleanFlag)(name);
}

});
parcelRegister("aSXOk", function(module, exports) {

$parcel$export(module.exports, "setBooleanResolver", function () { return $7ecd57ae89f699d7$export$f2b591175b3e424c; });
$parcel$export(module.exports, "resolveBooleanFlag", function () { return $7ecd57ae89f699d7$export$6333b6aff9fc6275; });

var $3tDkq = parcelRequire("3tDkq");

var $1RdT6 = parcelRequire("1RdT6");
var $7ecd57ae89f699d7$var$pkgName = "@atlaskit/platform-feature-flags";
var $7ecd57ae89f699d7$export$7e41b1b2bdee3f98 = "__PLATFORM_FEATURE_FLAGS__";
var $7ecd57ae89f699d7$var$hasProcessEnv = typeof $1RdT6 !== "undefined" && typeof $1RdT6.env !== "undefined";
// FF global overrides can be configured by test runners or Storybook
var $7ecd57ae89f699d7$var$ENV_ENABLE_PLATFORM_FF = $7ecd57ae89f699d7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $7ecd57ae89f699d7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $7ecd57ae89f699d7$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $7ecd57ae89f699d7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $7ecd57ae89f699d7$var$ENV_ENABLE_PLATFORM_FF || $7ecd57ae89f699d7$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $7ecd57ae89f699d7$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $7ecd57ae89f699d7$var$globalVar = typeof window !== "undefined" ? window : globalThis;
$7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98] = $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98] || $7ecd57ae89f699d7$var$DEFAULT_PFF_GLOBAL;
function $7ecd57ae89f699d7$export$f2b591175b3e424c(resolver) {
    $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $7ecd57ae89f699d7$export$6333b6aff9fc6275(flagKey) {
    if ($7ecd57ae89f699d7$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $3tDkq.debug)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $7ecd57ae89f699d7$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $7ecd57ae89f699d7$var$globalVar[$7ecd57ae89f699d7$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== "boolean") {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}

});
parcelRegister("3tDkq", function(module, exports) {

$parcel$export(module.exports, "debug", function () { return $288296556e3638b5$export$1c9f709888824e05; });
var $288296556e3638b5$var$_ref, $288296556e3638b5$var$_process, $288296556e3638b5$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $288296556e3638b5$var$TESTS_MODE = ($288296556e3638b5$var$_ref = (globalThis === null || globalThis === void 0 || ($288296556e3638b5$var$_process = globalThis.process) === null || $288296556e3638b5$var$_process === void 0 || ($288296556e3638b5$var$_process = $288296556e3638b5$var$_process.env) === null || $288296556e3638b5$var$_process === void 0 ? void 0 : $288296556e3638b5$var$_process.JEST_WORKER_ID) !== undefined, $288296556e3638b5$var$_ref !== void 0) ? $288296556e3638b5$var$_ref : false;
var $288296556e3638b5$var$DEBUG_MODE = !$288296556e3638b5$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($288296556e3638b5$var$_process2 = globalThis.process) === null || $288296556e3638b5$var$_process2 === void 0 || ($288296556e3638b5$var$_process2 = $288296556e3638b5$var$_process2.env) === null || $288296556e3638b5$var$_process2 === void 0 ? void 0 : $288296556e3638b5$var$_process2.NODE_ENV) !== "production";
var $288296556e3638b5$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$288296556e3638b5$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};

});




parcelRegister("529n6", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", function () { return $3aa468af555014ae$export$f19b488f7c0547ee; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kg5sN = parcelRequire("kg5sN");

var $lwjqb = parcelRequire("lwjqb");
var $3aa468af555014ae$var$themeKinds = [
    "light",
    "dark",
    "spacing",
    "typography",
    "shape"
];
var $3aa468af555014ae$var$customThemeOptions = "UNSAFE_themeOptions";
var $3aa468af555014ae$var$isThemeKind = function isThemeKind(themeKind) {
    return $3aa468af555014ae$var$themeKinds.find(function(kind) {
        return kind === themeKind;
    }) !== undefined;
};
var $3aa468af555014ae$var$isThemeIds = function isThemeIds(themeId) {
    return (0, $lwjqb.themeIds).find(function(id) {
        return id === themeId;
    }) !== undefined;
};
var $3aa468af555014ae$var$isColorMode = function isColorMode(modeId) {
    return [
        "light",
        "dark",
        "auto"
    ].includes(modeId);
};
var $3aa468af555014ae$export$f19b488f7c0547ee = function themeStringToObject(themeState) {
    return themeState.split(" ").map(function(theme) {
        return theme.split(/:([\s\S]*)/);
    }).reduce(function(themeObject, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), kind = _ref2[0], id = _ref2[1];
        if (kind === "colorMode" && $3aa468af555014ae$var$isColorMode(id)) themeObject[kind] = id;
        if ($3aa468af555014ae$var$isThemeKind(kind) && $3aa468af555014ae$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $3aa468af555014ae$var$customThemeOptions) try {
            themeObject[$3aa468af555014ae$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error("Invalid custom theme string");
        }
        return themeObject;
    }, {});
};
var $3aa468af555014ae$export$62c37ab81302621a = function themeObjectToString(themeState) {
    return Object.entries(themeState).reduce(function(themeString, _ref3) {
        var _ref4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 2), kind = _ref4[0], id = _ref4[1];
        if (// colorMode theme state
        kind === "colorMode" && typeof id === "string" && $3aa468af555014ae$var$isColorMode(id) || // custom theme state
        kind === $3aa468af555014ae$var$customThemeOptions && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(id) === "object" || // other theme states
        $3aa468af555014ae$var$isThemeKind(kind) && typeof id === "string" && $3aa468af555014ae$var$isThemeIds(id)) return themeString + "".concat(themeString ? " " : "") + "".concat(kind, ":").concat((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(id) === "object" ? JSON.stringify(id) : id);
        return themeString;
    }, "");
};

});


parcelRegister("bHkgo", function(module, exports) {

$parcel$export(module.exports, "ConfluenceDarkTheme", function () { return $88436dbc4af8af29$export$42b780ab52e6a23f; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eOtKa = parcelRequire("eOtKa");

var $5BYnF = parcelRequire("5BYnF");

var $7ksF7 = parcelRequire("7ksF7");

var $7rBTv = parcelRequire("7rBTv");

var $8LG6n = parcelRequire("8LG6n");

var $kPkMb = parcelRequire("kPkMb");

var $HgI8j = parcelRequire("HgI8j");
var $88436dbc4af8af29$export$42b780ab52e6a23f = function ConfluenceDarkTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eOtKa.DarkBackground), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5BYnF.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $kPkMb.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $HgI8j.SecondaryNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7rBTv.PageBreadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8LG6n.PageContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7ksF7.PageActions), null));
};

});
parcelRegister("5BYnF", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $415f3ec8aa45fb79$export$8b251419efc915eb; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9ram4 = parcelRequire("9ram4");
var $415f3ec8aa45fb79$export$8b251419efc915eb = function Header() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($415f3ec8aa45fb79$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.DarkModeLine), null));
};
var $415f3ec8aa45fb79$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 1280,
        height: 56,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip0_782_7707)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip1_782_7707)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M52 16h137v24H52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B6C2CF",
        d: "M88.175 34.491c-.968.621-2.501.88-4.115.88-5.11 0-7.988-2.949-7.988-7.681 0-4.552 2.878-7.733 7.961-7.733 1.506 0 3.04.284 4.142 1.034v1.992c-1.103-.673-2.34-1.035-4.142-1.035-3.658 0-5.81 2.328-5.81 5.767 0 3.44 2.26 5.716 5.945 5.716 1.64 0 2.904-.362 4.034-.905v1.965h-.027ZM89.654 29.448c0-3.413 2.071-5.896 5.621-5.896 3.524 0 5.595 2.483 5.595 5.896 0 3.414-2.071 5.949-5.595 5.949-3.523-.026-5.62-2.535-5.62-5.949Zm1.99 0c0 2.173 1.103 4.112 3.658 4.112 2.502 0 3.604-1.965 3.604-4.112 0-2.146-1.075-4.086-3.604-4.086-2.555 0-3.658 1.914-3.658 4.086ZM113.296 35.164h-2.044v-6.88c0-2.043-.861-2.948-2.797-2.948-1.883 0-3.201 1.216-3.201 3.517v6.337h-2.044V23.81h2.044v1.862c.753-1.344 2.152-2.094 3.738-2.094 2.717 0 4.277 1.81 4.277 4.94v6.646h.027ZM122.037 23.785v1.81h-3.066v9.569h-1.99v-9.57h-1.91v-1.81h1.91v-1.24c0-2.122 1.237-3.544 3.765-3.544.619 0 1.022.103 1.372.181v1.81c-.35-.077-.807-.103-1.291-.103-1.264 0-1.883.698-1.883 1.733v1.164h3.093ZM127.389 35.215c-1.936 0-3.173-.879-3.173-2.974V19.026h2.044v12.983c0 1.034.699 1.396 1.586 1.396.216 0 .35 0 .592-.026v1.759c-.188.052-.538.078-1.049.078ZM130.159 23.785h2.045v6.879c0 2.043.86 2.948 2.797 2.948 1.882 0 3.2-1.215 3.2-3.517v-6.31h2.044v11.379h-2.044v-1.862c-.753 1.345-2.151 2.095-3.738 2.095-2.717 0-4.277-1.81-4.277-4.94v-6.672h-.027ZM148.96 35.37c-4.438 0-6.374-2.456-6.374-5.948 0-3.44 1.99-5.896 5.594-5.896 3.658 0 5.11 2.43 5.11 5.896v.88h-8.634c.296 1.94 1.587 3.18 4.385 3.18 1.371 0 2.528-.258 3.604-.62v1.81c-.996.518-2.502.699-3.685.699Zm-4.357-6.723h6.616c-.107-2.121-1.103-3.31-3.147-3.31-2.151 0-3.254 1.318-3.469 3.31ZM165.743 35.164h-2.044v-6.88c0-2.043-.861-2.948-2.797-2.948-1.883 0-3.201 1.216-3.201 3.517v6.337h-2.044V23.81h2.044v1.862c.753-1.344 2.152-2.094 3.739-2.094 2.716 0 4.276 1.81 4.276 4.94v6.646h.027ZM176.959 34.853c-.7.362-1.803.518-2.878.518-4.223 0-6.186-2.457-6.186-5.949 0-3.44 1.963-5.896 6.186-5.896 1.075 0 1.882.13 2.824.543v1.81c-.753-.336-1.56-.543-2.663-.543-3.066 0-4.33 1.862-4.33 4.086 0 2.225 1.291 4.087 4.384 4.087 1.21 0 1.963-.156 2.689-.414v1.758h-.026ZM184.92 35.37c-4.438 0-6.375-2.456-6.375-5.948 0-3.44 1.991-5.896 5.595-5.896 3.658 0 5.11 2.43 5.11 5.896v.88h-8.634c.296 1.94 1.587 3.18 4.384 3.18 1.372 0 2.529-.258 3.604-.62v1.81c-.995.518-2.474.699-3.684.699Zm-4.331-6.723h6.617c-.108-2.121-1.103-3.31-3.147-3.31-2.179 0-3.254 1.318-3.47 3.31Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#paint0_linear_782_7707)",
        d: "M52.592 32.425c-.162.3-.377.627-.538.9-.162.245-.08.573.188.736l3.497 2.182a.532.532 0 0 0 .753-.19c.134-.246.323-.546.51-.873 1.4-2.319 2.771-2.046 5.3-.819l3.469 1.664c.269.136.591 0 .726-.273l1.668-3.818c.107-.273 0-.6-.27-.709-.726-.355-2.178-1.036-3.496-1.69-4.734-2.292-8.741-2.155-11.807 2.89Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#paint1_linear_782_7707)",
        d: "M68.272 23.78c.161-.3.377-.628.538-.9.161-.246.08-.573-.188-.737l-3.497-2.182a.532.532 0 0 0-.753.191c-.134.246-.323.546-.51.873-1.4 2.318-2.771 2.046-5.3.818l-3.442-1.69c-.269-.137-.592 0-.726.272l-1.668 3.818c-.107.273 0 .6.27.71.725.354 2.178 1.036 3.496 1.69 4.706 2.319 8.714 2.182 11.78-2.863Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip2_782_7707)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M213 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 220.5,
        y: 25,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M307 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        width: 64,
        height: 6,
        x: 311,
        y: 25,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip3_782_7707)",
        opacity: 0.6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M381 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#596773",
        d: "M381.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M401 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        width: 64,
        height: 6,
        x: 405,
        y: 25,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip4_782_7707)",
        opacity: 0.6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M475 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fill: "#596773",
        d: "M475.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M495 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 64,
        height: 6,
        x: 499,
        y: 25,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip5_782_7707)",
        opacity: 0.6
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M569 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#596773",
        d: "M569.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M589 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 71,
        height: 6,
        x: 596.5,
        y: 25,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 61,
        height: 32,
        x: 311,
        y: 12,
        fill: "#09326C",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        width: 44,
        height: 6,
        x: 319,
        y: 25,
        fill: "#596773",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 61,
        height: 32,
        x: 499,
        y: 12,
        fill: "#09326C",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        width: 44,
        height: 6,
        x: 507,
        y: 25,
        fill: "#596773",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 61,
        height: 32,
        x: 691,
        y: 12,
        fill: "#09326C",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        width: 44,
        height: 6,
        x: 699,
        y: 25,
        fill: "#596773",
        rx: 3
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M18 16h24v24H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "paint0_linear_782_7707",
        x1: 68.052,
        x2: 57.401,
        y1: 37.376,
        y2: 31.34,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 0.918,
        stopColor: "#2380FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "paint1_linear_782_7707",
        x1: 52.826,
        x2: 63.477,
        y1: 18.826,
        y2: 24.862,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 0.918,
        stopColor: "#2380FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 1,
        stopColor: "#2684FF"
    }))));
};

});

parcelRegister("7ksF7", function(module, exports) {

$parcel$export(module.exports, "PageActions", function () { return $5560a25b0a1dad0a$export$a9e583a1195b23df; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $5560a25b0a1dad0a$export$a9e583a1195b23df = function PageActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($5560a25b0a1dad0a$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($5560a25b0a1dad0a$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $5560a25b0a1dad0a$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    right: 0
});
var $5560a25b0a1dad0a$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 359,
        height: 88,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip0_782_7645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip1_782_7645)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 32,
        height: 32,
        x: 87,
        y: 28,
        fill: "#fff",
        fillOpacity: 0.01,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M91 32h24v24H91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M95.02 51.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21-.78 3.81Zm5.921-2.62-2.12-2.12 8.485-8.49h.002l2.121 2.121-8.489 8.49.001-.001Zm9.903-9.903-2.12-2.122a2 2 0 0 0-1.416-.585c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 0 0 0-2.828h.001Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 32,
        height: 32,
        x: 119,
        y: 28,
        fill: "#fff",
        fillOpacity: 0.01,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M123 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M127.998 43.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51Zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-4.142-4.037-7.513-9-7.513s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.03.164.033a.516.516 0 0 0 .475-.716Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M139 41h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2ZM134 44h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 32,
        height: 32,
        x: 151,
        y: 28,
        fill: "#fff",
        fillOpacity: 0.01,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M155 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "m167 48.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L167 37.687l-1.972 4.19-4.524.688 3.276 3.345-.762 4.655L167 48.373Zm0 2.283-3.016 1.662a2.001 2.001 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a1.994 1.994 0 0 1 .141-2.93c.282-.237.624-.392.988-.447l3.47-.528 1.518-3.224A2.004 2.004 0 0 1 167 35.687a2 2 0 0 1 1.809 1.147l1.519 3.224 3.47.528a2.001 2.001 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a1.999 1.999 0 0 1-2.94 2.075L167 50.656Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 32,
        height: 32,
        x: 183,
        y: 28,
        fill: "#fff",
        fillOpacity: 0.01,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M187 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M199 50c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6H199Zm.001-14C193.48 36 189 40.841 189 44c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M198.977 45.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2Zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 60,
        height: 32,
        x: 221,
        y: 28,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 44,
        height: 6,
        x: 229,
        y: 41,
        fill: "#596773",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 32,
        height: 32,
        x: 287,
        y: 28,
        fill: "#fff",
        fillOpacity: 0.01,
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M291 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        d: "M296 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM303 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM310 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    })));
};

});

parcelRegister("7rBTv", function(module, exports) {

$parcel$export(module.exports, "PageBreadcrumbs", function () { return $56b87305dba77ce2$export$f986fd6afe31509e; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $56b87305dba77ce2$export$f986fd6afe31509e = function PageBreadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($56b87305dba77ce2$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($56b87305dba77ce2$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $56b87305dba77ce2$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px")
});
var $56b87305dba77ce2$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: "320",
        height: "88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "32",
        y: "41",
        width: "100",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "145",
        y: "41",
        width: "54",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M140.701 38.6641L137.687 51.4746H136.292L139.307 38.6641H140.701Z",
        fill: "#596773"
    }));
};

});

parcelRegister("8LG6n", function(module, exports) {

$parcel$export(module.exports, "PageContent", function () { return $66235f0fb5bf9dac$export$16800ac069904dff; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $66235f0fb5bf9dac$export$16800ac069904dff = function PageContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($66235f0fb5bf9dac$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($66235f0fb5bf9dac$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($66235f0fb5bf9dac$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $66235f0fb5bf9dac$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT) + 100, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH) + 24, "px"),
    right: "34px",
    height: "80%"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $66235f0fb5bf9dac$var$ImageWrapper = (0, $3XNKR.default).div({
    display: "flex",
    justifyContent: "center"
});
var $66235f0fb5bf9dac$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 760,
        height: 586,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 503,
        height: 20,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 192,
        height: 6,
        x: 44,
        y: 60,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 119,
        height: 6,
        x: 44,
        y: 48,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#7F5F01",
        d: "M32 60c0-8.837-7.163-16-16-16S0 51.163 0 60s7.163 16 16 16 16-7.163 16-16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#paint0_linear_782_7597)",
        d: "M16.02 71.548c1.972-.008 3.492-.817 4.583-2.112h.036a6.923 6.923 0 0 1-.576-.407c-.126-.092-.246-1.444-.328-2.765-1.083.886-2.23 1.245-2.839 1.713-.471.36-2.281.21-2.747-.23-.607-.571-1.21-1.13-1.75-1.708-.055 1.406-.154 2.942-.265 3.049 0 .003-.297.202-.642.41 1.088 1.26 2.59 2.042 4.528 2.05Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#974F0C",
        d: "M20.703 69.436h-.1c-1.09 1.295-2.611 2.104-4.583 2.112-1.937-.008-3.44-.791-4.528-2.05l-.054-.062h-.1s-2.946 1.413-5.54 2.81a15.936 15.936 0 0 0 10.2 3.675c3.883 0 7.444-1.385 10.216-3.687A157.324 157.324 0 0 0 20.7 69.44l.003-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F7DAC6",
        d: "M22.4 59.739a18.416 18.416 0 0 1-.307 2.089c.02-.003.04-.01.061-.008a.262.262 0 0 1 .24.285.262.262 0 0 1-.283.24.256.256 0 0 1-.123-.046c-.03.133-.064.264-.097.392.389-.1.645-.436.688-1.03.06-.831.54-2.437.18-3.002-.09.366-.213.655-.346.878l-.013.2v.002ZM10.26 61.48a.262.262 0 0 1-.24-.285.262.262 0 0 1 .284-.24c.028 0 .054.013.08.023-.065-.676-.11-1.38-.1-1.907a2.372 2.372 0 0 1-.4-.85c-.125.72-.018 1.797-.074 2.416-.062.666.197 1.053.658 1.175-.013-.122-.028-.248-.041-.378a.255.255 0 0 1-.166.048v-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#253858",
        d: "M22.395 62.105a.264.264 0 0 0-.24-.285c-.021 0-.042.005-.062.008-.034.159-.067.317-.103.471a.255.255 0 0 0 .123.046.264.264 0 0 0 .285-.24h-.003ZM10.02 61.195a.264.264 0 0 0 .24.285.255.255 0 0 0 .167-.05l-.044-.455c-.025-.01-.05-.02-.079-.023a.264.264 0 0 0-.284.24v.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FFE5D4",
        d: "M14.15 67.747c.465.44 2.275.591 2.746.23.61-.468 1.759-.827 2.839-1.713a6.158 6.158 0 0 0 1.677-2.152c.174-.364.338-.863.481-1.419.033-.128.064-.258.097-.391.036-.157.072-.313.103-.471.148-.717.256-1.462.307-2.09l.013-.199c-.366.614-.799.758-.799.758s.085-.604.061-1.3c-.145-4.33-2.485-5.879-3.937-6.309-.916.433-2.322 1.503-2.309 4.02 0 0-2.527.45-4.001-.648a10.066 10.066 0 0 0-.627 2.06c-.133.684-.149 1.294-.149 1.294s-.176-.095-.371-.346c-.01.527.036 1.229.1 1.907l.043.456c.013.13.029.256.041.379.087.78.172 1.38.172 1.38.287 1.075.947 1.984 1.756 2.846.54.579 1.147 1.137 1.751 1.708h.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#579DFF",
        d: "m17.403 49.281-.83-.066c-2.127-.115-6.218.542-6.786 7.605-.046.582.005 1.037.1 1.398.102.39.253.663.4.85.194.251.37.346.37.346s.013-.612.149-1.293a10.06 10.06 0 0 1 .627-2.06 2.467 2.467 0 0 1-.822-1.06s.958-5.835 7.224-4.862c.026 0 .167.61.297 1.203.126.563.241 1.109.241 1.109a3.912 3.912 0 0 0-.63.238c1.45.43 3.792 1.979 3.938 6.307.023.697-.062 1.301-.062 1.301s.435-.146.799-.758a3.25 3.25 0 0 0 .346-.878c.056-.23.102-.486.125-.783.568-7.066-3.364-8.369-5.484-8.594l-.002-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#579DFF",
        d: "M18.13 51.342c-.13-.591-.271-1.2-.297-1.203C11.566 49.166 10.609 55 10.609 55c.092.23.212.43.353.607.138.174.297.325.468.453 1.475 1.1 4.002.648 4.002.648-.013-2.517 1.392-3.587 2.309-4.02.266-.125.494-.2.63-.238 0 0-.116-.547-.241-1.108Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 760,
        height: 86,
        y: 100,
        fill: "#092957",
        rx: 5
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M16 116h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#85B8FF",
        d: "M28 138c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1-14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 2a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 659,
        height: 12,
        x: 66,
        y: 126,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 325,
        height: 12,
        x: 66,
        y: 148,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 117,
        height: 20,
        y: 218,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 98.5,
        height: 20,
        y: 254,
        fill: "#09326C",
        rx: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#596773",
        d: "M12.74 270.6c-3.527 0-5.762-2.215-5.762-5.702v-.013c0-3.377 2.296-5.695 5.646-5.695 3.233 0 5.482 2.065 5.482 5.025v.014c0 2.221-.998 3.636-2.57 3.636-.786 0-1.388-.444-1.497-1.107l-.007-.041h-.11c-.293.697-.908 1.087-1.708 1.087-1.422 0-2.379-1.169-2.379-2.899v-.013c0-1.655.977-2.817 2.379-2.817.718 0 1.333.369 1.6.964h.109v-.834h1.032v4.013c0 .478.28.759.772.759.862 0 1.416-1.087 1.416-2.762v-.014c0-2.461-1.873-4.149-4.608-4.149-2.673 0-4.594 2.037-4.594 4.874v.013c0 2.913 1.887 4.792 4.813 4.792.936 0 1.86-.129 2.29-.328v.862c-.615.212-1.442.335-2.304.335Zm-.369-3.76c.937 0 1.538-.745 1.538-1.907v-.014c0-1.162-.595-1.9-1.524-1.9-.916 0-1.456.71-1.456 1.9v.014c0 1.182.547 1.907 1.442 1.907Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 21.5,
        y: 261,
        fill: "#596773",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 98.5,
        height: 20,
        x: 106.5,
        y: 254,
        fill: "#454F59",
        rx: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#596773",
        d: "M119.24 270.6c-3.527 0-5.762-2.215-5.762-5.702v-.013c0-3.377 2.296-5.695 5.646-5.695 3.233 0 5.482 2.065 5.482 5.025v.014c0 2.221-.998 3.636-2.57 3.636-.786 0-1.388-.444-1.497-1.107l-.007-.041h-.109c-.294.697-.909 1.087-1.709 1.087-1.422 0-2.379-1.169-2.379-2.899v-.013c0-1.655.977-2.817 2.379-2.817.718 0 1.333.369 1.599.964h.11v-.834h1.032v4.013c0 .478.28.759.773.759.861 0 1.415-1.087 1.415-2.762v-.014c0-2.461-1.873-4.149-4.608-4.149-2.673 0-4.594 2.037-4.594 4.874v.013c0 2.913 1.887 4.792 4.813 4.792.936 0 1.859-.129 2.29-.328v.862c-.615.212-1.442.335-2.304.335Zm-.369-3.76c.937 0 1.538-.745 1.538-1.907v-.014c0-1.162-.595-1.9-1.524-1.9-.916 0-1.456.71-1.456 1.9v.014c0 1.182.547 1.907 1.442 1.907Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 128,
        y: 261,
        fill: "#596773",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 98.5,
        height: 20,
        x: 213,
        y: 254,
        fill: "#454F59",
        rx: 10
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#596773",
        d: "M225.74 270.6c-3.527 0-5.762-2.215-5.762-5.702v-.013c0-3.377 2.296-5.695 5.646-5.695 3.233 0 5.482 2.065 5.482 5.025v.014c0 2.221-.998 3.636-2.57 3.636-.786 0-1.388-.444-1.497-1.107l-.007-.041h-.109c-.294.697-.909 1.087-1.709 1.087-1.422 0-2.379-1.169-2.379-2.899v-.013c0-1.655.977-2.817 2.379-2.817.718 0 1.333.369 1.599.964h.11v-.834h1.032v4.013c0 .478.28.759.773.759.861 0 1.415-1.087 1.415-2.762v-.014c0-2.461-1.873-4.149-4.608-4.149-2.673 0-4.594 2.037-4.594 4.874v.013c0 2.913 1.887 4.792 4.813 4.792.936 0 1.859-.129 2.29-.328v.862c-.615.212-1.442.335-2.304.335Zm-.369-3.76c.937 0 1.538-.745 1.538-1.907v-.014c0-1.162-.595-1.9-1.524-1.9-.916 0-1.456.71-1.456 1.9v.014c0 1.182.547 1.907 1.442 1.907Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 234.5,
        y: 261,
        fill: "#596773",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 290,
        height: 20,
        y: 306,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 730,
        height: 12,
        y: 342,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 730,
        height: 12,
        y: 370,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 343,
        height: 12,
        y: 398,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 12,
        height: 12,
        x: 16,
        y: 436,
        fill: "#454F59",
        rx: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#85B8FF",
        d: "M18 436h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm1.382 5.069a1 1 0 0 1 .325.224L21 442.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.09-1.638Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 36,
        y: 439,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 12,
        height: 12,
        x: 16,
        y: 468,
        fill: "#454F59",
        rx: 2
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#85B8FF",
        d: "M18 468h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm1.382 5.069a1 1 0 0 1 .325.224L21 474.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.09-1.638Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 36,
        y: 471,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 10,
        height: 10,
        x: 17,
        y: 501,
        stroke: "#596773",
        rx: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 36,
        y: 503,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 10,
        height: 10,
        x: 17,
        y: 533,
        stroke: "#596773",
        rx: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 36,
        y: 535,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 10,
        height: 10,
        x: 17,
        y: 565,
        stroke: "#596773",
        rx: 1
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 71,
        height: 6,
        x: 36,
        y: 567,
        fill: "#454F59",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip0_782_7597"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M44 60h192v6H44z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip1_782_7597"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 44h32v32H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "paint0_linear_782_7597",
        x1: 16.064,
        x2: 16.064,
        y1: 77.595,
        y2: 63.697,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#FFE5D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 0.4,
        stopColor: "#FCE1CF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 0.83,
        stopColor: "#F5D6C2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: 1,
        stopColor: "#F2D1BB"
    }))));
};

});

parcelRegister("kPkMb", function(module, exports) {

$parcel$export(module.exports, "Search", function () { return $f298afca73c5a721$export$4b85d3515bd863a5; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");
var $f298afca73c5a721$export$4b85d3515bd863a5 = function Search() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f298afca73c5a721$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f298afca73c5a721$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $f298afca73c5a721$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    top: 0,
    right: 0
});
var $f298afca73c5a721$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 412,
        height: 56,
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M356 12h32v32h-32z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip0_782_7719)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#09326C",
        d: "M386.93 27.997c0-8.247-6.685-14.932-14.931-14.932-8.247 0-14.932 6.685-14.932 14.932 0 8.246 6.685 14.931 14.932 14.931 8.246 0 14.931-6.685 14.931-14.931Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#388BFF",
        d: "M378.394 39.69a4.277 4.277 0 0 1-2.655-3.95 4.172 4.172 0 0 1 1.471-3.218c5.888-4.944 2.235-14.518-5.364-14.364-7.444.127-10.831 9.523-5.054 14.364a4.178 4.178 0 0 1 1.471 3.218 4.27 4.27 0 0 1-2.654 3.95c-.463.192-.917.406-1.366.632-.125.064-.242.139-.365.206a14.862 14.862 0 0 0 8.124 2.407c3 0 5.792-.888 8.129-2.41a16.828 16.828 0 0 0-1.735-.835h-.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip1_782_7719)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: 238,
        height: 32,
        x: 25,
        y: 12,
        fill: "#2C333A",
        rx: 3
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        fillRule: "evenodd",
        d: "M46 27a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-.523 4.89a6 6 0 1 1 1.414-1.414l2.816 2.817a1 1 0 0 1-1.414 1.414l-2.816-2.816Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M274 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        fillRule: "evenodd",
        d: "M280.485 33.669a2 2 0 0 0 2.829 0l-2.829-2.83a2.005 2.005 0 0 0-.434 2.18c.101.244.248.464.434.65Zm4.897-12.191-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.045 5.045 0 0 0 .64-6.356 1.01 1.01 0 1 0-1.354-1.494c-.023.025-.046.049-.066.075a5.044 5.044 0 0 0-4.72-.457 5.03 5.03 0 0 0-1.638 1.095v.001Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: 0.01,
        d: "M314 16h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#454F59",
        fillRule: "evenodd",
        d: "M336 28c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10Zm-7.172-4.84a3.97 3.97 0 0 1 1.062 1.89 3.988 3.988 0 0 1-2.536 4.698.507.507 0 0 0-.35.472v.782a1.005 1.005 0 0 1-1.002 1.002A1.003 1.003 0 0 1 325 31.002v-2.014a.998.998 0 0 1 1-.987h-.007a2.004 2.004 0 0 0 2.003-2 2.003 2.003 0 0 0-3.405-1.386 2 2 0 0 0-.602 1.388c-.002.551-.45.998-1.002.998a.993.993 0 0 1-.982-.904L322 25.95c.017-2.504 2.321-4.436 4.933-3.842a3.973 3.973 0 0 1 1.895 1.052ZM327 34a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip0_782_7719"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M357 13h30v30h-30z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip1_782_7719"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M24 11h314v34H24z"
    }))));
};

});

parcelRegister("HgI8j", function(module, exports) {

$parcel$export(module.exports, "SecondaryNav", function () { return $0820fab0362a5e18$export$b982c89a8be501e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $0820fab0362a5e18$export$b982c89a8be501e8 = function SecondaryNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($0820fab0362a5e18$var$Background, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($0820fab0362a5e18$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($0820fab0362a5e18$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $0820fab0362a5e18$var$Background = (0, $3XNKR.default).div({
    display: "inline-block",
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    left: 0,
    height: "100%",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px"),
    background: "#2c333a",
    borderRight: "1px solid #454f59"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $0820fab0362a5e18$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    left: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px")
});
var $0820fab0362a5e18$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "240",
        height: "1100",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "240",
        height: "1100",
        fill: "#2C333A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#clip0_782_7656)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(26 88)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "22",
        y: "84",
        width: "32",
        height: "32",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "97",
        width: "71",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(26 132)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "22",
        y: "128",
        width: "32",
        height: "32",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "141",
        width: "71",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(26 176)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "22",
        y: "172",
        width: "32",
        height: "32",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "185",
        width: "71",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(26 220)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "22",
        y: "216",
        width: "32",
        height: "32",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "229",
        width: "71",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(26 290)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "22",
        y: "286",
        width: "32",
        height: "32",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "299",
        width: "71",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "16",
        y: "326",
        width: "208",
        height: "40",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(40 334)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "52",
        cy: "346",
        r: "2",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "72",
        y: "343",
        width: "125",
        height: "6",
        rx: "3",
        fill: "#596773"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(40 378)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "52",
        cy: "390",
        r: "2",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "72",
        y: "387",
        width: "125",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "24",
        height: "24",
        transform: "translate(40 422)",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "52",
        cy: "434",
        r: "2",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "72",
        y: "431",
        width: "125",
        height: "6",
        rx: "3",
        fill: "#454F59"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "18",
        y: "24",
        width: "40",
        height: "40",
        rx: "3",
        fill: "#092957"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "29",
        width: "97",
        height: "12",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        x: "66",
        y: "53",
        width: "141",
        height: "6",
        rx: "3",
        fill: "#454F59"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "clip0_782_7656"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "208",
        height: "374",
        fill: "white",
        transform: "translate(16 80)"
    }))));
};

});


parcelRegister("e1ZEO", function(module, exports) {

$parcel$export(module.exports, "ConfluenceLightTheme", function () { return $a370fc88734709e9$export$d4cbd1e5e91e64ff; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eOtKa = parcelRequire("eOtKa");

var $j69BP = parcelRequire("j69BP");

var $38r4W = parcelRequire("38r4W");

var $gQGRY = parcelRequire("gQGRY");

var $dmDLw = parcelRequire("dmDLw");

var $gLRH9 = parcelRequire("gLRH9");

var $aibRh = parcelRequire("aibRh");
var $a370fc88734709e9$export$d4cbd1e5e91e64ff = function ConfluenceLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": "testId-confluence-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eOtKa.Background), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $38r4W.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $j69BP.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $aibRh.SecondaryNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dmDLw.PageBreadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gLRH9.PageContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gQGRY.PageActions), null));
};

});
parcelRegister("38r4W", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $24871fb8879531ed$export$8b251419efc915eb; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9ram4 = parcelRequire("9ram4");
var $24871fb8879531ed$export$8b251419efc915eb = function Header() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($24871fb8879531ed$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Line), null));
};
var $24871fb8879531ed$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: "1280",
        height: "56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h1280v56H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#HeaderA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M52 16h137v24H52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M88.175 34.491c-.968.621-2.501.88-4.115.88-5.11 0-7.988-2.949-7.988-7.681 0-4.552 2.878-7.733 7.961-7.733 1.506 0 3.04.284 4.142 1.034v1.992c-1.103-.673-2.34-1.035-4.142-1.035-3.658 0-5.81 2.328-5.81 5.767 0 3.44 2.26 5.716 5.945 5.716 1.64 0 2.904-.362 4.034-.905v1.965h-.027ZM89.654 29.448c0-3.413 2.071-5.896 5.621-5.896 3.524 0 5.595 2.483 5.595 5.896 0 3.414-2.071 5.949-5.595 5.949-3.523-.026-5.62-2.535-5.62-5.949Zm1.99 0c0 2.173 1.103 4.112 3.658 4.112 2.502 0 3.604-1.965 3.604-4.112 0-2.146-1.075-4.086-3.604-4.086-2.555 0-3.658 1.914-3.658 4.086ZM113.296 35.164h-2.044v-6.88c0-2.043-.861-2.948-2.797-2.948-1.883 0-3.201 1.216-3.201 3.517v6.337h-2.044V23.81h2.044v1.862c.753-1.344 2.152-2.094 3.738-2.094 2.717 0 4.277 1.81 4.277 4.94v6.646h.027ZM122.037 23.785v1.81h-3.066v9.569h-1.99v-9.57h-1.91v-1.81h1.91v-1.24c0-2.122 1.237-3.544 3.765-3.544.619 0 1.022.103 1.372.181v1.81c-.35-.077-.807-.103-1.291-.103-1.264 0-1.883.698-1.883 1.733v1.164h3.093ZM127.389 35.215c-1.936 0-3.173-.879-3.173-2.974V19.026h2.044v12.983c0 1.034.699 1.396 1.586 1.396.216 0 .35 0 .592-.026v1.759c-.188.052-.538.078-1.049.078ZM130.159 23.785h2.045v6.879c0 2.043.86 2.948 2.797 2.948 1.882 0 3.2-1.215 3.2-3.517v-6.31h2.044v11.379h-2.044v-1.862c-.753 1.345-2.151 2.095-3.738 2.095-2.717 0-4.277-1.81-4.277-4.94v-6.672h-.027ZM148.96 35.37c-4.438 0-6.374-2.456-6.374-5.948 0-3.44 1.99-5.896 5.594-5.896 3.658 0 5.11 2.43 5.11 5.896v.88h-8.633c.295 1.94 1.586 3.18 4.384 3.18 1.371 0 2.528-.258 3.604-.62v1.81c-.996.518-2.502.699-3.685.699Zm-4.357-6.723h6.616c-.107-2.121-1.103-3.31-3.147-3.31-2.151 0-3.254 1.318-3.469 3.31ZM165.743 35.164h-2.044v-6.88c0-2.043-.861-2.948-2.797-2.948-1.883 0-3.201 1.216-3.201 3.517v6.337h-2.044V23.81h2.044v1.862c.753-1.344 2.152-2.094 3.739-2.094 2.716 0 4.276 1.81 4.276 4.94v6.646h.027ZM176.959 34.853c-.7.362-1.803.518-2.878.518-4.223 0-6.186-2.457-6.186-5.949 0-3.44 1.963-5.896 6.186-5.896 1.075 0 1.882.13 2.824.543v1.81c-.753-.336-1.56-.543-2.663-.543-3.066 0-4.33 1.862-4.33 4.086 0 2.225 1.291 4.087 4.384 4.087 1.21 0 1.963-.156 2.689-.414v1.758h-.026ZM184.92 35.37c-4.438 0-6.375-2.456-6.375-5.948 0-3.44 1.991-5.896 5.595-5.896 3.658 0 5.11 2.43 5.11 5.896v.88h-8.634c.296 1.94 1.587 3.18 4.384 3.18 1.372 0 2.529-.258 3.604-.62v1.81c-.995.518-2.474.699-3.684.699Zm-4.331-6.723h6.617c-.108-2.121-1.103-3.31-3.147-3.31-2.179 0-3.254 1.318-3.47 3.31Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M52.592 32.425c-.162.3-.377.627-.538.9-.162.245-.08.573.188.736l3.497 2.182a.532.532 0 0 0 .753-.19c.134-.246.323-.546.51-.873 1.4-2.319 2.771-2.046 5.3-.819l3.469 1.664c.269.136.591 0 .726-.273l1.668-3.818c.107-.273 0-.6-.27-.709-.726-.355-2.178-1.036-3.496-1.69-4.734-2.292-8.741-2.155-11.807 2.89Z",
        fill: "url(#HeaderB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M68.272 23.78c.161-.3.377-.628.538-.9.161-.246.08-.573-.188-.737l-3.497-2.182a.532.532 0 0 0-.753.191c-.134.246-.323.546-.51.873-1.4 2.318-2.771 2.045-5.3.818l-3.442-1.69c-.269-.137-.592 0-.726.272l-1.668 3.818c-.107.273 0 .6.27.71.725.354 2.178 1.036 3.496 1.69 4.706 2.318 8.714 2.182 11.78-2.864Z",
        fill: "url(#HeaderC)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M213 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M220.5 28a3 3 0 0 1 3-3h65a3 3 0 1 1 0 6h-65a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M217 54a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v2h-78v-2Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M307 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        d: "M311 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: ".6",
        clipPath: "url(#HeaderD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M381 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M381.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.997.997 0 0 0-.703-.293.99.99 0 0 0-.703.293Z",
        fill: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M401 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        d: "M405 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: ".6",
        clipPath: "url(#HeaderE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M475 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M475.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.997.997 0 0 0-.703-.293.99.99 0 0 0-.703.293Z",
        fill: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M495 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M502.5 28a3 3 0 0 1 3-3h65a3 3 0 1 1 0 6h-65a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M589 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M593 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: ".6",
        clipPath: "url(#HeaderF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M663 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M663.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.997.997 0 0 0-.703-.293.99.99 0 0 0-.703.293Z",
        fill: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        d: "M315 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
        fill: "#B3D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        d: "M323 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        d: "M503 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
        fill: "#B3D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        d: "M511 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M691 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
        fill: "#B3D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M699 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M18 16h24v24H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
        fill: "#A5ADBA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(52 16)",
        d: "M0 0h137v24H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderD"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(381 18)",
        d: "M0 0h8v20H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(475 18)",
        d: "M0 0h8v20H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(663 18)",
        d: "M0 0h8v20H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "HeaderB",
        x1: "68.052",
        y1: "37.376",
        x2: "57.401",
        y2: "31.34",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".918",
        stopColor: "#2380FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "HeaderC",
        x1: "52.826",
        y1: "18.826",
        x2: "63.477",
        y2: "24.862",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".918",
        stopColor: "#2380FB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    }))));
};

});

parcelRegister("gQGRY", function(module, exports) {

$parcel$export(module.exports, "PageActions", function () { return $c442c1aa36c0a6cb$export$a9e583a1195b23df; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $c442c1aa36c0a6cb$export$a9e583a1195b23df = function PageActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c442c1aa36c0a6cb$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c442c1aa36c0a6cb$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $c442c1aa36c0a6cb$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    right: 0
});
var $c442c1aa36c0a6cb$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "359",
        height: "88",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageActionsA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageActionsB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "87",
        y: "28",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M91 32h24v24H91z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M95.02 51.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21-.78 3.81Zm5.921-2.62-2.12-2.12 8.485-8.49h.002l2.121 2.121-8.489 8.49.001-.001Zm9.903-9.903-2.12-2.122a2 2 0 0 0-1.416-.585c-.512 0-1.024.195-1.415.585l-9.757 9.758 4.95 4.95 9.757-9.758a2 2 0 0 0 0-2.828h.001Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "119",
        y: "28",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M123 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M127.998 43.513c0-3.038 3.141-5.51 7.002-5.51 3.861 0 7.002 2.472 7.002 5.51 0 3.039-3.141 5.51-7.002 5.51-3.861 0-7.002-2.471-7.002-5.51Zm14.84 7.771v-.002s-1.564-2.26-.767-3.116l-.037.02c1.227-1.284 1.966-2.907 1.966-4.673 0-4.142-4.037-7.513-9-7.513s-9 3.37-9 7.513 4.037 7.514 9 7.514c1.42 0 2.76-.285 3.957-.776 1.003 1.022 2.287 1.572 3.24 1.719l.002-.003c.053.02.108.03.164.033a.516.516 0 0 0 .475-.716Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        d: "M139 41h-8a1 1 0 0 0 0 2h8a1 1 0 0 0 0-2ZM134 44h-3a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "151",
        y: "28",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M155 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        d: "m167 48.373 3.98 2.193-.76-4.655 3.276-3.347-4.524-.69L167 37.687l-1.972 4.189-4.524.689 3.276 3.345-.762 4.655L167 48.373Zm0 2.283-3.016 1.662a2.001 2.001 0 0 1-2.939-2.075l.599-3.656-2.57-2.624a1.994 1.994 0 0 1 .141-2.93c.282-.237.624-.392.988-.447l3.47-.528 1.518-3.224A2.004 2.004 0 0 1 167 35.687a2 2 0 0 1 1.809 1.147l1.519 3.224 3.47.528a2.001 2.001 0 0 1 1.127 3.377l-2.569 2.624.599 3.656a1.999 1.999 0 0 1-2.94 2.075L167 50.656Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "183",
        y: "28",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M187 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M199 50c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6H199Zm.001-14C193.48 36 189 40.841 189 44c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M198.977 45.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2Zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4Z",
        clipRule: "evenodd"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "60",
        height: "32",
        x: "221",
        y: "28",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "229",
        y: "41",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "287",
        y: "28",
        fill: "#fff",
        fillOpacity: ".01",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M291 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        d: "M296 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM303 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM310 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageActionsA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M87 28h232v32H87z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageActionsB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M87 28h128v32H87z"
    }))));
};

});

parcelRegister("dmDLw", function(module, exports) {

$parcel$export(module.exports, "PageBreadcrumbs", function () { return $9bac2d0e84ed2a77$export$f986fd6afe31509e; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $9bac2d0e84ed2a77$export$f986fd6afe31509e = function PageBreadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($9bac2d0e84ed2a77$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($9bac2d0e84ed2a77$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $9bac2d0e84ed2a77$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px")
});
var $9bac2d0e84ed2a77$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: "320",
        height: "88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h320v88H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M32 44a3 3 0 0 1 3-3h94a3 3 0 1 1 0 6H35a3 3 0 0 1-3-3ZM145 44a3 3 0 0 1 3-3h48a3 3 0 1 1 0 6h-48a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "m137.372 51.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z",
        fill: "#6B778C"
    }));
};

});

parcelRegister("gLRH9", function(module, exports) {

$parcel$export(module.exports, "PageContent", function () { return $c35aafd1c53a403e$export$16800ac069904dff; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $c35aafd1c53a403e$export$16800ac069904dff = function PageContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c35aafd1c53a403e$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c35aafd1c53a403e$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c35aafd1c53a403e$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $c35aafd1c53a403e$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT) + 100, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH) + 24, "px"),
    right: "34px",
    height: "80%"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $c35aafd1c53a403e$var$ImageWrapper = (0, $3XNKR.default).div({
    display: "flex",
    justifyContent: "center"
});
var $c35aafd1c53a403e$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "760",
        height: "586",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "503",
        height: "20",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "192",
        height: "6",
        x: "44",
        y: "60",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "119",
        height: "6",
        x: "44",
        y: "48",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#PageContentB)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FFC400",
        d: "M32 60c0-8.837-7.163-16-16-16S0 51.163 0 60s7.163 16 16 16 16-7.163 16-16Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#PageContentC)",
        d: "M16.02 71.548c1.972-.008 3.492-.817 4.583-2.112h.036a6.923 6.923 0 0 1-.576-.407c-.126-.092-.246-1.444-.328-2.765-1.083.886-2.23 1.245-2.839 1.713-.471.36-2.281.21-2.747-.23-.607-.571-1.21-1.13-1.75-1.708-.055 1.406-.154 2.942-.265 3.049 0 .003-.297.202-.642.41 1.088 1.26 2.59 2.042 4.528 2.05Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FF991F",
        d: "M20.703 69.436h-.1c-1.09 1.295-2.611 2.104-4.583 2.112-1.938-.008-3.44-.79-4.528-2.05l-.054-.062h-.1s-2.946 1.413-5.54 2.811a15.936 15.936 0 0 0 10.2 3.674c3.883 0 7.444-1.385 10.216-3.687-2.585-1.39-5.514-2.795-5.514-2.795l.003-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F7DAC6",
        d: "M22.4 59.739a18.392 18.392 0 0 1-.307 2.089c.02-.003.04-.01.061-.008a.262.262 0 0 1 .24.284.262.262 0 0 1-.283.241.257.257 0 0 1-.123-.046c-.03.133-.064.264-.098.392.39-.1.646-.436.69-1.03.058-.832.54-2.437.178-3.002a3.18 3.18 0 0 1-.345.878l-.013.2v.002ZM10.26 61.48a.262.262 0 0 1-.24-.284.262.262 0 0 1 .284-.241c.028 0 .054.013.08.023-.065-.676-.11-1.38-.1-1.907a2.37 2.37 0 0 1-.4-.85c-.125.72-.018 1.797-.074 2.416-.061.666.197 1.053.658 1.175-.013-.122-.028-.248-.041-.378a.254.254 0 0 1-.166.048v-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#253858",
        d: "M22.395 62.104a.264.264 0 0 0-.24-.284c-.021 0-.042.005-.062.008-.034.159-.067.317-.103.47a.257.257 0 0 0 .123.047.264.264 0 0 0 .284-.24h-.002ZM10.02 61.196a.264.264 0 0 0 .24.284.255.255 0 0 0 .167-.049l-.044-.456c-.025-.01-.05-.02-.079-.023a.264.264 0 0 0-.284.24v.004Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FFE5D4",
        d: "M14.15 67.747c.465.44 2.275.59 2.746.23.61-.469 1.759-.827 2.839-1.713a6.158 6.158 0 0 0 1.677-2.153c.174-.363.338-.862.481-1.418.033-.128.064-.258.097-.392a17.847 17.847 0 0 0 .41-2.56l.013-.2c-.366.615-.799.759-.799.759s.085-.605.061-1.301c-.145-4.329-2.485-5.878-3.937-6.308-.916.433-2.322 1.503-2.309 4.02 0 0-2.527.45-4.001-.648a10.066 10.066 0 0 0-.627 2.06c-.133.684-.149 1.293-.149 1.293s-.176-.094-.371-.345c-.01.527.036 1.229.1 1.907l.043.456c.013.13.029.256.041.379.087.78.172 1.38.172 1.38.287 1.075.947 1.983 1.756 2.846.54.579 1.147 1.137 1.751 1.708h.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#PageContentD)",
        d: "m17.403 49.281-.83-.066c-2.127-.116-6.218.542-6.786 7.605-.046.582.005 1.037.1 1.398.102.39.253.663.399.85.195.251.371.346.371.346s.013-.612.149-1.293c.156-.788.37-1.472.627-2.06A2.47 2.47 0 0 1 10.61 55s.958-5.835 7.224-4.862c.026 0 .167.61.297 1.203.126.563.241 1.109.241 1.109a3.9 3.9 0 0 0-.63.238c1.45.43 3.792 1.978 3.938 6.307a8.51 8.51 0 0 1-.062 1.301s.435-.146.799-.758a3.25 3.25 0 0 0 .346-.878c.056-.23.102-.486.125-.783.568-7.066-3.364-8.369-5.484-8.594l-.002-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0065FF",
        d: "M18.13 51.342c-.13-.591-.271-1.2-.297-1.203C11.566 49.166 10.609 55 10.609 55c.092.23.212.43.353.607.138.174.297.325.468.453 1.475 1.101 4.002.648 4.002.648-.013-2.517 1.392-3.587 2.309-4.02.266-.125.494-.199.63-.237 0 0-.116-.548-.241-1.109Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "760",
        height: "86",
        y: "100",
        fill: "#DEEBFF",
        rx: "5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M16 116h24v24H16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0052CC",
        fillRule: "evenodd",
        d: "M28 138c-5.523 0-10-4.477-10-10s4.477-10 10-10 10 4.477 10 10-4.477 10-10 10Zm1-14a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-1 2a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0v-5a1 1 0 0 1 1-1Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "659",
        height: "12",
        x: "66",
        y: "126",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "325",
        height: "12",
        x: "66",
        y: "148",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "117",
        height: "20",
        y: "218",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "98.5",
        height: "20",
        y: "254",
        fill: "#B3D4FF",
        rx: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".48",
        d: "M12.624 259.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.43.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.416 2.769-.492 0-.772-.281-.772-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.6-.964-1.4 0-2.378 1.162-2.378 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.11c.081.67.703 1.148 1.503 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.24 3.829c.93 0 1.525.738 1.525 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "21.5",
        y: "261",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "98.5",
        height: "20",
        x: "106.5",
        y: "254",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".48",
        d: "M119.124 259.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "128",
        y: "261",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "98.5",
        height: "20",
        x: "213",
        y: "254",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".48",
        d: "M225.624 259.19c-3.35 0-5.646 2.318-5.646 5.702 0 3.493 2.235 5.708 5.762 5.708.862 0 1.689-.123 2.304-.335v-.862c-.431.199-1.354.328-2.29.328-2.926 0-4.813-1.879-4.813-4.798 0-2.844 1.921-4.881 4.594-4.881 2.735 0 4.608 1.688 4.608 4.156 0 1.682-.554 2.769-1.415 2.769-.493 0-.773-.281-.773-.759v-4.013h-1.032v.834h-.11c-.266-.595-.881-.964-1.599-.964-1.402 0-2.379 1.162-2.379 2.823 0 1.737.957 2.906 2.379 2.906.8 0 1.415-.39 1.709-1.087h.109c.082.67.704 1.148 1.504 1.148 1.572 0 2.57-1.415 2.57-3.643 0-2.967-2.249-5.032-5.482-5.032Zm-.239 3.829c.929 0 1.524.738 1.524 1.907s-.601 1.914-1.538 1.914c-.895 0-1.442-.725-1.442-1.914 0-1.197.54-1.907 1.456-1.907Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "234.5",
        y: "261",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "290",
        height: "20",
        y: "306",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "730",
        height: "12",
        y: "342",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "730",
        height: "12",
        y: "370",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "343",
        height: "12",
        y: "398",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "16",
        y: "436",
        fill: "#DFE1E6",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0052CC",
        fillRule: "evenodd",
        d: "M18 436h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm1.382 5.069a1 1 0 0 1 .325.224L21 442.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.09-1.638Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "36",
        y: "439",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "12",
        height: "12",
        x: "16",
        y: "468",
        fill: "#DFE1E6",
        rx: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0052CC",
        fillRule: "evenodd",
        d: "M18 468h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2Zm1.382 5.069a1 1 0 0 1 .325.224L21 474.586l3.293-3.293a1 1 0 1 1 1.414 1.414l-4 4a1.002 1.002 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.09-1.638Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "36",
        y: "471",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "17",
        y: "501",
        stroke: "#7A869A",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "36",
        y: "503",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "17",
        y: "533",
        stroke: "#7A869A",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "36",
        y: "535",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "10",
        height: "10",
        x: "17",
        y: "565",
        stroke: "#7A869A",
        strokeWidth: "2",
        rx: "1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "36",
        y: "567",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "PageContentC",
        x1: "16.064",
        x2: "16.064",
        y1: "77.595",
        y2: "63.697",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#FFE5D4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".4",
        stopColor: "#FCE1CF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".83",
        stopColor: "#F5D6C2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#F2D1BB"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "PageContentD",
        x1: "14.769",
        x2: "18.068",
        y1: "65.734",
        y2: "47.73",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".35",
        stopColor: "#91562D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".41",
        stopColor: "#775852"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".51",
        stopColor: "#4D5D8F"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".6",
        stopColor: "#2B60BF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".68",
        stopColor: "#1362E2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".75",
        stopColor: "#0564F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".8",
        stopColor: "#0065FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M44 60h192v6H44z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "PageContentB"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 44h32v32H0z"
    }))));
};

});

parcelRegister("aibRh", function(module, exports) {

$parcel$export(module.exports, "SecondaryNav", function () { return $77e4c8a616a89fdc$export$b982c89a8be501e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2Md0t = parcelRequire("2Md0t");
var $77e4c8a616a89fdc$export$b982c89a8be501e8 = function SecondaryNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2Md0t.SecondaryNavWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($77e4c8a616a89fdc$var$Image, null));
};
var $77e4c8a616a89fdc$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "240",
        height: "777",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        d: "M0 0h240v777H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SecondaryNavA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 88h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "84",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "97",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 132h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "128",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "141",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 176h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "172",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "185",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 220h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "216",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "229",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 290h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "286",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "299",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "208",
        height: "40",
        x: "16",
        y: "326",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M40 334h24v24H40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "52",
        cy: "346",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "125",
        height: "6",
        x: "72",
        y: "343",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M40 378h24v24H40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "52",
        cy: "390",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "125",
        height: "6",
        x: "72",
        y: "387",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M40 422h24v24H40z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("circle", {
        cx: "52",
        cy: "434",
        r: "2",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "125",
        height: "6",
        x: "72",
        y: "431",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "40",
        height: "40",
        x: "18",
        y: "24",
        fill: "#DEEBFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "97",
        height: "12",
        x: "66",
        y: "29",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "141",
        height: "6",
        x: "66",
        y: "53",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SecondaryNavA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M16 80h208v374H16z"
    }))));
};

});




parcelRegister("2erun", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $106fc7647dc66f9d$export$2e2bcd8739ae039; });

var $2KVdV = parcelRequire("2KVdV");

var $3cer2 = parcelRequire("3cer2");
const $106fc7647dc66f9d$var$JiraCobranding = {
    background: (0, $3cer2.JiraBackground),
    logo: {
        component: (0, $2KVdV.JiraLogo)
    },
    footerProducts: "Jira, Confluence, Trello"
};
var $106fc7647dc66f9d$export$2e2bcd8739ae039 = $106fc7647dc66f9d$var$JiraCobranding;

});
parcelRegister("2KVdV", function(module, exports) {

$parcel$export(module.exports, "JiraLogo", function () { return $201c44163c4a4d37$export$17d3acb0b4379d02; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $201c44163c4a4d37$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 77 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M7.967 21.323H5.748C2.401 21.323 0 19.273 0 16.271h11.933c.618 0 1.018.44 1.018 1.062V29.34c-2.983 0-4.984-2.416-4.984-5.784zm5.894-5.967h-2.22c-3.346 0-5.747-2.013-5.747-5.015h11.932c.618 0 1.055.402 1.055 1.025v12.007c-2.983 0-5.02-2.416-5.02-5.784zm5.93-5.93h-2.22c-3.347 0-5.748-2.05-5.748-5.052h11.933c.618 0 1.019.439 1.019 1.025v12.007c-2.983 0-4.984-2.416-4.984-5.784z"/>\n      <path fill="').concat(colors.textColor, '" d="M65.023 17.874c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.821 3.067-5.183 3.067-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM55.91 16.493v9.047h-2.577V10.207h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M46.224 6.159c0-1.165.767-1.84 1.84-1.84s1.84.675 1.84 1.84-.767 1.84-1.84 1.84-1.84-.675-1.84-1.84m.49 19.381V10.207h2.638V25.54zm-6.427-5.95V5.393h2.76v14.015c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.246-3.312-.522v-2.668c.828.338 1.84.522 2.852.522 2.33 0 3.128-1.41 3.128-3.404"/>\n    </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '<svg viewBox="0 0 69 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n      <defs>\n        <linearGradient x1="98.0308675%" y1="0.160599572%" x2="58.8877062%" y2="40.7655246%" id="'.concat(id, '">\n          <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="18%"></stop>\n          <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n        </linearGradient>\n      </defs>\n      <g stroke="none" stroke-width="1" fill-rule="nonzero">\n        <path fill="').concat(colors.iconColor, '" d="M22.9366667,4 L11.41,4 C11.41,5.3800098 11.9582068,6.703498 12.934021,7.67931228 C13.9098353,8.65512657 15.2333235,9.20333333 16.6133333,9.20333333 L18.7366667,9.20333333 L18.7366667,11.2533333 C18.7385054,14.1244521 21.0655479,16.4514946 23.9366667,16.4533333 L23.9366667,5 C23.9366667,4.44771525 23.4889514,4 22.9366667,4 Z"></path>\n        <path fill="url(#').concat(id, ')"d="M17.2333333,9.74333333 L5.70666667,9.74333333 C5.70850536,12.6144521 8.03554792,14.9414946 10.9066667,14.9433333 L13.03,14.9433333 L13.03,17 C13.0336786,19.8711178 15.3622132,22.196669 18.2333333,22.1966667 L18.2333333,10.7433333 C18.2333333,10.1910486 17.7856181,9.74333333 17.2333333,9.74333333 Z" ></path>\n        <path fill="url(#').concat(id, ')" d="M11.5266667,15.4833333 L0,15.4833333 C3.51929402e-16,18.357055 2.32961169,20.6866667 5.20333333,20.6866667 L7.33333333,20.6866667 L7.33333333,22.7366667 C7.33516565,25.6051863 9.65815176,27.9311544 12.5266667,27.9366667 L12.5266667,16.4833333 C12.5266667,15.9310486 12.0789514,15.4833333 11.5266667,15.4833333 Z" ></path>\n        <path fill="').concat(colors.textColor, '" d="M37.07,18.956 C37.07,20.646 36.394,21.842 34.418,21.842 C33.56,21.842 32.702,21.686 32,21.4 L32,23.662 C32.65,23.896 33.586,24.104 34.808,24.104 C38.032,24.104 39.41,21.946 39.41,18.8 L39.41,6.918 L37.07,6.918 L37.07,18.956 Z M42.894,7.568 C42.894,8.556 43.544,9.128 44.454,9.128 C45.364,9.128 46.014,8.556 46.014,7.568 C46.014,6.58 45.364,6.008 44.454,6.008 C43.544,6.008 42.894,6.58 42.894,7.568 Z M43.31,24 L45.546,24 L45.546,11 L43.31,11 L43.31,24 Z M48.926,24 L51.11,24 L51.11,16.33 C51.11,13.574 52.852,12.716 55.712,13.002 L55.712,10.818 C53.164,10.662 51.864,11.754 51.11,13.288 L51.11,11 L48.926,11 L48.926,24 Z M66.45,24 L66.45,21.66 C65.618,23.376 64.058,24.26 62.056,24.26 C58.598,24.26 56.856,21.322 56.856,17.5 C56.856,13.834 58.676,10.74 62.316,10.74 C64.214,10.74 65.67,11.598 66.45,13.288 L66.45,11 L68.686,11 L68.686,24 L66.45,24 Z M59.092,17.5 C59.092,20.62 60.34,22.18 62.654,22.18 C64.656,22.18 66.45,20.906 66.45,18.02 L66.45,16.98 C66.45,14.094 64.812,12.82 62.914,12.82 C60.392,12.82 59.092,14.484 59.092,17.5 Z" fill-rule="evenodd"></path>\n      </g>\n    </svg>');
    }
};
var $201c44163c4a4d37$export$17d3acb0b4379d02 = function JiraLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $201c44163c4a4d37$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("3cer2", function(module, exports) {

$parcel$export(module.exports, "JiraBackground", function () { return $253db0961c95205f$export$2ccb200c5de09b24; });

var $8ZuGG = parcelRequire("8ZuGG");

var $67Oxm = parcelRequire("67Oxm");

var $5GyOg = parcelRequire("5GyOg");
var $253db0961c95205f$export$2ccb200c5de09b24 = function JiraBackground(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5GyOg.DesktopOnlyBackground), {
        background: (0, $67Oxm.JiraLightTheme)
    }, children);
};

});
parcelRegister("67Oxm", function(module, exports) {

$parcel$export(module.exports, "JiraLightTheme", function () { return $475a991fad819cab$export$8e2414c6a082747f; });
/* eslint-disable @atlaskit/design-system/prefer-primitives */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $eOtKa = parcelRequire("eOtKa");

var $j69BP = parcelRequire("j69BP");

var $hQ9Ys = parcelRequire("hQ9Ys");

var $4iJNa = parcelRequire("4iJNa");

var $hEU6f = parcelRequire("hEU6f");

var $2LEqR = parcelRequire("2LEqR");

var $dA3G2 = parcelRequire("dA3G2");

var $h927Q = parcelRequire("h927Q");
var $475a991fad819cab$export$8e2414c6a082747f = function JiraLightTheme() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("div", {
        "data-testid": "testId-jira-wireframe"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $eOtKa.Background), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $4iJNa.Header), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $j69BP.Search), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $h927Q.SecondaryNav), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2LEqR.IssueBreadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hEU6f.IssueActions), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $dA3G2.IssueContent), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hQ9Ys.DetailsPanel), null));
};

});
parcelRegister("hQ9Ys", function(module, exports) {

$parcel$export(module.exports, "DetailsPanel", function () { return $cfcf07a15d851abe$export$e54a7f2505304e20; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $cfcf07a15d851abe$export$e54a7f2505304e20 = function DetailsPanel() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($cfcf07a15d851abe$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($cfcf07a15d851abe$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $cfcf07a15d851abe$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT) + 88, "px"),
    right: 0,
    padding: "0 ".concat("var(--ds-space-300, 24px)", " 100%"),
    background: "#fff"
});
var $cfcf07a15d851abe$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "328",
        height: "597",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "99",
        height: "32",
        fill: "#B3D4FF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "59",
        height: "6",
        x: "8",
        y: "13",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M70 4h24v24H70z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".25",
        fillRule: "evenodd",
        d: "M78.292 14.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        stroke: "#091E42",
        strokeOpacity: ".13",
        strokeWidth: "2",
        d: "M1 52a7 7 0 0 1 7-7h312a7 7 0 0 1 7 7v544H1V52Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "253",
        height: "6",
        x: "24",
        y: "77",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M280 68h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#091E42",
        fillOpacity: ".25",
        fillRule: "evenodd",
        d: "M288.292 78.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.997.997 0 0 0-.703-.293.99.99 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "121",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "54",
        height: "6",
        x: "24",
        y: "159",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "114",
        height: "6",
        x: "24",
        y: "197",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "52",
        height: "20",
        x: "178",
        y: "190",
        fill: "#EBECF0",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "182",
        y: "197",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "70",
        height: "6",
        x: "24",
        y: "235",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "273",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "311",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "349",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "387",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "425",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "89.122",
        height: "6",
        x: "24",
        y: "463",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "66",
        height: "6",
        x: "210",
        y: "121",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "178",
        y: "159",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "126",
        height: "6",
        x: "178",
        y: "273",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "126",
        height: "6",
        x: "178",
        y: "311",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "126",
        height: "6",
        x: "178",
        y: "349",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "126",
        height: "6",
        x: "178",
        y: "387",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "126",
        height: "6",
        x: "178",
        y: "425",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "126",
        height: "6",
        x: "178",
        y: "463",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "202",
        y: "235",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#DetailsPanelA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M193.963 237.998a7.964 7.964 0 1 0-15.927.001 7.964 7.964 0 0 0 15.927-.001Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "M189.41 244.235a2.283 2.283 0 0 1-1.416-2.107 2.225 2.225 0 0 1 .785-1.716c3.14-2.637 1.192-7.743-2.861-7.661-3.97.068-5.777 5.079-2.696 7.661.503.427.79 1.056.785 1.716a2.28 2.28 0 0 1-1.416 2.107c-.247.102-.489.216-.728.337-.067.034-.129.074-.195.11a7.93 7.93 0 0 0 4.333 1.283 7.92 7.92 0 0 0 4.336-1.285 9.53 9.53 0 0 0-.926-.445h-.001Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M178 112h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#0065FF",
        d: "m190.522 131.853.103-.072 5-4a1 1 0 0 0-1.147-1.634l-.103.072L190 129.72l-4.375-3.501a1.001 1.001 0 0 0-1.321.063l-.085.093c-.318.398-.283.965.063 1.321l.093.085 5 4a1 1 0 0 0 1.147.072Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "m190.522 126.853.103-.072 5-4a1 1 0 0 0-1.147-1.634l-.103.072L190 124.72l-4.375-3.501a1.001 1.001 0 0 0-1.321.063l-.085.093c-.318.398-.283.965.063 1.321l.093.085 5 4a1 1 0 0 0 1.147.072Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#4C9AFF",
        d: "m190.522 121.853.103-.072 5-4a1 1 0 0 0-1.147-1.634l-.103.072L190 119.72l-4.375-3.501a1.001 1.001 0 0 0-1.321.063l-.085.093c-.318.398-.283.965.063 1.321l.093.085 5 4a1 1 0 0 0 1.147.072Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "DetailsPanelA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M178 230h16v16h-16z"
    }))));
};

});

parcelRegister("4iJNa", function(module, exports) {

$parcel$export(module.exports, "Header", function () { return $321c5d3536496463$export$8b251419efc915eb; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $9ram4 = parcelRequire("9ram4");
var $321c5d3536496463$export$8b251419efc915eb = function Header() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Wrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($321c5d3536496463$var$Image, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9ram4.Line), null));
};
var $321c5d3536496463$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: "1279",
        height: "56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 0h1279v56H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#HeaderA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M52 16h57v24H52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M81.172 20.6h2.124v10.498c0 2.768-1.263 4.7-4.194 4.7-1.102 0-1.963-.182-2.554-.39v-2.012c.645.261 1.425.392 2.204.392 1.802 0 2.42-1.045 2.42-2.56V20.6ZM87.195 19.79c.833 0 1.425.497 1.425 1.385 0 .862-.592 1.384-1.425 1.384-.834 0-1.425-.496-1.425-1.384 0-.862.591-1.384 1.425-1.384Zm-1.049 4.414h2.044v11.49h-2.044v-11.49ZM93.244 35.694h-1.99v-11.49h1.99v2.01c.7-1.357 1.882-2.323 4.195-2.193v1.933c-2.608-.261-4.195.496-4.195 2.95v6.79ZM106.983 33.631c-.752 1.515-2.177 2.298-4.006 2.298-3.145 0-4.732-2.585-4.732-5.98 0-3.238 1.667-5.98 4.974-5.98 1.721 0 3.065.757 3.764 2.246v-2.01h2.044v11.49h-2.044V33.63Zm-3.468.47c1.828 0 3.442-1.123 3.442-3.682v-.914c0-2.559-1.479-3.682-3.227-3.682-2.285 0-3.468 1.462-3.468 4.126.027 2.768 1.156 4.152 3.253 4.152Z",
        fill: "#253858"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M70.498 18.25h-9.303c0 2.246 1.882 4.074 4.194 4.074h1.721v1.593c0 2.246 1.882 4.074 4.195 4.074v-8.958c0-.444-.35-.783-.807-.783Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M65.9 22.742h-9.302c0 2.245 1.882 4.073 4.194 4.073h1.72v1.62c0 2.245 1.883 4.073 4.195 4.073v-8.983a.797.797 0 0 0-.807-.783Z",
        fill: "url(#HeaderB)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M61.303 27.26H52c0 2.245 1.882 4.073 4.194 4.073h1.721v1.593c0 2.246 1.882 4.074 4.194 4.074v-8.957c0-.444-.376-.784-.806-.784Z",
        fill: "url(#HeaderC)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M133 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M140.5 28a3 3 0 0 1 3-3h65a3 3 0 1 1 0 6h-65a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M137 54a1 1 0 0 1 1-1h76a1 1 0 0 1 1 1v2h-78v-2Z",
        fill: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M227 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        d: "M231 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: ".6",
        clipPath: "url(#HeaderD)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M301 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M301.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z",
        fill: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M321 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        d: "M325 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: ".6",
        clipPath: "url(#HeaderE)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M395 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium large",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M395.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z",
        fill: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M415 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M422.5 28a3 3 0 0 1 3-3h65a3 3 0 1 1 0 6h-65a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M509 0h86v56h-86z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M513 28a3 3 0 0 1 3-3h58a3 3 0 1 1 0 6h-58a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        opacity: ".6",
        clipPath: "url(#HeaderF)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M583 18h8v20h-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M583.292 26.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.986.986 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.995.995 0 0 0-1.084-.217.995.995 0 0 0-.322.217Z",
        fill: "#344563"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        d: "M235 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
        fill: "#B3D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "small",
        d: "M243 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        d: "M423 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
        fill: "#B3D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "medium",
        d: "M431 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M611 15a3 3 0 0 1 3-3h55a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-55a3 3 0 0 1-3-3V15Z",
        fill: "#B3D4FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "large",
        d: "M619 28a3 3 0 0 1 3-3h38a3 3 0 1 1 0 6h-38a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M18 16h24v24H18z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M22 21.01c0-.559.443-1.01 1.01-1.01h1.98c.559 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6-6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm0 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm-12 6c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .559-.443 1.01-1.01 1.01h-1.98c-.559 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Zm6 0c0-.558.443-1.01 1.01-1.01h1.98c.558 0 1.01.443 1.01 1.01v1.98c0 .558-.443 1.01-1.01 1.01h-1.98c-.558 0-1.01-.443-1.01-1.01v-1.98Z",
        fill: "#A5ADBA"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(52 16)",
        d: "M0 0h57v24H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderD"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(301 18)",
        d: "M0 0h8v20H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderE"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(395 18)",
        d: "M0 0h8v20H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "HeaderF"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        transform: "translate(583 18)",
        d: "M0 0h8v20H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "HeaderB",
        x1: "66.509",
        y1: "22.764",
        x2: "62.673",
        y2: "26.838",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".176",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "HeaderC",
        x1: "62.17",
        y1: "27.289",
        x2: "57.727",
        y2: "31.741",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".176",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    }))));
};

});

parcelRegister("hEU6f", function(module, exports) {

$parcel$export(module.exports, "IssueActions", function () { return $cdb1b056509ee0dd$export$8f0a14bb9a7ce353; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $cdb1b056509ee0dd$export$8f0a14bb9a7ce353 = function IssueActions() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($cdb1b056509ee0dd$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($cdb1b056509ee0dd$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $cdb1b056509ee0dd$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    right: 0
});
var $cdb1b056509ee0dd$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: "359",
        height: "88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M153 31a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-26a3 3 0 0 1-3-3V31Z",
        fill: "#fff",
        fillOpacity: ".01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M163 36c2.209 0 4 1.792 4 4.002V42h5.991c1.11 0 2.009.887 2.009 2v6c0 1.105-.902 2-2.009 2h-7.982A1.999 1.999 0 0 1 163 50v-6c0-1.102.898-1.996 2-2v-1.998A2.001 2.001 0 0 0 163 38c-1.102 0-2 .898-2 2.002V43h-2v-2.998A4.004 4.004 0 0 1 163 36Zm6 9a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M185 31a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-26a3 3 0 0 1-3-3V31Z",
        fill: "#fff",
        fillOpacity: ".01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M189 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M201 50c-4.536 0-7.999-4.26-7.999-6 0-2.001 3.459-6 8-6 4.376 0 7.998 3.973 7.998 6 0 1.74-3.462 6-7.998 6H201Zm.001-14C195.48 36 191 40.841 191 44c0 3.086 4.576 8 10 8 5.423 0 10-4.914 10-8 0-3.159-4.48-8-10-8",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M200.977 45.984c-1.103 0-2-.897-2-2s.897-2 2-2c1.104 0 2 .897 2 2s-.896 2-2 2Zm0-6c-2.206 0-4 1.794-4 4s1.794 4 4 4c2.207 0 4-1.794 4-4s-1.793-4-4-4Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M217 31a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-26a3 3 0 0 1-3-3V31Z",
        fill: "#fff",
        fillOpacity: ".01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M221 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M225 44v7a.97.97 0 0 0 .278.704.999.999 0 0 0 .701.296H227v-9h-1.02a.988.988 0 0 0-.912.62.97.97 0 0 0-.068.38Zm15.281-.96a3.042 3.042 0 0 0-2.321-1.061h-2.634c.04-.181.08-.36.11-.532.515-2.934 0-4-.504-4.594a2.43 2.43 0 0 0-1.857-.853 3.079 3.079 0 0 0-2.968 2.751c-.393 1.839-.454 2-.968 2.725l-.768 1.089a2.009 2.009 0 0 0-.363 1.141v6.273c.001.532.216 1.041.596 1.416s.896.585 1.433.584h7.247a3.014 3.014 0 0 0 2.997-2.507l.677-4a2.967 2.967 0 0 0-.677-2.432Zm-1.998 6.1a1.01 1.01 0 0 1-1 .835h-7.245v-6.269l.767-1.089a7.575 7.575 0 0 0 1.302-3.509c.036-.543.255-1.209.969-1.108.714.1.575 1.916.363 3.1a19.698 19.698 0 0 1-.868 2.882l5.39-.008c.297-.001.58.128.773.352a.994.994 0 0 1 .226.813l-.676 4.001h-.001Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M249 31a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-26a3 3 0 0 1-3-3V31Z",
        fill: "#fff",
        fillOpacity: ".01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M253 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M259 47a2.998 2.998 0 0 0 3-3 2.999 2.999 0 0 0-5.121-2.121A2.999 2.999 0 0 0 259 47Zm0-2a1 1 0 1 1 0-1.999A1 1 0 0 1 259 45Zm12-4a2.998 2.998 0 0 0 3-3 2.999 2.999 0 0 0-5.121-2.121A2.999 2.999 0 0 0 271 41Zm0-2a1 1 0 1 1 0-1.999A1 1 0 0 1 271 39Zm0 14a2.998 2.998 0 0 0 3-3 2.999 2.999 0 0 0-5.121-2.121A2.999 2.999 0 0 0 271 53Zm0-2a1 1 0 1 1 0-1.999A1 1 0 0 1 271 51Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m260 45.562 8.66 5 1-1.732-8.66-5-1 1.732Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "m260 42.83 1 1.732 8.66-5-1-1.732-8.66 5Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M287 31a3 3 0 0 1 3-3h26a3 3 0 0 1 3 3v26a3 3 0 0 1-3 3h-26a3 3 0 0 1-3-3V31Z",
        fill: "#fff",
        fillOpacity: ".01"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M291 32h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M296 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM303 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM310 46a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
        fill: "#C1C7D0"
    }));
};

});

parcelRegister("2LEqR", function(module, exports) {

$parcel$export(module.exports, "IssueBreadcrumbs", function () { return $203f558ac5478e05$export$3719fea556ec58e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $203f558ac5478e05$export$3719fea556ec58e8 = function IssueBreadcrumbs() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($203f558ac5478e05$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($203f558ac5478e05$var$Image, null));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $203f558ac5478e05$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT), "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH), "px")
});
var $203f558ac5478e05$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        width: "320",
        height: "88",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "M32 44a3 3 0 0 1 3-3h94a3 3 0 1 1 0 6H35a3 3 0 0 1-3-3ZM145 44a3 3 0 0 1 3-3h48a3 3 0 1 1 0 6h-48a3 3 0 0 1-3-3Z",
        fill: "#091E42",
        fillOpacity: ".13"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        d: "m137.372 51.105 3.548-12.44h-1.299l-3.541 12.44h1.292Z",
        fill: "#6B778C"
    }));
};

});

parcelRegister("dA3G2", function(module, exports) {

$parcel$export(module.exports, "IssueContent", function () { return $028d2f70d47d7dc8$export$67cacc4c013d8d8a; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/prefer-primitives */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $d2jyZ = parcelRequire("d2jyZ");
var $028d2f70d47d7dc8$export$67cacc4c013d8d8a = function IssueContent() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($028d2f70d47d7dc8$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($028d2f70d47d7dc8$var$ImageWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($028d2f70d47d7dc8$var$Image, null)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $028d2f70d47d7dc8$var$Wrapper = (0, $3XNKR.default).div({
    position: "fixed",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    top: "".concat((0, $d2jyZ.HEADER_HEIGHT) + 88, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    left: "".concat((0, $d2jyZ.SECONDARY_NAV_WIDTH) + 24, "px"),
    right: "400px",
    height: "80%"
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var $028d2f70d47d7dc8$var$ImageWrapper = (0, $3XNKR.default).div({
    display: "flex",
    justifyContent: "center"
});
var $028d2f70d47d7dc8$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "739",
        height: "429",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "580.385",
        height: "20",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "60",
        height: "32",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "8",
        y: "57",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "99",
        height: "32",
        x: "68",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "83",
        height: "6",
        x: "76",
        y: "57",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "99",
        height: "32",
        x: "175",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "59",
        height: "6",
        x: "183",
        y: "57",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M245 48h24v24h-24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C1C7D0",
        fillRule: "evenodd",
        d: "M253.292 58.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.008 1.008 0 0 0-.322-1.637.987.987 0 0 0-1.084.218l-2.298 2.317-2.307-2.327a.997.997 0 0 0-.703-.293.99.99 0 0 0-.703.293Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "60",
        height: "32",
        x: "282",
        y: "44",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "290",
        y: "57",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "738.462",
        height: "12",
        y: "100",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "738.462",
        height: "12",
        y: "128",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "347.308",
        height: "12",
        y: "156",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "130.385",
        height: "12",
        y: "210",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "52",
        height: "20",
        y: "234",
        fill: "#EBECF0",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "4",
        y: "241",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "85",
        height: "20",
        x: "60",
        y: "234",
        fill: "#7A869A",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "77",
        height: "6",
        x: "64",
        y: "241",
        fill: "#EBECF0",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "52",
        height: "20",
        x: "153",
        y: "234",
        fill: "#EBECF0",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "157",
        y: "241",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "52",
        height: "20",
        x: "213",
        y: "234",
        fill: "#EBECF0",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "44",
        height: "6",
        x: "217",
        y: "241",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#IssueContentA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#B2D4FF",
        d: "M5.118 300c0 8.772 7.11 15.882 15.882 15.882 8.771 0 15.882-7.11 15.882-15.882 0-8.771-7.11-15.882-15.882-15.882-8.771 0-15.882 7.111-15.882 15.882Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#2684FF",
        d: "m14.362 309.157 3.61 2.488c2.798 1.931 6.66.866 8.074-2.227l.059-.13.514.302 2.965 1.741c.496.289.919.681 1.244 1.141a15.81 15.81 0 0 1-9.825 3.41 15.825 15.825 0 0 1-11.454-4.887c1.37-.832 3.095-1.462 4.695-1.922l.12.082-.002.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#4C9AFF",
        d: "m27.067 295.141-.03-.069.023.033a.186.186 0 0 0 .01.039l-.003-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#IssueContentB)",
        d: "M17.216 307.404v-4.488c.75 1.349 1.503 2.478 1.933 2.657.192.097.39.192.589.282a21.44 21.44 0 0 0 2.603.96c.582.174 1.032.284 1.214.309.264.041.514.093.755.123v.845l2.307 1.498-.515-.302-.059.13c-1.413 3.09-5.276 4.158-8.074 2.227l-3.61-2.488 2.855-1.753h.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#FFE5D4",
        d: "M22.341 306.815a21.44 21.44 0 0 1-2.603-.96c-.2-.09-.397-.185-.589-.282-.43-.179-1.183-1.308-1.933-2.657-.11-.2-.222-.405-.33-.612-.394-.138-.783-.433-1.124-.819-.786-.968-1.303-2.806-.573-3.441 1.213-1.055 2.086.31 2.086.31l.018.095c-.522 1.751-.148 2.867.433 3.878.12.207.248.412.379.617.007.033.015.067.025.1v-.062l-.025-.041a9.958 9.958 0 0 1-.157-.719 4.284 4.284 0 0 1-.05-1.262c.117-.986.68-1.961 2.137-3.11 1.385-.689 2.867-3.766 3.377-4.903a3.953 3.953 0 0 1 2.785.942l.26.226a5.72 5.72 0 0 1 .608 1.029c.42.911.68 2.104.463 3.602a7.421 7.421 0 0 1-.105.581c-.118.542.4.694.364 1.712-.041 1.114-1.014 2.532-1.255 3.538-.01.067-.025.11-.025.11s-.006.003-.006.006v.005c-.463 2.501-1.22 2.683-2.19 2.552-.239-.033-.492-.085-.756-.123a11.495 11.495 0 0 1-1.214-.31v-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#172B4D",
        d: "M18.13 303.044a1.217 1.217 0 0 0-.025-.1l.025.041v.061-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#172B4D",
        d: "M27.067 295.141s-.005-.025-.01-.038l-.023-.034a5.974 5.974 0 0 0-.576-.96l-.261-.225a3.922 3.922 0 0 0-2.785-.942c-.51 1.137-1.992 4.214-3.377 4.902-1.457 1.15-2.017 2.125-2.138 3.111-.05.415-.023.832.052 1.262.04.235.092.474.156.719-.13-.204-.259-.409-.38-.617-.58-1.011-.954-2.127-.432-3.878l-.018-.095s-.87-1.364-2.086-.31c-.732.635-.213 2.476.573 3.441.34.387.73.681 1.124.819.11.208.22.412.33.612v4.291a3.816 3.816 0 0 1-5.675-2.65 3.815 3.815 0 0 1 1.85-3.953l-.12-.046c-.94-4.108.315-8.038 2.376-9.451 1.441-.988 2.79-1.551 4.175-1.69l-.012-.013s.03 0 .079.006c.952-.085 1.925.033 2.96.353.42.13.81.322 1.174.555.407.187 1.664.725 1.81.817a.34.34 0 0 0 .049.026c1.551.962 2.78 2.447 2.744 4.736-.064 4.083.88 4.976 1.557 5.829.676.855.292 1.963-.704 1.812 0 0 .975-.258-.023-1.341-.64-.694-1.454-1.925-1.925-3.451.217-1.495-.044-2.691-.464-3.602v.005Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "591",
        height: "40",
        x: "46",
        y: "281",
        fill: "#F4F5F7",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "54",
        y: "297",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "423",
        height: "6",
        x: "44",
        y: "387",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "266",
        height: "6",
        x: "44",
        y: "405",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "266",
        height: "6",
        x: "44",
        y: "423",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "119",
        height: "6",
        x: "44",
        y: "358",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#IssueContentC)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#C0B6F2",
        d: "M15.939 354.064h-.003C7.135 354.064 0 361.199 0 370v.003c0 8.801 7.135 15.936 15.936 15.936h.003c8.8 0 15.936-7.135 15.936-15.936V370c0-8.801-7.135-15.936-15.936-15.936Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "url(#IssueContentD)",
        d: "M20.8 375.67c-.4-.378-.648-.89-.686-1.449-.568.525-1.526 1.158-2.176 1.598a2.957 2.957 0 0 1-3.044.151c-.942-.51-2.49-1.316-2.806-1.843l.02.325a2.216 2.216 0 0 1-.673 1.736c.395 1.797 4.199 5.872 4.944 6.658.653-.814 4.219-5.348 4.421-7.178v.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#5243AA",
        d: "M23.862 377.775c.01.015.02.025.03.041l-7.48 5.068.095.098-.128-.074-.103.069s.026-.034.07-.087l-8.093-4.731-2.995 1.346a6.115 6.115 0 0 0-1.367.853c2.924 3.415 7.26 5.581 12.106 5.581 4.857 0 9.201-2.174 12.125-5.599a5.798 5.798 0 0 0-.451-.259l-3.812-2.304.003-.002Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#6554C0",
        d: "m16.348 382.887-.069.087.102-.069.128.074-.094-.097 7.48-5.069c-.01-.015-.02-.025-.03-.041-1.793-2.452-3.06-2.12-3.06-2.12v.016c-.202 1.83-3.768 6.364-4.421 7.178-.745-.786-4.552-4.861-4.943-6.658 0-.011-.006-.021-.008-.031 0 0-1.6-.274-3.22 1.971l.048.028 8.092 4.731h-.005Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#D8AB87",
        d: "M21.386 369.898c-.03.348-.092.768-.171 1.203.489-.023.62-.346.824-1.081.207-.747.476-2.467-.297-2.813a26.315 26.315 0 0 1-.307 2.104c-.015.197-.033.395-.049.587Zm-10.936-2.12c-.72.43-.284 2.104-.005 2.824.23.591.381.906.706.978-.12-.418-.22-.82-.284-1.158-.159-.852-.333-1.769-.42-2.647l.003.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#E8BB9C",
        d: "M14.894 375.97a2.957 2.957 0 0 0 3.044-.151c.65-.44 1.608-1.073 2.176-1.598.22-.202.384-.391.445-.542.195-.479.471-1.57.656-2.576.08-.435.14-.855.171-1.203.016-.192.034-.389.049-.586-.064.346-.113.558-.113.558l-.292.361s.65-1.925-.35-3.021c-1.001-1.095-.643-3.927-.835-4.055-1.17-1.666-2.583-.028-3.883-.123l-.315.016c-1.283.225-2.926-1.303-3.853.512-.18.146.61 2.918-.277 4.111-.885 1.19-.048 3.041-.048 3.041l-.325-.33s-.42-1.275-.704-2.714c.002.036.007.075.01.111.09.878.261 1.794.42 2.647.064.335.164.739.284 1.157.284.99.673 2.063.916 2.521l.018.026c.315.527 1.864 1.334 2.806 1.843v-.005Zm.765-4.219.515.09.115-.011.371-.13s1.634-.013 1.915.783c0 0-.274.098-.747.11-.161.005-.225-.082-.474-.076-.701.017-1.031.084-1.031.084s-.228-.046-1.199-.046c-.41 0-.59.118-.798.136-.282.02-.515-.059-.515-.059.051-.858 1.846-.878 1.846-.878l.002-.003Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#4A3222",
        d: "m11.144 370.379.325.33s-.84-1.851.048-3.041c.886-1.191.098-3.963.277-4.112.924-1.812 2.568-.286 3.853-.512l.315-.015c1.3.095 2.713-1.544 3.883.123.192.128-.166 2.959.835 4.055 1 1.096.35 3.021.35 3.021l.292-.361s.046-.215.113-.558c.092-.497.223-1.267.307-2.105.067-.66.105-1.354.072-1.978.115-5.958-4.6-6.07-6.106-5.958-1.51.036-6.233.623-5.514 6.557.028.583.125 1.226.246 1.838.284 1.438.704 2.713.704 2.713v.003Zm2.67 2.25s.233.082.514.059c.208-.015.39-.136.799-.136.97 0 1.198.046 1.198.046s.33-.064 1.032-.084c.246-.008.312.079.473.077.474-.013.748-.11.748-.11-.282-.794-1.915-.784-1.915-.784l-.371.131-.115.01-.515-.09s-1.795.021-1.846.879l-.002.002Z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "IssueContentB",
        x1: "26.617",
        x2: "13.824",
        y1: "307.764",
        y2: "307.764",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        stopColor: "#F2D1BB"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: "1",
        stopColor: "#FFE5D4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("linearGradient", {
        id: "IssueContentD",
        x1: "15.897",
        x2: "16.201",
        y1: "384.248",
        y2: "372.497",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".23",
        stopColor: "#E8BB9C"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("stop", {
        offset: ".96",
        stopColor: "#D8AB87"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "IssueContentA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M5 284h32v32H5z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "IssueContentC"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M0 354h32v32H0z"
    }))));
};

});

parcelRegister("h927Q", function(module, exports) {

$parcel$export(module.exports, "SecondaryNav", function () { return $c7b4ecfdf7699022$export$b982c89a8be501e8; });
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $2Md0t = parcelRequire("2Md0t");
var $c7b4ecfdf7699022$export$b982c89a8be501e8 = function SecondaryNav() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2Md0t.SecondaryNavWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($c7b4ecfdf7699022$var$Image, null));
};
var $c7b4ecfdf7699022$var$Image = function Image() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "240",
        height: "777",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#F4F5F7",
        d: "M0 0h240v777H0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("g", {
        clipPath: "url(#SecondaryNavA)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 88h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "84",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "97",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 132h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "128",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "141",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 176h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "172",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "185",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "208",
        height: "40",
        x: "16",
        y: "212",
        fill: "#091E42",
        fillOpacity: ".04",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        fillOpacity: ".01",
        d: "M26 220h24v24H26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "32",
        height: "32",
        x: "22",
        y: "216",
        fill: "#091E42",
        fillOpacity: ".08",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "71",
        height: "6",
        x: "66",
        y: "229",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "40",
        height: "40",
        x: "18",
        y: "24",
        fill: "#DEEBFF",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "97",
        height: "12",
        x: "66",
        y: "29",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("rect", {
        width: "141",
        height: "6",
        x: "66",
        y: "53",
        fill: "#091E42",
        fillOpacity: ".13",
        rx: "3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("clipPath", {
        id: "SecondaryNavA"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement("path", {
        fill: "#fff",
        d: "M16 80h208v172H16z"
    }))));
};

});




parcelRegister("7lF7s", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a8b0e9f29199c84$export$2e2bcd8739ae039; });

var $dyyb1 = parcelRequire("dyyb1");

var $ebKJK = parcelRequire("ebKJK");

var $i4z5N = parcelRequire("i4z5N");

var $b2Jk5 = parcelRequire("b2Jk5");
const $6a8b0e9f29199c84$export$29decb186c8152a6 = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($dyyb1))), (0, (/*@__PURE__*/$parcel$interopDefault($ebKJK))));
const $6a8b0e9f29199c84$var$OpsgenieCobranding = {
    background: $6a8b0e9f29199c84$export$29decb186c8152a6,
    logo: {
        component: (0, $i4z5N.OpsgenieLogo)
    },
    footerProducts: "Opsgenie, Jira, Confluence"
};
var $6a8b0e9f29199c84$export$2e2bcd8739ae039 = $6a8b0e9f29199c84$var$OpsgenieCobranding;

});
parcelRegister("dyyb1", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "opsgenie-left.49c0f64b.svg";

});

parcelRegister("ebKJK", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "opsgenie-right.77c52ee2.svg";

});

parcelRegister("i4z5N", function(module, exports) {

$parcel$export(module.exports, "OpsgenieLogo", function () { return $d283d258afa642f3$export$a1c6484cdecc2c4b; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $d283d258afa642f3$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 154 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M11.78 28.127c-.785.578-1.198.537-1.983-.041-3.801-2.727-7.313-5.826-9.668-9.049-.248-.33-.124-.785.248-.991l4.297-2.686q.558-.372.991.124c1.653 1.9 3.264 3.76 5.124 5.082 1.859-1.322 3.47-3.181 5.123-5.082q.435-.495.992-.124l4.297 2.686c.371.206.495.66.247.991-2.355 3.223-5.867 6.322-9.668 9.09m-.99-11.857c3.388 0 6.197-2.768 6.197-6.156s-2.81-6.239-6.197-6.239-6.198 2.81-6.198 6.239c0 3.43 2.727 6.156 6.198 6.156"/>\n      <path fill="').concat(colors.textColor, '" d="M146.689 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zM133.385 6.16c0-1.166.767-1.84 1.841-1.84s1.84.674 1.84 1.84-.767 1.84-1.84 1.84c-1.074 0-1.841-.675-1.841-1.84m.491 19.38V10.208h2.638v15.334zm-3.677-8.984v8.985h-2.638V16.28c0-2.76-1.104-3.987-3.618-3.987-2.454 0-4.14 1.625-4.14 4.723v8.525h-2.638V10.208h2.638v2.514c.981-1.81 2.79-2.821 4.845-2.821 3.527 0 5.551 2.423 5.551 6.655m-22.921-4.263c-2.791 0-4.201 1.81-4.477 4.477h8.556c-.154-2.852-1.442-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.25-3.312-8.25-8.004 0-4.631 2.576-7.943 7.238-7.943 4.722 0 6.624 3.281 6.624 7.943v1.196h-11.194c.368 2.606 2.055 4.293 5.674 4.293 1.778 0 3.281-.337 4.661-.828zm-18.639-.614v-1.533c-.981 2.024-2.821 3.067-5.182 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.378-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.834 0 5.152-2.055 5.152-4.907m-8.678-6.44c0 3.68 1.472 5.52 4.2 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.508 1.963-4.508 5.52m-4.703 3.497c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.17-.52-5.336-1.134v-2.79c1.319.766 3.527 1.502 5.459 1.502 2.024 0 3.066-.828 3.066-2.024 0-1.165-.89-1.84-3.802-2.545-3.404-.829-4.846-2.147-4.846-4.662 0-2.668 2.055-4.293 5.55-4.293 1.994 0 3.804.49 4.938 1.104v2.73c-1.84-.92-3.342-1.411-4.968-1.411-1.932 0-2.974.674-2.974 1.87 0 1.073.736 1.748 3.557 2.423 3.404.828 5.121 2.085 5.121 4.753m-16.274-3.496c0-3.68-1.472-5.52-4.202-5.52-2.36 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.509-1.962 4.509-5.52m-3.803 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.637V10.207h2.637v2.76c.981-2.024 2.821-3.066 5.183-3.066 4.079 0 6.133 3.465 6.133 7.973 0 4.324-2.147 7.973-6.44 7.973m-20.121 0c-6.225 0-9.721-4.293-9.721-10.426 0-6.072 3.496-10.335 9.721-10.335 6.195 0 9.69 4.263 9.69 10.335 0 6.133-3.495 10.426-9.69 10.426m0-18.124c-4.968 0-6.961 3.527-6.961 7.698 0 4.262 1.993 7.789 6.961 7.789 4.937 0 6.93-3.527 6.93-7.79 0-4.17-1.993-7.697-6.93-7.697" />\n    </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '<svg viewBox="0 0 133 32" height="32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n      <defs>\n        <linearGradient id="'.concat(id, '-1" x1="50%" x2="50%" y1="0%" y2="100%">\n          <stop\n            offset="0%"\n            stop-color="').concat(colors.iconGradientStop, '"\n          />\n          <stop\n            offset="82%"\n            stop-color="').concat(colors.iconGradientStart, '"\n            ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", '\n          />\n        </linearGradient>\n        <linearGradient id="').concat(id, '-2" x1="7.133%" x2="50%" y1="13.352%" y2="58.228%">\n          <stop\n            offset="0%"\n            stop-color="').concat(colors.iconGradientStop, '"\n          />\n          <stop\n            stop-color="').concat(colors.iconGradientStart, '"\n            ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", '\n            offset="100%"\n          />\n        </linearGradient>\n      </defs>\n      <g fill-rule="evenodd">\n        <path fill="').concat(colors.textColor, '" fill-rule="nonzero" d="M27,14.9963259 C27,9.84140338 29.9575,6.22438088 35.2484675,6.22438088 C40.539435,6.22438088 43.4880625,9.84436088 43.4880625,14.9963259 C43.4880625,20.1985684 40.5305625,23.8422084 35.263255,23.8422084 C29.9959475,23.8422084 27,20.1956109 27,14.9963259 Z M29.34234,14.9963259 C29.34234,18.6133484 31.03403,21.6063384 35.25734,21.6063384 C39.48065,21.6063384 41.1220625,18.6133484 41.1220625,14.9963259 C41.1220625,11.4473259 39.4303725,8.46320838 35.239595,8.46320838 C31.0488175,8.46320838 29.34234,11.4561984 29.34234,14.9963259 Z M48.7050925,21.2928434 L48.7050925,28.6570184 L46.466265,28.6570184 L46.466265,10.5719059 L48.7050925,10.5719059 L48.7050925,12.9142459 C49.53615,11.1959384 51.1006675,10.3116459 53.102895,10.3116459 C56.56317,10.3116459 58.308095,13.2514009 58.308095,17.0754484 C58.308095,20.7457059 56.486275,23.8422084 52.842635,23.8422084 C50.94392,23.8422084 49.4858725,22.9845334 48.7050925,21.2928434 Z M52.50548,12.3937259 C50.500295,12.3937259 48.7050925,13.6684084 48.7050925,16.5578859 L48.7050925,17.5989259 C48.7050925,20.4854459 50.3435475,21.7601284 52.2540925,21.7601284 C54.77684,21.7601284 56.07814,20.0950559 56.07814,17.0754484 C56.0692675,13.9552859 54.8212025,12.3937259 52.50548,12.3937259 Z M64.99796,23.8422084 C63.4334449,23.8787499 61.881995,23.5496237 60.46707,22.8810209 L60.46707,20.5150209 C61.8881071,21.303432 63.4771215,21.740487 65.1014725,21.7897034 C66.81978,21.7897034 67.7040725,21.0887759 67.7040725,20.0713959 C67.7040725,19.0540159 66.94991,18.5098359 64.47744,17.9124209 C61.5879625,17.2085359 60.3635575,16.0906009 60.3635575,13.9582434 C60.3635575,11.6927984 62.1084825,10.3146034 65.074855,10.3146034 C66.5257548,10.2930388 67.96137,10.6131901 69.2656325,11.2491734 L69.2656325,13.5678534 C67.7040725,12.7870734 66.42939,12.3848534 65.0482375,12.3848534 C63.4097825,12.3848534 62.52549,12.9556509 62.52549,13.9730309 C62.52549,14.8839409 63.1495225,15.4517809 65.5450975,16.0284934 C68.4316175,16.7294209 69.889665,17.8029934 69.889665,20.0625234 C69.889665,22.2037534 68.4848525,23.8422084 64.99796,23.8422084 Z M81.7581125,21.2396084 C80.9240975,22.9579159 79.3625375,23.8422084 77.3573525,23.8422084 C73.923695,23.8422084 72.2053875,20.9024534 72.2053875,17.0754484 C72.2053875,13.4081484 74.00059,10.3116459 77.62057,10.3116459 C79.519285,10.3116459 80.9773325,11.1693209 81.76107,12.8610109 L81.76107,10.5719059 L83.9466625,10.5719059 L83.9466625,22.4019059 C83.9466625,26.2289109 82.15146,28.8048934 77.49044,28.8048934 C75.9171438,28.849884 74.3485221,28.6124873 72.858995,28.1039659 L72.858995,25.9154159 C74.315222,26.4191931 75.8431618,26.6848349 77.38397,26.7021109 C80.63722,26.7021109 81.7581125,24.9601434 81.7581125,22.5379509 L81.7581125,21.2396084 Z M77.957725,21.7601284 C79.9599525,21.7601284 81.7581125,20.4854459 81.7581125,17.5989259 L81.7581125,16.5578859 C81.7581125,13.6684084 80.1167,12.3937259 78.2091125,12.3937259 C75.6834075,12.3937259 74.3821075,14.0587984 74.3821075,17.0754484 C74.39098,20.1956109 75.6420025,21.7601284 77.957725,21.7601284 Z M93.5467075,23.8422084 C88.6786625,23.8422084 86.546305,21.0325834 86.546305,17.0399584 C86.546305,13.1094409 88.7318975,10.2998159 92.6890325,10.2998159 C96.696445,10.2998159 98.308282,13.0828234 98.308282,17.0399584 L98.308282,18.0662109 L88.8087925,18.0662109 C89.1222875,20.2784209 90.5537175,21.7098509 93.6236025,21.7098509 C94.9737094,21.7089885 96.313149,21.4707325 97.580737,21.0059659 L97.580737,23.0762159 C96.51308,23.6351834 94.874625,23.8422084 93.5467075,23.8422084 Z M88.7851325,16.1527084 L96.045795,16.1527084 C95.915665,13.7305159 94.82139,12.3523209 92.5825625,12.3523209 C90.2165625,12.3404909 89.0335625,13.8754334 88.7851325,16.1408784 L88.7851325,16.1527084 Z M112.025168,23.5819484 L109.78634,23.5819484 L109.78634,15.7238709 C109.78634,13.3815309 108.848813,12.3404909 106.716455,12.3404909 C104.646205,12.3404909 103.202945,13.7186859 103.202945,16.3479034 L103.202945,23.5819484 L100.964118,23.5819484 L100.964118,10.5689484 L103.202945,10.5689484 L103.202945,12.7013059 C104.015399,11.1952365 105.603045,10.2712035 107.31387,10.3086884 C110.30686,10.3086884 112.025168,12.3789384 112.025168,15.9545559 L112.025168,23.5819484 Z M116.29284,5.57373088 C116.715541,5.54348282 117.130549,5.69826386 117.430208,5.99792296 C117.729867,6.29758207 117.884648,6.71258978 117.8544,7.13529088 C117.8544,7.99771665 117.155266,8.69685088 116.29284,8.69685088 C115.430414,8.69685088 114.73128,7.99771665 114.73128,7.13529088 C114.701032,6.71258978 114.855813,6.29758207 115.155472,5.99792296 C115.455131,5.69826386 115.870139,5.54348282 116.29284,5.57373088 Z M115.148287,10.5719059 L117.387115,10.5719059 L117.387115,23.5849059 L115.148287,23.5849059 L115.148287,10.5719059 Z M127.510637,23.8422084 C122.642592,23.8422084 120.510235,21.0325834 120.510235,17.0399584 C120.510235,13.1094409 122.695827,10.2998159 126.650005,10.2998159 C130.657417,10.2998159 132.269255,13.0828234 132.269255,17.0399584 L132.269255,18.0662109 L122.772722,18.0662109 C123.086217,20.2784209 124.517647,21.7098509 127.587532,21.7098509 C128.937639,21.7089885 130.277079,21.4707325 131.544667,21.0059659 L131.544667,23.0762159 C130.47701,23.6351834 128.838555,23.8422084 127.510637,23.8422084 Z M122.749062,16.1408784 L130.012682,16.1408784 C129.882552,13.7186859 128.788277,12.3404909 126.54945,12.3404909 C124.177535,12.3404909 122.982705,13.8754334 122.749062,16.1408784 Z"/>\n        <circle fill="url(#').concat(id, '-1)" cx="10.055" cy="10" r="6" fill-rule="nonzero"/>\n        <path fill="url(#').concat(id, '-2)" fill-rule="nonzero" d="M9.5466546,27.8535048 C5.6443752,25.3649677 2.39856217,21.9735337 0.0835689575,17.9658651 C-0.0952202525,17.6419027 0.0222963675,17.2343451 0.346122097,17.0553085 L0.374053287,17.0553085 L4.8989053,14.8208136 C5.2162202,14.6649408 5.6000426,14.7822878 5.7759446,15.088953 C8.0603155,18.9171632 11.4349681,21.9767185 15.4680659,23.876104 C13.9786912,25.3786979 12.3282342,26.7125519 10.5465911,27.8535048 C10.2398972,28.0418894 9.8533485,28.0418894 9.5466546,27.8535048 Z"/>\n        <path fill="').concat(colors.iconColor, '" fill-rule="nonzero" d="M10.5633498,27.8535048 C14.4667513,25.3663345 17.7128569,21.9745949 20.0264354,17.9658651 C20.2034083,17.6413306 20.0894039,17.23488 19.7694685,17.0497222 L19.7359511,17.0497222 L15.2055128,14.8152274 C14.8898394,14.6599316 14.5078288,14.7774733 14.3340598,15.0833668 C12.0472876,18.9191667 8.663628,21.9817774 4.6195935,23.876104 C6.11093,25.3787865 7.7632469,26.7126296 9.5466546,27.8535048 C9.8574084,28.0488317 10.252596,28.0488317 10.5633498,27.8535048 Z"/>\n      </g>\n    </svg>');
    }
};
var $d283d258afa642f3$export$a1c6484cdecc2c4b = function OpsgenieLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Opsgenie" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        label: label,
        size: size,
        svg: $d283d258afa642f3$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("gAd27", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f614cb07a327d8e$export$2e2bcd8739ae039; });

var $2NBqT = parcelRequire("2NBqT");

var $2YZQ2 = parcelRequire("2YZQ2");

var $aGZLM = parcelRequire("aGZLM");

var $b2Jk5 = parcelRequire("b2Jk5");
const $2f614cb07a327d8e$export$f35613b2e8bb1b7f = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($2NBqT))), (0, (/*@__PURE__*/$parcel$interopDefault($2YZQ2))));
const $2f614cb07a327d8e$var$StatuspageCobranding = {
    background: $2f614cb07a327d8e$export$f35613b2e8bb1b7f,
    logo: {
        component: (0, $aGZLM.StatuspageLogo)
    },
    footerProducts: "Statuspage, Jira, Confluence"
};
var $2f614cb07a327d8e$export$2e2bcd8739ae039 = $2f614cb07a327d8e$var$StatuspageCobranding;

});
parcelRegister("2NBqT", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "statuspage-left.6c5cd6d4.svg";

});

parcelRegister("2YZQ2", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "statuspage-right.447da08b.svg";

});

parcelRegister("aGZLM", function(module, exports) {

$parcel$export(module.exports, "StatuspageLogo", function () { return $7c8dbdcce2dad620$export$bb4ae5b41b43be04; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $7c8dbdcce2dad620$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 188 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" d="M13 12.604c-3.032 0-5.98 1.37-8.39 3.489q-.373.373-.747.373c-.208 0-.416-.124-.582-.332L.25 12.562c-.167-.207-.25-.415-.25-.581 0-.25.125-.457.374-.706C4.029 8.035 8.473 6.208 13 6.208s8.971 1.827 12.626 5.067c.25.249.374.457.374.706 0 .166-.083.374-.25.581l-3.031 3.572c-.166.208-.374.332-.582.332q-.373 0-.747-.374c-2.41-2.118-5.358-3.488-8.39-3.488m0 13.374c-3.364 0-6.105-2.742-6.105-6.064S9.635 13.85 13 13.85c3.364 0 6.105 2.7 6.105 6.064s-2.74 6.063-6.105 6.063" />\n      <path fill="').concat(colors.textColor, '" d="M180.293 12.293c-2.79 0-4.201 1.81-4.477 4.477h8.556c-.153-2.852-1.441-4.477-4.079-4.477m5.888 12.635c-1.257.674-3.189.92-4.753.92-5.735 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196h-11.193c.368 2.606 2.054 4.293 5.673 4.293 1.779 0 3.281-.337 4.661-.828zm-18.638-.614v-1.533c-.981 2.024-2.821 3.067-5.183 3.067-4.048 0-6.072-3.466-6.072-7.974 0-4.324 2.116-7.973 6.379-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.698h2.576V24.16c0 4.508-2.116 7.544-7.605 7.544-2.576 0-3.987-.337-5.459-.828V28.3c1.687.552 3.435.92 5.336.92 3.833 0 5.152-2.055 5.152-4.907m-8.679-6.44c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.974 0-4.508 1.963-4.508 5.52m-16.949.001c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.906V17.26c0-3.404-1.932-4.907-4.171-4.907-2.975 0-4.508 1.963-4.508 5.52m8.679 7.667v-2.76c-.982 2.024-2.822 3.066-5.183 3.066-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.973 6.44-7.973 2.238 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-16.091-7.666c0-3.68-1.472-5.52-4.201-5.52-2.361 0-4.477 1.503-4.477 4.907v1.227c0 3.404 1.932 4.906 4.17 4.906 2.975 0 4.508-1.962 4.508-5.52m-3.802 7.974c-2.239 0-3.956-1.013-4.876-3.006v8.679h-2.638V10.207h2.638v2.76c.981-2.024 2.821-3.066 5.182-3.066 4.079 0 6.134 3.465 6.134 7.973 0 4.324-2.147 7.973-6.44 7.973m-10.56-4.477c0 2.545-1.656 4.477-5.765 4.477-2.3 0-4.171-.52-5.336-1.134v-2.79c1.318.766 3.526 1.502 5.458 1.502 2.024 0 3.067-.828 3.067-2.024 0-1.165-.889-1.84-3.803-2.545-3.404-.829-4.845-2.147-4.845-4.662 0-2.668 2.055-4.293 5.551-4.293 1.993 0 3.802.49 4.937 1.104v2.73c-1.84-.92-3.343-1.411-4.968-1.411-1.932 0-2.975.674-2.975 1.87 0 1.073.736 1.748 3.558 2.423 3.404.828 5.121 2.085 5.121 4.753m-27.598-2.177v-8.985h2.638v9.26c0 2.76 1.104 3.988 3.618 3.988 2.454 0 4.14-1.626 4.14-4.723v-8.525h2.638V25.54h-2.638v-2.515c-.981 1.81-2.79 2.821-4.845 2.821-3.527 0-5.55-2.422-5.55-6.654m-7.155 1.596c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454H85.39zm-18.943-2.914c0 3.68 1.472 5.52 4.202 5.52 2.361 0 4.477-1.503 4.477-4.906V17.26c0-3.404-1.932-4.907-4.17-4.907-2.975 0-4.509 1.963-4.509 5.52m8.679 7.667v-2.76c-.981 2.024-2.821 3.066-5.183 3.066-4.078 0-6.133-3.465-6.133-7.973 0-4.324 2.147-7.973 6.44-7.973 2.239 0 3.956 1.012 4.876 3.005v-2.699h2.637V25.54zm-17.258-4.752c0 1.349.797 2.269 2.422 2.269.614 0 1.196-.123 1.656-.215v2.546a6.3 6.3 0 0 1-1.778.245c-3.282 0-4.876-1.932-4.876-4.784v-8.188h-2.484v-2.453h2.484V6.957h2.576v3.25h4.078v2.454h-4.078zm-6.894-.798c0 3.496-2.085 5.858-7.084 5.858-3.894 0-5.704-.767-7.268-1.564v-2.822c1.871.982 4.754 1.687 7.422 1.687 3.036 0 4.17-1.196 4.17-2.975 0-1.778-1.104-2.729-4.937-3.649-4.539-1.104-6.563-2.668-6.563-5.98 0-3.128 2.392-5.459 7.084-5.459 2.914 0 4.784.706 6.164 1.472v2.76c-2.024-1.165-4.201-1.533-6.286-1.533-2.638 0-4.202.92-4.202 2.76 0 1.656 1.288 2.484 4.846 3.373 4.262 1.074 6.654 2.454 6.654 6.072" />\n    </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '<svg height="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 161 32">\n    <defs>\n      <linearGradient id="'.concat(id, '" x1="50%" x2="50%" y1="82.77%" y2="10.134%">\n        <stop offset="0%" stop-color="').concat(colors.iconGradientStop, '" />\n        <stop offset="82%" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n      </linearGradient>\n    </defs>\n    <g fill-rule="evenodd">\n      <path fill="').concat(colors.textColor, '" fill-rule="nonzero" d="M44.168,18.294 C44.168,15.226 42.14,14.056 38.526,13.146 C35.51,12.392 34.418,11.69 34.418,10.286 C34.418,8.726 35.744,7.946 37.98,7.946 C39.748,7.946 41.594,8.258 43.31,9.246 L43.31,6.906 C42.14,6.256 40.554,5.658 38.084,5.658 C34.106,5.658 32.078,7.634 32.078,10.286 C32.078,13.094 33.794,14.42 37.642,15.356 C40.892,16.136 41.828,16.942 41.828,18.45 C41.828,19.958 40.866,20.972 38.292,20.972 C36.03,20.972 33.586,20.374 32,19.542 L32,21.934 C33.326,22.61 34.86,23.26 38.162,23.26 C42.4,23.26 44.168,21.258 44.168,18.294 Z M50.018,18.892 L50.018,12.08 L53.476,12.08 L53.476,10 L50.018,10 L50.018,7.244 L47.834,7.244 L47.834,10 L45.728,10 L45.728,12.08 L47.834,12.08 L47.834,18.944 C47.834,21.362 49.186,23 51.968,23 C52.644,23 53.086,22.896 53.476,22.792 L53.476,20.634 C53.086,20.712 52.592,20.816 52.072,20.816 C50.694,20.816 50.018,20.036 50.018,18.892 Z M65.15,23 L65.15,20.66 C64.318,22.376 62.758,23.26 60.756,23.26 C57.298,23.26 55.556,20.322 55.556,16.5 C55.556,12.834 57.376,9.74 61.016,9.74 C62.914,9.74 64.37,10.598 65.15,12.288 L65.15,10 L67.386,10 L67.386,23 L65.15,23 Z M57.792,16.5 C57.792,19.62 59.04,21.18 61.354,21.18 C63.356,21.18 65.15,19.906 65.15,17.02 L65.15,15.98 C65.15,13.094 63.512,11.82 61.614,11.82 C59.092,11.82 57.792,13.484 57.792,16.5 Z M73.86,18.892 L73.86,12.08 L77.318,12.08 L77.318,10 L73.86,10 L73.86,7.244 L71.676,7.244 L71.676,10 L69.57,10 L69.57,12.08 L71.676,12.08 L71.676,18.944 C71.676,21.362 73.028,23 75.81,23 C76.486,23 76.928,22.896 77.318,22.792 L77.318,20.634 C76.928,20.712 76.434,20.816 75.914,20.816 C74.536,20.816 73.86,20.036 73.86,18.892 Z M79.918,17.618 C79.918,21.206 81.634,23.26 84.624,23.26 C86.366,23.26 87.9,22.402 88.732,20.868 L88.732,23 L90.968,23 L90.968,10 L88.732,10 L88.732,17.228 C88.732,19.854 87.302,21.232 85.222,21.232 C83.09,21.232 82.154,20.192 82.154,17.852 L82.154,10 L79.918,10 L79.918,17.618 Z M103.318,19.464 C103.318,17.202 101.862,16.136 98.976,15.434 C96.584,14.862 95.96,14.29 95.96,13.38 C95.96,12.366 96.844,11.794 98.482,11.794 C99.86,11.794 101.134,12.21 102.694,12.99 L102.694,10.676 C101.732,10.156 100.198,9.74 98.508,9.74 C95.544,9.74 93.802,11.118 93.802,13.38 C93.802,15.512 95.024,16.63 97.91,17.332 C100.38,17.93 101.134,18.502 101.134,19.49 C101.134,20.504 100.25,21.206 98.534,21.206 C96.896,21.206 95.024,20.582 93.906,19.932 L93.906,22.298 C94.894,22.818 96.48,23.26 98.43,23.26 C101.914,23.26 103.318,21.622 103.318,19.464 Z M112.262,23.26 C110.364,23.26 108.908,22.402 108.128,20.712 L108.128,28.07 L105.892,28.07 L105.892,10 L108.128,10 L108.128,12.34 C108.96,10.624 110.52,9.74 112.522,9.74 C115.98,9.74 117.722,12.678 117.722,16.5 C117.722,20.166 115.902,23.26 112.262,23.26 Z M115.486,16.5 C115.486,13.38 114.238,11.82 111.924,11.82 C109.922,11.82 108.128,13.094 108.128,15.98 L108.128,17.02 C108.128,19.906 109.766,21.18 111.664,21.18 C114.186,21.18 115.486,19.516 115.486,16.5 Z M129.136,23 L129.136,20.66 C128.304,22.376 126.744,23.26 124.742,23.26 C121.284,23.26 119.542,20.322 119.542,16.5 C119.542,12.834 121.362,9.74 125.002,9.74 C126.9,9.74 128.356,10.598 129.136,12.288 L129.136,10 L131.372,10 L131.372,23 L129.136,23 Z M121.778,16.5 C121.778,19.62 123.026,21.18 125.34,21.18 C127.342,21.18 129.136,19.906 129.136,17.02 L129.136,15.98 C129.136,13.094 127.498,11.82 125.6,11.82 C123.078,11.82 121.778,13.484 121.778,16.5 Z M143.514,21.96 L143.514,20.66 C142.682,22.376 141.122,23.26 139.12,23.26 C135.688,23.26 133.972,20.322 133.972,16.5 C133.972,12.834 135.766,9.74 139.38,9.74 C141.278,9.74 142.734,10.598 143.514,12.288 L143.514,10 L145.698,10 L145.698,21.83 C145.698,25.652 143.904,28.226 139.25,28.226 C137.066,28.226 135.87,27.94 134.622,27.524 L134.622,25.34 C136.052,25.808 137.534,26.12 139.146,26.12 C142.396,26.12 143.514,24.378 143.514,21.96 Z M136.156,16.5 C136.156,19.62 137.404,21.18 139.718,21.18 C141.72,21.18 143.514,19.906 143.514,17.02 L143.514,15.98 C143.514,13.094 141.876,11.82 139.978,11.82 C137.456,11.82 136.156,13.484 136.156,16.5 Z M159.322,22.48 C158.256,23.052 156.618,23.26 155.292,23.26 C150.43,23.26 148.298,20.452 148.298,16.474 C148.298,12.548 150.482,9.74 154.434,9.74 C158.438,9.74 160.05,12.522 160.05,16.474 L160.05,17.488 L150.56,17.488 C150.872,19.698 152.302,21.128 155.37,21.128 C156.878,21.128 158.152,20.842 159.322,20.426 L159.322,22.48 Z M154.33,11.768 C151.964,11.768 150.768,13.302 150.534,15.564 L157.788,15.564 C157.658,13.146 156.566,11.768 154.33,11.768 Z"/>\n      <circle cx="12" cy="18.923" r="5.538" fill="url(#').concat(id, ')" fill-rule="nonzero"/>\n      <path fill="').concat(colors.iconColor, '" fill-rule="nonzero" d="M0.143183246,11.470217 L3.17443341,15.0164923 C3.40520779,15.2738906 3.80165918,15.3034375 4.06900618,15.0831635 C8.96019542,10.7622319 15.0323494,10.7622319 19.9235386,15.0831635 C20.1908857,15.3034375 20.5873371,15.2738906 20.8181114,15.0164923 L23.8525794,11.470217 C24.0663737,11.214892 24.04536,10.8403265 23.8043112,10.6098404 C16.6927794,4.46338652 7.29976539,4.46338652 0.201105223,10.6098404 C-0.042871755,10.8377486 -0.0680989446,11.2124749 0.143183246,11.470217 Z"/>\n    </g>\n  </svg>');
    }
};
var $7c8dbdcce2dad620$export$bb4ae5b41b43be04 = function StatuspageLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Statuspage" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $7c8dbdcce2dad620$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("ccCNm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $42015addf7646723$export$2e2bcd8739ae039; });

var $7vwSj = parcelRequire("7vwSj");

var $3TR98 = parcelRequire("3TR98");

var $acV2m = parcelRequire("acV2m");

var $b2Jk5 = parcelRequire("b2Jk5");
const $42015addf7646723$export$7995c4de8f2b3003 = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($7vwSj))), (0, (/*@__PURE__*/$parcel$interopDefault($3TR98))));
const $42015addf7646723$var$TrelloCobranding = {
    background: $42015addf7646723$export$7995c4de8f2b3003,
    logo: {
        component: (0, $acV2m.TrelloLogo)
    },
    footerProducts: "Trello, Jira, Confluence"
};
var $42015addf7646723$export$2e2bcd8739ae039 = $42015addf7646723$var$TrelloCobranding;

});
parcelRegister("7vwSj", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "trello-left.4f52d13c.svg";

});

parcelRegister("3TR98", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "trello-right.e6e102c7.svg";

});

parcelRegister("acV2m", function(module, exports) {

$parcel$export(module.exports, "TrelloLogo", function () { return $76e744bef6fc0411$export$60e26212f3b61a28; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $76e744bef6fc0411$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        // Currently the user can style the trello icon using only iconGradientStop and iconGradientStart
        // the following is used to mimic this edge case as these two props aren't used on the new logos
        if (colors.iconColor === "inherit") colors.iconColor = iconGradientStop;
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg fill="none" height="32" viewBox="0 0 106 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">\n      <path fill="'.concat(colors.iconColor, '" clip-rule="evenodd" d="M19.157 4.67H2.585A2.585 2.585 0 0 0 0 7.255v16.572a2.585 2.585 0 0 0 2.585 2.585h16.572a2.585 2.585 0 0 0 2.584-2.585V7.255a2.585 2.585 0 0 0-2.584-2.585M9.365 20.33a.86.86 0 0 1-.858.858H4.873a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86zm8.362-4.952a.86.86 0 0 1-.858.858h-3.634a.86.86 0 0 1-.859-.858V9.543c0-.475.385-.859.859-.859h3.634c.474 0 .858.385.858.86z" fill-rule="evenodd"/>\n      <path fill="').concat(colors.textColor, '" d="M97.64 25.848c-4.6 0-7.298-3.404-7.298-8.004S93.04 9.9 97.64 9.9c4.57 0 7.238 3.342 7.238 7.942s-2.668 8.004-7.238 8.004m0-13.494c-3.281 0-4.722 2.576-4.722 5.49 0 2.913 1.44 5.55 4.722 5.55 3.251 0 4.662-2.637 4.662-5.55 0-2.914-1.411-5.49-4.662-5.49M88.874 25.51c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zm-7.996 0c-.215.062-.675.123-1.35.123-2.514 0-4.109-1.196-4.109-4.017V3.798h2.637V21.31c0 1.38.92 1.87 2.055 1.87.276 0 .46 0 .767-.03zM65.532 12.293c-2.79 0-4.202 1.81-4.478 4.477h8.556c-.153-2.852-1.44-4.477-4.078-4.477m5.888 12.635c-1.258.674-3.19.92-4.754.92-5.734 0-8.249-3.312-8.249-8.004 0-4.631 2.576-7.943 7.237-7.943 4.723 0 6.624 3.281 6.624 7.943v1.196H61.085c.368 2.606 2.055 4.293 5.673 4.293 1.78 0 3.282-.337 4.662-.828zm-19.48-8.434v9.047h-2.576V10.208h2.576v2.698c.89-1.809 2.423-3.097 5.428-2.913v2.576c-3.373-.337-5.428.675-5.428 3.925M32.943 5.393H48.03V8.03h-6.164v17.511h-2.76V8.031h-6.164z"/>\n    </svg>');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '<svg\n      viewBox="0 0 94 32"\n      height="32"\n      fill="none"\n      xmlns="http://www.w3.org/2000/svg"\n      focusable="false"\n      aria-hidden="true"\n    >\n      <defs>\n        <linearGradient\n          id="'.concat(id, '"\n          x1="9.33821"\n          y1="23.6824"\n          x2="9.33821"\n          y2="5.00599"\n          gradientUnits="userSpaceOnUse"\n        >\n          <stop stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' offset="0%" />\n          <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%" />\n        </linearGradient>\n    </defs>\n    <path\n      fill="').concat(colors.textColor, '"\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M68.749 23.7902C66.249 23.7902 64.6742 22.5776 64.6742 19.7573V5H68.5155V19.2304C68.5155 20.0477 69.0574 20.3381 69.7131 20.3381C69.9021 20.3421 70.0911 20.3331 70.2789 20.3112V23.6315C69.7788 23.7552 69.2639 23.8086 68.749 23.7902ZM38.7121 9.98505V6.37431H26.0297V9.98505H30.3051V23.6825H34.4308V9.98505H38.7121ZM40.1498 23.6825H43.9641V16.6227C43.9641 14.464 45.2276 13.8053 47.9072 14.0149V10.027C45.8443 9.89522 44.6856 10.973 43.9641 12.7904V10.2096H40.1498V23.6825ZM72.6901 19.7573C72.6901 22.5776 74.2619 23.7902 76.7619 23.7902C77.2787 23.809 77.7957 23.7556 78.2978 23.6315V20.3112C78.109 20.333 77.9189 20.342 77.7289 20.3381C77.0732 20.3381 76.5313 20.0477 76.5313 19.2304V5H72.6901V19.7573ZM80.1444 16.9402C80.1444 12.7786 82.5396 9.93129 86.6653 9.93129C90.791 9.93129 93.1353 12.7845 93.1353 16.9402C93.1353 21.0958 90.764 24 86.6653 24C82.5665 24 80.1444 21.0749 80.1444 16.9402ZM83.8809 16.9402C83.8809 18.9701 84.7312 20.5749 86.6653 20.5749C88.5994 20.5749 89.3988 18.9701 89.3988 16.9402C89.3988 14.9103 88.5724 13.3474 86.6653 13.3474C84.7581 13.3474 83.8959 14.9103 83.8959 16.9402H83.8809ZM56.2777 18.3621C55.2023 18.3538 54.1281 18.2909 53.0592 18.1734C53.4124 20.0986 54.8256 20.7692 56.8795 20.7692C58.4004 20.7692 59.8854 20.3501 61.1998 19.9309V23.1734C59.7762 23.7133 58.2642 23.9824 56.7417 23.9668C51.6131 23.9668 49.3436 21.4009 49.3436 17.0806C49.3436 12.934 51.9723 9.94 56.0801 9.94C59.1309 9.94 61.6668 12.0058 61.6668 14.7513C61.6668 17.5776 59.1968 18.3621 56.2777 18.3621ZM57.9513 14.6166C57.9513 13.6136 57.0831 12.8801 56.0022 12.8801L55.9992 12.8711C55.4963 12.8789 55.0046 13.0206 54.5746 13.2816C54.1447 13.5426 53.7921 13.9135 53.5532 14.3561C53.2546 14.9118 53.0751 15.5236 53.0262 16.1525C53.686 16.2551 54.3525 16.3081 55.0202 16.3112C56.5861 16.3112 57.9513 15.91 57.9513 14.6166Z"\n    />\n    <path\n      fill-rule="evenodd"\n      clip-rule="evenodd"\n      d="M16.4579 5H2.21854C1.63014 5 1.06585 5.23374 0.649794 5.64979C0.233738 6.06585 0 6.63014 0 7.21854V21.4669C0 22.0553 0.233738 22.6196 0.649794 23.0356C1.06585 23.4517 1.63014 23.6854 2.21854 23.6854H16.4579C17.0463 23.6854 17.6106 23.4517 18.0266 23.0356C18.4427 22.6196 18.6764 22.0553 18.6764 21.4669V7.22452C18.6772 6.93268 18.6204 6.64354 18.5093 6.37369C18.3981 6.10383 18.2348 5.85855 18.0287 5.65191C17.8227 5.44527 17.5778 5.28131 17.3083 5.16945C17.0387 5.05758 16.7497 5 16.4579 5V5ZM8.04481 18.4729C8.04481 18.6685 7.96731 18.8561 7.82927 18.9947C7.69123 19.1333 7.50391 19.2116 7.30829 19.2124H4.18558C3.98969 19.2116 3.80205 19.1334 3.66353 18.9949C3.52502 18.8564 3.44685 18.6688 3.44607 18.4729V9.19157C3.44685 8.99568 3.52502 8.80804 3.66353 8.66952C3.80205 8.53101 3.98969 8.45284 4.18558 8.45205H7.30829C7.50391 8.45285 7.69123 8.53111 7.82927 8.66971C7.96731 8.80831 8.04481 8.99595 8.04481 9.19157V18.4729ZM15.2304 14.2185C15.2296 14.4143 15.1514 14.602 15.0129 14.7405C14.8744 14.879 14.6867 14.9572 14.4908 14.958H11.3681C11.1725 14.9572 10.9852 14.8789 10.8471 14.7403C10.7091 14.6017 10.6316 14.4141 10.6316 14.2185V9.19157C10.6316 8.99595 10.7091 8.80831 10.8471 8.66971C10.9852 8.53111 11.1725 8.45285 11.3681 8.45205H14.4908C14.6867 8.45284 14.8744 8.53101 15.0129 8.66952C15.1514 8.80804 15.2296 8.99568 15.2304 9.19157V14.2185Z"\n      fill="url(#').concat(id, ')"\n    />\n  </svg>');
    }
};
var $76e744bef6fc0411$export$60e26212f3b61a28 = function TrelloLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Trello" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $76e744bef6fc0411$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("lw2Cv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $673f1f94d690ee0f$export$2e2bcd8739ae039; });

var $5v6A7 = parcelRequire("5v6A7");

var $dwjLE = parcelRequire("dwjLE");

var $b2Jk5 = parcelRequire("b2Jk5");
const $673f1f94d690ee0f$export$911a80ac761af24c = (0, $b2Jk5.backgroundWithImage)((0, (/*@__PURE__*/$parcel$interopDefault($dwjLE))));
const $673f1f94d690ee0f$var$WacCobranding = {
    background: $673f1f94d690ee0f$export$911a80ac761af24c,
    logo: {
        component: (0, $5v6A7.AtlassianLogo)
    },
    footerProducts: "Jira, Confluence, Trello"
};
var $673f1f94d690ee0f$export$2e2bcd8739ae039 = $673f1f94d690ee0f$var$WacCobranding;

});
parcelRegister("dwjLE", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "wac.92a80da2.svg";

});


parcelRegister("3b3Yv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bf80ab84606e9e9$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $cx88G = parcelRequire("cx88G");

var $1CA01 = parcelRequire("1CA01");

var $1kJGA = parcelRequire("1kJGA");

var $b2Jk5 = parcelRequire("b2Jk5");
const $5bf80ab84606e9e9$export$14ae77d7d7e2d26f = (0, $b2Jk5.backgroundWithSideImages)((0, (/*@__PURE__*/$parcel$interopDefault($cx88G))), (0, (/*@__PURE__*/$parcel$interopDefault($1CA01))));
const $5bf80ab84606e9e9$var$AtlasCobranding = {
    background: $5bf80ab84606e9e9$export$14ae77d7d7e2d26f,
    logo: {
        renderLogo: ()=>/*#__PURE__*/ (0, $6rcps.jsx)((0, $1kJGA.default), {
                size: "large"
            })
    },
    footerProducts: "Trello, Jira, Confluence"
};
var $5bf80ab84606e9e9$export$2e2bcd8739ae039 = $5bf80ab84606e9e9$var$AtlasCobranding;

});
parcelRegister("1kJGA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a673f304a21a4a2$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $azw9d = parcelRequire("azw9d");

var $86MfR = parcelRequire("86MfR");

var $3XNKR = parcelRequire("3XNKR");
let $2a673f304a21a4a2$var$_ = (t)=>t, $2a673f304a21a4a2$var$t;
const $2a673f304a21a4a2$var$LogoContainer = (0, $3XNKR.default).div($2a673f304a21a4a2$var$t || ($2a673f304a21a4a2$var$t = $2a673f304a21a4a2$var$_`
  display: inline-block;
  height: ${0}px;
  position: relative;
  user-select: none;

  > img {
    width: 100%;
    height: 48px;
  }
`), (p)=>p.size ? (0, $azw9d.sizes)[p.size] : (0, $azw9d.sizes)["large"]);
const $2a673f304a21a4a2$var$AtlasLogo = ({ size: size })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)($2a673f304a21a4a2$var$LogoContainer, {
        size: size,
        children: /*#__PURE__*/ (0, $6rcps.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($86MfR))),
            alt: "Atlas Logo"
        })
    });
};
var $2a673f304a21a4a2$export$2e2bcd8739ae039 = $2a673f304a21a4a2$var$AtlasLogo;

});
parcelRegister("86MfR", function(module, exports) {

module.exports = (parcelRequire("5ptLS")).getBundleURL("7VwIV") + "atlaslogo.5491d009.svg";

});



parcelRegister("gyHmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5541158a686c2b7e$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $5v6A7 = parcelRequire("5v6A7");
var $2KVdV = parcelRequire("2KVdV");

var $8SsuY = parcelRequire("8SsuY");
function $5541158a686c2b7e$var$BlankBackgroundWithLogo({ children: children }) {
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8SsuY.BlankBackground), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $2KVdV.JiraLogo), {
                appearance: "brand",
                size: "large"
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $8SsuY.IdentityWrapper), {
                children: children
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5v6A7.AtlassianLogo), {
                appearance: "brand",
                size: "small"
            })
        ]
    });
}
const $5541158a686c2b7e$var$WacSignupOTPExperimentJira = {
    background: $5541158a686c2b7e$var$BlankBackgroundWithLogo,
    logo: null,
    whiteboxWidth: "400px",
    hideWhiteboxBorder: true
};
var $5541158a686c2b7e$export$2e2bcd8739ae039 = $5541158a686c2b7e$var$WacSignupOTPExperimentJira;

});
parcelRegister("8SsuY", function(module, exports) {

$parcel$export(module.exports, "BlankBackground", function () { return $45295f5b1887ee51$export$c231254635a46aaa; });
$parcel$export(module.exports, "IdentityWrapper", function () { return $45295f5b1887ee51$export$88c1886ba70127fc; });

var $3XNKR = parcelRequire("3XNKR");
const $45295f5b1887ee51$export$c231254635a46aaa = (0, $3XNKR.default).main({
    alignItems: "stretch",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    gap: "1rem",
    justifyContent: "space-between",
    margin: "0 auto",
    minHeight: "100vh",
    maxWidth: "432px",
    padding: "2rem 1rem 3rem",
    textAlign: "center"
});
const $45295f5b1887ee51$export$88c1886ba70127fc = (0, $3XNKR.default).section({
    flex: 1,
    justifySelf: "flex-start",
    textAlign: "left",
    "#WhiteboxContainer, #ProductHeading": {
        margin: 0
    },
    "#ProductHeadingSuffix": {
        alignItems: "stretch",
        marginBlockEnd: "1rem",
        paddingBlockStart: "1rem",
        width: "100%",
        "h2, h5": {
            fontWeight: 500,
            textAlign: "left",
            width: "100%"
        },
        h2: {
            fontSize: "2rem",
            margin: "10px 0 0"
        },
        h5: {
            fontSize: "1rem",
            margin: 0
        }
    },
    section: {
        padding: 0,
        width: "100%"
    }
});

});


parcelRegister("i1r2g", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5f45121b498f86c2$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $5v6A7 = parcelRequire("5v6A7");
var $dec5c = parcelRequire("dec5c");

var $8SsuY = parcelRequire("8SsuY");
function $5f45121b498f86c2$var$BlankBackgroundWithLogo({ children: children }) {
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8SsuY.BlankBackground), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $dec5c.ConfluenceLogo), {
                appearance: "brand",
                size: "large"
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $8SsuY.IdentityWrapper), {
                children: children
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5v6A7.AtlassianLogo), {
                appearance: "brand",
                size: "small"
            })
        ]
    });
}
const $5f45121b498f86c2$var$WacSignupOTPExperimentConfluence = {
    background: $5f45121b498f86c2$var$BlankBackgroundWithLogo,
    logo: null,
    whiteboxWidth: "460px",
    hideWhiteboxBorder: true
};
var $5f45121b498f86c2$export$2e2bcd8739ae039 = $5f45121b498f86c2$var$WacSignupOTPExperimentConfluence;

});

parcelRegister("4YCdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d7c853b442e7ea8$export$2e2bcd8739ae039; });

var $cdWvC = parcelRequire("cdWvC");

var $b2Jk5 = parcelRequire("b2Jk5");

var $3XNKR = parcelRequire("3XNKR");
let $0d7c853b442e7ea8$var$_ = (t)=>t, $0d7c853b442e7ea8$var$t;
const $0d7c853b442e7ea8$export$4fcb21def34701d = (0, $3XNKR.default)((0, $b2Jk5.DefaultBackground))($0d7c853b442e7ea8$var$t || ($0d7c853b442e7ea8$var$t = $0d7c853b442e7ea8$var$_`
  background-color: #fff;
`));
const $0d7c853b442e7ea8$var$LoomCobranding = {
    background: $0d7c853b442e7ea8$export$4fcb21def34701d,
    logo: {
        component: (0, $cdWvC.LoomLogo)
    },
    footerProducts: "Loom, Confluence, Jira"
};
var $0d7c853b442e7ea8$export$2e2bcd8739ae039 = $0d7c853b442e7ea8$var$LoomCobranding;

});
parcelRegister("cdWvC", function(module, exports) {

$parcel$export(module.exports, "LoomLogo", function () { return $8e64159840caf475$export$94e206806e36c2ec; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $8e64159840caf475$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsForLoom)(appearance, colorMode);
        return '<svg\n        fill="none"\n        height="32"\n        xmlns="http://www.w3.org/2000/svg"\n        viewBox="0 0 98 32"\n        focusable="false"\n        aria-hidden="true"\n      >\n        <path\n          d="M29.657 13.659h-8.672l7.51-4.337-1.649-2.857-7.51 4.336 4.335-7.51-2.857-1.65-4.336 7.51V.479H13.18v8.672l-4.337-7.51-2.856 1.65 4.336 7.51-7.51-4.336-1.65 2.857 7.51 4.336H0v3.299h8.671l-7.51 4.336 1.65 2.858 7.51-4.336-4.336 7.51 2.857 1.65 4.336-7.511v8.672h3.3v-8.671l4.335 7.51 2.857-1.65-4.336-7.51 7.51 4.336 1.65-2.858-7.51-4.335h8.672v-3.3zM14.83 19.794a4.503 4.503 0 1 1 0-9.006 4.503 4.503 0 0 1 0 9.006"\n          fill="'.concat(colors.iconColor, '"\n        />\n        <path\n          d="M37.303 26.155V4.459h3.983v21.696zm38.204-14.743h3.803v1.798c.808-1.438 2.696-2.218 4.313-2.218 2.007 0 3.624.87 4.373 2.457 1.167-1.798 2.726-2.457 4.673-2.457 2.725 0 5.33 1.648 5.33 5.604v9.559h-3.862v-8.75c0-1.588-.78-2.786-2.607-2.786-1.707 0-2.726 1.318-2.726 2.907v8.63H84.85v-8.75c0-1.59-.808-2.787-2.606-2.787-1.738 0-2.757 1.288-2.757 2.907v8.63h-3.981zm-25.219 15.17c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.251 7.798-7.737 7.798m0-11.996a4.2 4.2 0 0 0-4.197 4.199c0 2.315 1.883 4.199 4.197 4.199s4.196-1.884 4.196-4.2a4.2 4.2 0 0 0-4.196-4.198m16.245 11.996c-4.487 0-7.737-3.328-7.737-7.798 0-4.4 3.24-7.806 7.737-7.806 4.52 0 7.737 3.439 7.737 7.806 0 4.438-3.253 7.798-7.737 7.798m0-12.046c-2.34 0-4.245 1.906-4.245 4.247s1.904 4.247 4.245 4.247a4.25 4.25 0 0 0 4.245-4.247 4.25 4.25 0 0 0-4.245-4.247"\n          fill="').concat(colors.textColor, '"\n        />\n      </svg>');
    } else {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        var loomTextColor = colorMode === "light" && appearance === "brand" ? "#222" : colors.textColor;
        var loomIconColor = appearance === "brand" ? "#625DF5" : colors.iconColor;
        return '\n    <svg\n      fill="none"\n      height="32"\n      viewBox="0 0 87 32"\n      xmlns="http://www.w3.org/2000/svg"\n    >\n      <path\n        clip-rule="evenodd"\n        d="m33.0381 6.48975v19.01995h3.492v-19.01995zm36.8275 6.09465h-3.3347v12.9261h3.4912v-7.5659c0-1.4189.893-2.5487 2.4162-2.5487 1.5762 0 2.285 1.0505 2.285 2.4431v7.6715h3.465v-7.5659c0-1.3927.8929-2.5487 2.3899-2.5487 1.6017 0 2.285 1.0505 2.285 2.4431v7.6707h3.3871v-8.3806c0-3.4672-2.2843-4.9123-4.6734-4.9123-1.7067 0-3.0732.5772-4.0966 2.1541-.6563-1.3919-2.0737-2.1541-3.8337-2.1541-1.4174 0-3.0723.6836-3.781 1.9445zm-25.4441 13.2997c-3.9339 0-6.7826-2.9178-6.7826-6.8368 0-3.8565 2.8395-6.8437 6.7826-6.8437 3.9623 0 6.7827 3.0149 6.7827 6.8437 0 3.8905-2.8504 6.8368-6.7827 6.8368zm0-10.5168c-2.029 0-3.6794 1.6507-3.6794 3.6808 0 2.03 1.6504 3.6808 3.6794 3.6808s3.6786-1.6508 3.6786-3.6808c0-2.0301-1.6496-3.6808-3.6786-3.6808zm7.4592 3.68c0 3.919 2.8487 6.8368 6.7827 6.8368 3.9307 0 6.7826-2.9463 6.7826-6.8368 0-3.8288-2.8203-6.8437-6.7826-6.8437-3.9431 0-6.7827 2.9872-6.7827 6.8437zm3.0609-.0008c0-2.0523 1.6696-3.7232 3.7218-3.7232 2.0513 0 3.7209 1.6709 3.7218 3.7232 0 2.0524-1.6698 3.7233-3.7218 3.7233-2.0522 0-3.7218-1.6709-3.7218-3.7233z"\n        fill="'.concat(loomTextColor, '"\n        fill-rule="evenodd"\n      />\n      <path\n        d="m26 14.5543h-7.6028l6.5844-3.8015-1.446-2.50522-6.5843 3.80152 3.8006-6.58389-2.5052-1.44683-3.8007 6.58382v-7.6022h-2.8921v7.6029l-3.80205-6.58452-2.50442 1.4461 3.80136 6.58382-6.58438-3.80072-1.44606 2.50452 6.58438 3.8014h-7.60273v2.8923h7.60201l-6.58366 3.8014 1.44606 2.5052 6.58365-3.8007-3.80136 6.5838 2.50515 1.4461 3.80135-6.5845v7.6029h2.8921v-7.6022l3.8007 6.5838 2.5051-1.4461-3.8013-6.5845 6.5843 3.8014 1.4461-2.5052-6.5837-3.8008h7.602v-2.8921zm-13 5.3791c-2.1807 0-3.9483-1.7675-3.9483-3.9483s1.7676-3.9484 3.9483-3.9484 3.9482 1.7676 3.9482 3.9484-1.7675 3.9483-3.9482 3.9483z"\n        fill="').concat(loomIconColor, '"\n      />\n    </svg>\n  ');
    }
};
var $8e64159840caf475$export$94e206806e36c2ec = function LoomLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Loom" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        size: size,
        svg: $8e64159840caf475$var$svg({
            appearance: appearance,
            size: size,
            iconColor: iconColor,
            textColor: textColor
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("8liMg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $364c4443fd92ea03$export$2e2bcd8739ae039; });

var $byKTa = parcelRequire("byKTa");

var $b2Jk5 = parcelRequire("b2Jk5");

var $3XNKR = parcelRequire("3XNKR");
let $364c4443fd92ea03$var$_ = (t)=>t, $364c4443fd92ea03$var$t;
const $364c4443fd92ea03$export$69d75365d6a52225 = (0, $3XNKR.default)((0, $b2Jk5.DefaultBackground))($364c4443fd92ea03$var$t || ($364c4443fd92ea03$var$t = $364c4443fd92ea03$var$_`
  background-color: #fff;
`));
const $364c4443fd92ea03$var$JiraAlignCobranding = {
    background: $364c4443fd92ea03$export$69d75365d6a52225,
    logo: {
        component: (0, $byKTa.JiraAlignLogo)
    },
    footerProducts: "Jira Align, Confluence, Jira"
};
var $364c4443fd92ea03$export$2e2bcd8739ae039 = $364c4443fd92ea03$var$JiraAlignCobranding;

});
parcelRegister("byKTa", function(module, exports) {

$parcel$export(module.exports, "JiraAlignLogo", function () { return $86a73dd1ca23f887$export$ee11e928d3d045fd; });
/* eslint-disable max-len */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $ihgai = parcelRequire("ihgai");

var $kdKsS = parcelRequire("kdKsS");

var $9XpDE = parcelRequire("9XpDE");

var $azw9d = parcelRequire("azw9d");

var $czQZy = parcelRequire("czQZy");

var $gm61b = parcelRequire("gm61b");
var $86a73dd1ca23f887$var$svg = function svg(_ref, colorMode) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    };
    if ((0, $kdKsS.getBooleanFF)("platform.design-system-team.brand-refresh-update-product-logos_q7coo")) {
        if (appearance) colors = (0, $czQZy.getColorsFromAppearance)(appearance, colorMode);
        return '<svg viewBox="0 0 146 32" focusable="false" aria-hidden="true" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">\n      <path d="M19.04 25.727c0-3.604-2.949-6.517-6.517-6.517H6.517v-5.497H0v10.813c0 .837.364 1.201 1.201 1.201zM0 6.687c0 3.604 2.876 6.517 6.48 6.517h6.043V18.7h6.517V7.888q0-1.2-1.201-1.201z" fill="'.concat(colors.iconColor, '"/>\n      <path d="M144.993 16.555v8.985h-2.638v-9.26c0-2.76-1.104-3.988-3.618-3.988-2.454 0-4.14 1.626-4.14 4.723v8.525h-2.638V10.207h2.638v2.515c.981-1.81 2.79-2.822 4.845-2.822 3.527 0 5.551 2.423 5.551 6.655m-19.589 7.759V22.78c-.982 2.024-2.822 3.067-5.183 3.067-4.048 0-6.072-3.465-6.072-7.973 0-4.324 2.116-7.974 6.379-7.974 2.238 0 3.956 1.012 4.876 3.006v-2.699h2.576V24.16c0 4.508-2.116 7.544-7.606 7.544-2.576 0-3.986-.337-5.458-.828V28.3c1.686.552 3.434.92 5.336.92 3.833 0 5.152-2.054 5.152-4.906m-8.679-6.44c0 3.68 1.472 5.52 4.201 5.52 2.362 0 4.478-1.503 4.478-4.907V17.26c0-3.404-1.932-4.906-4.171-4.906-2.975 0-4.508 1.962-4.508 5.52M107.96 6.16c0-1.166.766-1.84 1.84-1.84 1.073 0 1.84.674 1.84 1.84S110.873 8 109.8 8c-1.074 0-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.638Zm-2.537-.03c-.215.061-.675.122-1.349.122-2.515 0-4.11-1.196-4.11-4.017V3.798h2.638v17.51c0 1.38.92 1.871 2.054 1.871.276 0 .46 0 .767-.03v2.36ZM88.83 21.523c-1.534 0-3.098-.184-4.815-.521l-1.687 4.539h-3.097l7.942-20.148h3.496l7.943 20.148h-3.097l-1.687-4.57c-1.81.368-3.373.552-4.999.552Zm0-2.453c1.287 0 2.606-.153 4.17-.399l-4.079-11.04-4.078 11.07c1.502.246 2.76.369 3.986.369Zm-27.807-1.196c0 3.68 1.472 5.52 4.202 5.52 2.36 0 4.477-1.503 4.477-4.907V17.26c0-3.404-1.932-4.906-4.17-4.906-2.975 0-4.509 1.962-4.509 5.52m8.679 7.666v-2.76c-.981 2.024-2.822 3.067-5.183 3.067-4.079 0-6.133-3.465-6.133-7.973 0-4.324 2.146-7.974 6.44-7.974 2.239 0 3.956 1.012 4.876 3.006v-2.699h2.637V25.54zM51.91 16.494v9.047h-2.577V10.207h2.576v2.699c.89-1.81 2.423-3.097 5.428-2.913v2.576c-3.373-.338-5.428.674-5.428 3.925ZM42.224 6.16c0-1.166.767-1.84 1.84-1.84s1.84.674 1.84 1.84S45.137 8 44.064 8s-1.84-.675-1.84-1.84m.49 19.38V10.208h2.638v15.334h-2.637Zm-6.427-5.949V5.393h2.76v14.014c0 3.71-1.626 6.256-5.428 6.256-1.442 0-2.546-.245-3.312-.521v-2.668c.828.337 1.84.521 2.852.521 2.33 0 3.128-1.41 3.128-3.404" fill="').concat(colors.textColor, '"/>\n    </svg>\n  ');
    } else {
        // Will be fixed upon removal of deprecated iconGradientStart and
        // iconGradientStop props, or with React 18's useId() hook when we update.
        // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
        var id = (0, $ihgai.uid)({
            iconGradientStart: iconGradientStop
        });
        if (appearance) colors = (0, $czQZy.getColorsFromAppearanceOldLogos)(appearance);
        return '\n    <svg height="32" viewBox="0 0 147 32" xmlns="http://www.w3.org/2000/svg" focusable="false" aria-hidden="true">\n      <defs>\n        <linearGradient id="'.concat(id, '-1" x1="8.97104" y1="20.5458" x2="10.5214" y2="12.6394" gradientUnits="userSpaceOnUse">\n          <stop offset="0.15" stop-color="').concat(colors.iconGradientStart, '"  ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n          <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n        </linearGradient>\n        <linearGradient id="').concat(id, '-2" x1="12.1408" y1="10.8472" x2="10.5904" y2="18.7536" gradientUnits="userSpaceOnUse">\n          <stop offset="0.15" stop-color="').concat(colors.iconGradientStart, '" ').concat(colors.iconGradientStart === "inherit" ? 'stop-opacity="0.4"' : "", ' />\n          <stop stop-color="').concat(colors.iconGradientStop, '" offset="100%"></stop>\n        </linearGradient>\n      </defs>\n      <g fill="').concat(colors.textColor, '">\n        <path d="M36.6401 4.60829H39.4754V18.6632C39.4754 22.3692 37.7886 24.9565 33.8766 24.9565C32.4051 24.9565 31.2566 24.7117 30.467 24.432V21.7399C31.3284 22.0895 32.3692 22.2644 33.41 22.2644C35.8146 22.2644 36.6401 20.8658 36.6401 18.838V4.60829Z" />\n        <path d="M44.6076 3.52444C45.7202 3.52444 46.5097 4.18873 46.5097 5.37745C46.5097 6.53121 45.7202 7.23046 44.6076 7.23046C43.495 7.23046 42.7054 6.56618 42.7054 5.37745C42.7054 4.18873 43.495 3.52444 44.6076 3.52444ZM43.2438 9.4331H45.9714V24.8166H43.2438V9.4331Z" />\n        <path d="M52.7545 24.8166H50.0987V9.43309H52.7545V12.1252C53.6877 10.3072 55.2668 9.01354 58.3534 9.18835V11.7756C54.872 11.426 52.7545 12.4399 52.7545 15.7263V24.8166Z" />\n        <path d="M71.0943 22.0546C70.0894 24.0824 68.1872 25.1313 65.7467 25.1313C61.5476 25.1313 59.4301 21.67 59.4301 17.1249C59.4301 12.7895 61.6552 9.11844 66.0697 9.11844C68.3666 9.11844 70.1611 10.1324 71.0943 12.1252V9.4331H73.8219V24.8166H71.0943V22.0546ZM66.4645 22.6489C68.905 22.6489 71.0584 21.1455 71.0584 17.7192V16.4955C71.0584 13.0692 69.0844 11.5658 66.7516 11.5658C63.701 11.5658 62.1218 13.5237 62.1218 17.0899C62.1577 20.8309 63.6651 22.6489 66.4645 22.6489Z" />\n        <path d="M83.9431 20.2715L82.2204 24.8166H79.0262L87.209 4.60829H90.798L98.9809 24.8166H95.7867L94.064 20.2365C92.1977 20.6211 90.5827 20.7959 88.9318 20.7959C87.3167 20.7959 85.7017 20.5862 83.9431 20.2715ZM93.2027 17.929L89.0035 6.84589L84.8044 17.964C86.3477 18.2087 87.6397 18.3486 88.8959 18.3486C90.2238 18.3136 91.5876 18.1737 93.2027 17.929Z" />\n        <path d="M105.082 24.9215C102.498 24.9215 100.847 23.7328 100.847 20.9008V3H103.575V20.5512C103.575 21.9497 104.508 22.4391 105.692 22.4391C105.979 22.4391 106.159 22.4391 106.482 22.4042V24.7816C106.266 24.8516 105.8 24.9215 105.082 24.9215Z" />\n        <path d="M110.501 3.52444C111.614 3.52444 112.404 4.18873 112.404 5.37745C112.404 6.53121 111.614 7.23046 110.501 7.23046C109.389 7.23046 108.599 6.56618 108.599 5.37745C108.599 4.18873 109.389 3.52444 110.501 3.52444ZM109.102 9.4331H111.829V24.8166H109.102V9.4331Z" />\n        <path d="M126.58 22.0546C125.575 24.0824 123.673 25.1313 121.233 25.1313C117.069 25.1313 114.988 21.67 114.988 17.1249C114.988 12.7895 117.177 9.11844 121.556 9.11844C123.852 9.11844 125.647 10.1324 126.58 12.1252V9.4331H129.236V23.4181C129.236 27.9283 127.047 30.97 121.412 30.97C118.756 30.97 117.321 30.6204 115.777 30.1309V27.5437C117.5 28.1031 119.33 28.4527 121.268 28.4527C125.216 28.4527 126.58 26.3899 126.58 23.523V22.0546ZM121.95 22.6489C124.391 22.6489 126.544 21.1455 126.544 17.7192V16.4955C126.544 13.0692 124.57 11.5658 122.237 11.5658C119.187 11.5658 117.608 13.5237 117.608 17.0899C117.644 20.8309 119.151 22.6489 121.95 22.6489Z" />\n        <path d="M146.75 24.8166H144.023V15.5166C144.023 12.7545 142.874 11.5309 140.29 11.5309C137.778 11.5309 136.019 13.1741 136.019 16.2858V24.8516H133.292V9.46807H136.019V11.9854C137.024 10.1673 138.89 9.15341 141.008 9.15341C144.633 9.15341 146.714 11.6008 146.714 15.8312V24.8166H146.75Z" />\n        <path fill="url(#').concat(id, '-1)" d="M0.75 5.78784C0.75 9.51693 3.76475 12.5581 7.46141 12.5581H13.6704V18.8578H20.3818V6.91019C20.3818 6.33091 19.9152 5.82405 19.341 5.82405L0.75 5.78784Z" />\n        <path fill="url(#').concat(id, '-2)" d="M20.3459 25.5918C20.3459 21.8627 17.3311 18.8577 13.6345 18.8577H7.46141V12.5581H0.75V24.5057C0.75 25.085 1.21657 25.5918 1.79081 25.5918H20.3459Z" />\n      </g>\n    </svg>\n  ');
    }
};
var $86a73dd1ca23f887$export$ee11e928d3d045fd = function JiraAlignLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? "Jira Align" : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $azw9d.defaultLogoParams).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $azw9d.defaultLogoParams).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $azw9d.defaultLogoParams).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $azw9d.defaultLogoParams).textColor : _ref2$textColor;
    var _useThemeObserver = (0, $9XpDE.default)(), colorMode = _useThemeObserver.colorMode;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gm61b.default), {
        appearance: appearance,
        label: label,
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        svg: $86a73dd1ca23f887$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor,
            size: size,
            label: label
        }, colorMode),
        testId: testId,
        textColor: textColor
    });
};

});



parcelRegister("yrE6A", function(module, exports) {

$parcel$export(module.exports, "ProductHeading", function () { return $fc811189c809365b$export$bb672d3ab4980938; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");
let $fc811189c809365b$var$_ = (t)=>t, $fc811189c809365b$var$t, $fc811189c809365b$var$t1;
const $fc811189c809365b$export$6fe455b424bdaa07 = (0, $3XNKR.default).div($fc811189c809365b$var$t || ($fc811189c809365b$var$t = $fc811189c809365b$var$_`
  display: flex;
  flex-direction: column;
  padding-top: ${0}px;
  align-items: center;

  h5 {
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    color: ${0};
  }
`), (0, $5b7Z4.gridSize)() * 3, (0, $kTdw7).N800);
const $fc811189c809365b$var$ProductHeadingWrapper = (0, $3XNKR.default).div($fc811189c809365b$var$t1 || ($fc811189c809365b$var$t1 = $fc811189c809365b$var$_`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
const $fc811189c809365b$export$bb672d3ab4980938 = ({ suffix: suffix, children: children })=>{
    return /*#__PURE__*/ (0, $6rcps.jsxs)($fc811189c809365b$var$ProductHeadingWrapper, {
        "data-testid": "header",
        id: "ProductHeading",
        children: [
            children,
            /*#__PURE__*/ (0, $6rcps.jsx)($fc811189c809365b$export$6fe455b424bdaa07, {
                "data-testid": "header-suffix",
                id: "ProductHeadingSuffix",
                children: suffix
            })
        ]
    });
};

});

parcelRegister("cDJ3z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2cf7fd3e4b6981d$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $ihLLY = parcelRequire("ihLLY");

var $gGDrC = parcelRequire("gGDrC");

var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $5v6A7 = parcelRequire("5v6A7");

var $b2Jk5 = parcelRequire("b2Jk5");

var $pO9YU = parcelRequire("pO9YU");

var $3ir1n = parcelRequire("3ir1n");
let $e2cf7fd3e4b6981d$var$_ = (t)=>t, $e2cf7fd3e4b6981d$var$t, $e2cf7fd3e4b6981d$var$t1, $e2cf7fd3e4b6981d$var$t2;
const $e2cf7fd3e4b6981d$var$PageFooter = (0, $3XNKR.default).footer($e2cf7fd3e4b6981d$var$t1 || ($e2cf7fd3e4b6981d$var$t1 = $e2cf7fd3e4b6981d$var$_`
  background: transparent;
  display: flex;
  align-items: center;
  text-align: center;
  box-sizing: border-box;
  flex-direction: column;
  margin: 0 auto;
  border-top: 1px solid ${0};
  padding-top: ${0}px;
  font-size: 11px;
  color: ${0};
  ${0}
  ${0}

  ${0}
`), (0, $kTdw7).N50, (0, $5b7Z4.gridSize)() * 3, (props)=>props.footerMessageTextColor, (props)=>(0, $b2Jk5.linkStyles)(props.textColor), (0, $b2Jk5.listStyles), (0, $ihLLY.media).handheld($e2cf7fd3e4b6981d$var$t || ($e2cf7fd3e4b6981d$var$t = $e2cf7fd3e4b6981d$var$_`
     line-height: inherit;
     background-color: transparent;
  `)));
const $e2cf7fd3e4b6981d$var$SubText = (0, $3XNKR.default).div($e2cf7fd3e4b6981d$var$t2 || ($e2cf7fd3e4b6981d$var$t2 = $e2cf7fd3e4b6981d$var$_`
  padding-top: ${0}px;
`), (0, $5b7Z4.gridSize)());
const $e2cf7fd3e4b6981d$var$FooterComponent = ({ renderText: renderText, footerProducts: footerProducts, pageId: pageId })=>{
    const onLinkClicked = (0, $3ir1n.useButtonClickedEvent)(pageId, "learnMoreAtlassianAccount");
    return /*#__PURE__*/ (0, $6rcps.jsxs)($e2cf7fd3e4b6981d$var$PageFooter, {
        "data-testid": "page-footer",
        textColor: (0, $kTdw7).B400,
        footerMessageTextColor: (0, $kTdw7).N800,
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $5v6A7.AtlassianLogo), {
                appearance: "neutral",
                size: "small"
            }),
            renderText && /*#__PURE__*/ (0, $6rcps.jsx)($e2cf7fd3e4b6981d$var$SubText, {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                    id: "footer.cobranding.text",
                    defaultMessage: "One account for {products} and {link}.",
                    description: "{products} is a comma-separated list of products. {link} is a hyperlink that will be filled with a separately translated string: more",
                    values: {
                        products: footerProducts,
                        link: /*#__PURE__*/ (0, $6rcps.jsx)((0, $pO9YU.LearnMoreAboutAtlassianAccountLink), {
                            onClick: onLinkClicked
                        })
                    }
                })
            })
        ]
    });
};
var $e2cf7fd3e4b6981d$export$2e2bcd8739ae039 = $e2cf7fd3e4b6981d$var$FooterComponent;

});
parcelRegister("pO9YU", function(module, exports) {

$parcel$export(module.exports, "SELF_SERVICE_LINK_URL", function () { return $c708b5cc270ed46d$export$86be5cde852cdd25; });
$parcel$export(module.exports, "SelfServiceLink", function () { return $c708b5cc270ed46d$export$a817dad308d44854; });
$parcel$export(module.exports, "SupportLink", function () { return $c708b5cc270ed46d$export$a6b83d54334dba9f; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL_MOBILE", function () { return $c708b5cc270ed46d$export$e6483b6b5710900e; });
$parcel$export(module.exports, "PRIVACY_POLICY_URL", function () { return $c708b5cc270ed46d$export$30786e8ac20c09d8; });
$parcel$export(module.exports, "PrivacyPolicyLink", function () { return $c708b5cc270ed46d$export$fdd773f48aebb8ab; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL_MOBILE", function () { return $c708b5cc270ed46d$export$4f1e847a8e64f5b; });
$parcel$export(module.exports, "CLOUD_TERMS_OF_SERVICE_URL", function () { return $c708b5cc270ed46d$export$b6aa5b30b55e4e21; });
$parcel$export(module.exports, "UserNoticeLink", function () { return $c708b5cc270ed46d$export$afb6ca8138b3e5a3; });
$parcel$export(module.exports, "LearnMoreAboutAtlassianAccountLink", function () { return $c708b5cc270ed46d$export$694937257991c79; });
$parcel$export(module.exports, "RequestAccessLink", function () { return $c708b5cc270ed46d$export$5ce617bd6fde7ab8; });
$parcel$export(module.exports, "PASSWORD_LEAKED_LINK", function () { return $c708b5cc270ed46d$export$4b69c758417d5b1b; });

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $9OvaU = parcelRequire("9OvaU");

var $3XNKR = parcelRequire("3XNKR");

var $kTdw7 = parcelRequire("kTdw7");
let $c708b5cc270ed46d$var$_ = (t)=>t, $c708b5cc270ed46d$var$t;
const $c708b5cc270ed46d$var$SubtleLink = (0, $3XNKR.default).a($c708b5cc270ed46d$var$t || ($c708b5cc270ed46d$var$t = $c708b5cc270ed46d$var$_`
  color: ${0};

  &:hover {
    color: ${0};
  }
`), (0, $kTdw7).N800, (0, $kTdw7).N800);
const $c708b5cc270ed46d$export$86be5cde852cdd25 = "https://support.atlassian.com/atlassian-account/docs/troubleshoot-login-issues-with-your-atlassian-account/";
function $c708b5cc270ed46d$export$a817dad308d44854(props) {
    return /*#__PURE__*/ (0, $6rcps.jsx)($c708b5cc270ed46d$var$SubtleLink, {
        href: $c708b5cc270ed46d$export$86be5cde852cdd25,
        id: "self-service-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "resetpassword.self.service",
            defaultMessage: "Login help"
        })
    });
}
const $c708b5cc270ed46d$export$56321425bd50535f = "https://support.atlassian.com/";
function $c708b5cc270ed46d$export$a6b83d54334dba9f(props) {
    return /*#__PURE__*/ (0, $6rcps.jsx)($c708b5cc270ed46d$var$SubtleLink, {
        href: $c708b5cc270ed46d$export$56321425bd50535f,
        id: "support-link",
        target: "_blank",
        rel: "noopener noreferrer",
        // https://mathiasbynens.github.io/rel-noopener
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "resetpassword.support",
            defaultMessage: "Contact Support"
        })
    });
}
const $c708b5cc270ed46d$export$e6483b6b5710900e = "https://www.atlassian.com/legal/privacy-policy/mobile";
const $c708b5cc270ed46d$export$30786e8ac20c09d8 = "https://www.atlassian.com/legal/privacy-policy";
function $c708b5cc270ed46d$export$fdd773f48aebb8ab(props) {
    const privacyPolicyUrl = props.isMobileLink ? $c708b5cc270ed46d$export$e6483b6b5710900e : $c708b5cc270ed46d$export$30786e8ac20c09d8;
    return /*#__PURE__*/ (0, $6rcps.jsx)($c708b5cc270ed46d$var$SubtleLink, {
        href: privacyPolicyUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "common.privacy.policy",
            defaultMessage: "Privacy Policy"
        })
    });
}
const $c708b5cc270ed46d$export$4f1e847a8e64f5b = "https://www.atlassian.com/legal/customer-agreement/mobile";
const $c708b5cc270ed46d$export$b6aa5b30b55e4e21 = "https://www.atlassian.com/legal/cloud-terms-of-service";
const $c708b5cc270ed46d$export$5e45d5d0eb34696e = "https://www.atlassian.com/legal/user-notice/mobile";
const $c708b5cc270ed46d$export$b6eec8592d48b4f1 = "https://www.atlassian.com/legal/user-notice";
function $c708b5cc270ed46d$export$afb6ca8138b3e5a3(props) {
    const userNoticeUrl = props.isMobileLink ? $c708b5cc270ed46d$export$5e45d5d0eb34696e : $c708b5cc270ed46d$export$b6eec8592d48b4f1;
    return /*#__PURE__*/ (0, $6rcps.jsx)($c708b5cc270ed46d$var$SubtleLink, {
        href: userNoticeUrl,
        target: "_blank",
        rel: "noreferrer noopener",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "common.user.notice",
            defaultMessage: "User Notice",
            description: "Link that takes users to the Atlassian User Notice"
        })
    });
}
function $c708b5cc270ed46d$export$694937257991c79(props) {
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    return /*#__PURE__*/ (0, $6rcps.jsx)($c708b5cc270ed46d$var$SubtleLink, {
        id: "atlassian-account-link-more-short",
        target: "_blank",
        rel: "noreferrer noopener",
        onClick: props.onClick,
        "aria-label": formatMessage({
            id: "cobranding.footer.learn.more.about.atlassian.account.link.aria.label",
            defaultMessage: "Learn more about Atlassian Account",
            description: "Aria label for short link to let users learn more about what an Atlassian Account is."
        }),
        href: "https://support.atlassian.com/atlassian-account/docs/what-is-an-atlassian-account/",
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "cobranding.footer.learn.more.about.atlassian.account.link",
            defaultMessage: "more",
            description: "Short link to let users learn more about using one account for multiple products. e.g. One account for {products} and more."
        })
    });
}
function $c708b5cc270ed46d$export$5ce617bd6fde7ab8(props) {
    const { destUrl: destUrl, applicationDestination: applicationDestination } = props;
    let redirectUrl = `https://${applicationDestination.destinationHostname}/login?application=${applicationDestination.applicationName.toLowerCase()}&permission-violation=true&preferred-redirect=request-access`;
    if (destUrl) redirectUrl += `&dest-url=${encodeURIComponent(destUrl)}`;
    const buttonText = /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
        id: "select.account.request.access.to.product",
        defaultMessage: "Request access to {productName}",
        values: {
            productName: applicationDestination.applicationName
        }
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $9OvaU.default), {
        id: "redirect-to-request-access",
        href: redirectUrl,
        onClick: props.onClick,
        children: buttonText
    });
}
const $c708b5cc270ed46d$export$4b69c758417d5b1b = "https://support.atlassian.com/atlassian-account/docs/protect-your-atlassian-account/";

});
parcelRegister("9OvaU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eae64e2bf233577a$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $iRVQ8 = parcelRequire("iRVQ8");

var $3XNKR = parcelRequire("3XNKR");
parcelRequire("8ZuGG");
let $eae64e2bf233577a$var$_ = (t)=>t, $eae64e2bf233577a$var$t;
const $eae64e2bf233577a$var$StyledButton = (0, $3XNKR.default)((0, $iRVQ8.default))($eae64e2bf233577a$var$t || ($eae64e2bf233577a$var$t = $eae64e2bf233577a$var$_`
  span {
    font-weight: 400;
  }
`));
const $eae64e2bf233577a$var$ButtonLink = (props)=>{
    const { appearance: appearance, ...rest } = props;
    return /*#__PURE__*/ (0, $6rcps.jsx)($eae64e2bf233577a$var$StyledButton, {
        appearance: appearance || "link",
        ...rest
    });
};
var $eae64e2bf233577a$export$2e2bcd8739ae039 = $eae64e2bf233577a$var$ButtonLink;

});
parcelRegister("iRVQ8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dbca0b098c0d3c0d$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $5AVd4 = parcelRequire("5AVd4");

var $62B5W = parcelRequire("62B5W");

var $hU0Cl = parcelRequire("hU0Cl");

var $2itye = parcelRequire("2itye");

var $7yjH4 = parcelRequire("7yjH4");
var $dbca0b098c0d3c0d$var$_excluded = [
    "appearance",
    "children",
    "iconBefore",
    "iconAfter",
    "isSelected",
    "onMouseDown",
    "onMouseUp",
    "shouldFitContainer",
    "spacing"
];
var $dbca0b098c0d3c0d$var$isFirefox = typeof navigator !== "undefined" && navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
/**
 * __Button__
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ var $dbca0b098c0d3c0d$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function Button(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$onMouseDown = _ref.onMouseDown, providedOnMouseDown = _ref$onMouseDown === void 0 ? (0, $5AVd4.default) : _ref$onMouseDown, _ref$onMouseUp = _ref.onMouseUp, providedOnMouseUp = _ref$onMouseUp === void 0 ? (0, $5AVd4.default) : _ref$onMouseUp, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $dbca0b098c0d3c0d$var$_excluded);
    var _useGlobalTheme = (0, $62B5W.useGlobalTheme)(), mode = _useGlobalTheme.mode;
    var isOnlySingleIcon = (0, $7yjH4.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isActive = _useState2[0], setIsActive = _useState2[1];
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        providedOnMouseDown(event);
        if ($dbca0b098c0d3c0d$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    var onMouseUp = (0, $8ZuGG.useCallback)(function(event) {
        providedOnMouseUp(event);
        if ($dbca0b098c0d3c0d$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    var buttonCss = (0, $8ZuGG.useMemo)(function() {
        return (0, $2itye.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        });
    }, [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $hU0Cl.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$dbca0b098c0d3c0d$var$Button.displayName = "Button";
var $dbca0b098c0d3c0d$export$2e2bcd8739ae039 = $dbca0b098c0d3c0d$var$Button;

});
parcelRegister("62B5W", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", function () { return $465fb43e668bdbb1$export$7692396083754928; });
$parcel$export(module.exports, "default", function () { return $465fb43e668bdbb1$export$2e2bcd8739ae039; });

var $7eaU1 = parcelRequire("7eaU1");
// Create default global light theme
var $465fb43e668bdbb1$var$_createTheme = (0, $7eaU1.createTheme)(function() {
    return {
        mode: "light"
    };
}), $465fb43e668bdbb1$var$Provider = $465fb43e668bdbb1$var$_createTheme.Provider, $465fb43e668bdbb1$var$Consumer = $465fb43e668bdbb1$var$_createTheme.Consumer, $465fb43e668bdbb1$export$7692396083754928 = $465fb43e668bdbb1$var$_createTheme.useTheme;
var $465fb43e668bdbb1$var$Theme = {
    Provider: $465fb43e668bdbb1$var$Provider,
    Consumer: $465fb43e668bdbb1$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$465fb43e668bdbb1$export$2e2bcd8739ae039 = $465fb43e668bdbb1$var$Theme;

});
parcelRegister("7eaU1", function(module, exports) {

$parcel$export(module.exports, "createTheme", function () { return $54324c3b5e2ff272$export$25d302a5b900a763; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");
var $54324c3b5e2ff272$var$_excluded = [
    "children"
];
function $54324c3b5e2ff272$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $8ZuGG.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $54324c3b5e2ff272$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $8ZuGG.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $8ZuGG.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("hU0Cl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0882544ffca4318$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $1Muvn = parcelRequire("1Muvn");

var $5AVd4 = parcelRequire("5AVd4");

var $c7GPs = parcelRequire("c7GPs");

var $c3Xui = parcelRequire("c3Xui");

var $hUeXI = parcelRequire("hUeXI");

var $kTdw7 = parcelRequire("kTdw7");

var $epZNN = parcelRequire("epZNN");

var $2itye = parcelRequire("2itye");

var $bJJt2 = parcelRequire("bJJt2");
var $d0882544ffca4318$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $d0882544ffca4318$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
var $d0882544ffca4318$var$iconBeforeSpacingFixStyle = (0, $14VNY.css)({
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $d0882544ffca4318$var$iconAfterSpacingFixStyle = (0, $14VNY.css)({
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $d0882544ffca4318$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $bJJt2.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
var $d0882544ffca4318$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $bJJt2.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $14VNY.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $d0882544ffca4318$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $5AVd4.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $5AVd4.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $d0882544ffca4318$var$_excluded);
    var ourRef = (0, $8ZuGG.useRef)();
    var setRef = (0, $8ZuGG.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $c7GPs.default)(ourRef, autoFocus);
    var interactionContext = (0, $8ZuGG.useContext)((0, $hUeXI.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "17.6.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $8ZuGG.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $14VNY.css)((0, $2itye.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $kTdw7.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $kTdw7.N500), ")"), " !important")
        }
    };
    return (0, $14VNY.jsx)((0, $c3Xui.default), null, (0, $14VNY.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $d0882544ffca4318$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $epZNN.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $14VNY.jsx)("span", {
        css: [
            fadeStyles,
            (0, $2itye.getIconStyle)({
                spacing: spacing
            }),
            $d0882544ffca4318$var$getSpacingFix(children, $d0882544ffca4318$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $d0882544ffca4318$var$getChildren(children, [
        fadeStyles,
        (0, $2itye.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $14VNY.jsx)("span", {
        css: [
            fadeStyles,
            (0, $2itye.getIconStyle)({
                spacing: spacing
            }),
            $d0882544ffca4318$var$getSpacingFix(children, $d0882544ffca4318$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $14VNY.jsx)("span", {
        css: [
            (0, $2itye.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});

});
parcelRegister("1Muvn", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", function () { return $14c1efccd710ba20$export$a4687b0234b40e28; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $gvAuA = parcelRequire("gvAuA");

var $gCnIo = parcelRequire("gCnIo");
function $14c1efccd710ba20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $14c1efccd710ba20$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $14c1efccd710ba20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $14c1efccd710ba20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $14c1efccd710ba20$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $gvAuA.useAnalyticsEvents)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $gCnIo.useTrackedRef)(analyticsData);
    var fnRef = (0, $gCnIo.useTrackedRef)(fn);
    var handler = (0, $8ZuGG.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $14c1efccd710ba20$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire("atlaskit");
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("gvAuA", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", function () { return $c04bd93a7d607136$export$5bf35293e545f20c; });

var $bzd3R = parcelRequire("bzd3R");

var $ky16a = parcelRequire("ky16a");

var $ltvlR = parcelRequire("ltvlR");
function $c04bd93a7d607136$export$5bf35293e545f20c() {
    var analyticsContext = (0, $ltvlR.useAnalyticsContext)();
    var createAnalyticsEvent = (0, $bzd3R.useCallbackOne)(function(payload) {
        return new (0, $ky16a.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("ky16a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef57d5c6bc88c36e$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5T1eV = parcelRequire("5T1eV");

var $c3k3z = parcelRequire("c3k3z");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $6bkHe = parcelRequire("6bkHe");

var $9zGER = parcelRequire("9zGER");
function $ef57d5c6bc88c36e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ef57d5c6bc88c36e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, result);
    };
}
function $ef57d5c6bc88c36e$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ef57d5c6bc88c36e$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $ef57d5c6bc88c36e$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $ef57d5c6bc88c36e$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "UIAnalyticsEvent";
};
var $ef57d5c6bc88c36e$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $ef57d5c6bc88c36e$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($5T1eV)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c3k3z)))((0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $9zGER.default));

});
parcelRegister("9zGER", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f8878f698fcbfe6$export$2e2bcd8739ae039; });

var $cd8Dz = parcelRequire("cd8Dz");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");
function $6f8878f698fcbfe6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f8878f698fcbfe6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f8878f698fcbfe6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f8878f698fcbfe6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $6f8878f698fcbfe6$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $6f8878f698fcbfe6$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === "AnalyticsEvent";
};
var $6f8878f698fcbfe6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $6f8878f698fcbfe6$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === "function") this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(updater) === "object") this.payload = $6f8878f698fcbfe6$var$_objectSpread($6f8878f698fcbfe6$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();

});


parcelRegister("ltvlR", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", function () { return $fa24a0320ce6fa73$export$d1f587f82ad51c4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $akh0H = parcelRequire("akh0H");
var $fa24a0320ce6fa73$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $8ZuGG.useContext)((0, $akh0H.default));
};

});


parcelRegister("gCnIo", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", function () { return $031f448105c6bcc9$export$1d27a74659855e44; });

var $8ZuGG = parcelRequire("8ZuGG");
var $031f448105c6bcc9$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $8ZuGG.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("c7GPs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8d375c6a35c21f31$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");
function $8d375c6a35c21f31$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $8ZuGG.useRef)(true);
    (0, $8ZuGG.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("c3Xui", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8c83e8df1da8eed5$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");
var $8c83e8df1da8eed5$var$BORDER_WIDTH = 2;
var $8c83e8df1da8eed5$var$baseFocusOutsideStyles = (0, $14VNY.css)({
    outline: "".concat($8c83e8df1da8eed5$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $8c83e8df1da8eed5$var$BORDER_WIDTH
});
var $8c83e8df1da8eed5$var$baseInsetStyles = (0, $14VNY.css)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    outlineOffset: -$8c83e8df1da8eed5$var$BORDER_WIDTH,
    outlineStyle: "solid",
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $8c83e8df1da8eed5$var$focusRingStyles = (0, $14VNY.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $8c83e8df1da8eed5$var$baseFocusOutsideStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $8c83e8df1da8eed5$var$baseFocusOutsideStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $8c83e8df1da8eed5$var$insetFocusRingStyles = (0, $14VNY.css)({
    // Focus styles used when :focus-visible isn't supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus": $8c83e8df1da8eed5$var$baseInsetStyles,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
    "&:focus-visible": $8c83e8df1da8eed5$var$baseInsetStyles,
    // Remove default focus styles for mouse interactions if :focus-visible is supported
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid",
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
            outlineOffset: "-1px"
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $8c83e8df1da8eed5$var$FocusRing = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $8c83e8df1da8eed5$var$baseInsetStyles : $8c83e8df1da8eed5$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $8c83e8df1da8eed5$var$insetFocusRingStyles : $8c83e8df1da8eed5$var$focusRingStyles;
    var focusCls = typeof focus === "undefined" ? uncontrolledStyles : focus === "on" && controlledStyles;
    return (0, $14VNY.jsx)((0, $14VNY.ClassNames), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $8ZuGG.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $8ZuGG.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$8c83e8df1da8eed5$var$FocusRing.displayName = "FocusRing";
var $8c83e8df1da8eed5$export$2e2bcd8739ae039 = $8c83e8df1da8eed5$var$FocusRing;

});

parcelRegister("epZNN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a7f3571866e8690a$export$2e2bcd8739ae039; });
function $a7f3571866e8690a$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $a7f3571866e8690a$var$tabKeyCode = 9;
function $a7f3571866e8690a$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $a7f3571866e8690a$var$tabKeyCode) return;
    $a7f3571866e8690a$var$abort(event);
}
var $a7f3571866e8690a$var$block = {
    onMouseDownCapture: $a7f3571866e8690a$var$abort,
    onMouseUpCapture: $a7f3571866e8690a$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $a7f3571866e8690a$var$onKey,
    onKeyUpCapture: $a7f3571866e8690a$var$onKey,
    onTouchStartCapture: $a7f3571866e8690a$var$abort,
    onTouchEndCapture: $a7f3571866e8690a$var$abort,
    onPointerDownCapture: $a7f3571866e8690a$var$abort,
    onPointerUpCapture: $a7f3571866e8690a$var$abort,
    onClickCapture: $a7f3571866e8690a$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $a7f3571866e8690a$var$abort
};
var $a7f3571866e8690a$var$doNotBlock = {};
function $a7f3571866e8690a$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $a7f3571866e8690a$var$doNotBlock : $a7f3571866e8690a$var$block;
}

});

parcelRegister("2itye", function(module, exports) {

$parcel$export(module.exports, "getCss", function () { return $1ac42f70122712cf$export$955358618f994a11; });
$parcel$export(module.exports, "getIconStyle", function () { return $1ac42f70122712cf$export$864eea3f4ec3368f; });
$parcel$export(module.exports, "getContentStyle", function () { return $1ac42f70122712cf$export$7ad0316cc0dd65a; });
$parcel$export(module.exports, "getFadingCss", function () { return $1ac42f70122712cf$export$1b5827d324e945b1; });
$parcel$export(module.exports, "overlayCss", function () { return $1ac42f70122712cf$export$1a9fe1b84c876bb5; });

var $6bkHe = parcelRequire("6bkHe");

var $14VNY = parcelRequire("14VNY");

var $5b7Z4 = parcelRequire("5b7Z4");

var $lSyBF = parcelRequire("lSyBF");
function $1ac42f70122712cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ac42f70122712cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ac42f70122712cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ac42f70122712cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1ac42f70122712cf$var$gridSize = (0, $5b7Z4.gridSize)();
var $1ac42f70122712cf$var$fontSize = (0, $5b7Z4.fontSize)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $1ac42f70122712cf$var$heights = {
    default: "".concat($1ac42f70122712cf$var$gridSize * 4 / $1ac42f70122712cf$var$fontSize, "em"),
    // 32px
    compact: "".concat($1ac42f70122712cf$var$gridSize * 3 / $1ac42f70122712cf$var$fontSize, "em"),
    none: "auto"
};
var $1ac42f70122712cf$var$lineHeights = {
    default: $1ac42f70122712cf$var$heights.default,
    compact: $1ac42f70122712cf$var$heights.compact,
    none: "inherit"
};
var $1ac42f70122712cf$var$padding = {
    // 10px gutter
    default: "0 ".concat($1ac42f70122712cf$var$gridSize + $1ac42f70122712cf$var$gridSize / 4, "px"),
    compact: "0 ".concat($1ac42f70122712cf$var$gridSize + $1ac42f70122712cf$var$gridSize / 4, "px"),
    none: "0"
};
var $1ac42f70122712cf$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px"),
    default: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px"),
    none: "0"
};
var $1ac42f70122712cf$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $1ac42f70122712cf$var$innerMargin = {
    content: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px"),
    icon: "0 ".concat($1ac42f70122712cf$var$gridSize / 4, "px")
};
function $1ac42f70122712cf$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $1ac42f70122712cf$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $1ac42f70122712cf$var$getColor({
            group: (0, $lSyBF.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($1ac42f70122712cf$var$getColor({
            group: (0, $lSyBF.default).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $1ac42f70122712cf$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $1ac42f70122712cf$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, baseColors), {}, {
        cursor: "pointer",
        height: $1ac42f70122712cf$var$heights[spacing],
        lineHeight: $1ac42f70122712cf$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $1ac42f70122712cf$var$singleIconPadding[spacing] : $1ac42f70122712cf$var$padding[spacing],
        verticalAlign: $1ac42f70122712cf$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center",
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        "&:visited": $1ac42f70122712cf$var$_objectSpread({}, baseColors),
        "&:hover": $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $1ac42f70122712cf$var$_objectSpread($1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        }),
        '&[data-has-overlay="true"]': {
            cursor: "default",
            textDecoration: "none"
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $1ac42f70122712cf$var$_objectSpread({}, $1ac42f70122712cf$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        })),
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $1ac42f70122712cf$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $14VNY.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $1ac42f70122712cf$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $1ac42f70122712cf$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $14VNY.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === "none" ? 0 : $1ac42f70122712cf$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $1ac42f70122712cf$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $14VNY.css)({
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $1ac42f70122712cf$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

});
parcelRegister("lSyBF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fed97c43eb5a3952$export$2e2bcd8739ae039; });

var $kTdw7 = parcelRequire("kTdw7");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $fed97c43eb5a3952$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $fed97c43eb5a3952$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($kTdw7.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($kTdw7.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($kTdw7.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($fed97c43eb5a3952$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($kTdw7.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($kTdw7.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($kTdw7.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($kTdw7.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($kTdw7.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($kTdw7.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($kTdw7.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($kTdw7.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($kTdw7.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($kTdw7.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($kTdw7.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($kTdw7.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($kTdw7.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($kTdw7.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($kTdw7.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($kTdw7.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($kTdw7.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($kTdw7.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($kTdw7.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($kTdw7.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($fed97c43eb5a3952$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($kTdw7.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($kTdw7.N500, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($kTdw7.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($kTdw7.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($kTdw7.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($kTdw7.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-link, ".concat($kTdw7.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($kTdw7.B300, ")"),
                dark: "var(--ds-link, ".concat($kTdw7.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($kTdw7.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($kTdw7.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($kTdw7.N500, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($kTdw7.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($kTdw7.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($kTdw7.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($kTdw7.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($kTdw7.N400, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        }
    }
};
var $fed97c43eb5a3952$export$2e2bcd8739ae039 = $fed97c43eb5a3952$var$values;

});


parcelRegister("bJJt2", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", function () { return $88b72a924d2c352b$export$20bbd2efb0d734c4; });

var $8ZuGG = parcelRequire("8ZuGG");

var $73a5X = parcelRequire("73a5X");
var $88b72a924d2c352b$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $8ZuGG.isValidElement)(children) && children.type === (0, $73a5X.default);
};

});
parcelRegister("73a5X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5220a4e678d1b2dd$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $14VNY = parcelRequire("14VNY");
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $5220a4e678d1b2dd$var$visuallyHiddenStyles = (0, $14VNY.css)({
    width: "1px",
    height: "1px",
    padding: "0",
    position: "absolute",
    border: "0",
    clip: "rect(1px, 1px, 1px, 1px)",
    overflow: "hidden",
    whiteSpace: "nowrap"
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $5220a4e678d1b2dd$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $14VNY.jsx)("span", {
        id: id,
        "data-testid": testId,
        css: $5220a4e678d1b2dd$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $5220a4e678d1b2dd$export$2e2bcd8739ae039 = $5220a4e678d1b2dd$var$VisuallyHidden;

});



parcelRegister("7yjH4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57fafc2857d60eef$export$2e2bcd8739ae039; });

var $bJJt2 = parcelRequire("bJJt2");
function $57fafc2857d60eef$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $bJJt2.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});





parcelRegister("kOqgB", function(module, exports) {

$parcel$export(module.exports, "RESET_APP_STATE", function () { return $1cb941067523c0e3$export$83323797e38f210e; });
$parcel$export(module.exports, "createAppStore", function () { return $1cb941067523c0e3$export$38e7b01cdeec369; });
$parcel$export(module.exports, "useAppDispatch", function () { return $1cb941067523c0e3$export$f51d452c10d5b956; });
$parcel$export(module.exports, "useAppSelector", function () { return $1cb941067523c0e3$export$a7347740d65f620b; });

var $l2d2N = parcelRequire("l2d2N");
var $6jPF3 = parcelRequire("6jPF3");

var $9JIXI = parcelRequire("9JIXI");

var $3rl5T = parcelRequire("3rl5T");
parcelRequire("iBTcr");
var $7JtuM = parcelRequire("7JtuM");
var $5Hzdz = parcelRequire("5Hzdz");
const $1cb941067523c0e3$export$83323797e38f210e = "RESET_APP_STATE";
const $1cb941067523c0e3$var$rootReducer = (state, action)=>{
    const shouldResetAppState = action.type === $1cb941067523c0e3$export$83323797e38f210e;
    const stateToUpdate = shouldResetAppState ? action.data : state;
    return (0, $l2d2N.combineReducers)((0, $9JIXI.getReducers)())(stateToUpdate, action);
};
const $1cb941067523c0e3$export$38e7b01cdeec369 = (preloadedState = {})=>(0, $6jPF3.configureStore)({
        reducer: $1cb941067523c0e3$var$rootReducer,
        devTools: false,
        preloadedState: preloadedState,
        middleware: (getDefaultMiddleware)=>getDefaultMiddleware().concat((0, $3rl5T.idAuthMfaMiddleware))
    });
const $1cb941067523c0e3$export$f51d452c10d5b956 = (0, $7JtuM.useDispatch);
const $1cb941067523c0e3$export$a7347740d65f620b = (0, $5Hzdz.useSelector);

});
parcelRegister("9JIXI", function(module, exports) {

$parcel$export(module.exports, "getReducers", function () { return $d6a8a0c44cf114bb$export$cf167d5dfe57ae0e; });

var $6pUL0 = parcelRequire("6pUL0");

var $jK8gE = parcelRequire("jK8gE");

var $8qLQj = parcelRequire("8qLQj");

var $d4mUe = parcelRequire("d4mUe");

var $4WFiR = parcelRequire("4WFiR");

var $ifeUR = parcelRequire("ifeUR");

var $21hpi = parcelRequire("21hpi");

var $aQAdX = parcelRequire("aQAdX");

var $l84x7 = parcelRequire("l84x7");

var $fI9D6 = parcelRequire("fI9D6");

var $cpoyZ = parcelRequire("cpoyZ");

var $buoUv = parcelRequire("buoUv");

var $iDHkk = parcelRequire("iDHkk");

var $3kyMd = parcelRequire("3kyMd");

var $hl8FM = parcelRequire("hl8FM");

var $9CzTs = parcelRequire("9CzTs");

var $dsaG2 = parcelRequire("dsaG2");

var $hZmDj = parcelRequire("hZmDj");

var $1hNLb = parcelRequire("1hNLb");

var $esppu = parcelRequire("esppu");

var $ahjwY = parcelRequire("ahjwY");

var $4vAET = parcelRequire("4vAET");

var $4C2Pu = parcelRequire("4C2Pu");

var $anpN3 = parcelRequire("anpN3");

var $3C3OI = parcelRequire("3C3OI");

var $bi3GK = parcelRequire("bi3GK");

var $bkO8T = parcelRequire("bkO8T");

var $8qcih = parcelRequire("8qcih");

var $dM2jK = parcelRequire("dM2jK");

var $iQMCQ = parcelRequire("iQMCQ");

var $1hbh2 = parcelRequire("1hbh2");

var $6cf1M = parcelRequire("6cf1M");

var $h0rSo = parcelRequire("h0rSo");

var $glXWv = parcelRequire("glXWv");

var $kVXtB = parcelRequire("kVXtB");

var $wWEnh = parcelRequire("wWEnh");

var $4ZYno = parcelRequire("4ZYno");
const $d6a8a0c44cf114bb$export$cf167d5dfe57ae0e = ()=>({
        appConfig: $6pUL0.default,
        csrfToken: $l84x7.csrfToken,
        hashedCsrfToken: $l84x7.hashedCsrfToken,
        globalStateLoading: $4ZYno.default,
        login: $3kyMd.default,
        logout: $hl8FM.default,
        marketingConsent: $9CzTs.default,
        mfaEnrollment: $dsaG2.default,
        mfaPromote: $hZmDj.default,
        microbranding: $1hNLb.default,
        multiFactor: $ahjwY.default,
        recovery: $4C2Pu.default,
        resetPassword: $anpN3.default,
        signup: $bkO8T.default,
        user: $1hbh2.default,
        flags: $cpoyZ.default,
        continueAs: $21hpi.default,
        selectAccount: $3C3OI.default,
        cancelDeletion: $jK8gE.default,
        expiredPassword: $fI9D6.default,
        googleOneTap: $buoUv.default,
        changePassword: $d4mUe.default,
        changeEmail: $8qLQj.default,
        createAccount: $aQAdX.default,
        welcome: $kVXtB.default,
        context: $ifeUR.default,
        migrateConfirmation: $esppu.default,
        socialLoginRecovery: $8qcih.default,
        verifyEmail: $6cf1M.default,
        verifyEmailSent: $glXWv.default,
        serverError: $bi3GK.default,
        cobranding: $4WFiR.default,
        stepUp: $dM2jK.default,
        stepUpSso: $iQMCQ.default,
        welcomeSent: $4vAET.default,
        locale: $iDHkk.default,
        verifyEmailOtp: $h0rSo.default,
        loginConsent: $wWEnh.default
    });

});
parcelRegister("6pUL0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9fa1948989b34767$export$2e2bcd8739ae039; });
const $9fa1948989b34767$export$49d5fc8cba920a0 = {
    googleAuthClientId: "596149463257-9oquqfivs9on8t8erq23c8qso6vk3cp1.apps.googleusercontent.com",
    isSamlEnabled: true,
    recaptchaEnable: true,
    recaptchaEnterpriseCheckboxKeySite: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    recaptchaEnterpriseInvisibleKeySite: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    recaptchaEnterpriseScoreKeySite: "6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN",
    smsEnrollmentRecaptchaEnabled: true,
    smsEnrollmentRecaptchaEnterpriseInvisibleKeySite: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI",
    auth0Config: {
        domain: "auth-domain.dev.atlassian.com",
        clientId: "RJH00Zs94cwksZuhhkM133mJvmBA0NoQ",
        callbackUrl: "http://localhost:3000/login/callback",
        deferRules: {
            apple: {
                callbackUrl: "https://id.dev.internal.atlassian.com/login/apple/callback",
                clientId: "EtITLqX61hS0sxFzgMEwYYWHosfYHjgY"
            },
            microsoft: {
                callbackUrl: "https://id.dev.internal.atlassian.com/login/microsoft/callback",
                clientId: "3LDSJPtWZnovKS1gMCnKmp9Hk3iXlVEZ"
            },
            slack: {
                callbackUrl: "https://id.dev.internal.atlassian.com/login/slack/callback",
                clientId: "zKYyRODwsh165L0h41wALWAeqVfqDs0i"
            }
        }
    },
    contextPath: "",
    segmentIoKey: "",
    castlePublishableApiKey: ""
};
const $9fa1948989b34767$var$appConfig = (state = $9fa1948989b34767$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $9fa1948989b34767$export$2e2bcd8739ae039 = $9fa1948989b34767$var$appConfig;

});

parcelRegister("jK8gE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5059c1de7b8450b6$export$2e2bcd8739ae039; });
const $5059c1de7b8450b6$export$49d5fc8cba920a0 = {
    deleteOn: ""
};
const $5059c1de7b8450b6$var$cancelDeletion = (state = $5059c1de7b8450b6$export$49d5fc8cba920a0)=>{
    return state;
};
var $5059c1de7b8450b6$export$2e2bcd8739ae039 = $5059c1de7b8450b6$var$cancelDeletion;

});

parcelRegister("8qLQj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5a77c8fcbb3e9595$export$2e2bcd8739ae039; });
const $5a77c8fcbb3e9595$export$49d5fc8cba920a0 = {
    email: "",
    newEmail: "",
    error: null
};
const $5a77c8fcbb3e9595$var$changeEmail = (state = $5a77c8fcbb3e9595$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $5a77c8fcbb3e9595$export$2e2bcd8739ae039 = $5a77c8fcbb3e9595$var$changeEmail;

});

parcelRegister("d4mUe", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $8431b1ca71d9cd49$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $8431b1ca71d9cd49$export$2e2bcd8739ae039; });
const $8431b1ca71d9cd49$export$49d5fc8cba920a0 = {
    email: "",
    displayName: "",
    fieldErrors: {},
    isLoading: false
};
const $8431b1ca71d9cd49$var$changePassword = (state = $8431b1ca71d9cd49$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "CHANGE_PASSWORD_REQUEST_INITIATE":
            return {
                ...state,
                fieldErrors: {},
                isLoading: true,
                error: undefined
            };
        case "CHANGE_PASSWORD_REQUEST_SUCCESS":
            return {
                ...state,
                isLoading: false,
                error: undefined
            };
        case "CHANGE_PASSWORD_REQUEST_FAILED":
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        case "CHANGE_PASSWORD_REQUEST_FIELD_ERRORS":
            return {
                ...state,
                isLoading: false,
                fieldErrors: action.fieldErrors
            };
        default:
            return state;
    }
};
var $8431b1ca71d9cd49$export$2e2bcd8739ae039 = $8431b1ca71d9cd49$var$changePassword;

});

parcelRegister("4WFiR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cbe1d0c0c8e3bbaa$export$2e2bcd8739ae039; });
const $cbe1d0c0c8e3bbaa$export$49d5fc8cba920a0 = {};
const $cbe1d0c0c8e3bbaa$var$cobranding = (state = $cbe1d0c0c8e3bbaa$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $cbe1d0c0c8e3bbaa$export$2e2bcd8739ae039 = $cbe1d0c0c8e3bbaa$var$cobranding;

});

parcelRegister("ifeUR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $af3c7d62fe82984e$export$2e2bcd8739ae039; });
const $af3c7d62fe82984e$export$49d5fc8cba920a0 = {
    tenantCloudId: undefined
};
const $af3c7d62fe82984e$var$appConfig = (state = $af3c7d62fe82984e$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $af3c7d62fe82984e$export$2e2bcd8739ae039 = $af3c7d62fe82984e$var$appConfig;

});

parcelRegister("21hpi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4f555a91bb6aa8d6$export$2e2bcd8739ae039; });
const $4f555a91bb6aa8d6$export$49d5fc8cba920a0 = {
    displayName: "",
    email: "",
    avatarUrl: "",
    continueUrl: ""
};
const $4f555a91bb6aa8d6$var$continueAs = (state = $4f555a91bb6aa8d6$export$49d5fc8cba920a0)=>{
    return state;
};
var $4f555a91bb6aa8d6$export$2e2bcd8739ae039 = $4f555a91bb6aa8d6$var$continueAs;

});

parcelRegister("aQAdX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c55374ae0983c87$export$2e2bcd8739ae039; });
const $6c55374ae0983c87$export$49d5fc8cba920a0 = {
    formError: undefined,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false,
    source: undefined,
    loginType: undefined,
    displayName: undefined,
    email: undefined,
    accessToken: undefined,
    idToken: undefined,
    createNeeded: undefined,
    verifyNeeded: undefined,
    confirmationToken: undefined,
    mfaToken: undefined
};
const $6c55374ae0983c87$var$createAccount = (state = $6c55374ae0983c87$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "CONFIRMATION_RESET":
            return $6c55374ae0983c87$export$49d5fc8cba920a0;
        case "CONFIRMATION_REQUEST":
            return {
                ...state,
                fieldErrors: {},
                formError: undefined,
                isLoading: true
            };
        case "CONFIRMATION_REQUEST_SUCCESS":
            return {
                ...state,
                fieldErrors: {},
                isLoading: false,
                redirectTo: action.redirectTo
            };
        case "CONFIRMATION_RESEND_SUCCESS":
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        case "CONFIRMATION_REQUEST_FAILED":
            return {
                ...state,
                formError: action.error,
                isLoading: false
            };
        case "CONFIRMATION_SHOW_FIELD_ERROR":
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        default:
            return state;
    }
};
var $6c55374ae0983c87$export$2e2bcd8739ae039 = $6c55374ae0983c87$var$createAccount;

});

parcelRegister("l84x7", function(module, exports) {

$parcel$export(module.exports, "csrfToken", function () { return $ea0d14f1bc310c0d$export$c077d53e8672d0e9; });
$parcel$export(module.exports, "hashedCsrfToken", function () { return $ea0d14f1bc310c0d$export$e9eff156dd8b992; });
const $ea0d14f1bc310c0d$export$49d5fc8cba920a0 = "";
const $ea0d14f1bc310c0d$export$c077d53e8672d0e9 = (state = $ea0d14f1bc310c0d$export$49d5fc8cba920a0, action)=>{
    if (action.type === "CSRF_TOKEN_UPDATE") return action.csrfToken;
    return state;
};
const $ea0d14f1bc310c0d$export$e9eff156dd8b992 = (state = $ea0d14f1bc310c0d$export$49d5fc8cba920a0, action)=>{
    if (action.type === "HASHED_CSRF_TOKEN_UPDATE") return action.hashedCsrfToken;
    return state;
};

});

parcelRegister("fI9D6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $789ae73cf2bf42e5$export$2e2bcd8739ae039; });
const $789ae73cf2bf42e5$export$49d5fc8cba920a0 = {
    error: null,
    isLoading: false,
    isComplete: false
};
const $789ae73cf2bf42e5$var$expiredPassword = (state = $789ae73cf2bf42e5$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "EXPIRED_PASSWORD_RESET_REQUEST_INITIATE":
            return {
                ...state,
                error: null,
                isLoading: true,
                isComplete: false
            };
        case "EXPIRED_PASSWORD_RESET_REQUEST_SUCCESS":
            return {
                ...state,
                error: null,
                isLoading: false,
                isComplete: true
            };
        case "EXPIRED_PASSWORD_RESET_REQUEST_FAILED":
            return {
                ...state,
                error: action.error,
                isLoading: false,
                isComplete: true
            };
        default:
            return state;
    }
};
var $789ae73cf2bf42e5$export$2e2bcd8739ae039 = $789ae73cf2bf42e5$var$expiredPassword;

});

parcelRegister("cpoyZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4826b8a8b0e3d519$export$2e2bcd8739ae039; });
const $4826b8a8b0e3d519$export$49d5fc8cba920a0 = {
    flags: []
};
var $4826b8a8b0e3d519$export$2e2bcd8739ae039 = (state = $4826b8a8b0e3d519$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "FLAG_ADD":
            return {
                ...state,
                flags: [
                    action.flag,
                    ...state.flags
                ]
            };
        case "FLAG_DISMISS":
            return {
                ...state,
                flags: state.flags.slice(1)
            };
        default:
            return state;
    }
};

});

parcelRegister("buoUv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e076259435b5b83a$export$2e2bcd8739ae039; });
const $e076259435b5b83a$export$49d5fc8cba920a0 = {
    dismissed: false
};
const $e076259435b5b83a$var$googleOneTap = (state = $e076259435b5b83a$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "GOOGLE_ONE_TAP_DISMISS":
            return {
                ...state,
                dismissed: true
            };
        default:
            return state;
    }
};
var $e076259435b5b83a$export$2e2bcd8739ae039 = $e076259435b5b83a$var$googleOneTap;

});

parcelRegister("iDHkk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3883dd85449954f1$export$2e2bcd8739ae039; });
const $3883dd85449954f1$export$49d5fc8cba920a0 = "en";
const $3883dd85449954f1$var$locale = (state = $3883dd85449954f1$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $3883dd85449954f1$export$2e2bcd8739ae039 = $3883dd85449954f1$var$locale;

});

parcelRegister("3kyMd", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $489d972a406afd03$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $489d972a406afd03$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $489d972a406afd03$export$49d5fc8cba920a0 = {
    isUsernameChecked: false,
    passwordless: (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
    isCaptchaRequired: false,
    isCheckingUsername: false,
    isErrorShown: false,
    fieldErrors: {},
    isLoggingIn: false,
    redirectUrl: "",
    redirectType: null,
    restrictedEmail: false,
    nextAttempt: 1,
    showResetHint: false,
    usernameExists: false,
    isSocialBlocked: false
};
const $489d972a406afd03$var$login = (state = $489d972a406afd03$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "LOGIN_REQUEST_CHECK_USERNAME":
            return {
                ...state,
                isCheckingUsername: true,
                isErrorShown: false,
                fieldErrors: {},
                identities: undefined
            };
        case "LOGIN_REQUEST_CHECK_USERNAME_REDIRECT":
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: false,
                usernameExists: true,
                redirectUrl: action.redirectUrl,
                redirectType: action.redirectType,
                passwordless: (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            };
        case "LOGIN_REQUEST_CHECK_USERNAME_SIGNUP":
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: false,
                redirectUrl: "",
                redirectType: null,
                passwordless: (0, $8dHAc.CheckUserNamePasswordlessType).Disallowed,
                isSocialBlocked: false
            };
        case "LOGIN_REQUEST_CHECK_USERNAME_NO_ACTION":
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: "",
                redirectType: null,
                passwordless: action.passwordless,
                isSocialBlocked: action.social === "disallowed"
            };
        case "LOGIN_REQUEST_CHECK_USERNAME_SOCIAL_LOGIN":
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: false,
                fieldErrors: {},
                isUsernameChecked: true,
                usernameExists: true,
                redirectUrl: "",
                redirectType: null,
                passwordless: action.passwordless,
                identities: action.identities,
                isSocialBlocked: false
            };
        case "LOGIN_REQUEST_CHECK_USERNAME_FAILED":
            return {
                ...state,
                isErrorShown: false,
                isCheckingUsername: false,
                fieldErrors: {
                    email: action.error
                }
            };
        case "LOGIN_REQUEST_CHECK_USERNAME_ERROR":
            return {
                ...state,
                isCheckingUsername: false,
                isErrorShown: true,
                error: action.error
            };
        case "LOGIN_RESET":
            return {
                ...state,
                isCaptchaRequired: false,
                isSocialBlocked: false,
                isUsernameChecked: false,
                usernameExists: false,
                isErrorShown: false,
                nextAttempt: 1,
                fieldErrors: {},
                identities: undefined
            };
        case "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN":
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            };
        case "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_FAILED":
            return {
                ...state,
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            };
        case "LOGIN_REQUEST_USERNAME_PASSWORD_LOGIN_SUCCESS":
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            };
        case "LOGIN_REQUEST_PASSWORDLESS_LOGIN":
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: true,
                fieldErrors: {}
            };
        case "LOGIN_REQUEST_PASSWORDLESS_LOGIN_FAILED":
            return {
                ...state,
                isErrorShown: true,
                isLoggingIn: false,
                error: action.error
            };
        case "LOGIN_REQUEST_PASSWORDLESS_LOGIN_SUCCESS":
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {}
            };
        case "LOGIN_REDIRECT_USER":
            return {
                ...state,
                isErrorShown: false,
                isLoggingIn: false,
                fieldErrors: {},
                redirectUrl: action.redirectUrl
            };
        case "LOGIN_SHOW_LOGIN_FORM_ERRORS":
            return {
                ...state,
                fieldErrors: action.errors
            };
        case "UPDATE_LOGIN_ATTEMPT_DETAILS":
            return {
                ...state,
                nextAttempt: action.nextAttempt
            };
        case "LOGIN_UPDATE_CAPTCHA_REQUIREMENT":
            return {
                ...state,
                isCaptchaRequired: action.isCaptchaRequired
            };
        case "LOGIN_SET_STATE":
            var _action_state_login, _action_state_login1, _action_state_login2, _action_state_login3;
            return {
                ...state,
                ...((_action_state_login = action.state.login) === null || _action_state_login === void 0 ? void 0 : _action_state_login.error) && {
                    error: action.state.login.error
                },
                ...((_action_state_login1 = action.state.login) === null || _action_state_login1 === void 0 ? void 0 : _action_state_login1.fieldErrors) && {
                    fieldErrors: action.state.login.fieldErrors
                },
                ...((_action_state_login2 = action.state.login) === null || _action_state_login2 === void 0 ? void 0 : _action_state_login2.recoveryToken) && {
                    recoveryToken: (_action_state_login3 = action.state.login) === null || _action_state_login3 === void 0 ? void 0 : _action_state_login3.recoveryToken
                }
            };
        default:
            return state;
    }
};
var $489d972a406afd03$export$2e2bcd8739ae039 = $489d972a406afd03$var$login;

});
parcelRegister("8dHAc", function(module, exports) {

$parcel$export(module.exports, "CheckUserNameRedirectType", function () { return $1c8c8623224b2159$export$8ef54b27f2e9d22a; });
$parcel$export(module.exports, "CheckUserNamePasswordlessType", function () { return $1c8c8623224b2159$export$b660b4f2246928fd; });
$parcel$export(module.exports, "SocialProvider", function () { return $1c8c8623224b2159$export$9368509e79aec5d3; });
$parcel$export(module.exports, "OidcDisplay", function () { return $1c8c8623224b2159$export$979d11be6cba8f4d; });
$parcel$export(module.exports, "VerificationType", function () { return $1c8c8623224b2159$export$ca9df54f128b4fc3; });
$parcel$export(module.exports, "VerifyOrReverifyEmailError", function () { return $1c8c8623224b2159$export$900620e02700dc8d; });
$parcel$export(module.exports, "EmailConfirmationError", function () { return $1c8c8623224b2159$export$3ea6b5c03372ccee; });
$parcel$export(module.exports, "WelcomeError", function () { return $1c8c8623224b2159$export$b3e1628b2fcac0ef; });
$parcel$export(module.exports, "WelcomeSentError", function () { return $1c8c8623224b2159$export$8681a4e3b8216bf1; });
$parcel$export(module.exports, "RedirectType", function () { return $1c8c8623224b2159$export$901f7b7cba88b6fd; });
$parcel$export(module.exports, "MfaFlow", function () { return $1c8c8623224b2159$export$dfa50caeee289030; });
$parcel$export(module.exports, "KnownRecoveryEmailErrorReasons", function () { return $1c8c8623224b2159$export$617703099de92392; });
var $1c8c8623224b2159$export$8ef54b27f2e9d22a;
(function(CheckUserNameRedirectType) {
    CheckUserNameRedirectType["Sso"] = "sso";
    CheckUserNameRedirectType["EmailSent"] = "email_sent";
})($1c8c8623224b2159$export$8ef54b27f2e9d22a || ($1c8c8623224b2159$export$8ef54b27f2e9d22a = {}));
var $1c8c8623224b2159$export$b660b4f2246928fd;
(function(CheckUserNamePasswordlessType) {
    CheckUserNamePasswordlessType["Disallowed"] = "disallowed";
    CheckUserNamePasswordlessType["Allowed"] = "allowed";
})($1c8c8623224b2159$export$b660b4f2246928fd || ($1c8c8623224b2159$export$b660b4f2246928fd = {}));
var $1c8c8623224b2159$export$9368509e79aec5d3;
(function(SocialProvider) {
    SocialProvider["Google"] = "google";
    SocialProvider["Microsoft"] = "microsoft";
    SocialProvider["Apple"] = "apple";
    SocialProvider["Slack"] = "slack";
})($1c8c8623224b2159$export$9368509e79aec5d3 || ($1c8c8623224b2159$export$9368509e79aec5d3 = {}));
var $1c8c8623224b2159$export$979d11be6cba8f4d;
(function(OidcDisplay) {
    OidcDisplay["Login"] = "login";
    OidcDisplay["Signup"] = "signup";
    OidcDisplay["Continue"] = "continue";
    OidcDisplay["LoginWithRedirect"] = "login_with_redirect";
    OidcDisplay["Reverify"] = "reverify";
    OidcDisplay["ManageSessions"] = "manage_sessions";
})($1c8c8623224b2159$export$979d11be6cba8f4d || ($1c8c8623224b2159$export$979d11be6cba8f4d = {}));
var $1c8c8623224b2159$export$ca9df54f128b4fc3;
(function(VerificationType) {
    VerificationType["Verify"] = "verify";
    VerificationType["VerifyWithSoftSession"] = "verifyWithSoftSession";
    VerificationType["Reverify"] = "reverify";
})($1c8c8623224b2159$export$ca9df54f128b4fc3 || ($1c8c8623224b2159$export$ca9df54f128b4fc3 = {}));
var $1c8c8623224b2159$export$900620e02700dc8d;
(function(VerifyOrReverifyEmailError) {
    VerifyOrReverifyEmailError["ExpiredToken"] = "expired_token_error";
    VerifyOrReverifyEmailError["InvalidToken"] = "invalid_token_error";
    VerifyOrReverifyEmailError["RateLimitExceeded"] = "ratelimit_exceeded_error";
})($1c8c8623224b2159$export$900620e02700dc8d || ($1c8c8623224b2159$export$900620e02700dc8d = {}));
var $1c8c8623224b2159$export$3ea6b5c03372ccee;
(function(EmailConfirmationError) {
    EmailConfirmationError["InvalidPassword"] = "invalid_password";
    EmailConfirmationError["InvalidToken"] = "invalid_token";
})($1c8c8623224b2159$export$3ea6b5c03372ccee || ($1c8c8623224b2159$export$3ea6b5c03372ccee = {}));
var $1c8c8623224b2159$export$b3e1628b2fcac0ef;
(function(WelcomeError) {
    WelcomeError["RateLimitExceeded"] = "rate_limit_exceeded";
})($1c8c8623224b2159$export$b3e1628b2fcac0ef || ($1c8c8623224b2159$export$b3e1628b2fcac0ef = {}));
var $1c8c8623224b2159$export$8681a4e3b8216bf1;
(function(WelcomeSentError) {
    WelcomeSentError["ExpiredToken"] = "expired_token";
    WelcomeSentError["InvalidToken"] = "invalid_token";
})($1c8c8623224b2159$export$8681a4e3b8216bf1 || ($1c8c8623224b2159$export$8681a4e3b8216bf1 = {}));
var $1c8c8623224b2159$export$901f7b7cba88b6fd;
(function(RedirectType) {
    RedirectType["ResumeMigration"] = "resume_migration";
    RedirectType["Migration"] = "migration";
    RedirectType["Signup"] = "signup";
    RedirectType["ResumeSignup"] = "resume_signup";
    RedirectType["Invite"] = "invite";
})($1c8c8623224b2159$export$901f7b7cba88b6fd || ($1c8c8623224b2159$export$901f7b7cba88b6fd = {}));
var $1c8c8623224b2159$export$12df27b025e392f8;
(function(SecurityKeyAuthenticatorAttachment) {
    SecurityKeyAuthenticatorAttachment["Platform"] = "platform";
    SecurityKeyAuthenticatorAttachment["CrossPlatform"] = "cross-platform";
})($1c8c8623224b2159$export$12df27b025e392f8 || ($1c8c8623224b2159$export$12df27b025e392f8 = {}));
var $1c8c8623224b2159$export$dfa50caeee289030;
(function(MfaFlow) {
    MfaFlow["Sms"] = "sms";
    MfaFlow["Totp"] = "totp";
    MfaFlow["SecurityKey"] = "security_key";
})($1c8c8623224b2159$export$dfa50caeee289030 || ($1c8c8623224b2159$export$dfa50caeee289030 = {}));
const $1c8c8623224b2159$export$617703099de92392 = [
    "userNotFound",
    "userIsManaged",
    "alreadyRequested"
];

});


parcelRegister("hl8FM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d22842a4865a4fd9$export$2e2bcd8739ae039; });
const $d22842a4865a4fd9$export$49d5fc8cba920a0 = {
    autoSubmit: false
};
const $d22842a4865a4fd9$var$logout = (state = $d22842a4865a4fd9$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $d22842a4865a4fd9$export$2e2bcd8739ae039 = $d22842a4865a4fd9$var$logout;

});

parcelRegister("9CzTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04113fe52f7d911f$export$2e2bcd8739ae039; });
const $04113fe52f7d911f$export$49d5fc8cba920a0 = {
    config: undefined
};
const $04113fe52f7d911f$var$marketingConsent = (state = $04113fe52f7d911f$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "UPDATE_MARKETING_CONSENT_CONFIG":
            return {
                ...state,
                config: action.config
            };
        default:
            return state;
    }
};
var $04113fe52f7d911f$export$2e2bcd8739ae039 = $04113fe52f7d911f$var$marketingConsent;

});

parcelRegister("dsaG2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $06f8df9022125542$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $06f8df9022125542$export$49d5fc8cba920a0 = {
    invalid: false,
    enrollStarted: false,
    enrollConfirmed: false,
    token: "",
    redirectUrl: null,
    recoveryCode: null,
    transactionToken: null,
    unsupportedCountries: []
};
var $06f8df9022125542$export$2e2bcd8739ae039 = (state = $06f8df9022125542$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "START_ENROLL":
            return {
                ...state,
                token: action.token,
                mfaFlow: (0, $8dHAc.MfaFlow).Totp
            };
        case "START_ENROLL_RESPONSE":
            return {
                ...state,
                enrollStarted: true,
                transactionToken: action.transactionToken,
                emailAddress: action.emailAddress,
                totpSecret: action.totpSecret,
                recoveryCode: action.recoveryCode,
                totpUri: action.totpUri
            };
        case "CONFIRM_ENROLL":
            return {
                ...state,
                confirmingEnroll: true,
                invalid: false
            };
        case "CONFIRM_ENROLL_RESPONSE":
            return {
                ...state,
                enrollConfirmed: true,
                confirmingEnroll: false,
                redirectUrl: action.redirectUrl
            };
        case "CONFIRM_ENROLL_ERROR":
            return {
                ...state,
                confirmingEnroll: false,
                invalid: true
            };
        case "START_SMS_ENROLL":
            return {
                ...state,
                token: action.token,
                phoneNumber: action.phoneNumber,
                mfaFlow: (0, $8dHAc.MfaFlow).Sms
            };
        case "START_SMS_ENROLL_RESPONSE":
            return {
                ...state,
                transactionToken: action.transactionToken,
                recoveryCode: action.recoveryCode,
                smsEnrollError: null,
                phoneNumber: action.phoneNumber
            };
        case "START_SMS_ENROLL_ERROR":
            return {
                ...state,
                smsEnrollError: action.smsEnrollError,
                transactionToken: null,
                recoveryCode: null
            };
        case "UPDATE_SMS_ENROLLMENT_UNSUPPORTED_COUNTRIES":
            return {
                ...state,
                unsupportedCountries: action.unsupportedCountries
            };
        case "RESET_SMS_ENROLL_ERROR":
            return {
                ...state,
                smsEnrollError: null
            };
        case "START_SECURITY_KEY_ENROLL":
            return {
                ...state,
                token: action.token,
                mfaFlow: (0, $8dHAc.MfaFlow).SecurityKey
            };
        case "CONFIRM_SECURITY_KEY_ENROLLMENT":
            return {
                ...state,
                recoveryCode: action.recoveryCode
            };
        default:
            return state;
    }
};

});

parcelRegister("hZmDj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da8b36f53fba7ae2$export$2e2bcd8739ae039; });
const $da8b36f53fba7ae2$export$49d5fc8cba920a0 = {
    redirectTo: null
};
var $da8b36f53fba7ae2$export$2e2bcd8739ae039 = (state = $da8b36f53fba7ae2$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "MFA_PROMOTE_REDIRECT":
            return {
                ...state,
                redirectTo: action.redirectTo
            };
        default:
            return state;
    }
};

});

parcelRegister("1hNLb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a427087b2ba04847$export$2e2bcd8739ae039; });
const $a427087b2ba04847$export$49d5fc8cba920a0 = {
    oidcContext: undefined,
    isEmbedded: false,
    isAnyMobile: false,
    isMobileApp: false,
    screenSize: "unknown"
};
const $a427087b2ba04847$var$microbranding = (state = $a427087b2ba04847$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "MICROBRANDING_UPDATE":
            return {
                ...state,
                ...action.microbranding
            };
        case "SCREEN_SIZE_UPDATED":
            return {
                ...state,
                screenSize: action.screenSize
            };
        default:
            return state;
    }
};
var $a427087b2ba04847$export$2e2bcd8739ae039 = $a427087b2ba04847$var$microbranding;

});

parcelRegister("esppu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f4d63e1c3ff9f132$export$2e2bcd8739ae039; });
const $f4d63e1c3ff9f132$export$49d5fc8cba920a0 = {
    redirectTo: ""
};
const $f4d63e1c3ff9f132$var$migrateConfirmation = (state = $f4d63e1c3ff9f132$export$49d5fc8cba920a0)=>{
    return state;
};
var $f4d63e1c3ff9f132$export$2e2bcd8739ae039 = $f4d63e1c3ff9f132$var$migrateConfirmation;

});

parcelRegister("ahjwY", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $c238b5af5f606471$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $c238b5af5f606471$export$2e2bcd8739ae039; });
const $c238b5af5f606471$export$49d5fc8cba920a0 = {
    email: "",
    fieldErrors: {},
    isLoading: false,
    isManaged: true,
    isRecoveryEmailSent: false
};
var $c238b5af5f606471$export$2e2bcd8739ae039 = (state = $c238b5af5f606471$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "MFA_VERIFICATION_VERIFY":
            return {
                ...state,
                fieldErrors: {},
                isLoading: true
            };
        case "MFA_VERIFICATION_RECOVER":
            return {
                ...state,
                fieldErrors: {},
                isLoading: true
            };
        case "MFA_VERIFICATION_RECOVER_RESPONSE":
            return {
                ...state,
                recoveryCode: action.recoveryCode
            };
        case "MFA_VERIFICATION_VERIFY_ERROR":
            return {
                ...state,
                isLoading: false,
                fieldErrors: {
                    otpCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            };
        case "MFA_VERIFICATION_RECOVER_ERROR":
            return {
                ...state,
                isLoading: false,
                fieldErrors: {
                    recoveryCode: {
                        errorCode: action.errorCode,
                        message: action.message
                    }
                }
            };
        case "RECOVERY_EMAIL_SENT":
            return {
                ...state,
                isRecoveryEmailSent: true
            };
        case "RECOVERY_EMAIL_START":
            return {
                ...state,
                recoveryEmailError: undefined
            };
        case "RECOVERY_EMAIL_ERROR":
            return {
                ...state,
                recoveryEmailError: action.reason
            };
        case "USER_MANAGED_STATUS":
            return {
                ...state,
                isManaged: action.isManaged
            };
        default:
            return state;
    }
};

});

parcelRegister("4vAET", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $000d60a75afddc68$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $000d60a75afddc68$export$49d5fc8cba920a0 = {
    error: null,
    email: "",
    redirectType: (0, $8dHAc.RedirectType).ResumeMigration,
    showBrowserWarning: false
};
const $000d60a75afddc68$var$welcomeSent = (state = $000d60a75afddc68$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $000d60a75afddc68$export$2e2bcd8739ae039 = $000d60a75afddc68$var$welcomeSent;

});

parcelRegister("4C2Pu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d340bb96d5d24516$export$2e2bcd8739ae039; });
const $d340bb96d5d24516$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    redirectTo: null,
    isLoading: false
};
const $d340bb96d5d24516$var$recovery = (state = $d340bb96d5d24516$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "TSV_RECOVERY_RESET":
            return $d340bb96d5d24516$export$49d5fc8cba920a0;
        case "TSV_RECOVERY_LOGIN_REQUEST_LINK_REDIRECT":
            return {
                ...state,
                fieldErrors: {},
                error: null,
                redirectTo: action.redirectTo,
                isLoading: true
            };
        case "TSV_RECOVERY_REQUEST_FAILED":
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case "TSV_RECOVERY_SHOW_FIELD_ERRORS":
            return {
                ...state,
                fieldErrors: action.error,
                isLoading: false
            };
        default:
            return state;
    }
};
var $d340bb96d5d24516$export$2e2bcd8739ae039 = $d340bb96d5d24516$var$recovery;

});

parcelRegister("anpN3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f490eae4ef3e9b73$export$2e2bcd8739ae039; });
const $f490eae4ef3e9b73$export$49d5fc8cba920a0 = {
    error: undefined,
    fieldErrors: {},
    isLoading: false,
    isSent: false
};
const $f490eae4ef3e9b73$var$resetPassword = (state = $f490eae4ef3e9b73$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "RESET_PASSWORD_RESET":
            return {
                ...state,
                error: undefined,
                isLoading: false,
                isSent: false
            };
        case "RESET_PASSWORD_REQUEST_LINK":
            return {
                ...state,
                error: undefined,
                isLoading: true,
                isSent: false
            };
        case "RESET_PASSWORD_REQUEST_LINK_SUCCESS":
            return {
                ...state,
                error: undefined,
                isLoading: false,
                isSent: true
            };
        // TODO: Clean up legacy https://hello.jira.atlassian.cloud/browse/KIRBY-6709
        case "RESET_PASSWORD_REQUEST_LINK_REDIRECT":
            return {
                ...state,
                error: undefined,
                isLoading: true,
                isSent: false,
                redirectTo: action.redirectTo
            };
        case "RESET_PASSWORD_ERROR":
            return {
                ...state,
                error: action.error,
                isLoading: false,
                isSent: false
            };
        case "RESET_PASSWORD_REQUEST_LINK_FAILED_WITH_FIELD_ERRORS":
            return {
                ...state,
                fieldErrors: action.fieldErrors,
                isLoading: false,
                isSent: false
            };
        default:
            return state;
    }
};
var $f490eae4ef3e9b73$export$2e2bcd8739ae039 = $f490eae4ef3e9b73$var$resetPassword;

});

parcelRegister("3C3OI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0abf4fb31d475c6b$export$2e2bcd8739ae039; });
const $0abf4fb31d475c6b$export$49d5fc8cba920a0 = {
    sessions: null
};
const $0abf4fb31d475c6b$var$selectAccount = (state = $0abf4fb31d475c6b$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "SESSION_REQUEST":
            return {
                ...state,
                isLoading: true
            };
        default:
            return state;
    }
};
var $0abf4fb31d475c6b$export$2e2bcd8739ae039 = $0abf4fb31d475c6b$var$selectAccount;

});

parcelRegister("bi3GK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34a980e8861d21d1$export$2e2bcd8739ae039; });
const $34a980e8861d21d1$export$49d5fc8cba920a0 = null;
const $34a980e8861d21d1$var$serverErrorReducer = (state = $34a980e8861d21d1$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "SERVER_ERROR_UPDATE":
            return action.error;
        default:
            return state;
    }
};
var $34a980e8861d21d1$export$2e2bcd8739ae039 = $34a980e8861d21d1$var$serverErrorReducer;

});

parcelRegister("bkO8T", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $439f074b443cfef8$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $439f074b443cfef8$export$2e2bcd8739ae039; });
const $439f074b443cfef8$export$49d5fc8cba920a0 = {
    error: null,
    fieldErrors: {},
    isLoading: false,
    redirectTo: null,
    autoSubmit: false
};
const $439f074b443cfef8$var$signup = (state = $439f074b443cfef8$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "SIGNUP_RESET":
            return $439f074b443cfef8$export$49d5fc8cba920a0;
        case "SIGNUP_REQUEST":
            return {
                ...state,
                error: null,
                fieldErrors: {},
                isLoading: true
            };
        case "SIGNUP_REQUEST_SUCCESS":
            return {
                ...state,
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            };
        case "SIGNUP_REQUEST_FAILED":
            return {
                ...state,
                error: action.error,
                isLoading: false
            };
        case "SIGNUP_SHOW_FIELD_ERRORS":
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        default:
            return state;
    }
};
var $439f074b443cfef8$export$2e2bcd8739ae039 = $439f074b443cfef8$var$signup;

});

parcelRegister("8qcih", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18453f779cffef32$export$2e2bcd8739ae039; });
const $18453f779cffef32$export$49d5fc8cba920a0 = {};
const $18453f779cffef32$var$socialLoginRecovery = (state = $18453f779cffef32$export$49d5fc8cba920a0)=>state;
var $18453f779cffef32$export$2e2bcd8739ae039 = $18453f779cffef32$var$socialLoginRecovery;

});

parcelRegister("dM2jK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fc8a8651526e14a6$export$2e2bcd8739ae039; });
const $fc8a8651526e14a6$export$49d5fc8cba920a0 = {
    email: "",
    mfaToken: "",
    orgName: null,
    token: null
};
const $fc8a8651526e14a6$var$stepUp = (state = $fc8a8651526e14a6$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "STEP_UP_RESEND_CODE_SUCCESS":
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        case "STEP_UP_SEND_CODE_SUCCESS":
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        case "STEP_UP_MFA_TOKEN_LOAD_FROM_SESSION_STORAGE":
            return {
                ...state,
                mfaToken: action.mfaToken
            };
        default:
            return state;
    }
};
var $fc8a8651526e14a6$export$2e2bcd8739ae039 = $fc8a8651526e14a6$var$stepUp;

});

parcelRegister("iQMCQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f20bd6d3f89ee761$export$2e2bcd8739ae039; });
const $f20bd6d3f89ee761$export$49d5fc8cba920a0 = {
    ssoRedirectUrl: undefined,
    idp: {
        trusted: false,
        humanReadableRedirectLocation: undefined
    }
};
const $f20bd6d3f89ee761$var$stepUpSso = (state = $f20bd6d3f89ee761$export$49d5fc8cba920a0, action)=>{
    return state;
};
var $f20bd6d3f89ee761$export$2e2bcd8739ae039 = $f20bd6d3f89ee761$var$stepUpSso;

});

parcelRegister("1hbh2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9429e0442dc84fe8$export$2e2bcd8739ae039; });
const $9429e0442dc84fe8$export$49d5fc8cba920a0 = {
    email: ""
};
const $9429e0442dc84fe8$var$user = (state = $9429e0442dc84fe8$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $9429e0442dc84fe8$export$2e2bcd8739ae039 = $9429e0442dc84fe8$var$user;

});

parcelRegister("6cf1M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ae566f4d66bd0634$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $ae566f4d66bd0634$export$49d5fc8cba920a0 = {
    verificationType: (0, $8dHAc.VerificationType).Verify,
    url: "#",
    error: (0, $8dHAc.VerifyOrReverifyEmailError).ExpiredToken
};
const $ae566f4d66bd0634$var$verifyEmail = (state = $ae566f4d66bd0634$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $ae566f4d66bd0634$export$2e2bcd8739ae039 = $ae566f4d66bd0634$var$verifyEmail;

});

parcelRegister("h0rSo", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $cb0b83e3166018bc$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $cb0b83e3166018bc$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $cb0b83e3166018bc$export$49d5fc8cba920a0 = {
    email: "",
    isLoading: false,
    redirectType: (0, $8dHAc.RedirectType).Signup
};
const $cb0b83e3166018bc$var$verifyEmailOtp = (state = $cb0b83e3166018bc$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "VERIFY_EMAIL_OTP_REQUEST":
            return {
                ...state,
                isLoading: true,
                error: undefined,
                redirectTo: undefined
            };
        case "VERIFY_EMAIL_OTP_SUCCESS":
            return {
                ...state,
                redirectTo: action.redirectTo
            };
        case "VERIFY_EMAIL_OTP_FAILURE":
            return {
                ...state,
                isLoading: false,
                error: action.error
            };
        case "VERIFY_EMAIL_OTP_SET_STATE":
            return {
                ...state,
                email: action.state.email
            };
        default:
            return state;
    }
};
var $cb0b83e3166018bc$export$2e2bcd8739ae039 = $cb0b83e3166018bc$var$verifyEmailOtp;

});

parcelRegister("glXWv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c9dcea1146adce0$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");
const $3c9dcea1146adce0$export$49d5fc8cba920a0 = {
    verificationType: (0, $8dHAc.VerificationType).Verify,
    showBrowserWarning: false
};
const $3c9dcea1146adce0$var$verifyEmailSent = (state = $3c9dcea1146adce0$export$49d5fc8cba920a0, action)=>{
    action.type;
    return state;
};
var $3c9dcea1146adce0$export$2e2bcd8739ae039 = $3c9dcea1146adce0$var$verifyEmailSent;

});

parcelRegister("kVXtB", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $1999ac8408786e31$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $1999ac8408786e31$export$2e2bcd8739ae039; });

var $8dHAc = parcelRequire("8dHAc");

var $60zme = parcelRequire("60zme");
const $1999ac8408786e31$export$49d5fc8cba920a0 = {
    error: null,
    formError: null,
    fieldErrors: {},
    isLoading: false,
    isMobile: (0, $60zme.detectClient)().atlassianMobileApp,
    redirectTo: null,
    redirectType: (0, $8dHAc.RedirectType).Migration,
    email: "",
    shouldSkipCaptcha: false
};
const $1999ac8408786e31$var$welcome = (state = $1999ac8408786e31$export$49d5fc8cba920a0, action)=>{
    switch(action.type){
        case "WELCOME_SIGNUP_RESET":
            return $1999ac8408786e31$export$49d5fc8cba920a0;
        case "WELCOME_SIGNUP_REQUEST":
            return {
                ...state,
                error: null,
                formError: null,
                fieldErrors: {},
                isLoading: true
            };
        case "WELCOME_SIGNUP_REQUEST_SUCCESS":
            return {
                ...state,
                isLoading: false,
                fieldErrors: {},
                redirectTo: action.redirectTo
            };
        case "WELCOME_SIGNUP_REQUEST_FAILED":
            return {
                ...state,
                error: null,
                formError: action.formError,
                isLoading: false
            };
        case "WELCOME_SIGNUP_SHOW_FIELD_ERRORS":
            return {
                ...state,
                fieldErrors: action.errors,
                isLoading: false
            };
        case "WELCOME_SIGNUP_SET_STATE":
            return {
                ...state,
                ...action.state.recoveryToken && {
                    recoveryToken: action.state.recoveryToken
                },
                redirectType: action.state.redirectType,
                shouldSkipCaptcha: action.state.shouldSkipCaptcha,
                email: action.state.email,
                ...action.state.displayName && {
                    displayName: action.state.displayName
                }
            };
        default:
            return state;
    }
};
var $1999ac8408786e31$export$2e2bcd8739ae039 = $1999ac8408786e31$var$welcome;

});
parcelRegister("60zme", function(module, exports) {

$parcel$export(module.exports, "detectClient", function () { return $5ed541b2c53df5a1$export$dbd7930c526235a3; });
const $5ed541b2c53df5a1$var$userAgent = navigator.userAgent || navigator.vendor || window.opera;
const $5ed541b2c53df5a1$export$b7eb5c075a7422f3 = ()=>{
    if (/windows phone/i.test($5ed541b2c53df5a1$var$userAgent)) return "windows phone";
    if (/android/i.test($5ed541b2c53df5a1$var$userAgent)) return "android";
    if (/iPad|iPhone|iPod/.test($5ed541b2c53df5a1$var$userAgent) && !window.MSStream) return "ios";
    return "unknown";
};
const $5ed541b2c53df5a1$export$dbd7930c526235a3 = ()=>{
    return {
        platform: $5ed541b2c53df5a1$export$b7eb5c075a7422f3(),
        atlassianMobileApp: /AtlassianMobileApp/i.test($5ed541b2c53df5a1$var$userAgent)
    };
};

});


parcelRegister("wWEnh", function(module, exports) {

$parcel$export(module.exports, "defaultState", function () { return $a152319138357f8c$export$49d5fc8cba920a0; });
$parcel$export(module.exports, "default", function () { return $a152319138357f8c$export$2e2bcd8739ae039; });
const $a152319138357f8c$export$49d5fc8cba920a0 = {
    consentType: undefined
};
const $a152319138357f8c$var$loginConsent = (state = $a152319138357f8c$export$49d5fc8cba920a0)=>{
    return state;
};
var $a152319138357f8c$export$2e2bcd8739ae039 = $a152319138357f8c$var$loginConsent;

});

parcelRegister("4ZYno", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bc7cb8cdfb2d8018$export$2e2bcd8739ae039; });
const $bc7cb8cdfb2d8018$var$globalStateLoading = (state = false, action)=>{
    if (action.type === "SET_GLOBAL_STATE_LOADING") return action.isLoading;
    return state;
};
var $bc7cb8cdfb2d8018$export$2e2bcd8739ae039 = $bc7cb8cdfb2d8018$var$globalStateLoading;

});


parcelRegister("3rl5T", function(module, exports) {

$parcel$export(module.exports, "idAuthMfaMiddleware", function () { return $4a0bd3d5ddd7886d$export$9c3b774af0e8f6c4; });

var $gyRZh = parcelRequire("gyRZh");

var $jSnDV = parcelRequire("jSnDV");

var $4yIkJ = parcelRequire("4yIkJ");

var $8f2pb = parcelRequire("8f2pb");

var $xe7jL = parcelRequire("xe7jL");

var $dZoLz = parcelRequire("dZoLz");

var $lk8Tl = parcelRequire("lk8Tl");
const $4a0bd3d5ddd7886d$export$9c3b774af0e8f6c4 = ({ dispatch: dispatch })=>(next)=>(action)=>{
            switch(action.type){
                case "MFA_VERIFICATION_VERIFY":
                    next(action);
                    // The action that calls fetch (/verify) and redirects
                    return dispatch($4a0bd3d5ddd7886d$export$5d2dfc489f5d5678(action));
                case "MFA_VERIFICATION_RESEND_OTP":
                    next(action);
                    // The action that calls fetch to resend OTP code
                    // Transport (i.e. via SMS or Email) is determined by the mfa token.
                    return dispatch($4a0bd3d5ddd7886d$export$6a7404e2291306ab(action));
                case "MFA_VERIFICATION_RECOVER":
                    next(action);
                    // The action that verifies recovery code
                    return dispatch($4a0bd3d5ddd7886d$export$d76d4fe28235a83(action));
                case "MFA_VERIFICATION_CONFIRMED_RECOVER":
                    next(action);
                    // The action that calls /mfa/authorize and redirects
                    return dispatch($4a0bd3d5ddd7886d$export$8cfa5c421bdc24ae(action));
                default:
                    next(action);
            }
        };
const $4a0bd3d5ddd7886d$export$6a7404e2291306ab = ({ params: params, analyticsClient: analyticsClient, navigate: navigate, mfaMethod: mfaMethod })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/resend${params}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": getState().csrfToken
                }
            });
            const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
            switch(response.status){
                case 200:
                    const { transactionToken: transactionToken } = await response.json();
                    navigate({
                        search: `?${new URLSearchParams({
                            transactionToken: transactionToken
                        })}`
                    }, {
                        replace: true
                    });
                    if (mfaMethod === "email-otp") dispatch((0, $xe7jL.addFlag)("success", (0, $dZoLz.default).mfEmailResentSuccessTitle, (0, $dZoLz.default).mfEmailResentSuccessDesc));
                    else dispatch((0, $xe7jL.addFlag)("success", (0, $dZoLz.default).mfRecoverySMSResentSuccessTitle, (0, $dZoLz.default).mfRecoverySMSResentSuccessDesc));
                    break;
                case 400:
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: "2svChallengeScreen",
                        subjectId: "2svIncorrectToken",
                        currentQueryParams: queryParams
                    });
                    break;
                case 429:
                    analyticsClient.errorShownEvent("2svChallengeScreen", "2svTooManySms");
                    $4a0bd3d5ddd7886d$var$handleError(dispatch);
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent("2svChallengeScreen", "2svUnknownError");
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };

const $4a0bd3d5ddd7886d$export$5d2dfc489f5d5678 = ({ params: params, otpCode: otpCode, analyticsClient: analyticsClient })=>async (dispatch, getState)=>{
        try {
            const isCommercial = (0, $lk8Tl.getCurrentPerimeter)() === "commercial";
            const token = isCommercial ? await (parcelRequire("jo0uw")).then(async ({ createRequestToken: createRequestToken })=>await createRequestToken()).catch(()=>"") : null;
            const response = await fetch(`/rest/mfa/verify${params}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": getState().csrfToken
                },
                body: JSON.stringify({
                    otpCode: otpCode,
                    ...token && {
                        token: token
                    }
                })
            });
            switch(response.status){
                case 200:
                    const { transactionToken: transactionToken, redirectUri: redirectUri } = await response.json();
                    if (redirectUri) // fast5
                    window.location.assign(redirectUri);
                    else {
                        const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                        queryParams.transactionToken = transactionToken;
                        const authorizeResponse = await fetch(`/rest/mfa/authorize?${(0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(queryParams)}`);
                        if (!authorizeResponse.ok) {
                            const error = await authorizeResponse.text();
                            throw new Error(error || authorizeResponse.statusText);
                        }
                        const { redirectUri: redirectUri } = await authorizeResponse.json();
                        window.location.assign(redirectUri);
                    }
                    break;
                case 400:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: "2svChallengeScreen",
                        subjectId: "2svIncorrectToken",
                        currentQueryParams: queryParams
                    });
                    break;
                case 403:
                case 429:
                    analyticsClient.errorShownEvent("2svChallengeScreen", "2svIncorrectCode");
                    dispatch((0, $4yIkJ.mfaVerifyError)({
                        errorCode: "invalid_otp",
                        message: "invalid otp code"
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(error || response.statusText);
            }
        } catch (error) {
            analyticsClient.errorShownEvent("2svChallengeScreen", "2svUnknownError");
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };
const $4a0bd3d5ddd7886d$export$d76d4fe28235a83 = ({ params: params, recoveryCode: recoveryCode, analyticsClient: analyticsClient, navigate: navigate })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/verify/recoverycode${params}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRF-TOKEN": getState().csrfToken
                },
                body: JSON.stringify({
                    recoveryCode: recoveryCode
                })
            });
            switch(response.status){
                case 200:
                    const { recoveryCode: recoveryCode1, transactionToken: transactionToken } = await response.json();
                    const newParams = {
                        continue: (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params).continue,
                        transactionToken: transactionToken.toString()
                    };
                    navigate({
                        search: `?${(0, $gyRZh.createSearchParams)(newParams)}`
                    }, {
                        replace: true
                    });
                    dispatch((0, $4yIkJ.mfaRecoverResponse)({
                        recoveryCode: recoveryCode1
                    }));
                    break;
                case 400:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: "2svRecoveryKeyScreen",
                        subjectId: "2svIncorrectToken",
                        currentQueryParams: queryParams
                    });
                    break;
                case 403:
                case 429:
                    analyticsClient.errorShownEvent("2svRecoveryKeyScreen", "2svIncorrectCode");
                    dispatch((0, $4yIkJ.mfaRecoverError)({
                        errorCode: "invalid_recovery_code",
                        message: "invalid recovery code"
                    }));
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from POST /rest/mfa/verify/recoverycode: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent("2svRecoveryKeyScreen", "2svUnknownError");
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };
const $4a0bd3d5ddd7886d$export$8cfa5c421bdc24ae = ({ params: params, analyticsClient: analyticsClient })=>async (dispatch, getState)=>{
        try {
            const response = await fetch(`/rest/mfa/authorize${params}`);
            switch(response.status){
                case 200:
                    const { redirectUri: redirectUri } = await response.json();
                    window.location.assign(redirectUri);
                    break;
                case 400:
                case 403:
                    const queryParams = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).parse(params);
                    $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({
                        analyticsClient: analyticsClient,
                        page: "2svSavedNewRecoveryKey",
                        subjectId: "2svIncorrectToken",
                        currentQueryParams: queryParams
                    });
                    break;
                default:
                    const error = await response.text();
                    throw new Error(`Unexpected response from GET /rest/mfa/authorize: ${error || response.statusText}`);
            }
        } catch (error) {
            analyticsClient.errorShownEvent("2svSavedNewRecoveryKey", "2svUnknownError");
            $4a0bd3d5ddd7886d$var$handleError(dispatch);
            (0, $8f2pb.captureException)(error);
        }
    };
function $4a0bd3d5ddd7886d$var$handleError(dispatch) {
    return dispatch((0, $xe7jL.addFlag)("error", (0, $dZoLz.default).mfVerifyErrorTitle, (0, $dZoLz.default).mfVerifyErrorDesc));
}
function $4a0bd3d5ddd7886d$var$redirectToLoginErrorOn400IncorrectTokenResponse({ analyticsClient: analyticsClient, page: page, subjectId: subjectId, currentQueryParams: currentQueryParams }) {
    analyticsClient.errorShownEvent(page, subjectId);
    delete currentQueryParams.transactionToken;
    delete currentQueryParams.errorCode;
    const currentQueryString = (0, (/*@__PURE__*/$parcel$interopDefault($jSnDV))).stringify(currentQueryParams);
    const extraParamsString = currentQueryString === "" ? "" : `&${currentQueryString}`;
    window.location.assign(`/login?prompt=true&errorCode=login.form.token.expired${extraParamsString}`);
}

});
parcelRegister("4yIkJ", function(module, exports) {

$parcel$export(module.exports, "confirmedRecoveryCode", function () { return $4740302bde0586d8$export$9d6418e9b0c5e37; });
$parcel$export(module.exports, "verifyOtpCode", function () { return $4740302bde0586d8$export$a5c568dd7addf7ae; });
$parcel$export(module.exports, "resendOtp", function () { return $4740302bde0586d8$export$fa0ba0eb6a79519c; });
$parcel$export(module.exports, "recoverAccount", function () { return $4740302bde0586d8$export$5e6ce816cc4182a; });
$parcel$export(module.exports, "mfaRecoverResponse", function () { return $4740302bde0586d8$export$9034102f3c89e717; });
$parcel$export(module.exports, "mfaVerifyError", function () { return $4740302bde0586d8$export$2026ab15e46bd57d; });
$parcel$export(module.exports, "mfaRecoverError", function () { return $4740302bde0586d8$export$3652b92f5dbdf874; });
$parcel$export(module.exports, "sendRecoveryEmail", function () { return $4740302bde0586d8$export$ad7f1a4d46b544fc; });

var $8dHAc = parcelRequire("8dHAc");

var $lk8Tl = parcelRequire("lk8Tl");

var $8f2pb = parcelRequire("8f2pb");
const $4740302bde0586d8$export$9d6418e9b0c5e37 = (params, analyticsClient)=>({
        type: "MFA_VERIFICATION_CONFIRMED_RECOVER",
        params: params,
        analyticsClient: analyticsClient
    });
const $4740302bde0586d8$export$a5c568dd7addf7ae = (params, otpCode, analyticsClient)=>({
        type: "MFA_VERIFICATION_VERIFY",
        params: params,
        otpCode: otpCode,
        analyticsClient: analyticsClient
    });
const $4740302bde0586d8$export$fa0ba0eb6a79519c = (params, analyticsClient, navigate, mfaMethod)=>({
        type: "MFA_VERIFICATION_RESEND_OTP",
        params: params,
        analyticsClient: analyticsClient,
        navigate: navigate,
        mfaMethod: mfaMethod
    });
const $4740302bde0586d8$export$5e6ce816cc4182a = (params, recoveryCode, analyticsClient, navigate)=>({
        type: "MFA_VERIFICATION_RECOVER",
        params: params,
        recoveryCode: recoveryCode,
        analyticsClient: analyticsClient,
        navigate: navigate
    });
const $4740302bde0586d8$export$9034102f3c89e717 = ({ recoveryCode: recoveryCode })=>({
        type: "MFA_VERIFICATION_RECOVER_RESPONSE",
        recoveryCode: recoveryCode
    });
const $4740302bde0586d8$export$2026ab15e46bd57d = ({ errorCode: errorCode, message: message })=>({
        type: "MFA_VERIFICATION_VERIFY_ERROR",
        errorCode: errorCode,
        message: message
    });
const $4740302bde0586d8$export$3652b92f5dbdf874 = ({ errorCode: errorCode, message: message })=>({
        type: "MFA_VERIFICATION_RECOVER_ERROR",
        errorCode: errorCode,
        message: message
    });
const $4740302bde0586d8$export$b147b2e1028c65fa = ()=>({
        type: "RECOVERY_EMAIL_SENT"
    });
const $4740302bde0586d8$export$cc7dfbcab13c5eea = ()=>({
        type: "RECOVERY_EMAIL_START"
    });
const $4740302bde0586d8$export$b760122b98e1a9be = (reason)=>({
        type: "RECOVERY_EMAIL_ERROR",
        reason: reason
    });
const $4740302bde0586d8$export$ad7f1a4d46b544fc = (email)=>async (dispatch)=>{
        dispatch($4740302bde0586d8$export$cc7dfbcab13c5eea());
        try {
            var _body_error;
            const response = await fetch(`${(0, $lk8Tl.idacOrigin)}/rest/tsv-recovery/trigger`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: email
                })
            });
            const body = await response.json();
            const errorReason = body === null || body === void 0 ? void 0 : (_body_error = body.error) === null || _body_error === void 0 ? void 0 : _body_error.reason;
            // Note that sing-in-service may return an error reason with a 200 response, in cases where
            // a non-200 response could introduce an account enumeration vulnerability.
            if (response.ok && !errorReason) dispatch($4740302bde0586d8$export$b147b2e1028c65fa());
            else {
                const narrowedReason = $4740302bde0586d8$var$narrowErrorReason(errorReason);
                dispatch($4740302bde0586d8$export$b760122b98e1a9be(narrowedReason));
            }
        } catch (e) {
            (0, $8f2pb.captureException)(e);
            dispatch($4740302bde0586d8$export$b760122b98e1a9be("unknown"));
        }
    };
const $4740302bde0586d8$var$isKnownRecoveryEmailErrorReason = (reason)=>(0, $8dHAc.KnownRecoveryEmailErrorReasons).includes(reason);
/** Maps arbitrary string returned by API to a type-safe value compatible with the redux state */ const $4740302bde0586d8$var$narrowErrorReason = (reason)=>{
    if (reason && $4740302bde0586d8$var$isKnownRecoveryEmailErrorReason(reason)) return reason;
    return "unknown";
};

});

parcelRegister("xe7jL", function(module, exports) {

$parcel$export(module.exports, "addFlag", function () { return $44b115d1498b33eb$export$820a1da46c7a4303; });
$parcel$export(module.exports, "dismissFlag", function () { return $44b115d1498b33eb$export$900a08a292ad23cd; });

var $a6HGw = parcelRequire("a6HGw");
const $44b115d1498b33eb$export$820a1da46c7a4303 = (type, title, description)=>({
        type: "FLAG_ADD",
        flag: {
            type: type,
            title: title,
            description: description,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($a6HGw))).v4()
        }
    });
const $44b115d1498b33eb$export$900a08a292ad23cd = ()=>({
        type: "FLAG_DISMISS"
    });

});

parcelRegister("dZoLz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ac3884d4ac2a263$export$2e2bcd8739ae039; });

var $3VrrU = parcelRequire("3VrrU");
var $1ac3884d4ac2a263$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    loginHeadTitle: {
        id: "login.head.title",
        defaultMessage: "Log in to continue",
        description: ""
    },
    // Flags
    mfRecoveryEmailResentSuccessTitle: {
        id: "mf.recoveryemailresentsuccess.title",
        defaultMessage: "Recovery email resent!",
        description: ""
    },
    mfRecoveryEmailResentSuccessDesc: {
        id: "mf.recoveryemailresentsuccess",
        defaultMessage: "A recovery email has been resent to you!",
        description: ""
    },
    mfRecoveryEmailResentErrorTitle: {
        id: "mf.recoveryemailresenterror.title",
        defaultMessage: "Something went wrong.",
        description: ""
    },
    mfRecoveryEmailResentErrorDesc: {
        id: "mf.recoveryemailresenterror",
        defaultMessage: "We couldn\u2019t send the recovery email. Please try again later.",
        description: ""
    },
    mfRecoverySMSResentSuccessTitle: {
        id: "mf.recoverysmsresentsuccess.title",
        defaultMessage: "SMS resent!",
        description: ""
    },
    mfRecoverySMSResentSuccessDesc: {
        id: "mf.recoverysmsresentsuccess",
        defaultMessage: "A SMS has been resent to you!",
        description: ""
    },
    mfEmailResentSuccessTitle: {
        id: "mf.emailresentsuccess.title",
        defaultMessage: "Email resent!",
        description: ""
    },
    mfEmailResentSuccessDesc: {
        id: "mf.emailresentsuccess",
        defaultMessage: "An Email has been resent to you!",
        description: ""
    },
    mfVerifyErrorTitle: {
        id: "guardian.error.default.flag.title",
        defaultMessage: "Oops, that didn't work!"
    },
    mfVerifyErrorDesc: {
        id: "guardian.error.default.flag.description",
        defaultMessage: "Try that again in a moment."
    }
});

});

parcelRegister("jo0uw", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fxF5P")).then(()=>parcelRequire("f6Jfi"));

});


parcelRegister("iBTcr", function(module, exports) {
$parcel$export(module.exports, "connect", function () { return (parcelRequire("ittIU")).default; });
$parcel$export(module.exports, "Provider", function () { return (parcelRequire("e1hxF")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("7JtuM")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("5Hzdz")).useSelector; });
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $hU7R8 = parcelRequire("hU7R8");

var $7H231 = parcelRequire("7H231");
parcelRequire("A0Qvp");
var $h1d60 = parcelRequire("h1d60");

var $c4bmG = parcelRequire("c4bmG");

var $5Hzdz = parcelRequire("5Hzdz");

var $ittIU = parcelRequire("ittIU");
parcelRequire("cSOXH");
(0, $5Hzdz.initializeUseSelector)((0, $7H231.useSyncExternalStoreWithSelector));
(0, $ittIU.initializeConnect)((0, $hU7R8.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $c4bmG.setBatch)((0, $h1d60.unstable_batchedUpdates));

});
parcelRegister("7H231", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hi0mu"));

});

parcelRegister("A0Qvp", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", function () { return (parcelRequire("h1d60")).unstable_batchedUpdates; });

var $h1d60 = parcelRequire("h1d60");

});

parcelRegister("c4bmG", function(module, exports) {

$parcel$export(module.exports, "setBatch", function () { return $8c8eac927667bb1c$export$4b9874722d0da7bc; });
$parcel$export(module.exports, "getBatch", function () { return $8c8eac927667bb1c$export$fc47d4c0ba3bd2c6; });
// Default to a dummy "batch" implementation that just runs the callback
function $8c8eac927667bb1c$var$defaultNoopBatch(callback) {
    callback();
}
let $8c8eac927667bb1c$var$batch = $8c8eac927667bb1c$var$defaultNoopBatch; // Allow injecting another batching function later
const $8c8eac927667bb1c$export$4b9874722d0da7bc = (newBatch)=>$8c8eac927667bb1c$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $8c8eac927667bb1c$export$fc47d4c0ba3bd2c6 = ()=>$8c8eac927667bb1c$var$batch;

});

parcelRegister("5Hzdz", function(module, exports) {

$parcel$export(module.exports, "initializeUseSelector", function () { return $426c4972d699f3ad$export$e2e6e3f3f3b782e3; });
$parcel$export(module.exports, "useSelector", function () { return $426c4972d699f3ad$export$2105062e25df4afe; });

var $8ZuGG = parcelRequire("8ZuGG");

var $hIX6X = parcelRequire("hIX6X");

var $1PVdq = parcelRequire("1PVdq");

var $4I5qa = parcelRequire("4I5qa");
let $426c4972d699f3ad$var$useSyncExternalStoreWithSelector = (0, $4I5qa.notInitialized);
const $426c4972d699f3ad$export$e2e6e3f3f3b782e3 = (fn)=>{
    $426c4972d699f3ad$var$useSyncExternalStoreWithSelector = fn;
};
const $426c4972d699f3ad$var$refEquality = (a, b)=>a === b;
function $426c4972d699f3ad$export$2b53f90d2bd1cbfb(context = (0, $1PVdq.ReactReduxContext)) {
    const useReduxContext = context === (0, $1PVdq.ReactReduxContext) ? (0, $hIX6X.useReduxContext) : (0, $hIX6X.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $426c4972d699f3ad$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $8ZuGG.useRef)(true);
        const wrappedSelector = (0, $8ZuGG.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $426c4972d699f3ad$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $8ZuGG.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $426c4972d699f3ad$export$2105062e25df4afe = /*#__PURE__*/ $426c4972d699f3ad$export$2b53f90d2bd1cbfb();

});
parcelRegister("hIX6X", function(module, exports) {

$parcel$export(module.exports, "createReduxContextHook", function () { return $ce7466006b4afaca$export$d4d6226d5fc61558; });
$parcel$export(module.exports, "useReduxContext", function () { return $ce7466006b4afaca$export$c1275ca9a6fd3ec5; });

var $8ZuGG = parcelRequire("8ZuGG");

var $1PVdq = parcelRequire("1PVdq");
function $ce7466006b4afaca$export$d4d6226d5fc61558(context = (0, $1PVdq.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $8ZuGG.useContext)(context);
        return contextValue;
    };
}
const $ce7466006b4afaca$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $ce7466006b4afaca$export$d4d6226d5fc61558();

});
parcelRegister("1PVdq", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", function () { return $1566efb0ddf2d2a2$export$cc80c08dc91f1c00; });

var $8ZuGG = parcelRequire("8ZuGG");
const $1566efb0ddf2d2a2$var$ContextKey = Symbol.for(`react-redux-context`);
const $1566efb0ddf2d2a2$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $1566efb0ddf2d2a2$var$getContext() {
    var _gT$ContextKey;
    if (!$8ZuGG.createContext) return {};
    const contextMap = (_gT$ContextKey = $1566efb0ddf2d2a2$var$gT[$1566efb0ddf2d2a2$var$ContextKey]) != null ? _gT$ContextKey : $1566efb0ddf2d2a2$var$gT[$1566efb0ddf2d2a2$var$ContextKey] = new Map();
    let realContext = contextMap.get($8ZuGG.createContext);
    if (!realContext) {
        realContext = $8ZuGG.createContext(null);
        contextMap.set($8ZuGG.createContext, realContext);
    }
    return realContext;
}
const $1566efb0ddf2d2a2$export$cc80c08dc91f1c00 = /*#__PURE__*/ $1566efb0ddf2d2a2$var$getContext();
var $1566efb0ddf2d2a2$export$2e2bcd8739ae039 = $1566efb0ddf2d2a2$export$cc80c08dc91f1c00;

});


parcelRegister("4I5qa", function(module, exports) {

$parcel$export(module.exports, "notInitialized", function () { return $36df7a00ed1af54b$export$20656a4825650bd0; });
const $36df7a00ed1af54b$export$20656a4825650bd0 = ()=>{
    throw new Error("uSES not initialized!");
};

});


parcelRegister("ittIU", function(module, exports) {

$parcel$export(module.exports, "initializeConnect", function () { return $d731fdd9650e34d2$export$36d45daa6a4925b8; });
$parcel$export(module.exports, "default", function () { return $d731fdd9650e34d2$export$2e2bcd8739ae039; });

var $6vRlT = parcelRequire("6vRlT");

var $4KVmf = parcelRequire("4KVmf");

var $fiQA5 = parcelRequire("fiQA5");

var $8ZuGG = parcelRequire("8ZuGG");

var $ejazM = parcelRequire("ejazM");

var $nkY8n = parcelRequire("nkY8n");

var $aOI60 = parcelRequire("aOI60");

var $b9plV = parcelRequire("b9plV");

var $aPse6 = parcelRequire("aPse6");

var $rlEIG = parcelRequire("rlEIG");

var $4fn4K = parcelRequire("4fn4K");

var $8LoSk = parcelRequire("8LoSk");
parcelRequire("8Hy2h");

var $1PVdq = parcelRequire("1PVdq");

var $4I5qa = parcelRequire("4I5qa");
const $d731fdd9650e34d2$var$_excluded = [
    "reactReduxForwardedRef"
];
let $d731fdd9650e34d2$var$useSyncExternalStore = (0, $4I5qa.notInitialized);
const $d731fdd9650e34d2$export$36d45daa6a4925b8 = (fn)=>{
    $d731fdd9650e34d2$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $d731fdd9650e34d2$var$EMPTY_ARRAY = [
    null,
    0
];
const $d731fdd9650e34d2$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $d731fdd9650e34d2$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $d731fdd9650e34d2$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $4fn4K.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $d731fdd9650e34d2$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $d731fdd9650e34d2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $d731fdd9650e34d2$var$initStateUpdates = ()=>$d731fdd9650e34d2$var$EMPTY_ARRAY;
function $d731fdd9650e34d2$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $d731fdd9650e34d2$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $d731fdd9650e34d2$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d731fdd9650e34d2$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $8LoSk.default), areStatePropsEqual: areStatePropsEqual = (0, $8LoSk.default), areMergedPropsEqual: areMergedPropsEqual = (0, $8LoSk.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $1PVdq.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $b9plV.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $aOI60.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $aPse6.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $8ZuGG.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $4KVmf.default)(props, $d731fdd9650e34d2$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $8ZuGG.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $ejazM.isContextConsumer)(/*#__PURE__*/ $8ZuGG.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $8ZuGG.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $8ZuGG.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $nkY8n.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $8ZuGG.useMemo(()=>{
                if (!shouldHandleStateChanges) return $d731fdd9650e34d2$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $rlEIG.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $8ZuGG.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $6vRlT.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $8ZuGG.useRef();
            const lastWrapperProps = $8ZuGG.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $8ZuGG.useRef();
            const renderIsScheduled = $8ZuGG.useRef(false);
            const isProcessingDispatch = $8ZuGG.useRef(false);
            const isMounted = $8ZuGG.useRef(false);
            const latestSubscriptionCallbackError = $8ZuGG.useRef();
            (0, $4fn4K.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $8ZuGG.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $8ZuGG.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d731fdd9650e34d2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d731fdd9650e34d2$var$useIsomorphicLayoutEffectWithArgs($d731fdd9650e34d2$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $d731fdd9650e34d2$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $4fn4K.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $8ZuGG.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $8ZuGG.createElement(WrappedComponent, (0, $6vRlT.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $8ZuGG.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $8ZuGG.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $8ZuGG.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $8ZuGG.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $8ZuGG.createElement(Connect, (0, $6vRlT.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($fiQA5)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d731fdd9650e34d2$export$2e2bcd8739ae039 = $d731fdd9650e34d2$var$connect;

});
parcelRegister("ejazM", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eNPsz"));

});

parcelRegister("nkY8n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $04626a15ce2ca36c$export$2e2bcd8739ae039; });

var $4KVmf = parcelRequire("4KVmf");
parcelRequire("d4jAj");
const $04626a15ce2ca36c$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $04626a15ce2ca36c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $04626a15ce2ca36c$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $4KVmf.default)(_ref, $04626a15ce2ca36c$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $04626a15ce2ca36c$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("d4jAj", function(module, exports) {

var $8Hy2h = parcelRequire("8Hy2h");
function $983ad72e2e3c6a90$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) (0, $8Hy2h.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $983ad72e2e3c6a90$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $983ad72e2e3c6a90$var$verify(mapStateToProps, "mapStateToProps");
    $983ad72e2e3c6a90$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $983ad72e2e3c6a90$var$verify(mergeProps, "mergeProps");
}

});
parcelRegister("8Hy2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $655cbda9d169540e$export$2e2bcd8739ae039; });
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $655cbda9d169540e$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("aOI60", function(module, exports) {

$parcel$export(module.exports, "mapDispatchToPropsFactory", function () { return $7e00c76b181085d1$export$b69a785ceac019a6; });

var $1GhI8 = parcelRequire("1GhI8");

var $dQIZ0 = parcelRequire("dQIZ0");

var $8Reab = parcelRequire("8Reab");
function $7e00c76b181085d1$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? (0, $dQIZ0.wrapMapToPropsConstant)((dispatch)=>(0, $1GhI8.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $dQIZ0.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? (0, $dQIZ0.wrapMapToPropsFunc)(mapDispatchToProps, "mapDispatchToProps") : (0, $8Reab.createInvalidArgFactory)(mapDispatchToProps, "mapDispatchToProps");
}

});
parcelRegister("1GhI8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $139773b4c0ddfa4a$export$2e2bcd8739ae039; });
function $139773b4c0ddfa4a$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("dQIZ0", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", function () { return $a1530660b5e8cf18$export$710f7c60f68acd3e; });
$parcel$export(module.exports, "wrapMapToPropsFunc", function () { return $a1530660b5e8cf18$export$8d46c7f53c8c602f; });
parcelRequire("Dt8dT");
function $a1530660b5e8cf18$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $a1530660b5e8cf18$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $a1530660b5e8cf18$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $a1530660b5e8cf18$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $a1530660b5e8cf18$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("Dt8dT", function(module, exports) {

var $fVGP0 = parcelRequire("fVGP0");

var $8Hy2h = parcelRequire("8Hy2h");
function $076a3d9153f2de76$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $fVGP0.default)(value)) (0, $8Hy2h.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("fVGP0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b98d655ed8ff004e$export$2e2bcd8739ae039; });
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $b98d655ed8ff004e$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("8Reab", function(module, exports) {

$parcel$export(module.exports, "createInvalidArgFactory", function () { return $672e4284902232d1$export$19ef7b929f7e2559; });
function $672e4284902232d1$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("b9plV", function(module, exports) {

$parcel$export(module.exports, "mapStateToPropsFactory", function () { return $81e4337dc73c3d41$export$e00e93951827eda7; });

var $dQIZ0 = parcelRequire("dQIZ0");

var $8Reab = parcelRequire("8Reab");
function $81e4337dc73c3d41$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $dQIZ0.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === "function" ? (0, $dQIZ0.wrapMapToPropsFunc)(mapStateToProps, "mapStateToProps") : (0, $8Reab.createInvalidArgFactory)(mapStateToProps, "mapStateToProps");
}

});

parcelRegister("aPse6", function(module, exports) {

$parcel$export(module.exports, "mergePropsFactory", function () { return $7e2490026ce772fd$export$17457cf6fa742f84; });

var $6vRlT = parcelRequire("6vRlT");
parcelRequire("Dt8dT");

var $8Reab = parcelRequire("8Reab");
function $7e2490026ce772fd$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $6vRlT.default)({}, ownProps, stateProps, dispatchProps);
}
function $7e2490026ce772fd$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $7e2490026ce772fd$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$7e2490026ce772fd$export$691c327fc30bc857 : typeof mergeProps === "function" ? $7e2490026ce772fd$export$5b105939c84b5234(mergeProps) : (0, $8Reab.createInvalidArgFactory)(mergeProps, "mergeProps");
}

});

parcelRegister("rlEIG", function(module, exports) {

$parcel$export(module.exports, "createSubscription", function () { return $0523521d92a4a169$export$d567d2b9af322f8f; });

var $c4bmG = parcelRequire("c4bmG");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0523521d92a4a169$var$createListenerCollection() {
    const batch = (0, $c4bmG.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $0523521d92a4a169$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $0523521d92a4a169$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $0523521d92a4a169$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0523521d92a4a169$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0523521d92a4a169$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("4fn4K", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $317a7672d50d9c88$export$700979bc83e7db82; });

var $8ZuGG = parcelRequire("8ZuGG");
const $317a7672d50d9c88$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $317a7672d50d9c88$export$700979bc83e7db82 = $317a7672d50d9c88$export$71594e8a50f746f4 ? $8ZuGG.useLayoutEffect : $8ZuGG.useEffect;

});

parcelRegister("8LoSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6616023885707955$export$2e2bcd8739ae039; });
function $6616023885707955$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $6616023885707955$export$2e2bcd8739ae039(objA, objB) {
    if ($6616023885707955$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$6616023885707955$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("cSOXH", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return (parcelRequire("e1hxF")).default; });
$parcel$export(module.exports, "connect", function () { return (parcelRequire("ittIU")).default; });
$parcel$export(module.exports, "useDispatch", function () { return (parcelRequire("7JtuM")).useDispatch; });
$parcel$export(module.exports, "useSelector", function () { return (parcelRequire("5Hzdz")).useSelector; });

var $e1hxF = parcelRequire("e1hxF");

var $ittIU = parcelRequire("ittIU");

var $1PVdq = parcelRequire("1PVdq");

var $7JtuM = parcelRequire("7JtuM");

var $5Hzdz = parcelRequire("5Hzdz");

var $g5XoR = parcelRequire("g5XoR");

var $8LoSk = parcelRequire("8LoSk");
parcelRequire("aZ6pU");

});
parcelRegister("e1hxF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a34ec4300d3a80c8$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $1PVdq = parcelRequire("1PVdq");

var $rlEIG = parcelRequire("rlEIG");

var $4fn4K = parcelRequire("4fn4K");
function $a34ec4300d3a80c8$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", noopCheck: noopCheck = "once" }) {
    const contextValue = $8ZuGG.useMemo(()=>{
        const subscription = (0, $rlEIG.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $8ZuGG.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $4fn4K.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $1PVdq.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $8ZuGG.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $a34ec4300d3a80c8$export$2e2bcd8739ae039 = $a34ec4300d3a80c8$var$Provider;

});

parcelRegister("7JtuM", function(module, exports) {

$parcel$export(module.exports, "useDispatch", function () { return $5a139d88100a3adc$export$8ad76b76a4c905f8; });

var $1PVdq = parcelRequire("1PVdq");

var $g5XoR = parcelRequire("g5XoR");
function $5a139d88100a3adc$export$bc9b55530897c558(context = (0, $1PVdq.ReactReduxContext)) {
    const useStore = context === (0, $1PVdq.ReactReduxContext) ? (0, $g5XoR.useStore) : (0, $g5XoR.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $5a139d88100a3adc$export$8ad76b76a4c905f8 = /*#__PURE__*/ $5a139d88100a3adc$export$bc9b55530897c558();

});
parcelRegister("g5XoR", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", function () { return $bb7b3095e44c4ec6$export$671dba69185d0304; });
$parcel$export(module.exports, "useStore", function () { return $bb7b3095e44c4ec6$export$6ccbb43953eebf8; });

var $1PVdq = parcelRequire("1PVdq");

var $hIX6X = parcelRequire("hIX6X");
function $bb7b3095e44c4ec6$export$671dba69185d0304(context = (0, $1PVdq.ReactReduxContext)) {
    const useReduxContext = context === (0, $1PVdq.ReactReduxContext) ? (0, $hIX6X.useReduxContext) : (0, $hIX6X.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $bb7b3095e44c4ec6$export$6ccbb43953eebf8 = /*#__PURE__*/ $bb7b3095e44c4ec6$export$671dba69185d0304();

});


parcelRegister("aZ6pU", function(module, exports) {

});





parcelRegister("1SvOA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93efe20d23b19eb8$export$2e2bcd8739ae039; });

var $6rcps = parcelRequire("6rcps");

var $3XNKR = parcelRequire("3XNKR");

var $8iNm9 = parcelRequire("8iNm9");
parcelRequire("8ZuGG");
let $93efe20d23b19eb8$var$_ = (t)=>t, $93efe20d23b19eb8$var$t;
const $93efe20d23b19eb8$var$StyledButton = (0, $3XNKR.default)((0, $8iNm9.default))($93efe20d23b19eb8$var$t || ($93efe20d23b19eb8$var$t = $93efe20d23b19eb8$var$_`
  height: 40px !important;
  line-height: 40px !important;

  div,
  span {
    display: flex !important;
    justify-content: center;
  }
`));
function $93efe20d23b19eb8$export$2e2bcd8739ae039(props) {
    const { isFullWidth: isFullWidth, ...rest } = props;
    return /*#__PURE__*/ (0, $6rcps.jsx)($93efe20d23b19eb8$var$StyledButton, {
        ...rest,
        shouldFitContainer: isFullWidth
    });
}

});
parcelRegister("8iNm9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $60b64a4d2bfea2d8$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $iRVQ8 = parcelRequire("iRVQ8");

var $7GSOz = parcelRequire("7GSOz");
var $60b64a4d2bfea2d8$var$_excluded = [
    "appearance",
    "isDisabled",
    "isSelected",
    "isLoading",
    "spacing"
];
/**
 * __Loading button__
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ var $60b64a4d2bfea2d8$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function LoadingButton(_ref, ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, spacing = _ref.spacing, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $60b64a4d2bfea2d8$var$_excluded);
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $iRVQ8.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $7GSOz.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$60b64a4d2bfea2d8$var$LoadingButton.displayName = "LoadingButton";
var $60b64a4d2bfea2d8$export$2e2bcd8739ae039 = $60b64a4d2bfea2d8$var$LoadingButton;

});
parcelRegister("7GSOz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5996f9b04030c224$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $cufV0 = parcelRequire("cufV0");
function $5996f9b04030c224$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $5996f9b04030c224$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cufV0.default), {
        size: size,
        label: ", Loading",
        appearance: $5996f9b04030c224$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});



parcelRegister("gJFTu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7770daab1be6a9cb$export$2e2bcd8739ae039; });

var $3XNKR = parcelRequire("3XNKR");

var $5b7Z4 = parcelRequire("5b7Z4");
let $7770daab1be6a9cb$var$_ = (t)=>t, $7770daab1be6a9cb$var$t;
const $7770daab1be6a9cb$var$ButtonContainer = (0, $3XNKR.default).div($7770daab1be6a9cb$var$t || ($7770daab1be6a9cb$var$t = $7770daab1be6a9cb$var$_`
  width: 100%;
  padding-top: ${0}px;
`), (0, $5b7Z4.gridSize)() * 2);
var $7770daab1be6a9cb$export$2e2bcd8739ae039 = $7770daab1be6a9cb$var$ButtonContainer;

});

parcelRegister("9ek8N", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ftyoZ")).then(()=>parcelRequire("ktL5S"));

});

parcelRegister("imyZ9", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("61GGu")).then(()=>parcelRequire("KoVn5"));

});

parcelRegister("41CBD", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2lNCA")).then(()=>parcelRequire("bw2HW"));

});

parcelRegister("hQLzx", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("buCkT")).then(()=>parcelRequire("5KDON"));

});

parcelRegister("2n6QC", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fZ5pR")).then(()=>parcelRequire("jQnR7"));

});

parcelRegister("jgIFg", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9YoXx")).then(()=>parcelRequire("krGT6"));

});

parcelRegister("eQS3o", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lJivj")).then(()=>parcelRequire("b3UdK"));

});

parcelRegister("d8wgI", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ilWCw")).then(()=>parcelRequire("c1UFv"));

});

parcelRegister("g4zfV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4C5B7")).then(()=>parcelRequire("WMHLj"));

});

parcelRegister("3uRuL", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("agqiQ")).then(()=>parcelRequire("hsbBZ"));

});

parcelRegister("b6QhV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("cbcf1")).then(()=>parcelRequire("7jMwu"));

});

parcelRegister("4MwDy", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("assWM")).then(()=>parcelRequire("g7gTB"));

});

parcelRegister("2zMlh", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("et9BZ")).then(()=>parcelRequire("3Y4oi"));

});

parcelRegister("2TaUl", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fOCIn")).then(()=>parcelRequire("hzvGc"));

});

parcelRegister("bfqCY", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fgQyO")).then(()=>parcelRequire("8yAUO"));

});

parcelRegister("lEJ78", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7po9d")).then(()=>parcelRequire("1Wtav"));

});

parcelRegister("gqK4f", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("iSFDb")).then(()=>parcelRequire("ePQpV"));

});

parcelRegister("3omAS", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("eN5Fq")).then(()=>parcelRequire("bHhaD"));

});

parcelRegister("7yvG1", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1bASk")).then(()=>parcelRequire("9zdUx"));

});

parcelRegister("e7JDz", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("johxQ")).then(()=>parcelRequire("5WIli"));

});

parcelRegister("gQVR5", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1ec6N")).then(()=>parcelRequire("b1JLi"));

});

parcelRegister("4R2AC", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("a4TDP")).then(()=>parcelRequire("8hQfv"));

});

parcelRegister("jrFLZ", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("GXJZ8")).then(()=>parcelRequire("4wsGs"));

});

parcelRegister("b05HP", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e6XXT")).then(()=>parcelRequire("clMSz"));

});

parcelRegister("2FOdn", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ajfHd")).then(()=>parcelRequire("jNJtd"));

});

parcelRegister("82mu7", function(module, exports) {

$parcel$export(module.exports, "preloadAppState", function () { return $f47790f73dd9f9af$export$b2d23fea71dbec1b; });
$parcel$export(module.exports, "buildMicrobranding", function () { return $f47790f73dd9f9af$export$4cd70f9ecbebfa45; });
$parcel$export(module.exports, "buildInitialState", function () { return $f47790f73dd9f9af$export$2a115e4c5d766179; });
$parcel$export(module.exports, "createAnalyticsClient", function () { return $f47790f73dd9f9af$export$3d970ca206012d6b; });
$parcel$export(module.exports, "startupAnalyticEvent", function () { return $f47790f73dd9f9af$export$514076659add65b6; });
$parcel$export(module.exports, "pushGlobals", function () { return $f47790f73dd9f9af$export$fac9d5c57cee7357; });
$parcel$export(module.exports, "initCastle", function () { return $f47790f73dd9f9af$export$22e481f8c6e85dea; });

var $ihLLY = parcelRequire("ihLLY");

var $3kyMd = parcelRequire("3kyMd");

var $day6I = parcelRequire("day6I");

var $d4mUe = parcelRequire("d4mUe");

var $bkO8T = parcelRequire("bkO8T");

var $kVXtB = parcelRequire("kVXtB");

var $h0rSo = parcelRequire("h0rSo");

var $3ir1n = parcelRequire("3ir1n");

var $ahjwY = parcelRequire("ahjwY");

var $lk8Tl = parcelRequire("lk8Tl");

var $8f2pb = parcelRequire("8f2pb");

var $wWEnh = parcelRequire("wWEnh");
function $f47790f73dd9f9af$export$b2d23fea71dbec1b() {
    try {
        const el = document.body;
        return JSON.parse(el && el.getAttribute("data-app-state") || "null");
    } catch (e) {
        return null;
    }
}
async function $f47790f73dd9f9af$var$fetchAppState() {
    try {
        return await Promise.race([
            fetch(`${(0, $lk8Tl.idacOrigin)}/frontend/state`, {
                mode: "cors",
                credentials: "include"
            }).then((res)=>{
                if (res.status === 200) return res.json();
                else throw new Error(`Failed to fetch app state: ${res.status} ${res.statusText}`);
            }),
            new Promise((_, reject)=>{
                const timeoutMs = 10000;
                setTimeout(()=>reject(new Error(`Fetching app state timed out after ${timeoutMs}ms`)), timeoutMs);
            })
        ]);
    } catch (e) {
        (0, $8f2pb.captureException)(e);
        return null;
    }
}
function $f47790f73dd9f9af$export$4cd70f9ecbebfa45(oidcContext) {
    const isEmbedded = /AtlassianMobileApp|HipChat/.test(navigator.userAgent);
    const isMobileApp = isEmbedded || (0, $day6I.isMobileOidc)(oidcContext) || false;
    return {
        isEmbedded: isEmbedded,
        isAnyMobile: (0, $ihLLY.screenSize)() === "mobile" || isMobileApp,
        isMobileApp: isMobileApp,
        screenSize: (0, $ihLLY.screenSize)(),
        oidcContext: oidcContext
    };
}
async function $f47790f73dd9f9af$export$2a115e4c5d766179(preloaded) {
    const microbranding = $f47790f73dd9f9af$export$4cd70f9ecbebfa45(preloaded === null || preloaded === void 0 ? void 0 : preloaded.oidcContext);
    if (!preloaded) {
        const fetched = await $f47790f73dd9f9af$var$fetchAppState();
        return {
            initialStoreState: {
                csrfToken: fetched === null || fetched === void 0 ? void 0 : fetched.csrfToken,
                user: undefined,
                login: undefined,
                logout: undefined,
                appConfig: fetched === null || fetched === void 0 ? void 0 : fetched.appConfig,
                locale: fetched === null || fetched === void 0 ? void 0 : fetched.locale,
                continueAs: undefined,
                cancelDeletion: undefined,
                selectAccount: undefined,
                microbranding: $f47790f73dd9f9af$export$4cd70f9ecbebfa45(fetched === null || fetched === void 0 ? void 0 : fetched.oidcContext),
                createAccount: undefined,
                context: {
                    tenantCloudId: fetched === null || fetched === void 0 ? void 0 : fetched.tenantCloudId,
                    userId: undefined
                },
                migrateConfirmation: undefined,
                welcome: undefined,
                socialLoginRecovery: undefined,
                verifyEmail: undefined,
                verifyEmailSent: undefined,
                changeEmail: undefined,
                changePassword: undefined,
                welcomeSent: undefined,
                serverError: undefined,
                cobranding: fetched === null || fetched === void 0 ? void 0 : fetched.cobranding,
                stepUp: undefined,
                stepUpSso: undefined,
                verifyEmailOtp: undefined,
                loginConsent: undefined
            },
            cspNonce: (fetched === null || fetched === void 0 ? void 0 : fetched.cspNonce) || ""
        };
    }
    const loginState = preloaded.login && {
        ...(0, $3kyMd.defaultState),
        ...preloaded.login
    };
    return {
        initialStoreState: {
            csrfToken: preloaded.csrfToken,
            hashedCsrfToken: preloaded.hashedCsrfToken,
            user: preloaded.user,
            login: loginState,
            logout: preloaded.logout,
            appConfig: preloaded.appConfig,
            locale: preloaded.locale,
            continueAs: preloaded.continueAs,
            cancelDeletion: preloaded.cancelDeletion,
            selectAccount: preloaded.selectAccount,
            microbranding: microbranding,
            createAccount: preloaded.createAccount,
            context: {
                tenantCloudId: preloaded.tenantCloudId,
                userId: preloaded.userId
            },
            migrateConfirmation: preloaded.migrateConfirmation,
            signup: {
                ...(0, $bkO8T.defaultState),
                ...preloaded.signup
            },
            welcome: {
                ...(0, $kVXtB.defaultState),
                ...preloaded.welcome
            },
            socialLoginRecovery: preloaded.socialLoginRecovery,
            verifyEmail: preloaded.verifyEmail,
            verifyEmailSent: preloaded.verifyEmailSent,
            changeEmail: preloaded.changeEmail,
            changePassword: {
                ...(0, $d4mUe.defaultState),
                ...preloaded.changePassword
            },
            welcomeSent: preloaded.welcomeSent,
            serverError: preloaded.error,
            cobranding: preloaded.cobranding,
            multiFactor: {
                ...(0, $ahjwY.defaultState),
                ...preloaded.multiFactor
            },
            stepUp: preloaded.stepUp,
            stepUpSso: preloaded.stepUpSso,
            verifyEmailOtp: {
                ...(0, $h0rSo.defaultState),
                ...preloaded.verifyEmailOtp
            },
            loginConsent: {
                ...(0, $wWEnh.defaultState),
                ...preloaded.loginConsent
            }
        },
        cspNonce: preloaded.cspNonce
    };
}
function $f47790f73dd9f9af$export$3d970ca206012d6b(initialState) {
    const { microbranding: microbranding, cobranding: cobranding, context: context } = initialState.initialStoreState;
    const locale = undefined;
    return new (0, $3ir1n.AnalyticsClientImpl)({
        microbranding: microbranding,
        cobranding: cobranding || {},
        locale: locale,
        tenantCloudId: context.tenantCloudId,
        userId: context.userId,
        client: undefined
    });
}
function $f47790f73dd9f9af$export$514076659add65b6(analyticsClient) {
    analyticsClient.operationalEvent({
        page: "unknown",
        action: "loadPage",
        subject: "sli"
    });
}
function $f47790f73dd9f9af$export$fac9d5c57cee7357(appConfig, cspNonce) {
    window.segmentIoKey = appConfig && appConfig.segmentIoKey;
    window.cspNonce = cspNonce;
}

function $f47790f73dd9f9af$export$22e481f8c6e85dea(appConfig) {
    if ((0, $lk8Tl.currentPerimeter) !== "commercial") return; // Castle is not enabled for FedRAMP
    if (appConfig.castlePublishableApiKey) (parcelRequire("jo0uw")).then(({ configure: configure })=>{
        configure({
            pk: appConfig.castlePublishableApiKey
        });
    });
}

});

parcelRegister("l9koH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f65a42b83c2581ee$export$2e2bcd8739ae039; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $icabj = parcelRequire("icabj");

var $ckFNI = parcelRequire("ckFNI");

var $4hbFz = parcelRequire("4hbFz");

var $9TV3v = parcelRequire("9TV3v");

var $i6I7h = parcelRequire("i6I7h");

var $lcCMu = parcelRequire("lcCMu");
function $f65a42b83c2581ee$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f65a42b83c2581ee$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f65a42b83c2581ee$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f65a42b83c2581ee$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f65a42b83c2581ee$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f65a42b83c2581ee$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

/**
 * Sets the theme globally at runtime. This updates the `data-theme` and `data-color-mode` attributes on your page's <html> tag.
 *
 * @param {Object<string, string>} themeState The themes and color mode that should be applied.
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.contrastMode The contrast mode theme to be applied. If set to `auto`, the theme applied will be determined by the OS setting.set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.shape The shape theme to be applied.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 * @param {function} themeLoader Callback function used to override the default theme loading functionality.
 *
 * @returns A Promise of an unbind function, that can be used to stop listening for changes to system theme.
 *
 * @example
 * ```
 * setGlobalTheme({colorMode: 'auto', light: 'light', dark: 'dark', spacing: 'spacing'});
 * ```
 */ var $f65a42b83c2581ee$var$setGlobalTheme = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3() {
        var _ref2, _ref2$colorMode, colorMode, _ref2$contrastMode, contrastMode, _ref2$dark, dark, _ref2$light, light, _ref2$shape, shape, _ref2$spacing, spacing, _ref2$typography, typography, _ref2$UNSAFE_themeOpt, UNSAFE_themeOptions, themeLoader, themeState, themePreferences, loadingStrategy, loadingTasks, mode, attrOfMissingCustomStyles, themeOverridePreferences, _iterator, _step, themeId, autoUnbind, _args3 = arguments;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
            while(true)switch(_context3.prev = _context3.next){
                case 0:
                    _ref2 = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : {}, _ref2$colorMode = _ref2.colorMode, colorMode = _ref2$colorMode === void 0 ? (0, $icabj.themeStateDefaults)["colorMode"] : _ref2$colorMode, _ref2$contrastMode = _ref2.contrastMode, contrastMode = _ref2$contrastMode === void 0 ? (0, $icabj.themeStateDefaults)["contrastMode"] : _ref2$contrastMode, _ref2$dark = _ref2.dark, dark = _ref2$dark === void 0 ? (0, $icabj.themeStateDefaults)["dark"] : _ref2$dark, _ref2$light = _ref2.light, light = _ref2$light === void 0 ? (0, $icabj.themeStateDefaults)["light"] : _ref2$light, _ref2$shape = _ref2.shape, shape = _ref2$shape === void 0 ? (0, $icabj.themeStateDefaults)["shape"] : _ref2$shape, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? (0, $icabj.themeStateDefaults)["spacing"] : _ref2$spacing, _ref2$typography = _ref2.typography, typography = _ref2$typography === void 0 ? (0, $icabj.themeStateDefaults)["typography"] : _ref2$typography, _ref2$UNSAFE_themeOpt = _ref2.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref2$UNSAFE_themeOpt === void 0 ? (0, $icabj.themeStateDefaults)["UNSAFE_themeOptions"] : _ref2$UNSAFE_themeOpt;
                    themeLoader = _args3.length > 1 ? _args3[1] : undefined;
                    // CLEANUP: Remove. This blocks application of increased contrast themes
                    // without the feature flag enabled.
                    if (!(0, $i2LcI.fg)("platform.design-system-team.increased-contrast-themes")) {
                        if (light === "light-increased-contrast") light = "light";
                        if (dark === "dark-increased-contrast") dark = "dark";
                    }
                    themeState = {
                        colorMode: colorMode,
                        contrastMode: contrastMode,
                        dark: dark,
                        light: light,
                        shape: shape,
                        spacing: spacing,
                        typography: typography,
                        UNSAFE_themeOptions: themeLoader ? undefined : UNSAFE_themeOptions
                    }; // Determine what to load and loading strategy
                    themePreferences = (0, $i6I7h.getThemePreferences)(themeState);
                    loadingStrategy = themeLoader ? themeLoader : (0, $lcCMu.loadAndAppendThemeCss); // Load standard themes
                    loadingTasks = themePreferences.map(/*#__PURE__*/ function() {
                        var _ref3 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(themeId) {
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                                while(true)switch(_context.prev = _context.next){
                                    case 0:
                                        _context.next = 2;
                                        return loadingStrategy(themeId);
                                    case 2:
                                        return _context.abrupt("return", _context.sent);
                                    case 3:
                                    case "end":
                                        return _context.stop();
                                }
                            }, _callee);
                        }));
                        return function(_x) {
                            return _ref3.apply(this, arguments);
                        };
                    }()); // Load custom themes if needed
                    if (!themeLoader && UNSAFE_themeOptions && (0, $ckFNI.isValidBrandHex)(UNSAFE_themeOptions === null || UNSAFE_themeOptions === void 0 ? void 0 : UNSAFE_themeOptions.brandColor)) {
                        mode = colorMode || (0, $icabj.themeStateDefaults)["colorMode"];
                        attrOfMissingCustomStyles = (0, $9TV3v.findMissingCustomStyleElements)(UNSAFE_themeOptions, mode);
                        if (attrOfMissingCustomStyles.length > 0) // Load custom theme styles
                        loadingTasks.push((0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2() {
                            var _yield$import, loadAndAppendCustomThemeCss;
                            return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                                while(true)switch(_context2.prev = _context2.next){
                                    case 0:
                                        _context2.next = 2;
                                        return (parcelRequire("7ckqH"));
                                    case 2:
                                        _yield$import = _context2.sent;
                                        loadAndAppendCustomThemeCss = _yield$import.loadAndAppendCustomThemeCss;
                                        loadAndAppendCustomThemeCss({
                                            colorMode: attrOfMissingCustomStyles.length === 2 ? "auto" : // only load the missing custom theme styles
                                            attrOfMissingCustomStyles[0],
                                            UNSAFE_themeOptions: UNSAFE_themeOptions
                                        });
                                    case 5:
                                    case "end":
                                        return _context2.stop();
                                }
                            }, _callee2);
                        }))());
                    }
                    _context3.next = 10;
                    return Promise.all(loadingTasks);
                case 10:
                    // Load override themes after standard themes
                    themeOverridePreferences = (0, $i6I7h.getThemeOverridePreferences)(themeState);
                    _iterator = $f65a42b83c2581ee$var$_createForOfIteratorHelper(themeOverridePreferences);
                    _context3.prev = 12;
                    _iterator.s();
                case 14:
                    if ((_step = _iterator.n()).done) {
                        _context3.next = 20;
                        break;
                    }
                    themeId = _step.value;
                    _context3.next = 18;
                    return loadingStrategy(themeId);
                case 18:
                    _context3.next = 14;
                    break;
                case 20:
                    _context3.next = 25;
                    break;
                case 22:
                    _context3.prev = 22;
                    _context3.t0 = _context3["catch"](12);
                    _iterator.e(_context3.t0);
                case 25:
                    _context3.prev = 25;
                    _iterator.f();
                    return _context3.finish(25);
                case 28:
                    autoUnbind = (0, $4hbFz.default)(themeState);
                    return _context3.abrupt("return", autoUnbind);
                case 30:
                case "end":
                    return _context3.stop();
            }
        }, _callee3, null, [
            [
                12,
                22,
                25,
                28
            ]
        ]);
    }));
    return function setGlobalTheme() {
        return _ref.apply(this, arguments);
    };
}();
var $f65a42b83c2581ee$export$2e2bcd8739ae039 = $f65a42b83c2581ee$var$setGlobalTheme;

});
parcelRegister("ckFNI", function(module, exports) {

$parcel$export(module.exports, "isValidBrandHex", function () { return $8fa7c70feb8ab890$export$53031ac1ecb71f44; });
$parcel$export(module.exports, "rgbToHex", function () { return $8fa7c70feb8ab890$export$34d09c4a771c46ef; });
$parcel$export(module.exports, "hexToRgbA", function () { return $8fa7c70feb8ab890$export$b36dbdb4f463f05c; });
$parcel$export(module.exports, "hexToRgb", function () { return $8fa7c70feb8ab890$export$5a544e13ad4e1fa5; });
$parcel$export(module.exports, "hexToHSL", function () { return $8fa7c70feb8ab890$export$47ea145a83f50dc0; });
$parcel$export(module.exports, "HSLToRGB", function () { return $8fa7c70feb8ab890$export$1ff93e992dd58bec; });
$parcel$export(module.exports, "relativeLuminanceW3C", function () { return $8fa7c70feb8ab890$export$e770b01b744f3745; });
$parcel$export(module.exports, "getContrastRatio", function () { return $8fa7c70feb8ab890$export$d061e26956a60b0a; });
$parcel$export(module.exports, "deltaE", function () { return $8fa7c70feb8ab890$export$e8ddad763b4bebf9; });
// valid hex color with 6 digits
var $8fa7c70feb8ab890$export$53031ac1ecb71f44 = function isValidBrandHex(hex) {
    return /^#[0-9A-F]{6}$/i.test(hex);
};
// valid hex color with 4, 6 or 8 digits
var $8fa7c70feb8ab890$var$isValidHex = function isValidHex(hex) {
    return /^#([A-Fa-f0-9]{3,4}){1,2}$/.test(hex);
};
function $8fa7c70feb8ab890$export$34d09c4a771c46ef(r, g, b) {
    return "#" + (16777216 + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
function $8fa7c70feb8ab890$export$1212645cf40ebf71(hex) {
    if (hex.length === 9) {
        var int = parseInt(hex.slice(7, 9), 16) / 255;
        return Number(parseFloat(int.toString()).toFixed(2));
    }
    return 1;
}
function $8fa7c70feb8ab890$export$b36dbdb4f463f05c(hex) {
    if (!$8fa7c70feb8ab890$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255,
        $8fa7c70feb8ab890$export$1212645cf40ebf71(hex)
    ];
}
function $8fa7c70feb8ab890$export$5a544e13ad4e1fa5(hex) {
    if (!$8fa7c70feb8ab890$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var c;
    c = hex.substring(1).split("");
    if (c.length === 3) c = [
        c[0],
        c[0],
        c[1],
        c[1],
        c[2],
        c[2]
    ];
    c = "0x" + c.join("");
    return [
        c >> 16 & 255,
        c >> 8 & 255,
        c & 255
    ];
}
function $8fa7c70feb8ab890$export$47ea145a83f50dc0(hex) {
    if (!$8fa7c70feb8ab890$var$isValidHex(hex)) throw new Error("Invalid HEX");
    var r = 0, g = 0, b = 0;
    if (hex.length === 4) {
        r = "0x" + hex[1] + hex[1];
        g = "0x" + hex[2] + hex[2];
        b = "0x" + hex[3] + hex[3];
    } else if (hex.length === 7) {
        r = "0x" + hex[1] + hex[2];
        g = "0x" + hex[3] + hex[4];
        b = "0x" + hex[5] + hex[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    var cmin = Math.min(r, g, b), cmax = Math.max(r, g, b), delta = cmax - cmin, h = 0, s = 0, l = 0;
    if (delta === 0) h = 0;
    else if (cmax === r) h = (g - b) / delta % 6;
    else if (cmax === g) h = (b - r) / delta + 2;
    else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta === 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return [
        h,
        s,
        l
    ];
}
function $8fa7c70feb8ab890$export$1ff93e992dd58bec(h, s, l) {
    s /= 100;
    l /= 100;
    var k = function k(n) {
        return (n + h / 30) % 12;
    };
    var a = s * Math.min(l, 1 - l);
    var f = function f(n) {
        return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1)));
    };
    return [
        255 * f(0),
        255 * f(8),
        255 * f(4)
    ];
}
function $8fa7c70feb8ab890$export$e770b01b744f3745(r, g, b) {
    var RsRGB = r / 255;
    var GsRGB = g / 255;
    var BsRGB = b / 255;
    var R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    var G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    var B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    // For the sRGB colorspace, the relative luminance of a color is defined as:
    var L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    return L;
}
function $8fa7c70feb8ab890$export$d061e26956a60b0a(foreground, background) {
    if (!$8fa7c70feb8ab890$var$isValidHex(foreground) || !$8fa7c70feb8ab890$var$isValidHex(background)) throw new Error("Invalid HEX");
    var foregroundRgb = $8fa7c70feb8ab890$export$5a544e13ad4e1fa5(foreground);
    var backgroundRgb = $8fa7c70feb8ab890$export$5a544e13ad4e1fa5(background);
    var foregroundLuminance = $8fa7c70feb8ab890$export$e770b01b744f3745(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    var backgroundLuminance = $8fa7c70feb8ab890$export$e770b01b744f3745(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    var brightest = Math.max(foregroundLuminance, backgroundLuminance);
    var darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}
function $8fa7c70feb8ab890$export$e8ddad763b4bebf9(rgbA, rgbB) {
    var labA = $8fa7c70feb8ab890$var$rgbToLab(rgbA);
    var labB = $8fa7c70feb8ab890$var$rgbToLab(rgbB);
    var deltaL = labA[0] - labB[0];
    var deltaA = labA[1] - labB[1];
    var deltaB = labA[2] - labB[2];
    var c1 = Math.sqrt(labA[1] * labA[1] + labA[2] * labA[2]);
    var c2 = Math.sqrt(labB[1] * labB[1] + labB[2] * labB[2]);
    var deltaC = c1 - c2;
    var deltaH = deltaA * deltaA + deltaB * deltaB - deltaC * deltaC;
    deltaH = deltaH < 0 ? 0 : Math.sqrt(deltaH);
    var sc = 1.0 + 0.045 * c1;
    var sh = 1.0 + 0.015 * c1;
    var deltaLKlsl = deltaL / 1.0;
    var deltaCkcsc = deltaC / sc;
    var deltaHkhsh = deltaH / sh;
    var i = deltaLKlsl * deltaLKlsl + deltaCkcsc * deltaCkcsc + deltaHkhsh * deltaHkhsh;
    return i < 0 ? 0 : Math.sqrt(i);
}
function $8fa7c70feb8ab890$var$rgbToLab(rgb) {
    var r = rgb[0] / 255, g = rgb[1] / 255, b = rgb[2] / 255, x, y, z;
    r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
    g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
    b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
    x = (r * 0.4124 + g * 0.3576 + b * 0.1805) / 0.95047;
    y = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 1.0;
    z = (r * 0.0193 + g * 0.1192 + b * 0.9505) / 1.08883;
    x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
    return [
        116 * y - 16,
        500 * (x - y),
        200 * (y - z)
    ];
}

});

parcelRegister("4hbFz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $31d1cd45d26c9b78$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $i2LcI = parcelRequire("i2LcI");

var $bDlvL = parcelRequire("bDlvL");

var $jodS5 = parcelRequire("jodS5");

var $6wkMV = parcelRequire("6wkMV");
function $31d1cd45d26c9b78$export$2e2bcd8739ae039(themeState) {
    if (themeState.colorMode === "auto") {
        // Set colorMode based on the user preference
        themeState.colorMode = (0, $jodS5.default).getColorMode();
        // Bind a listener (if one doesn't already exist) to keep colorMode updated
        (0, $jodS5.default).bind();
    } else (0, $jodS5.default).unbind();
    if ((0, $i2LcI.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) {
        if (themeState.contrastMode === "auto") {
            // Set contrastMode based on the user preference
            themeState.contrastMode = (0, $6wkMV.default).getContrastMode();
            // Bind a listener (if one doesn't already exist) to keep contrastMode updated
            (0, $6wkMV.default).bind();
        } else (0, $6wkMV.default).unbind();
    }
    var themeAttributes = (0, $bDlvL.default)(themeState);
    Object.entries(themeAttributes).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        document.documentElement.setAttribute(key, value);
    });
    return function() {
        (0, $jodS5.default).unbind();
        if ((0, $i2LcI.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) (0, $6wkMV.default).unbind();
    };
}

});
parcelRegister("bDlvL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $878405ec9d471670$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $i2LcI = parcelRequire("i2LcI");

var $bDRHl = parcelRequire("bDRHl");

var $icabj = parcelRequire("icabj");

var $juoNE = parcelRequire("juoNE");

var $ckFNI = parcelRequire("ckFNI");

var $5S9Ox = parcelRequire("5S9Ox");
function $878405ec9d471670$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $878405ec9d471670$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $878405ec9d471670$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $878405ec9d471670$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $878405ec9d471670$var$defaultColorMode = "light";
var $878405ec9d471670$var$defaultContrastMode = "no-preference";
/**
 * Server-side rendering utility. Generates the valid HTML attributes for a given theme.
 * Note: this utility does not handle automatic theme switching.
 *
 * @param {Object<string, string>} themeOptions - Theme options object
 * @param {string} themeState.colorMode Determines which color theme is applied. If set to `auto`, the theme applied will be determined by the OS setting.
 * @param {string} themeState.dark The color theme to be applied when the color mode resolves to 'dark'.
 * @param {string} themeState.light The color theme to be applied when the color mode resolves to 'light'.
 * @param {string} themeState.spacing The spacing theme to be applied.
 * @param {string} themeState.typography The typography theme to be applied.
 * @param {Object} themeState.UNSAFE_themeOptions The custom branding options to be used for custom theme generation
 *
 * @returns {Object} Object of HTML attributes to be applied to the document root
 */ var $878405ec9d471670$var$getThemeHtmlAttrs = function getThemeHtmlAttrs() {
    var _result;
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$colorMode = _ref.colorMode, colorMode = _ref$colorMode === void 0 ? (0, $icabj.themeStateDefaults)["colorMode"] : _ref$colorMode, _ref$dark = _ref.dark, dark = _ref$dark === void 0 ? (0, $icabj.themeStateDefaults)["dark"] : _ref$dark, _ref$light = _ref.light, light = _ref$light === void 0 ? (0, $icabj.themeStateDefaults)["light"] : _ref$light, _ref$contrastMode = _ref.contrastMode, contrastMode = _ref$contrastMode === void 0 ? (0, $icabj.themeStateDefaults)["contrastMode"] : _ref$contrastMode, _ref$shape = _ref.shape, shape = _ref$shape === void 0 ? (0, $icabj.themeStateDefaults)["shape"] : _ref$shape, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? (0, $icabj.themeStateDefaults)["spacing"] : _ref$spacing, _ref$typography = _ref.typography, typography = _ref$typography === void 0 ? (0, $icabj.themeStateDefaults)["typography"] : _ref$typography, _ref$UNSAFE_themeOpti = _ref.UNSAFE_themeOptions, UNSAFE_themeOptions = _ref$UNSAFE_themeOpti === void 0 ? (0, $icabj.themeStateDefaults)["UNSAFE_themeOptions"] : _ref$UNSAFE_themeOpti;
    var themeAttribute = (0, $juoNE.themeObjectToString)({
        dark: dark,
        light: light,
        shape: shape,
        spacing: spacing,
        typography: typography
    });
    var result = (_result = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_result, (0, $bDRHl.THEME_DATA_ATTRIBUTE), themeAttribute), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_result, (0, $bDRHl.COLOR_MODE_ATTRIBUTE), colorMode === "auto" ? $878405ec9d471670$var$defaultColorMode : colorMode), _result);
    if ((0, $i2LcI.getBooleanFF)("platform.design-system-team.increased-contrast-themes")) result = $878405ec9d471670$var$_objectSpread($878405ec9d471670$var$_objectSpread({}, result), {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, (0, $bDRHl.CONTRAST_MODE_ATTRIBUTE), contrastMode === "auto" ? $878405ec9d471670$var$defaultContrastMode : contrastMode));
    if (UNSAFE_themeOptions && (0, $ckFNI.isValidBrandHex)(UNSAFE_themeOptions.brandColor)) {
        var optionString = JSON.stringify(UNSAFE_themeOptions);
        var uniqueId = (0, $5S9Ox.hash)(optionString);
        result[0, $bDRHl.CUSTOM_THEME_ATTRIBUTE] = uniqueId;
    }
    return result;
};
var $878405ec9d471670$export$2e2bcd8739ae039 = $878405ec9d471670$var$getThemeHtmlAttrs;

});
parcelRegister("5S9Ox", function(module, exports) {

$parcel$export(module.exports, "hash", function () { return $44699bc9120bb840$export$d6af199866bfb566; });
var $44699bc9120bb840$export$d6af199866bfb566 = function hash(str) {
    var hash = 0;
    for(var i = 0; i < str.length; i++){
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash &= hash; // Convert to 32bit integer
    }
    return new Uint32Array([
        hash
    ])[0].toString(36);
};

});


parcelRegister("jodS5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1db04c1e1f7c628$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $k6Bkl = parcelRequire("k6Bkl");

var $bDRHl = parcelRequire("bDRHl");

var $lcCMu = parcelRequire("lcCMu");
var $e1db04c1e1f7c628$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system theme changes. Should be bound
 * to an event listener listening on the '(prefers-color-scheme: dark)' query
 * @param e The event representing a change in system theme.
 */ function $e1db04c1e1f7c628$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $bDRHl.COLOR_MODE_ATTRIBUTE), e.matches ? "dark" : "light");
}
var $e1db04c1e1f7c628$var$darkModeMql = $e1db04c1e1f7c628$var$isMatchMediaAvailable && window.matchMedia((0, $lcCMu.darkModeMediaQuery));
var $e1db04c1e1f7c628$var$ColorModeObserver = /*#__PURE__*/ function() {
    function ColorModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ColorModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbindThemeChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ColorModeObserver, [
        {
            key: "getColorMode",
            value: function getColorMode() {
                if (!$e1db04c1e1f7c628$var$darkModeMql) return "light";
                return $e1db04c1e1f7c628$var$darkModeMql !== null && $e1db04c1e1f7c628$var$darkModeMql !== void 0 && $e1db04c1e1f7c628$var$darkModeMql.matches ? "dark" : "light";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($e1db04c1e1f7c628$var$darkModeMql && this.unbindThemeChangeListener === null) this.unbindThemeChangeListener = (0, $k6Bkl.bind)($e1db04c1e1f7c628$var$darkModeMql, {
                    type: "change",
                    listener: $e1db04c1e1f7c628$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindThemeChangeListener) {
                    this.unbindThemeChangeListener();
                    this.unbindThemeChangeListener = null;
                }
            }
        }
    ]);
    return ColorModeObserver;
}();
/**
 * A singleton color mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $e1db04c1e1f7c628$var$SingletonColorModeObserver = new $e1db04c1e1f7c628$var$ColorModeObserver();
var $e1db04c1e1f7c628$export$2e2bcd8739ae039 = $e1db04c1e1f7c628$var$SingletonColorModeObserver;

});
parcelRegister("lcCMu", function(module, exports) {

$parcel$export(module.exports, "loadAndAppendThemeCss", function () { return $f6f8cd14966b02ee$export$26cd7ae85c7144e5; });
$parcel$export(module.exports, "darkModeMediaQuery", function () { return $f6f8cd14966b02ee$export$bb1e815119d30f8b; });
$parcel$export(module.exports, "moreContrastMediaQuery", function () { return $f6f8cd14966b02ee$export$8662df6937d86fcb; });

var $7f5qq = parcelRequire("7f5qq");

var $5msJs = parcelRequire("5msJs");

var $i2LcI = parcelRequire("i2LcI");

var $6xyVI = parcelRequire("6xyVI");

var $bDRHl = parcelRequire("bDRHl");
var $f6f8cd14966b02ee$export$26cd7ae85c7144e5 = /*#__PURE__*/ function() {
    var _ref = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(themeId) {
        var themeCss, style;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
            while(true)switch(_context.prev = _context.next){
                case 0:
                    if (!document.head.querySelector("style[".concat((0, $bDRHl.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]:not([').concat((0, $bDRHl.CUSTOM_THEME_ATTRIBUTE), "])"))) {
                        _context.next = 2;
                        break;
                    }
                    return _context.abrupt("return");
                case 2:
                    if (themeId) {
                        _context.next = 4;
                        break;
                    }
                    return _context.abrupt("return");
                case 4:
                    _context.next = 6;
                    return $f6f8cd14966b02ee$export$8a48286ed7df6720(themeId);
                case 6:
                    themeCss = _context.sent;
                    style = document.createElement("style");
                    style.textContent = themeCss;
                    style.dataset.theme = themeId;
                    document.head.appendChild(style);
                case 11:
                case "end":
                    return _context.stop();
            }
        }, _callee);
    }));
    return function loadAndAppendThemeCss(_x) {
        return _ref.apply(this, arguments);
    };
}();
var $f6f8cd14966b02ee$export$8a48286ed7df6720 = /*#__PURE__*/ function() {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(themeId) {
        var _yield$themeImportMap, themeCss;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
            while(true)switch(_context2.prev = _context2.next){
                case 0:
                    if ((themeId === "light" || themeId === "dark") && (0, $i2LcI.fg)("platform-component-visual-refresh")) themeId += "-brand-refresh";
                    _context2.next = 3;
                    return (0, $6xyVI.default)[themeId]();
                case 3:
                    _yield$themeImportMap = _context2.sent;
                    themeCss = _yield$themeImportMap.default;
                    return _context2.abrupt("return", themeCss);
                case 6:
                case "end":
                    return _context2.stop();
            }
        }, _callee2);
    }));
    return function loadThemeCss(_x2) {
        return _ref2.apply(this, arguments);
    };
}();
var $f6f8cd14966b02ee$export$bb1e815119d30f8b = "(prefers-color-scheme: dark)";
var $f6f8cd14966b02ee$export$8662df6937d86fcb = "(prefers-contrast: more)";

});
parcelRegister("6xyVI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c30eb7a1dd45237$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This file contains a dynamic import for each theme this package exports.
 * Themes are loaded asynchronously at runtime to minimise the amount of CSS we send to the client.
 * This allows users to compose their themes and only use the tokens that are requested.
 * When a new theme is created, the import should automatically be added to the map
 *
 * @codegen <<SignedSource::8352f41e09dfe9d45ead708661744456>>
 * @codegenCommand yarn build tokens
 */ 














var $4c30eb7a1dd45237$var$themeImportsMap = {
    "light": function light() {
        return (parcelRequire("kHYoq"));
    },
    "light-future": function lightFuture() {
        return (parcelRequire("gpRk8"));
    },
    "light-increased-contrast": function lightIncreasedContrast() {
        return (parcelRequire("c8RbB"));
    },
    "dark": function dark() {
        return (parcelRequire("isrGv"));
    },
    "dark-future": function darkFuture() {
        return (parcelRequire("5dwxv"));
    },
    "dark-increased-contrast": function darkIncreasedContrast() {
        return (parcelRequire("kKMbx"));
    },
    "legacy-light": function legacyLight() {
        return (parcelRequire("rYlZ2"));
    },
    "legacy-dark": function legacyDark() {
        return (parcelRequire("5TU7G"));
    },
    "spacing": function spacing() {
        return (parcelRequire("iTurb"));
    },
    "typography-adg3": function typographyAdg3() {
        return (parcelRequire("8FkoG"));
    },
    "shape": function shape() {
        return (parcelRequire("hnVYZ"));
    },
    "typography-modernized": function typographyModernized() {
        return (parcelRequire("briFb"));
    },
    "typography-refreshed": function typographyRefreshed() {
        return (parcelRequire("c7EWG"));
    },
    "light-brand-refresh": function lightBrandRefresh() {
        return (parcelRequire("aeCsz"));
    },
    "dark-brand-refresh": function darkBrandRefresh() {
        return (parcelRequire("4asKf"));
    }
};
var $4c30eb7a1dd45237$export$2e2bcd8739ae039 = $4c30eb7a1dd45237$var$themeImportsMap;

});
parcelRegister("kHYoq", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5RhAq")).then(()=>parcelRequire("5La7Y"));

});

parcelRegister("gpRk8", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("gK1Yq")).then(()=>parcelRequire("kwQvi"));

});

parcelRegister("c8RbB", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9gbDH")).then(()=>parcelRequire("aJEBV"));

});

parcelRegister("isrGv", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4Oijb")).then(()=>parcelRequire("b5Mom"));

});

parcelRegister("5dwxv", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("j2dhL")).then(()=>parcelRequire("kakn5"));

});

parcelRegister("kKMbx", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("95iyH")).then(()=>parcelRequire("5RNcl"));

});

parcelRegister("rYlZ2", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("f6mth")).then(()=>parcelRequire("kpJ9q"));

});

parcelRegister("5TU7G", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("02w4q")).then(()=>parcelRequire("buee9"));

});

parcelRegister("iTurb", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lTbXm")).then(()=>parcelRequire("aPPua"));

});

parcelRegister("8FkoG", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("3XOdM")).then(()=>parcelRequire("iiwWs"));

});

parcelRegister("hnVYZ", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("bd7QQ")).then(()=>parcelRequire("2ha2L"));

});

parcelRegister("briFb", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("dKPoJ")).then(()=>parcelRequire("bUpS3"));

});

parcelRegister("c7EWG", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("jP2fr")).then(()=>parcelRequire("24dUH"));

});

parcelRegister("aeCsz", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aMC4s")).then(()=>parcelRequire("aoFOn"));

});

parcelRegister("4asKf", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("6Amvt")).then(()=>parcelRequire("4ASg8"));

});




parcelRegister("6wkMV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4bf5db56eda62f9b$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $k6Bkl = parcelRequire("k6Bkl");

var $bDRHl = parcelRequire("bDRHl");

var $lcCMu = parcelRequire("lcCMu");
var $4bf5db56eda62f9b$var$isMatchMediaAvailable = typeof window !== "undefined" && "matchMedia" in window;
/**
 * Updates the current theme when the system contrast preference changes. Should be bound
 * to an event listener listening on the '(prefers-contrast: more)' query
 * @param e The event representing a change in system theme.
 */ function $4bf5db56eda62f9b$var$checkNativeListener(e) {
    var element = document.documentElement;
    element.setAttribute((0, $bDRHl.CONTRAST_MODE_ATTRIBUTE), e.matches ? "more" : "no-preference");
}
var $4bf5db56eda62f9b$var$contrastModeMql = $4bf5db56eda62f9b$var$isMatchMediaAvailable && window.matchMedia((0, $lcCMu.moreContrastMediaQuery));
var $4bf5db56eda62f9b$var$ContrastModeObserver = /*#__PURE__*/ function() {
    function ContrastModeObserver() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ContrastModeObserver);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "unbindContrastChangeListener", null);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ContrastModeObserver, [
        {
            key: "getContrastMode",
            value: function getContrastMode() {
                if (!$4bf5db56eda62f9b$var$contrastModeMql) return "no-preference";
                return $4bf5db56eda62f9b$var$contrastModeMql !== null && $4bf5db56eda62f9b$var$contrastModeMql !== void 0 && $4bf5db56eda62f9b$var$contrastModeMql.matches ? "more" : "no-preference";
            }
        },
        {
            key: "bind",
            value: function bind() {
                if ($4bf5db56eda62f9b$var$contrastModeMql && this.unbindContrastChangeListener === null) this.unbindContrastChangeListener = (0, $k6Bkl.bind)($4bf5db56eda62f9b$var$contrastModeMql, {
                    type: "change",
                    listener: $4bf5db56eda62f9b$var$checkNativeListener
                });
            }
        },
        {
            key: "unbind",
            value: function unbind() {
                if (this.unbindContrastChangeListener) {
                    this.unbindContrastChangeListener();
                    this.unbindContrastChangeListener = null;
                }
            }
        }
    ]);
    return ContrastModeObserver;
}();
/**
 * A singleton contrast mode observer - binds "auto" switching logic to a single `mediaQueryList` listener
 * that can be unbound by any consumer when no longer needed.
 */ var $4bf5db56eda62f9b$var$SingletonContrastModeObserver = new $4bf5db56eda62f9b$var$ContrastModeObserver();
var $4bf5db56eda62f9b$export$2e2bcd8739ae039 = $4bf5db56eda62f9b$var$SingletonContrastModeObserver;

});


parcelRegister("9TV3v", function(module, exports) {

$parcel$export(module.exports, "findMissingCustomStyleElements", function () { return $735582283b5cccb2$export$bd1ac9300b0e885a; });
$parcel$export(module.exports, "limitSizeOfCustomStyleElements", function () { return $735582283b5cccb2$export$e7ae172320e03461; });
$parcel$export(module.exports, "reduceTokenMap", function () { return $735582283b5cccb2$export$e673f367da2ff23e; });

var $kg5sN = parcelRequire("kg5sN");

var $cF8Kw = parcelRequire("cF8Kw");

var $aBY8N = parcelRequire("aBY8N");

var $bDRHl = parcelRequire("bDRHl");

var $5S9Ox = parcelRequire("5S9Ox");
function $735582283b5cccb2$export$bd1ac9300b0e885a(UNSAFE_themeOptions, mode) {
    var optionString = JSON.stringify(UNSAFE_themeOptions);
    var uniqueId = (0, $5S9Ox.hash)(optionString);
    var attrOfMissingCustomStyles = [];
    (mode === "auto" ? [
        "light",
        "dark"
    ] : [
        mode
    ]).forEach(function(themeId) {
        var element = document.head.querySelector("style[".concat((0, $bDRHl.CUSTOM_THEME_ATTRIBUTE), '="').concat(uniqueId, '"][').concat((0, $bDRHl.THEME_DATA_ATTRIBUTE), '="').concat(themeId, '"]'));
        if (element) // Append the existing custom styles to take precedence over others
        document.head.appendChild(element);
        else attrOfMissingCustomStyles.push(themeId);
    });
    return attrOfMissingCustomStyles;
}
function $735582283b5cccb2$export$e7ae172320e03461(sizeThreshold) {
    var styleTags = (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(Array.from(document.head.querySelectorAll("style[".concat((0, $bDRHl.CUSTOM_THEME_ATTRIBUTE), "][").concat((0, $bDRHl.THEME_DATA_ATTRIBUTE), "]"))));
    if (styleTags.length < sizeThreshold) return;
    styleTags.slice(0, styleTags.length - (sizeThreshold - 1)).forEach(function(element) {
        return element.remove();
    });
}
function $735582283b5cccb2$export$e673f367da2ff23e(tokenMap, themeRamp) {
    return Object.entries(tokenMap).reduce(function(acc, _ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cssVar = (0, $aBY8N.default)[key];
        return cssVar ? "".concat(acc, "\n  ").concat(cssVar, ": ").concat(typeof value === "string" ? value : themeRamp[value], ";") : acc;
    }, "");
}

});

parcelRegister("i6I7h", function(module, exports) {

$parcel$export(module.exports, "getThemePreferences", function () { return $d2eb021c005a43dc$export$dd6aeb7c823fc03d; });
$parcel$export(module.exports, "getThemeOverridePreferences", function () { return $d2eb021c005a43dc$export$5d76d7014f4a5d08; });

var $cF8Kw = parcelRequire("cF8Kw");

var $i2LcI = parcelRequire("i2LcI");

var $6C7Th = parcelRequire("6C7Th");
var $d2eb021c005a43dc$export$dd6aeb7c823fc03d = function getThemePreferences(themeState) {
    var colorMode = themeState.colorMode, contrastMode = themeState.contrastMode, dark = themeState.dark, light = themeState.light, shape = themeState.shape, spacing = themeState.spacing, typography = themeState.typography;
    var autoColorModeThemes = [
        light,
        dark
    ];
    var themePreferences = [];
    if (colorMode === "auto") {
        if (contrastMode !== "no-preference" && (0, $i2LcI.fg)("platform.design-system-team.increased-contrast-themes")) autoColorModeThemes.forEach(function(normalTheme) {
            var increasedContrastTheme = (0, $6C7Th.default)(normalTheme);
            if (increasedContrastTheme) autoColorModeThemes.push(increasedContrastTheme);
        });
        themePreferences.push.apply(themePreferences, autoColorModeThemes);
    } else {
        themePreferences.push(themeState[colorMode]);
        if (contrastMode !== "no-preference" && (0, $i2LcI.fg)("platform.design-system-team.increased-contrast-themes")) {
            var increasedContrastTheme = (0, $6C7Th.default)(themeState[colorMode]);
            if (increasedContrastTheme) themePreferences.push(increasedContrastTheme);
        }
    }
    [
        shape,
        spacing,
        typography
    ].forEach(function(themeId) {
        if (themeId) themePreferences.push(themeId);
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set(themePreferences));
};
var $d2eb021c005a43dc$export$5d76d7014f4a5d08 = function getThemeOverridePreferences(_themeState) {
    var themeOverridePreferences = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(new Set(themeOverridePreferences));
};

});
parcelRegister("6C7Th", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4d0c6993b17e563a$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $icabj = parcelRequire("icabj");
function $4d0c6993b17e563a$export$2e2bcd8739ae039(themeId) {
    var _Object$entries$find;
    return (_Object$entries$find = Object.entries((0, $icabj.default)).find(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), increasesContrastFor = _ref2[1].increasesContrastFor;
        return increasesContrastFor === themeId;
    })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[1].id;
}

});


parcelRegister("7ckqH", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e0PVZ")).then(()=>parcelRequire("bJxb0"));

});


parcelRegister("3o9o3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $277ae50bc9fd00a3$export$2e2bcd8739ae039; }, function (v) { return $277ae50bc9fd00a3$export$2e2bcd8739ae039 = v; });
var $277ae50bc9fd00a3$export$1e511d4a378977f5;
var $277ae50bc9fd00a3$export$dcef8f9bb9a41431;
var $277ae50bc9fd00a3$export$2e2bcd8739ae039;
$277ae50bc9fd00a3$export$1e511d4a378977f5 = true;
$277ae50bc9fd00a3$export$dcef8f9bb9a41431 = undefined;
var $277ae50bc9fd00a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $277ae50bc9fd00a3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8ZuGG = parcelRequire("8ZuGG");
var $277ae50bc9fd00a3$var$_react2 = $277ae50bc9fd00a3$var$_interopRequireDefault($8ZuGG);

var $6CJPF = parcelRequire("6CJPF");
var $277ae50bc9fd00a3$var$_propTypes2 = $277ae50bc9fd00a3$var$_interopRequireDefault($6CJPF);

var $hy2Kv = parcelRequire("hy2Kv");
var $277ae50bc9fd00a3$var$_reactSideEffect2 = $277ae50bc9fd00a3$var$_interopRequireDefault($hy2Kv);

var $dvvSh = parcelRequire("dvvSh");
var $277ae50bc9fd00a3$var$_reactFastCompare2 = $277ae50bc9fd00a3$var$_interopRequireDefault($dvvSh);

var $7qvS0 = parcelRequire("7qvS0");

var $d2KJI = parcelRequire("d2KJI");
function $277ae50bc9fd00a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $277ae50bc9fd00a3$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $277ae50bc9fd00a3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $277ae50bc9fd00a3$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $277ae50bc9fd00a3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $277ae50bc9fd00a3$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $277ae50bc9fd00a3$var$_inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $277ae50bc9fd00a3$var$_classCallCheck(this, HelmetWrapper);
            return $277ae50bc9fd00a3$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, $277ae50bc9fd00a3$var$_reactFastCompare2.default)(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $d2KJI.TAG_NAMES.SCRIPT:
                case $d2KJI.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $d2KJI.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $277ae50bc9fd00a3$var$_extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $277ae50bc9fd00a3$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _extends2));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $d2KJI.TAG_NAMES.TITLE:
                    return $277ae50bc9fd00a3$var$_extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = $277ae50bc9fd00a3$var$_extends({}, newChildProps), _extends3));
                case $d2KJI.TAG_NAMES.BODY:
                    return $277ae50bc9fd00a3$var$_extends({}, newProps, {
                        bodyAttributes: $277ae50bc9fd00a3$var$_extends({}, newChildProps)
                    });
                case $d2KJI.TAG_NAMES.HTML:
                    return $277ae50bc9fd00a3$var$_extends({}, newProps, {
                        htmlAttributes: $277ae50bc9fd00a3$var$_extends({}, newChildProps)
                    });
            }
            return $277ae50bc9fd00a3$var$_extends({}, newProps, (_extends4 = {}, _extends4[child.type] = $277ae50bc9fd00a3$var$_extends({}, newChildProps), _extends4));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $277ae50bc9fd00a3$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _extends5;
                newFlattenedProps = $277ae50bc9fd00a3$var$_extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            $277ae50bc9fd00a3$var$_react2.default.Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $277ae50bc9fd00a3$var$_objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = (0, $7qvS0.convertReactPropstoHtmlAttributes)(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $d2KJI.TAG_NAMES.LINK:
                    case $d2KJI.TAG_NAMES.META:
                    case $d2KJI.TAG_NAMES.NOSCRIPT:
                    case $d2KJI.TAG_NAMES.SCRIPT:
                    case $d2KJI.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $277ae50bc9fd00a3$var$_objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $277ae50bc9fd00a3$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return $277ae50bc9fd00a3$var$_react2.default.createElement(Component, newProps);
        };
        $277ae50bc9fd00a3$var$_createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }($277ae50bc9fd00a3$var$_react2.default.Component), _class.propTypes = {
        base: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        bodyAttributes: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        children: $277ae50bc9fd00a3$var$_propTypes2.default.oneOfType([
            $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.node),
            $277ae50bc9fd00a3$var$_propTypes2.default.node
        ]),
        defaultTitle: $277ae50bc9fd00a3$var$_propTypes2.default.string,
        defer: $277ae50bc9fd00a3$var$_propTypes2.default.bool,
        encodeSpecialCharacters: $277ae50bc9fd00a3$var$_propTypes2.default.bool,
        htmlAttributes: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        link: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        meta: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        noscript: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        onChangeClientState: $277ae50bc9fd00a3$var$_propTypes2.default.func,
        script: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        style: $277ae50bc9fd00a3$var$_propTypes2.default.arrayOf($277ae50bc9fd00a3$var$_propTypes2.default.object),
        title: $277ae50bc9fd00a3$var$_propTypes2.default.string,
        titleAttributes: $277ae50bc9fd00a3$var$_propTypes2.default.object,
        titleTemplate: $277ae50bc9fd00a3$var$_propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = (0, $7qvS0.mapStateOnServer)({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $277ae50bc9fd00a3$var$NullComponent = function NullComponent() {
    return null;
};
var $277ae50bc9fd00a3$var$HelmetSideEffects = (0, $277ae50bc9fd00a3$var$_reactSideEffect2.default)($7qvS0.reducePropsToState, $7qvS0.handleClientStateChange, $7qvS0.mapStateOnServer)($277ae50bc9fd00a3$var$NullComponent);
var $277ae50bc9fd00a3$var$HelmetExport = $277ae50bc9fd00a3$var$Helmet($277ae50bc9fd00a3$var$HelmetSideEffects);
$277ae50bc9fd00a3$var$HelmetExport.renderStatic = $277ae50bc9fd00a3$var$HelmetExport.rewind;
$277ae50bc9fd00a3$export$dcef8f9bb9a41431 = $277ae50bc9fd00a3$var$HelmetExport;
$277ae50bc9fd00a3$export$2e2bcd8739ae039 = $277ae50bc9fd00a3$var$HelmetExport;

});
parcelRegister("6CJPF", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4d29d80e7041a0e5$var$ReactIs, $4d29d80e7041a0e5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("9fskv"))();

});
parcelRegister("9fskv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $9rdNz = parcelRequire("9rdNz");
function $6bbb7d7d00cbcfd9$var$emptyFunction() {}
function $6bbb7d7d00cbcfd9$var$emptyFunctionWithReset() {}
$6bbb7d7d00cbcfd9$var$emptyFunctionWithReset.resetWarningCache = $6bbb7d7d00cbcfd9$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $9rdNz) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $6bbb7d7d00cbcfd9$var$emptyFunctionWithReset,
        resetWarningCache: $6bbb7d7d00cbcfd9$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("9rdNz", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $6df156ca640c7829$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $6df156ca640c7829$var$ReactPropTypesSecret;

});



parcelRegister("hy2Kv", function(module, exports) {
"use strict";
function $cc67be915ef1ace6$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $8ZuGG = parcelRequire("8ZuGG");
var $cc67be915ef1ace6$var$React__default = $cc67be915ef1ace6$var$_interopDefault($8ZuGG);

var $cc67be915ef1ace6$var$shallowEqual = $cc67be915ef1ace6$var$_interopDefault((parcelRequire("lA2Ha")));
function $cc67be915ef1ace6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cc67be915ef1ace6$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $cc67be915ef1ace6$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $cc67be915ef1ace6$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_Component) {
            $cc67be915ef1ace6$var$_inheritsLoose(SideEffect, _Component);
            function SideEffect() {
                return _Component.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
                return !$cc67be915ef1ace6$var$shallowEqual(nextProps, this.props);
            };
            _proto.componentWillMount = function componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $cc67be915ef1ace6$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($8ZuGG.Component);
        $cc67be915ef1ace6$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $cc67be915ef1ace6$var$_defineProperty(SideEffect, "canUseDOM", $cc67be915ef1ace6$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $cc67be915ef1ace6$var$withSideEffect;

});
parcelRegister("lA2Ha", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});


parcelRegister("dvvSh", function(module, exports) {
"use strict";
var $9d56e535984c73e5$var$isArray = Array.isArray;
var $9d56e535984c73e5$var$keyList = Object.keys;
var $9d56e535984c73e5$var$hasProp = Object.prototype.hasOwnProperty;
var $9d56e535984c73e5$var$hasElementType = typeof Element !== "undefined";
function $9d56e535984c73e5$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        var arrA = $9d56e535984c73e5$var$isArray(a), arrB = $9d56e535984c73e5$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$9d56e535984c73e5$var$equal(a[i], b[i])) return false;
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $9d56e535984c73e5$var$keyList(a);
        length = keys.length;
        if (length !== $9d56e535984c73e5$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;)if (!$9d56e535984c73e5$var$hasProp.call(b, keys[i])) return false;
        // end fast-deep-equal
        // start react-fast-compare
        // custom handling for DOM elements
        if ($9d56e535984c73e5$var$hasElementType && a instanceof Element && b instanceof Element) return a === b;
        // custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$9d56e535984c73e5$var$equal(a[key], b[key])) return false;
            }
        }
        // end react-fast-compare
        // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function exportedEqual(a, b) {
    try {
        return $9d56e535984c73e5$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i) || error.number === -2146828260) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("7qvS0", function(module, exports) {

$parcel$export(module.exports, "reducePropsToState", function () { return $5683aed557661a44$export$bfed3b07ff81c934; }, function (v) { return $5683aed557661a44$export$bfed3b07ff81c934 = v; });
$parcel$export(module.exports, "mapStateOnServer", function () { return $5683aed557661a44$export$971402543ca2bd1d; }, function (v) { return $5683aed557661a44$export$971402543ca2bd1d = v; });
$parcel$export(module.exports, "handleClientStateChange", function () { return $5683aed557661a44$export$8e0854f6f2040fff; }, function (v) { return $5683aed557661a44$export$8e0854f6f2040fff = v; });
$parcel$export(module.exports, "convertReactPropstoHtmlAttributes", function () { return $5683aed557661a44$export$8f437c7c6568a694; }, function (v) { return $5683aed557661a44$export$8f437c7c6568a694 = v; });
var $5683aed557661a44$export$1e511d4a378977f5;
var $5683aed557661a44$export$c106dd0671a0fc2d;
var $5683aed557661a44$export$6cb2c4c0a22909c0;
var $5683aed557661a44$export$bfed3b07ff81c934;
var $5683aed557661a44$export$971402543ca2bd1d;
var $5683aed557661a44$export$8e0854f6f2040fff;
var $5683aed557661a44$export$8f437c7c6568a694;
$5683aed557661a44$export$1e511d4a378977f5 = true;
$5683aed557661a44$export$c106dd0671a0fc2d = $5683aed557661a44$export$6cb2c4c0a22909c0 = $5683aed557661a44$export$bfed3b07ff81c934 = $5683aed557661a44$export$971402543ca2bd1d = $5683aed557661a44$export$8e0854f6f2040fff = $5683aed557661a44$export$8f437c7c6568a694 = undefined;
var $5683aed557661a44$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $5683aed557661a44$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8ZuGG = parcelRequire("8ZuGG");
var $5683aed557661a44$var$_react2 = $5683aed557661a44$var$_interopRequireDefault($8ZuGG);

var $lir0C = parcelRequire("lir0C");
var $5683aed557661a44$var$_objectAssign2 = $5683aed557661a44$var$_interopRequireDefault($lir0C);

var $d2KJI = parcelRequire("d2KJI");
function $5683aed557661a44$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5683aed557661a44$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $5683aed557661a44$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.TAG_NAMES.TITLE);
    var innermostTemplate = $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return innermostTitle;
    });
    var innermostDefaultTitle = $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $5683aed557661a44$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $5683aed557661a44$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $5683aed557661a44$var$_extends({}, tagAttrs, current);
    }, {});
};
var $5683aed557661a44$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$d2KJI.TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$d2KJI.TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $5683aed557661a44$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $5683aed557661a44$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $5683aed557661a44$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $d2KJI.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $d2KJI.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $d2KJI.TAG_PROPERTIES.INNER_HTML || attributeKey === $d2KJI.TAG_PROPERTIES.CSS_TEXT || attributeKey === $d2KJI.TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, $5683aed557661a44$var$_objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $5683aed557661a44$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $5683aed557661a44$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $5683aed557661a44$var$getBaseTagFromPropsList([
            $d2KJI.TAG_PROPERTIES.HREF
        ], propsList),
        bodyAttributes: $5683aed557661a44$var$getAttributesFromPropsList($d2KJI.ATTRIBUTE_NAMES.BODY, propsList),
        defer: $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.DEFER),
        encode: $5683aed557661a44$var$getInnermostProperty(propsList, $d2KJI.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $5683aed557661a44$var$getAttributesFromPropsList($d2KJI.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.LINK, [
            $d2KJI.TAG_PROPERTIES.REL,
            $d2KJI.TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.META, [
            $d2KJI.TAG_PROPERTIES.NAME,
            $d2KJI.TAG_PROPERTIES.CHARSET,
            $d2KJI.TAG_PROPERTIES.HTTPEQUIV,
            $d2KJI.TAG_PROPERTIES.PROPERTY,
            $d2KJI.TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.NOSCRIPT, [
            $d2KJI.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $5683aed557661a44$var$getOnChangeClientState(propsList),
        scriptTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.SCRIPT, [
            $d2KJI.TAG_PROPERTIES.SRC,
            $d2KJI.TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $5683aed557661a44$var$getTagsFromPropsList($d2KJI.TAG_NAMES.STYLE, [
            $d2KJI.TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $5683aed557661a44$var$getTitleFromPropsList(propsList),
        titleAttributes: $5683aed557661a44$var$getAttributesFromPropsList($d2KJI.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $5683aed557661a44$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $5683aed557661a44$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $5683aed557661a44$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $5683aed557661a44$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $5683aed557661a44$var$rafPolyfill : $parcel$global.requestAnimationFrame || $5683aed557661a44$var$rafPolyfill;
var $5683aed557661a44$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $5683aed557661a44$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $5683aed557661a44$var$cafPolyfill;
var $5683aed557661a44$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $5683aed557661a44$var$_helmetCallback = null;
var $5683aed557661a44$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($5683aed557661a44$var$_helmetCallback) $5683aed557661a44$var$cancelAnimationFrame($5683aed557661a44$var$_helmetCallback);
    if (newState.defer) $5683aed557661a44$var$_helmetCallback = $5683aed557661a44$var$requestAnimationFrame(function() {
        $5683aed557661a44$var$commitTagChanges(newState, function() {
            $5683aed557661a44$var$_helmetCallback = null;
        });
    });
    else {
        $5683aed557661a44$var$commitTagChanges(newState);
        $5683aed557661a44$var$_helmetCallback = null;
    }
};
var $5683aed557661a44$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $5683aed557661a44$var$updateAttributes($d2KJI.TAG_NAMES.BODY, bodyAttributes);
    $5683aed557661a44$var$updateAttributes($d2KJI.TAG_NAMES.HTML, htmlAttributes);
    $5683aed557661a44$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.BASE, baseTag),
        linkTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.LINK, linkTags),
        metaTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.META, metaTags),
        noscriptTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $5683aed557661a44$var$updateTags($d2KJI.TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $5683aed557661a44$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $5683aed557661a44$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $5683aed557661a44$var$flattenArray(title);
    $5683aed557661a44$var$updateAttributes($d2KJI.TAG_NAMES.TITLE, attributes);
};
var $5683aed557661a44$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($d2KJI.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($d2KJI.HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($d2KJI.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($d2KJI.HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $5683aed557661a44$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($d2KJI.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $d2KJI.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $d2KJI.TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $d2KJI.TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($d2KJI.HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $5683aed557661a44$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $5683aed557661a44$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $5683aed557661a44$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $5683aed557661a44$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $d2KJI.HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $5683aed557661a44$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $d2KJI.HELMET_ATTRIBUTE + '="true">' + $5683aed557661a44$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $5683aed557661a44$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $d2KJI.TAG_PROPERTIES.INNER_HTML || attribute === $d2KJI.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $5683aed557661a44$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $d2KJI.SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $d2KJI.HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $5683aed557661a44$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$d2KJI.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $5683aed557661a44$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$d2KJI.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $5683aed557661a44$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$d2KJI.HELMET_ATTRIBUTE] = true, _initProps);
    var props = $5683aed557661a44$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        $5683aed557661a44$var$_react2.default.createElement($d2KJI.TAG_NAMES.TITLE, props, title)
    ];
};
var $5683aed557661a44$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$d2KJI.HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $d2KJI.REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $d2KJI.TAG_PROPERTIES.INNER_HTML || mappedAttribute === $d2KJI.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return $5683aed557661a44$var$_react2.default.createElement(type, mappedTag);
    });
};
var $5683aed557661a44$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $d2KJI.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $5683aed557661a44$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $5683aed557661a44$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $d2KJI.ATTRIBUTE_NAMES.BODY:
        case $d2KJI.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $5683aed557661a44$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $5683aed557661a44$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $5683aed557661a44$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $5683aed557661a44$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $5683aed557661a44$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $5683aed557661a44$var$getMethodsForTag($d2KJI.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $5683aed557661a44$var$getMethodsForTag($d2KJI.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.LINK, linkTags, encode),
        meta: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.META, metaTags, encode),
        noscript: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.STYLE, styleTags, encode),
        title: $5683aed557661a44$var$getMethodsForTag($d2KJI.TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
$5683aed557661a44$export$8f437c7c6568a694 = $5683aed557661a44$var$convertReactPropstoHtmlAttributes;
$5683aed557661a44$export$8e0854f6f2040fff = $5683aed557661a44$var$handleClientStateChange;
$5683aed557661a44$export$971402543ca2bd1d = $5683aed557661a44$var$mapStateOnServer;
$5683aed557661a44$export$bfed3b07ff81c934 = $5683aed557661a44$var$reducePropsToState;
$5683aed557661a44$export$6cb2c4c0a22909c0 = $5683aed557661a44$var$requestAnimationFrame;
$5683aed557661a44$export$c106dd0671a0fc2d = $5683aed557661a44$var$warn;

});
parcelRegister("d2KJI", function(module, exports) {

$parcel$export(module.exports, "ATTRIBUTE_NAMES", function () { return $97efb7253686f530$export$8b4d23abccee6cc2; }, function (v) { return $97efb7253686f530$export$8b4d23abccee6cc2 = v; });
$parcel$export(module.exports, "TAG_NAMES", function () { return $97efb7253686f530$export$7e674a85a2656dce; }, function (v) { return $97efb7253686f530$export$7e674a85a2656dce = v; });
$parcel$export(module.exports, "TAG_PROPERTIES", function () { return $97efb7253686f530$export$55a55363959ee034; }, function (v) { return $97efb7253686f530$export$55a55363959ee034 = v; });
$parcel$export(module.exports, "REACT_TAG_MAP", function () { return $97efb7253686f530$export$f5ab464b3d67ea9c; }, function (v) { return $97efb7253686f530$export$f5ab464b3d67ea9c = v; });
$parcel$export(module.exports, "HELMET_PROPS", function () { return $97efb7253686f530$export$6bb0645fb3f2618c; }, function (v) { return $97efb7253686f530$export$6bb0645fb3f2618c = v; });
$parcel$export(module.exports, "HTML_TAG_MAP", function () { return $97efb7253686f530$export$3fedf55cd3a4e6fa; }, function (v) { return $97efb7253686f530$export$3fedf55cd3a4e6fa = v; });
$parcel$export(module.exports, "SELF_CLOSING_TAGS", function () { return $97efb7253686f530$export$7f7c530a82f07f20; }, function (v) { return $97efb7253686f530$export$7f7c530a82f07f20 = v; });
$parcel$export(module.exports, "HELMET_ATTRIBUTE", function () { return $97efb7253686f530$export$1f547d7d8e831b2b; }, function (v) { return $97efb7253686f530$export$1f547d7d8e831b2b = v; });
var $97efb7253686f530$export$1e511d4a378977f5;
var $97efb7253686f530$export$8b4d23abccee6cc2;
var $97efb7253686f530$export$7e674a85a2656dce;
var $97efb7253686f530$export$7a7b396eb62fa0f9;
var $97efb7253686f530$export$55a55363959ee034;
var $97efb7253686f530$export$f5ab464b3d67ea9c;
var $97efb7253686f530$export$6bb0645fb3f2618c;
var $97efb7253686f530$export$3fedf55cd3a4e6fa;
var $97efb7253686f530$export$7f7c530a82f07f20;
var $97efb7253686f530$export$1f547d7d8e831b2b;
$97efb7253686f530$export$1e511d4a378977f5 = true;
var $97efb7253686f530$var$ATTRIBUTE_NAMES = $97efb7253686f530$export$8b4d23abccee6cc2 = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $97efb7253686f530$var$TAG_NAMES = $97efb7253686f530$export$7e674a85a2656dce = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $97efb7253686f530$var$VALID_TAG_NAMES = $97efb7253686f530$export$7a7b396eb62fa0f9 = Object.keys($97efb7253686f530$var$TAG_NAMES).map(function(name) {
    return $97efb7253686f530$var$TAG_NAMES[name];
});
var $97efb7253686f530$var$TAG_PROPERTIES = $97efb7253686f530$export$55a55363959ee034 = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};
var $97efb7253686f530$var$REACT_TAG_MAP = $97efb7253686f530$export$f5ab464b3d67ea9c = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $97efb7253686f530$var$HELMET_PROPS = $97efb7253686f530$export$6bb0645fb3f2618c = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $97efb7253686f530$var$HTML_TAG_MAP = $97efb7253686f530$export$3fedf55cd3a4e6fa = Object.keys($97efb7253686f530$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$97efb7253686f530$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $97efb7253686f530$var$SELF_CLOSING_TAGS = $97efb7253686f530$export$7f7c530a82f07f20 = [
    $97efb7253686f530$var$TAG_NAMES.NOSCRIPT,
    $97efb7253686f530$var$TAG_NAMES.SCRIPT,
    $97efb7253686f530$var$TAG_NAMES.STYLE
];
var $97efb7253686f530$var$HELMET_ATTRIBUTE = $97efb7253686f530$export$1f547d7d8e831b2b = "data-react-helmet";

});



parcelRegister("lThM2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fefc8589746da7f2$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $1S0T5 = parcelRequire("1S0T5");

var $57fzU = parcelRequire("57fzU");

var $9YQBI = parcelRequire("9YQBI");
var $fefc8589746da7f2$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $fefc8589746da7f2$var$_excluded2 = [
    "className"
];
var $fefc8589746da7f2$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $fefc8589746da7f2$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $fefc8589746da7f2$var$_excluded2);
    var resolvedStyles = (0, $57fzU.parseXcss)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $14VNY.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $fefc8589746da7f2$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1S0T5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $1S0T5.isSurfaceColorToken)(backgroundColor) && (0, $1S0T5.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1S0T5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1S0T5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1S0T5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1S0T5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1S0T5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1S0T5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1S0T5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $14VNY.jsx)((0, $9YQBI.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $fefc8589746da7f2$export$2e2bcd8739ae039 = $fefc8589746da7f2$export$e71c4d32a2263218;
var $fefc8589746da7f2$var$baseStyles = (0, $14VNY.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});

});
parcelRegister("1S0T5", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", function () { return $15cb85ce99dd9824$export$6ccdbebca2ee545f; });
$parcel$export(module.exports, "positiveSpaceMap", function () { return $15cb85ce99dd9824$export$958d0ae7f2977ae4; });
$parcel$export(module.exports, "allSpaceMap", function () { return $15cb85ce99dd9824$export$632685d741f3dbbf; });
$parcel$export(module.exports, "inverseColorMap", function () { return $15cb85ce99dd9824$export$2185ce37f9bdd963; });
$parcel$export(module.exports, "opacityMap", function () { return $15cb85ce99dd9824$export$daf94a976c798b4f; });
$parcel$export(module.exports, "shadowMap", function () { return $15cb85ce99dd9824$export$7aff6e7ba39bb774; });
$parcel$export(module.exports, "borderColorMap", function () { return $15cb85ce99dd9824$export$1531ad5bb3fbedac; });
$parcel$export(module.exports, "backgroundColorMap", function () { return $15cb85ce99dd9824$export$d1d79bf68ac056bd; });
$parcel$export(module.exports, "textColorMap", function () { return $15cb85ce99dd9824$export$8473307aa00d6ea1; });
$parcel$export(module.exports, "layerMap", function () { return $15cb85ce99dd9824$export$b5f31a7e431d2eab; });
$parcel$export(module.exports, "borderWidthMap", function () { return $15cb85ce99dd9824$export$e1b83c5210c471b8; });
$parcel$export(module.exports, "borderRadiusMap", function () { return $15cb85ce99dd9824$export$3c0a6c3e64bb180d; });
$parcel$export(module.exports, "paddingStylesMap", function () { return $15cb85ce99dd9824$export$e615f061ca585a6c; });
$parcel$export(module.exports, "spaceStylesMap", function () { return $15cb85ce99dd9824$export$bf46c3f9eeafc71f; });
$parcel$export(module.exports, "backgroundColorStylesMap", function () { return $15cb85ce99dd9824$export$e7af83bafe7f9e63; });
$parcel$export(module.exports, "textColorStylesMap", function () { return $15cb85ce99dd9824$export$3a1bcba60b23d7f0; });
$parcel$export(module.exports, "fontWeightStylesMap", function () { return $15cb85ce99dd9824$export$45f3f4fe16f9f7d5; });
$parcel$export(module.exports, "fontStylesMap", function () { return $15cb85ce99dd9824$export$128f10c238242f83; });
$parcel$export(module.exports, "surfaceColorStylesMap", function () { return $15cb85ce99dd9824$export$ff257d957d48c421; });
$parcel$export(module.exports, "isSurfaceColorToken", function () { return $15cb85ce99dd9824$export$5e65a44e5b6ecadb; });

var $6bkHe = parcelRequire("6bkHe");

var $14VNY = parcelRequire("14VNY");

var $bDRHl = parcelRequire("bDRHl");
function $15cb85ce99dd9824$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15cb85ce99dd9824$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15cb85ce99dd9824$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15cb85ce99dd9824$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $15cb85ce99dd9824$export$6ccdbebca2ee545f = {
    "100%": "100%",
    "size.100": "1rem",
    "size.200": "1.5rem",
    "size.300": "2rem",
    "size.400": "2.5rem",
    "size.500": "3rem",
    "size.600": "6rem",
    "size.1000": "12rem"
};
var $15cb85ce99dd9824$export$958d0ae7f2977ae4 = {
    "space.0": "var(--ds-space-0, 0px)",
    "space.025": "var(--ds-space-025, 2px)",
    "space.050": "var(--ds-space-050, 4px)",
    "space.075": "var(--ds-space-075, 6px)",
    "space.100": "var(--ds-space-100, 8px)",
    "space.150": "var(--ds-space-150, 12px)",
    "space.200": "var(--ds-space-200, 16px)",
    "space.250": "var(--ds-space-250, 20px)",
    "space.300": "var(--ds-space-300, 24px)",
    "space.400": "var(--ds-space-400, 32px)",
    "space.500": "var(--ds-space-500, 40px)",
    "space.600": "var(--ds-space-600, 48px)",
    "space.800": "var(--ds-space-800, 64px)",
    "space.1000": "var(--ds-space-1000, 80px)"
};
var $15cb85ce99dd9824$export$d2dc61f58390201c = {
    "space.negative.025": "var(--ds-space-negative-025, -2px)",
    "space.negative.050": "var(--ds-space-negative-050, -4px)",
    "space.negative.075": "var(--ds-space-negative-075, -6px)",
    "space.negative.100": "var(--ds-space-negative-100, -8px)",
    "space.negative.150": "var(--ds-space-negative-150, -12px)",
    "space.negative.200": "var(--ds-space-negative-200, -16px)",
    "space.negative.250": "var(--ds-space-negative-250, -20px)",
    "space.negative.300": "var(--ds-space-negative-300, -24px)",
    "space.negative.400": "var(--ds-space-negative-400, -32px)"
};
var $15cb85ce99dd9824$export$632685d741f3dbbf = $15cb85ce99dd9824$var$_objectSpread($15cb85ce99dd9824$var$_objectSpread({}, $15cb85ce99dd9824$export$958d0ae7f2977ae4), $15cb85ce99dd9824$export$d2dc61f58390201c);
var $15cb85ce99dd9824$export$2185ce37f9bdd963 = {
    "color.background.neutral.bold": "color.text.inverse",
    "color.background.neutral.bold.hovered": "color.text.inverse",
    "color.background.neutral.bold.pressed": "color.text.inverse",
    "color.background.selected.bold": "color.text.inverse",
    "color.background.selected.bold.hovered": "color.text.inverse",
    "color.background.selected.bold.pressed": "color.text.inverse",
    "color.background.brand.bold": "color.text.inverse",
    "color.background.brand.bold.hovered": "color.text.inverse",
    "color.background.brand.bold.pressed": "color.text.inverse",
    "color.background.brand.boldest": "color.text.inverse",
    "color.background.brand.boldest.hovered": "color.text.inverse",
    "color.background.brand.boldest.pressed": "color.text.inverse",
    "color.background.danger.bold": "color.text.inverse",
    "color.background.danger.bold.hovered": "color.text.inverse",
    "color.background.danger.bold.pressed": "color.text.inverse",
    "color.background.warning.bold": "color.text.warning.inverse",
    "color.background.warning.bold.hovered": "color.text.warning.inverse",
    "color.background.warning.bold.pressed": "color.text.warning.inverse",
    "color.background.success.bold": "color.text.inverse",
    "color.background.success.bold.hovered": "color.text.inverse",
    "color.background.success.bold.pressed": "color.text.inverse",
    "color.background.discovery.bold": "color.text.inverse",
    "color.background.discovery.bold.hovered": "color.text.inverse",
    "color.background.discovery.bold.pressed": "color.text.inverse",
    "color.background.information.bold": "color.text.inverse",
    "color.background.information.bold.hovered": "color.text.inverse",
    "color.background.information.bold.pressed": "color.text.inverse"
};
var $15cb85ce99dd9824$export$daf94a976c798b4f = {
    "opacity.disabled": "var(--ds-opacity-disabled, 0.4)",
    "opacity.loading": "var(--ds-opacity-loading, 0.2)"
};
var $15cb85ce99dd9824$export$7aff6e7ba39bb774 = {
    "elevation.shadow.overflow": "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.overflow.perimeter": "var(--ds-shadow-overflow-perimeter, #091e421f)",
    "elevation.shadow.overflow.spread": "var(--ds-shadow-overflow-spread, #091e4229)",
    "elevation.shadow.overlay": "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    "elevation.shadow.raised": "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $15cb85ce99dd9824$export$41a358c9c2356760 = {
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)"
};
var $15cb85ce99dd9824$export$1531ad5bb3fbedac = {
    "color.border": "var(--ds-border, #091e4221)",
    "color.border.accent.lime": "var(--ds-border-accent-lime, #6A9A23)",
    "color.border.accent.red": "var(--ds-border-accent-red, #FF5630)",
    "color.border.accent.orange": "var(--ds-border-accent-orange, #D94008)",
    "color.border.accent.yellow": "var(--ds-border-accent-yellow, #FFAB00)",
    "color.border.accent.green": "var(--ds-border-accent-green, #36B37E)",
    "color.border.accent.teal": "var(--ds-border-accent-teal, #00B8D9)",
    "color.border.accent.blue": "var(--ds-border-accent-blue, #0065FF)",
    "color.border.accent.purple": "var(--ds-border-accent-purple, #6554C0)",
    "color.border.accent.magenta": "var(--ds-border-accent-magenta, #CD519D)",
    "color.border.accent.gray": "var(--ds-border-accent-gray, #5E6C84)",
    "color.border.disabled": "var(--ds-border-disabled, #FAFBFC)",
    "color.border.focused": "var(--ds-border-focused, #2684FF)",
    "color.border.input": "var(--ds-border-input, #FAFBFC)",
    "color.border.inverse": "var(--ds-border-inverse, #FFFFFF)",
    "color.border.selected": "var(--ds-border-selected, #0052CC)",
    "color.border.brand": "var(--ds-border-brand, #0052CC)",
    "color.border.danger": "var(--ds-border-danger, #FF5630)",
    "color.border.warning": "var(--ds-border-warning, #FFC400)",
    "color.border.success": "var(--ds-border-success, #00875A)",
    "color.border.discovery": "var(--ds-border-discovery, #998DD9)",
    "color.border.information": "var(--ds-border-information, #0065FF)",
    "color.border.bold": "var(--ds-border-bold, #344563)"
};
var $15cb85ce99dd9824$export$d1d79bf68ac056bd = {
    "color.background.accent.lime.subtlest": "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    "color.background.accent.lime.subtlest.hovered": "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    "color.background.accent.lime.subtlest.pressed": "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    "color.background.accent.lime.subtler": "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    "color.background.accent.lime.subtler.hovered": "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    "color.background.accent.lime.subtler.pressed": "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    "color.background.accent.lime.subtle": "var(--ds-background-accent-lime-subtle, #94C748)",
    "color.background.accent.lime.subtle.hovered": "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    "color.background.accent.lime.subtle.pressed": "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    "color.background.accent.lime.bolder": "var(--ds-background-accent-lime-bolder, #5B7F24)",
    "color.background.accent.lime.bolder.hovered": "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    "color.background.accent.lime.bolder.pressed": "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    "color.background.accent.red.subtlest": "var(--ds-background-accent-red-subtlest, #FF8F73)",
    "color.background.accent.red.subtlest.hovered": "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    "color.background.accent.red.subtlest.pressed": "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    "color.background.accent.red.subtler": "var(--ds-background-accent-red-subtler, #FF7452)",
    "color.background.accent.red.subtler.hovered": "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    "color.background.accent.red.subtler.pressed": "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    "color.background.accent.red.subtle": "var(--ds-background-accent-red-subtle, #DE350B)",
    "color.background.accent.red.subtle.hovered": "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    "color.background.accent.red.subtle.pressed": "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    "color.background.accent.red.bolder": "var(--ds-background-accent-red-bolder, #DE350B)",
    "color.background.accent.red.bolder.hovered": "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    "color.background.accent.red.bolder.pressed": "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    "color.background.accent.orange.subtlest": "var(--ds-background-accent-orange-subtlest, #F18D13)",
    "color.background.accent.orange.subtlest.hovered": "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    "color.background.accent.orange.subtlest.pressed": "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    "color.background.accent.orange.subtler": "var(--ds-background-accent-orange-subtler, #B65C02)",
    "color.background.accent.orange.subtler.hovered": "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    "color.background.accent.orange.subtler.pressed": "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    "color.background.accent.orange.subtle": "var(--ds-background-accent-orange-subtle, #5F3811)",
    "color.background.accent.orange.subtle.hovered": "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    "color.background.accent.orange.subtle.pressed": "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    "color.background.accent.orange.bolder": "var(--ds-background-accent-orange-bolder, #43290F)",
    "color.background.accent.orange.bolder.hovered": "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    "color.background.accent.orange.bolder.pressed": "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    "color.background.accent.yellow.subtlest": "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    "color.background.accent.yellow.subtlest.hovered": "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    "color.background.accent.yellow.subtlest.pressed": "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    "color.background.accent.yellow.subtler": "var(--ds-background-accent-yellow-subtler, #FFC400)",
    "color.background.accent.yellow.subtler.hovered": "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    "color.background.accent.yellow.subtler.pressed": "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    "color.background.accent.yellow.subtle": "var(--ds-background-accent-yellow-subtle, #FF991F)",
    "color.background.accent.yellow.subtle.hovered": "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    "color.background.accent.yellow.subtle.pressed": "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    "color.background.accent.yellow.bolder": "var(--ds-background-accent-yellow-bolder, #FF991F)",
    "color.background.accent.yellow.bolder.hovered": "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    "color.background.accent.yellow.bolder.pressed": "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    "color.background.accent.green.subtlest": "var(--ds-background-accent-green-subtlest, #79F2C0)",
    "color.background.accent.green.subtlest.hovered": "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    "color.background.accent.green.subtlest.pressed": "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    "color.background.accent.green.subtler": "var(--ds-background-accent-green-subtler, #57D9A3)",
    "color.background.accent.green.subtler.hovered": "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    "color.background.accent.green.subtler.pressed": "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    "color.background.accent.green.subtle": "var(--ds-background-accent-green-subtle, #00875A)",
    "color.background.accent.green.subtle.hovered": "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    "color.background.accent.green.subtle.pressed": "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    "color.background.accent.green.bolder": "var(--ds-background-accent-green-bolder, #00875A)",
    "color.background.accent.green.bolder.hovered": "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    "color.background.accent.green.bolder.pressed": "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    "color.background.accent.teal.subtlest": "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    "color.background.accent.teal.subtlest.hovered": "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    "color.background.accent.teal.subtlest.pressed": "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    "color.background.accent.teal.subtler": "var(--ds-background-accent-teal-subtler, #00C7E6)",
    "color.background.accent.teal.subtler.hovered": "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    "color.background.accent.teal.subtler.pressed": "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    "color.background.accent.teal.subtle": "var(--ds-background-accent-teal-subtle, #00A3BF)",
    "color.background.accent.teal.subtle.hovered": "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    "color.background.accent.teal.subtle.pressed": "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    "color.background.accent.teal.bolder": "var(--ds-background-accent-teal-bolder, #00A3BF)",
    "color.background.accent.teal.bolder.hovered": "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    "color.background.accent.teal.bolder.pressed": "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    "color.background.accent.blue.subtlest": "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    "color.background.accent.blue.subtlest.hovered": "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    "color.background.accent.blue.subtlest.pressed": "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    "color.background.accent.blue.subtler": "var(--ds-background-accent-blue-subtler, #2684FF)",
    "color.background.accent.blue.subtler.hovered": "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    "color.background.accent.blue.subtler.pressed": "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    "color.background.accent.blue.subtle": "var(--ds-background-accent-blue-subtle, #0052CC)",
    "color.background.accent.blue.subtle.hovered": "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    "color.background.accent.blue.subtle.pressed": "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    "color.background.accent.blue.bolder": "var(--ds-background-accent-blue-bolder, #0052CC)",
    "color.background.accent.blue.bolder.hovered": "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    "color.background.accent.blue.bolder.pressed": "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    "color.background.accent.purple.subtlest": "var(--ds-background-accent-purple-subtlest, #998DD9)",
    "color.background.accent.purple.subtlest.hovered": "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    "color.background.accent.purple.subtlest.pressed": "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    "color.background.accent.purple.subtler": "var(--ds-background-accent-purple-subtler, #8777D9)",
    "color.background.accent.purple.subtler.hovered": "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    "color.background.accent.purple.subtler.pressed": "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    "color.background.accent.purple.subtle": "var(--ds-background-accent-purple-subtle, #5243AA)",
    "color.background.accent.purple.subtle.hovered": "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    "color.background.accent.purple.subtle.pressed": "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    "color.background.accent.purple.bolder": "var(--ds-background-accent-purple-bolder, #5243AA)",
    "color.background.accent.purple.bolder.hovered": "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    "color.background.accent.purple.bolder.pressed": "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    "color.background.accent.magenta.subtlest": "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    "color.background.accent.magenta.subtlest.hovered": "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    "color.background.accent.magenta.subtlest.pressed": "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    "color.background.accent.magenta.subtler": "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    "color.background.accent.magenta.subtler.hovered": "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    "color.background.accent.magenta.subtler.pressed": "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    "color.background.accent.magenta.subtle": "var(--ds-background-accent-magenta-subtle, #E774BB)",
    "color.background.accent.magenta.subtle.hovered": "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    "color.background.accent.magenta.subtle.pressed": "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    "color.background.accent.magenta.bolder": "var(--ds-background-accent-magenta-bolder, #AE4787)",
    "color.background.accent.magenta.bolder.hovered": "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "color.background.accent.magenta.bolder.pressed": "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    "color.background.accent.gray.subtlest": "var(--ds-background-accent-gray-subtlest, #6B778C)",
    "color.background.accent.gray.subtlest.hovered": "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    "color.background.accent.gray.subtlest.pressed": "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    "color.background.accent.gray.subtler": "var(--ds-background-accent-gray-subtler, #5E6C84)",
    "color.background.accent.gray.subtler.hovered": "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    "color.background.accent.gray.subtler.pressed": "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    "color.background.accent.gray.subtle": "var(--ds-background-accent-gray-subtle, #505F79)",
    "color.background.accent.gray.subtle.hovered": "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    "color.background.accent.gray.subtle.pressed": "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    "color.background.accent.gray.bolder": "var(--ds-background-accent-gray-bolder, #42526E)",
    "color.background.accent.gray.bolder.hovered": "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    "color.background.accent.gray.bolder.pressed": "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    "color.background.disabled": "var(--ds-background-disabled, #091e4289)",
    "color.background.input": "var(--ds-background-input, #FAFBFC)",
    "color.background.input.hovered": "var(--ds-background-input-hovered, #EBECF0)",
    "color.background.input.pressed": "var(--ds-background-input-pressed, #FFFFFF)",
    "color.background.inverse.subtle": "var(--ds-background-inverse-subtle, #00000029)",
    "color.background.inverse.subtle.hovered": "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    "color.background.inverse.subtle.pressed": "var(--ds-background-inverse-subtle-pressed, #00000052)",
    "color.background.neutral": "var(--ds-background-neutral, #DFE1E6)",
    "color.background.neutral.hovered": "var(--ds-background-neutral-hovered, #091e4214)",
    "color.background.neutral.pressed": "var(--ds-background-neutral-pressed, #B3D4FF)",
    "color.background.neutral.subtle": "var(--ds-background-neutral-subtle, transparent)",
    "color.background.neutral.subtle.hovered": "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    "color.background.neutral.subtle.pressed": "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    "color.background.neutral.bold": "var(--ds-background-neutral-bold, #42526E)",
    "color.background.neutral.bold.hovered": "var(--ds-background-neutral-bold-hovered, #505F79)",
    "color.background.neutral.bold.pressed": "var(--ds-background-neutral-bold-pressed, #344563)",
    "color.background.selected": "var(--ds-background-selected, #DEEBFF)",
    "color.background.selected.hovered": "var(--ds-background-selected-hovered, #B3D4FF)",
    "color.background.selected.pressed": "var(--ds-background-selected-pressed, #4C9AFF)",
    "color.background.selected.bold": "var(--ds-background-selected-bold, #0052CC)",
    "color.background.selected.bold.hovered": "var(--ds-background-selected-bold-hovered, #2684FF)",
    "color.background.selected.bold.pressed": "var(--ds-background-selected-bold-pressed, #0052CC)",
    "color.background.brand.subtlest": "var(--ds-background-brand-subtlest, #B3D4FF)",
    "color.background.brand.subtlest.hovered": "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    "color.background.brand.subtlest.pressed": "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    "color.background.brand.bold": "var(--ds-background-brand-bold, #0052CC)",
    "color.background.brand.bold.hovered": "var(--ds-background-brand-bold-hovered, #0065FF)",
    "color.background.brand.bold.pressed": "var(--ds-background-brand-bold-pressed, #0747A6)",
    "color.background.brand.boldest": "var(--ds-background-brand-boldest, #0747A6)",
    "color.background.brand.boldest.hovered": "var(--ds-background-brand-boldest-hovered, #0052CC)",
    "color.background.brand.boldest.pressed": "var(--ds-background-brand-boldest-pressed, #0747A6)",
    "color.background.danger": "var(--ds-background-danger, #FFEBE6)",
    "color.background.danger.hovered": "var(--ds-background-danger-hovered, #FFBDAD)",
    "color.background.danger.pressed": "var(--ds-background-danger-pressed, #FF8F73)",
    "color.background.danger.bold": "var(--ds-background-danger-bold, #DE350B)",
    "color.background.danger.bold.hovered": "var(--ds-background-danger-bold-hovered, #FF5630)",
    "color.background.danger.bold.pressed": "var(--ds-background-danger-bold-pressed, #BF2600)",
    "color.background.warning": "var(--ds-background-warning, #FFFAE6)",
    "color.background.warning.hovered": "var(--ds-background-warning-hovered, #FFF0B3)",
    "color.background.warning.pressed": "var(--ds-background-warning-pressed, #FFE380)",
    "color.background.warning.bold": "var(--ds-background-warning-bold, #FFAB00)",
    "color.background.warning.bold.hovered": "var(--ds-background-warning-bold-hovered, #FFC400)",
    "color.background.warning.bold.pressed": "var(--ds-background-warning-bold-pressed, #FF991F)",
    "color.background.success": "var(--ds-background-success, #E3FCEF)",
    "color.background.success.hovered": "var(--ds-background-success-hovered, #ABF5D1)",
    "color.background.success.pressed": "var(--ds-background-success-pressed, #79F2C0)",
    "color.background.success.bold": "var(--ds-background-success-bold, #00875A)",
    "color.background.success.bold.hovered": "var(--ds-background-success-bold-hovered, #57D9A3)",
    "color.background.success.bold.pressed": "var(--ds-background-success-bold-pressed, #00875A)",
    "color.background.discovery": "var(--ds-background-discovery, #EAE6FF)",
    "color.background.discovery.hovered": "var(--ds-background-discovery-hovered, #C0B6F2)",
    "color.background.discovery.pressed": "var(--ds-background-discovery-pressed, #998DD9)",
    "color.background.discovery.bold": "var(--ds-background-discovery-bold, #5243AA)",
    "color.background.discovery.bold.hovered": "var(--ds-background-discovery-bold-hovered, #8777D9)",
    "color.background.discovery.bold.pressed": "var(--ds-background-discovery-bold-pressed, #5243AA)",
    "color.background.information": "var(--ds-background-information, #DEEBFF)",
    "color.background.information.hovered": "var(--ds-background-information-hovered, #B3D4FF)",
    "color.background.information.pressed": "var(--ds-background-information-pressed, #4C9AFF)",
    "color.background.information.bold": "var(--ds-background-information-bold, #0052CC)",
    "color.background.information.bold.hovered": "var(--ds-background-information-bold-hovered, #2684FF)",
    "color.background.information.bold.pressed": "var(--ds-background-information-bold-pressed, #0052CC)",
    "color.blanket": "var(--ds-blanket, #091e4289)",
    "color.blanket.selected": "var(--ds-blanket-selected, #388BFF14)",
    "color.blanket.danger": "var(--ds-blanket-danger, #EF5C4814)",
    "color.skeleton": "var(--ds-skeleton, #F4F5F7)",
    "color.skeleton.subtle": "var(--ds-skeleton-subtle, #091e420a)",
    "elevation.surface": "var(--ds-surface, #FFFFFF)",
    "elevation.surface.hovered": "var(--ds-surface-hovered, #FAFBFC)",
    "elevation.surface.pressed": "var(--ds-surface-pressed, #F4F5F7)",
    "elevation.surface.overlay": "var(--ds-surface-overlay, #FFFFFF)",
    "elevation.surface.overlay.hovered": "var(--ds-surface-overlay-hovered, #FAFBFC)",
    "elevation.surface.overlay.pressed": "var(--ds-surface-overlay-pressed, #F4F5F7)",
    "elevation.surface.raised": "var(--ds-surface-raised, #FFFFFF)",
    "elevation.surface.raised.hovered": "var(--ds-surface-raised-hovered, #FAFBFC)",
    "elevation.surface.raised.pressed": "var(--ds-surface-raised-pressed, #F4F5F7)",
    "elevation.surface.sunken": "var(--ds-surface-sunken, #F4F5F7)",
    "utility.elevation.surface.current": "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $15cb85ce99dd9824$export$8473307aa00d6ea1 = {
    "color.text": "var(--ds-text, #172B4D)",
    "color.text.accent.lime": "var(--ds-text-accent-lime, #4C6B1F)",
    "color.text.accent.lime.bolder": "var(--ds-text-accent-lime-bolder, #37471F)",
    "color.text.accent.red": "var(--ds-text-accent-red, #DE350B)",
    "color.text.accent.red.bolder": "var(--ds-text-accent-red-bolder, #BF2600)",
    "color.text.accent.orange": "var(--ds-text-accent-orange, #F18D13)",
    "color.text.accent.orange.bolder": "var(--ds-text-accent-orange-bolder, #B65C02)",
    "color.text.accent.yellow": "var(--ds-text-accent-yellow, #FF991F)",
    "color.text.accent.yellow.bolder": "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    "color.text.accent.green": "var(--ds-text-accent-green, #00875A)",
    "color.text.accent.green.bolder": "var(--ds-text-accent-green-bolder, #006644)",
    "color.text.accent.teal": "var(--ds-text-accent-teal, #00A3BF)",
    "color.text.accent.teal.bolder": "var(--ds-text-accent-teal-bolder, #008DA6)",
    "color.text.accent.blue": "var(--ds-text-accent-blue, #0052CC)",
    "color.text.accent.blue.bolder": "var(--ds-text-accent-blue-bolder, #0747A6)",
    "color.text.accent.purple": "var(--ds-text-accent-purple, #5243AA)",
    "color.text.accent.purple.bolder": "var(--ds-text-accent-purple-bolder, #403294)",
    "color.text.accent.magenta": "var(--ds-text-accent-magenta, #E774BB)",
    "color.text.accent.magenta.bolder": "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    "color.text.accent.gray": "var(--ds-text-accent-gray, #505F79)",
    "color.text.accent.gray.bolder": "var(--ds-text-accent-gray-bolder, #172B4D)",
    "color.text.disabled": "var(--ds-text-disabled, #A5ADBA)",
    "color.text.inverse": "var(--ds-text-inverse, #FFFFFF)",
    "color.text.selected": "var(--ds-text-selected, #0052CC)",
    "color.text.brand": "var(--ds-text-brand, #0065FF)",
    "color.text.danger": "var(--ds-text-danger, #DE350B)",
    "color.text.warning": "var(--ds-text-warning, #974F0C)",
    "color.text.warning.inverse": "var(--ds-text-warning-inverse, #172B4D)",
    "color.text.success": "var(--ds-text-success, #006644)",
    "color.text.discovery": "var(--ds-text-discovery, #403294)",
    "color.text.information": "var(--ds-text-information, #0052CC)",
    "color.text.subtlest": "var(--ds-text-subtlest, #7A869A)",
    "color.text.subtle": "var(--ds-text-subtle, #42526E)",
    "color.link": "var(--ds-link, #0052CC)",
    "color.link.pressed": "var(--ds-link-pressed, #0747A6)",
    "color.link.visited": "var(--ds-link-visited, #403294)",
    "color.link.visited.pressed": "var(--ds-link-visited-pressed, #403294)"
};
var $15cb85ce99dd9824$export$498780f74be9af68 = {
    "color.icon": "var(--ds-icon, #505F79)",
    "color.icon.accent.lime": "var(--ds-icon-accent-lime, #6A9A23)",
    "color.icon.accent.red": "var(--ds-icon-accent-red, #FF5630)",
    "color.icon.accent.orange": "var(--ds-icon-accent-orange, #D94008)",
    "color.icon.accent.yellow": "var(--ds-icon-accent-yellow, #FFAB00)",
    "color.icon.accent.green": "var(--ds-icon-accent-green, #36B37E)",
    "color.icon.accent.teal": "var(--ds-icon-accent-teal, #00B8D9)",
    "color.icon.accent.blue": "var(--ds-icon-accent-blue, #0065FF)",
    "color.icon.accent.purple": "var(--ds-icon-accent-purple, #6554C0)",
    "color.icon.accent.magenta": "var(--ds-icon-accent-magenta, #CD519D)",
    "color.icon.accent.gray": "var(--ds-icon-accent-gray, #5E6C84)",
    "color.icon.disabled": "var(--ds-icon-disabled, #8993A4)",
    "color.icon.inverse": "var(--ds-icon-inverse, #FFFFFF)",
    "color.icon.selected": "var(--ds-icon-selected, #0052CC)",
    "color.icon.brand": "var(--ds-icon-brand, #0065FF)",
    "color.icon.danger": "var(--ds-icon-danger, #DE350B)",
    "color.icon.warning": "var(--ds-icon-warning, #FFC400)",
    "color.icon.warning.inverse": "var(--ds-icon-warning-inverse, #253858)",
    "color.icon.success": "var(--ds-icon-success, #00875A)",
    "color.icon.discovery": "var(--ds-icon-discovery, #8777D9)",
    "color.icon.information": "var(--ds-icon-information, #0747A6)",
    "color.icon.subtle": "var(--ds-icon-subtle, #6B778C)"
};
var $15cb85ce99dd9824$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $15cb85ce99dd9824$export$e1b83c5210c471b8 = {
    "border.width": "var(--ds-border-width, 1px)",
    "border.width.0": "var(--ds-border-width-0, 0px)",
    "border.width.indicator": "var(--ds-border-width-indicator, 3px)",
    "border.width.outline": "var(--ds-border-width-outline, 2px)"
};
var $15cb85ce99dd9824$export$3c0a6c3e64bb180d = {
    "border.radius.050": "var(--ds-border-radius-050, 2px)",
    "border.radius": "var(--ds-border-radius, 3px)",
    "border.radius.100": "var(--ds-border-radius-100, 3px)",
    "border.radius.200": "var(--ds-border-radius-200, 8px)",
    "border.radius.300": "var(--ds-border-radius-300, 12px)",
    "border.radius.400": "var(--ds-border-radius-400, 16px)",
    "border.radius.circle": "var(--ds-border-radius-circle, 32032px)"
};
var $15cb85ce99dd9824$export$6cc560b4dedf3816 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
var $15cb85ce99dd9824$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $15cb85ce99dd9824$export$3c7e9587132614b4 = {
    "font.family.body": 'var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.body": 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.brand.heading": 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)',
    "font.family.code": 'var(--ds-font-family-code, ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    "font.family.heading": 'var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
var $15cb85ce99dd9824$var$spacingProperties = [
    // Used by Box
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    // Used by Inline and Stack
    "gap",
    "rowGap",
    "columnGap"
];
var $15cb85ce99dd9824$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $14VNY.css)((0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $15cb85ce99dd9824$export$e615f061ca585a6c = $15cb85ce99dd9824$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $15cb85ce99dd9824$var$getSerializedStylesMap(spacingProperty, $15cb85ce99dd9824$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $15cb85ce99dd9824$export$bf46c3f9eeafc71f = $15cb85ce99dd9824$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $15cb85ce99dd9824$var$getSerializedStylesMap(spacingProperty, $15cb85ce99dd9824$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $15cb85ce99dd9824$export$e7af83bafe7f9e63 = $15cb85ce99dd9824$var$getSerializedStylesMap("backgroundColor", $15cb85ce99dd9824$export$d1d79bf68ac056bd);
var $15cb85ce99dd9824$export$3a1bcba60b23d7f0 = $15cb85ce99dd9824$var$getSerializedStylesMap("color", $15cb85ce99dd9824$export$8473307aa00d6ea1);
var $15cb85ce99dd9824$export$45f3f4fe16f9f7d5 = $15cb85ce99dd9824$var$getSerializedStylesMap("fontWeight", $15cb85ce99dd9824$export$303e322c6b1ed114);
var $15cb85ce99dd9824$export$68cc305da27dbaa4 = $15cb85ce99dd9824$var$getSerializedStylesMap("fontFamily", $15cb85ce99dd9824$export$3c7e9587132614b4);
var $15cb85ce99dd9824$export$128f10c238242f83 = $15cb85ce99dd9824$var$getSerializedStylesMap("font", $15cb85ce99dd9824$export$6cc560b4dedf3816);
var $15cb85ce99dd9824$export$ff257d957d48c421 = $15cb85ce99dd9824$var$getSerializedStylesMap((0, $bDRHl.CURRENT_SURFACE_CSS_VAR), $15cb85ce99dd9824$export$41a358c9c2356760);
var $15cb85ce99dd9824$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $15cb85ce99dd9824$export$41a358c9c2356760[color] !== undefined;
};

});

parcelRegister("57fzU", function(module, exports) {

$parcel$export(module.exports, "parseXcss", function () { return $3b99b0b8f0b63277$export$a9c84988c8f81f2d; });
$parcel$export(module.exports, "xcss", function () { return $3b99b0b8f0b63277$export$f6c783d06584602c; });

var $cF8Kw = parcelRequire("cF8Kw");

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $cd8Dz = parcelRequire("cd8Dz");

var $14VNY = parcelRequire("14VNY");

var $1S0T5 = parcelRequire("1S0T5");

var $1RdT6 = parcelRequire("1RdT6");
function $3b99b0b8f0b63277$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $3b99b0b8f0b63277$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $3b99b0b8f0b63277$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $3b99b0b8f0b63277$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $3b99b0b8f0b63277$var$_arrayLikeToArray(o, minLen);
}
function $3b99b0b8f0b63277$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $3b99b0b8f0b63277$export$9a199fbafee0014e = {
    backgroundColor: (0, $1S0T5.backgroundColorMap),
    blockSize: (0, $1S0T5.dimensionMap),
    borderBlockColor: (0, $1S0T5.borderColorMap),
    borderBlockEndColor: (0, $1S0T5.borderColorMap),
    borderBlockEndWidth: (0, $1S0T5.borderWidthMap),
    borderBlockStartColor: (0, $1S0T5.borderColorMap),
    borderBlockStartWidth: (0, $1S0T5.borderWidthMap),
    borderBlockWidth: (0, $1S0T5.borderWidthMap),
    borderBottomColor: (0, $1S0T5.borderColorMap),
    borderBottomLeftRadius: (0, $1S0T5.borderRadiusMap),
    borderBottomRightRadius: (0, $1S0T5.borderRadiusMap),
    borderBottomWidth: (0, $1S0T5.borderWidthMap),
    borderColor: (0, $1S0T5.borderColorMap),
    borderEndEndRadius: (0, $1S0T5.borderRadiusMap),
    borderEndStartRadius: (0, $1S0T5.borderRadiusMap),
    borderInlineColor: (0, $1S0T5.borderColorMap),
    borderInlineEndColor: (0, $1S0T5.borderColorMap),
    borderInlineEndWidth: (0, $1S0T5.borderWidthMap),
    borderInlineStartColor: (0, $1S0T5.borderColorMap),
    borderInlineStartWidth: (0, $1S0T5.borderWidthMap),
    borderInlineWidth: (0, $1S0T5.borderWidthMap),
    borderLeftColor: (0, $1S0T5.borderColorMap),
    borderLeftWidth: (0, $1S0T5.borderWidthMap),
    borderRadius: (0, $1S0T5.borderRadiusMap),
    borderRightColor: (0, $1S0T5.borderColorMap),
    borderRightWidth: (0, $1S0T5.borderWidthMap),
    borderStartEndRadius: (0, $1S0T5.borderRadiusMap),
    borderStartStartRadius: (0, $1S0T5.borderRadiusMap),
    borderTopColor: (0, $1S0T5.borderColorMap),
    borderTopLeftRadius: (0, $1S0T5.borderRadiusMap),
    borderTopRightRadius: (0, $1S0T5.borderRadiusMap),
    borderTopWidth: (0, $1S0T5.borderWidthMap),
    borderWidth: (0, $1S0T5.borderWidthMap),
    bottom: (0, $1S0T5.allSpaceMap),
    boxShadow: (0, $1S0T5.shadowMap),
    color: (0, $1S0T5.textColorMap),
    columnGap: (0, $1S0T5.positiveSpaceMap),
    gap: (0, $1S0T5.positiveSpaceMap),
    height: (0, $1S0T5.dimensionMap),
    inlineSize: (0, $1S0T5.dimensionMap),
    inset: (0, $1S0T5.allSpaceMap),
    insetBlock: (0, $1S0T5.allSpaceMap),
    insetBlockEnd: (0, $1S0T5.allSpaceMap),
    insetBlockStart: (0, $1S0T5.allSpaceMap),
    insetInline: (0, $1S0T5.allSpaceMap),
    insetInlineEnd: (0, $1S0T5.allSpaceMap),
    insetInlineStart: (0, $1S0T5.allSpaceMap),
    left: (0, $1S0T5.allSpaceMap),
    margin: (0, $1S0T5.allSpaceMap),
    marginBlock: (0, $1S0T5.allSpaceMap),
    marginBlockEnd: (0, $1S0T5.allSpaceMap),
    marginBlockStart: (0, $1S0T5.allSpaceMap),
    marginBottom: (0, $1S0T5.allSpaceMap),
    marginInline: (0, $1S0T5.allSpaceMap),
    marginInlineEnd: (0, $1S0T5.allSpaceMap),
    marginInlineStart: (0, $1S0T5.allSpaceMap),
    marginLeft: (0, $1S0T5.allSpaceMap),
    marginRight: (0, $1S0T5.allSpaceMap),
    marginTop: (0, $1S0T5.allSpaceMap),
    maxBlockSize: (0, $1S0T5.dimensionMap),
    maxHeight: (0, $1S0T5.dimensionMap),
    maxInlineSize: (0, $1S0T5.dimensionMap),
    maxWidth: (0, $1S0T5.dimensionMap),
    minBlockSize: (0, $1S0T5.dimensionMap),
    minHeight: (0, $1S0T5.dimensionMap),
    minInlineSize: (0, $1S0T5.dimensionMap),
    minWidth: (0, $1S0T5.dimensionMap),
    opacity: (0, $1S0T5.opacityMap),
    outlineColor: (0, $1S0T5.borderColorMap),
    outlineOffset: (0, $1S0T5.positiveSpaceMap),
    outlineWidth: (0, $1S0T5.borderWidthMap),
    padding: (0, $1S0T5.positiveSpaceMap),
    paddingBlock: (0, $1S0T5.positiveSpaceMap),
    paddingBlockEnd: (0, $1S0T5.positiveSpaceMap),
    paddingBlockStart: (0, $1S0T5.positiveSpaceMap),
    paddingBottom: (0, $1S0T5.positiveSpaceMap),
    paddingInline: (0, $1S0T5.positiveSpaceMap),
    paddingInlineEnd: (0, $1S0T5.positiveSpaceMap),
    paddingInlineStart: (0, $1S0T5.positiveSpaceMap),
    paddingLeft: (0, $1S0T5.positiveSpaceMap),
    paddingRight: (0, $1S0T5.positiveSpaceMap),
    paddingTop: (0, $1S0T5.positiveSpaceMap),
    right: (0, $1S0T5.allSpaceMap),
    rowGap: (0, $1S0T5.positiveSpaceMap),
    top: (0, $1S0T5.allSpaceMap),
    width: (0, $1S0T5.dimensionMap),
    zIndex: (0, $1S0T5.layerMap)
};
var $3b99b0b8f0b63277$var$uniqueSymbol = Symbol("UNSAFE_INTERNAL_styles");
var $3b99b0b8f0b63277$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $1RdT6 === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))($1RdT6)) === "object" && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))($1RdT6.env) === "object" && false;
};
var $3b99b0b8f0b63277$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $3b99b0b8f0b63277$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $3b99b0b8f0b63277$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(styleObj) !== "object") return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value) === "object" && $3b99b0b8f0b63277$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($3b99b0b8f0b63277$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($3b99b0b8f0b63277$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $3b99b0b8f0b63277$export$9a199fbafee0014e)) return;
        var tokenValue = $3b99b0b8f0b63277$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $3b99b0b8f0b63277$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $3b99b0b8f0b63277$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $3b99b0b8f0b63277$var$uniqueSymbol, (0, $14VNY.css)(transformedStyles));
};
var $3b99b0b8f0b63277$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $3b99b0b8f0b63277$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(" ")
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$3b99b0b8f0b63277$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $3b99b0b8f0b63277$export$f6c783d06584602c(style) {
    return $3b99b0b8f0b63277$var$baseXcss(style);
}

});

parcelRegister("9YQBI", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", function () { return $74428662e176e807$export$1ca2a26fecb070ae; });
$parcel$export(module.exports, "useSurface", function () { return $74428662e176e807$export$1aeb4f6b93c4540d; });

var $8ZuGG = parcelRequire("8ZuGG");
var $74428662e176e807$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $8ZuGG.createContext)("elevation.surface");
var $74428662e176e807$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $8ZuGG.useContext)($74428662e176e807$export$1ca2a26fecb070ae);
};
$74428662e176e807$export$1ca2a26fecb070ae.displayName = "SurfaceProvider";

});


parcelRegister("7SrF8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5bc308bcf175da79$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $57fzU = parcelRequire("57fzU");

var $ld7ev = parcelRequire("ld7ev");
var $5bc308bcf175da79$var$flexGrowMap = {
    hug: (0, $57fzU.xcss)({
        flexGrow: 0
    }),
    fill: (0, $57fzU.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
var $5bc308bcf175da79$var$separatorStyles = (0, $14VNY.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: "none",
    userSelect: "none"
});
var $5bc308bcf175da79$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $14VNY.jsx)("span", {
        css: $5bc308bcf175da79$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $5bc308bcf175da79$var$Inline = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? "start" : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === "string" ? (0, $14VNY.jsx)($5bc308bcf175da79$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $8ZuGG.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $14VNY.jsx)((0, $8ZuGG.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $5bc308bcf175da79$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $14VNY.jsx)((0, $ld7ev.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? "wrap" : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$5bc308bcf175da79$var$Inline.displayName = "Inline";
var $5bc308bcf175da79$export$2e2bcd8739ae039 = $5bc308bcf175da79$var$Inline;

});
parcelRegister("ld7ev", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7106c2ddd2d47fb$export$2e2bcd8739ae039; });
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $1S0T5 = parcelRequire("1S0T5");

var $57fzU = parcelRequire("57fzU");
var $f7106c2ddd2d47fb$var$justifyContentMap = {
    start: (0, $14VNY.css)({
        justifyContent: "start"
    }),
    center: (0, $14VNY.css)({
        justifyContent: "center"
    }),
    end: (0, $14VNY.css)({
        justifyContent: "end"
    }),
    "space-between": (0, $14VNY.css)({
        justifyContent: "space-between"
    }),
    "space-around": (0, $14VNY.css)({
        justifyContent: "space-around"
    }),
    "space-evenly": (0, $14VNY.css)({
        justifyContent: "space-evenly"
    }),
    stretch: (0, $14VNY.css)({
        justifyContent: "stretch"
    })
};
var $f7106c2ddd2d47fb$var$flexDirectionMap = {
    column: (0, $14VNY.css)({
        flexDirection: "column"
    }),
    row: (0, $14VNY.css)({
        flexDirection: "row"
    })
};
var $f7106c2ddd2d47fb$var$flexWrapMap = {
    wrap: (0, $14VNY.css)({
        flexWrap: "wrap"
    }),
    nowrap: (0, $14VNY.css)({
        flexWrap: "nowrap"
    })
};
var $f7106c2ddd2d47fb$var$alignItemsMap = {
    start: (0, $14VNY.css)({
        alignItems: "start"
    }),
    center: (0, $14VNY.css)({
        alignItems: "center"
    }),
    baseline: (0, $14VNY.css)({
        alignItems: "baseline"
    }),
    end: (0, $14VNY.css)({
        alignItems: "end"
    }),
    stretch: (0, $14VNY.css)({
        alignItems: "stretch"
    })
};
var $f7106c2ddd2d47fb$var$baseStyles = (0, $14VNY.css)({
    display: "flex",
    boxSizing: "border-box"
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $f7106c2ddd2d47fb$var$Flex = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? "div" : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $57fzU.parseXcss)(xcss);
    return (0, $14VNY.jsx)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $f7106c2ddd2d47fb$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $1S0T5.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $1S0T5.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $1S0T5.spaceStylesMap).rowGap[rowGap],
            alignItems && $f7106c2ddd2d47fb$var$alignItemsMap[alignItems],
            direction && $f7106c2ddd2d47fb$var$flexDirectionMap[direction],
            justifyContent && $f7106c2ddd2d47fb$var$justifyContentMap[justifyContent],
            wrap && $f7106c2ddd2d47fb$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$f7106c2ddd2d47fb$var$Flex.displayName = "Flex";
var $f7106c2ddd2d47fb$export$2e2bcd8739ae039 = $f7106c2ddd2d47fb$var$Flex;

});


parcelRegister("6m9zh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a0c382884211ef8$export$2e2bcd8739ae039; });

var $cF8Kw = parcelRequire("cF8Kw");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $57fzU = parcelRequire("57fzU");

var $ld7ev = parcelRequire("ld7ev");
var $4a0c382884211ef8$var$flexGrowMap = {
    hug: (0, $57fzU.xcss)({
        flexGrow: 0
    }),
    fill: (0, $57fzU.xcss)({
        width: "100%",
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ var $4a0c382884211ef8$var$Stack = /*#__PURE__*/ (0, $8ZuGG.memo)(/*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var as = _ref.as, alignItems = _ref.alignInline, _ref$alignBlock = _ref.alignBlock, alignBlock = _ref$alignBlock === void 0 ? "stretch" : _ref$alignBlock, spread = _ref.spread, grow = _ref.grow, space = _ref.space, children = _ref.children, testId = _ref.testId, xcss = _ref.xcss, role = _ref.role;
    var justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $4a0c382884211ef8$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($cF8Kw)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $14VNY.jsx)((0, $ld7ev.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$4a0c382884211ef8$var$Stack.displayName = "Stack";
var $4a0c382884211ef8$export$2e2bcd8739ae039 = $4a0c382884211ef8$var$Stack;

});

parcelRegister("4xaIc", function(module, exports) {

$parcel$export(module.exports, "easeInOut", function () { return $34d28dacc3f8375b$export$c07234257a03d5e9; });
$parcel$export(module.exports, "easeOut", function () { return $34d28dacc3f8375b$export$57636bb43b1ccbb0; });
$parcel$export(module.exports, "easeIn", function () { return $34d28dacc3f8375b$export$929e5a82286172a6; });
var $34d28dacc3f8375b$export$c07234257a03d5e9 = "cubic-bezier(0.15,1,0.3,1)";
var $34d28dacc3f8375b$export$57636bb43b1ccbb0 = "cubic-bezier(0.2,0,0,1)";
var $34d28dacc3f8375b$export$929e5a82286172a6 = "cubic-bezier(0.8,0,0,0.8)";

});

parcelRegister("9cyTu", function(module, exports) {

$parcel$export(module.exports, "wrapChildWithContextProvider", function () { return $6b304d4909b95572$export$e4c4c45693c3a7c; });
$parcel$export(module.exports, "childrenToArray", function () { return $6b304d4909b95572$export$7032ae6d9d98bedd; });
$parcel$export(module.exports, "spliceNewElementsIntoPrevious", function () { return $6b304d4909b95572$export$2ccbe4ff092af328; });
$parcel$export(module.exports, "childrenToObj", function () { return $6b304d4909b95572$export$1d8c49f95a162a41; });
$parcel$export(module.exports, "useExitingPersistence", function () { return $6b304d4909b95572$export$3b6f38abbdcbd000; });
$parcel$export(module.exports, "default", function () { return $6b304d4909b95572$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $i2LcI = parcelRequire("i2LcI");

var $luGMe = parcelRequire("luGMe");

var $fSrDY = parcelRequire("fSrDY");
var $6b304d4909b95572$export$d1e013d71d2e2121 = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $6b304d4909b95572$export$b9c4904d7a6929e6 = /*#__PURE__*/ (0, $8ZuGG.createContext)($6b304d4909b95572$export$d1e013d71d2e2121);
var $6b304d4909b95572$export$e4c4c45693c3a7c = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $6b304d4909b95572$export$d1e013d71d2e2121;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6b304d4909b95572$export$b9c4904d7a6929e6.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $6b304d4909b95572$export$7032ae6d9d98bedd = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $8ZuGG.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== "boolean" && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
var $6b304d4909b95572$export$2ccbe4ff092af328 = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $6b304d4909b95572$export$1d8c49f95a162a41(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
var $6b304d4909b95572$export$1d8c49f95a162a41 = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $6b304d4909b95572$var$ExitingPersistence = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    return (0, $i2LcI.getBooleanFF)("platform.design-system-team.update-motion-for-strict-mode_p6qs0") ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $luGMe.default), {
        appear: appear,
        children: children,
        exitThenEnter: exitThenEnter
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $fSrDY.default), {
        appear: appear,
        children: children,
        exitThenEnter: exitThenEnter
    });
});
var $6b304d4909b95572$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $8ZuGG.useContext)($6b304d4909b95572$export$b9c4904d7a6929e6);
};
$6b304d4909b95572$var$ExitingPersistence.displayName = "ExitingPersistence";
var $6b304d4909b95572$export$2e2bcd8739ae039 = $6b304d4909b95572$var$ExitingPersistence;

});
parcelRegister("luGMe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fa5d94f116cb8e5c$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $cbGWw = parcelRequire("cbGWw");

var $9cyTu = parcelRequire("9cyTu");
var $fa5d94f116cb8e5c$var$getMissingKeys = function getMissingKeys(current, previous) {
    var currentMapKeys = new Set(current.map(function(child) {
        return child.key;
    }));
    var missing = new Set();
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var key = element.key;
        if (!currentMapKeys.has(key)) missing.add(key);
    }
    return missing;
};
/**
 * __WithStrictModeSupport__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $fa5d94f116cb8e5c$var$WithStrictModeSupport = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appear = _ref$appear === void 0 ? false : _ref$appear, children = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var _useState = (0, $8ZuGG.useState)([
        null,
        children
    ]), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), stateChildren = _useState2[0], setChildren = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)([]), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), exitingChildren = _useState4[0], setExitingChildren = _useState4[1];
    var _useState5 = (0, $8ZuGG.useState)(function() {
        return {
            appear: appear,
            isExiting: false
        };
    }), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState5, 2), defaultContext = _useState6[0], setDefaultContext = _useState6[1];
    (0, $8ZuGG.useEffect)(function() {
        if (!defaultContext.appear) setDefaultContext({
            appear: true,
            isExiting: false
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ((0, $cbGWw.isReducedMotion)()) return children;
    /**
   * NOTE: This is a workaround for the test case written in Jira where the stateChildren is a boolean value because
   * useState is mocked to return a boolean value.
   */ if (typeof stateChildren === "boolean") return children;
    var _stateChildren = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(stateChildren, 2), previousChildren = _stateChildren[0], currentChildren = _stateChildren[1];
    var previous = (0, $9cyTu.childrenToArray)(previousChildren);
    var current = (0, $9cyTu.childrenToArray)(currentChildren);
    if (currentChildren !== children) setChildren([
        currentChildren,
        children
    ]);
    var missingKeys = $fa5d94f116cb8e5c$var$getMissingKeys(current, previous);
    var isSomeChildRemoved = !!missingKeys.size;
    var visibleChildren = current;
    if (isSomeChildRemoved) visibleChildren = (0, $9cyTu.spliceNewElementsIntoPrevious)(current, previous);
    if (exitThenEnter) {
        if (exitingChildren.length) visibleChildren = exitingChildren;
        else {
            var nextExitingChildren = visibleChildren.filter(function(child) {
                return missingKeys.has(child.key);
            });
            if (nextExitingChildren.length) setExitingChildren(nextExitingChildren);
        }
    }
    if (missingKeys.size) visibleChildren = visibleChildren.map(function(child) {
        var isExiting = missingKeys.has(child.key);
        return (0, $9cyTu.wrapChildWithContextProvider)(child, {
            appear: true,
            isExiting: isExiting,
            onFinish: isExiting ? function() {
                missingKeys.delete(child.key);
                if (missingKeys.size === 0) {
                    setChildren([
                        null,
                        children
                    ]);
                    setExitingChildren([]);
                }
            } : undefined
        });
    });
    else visibleChildren = visibleChildren.map(function(child) {
        return (0, $9cyTu.wrapChildWithContextProvider)(child, defaultContext);
    });
    return visibleChildren;
});
var $fa5d94f116cb8e5c$export$2e2bcd8739ae039 = $fa5d94f116cb8e5c$var$WithStrictModeSupport;

});
parcelRegister("cbGWw", function(module, exports) {

$parcel$export(module.exports, "isReducedMotion", function () { return $8df7d2b2be5f5d04$export$b7baf7667a68d87c; });
$parcel$export(module.exports, "reduceMotionAsPerUserPreference", function () { return $8df7d2b2be5f5d04$export$f0f789643ba5a83c; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $k6Bkl = parcelRequire("k6Bkl");
var $8df7d2b2be5f5d04$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== "undefined" && "matchMedia" in window;
};
var $8df7d2b2be5f5d04$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$8df7d2b2be5f5d04$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia("(prefers-reduced-motion: reduce)"), matches = _window$matchMedia.matches;
    return matches;
};
var $8df7d2b2be5f5d04$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $8ZuGG.useState)($8df7d2b2be5f5d04$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        if (!$8df7d2b2be5f5d04$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia("(prefers-reduced-motion: reduce)");
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $k6Bkl.bind)(mediaQueryList, {
            type: "change",
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $8df7d2b2be5f5d04$export$f0f789643ba5a83c = {
    "@media (prefers-reduced-motion: reduce)": {
        animation: "none",
        transition: "none"
    }
};
var $8df7d2b2be5f5d04$export$ff7706047246b98b = function prefersReducedMotion() {
    return $8df7d2b2be5f5d04$export$f0f789643ba5a83c;
};

});


parcelRegister("fSrDY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b8f157a44db0a79f$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $cbGWw = parcelRequire("cbGWw");

var $2xDTy = parcelRequire("2xDTy");

var $9cyTu = parcelRequire("9cyTu");
var $b8f157a44db0a79f$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $b8f157a44db0a79f$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $b8f157a44db0a79f$var$WithoutStrictModeSupport = /*#__PURE__*/ (0, $8ZuGG.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = (0, $9cyTu.childrenToArray)(childs);
    var childrenObj = (0, $9cyTu.childrenToObj)(children);
    var previousChildren = (0, $8ZuGG.useRef)([]);
    var persistedChildren = (0, $8ZuGG.useRef)([]);
    var forceRender = (0, $2xDTy.useForceRender)();
    var exitingChildren = (0, $8ZuGG.useRef)({});
    var appear = (0, $8ZuGG.useRef)(appearFromProp);
    var defaultContextValue = (0, $8ZuGG.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $cbGWw.isReducedMotion)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $b8f157a44db0a79f$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $b8f157a44db0a79f$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : (0, $9cyTu.spliceNewElementsIntoPrevious)(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return (0, $9cyTu.wrapChildWithContextProvider)(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return (0, $9cyTu.wrapChildWithContextProvider)(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return (0, $9cyTu.wrapChildWithContextProvider)(child, defaultContextValue);
    });
});
var $b8f157a44db0a79f$export$2e2bcd8739ae039 = $b8f157a44db0a79f$var$WithoutStrictModeSupport;

});
parcelRegister("2xDTy", function(module, exports) {

$parcel$export(module.exports, "useForceRender", function () { return $1d9d9c270902d268$export$b902f6ef73d6633a; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");
var $1d9d9c270902d268$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $8ZuGG.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $8ZuGG.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};

});



parcelRegister("9tcFo", function(module, exports) {

$parcel$export(module.exports, "mediumDurationMs", function () { return $6e50a5d13d2e5a45$export$6fa259be09e118a7; });
$parcel$export(module.exports, "largeDurationMs", function () { return $6e50a5d13d2e5a45$export$9424640c29bc466d; });
/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $6e50a5d13d2e5a45$export$368bacef0dacbe05 = 25;
var $6e50a5d13d2e5a45$export$2023a81c8547415f = $6e50a5d13d2e5a45$export$368bacef0dacbe05 * 4;
var $6e50a5d13d2e5a45$export$6fa259be09e118a7 = $6e50a5d13d2e5a45$export$368bacef0dacbe05 * 14;
var $6e50a5d13d2e5a45$export$9424640c29bc466d = $6e50a5d13d2e5a45$export$368bacef0dacbe05 * 28;

});

parcelRegister("jTcCE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e7acf1ee56512abd$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $2HBmw = parcelRequire("2HBmw");

var $fYjmY = parcelRequire("fYjmY");

var $kbQtp = parcelRequire("kbQtp");
function $e7acf1ee56512abd$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? "effect" : _ref$mountStrategy;
    var isSubsequentRender = (0, $fYjmY.default)(mountStrategy);
    (0, $kbQtp.default)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $2HBmw.default), {
        zIndex: zIndex
    }, children) : null;
}

});
parcelRegister("2HBmw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1f7c944f08970b20$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $h1d60 = parcelRequire("h1d60");

var $btYQT = parcelRequire("btYQT");
function $1f7c944f08970b20$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $8ZuGG.useMemo)(function() {
        return (0, $btYQT.createContainer)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $btYQT.appendPortalContainerIfNotAppended)(container);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            (0, $btYQT.removePortalContainer)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $h1d60.createPortal)(children, container);
}

});
parcelRegister("btYQT", function(module, exports) {

$parcel$export(module.exports, "createContainer", function () { return $85c19b1bb9332718$export$26ae5ca175b4ec5a; });
$parcel$export(module.exports, "removePortalContainer", function () { return $85c19b1bb9332718$export$da99f98bf3fe55b3; });
$parcel$export(module.exports, "appendPortalContainerIfNotAppended", function () { return $85c19b1bb9332718$export$c582005add11e141; });

var $cXGef = parcelRequire("cXGef");
var $85c19b1bb9332718$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement("div");
    container.className = (0, $cXGef.portalClassName);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $85c19b1bb9332718$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $85c19b1bb9332718$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $cXGef.portalParentSelector));
    if (!parentElement) {
        var _getBody;
        var parent = document.createElement("div");
        parent.className = (0, $cXGef.portalParentClassName);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = "flex";
        (_getBody = $85c19b1bb9332718$var$getBody()) === null || _getBody === void 0 || _getBody.appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $85c19b1bb9332718$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $85c19b1bb9332718$var$getPortalParent().removeChild(container);
};
var $85c19b1bb9332718$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $85c19b1bb9332718$var$getPortalParent().appendChild(container);
};

});
parcelRegister("cXGef", function(module, exports) {

$parcel$export(module.exports, "portalParentClassName", function () { return $96fbc07ae52e1999$export$e4c79eb95c23a0da; });
$parcel$export(module.exports, "portalParentSelector", function () { return $96fbc07ae52e1999$export$72f415121273627e; });
$parcel$export(module.exports, "portalClassName", function () { return $96fbc07ae52e1999$export$13f57c02915787b3; });
var $96fbc07ae52e1999$export$e4c79eb95c23a0da = "atlaskit-portal-container";
var $96fbc07ae52e1999$export$72f415121273627e = "body > .atlaskit-portal-container";
var $96fbc07ae52e1999$export$13f57c02915787b3 = "atlaskit-portal";

});



parcelRegister("fYjmY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba0b7c03a242df8c$export$2e2bcd8739ae039; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $4SntX = parcelRequire("4SntX");
var $ba0b7c03a242df8c$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $8ZuGG.useState)(function() {
        return mountStrategy === "layoutEffect" ? (0, $4SntX.useIsomorphicLayoutEffect) : (0, $8ZuGG.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $ba0b7c03a242df8c$export$2e2bcd8739ae039 = $ba0b7c03a242df8c$var$useIsSubsequentRender;

});
parcelRegister("4SntX", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $38ce6baade87f434$export$700979bc83e7db82; });

var $8ZuGG = parcelRequire("8ZuGG");
var $38ce6baade87f434$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $8ZuGG.useLayoutEffect) : (0, $8ZuGG.useEffect);

});


parcelRegister("kbQtp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $eb2d89d7e979aa86$export$2e2bcd8739ae039; });

var $8ZuGG = parcelRequire("8ZuGG");

var $9apqF = parcelRequire("9apqF");

var $hPCFC = parcelRequire("hPCFC");
var $eb2d89d7e979aa86$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $8ZuGG.useEffect)(function() {
        (0, $hPCFC.default)((0, $9apqF.PORTAL_MOUNT_EVENT), zIndexNumber);
        return function() {
            (0, $hPCFC.default)((0, $9apqF.PORTAL_UNMOUNT_EVENT), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $eb2d89d7e979aa86$export$2e2bcd8739ae039 = $eb2d89d7e979aa86$var$useFirePortalEvent;

});
parcelRegister("9apqF", function(module, exports) {

$parcel$export(module.exports, "PORTAL_MOUNT_EVENT", function () { return $6ac8c5eb586fe3f0$export$ed5835cc67e87f72; });
$parcel$export(module.exports, "PORTAL_UNMOUNT_EVENT", function () { return $6ac8c5eb586fe3f0$export$80816bd900e5bd00; });
var $6ac8c5eb586fe3f0$export$ed5835cc67e87f72 = "akPortalMount";
var $6ac8c5eb586fe3f0$export$80816bd900e5bd00 = "akPortalUnmount";

});

parcelRegister("hPCFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfb53235835b7bd2$export$2e2bcd8739ae039; });
var $cfb53235835b7bd2$var$zIndexToName = {
    100: "card",
    200: "navigation",
    300: "dialog",
    400: "layer",
    500: "blanket",
    510: "modal",
    600: "flag",
    700: "spotlight",
    9999: "tooltip"
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $cfb53235835b7bd2$var$getLayerName = function getLayerName(zIndex) {
    return $cfb53235835b7bd2$var$zIndexToName.hasOwnProperty(zIndex) ? $cfb53235835b7bd2$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $cfb53235835b7bd2$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $cfb53235835b7bd2$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $cfb53235835b7bd2$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $cfb53235835b7bd2$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}

});



parcelRegister("k71RP", function(module, exports) {

$parcel$export(module.exports, "Icon", function () { return $ea45e8e592f86faf$export$f04a61298a47a40f; });

var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $167MO = parcelRequire("167MO");

var $gRWxU = parcelRequire("gRWxU");
function $ea45e8e592f86faf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ea45e8e592f86faf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ea45e8e592f86faf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ea45e8e592f86faf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $ea45e8e592f86faf$var$iconStyles = (0, $14VNY.css)({
    display: "inline-block",
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    "> svg": $ea45e8e592f86faf$var$_objectSpread($ea45e8e592f86faf$var$_objectSpread({}, (0, $gRWxU.commonSVGStyles)), {}, {
        maxWidth: "100%",
        maxHeight: "100%",
        color: "var(--icon-primary-color)",
        fill: "var(--icon-secondary-color)",
        verticalAlign: "bottom"
    })
});
/**
 * For windows high contrast mode
 */ var $ea45e8e592f86faf$var$baseHcmStyles = (0, $14VNY.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            filter: "grayscale(1)",
            "--icon-primary-color": "CanvasText",
            // foreground
            "--icon-secondary-color": "Canvas" // background
        }
    }
});
var $ea45e8e592f86faf$var$primaryEqualsSecondaryHcmStyles = (0, $14VNY.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            "--icon-primary-color": "Canvas" // foreground
        }
    }
});
var $ea45e8e592f86faf$var$secondaryTransparentHcmStyles = (0, $14VNY.css)({
    "@media screen and (forced-colors: active)": {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        "> svg": {
            "--icon-secondary-color": "transparent" // background
        }
    }
});
var $ea45e8e592f86faf$export$f04a61298a47a40f = /*#__PURE__*/ (0, $8ZuGG.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? "currentColor" : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $14VNY.jsx)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $gRWxU.getIconSize)({
        width: width,
        height: height,
        size: size
    });
    return (0, $14VNY.jsx)("span", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        "data-testid": testId,
        role: label ? "img" : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            "--icon-primary-color": primaryColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            "--icon-secondary-color": secondaryColor || (0, $167MO.getBackground)()
        }
    }, glyphProps, {
        css: [
            $ea45e8e592f86faf$var$iconStyles,
            $ea45e8e592f86faf$var$baseHcmStyles,
            primaryColor === secondaryColor && $ea45e8e592f86faf$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === "transparent" && $ea45e8e592f86faf$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsulating them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $14VNY.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: dimensions.width,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: dimensions.height,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                "> svg": dimensions
            })
        ]
    }));
});
var $ea45e8e592f86faf$export$2e2bcd8739ae039 = $ea45e8e592f86faf$export$f04a61298a47a40f;

});
parcelRegister("167MO", function(module, exports) {

$parcel$export(module.exports, "getBackground", function () { return $0ccc642941a0a4d8$export$18cb9425622d4e06; });
var $0ccc642941a0a4d8$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};

});

parcelRegister("gRWxU", function(module, exports) {

$parcel$export(module.exports, "commonSVGStyles", function () { return $c47f028e60de9355$export$16374db1c3e6dfba; });
$parcel$export(module.exports, "sizeStyleMap", function () { return $c47f028e60de9355$export$ef0ad74202575b64; });
$parcel$export(module.exports, "getIconSize", function () { return $c47f028e60de9355$export$3eb7d6130acfda37; });

var $1ayaO = parcelRequire("1ayaO");

var $14VNY = parcelRequire("14VNY");
var $c47f028e60de9355$export$16374db1c3e6dfba = {
    overflow: "hidden",
    pointerEvents: "none",
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: "currentColor"
    }
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $c47f028e60de9355$var$smallStyles = (0, $14VNY.css)((0, $1ayaO.dimensions).small);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $c47f028e60de9355$var$mediumStyles = (0, $14VNY.css)((0, $1ayaO.dimensions).medium);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $c47f028e60de9355$var$largeStyles = (0, $14VNY.css)((0, $1ayaO.dimensions).large);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
var $c47f028e60de9355$var$xlargeStyles = (0, $14VNY.css)((0, $1ayaO.dimensions).xlarge);
var $c47f028e60de9355$export$ef0ad74202575b64 = {
    small: $c47f028e60de9355$var$smallStyles,
    medium: $c47f028e60de9355$var$mediumStyles,
    large: $c47f028e60de9355$var$largeStyles,
    xlarge: $c47f028e60de9355$var$xlargeStyles
};
var $c47f028e60de9355$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $1ayaO.dimensions)[size];
    return undefined;
};

});
parcelRegister("1ayaO", function(module, exports) {

$parcel$export(module.exports, "dimensions", function () { return $0da13bbaa17dda0e$export$62ad7b0c781000e9; });
var $0da13bbaa17dda0e$export$c647cb0ee6e282fe = {
    small: "16px",
    medium: "24px",
    large: "32px",
    xlarge: "48px"
};
var $0da13bbaa17dda0e$export$7bd66fc94c81bf84 = {
    small: "small",
    medium: "medium",
    large: "large",
    xlarge: "xlarge"
};
var $0da13bbaa17dda0e$export$62ad7b0c781000e9 = {
    small: {
        width: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.small,
        height: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.medium,
        height: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.large,
        height: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.xlarge,
        height: $0da13bbaa17dda0e$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("bJIvo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88b66b8490014314$export$2e2bcd8739ae039; });

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $1Muvn = parcelRequire("1Muvn");

var $5AVd4 = parcelRequire("5AVd4");

var $hUeXI = parcelRequire("hUeXI");

var $1S0T5 = parcelRequire("1S0T5");

var $57fzU = parcelRequire("57fzU");
var $88b66b8490014314$var$_excluded = [
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "isDisabled",
    "type",
    "onClick",
    "interactionName",
    "componentName",
    "analyticsContext",
    "style",
    "testId",
    "xcss"
], $88b66b8490014314$var$_excluded2 = [
    "className"
];
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
var $88b66b8490014314$var$focusRingStyles = (0, $14VNY.css)({
    "&:focus, &:focus-visible": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $1S0T5.borderColorMap)["color.border.focused"],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $1S0T5.positiveSpaceMap)["space.025"],
        outlineStyle: "solid",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $1S0T5.borderWidthMap)["border.width.outline"]
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    "&:focus:not(:focus-visible)": {
        outline: "none"
    },
    "@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)": {
        "&:focus-visible": {
            outline: "1px solid"
        }
    }
});
var $88b66b8490014314$var$baseStyles = (0, $14VNY.css)({
    boxSizing: "border-box",
    appearance: "none",
    border: "none"
});
var $88b66b8490014314$var$enabledStyles = (0, $14VNY.css)({
    cursor: "pointer"
});
var $88b66b8490014314$var$disabledStyles = (0, $14VNY.css)({
    cursor: "not-allowed"
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ var $88b66b8490014314$var$Pressable = /*#__PURE__*/ (0, $8ZuGG.forwardRef)(function(_ref, ref) {
    var children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, isDisabled = _ref.isDisabled, _ref$type = _ref.type, type = _ref$type === void 0 ? "button" : _ref$type, _ref$onClick = _ref.onClick, providedOnClick = _ref$onClick === void 0 ? (0, $5AVd4.default) : _ref$onClick, interactionName = _ref.interactionName, componentName = _ref.componentName, analyticsContext = _ref.analyticsContext, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref, $88b66b8490014314$var$_excluded);
    var interactionContext = (0, $8ZuGG.useContext)((0, $hUeXI.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: componentName || "Pressable",
        packageName: "@atlaskit/primitives",
        packageVersion: "11.0.2",
        analyticsData: analyticsContext,
        actionSubject: "button"
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(htmlAttributes, $88b66b8490014314$var$_excluded2);
    var resolvedStyles = (0, $57fzU.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $14VNY.jsx)("button", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $88b66b8490014314$var$baseStyles,
            $88b66b8490014314$var$focusRingStyles,
            isDisabled ? $88b66b8490014314$var$disabledStyles : $88b66b8490014314$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $1S0T5.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $1S0T5.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $1S0T5.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $1S0T5.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $1S0T5.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $1S0T5.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $1S0T5.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $1S0T5.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $88b66b8490014314$export$2e2bcd8739ae039 = $88b66b8490014314$var$Pressable;

});

parcelRegister("gWxJe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c55c39ede663614e$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $4xaIc = parcelRequire("4xaIc");

var $9tcFo = parcelRequire("9tcFo");

var $k1pve = parcelRequire("k1pve");
function $c55c39ede663614e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c55c39ede663614e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c55c39ede663614e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c55c39ede663614e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $c55c39ede663614e$var$directionMotions = {
    proportional: {
        bottom: "translate3d(0, calc(5% + 4px), 0)",
        left: "translate3d(calc(-5% - 4px), 0, 0)",
        right: "translate3d(calc(5% + 4px), 0, 0)",
        top: "translate3d(0, calc(-5% - 4px), 0)"
    },
    constant: {
        bottom: "translate3d(0, 4px, 0)",
        left: "translate3d(-4px, 0, 0)",
        right: "translate3d(4px, 0, 0)",
        top: "translate3d(0, -4px, 0)"
    }
};
var $c55c39ede663614e$var$invertedDirection = {
    top: "bottom",
    bottom: "top",
    left: "right",
    right: "left"
};
var $c55c39ede663614e$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: $c55c39ede663614e$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c55c39ede663614e$var$directionMotions[distance][direction]
        }),
        "50%": {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? "none" : undefined
        }
    };
};
var $c55c39ede663614e$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "proportional";
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? "translate3d(0, 0, 0)" : undefined
        },
        to: $c55c39ede663614e$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $c55c39ede663614e$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $c55c39ede663614e$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $9tcFo.largeDurationMs) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? "proportional" : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $c55c39ede663614e$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $k1pve.default), {
        duration: duration,
        enteringAnimation: $c55c39ede663614e$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $c55c39ede663614e$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $4xaIc.easeInOut;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $c55c39ede663614e$export$2e2bcd8739ae039 = $c55c39ede663614e$var$FadeIn;

});
parcelRegister("k1pve", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e937aefa53328e39$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $cbGWw = parcelRequire("cbGWw");

var $9tcFo = parcelRequire("9tcFo");

var $7gmhW = parcelRequire("7gmhW");

var $9cyTu = parcelRequire("9cyTu");

var $9pDEZ = parcelRequire("9pDEZ");
function $e937aefa53328e39$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e937aefa53328e39$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e937aefa53328e39$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e937aefa53328e39$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $e937aefa53328e39$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $e937aefa53328e39$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $9tcFo.largeDurationMs) : _ref$duration;
    var staggered = (0, $9pDEZ.useStaggeredEntrance)();
    var _useExitingPersistenc = (0, $9cyTu.useExitingPersistence)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $7gmhW.useSetTimeout)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? "exiting" : "entering";
    var _useState = (0, $8ZuGG.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $8ZuGG.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === "exiting") onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $e937aefa53328e39$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $14VNY.ClassNames), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($e937aefa53328e39$var$_objectSpread($e937aefa53328e39$var$_objectSpread({}, (0, $cbGWw.reduceMotionAsPerUserPreference)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $e937aefa53328e39$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? "forwards" : "backwards",
                animationName: "".concat((0, $14VNY.keyframes)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? "paused" : "running",
                animationTimingFunction: animationTimingFunction(state)
            })) : ""
        }, state);
    });
};
var $e937aefa53328e39$export$2e2bcd8739ae039 = $e937aefa53328e39$var$EnteringMotion;

});
parcelRegister("7gmhW", function(module, exports) {

$parcel$export(module.exports, "useSetTimeout", function () { return $549b5105b658323a$export$4f34107a2b00f39c; });

var $8ZuGG = parcelRequire("8ZuGG");
var $549b5105b658323a$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case "next-effect":
            return undefined;
        case "unmount":
        default:
            return [];
    }
};
var $549b5105b658323a$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var frames = (0, $8ZuGG.useRef)([]);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $549b5105b658323a$var$getHookDeps(opts));
    return (0, $8ZuGG.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $549b5105b658323a$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: "unmount"
    };
    var timeouts = (0, $8ZuGG.useRef)([]);
    (0, $8ZuGG.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $549b5105b658323a$var$getHookDeps(opts));
    return (0, $8ZuGG.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};

});

parcelRegister("9pDEZ", function(module, exports) {

$parcel$export(module.exports, "useStaggeredEntrance", function () { return $6da53681a021116b$export$25c7213fc07ec080; });

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $5AVd4 = parcelRequire("5AVd4");

var $9F3xO = parcelRequire("9F3xO");

var $iJdss = parcelRequire("iJdss");
var $6da53681a021116b$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $5AVd4.default)
    };
});
var $6da53681a021116b$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $iJdss.useUniqueId)();
    var context = (0, $8ZuGG.useContext)($6da53681a021116b$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $6da53681a021116b$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? "responsive" : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $8ZuGG.useRef)([]);
    var indexes = [];
    var _useState = (0, $8ZuGG.useState)(function() {
        if (typeof columns === "number") // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === "number") // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $9F3xO.useLayoutEffect)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === "responsive" && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($6da53681a021116b$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $6da53681a021116b$export$2e2bcd8739ae039 = $6da53681a021116b$var$StaggeredEntrance;

});
parcelRegister("9F3xO", function(module, exports) {

$parcel$export(module.exports, "useLayoutEffect", function () { return $708ab13d71506390$export$e5c5a5f917a5871c; });

var $8ZuGG = parcelRequire("8ZuGG");
var $708ab13d71506390$export$e5c5a5f917a5871c = typeof window === "undefined" ? (0, $8ZuGG.useEffect) : (0, $8ZuGG.useLayoutEffect);

});

parcelRegister("iJdss", function(module, exports) {

$parcel$export(module.exports, "useUniqueId", function () { return $da26de6f207f22f0$export$c485849f2e393253; });
/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $8ZuGG = parcelRequire("8ZuGG");
function $da26de6f207f22f0$export$c485849f2e393253() {
    var identifier = (0, $8ZuGG.useRef)("");
    if (!identifier.current) identifier.current = "_" + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}

});




parcelRegister("5BHjB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $415201f0f55b2c23$var$_react = $415201f0f55b2c23$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $k71RP = parcelRequire("k71RP");
function $415201f0f55b2c23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $415201f0f55b2c23$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $415201f0f55b2c23$var$_react.default.createElement($k71RP.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle fill="currentColor" cx="12" cy="12" r="10"/><path d="M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z" fill="inherit"/></g></svg>`
    }, props));
$415201f0f55b2c23$var$CheckCircleIcon.displayName = "CheckCircleIcon";
var $415201f0f55b2c23$var$_default = $415201f0f55b2c23$var$CheckCircleIcon;
module.exports.default = $415201f0f55b2c23$var$_default;

});

parcelRegister("7lAAA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5596e0610de8ab1f$var$_react = $5596e0610de8ab1f$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $k71RP = parcelRequire("k71RP");
function $5596e0610de8ab1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5596e0610de8ab1f$var$ErrorIcon = (props)=>/*#__PURE__*/ $5596e0610de8ab1f$var$_react.default.createElement($k71RP.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path d="M13.416 4.417a2.002 2.002 0 00-2.832 0l-6.168 6.167a2.002 2.002 0 000 2.833l6.168 6.167a2.002 2.002 0 002.832 0l6.168-6.167a2.002 2.002 0 000-2.833l-6.168-6.167z" fill="currentColor"/><path d="M12 14a1 1 0 01-1-1V8a1 1 0 012 0v5a1 1 0 01-1 1m0 3a1 1 0 010-2 1 1 0 010 2" fill="inherit"/></g></svg>`
    }, props));
$5596e0610de8ab1f$var$ErrorIcon.displayName = "ErrorIcon";
var $5596e0610de8ab1f$var$_default = $5596e0610de8ab1f$var$ErrorIcon;
module.exports.default = $5596e0610de8ab1f$var$_default;

});

parcelRegister("3wlJ5", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7GeoT")).then(()=>parcelRequire("89s2O"));

});

parcelRegister("jkZ8p", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("invL5"))
]).then(()=>parcelRequire("04Sj4"));

});

parcelRegister("avyIi", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hqoG1")).then(()=>parcelRequire("3rMgh"));

});

parcelRegister("7mBc6", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("34nrb"))
]).then(()=>parcelRequire("4sO9M"));

});

parcelRegister("78gHK", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("gxhbY")).then(()=>parcelRequire("1Ix2R"));

});

parcelRegister("5dD3p", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9wE1v"))
]).then(()=>parcelRequire("gEsch"));

});

parcelRegister("8umKI", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("c4weA")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ftQt4")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5j8Js")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lMxth")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1do6y"))
]).then(()=>parcelRequire("cJaD4"));

});

parcelRegister("kNf8F", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1gsC9")).then(()=>parcelRequire("hL11L"));

});

parcelRegister("fESxg", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ab5u4")).then(()=>parcelRequire("30C6j"));

});

parcelRegister("b86ZF", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1b58t")).then(()=>parcelRequire("d3VRQ"));

});

parcelRegister("8WKkQ", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("iAwwt")).then(()=>parcelRequire("9N9Ys"));

});

parcelRegister("h6W4e", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fJ1OD")).then(()=>parcelRequire("pAsnm"));

});

parcelRegister("1CJSz", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9EAPL")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ci2Vd"))
]).then(()=>parcelRequire("hWM0L"));

});

parcelRegister("4NIjs", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("fCnUj")).then(()=>parcelRequire("gjxi0"));

});

parcelRegister("61mIx", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hqoG1")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("invL5")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("3Nn9e"))
]).then(()=>parcelRequire("akKks"));

});

parcelRegister("7fzaF", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("jsyDW")).then(()=>parcelRequire("5S2Pz"));

});

parcelRegister("3XS0t", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("f1tTh"))
]).then(()=>parcelRequire("aZgOq"));

});

parcelRegister("hfN0O", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9JEXQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("7s7M1"))
]).then(()=>parcelRequire("lFKa2"));

});

parcelRegister("gQGaJ", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1brxb")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("23mfE"))
]).then(()=>parcelRequire("lGfVq"));

});

parcelRegister("fJ46X", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ecNZk"))
]).then(()=>parcelRequire("4GJDT"));

});

parcelRegister("8e1Aj", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9EAPL")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("enqBr"))
]).then(()=>parcelRequire("c8zx1"));

});

parcelRegister("lm9T8", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("gRQp7")).then(()=>parcelRequire("aiiz9"));

});

parcelRegister("l8RSV", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5Ycje")).then(()=>parcelRequire("ghg9H"));

});

parcelRegister("iPFs9", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ldkNR")).then(()=>parcelRequire("9mUVE"));

});

parcelRegister("3Z8MS", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9JEXQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1brxb")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9qfgK"))
]).then(()=>parcelRequire("50Ge8"));

});

parcelRegister("cXerD", function(module, exports) {






module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9JEXQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("bC5Oq"))
]).then(()=>parcelRequire("889Xg"));

});

parcelRegister("k07Fo", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9JEXQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aAexT"))
]).then(()=>parcelRequire("e0qo2"));

});

parcelRegister("8hrXD", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5AYxq")).then(()=>parcelRequire("4RcrL"));

});

parcelRegister("jhLdq", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9EAPL")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4yKTV"))
]).then(()=>parcelRequire("9GYqm"));

});

parcelRegister("5AsmO", function(module, exports) {








module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4v6km")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5j8Js")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lMxth")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("1xGEb"))
]).then(()=>parcelRequire("f1MY9"));

});

parcelRegister("d1ZQM", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("djOOX")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aSZgj")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4v6km")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5j8Js")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("jQoZC"))
]).then(()=>parcelRequire("aJ3om"));

});

parcelRegister("3yflG", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("djOOX")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aSZgj")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4v6km")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5j8Js")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("lMxth")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("bRVWW"))
]).then(()=>parcelRequire("8xCdd"));

});

parcelRegister("81dT5", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aSZgj")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4v6km")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("c4weA")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("5j8Js")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2GE3c"))
]).then(()=>parcelRequire("fQlcd"));

});

parcelRegister("6sFmz", function(module, exports) {














module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aSZgj")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4v6km")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ftQt4")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("d7q9g"))
]).then(()=>parcelRequire("eHaka"));

});

parcelRegister("CytXg", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("90gtY")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2TTwv")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("Ou8I6"))
]).then(()=>parcelRequire("7VpeL"));

});

parcelRegister("5k5ur", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("90gtY")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2TTwv")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("ftQt4")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hIuXM"))
]).then(()=>parcelRequire("WiklM"));

});

parcelRegister("cicF5", function(module, exports) {


















module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("4lFZL")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("90gtY")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2TTwv")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9EAPL")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("hExuV"))
]).then(()=>parcelRequire("nInul"));

});

parcelRegister("eIShq", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("3q3uM")).then(()=>parcelRequire("cqhyt"));

});

parcelRegister("7YVtY", function(module, exports) {


module.exports = (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("i6HCB")).then(()=>parcelRequire("8GH1V"));

});

parcelRegister("jFWlr", function(module, exports) {












module.exports = Promise.all([
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2TTwv")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("e4ywz")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("aHqAe")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("2fzZF")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("9GcEQ")),
    (parcelRequire("1VTzg"))((parcelRequire("WpYDg")).resolve("kQdzn"))
]).then(()=>parcelRequire("8UYrY"));

});

parcelRegister("jtt5y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e1a4baa2ba97a8e3$export$2e2bcd8739ae039; });
const $e1a4baa2ba97a8e3$var$EMPTY_APP_STATE_VALUE = "{{data_app_state}}";
const $e1a4baa2ba97a8e3$var$hasNoInjectedServerState = ()=>{
    const data = document.body.getAttribute("data-app-state");
    const dataNotInjectedDueToTestContext = data === null;
    return data === $e1a4baa2ba97a8e3$var$EMPTY_APP_STATE_VALUE || dataNotInjectedDueToTestContext;
};
var $e1a4baa2ba97a8e3$export$2e2bcd8739ae039 = $e1a4baa2ba97a8e3$var$hasNoInjectedServerState;

});

parcelRegister("gV6nD", function(module, exports) {

$parcel$export(module.exports, "checkFeatureGate", function () { return $af3bde101ec9c464$export$bd360271f9be3afb; });

var $eF4yw = parcelRequire("eF4yw");
const $af3bde101ec9c464$export$bd360271f9be3afb = (key)=>{
    return (0, $eF4yw.default).checkGate(key);
};

});
parcelRegister("eF4yw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aac86db54f6afcba$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("glkGR")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("glkGR")).EvaluationReason; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("51qEW")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("51qEW")).PerimeterType; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("g1oWB")).CLIENT_VERSION; });

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $5msJs = parcelRequire("5msJs");

var $glkGR = parcelRequire("glkGR");

var $1tAmr = parcelRequire("1tAmr");

var $1LBry = parcelRequire("1LBry");

var $fHUq5 = parcelRequire("fHUq5");

var $51qEW = parcelRequire("51qEW");

var $g1oWB = parcelRequire("g1oWB");
var $aac86db54f6afcba$var$_excluded = [
    "sdkKey",
    "updateUserCompletionCallback",
    "perimeter"
];
function $aac86db54f6afcba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aac86db54f6afcba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aac86db54f6afcba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aac86db54f6afcba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $aac86db54f6afcba$var$DEFAULT_CLIENT_KEY = "client-default-key";
// the default event logging api is the Atlassian proxy rather than Statsig's domain, to avoid ad blockers
var $aac86db54f6afcba$var$DEFAULT_EVENT_LOGGING_API = "https://xp.atlassian.com/v1/";
/**
 * Access the FeatureGates object via the default export.
 * ```ts
 * import FeatureGates from '@atlaskit/feature-gate-js-client';
 * ```
 */ var $aac86db54f6afcba$var$FeatureGates = /*#__PURE__*/ function() {
    function FeatureGates() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, FeatureGates);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(FeatureGates, null, [
        {
            key: "initialize",
            value: /**
     * @description
     * This method initializes the client using a network call to fetch the bootstrap values.
     * If the client is inialized with an `analyticsWebClient`, it will send an operational event
     * to GASv3 with the following attributes:
     * - targetApp: the target app of the client
     * - clientVersion: the version of the client
     * - success: whether the initialization was successful
     * - startTime: the time when the initialization started
     * - totalTime: the total time it took to initialize the client
     * - apiKey: the api key used to initialize the client
     * @param clientOptions {ClientOptions}
     * @param identifiers {Identifiers}
     * @param customAttributes {CustomAttributes}
     * @returns {Promise<void>}
     */ function() {
                var _initialize = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(clientOptions, identifiers, customAttributes) {
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                clientOptionsWithDefaults = this.getOptionsWithDefaults(clientOptions);
                                if (!FeatureGates.initPromise) {
                                    _context.next = 4;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptionsWithDefaults, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptionsWithDefaults;
                                FeatureGates.initPromise = FeatureGates.init(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    FeatureGates.initCompleted = true;
                                    FeatureGates.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initialize", FeatureGates.initCompleted, clientOptionsWithDefaults.apiKey);
                                });
                                return _context.abrupt("return", FeatureGates.initPromise);
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this);
                }));
                function initialize(_x, _x2, _x3) {
                    return _initialize.apply(this, arguments);
                }
                return initialize;
            }()
        },
        {
            key: "initializeWithProvider",
            value: function() {
                var _initializeWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(clientOptions, provider, identifiers, customAttributes) {
                    var clientOptionsWithDefaults, startTime;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                clientOptionsWithDefaults = this.getOptionsWithDefaults(clientOptions);
                                if (!FeatureGates.initPromise) {
                                    _context2.next = 4;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptionsWithDefaults, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptionsWithDefaults;
                                FeatureGates.provider = provider;
                                FeatureGates.provider.setClientVersion((0, $g1oWB.CLIENT_VERSION));
                                if (FeatureGates.provider.setApplyUpdateCallback) FeatureGates.provider.setApplyUpdateCallback(this.applyUpdateCallback);
                                FeatureGates.initPromise = FeatureGates.initWithProvider(clientOptionsWithDefaults, identifiers, customAttributes).then(function() {
                                    FeatureGates.initCompleted = true;
                                    FeatureGates.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initializeWithProvider", FeatureGates.initCompleted, provider.getApiKey ? provider.getApiKey() : undefined);
                                });
                                return _context2.abrupt("return", FeatureGates.initPromise);
                            case 11:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this);
                }));
                function initializeWithProvider(_x4, _x5, _x6, _x7) {
                    return _initializeWithProvider.apply(this, arguments);
                }
                return initializeWithProvider;
            }()
        },
        {
            key: "applyUpdateCallback",
            value: function applyUpdateCallback(experimentsResult) {
                try {
                    if (FeatureGates.initCompleted || FeatureGates.initWithDefaults) {
                        (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).setInitializeValues(experimentsResult.experimentValues);
                        FeatureGates.subscriptions.anyUpdated();
                    }
                } catch (error) {
                    // eslint-disable-next-line no-console
                    console.warn("Error when attempting to apply update", error);
                }
            }
        },
        {
            key: "fireClientEvent",
            value: function fireClientEvent(startTime, totalTime, action, success) {
                var _FeatureGates$initOpt;
                var apiKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
                (_FeatureGates$initOpt = FeatureGates.initOptions.analyticsWebClient) === null || _FeatureGates$initOpt === void 0 || _FeatureGates$initOpt.then(function(analyticsWebClient) {
                    var attributes = $aac86db54f6afcba$var$_objectSpread({
                        targetApp: FeatureGates.initOptions.targetApp,
                        clientVersion: (0, $g1oWB.CLIENT_VERSION),
                        success: success,
                        startTime: startTime,
                        totalTime: totalTime
                    }, apiKey && {
                        apiKey: apiKey
                    });
                    analyticsWebClient.sendOperationalEvent({
                        action: action,
                        actionSubject: "featureGatesClient",
                        attributes: attributes,
                        tags: [
                            "measurement"
                        ],
                        source: "@atlaskit/feature-gate-js-client"
                    });
                }).catch(function(err) {
                    if (FeatureGates.initOptions.environment !== (0, $51qEW.FeatureGateEnvironment).Production) // eslint-disable-next-line no-console
                    console.error("Analytics web client promise did not resolve", err);
                });
            }
        },
        {
            key: "initializeFromValues",
            value: function() {
                var _initializeFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(clientOptions, identifiers, customAttributes) {
                    var initializeValues, clientOptionsWithDefaults, startTime, _args3 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                initializeValues = _args3.length > 3 && _args3[3] !== undefined ? _args3[3] : {};
                                clientOptionsWithDefaults = this.getOptionsWithDefaults(clientOptions);
                                if (!FeatureGates.initPromise) {
                                    _context3.next = 5;
                                    break;
                                }
                                if (!FeatureGates.shallowEquals(clientOptionsWithDefaults, FeatureGates.initOptions)) // eslint-disable-next-line no-console
                                console.warn("Feature Gates client already initialized with different options. New options were not applied.");
                                return _context3.abrupt("return", FeatureGates.initPromise);
                            case 5:
                                startTime = performance.now();
                                FeatureGates.initOptions = clientOptionsWithDefaults;
                                FeatureGates.initPromise = FeatureGates.initFromValues(clientOptionsWithDefaults, identifiers, customAttributes, initializeValues).then(function() {
                                    FeatureGates.initCompleted = true;
                                    FeatureGates.initWithDefaults = true;
                                }).finally(function() {
                                    var endTime = performance.now();
                                    var totalTime = endTime - startTime;
                                    FeatureGates.fireClientEvent(startTime, totalTime, "initializeFromValues", FeatureGates.initCompleted);
                                });
                                return _context3.abrupt("return", FeatureGates.initPromise);
                            case 9:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3, this);
                }));
                function initializeFromValues(_x8, _x9, _x10) {
                    return _initializeFromValues.apply(this, arguments);
                }
                return initializeFromValues;
            }()
        },
        {
            key: "updateUser",
            value: function() {
                var _updateUser = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee4(fetchOptions, identifiers, customAttributes) {
                    var fetchOptionsWithDefaults, initializeValuesProducer;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                fetchOptionsWithDefaults = this.getOptionsWithDefaults(fetchOptions);
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return (0, $fHUq5.default).fetchExperimentValues(fetchOptionsWithDefaults, identifiers, customAttributes).then(function(_ref) {
                                        var experimentValues = _ref.experimentValues, customAttributes = _ref.customAttributes;
                                        return {
                                            experimentValues: experimentValues,
                                            customAttributesFromFetch: customAttributes
                                        };
                                    });
                                };
                                _context4.next = 4;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4, this);
                }));
                function updateUser(_x11, _x12, _x13) {
                    return _updateUser.apply(this, arguments);
                }
                return updateUser;
            }()
        },
        {
            key: "updateUserWithProvider",
            value: function() {
                var _updateUserWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee5(identifiers, customAttributes) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                if (FeatureGates.provider) {
                                    _context5.next = 2;
                                    break;
                                }
                                throw new Error("Cannot update user using provider as the client was not initialised with a provider");
                            case 2:
                                _context5.next = 4;
                                return FeatureGates.provider.setProfile(FeatureGates.initOptions, identifiers, customAttributes);
                            case 4:
                                _context5.next = 6;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(function() {
                                    return FeatureGates.provider.getExperimentValues();
                                }, identifiers, customAttributes);
                            case 6:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5);
                }));
                function updateUserWithProvider(_x14, _x15) {
                    return _updateUserWithProvider.apply(this, arguments);
                }
                return updateUserWithProvider;
            }()
        },
        {
            key: "updateUserWithValues",
            value: function() {
                var _updateUserWithValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee6(identifiers, customAttributes) {
                    var initializeValues, initializeValuesProducer, _args6 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee6$(_context6) {
                        while(true)switch(_context6.prev = _context6.next){
                            case 0:
                                initializeValues = _args6.length > 2 && _args6[2] !== undefined ? _args6[2] : {};
                                initializeValuesProducer = function initializeValuesProducer() {
                                    return Promise.resolve({
                                        experimentValues: initializeValues,
                                        customAttributesFromFetch: customAttributes
                                    });
                                };
                                _context6.next = 4;
                                return FeatureGates.updateUserUsingInitializeValuesProducer(initializeValuesProducer, identifiers, customAttributes);
                            case 4:
                            case "end":
                                return _context6.stop();
                        }
                    }, _callee6);
                }));
                function updateUserWithValues(_x16, _x17) {
                    return _updateUserWithValues.apply(this, arguments);
                }
                return updateUserWithValues;
            }()
        },
        {
            key: "initializeCalled",
            value: function initializeCalled() {
                return FeatureGates.initPromise != null;
            }
        },
        {
            key: "initializeCompleted",
            value: function initializeCompleted() {
                return FeatureGates.initCompleted;
            }
        },
        {
            key: "checkGate",
            value: function checkGate(gateName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    // Check if the CRITERION override mechanism is available
                    if (window && window.__CRITERION__ && typeof window.__CRITERION__.getFeatureFlagOverride === "function") {
                        // Attempt to retrieve an override value for the feature gate
                        var overrideValue = window.__CRITERION__.getFeatureFlagOverride(gateName);
                        // If an override value is found, return it immediately
                        if (overrideValue !== undefined) return overrideValue;
                    }
                    // Proceed with the main logic if no override is found
                    var _options$fireGateExpo = options.fireGateExposure, fireGateExposure = _options$fireGateExpo === void 0 ? true : _options$fireGateExpo;
                    var evalMethod = fireGateExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).checkGate.bind((0, (/*@__PURE__*/$parcel$interopDefault($glkGR)))) : (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).checkGateWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($glkGR))));
                    return evalMethod(gateName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasCheckGateErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred checking the feature gate. Only the first occurrence of this error is logged.",
                            gateName: gateName,
                            error: error
                        });
                        FeatureGates.hasCheckGateErrorOccurred = true;
                    }
                    return false;
                }
            }
        },
        {
            key: "manuallyLogGateExposure",
            value: function manuallyLogGateExposure(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).manuallyLogGateExposure(gateName);
            }
        },
        {
            key: "getExperiment",
            value: function getExperiment(experimentName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireExperime = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime === void 0 ? true : _options$fireExperime;
                    var evalMethod = fireExperimentExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).getExperiment.bind((0, (/*@__PURE__*/$parcel$interopDefault($glkGR)))) : (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).getExperimentWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($glkGR))));
                    return evalMethod(experimentName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            error: error
                        });
                        FeatureGates.hasGetExperimentErrorOccurred = true;
                    }
                    // Return a default value
                    return new (0, $glkGR.DynamicConfig)(experimentName, {}, "", {
                        time: Date.now(),
                        reason: (0, $glkGR.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getExperimentValue",
            value: function getExperimentValue(experimentName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                // Check if the CRITERION override mechanism is available
                if (window && window.__CRITERION__ && typeof window.__CRITERION__.getExperimentValueOverride === "function") {
                    var overrideValue = window.__CRITERION__.getExperimentValueOverride(experimentName, parameterName);
                    if (overrideValue !== undefined && overrideValue !== null) return overrideValue;
                }
                // Proceed with the main logic if no override is found
                var experiment = FeatureGates.getExperiment(experimentName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return experiment.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetExperimentValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the experiment value. Only the first occurrence of this error is logged.",
                            experimentName: experimentName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetExperimentValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "manuallyLogExperimentExposure",
            value: function manuallyLogExperimentExposure(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).manuallyLogExperimentExposure(experimentName);
            }
        },
        {
            key: "manuallyLogLayerExposure",
            value: function manuallyLogLayerExposure(layerName, parameterName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).manuallyLogLayerParameterExposure(layerName, parameterName);
            }
        },
        {
            key: "shutdownStatsig",
            value: function shutdownStatsig() {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).shutdown();
            }
        },
        {
            key: "overrideGate",
            value: function overrideGate(gateName, value) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).overrideGate(gateName, value);
            }
        },
        {
            key: "clearGateOverride",
            value: function clearGateOverride(gateName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).overrideGate(gateName, null);
            }
        },
        {
            key: "overrideConfig",
            value: function overrideConfig(experimentName, values) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).overrideConfig(experimentName, values);
            }
        },
        {
            key: "clearConfigOverride",
            value: function clearConfigOverride(experimentName) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).overrideConfig(experimentName, null);
            }
        },
        {
            key: "setOverrides",
            value: function setOverrides(overrides) {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).setOverrides($aac86db54f6afcba$var$_objectSpread({
                    gates: {},
                    configs: {},
                    layers: {}
                }, overrides));
            }
        },
        {
            key: "getOverrides",
            value: function getOverrides() {
                return (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).getOverrides();
            }
        },
        {
            key: "clearAllOverrides",
            value: function clearAllOverrides() {
                (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).setOverrides(null);
            }
        },
        {
            key: "isCurrentUser",
            value: function isCurrentUser(identifiers, customAttributes) {
                return FeatureGates.shallowEquals(FeatureGates.currentIdentifiers, identifiers) && FeatureGates.shallowEquals(FeatureGates.currentAttributes, customAttributes);
            }
        },
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireGateExpo2 = options.fireGateExposure, fireGateExposure = _options$fireGateExpo2 === void 0 ? true : _options$fireGateExpo2;
                    if (fireGateExposure) FeatureGates.manuallyLogGateExposure(gateName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for gate ".concat(gateName, " with value ").concat(value), error);
                    }
                };
                return FeatureGates.subscriptions.onGateUpdated(gateName, wrapCallback, FeatureGates.checkGate, options);
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
                var wrapCallback = function wrapCallback(value) {
                    var _options$fireExperime2 = options.fireExperimentExposure, fireExperimentExposure = _options$fireExperime2 === void 0 ? true : _options$fireExperime2;
                    if (fireExperimentExposure) FeatureGates.manuallyLogExperimentExposure(experimentName);
                    try {
                        callback(value);
                    } catch (error) {
                        // eslint-disable-next-line no-console
                        console.warn("Error calling callback for experiment ".concat(experimentName, " with value ").concat(value), error);
                    }
                };
                return FeatureGates.subscriptions.onExperimentValueUpdated(experimentName, parameterName, defaultValue, wrapCallback, FeatureGates.getExperimentValue, options);
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _FeatureGates$subscri;
                return (_FeatureGates$subscri = FeatureGates.subscriptions) === null || _FeatureGates$subscri === void 0 ? void 0 : _FeatureGates$subscri.onAnyUpdated(callback);
            }
        },
        {
            key: "init",
            value: function() {
                var _init = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee7(clientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all, _yield$Promise$all2, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee7$(_context7) {
                        while(true)switch(_context7.prev = _context7.next){
                            case 0:
                                fromValuesClientOptions = $aac86db54f6afcba$var$_objectSpread({}, clientOptions);
                                _context7.prev = 1;
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                // values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = (0, $fHUq5.default).fetchClientSdk(clientOptions).then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value.clientSdkKey;
                                });
                                experimentValuesPromise = (0, $fHUq5.default).fetchExperimentValues(clientOptions, identifiers, customAttributes); // Only wait for the experiment values request to finish and try to initialise the client with experiment
                                // values if both requests are successful. Else an error would be thrown and handled by the catch
                                _context7.next = 6;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 6:
                                _yield$Promise$all = _context7.sent;
                                _yield$Promise$all2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_yield$Promise$all, 2);
                                experimentValuesResult = _yield$Promise$all2[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributes;
                                _context7.next = 20;
                                break;
                            case 13:
                                _context7.prev = 13;
                                _context7.t0 = _context7["catch"](1);
                                if (_context7.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context7.next = 19;
                                return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 19:
                                throw _context7.t0;
                            case 20:
                                _context7.next = 22;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                            case 22:
                            case "end":
                                return _context7.stop();
                        }
                    }, _callee7, this, [
                        [
                            1,
                            13
                        ]
                    ]);
                }));
                function init(_x18, _x19, _x20) {
                    return _init.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: "initWithProvider",
            value: function() {
                var _initWithProvider = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee8(baseClientOptions, identifiers, customAttributes) {
                    var fromValuesClientOptions, experimentValues, customAttributesFromResult, clientSdkKeyPromise, experimentValuesPromise, _yield$Promise$all3, _yield$Promise$all4, experimentValuesResult;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee8$(_context8) {
                        while(true)switch(_context8.prev = _context8.next){
                            case 0:
                                fromValuesClientOptions = $aac86db54f6afcba$var$_objectSpread($aac86db54f6afcba$var$_objectSpread({}, baseClientOptions), {}, {
                                    disableCurrentPageLogging: true
                                });
                                _context8.prev = 1;
                                _context8.next = 4;
                                return FeatureGates.provider.setProfile(baseClientOptions, identifiers, customAttributes);
                            case 4:
                                // If client sdk key fetch fails, an error would be thrown and handled instead of waiting for the experiment
                                // values request to be settled, and it will fall back to use default values.
                                clientSdkKeyPromise = FeatureGates.provider.getClientSdkKey().then(function(value) {
                                    return fromValuesClientOptions.sdkKey = value;
                                });
                                experimentValuesPromise = FeatureGates.provider.getExperimentValues(); // Only wait for the experiment values request to finish and try to initialise the client with experiment
                                // values if both requests are successful. Else an error would be thrown and handled by the catch
                                _context8.next = 8;
                                return Promise.all([
                                    clientSdkKeyPromise,
                                    experimentValuesPromise
                                ]);
                            case 8:
                                _yield$Promise$all3 = _context8.sent;
                                _yield$Promise$all4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_yield$Promise$all3, 2);
                                experimentValuesResult = _yield$Promise$all4[1];
                                experimentValues = experimentValuesResult.experimentValues;
                                customAttributesFromResult = experimentValuesResult.customAttributesFromFetch;
                                _context8.next = 22;
                                break;
                            case 15:
                                _context8.prev = 15;
                                _context8.t0 = _context8["catch"](1);
                                if (_context8.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to fetch the Feature Gates client values, error: ".concat(_context8.t0 === null || _context8.t0 === void 0 ? void 0 : _context8.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client without values");
                                _context8.next = 21;
                                return FeatureGates.initFromValues(fromValuesClientOptions, identifiers, customAttributes);
                            case 21:
                                throw _context8.t0;
                            case 22:
                                _context8.next = 24;
                                return this.initFromValues(fromValuesClientOptions, identifiers, customAttributesFromResult, experimentValues);
                            case 24:
                            case "end":
                                return _context8.stop();
                        }
                    }, _callee8, this, [
                        [
                            1,
                            15
                        ]
                    ]);
                }));
                function initWithProvider(_x21, _x22, _x23) {
                    return _initWithProvider.apply(this, arguments);
                }
                return initWithProvider;
            }()
        },
        {
            key: "initFromValues",
            value: function() {
                var _initFromValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee9(clientOptions, identifiers, customAttributes) {
                    var initializeValues, user, sdkKey, statsigOptions, _args9 = arguments;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee9$(_context9) {
                        while(true)switch(_context9.prev = _context9.next){
                            case 0:
                                initializeValues = _args9.length > 3 && _args9[3] !== undefined ? _args9[3] : {};
                                user = this.toStatsigUser(identifiers, customAttributes);
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                if (!clientOptions.sdkKey) clientOptions.sdkKey = $aac86db54f6afcba$var$DEFAULT_CLIENT_KEY;
                                if (!clientOptions.eventLoggingApi) clientOptions.eventLoggingApi = $aac86db54f6afcba$var$DEFAULT_EVENT_LOGGING_API;
                                if (clientOptions.perimeter === (0, $51qEW.PerimeterType).FEDRAMP_MODERATE) // disable all logging in FedRAMP to prevent egress of sensitive data
                                clientOptions.disableAllLogging = true;
                                sdkKey = clientOptions.sdkKey;
                                statsigOptions = this.toStatsigOptions(clientOptions, initializeValues);
                                _context9.prev = 9;
                                _context9.next = 12;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).initialize(sdkKey, user, statsigOptions);
                            case 12:
                                _context9.next = 22;
                                break;
                            case 14:
                                _context9.prev = 14;
                                _context9.t0 = _context9["catch"](9);
                                if (_context9.t0 instanceof Error) // eslint-disable-next-line no-console
                                console.error("Error occurred when trying to initialise the Statsig client, error: ".concat(_context9.t0 === null || _context9.t0 === void 0 ? void 0 : _context9.t0.message));
                                // eslint-disable-next-line no-console
                                console.warn("Initialising Statsig client with default sdk key and without values");
                                _context9.next = 20;
                                return (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).initialize($aac86db54f6afcba$var$DEFAULT_CLIENT_KEY, user, $aac86db54f6afcba$var$_objectSpread($aac86db54f6afcba$var$_objectSpread({}, statsigOptions), {}, {
                                    initializeValues: {}
                                }));
                            case 20:
                                FeatureGates.initWithDefaults = true;
                                throw _context9.t0;
                            case 22:
                            case "end":
                                return _context9.stop();
                        }
                    }, _callee9, this, [
                        [
                            9,
                            14
                        ]
                    ]);
                }));
                function initFromValues(_x24, _x25, _x26) {
                    return _initFromValues.apply(this, arguments);
                }
                return initFromValues;
            }()
        },
        {
            key: "toStatsigUser",
            value: function toStatsigUser(identifiers, customAttributes) {
                var user = {
                    customIDs: identifiers,
                    custom: customAttributes
                };
                if (identifiers.atlassianAccountId) user.userID = identifiers.atlassianAccountId;
                return user;
            }
        },
        {
            key: "updateUserUsingInitializeValuesProducer",
            value: function() {
                var _updateUserUsingInitializeValuesProducer = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee11(getInitializeValues, identifiers, customAttributes) {
                    var originalInitPromise, initializeValuesPromise, updateUserPromise;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee11$(_context11) {
                        while(true)switch(_context11.prev = _context11.next){
                            case 0:
                                if (FeatureGates.initPromise) {
                                    _context11.next = 2;
                                    break;
                                }
                                throw new Error("The FeatureGates client must be initialized before you can update the user.");
                            case 2:
                                if (!FeatureGates.isCurrentUser(identifiers, customAttributes)) {
                                    _context11.next = 4;
                                    break;
                                }
                                return _context11.abrupt("return", FeatureGates.initPromise);
                            case 4:
                                // Wait for the current initialize/update to finish
                                originalInitPromise = FeatureGates.initPromise;
                                _context11.prev = 5;
                                _context11.next = 8;
                                return FeatureGates.initPromise;
                            case 8:
                                _context11.next = 12;
                                break;
                            case 10:
                                _context11.prev = 10;
                                _context11.t0 = _context11["catch"](5);
                            case 12:
                                initializeValuesPromise = getInitializeValues();
                                updateUserPromise = FeatureGates.updateStatsigClientUser(initializeValuesPromise, identifiers, customAttributes); // We replace the init promise here since we are essentially re-initializing the client at this point.
                                // Any subsequent calls to await FeatureGates.initialize() or FeatureGates.updateUser() will now also await this user update.
                                FeatureGates.initPromise = updateUserPromise.catch(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee10() {
                                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee10$(_context10) {
                                        while(true)switch(_context10.prev = _context10.next){
                                            case 0:
                                                // If the update failed then it changed nothing, so revert back to the original promise.
                                                FeatureGates.initPromise = originalInitPromise;
                                                // Set the user profile again to revert back to the current user
                                                if (!FeatureGates.provider) {
                                                    _context10.next = 4;
                                                    break;
                                                }
                                                _context10.next = 4;
                                                return FeatureGates.provider.setProfile(FeatureGates.initOptions, FeatureGates.currentIdentifiers, FeatureGates.currentAttributes);
                                            case 4:
                                            case "end":
                                                return _context10.stop();
                                        }
                                    }, _callee10);
                                })));
                                return _context11.abrupt("return", updateUserPromise);
                            case 16:
                            case "end":
                                return _context11.stop();
                        }
                    }, _callee11, null, [
                        [
                            5,
                            10
                        ]
                    ]);
                }));
                function updateUserUsingInitializeValuesProducer(_x27, _x28, _x29) {
                    return _updateUserUsingInitializeValuesProducer.apply(this, arguments);
                }
                return updateUserUsingInitializeValuesProducer;
            }()
        },
        {
            key: "updateStatsigClientUser",
            value: function() {
                var _updateStatsigClientUser = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee12(initializeValuesPromise, identifiers, customAttributes) {
                    var initializeValues, user, _FeatureGates$initOpt2, _FeatureGates$initOpt3, errMsg, success;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee12$(_context12) {
                        while(true)switch(_context12.prev = _context12.next){
                            case 0:
                                _context12.prev = 0;
                                _context12.next = 3;
                                return initializeValuesPromise;
                            case 3:
                                initializeValues = _context12.sent;
                                user = FeatureGates.toStatsigUser(identifiers, initializeValues.customAttributesFromFetch);
                                _context12.next = 12;
                                break;
                            case 7:
                                _context12.prev = 7;
                                _context12.t0 = _context12["catch"](0);
                                // Make sure the updateUserCompletionCallback is called for any errors in our custom code.
                                // This is not necessary for the updateUserWithValues call, because the Statsig client will already invoke the callback itself.
                                errMsg = _context12.t0 instanceof Error ? _context12.t0.message : JSON.stringify(_context12.t0);
                                (_FeatureGates$initOpt2 = (_FeatureGates$initOpt3 = FeatureGates.initOptions).updateUserCompletionCallback) === null || _FeatureGates$initOpt2 === void 0 || _FeatureGates$initOpt2.call(_FeatureGates$initOpt3, false, errMsg);
                                throw _context12.t0;
                            case 12:
                                success = (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).updateUserWithValues(user, initializeValues.experimentValues);
                                if (!success) {
                                    _context12.next = 19;
                                    break;
                                }
                                FeatureGates.currentIdentifiers = identifiers;
                                FeatureGates.currentAttributes = customAttributes;
                                FeatureGates.subscriptions.anyUpdated();
                                _context12.next = 20;
                                break;
                            case 19:
                                throw new Error("Failed to update user. An unexpected error occured.");
                            case 20:
                            case "end":
                                return _context12.stop();
                        }
                    }, _callee12, null, [
                        [
                            0,
                            7
                        ]
                    ]);
                }));
                function updateStatsigClientUser(_x30, _x31, _x32) {
                    return _updateStatsigClientUser.apply(this, arguments);
                }
                return updateStatsigClientUser;
            }()
        },
        {
            key: "toStatsigOptions",
            value: function toStatsigOptions(options, initializeValues) {
                var sdkKey = options.sdkKey, updateUserCompletionCallback = options.updateUserCompletionCallback, perimeter = options.perimeter, restClientOptions = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(options, $aac86db54f6afcba$var$_excluded);
                return $aac86db54f6afcba$var$_objectSpread($aac86db54f6afcba$var$_objectSpread({}, restClientOptions), {}, {
                    initializeValues: initializeValues,
                    environment: {
                        tier: options.environment
                    },
                    disableCurrentPageLogging: true
                }, options.updateUserCompletionCallback && {
                    updateUserCompletionCallback: FeatureGates.toStatsigUpdateUserCompletionCallback(options.updateUserCompletionCallback)
                });
            }
        },
        {
            key: "toStatsigUpdateUserCompletionCallback",
            value: function toStatsigUpdateUserCompletionCallback(callback) {
                /**
       * The duration passed to the callback indicates how long the update took, but it is deceptive since it only times the
       * Statsig code and doesn't account for all of the extra custom work we do to obtain the bootstrap values.
       * As a result, we just suppress this parameter in our own callback rather than trying to keep it accurate.
       */ return function(_duration, success, message) {
                    callback(success, message);
                };
            }
        },
        {
            key: "shallowEquals",
            value: function shallowEquals(objectA, objectB) {
                if (!objectA && !objectB) return true;
                if (!objectA || !objectB) return false;
                var aEntries = Object.entries(objectA);
                var bEntries = Object.entries(objectB);
                if (aEntries.length !== bEntries.length) return false;
                var ascendingKeyOrder = function ascendingKeyOrder(_ref3, _ref4) {
                    var _ref5 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref3, 1), key1 = _ref5[0];
                    var _ref6 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref4, 1), key2 = _ref6[0];
                    return key1.localeCompare(key2);
                };
                aEntries.sort(ascendingKeyOrder);
                bEntries.sort(ascendingKeyOrder);
                for(var i = 0; i < aEntries.length; i++){
                    var _aEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(aEntries[i], 2), aValue = _aEntries$i[1];
                    var _bEntries$i = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(bEntries[i], 2), bValue = _bEntries$i[1];
                    if (aValue !== bValue) return false;
                }
                return true;
            }
        },
        {
            key: "getPackageVersion",
            value: function getPackageVersion() {
                return 0, $g1oWB.CLIENT_VERSION;
            }
        },
        {
            key: "getLayer",
            value: function getLayer(layerName) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                try {
                    var _options$fireLayerExp = options.fireLayerExposure, fireLayerExposure = _options$fireLayerExp === void 0 ? true : _options$fireLayerExp;
                    var evalMethod = fireLayerExposure ? (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).getLayer.bind((0, (/*@__PURE__*/$parcel$interopDefault($glkGR)))) : (0, (/*@__PURE__*/$parcel$interopDefault($glkGR))).getLayerWithExposureLoggingDisabled.bind((0, (/*@__PURE__*/$parcel$interopDefault($glkGR))));
                    return evalMethod(layerName);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            error: error
                        });
                        FeatureGates.hasGetLayerErrorOccurred = true;
                    }
                    // Return a default value
                    return (0, $glkGR.Layer)._create(layerName, {}, "", {
                        time: Date.now(),
                        reason: (0, $glkGR.EvaluationReason).Error
                    });
                }
            }
        },
        {
            key: "getLayerValue",
            value: function getLayerValue(layerName, parameterName, defaultValue) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var layer = FeatureGates.getLayer(layerName, options);
                try {
                    var typeGuard = options.typeGuard;
                    return layer.get(parameterName, defaultValue, typeGuard);
                } catch (error) {
                    // Log the first occurrence of the error
                    if (!FeatureGates.hasGetLayerValueErrorOccurred) {
                        // eslint-disable-next-line no-console
                        console.warn({
                            msg: "An error has occurred getting the layer value. Only the first occurrence of this error is logged.",
                            layerName: layerName,
                            defaultValue: defaultValue,
                            options: options,
                            error: error
                        });
                        FeatureGates.hasGetLayerValueErrorOccurred = true;
                    }
                    return defaultValue;
                }
            }
        },
        {
            key: "getOptionsWithDefaults",
            value: function getOptionsWithDefaults(options) {
                return $aac86db54f6afcba$var$_objectSpread({
                    perimeter: FeatureGates.getDefaultPerimeter()
                }, options);
            }
        },
        {
            key: "getDefaultPerimeter",
            value: function getDefaultPerimeter() {
                /**
       * If more federal PerimeterTypes are added in the future, this should be updated so
       * that isFedRamp() === true always returns the strictest perimeter.
       */ return (0, $1tAmr.isFedRamp)() ? (0, $51qEW.PerimeterType).FEDRAMP_MODERATE : (0, $51qEW.PerimeterType).COMMERCIAL;
            }
        }
    ]);
    return FeatureGates;
}();
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "initPromise", null);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "initCompleted", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "initWithDefaults", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "hasGetExperimentErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "hasGetExperimentValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "hasGetLayerErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "hasGetLayerValueErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "hasCheckGateErrorOccurred", false);
(0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))($aac86db54f6afcba$var$FeatureGates, "subscriptions", new (0, $1LBry.default)());
var $aac86db54f6afcba$var$boundFGJS = $aac86db54f6afcba$var$FeatureGates;
// This makes it possible to get a reference to the FeatureGates client at runtime.
// This is important for overriding values in Cypress tests, as there needs to be a
// way to get the exact instance for a window in order to mock some of its methods.
if (typeof window !== "undefined") {
    if (window.__FEATUREGATES_JS__ === undefined) window.__FEATUREGATES_JS__ = $aac86db54f6afcba$var$FeatureGates;
    else {
        var $aac86db54f6afcba$var$_boundFGJS, $aac86db54f6afcba$var$_boundFGJS$getPackage;
        $aac86db54f6afcba$var$boundFGJS = window.__FEATUREGATES_JS__;
        var $aac86db54f6afcba$var$boundVersion = (($aac86db54f6afcba$var$_boundFGJS = $aac86db54f6afcba$var$boundFGJS) === null || $aac86db54f6afcba$var$_boundFGJS === void 0 || ($aac86db54f6afcba$var$_boundFGJS$getPackage = $aac86db54f6afcba$var$_boundFGJS.getPackageVersion) === null || $aac86db54f6afcba$var$_boundFGJS$getPackage === void 0 ? void 0 : $aac86db54f6afcba$var$_boundFGJS$getPackage.call($aac86db54f6afcba$var$_boundFGJS)) || "4.10.0 or earlier";
        if ($aac86db54f6afcba$var$boundVersion !== (0, $g1oWB.CLIENT_VERSION)) {
            var $aac86db54f6afcba$var$message = "Multiple versions of FeatureGateClients found on the current page.\n      The currently bound version is ".concat($aac86db54f6afcba$var$boundVersion, " when module version ").concat((0, $g1oWB.CLIENT_VERSION), " was loading.");
            // eslint-disable-next-line no-console
            console.warn($aac86db54f6afcba$var$message);
        }
    }
}
var /**
 * @property {FeatureGates} FeatureGate default export
 */ $aac86db54f6afcba$export$2e2bcd8739ae039 = $aac86db54f6afcba$var$boundFGJS;

});
parcelRegister("glkGR", function(module, exports) {
"use strict";
var $be5ea829040eec96$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $be5ea829040eec96$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $be5ea829040eec96$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = module.exports.Layer = module.exports.DynamicConfig = void 0;

var $e4B2M = parcelRequire("e4B2M");

var $be5ea829040eec96$var$StatsigClient_1 = $be5ea829040eec96$var$__importDefault((parcelRequire("2WO2C")));

var $lpLpB = parcelRequire("lpLpB");

var $7DuT3 = parcelRequire("7DuT3");
Object.defineProperty(module.exports, "DynamicConfig", {
    enumerable: true,
    get: function() {
        return $be5ea829040eec96$var$__importDefault($7DuT3).default;
    }
});

var $kL03Z = parcelRequire("kL03Z");
Object.defineProperty(module.exports, "Layer", {
    enumerable: true,
    get: function() {
        return $be5ea829040eec96$var$__importDefault($kL03Z).default;
    }
});

var $lpLpB = parcelRequire("lpLpB");
Object.defineProperty(module.exports, "EvaluationReason", {
    enumerable: true,
    get: function() {
        return $lpLpB.EvaluationReason;
    }
});
var $be5ea829040eec96$var$Statsig = /** @class */ function() {
    function Statsig() {}
    Statsig.initialize = function(sdkKey, user, options) {
        var _a;
        return $be5ea829040eec96$var$__awaiter(this, void 0, void 0, function() {
            var inst;
            return $be5ea829040eec96$var$__generator(this, function(_b) {
                inst = (_a = Statsig.instance) !== null && _a !== void 0 ? _a : new $be5ea829040eec96$var$StatsigClient_1.default(sdkKey, user, options);
                if (!Statsig.instance) Statsig.instance = inst;
                return [
                    2 /*return*/ ,
                    inst.initializeAsync()
                ];
            });
        });
    };
    Statsig.setInitializeValues = function(initializeValues) {
        Statsig._getClientX().setInitializeValues(initializeValues);
    };
    // Gate
    Statsig.checkGate = function(gateName) {
        return Statsig._getClientX().checkGate(gateName);
    };
    Statsig.checkGateWithExposureLoggingDisabled = function(gateName) {
        return Statsig._getClientX().checkGateWithExposureLoggingDisabled(gateName);
    };
    Statsig.manuallyLogGateExposure = function(gateName) {
        Statsig._getClientX().logGateExposure(gateName);
    };
    // Config
    Statsig.getConfig = function(configName) {
        return Statsig._getClientX().getConfig(configName);
    };
    Statsig.getConfigWithExposureLoggingDisabled = function(configName) {
        return Statsig._getClientX().getConfigWithExposureLoggingDisabled(configName);
    };
    Statsig.manuallyLogConfigExposure = function(configName) {
        Statsig._getClientX().logConfigExposure(configName);
    };
    // Experiment
    Statsig.getExperiment = function(experimentName) {
        return Statsig._getClientX().getExperiment(experimentName);
    };
    Statsig.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return Statsig._getClientX().getExperimentWithExposureLoggingDisabled(experimentName);
    };
    Statsig.manuallyLogExperimentExposure = function(configName) {
        Statsig._getClientX().logExperimentExposure(configName);
    };
    // Layer
    Statsig.getLayer = function(layerName) {
        return Statsig._getClientX().getLayer(layerName);
    };
    Statsig.getLayerWithExposureLoggingDisabled = function(layerName) {
        return Statsig._getClientX().getLayerWithExposureLoggingDisabled(layerName);
    };
    Statsig.manuallyLogLayerParameterExposure = function(layerName, parameterName) {
        Statsig._getClientX().logLayerParameterExposure(layerName, parameterName);
    };
    Statsig.logEvent = function(eventName, value, metadata) {
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        return Statsig._getClientX().logEvent(eventName, value, metadata);
    };
    Statsig.updateUser = function(user) {
        return Statsig._getClientX().updateUser(user);
    };
    Statsig.updateUserWithValues = function(user, values) {
        return Statsig._getClientX().updateUserWithValues(user, values);
    };
    Statsig.shutdown = function() {
        Statsig._getClientX().shutdown();
        Statsig.instance = null;
    };
    Statsig.overrideGate = function(gate, result) {
        Statsig._getClientX().overrideGate(gate, result);
    };
    Statsig.overrideConfig = function(config, result) {
        Statsig._getClientX().overrideConfig(config, result);
    };
    Statsig.overrideLayer = function(layer, result) {
        Statsig._getClientX().overrideLayer(layer, result);
    };
    Statsig.setOverrides = function(overrides) {
        Statsig._getClientX().setOverrides(overrides);
    };
    Statsig.getOverrides = function() {
        return Statsig._getClientX().getOverrides();
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ Statsig.getStableID = function() {
        return Statsig._getClientX().getStableID();
    };
    /**
     *
     * @returns The reason and time associated with the evaluation for the current set
     * of gates and configs
     */ Statsig.getEvaluationDetails = function() {
        var _a, _b;
        return (_b = (_a = Statsig.instance) === null || _a === void 0 ? void 0 : _a.getEvaluationDetails()) !== null && _b !== void 0 ? _b : {
            reason: $lpLpB.EvaluationReason.Uninitialized,
            time: 0
        };
    };
    /**
     *
     * @returns true if initialize has already been called, false otherwise
     */ Statsig.initializeCalled = function() {
        return Statsig.instance != null && Statsig.instance.initializeCalled();
    };
    Statsig._getClientX = function() {
        if (!Statsig.instance) throw new $e4B2M.StatsigUninitializedError();
        return Statsig.instance;
    };
    Statsig.instance = null;
    return Statsig;
}();
module.exports.default = $be5ea829040eec96$var$Statsig;

});
parcelRegister("e4B2M", function(module, exports) {
"use strict";
var $a3ee2c8e960b90de$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSDKKeyMismatchError = module.exports.StatsigInvalidArgumentError = module.exports.StatsigUninitializedError = module.exports.StatsigErrorMessage = void 0;
var $a3ee2c8e960b90de$var$StatsigErrorMessage;
(function(StatsigErrorMessage) {
    StatsigErrorMessage["REQUIRE_ASYNC_INITIALIZE"] = "Call initialize() first.";
    StatsigErrorMessage["REQUIRE_SYNC_INITIALIZE"] = "Call and wait for initialize() to finish first.";
    StatsigErrorMessage["REQUIRE_INITIALIZE_FOR_LOG_EVENT"] = "Must initialize() before logging events.";
})($a3ee2c8e960b90de$var$StatsigErrorMessage = module.exports.StatsigErrorMessage || (module.exports.StatsigErrorMessage = {}));
var $a3ee2c8e960b90de$var$StatsigUninitializedError = /** @class */ function(_super) {
    $a3ee2c8e960b90de$var$__extends(StatsigUninitializedError, _super);
    function StatsigUninitializedError(message) {
        var _this = _super.call(this, message !== null && message !== void 0 ? message : $a3ee2c8e960b90de$var$StatsigErrorMessage.REQUIRE_SYNC_INITIALIZE) || this;
        Object.setPrototypeOf(_this, StatsigUninitializedError.prototype);
        return _this;
    }
    return StatsigUninitializedError;
}(Error);
module.exports.StatsigUninitializedError = $a3ee2c8e960b90de$var$StatsigUninitializedError;
var $a3ee2c8e960b90de$var$StatsigInvalidArgumentError = /** @class */ function(_super) {
    $a3ee2c8e960b90de$var$__extends(StatsigInvalidArgumentError, _super);
    function StatsigInvalidArgumentError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigInvalidArgumentError.prototype);
        return _this;
    }
    return StatsigInvalidArgumentError;
}(Error);
module.exports.StatsigInvalidArgumentError = $a3ee2c8e960b90de$var$StatsigInvalidArgumentError;
var $a3ee2c8e960b90de$var$StatsigSDKKeyMismatchError = /** @class */ function(_super) {
    $a3ee2c8e960b90de$var$__extends(StatsigSDKKeyMismatchError, _super);
    function StatsigSDKKeyMismatchError(message) {
        var _this = _super.call(this, message) || this;
        Object.setPrototypeOf(_this, StatsigSDKKeyMismatchError.prototype);
        return _this;
    }
    return StatsigSDKKeyMismatchError;
}(Error);
module.exports.StatsigSDKKeyMismatchError = $a3ee2c8e960b90de$var$StatsigSDKKeyMismatchError;

});

parcelRegister("2WO2C", function(module, exports) {
"use strict";
var $2257d0b03f126f5d$var$__assign = module.exports && module.exports.__assign || function() {
    $2257d0b03f126f5d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $2257d0b03f126f5d$var$__assign.apply(this, arguments);
};
var $2257d0b03f126f5d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2257d0b03f126f5d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2257d0b03f126f5d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2257d0b03f126f5d$var$__createBinding(result, mod, k);
    }
    $2257d0b03f126f5d$var$__setModuleDefault(result, mod);
    return result;
};
var $2257d0b03f126f5d$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $2257d0b03f126f5d$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $2257d0b03f126f5d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $2257d0b03f126f5d$var$DynamicConfig_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("7DuT3")));

var $2257d0b03f126f5d$var$ErrorBoundary_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("lGEgG")));

var $e4B2M = parcelRequire("e4B2M");

var $2257d0b03f126f5d$var$Layer_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("kL03Z")));

var $2257d0b03f126f5d$var$StatsigIdentity_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("5ByMV")));

var $2257d0b03f126f5d$var$StatsigLogger_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("hRhus")));

var $2257d0b03f126f5d$var$StatsigNetwork_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("ip3ji")));

var $2257d0b03f126f5d$var$StatsigSDKOptions_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("cKL8P")));

var $2257d0b03f126f5d$var$StatsigStore_1 = $2257d0b03f126f5d$var$__importStar((parcelRequire("lpLpB")));

var $5kBGP = parcelRequire("5kBGP");

var $2257d0b03f126f5d$var$StatsigLocalStorage_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("jdP7e")));

var $03ZVc = parcelRequire("03ZVc");

var $2257d0b03f126f5d$var$LogEvent_1 = $2257d0b03f126f5d$var$__importDefault((parcelRequire("dbyyI")));

var $4inhx = parcelRequire("4inhx");
var $2257d0b03f126f5d$var$StatsigClient = /** @class */ function() {
    function StatsigClient(sdkKey, user, options) {
        var _this = this;
        this._initCalled = false;
        this._pendingInitPromise = null;
        this._sdkKey = null;
        this._logLayerParameterExposureForLayer = function(layer, parameterName, isManualExposure) {
            if (isManualExposure === void 0) isManualExposure = false;
            var allocatedExperiment = "";
            var exposures = layer._undelegatedSecondaryExposures;
            var isExplicit = layer._explicitParameters.includes(parameterName);
            if (isExplicit) {
                allocatedExperiment = layer._allocatedExperimentName;
                exposures = layer._secondaryExposures;
            }
            _this._logger.logLayerExposure(_this._identity._user, layer._name, layer._ruleID, exposures, allocatedExperiment, parameterName, isExplicit, layer._evaluationDetails, isManualExposure, _this._store.getBootstrapMetadata());
        };
        if ((options === null || options === void 0 ? void 0 : options.localMode) !== true && (typeof sdkKey !== "string" || !sdkKey.startsWith("client-"))) throw new $e4B2M.StatsigInvalidArgumentError("Invalid key provided.  You must use a Client SDK Key from the Statsig console to initialize the sdk");
        this._sdkKey = sdkKey;
        this._startTime = (0, $03ZVc.now)();
        this._options = new $2257d0b03f126f5d$var$StatsigSDKOptions_1.default(options);
        this._errorBoundary = new $2257d0b03f126f5d$var$ErrorBoundary_1.default(sdkKey, this._options);
        this._ready = false;
        $2257d0b03f126f5d$var$StatsigLocalStorage_1.default.disabled = this._options.disableLocalStorage;
        this._overrides = (0, $4inhx.loadOverridesFromLocalStorage)();
        this._identity = new $2257d0b03f126f5d$var$StatsigIdentity_1.default(sdkKey, this._normalizeUser(user !== null && user !== void 0 ? user : null), this._options.overrideStableID);
        this._network = new $2257d0b03f126f5d$var$StatsigNetwork_1.default(this._options, this._identity, this._errorBoundary);
        this._logger = new $2257d0b03f126f5d$var$StatsigLogger_1.default(this._options, this._identity, this._network, this._errorBoundary);
        this._store = new $2257d0b03f126f5d$var$StatsigStore_1.default(this._identity, this._logger.logConfigDefaultValueFallback, this._options.initializeValues);
        this._errorBoundary._setStatsigMetadata(this._identity._statsigMetadata);
        if (this._options.initializeValues != null) {
            this._ready = true;
            this._initCalled = true;
            setTimeout(function() {
                return _this._delayedSetup();
            }, 20);
        }
    }
    StatsigClient.prototype.setInitializeValues = function(initializeValues) {
        var _this = this;
        this._errorBoundary._capture("setInitializeValues", function() {
            _this._store.bootstrap(initializeValues);
            if (!_this._ready) {
                // the sdk is usable and considered initialized when configured
                // with initializeValues
                _this._ready = true;
                _this._initCalled = true;
            }
            // we wont have access to window/document/localStorage if these run on the server
            // so try to run whenever this is called
            _this._logger.sendSavedRequests();
        }, function() {
            _this._ready = true;
            _this._initCalled = true;
        });
    };
    StatsigClient.prototype.initializeAsync = function() {
        return $2257d0b03f126f5d$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("initializeAsync", function() {
                        return $2257d0b03f126f5d$var$__awaiter(_this, void 0, void 0, function() {
                            var user;
                            var _this = this;
                            return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                                if (this._pendingInitPromise != null) return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                                if (this._ready) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                this._initCalled = true;
                                if (this._options.localMode) return [
                                    2 /*return*/ ,
                                    Promise.resolve()
                                ];
                                user = this._identity._user;
                                this._pendingInitPromise = this._fetchAndSaveValues(user, this._options.initTimeoutMs).then(function() {
                                    return;
                                }).catch(function(e) {
                                    _this._errorBoundary._logError("initializeAsync:fetchAndSaveValues", e);
                                    return {
                                        success: false,
                                        message: e.message
                                    };
                                }).then(function() {
                                    return;
                                }).finally(function() {
                                    return $2257d0b03f126f5d$var$__awaiter(_this, void 0, void 0, function() {
                                        return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                                            this._pendingInitPromise = null;
                                            this._ready = true;
                                            this._delayedSetup();
                                            return [
                                                2 /*return*/ 
                                            ];
                                        });
                                    });
                                });
                                return [
                                    2 /*return*/ ,
                                    this._pendingInitPromise
                                ];
                            });
                        });
                    }, function() {
                        _this._ready = true;
                        _this._initCalled = true;
                        return Promise.resolve();
                    })
                ];
            });
        });
    };
    StatsigClient.prototype.getEvaluationDetails = function() {
        var _this = this;
        return this._errorBoundary._capture("getEvaluationDetails", function() {
            return _this._store.getGlobalEvaluationDetails();
        }, function() {
            return {
                time: Date.now(),
                reason: $2257d0b03f126f5d$var$StatsigStore_1.EvaluationReason.Error
            };
        });
    };
    /**
     * Checks the value of a gate for the current user
     * @param {string} gateName - the name of the gate to check
     * @returns {boolean} - value of a gate for the user. Gates are "off" (return false) by default
     * @throws Error if initialize() is not called first, or gateName is not a string
     */ StatsigClient.prototype.checkGate = function(gateName) {
        return this._checkGateImpl(gateName, "checkGate");
    };
    StatsigClient.prototype.checkGateWithExposureLoggingDisabled = function(gateName) {
        return this._checkGateImpl(gateName, "checkGateWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logGateExposure = function(gateName) {
        var _this = this;
        this._errorBoundary._swallow("logGateExposure", function() {
            _this._logGateExposureImpl(gateName);
        });
    };
    /**
     * Checks the value of a config for the current user
     * @param {string} configName - the name of the config to get
     * @returns {DynamicConfig} - value of a config for the user
     * @throws Error if initialize() is not called first, or configName is not a string
     */ StatsigClient.prototype.getConfig = function(configName) {
        return this._getConfigImpl(configName, "getConfig");
    };
    StatsigClient.prototype.getConfigWithExposureLoggingDisabled = function(configName) {
        return this._getConfigImpl(configName, "getConfigWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logConfigExposure = function(configName) {
        var _this = this;
        this._errorBoundary._swallow("logConfigExposure", function() {
            _this._logConfigExposureImpl(configName);
        });
    };
    StatsigClient.prototype.getExperiment = function(experimentName) {
        return this.getConfig(experimentName);
    };
    StatsigClient.prototype.getExperimentWithExposureLoggingDisabled = function(experimentName) {
        return this.getConfigWithExposureLoggingDisabled(experimentName);
    };
    StatsigClient.prototype.logExperimentExposure = function(experimentName) {
        this.logConfigExposure(experimentName);
    };
    StatsigClient.prototype.getLayer = function(layerName) {
        return this._getLayerImpl(layerName, "getLayer");
    };
    StatsigClient.prototype.getLayerWithExposureLoggingDisabled = function(layerName) {
        return this._getLayerImpl(layerName, "getLayerWithExposureLoggingDisabled");
    };
    StatsigClient.prototype.logLayerParameterExposure = function(layerName, parameterName) {
        var _this = this;
        this._errorBoundary._swallow("logLayerParameterExposure", function() {
            var layer = _this._getLayerFromStore(null, layerName);
            _this._logLayerParameterExposureForLayer(layer, parameterName, true);
        });
    };
    StatsigClient.prototype.logEvent = function(eventName, value, metadata) {
        var _this = this;
        if (value === void 0) value = null;
        if (metadata === void 0) metadata = null;
        this._errorBoundary._swallow("logEvent", function() {
            if (!_this._logger || !_this._identity._sdkKey) throw new $e4B2M.StatsigUninitializedError($e4B2M.StatsigErrorMessage.REQUIRE_INITIALIZE_FOR_LOG_EVENT);
            if (typeof eventName !== "string" || eventName.length === 0) return;
            var event = (0, $2257d0b03f126f5d$var$LogEvent_1.default)(eventName, _this._identity._user, _this._identity._statsigMetadata, value, metadata);
            _this._logger.log(event);
        });
    };
    StatsigClient.prototype.updateUserWithValues = function(user, values) {
        var _this = this;
        var updateStartTime = Date.now();
        var fireCompletionCallback;
        return this._errorBoundary._capture("updateUserWithValues", function() {
            if (!_this.initializeCalled()) throw new $e4B2M.StatsigUninitializedError($e4B2M.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
            fireCompletionCallback = function(success, error) {
                var cb = _this._options.updateUserCompletionCallback;
                cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
            };
            _this._identity._user = _this._normalizeUser(user);
            _this._store.bootstrap(values);
            _this._logger.resetDedupeKeys();
            fireCompletionCallback(true, null);
            return true;
        }, function() {
            fireCompletionCallback === null || fireCompletionCallback === void 0 || fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
            return false;
        });
    };
    StatsigClient.prototype.updateUser = function(user) {
        return $2257d0b03f126f5d$var$__awaiter(this, void 0, void 0, function() {
            var updateStartTime, fireCompletionCallback;
            var _this = this;
            return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                updateStartTime = Date.now();
                return [
                    2 /*return*/ ,
                    this._errorBoundary._capture("updateUser", function() {
                        return $2257d0b03f126f5d$var$__awaiter(_this, void 0, void 0, function() {
                            var currentUser;
                            var _this = this;
                            return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!this.initializeCalled()) throw new $e4B2M.StatsigUninitializedError($e4B2M.StatsigErrorMessage.REQUIRE_ASYNC_INITIALIZE);
                                        fireCompletionCallback = function(success, error) {
                                            var cb = _this._options.updateUserCompletionCallback;
                                            cb === null || cb === void 0 || cb(Date.now() - updateStartTime, success, error);
                                        };
                                        this._identity._user = this._normalizeUser(user);
                                        this._store.updateUser();
                                        this._logger.resetDedupeKeys();
                                        if (!(this._pendingInitPromise != null)) return [
                                            3 /*break*/ ,
                                            2
                                        ];
                                        return [
                                            4 /*yield*/ ,
                                            this._pendingInitPromise
                                        ];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2:
                                        if (this._options.localMode) {
                                            fireCompletionCallback(true, null);
                                            return [
                                                2 /*return*/ ,
                                                Promise.resolve(true)
                                            ];
                                        }
                                        currentUser = this._identity._user;
                                        this._pendingInitPromise = this._fetchAndSaveValues(currentUser).finally(function() {
                                            _this._pendingInitPromise = null;
                                        });
                                        return [
                                            2 /*return*/ ,
                                            this._pendingInitPromise.then(function() {
                                                fireCompletionCallback(true, null);
                                                return Promise.resolve(true);
                                            }).catch(function(error) {
                                                fireCompletionCallback(false, "Failed to update user: ".concat(error));
                                                return Promise.resolve(false);
                                            })
                                        ];
                                }
                            });
                        });
                    }, function() {
                        fireCompletionCallback(false, "Failed to update user. An unexpected error occured.");
                        return Promise.resolve(false);
                    })
                ];
            });
        });
    };
    /**
     * Informs the statsig SDK that the client is closing or shutting down
     * so the SDK can clean up internal state
     */ StatsigClient.prototype.shutdown = function() {
        var _this = this;
        this._errorBoundary._swallow("shutdown", function() {
            _this._logger.shutdown();
        });
    };
    /**
     * @returns The Statsig stable ID used for device level experiments
     */ StatsigClient.prototype.getStableID = function() {
        var _this = this;
        return this._errorBoundary._capture("getStableID", function() {
            return _this._identity._statsigMetadata.stableID;
        }, function() {
            return "";
        });
    };
    StatsigClient.prototype.initializeCalled = function() {
        return this._initCalled;
    };
    StatsigClient.prototype.overrideGate = function(gate, result) {
        this._setOverride("gates", gate, result);
    };
    StatsigClient.prototype.overrideConfig = function(config, result) {
        this._setOverride("configs", config, result);
    };
    StatsigClient.prototype.overrideLayer = function(layer, result) {
        this._setOverride("layers", layer, result);
    };
    StatsigClient.prototype.setOverrides = function(overrides) {
        var _this = this;
        this._errorBoundary._swallow("setOverrides", function() {
            _this._overrides = overrides !== null && overrides !== void 0 ? overrides : (0, $4inhx.makeEmptyOverrides)();
            (0, $4inhx.saveOverridesToLocalStorage)(_this._overrides);
        });
    };
    StatsigClient.prototype.getOverrides = function() {
        var _this = this;
        return this._errorBoundary._capture("getOverrides", function() {
            return _this._overrides;
        }, function() {
            return (0, $4inhx.makeEmptyOverrides)();
        });
    };
    // Private
    StatsigClient.prototype._delayedSetup = function() {
        var _this = this;
        this._errorBoundary._swallow("delayedSetup", function() {
            _this._identity.saveStableID();
            _this._logger.sendSavedRequests().then(function() {
            /* noop */ });
        });
    };
    StatsigClient.prototype._normalizeUser = function(user) {
        var userCopy = {};
        try {
            userCopy = JSON.parse(JSON.stringify(user));
        } catch (error) {
            throw new $e4B2M.StatsigInvalidArgumentError("User object must be convertable to JSON string.");
        }
        if (this._options.environment != null) userCopy = $2257d0b03f126f5d$var$__assign($2257d0b03f126f5d$var$__assign({}, userCopy), {
            statsigEnvironment: this._options.environment
        });
        return userCopy;
    };
    StatsigClient.prototype._ensureStoreLoaded = function() {
        if (!this._store.isLoaded()) throw new $e4B2M.StatsigUninitializedError();
    };
    StatsigClient.prototype._getEvaluationDetailsForError = function() {
        return {
            time: Date.now(),
            reason: $2257d0b03f126f5d$var$StatsigStore_1.EvaluationReason.Error
        };
    };
    StatsigClient.prototype._fetchAndSaveValues = function(user, timeout) {
        if (timeout === void 0) timeout = this._options.initTimeoutMs;
        return $2257d0b03f126f5d$var$__awaiter(this, void 0, void 0, function() {
            var sinceTime, previousDerivedFields;
            var _this = this;
            return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                sinceTime = null;
                sinceTime = this._store.getLastUpdateTime(user);
                previousDerivedFields = this._store.getPreviousDerivedFields(user);
                return [
                    2 /*return*/ ,
                    this._network.fetchValues(user, sinceTime, timeout, previousDerivedFields).eventually(function(json) {
                        var _a;
                        if (!(0, $5kBGP.verifySDKKeyUsed)(json, (_a = _this._sdkKey) !== null && _a !== void 0 ? _a : "", _this._errorBoundary)) return;
                        if (json === null || json === void 0 ? void 0 : json.has_updates) _this._store.save(user, json, false);
                    }).then(function(json) {
                        return $2257d0b03f126f5d$var$__awaiter(_this, void 0, void 0, function() {
                            var _this = this;
                            return $2257d0b03f126f5d$var$__generator(this, function(_a) {
                                return [
                                    2 /*return*/ ,
                                    this._errorBoundary._swallow("fetchAndSaveValues", function() {
                                        return $2257d0b03f126f5d$var$__awaiter(_this, void 0, void 0, function() {
                                            var _a;
                                            return $2257d0b03f126f5d$var$__generator(this, function(_b) {
                                                switch(_b.label){
                                                    case 0:
                                                        if (!(0, $5kBGP.verifySDKKeyUsed)(json, (_a = this._sdkKey) !== null && _a !== void 0 ? _a : "", this._errorBoundary)) return [
                                                            2 /*return*/ 
                                                        ];
                                                        if (!(json === null || json === void 0 ? void 0 : json.has_updates)) return [
                                                            3 /*break*/ ,
                                                            2
                                                        ];
                                                        return [
                                                            4 /*yield*/ ,
                                                            this._store.save(user, json)
                                                        ];
                                                    case 1:
                                                        _b.sent();
                                                        return [
                                                            3 /*break*/ ,
                                                            3
                                                        ];
                                                    case 2:
                                                        if (json === null || json === void 0 ? void 0 : json.is_no_content) this._store.setEvaluationReason($2257d0b03f126f5d$var$StatsigStore_1.EvaluationReason.NetworkNotModified);
                                                        _b.label = 3;
                                                    case 3:
                                                        return [
                                                            2 /*return*/ 
                                                        ];
                                                }
                                            });
                                        });
                                    })
                                ];
                            });
                        });
                    })
                ];
            });
        });
    };
    StatsigClient.prototype._checkGateImpl = function(gateName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (typeof _this._overrides.gates[gateName] === "boolean") return _this._overrides.gates[gateName];
            var result = _this._getGateFromStore(gateName);
            if (callsite === "checkGate") _this._logGateExposureImpl(gateName, result);
            return result.gate.value === true;
        }, function() {
            return false;
        });
    };
    StatsigClient.prototype._getGateFromStore = function(gateName) {
        this._ensureStoreLoaded();
        if (typeof gateName !== "string" || gateName.length === 0) throw new $e4B2M.StatsigInvalidArgumentError("Must pass a valid string as the gateName.");
        return this._store.checkGate(gateName);
    };
    StatsigClient.prototype._logGateExposureImpl = function(gateName, fetchResult) {
        var _a;
        var isManualExposure = !fetchResult;
        var result = fetchResult !== null && fetchResult !== void 0 ? fetchResult : this._getGateFromStore(gateName);
        var gate = result.gate;
        this._logger.logGateExposure(this._identity._user, gateName, gate.value, gate.rule_id, this._store.mapExposures((_a = gate.secondary_exposures) !== null && _a !== void 0 ? _a : []), result.evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getConfigImpl = function(configName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.configs[configName]) return new $2257d0b03f126f5d$var$DynamicConfig_1.default(configName, _this._overrides.configs[configName], "local_override", {
                reason: $2257d0b03f126f5d$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var result = _this._getConfigFromStore(configName);
            if (callsite === "getConfig") _this._logConfigExposureImpl(configName, result);
            return result;
        }, function() {
            return _this._getEmptyConfig(configName);
        });
    };
    StatsigClient.prototype._getConfigFromStore = function(configName) {
        this._ensureStoreLoaded();
        if (typeof configName !== "string" || configName.length === 0) throw new $e4B2M.StatsigInvalidArgumentError("Must pass a valid string as the configName.");
        return this._store.getConfig(configName);
    };
    StatsigClient.prototype._logConfigExposureImpl = function(configName, config) {
        var isManualExposure = !config;
        var localConfig = config !== null && config !== void 0 ? config : this._getConfigFromStore(configName);
        this._logger.logConfigExposure(this._identity._user, configName, localConfig._ruleID, localConfig._secondaryExposures, localConfig._evaluationDetails, isManualExposure, this._store.getBootstrapMetadata());
    };
    StatsigClient.prototype._getLayerImpl = function(layerName, callsite) {
        var _this = this;
        return this._errorBoundary._capture(callsite, function() {
            if (_this._overrides.layers[layerName]) return $2257d0b03f126f5d$var$Layer_1.default._create(layerName, _this._overrides.layers[layerName], "local_override", {
                reason: $2257d0b03f126f5d$var$StatsigStore_1.EvaluationReason.LocalOverride,
                time: Date.now()
            });
            var logFunc = callsite === "getLayer" ? _this._logLayerParameterExposureForLayer : null;
            return _this._getLayerFromStore(logFunc, layerName);
        }, function() {
            return $2257d0b03f126f5d$var$Layer_1.default._create(layerName, {}, "", _this._getEvaluationDetailsForError());
        });
    };
    StatsigClient.prototype._getLayerFromStore = function(logParameterFunction, layerName) {
        this._ensureStoreLoaded();
        if (typeof layerName !== "string" || layerName.length === 0) throw new $e4B2M.StatsigInvalidArgumentError("Must pass a valid string as the layerName.");
        return this._store.getLayer(logParameterFunction, layerName);
    };
    StatsigClient.prototype._getEmptyConfig = function(configName) {
        return new $2257d0b03f126f5d$var$DynamicConfig_1.default(configName, {}, "", this._getEvaluationDetailsForError());
    };
    StatsigClient.prototype._setOverride = function(type, key, result) {
        if (result == null) delete this._overrides[type][key];
        else this._overrides[type][key] = result;
        this.setOverrides(this._overrides);
    };
    return StatsigClient;
}();
module.exports.default = $2257d0b03f126f5d$var$StatsigClient;

});
parcelRegister("7DuT3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $58f42271ddfd170e$var$DynamicConfig = /** @class */ function() {
    function DynamicConfig(configName, configValue, ruleID, evaluationDetails, secondaryExposures, allocatedExperimentName, onDefaultValueFallback) {
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (onDefaultValueFallback === void 0) onDefaultValueFallback = null;
        this._onDefaultValueFallback = null;
        this.value = JSON.parse(JSON.stringify(configValue !== null && configValue !== void 0 ? configValue : {}));
        this._name = configName;
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._secondaryExposures = secondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._evaluationDetails = evaluationDetails;
        this._onDefaultValueFallback = onDefaultValueFallback;
    }
    DynamicConfig.prototype.get = function(key, defaultValue, typeGuard) {
        var _a, _b;
        var val = this.getValue(key, defaultValue);
        if (val == null) return defaultValue;
        var expectedType = Array.isArray(defaultValue) ? "array" : typeof defaultValue;
        var actualType = Array.isArray(val) ? "array" : typeof val;
        if (typeGuard) {
            if (typeGuard(val)) return val;
            (_a = this._onDefaultValueFallback) === null || _a === void 0 || _a.call(this, this, key, expectedType, actualType);
            return defaultValue;
        }
        if (defaultValue == null || expectedType === actualType) return val;
        (_b = this._onDefaultValueFallback) === null || _b === void 0 || _b.call(this, this, key, expectedType, actualType);
        return defaultValue;
    };
    DynamicConfig.prototype.getValue = function(key, defaultValue) {
        if (key == null) return this.value;
        if (defaultValue == null) defaultValue = null;
        if (this.value[key] == null) return defaultValue;
        return this.value[key];
    };
    return DynamicConfig;
}();
module.exports.default = $58f42271ddfd170e$var$DynamicConfig;

});

parcelRegister("lGEgG", function(module, exports) {
"use strict";
var $fc9cc19fe359b050$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $fc9cc19fe359b050$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExceptionEndpoint = void 0;

var $e4B2M = parcelRequire("e4B2M");
module.exports.ExceptionEndpoint = "https://statsigapi.net/v1/sdk_exception";
var $fc9cc19fe359b050$var$ErrorBoundary = /** @class */ function() {
    function ErrorBoundary(sdkKey, options) {
        this._seen = new Set();
        this._sdkKey = sdkKey;
        this._options = options;
    }
    ErrorBoundary.prototype._setStatsigMetadata = function(statsigMetadata) {
        this._statsigMetadata = statsigMetadata;
    };
    ErrorBoundary.prototype._swallow = function(tag, task) {
        this._capture(tag, task, function() {
            return undefined;
        });
    };
    ErrorBoundary.prototype._capture = function(tag, task, recover, getExtraData) {
        var _this = this;
        try {
            var result = task();
            if (result instanceof Promise) return result.catch(function(e) {
                return _this._onCaught(tag, e, recover, getExtraData);
            });
            return result;
        } catch (error) {
            return this._onCaught(tag, error, recover, getExtraData);
        }
    };
    ErrorBoundary.prototype._logError = function(tag, error, getExtraData) {
        var _this = this;
        if (this._options.disableAllLogging) return;
        try {
            var impl = function() {
                return $fc9cc19fe359b050$var$__awaiter(_this, void 0, void 0, function() {
                    var extra, _a, unwrapped, isError, name, info, metadata, body;
                    var _b;
                    return $fc9cc19fe359b050$var$__generator(this, function(_c) {
                        switch(_c.label){
                            case 0:
                                if (!(typeof getExtraData === "function")) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    getExtraData()
                                ];
                            case 1:
                                _a = _c.sent();
                                return [
                                    3 /*break*/ ,
                                    3
                                ];
                            case 2:
                                _a = null;
                                _c.label = 3;
                            case 3:
                                extra = _a;
                                unwrapped = error !== null && error !== void 0 ? error : Error("[Statsig] Error was empty");
                                isError = unwrapped instanceof Error;
                                name = isError ? unwrapped.name : "No Name";
                                if (this._seen.has(name)) return [
                                    2 /*return*/ 
                                ];
                                this._seen.add(name);
                                info = isError ? unwrapped.stack : this._getDescription(unwrapped);
                                metadata = (_b = this._statsigMetadata) !== null && _b !== void 0 ? _b : {};
                                body = JSON.stringify({
                                    tag: tag,
                                    exception: name,
                                    info: info,
                                    statsigMetadata: metadata,
                                    extra: extra !== null && extra !== void 0 ? extra : {}
                                });
                                return [
                                    2 /*return*/ ,
                                    fetch(module.exports.ExceptionEndpoint, {
                                        method: "POST",
                                        headers: {
                                            "STATSIG-API-KEY": this._sdkKey,
                                            "STATSIG-SDK-TYPE": String(metadata["sdkType"]),
                                            "STATSIG-SDK-VERSION": String(metadata["sdkVersion"]),
                                            "Content-Type": "application/json",
                                            "Content-Length": "".concat(body.length)
                                        },
                                        body: body
                                    })
                                ];
                        }
                    });
                });
            };
            impl().then(function() {
            /* noop */ }).catch(function() {
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    };
    ErrorBoundary.prototype._onCaught = function(tag, error, recover, getExtraData) {
        if (error instanceof $e4B2M.StatsigUninitializedError || error instanceof $e4B2M.StatsigInvalidArgumentError) throw error; // Don't catch these
        console.error("[Statsig] An unexpected exception occurred.", error);
        this._logError(tag, error, getExtraData);
        return recover();
    };
    ErrorBoundary.prototype._getDescription = function(obj) {
        try {
            return JSON.stringify(obj);
        } catch (_a) {
            return "[Statsig] Failed to get string for error.";
        }
    };
    return ErrorBoundary;
}();
module.exports.default = $fc9cc19fe359b050$var$ErrorBoundary;

});

parcelRegister("kL03Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f1c83f026916a918$var$Layer = /** @class */ function() {
    function Layer(name, layerValue, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        this._logParameterFunction = logParameterFunction;
        this._name = name;
        this._value = JSON.parse(JSON.stringify(layerValue !== null && layerValue !== void 0 ? layerValue : {}));
        this._ruleID = ruleID !== null && ruleID !== void 0 ? ruleID : "";
        this._evaluationDetails = evaluationDetails;
        this._secondaryExposures = secondaryExposures;
        this._undelegatedSecondaryExposures = undelegatedSecondaryExposures;
        this._allocatedExperimentName = allocatedExperimentName;
        this._explicitParameters = explicitParameters;
    }
    Layer._create = function(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters) {
        if (logParameterFunction === void 0) logParameterFunction = null;
        if (secondaryExposures === void 0) secondaryExposures = [];
        if (undelegatedSecondaryExposures === void 0) undelegatedSecondaryExposures = [];
        if (allocatedExperimentName === void 0) allocatedExperimentName = "";
        if (explicitParameters === void 0) explicitParameters = [];
        return new Layer(name, value, ruleID, evaluationDetails, logParameterFunction, secondaryExposures, undelegatedSecondaryExposures, allocatedExperimentName, explicitParameters);
    };
    Layer.prototype.get = function(key, defaultValue, typeGuard) {
        var _this = this;
        var val = this._value[key];
        if (val == null) return defaultValue;
        var logAndReturn = function() {
            _this._logLayerParameterExposure(key);
            return val;
        };
        if (typeGuard) return typeGuard(val) ? logAndReturn() : defaultValue;
        if (defaultValue == null) return logAndReturn();
        if (typeof val === typeof defaultValue && Array.isArray(defaultValue) === Array.isArray(val)) return logAndReturn();
        return defaultValue;
    };
    Layer.prototype.getValue = function(key, defaultValue) {
        if (defaultValue == undefined) defaultValue = null;
        var val = this._value[key];
        if (val != null) this._logLayerParameterExposure(key);
        return val !== null && val !== void 0 ? val : defaultValue;
    };
    Layer.prototype._logLayerParameterExposure = function(parameterName) {
        var _a;
        (_a = this._logParameterFunction) === null || _a === void 0 || _a.call(this, this, parameterName);
    };
    return Layer;
}();
module.exports.default = $f1c83f026916a918$var$Layer;

});

parcelRegister("5ByMV", function(module, exports) {
"use strict";
var $414b64a407b0856c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $eLumd = parcelRequire("eLumd");

var $6Bvad = parcelRequire("6Bvad");

var $414b64a407b0856c$var$StatsigLocalStorage_1 = $414b64a407b0856c$var$__importDefault((parcelRequire("jdP7e")));

var $89awa = parcelRequire("89awa");
var $414b64a407b0856c$var$Identity = /** @class */ function() {
    function Identity(sdkKey, user, overrideStableID) {
        var _a;
        this._sdkType = "js-lite";
        this._sdkKey = sdkKey;
        this._user = user;
        this._sdkVersion = $89awa.version;
        var stableID = overrideStableID;
        stableID = (_a = stableID !== null && stableID !== void 0 ? stableID : $414b64a407b0856c$var$StatsigLocalStorage_1.default.getItem($eLumd.STATSIG_STABLE_ID_KEY)) !== null && _a !== void 0 ? _a : this._getUUID();
        this._statsigMetadata = {
            stableID: stableID,
            sdkType: this._sdkType,
            sdkVersion: this._sdkVersion
        };
    }
    Identity.prototype.saveStableID = function() {
        if (this._statsigMetadata.stableID != null) $414b64a407b0856c$var$StatsigLocalStorage_1.default.setItem($eLumd.STATSIG_STABLE_ID_KEY, this._statsigMetadata.stableID);
    };
    Identity.prototype.getUserCacheKey = function() {
        return (0, $6Bvad.getUserCacheKey)(this._user);
    };
    Identity.prototype._getUUID = function() {
        var uuid = "";
        for(var i = 0; i < 32; i++){
            if (i === 8 || i === 12 || i === 16 || i === 20) uuid += "-";
            var randomDigit = Math.random() * 16 | 0;
            if (i === 12) uuid += "4";
            else if (i === 16) uuid += (randomDigit & 3 | 8).toString(16);
            else uuid += randomDigit.toString(16);
        }
        return uuid;
    };
    return Identity;
}();
module.exports.default = $414b64a407b0856c$var$Identity;

});
parcelRegister("eLumd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LOCAL_STORAGE_KEYS = module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = module.exports.STATSIG_STABLE_ID_KEY = module.exports.INTERNAL_STORE_KEY = void 0;
module.exports.INTERNAL_STORE_KEY = "STATSIG_STORE";
module.exports.STATSIG_STABLE_ID_KEY = "STATSIG_STABLE_ID";
module.exports.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY = "STATSIG_LOGS";
module.exports.LOCAL_STORAGE_KEYS = {
    INTERNAL_STORE_KEY: true,
    STATSIG_STABLE_ID_KEY: true,
    STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY: true
};

});

parcelRegister("6Bvad", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUserCacheKey = module.exports.getSortedObject = module.exports.djb2HashForObject = module.exports.getHashValue = module.exports.SimpleHash = void 0;
function $4cee5f43ef29fcac$var$SimpleHash(value) {
    var hash = 0;
    for(var i = 0; i < value.length; i++){
        var character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
}
module.exports.SimpleHash = $4cee5f43ef29fcac$var$SimpleHash;
function $4cee5f43ef29fcac$var$getHashValue(value, hash_used) {
    if (hash_used === "none") return value;
    return $4cee5f43ef29fcac$var$SimpleHash(value);
}
module.exports.getHashValue = $4cee5f43ef29fcac$var$getHashValue;
function $4cee5f43ef29fcac$var$djb2HashForObject(object) {
    return $4cee5f43ef29fcac$var$SimpleHash(JSON.stringify($4cee5f43ef29fcac$var$getSortedObject(object)));
}
module.exports.djb2HashForObject = $4cee5f43ef29fcac$var$djb2HashForObject;
function $4cee5f43ef29fcac$var$getSortedObject(object) {
    if (object == null) return null;
    var keys = Object.keys(object).sort();
    var sortedObject = {};
    keys.forEach(function(key) {
        var value = object[key];
        if (value instanceof Object) value = $4cee5f43ef29fcac$var$getSortedObject(value);
        sortedObject[key] = value;
    });
    return sortedObject;
}
module.exports.getSortedObject = $4cee5f43ef29fcac$var$getSortedObject;
function $4cee5f43ef29fcac$var$getUserCacheKey(user) {
    var _a;
    var key = "userID:".concat(String((_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ""));
    var customIDs = user === null || user === void 0 ? void 0 : user.customIDs;
    if (customIDs != null) for(var _i = 0, _b = Object.entries(customIDs); _i < _b.length; _i++){
        var _c = _b[_i], type = _c[0], value = _c[1];
        key += ";".concat(type, ":").concat(value);
    }
    return $4cee5f43ef29fcac$var$SimpleHash(key);
}
module.exports.getUserCacheKey = $4cee5f43ef29fcac$var$getUserCacheKey;

});

parcelRegister("jdP7e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dfe6e1baeb70cc85$var$StatsigLocalStorage = /** @class */ function() {
    function StatsigLocalStorage() {}
    StatsigLocalStorage.getItem = function(key) {
        var _a;
        try {
            if (this.isStorageAccessible()) return window.localStorage.getItem(key);
        } catch (e) {}
        return (_a = this.fallbackSessionCache[key]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigLocalStorage.setItem = function(key, value) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.setItem(key, value);
                return;
            }
        } catch (e) {}
        this.fallbackSessionCache[key] = value;
    };
    StatsigLocalStorage.removeItem = function(key) {
        try {
            if (this.isStorageAccessible()) {
                window.localStorage.removeItem(key);
                return;
            }
        } catch (e) {}
        delete this.fallbackSessionCache[key];
    };
    StatsigLocalStorage.isStorageAccessible = function(ignoreDisabledOption) {
        if (ignoreDisabledOption === void 0) ignoreDisabledOption = false;
        if (this.canAccessStorageAccessible == null) this.canAccessStorageAccessible = typeof Storage !== "undefined" && typeof window !== "undefined" && window != null && window.localStorage != null;
        var canAccess = this.canAccessStorageAccessible;
        if (ignoreDisabledOption) return canAccess;
        return !this.disabled && canAccess;
    };
    StatsigLocalStorage.disabled = false;
    StatsigLocalStorage.fallbackSessionCache = {};
    StatsigLocalStorage.canAccessStorageAccessible = null;
    return StatsigLocalStorage;
}();
module.exports.default = $dfe6e1baeb70cc85$var$StatsigLocalStorage;

});

parcelRegister("89awa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version = void 0;
// Generated by genversion.
module.exports.version = "1.6.0";

});


parcelRegister("hRhus", function(module, exports) {
"use strict";
var $d004f41d805b77ab$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d004f41d805b77ab$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $d004f41d805b77ab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d004f41d805b77ab$var$LogEvent_1 = $d004f41d805b77ab$var$__importDefault((parcelRequire("dbyyI")));

var $ip3ji = parcelRequire("ip3ji");

var $eLumd = parcelRequire("eLumd");

var $d004f41d805b77ab$var$StatsigLocalStorage_1 = $d004f41d805b77ab$var$__importDefault((parcelRequire("jdP7e")));
var $d004f41d805b77ab$var$INTERNAL_EVENT_PREFIX = "statsig::";
var $d004f41d805b77ab$var$CONFIG_EXPOSURE_EVENT = $d004f41d805b77ab$var$INTERNAL_EVENT_PREFIX + "config_exposure";
var $d004f41d805b77ab$var$LAYER_EXPOSURE_EVENT = $d004f41d805b77ab$var$INTERNAL_EVENT_PREFIX + "layer_exposure";
var $d004f41d805b77ab$var$GATE_EXPOSURE_EVENT = $d004f41d805b77ab$var$INTERNAL_EVENT_PREFIX + "gate_exposure";
var $d004f41d805b77ab$var$LOG_FAILURE_EVENT = $d004f41d805b77ab$var$INTERNAL_EVENT_PREFIX + "log_event_failed";
var $d004f41d805b77ab$var$DEFAULT_VALUE_WARNING = $d004f41d805b77ab$var$INTERNAL_EVENT_PREFIX + "default_value_type_mismatch";
var $d004f41d805b77ab$var$MS_RETRY_LOGS_CUTOFF = 432000000;
var $d004f41d805b77ab$var$MAX_BATCHES_TO_RETRY = 100;
var $d004f41d805b77ab$var$MAX_FAILED_EVENTS = 1000;
var $d004f41d805b77ab$var$MAX_LOCAL_STORAGE_SIZE = 1024 * $d004f41d805b77ab$var$MAX_FAILED_EVENTS;
var $d004f41d805b77ab$var$StatsigLogger = /** @class */ function() {
    function StatsigLogger(options, identity, network, errorBoundary) {
        var _this = this;
        this._failedLogEventCount = 0;
        this.logConfigDefaultValueFallback = function(user, message, metadata) {
            var defaultValueEvent = (0, $d004f41d805b77ab$var$LogEvent_1.default)($d004f41d805b77ab$var$DEFAULT_VALUE_WARNING, user, _this._identity._statsigMetadata, message, metadata);
            _this.log(defaultValueEvent);
            _this._loggedErrors.add(message);
        };
        this._options = options;
        this._identity = identity;
        this._network = network;
        this._errorBoundary = errorBoundary;
        this._queue = [];
        this._flushInterval = null;
        this._loggedErrors = new Set();
        this._failedLogEvents = [];
        this._exposureDedupeKeys = {};
        this._failedLogEventCount = 0;
        this._init();
    }
    StatsigLogger.prototype.log = function(event) {
        if (this._options.disableAllLogging) return;
        try {
            if (!this._options.disableCurrentPageLogging && typeof window !== "undefined" && window != null && typeof window.location === "object" && typeof window.location.href === "string") {
                // https://stackoverflow.com/questions/6257463/how-to-get-the-url-without-any-parameters-in-javascript
                var parts = window.location.href.split(/[?#]/);
                if ((parts === null || parts === void 0 ? void 0 : parts.length) > 0) event.statsigMetadata.currentPage = parts[0];
            }
        } catch (_e) {}
        this._queue.push(event);
        if (this._queue.length >= this._options.loggingBufferMaxSize) this.flush();
    };
    StatsigLogger.prototype.resetDedupeKeys = function() {
        this._exposureDedupeKeys = {};
    };
    StatsigLogger.prototype.logGateExposure = function(user, gateName, gateValue, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = gateName + String(gateValue) + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            gate: gateName,
            gateValue: String(gateValue),
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var gateExposure = (0, $d004f41d805b77ab$var$LogEvent_1.default)($d004f41d805b77ab$var$GATE_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(gateExposure);
    };
    StatsigLogger.prototype.logConfigExposure = function(user, configName, ruleID, secondaryExposures, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = configName + ruleID + details.reason;
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $d004f41d805b77ab$var$LogEvent_1.default)($d004f41d805b77ab$var$CONFIG_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.logLayerExposure = function(user, configName, ruleID, secondaryExposures, allocatedExperiment, parameterName, isExplicitParameter, details, isManualExposure, bootstrapMetadata) {
        var dedupeKey = [
            configName,
            ruleID,
            allocatedExperiment,
            parameterName,
            String(isExplicitParameter),
            details.reason
        ].join("|");
        if (!this._shouldLogExposure(dedupeKey)) return;
        var metadata = {
            config: configName,
            ruleID: ruleID,
            allocatedExperiment: allocatedExperiment,
            parameterName: parameterName,
            isExplicitParameter: String(isExplicitParameter),
            reason: details.reason,
            time: details.time
        };
        if (isManualExposure) metadata["isManualExposure"] = "true";
        if (bootstrapMetadata != null) metadata["bootstrapMetadata"] = bootstrapMetadata;
        var configExposure = (0, $d004f41d805b77ab$var$LogEvent_1.default)($d004f41d805b77ab$var$LAYER_EXPOSURE_EVENT, user, this._identity._statsigMetadata, null, metadata, secondaryExposures);
        this.log(configExposure);
    };
    StatsigLogger.prototype.shutdown = function() {
        if (this._flushInterval) {
            clearInterval(this._flushInterval);
            this._flushInterval = null;
        }
        this.flush(true);
    };
    StatsigLogger.prototype.flush = function(isClosing) {
        var _this = this;
        if (isClosing === void 0) isClosing = false;
        if (this._queue.length === 0) return;
        var statsigMetadata = this._identity._statsigMetadata;
        var oldQueue = this._queue;
        this._queue = [];
        if (isClosing && !this._network.supportsKeepalive() && typeof navigator !== "undefined" && navigator != null && // @ts-ignore
        navigator.sendBeacon) {
            var beacon = this._network.sendLogBeacon({
                events: oldQueue,
                statsigMetadata: statsigMetadata
            });
            if (!beacon) {
                this._queue = oldQueue.concat(this._queue);
                if (this._queue.length > 0) {
                    this._addFailedRequest({
                        events: this._queue,
                        statsigMetadata: statsigMetadata,
                        time: Date.now()
                    });
                    this._queue = [];
                }
                this._saveFailedRequests();
            }
            return;
        }
        var processor = this;
        this._network.postToEndpoint($ip3ji.StatsigEndpoint.Rgstr, {
            events: oldQueue,
            statsigMetadata: statsigMetadata
        }, 3 /* retries */ , 1000 /* backoff */ , 0 /* retry attempt */ , isClosing /* useKeepalive */ ).then(function(response) {
            if (!response.ok) throw response;
        }).catch(function(error) {
            if (typeof error.text === "function") error.text().then(function(errorText) {
                _this._errorBoundary._logError($d004f41d805b77ab$var$LOG_FAILURE_EVENT, error, function() {
                    return $d004f41d805b77ab$var$__awaiter(_this, void 0, void 0, function() {
                        return $d004f41d805b77ab$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                {
                                    eventCount: oldQueue.length,
                                    error: errorText
                                }
                            ];
                        });
                    });
                });
            });
            else _this._errorBoundary._logError($d004f41d805b77ab$var$LOG_FAILURE_EVENT, error, function() {
                return $d004f41d805b77ab$var$__awaiter(_this, void 0, void 0, function() {
                    return $d004f41d805b77ab$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            {
                                eventCount: oldQueue.length,
                                error: error.message
                            }
                        ];
                    });
                });
            });
            processor._newFailedRequest($d004f41d805b77ab$var$LOG_FAILURE_EVENT, oldQueue);
        }).finally(function() {
            return $d004f41d805b77ab$var$__awaiter(_this, void 0, void 0, function() {
                return $d004f41d805b77ab$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!isClosing) return [
                                3 /*break*/ ,
                                2
                            ];
                            if (this._queue.length > 0) {
                                this._addFailedRequest({
                                    events: this._queue,
                                    statsigMetadata: statsigMetadata,
                                    time: Date.now()
                                });
                                // on app background/window blur, save unsent events as a request and clean up the queue (in case app foregrounds)
                                this._queue = [];
                            }
                            return [
                                4 /*yield*/ ,
                                processor._saveFailedRequests()
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    };
    StatsigLogger.prototype.sendSavedRequests = function() {
        return $d004f41d805b77ab$var$__awaiter(this, void 0, void 0, function() {
            var failedRequests, fireAndForget, requestBodies, _loop_1, this_1, _i, requestBodies_1, requestBody;
            var _this = this;
            return $d004f41d805b77ab$var$__generator(this, function(_a) {
                fireAndForget = false;
                failedRequests = $d004f41d805b77ab$var$StatsigLocalStorage_1.default.getItem($eLumd.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
                if (failedRequests == null) {
                    this._clearLocalStorageRequests();
                    return [
                        2 /*return*/ 
                    ];
                }
                if (failedRequests.length > $d004f41d805b77ab$var$MAX_LOCAL_STORAGE_SIZE) fireAndForget = true;
                requestBodies = [];
                try {
                    requestBodies = JSON.parse(failedRequests);
                    _loop_1 = function(requestBody) {
                        if (requestBody != null && requestBody.events && Array.isArray(requestBody.events)) this_1._network.postToEndpoint($ip3ji.StatsigEndpoint.Rgstr, requestBody).then(function(response) {
                            if (!response.ok) throw Error(response.status + "");
                        }).catch(function(_e) {
                            if (fireAndForget) return;
                            _this._addFailedRequest(requestBody);
                        });
                    };
                    this_1 = this;
                    for(_i = 0, requestBodies_1 = requestBodies; _i < requestBodies_1.length; _i++){
                        requestBody = requestBodies_1[_i];
                        _loop_1(requestBody);
                    }
                } catch (_e) {} finally{
                    this._clearLocalStorageRequests();
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._init = function() {
        var _this = this;
        if (typeof window !== "undefined" && typeof window.addEventListener === "function") {
            window.addEventListener("blur", function() {
                return _this.flush(true);
            });
            window.addEventListener("beforeunload", function() {
                return _this.flush(true);
            });
            window.addEventListener("load", function() {
                setTimeout(function() {
                    return _this.flush();
                }, 100);
                setTimeout(function() {
                    return _this.flush();
                }, 1000);
            });
        }
        if (typeof document !== "undefined" && typeof document.addEventListener === "function") document.addEventListener("visibilitychange", function() {
            _this.flush(document.visibilityState !== "visible");
        });
        if (!this._options.ignoreWindowUndefined && (typeof window === "undefined" || window == null)) // dont set the flush interval outside of client browser environments
        return;
        if (this._options.localMode) // unnecessary interval in local mode since logs dont flush anyway
        return;
        var me = this;
        this._flushInterval = setInterval(function() {
            me.flush();
        }, this._options.loggingIntervalMillis);
        // Quick flush
        setTimeout(function() {
            return _this.flush();
        }, 100);
        setTimeout(function() {
            return _this.flush();
        }, 1000);
    };
    StatsigLogger.prototype._shouldLogExposure = function(key) {
        var lastTime = this._exposureDedupeKeys[key];
        var now = Date.now();
        if (lastTime == null) {
            this._exposureDedupeKeys[key] = now;
            return true;
        }
        if (lastTime >= now - 600000) return false;
        this._exposureDedupeKeys[key] = now;
        return true;
    };
    StatsigLogger.prototype._saveFailedRequests = function() {
        return $d004f41d805b77ab$var$__awaiter(this, void 0, void 0, function() {
            var requestsCopy;
            return $d004f41d805b77ab$var$__generator(this, function(_a) {
                if (this._failedLogEvents.length > 0) {
                    requestsCopy = JSON.stringify(this._failedLogEvents);
                    if (requestsCopy.length > $d004f41d805b77ab$var$MAX_LOCAL_STORAGE_SIZE) {
                        this._clearLocalStorageRequests();
                        return [
                            2 /*return*/ 
                        ];
                    }
                    $d004f41d805b77ab$var$StatsigLocalStorage_1.default.setItem($eLumd.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY, requestsCopy);
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    StatsigLogger.prototype._addFailedRequest = function(requestBody) {
        if (requestBody.time < Date.now() - $d004f41d805b77ab$var$MS_RETRY_LOGS_CUTOFF) return;
        if (this._failedLogEvents.length > $d004f41d805b77ab$var$MAX_BATCHES_TO_RETRY) return;
        var additionalEvents = requestBody.events.length;
        if (this._failedLogEventCount + additionalEvents > $d004f41d805b77ab$var$MAX_FAILED_EVENTS) return;
        this._failedLogEvents.push(requestBody);
        this._failedLogEventCount += additionalEvents;
    };
    StatsigLogger.prototype._clearLocalStorageRequests = function() {
        $d004f41d805b77ab$var$StatsigLocalStorage_1.default.removeItem($eLumd.STATSIG_LOCAL_STORAGE_LOGGING_REQUEST_KEY);
    };
    StatsigLogger.prototype._newFailedRequest = function(name, queue) {
        if (this._loggedErrors.has(name)) return;
        this._loggedErrors.add(name);
        this._failedLogEvents.push({
            events: queue,
            statsigMetadata: this._identity._statsigMetadata,
            time: Date.now()
        });
        this._saveFailedRequests().then(function() {});
    };
    return StatsigLogger;
}();
module.exports.default = $d004f41d805b77ab$var$StatsigLogger;

});
parcelRegister("dbyyI", function(module, exports) {
"use strict";
var $99971c237fcc2473$var$__assign = module.exports && module.exports.__assign || function() {
    $99971c237fcc2473$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $99971c237fcc2473$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $99971c237fcc2473$var$makeLogEvent(eventName, user, statsigMetadata, value, metadata, secondaryExposures) {
    if (value === void 0) value = null;
    if (metadata === void 0) metadata = null;
    var logUser = user;
    if (logUser === null || logUser === void 0 ? void 0 : logUser.privateAttributes) {
        logUser = $99971c237fcc2473$var$__assign({}, user);
        delete logUser.privateAttributes;
    }
    return {
        time: Date.now(),
        eventName: eventName,
        statsigMetadata: statsigMetadata,
        user: logUser,
        value: value,
        metadata: metadata,
        secondaryExposures: secondaryExposures
    };
}
module.exports.default = $99971c237fcc2473$var$makeLogEvent;

});

parcelRegister("ip3ji", function(module, exports) {
"use strict";
var $d65d2128fff86f47$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $d65d2128fff86f47$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEndpoint = void 0;
var $d65d2128fff86f47$var$StatsigEndpoint;
(function(StatsigEndpoint) {
    StatsigEndpoint["Initialize"] = "initialize";
    StatsigEndpoint["Rgstr"] = "rgstr";
    StatsigEndpoint["LogEventBeacon"] = "log_event_beacon";
})($d65d2128fff86f47$var$StatsigEndpoint = module.exports.StatsigEndpoint || (module.exports.StatsigEndpoint = {}));
var $d65d2128fff86f47$var$NO_CONTENT = 204;
var $d65d2128fff86f47$var$StatsigNetwork = /** @class */ function() {
    function StatsigNetwork(options, identity, errorBoundary) {
        this.retryCodes = {
            408: true,
            500: true,
            502: true,
            503: true,
            504: true,
            522: true,
            524: true,
            599: true
        };
        this.canUseKeepalive = false;
        this._options = options;
        this._identity = identity;
        this._errorBoundary = errorBoundary;
        this.leakyBucket = {};
        this._init();
    }
    StatsigNetwork.prototype.fetchValues = function(user, sinceTime, timeout, previousDerivedFields) {
        var input = {
            user: user,
            statsigMetadata: this._identity._statsigMetadata,
            sinceTime: sinceTime !== null && sinceTime !== void 0 ? sinceTime : undefined,
            hash: "djb2",
            previousDerivedFields: previousDerivedFields
        };
        return this._postWithTimeout($d65d2128fff86f47$var$StatsigEndpoint.Initialize, input, timeout, 3);
    };
    StatsigNetwork.prototype.sendLogBeacon = function(payload) {
        if (this._options.localMode) return true;
        var url = new URL(this._options.eventLoggingApi + $d65d2128fff86f47$var$StatsigEndpoint.LogEventBeacon);
        url.searchParams.append("k", this._identity._sdkKey);
        payload.clientTime = Date.now() + "";
        var stringPayload = null;
        try {
            stringPayload = JSON.stringify(payload);
        } catch (_e) {
            return false;
        }
        return navigator.sendBeacon(url.toString(), stringPayload);
    };
    StatsigNetwork.prototype.postToEndpoint = function(endpointName, body, retries, backoff, retryAttempt, useKeepalive) {
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        if (retryAttempt === void 0) retryAttempt = 0;
        if (useKeepalive === void 0) useKeepalive = false;
        return $d65d2128fff86f47$var$__awaiter(this, void 0, void 0, function() {
            var api, url, counter, postBody, statsigMetadata, params;
            var _this = this;
            return $d65d2128fff86f47$var$__generator(this, function(_a) {
                if (this._options.localMode) return [
                    2 /*return*/ ,
                    Promise.reject("no network requests in localMode")
                ];
                if (typeof fetch !== "function") // fetch is not defined in this environment, short circuit
                return [
                    2 /*return*/ ,
                    Promise.reject("fetch is not defined")
                ];
                if (typeof window === "undefined" && !this._options.ignoreWindowUndefined) // by default, dont issue requests from the server
                return [
                    2 /*return*/ ,
                    Promise.reject("window is not defined")
                ];
                api = [
                    $d65d2128fff86f47$var$StatsigEndpoint.Initialize
                ].includes(endpointName) ? this._options.api : retryAttempt > 0 ? this._options.eventLoggingApiForRetries : this._options.eventLoggingApi;
                url = api + endpointName;
                counter = this.leakyBucket[url];
                if (counter != null && counter >= 30) return [
                    2 /*return*/ ,
                    Promise.reject(new Error("Request failed because you are making the same request too frequently."))
                ];
                if (counter == null) this.leakyBucket[url] = 1;
                else this.leakyBucket[url] = counter + 1;
                postBody = JSON.stringify(body);
                statsigMetadata = this._identity._statsigMetadata;
                params = {
                    method: "POST",
                    body: postBody,
                    headers: {
                        "Content-type": "application/json; charset=UTF-8",
                        "STATSIG-API-KEY": this._identity._sdkKey,
                        "STATSIG-CLIENT-TIME": Date.now() + "",
                        "STATSIG-SDK-TYPE": statsigMetadata.sdkType,
                        "STATSIG-SDK-VERSION": statsigMetadata.sdkVersion
                    }
                };
                if (this.canUseKeepalive && useKeepalive) params.keepalive = true;
                return [
                    2 /*return*/ ,
                    fetch(url, params).then(function(res) {
                        return $d65d2128fff86f47$var$__awaiter(_this, void 0, void 0, function() {
                            var networkResponse, text, errorText;
                            return $d65d2128fff86f47$var$__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!res.ok) return [
                                            3 /*break*/ ,
                                            4
                                        ];
                                        networkResponse = res;
                                        if (!(res.status === $d65d2128fff86f47$var$NO_CONTENT)) return [
                                            3 /*break*/ ,
                                            1
                                        ];
                                        networkResponse.data = {
                                            has_updates: false,
                                            is_no_content: true
                                        };
                                        return [
                                            3 /*break*/ ,
                                            3
                                        ];
                                    case 1:
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 2:
                                        text = _a.sent();
                                        networkResponse.data = JSON.parse(text);
                                        _a.label = 3;
                                    case 3:
                                        return [
                                            2 /*return*/ ,
                                            Promise.resolve(networkResponse)
                                        ];
                                    case 4:
                                        if (!this.retryCodes[res.status]) retries = 0;
                                        return [
                                            4 /*yield*/ ,
                                            res.text()
                                        ];
                                    case 5:
                                        errorText = _a.sent();
                                        return [
                                            2 /*return*/ ,
                                            Promise.reject(new Error("".concat(res.status, ": ").concat(errorText)))
                                        ];
                                }
                            });
                        });
                    }).catch(function(e) {
                        if (retries > 0) return new Promise(function(resolve, reject) {
                            setTimeout(function() {
                                _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                                _this.postToEndpoint(endpointName, body, retries - 1, backoff * 2, retryAttempt + 1, useKeepalive).then(resolve).catch(reject);
                            }, backoff);
                        });
                        return Promise.reject(e);
                    }).finally(function() {
                        _this.leakyBucket[url] = Math.max(_this.leakyBucket[url] - 1, 0);
                    })
                ];
            });
        });
    };
    StatsigNetwork.prototype.supportsKeepalive = function() {
        return this.canUseKeepalive;
    };
    StatsigNetwork.prototype._init = function() {
        if (!this._options.disableNetworkKeepalive) try {
            this.canUseKeepalive = "keepalive" in new Request("");
        } catch (_e) {}
    };
    StatsigNetwork.prototype._postWithTimeout = function(endpointName, body, timeout, retries, backoff) {
        var _this = this;
        if (timeout === void 0) timeout = 0;
        if (retries === void 0) retries = 0;
        if (backoff === void 0) backoff = 1000;
        var hasTimedOut = false;
        var timer = null;
        var cachedReturnValue = null;
        var eventuals = [];
        var eventually = function(boundScope) {
            return function(fn) {
                if (hasTimedOut && cachedReturnValue) fn(cachedReturnValue);
                else eventuals.push(fn);
                return boundScope;
            };
        };
        if (timeout != 0) timer = new Promise(function(resolve, reject) {
            setTimeout(function() {
                hasTimedOut = true;
                reject(new Error("The initialization timeout of ".concat(timeout, "ms has been hit before the network request has completed.")));
            }, timeout);
        });
        var fetchPromise = this.postToEndpoint(endpointName, body, retries, backoff).then(function(res) {
            if (!res.ok) return Promise.reject(new Error("Request to ".concat(endpointName, " failed with status ").concat(res.status)));
            if (typeof res.data !== "object") {
                var error = new Error("Request to ".concat(endpointName, " received invalid response type. Expected 'object' but got '").concat(typeof res.data, "'"));
                _this._errorBoundary._logError("postWithTimeoutInvalidRes", error, function() {
                    return $d65d2128fff86f47$var$__awaiter(_this, void 0, void 0, function() {
                        return $d65d2128fff86f47$var$__generator(this, function(_a) {
                            return [
                                2 /*return*/ ,
                                this._getErrorData(endpointName, body, retries, backoff, res)
                            ];
                        });
                    });
                });
                return Promise.reject(error);
            }
            var json = res.data;
            return _this._errorBoundary._capture("postWithTimeout", function() {
                return $d65d2128fff86f47$var$__awaiter(_this, void 0, void 0, function() {
                    return $d65d2128fff86f47$var$__generator(this, function(_a) {
                        cachedReturnValue = json;
                        if (hasTimedOut) {
                            eventuals.forEach(function(fn) {
                                return fn(json);
                            });
                            eventuals = [];
                        }
                        return [
                            2 /*return*/ ,
                            Promise.resolve(json)
                        ];
                    });
                });
            }, function() {
                return Promise.resolve({});
            }, function() {
                return $d65d2128fff86f47$var$__awaiter(_this, void 0, void 0, function() {
                    return $d65d2128fff86f47$var$__generator(this, function(_a) {
                        return [
                            2 /*return*/ ,
                            this._getErrorData(endpointName, body, retries, backoff, res)
                        ];
                    });
                });
            });
        }).catch(function(e) {
            return Promise.reject(e);
        });
        var racingPromise = timer ? Promise.race([
            fetchPromise,
            timer
        ]) : fetchPromise;
        racingPromise.eventually = eventually(racingPromise);
        return racingPromise;
    };
    StatsigNetwork.prototype._getErrorData = function(endpointName, body, retries, backoff, res) {
        var _a;
        return $d65d2128fff86f47$var$__awaiter(this, void 0, void 0, function() {
            var headers_1;
            return $d65d2128fff86f47$var$__generator(this, function(_b) {
                try {
                    headers_1 = {};
                    ((_a = res.headers) !== null && _a !== void 0 ? _a : []).forEach(function(value, key) {
                        headers_1[key] = value;
                    });
                    return [
                        2 /*return*/ ,
                        {
                            responseInfo: {
                                headers: headers_1,
                                status: res.status,
                                statusText: res.statusText,
                                type: res.type,
                                url: res.url,
                                redirected: res.redirected,
                                bodySnippet: res.data ? JSON.stringify(res.data).slice(0, 500) : null
                            },
                            requestInfo: {
                                endpointName: endpointName,
                                bodySnippet: JSON.stringify(body).slice(0, 500),
                                retries: retries,
                                backoff: backoff
                            }
                        }
                    ];
                } catch (_e) {
                    return [
                        2 /*return*/ ,
                        {
                            statusText: "statsig::failed to extract extra data"
                        }
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return StatsigNetwork;
}();
module.exports.default = $d65d2128fff86f47$var$StatsigNetwork;

});


parcelRegister("cKL8P", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.INIT_TIMEOUT_DEFAULT_MS = void 0;
var $948e593c5339df08$var$DEFAULT_FEATURE_GATE_API = "https://featuregates.org/v1/";
var $948e593c5339df08$var$DEFAULT_EVENT_LOGGING_API = "https://events.statsigapi.net/v1/";
module.exports.INIT_TIMEOUT_DEFAULT_MS = 3000;
var $948e593c5339df08$var$StatsigSDKOptions = /** @class */ function() {
    function StatsigSDKOptions(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (options == null) options = {};
        var api = (_a = options.api) !== null && _a !== void 0 ? _a : $948e593c5339df08$var$DEFAULT_FEATURE_GATE_API;
        this.api = api.endsWith("/") ? api : api + "/";
        this.disableCurrentPageLogging = (_b = options.disableCurrentPageLogging) !== null && _b !== void 0 ? _b : false;
        this.environment = (_c = options.environment) !== null && _c !== void 0 ? _c : null;
        this.loggingIntervalMillis = this.normalizeNumberInput(options.loggingIntervalMillis, {
            default: 10000,
            min: 1000,
            max: 60000
        });
        this.loggingBufferMaxSize = this.normalizeNumberInput(options.loggingBufferMaxSize, {
            default: 100,
            min: 2,
            max: 500
        });
        this.disableNetworkKeepalive = (_d = options.disableNetworkKeepalive) !== null && _d !== void 0 ? _d : false;
        this.overrideStableID = (_e = options.overrideStableID) !== null && _e !== void 0 ? _e : null;
        this.localMode = (_f = options.localMode) !== null && _f !== void 0 ? _f : false;
        this.initTimeoutMs = options.initTimeoutMs && options.initTimeoutMs >= 0 ? options.initTimeoutMs : module.exports.INIT_TIMEOUT_DEFAULT_MS;
        this.disableErrorLogging = (_g = options.disableErrorLogging) !== null && _g !== void 0 ? _g : false;
        this.disableAutoMetricsLogging = (_h = options.disableAutoMetricsLogging) !== null && _h !== void 0 ? _h : false;
        this.initializeValues = (_j = options.initializeValues) !== null && _j !== void 0 ? _j : null;
        var eventLoggingApi = (_l = (_k = options.eventLoggingApi) !== null && _k !== void 0 ? _k : options.api) !== null && _l !== void 0 ? _l : $948e593c5339df08$var$DEFAULT_EVENT_LOGGING_API;
        this.eventLoggingApi = eventLoggingApi.endsWith("/") ? eventLoggingApi : eventLoggingApi + "/";
        var eventLoggingApiForRetries = (_m = options.eventLoggingApiForRetries) !== null && _m !== void 0 ? _m : eventLoggingApi;
        this.eventLoggingApiForRetries = eventLoggingApiForRetries.endsWith("/") ? eventLoggingApiForRetries : eventLoggingApiForRetries + "/";
        this.disableLocalStorage = (_o = options.disableLocalStorage) !== null && _o !== void 0 ? _o : false;
        this.ignoreWindowUndefined = (_p = options === null || options === void 0 ? void 0 : options.ignoreWindowUndefined) !== null && _p !== void 0 ? _p : false;
        this.updateUserCompletionCallback = (_q = options === null || options === void 0 ? void 0 : options.updateUserCompletionCallback) !== null && _q !== void 0 ? _q : null;
        this.disableAllLogging = (_r = options === null || options === void 0 ? void 0 : options.disableAllLogging) !== null && _r !== void 0 ? _r : false;
    }
    StatsigSDKOptions.prototype.normalizeNumberInput = function(input, bounds) {
        if (input == null) return bounds.default;
        return Math.max(Math.min(input, bounds.max), bounds.min);
    };
    return StatsigSDKOptions;
}();
module.exports.default = $948e593c5339df08$var$StatsigSDKOptions;

});

parcelRegister("lpLpB", function(module, exports) {
"use strict";
var $0405f26a9db19500$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $0405f26a9db19500$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $0405f26a9db19500$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EvaluationReason = void 0;

var $0405f26a9db19500$var$DynamicConfig_1 = $0405f26a9db19500$var$__importDefault((parcelRequire("7DuT3")));

var $0405f26a9db19500$var$Layer_1 = $0405f26a9db19500$var$__importDefault((parcelRequire("kL03Z")));

var $0405f26a9db19500$var$BootstrapValidator_1 = $0405f26a9db19500$var$__importDefault((parcelRequire("7bryX")));

var $eLumd = parcelRequire("eLumd");

var $6Bvad = parcelRequire("6Bvad");

var $0405f26a9db19500$var$StatsigLocalStorage_1 = $0405f26a9db19500$var$__importDefault((parcelRequire("jdP7e")));
var $0405f26a9db19500$var$EvaluationReason;
(function(EvaluationReason) {
    EvaluationReason["Network"] = "Network";
    EvaluationReason["Bootstrap"] = "Bootstrap";
    EvaluationReason["InvalidBootstrap"] = "InvalidBootstrap";
    EvaluationReason["Cache"] = "Cache";
    EvaluationReason["Unrecognized"] = "Unrecognized";
    EvaluationReason["Uninitialized"] = "Uninitialized";
    EvaluationReason["Error"] = "Error";
    EvaluationReason["NetworkNotModified"] = "NetworkNotModified";
    EvaluationReason["LocalOverride"] = "LocalOverride";
})($0405f26a9db19500$var$EvaluationReason = module.exports.EvaluationReason || (module.exports.EvaluationReason = {}));
var $0405f26a9db19500$var$MAX_USER_VALUE_CACHED = 10;
var $0405f26a9db19500$var$StatsigStore = /** @class */ function() {
    function StatsigStore(identity, onDefaultValueFallback, initializeValues) {
        this._identity = identity;
        this._onDefaultValueFallback = onDefaultValueFallback;
        this._userCacheKey = this._identity.getUserCacheKey();
        this._values = {};
        this._userValues = this._getDefaultUserCacheValues();
        this._loaded = false;
        this._reason = $0405f26a9db19500$var$EvaluationReason.Uninitialized;
        if (initializeValues) this.bootstrap(initializeValues);
        else this._loadFromLocalStorage();
    }
    StatsigStore.prototype.updateUser = function() {
        this._userCacheKey = this._identity.getUserCacheKey();
        return this._setUserValueFromCache();
    };
    StatsigStore.prototype.bootstrap = function(initializeValues) {
        var _a, _b, _c, _d, _f, _g, _h;
        var key = this._identity.getUserCacheKey();
        var user = this._identity._user;
        var reason = $0405f26a9db19500$var$BootstrapValidator_1.default.isValid(user, initializeValues) ? $0405f26a9db19500$var$EvaluationReason.Bootstrap : $0405f26a9db19500$var$EvaluationReason.InvalidBootstrap;
        // clients are going to assume that the SDK is bootstrapped after this method runs
        // if we fail to parse, we will fall back to defaults, but we dont want to throw
        // when clients try to check gates/configs/etc after this point
        this._loaded = true;
        try {
            this._userValues.feature_gates = (_a = initializeValues.feature_gates) !== null && _a !== void 0 ? _a : {};
            this._userValues.dynamic_configs = (_b = initializeValues.dynamic_configs) !== null && _b !== void 0 ? _b : {};
            this._userValues.layer_configs = (_c = initializeValues.layer_configs) !== null && _c !== void 0 ? _c : {};
            this._userValues.evaluation_time = Date.now();
            this._userValues.time = (_d = initializeValues.time) !== null && _d !== void 0 ? _d : Date.now();
            this._userValues.exposures = (_f = initializeValues.exposures) !== null && _f !== void 0 ? _f : [];
            this._userValues.hash_used = (_g = initializeValues.hash_used) !== null && _g !== void 0 ? _g : "djb2";
            this._values[key] = this._userValues;
            this._reason = reason;
            var generatorSDKInfo = (_h = initializeValues.sdkInfo) !== null && _h !== void 0 ? _h : initializeValues.sdk_info;
            this._userValues.bootstrapMetadata = {};
            if (generatorSDKInfo != null) this._userValues.bootstrapMetadata.generatorSDKInfo = generatorSDKInfo;
            if (initializeValues.user != null) this._userValues.bootstrapMetadata.user = initializeValues.user;
            if (initializeValues.time != null) this._userValues.bootstrapMetadata.lcut = initializeValues.time;
        } catch (_e) {
            return;
        }
    };
    StatsigStore.prototype.getBootstrapMetadata = function() {
        var _a;
        return (_a = this._userValues.bootstrapMetadata) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.isLoaded = function() {
        return this._loaded;
    };
    StatsigStore.prototype.getLastUpdateTime = function(user) {
        var userHash = (0, $6Bvad.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.time;
        return null;
    };
    StatsigStore.prototype.getPreviousDerivedFields = function(user) {
        var userHash = (0, $6Bvad.djb2HashForObject)(user);
        if (this._userValues.user_hash == userHash) return this._userValues.derived_fields;
        return undefined;
    };
    StatsigStore.prototype.setEvaluationReason = function(evalReason) {
        this._reason = evalReason;
    };
    StatsigStore.prototype.save = function(user, jsonConfigs, updateState) {
        if (updateState === void 0) updateState = true;
        return $0405f26a9db19500$var$__awaiter(this, void 0, void 0, function() {
            var requestedUserCacheKey, initResponse, userValues, _a;
            return $0405f26a9db19500$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        requestedUserCacheKey = (0, $6Bvad.getUserCacheKey)(user);
                        initResponse = jsonConfigs;
                        this._mergeInitializeResponseIntoUserMap(initResponse, this._values, requestedUserCacheKey, user, function(userValues) {
                            return userValues;
                        });
                        if (updateState) {
                            userValues = this._values[requestedUserCacheKey];
                            if (userValues && requestedUserCacheKey && requestedUserCacheKey == this._userCacheKey) {
                                this._userValues = userValues;
                                this._reason = $0405f26a9db19500$var$EvaluationReason.Network;
                            }
                        }
                        _a = this;
                        return [
                            4 /*yield*/ ,
                            this._writeValuesToStorage(this._values)
                        ];
                    case 1:
                        _a._values = _b.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    StatsigStore.prototype.checkGate = function(gateName) {
        var _a, _b;
        var gateNameHash = (0, $6Bvad.getHashValue)(gateName, this._userValues.hash_used);
        var gateValue = {
            name: gateName,
            value: false,
            rule_id: "",
            secondary_exposures: []
        };
        var details;
        var value = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a.feature_gates[gateNameHash];
        if (value) gateValue = value;
        gateValue.secondary_exposures = this.mapExposures((_b = gateValue.secondary_exposures) !== null && _b !== void 0 ? _b : []);
        details = this._getEvaluationDetails(value != null);
        return {
            evaluationDetails: details,
            gate: gateValue
        };
    };
    StatsigStore.prototype.mapExposures = function(exposures) {
        var _this = this;
        return exposures.map(function(exposure) {
            var _a;
            if (typeof exposure === "string") return ((_a = _this._userValues.exposures) !== null && _a !== void 0 ? _a : {})[exposure];
            return exposure;
        });
    };
    StatsigStore.prototype.getConfig = function(configName) {
        var _a, _b;
        var configNameHash = (0, $6Bvad.getHashValue)(configName, this._userValues.hash_used);
        var configValue;
        var details;
        if (((_a = this._userValues) === null || _a === void 0 ? void 0 : _a.dynamic_configs[configNameHash]) != null) {
            var rawConfigValue = (_b = this._userValues) === null || _b === void 0 ? void 0 : _b.dynamic_configs[configNameHash];
            details = this._getEvaluationDetails(true);
            configValue = this._createDynamicConfig(configName, rawConfigValue, details);
        } else {
            details = this._getEvaluationDetails(false);
            configValue = new $0405f26a9db19500$var$DynamicConfig_1.default(configName, {}, "", details);
        }
        return configValue;
    };
    StatsigStore.prototype.getLayer = function(logParameterFunction, layerName) {
        var _a, _b, _c, _d, _f;
        var latestValue = this._getLatestValue(layerName, "layer_configs");
        var details = this._getEvaluationDetails(latestValue != null);
        return $0405f26a9db19500$var$Layer_1.default._create(layerName, (_a = latestValue === null || latestValue === void 0 ? void 0 : latestValue.value) !== null && _a !== void 0 ? _a : {}, (_b = latestValue === null || latestValue === void 0 ? void 0 : latestValue.rule_id) !== null && _b !== void 0 ? _b : "", details, logParameterFunction, this.mapExposures((_c = latestValue === null || latestValue === void 0 ? void 0 : latestValue.secondary_exposures) !== null && _c !== void 0 ? _c : []), this.mapExposures((_d = latestValue === null || latestValue === void 0 ? void 0 : latestValue.undelegated_secondary_exposures) !== null && _d !== void 0 ? _d : []), (_f = latestValue === null || latestValue === void 0 ? void 0 : latestValue.allocated_experiment_name) !== null && _f !== void 0 ? _f : "", latestValue === null || latestValue === void 0 ? void 0 : latestValue.explicit_parameters);
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function() {
        var _a, _b;
        return {
            reason: (_a = this._reason) !== null && _a !== void 0 ? _a : $0405f26a9db19500$var$EvaluationReason.Uninitialized,
            time: (_b = this._userValues.evaluation_time) !== null && _b !== void 0 ? _b : 0
        };
    };
    StatsigStore.prototype._loadFromLocalStorage = function() {
        this._parseCachedValues($0405f26a9db19500$var$StatsigLocalStorage_1.default.getItem($eLumd.INTERNAL_STORE_KEY));
        this._loaded = true;
    };
    StatsigStore.prototype._parseCachedValues = function(allValues) {
        try {
            this._values = allValues ? JSON.parse(allValues) : this._values;
            this._setUserValueFromCache();
        } catch (e) {
            // Cached value corrupted, remove cache
            this._removeFromStorage($eLumd.INTERNAL_STORE_KEY);
        }
    };
    StatsigStore.prototype._setUserValueFromCache = function() {
        var _a;
        var cachedValues = this._values[this._userCacheKey];
        if (cachedValues == null) {
            this._resetUserValues();
            this._reason = $0405f26a9db19500$var$EvaluationReason.Uninitialized;
            return null;
        }
        this._userValues = cachedValues;
        this._reason = $0405f26a9db19500$var$EvaluationReason.Cache;
        return (_a = cachedValues.evaluation_time) !== null && _a !== void 0 ? _a : 0;
    };
    StatsigStore.prototype._removeFromStorage = function(key) {
        $0405f26a9db19500$var$StatsigLocalStorage_1.default.removeItem(key);
    };
    /**
     * Merges the provided init configs into the provided config map, according to the provided merge function
     */ StatsigStore.prototype._mergeInitializeResponseIntoUserMap = function(data, configMap, requestedUserCacheKey, user, mergeFn) {
        if (requestedUserCacheKey) {
            var requestedUserValues = this._convertAPIDataToCacheValues(data, requestedUserCacheKey);
            if (data.has_updates && data.time) {
                var userHash = (0, $6Bvad.djb2HashForObject)(user);
                requestedUserValues.user_hash = userHash;
            }
            configMap[requestedUserCacheKey] = mergeFn(requestedUserValues, requestedUserCacheKey);
        }
    };
    StatsigStore.prototype._getDefaultUserCacheValues = function() {
        return {
            feature_gates: {},
            layer_configs: {},
            dynamic_configs: {},
            time: 0,
            evaluation_time: 0,
            has_updates: false
        };
    };
    /**
     * Writes the provided values to storage, truncating down to
     * MAX_USER_VALUE_CACHED number entries.
     * @returns The truncated entry list
     */ StatsigStore.prototype._writeValuesToStorage = function(valuesToWrite) {
        return $0405f26a9db19500$var$__awaiter(this, void 0, void 0, function() {
            var filteredValues;
            return $0405f26a9db19500$var$__generator(this, function(_a) {
                filteredValues = Object.entries(valuesToWrite).sort(function(_a, _b) {
                    var _c, _d;
                    var a = _a[1];
                    var b = _b[1];
                    if (a == null) return 1;
                    if (b == null) return -1;
                    return ((_c = b === null || b === void 0 ? void 0 : b.evaluation_time) !== null && _c !== void 0 ? _c : b === null || b === void 0 ? void 0 : b.time) - ((_d = a === null || a === void 0 ? void 0 : a.evaluation_time) !== null && _d !== void 0 ? _d : a === null || a === void 0 ? void 0 : a.time);
                }).slice(0, $0405f26a9db19500$var$MAX_USER_VALUE_CACHED);
                valuesToWrite = Object.fromEntries(filteredValues);
                $0405f26a9db19500$var$StatsigLocalStorage_1.default.setItem($eLumd.INTERNAL_STORE_KEY, JSON.stringify(valuesToWrite));
                return [
                    2 /*return*/ ,
                    valuesToWrite
                ];
            });
        });
    };
    StatsigStore.prototype._getLatestValue = function(name, topLevelKey) {
        var _a, _b, _c, _d, _f;
        var hash = (0, $6Bvad.getHashValue)(name, this._userValues.hash_used);
        return (_c = (_b = (_a = this._userValues) === null || _a === void 0 ? void 0 : _a[topLevelKey]) === null || _b === void 0 ? void 0 : _b[hash]) !== null && _c !== void 0 ? _c : (_f = (_d = this._userValues) === null || _d === void 0 ? void 0 : _d[topLevelKey]) === null || _f === void 0 ? void 0 : _f[name];
    };
    StatsigStore.prototype._createDynamicConfig = function(name, apiConfig, details) {
        var _a, _b, _c, _d;
        return new $0405f26a9db19500$var$DynamicConfig_1.default(name, (_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.value) !== null && _a !== void 0 ? _a : {}, (_b = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.rule_id) !== null && _b !== void 0 ? _b : "", details, this.mapExposures((_c = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.secondary_exposures) !== null && _c !== void 0 ? _c : []), (_d = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.allocated_experiment_name) !== null && _d !== void 0 ? _d : "", this._makeOnConfigDefaultValueFallback(this._identity._user));
    };
    StatsigStore.prototype._getEvaluationDetails = function(valueExists, reasonOverride) {
        var _a;
        if (valueExists) return {
            reason: this._reason,
            time: (_a = this._userValues.evaluation_time) !== null && _a !== void 0 ? _a : Date.now()
        };
        else return {
            reason: reasonOverride !== null && reasonOverride !== void 0 ? reasonOverride : this._reason == $0405f26a9db19500$var$EvaluationReason.Uninitialized ? $0405f26a9db19500$var$EvaluationReason.Uninitialized : $0405f26a9db19500$var$EvaluationReason.Unrecognized,
            time: Date.now()
        };
    };
    StatsigStore.prototype._resetUserValues = function() {
        this._userValues = this._getDefaultUserCacheValues();
    };
    StatsigStore.prototype._convertAPIDataToCacheValues = function(data, cacheKey) {
        // Specifically pulling keys from data here to avoid pulling in unwanted keys
        return {
            feature_gates: data.feature_gates,
            layer_configs: data.layer_configs,
            dynamic_configs: data.dynamic_configs,
            time: data.time == null || isNaN(data.time) ? 0 : data.time,
            evaluation_time: Date.now(),
            derived_fields: data.derived_fields,
            hash_used: data.hash_used
        };
    };
    StatsigStore.prototype._makeOnConfigDefaultValueFallback = function(user) {
        var _this = this;
        return function(config, parameter, defaultValueType, valueType) {
            if (!_this.isLoaded()) return;
            _this._onDefaultValueFallback(user, "Parameter ".concat(parameter, " is a value of type ").concat(valueType, ".\n          Returning requested defaultValue type ").concat(defaultValueType), {
                name: config._name,
                ruleID: config._ruleID,
                parameter: parameter,
                defaultValueType: defaultValueType,
                valueType: valueType
            });
        };
    };
    return StatsigStore;
}();
module.exports.default = $0405f26a9db19500$var$StatsigStore;

});
parcelRegister("7bryX", function(module, exports) {
"use strict";
var $53aef0e7a8c7517e$var$__assign = module.exports && module.exports.__assign || function() {
    $53aef0e7a8c7517e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $53aef0e7a8c7517e$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $53aef0e7a8c7517e$var$BootstrapValidator = /** @class */ function() {
    function BootstrapValidator() {}
    BootstrapValidator.isValid = function(user, values) {
        try {
            var evaluatedKeys = values["evaluated_keys"];
            if (!evaluatedKeys) {
                var user_1 = values["user"];
                if (user_1) {
                    evaluatedKeys = {};
                    evaluatedKeys["userID"] = user_1["userID"];
                    if (user_1["customIDs"]) evaluatedKeys["customIDs"] = user_1["customIDs"];
                }
            }
            if (!evaluatedKeys || typeof evaluatedKeys !== "object") return true;
            var evaluatedKeysRecord = this.copyObject(evaluatedKeys);
            var userToCompare = user == null ? null : this.copyObject(user);
            return BootstrapValidator.validate(evaluatedKeysRecord, userToCompare) && BootstrapValidator.validate(userToCompare, evaluatedKeysRecord);
        } catch (error) {
        // This is best-effort. If we fail, return true.
        }
        return true;
    };
    BootstrapValidator.validate = function(one, two) {
        if (one == null) return two == null;
        else if (two == null) return false;
        for(var _i = 0, _a = Object.entries(one); _i < _a.length; _i++){
            var _b = _a[_i], key = _b[0], value = _b[1];
            if (key === "stableID") continue;
            if (typeof value !== typeof two[key]) return false;
            if (typeof value === "string") {
                if (value !== two[key]) return false;
            } else if (typeof value === "object") return this.validate(value, two[key]);
            else // unexpected
            return false;
        }
        return true;
    };
    BootstrapValidator.copyObject = function(obj) {
        if (obj == null) return null;
        var copy = {};
        if (obj === null || obj === void 0 ? void 0 : obj.userID) copy["userID"] = obj === null || obj === void 0 ? void 0 : obj.userID;
        if (obj === null || obj === void 0 ? void 0 : obj.customIDs) {
            var customIDs = $53aef0e7a8c7517e$var$__assign({}, obj.customIDs);
            delete customIDs["stableID"];
            if (Object.keys(customIDs).length !== 0) copy["customIDs"] = customIDs;
        }
        return copy;
    };
    return BootstrapValidator;
}();
module.exports.default = $53aef0e7a8c7517e$var$BootstrapValidator;

});


parcelRegister("5kBGP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.verifySDKKeyUsed = void 0;

var $e4B2M = parcelRequire("e4B2M");

var $6Bvad = parcelRequire("6Bvad");
function $3e1c0e6d82944a91$var$verifySDKKeyUsed(json, sdkKey, errorBoundary) {
    var hashedSDKKeyUsed = json === null || json === void 0 ? void 0 : json.hashed_sdk_key_used;
    if (hashedSDKKeyUsed != null && hashedSDKKeyUsed !== (0, $6Bvad.SimpleHash)(sdkKey !== null && sdkKey !== void 0 ? sdkKey : "")) {
        errorBoundary._logError("fetchAndSaveValues", new $e4B2M.StatsigSDKKeyMismatchError("The SDK key provided does not match the one used to generate values."));
        return false;
    }
    return true;
}
module.exports.verifySDKKeyUsed = $3e1c0e6d82944a91$var$verifySDKKeyUsed;

});

parcelRegister("03ZVc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.difference = module.exports.now = void 0;
function $00c0504641c89f95$var$now() {
    if (typeof performance === "undefined" || !performance) return Date.now();
    return performance.now() | 0;
}
module.exports.now = $00c0504641c89f95$var$now;
function $00c0504641c89f95$var$difference(time) {
    return $00c0504641c89f95$var$now() - time;
}
module.exports.difference = $00c0504641c89f95$var$difference;

});

parcelRegister("4inhx", function(module, exports) {
"use strict";
var $320ae722e83b07d5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.saveOverridesToLocalStorage = module.exports.loadOverridesFromLocalStorage = module.exports.makeEmptyOverrides = module.exports.STORAGE_KEY = void 0;

var $320ae722e83b07d5$var$StatsigLocalStorage_1 = $320ae722e83b07d5$var$__importDefault((parcelRequire("jdP7e")));
module.exports.STORAGE_KEY = "STATSIG_JS_LITE_LOCAL_OVERRIDES";
function $320ae722e83b07d5$var$makeEmptyOverrides() {
    return {
        gates: {},
        configs: {},
        layers: {}
    };
}
module.exports.makeEmptyOverrides = $320ae722e83b07d5$var$makeEmptyOverrides;
function $320ae722e83b07d5$var$loadOverridesFromLocalStorage() {
    var raw = $320ae722e83b07d5$var$StatsigLocalStorage_1.default.getItem(module.exports.STORAGE_KEY);
    if (raw) try {
        return JSON.parse(raw);
    } catch (error) {
    // noop
    }
    return $320ae722e83b07d5$var$makeEmptyOverrides();
}
module.exports.loadOverridesFromLocalStorage = $320ae722e83b07d5$var$loadOverridesFromLocalStorage;
function $320ae722e83b07d5$var$saveOverridesToLocalStorage(overrides) {
    $320ae722e83b07d5$var$StatsigLocalStorage_1.default.setItem(module.exports.STORAGE_KEY, JSON.stringify(overrides));
}
module.exports.saveOverridesToLocalStorage = $320ae722e83b07d5$var$saveOverridesToLocalStorage;

});



parcelRegister("1tAmr", function(module, exports) {

$parcel$export(module.exports, "isFedRamp", function () { return $1134b46c8fb3cc88$export$64d6499adf9b2e51; });

var $8BbMq = parcelRequire("8BbMq");
function $1134b46c8fb3cc88$export$64d6499adf9b2e51() {
    var _global$location;
    var global = globalThis;
    // MICROS_PERIMETER is already used by few products, so we need to keep it for backward compatibility
    var env = global.MICROS_PERIMETER || global.UNSAFE_ATL_CONTEXT_BOUNDARY;
    if (env) return env === (0, $8BbMq.FEDRAMP_MODERATE);
    var matches = (_global$location = global.location) === null || _global$location === void 0 || (_global$location = _global$location.hostname) === null || _global$location === void 0 ? void 0 : _global$location.match(/atlassian-us-gov-mod\.(com|net)|atlassian-us-gov\.(com|net)|atlassian-fex\.(com|net)|atlassian-stg-fedm\.(com|net)/);
    return matches ? matches.length > 0 : false;
}

});
parcelRegister("8BbMq", function(module, exports) {

$parcel$export(module.exports, "FEDRAMP_MODERATE", function () { return $642aeab8c86151d1$export$ce553301d55c2fd8; });
var $642aeab8c86151d1$export$ce553301d55c2fd8 = "fedramp-moderate";
var $642aeab8c86151d1$export$f005e2e9f707cb5f = "commercial";
var $642aeab8c86151d1$export$bd6b5a7802d76127 = "fedramp-fedex";
var $642aeab8c86151d1$export$a739cd5aac835909 = "stg";
var $642aeab8c86151d1$export$42dd0cdd351a4a9 = "prod";
var $642aeab8c86151d1$export$404582bc18fe4d9e = "dev";

});


parcelRegister("1LBry", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $149739b255f52f8e$export$2e2bcd8739ae039; });

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $6bkHe = parcelRequire("6bkHe");

var $c2zYg = parcelRequire("c2zYg");
function $149739b255f52f8e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149739b255f52f8e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149739b255f52f8e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149739b255f52f8e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $149739b255f52f8e$export$a66cbd9b2289cd78 = "@all-features";
var $149739b255f52f8e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Subscriptions() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Subscriptions);
        (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(this, "eventToValue", new Map());
        this.emitter = new (0, $c2zYg.EventEmitter2)();
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Subscriptions, [
        {
            key: "onGateUpdated",
            value: function onGateUpdated(gateName, callback, checkGate, options) {
                var _this = this;
                var value = checkGate(gateName, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                    fireGateExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = checkGate(gateName, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                        fireGateExposure: false
                    }));
                    var existingValue = _this.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(gateName, wrapCallback);
                return function() {
                    _this.emitter.off(gateName, wrapCallback);
                };
            }
        },
        {
            key: "onExperimentValueUpdated",
            value: function onExperimentValueUpdated(experimentName, parameterName, defaultValue, callback, getExperimentValue, options) {
                var _this2 = this;
                var experimentEventName = "".concat(experimentName, ".").concat(parameterName);
                var value = getExperimentValue(experimentName, parameterName, defaultValue, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                    fireExperimentExposure: false
                }));
                if (this.eventToValue.get(callback) === undefined) this.eventToValue.set(callback, value);
                var wrapCallback = function wrapCallback() {
                    var value = getExperimentValue(experimentName, parameterName, defaultValue, $149739b255f52f8e$var$_objectSpread($149739b255f52f8e$var$_objectSpread({}, options), {}, {
                        fireExperimentExposure: false
                    }));
                    var existingValue = _this2.eventToValue.get(callback);
                    if (existingValue !== value) {
                        _this2.eventToValue.set(callback, value);
                        callback(value);
                    }
                };
                this.emitter.on(experimentEventName, wrapCallback);
                return function() {
                    _this2.emitter.off(experimentEventName, wrapCallback);
                };
            }
        },
        {
            key: "onAnyUpdated",
            value: function onAnyUpdated(callback) {
                var _this3 = this;
                this.emitter.on($149739b255f52f8e$export$a66cbd9b2289cd78, callback);
                return function() {
                    _this3.emitter.off($149739b255f52f8e$export$a66cbd9b2289cd78, callback);
                };
            }
        },
        {
            key: "anyUpdated",
            value: function anyUpdated() {
                var _this4 = this;
                this.emitter.emit($149739b255f52f8e$export$a66cbd9b2289cd78);
                this.emitter.eventNames().filter(function(name) {
                    return name !== $149739b255f52f8e$export$a66cbd9b2289cd78;
                }).forEach(function(event) {
                    _this4.emitter.emit(event);
                });
            }
        }
    ]);
    return Subscriptions;
}();

});
parcelRegister("c2zYg", function(module, exports) {

var $1RdT6 = parcelRequire("1RdT6");
!function(undefined) {
    var isArray = Array.isArray ? Array.isArray : function _isArray(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
    };
    var defaultMaxListeners = 10;
    function init() {
        this._events = {};
        if (this._conf) configure.call(this, this._conf);
    }
    function configure(conf) {
        if (conf) {
            this._conf = conf;
            conf.delimiter && (this.delimiter = conf.delimiter);
            this._maxListeners = conf.maxListeners !== undefined ? conf.maxListeners : defaultMaxListeners;
            conf.wildcard && (this.wildcard = conf.wildcard);
            conf.newListener && (this.newListener = conf.newListener);
            conf.verboseMemoryLeak && (this.verboseMemoryLeak = conf.verboseMemoryLeak);
            if (this.wildcard) this.listenerTree = {};
        } else this._maxListeners = defaultMaxListeners;
    }
    function logPossibleMemoryLeak(count, eventName) {
        var errorMsg = "(node) warning: possible EventEmitter memory leak detected. " + count + " listeners added. " + "Use emitter.setMaxListeners() to increase limit.";
        if (this.verboseMemoryLeak) errorMsg += " Event name: " + eventName + ".";
        if (typeof $1RdT6 !== "undefined" && $1RdT6.emitWarning) {
            var e = new Error(errorMsg);
            e.name = "MaxListenersExceededWarning";
            e.emitter = this;
            e.count = count;
            $1RdT6.emitWarning(e);
        } else {
            console.error(errorMsg);
            if (console.trace) console.trace();
        }
    }
    function EventEmitter(conf) {
        this._events = {};
        this.newListener = false;
        this.verboseMemoryLeak = false;
        configure.call(this, conf);
    }
    EventEmitter.EventEmitter2 = EventEmitter; // backwards compatibility for exporting EventEmitter property
    //
    // Attention, function return type now is array, always !
    // It has zero elements if no any matches found and one or more
    // elements (leafs) if there are matches
    //
    function searchListenerTree(handlers, type, tree, i) {
        if (!tree) return [];
        var listeners = [], leaf, len, branch, xTree, xxTree, isolatedBranch, endReached, typeLength = type.length, currentType = type[i], nextType = type[i + 1];
        if (i === typeLength && tree._listeners) {
            //
            // If at the end of the event(s) list and the tree has listeners
            // invoke those listeners.
            //
            if (typeof tree._listeners === "function") {
                handlers && handlers.push(tree._listeners);
                return [
                    tree
                ];
            } else {
                for(leaf = 0, len = tree._listeners.length; leaf < len; leaf++)handlers && handlers.push(tree._listeners[leaf]);
                return [
                    tree
                ];
            }
        }
        if (currentType === "*" || currentType === "**" || tree[currentType]) {
            //
            // If the event emitted is '*' at this part
            // or there is a concrete match at this patch
            //
            if (currentType === "*") {
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 1));
                return listeners;
            } else if (currentType === "**") {
                endReached = i + 1 === typeLength || i + 2 === typeLength && nextType === "*";
                if (endReached && tree._listeners) // The next element has a _listeners, add it to the handlers.
                listeners = listeners.concat(searchListenerTree(handlers, type, tree, typeLength));
                for(branch in tree)if (branch !== "_listeners" && tree.hasOwnProperty(branch)) {
                    if (branch === "*" || branch === "**") {
                        if (tree[branch]._listeners && !endReached) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], typeLength));
                        listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                    } else if (branch === nextType) listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i + 2));
                    else // No match on this one, shift into the tree but not in the type array.
                    listeners = listeners.concat(searchListenerTree(handlers, type, tree[branch], i));
                }
                return listeners;
            }
            listeners = listeners.concat(searchListenerTree(handlers, type, tree[currentType], i + 1));
        }
        xTree = tree["*"];
        if (xTree) //
        // If the listener tree will allow any match for this part,
        // then recursively explore all branches of the tree
        //
        searchListenerTree(handlers, type, xTree, i + 1);
        xxTree = tree["**"];
        if (xxTree) {
            if (i < typeLength) {
                if (xxTree._listeners) // If we have a listener on a '**', it will catch all, so add its handler.
                searchListenerTree(handlers, type, xxTree, typeLength);
                // Build arrays of matching next branches and others.
                for(branch in xxTree)if (branch !== "_listeners" && xxTree.hasOwnProperty(branch)) {
                    if (branch === nextType) // We know the next element will match, so jump twice.
                    searchListenerTree(handlers, type, xxTree[branch], i + 2);
                    else if (branch === currentType) // Current node matches, move into the tree.
                    searchListenerTree(handlers, type, xxTree[branch], i + 1);
                    else {
                        isolatedBranch = {};
                        isolatedBranch[branch] = xxTree[branch];
                        searchListenerTree(handlers, type, {
                            "**": isolatedBranch
                        }, i + 1);
                    }
                }
            } else if (xxTree._listeners) // We have reached the end and still on a '**'
            searchListenerTree(handlers, type, xxTree, typeLength);
            else if (xxTree["*"] && xxTree["*"]._listeners) searchListenerTree(handlers, type, xxTree["*"], typeLength);
        }
        return listeners;
    }
    function growListenerTree(type, listener) {
        type = typeof type === "string" ? type.split(this.delimiter) : type.slice();
        //
        // Looks for two consecutive '**', if so, don't add the event at all.
        //
        for(var i = 0, len = type.length; i + 1 < len; i++){
            if (type[i] === "**" && type[i + 1] === "**") return;
        }
        var tree = this.listenerTree;
        var name = type.shift();
        while(name !== undefined){
            if (!tree[name]) tree[name] = {};
            tree = tree[name];
            if (type.length === 0) {
                if (!tree._listeners) tree._listeners = listener;
                else {
                    if (typeof tree._listeners === "function") tree._listeners = [
                        tree._listeners
                    ];
                    tree._listeners.push(listener);
                    if (!tree._listeners.warned && this._maxListeners > 0 && tree._listeners.length > this._maxListeners) {
                        tree._listeners.warned = true;
                        logPossibleMemoryLeak.call(this, tree._listeners.length, name);
                    }
                }
                return true;
            }
            name = type.shift();
        }
        return true;
    }
    // By default EventEmitters will print a warning if more than
    // 10 listeners are added to it. This is a useful default which
    // helps finding memory leaks.
    //
    // Obviously not all Emitters should be limited to 10. This function allows
    // that to be increased. Set to zero for unlimited.
    EventEmitter.prototype.delimiter = ".";
    EventEmitter.prototype.setMaxListeners = function(n) {
        if (n !== undefined) {
            this._maxListeners = n;
            if (!this._conf) this._conf = {};
            this._conf.maxListeners = n;
        }
    };
    EventEmitter.prototype.event = "";
    EventEmitter.prototype.once = function(event, fn) {
        return this._once(event, fn, false);
    };
    EventEmitter.prototype.prependOnceListener = function(event, fn) {
        return this._once(event, fn, true);
    };
    EventEmitter.prototype._once = function(event, fn, prepend) {
        this._many(event, 1, fn, prepend);
        return this;
    };
    EventEmitter.prototype.many = function(event, ttl, fn) {
        return this._many(event, ttl, fn, false);
    };
    EventEmitter.prototype.prependMany = function(event, ttl, fn) {
        return this._many(event, ttl, fn, true);
    };
    EventEmitter.prototype._many = function(event, ttl, fn, prepend) {
        var self = this;
        if (typeof fn !== "function") throw new Error("many only accepts instances of Function");
        function listener() {
            if (--ttl === 0) self.off(event, listener);
            return fn.apply(this, arguments);
        }
        listener._origin = fn;
        this._on(event, listener, prepend);
        return self;
    };
    EventEmitter.prototype.emit = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return false;
        }
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all && this._all.length) {
            handler = this._all.slice();
            if (al > 3) {
                args = new Array(al);
                for(j = 0; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this, type);
                        break;
                    case 2:
                        handler[i].call(this, type, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, type, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else {
            handler = this._events[type];
            if (typeof handler === "function") {
                this.event = type;
                switch(al){
                    case 1:
                        handler.call(this);
                        break;
                    case 2:
                        handler.call(this, arguments[1]);
                        break;
                    case 3:
                        handler.call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        args = new Array(al - 1);
                        for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                        handler.apply(this, args);
                }
                return true;
            } else if (handler) // need to make copy of handlers because list can change in the middle
            // of emit call
            handler = handler.slice();
        }
        if (handler && handler.length) {
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        handler[i].call(this);
                        break;
                    case 2:
                        handler[i].call(this, arguments[1]);
                        break;
                    case 3:
                        handler[i].call(this, arguments[1], arguments[2]);
                        break;
                    default:
                        handler[i].apply(this, args);
                }
            }
            return true;
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) throw arguments[1]; // Unhandled 'error' event
            else throw new Error("Uncaught, unspecified 'error' event.");
            return false;
        }
        return !!this._all;
    };
    EventEmitter.prototype.emitAsync = function() {
        this._events || init.call(this);
        var type = arguments[0];
        if (type === "newListener" && !this.newListener) {
            if (!this._events.newListener) return Promise.resolve([
                false
            ]);
        }
        var promises = [];
        var al = arguments.length;
        var args, l, i, j;
        var handler;
        if (this._all) {
            if (al > 3) {
                args = new Array(al);
                for(j = 1; j < al; j++)args[j] = arguments[j];
            }
            for(i = 0, l = this._all.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(this._all[i].call(this, type));
                        break;
                    case 2:
                        promises.push(this._all[i].call(this, type, arguments[1]));
                        break;
                    case 3:
                        promises.push(this._all[i].call(this, type, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(this._all[i].apply(this, args));
                }
            }
        }
        if (this.wildcard) {
            handler = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handler, ns, this.listenerTree, 0);
        } else handler = this._events[type];
        if (typeof handler === "function") {
            this.event = type;
            switch(al){
                case 1:
                    promises.push(handler.call(this));
                    break;
                case 2:
                    promises.push(handler.call(this, arguments[1]));
                    break;
                case 3:
                    promises.push(handler.call(this, arguments[1], arguments[2]));
                    break;
                default:
                    args = new Array(al - 1);
                    for(j = 1; j < al; j++)args[j - 1] = arguments[j];
                    promises.push(handler.apply(this, args));
            }
        } else if (handler && handler.length) {
            handler = handler.slice();
            if (al > 3) {
                args = new Array(al - 1);
                for(j = 1; j < al; j++)args[j - 1] = arguments[j];
            }
            for(i = 0, l = handler.length; i < l; i++){
                this.event = type;
                switch(al){
                    case 1:
                        promises.push(handler[i].call(this));
                        break;
                    case 2:
                        promises.push(handler[i].call(this, arguments[1]));
                        break;
                    case 3:
                        promises.push(handler[i].call(this, arguments[1], arguments[2]));
                        break;
                    default:
                        promises.push(handler[i].apply(this, args));
                }
            }
        } else if (!this._all && type === "error") {
            if (arguments[1] instanceof Error) return Promise.reject(arguments[1]); // Unhandled 'error' event
            else return Promise.reject("Uncaught, unspecified 'error' event.");
        }
        return Promise.all(promises);
    };
    EventEmitter.prototype.on = function(type, listener) {
        return this._on(type, listener, false);
    };
    EventEmitter.prototype.prependListener = function(type, listener) {
        return this._on(type, listener, true);
    };
    EventEmitter.prototype.onAny = function(fn) {
        return this._onAny(fn, false);
    };
    EventEmitter.prototype.prependAny = function(fn) {
        return this._onAny(fn, true);
    };
    EventEmitter.prototype.addListener = EventEmitter.prototype.on;
    EventEmitter.prototype._onAny = function(fn, prepend) {
        if (typeof fn !== "function") throw new Error("onAny only accepts instances of Function");
        if (!this._all) this._all = [];
        // Add the function to the event listener collection.
        if (prepend) this._all.unshift(fn);
        else this._all.push(fn);
        return this;
    };
    EventEmitter.prototype._on = function(type, listener, prepend) {
        if (typeof type === "function") {
            this._onAny(type, listener);
            return this;
        }
        if (typeof listener !== "function") throw new Error("on only accepts instances of Function");
        this._events || init.call(this);
        // To avoid recursion in the case that type == "newListeners"! Before
        // adding it to the listeners, first emit "newListeners".
        this.emit("newListener", type, listener);
        if (this.wildcard) {
            growListenerTree.call(this, type, listener);
            return this;
        }
        if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
        this._events[type] = listener;
        else {
            if (typeof this._events[type] === "function") // Change to array.
            this._events[type] = [
                this._events[type]
            ];
            // If we've already got an array, just add
            if (prepend) this._events[type].unshift(listener);
            else this._events[type].push(listener);
            // Check for listener leak
            if (!this._events[type].warned && this._maxListeners > 0 && this._events[type].length > this._maxListeners) {
                this._events[type].warned = true;
                logPossibleMemoryLeak.call(this, this._events[type].length, type);
            }
        }
        return this;
    };
    EventEmitter.prototype.off = function(type, listener) {
        if (typeof listener !== "function") throw new Error("removeListener only takes instances of Function");
        var handlers, leafs = [];
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
        } else {
            // does not use listeners(), so no side effect of creating _events[type]
            if (!this._events[type]) return this;
            handlers = this._events[type];
            leafs.push({
                _listeners: handlers
            });
        }
        for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
            var leaf = leafs[iLeaf];
            handlers = leaf._listeners;
            if (isArray(handlers)) {
                var position = -1;
                for(var i = 0, length = handlers.length; i < length; i++)if (handlers[i] === listener || handlers[i].listener && handlers[i].listener === listener || handlers[i]._origin && handlers[i]._origin === listener) {
                    position = i;
                    break;
                }
                if (position < 0) continue;
                if (this.wildcard) leaf._listeners.splice(position, 1);
                else this._events[type].splice(position, 1);
                if (handlers.length === 0) {
                    if (this.wildcard) delete leaf._listeners;
                    else delete this._events[type];
                }
                this.emit("removeListener", type, listener);
                return this;
            } else if (handlers === listener || handlers.listener && handlers.listener === listener || handlers._origin && handlers._origin === listener) {
                if (this.wildcard) delete leaf._listeners;
                else delete this._events[type];
                this.emit("removeListener", type, listener);
            }
        }
        function recursivelyGarbageCollect(root) {
            if (root === undefined) return;
            var keys = Object.keys(root);
            for(var i in keys){
                var key = keys[i];
                var obj = root[key];
                if (obj instanceof Function || typeof obj !== "object" || obj === null) continue;
                if (Object.keys(obj).length > 0) recursivelyGarbageCollect(root[key]);
                if (Object.keys(obj).length === 0) delete root[key];
            }
        }
        recursivelyGarbageCollect(this.listenerTree);
        return this;
    };
    EventEmitter.prototype.offAny = function(fn) {
        var i = 0, l = 0, fns;
        if (fn && this._all && this._all.length > 0) {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)if (fn === fns[i]) {
                fns.splice(i, 1);
                this.emit("removeListenerAny", fn);
                return this;
            }
        } else {
            fns = this._all;
            for(i = 0, l = fns.length; i < l; i++)this.emit("removeListenerAny", fns[i]);
            this._all = [];
        }
        return this;
    };
    EventEmitter.prototype.removeListener = EventEmitter.prototype.off;
    EventEmitter.prototype.removeAllListeners = function(type) {
        if (arguments.length === 0) {
            !this._events || init.call(this);
            return this;
        }
        if (this.wildcard) {
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            var leafs = searchListenerTree.call(this, null, ns, this.listenerTree, 0);
            for(var iLeaf = 0; iLeaf < leafs.length; iLeaf++){
                var leaf = leafs[iLeaf];
                leaf._listeners = null;
            }
        } else if (this._events) this._events[type] = null;
        return this;
    };
    EventEmitter.prototype.listeners = function(type) {
        if (this.wildcard) {
            var handlers = [];
            var ns = typeof type === "string" ? type.split(this.delimiter) : type.slice();
            searchListenerTree.call(this, handlers, ns, this.listenerTree, 0);
            return handlers;
        }
        this._events || init.call(this);
        if (!this._events[type]) this._events[type] = [];
        if (!isArray(this._events[type])) this._events[type] = [
            this._events[type]
        ];
        return this._events[type];
    };
    EventEmitter.prototype.eventNames = function() {
        return Object.keys(this._events);
    };
    EventEmitter.prototype.listenerCount = function(type) {
        return this.listeners(type).length;
    };
    EventEmitter.prototype.listenersAny = function() {
        if (this._all) return this._all;
        else return [];
    };
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define(function() {
        return EventEmitter;
    });
    else // CommonJS
    module.exports = EventEmitter;
}();

});


parcelRegister("fHUq5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6f6a2f5dec24b1f$export$2e2bcd8739ae039; });

var $6bkHe = parcelRequire("6bkHe");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $51qEW = parcelRequire("51qEW");

var $g1oWB = parcelRequire("g1oWB");

var $il9LQ = parcelRequire("il9LQ");
function $b6f6a2f5dec24b1f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6f6a2f5dec24b1f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6f6a2f5dec24b1f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6f6a2f5dec24b1f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $b6f6a2f5dec24b1f$var$DEFAULT_REQUEST_TIMEOUT_MS = 5000;
var $b6f6a2f5dec24b1f$export$250a58ecde616daa = "https://api.atlassian.com/flags";
var $b6f6a2f5dec24b1f$export$942ba04389b0d5a2 = "https://api.stg.atlassian.com/flags";
var $b6f6a2f5dec24b1f$export$f058dbf75c3bc647 = "https://api.dev.atlassian.com/flags";
var $b6f6a2f5dec24b1f$export$1a401a0da8da3565 = "https://api.stg.atlassian-us-gov-mod.com/flags";
var $b6f6a2f5dec24b1f$export$18c93900db9358a4 = "https://api.atlassian-us-gov-mod.com/flags";
var $b6f6a2f5dec24b1f$export$450bd8fb2a6d7ace = "/gateway/api/flags";
var $b6f6a2f5dec24b1f$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Fetcher() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, Fetcher);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(Fetcher, null, [
        {
            key: "fetchClientSdk",
            value: function() {
                var _fetchClientSdk = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(fetcherOptions) {
                    var targetApp, url;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                targetApp = fetcherOptions.targetApp;
                                url = "/api/v2/frontend/clientSdkKey/".concat(targetApp);
                                _context.prev = 2;
                                _context.next = 5;
                                return this.fetchRequest(url, "GET", fetcherOptions);
                            case 5:
                                return _context.abrupt("return", _context.sent);
                            case 8:
                                _context.prev = 8;
                                _context.t0 = _context["catch"](2);
                                if (!(_context.t0 instanceof Error)) {
                                    _context.next = 12;
                                    break;
                                }
                                throw _context.t0;
                            case 12:
                                throw Error("Failed to retrieve client sdk key");
                            case 13:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee, this, [
                        [
                            2,
                            8
                        ]
                    ]);
                }));
                function fetchClientSdk(_x) {
                    return _fetchClientSdk.apply(this, arguments);
                }
                return fetchClientSdk;
            }()
        },
        {
            key: "fetchExperimentValues",
            value: function() {
                var _fetchExperimentValues = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee2(fetcherOptions, identifiers, customAttributes) {
                    var requestBody;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee2$(_context2) {
                        while(true)switch(_context2.prev = _context2.next){
                            case 0:
                                requestBody = {
                                    identifiers: identifiers,
                                    customAttributes: customAttributes,
                                    targetApp: fetcherOptions.targetApp
                                };
                                _context2.prev = 1;
                                _context2.next = 4;
                                return this.fetchRequest("/api/v2/frontend/experimentValues", "POST", fetcherOptions, requestBody);
                            case 4:
                                return _context2.abrupt("return", _context2.sent);
                            case 7:
                                _context2.prev = 7;
                                _context2.t0 = _context2["catch"](1);
                                if (!(_context2.t0 instanceof Error)) {
                                    _context2.next = 11;
                                    break;
                                }
                                throw _context2.t0;
                            case 11:
                                throw Error("Failed to retrieve experiment values");
                            case 12:
                            case "end":
                                return _context2.stop();
                        }
                    }, _callee2, this, [
                        [
                            1,
                            7
                        ]
                    ]);
                }));
                function fetchExperimentValues(_x2, _x3, _x4) {
                    return _fetchExperimentValues.apply(this, arguments);
                }
                return fetchExperimentValues;
            }()
        },
        {
            key: "handleResponseError",
            value: function() {
                var _handleResponseError = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee3(response) {
                    var body;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee3$(_context3) {
                        while(true)switch(_context3.prev = _context3.next){
                            case 0:
                                if (response.ok) {
                                    _context3.next = 5;
                                    break;
                                }
                                _context3.next = 3;
                                return response.text();
                            case 3:
                                body = _context3.sent;
                                throw new (0, $il9LQ.ResponseError)("Non 2xx response status received, status: ".concat(response.status, ", body: ").concat(JSON.stringify(body)));
                            case 5:
                                if (!(response.status === 204)) {
                                    _context3.next = 7;
                                    break;
                                }
                                throw new (0, $il9LQ.ResponseError)("Unexpected 204 response");
                            case 7:
                            case "end":
                                return _context3.stop();
                        }
                    }, _callee3);
                }));
                function handleResponseError(_x5) {
                    return _handleResponseError.apply(this, arguments);
                }
                return handleResponseError;
            }()
        },
        {
            key: "extractResponseBody",
            value: function() {
                var _extractResponseBody = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee4(response) {
                    var value;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee4$(_context4) {
                        while(true)switch(_context4.prev = _context4.next){
                            case 0:
                                _context4.next = 2;
                                return response.text();
                            case 2:
                                value = _context4.sent;
                                return _context4.abrupt("return", JSON.parse(value));
                            case 4:
                            case "end":
                                return _context4.stop();
                        }
                    }, _callee4);
                }));
                function extractResponseBody(_x6) {
                    return _extractResponseBody.apply(this, arguments);
                }
                return extractResponseBody;
            }()
        },
        {
            key: "getBaseUrl",
            value: function getBaseUrl(serviceEnv) {
                var useGatewayUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                var perimeter = arguments.length > 2 ? arguments[2] : undefined;
                if (useGatewayUrl) return $b6f6a2f5dec24b1f$export$450bd8fb2a6d7ace;
                if (perimeter === (0, $51qEW.PerimeterType).FEDRAMP_MODERATE) switch(serviceEnv){
                    case (0, $51qEW.FeatureGateEnvironment).Production:
                        return $b6f6a2f5dec24b1f$export$18c93900db9358a4;
                    case (0, $51qEW.FeatureGateEnvironment).Staging:
                        return $b6f6a2f5dec24b1f$export$1a401a0da8da3565;
                    default:
                        throw new Error('Invalid environment "'.concat(serviceEnv, '" for "').concat(perimeter, '" perimeter'));
                }
                else if (perimeter === (0, $51qEW.PerimeterType).COMMERCIAL) switch(serviceEnv){
                    case (0, $51qEW.FeatureGateEnvironment).Development:
                        return $b6f6a2f5dec24b1f$export$f058dbf75c3bc647;
                    case (0, $51qEW.FeatureGateEnvironment).Staging:
                        return $b6f6a2f5dec24b1f$export$942ba04389b0d5a2;
                    default:
                        return $b6f6a2f5dec24b1f$export$250a58ecde616daa;
                }
                else throw new Error('Invalid perimeter "'.concat(perimeter, '"'));
            }
        },
        {
            key: "fetchRequest",
            value: function() {
                var _fetchRequest = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee5(path, method, fetcherOptions, body) {
                    var baseUrl, fetchTimeout, abortSignal, abortController, response;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee5$(_context5) {
                        while(true)switch(_context5.prev = _context5.next){
                            case 0:
                                baseUrl = Fetcher.getBaseUrl(fetcherOptions.environment, fetcherOptions.useGatewayURL, fetcherOptions.perimeter);
                                fetchTimeout = fetcherOptions.fetchTimeoutMs || $b6f6a2f5dec24b1f$var$DEFAULT_REQUEST_TIMEOUT_MS;
                                if (AbortSignal.timeout) abortSignal = AbortSignal.timeout(fetchTimeout);
                                else if (AbortController) {
                                    abortController = new AbortController();
                                    abortSignal = abortController.signal;
                                    setTimeout(function() {
                                        return abortController.abort();
                                    }, fetchTimeout);
                                }
                                _context5.next = 5;
                                return fetch("".concat(baseUrl).concat(path), $b6f6a2f5dec24b1f$var$_objectSpread({
                                    method: method,
                                    headers: {
                                        "Content-Type": "application/json",
                                        "X-Client-Name": "feature-gate-js-client",
                                        "X-Client-Version": (0, $g1oWB.CLIENT_VERSION),
                                        "X-API-KEY": fetcherOptions.apiKey
                                    },
                                    signal: abortSignal
                                }, body && {
                                    body: JSON.stringify(body)
                                }));
                            case 5:
                                response = _context5.sent;
                                _context5.next = 8;
                                return this.handleResponseError(response);
                            case 8:
                                _context5.next = 10;
                                return this.extractResponseBody(response);
                            case 10:
                                return _context5.abrupt("return", _context5.sent);
                            case 11:
                            case "end":
                                return _context5.stop();
                        }
                    }, _callee5, this);
                }));
                function fetchRequest(_x7, _x8, _x9, _x10) {
                    return _fetchRequest.apply(this, arguments);
                }
                return fetchRequest;
            }()
        }
    ]);
    return Fetcher;
}();

});
parcelRegister("51qEW", function(module, exports) {

$parcel$export(module.exports, "FeatureGateEnvironment", function () { return $3a81b9c044a39023$export$479e7351a733299; });
$parcel$export(module.exports, "PerimeterType", function () { return $3a81b9c044a39023$export$c42b7bbc5e7ba555; });
/**
 * The identifiers for the user. Options are restricted to the set that is currently supported.
 */ /**
 * Base client options. Does not include any options specific to providers
 * @interface BaseClientOptions
 * @property {FeatureGateEnvironment} environment - The environment for the client.
 * @property {string} targetApp - The target app for the client.
 * @property {AnalyticsWebClient} analyticsWebClient - The analytics web client.
 * @property {PerimeterType} perimeter - The perimeter for the client.
 */ /**
 * The options for the client.
 * @interface ClientOptions
 * @extends {BaseClientOptions}
 * @property {string} apiKey - The API key for the client.
 * @property {fetchTimeoutMs} fetchTimeoutMs - The timeout for the fetch request in milliseconds. Defaults to 5000.
 * @property {boolean} useGatewayURL - Whether to use the gateway URL. Defaults to false.
 */ /**
 * The custom attributes for the user.
 */ var $3a81b9c044a39023$export$479e7351a733299 = /*#__PURE__*/ function(FeatureGateEnvironment) {
    FeatureGateEnvironment["Development"] = "development";
    FeatureGateEnvironment["Staging"] = "staging";
    FeatureGateEnvironment["Production"] = "production";
    return FeatureGateEnvironment;
}({});
var $3a81b9c044a39023$export$c42b7bbc5e7ba555 = /*#__PURE__*/ function(PerimeterType) {
    PerimeterType["COMMERCIAL"] = "commercial";
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
    return PerimeterType;
}({});
var $3a81b9c044a39023$export$42f4885608027d0c = "non_boolean";

});

parcelRegister("g1oWB", function(module, exports) {

$parcel$export(module.exports, "CLIENT_VERSION", function () { return $baa016bc27589a40$export$a59f8d67326bd1cb; });
/// <reference types="node" />
var $baa016bc27589a40$export$a59f8d67326bd1cb = "4.23.0";

});

parcelRegister("il9LQ", function(module, exports) {

$parcel$export(module.exports, "ResponseError", function () { return $d5a1c468b9a2d8bd$export$286baf652d0b1206; });

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $3Fq9h = parcelRequire("3Fq9h");
function $d5a1c468b9a2d8bd$var$_createSuper(t) {
    var r = $d5a1c468b9a2d8bd$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $d5a1c468b9a2d8bd$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($d5a1c468b9a2d8bd$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $d5a1c468b9a2d8bd$export$286baf652d0b1206 = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(ResponseError, _Error);
    var _super = $d5a1c468b9a2d8bd$var$_createSuper(ResponseError);
    function ResponseError(message) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ResponseError);
        return _super.call(this, message);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ResponseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3Fq9h)))(Error));

});




parcelRegister("gjw2g", function(module, exports) {

$parcel$export(module.exports, "AidFrontendFeatureGate", function () { return $f7fc6a0b911c7319$export$e2b0cf8c8e2eb757; });
var $f7fc6a0b911c7319$export$e2b0cf8c8e2eb757;
(function(AidFrontendFeatureGate) {
    // https://switcheroo.atlassian.com/ui/gates/e7ac1711-ad22-4973-bc22-fa2ea03821e0/key/_identity_aid_frontend_use_global_page_state
    AidFrontendFeatureGate["SHOULD_USE_GLOBAL_PAGE_STATE"] = "identity-aid-frontend-use-global-page-state";
    // https://switcheroo.atlassian.com/ui/gates/747daf81-87f7-46dc-8ce3-c9e229c6c60f/key/should_fail_open_on_recaptcha_aid-frontend
    AidFrontendFeatureGate["SHOULD_FAIL_OPEN_RECAPTCHA"] = "should_fail_open_on_recaptcha_aid-frontend";
    // TODO remove after resolving HOT-113002
    // https://switcheroo.atlassian.com/ui/gates/b62923fa-9ad8-4aa4-9c00-f265ea08db0d/key/hot-113002_force_checkbox_recaptcha
    AidFrontendFeatureGate["HOT_113002_FORCE_CHECKBOX"] = "hot-113002_force_checkbox_recaptcha";
})($f7fc6a0b911c7319$export$e2b0cf8c8e2eb757 || ($f7fc6a0b911c7319$export$e2b0cf8c8e2eb757 = {}));

});

parcelRegister("1uBrV", function(module, exports) {

$parcel$export(module.exports, "isSasStateEndpointEnabled", function () { return $d92a283854d1de0e$export$ae2c1d86ed68b3d4; });
$parcel$export(module.exports, "usePageState", function () { return $d92a283854d1de0e$export$d2bdb7c20492cc5; });
$parcel$export(module.exports, "isPageStateResult", function () { return $d92a283854d1de0e$export$e76aa5e66969f2de; });
$parcel$export(module.exports, "isRedirectResult", function () { return $d92a283854d1de0e$export$72263c6e24ee9e46; });

var $kvYHH = parcelRequire("kvYHH");

var $1ddmc = parcelRequire("1ddmc");

var $lk8Tl = parcelRequire("lk8Tl");

var $gyRZh = parcelRequire("gyRZh");

var $kOqgB = parcelRequire("kOqgB");

var $8ZuGG = parcelRequire("8ZuGG");

var $imnta = parcelRequire("imnta");
const $d92a283854d1de0e$export$ae2c1d86ed68b3d4 = ()=>false;
const $d92a283854d1de0e$export$d2bdb7c20492cc5 = (path, options = {
    enabled: true
})=>{
    const { enabled: enabled } = options;
    const [searchParams] = (0, $gyRZh.useSearchParams)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const { data: data, isLoading: isLoading, isError: isError, isSuccess: isSuccess, error: error } = (0, $kvYHH.useQuery)({
        queryKey: [
            path
        ],
        refetchOnWindowFocus: false,
        queryFn: async ()=>{
            const params = searchParams.size > 0 ? `?${searchParams.toString()}` : "";
            const response = await (0, $1ddmc.fetchApi)(`${(0, $lk8Tl.idacOrigin)}${path}${params}`);
            return await response.json();
        },
        enabled: enabled
    });
    (0, $8ZuGG.useEffect)(()=>{
        if ($d92a283854d1de0e$export$e76aa5e66969f2de(data)) {
            const { csrfToken: csrfToken, hashedCsrfToken: hashedCsrfToken } = data;
            if (csrfToken) dispatch((0, $imnta.updateCsrfToken)(csrfToken));
            if (hashedCsrfToken) dispatch((0, $imnta.updateHashedCsrfToken)(hashedCsrfToken));
        }
    }, [
        isSuccess,
        data,
        dispatch
    ]);
    return {
        state: data,
        isLoading: isLoading,
        isError: isError,
        isSuccess: isSuccess,
        error: error
    };
};
const $d92a283854d1de0e$export$72263c6e24ee9e46 = (result)=>{
    return (result === null || result === void 0 ? void 0 : result.type) === "redirect";
};
const $d92a283854d1de0e$export$e76aa5e66969f2de = (result)=>{
    return (result === null || result === void 0 ? void 0 : result.type) === "page-state";
};

});
parcelRegister("kvYHH", function(module, exports) {

$parcel$export(module.exports, "useQuery", function () { return $eef5ca6b7ea14356$export$dd0a697e1782aedd; });

var $eyuWU = parcelRequire("eyuWU");
var $koVIV = parcelRequire("koVIV");

var $i8LmD = parcelRequire("i8LmD");
"use client";
function $eef5ca6b7ea14356$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
    return (0, $i8LmD.useBaseQuery)(parsedOptions, (0, $koVIV.QueryObserver));
}

});
parcelRegister("eyuWU", function(module, exports) {

$parcel$export(module.exports, "isServer", function () { return $a98c3f89471fbd4b$export$6acf61af03e62db; });
$parcel$export(module.exports, "noop", function () { return $a98c3f89471fbd4b$export$8793edee2d425525; });
$parcel$export(module.exports, "functionalUpdate", function () { return $a98c3f89471fbd4b$export$7f095f455ad5af3f; });
$parcel$export(module.exports, "isValidTimeout", function () { return $a98c3f89471fbd4b$export$e539f754e934e270; });
$parcel$export(module.exports, "timeUntilStale", function () { return $a98c3f89471fbd4b$export$811b83d62bcf47f0; });
$parcel$export(module.exports, "parseQueryArgs", function () { return $a98c3f89471fbd4b$export$8a11fbc2c8ea08fd; });
$parcel$export(module.exports, "parseFilterArgs", function () { return $a98c3f89471fbd4b$export$18e8f4b987e6c111; });
$parcel$export(module.exports, "matchQuery", function () { return $a98c3f89471fbd4b$export$c5d1efe363797780; });
$parcel$export(module.exports, "hashQueryKeyByOptions", function () { return $a98c3f89471fbd4b$export$cc90ca97bc0d73fd; });
$parcel$export(module.exports, "partialMatchKey", function () { return $a98c3f89471fbd4b$export$2f07189bb9fa26a7; });
$parcel$export(module.exports, "matchMutation", function () { return $a98c3f89471fbd4b$export$a1ea5fb559f63ae3; });
$parcel$export(module.exports, "hashQueryKey", function () { return $a98c3f89471fbd4b$export$5fcb678681417b54; });
$parcel$export(module.exports, "shallowEqualObjects", function () { return $a98c3f89471fbd4b$export$3e67810a3f0e9f1c; });
$parcel$export(module.exports, "sleep", function () { return $a98c3f89471fbd4b$export$e772c8ff12451969; });
$parcel$export(module.exports, "scheduleMicrotask", function () { return $a98c3f89471fbd4b$export$4304cb76768ca134; });
$parcel$export(module.exports, "getAbortController", function () { return $a98c3f89471fbd4b$export$382ca5d13a8f252c; });
$parcel$export(module.exports, "replaceData", function () { return $a98c3f89471fbd4b$export$17619bac5b909b23; });
// TYPES
// UTILS
const $a98c3f89471fbd4b$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $a98c3f89471fbd4b$export$8793edee2d425525() {
    return undefined;
}
function $a98c3f89471fbd4b$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $a98c3f89471fbd4b$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $a98c3f89471fbd4b$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $a98c3f89471fbd4b$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $a98c3f89471fbd4b$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $a98c3f89471fbd4b$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $a98c3f89471fbd4b$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $a98c3f89471fbd4b$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $a98c3f89471fbd4b$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $a98c3f89471fbd4b$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $a98c3f89471fbd4b$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($a98c3f89471fbd4b$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $a98c3f89471fbd4b$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$a98c3f89471fbd4b$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $a98c3f89471fbd4b$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($a98c3f89471fbd4b$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($a98c3f89471fbd4b$export$5fcb678681417b54(mutation.options.mutationKey) !== $a98c3f89471fbd4b$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$a98c3f89471fbd4b$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $a98c3f89471fbd4b$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $a98c3f89471fbd4b$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $a98c3f89471fbd4b$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$a98c3f89471fbd4b$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $a98c3f89471fbd4b$export$2f07189bb9fa26a7(a, b) {
    return $a98c3f89471fbd4b$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $a98c3f89471fbd4b$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$a98c3f89471fbd4b$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $a98c3f89471fbd4b$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $a98c3f89471fbd4b$export$7a8558113332b71e(a) && $a98c3f89471fbd4b$export$7a8558113332b71e(b);
    if (array || $a98c3f89471fbd4b$export$53b83ca8eaab0383(a) && $a98c3f89471fbd4b$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $a98c3f89471fbd4b$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $a98c3f89471fbd4b$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $a98c3f89471fbd4b$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $a98c3f89471fbd4b$export$53b83ca8eaab0383(o) {
    if (!$a98c3f89471fbd4b$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$a98c3f89471fbd4b$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $a98c3f89471fbd4b$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $a98c3f89471fbd4b$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $a98c3f89471fbd4b$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $a98c3f89471fbd4b$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $a98c3f89471fbd4b$export$4304cb76768ca134(callback) {
    $a98c3f89471fbd4b$export$e772c8ff12451969(0).then(callback);
}
function $a98c3f89471fbd4b$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $a98c3f89471fbd4b$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $a98c3f89471fbd4b$export$77a71fc411098696(prevData, data);
    return data;
}

});

parcelRegister("koVIV", function(module, exports) {

$parcel$export(module.exports, "QueryObserver", function () { return $eda2d33ae64a8fec$export$a06cf8c0066f0d4c; });

var $eyuWU = parcelRequire("eyuWU");

var $7iBIE = parcelRequire("7iBIE");

var $efras = parcelRequire("efras");

var $4QQ45 = parcelRequire("4QQ45");

var $hGQfz = parcelRequire("hGQfz");
class $eda2d33ae64a8fec$export$a06cf8c0066f0d4c extends (0, $4QQ45.Subscribable) {
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($eda2d33ae64a8fec$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $eda2d33ae64a8fec$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $eda2d33ae64a8fec$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $eyuWU.shallowEqualObjects)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $eda2d33ae64a8fec$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($eda2d33ae64a8fec$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $eyuWU.noop));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $eyuWU.isServer) || this.currentResult.isStale || !(0, $eyuWU.isValidTimeout)(this.options.staleTime)) return;
        const time = (0, $eyuWU.timeUntilStale)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $eyuWU.isServer) || this.options.enabled === false || !(0, $eyuWU.isValidTimeout)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $efras.focusManager).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $eda2d33ae64a8fec$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $eda2d33ae64a8fec$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $hGQfz.canFetch)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $eyuWU.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $eyuWU.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $eda2d33ae64a8fec$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $eyuWU.shallowEqualObjects)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $hGQfz.isCancelledError)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $7iBIE.notifyManager).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
}
function $eda2d33ae64a8fec$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $eda2d33ae64a8fec$var$shouldFetchOnMount(query, options) {
    return $eda2d33ae64a8fec$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $eda2d33ae64a8fec$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $eda2d33ae64a8fec$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $eda2d33ae64a8fec$var$isStale(query, options);
    }
    return false;
}
function $eda2d33ae64a8fec$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $eda2d33ae64a8fec$var$isStale(query, options);
}
function $eda2d33ae64a8fec$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $eda2d33ae64a8fec$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $eyuWU.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}

});
parcelRegister("7iBIE", function(module, exports) {

$parcel$export(module.exports, "notifyManager", function () { return $5507791a01626ec5$export$520687f44db6e1ab; });

var $eyuWU = parcelRequire("eyuWU");
function $5507791a01626ec5$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $eyuWU.scheduleMicrotask)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $eyuWU.scheduleMicrotask)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $5507791a01626ec5$export$520687f44db6e1ab = $5507791a01626ec5$export$316a8efd03cd1458();

});

parcelRegister("efras", function(module, exports) {

$parcel$export(module.exports, "focusManager", function () { return $a5f78a54d3e37753$export$6bf54661be5b02cf; });

var $4QQ45 = parcelRequire("4QQ45");

var $eyuWU = parcelRequire("eyuWU");
class $a5f78a54d3e37753$export$86f1af424b2ca4de extends (0, $4QQ45.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $eyuWU.isServer) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
}
const $a5f78a54d3e37753$export$6bf54661be5b02cf = new $a5f78a54d3e37753$export$86f1af424b2ca4de();

});
parcelRegister("4QQ45", function(module, exports) {

$parcel$export(module.exports, "Subscribable", function () { return $388467bc05d5b41d$export$d26086b469ecdbcc; });
class $388467bc05d5b41d$export$d26086b469ecdbcc {
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
}

});


parcelRegister("hGQfz", function(module, exports) {

$parcel$export(module.exports, "canFetch", function () { return $ce0ee3b74b0b248e$export$61b92f63f30245cf; });
$parcel$export(module.exports, "isCancelledError", function () { return $ce0ee3b74b0b248e$export$986cc6445c1d323; });
$parcel$export(module.exports, "createRetryer", function () { return $ce0ee3b74b0b248e$export$2cbd00fe8a2c8d85; });

var $efras = parcelRequire("efras");

var $gF9Ao = parcelRequire("gF9Ao");

var $eyuWU = parcelRequire("eyuWU");
function $ce0ee3b74b0b248e$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $ce0ee3b74b0b248e$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $gF9Ao.onlineManager).isOnline() : true;
}
class $ce0ee3b74b0b248e$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $ce0ee3b74b0b248e$export$986cc6445c1d323(value) {
    return value instanceof $ce0ee3b74b0b248e$export$a8430ed4188f35a9;
}
function $ce0ee3b74b0b248e$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $ce0ee3b74b0b248e$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $efras.focusManager).isFocused() || config.networkMode !== "always" && !(0, $gF9Ao.onlineManager).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $ce0ee3b74b0b248e$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $eyuWU.sleep)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($ce0ee3b74b0b248e$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}

});
parcelRegister("gF9Ao", function(module, exports) {

$parcel$export(module.exports, "onlineManager", function () { return $c217e93a8595470f$export$b113e788b2dd3fdc; });

var $4QQ45 = parcelRequire("4QQ45");

var $eyuWU = parcelRequire("eyuWU");
const $c217e93a8595470f$var$onlineEvents = [
    "online",
    "offline"
];
class $c217e93a8595470f$export$58774fb55d5ff7fc extends (0, $4QQ45.Subscribable) {
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $eyuWU.isServer) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $c217e93a8595470f$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $c217e93a8595470f$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
}
const $c217e93a8595470f$export$b113e788b2dd3fdc = new $c217e93a8595470f$export$58774fb55d5ff7fc();

});



parcelRegister("i8LmD", function(module, exports) {

$parcel$export(module.exports, "useBaseQuery", function () { return $d34db6e290374250$export$fff0865807e996c5; });

var $8ZuGG = parcelRequire("8ZuGG");

var $7iBIE = parcelRequire("7iBIE");

var $cxhPV = parcelRequire("cxhPV");

var $5fBdi = parcelRequire("5fBdi");

var $6b5zr = parcelRequire("6b5zr");

var $eqWCb = parcelRequire("eqWCb");

var $2N9lk = parcelRequire("2N9lk");

var $hg7gb = parcelRequire("hg7gb");
"use client";
function $d34db6e290374250$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $6b5zr.useQueryClient)({
        context: options.context
    });
    const isRestoring = (0, $eqWCb.useIsRestoring)();
    const errorResetBoundary = (0, $5fBdi.useQueryErrorResetBoundary)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $7iBIE.notifyManager).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $7iBIE.notifyManager).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $7iBIE.notifyManager).batchCalls(defaultedOptions.onSettled);
    (0, $hg7gb.ensureStaleTime)(defaultedOptions);
    (0, $2N9lk.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, $2N9lk.useClearResetErrorBoundary)(errorResetBoundary);
    const [observer] = $8ZuGG.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $cxhPV.useSyncExternalStore)($8ZuGG.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $7iBIE.notifyManager).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $8ZuGG.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $hg7gb.shouldSuspend)(defaultedOptions, result, isRestoring)) throw (0, $hg7gb.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2N9lk.getHasError)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

});
parcelRegister("cxhPV", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $9206670e189bd477$export$306c0aa65ff9ec16; });

var $hU7R8 = parcelRequire("hU7R8");
"use client";
const $9206670e189bd477$export$306c0aa65ff9ec16 = (0, $hU7R8.useSyncExternalStore);

});

parcelRegister("5fBdi", function(module, exports) {

$parcel$export(module.exports, "useQueryErrorResetBoundary", function () { return $3d2b384b20b10766$export$50dfac555130cafd; });

var $8ZuGG = parcelRequire("8ZuGG");
"use client";
function $3d2b384b20b10766$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $3d2b384b20b10766$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $8ZuGG.createContext($3d2b384b20b10766$var$createValue()); // HOOK
const $3d2b384b20b10766$export$50dfac555130cafd = ()=>$8ZuGG.useContext($3d2b384b20b10766$var$QueryErrorResetBoundaryContext); // COMPONENT
const $3d2b384b20b10766$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $8ZuGG.useState(()=>$3d2b384b20b10766$var$createValue());
    return /*#__PURE__*/ $8ZuGG.createElement($3d2b384b20b10766$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};

});

parcelRegister("6b5zr", function(module, exports) {

$parcel$export(module.exports, "useQueryClient", function () { return $47f8175e7e84905b$export$22e77b9572c4fded; });
$parcel$export(module.exports, "QueryClientProvider", function () { return $47f8175e7e84905b$export$45604f0cc8ae667b; });

var $8ZuGG = parcelRequire("8ZuGG");
"use client";
const $47f8175e7e84905b$export$2fba198b5b2e37fa = /*#__PURE__*/ $8ZuGG.createContext(undefined);
const $47f8175e7e84905b$var$QueryClientSharingContext = /*#__PURE__*/ $8ZuGG.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $47f8175e7e84905b$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $47f8175e7e84905b$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $47f8175e7e84905b$export$2fba198b5b2e37fa;
}
const $47f8175e7e84905b$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $8ZuGG.useContext($47f8175e7e84905b$var$getQueryClientContext(context, $8ZuGG.useContext($47f8175e7e84905b$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $47f8175e7e84905b$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $8ZuGG.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $47f8175e7e84905b$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $8ZuGG.createElement($47f8175e7e84905b$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $8ZuGG.createElement(Context.Provider, {
        value: client
    }, children));
};

});

parcelRegister("eqWCb", function(module, exports) {

$parcel$export(module.exports, "useIsRestoring", function () { return $a820f613d277ea97$export$4da0178d6b5f553; });

var $8ZuGG = parcelRequire("8ZuGG");
"use client";
const $a820f613d277ea97$var$IsRestoringContext = /*#__PURE__*/ $8ZuGG.createContext(false);
const $a820f613d277ea97$export$4da0178d6b5f553 = ()=>$8ZuGG.useContext($a820f613d277ea97$var$IsRestoringContext);
const $a820f613d277ea97$export$593807d4e94f9621 = $a820f613d277ea97$var$IsRestoringContext.Provider;

});

parcelRegister("2N9lk", function(module, exports) {

$parcel$export(module.exports, "ensurePreventErrorBoundaryRetry", function () { return $208767ad9723015c$export$ae8adb3de3d77633; });
$parcel$export(module.exports, "useClearResetErrorBoundary", function () { return $208767ad9723015c$export$b2b17ca3a1fb0229; });
$parcel$export(module.exports, "getHasError", function () { return $208767ad9723015c$export$1fbcf724762d607; });

var $8ZuGG = parcelRequire("8ZuGG");

var $jYVec = parcelRequire("jYVec");
"use client";
const $208767ad9723015c$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $208767ad9723015c$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $8ZuGG.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $208767ad9723015c$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $jYVec.shouldThrowError)(useErrorBoundary, [
        result.error,
        query
    ]);
};

});
parcelRegister("jYVec", function(module, exports) {

$parcel$export(module.exports, "shouldThrowError", function () { return $e8c0033a9931b9e4$export$2072f68e6c3507cf; });
function $e8c0033a9931b9e4$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}

});


parcelRegister("hg7gb", function(module, exports) {

$parcel$export(module.exports, "ensureStaleTime", function () { return $c9098ffa7e492c22$export$2c40a591ad2dafb1; });
$parcel$export(module.exports, "shouldSuspend", function () { return $c9098ffa7e492c22$export$88d3586dfed64df9; });
$parcel$export(module.exports, "fetchOptimistic", function () { return $c9098ffa7e492c22$export$defdc11a9c9acfcf; });
const $c9098ffa7e492c22$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    {
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
    }
};
const $c9098ffa7e492c22$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $c9098ffa7e492c22$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $c9098ffa7e492c22$export$e0a3f29513afe430(result, isRestoring);
const $c9098ffa7e492c22$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });

});



parcelRegister("1ddmc", function(module, exports) {

$parcel$export(module.exports, "fetchApi", function () { return $a1c35d651506ef1d$export$adb4bb4243526aef; });
$parcel$export(module.exports, "ServerErrorException", function () { return $a1c35d651506ef1d$export$173e0be89ecf9709; });

var $8f2pb = parcelRequire("8f2pb");
const $a1c35d651506ef1d$export$adb4bb4243526aef = async (url, headers)=>{
    const response = await fetch(url, {
        headers: {
            "Content-Type": "application/json",
            ...headers
        }
    });
    if (response.status >= 500) {
        const data = await response.json();
        const message = `Failed to fetch ${url} [${response.status} status]`;
        const errorType = (data === null || data === void 0 ? void 0 : data.error) || {
            error: "internal_server_error"
        };
        (0, $8f2pb.captureErrorMessage)(message, data);
        throw new $a1c35d651506ef1d$export$173e0be89ecf9709(message, response.status, errorType);
    }
    return response;
};
class $a1c35d651506ef1d$export$173e0be89ecf9709 extends Error {
    constructor(message, status, errorType){
        super(message);
        this.message = message;
        this.status = status;
        this.errorType = errorType;
        this.name = "ServerErrorException";
    }
}

});

parcelRegister("imnta", function(module, exports) {

$parcel$export(module.exports, "updateCsrfToken", function () { return $2b92f6952af08793$export$527f2c21586e0a0e; });
$parcel$export(module.exports, "updateHashedCsrfToken", function () { return $2b92f6952af08793$export$32d195f109b250f4; });
const $2b92f6952af08793$export$527f2c21586e0a0e = (csrfToken)=>({
        type: "CSRF_TOKEN_UPDATE",
        csrfToken: csrfToken
    });
const $2b92f6952af08793$export$32d195f109b250f4 = (hashedCsrfToken)=>({
        type: "HASHED_CSRF_TOKEN_UPDATE",
        hashedCsrfToken: hashedCsrfToken
    });

});


parcelRegister("6XahI", function(module, exports) {
"use strict";
var $51003b198f03e743$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitialization = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $51003b198f03e743$var$feature_gate_js_client_1 = $51003b198f03e743$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $51003b198f03e743$var$FeatureGatesInitialization = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializingComponent: initializingComponent, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $51003b198f03e743$var$feature_gate_js_client_1.default.initializeCalled() ? $51003b198f03e743$var$feature_gate_js_client_1.default.updateUser(optionsRef.current, identifiers, customAttributes) : $51003b198f03e743$var$feature_gate_js_client_1.default.initialize(optionsRef.current, identifiers, customAttributes);
                initPromise.then(()=>(0, $aGsgY.applyOverrides)(overrides)).catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children, initializingComponent);
};
module.exports.FeatureGatesInitialization = $51003b198f03e743$var$FeatureGatesInitialization;
module.exports.default = module.exports.FeatureGatesInitialization;

});
parcelRegister("boRTX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return (parcelRequire("eF4yw")).default; });
$parcel$export(module.exports, "FeatureGateEnvironment", function () { return (parcelRequire("51qEW")).FeatureGateEnvironment; });
$parcel$export(module.exports, "PerimeterType", function () { return (parcelRequire("51qEW")).PerimeterType; });
$parcel$export(module.exports, "CLIENT_VERSION", function () { return (parcelRequire("g1oWB")).CLIENT_VERSION; });
$parcel$export(module.exports, "DynamicConfig", function () { return (parcelRequire("glkGR")).DynamicConfig; });
$parcel$export(module.exports, "EvaluationReason", function () { return (parcelRequire("glkGR")).EvaluationReason; });
parcelRequire("eF4yw");
var $g1oWB = parcelRequire("g1oWB");
var $eF4yw = parcelRequire("eF4yw");
var $glkGR = parcelRequire("glkGR");
var $51qEW = parcelRequire("51qEW");

});

parcelRegister("aGsgY", function(module, exports) {
"use strict";
var $7c73c20059986bcf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clearOverrides = module.exports.applyOverrides = module.exports.toError = module.exports.pickChildToRender = module.exports.isClientAlreadyInCorrectState = void 0;

const $7c73c20059986bcf$var$react_1 = $7c73c20059986bcf$var$__importDefault((parcelRequire("8ZuGG")));

const $7c73c20059986bcf$var$feature_gate_js_client_1 = $7c73c20059986bcf$var$__importDefault((parcelRequire("boRTX")));
let $7c73c20059986bcf$var$hasWarnedAboutMissingOverrideSupport = false;
function $7c73c20059986bcf$var$isClientAlreadyInCorrectState(identifiers, customAttributes) {
    var _a, _b;
    // If either of these methods don't exist (ie. if the product is using <v4.2.0), then this method will always return false
    return ((_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.initializeCompleted) === null || _a === void 0 ? void 0 : _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default)) && ((_b = $7c73c20059986bcf$var$feature_gate_js_client_1.default.isCurrentUser) === null || _b === void 0 ? void 0 : _b.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, identifiers, customAttributes));
}
module.exports.isClientAlreadyInCorrectState = $7c73c20059986bcf$var$isClientAlreadyInCorrectState;
function $7c73c20059986bcf$var$pickChildToRender(enabled, isInitialized, children, initializingComponent) {
    if (!enabled || isInitialized) return $7c73c20059986bcf$var$react_1.default.createElement($7c73c20059986bcf$var$react_1.default.Fragment, null, children);
    if (initializingComponent != null) return $7c73c20059986bcf$var$react_1.default.createElement($7c73c20059986bcf$var$react_1.default.Fragment, null, initializingComponent);
    return null;
}
module.exports.pickChildToRender = $7c73c20059986bcf$var$pickChildToRender;
function $7c73c20059986bcf$var$toError(err) {
    if (err instanceof Error) return err;
    return new Error(err === null || err === void 0 ? void 0 : err.toString());
}
module.exports.toError = $7c73c20059986bcf$var$toError;
function $7c73c20059986bcf$var$applyOverrides(overrides) {
    // Allow newer versions of the React SDK to be used with older v3.x JS client versions,
    // provided the caller does not try to leverage the overrides which were introduced in v4.
    if (overrides && (!$7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideGate || !$7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideConfig)) {
        if (!$7c73c20059986bcf$var$hasWarnedAboutMissingOverrideSupport) {
            console.warn("Overrides are only supported in @atlaskit/feature-gate-js-client v4.0.0+");
            $7c73c20059986bcf$var$hasWarnedAboutMissingOverrideSupport = true;
        }
        return;
    }
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach(([gateName, value])=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideGate) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, gateName, value);
    });
    Object.entries((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach(([configName, values])=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.overrideConfig) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, configName, values);
    });
}
module.exports.applyOverrides = $7c73c20059986bcf$var$applyOverrides;
function $7c73c20059986bcf$var$clearOverrides(overrides) {
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.gates) || {}).forEach((gateName)=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.clearGateOverride) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, gateName);
    });
    Object.keys((overrides === null || overrides === void 0 ? void 0 : overrides.configs) || {}).forEach((configName)=>{
        var _a;
        (_a = $7c73c20059986bcf$var$feature_gate_js_client_1.default.clearConfigOverride) === null || _a === void 0 || _a.call($7c73c20059986bcf$var$feature_gate_js_client_1.default, configName);
    });
}
module.exports.clearOverrides = $7c73c20059986bcf$var$clearOverrides;

});


parcelRegister("7YQq7", function(module, exports) {
"use strict";
var $5cf6cc996f6bccec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithDefaults = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $5cf6cc996f6bccec$var$feature_gate_js_client_1 = $5cf6cc996f6bccec$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $5cf6cc996f6bccec$var$FeatureGatesInitializationWithDefaults = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $5cf6cc996f6bccec$var$feature_gate_js_client_1.default.initializeCalled() ? $5cf6cc996f6bccec$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes) : $5cf6cc996f6bccec$var$feature_gate_js_client_1.default.initializeFromValues(Object.assign({
                    sdkKey: "client-default-key"
                }, optionsRef.current || {}), identifiers, customAttributes);
                initPromise.then(()=>(0, $aGsgY.applyOverrides)(overrides)).catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithDefaults = $5cf6cc996f6bccec$var$FeatureGatesInitializationWithDefaults;
module.exports.default = module.exports.FeatureGatesInitializationWithDefaults;

});

parcelRegister("eYpIx", function(module, exports) {
"use strict";
var $ae6a9e32a43bfbea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FeatureGatesInitializationWithValues = void 0;

var $8ZuGG = parcelRequire("8ZuGG");

const $ae6a9e32a43bfbea$var$feature_gate_js_client_1 = $ae6a9e32a43bfbea$var$__importDefault((parcelRequire("boRTX")));

var $aGsgY = parcelRequire("aGsgY");
/**
 * This component initializes the @atlassian/feature-flag-js-client by fetching the gate and experiment
 * evaluations for the given user, and blocks rendering of the children until the rendering is complete.
 */ const $ae6a9e32a43bfbea$var$FeatureGatesInitializationWithValues = ({ children: children, enabled: enabled = true, identifiers: identifiers, customAttributes: customAttributes, options: options, initializeValues: initializeValues, overrides: overrides, onReady: onReady })=>{
    // Rather than checking the state of all overrides, we can just assume that if overrides are provided
    // then some sort of update will need to be performed, and hold off rendering until the useEffect is run.
    const [isInitialized, setInitialized] = (0, $8ZuGG.useState)(!overrides && (0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes));
    // Use a ref for the options, so that we can use them within the following useEffect
    // without adding options as a dependency.
    // This avoids the user updating every time an option is changed.
    const optionsRef = (0, $8ZuGG.useRef)(options);
    (0, $8ZuGG.useEffect)(()=>{
        optionsRef.current = options;
    }, [
        options
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        if (enabled) {
            if ((0, $aGsgY.isClientAlreadyInCorrectState)(identifiers, customAttributes)) {
                (0, $aGsgY.applyOverrides)(overrides);
                setInitialized(true);
                onReady === null || onReady === void 0 || onReady();
            } else {
                setInitialized(false);
                const initPromise = $ae6a9e32a43bfbea$var$feature_gate_js_client_1.default.initializeCalled() ? $ae6a9e32a43bfbea$var$feature_gate_js_client_1.default.updateUserWithValues(identifiers, customAttributes, initializeValues) : $ae6a9e32a43bfbea$var$feature_gate_js_client_1.default.initializeFromValues(optionsRef.current, identifiers, customAttributes, initializeValues);
                initPromise.then(()=>(0, $aGsgY.applyOverrides)(overrides)).catch((err)=>(0, $aGsgY.toError)(err)).then((err)=>{
                    setInitialized(true);
                    onReady === null || onReady === void 0 || onReady(err || undefined);
                });
            }
        } else {
            setInitialized(true);
            onReady === null || onReady === void 0 || onReady();
        }
        return ()=>(0, $aGsgY.clearOverrides)(overrides);
    }, [
        enabled,
        identifiers,
        customAttributes,
        initializeValues,
        overrides
    ]);
    return (0, $aGsgY.pickChildToRender)(enabled, isInitialized, children);
};
module.exports.FeatureGatesInitializationWithValues = $ae6a9e32a43bfbea$var$FeatureGatesInitializationWithValues;
module.exports.default = module.exports.FeatureGatesInitializationWithValues;

});


var $6rcps = parcelRequire("6rcps");
/**
 * CoreJS https://github.com/zloirock/core-js
 * Our package.json['browserslist'] drives how Parcel/swc polyfills our application.
 * However we want to manually polyfill a handful of features that enables more of the application for more users.
 */ "use strict";
"use strict";
var $75395d4d1502b249$exports = {};
"use strict";
var $28b32bdb3c934954$exports = {};
"use strict";
var $28b32bdb3c934954$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$28b32bdb3c934954$exports = // eslint-disable-next-line es/no-global-this -- safe
$28b32bdb3c934954$var$check(typeof globalThis == "object" && globalThis) || $28b32bdb3c934954$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$28b32bdb3c934954$var$check(typeof self == "object" && self) || $28b32bdb3c934954$var$check(typeof $parcel$global == "object" && $parcel$global) || $28b32bdb3c934954$var$check(typeof $28b32bdb3c934954$exports == "object" && $28b32bdb3c934954$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $ce77c1f0936b11bf$export$2d1720544b23b823;
"use strict";
var $52f9c610bf0521fc$exports = {};
"use strict";
var $7fbdf4c0599ef462$exports = {};
"use strict";
$7fbdf4c0599ef462$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$52f9c610bf0521fc$exports = !$7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $0c06b1aeebe22a6e$exports = {};
"use strict";
var $e66e7bf0d4cfee4a$exports = {};
"use strict";

$e66e7bf0d4cfee4a$exports = !$7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $0c06b1aeebe22a6e$var$call = Function.prototype.call;
$0c06b1aeebe22a6e$exports = $e66e7bf0d4cfee4a$exports ? $0c06b1aeebe22a6e$var$call.bind($0c06b1aeebe22a6e$var$call) : function() {
    return $0c06b1aeebe22a6e$var$call.apply($0c06b1aeebe22a6e$var$call, arguments);
};


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $3f7aa21c8f18f10f$export$2d1720544b23b823;
"use strict";
var $3f7aa21c8f18f10f$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $3f7aa21c8f18f10f$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $3f7aa21c8f18f10f$var$NASHORN_BUG = $3f7aa21c8f18f10f$var$getOwnPropertyDescriptor && !$3f7aa21c8f18f10f$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$3f7aa21c8f18f10f$export$2d1720544b23b823 = $3f7aa21c8f18f10f$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $3f7aa21c8f18f10f$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $3f7aa21c8f18f10f$var$$propertyIsEnumerable;


var $280423f212a26849$exports = {};
"use strict";
$280423f212a26849$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


var $9d811c44f1b32f82$exports = {};
"use strict";
var $07c591c29318e081$exports = {};
"use strict";
var $c800df2b7efc8f14$exports = {};
"use strict";

var $c800df2b7efc8f14$var$FunctionPrototype = Function.prototype;
var $c800df2b7efc8f14$var$call = $c800df2b7efc8f14$var$FunctionPrototype.call;
var $c800df2b7efc8f14$var$uncurryThisWithBind = $e66e7bf0d4cfee4a$exports && $c800df2b7efc8f14$var$FunctionPrototype.bind.bind($c800df2b7efc8f14$var$call, $c800df2b7efc8f14$var$call);
$c800df2b7efc8f14$exports = $e66e7bf0d4cfee4a$exports ? $c800df2b7efc8f14$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $c800df2b7efc8f14$var$call.apply(fn, arguments);
    };
};



var $6b7f47111eaca73a$exports = {};
"use strict";

var $6b7f47111eaca73a$var$toString = $c800df2b7efc8f14$exports({}.toString);
var $6b7f47111eaca73a$var$stringSlice = $c800df2b7efc8f14$exports("".slice);
$6b7f47111eaca73a$exports = function(it) {
    return $6b7f47111eaca73a$var$stringSlice($6b7f47111eaca73a$var$toString(it), 8, -1);
};


var $07c591c29318e081$var$$Object = Object;
var $07c591c29318e081$var$split = $c800df2b7efc8f14$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$07c591c29318e081$exports = $7fbdf4c0599ef462$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$07c591c29318e081$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $6b7f47111eaca73a$exports(it) === "String" ? $07c591c29318e081$var$split(it, "") : $07c591c29318e081$var$$Object(it);
} : $07c591c29318e081$var$$Object;


var $dc13fa5d6a969043$exports = {};
"use strict";
var $4961f37f7ea715b0$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$4961f37f7ea715b0$exports = function(it) {
    return it === null || it === undefined;
};


var $dc13fa5d6a969043$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$dc13fa5d6a969043$exports = function(it) {
    if ($4961f37f7ea715b0$exports(it)) throw new $dc13fa5d6a969043$var$$TypeError("Can't call method on " + it);
    return it;
};


$9d811c44f1b32f82$exports = function(it) {
    return $07c591c29318e081$exports($dc13fa5d6a969043$exports(it));
};


var $557ce3c5a27f1e8c$exports = {};
"use strict";
var $40e7e1ffc2bc7815$exports = {};
"use strict";

var $fbd29800d02822fa$exports = {};
"use strict";
var $a7eaff0338821e23$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $a7eaff0338821e23$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$a7eaff0338821e23$exports = typeof $a7eaff0338821e23$var$documentAll == "undefined" && $a7eaff0338821e23$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $a7eaff0338821e23$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


$fbd29800d02822fa$exports = function(it) {
    return typeof it == "object" ? it !== null : $a7eaff0338821e23$exports(it);
};


var $ddbceefbd7001b7f$exports = {};
"use strict";
var $4ea75fe1d4279dda$exports = {};
"use strict";


var $4ea75fe1d4279dda$var$aFunction = function(argument) {
    return $a7eaff0338821e23$exports(argument) ? argument : undefined;
};
$4ea75fe1d4279dda$exports = function(namespace, method) {
    return arguments.length < 2 ? $4ea75fe1d4279dda$var$aFunction($28b32bdb3c934954$exports[namespace]) : $28b32bdb3c934954$exports[namespace] && $28b32bdb3c934954$exports[namespace][method];
};



var $931b0ab7ad810eb0$exports = {};
"use strict";

$931b0ab7ad810eb0$exports = $c800df2b7efc8f14$exports({}.isPrototypeOf);


var $9523c6a2ad8fa394$exports = {};
"use strict";
var $8a705df41e267127$exports = {};
"use strict";
var $c7c03cf3179d3a91$exports = {};
"use strict";

var $ea8a78aa1b038edc$exports = {};
"use strict";
$ea8a78aa1b038edc$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $c7c03cf3179d3a91$var$process = $28b32bdb3c934954$exports.process;
var $c7c03cf3179d3a91$var$Deno = $28b32bdb3c934954$exports.Deno;
var $c7c03cf3179d3a91$var$versions = $c7c03cf3179d3a91$var$process && $c7c03cf3179d3a91$var$process.versions || $c7c03cf3179d3a91$var$Deno && $c7c03cf3179d3a91$var$Deno.version;
var $c7c03cf3179d3a91$var$v8 = $c7c03cf3179d3a91$var$versions && $c7c03cf3179d3a91$var$versions.v8;
var $c7c03cf3179d3a91$var$match, $c7c03cf3179d3a91$var$version;
if ($c7c03cf3179d3a91$var$v8) {
    $c7c03cf3179d3a91$var$match = $c7c03cf3179d3a91$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $c7c03cf3179d3a91$var$version = $c7c03cf3179d3a91$var$match[0] > 0 && $c7c03cf3179d3a91$var$match[0] < 4 ? 1 : +($c7c03cf3179d3a91$var$match[0] + $c7c03cf3179d3a91$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$c7c03cf3179d3a91$var$version && $ea8a78aa1b038edc$exports) {
    $c7c03cf3179d3a91$var$match = $ea8a78aa1b038edc$exports.match(/Edge\/(\d+)/);
    if (!$c7c03cf3179d3a91$var$match || $c7c03cf3179d3a91$var$match[1] >= 74) {
        $c7c03cf3179d3a91$var$match = $ea8a78aa1b038edc$exports.match(/Chrome\/(\d+)/);
        if ($c7c03cf3179d3a91$var$match) $c7c03cf3179d3a91$var$version = +$c7c03cf3179d3a91$var$match[1];
    }
}
$c7c03cf3179d3a91$exports = $c7c03cf3179d3a91$var$version;




var $8a705df41e267127$var$$String = $28b32bdb3c934954$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$8a705df41e267127$exports = !!Object.getOwnPropertySymbols && !$7fbdf4c0599ef462$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$8a705df41e267127$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $c7c03cf3179d3a91$exports && $c7c03cf3179d3a91$exports < 41;
});


$9523c6a2ad8fa394$exports = $8a705df41e267127$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $ddbceefbd7001b7f$var$$Object = Object;
$ddbceefbd7001b7f$exports = $9523c6a2ad8fa394$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $4ea75fe1d4279dda$exports("Symbol");
    return $a7eaff0338821e23$exports($Symbol) && $931b0ab7ad810eb0$exports($Symbol.prototype, $ddbceefbd7001b7f$var$$Object(it));
};


var $f32de95dd0610261$exports = {};
"use strict";
var $11648e8ec26b6ecd$exports = {};
"use strict";

var $ff2dcd98892ae4f4$exports = {};
"use strict";
var $ff2dcd98892ae4f4$var$$String = String;
$ff2dcd98892ae4f4$exports = function(argument) {
    try {
        return $ff2dcd98892ae4f4$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $11648e8ec26b6ecd$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$11648e8ec26b6ecd$exports = function(argument) {
    if ($a7eaff0338821e23$exports(argument)) return argument;
    throw new $11648e8ec26b6ecd$var$$TypeError($ff2dcd98892ae4f4$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$f32de95dd0610261$exports = function(V, P) {
    var func = V[P];
    return $4961f37f7ea715b0$exports(func) ? undefined : $11648e8ec26b6ecd$exports(func);
};


var $1f3ca27c7e1ee501$exports = {};
"use strict";



var $1f3ca27c7e1ee501$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$1f3ca27c7e1ee501$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $a7eaff0338821e23$exports(fn = input.toString) && !$fbd29800d02822fa$exports(val = $0c06b1aeebe22a6e$exports(fn, input))) return val;
    if ($a7eaff0338821e23$exports(fn = input.valueOf) && !$fbd29800d02822fa$exports(val = $0c06b1aeebe22a6e$exports(fn, input))) return val;
    if (pref !== "string" && $a7eaff0338821e23$exports(fn = input.toString) && !$fbd29800d02822fa$exports(val = $0c06b1aeebe22a6e$exports(fn, input))) return val;
    throw new $1f3ca27c7e1ee501$var$$TypeError("Can't convert object to primitive value");
};


var $0b105ffe14c0d5a5$exports = {};
"use strict";

var $de060b0c07c00dae$exports = {};
"use strict";
var $7b0d7577e35530be$exports = {};
"use strict";
var $6ad9df1f2e7ebd85$exports = {};
"use strict";
$6ad9df1f2e7ebd85$exports = false;



var $7f3648e7cf38ebc9$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $7f3648e7cf38ebc9$var$defineProperty = Object.defineProperty;
$7f3648e7cf38ebc9$exports = function(key, value) {
    try {
        $7f3648e7cf38ebc9$var$defineProperty($28b32bdb3c934954$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $28b32bdb3c934954$exports[key] = value;
    }
    return value;
};


var $7b0d7577e35530be$var$SHARED = "__core-js_shared__";
var $7b0d7577e35530be$var$store = $7b0d7577e35530be$exports = globalThis[$7b0d7577e35530be$var$SHARED] || $7f3648e7cf38ebc9$exports($7b0d7577e35530be$var$SHARED, {});
($7b0d7577e35530be$var$store.versions || ($7b0d7577e35530be$var$store.versions = [])).push({
    version: "3.37.1",
    mode: $6ad9df1f2e7ebd85$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.37.1/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


$de060b0c07c00dae$exports = function(key, value) {
    return $7b0d7577e35530be$exports[key] || ($7b0d7577e35530be$exports[key] = value || {});
};


var $cad4bbfed17498c2$exports = {};
"use strict";

var $9979de0a9e7dae17$exports = {};
"use strict";

var $9979de0a9e7dae17$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$9979de0a9e7dae17$exports = function(argument) {
    return $9979de0a9e7dae17$var$$Object($dc13fa5d6a969043$exports(argument));
};


var $cad4bbfed17498c2$var$hasOwnProperty = $c800df2b7efc8f14$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$cad4bbfed17498c2$exports = Object.hasOwn || function hasOwn(it, key) {
    return $cad4bbfed17498c2$var$hasOwnProperty($9979de0a9e7dae17$exports(it), key);
};


var $00c072c5b94e6c06$exports = {};
"use strict";

var $00c072c5b94e6c06$var$id = 0;
var $00c072c5b94e6c06$var$postfix = Math.random();
var $00c072c5b94e6c06$var$toString = $c800df2b7efc8f14$exports(1.0.toString);
$00c072c5b94e6c06$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $00c072c5b94e6c06$var$toString(++$00c072c5b94e6c06$var$id + $00c072c5b94e6c06$var$postfix, 36);
};




var $0b105ffe14c0d5a5$var$Symbol = $28b32bdb3c934954$exports.Symbol;
var $0b105ffe14c0d5a5$var$WellKnownSymbolsStore = $de060b0c07c00dae$exports("wks");
var $0b105ffe14c0d5a5$var$createWellKnownSymbol = $9523c6a2ad8fa394$exports ? $0b105ffe14c0d5a5$var$Symbol["for"] || $0b105ffe14c0d5a5$var$Symbol : $0b105ffe14c0d5a5$var$Symbol && $0b105ffe14c0d5a5$var$Symbol.withoutSetter || $00c072c5b94e6c06$exports;
$0b105ffe14c0d5a5$exports = function(name) {
    if (!$cad4bbfed17498c2$exports($0b105ffe14c0d5a5$var$WellKnownSymbolsStore, name)) $0b105ffe14c0d5a5$var$WellKnownSymbolsStore[name] = $8a705df41e267127$exports && $cad4bbfed17498c2$exports($0b105ffe14c0d5a5$var$Symbol, name) ? $0b105ffe14c0d5a5$var$Symbol[name] : $0b105ffe14c0d5a5$var$createWellKnownSymbol("Symbol." + name);
    return $0b105ffe14c0d5a5$var$WellKnownSymbolsStore[name];
};


var $40e7e1ffc2bc7815$var$$TypeError = TypeError;
var $40e7e1ffc2bc7815$var$TO_PRIMITIVE = $0b105ffe14c0d5a5$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$40e7e1ffc2bc7815$exports = function(input, pref) {
    if (!$fbd29800d02822fa$exports(input) || $ddbceefbd7001b7f$exports(input)) return input;
    var exoticToPrim = $f32de95dd0610261$exports(input, $40e7e1ffc2bc7815$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $0c06b1aeebe22a6e$exports(exoticToPrim, input, pref);
        if (!$fbd29800d02822fa$exports(result) || $ddbceefbd7001b7f$exports(result)) return result;
        throw new $40e7e1ffc2bc7815$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $1f3ca27c7e1ee501$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$557ce3c5a27f1e8c$exports = function(argument) {
    var key = $40e7e1ffc2bc7815$exports(argument, "string");
    return $ddbceefbd7001b7f$exports(key) ? key : key + "";
};



var $2fc96a6036cafd3b$exports = {};
"use strict";


var $c5824977ab5a14ea$exports = {};
"use strict";


var $c5824977ab5a14ea$var$document = $28b32bdb3c934954$exports.document;
// typeof document.createElement is 'object' in old IE
var $c5824977ab5a14ea$var$EXISTS = $fbd29800d02822fa$exports($c5824977ab5a14ea$var$document) && $fbd29800d02822fa$exports($c5824977ab5a14ea$var$document.createElement);
$c5824977ab5a14ea$exports = function(it) {
    return $c5824977ab5a14ea$var$EXISTS ? $c5824977ab5a14ea$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$2fc96a6036cafd3b$exports = !$52f9c610bf0521fc$exports && !$7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($c5824977ab5a14ea$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $ce77c1f0936b11bf$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$ce77c1f0936b11bf$export$2d1720544b23b823 = $52f9c610bf0521fc$exports ? $ce77c1f0936b11bf$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $9d811c44f1b32f82$exports(O);
    P = $557ce3c5a27f1e8c$exports(P);
    if ($2fc96a6036cafd3b$exports) try {
        return $ce77c1f0936b11bf$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($cad4bbfed17498c2$exports(O, P)) return $280423f212a26849$exports(!$0c06b1aeebe22a6e$exports($3f7aa21c8f18f10f$export$2d1720544b23b823, O, P), O[P]);
};


var $75395d4d1502b249$require$getOwnPropertyDescriptor = $ce77c1f0936b11bf$export$2d1720544b23b823;
var $13b85566beee9498$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $722eb9ecceb224f8$export$2d1720544b23b823;
"use strict";


var $76b8d485b6e52872$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$76b8d485b6e52872$exports = $52f9c610bf0521fc$exports && $7fbdf4c0599ef462$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $3972fdbff685207b$exports = {};
"use strict";

var $3972fdbff685207b$var$$String = String;
var $3972fdbff685207b$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$3972fdbff685207b$exports = function(argument) {
    if ($fbd29800d02822fa$exports(argument)) return argument;
    throw new $3972fdbff685207b$var$$TypeError($3972fdbff685207b$var$$String(argument) + " is not an object");
};



var $722eb9ecceb224f8$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $722eb9ecceb224f8$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $722eb9ecceb224f8$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $722eb9ecceb224f8$var$ENUMERABLE = "enumerable";
var $722eb9ecceb224f8$var$CONFIGURABLE = "configurable";
var $722eb9ecceb224f8$var$WRITABLE = "writable";
$722eb9ecceb224f8$export$2d1720544b23b823 = $52f9c610bf0521fc$exports ? $76b8d485b6e52872$exports ? function defineProperty(O, P, Attributes) {
    $3972fdbff685207b$exports(O);
    P = $557ce3c5a27f1e8c$exports(P);
    $3972fdbff685207b$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $722eb9ecceb224f8$var$WRITABLE in Attributes && !Attributes[$722eb9ecceb224f8$var$WRITABLE]) {
        var current = $722eb9ecceb224f8$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$722eb9ecceb224f8$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $722eb9ecceb224f8$var$CONFIGURABLE in Attributes ? Attributes[$722eb9ecceb224f8$var$CONFIGURABLE] : current[$722eb9ecceb224f8$var$CONFIGURABLE],
                enumerable: $722eb9ecceb224f8$var$ENUMERABLE in Attributes ? Attributes[$722eb9ecceb224f8$var$ENUMERABLE] : current[$722eb9ecceb224f8$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $722eb9ecceb224f8$var$$defineProperty(O, P, Attributes);
} : $722eb9ecceb224f8$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $3972fdbff685207b$exports(O);
    P = $557ce3c5a27f1e8c$exports(P);
    $3972fdbff685207b$exports(Attributes);
    if ($2fc96a6036cafd3b$exports) try {
        return $722eb9ecceb224f8$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $722eb9ecceb224f8$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};



$13b85566beee9498$exports = $52f9c610bf0521fc$exports ? function(object, key, value) {
    return $722eb9ecceb224f8$export$2d1720544b23b823(object, key, $280423f212a26849$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};


var $0610e46059a94cbd$exports = {};
"use strict";


var $b9e70daef8851f0b$exports = {};
"use strict";





var $4c1919cb72ce1a0c$exports = {};
"use strict";


var $4c1919cb72ce1a0c$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $4c1919cb72ce1a0c$var$getDescriptor = $52f9c610bf0521fc$exports && Object.getOwnPropertyDescriptor;
var $4c1919cb72ce1a0c$var$EXISTS = $cad4bbfed17498c2$exports($4c1919cb72ce1a0c$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $4c1919cb72ce1a0c$var$PROPER = $4c1919cb72ce1a0c$var$EXISTS && (function something() {}).name === "something";
var $4c1919cb72ce1a0c$var$CONFIGURABLE = $4c1919cb72ce1a0c$var$EXISTS && (!$52f9c610bf0521fc$exports || $52f9c610bf0521fc$exports && $4c1919cb72ce1a0c$var$getDescriptor($4c1919cb72ce1a0c$var$FunctionPrototype, "name").configurable);
$4c1919cb72ce1a0c$exports = {
    EXISTS: $4c1919cb72ce1a0c$var$EXISTS,
    PROPER: $4c1919cb72ce1a0c$var$PROPER,
    CONFIGURABLE: $4c1919cb72ce1a0c$var$CONFIGURABLE
};


var $b9e70daef8851f0b$require$CONFIGURABLE_FUNCTION_NAME = $4c1919cb72ce1a0c$exports.CONFIGURABLE;
var $94b2f3bb3c74e175$exports = {};
"use strict";



var $94b2f3bb3c74e175$var$functionToString = $c800df2b7efc8f14$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$a7eaff0338821e23$exports($7b0d7577e35530be$exports.inspectSource)) $7b0d7577e35530be$exports.inspectSource = function(it) {
    return $94b2f3bb3c74e175$var$functionToString(it);
};
$94b2f3bb3c74e175$exports = $7b0d7577e35530be$exports.inspectSource;


var $f87bb15e699cf95b$exports = {};
"use strict";
var $d1fc8e6ada472082$exports = {};
"use strict";


var $d1fc8e6ada472082$var$WeakMap = $28b32bdb3c934954$exports.WeakMap;
$d1fc8e6ada472082$exports = $a7eaff0338821e23$exports($d1fc8e6ada472082$var$WeakMap) && /native code/.test(String($d1fc8e6ada472082$var$WeakMap));







var $37f7417c6f6b2b99$exports = {};
"use strict";


var $37f7417c6f6b2b99$var$keys = $de060b0c07c00dae$exports("keys");
$37f7417c6f6b2b99$exports = function(key) {
    return $37f7417c6f6b2b99$var$keys[key] || ($37f7417c6f6b2b99$var$keys[key] = $00c072c5b94e6c06$exports(key));
};


var $c30c863eb145c5a8$exports = {};
"use strict";
$c30c863eb145c5a8$exports = {};


var $f87bb15e699cf95b$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $f87bb15e699cf95b$var$TypeError = $28b32bdb3c934954$exports.TypeError;
var $f87bb15e699cf95b$var$WeakMap = $28b32bdb3c934954$exports.WeakMap;
var $f87bb15e699cf95b$var$set, $f87bb15e699cf95b$var$get, $f87bb15e699cf95b$var$has;
var $f87bb15e699cf95b$var$enforce = function(it) {
    return $f87bb15e699cf95b$var$has(it) ? $f87bb15e699cf95b$var$get(it) : $f87bb15e699cf95b$var$set(it, {});
};
var $f87bb15e699cf95b$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$fbd29800d02822fa$exports(it) || (state = $f87bb15e699cf95b$var$get(it)).type !== TYPE) throw new $f87bb15e699cf95b$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($d1fc8e6ada472082$exports || $7b0d7577e35530be$exports.state) {
    var $f87bb15e699cf95b$var$store = $7b0d7577e35530be$exports.state || ($7b0d7577e35530be$exports.state = new $f87bb15e699cf95b$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $f87bb15e699cf95b$var$store.get = $f87bb15e699cf95b$var$store.get;
    $f87bb15e699cf95b$var$store.has = $f87bb15e699cf95b$var$store.has;
    $f87bb15e699cf95b$var$store.set = $f87bb15e699cf95b$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $f87bb15e699cf95b$var$set = function(it, metadata) {
        if ($f87bb15e699cf95b$var$store.has(it)) throw new $f87bb15e699cf95b$var$TypeError($f87bb15e699cf95b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $f87bb15e699cf95b$var$store.set(it, metadata);
        return metadata;
    };
    $f87bb15e699cf95b$var$get = function(it) {
        return $f87bb15e699cf95b$var$store.get(it) || {};
    };
    $f87bb15e699cf95b$var$has = function(it) {
        return $f87bb15e699cf95b$var$store.has(it);
    };
} else {
    var $f87bb15e699cf95b$var$STATE = $37f7417c6f6b2b99$exports("state");
    $c30c863eb145c5a8$exports[$f87bb15e699cf95b$var$STATE] = true;
    $f87bb15e699cf95b$var$set = function(it, metadata) {
        if ($cad4bbfed17498c2$exports(it, $f87bb15e699cf95b$var$STATE)) throw new $f87bb15e699cf95b$var$TypeError($f87bb15e699cf95b$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $13b85566beee9498$exports(it, $f87bb15e699cf95b$var$STATE, metadata);
        return metadata;
    };
    $f87bb15e699cf95b$var$get = function(it) {
        return $cad4bbfed17498c2$exports(it, $f87bb15e699cf95b$var$STATE) ? it[$f87bb15e699cf95b$var$STATE] : {};
    };
    $f87bb15e699cf95b$var$has = function(it) {
        return $cad4bbfed17498c2$exports(it, $f87bb15e699cf95b$var$STATE);
    };
}
$f87bb15e699cf95b$exports = {
    set: $f87bb15e699cf95b$var$set,
    get: $f87bb15e699cf95b$var$get,
    has: $f87bb15e699cf95b$var$has,
    enforce: $f87bb15e699cf95b$var$enforce,
    getterFor: $f87bb15e699cf95b$var$getterFor
};


var $b9e70daef8851f0b$var$enforceInternalState = $f87bb15e699cf95b$exports.enforce;
var $b9e70daef8851f0b$var$getInternalState = $f87bb15e699cf95b$exports.get;
var $b9e70daef8851f0b$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $b9e70daef8851f0b$var$defineProperty = Object.defineProperty;
var $b9e70daef8851f0b$var$stringSlice = $c800df2b7efc8f14$exports("".slice);
var $b9e70daef8851f0b$var$replace = $c800df2b7efc8f14$exports("".replace);
var $b9e70daef8851f0b$var$join = $c800df2b7efc8f14$exports([].join);
var $b9e70daef8851f0b$var$CONFIGURABLE_LENGTH = $52f9c610bf0521fc$exports && !$7fbdf4c0599ef462$exports(function() {
    return $b9e70daef8851f0b$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $b9e70daef8851f0b$var$TEMPLATE = String(String).split("String");
var $b9e70daef8851f0b$var$makeBuiltIn = $b9e70daef8851f0b$exports = function(value, name, options) {
    if ($b9e70daef8851f0b$var$stringSlice($b9e70daef8851f0b$var$$String(name), 0, 7) === "Symbol(") name = "[" + $b9e70daef8851f0b$var$replace($b9e70daef8851f0b$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$cad4bbfed17498c2$exports(value, "name") || $b9e70daef8851f0b$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($52f9c610bf0521fc$exports) $b9e70daef8851f0b$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($b9e70daef8851f0b$var$CONFIGURABLE_LENGTH && options && $cad4bbfed17498c2$exports(options, "arity") && value.length !== options.arity) $b9e70daef8851f0b$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $cad4bbfed17498c2$exports(options, "constructor") && options.constructor) {
            if ($52f9c610bf0521fc$exports) $b9e70daef8851f0b$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $b9e70daef8851f0b$var$enforceInternalState(value);
    if (!$cad4bbfed17498c2$exports(state, "source")) state.source = $b9e70daef8851f0b$var$join($b9e70daef8851f0b$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $b9e70daef8851f0b$var$makeBuiltIn(function toString() {
    return $a7eaff0338821e23$exports(this) && $b9e70daef8851f0b$var$getInternalState(this).source || $94b2f3bb3c74e175$exports(this);
}, "toString");



$0610e46059a94cbd$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($a7eaff0338821e23$exports(value)) $b9e70daef8851f0b$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $7f3648e7cf38ebc9$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $722eb9ecceb224f8$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $e936b86422279645$exports = {};
"use strict";

var $36eb3102175944c8$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $63553e39e7798603$export$2d1720544b23b823;
"use strict";
var $b3e319add4fe1dfd$exports = {};
"use strict";



var $538f3c10b3b3f45e$exports = {};
"use strict";

var $4358a7aa0cd0bcdd$exports = {};
"use strict";
var $dd070c356673d59c$exports = {};
"use strict";
var $71f29641d8c90c7d$exports = {};
"use strict";
var $71f29641d8c90c7d$var$ceil = Math.ceil;
var $71f29641d8c90c7d$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$71f29641d8c90c7d$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $71f29641d8c90c7d$var$floor : $71f29641d8c90c7d$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$dd070c356673d59c$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $71f29641d8c90c7d$exports(number);
};


var $4358a7aa0cd0bcdd$var$max = Math.max;
var $4358a7aa0cd0bcdd$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$4358a7aa0cd0bcdd$exports = function(index, length) {
    var integer = $dd070c356673d59c$exports(index);
    return integer < 0 ? $4358a7aa0cd0bcdd$var$max(integer + length, 0) : $4358a7aa0cd0bcdd$var$min(integer, length);
};


var $a25bd31168207e91$exports = {};
"use strict";
var $17b8713bace259ee$exports = {};
"use strict";

var $17b8713bace259ee$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$17b8713bace259ee$exports = function(argument) {
    var len = $dd070c356673d59c$exports(argument);
    return len > 0 ? $17b8713bace259ee$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$a25bd31168207e91$exports = function(obj) {
    return $17b8713bace259ee$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $538f3c10b3b3f45e$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $9d811c44f1b32f82$exports($this);
        var length = $a25bd31168207e91$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $4358a7aa0cd0bcdd$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$538f3c10b3b3f45e$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $538f3c10b3b3f45e$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $538f3c10b3b3f45e$var$createMethod(false)
};


var $b3e319add4fe1dfd$require$indexOf = $538f3c10b3b3f45e$exports.indexOf;

var $b3e319add4fe1dfd$var$push = $c800df2b7efc8f14$exports([].push);
$b3e319add4fe1dfd$exports = function(object, names) {
    var O = $9d811c44f1b32f82$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$cad4bbfed17498c2$exports($c30c863eb145c5a8$exports, key) && $cad4bbfed17498c2$exports(O, key) && $b3e319add4fe1dfd$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($cad4bbfed17498c2$exports(O, key = names[i++])) ~$b3e319add4fe1dfd$require$indexOf(result, key) || $b3e319add4fe1dfd$var$push(result, key);
    return result;
};


var $2c7a9530035f509a$exports = {};
"use strict";
// IE8- don't enum bug keys
$2c7a9530035f509a$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $63553e39e7798603$var$hiddenKeys = $2c7a9530035f509a$exports.concat("length", "prototype");
$63553e39e7798603$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $b3e319add4fe1dfd$exports(O, $63553e39e7798603$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $7e6f79981172a35d$export$2d1720544b23b823;
"use strict";
$7e6f79981172a35d$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $36eb3102175944c8$var$concat = $c800df2b7efc8f14$exports([].concat);
// all object keys, includes non-enumerable and symbols
$36eb3102175944c8$exports = $4ea75fe1d4279dda$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $63553e39e7798603$export$2d1720544b23b823($3972fdbff685207b$exports(it));
    var getOwnPropertySymbols = $7e6f79981172a35d$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $36eb3102175944c8$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$e936b86422279645$exports = function(target, source, exceptions) {
    var keys = $36eb3102175944c8$exports(source);
    var defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $ce77c1f0936b11bf$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$cad4bbfed17498c2$exports(target, key) && !(exceptions && $cad4bbfed17498c2$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $aa1234bb61540248$exports = {};
"use strict";


var $aa1234bb61540248$var$replacement = /#|\.prototype\./;
var $aa1234bb61540248$var$isForced = function(feature, detection) {
    var value = $aa1234bb61540248$var$data[$aa1234bb61540248$var$normalize(feature)];
    return value === $aa1234bb61540248$var$POLYFILL ? true : value === $aa1234bb61540248$var$NATIVE ? false : $a7eaff0338821e23$exports(detection) ? $7fbdf4c0599ef462$exports(detection) : !!detection;
};
var $aa1234bb61540248$var$normalize = $aa1234bb61540248$var$isForced.normalize = function(string) {
    return String(string).replace($aa1234bb61540248$var$replacement, ".").toLowerCase();
};
var $aa1234bb61540248$var$data = $aa1234bb61540248$var$isForced.data = {};
var $aa1234bb61540248$var$NATIVE = $aa1234bb61540248$var$isForced.NATIVE = "N";
var $aa1234bb61540248$var$POLYFILL = $aa1234bb61540248$var$isForced.POLYFILL = "P";
$aa1234bb61540248$exports = $aa1234bb61540248$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $75395d4d1502b249$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $28b32bdb3c934954$exports;
    else if (STATIC) target = $28b32bdb3c934954$exports[TARGET] || $7f3648e7cf38ebc9$exports(TARGET, {});
    else target = $28b32bdb3c934954$exports[TARGET] && $28b32bdb3c934954$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $75395d4d1502b249$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $aa1234bb61540248$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $e936b86422279645$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $13b85566beee9498$exports(sourceProperty, "sham", true);
        $0610e46059a94cbd$exports(target, key, sourceProperty, options);
    }
};




// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
var $669e6c84da4bfea7$export$2d1720544b23b823;
"use strict";

var $669e6c84da4bfea7$var$$TypeError = TypeError;
var $669e6c84da4bfea7$var$PromiseCapability = function(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw new $669e6c84da4bfea7$var$$TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $11648e8ec26b6ecd$exports(resolve);
    this.reject = $11648e8ec26b6ecd$exports(reject);
};
$669e6c84da4bfea7$export$2d1720544b23b823 = function(C) {
    return new $669e6c84da4bfea7$var$PromiseCapability(C);
};


var $df917240a5fd81a7$exports = {};
"use strict";
$df917240a5fd81a7$exports = function(exec) {
    try {
        return {
            error: false,
            value: exec()
        };
    } catch (error) {
        return {
            error: true,
            value: error
        };
    }
};


var $326565c1b25fdb3e$exports = {};
"use strict";
var $bd008ec4ae504cf2$exports = {};
"use strict";
var $22f471ac77cc41b7$exports = {};
"use strict";


$22f471ac77cc41b7$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($6b7f47111eaca73a$exports(fn) === "Function") return $c800df2b7efc8f14$exports(fn);
};




var $bd008ec4ae504cf2$var$bind = $22f471ac77cc41b7$exports($22f471ac77cc41b7$exports.bind);
// optional / simple context binding
$bd008ec4ae504cf2$exports = function(fn, that) {
    $11648e8ec26b6ecd$exports(fn);
    return that === undefined ? fn : $e66e7bf0d4cfee4a$exports ? $bd008ec4ae504cf2$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $03921241703ed0a4$exports = {};
"use strict";

var $95f4729b625bb7e4$exports = {};
"use strict";
$95f4729b625bb7e4$exports = {};


var $03921241703ed0a4$var$ITERATOR = $0b105ffe14c0d5a5$exports("iterator");
var $03921241703ed0a4$var$ArrayPrototype = Array.prototype;
// check on default Array iterator
$03921241703ed0a4$exports = function(it) {
    return it !== undefined && ($95f4729b625bb7e4$exports.Array === it || $03921241703ed0a4$var$ArrayPrototype[$03921241703ed0a4$var$ITERATOR] === it);
};




var $eb3f950a8684bf37$exports = {};
"use strict";




var $8732c0df95152353$exports = {};
"use strict";
var $4d020c4f4ca990f0$exports = {};
"use strict";
var $9462e87e207cd0ad$exports = {};
"use strict";

var $9462e87e207cd0ad$var$TO_STRING_TAG = $0b105ffe14c0d5a5$exports("toStringTag");
var $9462e87e207cd0ad$var$test = {};
$9462e87e207cd0ad$var$test[$9462e87e207cd0ad$var$TO_STRING_TAG] = "z";
$9462e87e207cd0ad$exports = String($9462e87e207cd0ad$var$test) === "[object z]";





var $4d020c4f4ca990f0$var$TO_STRING_TAG = $0b105ffe14c0d5a5$exports("toStringTag");
var $4d020c4f4ca990f0$var$$Object = Object;
// ES3 wrong here
var $4d020c4f4ca990f0$var$CORRECT_ARGUMENTS = $6b7f47111eaca73a$exports(function() {
    return arguments;
}()) === "Arguments";
// fallback for IE11 Script Access Denied error
var $4d020c4f4ca990f0$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (error) {}
};
// getting tag from ES6+ `Object.prototype.toString`
$4d020c4f4ca990f0$exports = $9462e87e207cd0ad$exports ? $6b7f47111eaca73a$exports : function(it) {
    var O, tag, result;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (tag = $4d020c4f4ca990f0$var$tryGet(O = $4d020c4f4ca990f0$var$$Object(it), $4d020c4f4ca990f0$var$TO_STRING_TAG)) == "string" ? tag : $4d020c4f4ca990f0$var$CORRECT_ARGUMENTS ? $6b7f47111eaca73a$exports(O) : (result = $6b7f47111eaca73a$exports(O)) === "Object" && $a7eaff0338821e23$exports(O.callee) ? "Arguments" : result;
};






var $8732c0df95152353$var$ITERATOR = $0b105ffe14c0d5a5$exports("iterator");
$8732c0df95152353$exports = function(it) {
    if (!$4961f37f7ea715b0$exports(it)) return $f32de95dd0610261$exports(it, $8732c0df95152353$var$ITERATOR) || $f32de95dd0610261$exports(it, "@@iterator") || $95f4729b625bb7e4$exports[$4d020c4f4ca990f0$exports(it)];
};


var $eb3f950a8684bf37$var$$TypeError = TypeError;
$eb3f950a8684bf37$exports = function(argument, usingIterator) {
    var iteratorMethod = arguments.length < 2 ? $8732c0df95152353$exports(argument) : usingIterator;
    if ($11648e8ec26b6ecd$exports(iteratorMethod)) return $3972fdbff685207b$exports($0c06b1aeebe22a6e$exports(iteratorMethod, argument));
    throw new $eb3f950a8684bf37$var$$TypeError($ff2dcd98892ae4f4$exports(argument) + " is not iterable");
};



var $83cc9c7df832fea4$exports = {};
"use strict";



$83cc9c7df832fea4$exports = function(iterator, kind, value) {
    var innerResult, innerError;
    $3972fdbff685207b$exports(iterator);
    try {
        innerResult = $f32de95dd0610261$exports(iterator, "return");
        if (!innerResult) {
            if (kind === "throw") throw value;
            return value;
        }
        innerResult = $0c06b1aeebe22a6e$exports(innerResult, iterator);
    } catch (error) {
        innerError = true;
        innerResult = error;
    }
    if (kind === "throw") throw value;
    if (innerError) throw innerResult;
    $3972fdbff685207b$exports(innerResult);
    return value;
};


var $326565c1b25fdb3e$var$$TypeError = TypeError;
var $326565c1b25fdb3e$var$Result = function(stopped, result) {
    this.stopped = stopped;
    this.result = result;
};
var $326565c1b25fdb3e$var$ResultPrototype = $326565c1b25fdb3e$var$Result.prototype;
$326565c1b25fdb3e$exports = function(iterable, unboundFunction, options) {
    var that = options && options.that;
    var AS_ENTRIES = !!(options && options.AS_ENTRIES);
    var IS_RECORD = !!(options && options.IS_RECORD);
    var IS_ITERATOR = !!(options && options.IS_ITERATOR);
    var INTERRUPTED = !!(options && options.INTERRUPTED);
    var fn = $bd008ec4ae504cf2$exports(unboundFunction, that);
    var iterator, iterFn, index, length, result, next, step;
    var stop = function(condition) {
        if (iterator) $83cc9c7df832fea4$exports(iterator, "normal", condition);
        return new $326565c1b25fdb3e$var$Result(true, condition);
    };
    var callFn = function(value) {
        if (AS_ENTRIES) {
            $3972fdbff685207b$exports(value);
            return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
        }
        return INTERRUPTED ? fn(value, stop) : fn(value);
    };
    if (IS_RECORD) iterator = iterable.iterator;
    else if (IS_ITERATOR) iterator = iterable;
    else {
        iterFn = $8732c0df95152353$exports(iterable);
        if (!iterFn) throw new $326565c1b25fdb3e$var$$TypeError($ff2dcd98892ae4f4$exports(iterable) + " is not iterable");
        // optimisation for array iterators
        if ($03921241703ed0a4$exports(iterFn)) {
            for(index = 0, length = $a25bd31168207e91$exports(iterable); length > index; index++){
                result = callFn(iterable[index]);
                if (result && $931b0ab7ad810eb0$exports($326565c1b25fdb3e$var$ResultPrototype, result)) return result;
            }
            return new $326565c1b25fdb3e$var$Result(false);
        }
        iterator = $eb3f950a8684bf37$exports(iterable, iterFn);
    }
    next = IS_RECORD ? iterable.next : iterator.next;
    while(!(step = $0c06b1aeebe22a6e$exports(next, iterator)).done){
        try {
            result = callFn(step.value);
        } catch (error) {
            $83cc9c7df832fea4$exports(iterator, "throw", error);
        }
        if (typeof result == "object" && result && $931b0ab7ad810eb0$exports($326565c1b25fdb3e$var$ResultPrototype, result)) return result;
    }
    return new $326565c1b25fdb3e$var$Result(false);
};


var $8c0fc3f64f140a34$exports = {};
"use strict";
var $7af76ae23e077640$exports = {};
"use strict";

$7af76ae23e077640$exports = $28b32bdb3c934954$exports.Promise;


var $e1124fa8137a8aa0$exports = {};
"use strict";

var $e1124fa8137a8aa0$var$ITERATOR = $0b105ffe14c0d5a5$exports("iterator");
var $e1124fa8137a8aa0$var$SAFE_CLOSING = false;
try {
    var $e1124fa8137a8aa0$var$called = 0;
    var $e1124fa8137a8aa0$var$iteratorWithReturn = {
        next: function() {
            return {
                done: !!$e1124fa8137a8aa0$var$called++
            };
        },
        "return": function() {
            $e1124fa8137a8aa0$var$SAFE_CLOSING = true;
        }
    };
    $e1124fa8137a8aa0$var$iteratorWithReturn[$e1124fa8137a8aa0$var$ITERATOR] = function() {
        return this;
    };
    // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
    Array.from($e1124fa8137a8aa0$var$iteratorWithReturn, function() {
        throw 2;
    });
} catch (error) {}
$e1124fa8137a8aa0$exports = function(exec, SKIP_CLOSING) {
    try {
        if (!SKIP_CLOSING && !$e1124fa8137a8aa0$var$SAFE_CLOSING) return false;
    } catch (error) {
        return false;
    } // workaround of old WebKit + `eval` bug
    var ITERATION_SUPPORT = false;
    try {
        var object = {};
        object[$e1124fa8137a8aa0$var$ITERATOR] = function() {
            return {
                next: function() {
                    return {
                        done: ITERATION_SUPPORT = true
                    };
                }
            };
        };
        exec(object);
    } catch (error) {}
    return ITERATION_SUPPORT;
};


var $72dc8e0778c344a5$exports = {};
"use strict";






var $a74f493965232526$exports = {};
"use strict";
var $5b973747795b6bee$exports = {};
"use strict";
/* global Deno -- Deno case */ $5b973747795b6bee$exports = typeof Deno == "object" && Deno && typeof Deno.version == "object";


var $5d6b7b0fcfa271a5$exports = {};
"use strict";


$5d6b7b0fcfa271a5$exports = $6b7f47111eaca73a$exports($28b32bdb3c934954$exports.process) === "process";


$a74f493965232526$exports = !$5b973747795b6bee$exports && !$5d6b7b0fcfa271a5$exports && typeof window == "object" && typeof document == "object";





var $72dc8e0778c344a5$var$NativePromisePrototype = $7af76ae23e077640$exports && $7af76ae23e077640$exports.prototype;
var $72dc8e0778c344a5$var$SPECIES = $0b105ffe14c0d5a5$exports("species");
var $72dc8e0778c344a5$var$SUBCLASSING = false;
var $72dc8e0778c344a5$var$NATIVE_PROMISE_REJECTION_EVENT = $a7eaff0338821e23$exports($28b32bdb3c934954$exports.PromiseRejectionEvent);
var $72dc8e0778c344a5$var$FORCED_PROMISE_CONSTRUCTOR = $aa1234bb61540248$exports("Promise", function() {
    var PROMISE_CONSTRUCTOR_SOURCE = $94b2f3bb3c74e175$exports($7af76ae23e077640$exports);
    var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String($7af76ae23e077640$exports);
    // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
    // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
    // We can't detect it synchronously, so just check versions
    if (!GLOBAL_CORE_JS_PROMISE && $c7c03cf3179d3a91$exports === 66) return true;
    // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
    if ($6ad9df1f2e7ebd85$exports && !($72dc8e0778c344a5$var$NativePromisePrototype["catch"] && $72dc8e0778c344a5$var$NativePromisePrototype["finally"])) return true;
    // We can't use @@species feature detection in V8 since it causes
    // deoptimization and performance degradation
    // https://github.com/zloirock/core-js/issues/679
    if (!$c7c03cf3179d3a91$exports || $c7c03cf3179d3a91$exports < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
        // Detect correctness of subclassing with @@species support
        var promise = new $7af76ae23e077640$exports(function(resolve) {
            resolve(1);
        });
        var FakePromise = function(exec) {
            exec(function() {}, function() {});
        };
        var constructor = promise.constructor = {};
        constructor[$72dc8e0778c344a5$var$SPECIES] = FakePromise;
        $72dc8e0778c344a5$var$SUBCLASSING = promise.then(function() {}) instanceof FakePromise;
        if (!$72dc8e0778c344a5$var$SUBCLASSING) return true;
    // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    }
    return !GLOBAL_CORE_JS_PROMISE && ($a74f493965232526$exports || $5b973747795b6bee$exports) && !$72dc8e0778c344a5$var$NATIVE_PROMISE_REJECTION_EVENT;
});
$72dc8e0778c344a5$exports = {
    CONSTRUCTOR: $72dc8e0778c344a5$var$FORCED_PROMISE_CONSTRUCTOR,
    REJECTION_EVENT: $72dc8e0778c344a5$var$NATIVE_PROMISE_REJECTION_EVENT,
    SUBCLASSING: $72dc8e0778c344a5$var$SUBCLASSING
};


var $8c0fc3f64f140a34$require$FORCED_PROMISE_CONSTRUCTOR = $72dc8e0778c344a5$exports.CONSTRUCTOR;
$8c0fc3f64f140a34$exports = $8c0fc3f64f140a34$require$FORCED_PROMISE_CONSTRUCTOR || !$e1124fa8137a8aa0$exports(function(iterable) {
    $7af76ae23e077640$exports.all(iterable).then(undefined, function() {});
});


// `Promise.allSettled` method
// https://tc39.es/ecma262/#sec-promise.allsettled
$75395d4d1502b249$exports({
    target: "Promise",
    stat: true,
    forced: $8c0fc3f64f140a34$exports
}, {
    allSettled: function allSettled(iterable) {
        var C = this;
        var capability = $669e6c84da4bfea7$export$2d1720544b23b823(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $df917240a5fd81a7$exports(function() {
            var promiseResolve = $11648e8ec26b6ecd$exports(C.resolve);
            var values = [];
            var counter = 0;
            var remaining = 1;
            $326565c1b25fdb3e$exports(iterable, function(promise) {
                var index = counter++;
                var alreadyCalled = false;
                remaining++;
                $0c06b1aeebe22a6e$exports(promiseResolve, C, promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "fulfilled",
                        value: value
                    };
                    --remaining || resolve(values);
                }, function(error) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[index] = {
                        status: "rejected",
                        reason: error
                    };
                    --remaining || resolve(values);
                });
            });
            --remaining || resolve(values);
        });
        if (result.error) reject(result.value);
        return capability.promise;
    }
});




"use strict";

var $e58a769b5c316bc3$exports = {};
"use strict";
// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
$e58a769b5c316bc3$exports = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
};


var $c304d3413cc13bcd$exports = {};
"use strict";

var $c304d3413cc13bcd$var$classList = $c5824977ab5a14ea$exports("span").classList;
var $c304d3413cc13bcd$var$DOMTokenListPrototype = $c304d3413cc13bcd$var$classList && $c304d3413cc13bcd$var$classList.constructor && $c304d3413cc13bcd$var$classList.constructor.prototype;
$c304d3413cc13bcd$exports = $c304d3413cc13bcd$var$DOMTokenListPrototype === Object.prototype ? undefined : $c304d3413cc13bcd$var$DOMTokenListPrototype;


var $3dd1d4531fe4b9d5$exports = {};
"use strict";

var $664ec0493109aa88$exports = {};
"use strict";

var $21da32aa197e9369$exports = {};
"use strict";

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $776aae61651a64af$export$2d1720544b23b823;
"use strict";





var $e0e1484389826131$exports = {};
"use strict";


// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
$e0e1484389826131$exports = Object.keys || function keys(O) {
    return $b3e319add4fe1dfd$exports(O, $2c7a9530035f509a$exports);
};


$776aae61651a64af$export$2d1720544b23b823 = $52f9c610bf0521fc$exports && !$76b8d485b6e52872$exports ? Object.defineProperties : function defineProperties(O, Properties) {
    $3972fdbff685207b$exports(O);
    var props = $9d811c44f1b32f82$exports(Properties);
    var keys = $e0e1484389826131$exports(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$722eb9ecceb224f8$export$2d1720544b23b823(O, key = keys[index++], props[key]);
    return O;
};




var $271aa357825a8811$exports = {};
"use strict";

$271aa357825a8811$exports = $4ea75fe1d4279dda$exports("document", "documentElement");




var $21da32aa197e9369$var$GT = ">";
var $21da32aa197e9369$var$LT = "<";
var $21da32aa197e9369$var$PROTOTYPE = "prototype";
var $21da32aa197e9369$var$SCRIPT = "script";
var $21da32aa197e9369$var$IE_PROTO = $37f7417c6f6b2b99$exports("IE_PROTO");
var $21da32aa197e9369$var$EmptyConstructor = function() {};
var $21da32aa197e9369$var$scriptTag = function(content) {
    return $21da32aa197e9369$var$LT + $21da32aa197e9369$var$SCRIPT + $21da32aa197e9369$var$GT + content + $21da32aa197e9369$var$LT + "/" + $21da32aa197e9369$var$SCRIPT + $21da32aa197e9369$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $21da32aa197e9369$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($21da32aa197e9369$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $21da32aa197e9369$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $c5824977ab5a14ea$exports("iframe");
    var JS = "java" + $21da32aa197e9369$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $271aa357825a8811$exports.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($21da32aa197e9369$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $21da32aa197e9369$var$activeXDocument;
var $21da32aa197e9369$var$NullProtoObject = function() {
    try {
        $21da32aa197e9369$var$activeXDocument = new ActiveXObject("htmlfile");
    } catch (error) {}
    $21da32aa197e9369$var$NullProtoObject = typeof document != "undefined" ? document.domain && $21da32aa197e9369$var$activeXDocument ? $21da32aa197e9369$var$NullProtoObjectViaActiveX($21da32aa197e9369$var$activeXDocument) // old IE
     : $21da32aa197e9369$var$NullProtoObjectViaIFrame() : $21da32aa197e9369$var$NullProtoObjectViaActiveX($21da32aa197e9369$var$activeXDocument); // WSH
    var length = $2c7a9530035f509a$exports.length;
    while(length--)delete $21da32aa197e9369$var$NullProtoObject[$21da32aa197e9369$var$PROTOTYPE][$2c7a9530035f509a$exports[length]];
    return $21da32aa197e9369$var$NullProtoObject();
};
$c30c863eb145c5a8$exports[$21da32aa197e9369$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
$21da32aa197e9369$exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $21da32aa197e9369$var$EmptyConstructor[$21da32aa197e9369$var$PROTOTYPE] = $3972fdbff685207b$exports(O);
        result = new $21da32aa197e9369$var$EmptyConstructor();
        $21da32aa197e9369$var$EmptyConstructor[$21da32aa197e9369$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$21da32aa197e9369$var$IE_PROTO] = O;
    } else result = $21da32aa197e9369$var$NullProtoObject();
    return Properties === undefined ? result : $776aae61651a64af$export$2d1720544b23b823(result, Properties);
};



var $664ec0493109aa88$require$defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;
var $664ec0493109aa88$var$UNSCOPABLES = $0b105ffe14c0d5a5$exports("unscopables");
var $664ec0493109aa88$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($664ec0493109aa88$var$ArrayPrototype[$664ec0493109aa88$var$UNSCOPABLES] === undefined) $664ec0493109aa88$require$defineProperty($664ec0493109aa88$var$ArrayPrototype, $664ec0493109aa88$var$UNSCOPABLES, {
    configurable: true,
    value: $21da32aa197e9369$exports(null)
});
// add a key to Array.prototype[@@unscopables]
$664ec0493109aa88$exports = function(key) {
    $664ec0493109aa88$var$ArrayPrototype[$664ec0493109aa88$var$UNSCOPABLES][key] = true;
};





var $3dd1d4531fe4b9d5$require$defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;
var $00ee7d8cefddb502$exports = {};
"use strict";





var $2aaebeededb83b7e$exports = {};
"use strict";
var $d4c634f75c944ca5$exports = {};
"use strict";




var $44b2740ddbb64f07$exports = {};
"use strict";




var $9604c7aa55203397$exports = {};
"use strict";

$9604c7aa55203397$exports = !$7fbdf4c0599ef462$exports(function() {
    function F() {}
    F.prototype.constructor = null;
    // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
    return Object.getPrototypeOf(new F()) !== F.prototype;
});


var $44b2740ddbb64f07$var$IE_PROTO = $37f7417c6f6b2b99$exports("IE_PROTO");
var $44b2740ddbb64f07$var$$Object = Object;
var $44b2740ddbb64f07$var$ObjectPrototype = $44b2740ddbb64f07$var$$Object.prototype;
// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
$44b2740ddbb64f07$exports = $9604c7aa55203397$exports ? $44b2740ddbb64f07$var$$Object.getPrototypeOf : function(O) {
    var object = $9979de0a9e7dae17$exports(O);
    if ($cad4bbfed17498c2$exports(object, $44b2740ddbb64f07$var$IE_PROTO)) return object[$44b2740ddbb64f07$var$IE_PROTO];
    var constructor = object.constructor;
    if ($a7eaff0338821e23$exports(constructor) && object instanceof constructor) return constructor.prototype;
    return object instanceof $44b2740ddbb64f07$var$$Object ? $44b2740ddbb64f07$var$ObjectPrototype : null;
};





var $d4c634f75c944ca5$var$ITERATOR = $0b105ffe14c0d5a5$exports("iterator");
var $d4c634f75c944ca5$var$BUGGY_SAFARI_ITERATORS = false;
// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var $d4c634f75c944ca5$var$IteratorPrototype, $d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype, $d4c634f75c944ca5$var$arrayIterator;
/* eslint-disable es/no-array-prototype-keys -- safe */ if ([].keys) {
    $d4c634f75c944ca5$var$arrayIterator = [].keys();
    // Safari 8 has buggy iterators w/o `next`
    if (!("next" in $d4c634f75c944ca5$var$arrayIterator)) $d4c634f75c944ca5$var$BUGGY_SAFARI_ITERATORS = true;
    else {
        $d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype = $44b2740ddbb64f07$exports($44b2740ddbb64f07$exports($d4c634f75c944ca5$var$arrayIterator));
        if ($d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype !== Object.prototype) $d4c634f75c944ca5$var$IteratorPrototype = $d4c634f75c944ca5$var$PrototypeOfArrayIteratorPrototype;
    }
}
var $d4c634f75c944ca5$var$NEW_ITERATOR_PROTOTYPE = !$fbd29800d02822fa$exports($d4c634f75c944ca5$var$IteratorPrototype) || $7fbdf4c0599ef462$exports(function() {
    var test = {};
    // FF44- legacy iterators case
    return $d4c634f75c944ca5$var$IteratorPrototype[$d4c634f75c944ca5$var$ITERATOR].call(test) !== test;
});
if ($d4c634f75c944ca5$var$NEW_ITERATOR_PROTOTYPE) $d4c634f75c944ca5$var$IteratorPrototype = {};
else if ($6ad9df1f2e7ebd85$exports) $d4c634f75c944ca5$var$IteratorPrototype = $21da32aa197e9369$exports($d4c634f75c944ca5$var$IteratorPrototype);
// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!$a7eaff0338821e23$exports($d4c634f75c944ca5$var$IteratorPrototype[$d4c634f75c944ca5$var$ITERATOR])) $0610e46059a94cbd$exports($d4c634f75c944ca5$var$IteratorPrototype, $d4c634f75c944ca5$var$ITERATOR, function() {
    return this;
});
$d4c634f75c944ca5$exports = {
    IteratorPrototype: $d4c634f75c944ca5$var$IteratorPrototype,
    BUGGY_SAFARI_ITERATORS: $d4c634f75c944ca5$var$BUGGY_SAFARI_ITERATORS
};


var $2aaebeededb83b7e$require$IteratorPrototype = $d4c634f75c944ca5$exports.IteratorPrototype;


var $f4a284a3b2ffc725$exports = {};
"use strict";

var $f4a284a3b2ffc725$require$defineProperty = $722eb9ecceb224f8$export$2d1720544b23b823;


var $f4a284a3b2ffc725$var$TO_STRING_TAG = $0b105ffe14c0d5a5$exports("toStringTag");
$f4a284a3b2ffc725$exports = function(target, TAG, STATIC) {
    if (target && !STATIC) target = target.prototype;
    if (target && !$cad4bbfed17498c2$exports(target, $f4a284a3b2ffc725$var$TO_STRING_TAG)) $f4a284a3b2ffc725$require$defineProperty(target, $f4a284a3b2ffc725$var$TO_STRING_TAG, {
        configurable: true,
        value: TAG
    });
};



var $2aaebeededb83b7e$var$returnThis = function() {
    return this;
};
$2aaebeededb83b7e$exports = function(IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
    var TO_STRING_TAG = NAME + " Iterator";
    IteratorConstructor.prototype = $21da32aa197e9369$exports($2aaebeededb83b7e$require$IteratorPrototype, {
        next: $280423f212a26849$exports(+!ENUMERABLE_NEXT, next)
    });
    $f4a284a3b2ffc725$exports(IteratorConstructor, TO_STRING_TAG, false, true);
    $95f4729b625bb7e4$exports[TO_STRING_TAG] = $2aaebeededb83b7e$var$returnThis;
    return IteratorConstructor;
};



var $272762809cba1f01$exports = {};
"use strict";
var $794046773695e4c1$exports = {};
"use strict";


$794046773695e4c1$exports = function(object, key, method) {
    try {
        // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
        return $c800df2b7efc8f14$exports($11648e8ec26b6ecd$exports(Object.getOwnPropertyDescriptor(object, key)[method]));
    } catch (error) {}
};




var $14994f6e66f859e1$exports = {};
"use strict";
var $638415392bcad94e$exports = {};
"use strict";

$638415392bcad94e$exports = function(argument) {
    return $fbd29800d02822fa$exports(argument) || argument === null;
};


var $14994f6e66f859e1$var$$String = String;
var $14994f6e66f859e1$var$$TypeError = TypeError;
$14994f6e66f859e1$exports = function(argument) {
    if ($638415392bcad94e$exports(argument)) return argument;
    throw new $14994f6e66f859e1$var$$TypeError("Can't set " + $14994f6e66f859e1$var$$String(argument) + " as a prototype");
};


// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
$272762809cba1f01$exports = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var CORRECT_SETTER = false;
    var test = {};
    var setter;
    try {
        setter = $794046773695e4c1$exports(Object.prototype, "__proto__", "set");
        setter(test, []);
        CORRECT_SETTER = test instanceof Array;
    } catch (error) {}
    return function setPrototypeOf(O, proto) {
        $dc13fa5d6a969043$exports(O);
        $14994f6e66f859e1$exports(proto);
        if (!$fbd29800d02822fa$exports(O)) return O;
        if (CORRECT_SETTER) setter(O, proto);
        else O.__proto__ = proto;
        return O;
    };
}() : undefined);








var $00ee7d8cefddb502$var$PROPER_FUNCTION_NAME = $4c1919cb72ce1a0c$exports.PROPER;
var $00ee7d8cefddb502$var$CONFIGURABLE_FUNCTION_NAME = $4c1919cb72ce1a0c$exports.CONFIGURABLE;
var $00ee7d8cefddb502$var$IteratorPrototype = $d4c634f75c944ca5$exports.IteratorPrototype;
var $00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS = $d4c634f75c944ca5$exports.BUGGY_SAFARI_ITERATORS;
var $00ee7d8cefddb502$var$ITERATOR = $0b105ffe14c0d5a5$exports("iterator");
var $00ee7d8cefddb502$var$KEYS = "keys";
var $00ee7d8cefddb502$var$VALUES = "values";
var $00ee7d8cefddb502$var$ENTRIES = "entries";
var $00ee7d8cefddb502$var$returnThis = function() {
    return this;
};
$00ee7d8cefddb502$exports = function(Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
    $2aaebeededb83b7e$exports(IteratorConstructor, NAME, next);
    var getIterationMethod = function(KIND) {
        if (KIND === DEFAULT && defaultIterator) return defaultIterator;
        if (!$00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS && KIND && KIND in IterablePrototype) return IterablePrototype[KIND];
        switch(KIND){
            case $00ee7d8cefddb502$var$KEYS:
                return function keys() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00ee7d8cefddb502$var$VALUES:
                return function values() {
                    return new IteratorConstructor(this, KIND);
                };
            case $00ee7d8cefddb502$var$ENTRIES:
                return function entries() {
                    return new IteratorConstructor(this, KIND);
                };
        }
        return function() {
            return new IteratorConstructor(this);
        };
    };
    var TO_STRING_TAG = NAME + " Iterator";
    var INCORRECT_VALUES_NAME = false;
    var IterablePrototype = Iterable.prototype;
    var nativeIterator = IterablePrototype[$00ee7d8cefddb502$var$ITERATOR] || IterablePrototype["@@iterator"] || DEFAULT && IterablePrototype[DEFAULT];
    var defaultIterator = !$00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
    var anyNativeIterator = NAME === "Array" ? IterablePrototype.entries || nativeIterator : nativeIterator;
    var CurrentIteratorPrototype, methods, KEY;
    // fix native
    if (anyNativeIterator) {
        CurrentIteratorPrototype = $44b2740ddbb64f07$exports(anyNativeIterator.call(new Iterable()));
        if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
            if (!$6ad9df1f2e7ebd85$exports && $44b2740ddbb64f07$exports(CurrentIteratorPrototype) !== $00ee7d8cefddb502$var$IteratorPrototype) {
                if ($272762809cba1f01$exports) $272762809cba1f01$exports(CurrentIteratorPrototype, $00ee7d8cefddb502$var$IteratorPrototype);
                else if (!$a7eaff0338821e23$exports(CurrentIteratorPrototype[$00ee7d8cefddb502$var$ITERATOR])) $0610e46059a94cbd$exports(CurrentIteratorPrototype, $00ee7d8cefddb502$var$ITERATOR, $00ee7d8cefddb502$var$returnThis);
            }
            // Set @@toStringTag to native iterators
            $f4a284a3b2ffc725$exports(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
            if ($6ad9df1f2e7ebd85$exports) $95f4729b625bb7e4$exports[TO_STRING_TAG] = $00ee7d8cefddb502$var$returnThis;
        }
    }
    // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
    if ($00ee7d8cefddb502$var$PROPER_FUNCTION_NAME && DEFAULT === $00ee7d8cefddb502$var$VALUES && nativeIterator && nativeIterator.name !== $00ee7d8cefddb502$var$VALUES) {
        if (!$6ad9df1f2e7ebd85$exports && $00ee7d8cefddb502$var$CONFIGURABLE_FUNCTION_NAME) $13b85566beee9498$exports(IterablePrototype, "name", $00ee7d8cefddb502$var$VALUES);
        else {
            INCORRECT_VALUES_NAME = true;
            defaultIterator = function values() {
                return $0c06b1aeebe22a6e$exports(nativeIterator, this);
            };
        }
    }
    // export additional methods
    if (DEFAULT) {
        methods = {
            values: getIterationMethod($00ee7d8cefddb502$var$VALUES),
            keys: IS_SET ? defaultIterator : getIterationMethod($00ee7d8cefddb502$var$KEYS),
            entries: getIterationMethod($00ee7d8cefddb502$var$ENTRIES)
        };
        if (FORCED) {
            for(KEY in methods)if ($00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) $0610e46059a94cbd$exports(IterablePrototype, KEY, methods[KEY]);
        } else $75395d4d1502b249$exports({
            target: NAME,
            proto: true,
            forced: $00ee7d8cefddb502$var$BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME
        }, methods);
    }
    // define iterator
    if ((!$6ad9df1f2e7ebd85$exports || FORCED) && IterablePrototype[$00ee7d8cefddb502$var$ITERATOR] !== defaultIterator) $0610e46059a94cbd$exports(IterablePrototype, $00ee7d8cefddb502$var$ITERATOR, defaultIterator, {
        name: DEFAULT
    });
    $95f4729b625bb7e4$exports[NAME] = defaultIterator;
    return methods;
};


var $6712d89e16ffd986$exports = {};
"use strict";
// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
$6712d89e16ffd986$exports = function(value, done) {
    return {
        value: value,
        done: done
    };
};




var $3dd1d4531fe4b9d5$var$ARRAY_ITERATOR = "Array Iterator";
var $3dd1d4531fe4b9d5$var$setInternalState = $f87bb15e699cf95b$exports.set;
var $3dd1d4531fe4b9d5$var$getInternalState = $f87bb15e699cf95b$exports.getterFor($3dd1d4531fe4b9d5$var$ARRAY_ITERATOR);
// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
$3dd1d4531fe4b9d5$exports = $00ee7d8cefddb502$exports(Array, "Array", function(iterated, kind) {
    $3dd1d4531fe4b9d5$var$setInternalState(this, {
        type: $3dd1d4531fe4b9d5$var$ARRAY_ITERATOR,
        target: $9d811c44f1b32f82$exports(iterated),
        index: 0,
        kind: kind // kind
    });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function() {
    var state = $3dd1d4531fe4b9d5$var$getInternalState(this);
    var target = state.target;
    var index = state.index++;
    if (!target || index >= target.length) {
        state.target = undefined;
        return $6712d89e16ffd986$exports(undefined, true);
    }
    switch(state.kind){
        case "keys":
            return $6712d89e16ffd986$exports(index, false);
        case "values":
            return $6712d89e16ffd986$exports(target[index], false);
    }
    return $6712d89e16ffd986$exports([
        index,
        target[index]
    ], false);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var $3dd1d4531fe4b9d5$var$values = $95f4729b625bb7e4$exports.Arguments = $95f4729b625bb7e4$exports.Array;
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$664ec0493109aa88$exports("keys");
$664ec0493109aa88$exports("values");
$664ec0493109aa88$exports("entries");
// V8 ~ Chrome 45- bug
if (!$6ad9df1f2e7ebd85$exports && $52f9c610bf0521fc$exports && $3dd1d4531fe4b9d5$var$values.name !== "values") try {
    $3dd1d4531fe4b9d5$require$defineProperty($3dd1d4531fe4b9d5$var$values, "name", {
        value: "values"
    });
} catch (error) {}





var $8cc0c75cf23be5a0$var$ITERATOR = $0b105ffe14c0d5a5$exports("iterator");
var $8cc0c75cf23be5a0$var$ArrayValues = $3dd1d4531fe4b9d5$exports.values;
var $8cc0c75cf23be5a0$var$handlePrototype = function(CollectionPrototype, COLLECTION_NAME) {
    if (CollectionPrototype) {
        // some Chrome versions have non-configurable methods on DOMTokenList
        if (CollectionPrototype[$8cc0c75cf23be5a0$var$ITERATOR] !== $8cc0c75cf23be5a0$var$ArrayValues) try {
            $13b85566beee9498$exports(CollectionPrototype, $8cc0c75cf23be5a0$var$ITERATOR, $8cc0c75cf23be5a0$var$ArrayValues);
        } catch (error) {
            CollectionPrototype[$8cc0c75cf23be5a0$var$ITERATOR] = $8cc0c75cf23be5a0$var$ArrayValues;
        }
        $f4a284a3b2ffc725$exports(CollectionPrototype, COLLECTION_NAME, true);
        if ($e58a769b5c316bc3$exports[COLLECTION_NAME]) for(var METHOD_NAME in $3dd1d4531fe4b9d5$exports){
            // some Chrome versions have non-configurable methods on DOMTokenList
            if (CollectionPrototype[METHOD_NAME] !== $3dd1d4531fe4b9d5$exports[METHOD_NAME]) try {
                $13b85566beee9498$exports(CollectionPrototype, METHOD_NAME, $3dd1d4531fe4b9d5$exports[METHOD_NAME]);
            } catch (error) {
                CollectionPrototype[METHOD_NAME] = $3dd1d4531fe4b9d5$exports[METHOD_NAME];
            }
        }
    }
};
for(var $8cc0c75cf23be5a0$var$COLLECTION_NAME in $e58a769b5c316bc3$exports)$8cc0c75cf23be5a0$var$handlePrototype($28b32bdb3c934954$exports[$8cc0c75cf23be5a0$var$COLLECTION_NAME] && $28b32bdb3c934954$exports[$8cc0c75cf23be5a0$var$COLLECTION_NAME].prototype, $8cc0c75cf23be5a0$var$COLLECTION_NAME);
$8cc0c75cf23be5a0$var$handlePrototype($c304d3413cc13bcd$exports, "DOMTokenList");




parcelRequire("8ZuGG");
var $11bb442d9fd66b68$export$882461b6382ed46c;
var $11bb442d9fd66b68$export$757ceba2d55c277e;
"use strict";

var $h1d60 = parcelRequire("h1d60");
var $11bb442d9fd66b68$var$i;
$11bb442d9fd66b68$export$882461b6382ed46c = $h1d60.createRoot;
$11bb442d9fd66b68$export$757ceba2d55c277e = $h1d60.hydrateRoot;


parcelRequire("iBTcr");
var $e1hxF = parcelRequire("e1hxF");

var $gyRZh = parcelRequire("gyRZh");

var $cufV0 = parcelRequire("cufV0");

var $9Li6K = parcelRequire("9Li6K");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $7tB0e = parcelRequire("7tB0e");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $jSnDV = parcelRequire("jSnDV");

var $gGDrC = parcelRequire("gGDrC");
var $iSD9t = parcelRequire("iSD9t");

var $HBurV = parcelRequire("HBurV");

var $3VrrU = parcelRequire("3VrrU");
var $aea8a4ae1ebffbe2$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    csrfMismatchTitle: {
        id: "error.csrfmismatch.title",
        defaultMessage: "We couldn't log you in"
    },
    csrfMismatchDescriptionFirstLine: {
        id: "error.csrfmismatch.description.firstline",
        defaultMessage: "Before trying again:"
    },
    csrfMismatchDescriptionThirdLine: {
        id: "error.csrfmismatch.description.thirdline",
        defaultMessage: "Check your browser settings and disable any extensions that may interfere with cookies."
    },
    csrfMismatchButtonText: {
        id: "error.csrfmismatch.button",
        defaultMessage: "Try logging in again"
    }
});



var $7CMue = parcelRequire("7CMue");

var $1SvOA = parcelRequire("1SvOA");

var $gJFTu = parcelRequire("gJFTu");

var $3ir1n = parcelRequire("3ir1n");

var $3XNKR = parcelRequire("3XNKR");

var $5b7Z4 = parcelRequire("5b7Z4");
let $993cb5104798db5b$var$_ = (t)=>t, $993cb5104798db5b$var$t;
const $993cb5104798db5b$var$pageId = "atlassianAccountCsrfTokenMismatchErrorScreen";
const $993cb5104798db5b$var$StyledOptions = (0, $3XNKR.default).ul($993cb5104798db5b$var$t || ($993cb5104798db5b$var$t = $993cb5104798db5b$var$_`
  padding-left: ${0}px;
`), 3 * (0, $5b7Z4.gridSize)());
const $993cb5104798db5b$export$2529ac9c93e3a3c2 = ()=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsClient = (0, $3ir1n.useAnalyticsClient)();
    const preservedParamsKeys = [
        "application",
        "continue",
        "display",
        "email",
        "login_hint",
        "tenant"
    ];
    const originalParams = $jSnDV.parse(window.location.search);
    const preservedParams = Object.keys(originalParams).filter((key)=>preservedParamsKeys.includes(key)).reduce((obj, key)=>{
        obj[key] = originalParams[key];
        return obj;
    }, {});
    (0, $3ir1n.usePageViewedEvent)($993cb5104798db5b$var$pageId, {
        application: preservedParams.application
    });
    const tryLoginAgainAction = ()=>{
        analyticsClient.buttonClickedEvent($993cb5104798db5b$var$pageId, "csrfTokenMismatchTryAgainButton", {
            application: preservedParams.application
        });
        const queryParamsString = $jSnDV.stringify(preservedParams);
        window.location.assign("/login" + (queryParamsString ? `?${queryParamsString}` : ""));
    };
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $7CMue.default), {
        pageId: $993cb5104798db5b$var$pageId,
        header: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            tagName: "h5",
            ...(0, $aea8a4ae1ebffbe2$export$2e2bcd8739ae039).csrfMismatchTitle
        }),
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($HBurV))),
                height: "150",
                alt: "",
                className: "error-image"
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("br", {}),
            /*#__PURE__*/ (0, $6rcps.jsxs)("div", {
                className: "error-description",
                children: [
                    /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                        ...(0, $aea8a4ae1ebffbe2$export$2e2bcd8739ae039).csrfMismatchDescriptionFirstLine
                    }),
                    /*#__PURE__*/ (0, $6rcps.jsxs)($993cb5104798db5b$var$StyledOptions, {
                        children: [
                            /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    id: "error.csrfmismatch.description.secondline",
                                    defaultMessage: "Close any <b>{siteName}</b> windows in your browser",
                                    values: {
                                        b: (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("strong", {
                                                children: chunks
                                            }),
                                        siteName: window.location.hostname
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $6rcps.jsx)("li", {
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                                    ...(0, $aea8a4ae1ebffbe2$export$2e2bcd8739ae039).csrfMismatchDescriptionThirdLine
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $gJFTu.default), {
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $1SvOA.default), {
                    appearance: "primary",
                    id: "try-again-button",
                    isFullWidth: true,
                    onClick: tryLoginAgainAction,
                    children: formatMessage((0, $aea8a4ae1ebffbe2$export$2e2bcd8739ae039).csrfMismatchButtonText)
                })
            })
        ]
    });
};
var $993cb5104798db5b$export$2e2bcd8739ae039 = $993cb5104798db5b$export$2529ac9c93e3a3c2;



var $3VrrU = parcelRequire("3VrrU");
var $caaed7f68f806aa4$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    genericErrorTitle: {
        id: "error.title",
        defaultMessage: "Something went wrong."
    },
    internalServerErrorTitle: {
        id: "error.internalservererror.title",
        defaultMessage: "Something went wrong while executing your request."
    },
    internalServerErrorDescription: {
        id: "error.internalservererror.desc",
        defaultMessage: "We're working on it, please try again shortly."
    },
    notFoundTitle: {
        id: "error.notfound.title",
        defaultMessage: "Page Not Found"
    },
    badRequestTitle: {
        id: "error.badrequest.title",
        defaultMessage: "Oops, you've made a malformed request."
    }
});



var $kOqgB = parcelRequire("kOqgB");
const $9620e8d7f2a05fd6$export$f90bece7989dfdb6 = ({ children: children })=>{
    const intl = (0, $iSD9t.default)();
    const serverError = (0, $kOqgB.useAppSelector)((state)=>state.serverError);
    if (serverError) {
        if (serverError.type === "not_found") return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
            title: intl.formatMessage((0, $caaed7f68f806aa4$export$2e2bcd8739ae039).notFoundTitle)
        });
        else if (serverError.type === "internal_server_error") return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
            title: intl.formatMessage((0, $caaed7f68f806aa4$export$2e2bcd8739ae039).internalServerErrorTitle),
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                ...(0, $caaed7f68f806aa4$export$2e2bcd8739ae039).internalServerErrorDescription
            })
        });
        else if (serverError.type === "bad_request") return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
            title: intl.formatMessage((0, $caaed7f68f806aa4$export$2e2bcd8739ae039).badRequestTitle),
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
                id: "error.badrequest.desc.xml",
                defaultMessage: "Often, clearing your browsers cache and restarting your browser will solve this problem.{br}If that doesn't work, please <support-link>contact support</support-link>.",
                values: {
                    br: /*#__PURE__*/ (0, $6rcps.jsx)("br", {}),
                    "support-link": (chunks)=>/*#__PURE__*/ (0, $6rcps.jsx)("a", {
                            href: "https://support.atlassian.com/",
                            target: "_blank",
                            rel: "noreferrer",
                            children: chunks
                        })
                }
            })
        });
        else if (serverError.type === "csrf_token_mismatch") return /*#__PURE__*/ (0, $6rcps.jsx)((0, $993cb5104798db5b$export$2e2bcd8739ae039), {});
        else throw new Error(serverError.type || "ServerError");
    }
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};
var $9620e8d7f2a05fd6$export$2e2bcd8739ae039 = $9620e8d7f2a05fd6$export$f90bece7989dfdb6;



var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $gGDrC = parcelRequire("gGDrC");

var $day6I = parcelRequire("day6I");

var $7tB0e = parcelRequire("7tB0e");

var $kOqgB = parcelRequire("kOqgB");
const $b20cf8091a47c413$var$isUnSupportedMobileBrowser = ()=>{
    return /UC.*Browser|UCWEB/.test(window.navigator.userAgent);
};
const $b20cf8091a47c413$export$3746f9f8319adede = ({ children: children })=>{
    const oidcContext = (0, $kOqgB.useAppSelector)((state)=>state.microbranding.oidcContext);
    if ((0, $day6I.isMobileOidc)(oidcContext) && $b20cf8091a47c413$var$isUnSupportedMobileBrowser()) return /*#__PURE__*/ (0, $6rcps.jsx)((0, $7tB0e.default), {
        title: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "unsupported.mobile.browser.error.message.heading",
            defaultMessage: "We\u2019re unable to log you in"
        }),
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gGDrC.default), {
            id: "unsupported.mobile.browser.error.message.content",
            defaultMessage: "You are currently using an unsupported browser. Please use a supported browser such as Chrome, Firefox, Opera or Samsung Internet."
        })
    });
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};
var $b20cf8091a47c413$export$2e2bcd8739ae039 = $b20cf8091a47c413$export$3746f9f8319adede;



var $8f2pb = parcelRequire("8f2pb");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $4OQoZ = parcelRequire("4OQoZ");

var $8f2pb = parcelRequire("8f2pb");

var $kOqgB = parcelRequire("kOqgB");

























const $b47ccb028625d76a$var$languages = {
    "pt-BR": ()=>(parcelRequire("9ek8N")),
    "en-ZZ": ()=>(parcelRequire("imyZ9")),
    "en-GB": ()=>(parcelRequire("41CBD")),
    "zh-CN": ()=>(parcelRequire("hQLzx")),
    "zh-TW": ()=>(parcelRequire("2n6QC")),
    cs: ()=>(parcelRequire("jgIFg")),
    da: ()=>(parcelRequire("eQS3o")),
    de: ()=>(parcelRequire("d8wgI")),
    en: ()=>(parcelRequire("g4zfV")),
    es: ()=>(parcelRequire("3uRuL")),
    fi: ()=>(parcelRequire("b6QhV")),
    fr: ()=>(parcelRequire("4MwDy")),
    hu: ()=>(parcelRequire("2zMlh")),
    it: ()=>(parcelRequire("2TaUl")),
    ja: ()=>(parcelRequire("bfqCY")),
    ko: ()=>(parcelRequire("lEJ78")),
    nb: ()=>(parcelRequire("gqK4f")),
    nl: ()=>(parcelRequire("3omAS")),
    pl: ()=>(parcelRequire("7yvG1")),
    ru: ()=>(parcelRequire("e7JDz")),
    sv: ()=>(parcelRequire("gQVR5")),
    th: ()=>(parcelRequire("4R2AC")),
    tr: ()=>(parcelRequire("jrFLZ")),
    uk: ()=>(parcelRequire("b05HP")),
    vi: ()=>(parcelRequire("2FOdn"))
};
const $b47ccb028625d76a$var$fetchLanguage = async (locale)=>{
    if (locale in $b47ccb028625d76a$var$languages) {
        const messages = await $b47ccb028625d76a$var$languages[locale]();
        return {
            locale: locale,
            messages: messages.default || messages
        };
    }
    throw new Error(`${locale} not found in languages config`);
};
const $b47ccb028625d76a$var$LocaleSwitcher = ({ children: children })=>{
    const locale = (0, $kOqgB.useAppSelector)((state)=>state.locale);
    const [fallbackLocale] = locale.split("-", 1);
    const [{ loading: loading, messages: messages, derivedLocale: derivedLocale }, setState] = (0, $8ZuGG.useState)({
        loading: true,
        messages: {},
        derivedLocale: locale
    });
    (0, $8ZuGG.useEffect)(()=>{
        $b47ccb028625d76a$var$fetchLanguage(locale).catch(()=>$b47ccb028625d76a$var$fetchLanguage(fallbackLocale)).then((i18n)=>{
            setState({
                loading: false,
                messages: i18n.messages,
                derivedLocale: i18n.locale
            });
        }, ()=>{
            const content = `no translations were found for localeId ${locale} or fallbackLocale ${fallbackLocale}.`;
            console.debug(content);
            (0, $8f2pb.captureErrorMessage)("i18n_fetch_language_error", {
                content: content,
                locale: locale,
                fallbackLocale: fallbackLocale
            });
            setState((prevState)=>({
                    ...prevState,
                    loading: false
                }));
        });
    }, [
        locale,
        fallbackLocale
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $4OQoZ.default), {
        locale: derivedLocale,
        messages: messages,
        children: loading ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {}) : children
    });
};
var $b47ccb028625d76a$export$2e2bcd8739ae039 = $b47ccb028625d76a$var$LocaleSwitcher;



var $82mu7 = parcelRequire("82mu7");

var $6rcps = parcelRequire("6rcps");


var $l9koH = parcelRequire("l9koH");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $iSD9t = parcelRequire("iSD9t");

var $5WDNl = parcelRequire("5WDNl");parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $6rcps = parcelRequire("6rcps");

var $3XNKR = parcelRequire("3XNKR");

var $8ZuGG = parcelRequire("8ZuGG");
parcelRequire("iBTcr");
var $ittIU = parcelRequire("ittIU");

var $ihLLY = parcelRequire("ihLLY");
const $f98abd6680cb5f12$export$92b52f782097f1e7 = (screenSize)=>({
        type: "SCREEN_SIZE_UPDATED",
        screenSize: screenSize
    });


let $e75b92d5ce2de9e1$var$_ = (t)=>t, $e75b92d5ce2de9e1$var$t;
const $e75b92d5ce2de9e1$var$FullHeightContainer = (0, $3XNKR.default).div($e75b92d5ce2de9e1$var$t || ($e75b92d5ce2de9e1$var$t = $e75b92d5ce2de9e1$var$_`
  height: 100%;
`));
const $e75b92d5ce2de9e1$var$DeviceTypeListener = ({ dispatch: dispatch, children: children })=>{
    (0, $8ZuGG.useEffect)(()=>{
        if (!(0, $ihLLY.screenSizeMatcher)) return;
        const onScreenSizeUpdated = ({ matches: matches })=>{
            dispatch((0, $f98abd6680cb5f12$export$92b52f782097f1e7)(matches ? "mobile" : "desktop"));
        };
        try {
            /**
       * Improved API but supported by only ~94.2% of browsers
       * https://caniuse.com/mdn-api_mediaquerylist_change_event
       */ (0, $ihLLY.screenSizeMatcher).addEventListener("change", onScreenSizeUpdated);
            return ()=>(0, $ihLLY.screenSizeMatcher).removeEventListener("change", onScreenSizeUpdated);
        } catch (e) {
            /**
       * These methods are deprecated but needed as fallbacks for browsers older than:
       * - Edge 79 (released 2020-01)
       * - Safari 14 (released 2020-09)
       * - Safari on iOS 14 (released 2020-09)
       *
       * All other browsers have had support since 2014-2017.
       * https://developer.mozilla.org/en-US/docs/Web/API/MediaQueryList/change_event
       */ (0, $ihLLY.screenSizeMatcher).addListener(onScreenSizeUpdated);
            return ()=>(0, $ihLLY.screenSizeMatcher).removeListener(onScreenSizeUpdated);
        }
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0, $6rcps.jsx)($e75b92d5ce2de9e1$var$FullHeightContainer, {
        children: children
    });
};
var $e75b92d5ce2de9e1$export$2e2bcd8739ae039 = (0, $ittIU.default)()($e75b92d5ce2de9e1$var$DeviceTypeListener);



var $kOqgB = parcelRequire("kOqgB");

var $cugIF = parcelRequire("cugIF");

var $3VrrU = parcelRequire("3VrrU");
var $178059c9f52b5bc2$export$2e2bcd8739ae039 = (0, $3VrrU.defineMessages)({
    headTitle: {
        id: "default.head.title",
        defaultMessage: "Log in with Atlassian account"
    }
});



var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3XNKR = parcelRequire("3XNKR");

var $dLcU7 = parcelRequire("dLcU7");

var $6bkHe = parcelRequire("6bkHe");

var $kg5sN = parcelRequire("kg5sN");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $lThM2 = parcelRequire("lThM2");
var $7SrF8 = parcelRequire("7SrF8");
var $6m9zh = parcelRequire("6m9zh");
var $57fzU = parcelRequire("57fzU");

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $kg5sN = parcelRequire("kg5sN");

var $14VNY = parcelRequire("14VNY");

var $8ZuGG = parcelRequire("8ZuGG");
// Allows support for heading levels 1-9 via aria-level
var $f27d983380a0811f$var$HeadingLevelContext = /*#__PURE__*/ (0, $8ZuGG.createContext)(0);
var $f27d983380a0811f$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $8ZuGG.useContext)($f27d983380a0811f$var$HeadingLevelContext);
};
var $f27d983380a0811f$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $f27d983380a0811f$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? "div" : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $f27d983380a0811f$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $f27d983380a0811f$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement($f27d983380a0811f$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $f27d983380a0811f$export$2e2bcd8739ae039 = $f27d983380a0811f$var$HeadingLevelContextProvider;



var $kg5sN = parcelRequire("kg5sN");

var $14VNY = parcelRequire("14VNY");

var $1S0T5 = parcelRequire("1S0T5");
var $9YQBI = parcelRequire("9YQBI");


var $1RdT6 = parcelRequire("1RdT6");
var $8504147a054b0381$var$sizeTagMap = {
    xxlarge: "h1",
    xlarge: "h1",
    large: "h2",
    medium: "h3",
    small: "h4",
    xsmall: "h5",
    xxsmall: "h6"
};
var $8504147a054b0381$var$headingResetStyles = (0, $14VNY.css)({
    letterSpacing: "normal",
    marginBlock: 0,
    textTransform: "none"
});
var $8504147a054b0381$var$useColor = function useColor(colorProp) {
    var surface = (0, $9YQBI.useSurface)();
    /**
   * Where the color of the surface is inverted we always override the color
   * as there is no valid choice that is not covered by the override.
   */ if ((0, $1S0T5.inverseColorMap).hasOwnProperty(surface)) return (0, $1S0T5.inverseColorMap)[surface];
    return colorProp || "color.text";
};
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $8504147a054b0381$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, id = _ref.id, testId = _ref.testId, as = _ref.as, colorProp = _ref.color;
    typeof $1RdT6;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $f27d983380a0811f$export$97a37b1befbbf9b1)($8504147a054b0381$var$sizeTagMap[size]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === "div" && hLevel;
    var color = $8504147a054b0381$var$useColor(colorProp);
    return (0, $14VNY.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $8504147a054b0381$var$headingResetStyles,
            size && $8504147a054b0381$var$headingSizeStylesMap[size],
            $8504147a054b0381$export$93e8ddd840a408f9[color]
        ]
    }, children);
};
var $8504147a054b0381$export$93e8ddd840a408f9 = {
    "color.text": (0, $14VNY.css)({
        color: "var(--ds-text, #172B4D)"
    }),
    "color.text.inverse": (0, $14VNY.css)({
        color: "var(--ds-text-inverse, #FFFFFF)"
    }),
    "color.text.warning.inverse": (0, $14VNY.css)({
        color: "var(--ds-text-warning-inverse, #172B4D)"
    })
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::df829c6c0aa19bb57c0c77dc08d12d60>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $8504147a054b0381$var$headingSizeStylesMap = {
    xxlarge: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xlarge: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    large: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    medium: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    small: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xsmall: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    }),
    xxsmall: (0, $14VNY.css)({
        font: 'var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif)'
    })
};
var /**
 * @codegenEnd
 */ $8504147a054b0381$export$2e2bcd8739ae039 = $8504147a054b0381$var$Heading;



var $1RdT6 = parcelRequire("1RdT6");
var $b75510f2a5d749a7$var$_excluded = [
    "level"
];
// https://atlassian.design/foundations/typography
var $b75510f2a5d749a7$var$levelMap = {
    h900: "h1",
    h800: "h1",
    h700: "h2",
    h600: "h3",
    h500: "h4",
    h400: "h5",
    h300: "h6",
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: "div",
    h100: "div"
};
var $b75510f2a5d749a7$var$headingResetStyles = (0, $14VNY.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $b75510f2a5d749a7$var$h900Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $b75510f2a5d749a7$var$h800Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $b75510f2a5d749a7$var$h700Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.01em",
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $b75510f2a5d749a7$var$h600Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: "-0.008em",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $b75510f2a5d749a7$var$h500Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.006em",
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $b75510f2a5d749a7$var$h400Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: "-0.003em",
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $b75510f2a5d749a7$var$h300Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: "uppercase"
});
var $b75510f2a5d749a7$var$h200Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $b75510f2a5d749a7$var$h100Styles = (0, $14VNY.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $b75510f2a5d749a7$var$inverseStyles = (0, $14VNY.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $b75510f2a5d749a7$var$subtlestStyles = (0, $14VNY.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $b75510f2a5d749a7$var$OldHeading = function OldHeading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? "default" : _ref$color;
    typeof $1RdT6;
    var _useHeading = (0, $f27d983380a0811f$export$97a37b1befbbf9b1)($b75510f2a5d749a7$var$levelMap[level]), _useHeading2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === "h200" || level === "h100";
    var needsAriaRole = Markup === "div" && hLevel;
    return (0, $14VNY.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? "heading" : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $b75510f2a5d749a7$var$headingResetStyles,
            level === "h100" && $b75510f2a5d749a7$var$h100Styles,
            level === "h200" && $b75510f2a5d749a7$var$h200Styles,
            level === "h300" && $b75510f2a5d749a7$var$h300Styles,
            level === "h400" && $b75510f2a5d749a7$var$h400Styles,
            level === "h500" && $b75510f2a5d749a7$var$h500Styles,
            level === "h600" && $b75510f2a5d749a7$var$h600Styles,
            level === "h700" && $b75510f2a5d749a7$var$h700Styles,
            level === "h800" && $b75510f2a5d749a7$var$h800Styles,
            level === "h900" && $b75510f2a5d749a7$var$h900Styles,
            color === "inverse" && $b75510f2a5d749a7$var$inverseStyles,
            color === "default" && isSubtleHeading && $b75510f2a5d749a7$var$subtlestStyles
        ]
    }, children);
};
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * // New component
 * <Heading size="xxlarge">Page title</Heading>
 *
 * // Old component
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $b75510f2a5d749a7$var$Heading = function Heading(_ref2) {
    var level = _ref2.level, props = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $b75510f2a5d749a7$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $14VNY.jsx)($b75510f2a5d749a7$var$OldHeading, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content, @repo/internal/react/no-unsafe-spread-props
    (0, $14VNY.jsx)((0, $8504147a054b0381$export$2e2bcd8739ae039), props);
};
var $b75510f2a5d749a7$export$2e2bcd8739ae039 = $b75510f2a5d749a7$var$Heading;



var $1Muvn = parcelRequire("1Muvn");

var $5AVd4 = parcelRequire("5AVd4");
var $33ed62187a2b812a$export$d6830277b06edd6 = "normal";
var $33ed62187a2b812a$export$4f8f13a66ae77bdd = "--color";
var $33ed62187a2b812a$export$e9244ec13bd422b5 = "--bg-color";
var $33ed62187a2b812a$export$97e78d9745006c11 = "--bg-color-hover";
var $33ed62187a2b812a$export$291d63757828f290 = "--bg-color-active";


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $kTdw7 = parcelRequire("kTdw7");
var $9a63c6f93d170bef$export$59e42969c95d314 = {
    error: "color.background.danger.bold",
    info: "color.background.neutral.bold",
    normal: "elevation.surface.overlay",
    success: "color.background.success.bold",
    warning: "color.background.warning.bold"
};
var $9a63c6f93d170bef$export$7f70afe2167f8235 = {
    error: "var(--ds-icon-inverse, ".concat((0, $kTdw7.N0), ")"),
    info: "var(--ds-icon-inverse, ".concat((0, $kTdw7.N0), ")"),
    normal: "var(--ds-icon-subtle, ".concat((0, $kTdw7.N500), ")"),
    success: "var(--ds-icon-inverse, ".concat((0, $kTdw7.N0), ")"),
    warning: "var(--ds-icon-warning-inverse, ".concat((0, $kTdw7.N700), ")")
};
var $9a63c6f93d170bef$export$f50075b2584087f = {
    error: "color.text.inverse",
    info: "color.text.inverse",
    normal: "color.text",
    success: "color.text.inverse",
    warning: "color.text.warning.inverse"
};
var $9a63c6f93d170bef$export$13b42cd9d596bfe0 = {
    error: "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")"),
    normal: "var(--ds-text, ".concat((0, $kTdw7.N800), ")"),
    success: "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $kTdw7.N700), ")")
};
var $9a63c6f93d170bef$export$81ba6b63eedb299f = {
    success: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $kTdw7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $kTdw7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $kTdw7.N30A), ")")
    },
    info: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $kTdw7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $kTdw7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $kTdw7.N30A), ")")
    },
    error: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $kTdw7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $kTdw7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $kTdw7.N30A), ")")
    },
    warning: {
        default: "var(--ds-background-inverse-subtle, ".concat((0, $kTdw7.N30A), ")"),
        active: "var(--ds-background-inverse-subtle-pressed, ".concat((0, $kTdw7.N30A), ")"),
        pressed: "var(--ds-background-inverse-subtle-hovered, ".concat((0, $kTdw7.N30A), ")")
    },
    normal: {
        default: "none",
        active: "none",
        pressed: "none"
    }
};
var $9a63c6f93d170bef$export$7bcfe3cca4dd78b6 = {
    success: "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")"),
    info: "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $kTdw7.N0), ")"),
    warning: "var(--ds-text-warning-inverse, ".concat((0, $kTdw7.N700), ")"),
    normal: "var(--ds-link, ".concat((0, $kTdw7.B400), ")")
};



var $6bkHe = parcelRequire("6bkHe");

var $14VNY = parcelRequire("14VNY");

var $dLcU7 = parcelRequire("dLcU7");

var $kg5sN = parcelRequire("kg5sN");

var $6bkHe = parcelRequire("6bkHe");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $62B5W = parcelRequire("62B5W");

var $dLcU7 = parcelRequire("dLcU7");

var $1Wcv5 = parcelRequire("1Wcv5");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $1Muvn = parcelRequire("1Muvn");

var $5AVd4 = parcelRequire("5AVd4");

var $c7GPs = parcelRequire("c7GPs");

var $c3Xui = parcelRequire("c3Xui");

var $hUeXI = parcelRequire("hUeXI");

var $kTdw7 = parcelRequire("kTdw7");
function $64cbd9f56e9cb7f0$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $64cbd9f56e9cb7f0$var$tabKeyCode = 9;
function $64cbd9f56e9cb7f0$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $64cbd9f56e9cb7f0$var$tabKeyCode) return;
    $64cbd9f56e9cb7f0$var$abort(event);
}
var $64cbd9f56e9cb7f0$var$block = {
    onMouseDownCapture: $64cbd9f56e9cb7f0$var$abort,
    onMouseUpCapture: $64cbd9f56e9cb7f0$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $64cbd9f56e9cb7f0$var$onKey,
    onKeyUpCapture: $64cbd9f56e9cb7f0$var$onKey,
    onTouchStartCapture: $64cbd9f56e9cb7f0$var$abort,
    onTouchEndCapture: $64cbd9f56e9cb7f0$var$abort,
    onPointerDownCapture: $64cbd9f56e9cb7f0$var$abort,
    onPointerUpCapture: $64cbd9f56e9cb7f0$var$abort,
    onClickCapture: $64cbd9f56e9cb7f0$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $64cbd9f56e9cb7f0$var$abort
};
var $64cbd9f56e9cb7f0$var$doNotBlock = {};
function $64cbd9f56e9cb7f0$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $64cbd9f56e9cb7f0$var$doNotBlock : $64cbd9f56e9cb7f0$var$block;
}



var $6bkHe = parcelRequire("6bkHe");

var $14VNY = parcelRequire("14VNY");

var $i2LcI = parcelRequire("i2LcI");

var $5b7Z4 = parcelRequire("5b7Z4");

var $kTdw7 = parcelRequire("kTdw7");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $707b76b7d2b451c4$var$fadedB75 = "rgba(179, 212, 255, 0.6)";
var $707b76b7d2b451c4$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-neutral, ".concat($kTdw7.DN70, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($kTdw7.N30A, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($kTdw7.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($707b76b7d2b451c4$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($kTdw7.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($kTdw7.B100, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($kTdw7.B300, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($kTdw7.B75, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($kTdw7.B500, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($kTdw7.B200, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($kTdw7.Y300, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($kTdw7.Y300, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($kTdw7.Y200, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($kTdw7.Y200, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($kTdw7.Y400, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($kTdw7.Y400, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.Y400, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($kTdw7.R400, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($kTdw7.R400, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($kTdw7.R300, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($kTdw7.R300, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($kTdw7.R500, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($kTdw7.R500, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($kTdw7.N20A, ")"),
                dark: "var(--ds-background-disabled, ".concat($kTdw7.DN70, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.R500, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.R500, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.R500, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($kTdw7.N30A, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($kTdw7.DN60, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($707b76b7d2b451c4$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($kTdw7.B75, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.DN0, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($kTdw7.N700, ")"),
                dark: "var(--ds-background-selected, ".concat($kTdw7.N20, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($kTdw7.N500, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($kTdw7.DN30, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($kTdw7.N800, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($kTdw7.N800, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N800, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N800, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N800, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-inverse, ".concat($kTdw7.N0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN30, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N0, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N0, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N0, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-link, ".concat($kTdw7.B100, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($kTdw7.B300, ")"),
                dark: "var(--ds-link, ".concat($kTdw7.B75, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($kTdw7.B500, ")"),
                dark: "var(--ds-link-pressed, ".concat($kTdw7.B200, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N700, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.N700, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($kTdw7.N500, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.DN400, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($kTdw7.B400, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.B400, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        },
        "subtle-link": {
            default: {
                light: "var(--ds-text-subtle, ".concat($kTdw7.N200, ")"),
                dark: "var(--ds-text-subtle, ".concat($kTdw7.DN400, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($kTdw7.N90, ")"),
                dark: "var(--ds-text-subtle, ".concat($kTdw7.B50, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($kTdw7.N400, ")"),
                dark: "var(--ds-text, ".concat($kTdw7.DN300, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($kTdw7.N70, ")"),
                dark: "var(--ds-text-disabled, ".concat($kTdw7.DN100, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($kTdw7.N20, ")"),
                dark: "var(--ds-text-selected, ".concat($kTdw7.DN400, ")")
            }
        }
    }
};
var $707b76b7d2b451c4$export$2e2bcd8739ae039 = $707b76b7d2b451c4$var$values;


function $351436310756804d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $351436310756804d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $351436310756804d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $351436310756804d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $351436310756804d$var$gridSize = (0, $5b7Z4.gridSize)();
var $351436310756804d$var$HAS_DISABLED_BACKGROUND = [
    "default",
    "primary",
    "danger",
    "warning"
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $351436310756804d$var$heights = {
    default: "".concat(32 / 14, "em"),
    // 32px
    compact: "".concat(24 / 14, "em"),
    none: "auto"
};
var $351436310756804d$var$lineHeights = {
    default: $351436310756804d$var$heights.default,
    compact: $351436310756804d$var$heights.compact,
    none: "inherit"
};
var $351436310756804d$var$padding = {
    // 10px gutter
    default: "0 ".concat($351436310756804d$var$gridSize + $351436310756804d$var$gridSize / 4, "px"),
    compact: "0 ".concat($351436310756804d$var$gridSize + $351436310756804d$var$gridSize / 4, "px"),
    none: "0"
};
var $351436310756804d$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($351436310756804d$var$gridSize / 4, "px"),
    default: "0 ".concat($351436310756804d$var$gridSize / 4, "px"),
    none: "0"
};
var $351436310756804d$var$verticalAlign = {
    default: "middle",
    compact: "middle",
    none: "baseline"
};
var $351436310756804d$var$innerMargin = {
    content: "0 ".concat($351436310756804d$var$gridSize / 4, "px"),
    icon: "0 ".concat($351436310756804d$var$gridSize / 4, "px")
};
var $351436310756804d$var$defaultAfterStyles = {
    borderRadius: "inherit",
    inset: "var(--ds-space-0, 0px)",
    borderStyle: "solid",
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: "none",
    position: "absolute"
};
var $351436310756804d$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    "&:not([disabled])::after": $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, $351436310756804d$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    }),
    "&:hover": {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
};
var $351436310756804d$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    "&:active": {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    }
};
var $351436310756804d$var$linkStyles = {
    background: "transparent",
    color: "var(--ds-link, #0C66E4)",
    "&:hover": {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: "underline"
    },
    "&:active": {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: "underline"
    }
};
var $351436310756804d$var$subtleStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    "&:active": {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
};
var $351436310756804d$var$subtleLinkStyles = {
    background: "transparent",
    color: "var(--ds-text-subtle, #44546F)",
    "&:hover": {
        background: "transparent",
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: "underline"
    },
    "&:active": {
        background: "transparent",
        color: "var(--ds-text, #172B4D)",
        textDecoration: "underline"
    }
};
var $351436310756804d$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    "&:hover": {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    "&:active": {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    }
};
var $351436310756804d$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    "&:hover": {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    "&:active": {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    }
};
var $351436310756804d$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    "&:not([disabled])::after": $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, $351436310756804d$var$defaultAfterStyles), {}, {
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    })
};
var $351436310756804d$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: "default",
        textDecoration: "none"
    }
};
function $351436310756804d$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $351436310756804d$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $351436310756804d$var$getColor({
            group: (0, $707b76b7d2b451c4$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($351436310756804d$var$getColor({
            group: (0, $707b76b7d2b451c4$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $351436310756804d$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $351436310756804d$var$getColors({
        appearance: appearance,
        key: isSelected ? "selected" : "default",
        mode: mode
    });
    return $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: "baseline",
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: "border-box",
        display: "inline-flex",
        fontSize: "inherit",
        fontStyle: "normal",
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: "inherit",
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: "100%",
        // Needed to position overlay
        position: "relative",
        textAlign: "center",
        textDecoration: "none",
        transition: "background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)",
        whiteSpace: "nowrap"
    }, !(0, $i2LcI.fg)("platform-component-visual-refresh") && baseColors), {}, {
        cursor: "pointer",
        height: $351436310756804d$var$heights[spacing],
        lineHeight: $351436310756804d$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $351436310756804d$var$singleIconPadding[spacing] : $351436310756804d$var$padding[spacing],
        verticalAlign: $351436310756804d$var$verticalAlign[spacing],
        width: shouldFitContainer ? "100%" : "auto",
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: "center"
    }, !(0, $i2LcI.fg)("platform-component-visual-refresh") && $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({
        // Disabling visited styles (just using the base colors)
        "&:visited": $351436310756804d$var$_objectSpread({}, baseColors),
        "&:hover": $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, $351436310756804d$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "hover",
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === "link" || appearance === "subtle-link") ? "underline" : "inherit",
            // background, box-shadow
            transitionDuration: "0s, 0.15s"
        }),
        // giving active styles preference by listing them after focus
        "&:active": $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, $351436310756804d$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, $351436310756804d$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "active",
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: "0s, 0s"
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        "&[disabled]": $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, $351436310756804d$var$getColors({
            appearance: appearance,
            key: "disabled",
            mode: mode
        })), {}, {
            cursor: "not-allowed",
            textDecoration: "none"
        })
    }, $351436310756804d$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $351436310756804d$var$_objectSpread({}, $351436310756804d$var$getColors({
            appearance: appearance,
            key: isSelected ? "selected" : "default",
            mode: mode
        }))
    })), (0, $i2LcI.fg)("platform-component-visual-refresh") && (isSelected ? $351436310756804d$var$selectedStyles : $351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread($351436310756804d$var$_objectSpread({}, appearance === "default" && $351436310756804d$var$defaultStyles), appearance === "primary" && $351436310756804d$var$primaryStyles), appearance === "link" && $351436310756804d$var$linkStyles), appearance === "subtle" && $351436310756804d$var$subtleStyles), appearance === "subtle-link" && $351436310756804d$var$subtleLinkStyles), appearance === "warning" && $351436310756804d$var$warningStyles), appearance === "danger" && $351436310756804d$var$dangerStyles), {}, {
        "&[disabled]": {
            color: "var(--ds-text-disabled, #091E424F)",
            backgroundColor: $351436310756804d$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent",
            cursor: "not-allowed",
            textDecoration: "none",
            "&:hovered": {
                backgroundColor: $351436310756804d$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            },
            "&:active": {
                backgroundColor: $351436310756804d$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : "transparent"
            }
        }
    }, $351436310756804d$var$hasOverlayStyles), {}, {
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
            background: "inherit"
        }
    }))), {}, {
        "&::-moz-focus-inner": {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $351436310756804d$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $14VNY.css)({
        display: "flex",
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $351436310756804d$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: "center",
        fontSize: 0,
        lineHeight: 0,
        userSelect: "none"
    });
}
function $351436310756804d$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $14VNY.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === "none" ? 0 : $351436310756804d$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    });
}
function $351436310756804d$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $14VNY.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: "opacity 0.3s"
    });
}
var $351436310756804d$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: "absolute",
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};



var $8ZuGG = parcelRequire("8ZuGG");

var $73a5X = parcelRequire("73a5X");
var $84b940db5f399a20$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $8ZuGG.isValidElement)(children) && children.type === (0, $73a5X.default);
};


var $5cd0511c10208ff7$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $5cd0511c10208ff7$var$noPointerEventsOnChildrenCss = {
    "> *": {
        pointerEvents: "none"
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ var $5cd0511c10208ff7$var$iconBeforeSpacingFixStyle = (0, $14VNY.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-025, 2px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
var $5cd0511c10208ff7$var$iconAfterSpacingFixStyle = (0, $14VNY.css)({
    "--ds--button--new-icon-padding-end": "var(--ds-space-050, 4px)",
    "--ds--button--new-icon-padding-start": "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
var $5cd0511c10208ff7$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!children || (0, $84b940db5f399a20$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $5cd0511c10208ff7$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $84b940db5f399a20$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $14VNY.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
var $5cd0511c10208ff7$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? "default" : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? "a" : "button" : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $5AVd4.default) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $5AVd4.default) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? "default" : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? "button" : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(props, $5cd0511c10208ff7$var$_excluded);
    var ourRef = (0, $8ZuGG.useRef)();
    var setRef = (0, $8ZuGG.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === "function") {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $c7GPs.default)(ourRef, autoFocus);
    var interactionContext = (0, $8ZuGG.useContext)((0, $hUeXI.default));
    var handleClick = (0, $8ZuGG.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $1Muvn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: "clicked",
        componentName: "button",
        packageName: "@atlaskit/button",
        packageVersion: "19.0.0",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $8ZuGG.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    var fadeStyles = (0, $14VNY.css)((0, $351436310756804d$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === "warning") spinnerHackCss = {
        "[data-theme] & circle": {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $kTdw7.N500), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $kTdw7.N500), ")"), " !important")
        }
    };
    return (0, $14VNY.jsx)((0, $c3Xui.default), null, (0, $14VNY.jsx)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $5cd0511c10208ff7$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $64cbd9f56e9cb7f0$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $14VNY.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $351436310756804d$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $5cd0511c10208ff7$var$getSpacingFix(children, $5cd0511c10208ff7$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $5cd0511c10208ff7$var$getChildren(children, [
        fadeStyles,
        (0, $351436310756804d$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $14VNY.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $351436310756804d$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $5cd0511c10208ff7$var$getSpacingFix(children, $5cd0511c10208ff7$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $14VNY.jsx)("span", {
        css: [
            (0, $351436310756804d$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5cd0511c10208ff7$export$2e2bcd8739ae039 = $5cd0511c10208ff7$var$ButtonBase;



function $8e2f64cee6bfd55f$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $84b940db5f399a20$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $8ZuGG = parcelRequire("8ZuGG");

var $cufV0 = parcelRequire("cufV0");
function $e90bbe8a00f4200b$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return "inherit";
    if (isSelected) return "invert";
    if (appearance === "primary" || appearance === "danger") return "invert";
    return "inherit";
}
function $e90bbe8a00f4200b$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing;
    var size = spacing === "default" ? "medium" : "small";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $cufV0.default), {
        size: size,
        label: ", Loading",
        appearance: $e90bbe8a00f4200b$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}



var $6bkHe = parcelRequire("6bkHe");

var $7eaU1 = parcelRequire("7eaU1");

function $8ac872f0cb00ef15$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8ac872f0cb00ef15$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8ac872f0cb00ef15$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8ac872f0cb00ef15$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $8ac872f0cb00ef15$var$stateToSelectorMap = {
    focus: "&:focus",
    focusSelected: "&:focus",
    hover: "&:hover",
    active: "&:active",
    disabled: "&[disabled]"
};
function $8ac872f0cb00ef15$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? "default" : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? "default" : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? "light" : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $351436310756804d$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = "none";
    // Pulling relevant styles up to the top level
    var selector = $8ac872f0cb00ef15$var$stateToSelectorMap[state];
    if (selector) result = $8ac872f0cb00ef15$var$_objectSpread($8ac872f0cb00ef15$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $8ac872f0cb00ef15$var$_objectSpread($8ac872f0cb00ef15$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === "&::-moz-focus-inner") return;
        // Not using .startsWith for ie11
        if (key.indexOf("&") === 0) delete result[key];
    });
    return result;
}
function $8ac872f0cb00ef15$export$643db0b8d8778e(styles) {
    return {
        "&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]": styles
    };
}
function $8ac872f0cb00ef15$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $8ac872f0cb00ef15$var$Theme = (0, $7eaU1.createTheme)(function(themeProps) {
    return {
        buttonStyles: $8ac872f0cb00ef15$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8ac872f0cb00ef15$export$2e2bcd8739ae039 = $8ac872f0cb00ef15$var$Theme;


var $740dfa4ea8d07aa2$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $740dfa4ea8d07aa2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $740dfa4ea8d07aa2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $740dfa4ea8d07aa2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $740dfa4ea8d07aa2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $740dfa4ea8d07aa2$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return "disabled";
    if (isSelected && isFocus) return "focusSelected";
    if (isSelected) return "selected";
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return "active";
    if (!isLoading && isHover) return "hover";
    if (isFocus) return "focus";
    return "default";
}
var $740dfa4ea8d07aa2$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $740dfa4ea8d07aa2$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? "default" : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? "default" : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $8ac872f0cb00ef15$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1Wcv5)))(_ref2, $740dfa4ea8d07aa2$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $740dfa4ea8d07aa2$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $8ZuGG.useState)($740dfa4ea8d07aa2$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $8ZuGG.useCallback)(function(event) {
        setState(function(current) {
            return $740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ac872f0cb00ef15$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $62B5W.default).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $8ac872f0cb00ef15$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            mode: mode,
            state: $740dfa4ea8d07aa2$var$getInteractionState($740dfa4ea8d07aa2$var$_objectSpread($740dfa4ea8d07aa2$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $8e2f64cee6bfd55f$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $5cd0511c10208ff7$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $e90bbe8a00f4200b$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || restProps["aria-disabled"],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $8ac872f0cb00ef15$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$740dfa4ea8d07aa2$var$CustomThemeButton.displayName = "CustomThemeButton";
var $740dfa4ea8d07aa2$export$2e2bcd8739ae039 = $740dfa4ea8d07aa2$var$CustomThemeButton;



var $7SrF8 = parcelRequire("7SrF8");


var $0b858008b256776a$var$buttonStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: "0 ".concat("var(--ds-space-100, 8px)", " !important"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: "var(".concat((0, $33ed62187a2b812a$export$e9244ec13bd422b5), ")"),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: "var(".concat((0, $33ed62187a2b812a$export$4f8f13a66ae77bdd), ") !important"),
        fontWeight: "var(--ds-font-weight-medium, 500)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:hover, &&:active, a&&:hover, a&&:active": {
        textDecoration: "underline"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:hover": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $33ed62187a2b812a$export$97e78d9745006c11), ")")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&:active": {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: "var(".concat((0, $33ed62187a2b812a$export$291d63757828f290), ")")
    }
});
var $0b858008b256776a$var$appearanceNormalButtonStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        padding: "0 !important"
    }
});
var $0b858008b256776a$var$appearanceNormalActionsContainerStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&&, a&&": {
        transform: "translateX(-2px)"
    }
});
var $0b858008b256776a$var$FlagActions = function FlagActions(props) {
    var _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $33ed62187a2b812a$export$d6830277b06edd6) : _props$appearance, _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, linkComponent = props.linkComponent, testId = props.testId;
    if (!actions.length) return null;
    var isBold = appearance !== (0, $33ed62187a2b812a$export$d6830277b06edd6);
    return (0, $14VNY.jsx)("span", {
        css: !isBold && $0b858008b256776a$var$appearanceNormalActionsContainerStyles
    }, (0, $14VNY.jsx)((0, $7SrF8.default), {
        space: "space.100",
        shouldWrap: true,
        alignBlock: "center",
        separator: isBold ? undefined : "\xb7",
        testId: testId && "".concat(testId, "-actions")
    }, actions.map(function(action, index) {
        var _ref;
        return (0, $14VNY.jsx)((0, $740dfa4ea8d07aa2$export$2e2bcd8739ae039), {
            onClick: action.onClick,
            href: action.href,
            target: action.target,
            appearance: isBold ? "default" : "link",
            component: linkComponent,
            spacing: "compact",
            testId: action.testId,
            key: index,
            style: (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref, (0, $33ed62187a2b812a$export$4f8f13a66ae77bdd), (0, $9a63c6f93d170bef$export$7bcfe3cca4dd78b6)[appearance]), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref, (0, $33ed62187a2b812a$export$e9244ec13bd422b5), (0, $9a63c6f93d170bef$export$81ba6b63eedb299f)[appearance].default), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref, (0, $33ed62187a2b812a$export$97e78d9745006c11), (0, $9a63c6f93d170bef$export$81ba6b63eedb299f)[appearance].pressed), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref, (0, $33ed62187a2b812a$export$291d63757828f290), (0, $9a63c6f93d170bef$export$81ba6b63eedb299f)[appearance].active), _ref),
            css: [
                $0b858008b256776a$var$buttonStyles,
                appearance === (0, $33ed62187a2b812a$export$d6830277b06edd6) && $0b858008b256776a$var$appearanceNormalButtonStyles
            ]
        }, action.content);
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$0b858008b256776a$export$2e2bcd8739ae039 = $0b858008b256776a$var$FlagActions;



var $cd8Dz = parcelRequire("cd8Dz");

var $8ZuGG = parcelRequire("8ZuGG");

var $14VNY = parcelRequire("14VNY");

var $4xaIc = parcelRequire("4xaIc");
var $9cyTu = parcelRequire("9cyTu");
var $6bkHe = parcelRequire("6bkHe");

var $8ZuGG = parcelRequire("8ZuGG");

var $4xaIc = parcelRequire("4xaIc");

var $9tcFo = parcelRequire("9tcFo");

var $k1pve = parcelRequire("k1pve");
var $5841b9425df56f89$export$97192c8fa0d5e26b = function slideInAnimation(from, state, fade) {
    var _ref;
    var initial = state === "entering" ? "0%" : "100%";
    var end = state === "entering" ? "100%" : "0%";
    var fromMap = {
        top: "translate3d(0, -100%, 0)",
        right: "translate3d(100%, 0, 0)",
        bottom: "translate3d(0, 100%, 0)",
        left: "translate3d(-100%, 0, 0)"
    };
    var animateOpacity = fade === "inout" || fade === "in" && state === "entering" || fade === "out" && state === "exiting";
    return _ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref, initial, {
        transform: fromMap[from],
        opacity: animateOpacity ? 0 : 1
    }), (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(_ref, end, {
        transform: "none",
        opacity: 1
    }), _ref;
};
/**
 * __SlideIn__
 *
 * Will slide an element into position, generally used for things that appear from outside of the viewport into view.
 *
 * See [examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions).
 */ var $5841b9425df56f89$var$SlideIn = function SlideIn(_ref2) {
    var children = _ref2.children, enterFrom = _ref2.enterFrom, exitTo = _ref2.exitTo, _ref2$fade = _ref2.fade, fade = _ref2$fade === void 0 ? "none" : _ref2$fade, _ref2$duration = _ref2.duration, duration = _ref2$duration === void 0 ? (0, $9tcFo.mediumDurationMs) : _ref2$duration, isPaused = _ref2.isPaused, onFinish = _ref2.onFinish, _ref2$animationTiming = _ref2.animationTimingFunction, animationTimingFunction = _ref2$animationTiming === void 0 ? function(state) {
        return state === "entering" ? (0, $4xaIc.easeOut) : (0, $4xaIc.easeIn);
    } : _ref2$animationTiming;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $k1pve.default), {
        duration: duration,
        enteringAnimation: $5841b9425df56f89$export$97192c8fa0d5e26b(enterFrom, "entering", fade),
        exitingAnimation: $5841b9425df56f89$export$97192c8fa0d5e26b(exitTo || enterFrom, "exiting", fade),
        animationTimingFunction: animationTimingFunction,
        isPaused: isPaused,
        onFinish: onFinish
    }, children);
};
var $5841b9425df56f89$export$2e2bcd8739ae039 = $5841b9425df56f89$var$SlideIn;



var $73a5X = parcelRequire("73a5X");

var $5AVd4 = parcelRequire("5AVd4");

var $jTcCE = parcelRequire("jTcCE");

var $5b7Z4 = parcelRequire("5b7Z4");
var $2b1dc5e26d0b22ea$var$gridSize = (0, $5b7Z4.gridSize)();
var $2b1dc5e26d0b22ea$export$1eee5ddc4f6d41c5 = $2b1dc5e26d0b22ea$var$gridSize * 50;
var $2b1dc5e26d0b22ea$export$a56455a41666bb2a = 400;
var $2b1dc5e26d0b22ea$var$defaultFlagGroupContext = {
    onDismissed: (0, $5AVd4.default),
    isDismissAllowed: false
};
var $2b1dc5e26d0b22ea$export$c57ba665aaa722be = /*#__PURE__*/ (0, $8ZuGG.createContext)($2b1dc5e26d0b22ea$var$defaultFlagGroupContext);
function $2b1dc5e26d0b22ea$export$e91ea202abb66350() {
    return (0, $8ZuGG.useContext)($2b1dc5e26d0b22ea$export$c57ba665aaa722be);
}
// transition: none is set on first-of-type to prevent a bug in Firefox
// that causes a broken transition
var $2b1dc5e26d0b22ea$var$baseStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: $2b1dc5e26d0b22ea$export$1eee5ddc4f6d41c5,
    position: "absolute",
    insetBlockEnd: 0,
    transition: "transform ".concat($2b1dc5e26d0b22ea$export$a56455a41666bb2a, "ms ease-in-out"),
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        width: "100vw"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":first-of-type": {
        transform: "translate(0,0)",
        transition: "none"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(n + 2)": {
        animationDuration: "0ms",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        transform: "translateX(0) translateY(100%) translateY(".concat(2 * $2b1dc5e26d0b22ea$var$gridSize, "px)")
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(1)": {
        zIndex: 5
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ":nth-of-type(2)": {
        zIndex: 4
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&:nth-of-type(n + 4)": {
        visibility: "hidden"
    }
});
// Transform needed to push up while 1st flag is leaving
// Exiting time should match the exiting time of motion so is halved
var $2b1dc5e26d0b22ea$var$dismissAllowedStyles = (0, $14VNY.css)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    "&& + *": {
        transform: "translate(0, 0)",
        transitionDuration: "".concat($2b1dc5e26d0b22ea$export$a56455a41666bb2a / 2, "ms")
    }
});
var $2b1dc5e26d0b22ea$var$flagGroupContainerStyles = (0, $14VNY.css)({
    position: "fixed",
    zIndex: "flag",
    insetBlockEnd: "var(--ds-space-600, 48px)",
    insetInlineStart: "var(--ds-space-1000, 80px)",
    // TODO: Use new breakpoints
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    "@media (max-width: 560px)": {
        insetBlockEnd: 0,
        insetInlineStart: 0
    }
});
/**
 * __Flag group__
 *
 * A flag group is used to group a set of related flags, with entry and exit animations.
 *
 * - [Examples](https://atlassian.design/components/flag/flag-group/examples)
 * - [Code](https://atlassian.design/components/flag/flag-group/code)
 */ var $2b1dc5e26d0b22ea$var$FlagGroup = function FlagGroup(props) {
    var id = props.id, _props$label = props.label, label = _props$label === void 0 ? "Flag notifications" : _props$label, _props$labelTag = props.labelTag, LabelTag = _props$labelTag === void 0 ? "h2" : _props$labelTag, _props$shouldRenderTo = props.shouldRenderToParent, shouldRenderToParent = _props$shouldRenderTo === void 0 ? false : _props$shouldRenderTo, children = props.children, _props$onDismissed = props.onDismissed, onDismissed = _props$onDismissed === void 0 ? (0, $5AVd4.default) : _props$onDismissed;
    var hasFlags = Array.isArray(children) ? children.length > 0 : Boolean(children);
    var dismissFlagContext = (0, $8ZuGG.useMemo)(function() {
        return {
            onDismissed: onDismissed,
            isDismissAllowed: true
        };
    }, [
        onDismissed
    ]);
    var renderChildren = function renderChildren() {
        return children && (0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(children) === "object" ? (0, $8ZuGG.Children).map(children, function(flag, index) {
            var isDismissAllowed = index === 0;
            return (0, $14VNY.jsx)((0, $5841b9425df56f89$export$2e2bcd8739ae039), {
                enterFrom: "left",
                fade: "inout",
                duration: $2b1dc5e26d0b22ea$export$a56455a41666bb2a,
                animationTimingFunction: function animationTimingFunction() {
                    return 0, $4xaIc.easeIn;
                }
            }, function(_ref) {
                var className = _ref.className, ref = _ref.ref;
                return (0, $14VNY.jsx)("div", {
                    css: [
                        $2b1dc5e26d0b22ea$var$baseStyles,
                        isDismissAllowed && $2b1dc5e26d0b22ea$var$dismissAllowedStyles
                    ],
                    className: className,
                    ref: ref
                }, (0, $14VNY.jsx)($2b1dc5e26d0b22ea$export$c57ba665aaa722be.Provider, {
                    value: // Only the first flag should be able to be dismissed.
                    isDismissAllowed ? dismissFlagContext : $2b1dc5e26d0b22ea$var$defaultFlagGroupContext
                }, flag));
            });
        }) : false;
    };
    var flags = (0, $14VNY.jsx)("div", {
        id: id,
        css: $2b1dc5e26d0b22ea$var$flagGroupContainerStyles
    }, hasFlags ? (0, $14VNY.jsx)((0, $73a5X.default), null, (0, $14VNY.jsx)(LabelTag, null, label)) : null, (0, $14VNY.jsx)((0, $9cyTu.default), {
        appear: false
    }, renderChildren()));
    return shouldRenderToParent ? flags : (0, $14VNY.jsx)((0, $jTcCE.default), {
        zIndex: (0, $5b7Z4.layers).flag()
    }, flags);
};
var $2b1dc5e26d0b22ea$export$2e2bcd8739ae039 = $2b1dc5e26d0b22ea$var$FlagGroup;



var $8ZuGG = parcelRequire("8ZuGG");
var $77de8c4e9a12b17d$exports = {};
"use strict";
Object.defineProperty($77de8c4e9a12b17d$exports, "__esModule", {
    value: true
});
$77de8c4e9a12b17d$exports.default = void 0;

var $77de8c4e9a12b17d$var$_react = $77de8c4e9a12b17d$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $k71RP = parcelRequire("k71RP");
function $77de8c4e9a12b17d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $77de8c4e9a12b17d$var$HipchatChevronDownIcon = (props)=>/*#__PURE__*/ $77de8c4e9a12b17d$var$_react.default.createElement($k71RP.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.744 8.744a1.053 1.053 0 000 1.49l4.547 4.557a1 1 0 001.416 0l4.55-4.558a1.051 1.051 0 10-1.488-1.488l-3.77 3.776-3.768-3.776a1.051 1.051 0 00-1.487 0z" fill="currentColor"/></svg>`
    }, props));
$77de8c4e9a12b17d$var$HipchatChevronDownIcon.displayName = "HipchatChevronDownIcon";
var $77de8c4e9a12b17d$var$_default = $77de8c4e9a12b17d$var$HipchatChevronDownIcon;
$77de8c4e9a12b17d$exports.default = $77de8c4e9a12b17d$var$_default;


var $e576ccd4b3558a82$exports = {};
"use strict";
Object.defineProperty($e576ccd4b3558a82$exports, "__esModule", {
    value: true
});
$e576ccd4b3558a82$exports.default = void 0;

var $e576ccd4b3558a82$var$_react = $e576ccd4b3558a82$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $k71RP = parcelRequire("k71RP");
function $e576ccd4b3558a82$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $e576ccd4b3558a82$var$HipchatChevronUpIcon = (props)=>/*#__PURE__*/ $e576ccd4b3558a82$var$_react.default.createElement($k71RP.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M11.294 8.708l-.001.001-4.549 4.559a1.051 1.051 0 101.486 1.488l.001-.001 3.77-3.776 3.768 3.776a1.05 1.05 0 001.486.001h.001a1.054 1.054 0 00.001-1.489l-4.548-4.558a1 1 0 00-1.415-.001z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$e576ccd4b3558a82$var$HipchatChevronUpIcon.displayName = "HipchatChevronUpIcon";
var $e576ccd4b3558a82$var$_default = $e576ccd4b3558a82$var$HipchatChevronUpIcon;
$e576ccd4b3558a82$exports.default = $e576ccd4b3558a82$var$_default;


var $789fb4b1f318699b$exports = {};
"use strict";
Object.defineProperty($789fb4b1f318699b$exports, "__esModule", {
    value: true
});
$789fb4b1f318699b$exports.default = void 0;

var $789fb4b1f318699b$var$_react = $789fb4b1f318699b$var$_interopRequireDefault((parcelRequire("8ZuGG")));

var $k71RP = parcelRequire("k71RP");
function $789fb4b1f318699b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $789fb4b1f318699b$var$CrossIcon = (props)=>/*#__PURE__*/ $789fb4b1f318699b$var$_react.default.createElement($k71RP.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 10.586L6.707 5.293a1 1 0 00-1.414 1.414L10.586 12l-5.293 5.293a1 1 0 001.414 1.414L12 13.414l5.293 5.293a1 1 0 001.414-1.414L13.414 12l5.293-5.293a1 1 0 10-1.414-1.414L12 10.586z" fill="currentColor"/></svg>`
    }, props));
$789fb4b1f318699b$var$CrossIcon.displayName = "CrossIcon";
var $789fb4b1f318699b$var$_default = $789fb4b1f318699b$var$CrossIcon;
$789fb4b1f318699b$exports.default = $789fb4b1f318699b$var$_default;



var $bJIvo = parcelRequire("bJIvo");
var $57fzU = parcelRequire("57fzU");

var $41e8f6b60a267fb7$var$buttonStyles = (0, $57fzU.xcss)({
    display: "flex",
    width: "24px",
    height: "24px",
    padding: "space.0",
    alignItems: "center",
    justifyContent: "center",
    flex: "0 0 auto",
    background: "none",
    borderStyle: "none",
    cursor: "pointer",
    whiteSpace: "nowrap"
});
var $41e8f6b60a267fb7$var$DismissButtonComponent = function DismissButtonComponent(_ref) {
    var appearance = _ref.appearance, onClick = _ref.onClick, isBold = _ref.isBold, isExpanded = _ref.isExpanded, testId = _ref.testId;
    var ButtonIcon = (0, (/*@__PURE__*/$parcel$interopDefault($789fb4b1f318699b$exports)));
    var buttonLabel = "Dismiss";
    var size = "small";
    var buttonTestId = testId && "".concat(testId, "-dismiss");
    if (isBold) {
        ButtonIcon = isExpanded ? (0, (/*@__PURE__*/$parcel$interopDefault($e576ccd4b3558a82$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($77de8c4e9a12b17d$exports)));
        buttonLabel = isExpanded ? "Collapse" : "Expand";
        size = "medium";
        buttonTestId = testId && "".concat(testId, "-toggle");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $bJIvo.default), {
        xcss: $41e8f6b60a267fb7$var$buttonStyles,
        onClick: onClick,
        "aria-expanded": isBold ? isExpanded : undefined,
        testId: buttonTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement(ButtonIcon, {
        label: buttonLabel,
        size: size,
        primaryColor: (0, $9a63c6f93d170bef$export$13b42cd9d596bfe0)[appearance]
    }));
};
var $41e8f6b60a267fb7$var$DismissButton = /*#__PURE__*/ (0, $8ZuGG.memo)($41e8f6b60a267fb7$var$DismissButtonComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$41e8f6b60a267fb7$export$2e2bcd8739ae039 = $41e8f6b60a267fb7$var$DismissButton;


var $dLcU7 = parcelRequire("dLcU7");

var $8ZuGG = parcelRequire("8ZuGG");

var $lThM2 = parcelRequire("lThM2");
var $6m9zh = parcelRequire("6m9zh");
var $57fzU = parcelRequire("57fzU");

var $9cyTu = parcelRequire("9cyTu");
var $gWxJe = parcelRequire("gWxJe");
var $18e1e747f2b1528c$var$expanderStyles = (0, $57fzU.xcss)({
    width: "100%"
});
var $18e1e747f2b1528c$var$containerStyles = (0, $57fzU.xcss)({
    transition: "max-height 0.3s"
});
var $18e1e747f2b1528c$var$Expander = function Expander(_ref) {
    var children = _ref.children, isExpanded = _ref.isExpanded, testId = _ref.testId;
    // Need to always render the ExpanderInternal otherwise the
    // reveal transition doesn't happen. We can't use CSS animation for
    // the the reveal because we don't know the height of the content.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lThM2.default), {
        xcss: $18e1e747f2b1528c$var$containerStyles,
        style: {
            maxHeight: isExpanded ? 150 : 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flex: "1 1 100%",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            minWidth: 0
        },
        "aria-hidden": !isExpanded,
        testId: testId && "".concat(testId, "-expander")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $9cyTu.default), {
        appear: true
    }, isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $gWxJe.default), null, function(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $lThM2.default), (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
            xcss: $18e1e747f2b1528c$var$expanderStyles
        }, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($8ZuGG))).createElement((0, $6m9zh.default), {
            space: "space.100"
        }, children));
    })));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$18e1e747f2b1528c$export$2e2bcd8739ae039 = $18e1e747f2b1528c$var$Expander;



var $73a5X = parcelRequire("73a5X");
function $d19d5736b40472d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d19d5736b40472d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d19d5736b40472d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d19d5736b40472d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $d19d5736b40472d8$var$CSS_VAR_ICON_COLOR = "--flag-icon-color";
// For cases where a single word is longer than the container (e.g. filenames)
var $d19d5736b40472d8$var$overflowWrapStyles = (0, $57fzU.xcss)({
    overflowWrap: "anywhere"
});
var $d19d5736b40472d8$var$descriptionStyles = (0, $14VNY.css)({
    maxHeight: 100,
    // height is defined as 5 lines maximum by design
    overflow: "auto",
    overflowWrap: "anywhere" // For cases where a single word is longer than the container (e.g. filenames)
});
var $d19d5736b40472d8$var$iconWrapperStyles = (0, $14VNY.css)({
    display: "flex",
    alignItems: "start",
    flexShrink: 0,
    color: "var(".concat($d19d5736b40472d8$var$CSS_VAR_ICON_COLOR, ")")
});
var $d19d5736b40472d8$var$flagStyles = (0, $57fzU.xcss)({
    boxShadow: "elevation.shadow.overlay",
    borderRadius: "border.radius.100",
    overflow: "hidden",
    zIndex: "flag",
    width: "100%",
    transition: "background-color 200ms"
});
var $d19d5736b40472d8$var$flagWrapperStyles = (0, $14VNY.css)({
    width: "100%"
});
var $d19d5736b40472d8$var$analyticsAttributes = {
    componentName: "flag",
    packageName: "@atlaskit/flag",
    packageVersion: "15.7.3"
};
var $d19d5736b40472d8$var$transitionStyles = (0, $14VNY.css)({
    flexGrow: 1,
    transition: "gap 0.3s"
});
/**
 * __Flag__
 *
 * A flag is used for confirmations, alerts, and acknowledgments that require minimal user interaction,
 * often displayed using a flag group.
 *
 * - [Examples](https://atlassian.design/components/flag/examples)
 * - [Code](https://atlassian.design/components/flag/code)
 * - [Usage](https://atlassian.design/components/flag/usage)
 */ var $d19d5736b40472d8$var$Flag = function Flag(props) {
    var _props$actions = props.actions, actions = _props$actions === void 0 ? [] : _props$actions, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? (0, $33ed62187a2b812a$export$d6830277b06edd6) : _props$appearance, icon = props.icon, title = props.title, description = props.description, linkComponent = props.linkComponent, onMouseOver = props.onMouseOver, _props$onFocus = props.onFocus, onFocus = _props$onFocus === void 0 ? (0, $5AVd4.default) : _props$onFocus, onMouseOut = props.onMouseOut, _props$onBlur = props.onBlur, onBlur = _props$onBlur === void 0 ? (0, $5AVd4.default) : _props$onBlur, _props$onDismissed = props.onDismissed, onDismissedProp = _props$onDismissed === void 0 ? (0, $5AVd4.default) : _props$onDismissed, testId = props.testId, id = props.id, analyticsContext = props.analyticsContext, delayAnnouncement = props.delayAnnouncement, _props$headingLevel = props.headingLevel, headingLevel = _props$headingLevel === void 0 ? 2 : _props$headingLevel;
    var _useState = (0, $8ZuGG.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState, 2), isDelayToAnnounce = _useState2[0], setIsDelayToAnnounce = _useState2[1];
    var _useFlagGroup = (0, $2b1dc5e26d0b22ea$export$e91ea202abb66350)(), onDismissedFromFlagGroup = _useFlagGroup.onDismissed, isDismissAllowed = _useFlagGroup.isDismissAllowed;
    var onDismissed = (0, $8ZuGG.useCallback)(function(id, analyticsEvent) {
        onDismissedProp(id, analyticsEvent);
        onDismissedFromFlagGroup(id, analyticsEvent);
    }, [
        onDismissedProp,
        onDismissedFromFlagGroup
    ]);
    var _useState3 = (0, $8ZuGG.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_useState3, 2), isExpanded = _useState4[0], setIsExpanded = _useState4[1];
    var onDismissedAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($d19d5736b40472d8$var$_objectSpread({
        fn: onDismissed,
        action: "dismissed",
        analyticsData: analyticsContext
    }, $d19d5736b40472d8$var$analyticsAttributes));
    var isBold = appearance !== (0, $33ed62187a2b812a$export$d6830277b06edd6);
    var toggleExpand = (0, $8ZuGG.useCallback)(function() {
        setIsExpanded(function(previous) {
            return !previous;
        });
    }, []);
    var buttonActionCallback = (0, $8ZuGG.useCallback)(function() {
        if (isDismissAllowed) onDismissedAnalytics(id);
    }, [
        onDismissedAnalytics,
        id,
        isDismissAllowed
    ]);
    (0, $8ZuGG.useEffect)(function() {
        // If buttons are removed as a prop, update isExpanded to be false
        if (isBold && isExpanded && !description && !actions.length) setIsExpanded(false);
    }, [
        actions.length,
        description,
        isBold,
        isExpanded
    ]);
    (0, $8ZuGG.useEffect)(function() {
        if (!delayAnnouncement) return;
        setTimeout(function() {
            setIsDelayToAnnounce(true);
        }, delayAnnouncement);
    }, [
        delayAnnouncement
    ]);
    var onFocusAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($d19d5736b40472d8$var$_objectSpread({
        fn: onFocus,
        action: "focused",
        analyticsData: analyticsContext
    }, $d19d5736b40472d8$var$analyticsAttributes));
    var onBlurAnalytics = (0, $1Muvn.usePlatformLeafEventHandler)($d19d5736b40472d8$var$_objectSpread({
        fn: onBlur,
        action: "blurred",
        analyticsData: analyticsContext
    }, $d19d5736b40472d8$var$analyticsAttributes));
    var autoDismissProps = {
        onMouseOver: onMouseOver,
        onFocus: onFocusAnalytics,
        onMouseOut: onMouseOut,
        onBlur: onBlurAnalytics
    };
    var textColor = (0, $9a63c6f93d170bef$export$f50075b2584087f)[appearance];
    var iconColor = (0, $9a63c6f93d170bef$export$7f70afe2167f8235)[appearance];
    var isDismissable = isBold || isDismissAllowed;
    var shouldRenderGap = !isBold && (description || actions.length) || isExpanded;
    // when delayAnnouncement is available we will use a hidden content for announcement
    var delayedAnnouncement = delayAnnouncement ? (0, $14VNY.jsx)((0, $73a5X.default), {
        role: "alert"
    }, title, description) : undefined;
    return (0, $14VNY.jsx)("div", (0, (/*@__PURE__*/$parcel$interopDefault($dLcU7)))({
        role: delayAnnouncement ? undefined : "alert",
        css: $d19d5736b40472d8$var$flagWrapperStyles,
        "data-testid": testId
    }, autoDismissProps), (0, $14VNY.jsx)((0, $lThM2.default), {
        backgroundColor: (0, $9a63c6f93d170bef$export$59e42969c95d314)[appearance],
        padding: "space.200",
        xcss: $d19d5736b40472d8$var$flagStyles
    }, (0, $14VNY.jsx)((0, $7SrF8.default), {
        alignBlock: "stretch",
        space: "space.200"
    }, (0, $14VNY.jsx)("div", {
        css: $d19d5736b40472d8$var$iconWrapperStyles,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($6bkHe)))({}, $d19d5736b40472d8$var$CSS_VAR_ICON_COLOR, iconColor)
    }, icon), (0, $14VNY.jsx)("span", {
        css: $d19d5736b40472d8$var$transitionStyles
    }, (0, $14VNY.jsx)((0, $6m9zh.default), {
        space: shouldRenderGap ? "space.100" : "space.0" // Gap exists even when not expanded due to Expander internals always being in the DOM
    }, isDelayToAnnounce && delayedAnnouncement, (0, $14VNY.jsx)((0, $7SrF8.default), {
        alignBlock: "stretch",
        space: "space.100",
        spread: "space-between"
    }, (0, $14VNY.jsx)((0, $lThM2.default), {
        paddingBlockStart: "space.050",
        paddingBlockEnd: "space.025",
        xcss: $d19d5736b40472d8$var$overflowWrapStyles
    }, (0, $14VNY.jsx)((0, $b75510f2a5d749a7$export$2e2bcd8739ae039), {
        as: "h".concat(headingLevel),
        size: "xsmall",
        color: textColor
    }, title)), isDismissable ? !(isBold && !description && !actions.length) && (0, $14VNY.jsx)((0, $41e8f6b60a267fb7$export$2e2bcd8739ae039), {
        testId: testId,
        appearance: appearance,
        isBold: isBold,
        isExpanded: isExpanded,
        onClick: isBold ? toggleExpand : buttonActionCallback
    }) : null), (0, $14VNY.jsx)((0, $18e1e747f2b1528c$export$2e2bcd8739ae039), {
        isExpanded: !isBold || isExpanded,
        testId: testId
    }, description && (0, $14VNY.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: {
            color: (0, $9a63c6f93d170bef$export$13b42cd9d596bfe0)[appearance]
        },
        css: $d19d5736b40472d8$var$descriptionStyles,
        "data-testid": testId && "".concat(testId, "-description")
    }, description), (0, $14VNY.jsx)((0, $0b858008b256776a$export$2e2bcd8739ae039), {
        actions: actions,
        appearance: appearance,
        linkComponent: linkComponent,
        testId: testId
    })))))));
};
var $d19d5736b40472d8$export$2e2bcd8739ae039 = $d19d5736b40472d8$var$Flag;



var $kTdw7 = parcelRequire("kTdw7");
var $5b7Z4 = parcelRequire("5b7Z4");

var $5BHjB = parcelRequire("5BHjB");

var $7lAAA = parcelRequire("7lAAA");

var $iSD9t = parcelRequire("iSD9t");

var $xe7jL = parcelRequire("xe7jL");

var $kOqgB = parcelRequire("kOqgB");
let $1438b5f8e1df0e8a$var$_ = (t)=>t, $1438b5f8e1df0e8a$var$t;
// We need to wrap the flag in a div to apply responsive styles so
// the flag are always visible on smaller viewports.
const $1438b5f8e1df0e8a$var$ResponsiveFlagWrapper = (0, $3XNKR.default).div($1438b5f8e1df0e8a$var$t || ($1438b5f8e1df0e8a$var$t = $1438b5f8e1df0e8a$var$_`
  [role='alert'] {
    max-width: calc(100vw - ${0}px);
  }
`), (0, $5b7Z4.gridSize)() * 11);
const $1438b5f8e1df0e8a$export$1fe549a730923236 = ()=>{
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const flags = (0, $kOqgB.useAppSelector)((state)=>state.flags.flags);
    const dispatch = (0, $kOqgB.useAppDispatch)();
    const toFlagComponent = (flag)=>{
        const icon = flag.type === "success" ? /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5BHjB))), {
            label: "Success",
            primaryColor: (0, $kTdw7).G300
        }) : /*#__PURE__*/ (0, $6rcps.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7lAAA))), {
            label: "Error",
            primaryColor: (0, $kTdw7).R300
        });
        return /*#__PURE__*/ (0, $6rcps.jsx)($1438b5f8e1df0e8a$var$ResponsiveFlagWrapper, {
            id: flag.id,
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $d19d5736b40472d8$export$2e2bcd8739ae039), {
                id: flag.id || "",
                title: formatMessage(flag.title),
                description: formatMessage(flag.description),
                icon: icon,
                onDismissed: ()=>dispatch((0, $xe7jL.dismissFlag)())
            })
        }, flag.id);
    };
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $2b1dc5e26d0b22ea$export$2e2bcd8739ae039), {
        children: flags.map(toFlagComponent)
    });
};
var $1438b5f8e1df0e8a$export$2e2bcd8739ae039 = $1438b5f8e1df0e8a$export$1fe549a730923236;



var $8ZuGG = parcelRequire("8ZuGG");

const $9086fb644175d6ad$export$f8df0673716775fc = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3wlJ5")));

const $9086fb644175d6ad$export$8860bd3f7903e57e = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("jkZ8p")));

const $9086fb644175d6ad$export$357c630eb6814495 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("avyIi")));

const $9086fb644175d6ad$export$f8dc9833cdc832ea = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("7mBc6")));

const $9086fb644175d6ad$export$1feb78d7c7eef8e6 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("78gHK")));

const $9086fb644175d6ad$export$84ed94b8c66e0057 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("5dD3p")));

const $9086fb644175d6ad$export$d5523937d2306712 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("8umKI")));

const $9086fb644175d6ad$export$68f39a5ef8cea54d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("kNf8F")));

const $9086fb644175d6ad$export$ffebed914bd6a6c9 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("fESxg")));

const $9086fb644175d6ad$export$ad79d74b0908a012 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("b86ZF")));

const $9086fb644175d6ad$export$40b885b03094ae2d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("8WKkQ")));

const $9086fb644175d6ad$export$467fb294f057077d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("h6W4e")));

const $9086fb644175d6ad$export$8ec0fb1e4323236d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("1CJSz")));

const $9086fb644175d6ad$export$ee564d35600efee8 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("4NIjs")));

const $9086fb644175d6ad$export$980c3b624c0da509 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("61mIx")));

const $9086fb644175d6ad$export$647c199e9f3e1159 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("7fzaF")));

const $9086fb644175d6ad$export$9feca1f6b3b10306 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3XS0t")));

const $9086fb644175d6ad$export$ae5920452e7cb547 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("hfN0O")));

const $9086fb644175d6ad$export$61fae207a78c2e53 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("gQGaJ")));

const $9086fb644175d6ad$export$e561dacd818ab41 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("fJ46X")));

const $9086fb644175d6ad$export$98b365c355bab28e = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("8e1Aj")));

const $9086fb644175d6ad$export$beb41ed376add573 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("lm9T8")));

const $9086fb644175d6ad$export$f5edf646533475ec = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("l8RSV")));

const $9086fb644175d6ad$export$8d7d33e241ae6c52 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("iPFs9")));

const $9086fb644175d6ad$export$66bcaaca6b1eddac = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3Z8MS")));

const $9086fb644175d6ad$export$134466789cb44107 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("cXerD")));

const $9086fb644175d6ad$export$a4ce1932d7e73468 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("k07Fo")));

const $9086fb644175d6ad$export$3432bb22f729c42b = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("8hrXD")));

const $9086fb644175d6ad$export$280a36f5ba1cc19f = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("jhLdq")));

const $9086fb644175d6ad$export$d137eda0ebcc3948 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("5AsmO")));

const $9086fb644175d6ad$export$717e3b31ee3d8960 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("d1ZQM")));

const $9086fb644175d6ad$export$d316ce63fb222131 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("3yflG")));

const $9086fb644175d6ad$export$70105507d801662a = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("81dT5")));

const $9086fb644175d6ad$export$bfd6201eae0d5333 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("6sFmz")));

const $9086fb644175d6ad$export$f14c0e3f98d164c0 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("CytXg")));

const $9086fb644175d6ad$export$74ab7a9a192e1a7a = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("5k5ur")));

const $9086fb644175d6ad$export$630ad10f0e1a953d = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("cicF5")));

const $9086fb644175d6ad$export$a16cb21d1f9bc820 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("eIShq")));

const $9086fb644175d6ad$export$da4433e8d8a5678 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("7YVtY")));

const $9086fb644175d6ad$export$a2f4b65ede167ce5 = /*#__PURE__*/ (0, $8ZuGG.lazy)(()=>(parcelRequire("jFWlr")));



var $lk8Tl = parcelRequire("lk8Tl");

var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $3o9o3 = parcelRequire("3o9o3");

var $gyRZh = parcelRequire("gyRZh");
const $a13f29e657c584ac$var$mobileAppToUrlPatterns = {
    jira: [
        "/secure",
        "/issues",
        "/browse",
        "#issue",
        "#myjirahome",
        "#browse"
    ],
    confluence: [
        "/wiki"
    ]
};
const $a13f29e657c584ac$var$iosAppId = {
    jira: "1006972087",
    confluence: "1006971684"
};
const $a13f29e657c584ac$var$slackAppId = {
    jira: "A2RPP3NFR",
    confluence: "AC23SDS77"
};
/**
 * Checks if the continueUrl contains the specified pattern.
 * Additionally searches for the url encoded form of the pattern,
 * which can be encoded up to 3 times e.g. openId continue urls.
 */ const $a13f29e657c584ac$var$checkForPattern = (continueUrl, pattern)=>{
    if (continueUrl.includes(pattern)) return true;
    const encode1 = encodeURIComponent(pattern);
    const encode2 = encodeURIComponent(encode1);
    const encode3 = encodeURIComponent(encode2);
    return continueUrl.includes(encode1) || continueUrl.includes(encode2) || continueUrl.includes(encode3);
};
/**
 * Adds mobile app meta tags to the document head if the continueUrl matches a pattern configured for mobile apps.
 */ const $a13f29e657c584ac$var$MobileAppMetaTags = ()=>{
    const [queryParams] = (0, $gyRZh.useSearchParams)();
    const continueUrl = queryParams.get("continue");
    const maybeMobileApp = (0, $8ZuGG.useMemo)(()=>{
        if (!continueUrl) return null;
        for (const [mobileApp, urlPatterns] of Object.entries($a13f29e657c584ac$var$mobileAppToUrlPatterns)){
            if (urlPatterns.find((urlPattern)=>$a13f29e657c584ac$var$checkForPattern(continueUrl, urlPattern))) return mobileApp;
        }
        return null;
    }, [
        continueUrl
    ]);
    return maybeMobileApp && /*#__PURE__*/ (0, $6rcps.jsxs)((0, $3o9o3.default), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)("meta", {
                name: "apple-itunes-app",
                content: `app-id=${$a13f29e657c584ac$var$iosAppId[maybeMobileApp]}`
            }),
            /*#__PURE__*/ (0, $6rcps.jsx)("meta", {
                name: "slack-app-id",
                content: $a13f29e657c584ac$var$slackAppId[maybeMobileApp]
            })
        ]
    });
};
var $a13f29e657c584ac$export$2e2bcd8739ae039 = $a13f29e657c584ac$var$MobileAppMetaTags;



var $kOqgB = parcelRequire("kOqgB");
parcelRequire("gyRZh");
var $5WDNl = parcelRequire("5WDNl");

var $82mu7 = parcelRequire("82mu7");

var $8ZuGG = parcelRequire("8ZuGG");

var $jtt5y = parcelRequire("jtt5y");

var $1ddmc = parcelRequire("1ddmc");

var $8f2pb = parcelRequire("8f2pb");
const $2c333acc9661c15e$export$222f8d3ac9d63890 = (error)=>({
        type: "SERVER_ERROR_UPDATE",
        error: error
    });



var $gV6nD = parcelRequire("gV6nD");

var $gjw2g = parcelRequire("gjw2g");

var $1uBrV = parcelRequire("1uBrV");
const $2ca216e8880b2fc2$var$SAS_FAST_FIVE_FETCH_HEADER = "sas-fast-five-fetch";
const $2ca216e8880b2fc2$var$EXCLUDED_PATHS = {
    existingSasMilestone2StateRoutes: [
        "/login",
        "/signup/welcome",
        "/signup/verify-email/otp/"
    ],
    previousReduxStore: [
        "/2step/enrollment/"
    ]
};
const $2ca216e8880b2fc2$export$c0c5e20150fdb34a = ()=>{
    const location = (0, $5WDNl.useLocation)();
    const dispatch = (0, $kOqgB.useAppDispatch)();
    (0, $8ZuGG.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!(0, $gV6nD.checkFeatureGate)((0, $gjw2g.AidFrontendFeatureGate).SHOULD_USE_GLOBAL_PAGE_STATE)) return;
            // For non-bifrost pages (i.e. injected state from sign-in-service), use the existing non-sas
            // behaviour. This could mean we may have old injected state which doesn't get
            // refreshed from here on page navigation, but that matches existing behaviour
            const hasInjectedServerState = !(0, $jtt5y.default)();
            if (hasInjectedServerState) return;
            const alreadyFetchesStateSpecificToRoute = (0, $1uBrV.isSasStateEndpointEnabled)() && $2ca216e8880b2fc2$var$EXCLUDED_PATHS.existingSasMilestone2StateRoutes.some((path)=>location.pathname === path);
            const requiresStateFromPreviousReduxStore = $2ca216e8880b2fc2$var$EXCLUDED_PATHS.previousReduxStore.some((path)=>location.pathname.startsWith(path));
            if (requiresStateFromPreviousReduxStore || alreadyFetchesStateSpecificToRoute) return;
            dispatch({
                type: "SET_GLOBAL_STATE_LOADING",
                isLoading: true
            });
            try {
                const url = location.pathname + location.search;
                const data = await $2ca216e8880b2fc2$var$fetchPageState(url);
                if ($2ca216e8880b2fc2$var$isRedirect(data)) {
                    window.location.assign(data.redirectTo);
                    return;
                }
                const fullState = await (0, $82mu7.buildInitialState)(data);
                dispatch({
                    type: (0, $kOqgB.RESET_APP_STATE),
                    data: fullState.initialStoreState
                });
            } catch (error) {
                let errorType = {
                    type: "internal_server_error"
                };
                if (error instanceof (0, $1ddmc.ServerErrorException)) {
                    errorType = error.errorType;
                    (0, $8f2pb.captureErrorMessage)(`Failed to load AppState in Bifrost: ${error.message}`);
                } else (0, $8f2pb.captureErrorMessage)(`Unexpected error while loading AppState in Bifrost: ${error}`);
                dispatch((0, $2c333acc9661c15e$export$222f8d3ac9d63890)(errorType));
            }
            dispatch({
                type: "SET_GLOBAL_STATE_LOADING",
                isLoading: false
            });
        };
        fetchData();
    // re-fetch whenever we change page, i.e. the fixed route
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.pathname
    ]);
};
const $2ca216e8880b2fc2$var$isRedirect = (data)=>Boolean(data && "redirectTo" in data);
const $2ca216e8880b2fc2$var$fetchPageState = async (fullPageUrl)=>{
    const headers = {
        [$2ca216e8880b2fc2$var$SAS_FAST_FIVE_FETCH_HEADER]: "true"
    };
    const response = await (0, $1ddmc.fetchApi)(fullPageUrl, headers);
    const data = await response.json();
    return data;
};



var $8ZuGG = parcelRequire("8ZuGG");

var $7f5qq = parcelRequire("7f5qq");

var $kD1JK = parcelRequire("kD1JK");

var $fhRQI = parcelRequire("fhRQI");

var $5msJs = parcelRequire("5msJs");

var $fhRQI = parcelRequire("fhRQI");

var $kD1JK = parcelRequire("kD1JK");

var $7Ar6h = parcelRequire("7Ar6h");

var $h2r7j = parcelRequire("h2r7j");

var $hOtqI = parcelRequire("hOtqI");

var $3Fq9h = parcelRequire("3Fq9h");

var $cd8Dz = parcelRequire("cd8Dz");

var $kg5sN = parcelRequire("kg5sN");
var $8cbe139e0fba169a$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($8cbe139e0fba169a$export$7debb50ef11d5e0b || ($8cbe139e0fba169a$export$7debb50ef11d5e0b = {}));
var $8cbe139e0fba169a$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($8cbe139e0fba169a$export$4aa2142c225fd5c7 || ($8cbe139e0fba169a$export$4aa2142c225fd5c7 = {}));
const $8cbe139e0fba169a$export$5716da67bfaa244d = $8cbe139e0fba169a$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $8cbe139e0fba169a$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.undefined;
        case "string":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $8cbe139e0fba169a$export$5716da67bfaa244d.nan : $8cbe139e0fba169a$export$5716da67bfaa244d.number;
        case "boolean":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.boolean;
        case "function":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.function;
        case "bigint":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $8cbe139e0fba169a$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $8cbe139e0fba169a$export$5716da67bfaa244d.array;
            if (data === null) return $8cbe139e0fba169a$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $8cbe139e0fba169a$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $8cbe139e0fba169a$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $8cbe139e0fba169a$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $8cbe139e0fba169a$export$5716da67bfaa244d.date;
            return $8cbe139e0fba169a$export$5716da67bfaa244d.object;
        default:
            return $8cbe139e0fba169a$export$5716da67bfaa244d.unknown;
    }
};
const $8cbe139e0fba169a$export$5ba560653e4a1035 = $8cbe139e0fba169a$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $8cbe139e0fba169a$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $8cbe139e0fba169a$export$f98dac4b251ab333 extends Error {
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    static assert(value) {
        if (!(value instanceof $8cbe139e0fba169a$export$f98dac4b251ab333)) throw new Error(`Not a ZodError: ${value}`);
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $8cbe139e0fba169a$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
}
$8cbe139e0fba169a$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $8cbe139e0fba169a$export$f98dac4b251ab333(issues);
    return error;
};
const $8cbe139e0fba169a$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $8cbe139e0fba169a$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $8cbe139e0fba169a$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $8cbe139e0fba169a$var$overrideErrorMap = $8cbe139e0fba169a$export$341b0b6e0a6f5099;
function $8cbe139e0fba169a$export$1097a8289cfd22d7(map) {
    $8cbe139e0fba169a$var$overrideErrorMap = map;
}
function $8cbe139e0fba169a$export$32f27c719778d4c4() {
    return $8cbe139e0fba169a$var$overrideErrorMap;
}
const $8cbe139e0fba169a$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    if (issueData.message !== undefined) return {
        ...issueData,
        path: fullPath,
        message: issueData.message
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: errorMessage
    };
};
const $8cbe139e0fba169a$export$1526d2e05f74572 = [];
function $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, issueData) {
    const overrideMap = $8cbe139e0fba169a$export$32f27c719778d4c4();
    const issue = $8cbe139e0fba169a$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            overrideMap,
            overrideMap === $8cbe139e0fba169a$export$341b0b6e0a6f5099 ? undefined : $8cbe139e0fba169a$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $8cbe139e0fba169a$export$5b20a5c3d05c1f6f {
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs){
            const key = await pair.key;
            const value = await pair.value;
            syncPairs.push({
                key: key,
                value: value
            });
        }
        return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
    constructor(){
        this.value = "valid";
    }
}
const $8cbe139e0fba169a$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $8cbe139e0fba169a$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $8cbe139e0fba169a$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $8cbe139e0fba169a$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $8cbe139e0fba169a$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $8cbe139e0fba169a$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $8cbe139e0fba169a$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $8cbe139e0fba169a$var$__classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $8cbe139e0fba169a$var$__classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
typeof SuppressedError === "function" && SuppressedError;
var $8cbe139e0fba169a$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($8cbe139e0fba169a$var$errorUtil || ($8cbe139e0fba169a$var$errorUtil = {}));
var $8cbe139e0fba169a$var$_ZodEnum_cache, $8cbe139e0fba169a$var$_ZodNativeEnum_cache;
class $8cbe139e0fba169a$var$ParseInputLazyPath {
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
}
const $8cbe139e0fba169a$var$handleResult = (ctx, result)=>{
    if ($8cbe139e0fba169a$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $8cbe139e0fba169a$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $8cbe139e0fba169a$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        var _a, _b;
        const { message: message } = params;
        if (iss.code === "invalid_enum_value") return {
            message: message !== null && message !== void 0 ? message : ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: (_a = message !== null && message !== void 0 ? message : required_error) !== null && _a !== void 0 ? _a : ctx.defaultError
        };
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        return {
            message: (_b = message !== null && message !== void 0 ? message : invalid_type_error) !== null && _b !== void 0 ? _b : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $8cbe139e0fba169a$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($8cbe139e0fba169a$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $8cbe139e0fba169a$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($8cbe139e0fba169a$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $8cbe139e0fba169a$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $8cbe139e0fba169a$export$a60af00cc0ce2582({
            schema: this,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $8cbe139e0fba169a$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $8cbe139e0fba169a$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $8cbe139e0fba169a$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $8cbe139e0fba169a$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $8cbe139e0fba169a$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $8cbe139e0fba169a$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $8cbe139e0fba169a$export$a60af00cc0ce2582({
            ...$8cbe139e0fba169a$var$processCreateParams(this._def),
            schema: this,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8cbe139e0fba169a$export$bb19b37874861e7e({
            ...$8cbe139e0fba169a$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $8cbe139e0fba169a$export$66b0c798a395271f({
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$8cbe139e0fba169a$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $8cbe139e0fba169a$export$75a44ec6249ac76b({
            ...$8cbe139e0fba169a$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $8cbe139e0fba169a$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $8cbe139e0fba169a$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
}
const $8cbe139e0fba169a$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $8cbe139e0fba169a$var$cuid2Regex = /^[0-9a-z]+$/;
const $8cbe139e0fba169a$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $8cbe139e0fba169a$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
const $8cbe139e0fba169a$var$nanoidRegex = /^[a-z0-9_-]{21}$/i;
const $8cbe139e0fba169a$var$durationRegex = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $8cbe139e0fba169a$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $8cbe139e0fba169a$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $8cbe139e0fba169a$var$emojiRegex;
// faster, simpler, safer
const $8cbe139e0fba169a$var$ipv4Regex = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/;
const $8cbe139e0fba169a$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// https://stackoverflow.com/questions/7860392/determine-if-string-is-in-base64-using-javascript
const $8cbe139e0fba169a$var$base64Regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
// simple
// const dateRegexSource = `\\d{4}-\\d{2}-\\d{2}`;
// no leap year validation
// const dateRegexSource = `\\d{4}-((0[13578]|10|12)-31|(0[13-9]|1[0-2])-30|(0[1-9]|1[0-2])-(0[1-9]|1\\d|2\\d))`;
// with leap year validation
const $8cbe139e0fba169a$var$dateRegexSource = `((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))`;
const $8cbe139e0fba169a$var$dateRegex = new RegExp(`^${$8cbe139e0fba169a$var$dateRegexSource}$`);
function $8cbe139e0fba169a$var$timeRegexSource(args) {
    // let regex = `\\d{2}:\\d{2}:\\d{2}`;
    let regex = `([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d`;
    if (args.precision) regex = `${regex}\\.\\d{${args.precision}}`;
    else if (args.precision == null) regex = `${regex}(\\.\\d+)?`;
    return regex;
}
function $8cbe139e0fba169a$var$timeRegex(args) {
    return new RegExp(`^${$8cbe139e0fba169a$var$timeRegexSource(args)}$`);
}
// Adapted from https://stackoverflow.com/a/3143231
function $8cbe139e0fba169a$export$a4b563879add27a(args) {
    let regex = `${$8cbe139e0fba169a$var$dateRegexSource}T${$8cbe139e0fba169a$var$timeRegexSource(args)}`;
    const opts = [];
    opts.push(args.local ? `Z?` : `Z`);
    if (args.offset) opts.push(`([+-]\\d{2}:?\\d{2})`);
    regex = `${regex}(${opts.join("|")})`;
    return new RegExp(`^${regex}$`);
}
function $8cbe139e0fba169a$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $8cbe139e0fba169a$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $8cbe139e0fba169a$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $8cbe139e0fba169a$export$1230eb29b8d3b502 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$8cbe139e0fba169a$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$8cbe139e0fba169a$var$emojiRegex) $8cbe139e0fba169a$var$emojiRegex = new RegExp($8cbe139e0fba169a$var$_emojiRegex, "u");
                if (!$8cbe139e0fba169a$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$8cbe139e0fba169a$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "nanoid") {
                if (!$8cbe139e0fba169a$var$nanoidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "nanoid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$8cbe139e0fba169a$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$8cbe139e0fba169a$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$8cbe139e0fba169a$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $8cbe139e0fba169a$export$a4b563879add27a(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "date") {
                const regex = $8cbe139e0fba169a$var$dateRegex;
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: "date",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "time") {
                const regex = $8cbe139e0fba169a$var$timeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        validation: "time",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "duration") {
                if (!$8cbe139e0fba169a$var$durationRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "duration",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$8cbe139e0fba169a$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "base64") {
                if (!$8cbe139e0fba169a$var$base64Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        validation: "base64",
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_string,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    nanoid(message) {
        return this._addCheck({
            kind: "nanoid",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    base64(message) {
        return this._addCheck({
            kind: "base64",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a, _b;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            local: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            local: (_b = options === null || options === void 0 ? void 0 : options.local) !== null && _b !== void 0 ? _b : false,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    date(message) {
        return this._addCheck({
            kind: "date",
            message: message
        });
    }
    time(options) {
        if (typeof options === "string") return this._addCheck({
            kind: "time",
            precision: null,
            message: options
        });
        return this._addCheck({
            kind: "time",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    duration(message) {
        return this._addCheck({
            kind: "duration",
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$8cbe139e0fba169a$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $8cbe139e0fba169a$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $8cbe139e0fba169a$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isDate() {
        return !!this._def.checks.find((ch)=>ch.kind === "date");
    }
    get isTime() {
        return !!this._def.checks.find((ch)=>ch.kind === "time");
    }
    get isDuration() {
        return !!this._def.checks.find((ch)=>ch.kind === "duration");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isNANOID() {
        return !!this._def.checks.find((ch)=>ch.kind === "nanoid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get isBase64() {
        return !!this._def.checks.find((ch)=>ch.kind === "base64");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$8cbe139e0fba169a$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $8cbe139e0fba169a$export$1230eb29b8d3b502({
        checks: [],
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $8cbe139e0fba169a$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $8cbe139e0fba169a$export$5b070a55c0c43e09 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$8cbe139e0fba169a$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($8cbe139e0fba169a$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8cbe139e0fba169a$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8cbe139e0fba169a$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $8cbe139e0fba169a$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
}
$8cbe139e0fba169a$export$5b070a55c0c43e09.create = (params)=>{
    return new $8cbe139e0fba169a$export$5b070a55c0c43e09({
        checks: [],
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$67d741fd70ff98f4 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $8cbe139e0fba169a$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $8cbe139e0fba169a$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $8cbe139e0fba169a$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
}
$8cbe139e0fba169a$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $8cbe139e0fba169a$export$67d741fd70ff98f4({
        checks: [],
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$723d146f80596191 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$723d146f80596191.create = (params)=>{
    return new $8cbe139e0fba169a$export$723d146f80596191({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$e974be33bdc55521 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_date
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const status = new $8cbe139e0fba169a$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $8cbe139e0fba169a$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $8cbe139e0fba169a$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$8cbe139e0fba169a$export$e974be33bdc55521.create = (params)=>{
    return new $8cbe139e0fba169a$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDate,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$bcc3b40f6b638044 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$bcc3b40f6b638044.create = (params)=>{
    return new $8cbe139e0fba169a$export$bcc3b40f6b638044({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodSymbol,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$4e780e961c30340d extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$4e780e961c30340d.create = (params)=>{
    return new $8cbe139e0fba169a$export$4e780e961c30340d({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodUndefined,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$a96281f914484f2d extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$a96281f914484f2d.create = (params)=>{
    return new $8cbe139e0fba169a$export$a96281f914484f2d({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNull,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$b9d1edb536b4e4eb extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
}
$8cbe139e0fba169a$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $8cbe139e0fba169a$export$b9d1edb536b4e4eb({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodAny,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$ef3b1bb1630977ae extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
}
$8cbe139e0fba169a$export$ef3b1bb1630977ae.create = (params)=>{
    return new $8cbe139e0fba169a$export$ef3b1bb1630977ae({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodUnknown,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$1e576a20c3ce9fb5 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
            code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
            expected: $8cbe139e0fba169a$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $8cbe139e0fba169a$export$9a105a556e65c2c0;
    }
}
$8cbe139e0fba169a$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $8cbe139e0fba169a$export$1e576a20c3ce9fb5({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNever,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$7d39f5df85f21031 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
}
$8cbe139e0fba169a$export$7d39f5df85f21031.create = (params)=>{
    return new $8cbe139e0fba169a$export$7d39f5df85f21031({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodVoid,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$7acfc3e64785411 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.array) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $8cbe139e0fba169a$export$5ba560653e4a1035.too_big : $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $8cbe139e0fba169a$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $8cbe139e0fba169a$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $8cbe139e0fba169a$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8cbe139e0fba169a$export$7acfc3e64785411.create = (schema, params)=>{
    return new $8cbe139e0fba169a$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodArray,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
function $8cbe139e0fba169a$var$deepPartialify(schema) {
    if (schema instanceof $8cbe139e0fba169a$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $8cbe139e0fba169a$export$aa56fec1e9d629b8.create($8cbe139e0fba169a$var$deepPartialify(fieldSchema));
        }
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $8cbe139e0fba169a$export$7acfc3e64785411) return new $8cbe139e0fba169a$export$7acfc3e64785411({
        ...schema._def,
        type: $8cbe139e0fba169a$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $8cbe139e0fba169a$export$aa56fec1e9d629b8) return $8cbe139e0fba169a$export$aa56fec1e9d629b8.create($8cbe139e0fba169a$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8cbe139e0fba169a$export$aaac0b8b429cef5) return $8cbe139e0fba169a$export$aaac0b8b429cef5.create($8cbe139e0fba169a$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $8cbe139e0fba169a$export$e2a18bb771d8e6a3) return $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$8cbe139e0fba169a$var$deepPartialify(item)));
    else return schema;
}
class $8cbe139e0fba169a$export$736315c5b55efbad extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $8cbe139e0fba169a$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $8cbe139e0fba169a$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                        code: $8cbe139e0fba169a$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                const value = await pair.value;
                syncPairs.push({
                    key: key,
                    value: value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $8cbe139e0fba169a$var$errorUtil.errToObj;
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $8cbe139e0fba169a$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $8cbe139e0fba169a$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $8cbe139e0fba169a$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $8cbe139e0fba169a$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $8cbe139e0fba169a$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $8cbe139e0fba169a$var$createZodEnum($8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
}
$8cbe139e0fba169a$export$736315c5b55efbad.create = (shape, params)=>{
    return new $8cbe139e0fba169a$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create(),
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
$8cbe139e0fba169a$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $8cbe139e0fba169a$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create(),
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
$8cbe139e0fba169a$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $8cbe139e0fba169a$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create(),
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodObject,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$a8b236cb5070a311 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $8cbe139e0fba169a$export$f98dac4b251ab333(result.ctx.common.issues));
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $8cbe139e0fba169a$export$f98dac4b251ab333(issues));
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$8cbe139e0fba169a$export$a8b236cb5070a311.create = (types, params)=>{
    return new $8cbe139e0fba169a$export$a8b236cb5070a311({
        options: types,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodUnion,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $8cbe139e0fba169a$var$getDiscriminator = (type)=>{
    if (type instanceof $8cbe139e0fba169a$export$378d0cfce37406e6) return $8cbe139e0fba169a$var$getDiscriminator(type.schema);
    else if (type instanceof $8cbe139e0fba169a$export$a60af00cc0ce2582) return $8cbe139e0fba169a$var$getDiscriminator(type.innerType());
    else if (type instanceof $8cbe139e0fba169a$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $8cbe139e0fba169a$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $8cbe139e0fba169a$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectValues(type.enum);
    else if (type instanceof $8cbe139e0fba169a$export$bb19b37874861e7e) return $8cbe139e0fba169a$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $8cbe139e0fba169a$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $8cbe139e0fba169a$export$a96281f914484f2d) return [
        null
    ];
    else if (type instanceof $8cbe139e0fba169a$export$aa56fec1e9d629b8) return [
        undefined,
        ...$8cbe139e0fba169a$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $8cbe139e0fba169a$export$aaac0b8b429cef5) return [
        null,
        ...$8cbe139e0fba169a$var$getDiscriminator(type.unwrap())
    ];
    else if (type instanceof $8cbe139e0fba169a$export$66b0c798a395271f) return $8cbe139e0fba169a$var$getDiscriminator(type.unwrap());
    else if (type instanceof $8cbe139e0fba169a$export$5d1f7ef05c4e493a) return $8cbe139e0fba169a$var$getDiscriminator(type.unwrap());
    else if (type instanceof $8cbe139e0fba169a$export$75a44ec6249ac76b) return $8cbe139e0fba169a$var$getDiscriminator(type._def.innerType);
    else return [];
};
class $8cbe139e0fba169a$export$5ef2424805ac76a3 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $8cbe139e0fba169a$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues.length) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $8cbe139e0fba169a$export$5ef2424805ac76a3({
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$8cbe139e0fba169a$var$processCreateParams(params)
        });
    }
}
function $8cbe139e0fba169a$var$mergeValues(a, b) {
    const aType = $8cbe139e0fba169a$export$3e9057828ebd5c7a(a);
    const bType = $8cbe139e0fba169a$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $8cbe139e0fba169a$export$5716da67bfaa244d.object && bType === $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
        const bKeys = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $8cbe139e0fba169a$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $8cbe139e0fba169a$export$5716da67bfaa244d.array && bType === $8cbe139e0fba169a$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $8cbe139e0fba169a$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $8cbe139e0fba169a$export$5716da67bfaa244d.date && bType === $8cbe139e0fba169a$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $8cbe139e0fba169a$export$c02deaf0bb5203d4 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($8cbe139e0fba169a$export$afa861e3c5730743(parsedLeft) || $8cbe139e0fba169a$export$afa861e3c5730743(parsedRight)) return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            const merged = $8cbe139e0fba169a$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            }
            if ($8cbe139e0fba169a$export$910b6cdd390341b3(parsedLeft) || $8cbe139e0fba169a$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$8cbe139e0fba169a$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $8cbe139e0fba169a$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodIntersection,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$e2a18bb771d8e6a3 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.array) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $8cbe139e0fba169a$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$8cbe139e0fba169a$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $8cbe139e0fba169a$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$a2acc09968cb4b7f extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.object) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            alwaysSet: key in ctx.data
        });
        if (ctx.common.async) return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $8cbe139e0fba169a$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $8cbe139e0fba169a$export$19342e026b58ebb7) return new $8cbe139e0fba169a$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodRecord,
            ...$8cbe139e0fba169a$var$processCreateParams(third)
        });
        return new $8cbe139e0fba169a$export$a2acc09968cb4b7f({
            keyType: $8cbe139e0fba169a$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodRecord,
            ...$8cbe139e0fba169a$var$processCreateParams(second)
        });
    }
}
class $8cbe139e0fba169a$export$163b6a2b712d9542 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.map) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$8cbe139e0fba169a$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $8cbe139e0fba169a$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodMap,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$977057706f816712 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.set) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $8cbe139e0fba169a$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $8cbe139e0fba169a$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $8cbe139e0fba169a$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $8cbe139e0fba169a$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$8cbe139e0fba169a$export$977057706f816712.create = (valueType, params)=>{
    return new $8cbe139e0fba169a$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodSet,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$d4602ba55673f53c extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.function) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $8cbe139e0fba169a$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8cbe139e0fba169a$export$32f27c719778d4c4(),
                    $8cbe139e0fba169a$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $8cbe139e0fba169a$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $8cbe139e0fba169a$export$32f27c719778d4c4(),
                    $8cbe139e0fba169a$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $8cbe139e0fba169a$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8cbe139e0fba169a$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $8cbe139e0fba169a$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $8cbe139e0fba169a$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $8cbe139e0fba169a$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $8cbe139e0fba169a$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $8cbe139e0fba169a$export$d4602ba55673f53c({
            ...this._def,
            args: $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create(items).rest($8cbe139e0fba169a$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $8cbe139e0fba169a$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $8cbe139e0fba169a$export$d4602ba55673f53c({
            args: args ? args : $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create([]).rest($8cbe139e0fba169a$export$ef3b1bb1630977ae.create()),
            returns: returns || $8cbe139e0fba169a$export$ef3b1bb1630977ae.create(),
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodFunction,
            ...$8cbe139e0fba169a$var$processCreateParams(params)
        });
    }
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
}
class $8cbe139e0fba169a$export$378d0cfce37406e6 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$8cbe139e0fba169a$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $8cbe139e0fba169a$export$378d0cfce37406e6({
        getter: getter,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodLazy,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$7e44096782a165d3 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$8cbe139e0fba169a$export$7e44096782a165d3.create = (value, params)=>{
    return new $8cbe139e0fba169a$export$7e44096782a165d3({
        value: value,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodLiteral,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
function $8cbe139e0fba169a$var$createZodEnum(values, params) {
    return new $8cbe139e0fba169a$export$d325d1f0e1c20179({
        values: values,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEnum,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
}
class $8cbe139e0fba169a$export$d325d1f0e1c20179 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                expected: $8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodEnum_cache, "f")) $8cbe139e0fba169a$var$__classPrivateFieldSet(this, $8cbe139e0fba169a$var$_ZodEnum_cache, new Set(this._def.values), "f");
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodEnum_cache, "f").has(input.data)) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values, newDef = this._def) {
        return $8cbe139e0fba169a$export$d325d1f0e1c20179.create(values, {
            ...this._def,
            ...newDef
        });
    }
    exclude(values, newDef = this._def) {
        return $8cbe139e0fba169a$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)), {
            ...this._def,
            ...newDef
        });
    }
    constructor(){
        super(...arguments);
        $8cbe139e0fba169a$var$_ZodEnum_cache.set(this, void 0);
    }
}
$8cbe139e0fba169a$var$_ZodEnum_cache = new WeakMap();
$8cbe139e0fba169a$export$d325d1f0e1c20179.create = $8cbe139e0fba169a$var$createZodEnum;
class $8cbe139e0fba169a$export$370b2e8d6d6f5c56 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $8cbe139e0fba169a$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.string && ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.number) {
            const expectedValues = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                expected: $8cbe139e0fba169a$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodNativeEnum_cache, "f")) $8cbe139e0fba169a$var$__classPrivateFieldSet(this, $8cbe139e0fba169a$var$_ZodNativeEnum_cache, new Set($8cbe139e0fba169a$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values)), "f");
        if (!$8cbe139e0fba169a$var$__classPrivateFieldGet(this, $8cbe139e0fba169a$var$_ZodNativeEnum_cache, "f").has(input.data)) {
            const expectedValues = $8cbe139e0fba169a$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
    constructor(){
        super(...arguments);
        $8cbe139e0fba169a$var$_ZodNativeEnum_cache.set(this, void 0);
    }
}
$8cbe139e0fba169a$var$_ZodNativeEnum_cache = new WeakMap();
$8cbe139e0fba169a$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $8cbe139e0fba169a$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNativeEnum,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$3f196b0127d6e50a extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $8cbe139e0fba169a$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$8cbe139e0fba169a$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $8cbe139e0fba169a$export$3f196b0127d6e50a({
        type: schema,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodPromise,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$a60af00cc0ce2582 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.async) return Promise.resolve(processed).then(async (processed)=>{
                if (status.value === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                const result = await this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                return result;
            });
            else {
                if (status.value === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                const result = this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
                if (result.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (result.status === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                if (status.value === "dirty") return $8cbe139e0fba169a$export$325a211da9693fcf(result.value);
                return result;
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$8cbe139e0fba169a$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$8cbe139e0fba169a$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $8cbe139e0fba169a$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$8cbe139e0fba169a$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $8cbe139e0fba169a$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
$8cbe139e0fba169a$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $8cbe139e0fba169a$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodEffects,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$aa56fec1e9d629b8 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) return $8cbe139e0fba169a$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodOptional,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$aaac0b8b429cef5 extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.null) return $8cbe139e0fba169a$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNullable,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$bb19b37874861e7e extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $8cbe139e0fba169a$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$bb19b37874861e7e.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$bb19b37874861e7e({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$75a44ec6249ac76b extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($8cbe139e0fba169a$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $8cbe139e0fba169a$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $8cbe139e0fba169a$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
class $8cbe139e0fba169a$export$26ccfa0145e8511f extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $8cbe139e0fba169a$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $8cbe139e0fba169a$export$db7caee60e5d514d(ctx, {
                code: $8cbe139e0fba169a$export$5ba560653e4a1035.invalid_type,
                expected: $8cbe139e0fba169a$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $8cbe139e0fba169a$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$8cbe139e0fba169a$export$26ccfa0145e8511f.create = (params)=>{
    return new $8cbe139e0fba169a$export$26ccfa0145e8511f({
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodNaN,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
const $8cbe139e0fba169a$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $8cbe139e0fba169a$export$66b0c798a395271f extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $8cbe139e0fba169a$export$a3c3ef8a0e95c6da extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $8cbe139e0fba169a$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $8cbe139e0fba169a$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $8cbe139e0fba169a$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $8cbe139e0fba169a$export$5d1f7ef05c4e493a extends $8cbe139e0fba169a$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        const freeze = (data)=>{
            if ($8cbe139e0fba169a$export$1ea939691cdc45b8(data)) data.value = Object.freeze(data.value);
            return data;
        };
        return $8cbe139e0fba169a$export$aefee5ebe1dcfd9e(result) ? result.then((data)=>freeze(data)) : freeze(result);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$8cbe139e0fba169a$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $8cbe139e0fba169a$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $8cbe139e0fba169a$export$558106ce543bd011.ZodReadonly,
        ...$8cbe139e0fba169a$var$processCreateParams(params)
    });
};
function $8cbe139e0fba169a$export$4c00f665f0d4b443(check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal) {
    if (check) return $8cbe139e0fba169a$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $8cbe139e0fba169a$export$b9d1edb536b4e4eb.create();
}
const $8cbe139e0fba169a$export$1ee8ee30835eab8b = {
    object: $8cbe139e0fba169a$export$736315c5b55efbad.lazycreate
};
var $8cbe139e0fba169a$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($8cbe139e0fba169a$export$558106ce543bd011 || ($8cbe139e0fba169a$export$558106ce543bd011 = {}));
const $8cbe139e0fba169a$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$8cbe139e0fba169a$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $8cbe139e0fba169a$export$22b082955e083ec3 = $8cbe139e0fba169a$export$1230eb29b8d3b502.create;
const $8cbe139e0fba169a$export$98e628dec113755e = $8cbe139e0fba169a$export$5b070a55c0c43e09.create;
const $8cbe139e0fba169a$export$9e06de0973666692 = $8cbe139e0fba169a$export$26ccfa0145e8511f.create;
const $8cbe139e0fba169a$export$a0f65b52274bcc00 = $8cbe139e0fba169a$export$67d741fd70ff98f4.create;
const $8cbe139e0fba169a$export$4a21f16c33752377 = $8cbe139e0fba169a$export$723d146f80596191.create;
const $8cbe139e0fba169a$export$324d90190a8b822a = $8cbe139e0fba169a$export$e974be33bdc55521.create;
const $8cbe139e0fba169a$export$8f701197936bc2a6 = $8cbe139e0fba169a$export$bcc3b40f6b638044.create;
const $8cbe139e0fba169a$export$1db45310990710a5 = $8cbe139e0fba169a$export$4e780e961c30340d.create;
const $8cbe139e0fba169a$export$7b1b591b262c240 = $8cbe139e0fba169a$export$a96281f914484f2d.create;
const $8cbe139e0fba169a$export$4154a199d7d90455 = $8cbe139e0fba169a$export$b9d1edb536b4e4eb.create;
const $8cbe139e0fba169a$export$19282c40b967aec6 = $8cbe139e0fba169a$export$ef3b1bb1630977ae.create;
const $8cbe139e0fba169a$export$b3e22bcfd64c1022 = $8cbe139e0fba169a$export$1e576a20c3ce9fb5.create;
const $8cbe139e0fba169a$export$490e536ee7389aeb = $8cbe139e0fba169a$export$7d39f5df85f21031.create;
const $8cbe139e0fba169a$export$2f23118c22fb2630 = $8cbe139e0fba169a$export$7acfc3e64785411.create;
const $8cbe139e0fba169a$export$be5493f9613cbbe = $8cbe139e0fba169a$export$736315c5b55efbad.create;
const $8cbe139e0fba169a$export$8fb0df5f40d0b477 = $8cbe139e0fba169a$export$736315c5b55efbad.strictCreate;
const $8cbe139e0fba169a$export$971dd5b0dfd021b6 = $8cbe139e0fba169a$export$a8b236cb5070a311.create;
const $8cbe139e0fba169a$export$4b888e40c4ee26dd = $8cbe139e0fba169a$export$5ef2424805ac76a3.create;
const $8cbe139e0fba169a$export$bc86dfbf7795668c = $8cbe139e0fba169a$export$c02deaf0bb5203d4.create;
const $8cbe139e0fba169a$export$65e3907585753458 = $8cbe139e0fba169a$export$e2a18bb771d8e6a3.create;
const $8cbe139e0fba169a$export$e5185e241753e543 = $8cbe139e0fba169a$export$a2acc09968cb4b7f.create;
const $8cbe139e0fba169a$export$871de8747c9eaa88 = $8cbe139e0fba169a$export$163b6a2b712d9542.create;
const $8cbe139e0fba169a$export$adaa4cf7ef1b65be = $8cbe139e0fba169a$export$977057706f816712.create;
const $8cbe139e0fba169a$export$44e51c8aac7c2deb = $8cbe139e0fba169a$export$d4602ba55673f53c.create;
const $8cbe139e0fba169a$export$488013bae63b21da = $8cbe139e0fba169a$export$378d0cfce37406e6.create;
const $8cbe139e0fba169a$export$c8ec6e1ec9fefcb0 = $8cbe139e0fba169a$export$7e44096782a165d3.create;
const $8cbe139e0fba169a$export$78a99c8d44d72635 = $8cbe139e0fba169a$export$d325d1f0e1c20179.create;
const $8cbe139e0fba169a$export$6fe7eca19ebe5199 = $8cbe139e0fba169a$export$370b2e8d6d6f5c56.create;
const $8cbe139e0fba169a$export$c957ef27a0ebfd4 = $8cbe139e0fba169a$export$3f196b0127d6e50a.create;
const $8cbe139e0fba169a$export$dc573d8a6576cdb3 = $8cbe139e0fba169a$export$a60af00cc0ce2582.create;
const $8cbe139e0fba169a$export$516e28dec6a4b6d4 = $8cbe139e0fba169a$export$aa56fec1e9d629b8.create;
const $8cbe139e0fba169a$export$133fc36489ac9add = $8cbe139e0fba169a$export$aaac0b8b429cef5.create;
const $8cbe139e0fba169a$export$fc37fe19dfda43ee = $8cbe139e0fba169a$export$a60af00cc0ce2582.createWithPreprocess;
const $8cbe139e0fba169a$export$43f28b24e1eb8181 = $8cbe139e0fba169a$export$a3c3ef8a0e95c6da.create;
const $8cbe139e0fba169a$export$3b3d07727c5b702c = ()=>$8cbe139e0fba169a$export$22b082955e083ec3().optional();
const $8cbe139e0fba169a$export$eb150471a61fced6 = ()=>$8cbe139e0fba169a$export$98e628dec113755e().optional();
const $8cbe139e0fba169a$export$269251733cdcbbf1 = ()=>$8cbe139e0fba169a$export$4a21f16c33752377().optional();
const $8cbe139e0fba169a$export$8c14e57e778d3873 = {
    string: (arg)=>$8cbe139e0fba169a$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$8cbe139e0fba169a$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$8cbe139e0fba169a$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$8cbe139e0fba169a$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$8cbe139e0fba169a$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $8cbe139e0fba169a$export$96c94437c95d7862 = $8cbe139e0fba169a$export$9a105a556e65c2c0;
var $8cbe139e0fba169a$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $8cbe139e0fba169a$export$341b0b6e0a6f5099,
    setErrorMap: $8cbe139e0fba169a$export$1097a8289cfd22d7,
    getErrorMap: $8cbe139e0fba169a$export$32f27c719778d4c4,
    makeIssue: $8cbe139e0fba169a$export$244a85fde9c419ed,
    EMPTY_PATH: $8cbe139e0fba169a$export$1526d2e05f74572,
    addIssueToContext: $8cbe139e0fba169a$export$db7caee60e5d514d,
    ParseStatus: $8cbe139e0fba169a$export$5b20a5c3d05c1f6f,
    INVALID: $8cbe139e0fba169a$export$9a105a556e65c2c0,
    DIRTY: $8cbe139e0fba169a$export$325a211da9693fcf,
    OK: $8cbe139e0fba169a$export$c6813a8d51f77eaf,
    isAborted: $8cbe139e0fba169a$export$afa861e3c5730743,
    isDirty: $8cbe139e0fba169a$export$910b6cdd390341b3,
    isValid: $8cbe139e0fba169a$export$1ea939691cdc45b8,
    isAsync: $8cbe139e0fba169a$export$aefee5ebe1dcfd9e,
    get util () {
        return $8cbe139e0fba169a$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $8cbe139e0fba169a$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $8cbe139e0fba169a$export$5716da67bfaa244d,
    getParsedType: $8cbe139e0fba169a$export$3e9057828ebd5c7a,
    ZodType: $8cbe139e0fba169a$export$19342e026b58ebb7,
    datetimeRegex: $8cbe139e0fba169a$export$a4b563879add27a,
    ZodString: $8cbe139e0fba169a$export$1230eb29b8d3b502,
    ZodNumber: $8cbe139e0fba169a$export$5b070a55c0c43e09,
    ZodBigInt: $8cbe139e0fba169a$export$67d741fd70ff98f4,
    ZodBoolean: $8cbe139e0fba169a$export$723d146f80596191,
    ZodDate: $8cbe139e0fba169a$export$e974be33bdc55521,
    ZodSymbol: $8cbe139e0fba169a$export$bcc3b40f6b638044,
    ZodUndefined: $8cbe139e0fba169a$export$4e780e961c30340d,
    ZodNull: $8cbe139e0fba169a$export$a96281f914484f2d,
    ZodAny: $8cbe139e0fba169a$export$b9d1edb536b4e4eb,
    ZodUnknown: $8cbe139e0fba169a$export$ef3b1bb1630977ae,
    ZodNever: $8cbe139e0fba169a$export$1e576a20c3ce9fb5,
    ZodVoid: $8cbe139e0fba169a$export$7d39f5df85f21031,
    ZodArray: $8cbe139e0fba169a$export$7acfc3e64785411,
    ZodObject: $8cbe139e0fba169a$export$736315c5b55efbad,
    ZodUnion: $8cbe139e0fba169a$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $8cbe139e0fba169a$export$5ef2424805ac76a3,
    ZodIntersection: $8cbe139e0fba169a$export$c02deaf0bb5203d4,
    ZodTuple: $8cbe139e0fba169a$export$e2a18bb771d8e6a3,
    ZodRecord: $8cbe139e0fba169a$export$a2acc09968cb4b7f,
    ZodMap: $8cbe139e0fba169a$export$163b6a2b712d9542,
    ZodSet: $8cbe139e0fba169a$export$977057706f816712,
    ZodFunction: $8cbe139e0fba169a$export$d4602ba55673f53c,
    ZodLazy: $8cbe139e0fba169a$export$378d0cfce37406e6,
    ZodLiteral: $8cbe139e0fba169a$export$7e44096782a165d3,
    ZodEnum: $8cbe139e0fba169a$export$d325d1f0e1c20179,
    ZodNativeEnum: $8cbe139e0fba169a$export$370b2e8d6d6f5c56,
    ZodPromise: $8cbe139e0fba169a$export$3f196b0127d6e50a,
    ZodEffects: $8cbe139e0fba169a$export$a60af00cc0ce2582,
    ZodTransformer: $8cbe139e0fba169a$export$a60af00cc0ce2582,
    ZodOptional: $8cbe139e0fba169a$export$aa56fec1e9d629b8,
    ZodNullable: $8cbe139e0fba169a$export$aaac0b8b429cef5,
    ZodDefault: $8cbe139e0fba169a$export$bb19b37874861e7e,
    ZodCatch: $8cbe139e0fba169a$export$75a44ec6249ac76b,
    ZodNaN: $8cbe139e0fba169a$export$26ccfa0145e8511f,
    BRAND: $8cbe139e0fba169a$export$cf2deea74cde46b4,
    ZodBranded: $8cbe139e0fba169a$export$66b0c798a395271f,
    ZodPipeline: $8cbe139e0fba169a$export$a3c3ef8a0e95c6da,
    ZodReadonly: $8cbe139e0fba169a$export$5d1f7ef05c4e493a,
    custom: $8cbe139e0fba169a$export$4c00f665f0d4b443,
    Schema: $8cbe139e0fba169a$export$19342e026b58ebb7,
    ZodSchema: $8cbe139e0fba169a$export$19342e026b58ebb7,
    late: $8cbe139e0fba169a$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $8cbe139e0fba169a$export$558106ce543bd011;
    },
    coerce: $8cbe139e0fba169a$export$8c14e57e778d3873,
    any: $8cbe139e0fba169a$export$4154a199d7d90455,
    array: $8cbe139e0fba169a$export$2f23118c22fb2630,
    bigint: $8cbe139e0fba169a$export$a0f65b52274bcc00,
    boolean: $8cbe139e0fba169a$export$4a21f16c33752377,
    date: $8cbe139e0fba169a$export$324d90190a8b822a,
    discriminatedUnion: $8cbe139e0fba169a$export$4b888e40c4ee26dd,
    effect: $8cbe139e0fba169a$export$dc573d8a6576cdb3,
    "enum": $8cbe139e0fba169a$export$78a99c8d44d72635,
    "function": $8cbe139e0fba169a$export$44e51c8aac7c2deb,
    "instanceof": $8cbe139e0fba169a$export$3d916e7c22dbd8b5,
    intersection: $8cbe139e0fba169a$export$bc86dfbf7795668c,
    lazy: $8cbe139e0fba169a$export$488013bae63b21da,
    literal: $8cbe139e0fba169a$export$c8ec6e1ec9fefcb0,
    map: $8cbe139e0fba169a$export$871de8747c9eaa88,
    nan: $8cbe139e0fba169a$export$9e06de0973666692,
    nativeEnum: $8cbe139e0fba169a$export$6fe7eca19ebe5199,
    never: $8cbe139e0fba169a$export$b3e22bcfd64c1022,
    "null": $8cbe139e0fba169a$export$7b1b591b262c240,
    nullable: $8cbe139e0fba169a$export$133fc36489ac9add,
    number: $8cbe139e0fba169a$export$98e628dec113755e,
    object: $8cbe139e0fba169a$export$be5493f9613cbbe,
    oboolean: $8cbe139e0fba169a$export$269251733cdcbbf1,
    onumber: $8cbe139e0fba169a$export$eb150471a61fced6,
    optional: $8cbe139e0fba169a$export$516e28dec6a4b6d4,
    ostring: $8cbe139e0fba169a$export$3b3d07727c5b702c,
    pipeline: $8cbe139e0fba169a$export$43f28b24e1eb8181,
    preprocess: $8cbe139e0fba169a$export$fc37fe19dfda43ee,
    promise: $8cbe139e0fba169a$export$c957ef27a0ebfd4,
    record: $8cbe139e0fba169a$export$e5185e241753e543,
    set: $8cbe139e0fba169a$export$adaa4cf7ef1b65be,
    strictObject: $8cbe139e0fba169a$export$8fb0df5f40d0b477,
    string: $8cbe139e0fba169a$export$22b082955e083ec3,
    symbol: $8cbe139e0fba169a$export$8f701197936bc2a6,
    transformer: $8cbe139e0fba169a$export$dc573d8a6576cdb3,
    tuple: $8cbe139e0fba169a$export$65e3907585753458,
    "undefined": $8cbe139e0fba169a$export$1db45310990710a5,
    union: $8cbe139e0fba169a$export$971dd5b0dfd021b6,
    unknown: $8cbe139e0fba169a$export$19282c40b967aec6,
    "void": $8cbe139e0fba169a$export$490e536ee7389aeb,
    NEVER: $8cbe139e0fba169a$export$96c94437c95d7862,
    ZodIssueCode: $8cbe139e0fba169a$export$5ba560653e4a1035,
    quotelessJson: $8cbe139e0fba169a$export$913eddeaf297cfea,
    ZodError: $8cbe139e0fba169a$export$f98dac4b251ab333
});


function $f99173babae80fe1$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $f99173babae80fe1$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $f99173babae80fe1$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $f99173babae80fe1$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $f99173babae80fe1$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $f99173babae80fe1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
var $f99173babae80fe1$export$c5fb415882705cf4 = /*#__PURE__*/ function(ConfigError) {
    ConfigError["NotFound"] = "not_found";
    ConfigError["InvalidState"] = "state_invalid";
    ConfigError["IncorrectType"] = "incorrect_type";
    return ConfigError;
}({});
var $f99173babae80fe1$export$e94ee64b2671e155 = (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).record((0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(), (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).object({
    value: (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).union([
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).boolean(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).number(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string().array(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).number().array()
    ])
}));
var $f99173babae80fe1$export$e38f7b10db0e126a = (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).tuple([
    // list of boolean configs which are on
    (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string().array(),
    // list of string config tuples
    (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).array((0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string()).refine(function(arr) {
        return arr.length % 2 === 0;
    }),
    // list of number config tuples
    (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).array((0, $8cbe139e0fba169a$export$2e2bcd8739ae039).union([
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).number()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            if (typeof arr[i] !== "string") return false;
            if (typeof arr[i + 1] !== "number") return false;
        }
        return true;
    }),
    // list of string list config tuples
    (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).array((0, $8cbe139e0fba169a$export$2e2bcd8739ae039).union([
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === "string";
            })) return false;
        }
        return true;
    }),
    // list of number list config tuples
    (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).array((0, $8cbe139e0fba169a$export$2e2bcd8739ae039).union([
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).number().array()
    ])).refine(function(arr) {
        if (arr.length % 2 !== 0) return false;
        for(var i = 0; i < arr.length; i += 2){
            var key = arr[i];
            var val = arr[i + 1];
            if (typeof key !== "string") return false;
            if (!Array.isArray(val) || !val.every(function(x) {
                return typeof x === "number";
            })) return false;
        }
        return true;
    })
]);
var $f99173babae80fe1$export$960d45de79bd7d81 = (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).union([
    $f99173babae80fe1$export$e94ee64b2671e155,
    $f99173babae80fe1$export$e38f7b10db0e126a
]);
var $f99173babae80fe1$export$ac2e9c88ba5d7cbb = (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).map((0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(), (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).object({
    value: (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).union([
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).boolean(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).number(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).string().array(),
        (0, $8cbe139e0fba169a$export$2e2bcd8739ae039).number().array()
    ])
}));
function $f99173babae80fe1$var$pairs(arr, fn) {
    for(var i = 0; i < arr.length; i += 2){
        var key = arr[i];
        var val = arr[i + 1];
        if (typeof key !== "string") throw new Error("Expected a string while iterating pairs, got: ".concat(arr[i]));
        fn(key, val);
    }
}
function $f99173babae80fe1$export$c29ba52779f58587(minimal) {
    var map = new Map();
    minimal[0].forEach(function(boolean) {
        return map.set(boolean, {
            value: true
        });
    });
    $f99173babae80fe1$var$pairs(minimal[1], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $f99173babae80fe1$var$pairs(minimal[2], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $f99173babae80fe1$var$pairs(minimal[3], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    $f99173babae80fe1$var$pairs(minimal[4], function(a, b) {
        return map.set(a, {
            value: b
        });
    });
    return map;
}
function $f99173babae80fe1$export$be5b69ecb011d7cc(standard) {
    var map = new Map();
    Object.entries(standard).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        return map.set(key, value);
    });
    return map;
}
function $f99173babae80fe1$export$460f06addafd9f86(map) {
    var minimal = [
        [],
        [],
        [],
        [],
        []
    ];
    var _iterator = $f99173babae80fe1$var$_createForOfIteratorHelper(map.entries()), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = (0, (/*@__PURE__*/$parcel$interopDefault($kg5sN)))(_step.value, 2), key = _step$value[0], value = _step$value[1].value;
            switch((0, (/*@__PURE__*/$parcel$interopDefault($cd8Dz)))(value)){
                case "boolean":
                    if (value) minimal[0].push(key);
                    break;
                case "string":
                    minimal[1].push(key, value);
                    break;
                case "number":
                    minimal[2].push(key, value);
                    break;
                default:
                    if (!Array.isArray(value)) throw new Error("Unexpected configuration value: ".concat(value));
                    var allStrings = value.every(function(x) {
                        return typeof x === "string";
                    });
                    if (allStrings) {
                        minimal[3].push(key, value);
                        break;
                    }
                    var allNumbers = value.every(function(x) {
                        return typeof x === "number";
                    });
                    if (allNumbers) {
                        minimal[4].push(key, value);
                        break;
                    }
                    throw new Error("Unexpected configuration value: ".concat(value));
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return minimal;
}
function $f99173babae80fe1$export$9d0101ad8235e092(map) {
    return Object.fromEntries(map.entries());
}


function $4e1e34a0383b14f9$var$_createSuper(t) {
    var r = $4e1e34a0383b14f9$var$_isNativeReflectConstruct();
    return function() {
        var e, o = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(t);
        if (r) {
            var s = (0, (/*@__PURE__*/$parcel$interopDefault($hOtqI)))(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($h2r7j)))(this, e);
    };
}
function $4e1e34a0383b14f9$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($4e1e34a0383b14f9$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $4e1e34a0383b14f9$export$f9c837a54db411d = /*#__PURE__*/ function(_Error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($7Ar6h)))(ParseError, _Error);
    var _super = $4e1e34a0383b14f9$var$_createSuper(ParseError);
    function ParseError(message, cause) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ParseError);
        _this = _super.call(this, message);
        _this.cause = cause;
        return _this;
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ParseError);
}(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($3Fq9h)))(Error));
function $4e1e34a0383b14f9$var$safeParse(json) {
    try {
        return {
            data: (0, $f99173babae80fe1$export$960d45de79bd7d81).parse(JSON.parse(json)),
            success: true
        };
    } catch (error) {
        if (error instanceof Error) return {
            success: false,
            error: error
        };
        return {
            success: false,
            error: new $4e1e34a0383b14f9$export$f9c837a54db411d("An unknown error occurred during parsing", error)
        };
    }
}
var $4e1e34a0383b14f9$export$2be5653e4dada0a3 = /*#__PURE__*/ function() {
    function ConfigCollection(config) {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ConfigCollection);
        this.config = config;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ConfigCollection, [
        {
            key: "toJson",
            value: function toJson(format) {
                switch(format){
                    case "standard":
                        return JSON.stringify((0, $f99173babae80fe1$export$9d0101ad8235e092)(this.config));
                    case "minimal":
                        return JSON.stringify((0, $f99173babae80fe1$export$460f06addafd9f86)(this.config));
                }
            }
        },
        {
            key: "getBoolean",
            value: function getBoolean(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (typeof value !== "boolean") return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getString",
            value: function getString(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (typeof value !== "string") return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumber",
            value: function getNumber(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (typeof value !== "number") return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getStringList",
            value: function getStringList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === "string";
                })) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        },
        {
            key: "getNumberList",
            value: function getNumberList(configName) {
                var config = this.config.get(configName);
                if (!config) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).NotFound
                };
                var value = config.value;
                if (!Array.isArray(value) || !value.every(function(x) {
                    return typeof x === "number";
                })) return {
                    error: (0, $f99173babae80fe1$export$c5fb415882705cf4).IncorrectType,
                    received: value
                };
                return {
                    value: value
                };
            }
        }
    ], [
        {
            key: "fromValues",
            value: function fromValues(values, options) {
                var result = $4e1e34a0383b14f9$var$safeParse(values);
                if (!result.success) {
                    var parseError = new $4e1e34a0383b14f9$export$f9c837a54db411d("Failed to deserialize config", result.error);
                    if (options !== null && options !== void 0 && options.throw) throw parseError;
                    // eslint-disable-next-line no-console
                    console.error(parseError);
                    return ConfigCollection.empty();
                }
                return new ConfigCollection(Array.isArray(result.data) ? (0, $f99173babae80fe1$export$c29ba52779f58587)(result.data) : (0, $f99173babae80fe1$export$be5b69ecb011d7cc)(result.data));
            }
        },
        {
            key: "empty",
            value: function empty() {
                return new ConfigCollection(new Map());
            }
        }
    ]);
    return ConfigCollection;
}();


var $ade17398dad4f267$export$8489e2f039bfcc4c = /*#__PURE__*/ function() {
    function ConfigClient() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kD1JK)))(this, ConfigClient);
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($fhRQI)))(ConfigClient, null, [
        {
            key: "fetch",
            value: function() {
                var _fetch = (0, (/*@__PURE__*/$parcel$interopDefault($7f5qq)))(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).mark(function _callee(options) {
                    var _options$fetch;
                    var fetch, response, valuesPayload;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($5msJs))).wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                fetch = (_options$fetch = options.fetch) !== null && _options$fetch !== void 0 ? _options$fetch : globalThis.fetch;
                                _context.next = 3;
                                return fetch("".concat(options.ffsBaseUrl, "/api/v2/configurations"), {
                                    method: "POST",
                                    body: JSON.stringify(options.context),
                                    headers: {
                                        "content-type": "application/json",
                                        "x-api-key": options.ffsApiKey
                                    }
                                });
                            case 3:
                                response = _context.sent;
                                if (response.ok) {
                                    _context.next = 12;
                                    break;
                                }
                                _context.t0 = Error;
                                _context.t1 = "Unexpected response ".concat(response.status, ": ");
                                _context.next = 9;
                                return response.text();
                            case 9:
                                _context.t2 = _context.sent;
                                _context.t3 = _context.t1.concat.call(_context.t1, _context.t2);
                                throw new _context.t0(_context.t3);
                            case 12:
                                _context.next = 14;
                                return response.text();
                            case 14:
                                valuesPayload = _context.sent;
                                return _context.abrupt("return", (0, $4e1e34a0383b14f9$export$2be5653e4dada0a3).fromValues(valuesPayload));
                            case 16:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                function fetch(_x) {
                    return _fetch.apply(this, arguments);
                }
                return fetch;
            }()
        }
    ]);
    return ConfigClient;
}();



var $lk8Tl = parcelRequire("lk8Tl");

var $lk8Tl = parcelRequire("lk8Tl");
const $85cfef0e58df38df$export$c0273fbd336e77ca = "aid-frontend_web";
const $85cfef0e58df38df$export$2f2c106effb3792 = ()=>{
    // Provided by https://developer.atlassian.com/platform/frontend-feature-flags/resources/api-keys/
    switch(0, $lk8Tl.currentEnv){
        case "dev":
        case "local":
            return "f0f574a2-4bcc-4049-a7d3-6a08637916e0";
        case "stg":
            return "de816d56-15e9-402b-8d1b-09ab6175bb1c";
        case "stg-fedm":
            return "487d67c3-d876-46d4-ac06-7a4b066e5b78";
        case "prod-fedm":
            return "e8a35d9c-f310-4842-9141-66e28cd0d395";
        case "prod":
        default:
            return "af2669c5-bf1e-48d6-b37d-a8514b7073d2";
    }
};



var $8f2pb = parcelRequire("8f2pb");
const $dc94064655470ccc$var$getDynamicConfigsClientBaseUrl = ()=>{
    // Provided by https://atlaskit.atlassian.com/packages/measurement/web-config-client
    switch(0, $lk8Tl.currentEnv){
        case "dev":
        case "local":
            return "https://api.dev.atlassian.com/flags";
        case "stg":
            return "https://api.stg.atlassian.com/flags";
        case "stg-fedm":
        case "prod-fedm":
            // see https://home.atlassian.com/o/2346a038-3c8c-498b-a79b-e7847859868d/s/a436116f-02ce-4520-8fbb-7301462a1674/project/ATLAS-74313/about to track FedRAMP availability
            console.warn("Dynamic configs are not currently supported in FedRAMP environments");
            return null;
        case "prod":
        default:
            return "https://api.atlassian.com/flags";
    }
};
const $dc94064655470ccc$export$d00723e9d793f99d = async (analyticsAnonymousId)=>{
    const baseUrl = $dc94064655470ccc$var$getDynamicConfigsClientBaseUrl();
    if (baseUrl === null) return (0, $4e1e34a0383b14f9$export$2be5653e4dada0a3).empty();
    try {
        return await (0, $ade17398dad4f267$export$8489e2f039bfcc4c).fetch({
            ffsBaseUrl: baseUrl,
            ffsApiKey: (0, $85cfef0e58df38df$export$2f2c106effb3792)(),
            context: {
                namespace: (0, $85cfef0e58df38df$export$c0273fbd336e77ca),
                // this uses a subset of the identifiers that the feature gates client uses. We can add more in future if they are needed.
                identifiers: {
                    analyticsAnonymousId: analyticsAnonymousId
                },
                metadata: {}
            }
        });
    } catch (error) {
        (0, $8f2pb.captureException)(error);
        console.error("Error creating Statsig dynamic config collection. Falling back to empty collection.");
        return (0, $4e1e34a0383b14f9$export$2be5653e4dada0a3).empty();
    }
};
const $dc94064655470ccc$export$70e7649e6de93d3 = (0, $8ZuGG.createContext)(undefined);
const $dc94064655470ccc$export$d18460a0831bab92 = ()=>{
    const context = (0, $8ZuGG.useContext)($dc94064655470ccc$export$70e7649e6de93d3);
    if (!context) throw new Error("useDynamicConfigsClient used outside of DynamicConfigsClientProvider.");
    return context;
};


const $04eb85c0779770b7$var$App = ()=>{
    (0, $8ZuGG.useLayoutEffect)(()=>{
        (0, $l9koH.default)({
            colorMode: "light"
        });
    }, []);
    (0, $2ca216e8880b2fc2$export$c0c5e20150fdb34a)();
    const { search: search } = (0, $5WDNl.useLocation)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const defaultTitle = formatMessage((0, $178059c9f52b5bc2$export$2e2bcd8739ae039).headTitle);
    const contextPath = (0, $kOqgB.useAppSelector)((state)=>state.appConfig.contextPath);
    const microbranding = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const cobranding = (0, $kOqgB.useAppSelector)((state)=>state.cobranding);
    const dynamicConfigs = (0, $dc94064655470ccc$export$d18460a0831bab92)();
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $8ZuGG.Suspense), {
        fallback: null,
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $3o9o3.default), {
                defaultTitle: defaultTitle,
                titleTemplate: `%s - ${defaultTitle}`
            }, "helmet"),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $a13f29e657c584ac$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $cugIF.CobrandingProvider), {
                value: {
                    cobranding: (0, $cugIF.getCurrentCobranding)(cobranding, dynamicConfigs),
                    isMobileApp: microbranding.isMobileApp
                },
                children: /*#__PURE__*/ (0, $6rcps.jsxs)((0, $e75b92d5ce2de9e1$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $6rcps.jsxs)((0, $5WDNl.Routes), {
                            children: [
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment/1-get-app`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$d137eda0ebcc3948), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment/2-configure-app`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$d316ce63fb222131), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment/2-configure-phone`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$717e3b31ee3d8960), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment/2-register-security-key`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$bfd6201eae0d5333), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment/3-connect-phone`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$d316ce63fb222131), {
                                        isConnectPhone: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment/4-save-recovery-key`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$70105507d801662a), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step/enrollment`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$1feb78d7c7eef8e6), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/2step/recover/expired",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$d5523937d2306712), {
                                        isExpired: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/2step/recover",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$280a36f5ba1cc19f), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: `${contextPath}/2step`,
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$f8df0673716775fc), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/resetpassword",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$da4433e8d8a5678), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/continue-as",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$a4ce1932d7e73468), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/select-account",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$134466789cb44107), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/remove-account",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$66bcaaca6b1eddac), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/cancel-account-deletion",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$ffebed914bd6a6c9), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/deletion-request-confirmation",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$467fb294f057077d), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/resetexpiredpassword",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$f8dc9833cdc832ea), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/changepassword/*",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$8ec0fb1e4323236d), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/inactive",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$ad79d74b0908a012), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/pending-deletion",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$40b885b03094ae2d), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/mfa",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$d5523937d2306712), {
                                        isExpired: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/consent",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$68f39a5ef8cea54d), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/social/confirmation",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$74ab7a9a192e1a7a), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/*",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Navigate), {
                                        to: {
                                            pathname: "/login",
                                            search: search
                                        },
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$f14c0e3f98d164c0), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/logout",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$ae5920452e7cb547), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/mf",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$d5523937d2306712), {
                                        isExpired: false
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/signup/migrate-confirmation",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$3432bb22f729c42b), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/signup/welcome/sent",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$9feca1f6b3b10306), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/signup/welcome/*",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$630ad10f0e1a953d), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/signup/invite/*",
                                    element: // KIRBY-7259: SIS redirects /signup/invite/* to /signup/welcome/*
                                    // This is a temporary fix to handle the redirect for SAS Fast5
                                    null
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/signup/verify-email/otp",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$a16cb21d1f9bc820), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/signup",
                                    element: (0, $lk8Tl.getCurrentPerimeter)() === "commercial" ? /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$a2f4b65ede167ce5), {}) : /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Navigate), {
                                        to: {
                                            pathname: "/login",
                                            search: search
                                        },
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/verify-email/change-email",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$98b365c355bab28e), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/verify-email/sent",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$980c3b624c0da509), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/verify-email/*",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$647c199e9f3e1159), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/security/expiredlink",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$f5edf646533475ec), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/security/successfulreset",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$8d7d33e241ae6c52), {
                                        successType: "password-reset"
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/security/successfulverification",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$8d7d33e241ae6c52), {
                                        successType: "verification"
                                    })
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/login/security-screen",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$84ed94b8c66e0057), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/social/recovery",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$ee564d35600efee8), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/error",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$beb41ed376add573), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/step-up/start",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$e561dacd818ab41), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "/step-up/sso",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9086fb644175d6ad$export$61fae207a78c2e53), {})
                                }),
                                /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Route), {
                                    path: "*",
                                    element: /*#__PURE__*/ (0, $6rcps.jsx)((0, $5WDNl.Navigate), {
                                        to: {
                                            pathname: "/login",
                                            search: search
                                        },
                                        replace: true
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $6rcps.jsx)((0, $1438b5f8e1df0e8a$export$2e2bcd8739ae039), {})
                    ]
                }, "screenSizeListener")
            })
        ]
    });
};
var $04eb85c0779770b7$export$2e2bcd8739ae039 = $04eb85c0779770b7$var$App;


parcelRequire("62Jrh");
var $HylXk = parcelRequire("HylXk");
var $2xiyk = parcelRequire("2xiyk");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");

var $3ir1n = parcelRequire("3ir1n");

var $iSD9t = parcelRequire("iSD9t");

var $kOqgB = parcelRequire("kOqgB");
const $55e2f1fb9825dd5f$var$AnalyticsClientProvider = ({ children: children })=>{
    const { locale: locale } = (0, $iSD9t.default)();
    const cobranding = (0, $kOqgB.useAppSelector)((state)=>state.cobranding);
    const microbranding = (0, $kOqgB.useAppSelector)((state)=>state.microbranding);
    const tenantCloudId = (0, $kOqgB.useAppSelector)((state)=>state.context.tenantCloudId);
    const userId = (0, $kOqgB.useAppSelector)((state)=>state.context.userId);
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $3ir1n.AnalyticsClientContext).Provider, {
        value: new (0, $3ir1n.AnalyticsClientImpl)({
            cobranding: cobranding,
            locale: locale,
            microbranding: microbranding,
            tenantCloudId: tenantCloudId,
            userId: userId
        }),
        children: children
    });
};
var $55e2f1fb9825dd5f$export$2e2bcd8739ae039 = $55e2f1fb9825dd5f$var$AnalyticsClientProvider;



var $kOqgB = parcelRequire("kOqgB");

var $eyuWU = parcelRequire("eyuWU");

var $eyuWU = parcelRequire("eyuWU");

var $eyuWU = parcelRequire("eyuWU");
const $a7a62065dcd8c6cb$export$1cf3d545f2d4635c = console;



var $7iBIE = parcelRequire("7iBIE");

var $hGQfz = parcelRequire("hGQfz");

var $eyuWU = parcelRequire("eyuWU");
class $0c5d56767fd842d9$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $eyuWU.isValidTimeout)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $eyuWU.isServer) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $34964cecc1580de1$export$62297b13309008b2 extends (0, $0c5d56767fd842d9$export$e09608847fcc8c59) {
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $eyuWU.replaceData)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $eyuWU.noop)).catch((0, $eyuWU.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $eyuWU.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $eyuWU.getAbortController)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $hGQfz.isCancelledError)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $hGQfz.isCancelledError)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $hGQfz.createRetryer)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $hGQfz.canFetch)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $hGQfz.isCancelledError)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7iBIE.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $a7a62065dcd8c6cb$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $34964cecc1580de1$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
}
function $34964cecc1580de1$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}



var $7iBIE = parcelRequire("7iBIE");

var $4QQ45 = parcelRequire("4QQ45");
// CLASS
class $8d134b4488e50629$export$5dde0cd941da8468 extends (0, $4QQ45.Subscribable) {
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $eyuWU.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $34964cecc1580de1$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    find(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $eyuWU.matchQuery)(filters, query));
    }
    findAll(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $eyuWU.matchQuery)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
}



var $7iBIE = parcelRequire("7iBIE");


var $7iBIE = parcelRequire("7iBIE");


var $hGQfz = parcelRequire("hGQfz");
// CLASS
class $8816a4920e39c68d$export$17b8b19c814bcf56 extends (0, $0c5d56767fd842d9$export$e09608847fcc8c59) {
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $hGQfz.createRetryer)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $hGQfz.canFetch)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $7iBIE.notifyManager).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $a7a62065dcd8c6cb$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $8816a4920e39c68d$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
}
function $8816a4920e39c68d$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}



var $eyuWU = parcelRequire("eyuWU");

var $4QQ45 = parcelRequire("4QQ45");
// CLASS
class $4533a9a1191d6293$export$1fcfd9a244434844 extends (0, $4QQ45.Subscribable) {
    build(client, options, state) {
        const mutation = new (0, $8816a4920e39c68d$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $eyuWU.matchMutation)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $eyuWU.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, $7iBIE.notifyManager).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $7iBIE.notifyManager).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $eyuWU.noop))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
}



var $efras = parcelRequire("efras");

var $gF9Ao = parcelRequire("gF9Ao");

var $7iBIE = parcelRequire("7iBIE");
function $95ee09b8df45fcd1$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $95ee09b8df45fcd1$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $95ee09b8df45fcd1$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $95ee09b8df45fcd1$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $95ee09b8df45fcd1$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $95ee09b8df45fcd1$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $95ee09b8df45fcd1$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $95ee09b8df45fcd1$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $95ee09b8df45fcd1$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $95ee09b8df45fcd1$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $987a37d76b93c345$export$405d0624ed55a03f {
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $efras.focusManager).subscribe(()=>{
            if ((0, $efras.focusManager).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $gF9Ao.onlineManager).subscribe(()=>{
            if ((0, $gF9Ao.onlineManager).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    isFetching(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $eyuWU.functionalUpdate)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $7iBIE.notifyManager).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    removeQueries(arg1, arg2) {
        const [filters] = (0, $eyuWU.parseFilterArgs)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $7iBIE.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $7iBIE.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $7iBIE.notifyManager).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $eyuWU.noop)).catch((0, $eyuWU.noop));
    }
    invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        return (0, $7iBIE.notifyManager).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $eyuWU.parseFilterArgs)(arg1, arg2, arg3);
        const promises = (0, $7iBIE.notifyManager).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $eyuWU.noop));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $eyuWU.noop));
        return promise;
    }
    fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $eyuWU.noop)).catch((0, $eyuWU.noop));
    }
    fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $eyuWU.parseQueryArgs)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $95ee09b8df45fcd1$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $eyuWU.noop)).catch((0, $eyuWU.noop));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $eyuWU.hashQueryKey)(queryKey) === (0, $eyuWU.hashQueryKey)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $eyuWU.partialMatchKey)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $eyuWU.hashQueryKey)(mutationKey) === (0, $eyuWU.hashQueryKey)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $eyuWU.partialMatchKey)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $eyuWU.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $8d134b4488e50629$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $4533a9a1191d6293$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $a7a62065dcd8c6cb$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
}


var $6b5zr = parcelRequire("6b5zr");
/**
 * This is the legacy LaunchDarkly client that we need to remove by Dec, 2024 but is in place till
 * https://hello.jira.atlassian.cloud/browse/KIRBY-6029 is completed.
 *
 * The new client is found in FeatureGateProvider. This is a wrapper around StatSig.
 * https://hello.atlassian.net/wiki/spaces/MEASURE/pages/2662710507/How+to+Integrate+with+Statsig
 */ 
var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $lwBvV = parcelRequire("lwBvV");

var $8f2pb = parcelRequire("8f2pb");
parcelRequire("7C0Dg");
var $c48Nq = parcelRequire("c48Nq");
const $61873cec842e07b1$export$ec0c43a58fca1a2 = ({ children: children, analyticsClient: analyticsClient })=>{
    const [isLoaded, setIsLoaded] = (0, $8ZuGG.useState)(false);
    (0, $8ZuGG.useEffect)(()=>{
        const load = async ()=>{
            try {
                const ffsId = (0, $c48Nq.getFfsId)();
                const client = (0, $c48Nq.initializeFeatureFlagClient)(analyticsClient);
                await client.ready();
                const flags = client.getFlags();
                $lwBvV.withScope((scope)=>{
                    Object.keys(flags).forEach((key)=>scope.setExtra(key, flags[key]));
                });
                if (ffsId) analyticsClient.setFfsId(ffsId);
            } catch (e) {
                console.warn("[FeatureFlagClient] Using default feature flags");
                (0, $8f2pb.captureException)(e, {
                    message: "Failed to load @atlassiansox/feature-flag-web-client"
                });
            } finally{
                setIsLoaded(true);
            }
        };
        if (!isLoaded) load();
    }, [
        isLoaded,
        analyticsClient
    ]);
    if (!isLoaded) return null;
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $6rcps.Fragment), {
        children: children
    });
};



var $6rcps = parcelRequire("6rcps");

var $8ZuGG = parcelRequire("8ZuGG");

var $kOqgB = parcelRequire("kOqgB");
parcelRequire("7C0Dg");
var $c48Nq = parcelRequire("c48Nq");

var $6rcps = parcelRequire("6rcps");
parcelRequire("8ZuGG");
var $5cd1a21fe9e09a3a$exports = {};
"use strict";
var $5cd1a21fe9e09a3a$var$__createBinding = $5cd1a21fe9e09a3a$exports && $5cd1a21fe9e09a3a$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5cd1a21fe9e09a3a$var$__exportStar = $5cd1a21fe9e09a3a$exports && $5cd1a21fe9e09a3a$exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $5cd1a21fe9e09a3a$var$__createBinding(exports1, m, p);
};
Object.defineProperty($5cd1a21fe9e09a3a$exports, "__esModule", {
    value: true
});

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("6XahI")), $5cd1a21fe9e09a3a$exports);

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("7YQq7")), $5cd1a21fe9e09a3a$exports);

$5cd1a21fe9e09a3a$var$__exportStar((parcelRequire("eYpIx")), $5cd1a21fe9e09a3a$exports);


parcelRequire("eF4yw");
var $51qEW = parcelRequire("51qEW");

var $lk8Tl = parcelRequire("lk8Tl");

const $cdf5ffe4034ca2d9$var$getLocalMode = ()=>(0, $lk8Tl.currentEnv) === "local";
const $cdf5ffe4034ca2d9$var$getEnv = ()=>{
    switch(0, $lk8Tl.currentEnv){
        case "dev":
        case "local":
            return (0, $51qEW.FeatureGateEnvironment).Development;
        case "stg":
        case "stg-fedm":
            return (0, $51qEW.FeatureGateEnvironment).Staging;
        case "prod":
        case "prod-fedm":
        default:
            return (0, $51qEW.FeatureGateEnvironment).Production;
    }
};
const $cdf5ffe4034ca2d9$var$options = {
    targetApp: (0, $85cfef0e58df38df$export$c0273fbd336e77ca),
    environment: $cdf5ffe4034ca2d9$var$getEnv(),
    apiKey: (0, $85cfef0e58df38df$export$2f2c106effb3792)(),
    localMode: $cdf5ffe4034ca2d9$var$getLocalMode()
};
const $cdf5ffe4034ca2d9$export$8bae65f5bd3fcf07 = ({ identifiers: identifiers, onReady: onReady })=>{
    return /*#__PURE__*/ (0, $6rcps.jsx)((0, $5cd1a21fe9e09a3a$exports.FeatureGatesInitialization), {
        enabled: true,
        identifiers: identifiers,
        options: $cdf5ffe4034ca2d9$var$options,
        onReady: onReady
    });
};



var $3ir1n = parcelRequire("3ir1n");

var $cufV0 = parcelRequire("cufV0");

var $iSD9t = parcelRequire("iSD9t");

const $85f8cdc40076b81a$export$d9e6d91f1f7e3282 = ({ children: children })=>{
    const [isFeatureGatesClientReady, setIsFeatureGatesClientReady] = (0, $8ZuGG.useState)(false);
    const [dynamicConfigsClient, setDynamicConfigsCollection] = (0, $8ZuGG.useState)(undefined);
    const tenantId = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_context;
        return (_state_context = state.context) === null || _state_context === void 0 ? void 0 : _state_context.tenantCloudId;
    });
    const atlassianAccountId = (0, $kOqgB.useAppSelector)((state)=>{
        var _state_context;
        return (_state_context = state.context) === null || _state_context === void 0 ? void 0 : _state_context.userId;
    });
    const ffsId = (0, $c48Nq.getFfsId)();
    const { formatMessage: formatMessage } = (0, $iSD9t.default)();
    const analyticsAnonymousId = (0, $3ir1n.useAnalyticsAnonymousId)();
    const featureGatesIdentifiers = (0, $8ZuGG.useMemo)(()=>({
            tenantId: tenantId,
            atlassianAccountId: atlassianAccountId,
            randomizationId: ffsId,
            analyticsAnonymousId: analyticsAnonymousId
        }), [
        tenantId,
        atlassianAccountId,
        ffsId,
        analyticsAnonymousId
    ]);
    (0, $8ZuGG.useEffect)(()=>{
        (0, $dc94064655470ccc$export$d00723e9d793f99d)(analyticsAnonymousId).then((dynamicConfigs)=>setDynamicConfigsCollection(dynamicConfigs));
    }, [
        analyticsAnonymousId
    ]);
    const onFeatureGatesReady = (0, $8ZuGG.useCallback)(()=>setIsFeatureGatesClientReady(true), []);
    const areClientsReady = isFeatureGatesClientReady && !!dynamicConfigsClient;
    return /*#__PURE__*/ (0, $6rcps.jsxs)((0, $6rcps.Fragment), {
        children: [
            /*#__PURE__*/ (0, $6rcps.jsx)((0, $cdf5ffe4034ca2d9$export$8bae65f5bd3fcf07), {
                identifiers: featureGatesIdentifiers,
                onReady: onFeatureGatesReady
            }),
            !areClientsReady && /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
                label: formatMessage({
                    id: "statsig.clients.loading",
                    defaultMessage: "Loading feature flags...",
                    description: "Label text for loading spinner when Statsig clients are being initialized"
                })
            }),
            areClientsReady && /*#__PURE__*/ (0, $6rcps.jsx)((0, $dc94064655470ccc$export$70e7649e6de93d3).Provider, {
                value: dynamicConfigsClient,
                children: children
            })
        ]
    });
};




// Render a spinner to remove the "failed to load scripts" error while loading the app
const $1d5a93c8cd6b268e$var$container = document.getElementById("root");
const $1d5a93c8cd6b268e$var$root = (0, $11bb442d9fd66b68$export$882461b6382ed46c)($1d5a93c8cd6b268e$var$container);
$1d5a93c8cd6b268e$var$root.render(/*#__PURE__*/ (0, $6rcps.jsx)("div", {
    style: {
        display: "flex",
        height: "100%",
        justifyContent: "center",
        alignItems: "center"
    },
    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $cufV0.default), {
        size: "large"
    })
}));
const $1d5a93c8cd6b268e$var$preloadedState = (0, $82mu7.preloadAppState)();
(0, $82mu7.buildInitialState)($1d5a93c8cd6b268e$var$preloadedState).then(async (initialState)=>{
    const { initialStoreState: initialStoreState, cspNonce: cspNonce } = initialState;
    (0, $8f2pb.initClient)(initialStoreState.microbranding);
    const analyticsClient = (0, $82mu7.createAnalyticsClient)(initialState);
    (0, $8f2pb.setUserId)(analyticsClient.getAnonymousId());
    (0, $82mu7.startupAnalyticEvent)(analyticsClient);
    (0, $2xiyk.startBrowserMetrics)(analyticsClient);
    (0, $82mu7.pushGlobals)(initialStoreState.appConfig, cspNonce);
    const store = (0, $kOqgB.createAppStore)(initialStoreState);
    if (initialStoreState.appConfig) (0, $82mu7.initCastle)(initialStoreState.appConfig);
    const queryClient = new (0, $987a37d76b93c345$export$405d0624ed55a03f)({
        defaultOptions: {
            queries: {
                retry: false
            }
        }
    });
    $1d5a93c8cd6b268e$var$root.render(/*#__PURE__*/ (0, $6rcps.jsx)((0, $e1hxF.default), {
        store: store,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $b47ccb028625d76a$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9Li6K.default), {
                analyticsClient: analyticsClient,
                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $6b5zr.QueryClientProvider), {
                    client: queryClient,
                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $gyRZh.BrowserRouter), {
                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $55e2f1fb9825dd5f$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $61873cec842e07b1$export$ec0c43a58fca1a2), {
                                analyticsClient: analyticsClient,
                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $85f8cdc40076b81a$export$d9e6d91f1f7e3282), {
                                    children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9620e8d7f2a05fd6$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $b20cf8091a47c413$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $HylXk.BrowserMetricsBoundary), {
                                                children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $04eb85c0779770b7$export$2e2bcd8739ae039), {})
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                })
            })
        })
    }));
}).catch((error)=>{
    (0, $8f2pb.captureException)(error);
    const emptyStore = (0, $kOqgB.createAppStore)({});
    $1d5a93c8cd6b268e$var$root.render(/*#__PURE__*/ (0, $6rcps.jsx)((0, $e1hxF.default), {
        store: emptyStore,
        children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $b47ccb028625d76a$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $6rcps.jsx)((0, $9Li6K.UnexpectedApplicationErrorPage), {})
        })
    }));
});

})();
//# sourceMappingURL=index.452ee72e.js.map
